import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  Date: Date;
  JSON: any;
  MongoID: any;
  RegExpAsString: any;
};

export type AddressInfo = {
  __typename?: 'AddressInfo';
  add1?: Maybe<Scalars['String']>;
  add2?: Maybe<Scalars['String']>;
  attention?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  countryCode?: Maybe<Scalars['String']>;
  mail?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  /** Optionally the address can come from a referenced object that has address info */
  refId?: Maybe<Scalars['MongoID']>;
  /** The referenced object type, Shop, BrandHouse, LogisticsPartner */
  refType?: Maybe<EnumAddressInfoRefType>;
  zipCode?: Maybe<Scalars['String']>;
};

export type AddressInfoInput = {
  add1?: InputMaybe<Scalars['String']>;
  add2?: InputMaybe<Scalars['String']>;
  attention?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  countryCode?: InputMaybe<Scalars['String']>;
  mail?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  /** Optionally the address can come from a referenced object that has address info */
  refId?: InputMaybe<Scalars['MongoID']>;
  /** The referenced object type, Shop, BrandHouse, LogisticsPartner */
  refType?: InputMaybe<EnumAddressInfoRefType>;
  zipCode?: InputMaybe<Scalars['String']>;
};

export type AuditNote = {
  __typename?: 'AuditNote';
  _id: Scalars['MongoID'];
  brandHouseId: Scalars['MongoID'];
  createdAt?: Maybe<Scalars['Date']>;
  explanation: Scalars['String'];
  updatedAt?: Maybe<Scalars['Date']>;
  updatedBy: ObjectPatchesUpdatedBy;
};

export type AuthorizeResult = {
  __typename?: 'AuthorizeResult';
  token: Scalars['String'];
  url: Scalars['String'];
};

/** Workflow schema for the autoretouch service */
export type AutoRetouchWorkflow = {
  __typename?: 'AutoRetouchWorkflow';
  id: Scalars['String'];
  name: Scalars['String'];
};

export type BrandApi = {
  __typename?: 'BrandApi';
  _id: Scalars['MongoID'];
  autoPublish?: Maybe<Scalars['Boolean']>;
  autoretouch?: Maybe<BrandApiAutoretouch>;
  b2ceurope?: Maybe<BrandApiB2ceurope>;
  burd?: Maybe<BrandApiBurd>;
  createdAt?: Maybe<Scalars['Date']>;
  externShop?: Maybe<BrandApiExternShop>;
  googleTrackingId?: Maybe<Scalars['String']>;
  sendgrid?: Maybe<BrandApiSendgrid>;
  shopId?: Maybe<Scalars['MongoID']>;
  shopify?: Maybe<BrandApiShopify>;
  spy?: Maybe<BrandApiSpy>;
  traede?: Maybe<BrandApiTraede>;
  updatedAt?: Maybe<Scalars['Date']>;
  updatedBy?: Maybe<ObjectPatchesUpdatedBy>;
};

export type BrandApiAutoretouch = {
  __typename?: 'BrandApiAutoretouch';
  autoProcess?: Maybe<Scalars['Boolean']>;
  autoRotate?: Maybe<Scalars['Float']>;
  workflowId?: Maybe<Scalars['String']>;
};

export type BrandApiAutoretouchInput = {
  autoProcess?: InputMaybe<Scalars['Boolean']>;
  autoRotate?: InputMaybe<Scalars['Float']>;
  workflowId?: InputMaybe<Scalars['String']>;
};

export type BrandApiB2ceurope = {
  __typename?: 'BrandApiB2ceurope';
  password?: Maybe<Scalars['String']>;
  userid?: Maybe<Scalars['String']>;
};

export type BrandApiB2ceuropeInput = {
  password?: InputMaybe<Scalars['String']>;
  userid?: InputMaybe<Scalars['String']>;
};

export type BrandApiBurd = {
  __typename?: 'BrandApiBurd';
  password?: Maybe<Scalars['String']>;
  username?: Maybe<Scalars['String']>;
};

export type BrandApiBurdInput = {
  password?: InputMaybe<Scalars['String']>;
  username?: InputMaybe<Scalars['String']>;
};

export type BrandApiExternShop = {
  __typename?: 'BrandApiExternShop';
  serviceBus?: Maybe<Scalars['String']>;
  topic?: Maybe<Scalars['String']>;
};

export type BrandApiExternShopInput = {
  serviceBus?: InputMaybe<Scalars['String']>;
  topic?: InputMaybe<Scalars['String']>;
};

export type BrandApiInput = {
  _id?: InputMaybe<Scalars['MongoID']>;
  autoPublish?: InputMaybe<Scalars['Boolean']>;
  autoretouch?: InputMaybe<BrandApiAutoretouchInput>;
  b2ceurope?: InputMaybe<BrandApiB2ceuropeInput>;
  burd?: InputMaybe<BrandApiBurdInput>;
  createdAt?: InputMaybe<Scalars['Date']>;
  externShop?: InputMaybe<BrandApiExternShopInput>;
  googleTrackingId?: InputMaybe<Scalars['String']>;
  sendgrid?: InputMaybe<BrandApiSendgridInput>;
  shopify?: InputMaybe<BrandApiShopifyInput>;
  spy?: InputMaybe<BrandApiSpyInput>;
  traede?: InputMaybe<BrandApiTraedeInput>;
  updatedAt?: InputMaybe<Scalars['Date']>;
  updatedBy?: InputMaybe<ObjectPatchesUpdatedByInput>;
};

export type BrandApiSendgrid = {
  __typename?: 'BrandApiSendgrid';
  from?: Maybe<Scalars['String']>;
  fromEmail?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
};

export type BrandApiSendgridInput = {
  from?: InputMaybe<Scalars['String']>;
  fromEmail?: InputMaybe<Scalars['String']>;
  token?: InputMaybe<Scalars['String']>;
};

export type BrandApiShopify = {
  __typename?: 'BrandApiShopify';
  capture?: Maybe<Scalars['Boolean']>;
  enabled?: Maybe<Scalars['Boolean']>;
  options?: Maybe<BrandApiShopifyOptions>;
  refund?: Maybe<Scalars['Boolean']>;
  shopifyLocationId?: Maybe<Scalars['String']>;
};

export type BrandApiShopifyInput = {
  capture?: InputMaybe<Scalars['Boolean']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  options?: InputMaybe<BrandApiShopifyOptionsInput>;
  refund?: InputMaybe<Scalars['Boolean']>;
  shopifyLocationId?: InputMaybe<Scalars['String']>;
};

export type BrandApiShopifyOptions = {
  __typename?: 'BrandApiShopifyOptions';
  color?: Maybe<Scalars['Boolean']>;
  colorName?: Maybe<Scalars['String']>;
  size?: Maybe<Scalars['Boolean']>;
  sizeName?: Maybe<Scalars['String']>;
};

export type BrandApiShopifyOptionsInput = {
  color?: InputMaybe<Scalars['Boolean']>;
  colorName?: InputMaybe<Scalars['String']>;
  size?: InputMaybe<Scalars['Boolean']>;
  sizeName?: InputMaybe<Scalars['String']>;
};

export type BrandApiSpy = {
  __typename?: 'BrandApiSpy';
  captureUrl?: Maybe<Scalars['String']>;
  enabled?: Maybe<Scalars['Boolean']>;
  refundUrl?: Maybe<Scalars['String']>;
};

export type BrandApiSpyInput = {
  captureUrl?: InputMaybe<Scalars['String']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  refundUrl?: InputMaybe<Scalars['String']>;
};

export type BrandApiTraede = {
  __typename?: 'BrandApiTraede';
  accessToken?: Maybe<Scalars['String']>;
  enabled?: Maybe<Scalars['Boolean']>;
  itemNumberPrefix?: Maybe<Scalars['String']>;
};

export type BrandApiTraedeInput = {
  accessToken?: InputMaybe<Scalars['String']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  itemNumberPrefix?: InputMaybe<Scalars['String']>;
};

export type BrandCarrier = {
  __typename?: 'BrandCarrier';
  _id: Scalars['MongoID'];
  active?: Maybe<Scalars['Boolean']>;
  brandHouseId?: Maybe<Scalars['MongoID']>;
  createdAt?: Maybe<Scalars['Date']>;
  shippingCarrier?: Maybe<ShippingCarrier>;
  shippingCarrierId: Scalars['MongoID'];
  updatedAt?: Maybe<Scalars['Date']>;
};

/** Conditions for the public */
export type BrandConditionPublic = {
  __typename?: 'BrandConditionPublic';
  condition: Scalars['Int'];
  description: Scalars['String'];
  name: Scalars['String'];
};

export type BrandHouse = {
  __typename?: 'BrandHouse';
  _id: Scalars['MongoID'];
  address?: Maybe<AddressInfo>;
  apiKey?: Maybe<Scalars['String']>;
  apiSecret?: Maybe<Scalars['String']>;
  /** The brand's circular concept name (e.g. "ReLoved"), currently the stock item title prefix. `language` is reserved for translations and is ignored for now. */
  conceptName?: Maybe<Scalars['String']>;
  /** Conditions */
  conditions?: Maybe<Array<Maybe<BrandConditionPublic>>>;
  createdAt?: Maybe<Scalars['Date']>;
  /** Brandhouse has been deactivated */
  deactivated?: Maybe<Scalars['Boolean']>;
  initials?: Maybe<Scalars['String']>;
  license?: Maybe<Scalars['String']>;
  logisticsPartnerId: Scalars['MongoID'];
  name?: Maybe<Scalars['String']>;
  /** List of all metafield values found on the given key */
  productMetaFieldValues?: Maybe<Array<Scalars['String']>>;
  /** List of all tags found on brand products */
  productTags?: Maybe<Array<Scalars['String']>>;
  /** List of all product types found on brand products */
  productTypes?: Maybe<Array<Maybe<LocalizationEntry>>>;
  /** When true, all configuration changes require an audit note with explanation */
  requireChangeExplanation?: Maybe<Scalars['Boolean']>;
  /** Brand settings */
  settings?: Maybe<BrandSetting>;
  /** Lists all shops for this brand */
  shops?: Maybe<Array<Maybe<Shop>>>;
  /** List of all sources found on brand products */
  sources?: Maybe<Array<Scalars['String']>>;
  updatedAt?: Maybe<Scalars['Date']>;
  updatedBy?: Maybe<ObjectPatchesUpdatedBy>;
};


export type BrandHouseConceptNameArgs = {
  language?: InputMaybe<Scalars['String']>;
};


export type BrandHouseProductMetaFieldValuesArgs = {
  key: Scalars['String'];
};

export type BrandItem = {
  __typename?: 'BrandItem';
  _id: Scalars['MongoID'];
  /** The boost in effect right now, if any */
  activeBoost?: Maybe<BrandItemBoost>;
  /** Attributes of the clothing item */
  attributes?: Maybe<BrandItemAttributes>;
  beforePrices?: Maybe<Array<Maybe<Pricing>>>;
  /** Every boost set on this item, newest first */
  boosts?: Maybe<Array<Maybe<BrandItemBoost>>>;
  brandHouse?: Maybe<BrandHouse>;
  brandHouseId: Scalars['MongoID'];
  /** Brand product size information */
  brandProductSize?: Maybe<BrandProductSize>;
  /** The master data variant/size */
  brandProductSizeId?: Maybe<Scalars['MongoID']>;
  /** The master data variant */
  brandProductVariantId?: Maybe<Scalars['MongoID']>;
  /** Product type in the requested language: typeLocalized, then translated attributes.type (da/de/en/nb/sv/fr/nl/es), then Unknown. */
  calculatedType: Scalars['String'];
  /** This item has been confirmed at the logisticspartner at the given date */
  checked?: Maybe<Scalars['Date']>;
  /** Localized color of the item */
  colorLocalized?: Maybe<Array<Maybe<LocalizationEntry>>>;
  /** True if the comment has been approved */
  commentApproved?: Maybe<Scalars['Boolean']>;
  /** Previous owner comments for the item, localized */
  commentLocalized?: Maybe<Array<Maybe<LocalizationEntry>>>;
  /** The tariff code for use in customs declarations. */
  commodityCode?: Maybe<Scalars['String']>;
  /** Condition of the item, between 1 and 3 */
  condition: Scalars['Float'];
  /** The countryOrigin of this brand item */
  countryOrigin?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['Date']>;
  /** Returns a list of data problems */
  dataErrors?: Maybe<Array<Scalars['String']>>;
  /** Actual days the item has been available for purchase (daysSinceFirstListed - daysOffline), null if never listed */
  daysForSale?: Maybe<Scalars['Int']>;
  /** Total days this item has been offline since firstListedDate */
  daysOffline?: Maybe<Scalars['Float']>;
  /** Total days since the item was first listed for sale (null if never listed) */
  daysSinceFirstListed?: Maybe<Scalars['Int']>;
  deleted?: Maybe<Scalars['Boolean']>;
  /** Localized description of the item */
  descriptionLocalized?: Maybe<Array<Maybe<LocalizationEntry>>>;
  directPrices?: Maybe<Array<Maybe<Pricing>>>;
  /** If true, the RRP list price is disabled */
  disableRRPListPrice?: Maybe<Scalars['Boolean']>;
  /** The date this item was discarded by the owner - a discarded item is not for sale */
  discarded?: Maybe<Scalars['Date']>;
  /** Whether the logistics partner has checked this stockitem since last recount */
  effectiveChecked: Scalars['Boolean'];
  /** Whether the logistics partner has marked this this stockitem as lost */
  effectiveMissing: Scalars['Boolean'];
  externalId?: Maybe<Scalars['String']>;
  /** The date when this item was first listed for sale (never recalculated) */
  firstListedDate?: Maybe<Scalars['Date']>;
  /** Cached key of the group of interchangeable items this item belongs to, set by the integrity event */
  groupKey?: Maybe<Scalars['String']>;
  hasComment?: Maybe<Scalars['Boolean']>;
  hasCustomImages?: Maybe<Scalars['Boolean']>;
  /** True if this item has errors */
  hasErrors: Scalars['Boolean'];
  hasLocation?: Maybe<Scalars['Boolean']>;
  hasMasterData?: Maybe<Scalars['Boolean']>;
  hasProblems?: Maybe<Scalars['Boolean']>;
  hasTranslatedComment?: Maybe<Scalars['Boolean']>;
  /** 512-dimensional embedding vector for the primary image */
  imageEmbedding?: Maybe<Array<Maybe<Scalars['Float']>>>;
  imageUrls?: Maybe<Array<Scalars['String']>>;
  /** Returns an array of images for this branditem */
  images?: Maybe<Array<Maybe<BrandItemImage>>>;
  /** If true, the manufacturer is invalid */
  invalidManufacturer?: Maybe<Scalars['Boolean']>;
  /** The invoice line for this item, if it exists */
  invoiceLine?: Maybe<InvoiceLine>;
  /** The invoice state for this item */
  invoiceState: Scalars['String'];
  /** Whether this stockitem is in-season */
  isInSeason: Scalars['Boolean'];
  isSold: Scalars['Boolean'];
  isTradeIn: Scalars['Boolean'];
  /** Internal EAN number for this brand-item */
  itemEan: Scalars['String'];
  /** Returns a list of item metafields */
  itemMetas?: Maybe<Array<Maybe<MetaFieldInstance>>>;
  /** The itemNr is a unique number for each branditem in context of the brandhouse */
  itemNr: Scalars['Float'];
  /** The SKU for this branditem */
  itemSku: Scalars['String'];
  /** State of the branditem */
  itemState: EnumBrandItemItemState;
  /** Returns a list of item tags */
  itemTags?: Maybe<Array<Maybe<BrandItemTag>>>;
  /** History of all location changes for this brand item */
  layawayHistory?: Maybe<Array<Maybe<BrandItemLayaway>>>;
  /** True if this item is linked to masterdata from a legacy group */
  legacyGroup: Scalars['Boolean'];
  /** The list price in selected currency, if not provided then shop currency */
  listPrice?: Maybe<Scalars['Float']>;
  /** List prices for this stockitem */
  listPrices?: Maybe<Array<Maybe<Pricing>>>;
  masterDataInfo?: Maybe<BrandItemMasterDataInfo>;
  /** Localized MAS masterdata metafields used as the source for item metafield resolution */
  masterDataLocalizedMetafields?: Maybe<Array<Maybe<LocalizedMetaFieldInstance>>>;
  /** MAS masterdata metafields used as the source for item metafield resolution */
  masterDataMetafields?: Maybe<Array<Maybe<MetaField>>>;
  /** The brandproduct masterdata that this itemis linked to */
  masterDataProduct?: Maybe<BrandProduct>;
  /** When MAS masterdata was last pulled into this item */
  masterDataPulledAt?: Maybe<Scalars['Date']>;
  masterDataSnapshot?: Maybe<BrandItemMasterDataSnapshot>;
  /** The external MAS masterdata variant id */
  masterDataVariantId?: Maybe<Scalars['String']>;
  /** This item is registered missing by the logisticspartner at the given date */
  missing?: Maybe<Scalars['Date']>;
  /** Localized name of the item */
  nameLocalized?: Maybe<Array<Maybe<LocalizationEntry>>>;
  /** The NFC Tag for this stockitem */
  nfcTag?: Maybe<Scalars['String']>;
  note?: Maybe<Scalars['String']>;
  options?: Maybe<Array<Maybe<OptionInstance>>>;
  /** If this branditem has an active orderline in one of its shops then this will be returned here */
  orderline?: Maybe<Order2Item>;
  /** If this branditem has orderlines in one of its shops then this will be returned here */
  orderlines?: Maybe<Array<Maybe<Order2Item>>>;
  /** The originalEan of this brand item */
  originalEan?: Maybe<Scalars['String']>;
  /** The originalSku of this brand item */
  originalSku?: Maybe<Scalars['String']>;
  problems?: Maybe<Array<Maybe<BrandItemProblem>>>;
  /** Cached, true while an older item in the same group is for sale and this one waits its turn */
  queued?: Maybe<Scalars['Boolean']>;
  resolved?: Maybe<BrandItemResolved>;
  reviewInfos?: Maybe<Array<Maybe<BrandItemReviewInfo>>>;
  /** Cached, true when the item would be for sale on its own: ready and active in a shop, located, unsold and free of blockers */
  saleable?: Maybe<Scalars['Boolean']>;
  /** The sales rank score (0-100) based on seasonal relevance and attribute popularity */
  salesRank: Scalars['Float'];
  /** Score indicating how sellable the item is (0-100) */
  salesScore?: Maybe<Scalars['Float']>;
  /** Timestamp when the sales score was last calculated */
  salesScoreTs?: Maybe<Scalars['Date']>;
  /** The selling price before tax in selected currency, if not provided then shop currency */
  sellingPrice?: Maybe<Scalars['Float']>;
  /** The selling prices for this branditem */
  sellingPrices?: Maybe<Array<Maybe<Pricing>>>;
  /** The shop info for this branditem */
  shops?: Maybe<Array<Maybe<BrandItemShopInfo>>>;
  /** The size of the item in a given language */
  size?: Maybe<Scalars['String']>;
  /** Localized size of the item */
  sizeLocalized?: Maybe<Array<Maybe<LocalizationEntry>>>;
  /** The date this item was sold */
  soldTs?: Maybe<Scalars['Date']>;
  /** The sortorder of this branditem */
  sortorder?: Maybe<Scalars['Float']>;
  /** The source type for this item */
  sourceType?: Maybe<ItemSourceType>;
  /** Aggregated state for this item, collected from multiple data sources */
  stateAggregation?: Maybe<BrandItemAggregatedStateEnum>;
  /** Statistics for this branditem */
  statistics?: Maybe<BrandItemStatistics>;
  stockLocation?: Maybe<Scalars['String']>;
  /** The barcode of the bag that the item is placed in at the stock location */
  stockLocationBag?: Maybe<Scalars['String']>;
  stockLocationTs?: Maybe<Scalars['Date']>;
  /** Returns a list of tags for this stockitem, use itemTags to see where the tag originated from */
  tags?: Maybe<Array<Scalars['String']>>;
  /** True if this item is a test item */
  test?: Maybe<Scalars['Boolean']>;
  /** Returns the tradein item that this branditem was made from */
  tradeInItem?: Maybe<TradeInItem>;
  /** Link to the tradein item, if applicable */
  tradeInItemId?: Maybe<Scalars['MongoID']>;
  /** The product type of this brand item */
  typeLocalized?: Maybe<Array<Maybe<LocalizationEntry>>>;
  /** This item is registered out of warehouse by the logisticspartner at the given date */
  unavailable?: Maybe<Scalars['Date']>;
  updatedAt?: Maybe<Scalars['Date']>;
  updatedBy?: Maybe<ObjectPatchesUpdatedBy>;
  /** Returns the VAS for this item */
  vas?: Maybe<Array<Maybe<BrandItemVas>>>;
  vasId?: Maybe<Scalars['String']>;
  /** Image references received from VAS for this item */
  vasImages?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** The current logistics state based on VAS entries */
  vasState?: Maybe<BrandItemLogisticsStateEnum>;
  /** The VAS contract version for this item */
  vasType?: Maybe<BrandItemVasTypeEnum>;
  /** The vendor type of this brand item */
  vendor?: Maybe<Scalars['String']>;
  /** Total page views for this item across all shops */
  views?: Maybe<Scalars['Float']>;
  /** Total unique visitors for this item across all shops */
  visitors?: Maybe<Scalars['Float']>;
};


export type BrandItemCalculatedTypeArgs = {
  language: Scalars['String'];
};


export type BrandItemImageUrlsArgs = {
  potentialImages?: InputMaybe<Scalars['Boolean']>;
};


export type BrandItemItemMetasArgs = {
  excludeAuto?: InputMaybe<Scalars['Boolean']>;
};


export type BrandItemItemTagsArgs = {
  includeAuto?: InputMaybe<Scalars['Boolean']>;
};


export type BrandItemListPriceArgs = {
  currency: Scalars['String'];
  excludeVAT?: InputMaybe<Scalars['Boolean']>;
};


export type BrandItemResolvedArgs = {
  applyFallbackLocale?: InputMaybe<Scalars['Boolean']>;
};


export type BrandItemSalesRankArgs = {
  date?: InputMaybe<Scalars['Date']>;
};


export type BrandItemSellingPriceArgs = {
  currency: Scalars['String'];
  excludeVAT?: InputMaybe<Scalars['Boolean']>;
};


export type BrandItemSizeArgs = {
  language: Scalars['String'];
};


export type BrandItemStatisticsArgs = {
  date?: InputMaybe<Scalars['Date']>;
};

export enum BrandItemAggregatedStateEnum {
  BLOCKED = 'BLOCKED',
  DISCARDED = 'DISCARDED',
  DRAFT = 'DRAFT',
  FORSALE = 'FORSALE',
  FORSALEPARTLY = 'FORSALEPARTLY',
  MISSING = 'MISSING',
  NOLOCATION = 'NOLOCATION',
  NONE = 'NONE',
  NOTFORSALE = 'NOTFORSALE',
  OUTOFSEASON = 'OUTOFSEASON',
  QUEUED = 'QUEUED',
  REVIEW = 'REVIEW',
  SOLD = 'SOLD',
  UNAVAILABLE = 'UNAVAILABLE'
}

export type BrandItemAttributes = {
  __typename?: 'BrandItemAttributes';
  apparentFabricType: EnumBrandItemAttributesApparentFabricType;
  confidence?: Maybe<Scalars['Float']>;
  dataProblem?: Maybe<Scalars['String']>;
  dateScanned?: Maybe<Scalars['Date']>;
  formalityLevel: EnumBrandItemAttributesFormalityLevel;
  graphicKeywords?: Maybe<Array<Maybe<Scalars['String']>>>;
  neckline?: Maybe<EnumBrandItemAttributesNeckline>;
  notableFeatures?: Maybe<Array<Maybe<EnumBrandItemAttributesNotableFeatures>>>;
  pattern: EnumBrandItemAttributesPattern;
  primaryColor: EnumBrandItemAttributesPrimaryColor;
  seasonSuitability?: Maybe<Array<Maybe<EnumBrandItemAttributesSeasonSuitability>>>;
  secondaryColors?: Maybe<Array<Maybe<EnumBrandItemAttributesSecondaryColors>>>;
  size?: Maybe<Scalars['String']>;
  subType?: Maybe<EnumBrandItemAttributesSubType>;
  textureAppearance: EnumBrandItemAttributesTextureAppearance;
  type: EnumBrandItemAttributesType;
};

export type BrandItemAttributesInput = {
  apparentFabricType: EnumBrandItemAttributesApparentFabricType;
  confidence?: InputMaybe<Scalars['Float']>;
  dataProblem?: InputMaybe<Scalars['String']>;
  dateScanned?: InputMaybe<Scalars['Date']>;
  formalityLevel: EnumBrandItemAttributesFormalityLevel;
  graphicKeywords?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  neckline?: InputMaybe<EnumBrandItemAttributesNeckline>;
  notableFeatures?: InputMaybe<Array<InputMaybe<EnumBrandItemAttributesNotableFeatures>>>;
  pattern: EnumBrandItemAttributesPattern;
  primaryColor: EnumBrandItemAttributesPrimaryColor;
  seasonSuitability?: InputMaybe<Array<InputMaybe<EnumBrandItemAttributesSeasonSuitability>>>;
  secondaryColors?: InputMaybe<Array<InputMaybe<EnumBrandItemAttributesSecondaryColors>>>;
  size?: InputMaybe<Scalars['String']>;
  subType?: InputMaybe<EnumBrandItemAttributesSubType>;
  textureAppearance: EnumBrandItemAttributesTextureAppearance;
  type: EnumBrandItemAttributesType;
};

export type BrandItemBoost = {
  __typename?: 'BrandItemBoost';
  _id: Scalars['MongoID'];
  /** True while the boost is in effect (endTs in the future and not ended or cancelled) */
  active: Scalars['Boolean'];
  /** The brand owning the item, so the dashboard can report per brand */
  brandHouseId: Scalars['MongoID'];
  /** The BrandItem this boost applies to */
  brandItemId: Scalars['MongoID'];
  createdAt?: Maybe<Scalars['Date']>;
  /** Who set the boost */
  createdBy?: Maybe<ObjectPatchesUpdatedBy>;
  /** When the boost is scheduled to end; active while endTs > now and endedTs is unset */
  endTs: Scalars['Date'];
  /** Who cancelled the boost, when it did not simply expire */
  endedBy?: Maybe<ObjectPatchesUpdatedBy>;
  /** Why the boost ended */
  endedReason?: Maybe<EnumBrandItemBoostEndedReason>;
  /** When the boost actually ended, stamped by expiry, cancellation or replacement */
  endedTs?: Maybe<Scalars['Date']>;
  /** Discount percentage on the normal selling price; absent when only visibility is boosted */
  pricePct?: Maybe<Scalars['Float']>;
  /** When the boost started */
  startTs: Scalars['Date'];
  updatedAt?: Maybe<Scalars['Date']>;
  /** True to rank the item ahead of unboosted items in storefront collections */
  visibility: Scalars['Boolean'];
};

/** List of items with pagination. */
export type BrandItemBrandItemPagination = {
  __typename?: 'BrandItemBrandItemPagination';
  /** Total object count. */
  count?: Maybe<Scalars['Int']>;
  /** Array of objects. */
  items?: Maybe<Array<BrandItem>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type BrandItemImage = {
  __typename?: 'BrandItemImage';
  _id: Scalars['MongoID'];
  /** Alternative descriptive text for the image */
  altText?: Maybe<Scalars['String']>;
  auditApproved?: Maybe<Scalars['Boolean']>;
  auditApprovedBy?: Maybe<ObjectPatchesUpdatedBy>;
  auditApprovedTs?: Maybe<Scalars['Date']>;
  brandHouseId: Scalars['MongoID'];
  brandItemId: Scalars['MongoID'];
  brandProductImageId?: Maybe<Scalars['MongoID']>;
  /** URL to the processed image */
  brandProductImageUrl?: Maybe<Scalars['String']>;
  deleted?: Maybe<Scalars['Boolean']>;
  externId?: Maybe<Scalars['String']>;
  failed?: Maybe<Scalars['Boolean']>;
  hide?: Maybe<Scalars['Date']>;
  imageId?: Maybe<Scalars['MongoID']>;
  /** The md5 hash of the image, used to compare images */
  imageMd5?: Maybe<Scalars['String']>;
  /** URL to the processed image */
  imageUrl?: Maybe<Scalars['String']>;
  /** If the image is the original image for the brand item */
  originalImage?: Maybe<Scalars['Boolean']>;
  perspective?: Maybe<EnumBrandItemImagePerspective>;
  process?: Maybe<Scalars['Boolean']>;
  processError?: Maybe<Scalars['String']>;
  processStart?: Maybe<Scalars['Date']>;
  removeBgSweepCount?: Maybe<Scalars['Float']>;
  removeBgSweepGaveUpTs?: Maybe<Scalars['Date']>;
  removeBgSweepTs?: Maybe<Scalars['Date']>;
  requireAudit?: Maybe<Scalars['Boolean']>;
  sortOrder?: Maybe<Scalars['Float']>;
  type?: Maybe<EnumBrandItemImageType>;
  updatedBy?: Maybe<ObjectPatchesUpdatedBy>;
  uploadId?: Maybe<Scalars['MongoID']>;
  /** The md5 hash of the upload, used to compare images */
  uploadMd5?: Maybe<Scalars['String']>;
  /** URL to the original uploaded image */
  uploadUrl?: Maybe<Scalars['String']>;
};

export type BrandItemImageInputInput = {
  /** The internal identifier, if missing or null a new image will be created */
  _id?: InputMaybe<Scalars['MongoID']>;
  /** An alternative text for the image, typically shown as a title on the web */
  altText?: InputMaybe<Scalars['String']>;
  /** The ID of the brand product image, either this or the uploadId must be supplied */
  brandProductImageId?: InputMaybe<Scalars['MongoID']>;
  /** The external identifier */
  externId?: InputMaybe<Scalars['String']>;
  /** The ID of the processed image */
  imageId?: InputMaybe<Scalars['MongoID']>;
  /** Whether its an original image for the product */
  originalImage?: InputMaybe<Scalars['Boolean']>;
  /** The perspective of the image */
  perspective?: InputMaybe<ImagePerspectiveEnum>;
  /** Whether the post-processing (background removal etc) should be run on this image */
  process?: InputMaybe<Scalars['Boolean']>;
  /** The type of the image */
  type?: InputMaybe<ImageTypeEnum>;
  /** The ID of the uploaded image, either this or the brandProductImageId must be supplied */
  uploadId?: InputMaybe<Scalars['MongoID']>;
  /** The url of the image upload, either uploadId or uploadUrl must be set */
  uploadUrl?: InputMaybe<Scalars['String']>;
};

export type BrandItemInputInput = {
  /** The internal identifier, if missing or null a new item will be created */
  _id?: InputMaybe<Scalars['MongoID']>;
  /** Attributes for this brand item */
  attributes?: InputMaybe<BrandItemAttributesInput>;
  /** The rrp prices in supported currencies */
  beforePrices?: InputMaybe<Array<InputMaybe<PricingInput>>>;
  /** The ID of the brand product size that this item is derived from */
  brandProductSizeId?: InputMaybe<Scalars['MongoID']>;
  /** The date of the last time this item was seen and checked */
  checked?: InputMaybe<Scalars['Date']>;
  /** The color of the item localized */
  colorLocalized?: InputMaybe<Array<InputMaybe<LocalizationEntryInput>>>;
  /** True if the comment has been approved */
  commentApproved?: InputMaybe<Scalars['Boolean']>;
  /** Previous owner comments for the item, localized */
  commentLocalized?: InputMaybe<Array<InputMaybe<LocalizationEntryInput>>>;
  /** The tariff / commodity code for this item */
  commodityCode?: InputMaybe<Scalars['String']>;
  /** The condition grading of the brand item - between 1 and 3 */
  condition?: InputMaybe<Scalars['Int']>;
  /** The country code of the country that made this item */
  countryOrigin?: InputMaybe<Scalars['String']>;
  /** The description of the item localized */
  descriptionLocalized?: InputMaybe<Array<InputMaybe<LocalizationEntryInput>>>;
  /** The direct selling prices in supported currencies */
  directPrices?: InputMaybe<Array<InputMaybe<PricingInput>>>;
  /** True if the list price should be disabled for this item */
  disableRRPListPrice?: InputMaybe<Scalars['Boolean']>;
  /** The date this item was discarded by the owner - a discarded item is not for sale */
  discarded?: InputMaybe<Scalars['Date']>;
  /** Unique identifier for the item */
  externalId?: InputMaybe<Scalars['String']>;
  /** 512-dimensional embedding vector for the primary image */
  imageEmbedding?: InputMaybe<Array<Scalars['Float']>>;
  /** The images for this item */
  images?: InputMaybe<Array<InputMaybe<BrandItemImageInputInput>>>;
  /** True if the manufacturer is invalid */
  invalidManufacturer?: InputMaybe<Scalars['Boolean']>;
  /** Issues for this branditem */
  issues?: InputMaybe<Array<InputMaybe<ItemIssueInput>>>;
  /** The publication state of this item */
  itemState?: InputMaybe<BrandItemStateEnum>;
  /** Tags for the item */
  itemTags?: InputMaybe<Array<InputMaybe<BrandItemTagInput>>>;
  /** The MAS masterdata variant id that this item is derived from */
  masterDataVariantId?: InputMaybe<Scalars['String']>;
  /** The date of the last time this item was recorded missing */
  missing?: InputMaybe<Scalars['Date']>;
  /** The name of the item localized */
  nameLocalized?: InputMaybe<Array<InputMaybe<LocalizationEntryInput>>>;
  /** The NFC tag for this branditem */
  nfcTag?: InputMaybe<Scalars['String']>;
  /** An internal note for this item */
  note?: InputMaybe<Scalars['String']>;
  /** Options for this branditem */
  options?: InputMaybe<Array<InputMaybe<OptionInstanceInput>>>;
  /** Optionally provide the original ean number for this stockitem - mostly relevant if not linked to masterdata */
  originalEan?: InputMaybe<Scalars['String']>;
  /** Optionally provide the original sku number for this stockitem - mostly relevant if not linked to masterdata */
  originalSku?: InputMaybe<Scalars['String']>;
  /** Problems for this brand item */
  problems?: InputMaybe<Array<InputMaybe<BrandItemProblemInput>>>;
  /** Info from the review process */
  reviewInfos?: InputMaybe<Array<InputMaybe<BrandItemReviewInfoInput>>>;
  /** The size of the item localized */
  sizeLocalized?: InputMaybe<Array<InputMaybe<LocalizationEntryInput>>>;
  /** Sortorder for the branditem */
  sortorder?: InputMaybe<Scalars['Int']>;
  /** The source type for this item */
  sourceType?: InputMaybe<ItemSourceType>;
  /** The location of the item */
  stockLocation?: InputMaybe<Scalars['String']>;
  /** The bag the item is placed in */
  stockLocationBag?: InputMaybe<Scalars['String']>;
  /** True if this item is a test item */
  test?: InputMaybe<Scalars['Boolean']>;
  /** The tradein item for this brand item */
  tradeInItemId?: InputMaybe<Scalars['MongoID']>;
  /** Type of product localized */
  typeLocalized?: InputMaybe<Array<InputMaybe<LocalizationEntryInput>>>;
  /** The date the item was unavailable from */
  unavailable?: InputMaybe<Scalars['Date']>;
  /** List of VAS for this branditem */
  vas?: InputMaybe<Array<InputMaybe<BrandItemVasInput>>>;
  /** Unique VAS identifier for the item */
  vasId?: InputMaybe<Scalars['String']>;
  /** Image references received from VAS for this item */
  vasImages?: InputMaybe<Array<Scalars['String']>>;
  /** The VAS contract version for this item */
  vasType?: InputMaybe<BrandItemVasTypeEnum>;
  /** Vendor of the item */
  vendor?: InputMaybe<Scalars['String']>;
};

export type BrandItemLayaway = {
  __typename?: 'BrandItemLayaway';
  _id: Scalars['MongoID'];
  brandItem?: Maybe<BrandItem>;
  /** Reference to the BrandItem */
  brandItemId: Scalars['MongoID'];
  createdAt?: Maybe<Scalars['Date']>;
  /** Stock location of the item */
  stockLocation?: Maybe<Scalars['String']>;
  /** Stock location bag of the item */
  stockLocationBag?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['Date']>;
  /** Who made this location change */
  updatedBy: ObjectPatchesUpdatedBy;
};

/** List of items with pagination. */
export type BrandItemLayawayBrandItemLayawayPagination = {
  __typename?: 'BrandItemLayawayBrandItemLayawayPagination';
  /** Total object count. */
  count?: Maybe<Scalars['Int']>;
  /** Array of objects. */
  items?: Maybe<Array<BrandItemLayaway>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export enum BrandItemLogisticsStateEnum {
  COMPLETED = 'COMPLETED',
  DISCARDED = 'DISCARDED',
  PROGRESSING = 'PROGRESSING',
  RECEIVED = 'RECEIVED',
  REPAIRING = 'REPAIRING',
  WASHING = 'WASHING'
}

export type BrandItemMasterDataBackfillResult = {
  __typename?: 'BrandItemMasterDataBackfillResult';
  queued: Scalars['Int'];
  requested: Scalars['Int'];
  skipped: Scalars['Int'];
};

export type BrandItemMasterDataInfo = {
  __typename?: 'BrandItemMasterDataInfo';
  /** Color pf product */
  color?: Maybe<Scalars['String']>;
  /** Master data ean */
  ean?: Maybe<Scalars['String']>;
  /** External ID */
  externalId?: Maybe<Scalars['String']>;
  /** Name of product */
  name?: Maybe<Scalars['String']>;
  /** Size of product */
  size?: Maybe<Scalars['String']>;
  /** Master data sku */
  sku?: Maybe<Scalars['String']>;
};

export type BrandItemMasterDataMigrationFieldSnapshot = {
  __typename?: 'BrandItemMasterDataMigrationFieldSnapshot';
  brandId?: Maybe<Scalars['String']>;
  color?: Maybe<Scalars['String']>;
  ean?: Maybe<Scalars['String']>;
  externalId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  size?: Maybe<Scalars['String']>;
  sku?: Maybe<Scalars['String']>;
  style?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  vendor?: Maybe<Scalars['String']>;
};

export type BrandItemMasterDataMigrationItem = {
  __typename?: 'BrandItemMasterDataMigrationItem';
  _id: Scalars['MongoID'];
  brandHouseId?: Maybe<Scalars['MongoID']>;
  brandItemId: Scalars['MongoID'];
  candidate?: Maybe<BrandItemMasterDataMigrationFieldSnapshot>;
  confidence?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['Date']>;
  current?: Maybe<BrandItemMasterDataMigrationFieldSnapshot>;
  error?: Maybe<Scalars['String']>;
  processedAt?: Maybe<Scalars['Date']>;
  proposedMasterDataProductId?: Maybe<Scalars['String']>;
  proposedMasterDataVariantId?: Maybe<Scalars['String']>;
  reasons?: Maybe<Array<Scalars['String']>>;
  runId: Scalars['MongoID'];
  signals?: Maybe<Array<Maybe<BrandItemMasterDataMigrationSignal>>>;
  status?: Maybe<BrandItemMasterDataMigrationItemStatus>;
  updatedAt?: Maybe<Scalars['Date']>;
};

export enum BrandItemMasterDataMigrationItemStatus {
  AlreadyLinked = 'AlreadyLinked',
  Auto = 'Auto',
  Failed = 'Failed',
  Migrated = 'Migrated',
  NoMatch = 'NoMatch',
  Processing = 'Processing',
  Queued = 'Queued',
  Review = 'Review',
  Stale = 'Stale'
}

export type BrandItemMasterDataMigrationRun = {
  __typename?: 'BrandItemMasterDataMigrationRun';
  _id: Scalars['MongoID'];
  createdAt?: Maybe<Scalars['Date']>;
  createdBy?: Maybe<BrandItemMasterDataMigrationUpdatedBy>;
  failedCount: Scalars['Int'];
  matchedCount: Scalars['Int'];
  migratedCount: Scalars['Int'];
  noMatchCount: Scalars['Int'];
  processedCount: Scalars['Int'];
  requestedCount: Scalars['Int'];
  reviewCount: Scalars['Int'];
  sourcePreviewRunId?: Maybe<Scalars['MongoID']>;
  staleCount: Scalars['Int'];
  status?: Maybe<BrandItemMasterDataMigrationRunStatus>;
  type?: Maybe<BrandItemMasterDataMigrationRunKind>;
  updatedAt?: Maybe<Scalars['Date']>;
};

export enum BrandItemMasterDataMigrationRunKind {
  Migration = 'Migration',
  Preview = 'Preview'
}

export enum BrandItemMasterDataMigrationRunStatus {
  Completed = 'Completed',
  Failed = 'Failed',
  Processing = 'Processing',
  Queued = 'Queued'
}

export type BrandItemMasterDataMigrationSelectionInput = {
  brandItemId: Scalars['MongoID'];
  masterDataVariantId: Scalars['String'];
};

export type BrandItemMasterDataMigrationSignal = {
  __typename?: 'BrandItemMasterDataMigrationSignal';
  detail?: Maybe<Scalars['String']>;
  result?: Maybe<BrandItemMasterDataMigrationSignalResult>;
  score?: Maybe<Scalars['Float']>;
  type?: Maybe<BrandItemMasterDataMigrationSignalType>;
  weight?: Maybe<BrandItemMasterDataMigrationSignalWeight>;
};

export enum BrandItemMasterDataMigrationSignalResult {
  Ambiguous = 'Ambiguous',
  Contradiction = 'Contradiction',
  DiscardedShared = 'DiscardedShared',
  Match = 'Match',
  Missing = 'Missing',
  WeakMatch = 'WeakMatch'
}

export enum BrandItemMasterDataMigrationSignalType {
  ColorSize = 'ColorSize',
  Ean = 'Ean',
  ExternalId = 'ExternalId',
  Name = 'Name',
  Sku = 'Sku',
  Style = 'Style',
  Tags = 'Tags',
  Type = 'Type',
  Vendor = 'Vendor'
}

export enum BrandItemMasterDataMigrationSignalWeight {
  Medium = 'Medium',
  Strong = 'Strong',
  Weak = 'Weak'
}

export type BrandItemMasterDataMigrationUpdatedBy = {
  __typename?: 'BrandItemMasterDataMigrationUpdatedBy';
  ref?: Maybe<Scalars['MongoID']>;
  type: Scalars['String'];
};

export type BrandItemMasterDataRefreshResult = {
  __typename?: 'BrandItemMasterDataRefreshResult';
  queued: Scalars['Int'];
  requested: Scalars['Int'];
  skipped: Scalars['Int'];
};

export type BrandItemMasterDataSnapshot = {
  __typename?: 'BrandItemMasterDataSnapshot';
  /** Source BrandProduct at time of snapshot */
  brandProductId?: Maybe<Scalars['MongoID']>;
  /** Source BrandProductSize at time of snapshot */
  brandProductSizeId?: Maybe<Scalars['MongoID']>;
  /** Source BrandProductVariant at time of snapshot */
  brandProductVariantId?: Maybe<Scalars['MongoID']>;
  /** Localized product metafields at time of snapshot */
  localizedMetaFields?: Maybe<Array<Maybe<LocalizedMetaFieldInstance>>>;
  /** Product metafields at time of snapshot */
  metaFields?: Maybe<Array<Maybe<MetaField>>>;
  /** Size metafields at time of snapshot */
  sizeMetaFields?: Maybe<Array<Maybe<MetaField>>>;
  /** When the snapshot was taken */
  snapshotTs?: Maybe<Scalars['Date']>;
  /** Product tags at time of snapshot */
  tags?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Variant weight at time of snapshot */
  weight?: Maybe<Scalars['Float']>;
};

export type BrandItemMasterImage = {
  __typename?: 'BrandItemMasterImage';
  altText?: Maybe<Scalars['String']>;
  color?: Maybe<Scalars['String']>;
  externId?: Maybe<Scalars['String']>;
  imageId?: Maybe<Scalars['String']>;
  imageUrl: Scalars['String'];
  perspective?: Maybe<ImagePerspectiveEnum>;
  sourceType?: Maybe<BrandItemMasterImageSourceType>;
  type?: Maybe<ImageTypeEnum>;
};

export enum BrandItemMasterImageSourceType {
  BRAND_PRODUCT_SIZE = 'BRAND_PRODUCT_SIZE',
  BRAND_PRODUCT_VARIANT = 'BRAND_PRODUCT_VARIANT',
  MASTERDATA_SERVICE = 'MASTERDATA_SERVICE',
  MASTERDATA_SNAPSHOT = 'MASTERDATA_SNAPSHOT'
}

export type BrandItemProblem = {
  __typename?: 'BrandItemProblem';
  createdAt?: Maybe<Scalars['Date']>;
  description?: Maybe<Scalars['String']>;
  solved: Scalars['Boolean'];
};

export type BrandItemProblemInput = {
  createdAt?: InputMaybe<Scalars['Date']>;
  description?: InputMaybe<Scalars['String']>;
  solved: Scalars['Boolean'];
};

export type BrandItemResolved = {
  __typename?: 'BrandItemResolved';
  _id: Scalars['MongoID'];
  /** The boost in effect right now, if any */
  activeBoost?: Maybe<BrandItemBoost>;
  /** Attributes of the clothing item */
  attributes?: Maybe<BrandItemAttributes>;
  beforePrices?: Maybe<Array<Maybe<Pricing>>>;
  /** Every boost set on this item, newest first */
  boosts?: Maybe<Array<Maybe<BrandItemBoost>>>;
  brandHouse?: Maybe<BrandHouse>;
  brandHouseId: Scalars['MongoID'];
  /** Brand product size information */
  brandProductSize?: Maybe<BrandProductSize>;
  /** The master data variant/size */
  brandProductSizeId?: Maybe<Scalars['MongoID']>;
  /** The master data variant */
  brandProductVariantId?: Maybe<Scalars['MongoID']>;
  /** Product type in the requested language: typeLocalized, then translated attributes.type (da/de/en/nb/sv/fr/nl/es), then Unknown. */
  calculatedType: Scalars['String'];
  /** This item has been confirmed at the logisticspartner at the given date */
  checked?: Maybe<Scalars['Date']>;
  /** Localized color of the item */
  colorLocalized?: Maybe<Array<Maybe<LocalizationEntry>>>;
  /** True if the comment has been approved */
  commentApproved?: Maybe<Scalars['Boolean']>;
  /** Previous owner comments for the item, localized */
  commentLocalized?: Maybe<Array<Maybe<LocalizationEntry>>>;
  /** The tariff code for use in customs declarations. */
  commodityCode?: Maybe<Scalars['String']>;
  /** Condition of the item, between 1 and 3 */
  condition: Scalars['Float'];
  /** The countryOrigin of this brand item */
  countryOrigin?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['Date']>;
  /** Returns a list of data problems */
  dataErrors?: Maybe<Array<Scalars['String']>>;
  /** Actual days the item has been available for purchase (daysSinceFirstListed - daysOffline), null if never listed */
  daysForSale?: Maybe<Scalars['Int']>;
  /** Total days this item has been offline since firstListedDate */
  daysOffline?: Maybe<Scalars['Float']>;
  /** Total days since the item was first listed for sale (null if never listed) */
  daysSinceFirstListed?: Maybe<Scalars['Int']>;
  deleted?: Maybe<Scalars['Boolean']>;
  /** Localized description of the item */
  descriptionLocalized?: Maybe<Array<Maybe<LocalizationEntry>>>;
  directPrices?: Maybe<Array<Maybe<Pricing>>>;
  /** If true, the RRP list price is disabled */
  disableRRPListPrice?: Maybe<Scalars['Boolean']>;
  /** The date this item was discarded by the owner - a discarded item is not for sale */
  discarded?: Maybe<Scalars['Date']>;
  /** Whether the logistics partner has checked this stockitem since last recount */
  effectiveChecked: Scalars['Boolean'];
  /** Whether the logistics partner has marked this this stockitem as lost */
  effectiveMissing: Scalars['Boolean'];
  externalId?: Maybe<Scalars['String']>;
  /** The date when this item was first listed for sale (never recalculated) */
  firstListedDate?: Maybe<Scalars['Date']>;
  /** Cached key of the group of interchangeable items this item belongs to, set by the integrity event */
  groupKey?: Maybe<Scalars['String']>;
  hasComment?: Maybe<Scalars['Boolean']>;
  hasCustomImages?: Maybe<Scalars['Boolean']>;
  /** True if this item has errors */
  hasErrors: Scalars['Boolean'];
  hasLocation?: Maybe<Scalars['Boolean']>;
  hasMasterData?: Maybe<Scalars['Boolean']>;
  hasProblems?: Maybe<Scalars['Boolean']>;
  hasTranslatedComment?: Maybe<Scalars['Boolean']>;
  /** 512-dimensional embedding vector for the primary image */
  imageEmbedding?: Maybe<Array<Maybe<Scalars['Float']>>>;
  imageUrls?: Maybe<Array<Scalars['String']>>;
  /** Returns an array of images for this branditem */
  images?: Maybe<Array<Maybe<BrandItemImage>>>;
  /** If true, the manufacturer is invalid */
  invalidManufacturer?: Maybe<Scalars['Boolean']>;
  /** The invoice line for this item, if it exists */
  invoiceLine?: Maybe<InvoiceLine>;
  /** The invoice state for this item */
  invoiceState: Scalars['String'];
  /** Whether this stockitem is in-season */
  isInSeason: Scalars['Boolean'];
  isSold: Scalars['Boolean'];
  isTradeIn: Scalars['Boolean'];
  /** Internal EAN number for this brand-item */
  itemEan: Scalars['String'];
  /** Returns a list of item metafields */
  itemMetas?: Maybe<Array<Maybe<MetaFieldInstance>>>;
  /** The itemNr is a unique number for each branditem in context of the brandhouse */
  itemNr: Scalars['Float'];
  /** The SKU for this branditem */
  itemSku: Scalars['String'];
  /** State of the branditem */
  itemState: EnumBrandItemItemState;
  /** Returns a list of item tags */
  itemTags?: Maybe<Array<Maybe<BrandItemTag>>>;
  /** History of all location changes for this brand item */
  layawayHistory?: Maybe<Array<Maybe<BrandItemLayaway>>>;
  /** True if this item is linked to masterdata from a legacy group */
  legacyGroup: Scalars['Boolean'];
  /** The list price in selected currency, if not provided then shop currency */
  listPrice?: Maybe<Scalars['Float']>;
  /** List prices for this stockitem */
  listPrices?: Maybe<Array<Maybe<Pricing>>>;
  masterDataInfo?: Maybe<BrandItemMasterDataInfo>;
  /** Localized MAS masterdata metafields used as the source for item metafield resolution */
  masterDataLocalizedMetafields?: Maybe<Array<Maybe<LocalizedMetaFieldInstance>>>;
  /** MAS masterdata metafields used as the source for item metafield resolution */
  masterDataMetafields?: Maybe<Array<Maybe<MetaField>>>;
  /** The brandproduct masterdata that this itemis linked to */
  masterDataProduct?: Maybe<BrandProduct>;
  /** When MAS masterdata was last pulled into this item */
  masterDataPulledAt?: Maybe<Scalars['Date']>;
  masterDataSnapshot?: Maybe<BrandItemMasterDataSnapshot>;
  /** The external MAS masterdata variant id */
  masterDataVariantId?: Maybe<Scalars['String']>;
  /** This item is registered missing by the logisticspartner at the given date */
  missing?: Maybe<Scalars['Date']>;
  /** Localized name of the item */
  nameLocalized?: Maybe<Array<Maybe<LocalizationEntry>>>;
  /** The NFC Tag for this stockitem */
  nfcTag?: Maybe<Scalars['String']>;
  note?: Maybe<Scalars['String']>;
  options?: Maybe<Array<Maybe<OptionInstance>>>;
  /** If this branditem has an active orderline in one of its shops then this will be returned here */
  orderline?: Maybe<Order2Item>;
  /** If this branditem has orderlines in one of its shops then this will be returned here */
  orderlines?: Maybe<Array<Maybe<Order2Item>>>;
  /** The originalEan of this brand item */
  originalEan?: Maybe<Scalars['String']>;
  /** The originalSku of this brand item */
  originalSku?: Maybe<Scalars['String']>;
  problems?: Maybe<Array<Maybe<BrandItemProblem>>>;
  /** Cached, true while an older item in the same group is for sale and this one waits its turn */
  queued?: Maybe<Scalars['Boolean']>;
  reviewInfos?: Maybe<Array<Maybe<BrandItemReviewInfo>>>;
  /** Cached, true when the item would be for sale on its own: ready and active in a shop, located, unsold and free of blockers */
  saleable?: Maybe<Scalars['Boolean']>;
  /** The sales rank score (0-100) based on seasonal relevance and attribute popularity */
  salesRank: Scalars['Float'];
  /** Score indicating how sellable the item is (0-100) */
  salesScore?: Maybe<Scalars['Float']>;
  /** Timestamp when the sales score was last calculated */
  salesScoreTs?: Maybe<Scalars['Date']>;
  /** The selling price before tax in selected currency, if not provided then shop currency */
  sellingPrice?: Maybe<Scalars['Float']>;
  /** The selling prices for this branditem */
  sellingPrices?: Maybe<Array<Maybe<Pricing>>>;
  /** The shop info for this branditem */
  shops?: Maybe<Array<Maybe<BrandItemShopInfo>>>;
  /** The size of the item in a given language */
  size?: Maybe<Scalars['String']>;
  /** Localized size of the item */
  sizeLocalized?: Maybe<Array<Maybe<LocalizationEntry>>>;
  /** The date this item was sold */
  soldTs?: Maybe<Scalars['Date']>;
  /** The sortorder of this branditem */
  sortorder?: Maybe<Scalars['Float']>;
  /** The source type for this item */
  sourceType?: Maybe<ItemSourceType>;
  /** Aggregated state for this item, collected from multiple data sources */
  stateAggregation?: Maybe<BrandItemAggregatedStateEnum>;
  /** Statistics for this branditem */
  statistics?: Maybe<BrandItemStatistics>;
  stockLocation?: Maybe<Scalars['String']>;
  /** The barcode of the bag that the item is placed in at the stock location */
  stockLocationBag?: Maybe<Scalars['String']>;
  stockLocationTs?: Maybe<Scalars['Date']>;
  /** Returns a list of tags for this stockitem, use itemTags to see where the tag originated from */
  tags?: Maybe<Array<Scalars['String']>>;
  /** True if this item is a test item */
  test?: Maybe<Scalars['Boolean']>;
  /** Returns the tradein item that this branditem was made from */
  tradeInItem?: Maybe<TradeInItem>;
  /** Link to the tradein item, if applicable */
  tradeInItemId?: Maybe<Scalars['MongoID']>;
  /** The product type of this brand item */
  typeLocalized?: Maybe<Array<Maybe<LocalizationEntry>>>;
  /** This item is registered out of warehouse by the logisticspartner at the given date */
  unavailable?: Maybe<Scalars['Date']>;
  updatedAt?: Maybe<Scalars['Date']>;
  updatedBy?: Maybe<ObjectPatchesUpdatedBy>;
  /** Returns the VAS for this item */
  vas?: Maybe<Array<Maybe<BrandItemVas>>>;
  vasId?: Maybe<Scalars['String']>;
  /** Image references received from VAS for this item */
  vasImages?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** The current logistics state based on VAS entries */
  vasState?: Maybe<BrandItemLogisticsStateEnum>;
  /** The VAS contract version for this item */
  vasType?: Maybe<BrandItemVasTypeEnum>;
  /** The vendor type of this brand item */
  vendor?: Maybe<Scalars['String']>;
  /** Total page views for this item across all shops */
  views?: Maybe<Scalars['Float']>;
  /** Total unique visitors for this item across all shops */
  visitors?: Maybe<Scalars['Float']>;
};


export type BrandItemResolvedCalculatedTypeArgs = {
  language: Scalars['String'];
};


export type BrandItemResolvedImageUrlsArgs = {
  potentialImages?: InputMaybe<Scalars['Boolean']>;
};


export type BrandItemResolvedItemMetasArgs = {
  excludeAuto?: InputMaybe<Scalars['Boolean']>;
};


export type BrandItemResolvedItemTagsArgs = {
  includeAuto?: InputMaybe<Scalars['Boolean']>;
};


export type BrandItemResolvedListPriceArgs = {
  currency: Scalars['String'];
  excludeVAT?: InputMaybe<Scalars['Boolean']>;
};


export type BrandItemResolvedSalesRankArgs = {
  date?: InputMaybe<Scalars['Date']>;
};


export type BrandItemResolvedSellingPriceArgs = {
  currency: Scalars['String'];
  excludeVAT?: InputMaybe<Scalars['Boolean']>;
};


export type BrandItemResolvedSizeArgs = {
  language: Scalars['String'];
};


export type BrandItemResolvedStatisticsArgs = {
  date?: InputMaybe<Scalars['Date']>;
};

export type BrandItemReviewInfo = {
  __typename?: 'BrandItemReviewInfo';
  type: Scalars['String'];
  value: Scalars['String'];
};

export type BrandItemReviewInfoInput = {
  type: Scalars['String'];
  value: Scalars['String'];
};

export type BrandItemSaleInterval = {
  __typename?: 'BrandItemSaleInterval';
  /** The end date of the interval */
  end?: Maybe<Scalars['Date']>;
  /** The start date of the interval */
  start: Scalars['Date'];
};

export type BrandItemShopInfo = {
  __typename?: 'BrandItemShopInfo';
  _id: Scalars['MongoID'];
  /** Whether this item should be active in the shop */
  active: Scalars['Boolean'];
  /** The branditem */
  brandItemId: Scalars['MongoID'];
  createdAt?: Maybe<Scalars['Date']>;
  problems?: Maybe<Array<Scalars['String']>>;
  shop?: Maybe<Shop>;
  /** The shop */
  shopId: Scalars['MongoID'];
  stockItem?: Maybe<StockItemResolved>;
  stockItemId?: Maybe<Scalars['MongoID']>;
  updatedAt?: Maybe<Scalars['Date']>;
  updatedBy?: Maybe<ObjectPatchesUpdatedBy>;
};

export enum BrandItemStateEnum {
  DRAFT = 'DRAFT',
  NONE = 'NONE',
  READY = 'READY',
  REVIEW = 'REVIEW'
}

export type BrandItemStatistics = {
  __typename?: 'BrandItemStatistics';
  /** The total number of days the item has been for sale at the given date */
  saleDaysTotal?: Maybe<Scalars['Int']>;
  /** Intervals for this branditem */
  salePeriods?: Maybe<Array<Maybe<BrandItemSaleInterval>>>;
};

export type BrandItemTag = {
  __typename?: 'BrandItemTag';
  auto?: Maybe<Scalars['Boolean']>;
  tag?: Maybe<Scalars['String']>;
};

export type BrandItemTagInput = {
  auto?: InputMaybe<Scalars['Boolean']>;
  tag?: InputMaybe<Scalars['String']>;
};

export type BrandItemVas = {
  __typename?: 'BrandItemVas';
  /** If the vas is completed */
  completed: Scalars['Boolean'];
  /** The user that completed the vas */
  completedBy?: Maybe<Scalars['String']>;
  /** The date the vas was completed */
  completedDate?: Maybe<Scalars['Date']>;
  /** The sorting order of the vas */
  sortingOrder?: Maybe<Scalars['Float']>;
  /** The date the vas was started */
  startDate?: Maybe<Scalars['Date']>;
  /** The id of the vas */
  vasId: Scalars['String'];
  /** The name of the vas */
  vasName: Scalars['String'];
  /** The name of the workflow */
  workflowName?: Maybe<Scalars['String']>;
  /** The timestamp of the workflow */
  workflowTs?: Maybe<Scalars['Date']>;
};

export type BrandItemVasInput = {
  /** If the vas is completed */
  completed: Scalars['Boolean'];
  /** The user that completed the vas */
  completedBy?: InputMaybe<Scalars['String']>;
  /** The date the vas was completed */
  completedDate?: InputMaybe<Scalars['Date']>;
  /** The sorting order of the vas */
  sortingOrder?: InputMaybe<Scalars['Float']>;
  /** The date the vas was started */
  startDate?: InputMaybe<Scalars['Date']>;
  /** The id of the vas */
  vasId: Scalars['String'];
  /** The name of the vas */
  vasName: Scalars['String'];
  /** The name of the workflow */
  workflowName?: InputMaybe<Scalars['String']>;
  /** The timestamp of the workflow */
  workflowTs?: InputMaybe<Scalars['Date']>;
};

export enum BrandItemVasTypeEnum {
  VAS1_0 = 'VAS1_0',
  VAS2_0 = 'VAS2_0'
}

export type BrandItemsPublishResult = {
  __typename?: 'BrandItemsPublishResult';
  /** Items whose publishing changed in at least one storefront */
  changed: Scalars['Int'];
  /** Item ids passed in, duplicates included */
  requested: Scalars['Int'];
  /** Duplicate, missing, deleted or not permitted items */
  skipped: Scalars['Int'];
  /** Items already in the requested state */
  unchanged: Scalars['Int'];
};

/** The publishing state wanted in one storefront */
export type BrandItemsPublishShopInput = {
  active: Scalars['Boolean'];
  shopId: Scalars['MongoID'];
};

export type BrandLocale = {
  __typename?: 'BrandLocale';
  /** Whether the locale is for stockitems */
  activeItems?: Maybe<Scalars['Boolean']>;
  /** Whether the locale is active for tradein app */
  activeTradeIn?: Maybe<Scalars['Boolean']>;
  /** The iso alpha 2 locale code */
  locale: Scalars['String'];
};

export type BrandLocaleInput = {
  /** Whether the locale is for stockitems */
  activeItems?: InputMaybe<Scalars['Boolean']>;
  /** Whether the locale is active for tradein app */
  activeTradeIn?: InputMaybe<Scalars['Boolean']>;
  /** The iso alpha 2 locale code */
  locale: Scalars['String'];
};

export type BrandProduct = {
  __typename?: 'BrandProduct';
  _id: Scalars['MongoID'];
  /** The brand that owns this product */
  brandHouseId?: Maybe<Scalars['MongoID']>;
  /** Collections associated with this product */
  collections?: Maybe<Array<Maybe<Scalars['String']>>>;
  createdAt?: Maybe<Scalars['Date']>;
  /** Custom data for the product */
  customData?: Maybe<Scalars['JSON']>;
  /** True if this variant has been deleted */
  deleted?: Maybe<Scalars['Boolean']>;
  /** The product description */
  description?: Maybe<Scalars['String']>;
  /** The product description localized */
  descriptionLocalized: Array<Maybe<LocalizationEntry>>;
  /** Whether to disable the RRP list price */
  disableRRPListPrice?: Maybe<Scalars['Boolean']>;
  /** Whether this product is disabled and shouldn't be used in the platform at all */
  disabled?: Maybe<Scalars['Boolean']>;
  /** A product unique external identifier */
  externalId: Scalars['String'];
  /** The group that this product belongs to */
  groupId: Scalars['MongoID'];
  /** Returns a list of image urls for this product */
  imageUrls?: Maybe<Array<Scalars['String']>>;
  /** Extra data about the product, localized */
  localizedMetaFields?: Maybe<Array<Maybe<LocalizedMetaFieldInstance>>>;
  /** Extra data about the product */
  metaFields?: Maybe<Array<Maybe<MetaField>>>;
  /** The same of the product */
  name?: Maybe<Scalars['String']>;
  /** The name of the product localized */
  nameLocalized: Array<Maybe<LocalizationEntry>>;
  /** Whether this product is a preowned product */
  preOwned?: Maybe<Scalars['Boolean']>;
  /** Source of the brandproduct, such as imported, shopify, salesforce etc */
  source?: Maybe<Scalars['String']>;
  /** The style number should optimally be a joining identifier for a number of variants. Internally this number is not used for this purpose though */
  style?: Maybe<Scalars['String']>;
  /** Tags associated with this product */
  tags?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** The type of product */
  type?: Maybe<Scalars['String']>;
  /** The product type, a translateable field */
  typeLocalized?: Maybe<Array<Maybe<LocalizationEntry>>>;
  updatedAt?: Maybe<Scalars['Date']>;
  /** The latest user that updated this */
  updatedBy?: Maybe<ObjectPatchesUpdatedBy>;
  /** Returns a list of product variants for this product */
  variants?: Maybe<Array<Maybe<BrandProductVariant>>>;
  /** The vendor of this product */
  vendor?: Maybe<Scalars['String']>;
  /** The weight of this item in grams */
  weight?: Maybe<Scalars['Float']>;
};

/** List of items with pagination. */
export type BrandProductBrandProductsPagination = {
  __typename?: 'BrandProductBrandProductsPagination';
  /** Total object count. */
  count?: Maybe<Scalars['Int']>;
  /** Array of objects. */
  items?: Maybe<Array<BrandProduct>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type BrandProductGroup = {
  __typename?: 'BrandProductGroup';
  _id: Scalars['MongoID'];
  /** Is the group active for everything */
  active: Scalars['Boolean'];
  /** Is the group active for potential linking */
  activePotentials?: Maybe<Scalars['Boolean']>;
  /** Is the group active for promoting brand items */
  activePromotions?: Maybe<Scalars['Boolean']>;
  brandHouseId: Scalars['MongoID'];
  /** The name of the group */
  name: Scalars['String'];
};

export type BrandProductImage = {
  __typename?: 'BrandProductImage';
  _id: Scalars['MongoID'];
  archivedImage?: Maybe<Scalars['Boolean']>;
  archivedThumb?: Maybe<Scalars['Boolean']>;
  brandHouseId: Scalars['MongoID'];
  /** The product that owns this image */
  brandProductId?: Maybe<Scalars['MongoID']>;
  /** The variant that owns this image */
  brandProductVariantId?: Maybe<Scalars['MongoID']>;
  /** Colors represented by this image */
  colors?: Maybe<Array<Maybe<Scalars['String']>>>;
  createdAt?: Maybe<Scalars['Date']>;
  /** Custom data for the image */
  customData?: Maybe<Scalars['JSON']>;
  deleted?: Maybe<Scalars['Boolean']>;
  error?: Maybe<Scalars['String']>;
  errorCount?: Maybe<Scalars['Float']>;
  /** An image unique external identifier */
  externalId: Scalars['String'];
  /** The group that this product belongs to */
  groupId: Scalars['MongoID'];
  imageAltText?: Maybe<Scalars['String']>;
  /** The storage ID of the file, will be null until the image is successfully stored */
  imageId?: Maybe<Scalars['MongoID']>;
  /** The md5 hash of the image, used to compare images */
  imageMd5?: Maybe<Scalars['String']>;
  /**
   * If the image was processed by us / background removal, then this contains the version of the processing
   * use this to determine if the background process needs to be redone
   */
  imageRemoveBgVersion?: Maybe<Scalars['Float']>;
  /** Returns an url to the variant image */
  imageUrl?: Maybe<Scalars['String']>;
  /** An optional language tag for the image */
  language?: Maybe<Scalars['String']>;
  lastUpdate?: Maybe<Scalars['Date']>;
  /** Extra data about the image, localized */
  localizedMetaFields?: Maybe<Array<Maybe<LocalizedMetaFieldInstance>>>;
  /** Extra data about the image */
  metaFields?: Maybe<Array<Maybe<MetaField>>>;
  /** The storage ID of the original image file, typically the same as imageId - but if the imageId can be modified */
  originalId?: Maybe<Scalars['MongoID']>;
  /** The md5 hash of the original image, used to compare images */
  originalMd5?: Maybe<Scalars['String']>;
  perspective?: Maybe<EnumBrandProductImagePerspective>;
  sortOrder?: Maybe<Scalars['Float']>;
  sourceUrl?: Maybe<Scalars['String']>;
  /** The storage ID of the thumbnail file, will be null until the image is successfully stored */
  thumbnailId?: Maybe<Scalars['MongoID']>;
  type?: Maybe<EnumBrandProductImageType>;
  updatedAt?: Maybe<Scalars['Date']>;
};

export type BrandProductImageSynchronizeInput = {
  /** Custom data for the image */
  customData?: InputMaybe<Scalars['JSON']>;
  /** Brandhouse unique identifier for the variant */
  externalId: Scalars['String'];
  /** Optionally an image alt text for use on web */
  imageAltText?: InputMaybe<Scalars['String']>;
  /** Additional data for image */
  metaFields?: InputMaybe<Array<InputMaybe<MetaFieldInput>>>;
  /** The perspective of the image */
  perspective?: InputMaybe<ImagePerspectiveEnum>;
  /** Images will be sorted ascending by this number, if present */
  sortOrder?: InputMaybe<Scalars['Int']>;
  /** The external URL of this image */
  sourceUrl: Scalars['String'];
  /** The type of image */
  type?: InputMaybe<ImageTypeEnum>;
};

export type BrandProductSize = {
  __typename?: 'BrandProductSize';
  _id: Scalars['MongoID'];
  /** The brand that owns this variant */
  brandHouseId: Scalars['MongoID'];
  brandProductId: Scalars['MongoID'];
  /** The variant that owns this size */
  brandProductVariantId: Scalars['MongoID'];
  /** Returns the variant that owns this size */
  brandVariant?: Maybe<BrandProductVariant>;
  createdAt?: Maybe<Scalars['Date']>;
  /** True if this product has been deleted */
  deleted?: Maybe<Scalars['Boolean']>;
  /** The EAN-13 of this variant */
  ean?: Maybe<Scalars['String']>;
  /** A variant unique external identifier */
  externalId: Scalars['String'];
  /** Returns whether the size is in an active group */
  group?: Maybe<BrandProductGroup>;
  /** The group that this product belongs to */
  groupId: Scalars['MongoID'];
  /** Extra data about the size, localized */
  localizedMetaFields?: Maybe<Array<Maybe<LocalizedMetaFieldInstance>>>;
  /** Extra data about the variant */
  metaFields?: Maybe<Array<Maybe<MetaField>>>;
  /** The size of this variant */
  size?: Maybe<Scalars['String']>;
  /** The size of this variant translated into the supported languages */
  sizeLocalized: Array<Maybe<LocalizationEntry>>;
  /** The SKU of this variant */
  sku?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['Date']>;
};

export type BrandProductSizeSynchronizeInput = {
  /** Set to true in order to delete this variant */
  deleted?: InputMaybe<Scalars['Boolean']>;
  /** EAN for the product */
  ean?: InputMaybe<Scalars['String']>;
  /** Brandhouse unique identifier for the variant */
  externalId: Scalars['String'];
  /** Additional data for variant */
  metaFields?: InputMaybe<Array<InputMaybe<MetaFieldInput>>>;
  /** The size of the variant */
  size?: InputMaybe<Scalars['String']>;
  /** The size localized */
  sizeLocalized?: InputMaybe<Array<InputMaybe<LocalizationEntryInput>>>;
  /** SKU for the product */
  sku?: InputMaybe<Scalars['String']>;
};

export type BrandProductSynchronizeInput = {
  /** A list of collections that this product has been part of */
  collections?: InputMaybe<Array<Scalars['String']>>;
  /** Custom data for the product */
  customData?: InputMaybe<Scalars['JSON']>;
  /** Set to true in order to delete this product */
  deleted?: InputMaybe<Scalars['Boolean']>;
  /** The description of the product */
  description?: InputMaybe<Scalars['String']>;
  /** The description of the product localized */
  descriptionLocalized?: InputMaybe<Array<InputMaybe<LocalizationEntryInput>>>;
  /** Set to true in order to disable RRP list price */
  disableRRPListPrice?: InputMaybe<Scalars['Boolean']>;
  /** Set to true in order to disable this product */
  disabled?: InputMaybe<Scalars['Boolean']>;
  /** Brandhouse unique identifier for the product */
  externalId: Scalars['String'];
  /** Optionally the group id of the product, if no group is provided the default active group will be used */
  groupId?: InputMaybe<Scalars['MongoID']>;
  /** Localized metafields for product */
  localizedMetaFields?: InputMaybe<Array<InputMaybe<LocalizedMetaFieldInstanceInput>>>;
  /** Additional data for product */
  metaFields?: InputMaybe<Array<InputMaybe<MetaFieldInput>>>;
  /** The name of the product */
  name?: InputMaybe<Scalars['String']>;
  /** The name of the product localized */
  nameLocalized?: InputMaybe<Array<InputMaybe<LocalizationEntryInput>>>;
  /** Whether this is a preowned style */
  preOwned?: InputMaybe<Scalars['Boolean']>;
  /** Style number for the product */
  style?: InputMaybe<Scalars['String']>;
  /** A list of tags for the product */
  tags?: InputMaybe<Array<Scalars['String']>>;
  /** The type of product */
  type?: InputMaybe<Scalars['String']>;
  /** The type of the product localized */
  typeLocalized?: InputMaybe<Array<InputMaybe<LocalizationEntryInput>>>;
  /** Variants for this product */
  variants?: InputMaybe<Array<InputMaybe<BrandProductVariantSynchronizeInput>>>;
  /** The vendor of this product */
  vendor?: InputMaybe<Scalars['String']>;
};

export type BrandProductVariant = {
  __typename?: 'BrandProductVariant';
  _id: Scalars['MongoID'];
  /** The brand that owns this variant */
  brandHouseId?: Maybe<Scalars['MongoID']>;
  /** Returns the brandProduct that owns this variant */
  brandProduct?: Maybe<BrandProduct>;
  brandProductId: Scalars['MongoID'];
  /** The color of this variant */
  color?: Maybe<Scalars['String']>;
  /** The color of this variant translated into the supported languages */
  colorLocalized?: Maybe<Array<Maybe<LocalizationEntry>>>;
  /** The tariff code for use in customs declarations. */
  commodityCode?: Maybe<Scalars['String']>;
  /** The ISO 3166-1 alpha-2 country code of origin. */
  countryOrigin?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['Date']>;
  /** Custom data for the product */
  customData?: Maybe<Scalars['JSON']>;
  /** True if this variant should not be used in the platform */
  deactivated?: Maybe<Scalars['Boolean']>;
  /** True if this product has been deleted */
  deleted?: Maybe<Scalars['Boolean']>;
  /** The EAN-13 of this variant */
  ean?: Maybe<Scalars['String']>;
  /** A variant unique external identifier */
  externalId: Scalars['String'];
  /** The group that this product belongs to */
  groupId: Scalars['MongoID'];
  /** 712-dimensional embedding vector for the variant's packshot image */
  imageEmbedding?: Maybe<Array<Maybe<Scalars['Float']>>>;
  /** Returns a list of image urls for this variant */
  imageUrls?: Maybe<Array<Scalars['String']>>;
  /** Returns a list of images for this variant */
  images?: Maybe<Array<Maybe<BrandProductImage>>>;
  /** Extra data about the variant, localized */
  localizedMetaFields?: Maybe<Array<Maybe<LocalizedMetaFieldInstance>>>;
  /** Extra data about the variant */
  metaFields?: Maybe<Array<Maybe<MetaField>>>;
  /** The RRP prices for this variant */
  rrp?: Maybe<Array<Maybe<Pricing>>>;
  /** The size of this variant translated into the supported languages - DEPRECATED */
  sizeLocalized?: Maybe<Array<Maybe<LocalizationEntry>>>;
  /** Returns a list of sizes for this variant */
  sizes?: Maybe<Array<Maybe<BrandProductSize>>>;
  /** The SKU of this variant */
  sku?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['Date']>;
  /** The weight of this variant in grams */
  weight?: Maybe<Scalars['Float']>;
};

export type BrandProductVariantSynchronizeInput = {
  /** The color of the variant */
  color?: InputMaybe<Scalars['String']>;
  /** The color of the variant localized */
  colorLocalized?: InputMaybe<Array<InputMaybe<LocalizationEntryInput>>>;
  /** The tariff commodity code */
  commodityCode?: InputMaybe<Scalars['String']>;
  /** The country of origin for this variant */
  countryOrigin?: InputMaybe<Scalars['String']>;
  /** Custom data for the variant */
  customData?: InputMaybe<Scalars['JSON']>;
  /** Set to true in order to deactivate this variant */
  deactivated?: InputMaybe<Scalars['Boolean']>;
  /** Set to true in order to delete this variant */
  deleted?: InputMaybe<Scalars['Boolean']>;
  /** EAN for the product */
  ean?: InputMaybe<Scalars['String']>;
  /** Brandhouse unique identifier for the variant */
  externalId: Scalars['String'];
  /** Images for this variant */
  images?: InputMaybe<Array<InputMaybe<BrandProductImageSynchronizeInput>>>;
  /** Additional data for variant */
  metaFields?: InputMaybe<Array<InputMaybe<MetaFieldInput>>>;
  /** Price of the variant in multiple currencies */
  rrp?: InputMaybe<Array<InputMaybe<PricingInput>>>;
  /** Sizes for this variant */
  sizes?: InputMaybe<Array<InputMaybe<BrandProductSizeSynchronizeInput>>>;
  /** SKU for the product */
  sku?: InputMaybe<Scalars['String']>;
  /** The weight of the variant in kg */
  weight?: InputMaybe<Scalars['Float']>;
};

export type BrandRule = {
  __typename?: 'BrandRule';
  _id: Scalars['MongoID'];
  active?: Maybe<Scalars['Boolean']>;
  /** The brand */
  brand?: Maybe<Shop>;
  createdAt?: Maybe<Scalars['Date']>;
  /** The percentage of the digital passport value, relative to the voucher value */
  digitalPassportPct?: Maybe<Scalars['Float']>;
  digitalPassportValue?: Maybe<EnumBrandRuleDigitalPassportValue>;
  expressions?: Maybe<Array<Maybe<BrandRuleTradeInSearchAmountsExpressions>>>;
  invalid?: Maybe<Scalars['Boolean']>;
  locked?: Maybe<Scalars['Boolean']>;
  marketingActive?: Maybe<Scalars['Boolean']>;
  marketingConsentRequired?: Maybe<Scalars['Boolean']>;
  marketingDelay?: Maybe<Scalars['Float']>;
  maximumAge?: Maybe<Scalars['Float']>;
  minimumAge?: Maybe<Scalars['Float']>;
  minimumPrice?: Maybe<Scalars['Float']>;
  /** The minimum price, relative to RRP or SP */
  minimumPriceType?: Maybe<EnumBrandRuleMinimumPriceType>;
  periodFrom?: Maybe<Scalars['Date']>;
  periodTo?: Maybe<Scalars['Date']>;
  priority?: Maybe<Scalars['Float']>;
  products?: Maybe<BrandRuleProducts>;
  secondhandTradeInPct: Scalars['Float'];
  secondhandVoucherValue: EnumBrandRuleSecondhandVoucherValue;
  shopId: Scalars['MongoID'];
  /** Statistics about the brandrule */
  statistics?: Maybe<BrandRuleStatistics>;
  tradeInPricePct: Scalars['Float'];
  tradeInSearchAmounts?: Maybe<Array<Maybe<BrandRuleTradeInSearchAmounts>>>;
  /** The percentage of the trade-in value that can be used when searching for a tradein product */
  tradeInSearchPct?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Date']>;
  updatedBy?: Maybe<ObjectPatchesUpdatedBy>;
  /** The version number of this brandrule, will be incremented by one each time its changed/saved */
  version?: Maybe<Scalars['Float']>;
  voucherAmounts?: Maybe<Array<Maybe<BrandRuleTradeInSearchAmounts>>>;
  voucherStrategy: EnumBrandRuleVoucherStrategy;
  voucherValue: EnumBrandRuleVoucherValue;
};

export type BrandRuleInput = {
  _id?: InputMaybe<Scalars['MongoID']>;
  active?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Date']>;
  /** The percentage of the digital passport value, relative to the voucher value */
  digitalPassportPct?: InputMaybe<Scalars['Float']>;
  digitalPassportValue?: InputMaybe<EnumBrandRuleDigitalPassportValue>;
  expressions?: InputMaybe<Array<InputMaybe<BrandRuleTradeInSearchAmountsExpressionsInput>>>;
  invalid?: InputMaybe<Scalars['Boolean']>;
  locked?: InputMaybe<Scalars['Boolean']>;
  marketingActive?: InputMaybe<Scalars['Boolean']>;
  marketingConsentRequired?: InputMaybe<Scalars['Boolean']>;
  marketingDelay?: InputMaybe<Scalars['Float']>;
  maximumAge?: InputMaybe<Scalars['Float']>;
  minimumAge?: InputMaybe<Scalars['Float']>;
  minimumPrice?: InputMaybe<Scalars['Float']>;
  /** The minimum price, relative to RRP or SP */
  minimumPriceType?: InputMaybe<EnumBrandRuleMinimumPriceType>;
  periodFrom?: InputMaybe<Scalars['Date']>;
  periodTo?: InputMaybe<Scalars['Date']>;
  priority?: InputMaybe<Scalars['Float']>;
  products?: InputMaybe<BrandRuleProductsInput>;
  secondhandTradeInPct: Scalars['Float'];
  secondhandVoucherValue: EnumBrandRuleSecondhandVoucherValue;
  shopId: Scalars['MongoID'];
  /** Statistics about the brandrule */
  statistics?: InputMaybe<BrandRuleStatisticsInput>;
  tradeInPricePct: Scalars['Float'];
  tradeInSearchAmounts?: InputMaybe<Array<InputMaybe<BrandRuleTradeInSearchAmountsInput>>>;
  /** The percentage of the trade-in value that can be used when searching for a tradein product */
  tradeInSearchPct?: InputMaybe<Scalars['Float']>;
  updatedAt?: InputMaybe<Scalars['Date']>;
  updatedBy?: InputMaybe<ObjectPatchesUpdatedByInput>;
  /** The version number of this brandrule, will be incremented by one each time its changed/saved */
  version?: InputMaybe<Scalars['Float']>;
  voucherAmounts?: InputMaybe<Array<InputMaybe<BrandRuleTradeInSearchAmountsInput>>>;
  voucherStrategy: EnumBrandRuleVoucherStrategy;
  voucherValue: EnumBrandRuleVoucherValue;
};

export type BrandRuleProducts = {
  __typename?: 'BrandRuleProducts';
  collections?: Maybe<Array<Maybe<Scalars['String']>>>;
  ids?: Maybe<Array<Maybe<Scalars['MongoID']>>>;
  tags?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type BrandRuleProductsInput = {
  collections?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type BrandRuleStatistics = {
  __typename?: 'BrandRuleStatistics';
  /** Number of consumers matching the rule */
  consumers: Scalars['Float'];
  /** Number of consumers for all rules */
  consumersTotal: Scalars['Float'];
  /** Number of items matching the rule */
  items: Scalars['Float'];
  /** Number of items matching any rule */
  itemsTotal: Scalars['Float'];
  /** Number of consumers that will receive an e-mail on future distributions */
  sendingFuture: Scalars['Float'];
  /** Number of consumers that will receive an e-mail on next distribution */
  sendingNow: Scalars['Float'];
  /** When this statistics was last updated */
  ts?: Maybe<Scalars['Date']>;
  /** Total value of vouchers */
  voucherSum: Scalars['Float'];
  /** Total value of vouchers across brandrules */
  voucherTotal: Scalars['Float'];
};

export type BrandRuleStatisticsInput = {
  /** Number of consumers matching the rule */
  consumers: Scalars['Float'];
  /** Number of consumers for all rules */
  consumersTotal: Scalars['Float'];
  /** Number of items matching the rule */
  items: Scalars['Float'];
  /** Number of items matching any rule */
  itemsTotal: Scalars['Float'];
  /** Number of consumers that will receive an e-mail on future distributions */
  sendingFuture: Scalars['Float'];
  /** Number of consumers that will receive an e-mail on next distribution */
  sendingNow: Scalars['Float'];
  /** When this statistics was last updated */
  ts?: InputMaybe<Scalars['Date']>;
  /** Total value of vouchers */
  voucherSum: Scalars['Float'];
  /** Total value of vouchers across brandrules */
  voucherTotal: Scalars['Float'];
};

export type BrandRuleTradeInSearchAmounts = {
  __typename?: 'BrandRuleTradeInSearchAmounts';
  _id?: Maybe<Scalars['MongoID']>;
  active: Scalars['Boolean'];
  expressions?: Maybe<Array<Maybe<BrandRuleTradeInSearchAmountsExpressions>>>;
  tag?: Maybe<Scalars['String']>;
  value: Scalars['Float'];
};

export type BrandRuleTradeInSearchAmountsExpressions = {
  __typename?: 'BrandRuleTradeInSearchAmountsExpressions';
  /** Optionally a key for the valuetype */
  key?: Maybe<Scalars['String']>;
  operation: EnumBrandRuleTradeInSearchAmountsExpressionsOperation;
  value?: Maybe<Array<Maybe<Scalars['String']>>>;
  valueType: EnumBrandRuleTradeInSearchAmountsExpressionsValueType;
};

export type BrandRuleTradeInSearchAmountsExpressionsInput = {
  /** Optionally a key for the valuetype */
  key?: InputMaybe<Scalars['String']>;
  operation: EnumBrandRuleTradeInSearchAmountsExpressionsOperation;
  value?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  valueType: EnumBrandRuleTradeInSearchAmountsExpressionsValueType;
};

export type BrandRuleTradeInSearchAmountsInput = {
  _id?: InputMaybe<Scalars['MongoID']>;
  active: Scalars['Boolean'];
  expressions?: InputMaybe<Array<InputMaybe<BrandRuleTradeInSearchAmountsExpressionsInput>>>;
  tag?: InputMaybe<Scalars['String']>;
  value: Scalars['Float'];
};

export type BrandSetting = {
  __typename?: 'BrandSetting';
  _id?: Maybe<Scalars['MongoID']>;
  brandHouseId?: Maybe<Scalars['MongoID']>;
  circular?: Maybe<CircularSettings>;
  consumer?: Maybe<BrandSettingConsumer>;
  contactPerson?: Maybe<Scalars['String']>;
  contactPersonEmail?: Maybe<Scalars['String']>;
  countries?: Maybe<BrandSettingCountries>;
  createdAt?: Maybe<Scalars['Date']>;
  /** The default tariff code for use in customs declarations. */
  defaultCommodityCode?: Maybe<Scalars['String']>;
  /** The default ISO 3166-1 alpha-2 country code of origin for stockitems. */
  defaultCountryOfOrigin?: Maybe<Scalars['String']>;
  /** If a product has an unknown EAN, then this will be used instead */
  defaultProductEAN?: Maybe<Scalars['String']>;
  /** If a product is missing an image, this will be shown instead. Fully qualified URL, e.g. https://domain.xx/imagepath */
  defaultProductImage?: Maybe<Scalars['String']>;
  /** Whether the digital passport feature is active for this brand/shop */
  digitalPassportActive?: Maybe<Scalars['Boolean']>;
  /** If true, then the RRP will not be used as list price */
  disableRRPListPrice?: Maybe<Scalars['Boolean']>;
  /** Locale used as a silent fallback when localized fields are missing entries for an active locale. Defaults to 'en' when not set. */
  fallbackLocale?: Maybe<Scalars['String']>;
  klaviyoConfig?: Maybe<BrandSettingKlaviyoConfig>;
  /** Whether the old legacy integration to shopify is disabled, only valid for shops */
  legacyIntegrationDisabled?: Maybe<Scalars['Boolean']>;
  legacyIntegrationDisabledMessages?: Maybe<Array<Maybe<EnumBrandSettingLegacyIntegrationDisabledMessages>>>;
  /** The locales / languages that texts are translated into */
  locales?: Maybe<Array<Maybe<BrandLocale>>>;
  marketingConsentDisabled?: Maybe<Scalars['Boolean']>;
  masterDataConsolidate?: Maybe<BrandSettingMasterDataConsolidate>;
  /** This is the language that we receive master data (products, variants etc) in. Should not be changed */
  masterDataLocale?: Maybe<Scalars['String']>;
  /** If true, then master data will be image processed */
  masterDataRemoveBg?: Maybe<Scalars['Boolean']>;
  /** The version number */
  masterDataRemoveBgVersion?: Maybe<Scalars['Float']>;
  /** Include product images */
  masterDataUseProductImages?: Maybe<Scalars['Boolean']>;
  /** Settings for orders */
  order?: Maybe<BrandSettingOrder>;
  plannedMailsTradeIn?: Maybe<BrandSettingPlannedMailsTradeIn>;
  plannedMailsVoucher?: Maybe<BrandSettingPlannedMailsVoucher>;
  /** List of all tags used in advanced pricing rules, can be a 0-length array */
  pricingTags?: Maybe<Array<Scalars['String']>>;
  /** List of all counties activated */
  selectedCountries?: Maybe<Array<Scalars['String']>>;
  sellPrice?: Maybe<Array<Maybe<BrandSettingSellPrice>>>;
  sellPriceAdvanced?: Maybe<Array<Maybe<BrandSettingSellPriceAdvanced>>>;
  /** The currency of the shop, not available for brandHouse */
  shopCurrency?: Maybe<Scalars['String']>;
  shopId?: Maybe<Scalars['MongoID']>;
  shopIdentifier?: Maybe<Scalars['String']>;
  stockItemConfig?: Maybe<BrandSettingStockItemConfig>;
  thumbnails?: Maybe<BrandSettingThumbnails>;
  tracking?: Maybe<Scalars['Boolean']>;
  tradeIn2?: Maybe<TradeInLayout>;
  tradeIn2Active?: Maybe<Scalars['Boolean']>;
  tradeIn2Analytics?: Maybe<BrandSettingTradeIn2Analytics>;
  /** If provided, the tradein-app can decide to validate that the email does not match this filter */
  tradeIn2InvalidEmailExp?: Maybe<Scalars['String']>;
  /** If true, then the trade-in app will allow comments from the previous owner */
  tradeInComments?: Maybe<Scalars['Boolean']>;
  /** If true, then the language selector will be hidden on the consumerform page */
  tradeInHideLanguageSelector?: Maybe<Scalars['Boolean']>;
  /** Whether the trade-in app should allow login when consumer has no potentials */
  tradeInLoginWithoutData?: Maybe<Scalars['Boolean']>;
  /** Whether the trade-in app should allow payout method to be selected by customer */
  tradeInPayoutEnabled?: Maybe<Scalars['Boolean']>;
  /** The percentage of the trade-in value that can be paid out (1-100%) */
  tradeInPayoutPct?: Maybe<Scalars['Float']>;
  /** Whether the trade-in app should use points instead of currency */
  tradeInPointsEnabled?: Maybe<Scalars['Boolean']>;
  /** The rate of points to currency, default is 1 */
  tradeInPointsRate?: Maybe<Scalars['Float']>;
  /** Whether the search based trade-in process is enabled */
  tradeInProductSearch?: Maybe<Scalars['Boolean']>;
  /** If provided, the product search feature will only search within this group */
  tradeInProductSearchGroupId?: Maybe<Scalars['MongoID']>;
  /** If true, only products with images will be included in the trade-in search results */
  tradeInProductSearchImagesOnly?: Maybe<Scalars['Boolean']>;
  /** If provided, the product search feature will create a masked input field */
  tradeInProductSearchMask?: Maybe<Scalars['String']>;
  /** Whether the tradein app should utilize hashes or browser address for state - default is browser */
  tradeInRouter?: Maybe<EnumBrandSettingTradeInRouter>;
  /** Whether the reward system should deduct the voucher value when a tradein item is rejected */
  tradeInVoucherDeduction?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['Date']>;
  updatedBy?: Maybe<ObjectPatchesUpdatedBy>;
  /** If enabled, only stock items on brand level is allowed */
  useBrandItems?: Maybe<Scalars['Boolean']>;
  /** Whether the brand/shop is using the return portal */
  usingReturnPortal?: Maybe<Scalars['Boolean']>;
  voucher?: Maybe<BrandSettingVoucher>;
};

export type BrandSettingConsumer = {
  __typename?: 'BrandSettingConsumer';
  authMethods?: Maybe<Array<Maybe<Scalars['String']>>>;
  lockEmail?: Maybe<Scalars['Boolean']>;
};

export type BrandSettingConsumerInput = {
  authMethods?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lockEmail?: InputMaybe<Scalars['Boolean']>;
};

export type BrandSettingCountries = {
  __typename?: 'BrandSettingCountries';
  AT?: Maybe<BrandSettingCountriesAt>;
  BE?: Maybe<BrandSettingCountriesBe>;
  BG?: Maybe<BrandSettingCountriesBg>;
  CY?: Maybe<BrandSettingCountriesCy>;
  CZ?: Maybe<BrandSettingCountriesCz>;
  DE?: Maybe<BrandSettingCountriesDe>;
  DK?: Maybe<BrandSettingCountriesDk>;
  EE?: Maybe<BrandSettingCountriesEe>;
  ES?: Maybe<BrandSettingCountriesEs>;
  FI?: Maybe<BrandSettingCountriesFi>;
  FR?: Maybe<BrandSettingCountriesFr>;
  GB?: Maybe<BrandSettingCountriesGb>;
  GR?: Maybe<BrandSettingCountriesGr>;
  HR?: Maybe<BrandSettingCountriesHr>;
  HU?: Maybe<BrandSettingCountriesHu>;
  IE?: Maybe<BrandSettingCountriesIe>;
  IT?: Maybe<BrandSettingCountriesIt>;
  LT?: Maybe<BrandSettingCountriesLt>;
  LU?: Maybe<BrandSettingCountriesLu>;
  LV?: Maybe<BrandSettingCountriesLv>;
  MT?: Maybe<BrandSettingCountriesMt>;
  NL?: Maybe<BrandSettingCountriesNl>;
  NO?: Maybe<BrandSettingCountriesNo>;
  PL?: Maybe<BrandSettingCountriesPl>;
  PT?: Maybe<BrandSettingCountriesPt>;
  RO?: Maybe<BrandSettingCountriesRo>;
  SE?: Maybe<BrandSettingCountriesSe>;
  SI?: Maybe<BrandSettingCountriesSi>;
  SK?: Maybe<BrandSettingCountriesSk>;
  SL?: Maybe<BrandSettingCountriesSl>;
};

export type BrandSettingCountriesAt = {
  __typename?: 'BrandSettingCountriesAT';
  currency?: Maybe<Scalars['String']>;
  enabled?: Maybe<Scalars['Boolean']>;
  vat?: Maybe<Scalars['Float']>;
};

export type BrandSettingCountriesAtInput = {
  currency?: InputMaybe<Scalars['String']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  vat?: InputMaybe<Scalars['Float']>;
};

export type BrandSettingCountriesBe = {
  __typename?: 'BrandSettingCountriesBE';
  currency?: Maybe<Scalars['String']>;
  enabled?: Maybe<Scalars['Boolean']>;
  vat?: Maybe<Scalars['Float']>;
};

export type BrandSettingCountriesBeInput = {
  currency?: InputMaybe<Scalars['String']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  vat?: InputMaybe<Scalars['Float']>;
};

export type BrandSettingCountriesBg = {
  __typename?: 'BrandSettingCountriesBG';
  currency?: Maybe<Scalars['String']>;
  enabled?: Maybe<Scalars['Boolean']>;
  vat?: Maybe<Scalars['Float']>;
};

export type BrandSettingCountriesBgInput = {
  currency?: InputMaybe<Scalars['String']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  vat?: InputMaybe<Scalars['Float']>;
};

export type BrandSettingCountriesCy = {
  __typename?: 'BrandSettingCountriesCY';
  currency?: Maybe<Scalars['String']>;
  enabled?: Maybe<Scalars['Boolean']>;
  vat?: Maybe<Scalars['Float']>;
};

export type BrandSettingCountriesCyInput = {
  currency?: InputMaybe<Scalars['String']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  vat?: InputMaybe<Scalars['Float']>;
};

export type BrandSettingCountriesCz = {
  __typename?: 'BrandSettingCountriesCZ';
  currency?: Maybe<Scalars['String']>;
  enabled?: Maybe<Scalars['Boolean']>;
  vat?: Maybe<Scalars['Float']>;
};

export type BrandSettingCountriesCzInput = {
  currency?: InputMaybe<Scalars['String']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  vat?: InputMaybe<Scalars['Float']>;
};

export type BrandSettingCountriesDe = {
  __typename?: 'BrandSettingCountriesDE';
  currency?: Maybe<Scalars['String']>;
  enabled?: Maybe<Scalars['Boolean']>;
  vat?: Maybe<Scalars['Float']>;
};

export type BrandSettingCountriesDeInput = {
  currency?: InputMaybe<Scalars['String']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  vat?: InputMaybe<Scalars['Float']>;
};

export type BrandSettingCountriesDk = {
  __typename?: 'BrandSettingCountriesDK';
  currency?: Maybe<Scalars['String']>;
  enabled?: Maybe<Scalars['Boolean']>;
  vat?: Maybe<Scalars['Float']>;
};

export type BrandSettingCountriesDkInput = {
  currency?: InputMaybe<Scalars['String']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  vat?: InputMaybe<Scalars['Float']>;
};

export type BrandSettingCountriesEe = {
  __typename?: 'BrandSettingCountriesEE';
  currency?: Maybe<Scalars['String']>;
  enabled?: Maybe<Scalars['Boolean']>;
  vat?: Maybe<Scalars['Float']>;
};

export type BrandSettingCountriesEeInput = {
  currency?: InputMaybe<Scalars['String']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  vat?: InputMaybe<Scalars['Float']>;
};

export type BrandSettingCountriesEs = {
  __typename?: 'BrandSettingCountriesES';
  currency?: Maybe<Scalars['String']>;
  enabled?: Maybe<Scalars['Boolean']>;
  vat?: Maybe<Scalars['Float']>;
};

export type BrandSettingCountriesEsInput = {
  currency?: InputMaybe<Scalars['String']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  vat?: InputMaybe<Scalars['Float']>;
};

export type BrandSettingCountriesFi = {
  __typename?: 'BrandSettingCountriesFI';
  currency?: Maybe<Scalars['String']>;
  enabled?: Maybe<Scalars['Boolean']>;
  vat?: Maybe<Scalars['Float']>;
};

export type BrandSettingCountriesFiInput = {
  currency?: InputMaybe<Scalars['String']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  vat?: InputMaybe<Scalars['Float']>;
};

export type BrandSettingCountriesFr = {
  __typename?: 'BrandSettingCountriesFR';
  currency?: Maybe<Scalars['String']>;
  enabled?: Maybe<Scalars['Boolean']>;
  vat?: Maybe<Scalars['Float']>;
};

export type BrandSettingCountriesFrInput = {
  currency?: InputMaybe<Scalars['String']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  vat?: InputMaybe<Scalars['Float']>;
};

export type BrandSettingCountriesGb = {
  __typename?: 'BrandSettingCountriesGB';
  currency?: Maybe<Scalars['String']>;
  enabled?: Maybe<Scalars['Boolean']>;
  vat?: Maybe<Scalars['Float']>;
};

export type BrandSettingCountriesGbInput = {
  currency?: InputMaybe<Scalars['String']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  vat?: InputMaybe<Scalars['Float']>;
};

export type BrandSettingCountriesGr = {
  __typename?: 'BrandSettingCountriesGR';
  currency?: Maybe<Scalars['String']>;
  enabled?: Maybe<Scalars['Boolean']>;
  vat?: Maybe<Scalars['Float']>;
};

export type BrandSettingCountriesGrInput = {
  currency?: InputMaybe<Scalars['String']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  vat?: InputMaybe<Scalars['Float']>;
};

export type BrandSettingCountriesHr = {
  __typename?: 'BrandSettingCountriesHR';
  currency?: Maybe<Scalars['String']>;
  enabled?: Maybe<Scalars['Boolean']>;
  vat?: Maybe<Scalars['Float']>;
};

export type BrandSettingCountriesHrInput = {
  currency?: InputMaybe<Scalars['String']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  vat?: InputMaybe<Scalars['Float']>;
};

export type BrandSettingCountriesHu = {
  __typename?: 'BrandSettingCountriesHU';
  currency?: Maybe<Scalars['String']>;
  enabled?: Maybe<Scalars['Boolean']>;
  vat?: Maybe<Scalars['Float']>;
};

export type BrandSettingCountriesHuInput = {
  currency?: InputMaybe<Scalars['String']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  vat?: InputMaybe<Scalars['Float']>;
};

export type BrandSettingCountriesIe = {
  __typename?: 'BrandSettingCountriesIE';
  currency?: Maybe<Scalars['String']>;
  enabled?: Maybe<Scalars['Boolean']>;
  vat?: Maybe<Scalars['Float']>;
};

export type BrandSettingCountriesIeInput = {
  currency?: InputMaybe<Scalars['String']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  vat?: InputMaybe<Scalars['Float']>;
};

export type BrandSettingCountriesIt = {
  __typename?: 'BrandSettingCountriesIT';
  currency?: Maybe<Scalars['String']>;
  enabled?: Maybe<Scalars['Boolean']>;
  vat?: Maybe<Scalars['Float']>;
};

export type BrandSettingCountriesItInput = {
  currency?: InputMaybe<Scalars['String']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  vat?: InputMaybe<Scalars['Float']>;
};

export type BrandSettingCountriesInput = {
  AT?: InputMaybe<BrandSettingCountriesAtInput>;
  BE?: InputMaybe<BrandSettingCountriesBeInput>;
  BG?: InputMaybe<BrandSettingCountriesBgInput>;
  CY?: InputMaybe<BrandSettingCountriesCyInput>;
  CZ?: InputMaybe<BrandSettingCountriesCzInput>;
  DE?: InputMaybe<BrandSettingCountriesDeInput>;
  DK?: InputMaybe<BrandSettingCountriesDkInput>;
  EE?: InputMaybe<BrandSettingCountriesEeInput>;
  ES?: InputMaybe<BrandSettingCountriesEsInput>;
  FI?: InputMaybe<BrandSettingCountriesFiInput>;
  FR?: InputMaybe<BrandSettingCountriesFrInput>;
  GB?: InputMaybe<BrandSettingCountriesGbInput>;
  GR?: InputMaybe<BrandSettingCountriesGrInput>;
  HR?: InputMaybe<BrandSettingCountriesHrInput>;
  HU?: InputMaybe<BrandSettingCountriesHuInput>;
  IE?: InputMaybe<BrandSettingCountriesIeInput>;
  IT?: InputMaybe<BrandSettingCountriesItInput>;
  LT?: InputMaybe<BrandSettingCountriesLtInput>;
  LU?: InputMaybe<BrandSettingCountriesLuInput>;
  LV?: InputMaybe<BrandSettingCountriesLvInput>;
  MT?: InputMaybe<BrandSettingCountriesMtInput>;
  NL?: InputMaybe<BrandSettingCountriesNlInput>;
  NO?: InputMaybe<BrandSettingCountriesNoInput>;
  PL?: InputMaybe<BrandSettingCountriesPlInput>;
  PT?: InputMaybe<BrandSettingCountriesPtInput>;
  RO?: InputMaybe<BrandSettingCountriesRoInput>;
  SE?: InputMaybe<BrandSettingCountriesSeInput>;
  SI?: InputMaybe<BrandSettingCountriesSiInput>;
  SK?: InputMaybe<BrandSettingCountriesSkInput>;
  SL?: InputMaybe<BrandSettingCountriesSlInput>;
};

export type BrandSettingCountriesLt = {
  __typename?: 'BrandSettingCountriesLT';
  currency?: Maybe<Scalars['String']>;
  enabled?: Maybe<Scalars['Boolean']>;
  vat?: Maybe<Scalars['Float']>;
};

export type BrandSettingCountriesLtInput = {
  currency?: InputMaybe<Scalars['String']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  vat?: InputMaybe<Scalars['Float']>;
};

export type BrandSettingCountriesLu = {
  __typename?: 'BrandSettingCountriesLU';
  currency?: Maybe<Scalars['String']>;
  enabled?: Maybe<Scalars['Boolean']>;
  vat?: Maybe<Scalars['Float']>;
};

export type BrandSettingCountriesLuInput = {
  currency?: InputMaybe<Scalars['String']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  vat?: InputMaybe<Scalars['Float']>;
};

export type BrandSettingCountriesLv = {
  __typename?: 'BrandSettingCountriesLV';
  currency?: Maybe<Scalars['String']>;
  enabled?: Maybe<Scalars['Boolean']>;
  vat?: Maybe<Scalars['Float']>;
};

export type BrandSettingCountriesLvInput = {
  currency?: InputMaybe<Scalars['String']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  vat?: InputMaybe<Scalars['Float']>;
};

export type BrandSettingCountriesMt = {
  __typename?: 'BrandSettingCountriesMT';
  currency?: Maybe<Scalars['String']>;
  enabled?: Maybe<Scalars['Boolean']>;
  vat?: Maybe<Scalars['Float']>;
};

export type BrandSettingCountriesMtInput = {
  currency?: InputMaybe<Scalars['String']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  vat?: InputMaybe<Scalars['Float']>;
};

export type BrandSettingCountriesNl = {
  __typename?: 'BrandSettingCountriesNL';
  currency?: Maybe<Scalars['String']>;
  enabled?: Maybe<Scalars['Boolean']>;
  vat?: Maybe<Scalars['Float']>;
};

export type BrandSettingCountriesNlInput = {
  currency?: InputMaybe<Scalars['String']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  vat?: InputMaybe<Scalars['Float']>;
};

export type BrandSettingCountriesNo = {
  __typename?: 'BrandSettingCountriesNO';
  currency?: Maybe<Scalars['String']>;
  enabled?: Maybe<Scalars['Boolean']>;
  vat?: Maybe<Scalars['Float']>;
};

export type BrandSettingCountriesNoInput = {
  currency?: InputMaybe<Scalars['String']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  vat?: InputMaybe<Scalars['Float']>;
};

export type BrandSettingCountriesPl = {
  __typename?: 'BrandSettingCountriesPL';
  currency?: Maybe<Scalars['String']>;
  enabled?: Maybe<Scalars['Boolean']>;
  vat?: Maybe<Scalars['Float']>;
};

export type BrandSettingCountriesPlInput = {
  currency?: InputMaybe<Scalars['String']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  vat?: InputMaybe<Scalars['Float']>;
};

export type BrandSettingCountriesPt = {
  __typename?: 'BrandSettingCountriesPT';
  currency?: Maybe<Scalars['String']>;
  enabled?: Maybe<Scalars['Boolean']>;
  vat?: Maybe<Scalars['Float']>;
};

export type BrandSettingCountriesPtInput = {
  currency?: InputMaybe<Scalars['String']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  vat?: InputMaybe<Scalars['Float']>;
};

export type BrandSettingCountriesRo = {
  __typename?: 'BrandSettingCountriesRO';
  currency?: Maybe<Scalars['String']>;
  enabled?: Maybe<Scalars['Boolean']>;
  vat?: Maybe<Scalars['Float']>;
};

export type BrandSettingCountriesRoInput = {
  currency?: InputMaybe<Scalars['String']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  vat?: InputMaybe<Scalars['Float']>;
};

export type BrandSettingCountriesSe = {
  __typename?: 'BrandSettingCountriesSE';
  currency?: Maybe<Scalars['String']>;
  enabled?: Maybe<Scalars['Boolean']>;
  vat?: Maybe<Scalars['Float']>;
};

export type BrandSettingCountriesSeInput = {
  currency?: InputMaybe<Scalars['String']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  vat?: InputMaybe<Scalars['Float']>;
};

export type BrandSettingCountriesSi = {
  __typename?: 'BrandSettingCountriesSI';
  currency?: Maybe<Scalars['String']>;
  enabled?: Maybe<Scalars['Boolean']>;
  vat?: Maybe<Scalars['Float']>;
};

export type BrandSettingCountriesSiInput = {
  currency?: InputMaybe<Scalars['String']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  vat?: InputMaybe<Scalars['Float']>;
};

export type BrandSettingCountriesSk = {
  __typename?: 'BrandSettingCountriesSK';
  currency?: Maybe<Scalars['String']>;
  enabled?: Maybe<Scalars['Boolean']>;
  vat?: Maybe<Scalars['Float']>;
};

export type BrandSettingCountriesSkInput = {
  currency?: InputMaybe<Scalars['String']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  vat?: InputMaybe<Scalars['Float']>;
};

export type BrandSettingCountriesSl = {
  __typename?: 'BrandSettingCountriesSL';
  currency?: Maybe<Scalars['String']>;
  enabled?: Maybe<Scalars['Boolean']>;
  vat?: Maybe<Scalars['Float']>;
};

export type BrandSettingCountriesSlInput = {
  currency?: InputMaybe<Scalars['String']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  vat?: InputMaybe<Scalars['Float']>;
};

export type BrandSettingInput = {
  _id?: InputMaybe<Scalars['MongoID']>;
  brandHouseId?: InputMaybe<Scalars['MongoID']>;
  circular?: InputMaybe<CircularSettingsInput>;
  consumer?: InputMaybe<BrandSettingConsumerInput>;
  contactPerson?: InputMaybe<Scalars['String']>;
  contactPersonEmail?: InputMaybe<Scalars['String']>;
  countries?: InputMaybe<BrandSettingCountriesInput>;
  createdAt?: InputMaybe<Scalars['Date']>;
  /** The default tariff code for use in customs declarations. */
  defaultCommodityCode?: InputMaybe<Scalars['String']>;
  /** The default ISO 3166-1 alpha-2 country code of origin for stockitems. */
  defaultCountryOfOrigin?: InputMaybe<Scalars['String']>;
  /** If a product has an unknown EAN, then this will be used instead */
  defaultProductEAN?: InputMaybe<Scalars['String']>;
  /** If a product is missing an image, this will be shown instead. Fully qualified URL, e.g. https://domain.xx/imagepath */
  defaultProductImage?: InputMaybe<Scalars['String']>;
  /** Whether the digital passport feature is active for this brand/shop */
  digitalPassportActive?: InputMaybe<Scalars['Boolean']>;
  /** If true, then the RRP will not be used as list price */
  disableRRPListPrice?: InputMaybe<Scalars['Boolean']>;
  /** Locale used as a silent fallback when localized fields are missing entries for an active locale. Defaults to 'en' when not set. */
  fallbackLocale?: InputMaybe<Scalars['String']>;
  klaviyoConfig?: InputMaybe<BrandSettingKlaviyoConfigInput>;
  /** Whether the old legacy integration to shopify is disabled, only valid for shops */
  legacyIntegrationDisabled?: InputMaybe<Scalars['Boolean']>;
  legacyIntegrationDisabledMessages?: InputMaybe<Array<InputMaybe<EnumBrandSettingLegacyIntegrationDisabledMessages>>>;
  /** The locales / languages that texts are translated into */
  locales?: InputMaybe<Array<InputMaybe<BrandLocaleInput>>>;
  marketingConsentDisabled?: InputMaybe<Scalars['Boolean']>;
  masterDataConsolidate?: InputMaybe<BrandSettingMasterDataConsolidateInput>;
  /** This is the language that we receive master data (products, variants etc) in. Should not be changed */
  masterDataLocale?: InputMaybe<Scalars['String']>;
  /** If true, then master data will be image processed */
  masterDataRemoveBg?: InputMaybe<Scalars['Boolean']>;
  /** The version number */
  masterDataRemoveBgVersion?: InputMaybe<Scalars['Float']>;
  /** Include product images */
  masterDataUseProductImages?: InputMaybe<Scalars['Boolean']>;
  /** Settings for orders */
  order?: InputMaybe<BrandSettingOrderInput>;
  plannedMailsTradeIn?: InputMaybe<BrandSettingPlannedMailsTradeInInput>;
  plannedMailsVoucher?: InputMaybe<BrandSettingPlannedMailsVoucherInput>;
  sellPrice?: InputMaybe<Array<InputMaybe<BrandSettingSellPriceInput>>>;
  sellPriceAdvanced?: InputMaybe<Array<InputMaybe<BrandSettingSellPriceAdvancedInput>>>;
  shopIdentifier?: InputMaybe<Scalars['String']>;
  stockItemConfig?: InputMaybe<BrandSettingStockItemConfigInput>;
  thumbnails?: InputMaybe<BrandSettingThumbnailsInput>;
  tracking?: InputMaybe<Scalars['Boolean']>;
  tradeIn2?: InputMaybe<TradeInLayoutInput>;
  tradeIn2Active?: InputMaybe<Scalars['Boolean']>;
  tradeIn2Analytics?: InputMaybe<BrandSettingTradeIn2AnalyticsInput>;
  /** If provided, the tradein-app can decide to validate that the email does not match this filter */
  tradeIn2InvalidEmailExp?: InputMaybe<Scalars['String']>;
  /** If true, then the trade-in app will allow comments from the previous owner */
  tradeInComments?: InputMaybe<Scalars['Boolean']>;
  /** If true, then the language selector will be hidden on the consumerform page */
  tradeInHideLanguageSelector?: InputMaybe<Scalars['Boolean']>;
  /** Whether the trade-in app should allow login when consumer has no potentials */
  tradeInLoginWithoutData?: InputMaybe<Scalars['Boolean']>;
  /** Whether the trade-in app should allow payout method to be selected by customer */
  tradeInPayoutEnabled?: InputMaybe<Scalars['Boolean']>;
  /** The percentage of the trade-in value that can be paid out (1-100%) */
  tradeInPayoutPct?: InputMaybe<Scalars['Float']>;
  /** Whether the trade-in app should use points instead of currency */
  tradeInPointsEnabled?: InputMaybe<Scalars['Boolean']>;
  /** The rate of points to currency, default is 1 */
  tradeInPointsRate?: InputMaybe<Scalars['Float']>;
  /** Whether the search based trade-in process is enabled */
  tradeInProductSearch?: InputMaybe<Scalars['Boolean']>;
  /** If provided, the product search feature will only search within this group */
  tradeInProductSearchGroupId?: InputMaybe<Scalars['MongoID']>;
  /** If true, only products with images will be included in the trade-in search results */
  tradeInProductSearchImagesOnly?: InputMaybe<Scalars['Boolean']>;
  /** If provided, the product search feature will create a masked input field */
  tradeInProductSearchMask?: InputMaybe<Scalars['String']>;
  /** Whether the tradein app should utilize hashes or browser address for state - default is browser */
  tradeInRouter?: InputMaybe<EnumBrandSettingTradeInRouter>;
  /** Whether the reward system should deduct the voucher value when a tradein item is rejected */
  tradeInVoucherDeduction?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['Date']>;
  updatedBy?: InputMaybe<ObjectPatchesUpdatedByInput>;
  /** If enabled, only stock items on brand level is allowed */
  useBrandItems?: InputMaybe<Scalars['Boolean']>;
  voucher?: InputMaybe<BrandSettingVoucherInput>;
};

export type BrandSettingKlaviyoConfig = {
  __typename?: 'BrandSettingKlaviyoConfig';
  allowNewIdentities?: Maybe<Scalars['Boolean']>;
  enabled?: Maybe<Scalars['Boolean']>;
  exportEvents?: Maybe<Scalars['Boolean']>;
  exportOffers?: Maybe<Scalars['Boolean']>;
  failedTs?: Maybe<Scalars['Date']>;
  privateToken?: Maybe<Scalars['String']>;
  publicToken?: Maybe<Scalars['String']>;
  updatedTs?: Maybe<Scalars['Date']>;
};

export type BrandSettingKlaviyoConfigInput = {
  allowNewIdentities?: InputMaybe<Scalars['Boolean']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  exportEvents?: InputMaybe<Scalars['Boolean']>;
  exportOffers?: InputMaybe<Scalars['Boolean']>;
  failedTs?: InputMaybe<Scalars['Date']>;
  privateToken?: InputMaybe<Scalars['String']>;
  publicToken?: InputMaybe<Scalars['String']>;
  updatedTs?: InputMaybe<Scalars['Date']>;
};

export type BrandSettingMasterDataConsolidate = {
  __typename?: 'BrandSettingMasterDataConsolidate';
  /** Whether we should automatically merge masterdata items */
  autoMerge?: Maybe<Scalars['Boolean']>;
  /** The date from when we should start auto merging */
  autoMergeFromTs?: Maybe<Scalars['Date']>;
  /** The group id that we should use for auto merging */
  autoMergeGroupId?: Maybe<Scalars['MongoID']>;
  /** Some color strategies requires a coloridentifier, see documentation */
  colorIdentifier?: Maybe<Scalars['String']>;
  /** How to identify colors on master data */
  colorStrategy?: Maybe<EnumBrandSettingMasterDataConsolidateColorStrategy>;
  /** Whether we should try to detect languages on masterdata, or use masterDataLocale */
  enableLanguageDetect?: Maybe<Scalars['Boolean']>;
  /** Whether the automatic master data consolidation is running for this brand */
  enabled: Scalars['Boolean'];
  /** The field that we are consolidating on */
  field: EnumBrandSettingMasterDataConsolidateField;
  /** When was the last time we updated, only product updates after this will be included */
  lastUpdate?: Maybe<Scalars['Date']>;
  /** Some color strategies requires a coloridentifier, see documentation */
  secondaryColorIdentifier?: Maybe<Scalars['String']>;
  /** Secondary identify color strategy */
  secondaryColorStrategy?: Maybe<EnumBrandSettingMasterDataConsolidateSecondaryColorStrategy>;
  /** Some color strategies requires a coloridentifier, see documentation */
  tertiaryColorIdentifier?: Maybe<Scalars['String']>;
  /** Tertiary identify color strategy */
  tertiaryColorStrategy?: Maybe<EnumBrandSettingMasterDataConsolidateTertiaryColorStrategy>;
  /** Regular expression to extract variant id from sku */
  variantIdFromSkuRegExp?: Maybe<Scalars['String']>;
};

export type BrandSettingMasterDataConsolidateInput = {
  /** Whether we should automatically merge masterdata items */
  autoMerge?: InputMaybe<Scalars['Boolean']>;
  /** The date from when we should start auto merging */
  autoMergeFromTs?: InputMaybe<Scalars['Date']>;
  /** The group id that we should use for auto merging */
  autoMergeGroupId?: InputMaybe<Scalars['MongoID']>;
  /** Some color strategies requires a coloridentifier, see documentation */
  colorIdentifier?: InputMaybe<Scalars['String']>;
  /** How to identify colors on master data */
  colorStrategy?: InputMaybe<EnumBrandSettingMasterDataConsolidateColorStrategy>;
  /** Whether we should try to detect languages on masterdata, or use masterDataLocale */
  enableLanguageDetect?: InputMaybe<Scalars['Boolean']>;
  /** Whether the automatic master data consolidation is running for this brand */
  enabled: Scalars['Boolean'];
  /** The field that we are consolidating on */
  field: EnumBrandSettingMasterDataConsolidateField;
  /** When was the last time we updated, only product updates after this will be included */
  lastUpdate?: InputMaybe<Scalars['Date']>;
  /** Some color strategies requires a coloridentifier, see documentation */
  secondaryColorIdentifier?: InputMaybe<Scalars['String']>;
  /** Secondary identify color strategy */
  secondaryColorStrategy?: InputMaybe<EnumBrandSettingMasterDataConsolidateSecondaryColorStrategy>;
  /** Some color strategies requires a coloridentifier, see documentation */
  tertiaryColorIdentifier?: InputMaybe<Scalars['String']>;
  /** Tertiary identify color strategy */
  tertiaryColorStrategy?: InputMaybe<EnumBrandSettingMasterDataConsolidateTertiaryColorStrategy>;
  /** Regular expression to extract variant id from sku */
  variantIdFromSkuRegExp?: InputMaybe<Scalars['String']>;
};

export type BrandSettingOrder = {
  __typename?: 'BrandSettingOrder';
  /** Delivery note template configuration */
  deliveryNote?: Maybe<Scalars['JSON']>;
  /** Whether the brand uses an external warehouse for order handling */
  externalWarehouse?: Maybe<Scalars['Boolean']>;
  /** Whether the brand uses an external WMS for order handling */
  externalWms?: Maybe<Scalars['Boolean']>;
  /** Optionally an GB EORI vat number */
  gbEori?: Maybe<Scalars['String']>;
  refundAdjustment?: Maybe<BrandSettingOrderRefundAdjustment>;
  /** Automatic return is not possible after the given number of days, if no returnMaxDays is provided then return is always possible */
  returnMaxDays?: Maybe<Scalars['Float']>;
  /** The VAT rate for the brand, number between 0 and 1. Used for order lines that report no tax rate, or 0% */
  vatRate?: Maybe<Scalars['Float']>;
};

export type BrandSettingOrderInput = {
  /** Delivery note template configuration */
  deliveryNote?: InputMaybe<Scalars['JSON']>;
  /** Whether the brand uses an external warehouse for order handling */
  externalWarehouse?: InputMaybe<Scalars['Boolean']>;
  /** Whether the brand uses an external WMS for order handling */
  externalWms?: InputMaybe<Scalars['Boolean']>;
  /** Optionally an GB EORI vat number */
  gbEori?: InputMaybe<Scalars['String']>;
  refundAdjustment?: InputMaybe<BrandSettingOrderRefundAdjustmentInput>;
  /** Automatic return is not possible after the given number of days, if no returnMaxDays is provided then return is always possible */
  returnMaxDays?: InputMaybe<Scalars['Float']>;
  /** The VAT rate for the brand, number between 0 and 1. Used for order lines that report no tax rate, or 0% */
  vatRate?: InputMaybe<Scalars['Float']>;
};

export type BrandSettingOrderRefundAdjustment = {
  __typename?: 'BrandSettingOrderRefundAdjustment';
  adjust?: Maybe<Array<Maybe<Pricing>>>;
  /** Whether this adjustment is done once per order, or on every refund */
  oncePerOrder: Scalars['Boolean'];
  /** Reason for adjustment */
  reason: Scalars['String'];
};

export type BrandSettingOrderRefundAdjustmentInput = {
  adjust?: InputMaybe<Array<InputMaybe<PricingInput>>>;
  /** Whether this adjustment is done once per order, or on every refund */
  oncePerOrder: Scalars['Boolean'];
  /** Reason for adjustment */
  reason: Scalars['String'];
};

export type BrandSettingPlannedMailsTradeIn = {
  __typename?: 'BrandSettingPlannedMailsTradeIn';
  /** How many times the remindermail should be sent */
  repeatCount?: Maybe<Scalars['Float']>;
  /** How many days between each remindermail */
  repeatDelay?: Maybe<Scalars['Float']>;
  /** After how many days the remindermail should be sent */
  startAfter?: Maybe<Scalars['Float']>;
};

export type BrandSettingPlannedMailsTradeInInput = {
  /** How many times the remindermail should be sent */
  repeatCount?: InputMaybe<Scalars['Float']>;
  /** How many days between each remindermail */
  repeatDelay?: InputMaybe<Scalars['Float']>;
  /** After how many days the remindermail should be sent */
  startAfter?: InputMaybe<Scalars['Float']>;
};

export type BrandSettingPlannedMailsVoucher = {
  __typename?: 'BrandSettingPlannedMailsVoucher';
  /** How many times the remindermail should be sent */
  repeatCount?: Maybe<Scalars['Float']>;
  /** How many days between each remindermail */
  repeatDelay?: Maybe<Scalars['Float']>;
  /** After how many days the remindermail should be sent */
  startAfter?: Maybe<Scalars['Float']>;
};

export type BrandSettingPlannedMailsVoucherInput = {
  /** How many times the remindermail should be sent */
  repeatCount?: InputMaybe<Scalars['Float']>;
  /** How many days between each remindermail */
  repeatDelay?: InputMaybe<Scalars['Float']>;
  /** After how many days the remindermail should be sent */
  startAfter?: InputMaybe<Scalars['Float']>;
};

export type BrandSettingSellPrice = {
  __typename?: 'BrandSettingSellPrice';
  _id?: Maybe<Scalars['MongoID']>;
  condition?: Maybe<Scalars['Float']>;
  pct?: Maybe<Scalars['Float']>;
};

export type BrandSettingSellPriceAdvanced = {
  __typename?: 'BrandSettingSellPriceAdvanced';
  sellPrice?: Maybe<Array<Maybe<BrandSettingSellPriceAdvancedSellPrice>>>;
  type?: Maybe<EnumBrandSettingSellPriceAdvancedType>;
  /** If provided, this tag produces a special set of selling prices */
  value: Scalars['String'];
};

export type BrandSettingSellPriceAdvancedInput = {
  sellPrice?: InputMaybe<Array<InputMaybe<BrandSettingSellPriceAdvancedSellPriceInput>>>;
  type?: InputMaybe<EnumBrandSettingSellPriceAdvancedType>;
  /** If provided, this tag produces a special set of selling prices */
  value: Scalars['String'];
};

export type BrandSettingSellPriceAdvancedSellPrice = {
  __typename?: 'BrandSettingSellPriceAdvancedSellPrice';
  _id?: Maybe<Scalars['MongoID']>;
  condition?: Maybe<Scalars['Float']>;
  pct?: Maybe<Scalars['Float']>;
};

export type BrandSettingSellPriceAdvancedSellPriceInput = {
  _id?: InputMaybe<Scalars['MongoID']>;
  condition?: InputMaybe<Scalars['Float']>;
  pct?: InputMaybe<Scalars['Float']>;
};

export type BrandSettingSellPriceInput = {
  _id?: InputMaybe<Scalars['MongoID']>;
  condition?: InputMaybe<Scalars['Float']>;
  pct?: InputMaybe<Scalars['Float']>;
};

export type BrandSettingStockItemConfig = {
  __typename?: 'BrandSettingStockItemConfig';
  _id?: Maybe<Scalars['MongoID']>;
  /** If true, the stockitems color will be appended to the stockitem title. */
  appendColor?: Maybe<Scalars['Boolean']>;
  /** Optionally a seperator before the appends (color or size) */
  appendSeperator?: Maybe<Scalars['String']>;
  /** If true, the stockitems size will be appended to the stockitem title. */
  appendSize?: Maybe<Scalars['Boolean']>;
  autoData?: Maybe<Array<Maybe<BrandSettingStockItemConfigAutoData>>>;
  /** Optional strategy for resolving missing stockitem colors from product titles */
  colorStrategy?: Maybe<EnumBrandSettingStockItemConfigColorStrategy>;
  /** Optional the currencies for stockitem pricing */
  currencies?: Maybe<Array<Maybe<Currency>>>;
  /** Optional text that will be appended to the stockitems description, can contain wildcards. See documentation. */
  descriptionSuffix?: Maybe<Scalars['String']>;
  /** Localized description suffix */
  descriptionSuffixLocalized?: Maybe<Array<Maybe<LocalizationEntry>>>;
  /** Extra meta about the item */
  extraMeta?: Maybe<Array<Maybe<MetaFieldInstance>>>;
  /** Extra tags for the item */
  extraTags?: Maybe<Array<Maybe<BrandSettingStockItemConfigExtraTags>>>;
  /** Optional text that will be appended to the stockitem images alt text, can contain wildcards. See documentation. */
  imageAltText?: Maybe<Scalars['String']>;
  /** Localized image alt texts for images, can contain wildcards. */
  imageAltTextLocalized?: Maybe<Array<Maybe<LocalizationEntry>>>;
  /** Optionally rotate the images by this number of degrees */
  imageRotate?: Maybe<Scalars['Float']>;
  /** Controls the order of the images, when querying on stockitems */
  imageSorting?: Maybe<EnumBrandSettingStockItemConfigImageSorting>;
  /** If true, then the stockitem must have a color */
  itemRuleColor?: Maybe<Scalars['Boolean']>;
  /** If set, then the stockitem must have at least this number of images */
  itemRuleImages?: Maybe<Scalars['Float']>;
  /** If true, then the stockitem must have a group of other standard fields */
  itemRuleOther?: Maybe<Scalars['Boolean']>;
  /** If true, then the stockitem must have a price for each currency */
  itemRulePrice?: Maybe<Scalars['Boolean']>;
  /** If true, then the stockitem must have a size */
  itemRuleSize?: Maybe<Scalars['Boolean']>;
  /** Item requirements for stockitems */
  itemRules?: Maybe<Array<Maybe<BrandSettingStockItemConfigItemRules>>>;
  /** How many (if available) masterdata product images should be included for new stockitems */
  masterImageCount?: Maybe<Scalars['Float']>;
  /** Which types of masterdata product images should be included for new stockitems */
  masterImageTypes?: Maybe<Array<Maybe<EnumBrandSettingStockItemConfigMasterImageTypes>>>;
  /** Optional text that will be appended to original images alt text, can contain wildcards. See documentation. */
  originalImageAltText?: Maybe<Scalars['String']>;
  /** Localized image alt texts for images, can contain wildcards. */
  originalImageAltTextLocalized?: Maybe<Array<Maybe<LocalizationEntry>>>;
  overrides?: Maybe<BrandSettingStockItemConfigOverrides>;
  /** If true, only one item per group of interchangeable items (same style, colour and size) is for sale at a time; the rest are queued until it sells */
  queueDuplicates?: Maybe<Scalars['Boolean']>;
  /** String replacements for texts on brandItems */
  replacements?: Maybe<Array<Maybe<BrandSettingStockItemConfigReplacements>>>;
  /** Whether the brands requires to review the item before its published */
  requireReview?: Maybe<Scalars['Boolean']>;
  /** How the SKU should be generated for new stockitems */
  skuStrategy?: Maybe<EnumBrandSettingStockItemConfigSkuStrategy>;
  /** Optional a name of the template used when showing stock items in external shop. In shopify this is the templateSuffix. */
  template?: Maybe<Scalars['String']>;
  /** Optionally an advanced format for the title, this will override any data in titlePrefix and seperators. Wildcards such as {{title}} is allowed here */
  titleAdvanced?: Maybe<Scalars['String']>;
  /** Text that will be prefixed to the stockitems title, can contain wildcards. See documentation. */
  titlePrefix?: Maybe<Scalars['String']>;
  /** Optionally a seperator after the titleprefix and before the actual stockitem title */
  titleSeperator?: Maybe<Scalars['String']>;
  /** Optional a vendor for those stock items that does not define a vendor themselves */
  vendor?: Maybe<Scalars['String']>;
};

export type BrandSettingStockItemConfigAutoData = {
  __typename?: 'BrandSettingStockItemConfigAutoData';
  operator: EnumBrandSettingStockItemConfigAutoDataOperator;
  search: EnumBrandSettingStockItemConfigAutoDataSearch;
  tag: Scalars['String'];
  target: EnumBrandSettingStockItemConfigAutoDataTarget;
};

export type BrandSettingStockItemConfigAutoDataInput = {
  operator: EnumBrandSettingStockItemConfigAutoDataOperator;
  search: EnumBrandSettingStockItemConfigAutoDataSearch;
  tag: Scalars['String'];
  target: EnumBrandSettingStockItemConfigAutoDataTarget;
};

export type BrandSettingStockItemConfigExtraTags = {
  __typename?: 'BrandSettingStockItemConfigExtraTags';
  /** Whether the tag is active */
  active?: Maybe<Scalars['Boolean']>;
  /** The tag to add */
  tag: Scalars['String'];
};

export type BrandSettingStockItemConfigExtraTagsInput = {
  /** Whether the tag is active */
  active?: InputMaybe<Scalars['Boolean']>;
  /** The tag to add */
  tag: Scalars['String'];
};

export type BrandSettingStockItemConfigInput = {
  _id?: InputMaybe<Scalars['MongoID']>;
  /** If true, the stockitems color will be appended to the stockitem title. */
  appendColor?: InputMaybe<Scalars['Boolean']>;
  /** Optionally a seperator before the appends (color or size) */
  appendSeperator?: InputMaybe<Scalars['String']>;
  /** If true, the stockitems size will be appended to the stockitem title. */
  appendSize?: InputMaybe<Scalars['Boolean']>;
  autoData?: InputMaybe<Array<InputMaybe<BrandSettingStockItemConfigAutoDataInput>>>;
  /** Optional strategy for resolving missing stockitem colors from product titles */
  colorStrategy?: InputMaybe<EnumBrandSettingStockItemConfigColorStrategy>;
  /** Optional the currencies for stockitem pricing */
  currencies?: InputMaybe<Array<InputMaybe<CurrencyInput>>>;
  /** Optional text that will be appended to the stockitems description, can contain wildcards. See documentation. */
  descriptionSuffix?: InputMaybe<Scalars['String']>;
  /** Localized description suffix */
  descriptionSuffixLocalized?: InputMaybe<Array<InputMaybe<LocalizationEntryInput>>>;
  /** Extra meta about the item */
  extraMeta?: InputMaybe<Array<InputMaybe<MetaFieldInstanceInput>>>;
  /** Extra tags for the item */
  extraTags?: InputMaybe<Array<InputMaybe<BrandSettingStockItemConfigExtraTagsInput>>>;
  /** Optional text that will be appended to the stockitem images alt text, can contain wildcards. See documentation. */
  imageAltText?: InputMaybe<Scalars['String']>;
  /** Localized image alt texts for images, can contain wildcards. */
  imageAltTextLocalized?: InputMaybe<Array<InputMaybe<LocalizationEntryInput>>>;
  /** Optionally rotate the images by this number of degrees */
  imageRotate?: InputMaybe<Scalars['Float']>;
  /** Controls the order of the images, when querying on stockitems */
  imageSorting?: InputMaybe<EnumBrandSettingStockItemConfigImageSorting>;
  /** If true, then the stockitem must have a color */
  itemRuleColor?: InputMaybe<Scalars['Boolean']>;
  /** If set, then the stockitem must have at least this number of images */
  itemRuleImages?: InputMaybe<Scalars['Float']>;
  /** If true, then the stockitem must have a group of other standard fields */
  itemRuleOther?: InputMaybe<Scalars['Boolean']>;
  /** If true, then the stockitem must have a price for each currency */
  itemRulePrice?: InputMaybe<Scalars['Boolean']>;
  /** If true, then the stockitem must have a size */
  itemRuleSize?: InputMaybe<Scalars['Boolean']>;
  /** Item requirements for stockitems */
  itemRules?: InputMaybe<Array<InputMaybe<BrandSettingStockItemConfigItemRulesInput>>>;
  /** How many (if available) masterdata product images should be included for new stockitems */
  masterImageCount?: InputMaybe<Scalars['Float']>;
  /** Which types of masterdata product images should be included for new stockitems */
  masterImageTypes?: InputMaybe<Array<InputMaybe<EnumBrandSettingStockItemConfigMasterImageTypes>>>;
  /** Optional text that will be appended to original images alt text, can contain wildcards. See documentation. */
  originalImageAltText?: InputMaybe<Scalars['String']>;
  /** Localized image alt texts for images, can contain wildcards. */
  originalImageAltTextLocalized?: InputMaybe<Array<InputMaybe<LocalizationEntryInput>>>;
  overrides?: InputMaybe<BrandSettingStockItemConfigOverridesInput>;
  /** If true, only one item per group of interchangeable items (same style, colour and size) is for sale at a time; the rest are queued until it sells */
  queueDuplicates?: InputMaybe<Scalars['Boolean']>;
  /** String replacements for texts on brandItems */
  replacements?: InputMaybe<Array<InputMaybe<BrandSettingStockItemConfigReplacementsInput>>>;
  /** Whether the brands requires to review the item before its published */
  requireReview?: InputMaybe<Scalars['Boolean']>;
  /** How the SKU should be generated for new stockitems */
  skuStrategy?: InputMaybe<EnumBrandSettingStockItemConfigSkuStrategy>;
  /** Optional a name of the template used when showing stock items in external shop. In shopify this is the templateSuffix. */
  template?: InputMaybe<Scalars['String']>;
  /** Optionally an advanced format for the title, this will override any data in titlePrefix and seperators. Wildcards such as {{title}} is allowed here */
  titleAdvanced?: InputMaybe<Scalars['String']>;
  /** Text that will be prefixed to the stockitems title, can contain wildcards. See documentation. */
  titlePrefix?: InputMaybe<Scalars['String']>;
  /** Optionally a seperator after the titleprefix and before the actual stockitem title */
  titleSeperator?: InputMaybe<Scalars['String']>;
  /** Optional a vendor for those stock items that does not define a vendor themselves */
  vendor?: InputMaybe<Scalars['String']>;
};

export type BrandSettingStockItemConfigItemRules = {
  __typename?: 'BrandSettingStockItemConfigItemRules';
  /** The expression to evaluate */
  expression: Scalars['String'];
  /** The message to show if the rule is not met */
  message: Scalars['String'];
};

export type BrandSettingStockItemConfigItemRulesInput = {
  /** The expression to evaluate */
  expression: Scalars['String'];
  /** The message to show if the rule is not met */
  message: Scalars['String'];
};

export type BrandSettingStockItemConfigOverrides = {
  __typename?: 'BrandSettingStockItemConfigOverrides';
  /** Optional product type that overrides the product type on all stock items */
  productType?: Maybe<Scalars['String']>;
  /** Optionally a vendor that will be set for all items, any vendor set on the masterdata/item will be overridden */
  vendor?: Maybe<Scalars['String']>;
};

export type BrandSettingStockItemConfigOverridesInput = {
  /** Optional product type that overrides the product type on all stock items */
  productType?: InputMaybe<Scalars['String']>;
  /** Optionally a vendor that will be set for all items, any vendor set on the masterdata/item will be overridden */
  vendor?: InputMaybe<Scalars['String']>;
};

export type BrandSettingStockItemConfigReplacements = {
  __typename?: 'BrandSettingStockItemConfigReplacements';
  /** The iso alpha 2 locale code */
  locales?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Replace with this string */
  replace: Scalars['String'];
  /** Search for this string */
  search: Scalars['String'];
};

export type BrandSettingStockItemConfigReplacementsInput = {
  /** The iso alpha 2 locale code */
  locales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Replace with this string */
  replace: Scalars['String'];
  /** Search for this string */
  search: Scalars['String'];
};

export type BrandSettingThumbnails = {
  __typename?: 'BrandSettingThumbnails';
  /** Alignment bits for the generation, see https://github.com/oliver-moran/jimp/blob/master/packages/core/src/constants.js */
  align?: Maybe<Scalars['Float']>;
  /** A test replacement of the background color, will only work when the background is one color - use with care */
  background?: Maybe<Scalars['String']>;
  /** The height of the generated thumbnail, default is 200 */
  height?: Maybe<Scalars['Float']>;
  /** Contain will make sure the image is contained wihtin the size, cover will make sure the image is covered. Use alignment to control placement of image */
  strategy?: Maybe<EnumBrandSettingThumbnailsStrategy>;
  /** The width of the generated thumbnail, default is 200 */
  width?: Maybe<Scalars['Float']>;
};

export type BrandSettingThumbnailsInput = {
  /** Alignment bits for the generation, see https://github.com/oliver-moran/jimp/blob/master/packages/core/src/constants.js */
  align?: InputMaybe<Scalars['Float']>;
  /** A test replacement of the background color, will only work when the background is one color - use with care */
  background?: InputMaybe<Scalars['String']>;
  /** The height of the generated thumbnail, default is 200 */
  height?: InputMaybe<Scalars['Float']>;
  /** Contain will make sure the image is contained wihtin the size, cover will make sure the image is covered. Use alignment to control placement of image */
  strategy?: InputMaybe<EnumBrandSettingThumbnailsStrategy>;
  /** The width of the generated thumbnail, default is 200 */
  width?: InputMaybe<Scalars['Float']>;
};

export type BrandSettingTradeIn2Analytics = {
  __typename?: 'BrandSettingTradeIn2Analytics';
  /** Google Analytics 4 Property ID */
  ga4Property?: Maybe<Scalars['String']>;
  /** Universal Analytics Property ID (Deprecated) */
  uaProperty?: Maybe<Scalars['String']>;
};

export type BrandSettingTradeIn2AnalyticsInput = {
  /** Google Analytics 4 Property ID */
  ga4Property?: InputMaybe<Scalars['String']>;
  /** Universal Analytics Property ID (Deprecated) */
  uaProperty?: InputMaybe<Scalars['String']>;
};

export type BrandSettingVoucher = {
  __typename?: 'BrandSettingVoucher';
  expireDays?: Maybe<Scalars['Float']>;
  /** The maximum possible value of a single reward on a tradein. When this is exceeded the tradein cant be completed */
  maximumValue?: Maybe<Scalars['Float']>;
  minimumPurchase?: Maybe<Scalars['Float']>;
  minimumPurchaseExt?: Maybe<Array<Maybe<BrandSettingVoucherMinimumPurchaseExt>>>;
  newVoucherUsage?: Maybe<Scalars['Boolean']>;
  prefix?: Maybe<Scalars['String']>;
  refundApproval?: Maybe<Scalars['Boolean']>;
};

export type BrandSettingVoucherInput = {
  expireDays?: InputMaybe<Scalars['Float']>;
  /** The maximum possible value of a single reward on a tradein. When this is exceeded the tradein cant be completed */
  maximumValue?: InputMaybe<Scalars['Float']>;
  minimumPurchase?: InputMaybe<Scalars['Float']>;
  minimumPurchaseExt?: InputMaybe<Array<InputMaybe<BrandSettingVoucherMinimumPurchaseExtInput>>>;
  newVoucherUsage?: InputMaybe<Scalars['Boolean']>;
  prefix?: InputMaybe<Scalars['String']>;
  refundApproval?: InputMaybe<Scalars['Boolean']>;
};

export type BrandSettingVoucherMinimumPurchaseExt = {
  __typename?: 'BrandSettingVoucherMinimumPurchaseExt';
  _id?: Maybe<Scalars['MongoID']>;
  minimumPurchase?: Maybe<Scalars['Float']>;
  valueMax?: Maybe<Scalars['Float']>;
};

export type BrandSettingVoucherMinimumPurchaseExtInput = {
  _id?: InputMaybe<Scalars['MongoID']>;
  minimumPurchase?: InputMaybe<Scalars['Float']>;
  valueMax?: InputMaybe<Scalars['Float']>;
};

export enum BrandSynchronizeMode {
  MERGE = 'MERGE',
  REPLACE = 'REPLACE',
  UPDATEIMAGES = 'UPDATEIMAGES'
}

export type BrickMail = {
  __typename?: 'BrickMail';
  _id: Scalars['MongoID'];
  active?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['Date']>;
  mails?: Maybe<Array<Maybe<BrickMailMails>>>;
  shopId: Scalars['MongoID'];
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['Date']>;
  updatedBy?: Maybe<ObjectPatchesUpdatedBy>;
};

export type BrickMailMails = {
  __typename?: 'BrickMailMails';
  htmlMail?: Maybe<BrickMailMailsHtmlMail>;
  language?: Maybe<Scalars['String']>;
  mail?: Maybe<Scalars['JSON']>;
  mailType?: Maybe<EnumBrickMailMailsMailType>;
};

export type BrickMailMailsHtmlMail = {
  __typename?: 'BrickMailMailsHtmlMail';
  from?: Maybe<BrickMailMailsHtmlMailFrom>;
  /** The html mail template */
  html?: Maybe<Scalars['String']>;
  /** Subject for the htmlmail */
  subject?: Maybe<Scalars['String']>;
};

export type BrickMailMailsHtmlMailFrom = {
  __typename?: 'BrickMailMailsHtmlMailFrom';
  /** Mail for the person */
  mail?: Maybe<Scalars['String']>;
  /** Name of the person */
  name?: Maybe<Scalars['String']>;
};

export type BrickMailMailsHtmlMailFromInput = {
  /** Mail for the person */
  mail?: InputMaybe<Scalars['String']>;
  /** Name of the person */
  name?: InputMaybe<Scalars['String']>;
};

export type BrickMailMailsHtmlMailInput = {
  from?: InputMaybe<BrickMailMailsHtmlMailFromInput>;
  /** The html mail template */
  html?: InputMaybe<Scalars['String']>;
  /** Subject for the htmlmail */
  subject?: InputMaybe<Scalars['String']>;
};

export type BrickMailMailsInput = {
  htmlMail?: InputMaybe<BrickMailMailsHtmlMailInput>;
  language?: InputMaybe<Scalars['String']>;
  mail?: InputMaybe<Scalars['JSON']>;
  mailType?: InputMaybe<EnumBrickMailMailsMailType>;
};

export type BrickMailType = {
  __typename?: 'BrickMailType';
  active: Scalars['Boolean'];
  description: Scalars['String'];
  title: Scalars['String'];
  type: Scalars['String'];
};

export enum BrickMailTypeEnum {
  /** The order was fulfilled, the consumer will receive this mail with information about the order and tracking */
  FULFILLMENT = 'FULFILLMENT',
  /** The consumer made an order that contains a secondhand styles. This mail will be sent to the consumer. */
  ORDERINFO = 'ORDERINFO',
  /** The consumer tradein has been received by the logistics partner, this thank-you mail will be sent as a follow-up */
  RECEIVED = 'RECEIVED',
  /** If the consumer registers a tradein, but the package arent received at the logistics partner, then a reminder mail will be sent */
  REMINDER = 'REMINDER',
  /** Mail sent to the consumer when they haven't used the voucher they received */
  REMINDERVOUCHER = 'REMINDERVOUCHER',
  /** The customer requested a return for the order, this mail will be sent to the consumer */
  STARTRETURN = 'STARTRETURN',
  /** The consumer requested access to the tradein platform, but the user does not exist */
  UNKNOWN = 'UNKNOWN',
  /** Mail will be sent when there is new automatically generated trade-in offer for this consumer */
  UPDATE = 'UPDATE',
  /** Consumer made a tradein, and will receive this mail containing information about the voucher */
  VOUCHER = 'VOUCHER',
  /** Reward was changed, either used in an order or was reimbursed. This mail notified the consumer about it. */
  VOUCHERUPDATED = 'VOUCHERUPDATED',
  /** The consumer requested access to the tradein platform, this mail contains access information */
  WELCOME = 'WELCOME'
}

export type BrickMailValidation = {
  __typename?: 'BrickMailValidation';
  locale: Scalars['String'];
  message?: Maybe<Scalars['JSON']>;
  result?: Maybe<BrickMailValidationResultEnum>;
};

export enum BrickMailValidationResultEnum {
  ERROR = 'ERROR',
  SUCCESS = 'SUCCESS',
  WARNING = 'WARNING'
}

export type Campaign = {
  __typename?: 'Campaign';
  _id: Scalars['MongoID'];
  /** The status of the campaign */
  active: Scalars['Boolean'];
  /** The brand house id of the campaign */
  brandHouseId: Scalars['MongoID'];
  /** The name of the campaign */
  campaignName: Scalars['String'];
  /** Whether the campaign is completed */
  completed?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['Date']>;
  /** The status of the campaign */
  disabled?: Maybe<Scalars['Boolean']>;
  /** The timestamp when the campaign ended */
  endedTs?: Maybe<Scalars['Date']>;
  /** The start date of the campaign */
  fromDate: Scalars['Date'];
  /** The percentage discount of the campaign */
  percentage: Scalars['Float'];
  /** The shop id of the campaign */
  shopId?: Maybe<Scalars['MongoID']>;
  /** The timestamp when the campaign started */
  startedTs?: Maybe<Scalars['Date']>;
  /** The end date of the campaign */
  toDate: Scalars['Date'];
  updatedAt?: Maybe<Scalars['Date']>;
};

export enum CancelReason {
  ItemCancelled = 'ItemCancelled',
  ItemExcluded = 'ItemExcluded',
  ItemRefunded = 'ItemRefunded'
}

export type CircularAccount = {
  __typename?: 'CircularAccount';
  /** The ID of the account owner */
  consumerId: Scalars['MongoID'];
  /** Total number of circular points that will be added to the total when approved (trade in received) */
  pending: Scalars['Float'];
  /** A list of all circular point transactions for this account */
  points?: Maybe<Array<Maybe<CircularPoint>>>;
  /** The brand */
  shopId: Scalars['MongoID'];
  /** Total number of circular points the owner of this account can spend */
  total: Scalars['Float'];
};

export type CircularPayoutInstance = {
  __typename?: 'CircularPayoutInstance';
  _id?: Maybe<Scalars['MongoID']>;
  accountNr?: Maybe<Scalars['String']>;
  currency: Scalars['String'];
  /** The type of circular payout */
  payoutId: Scalars['MongoID'];
  phoneNr?: Maybe<Scalars['String']>;
  regNr?: Maybe<Scalars['String']>;
  /** Optionally a tradein that was directly converted for this payout */
  tradeInId?: Maybe<Scalars['MongoID']>;
};

export type CircularPayoutInstanceInput = {
  _id?: InputMaybe<Scalars['MongoID']>;
  accountNr?: InputMaybe<Scalars['String']>;
  currency: Scalars['String'];
  /** The type of circular payout */
  payoutId: Scalars['MongoID'];
  phoneNr?: InputMaybe<Scalars['String']>;
  regNr?: InputMaybe<Scalars['String']>;
  /** Optionally a tradein that was directly converted for this payout */
  tradeInId?: InputMaybe<Scalars['MongoID']>;
};

export type CircularPayoutRatio = {
  __typename?: 'CircularPayoutRatio';
  _id?: Maybe<Scalars['MongoID']>;
  /** Whether the circular conversion is active for the brand */
  active: Scalars['Boolean'];
  /** The name of the payout */
  name: Scalars['String'];
  /** The type of circular payout */
  payoutId: Scalars['MongoID'];
  /** The ratio, a number >0 and <1 - 1 means full conversion, 0 means any points goes to 0 */
  ratio: Scalars['Float'];
  /** The name of the payout */
  type: Scalars['String'];
};

export type CircularPayoutRatioInput = {
  _id?: InputMaybe<Scalars['MongoID']>;
  /** Whether the circular conversion is active for the brand */
  active: Scalars['Boolean'];
  /** The type of circular payout */
  payoutId: Scalars['MongoID'];
  /** The ratio, a number >0 and <1 - 1 means full conversion, 0 means any points goes to 0 */
  ratio: Scalars['Float'];
};

export type CircularPayoutType = {
  __typename?: 'CircularPayoutType';
  _id: Scalars['MongoID'];
  createdAt?: Maybe<Scalars['Date']>;
  /** The default payout ratio, a number between 0 and 1 */
  defaultRatio: Scalars['Float'];
  /** The name of the payout */
  name: Scalars['String'];
  /** The type of payout */
  payoutType: EnumCircularPayoutTypePayoutType;
  updatedAt?: Maybe<Scalars['Date']>;
};

export type CircularPoint = {
  __typename?: 'CircularPoint';
  _id: Scalars['MongoID'];
  /** Whether the circularpoint point transaction has been activated for a tradein, or executed with the external service provider for a payout */
  activated: Scalars['Boolean'];
  /** The consumer id / account id, owning the points */
  consumerId: Scalars['MongoID'];
  createdAt?: Maybe<Scalars['Date']>;
  /** Whether this has been processed by the circular points engine */
  eventProcessed: Scalars['Boolean'];
  /** The shop */
  shopId: Scalars['MongoID'];
  /** Optionally data from the source that is relevant to the circular point */
  sourceData?: Maybe<CircularPointSourceData>;
  /** The source of the circularpoint transaction, tradein id, conversion id, etc */
  sourceObjectId: Scalars['MongoID'];
  /** The type of the transaction source, tradein or conversion */
  sourceType: EnumCircularPointSourceType;
  updatedAt?: Maybe<Scalars['Date']>;
  /** The change in points for this transaction. Can be a negative or positive value. */
  value: Scalars['Float'];
};

export type CircularPointSourceData = {
  __typename?: 'CircularPointSourceData';
  _id?: Maybe<Scalars['MongoID']>;
  actualPayout?: Maybe<CircularPayoutInstance>;
  postPayout?: Maybe<CircularPayoutInstance>;
};

export type CircularPointSourceDataInput = {
  _id?: InputMaybe<Scalars['MongoID']>;
  actualPayout?: InputMaybe<CircularPayoutInstanceInput>;
  postPayout?: InputMaybe<CircularPayoutInstanceInput>;
};

export type CircularSettings = {
  __typename?: 'CircularSettings';
  _id?: Maybe<Scalars['MongoID']>;
  /** If this is non-null, then the customer will receive circular points instead of a shop voucher from the given date. The points can be converted to vouchers or real money something else entirely */
  activationDate?: Maybe<Scalars['Date']>;
  payoutTypes?: Maybe<Array<Maybe<CircularPayoutRatio>>>;
};

export type CircularSettingsInput = {
  _id?: InputMaybe<Scalars['MongoID']>;
  /** If this is non-null, then the customer will receive circular points instead of a shop voucher from the given date. The points can be converted to vouchers or real money something else entirely */
  activationDate?: InputMaybe<Scalars['Date']>;
  payoutTypes?: InputMaybe<Array<InputMaybe<CircularPayoutRatioInput>>>;
};

export type ConfigCompareModelSummary = {
  __typename?: 'ConfigCompareModelSummary';
  count: Scalars['Int'];
  modelName: Scalars['String'];
};

export type ConfigCompareResult = {
  __typename?: 'ConfigCompareResult';
  comparedAt: Scalars['Date'];
  differences?: Maybe<Array<Maybe<PathDifference>>>;
  nameA: Scalars['String'];
  nameB: Scalars['String'];
  refA?: Maybe<ConfigRef>;
  refB?: Maybe<ConfigRef>;
  summary?: Maybe<ConfigCompareSummary>;
};

export type ConfigCompareSummary = {
  __typename?: 'ConfigCompareSummary';
  byModel?: Maybe<Array<Maybe<ConfigCompareModelSummary>>>;
  totalDifferences: Scalars['Int'];
};

export type ConfigRef = {
  __typename?: 'ConfigRef';
  brandHouseId?: Maybe<Scalars['String']>;
  shopId?: Maybe<Scalars['String']>;
};

export type Consumer = {
  __typename?: 'Consumer';
  _id: Scalars['MongoID'];
  /** Whether this consumer accepts marketing mails */
  acceptsMarketing?: Maybe<Scalars['Boolean']>;
  accessToken?: Maybe<Scalars['String']>;
  accountType?: Maybe<Scalars['String']>;
  add1?: Maybe<Scalars['String']>;
  add2?: Maybe<Scalars['String']>;
  brandHouseId: Scalars['MongoID'];
  city?: Maybe<Scalars['String']>;
  company?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  countryCode?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['Date']>;
  /** The currency of this consumer, typically based on the currency used in the consumers country */
  currency: Scalars['String'];
  /** Custom data for the consumer */
  customData?: Maybe<Scalars['JSON']>;
  /** Optionally a custom id for the consumer */
  customId?: Maybe<Scalars['String']>;
  disableContact?: Maybe<Scalars['Boolean']>;
  /** External orders for this consumer */
  externOrders?: Maybe<Array<Maybe<ExternOrder2>>>;
  /** URL to the external consumer */
  externUrl?: Maybe<Scalars['String']>;
  externalId?: Maybe<Scalars['String']>;
  /** Consumers first name */
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  journey?: Maybe<Array<Maybe<ConsumerJourney>>>;
  /** The consumers language, will default to the brands primary langauge if none is selected */
  language?: Maybe<Scalars['String']>;
  lastLogin?: Maybe<Scalars['Date']>;
  /** Consumers last name */
  lastName?: Maybe<Scalars['String']>;
  latestOfferMail?: Maybe<Scalars['Date']>;
  locale?: Maybe<Scalars['String']>;
  mail?: Maybe<Scalars['String']>;
  /** Consumers name */
  name?: Maybe<Scalars['String']>;
  personId?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  /** The phonenumber in E.164 format. */
  phoneE164?: Maybe<Scalars['String']>;
  /** The national part of the phone number, removes any +XX extension */
  phoneNational?: Maybe<Scalars['String']>;
  /** Whether this is a proxy account for another consumer */
  proxyAccount?: Maybe<Scalars['Boolean']>;
  /** Whether this consumer was created by a consumer himself or by a trusted source */
  selfCreated?: Maybe<Scalars['Boolean']>;
  shop?: Maybe<Shop>;
  shopId?: Maybe<Scalars['MongoID']>;
  /** Statistics for this consumer */
  statistics?: Maybe<ConsumerStatistics>;
  /** The tradein app url for this consumer */
  tradeInAppUrl: Scalars['String'];
  updatedAt?: Maybe<Scalars['Date']>;
  zipCode?: Maybe<Scalars['String']>;
};


export type ConsumerStatisticsArgs = {
  date?: InputMaybe<Scalars['Date']>;
};

export type ConsumerAccessRequestResult = {
  __typename?: 'ConsumerAccessRequestResult';
  messageId?: Maybe<Scalars['String']>;
  status: Scalars['String'];
};

export type ConsumerAccount = {
  __typename?: 'ConsumerAccount';
  /** The brand house this account belongs to */
  brandHouseId: Scalars['MongoID'];
  /** All consumers matching this identifier within the brandHouse */
  consumers?: Maybe<Array<Maybe<Consumer>>>;
  /** Currency from the most recently active consumer */
  currency?: Maybe<Scalars['String']>;
  /** The identifier value (email, phone, or externalId) */
  id: Scalars['String'];
  /** The type of identifier (EMAIL, PHONE, EXTERNALID) */
  idType: ConsumerIdentifierEnum;
  /** Language preference from the most recently active consumer */
  language?: Maybe<Scalars['String']>;
  /** Most recent login timestamp across all consumers */
  lastLogin?: Maybe<Scalars['Date']>;
  /** Name from the most recently active consumer */
  name?: Maybe<Scalars['String']>;
  /** All trade-ins across all matching consumers */
  tradeIns?: Maybe<Array<Maybe<TradeIn>>>;
  /** Total voucher balance across all active consumers, converted to the main currency */
  voucherBalance?: Maybe<Scalars['Float']>;
  /** List of vouchers with positive balance */
  voucherList?: Maybe<Array<Scalars['String']>>;
  /** All active vouchers across all matching consumers */
  vouchers?: Maybe<Array<Maybe<Voucher>>>;
};

export enum ConsumerAuthMethodEnum {
  MAIL_CODE = 'MAIL_CODE',
  MAIL_LINK = 'MAIL_LINK',
  SMS_CODE = 'SMS_CODE'
}

export type ConsumerAuthorizeResult = {
  __typename?: 'ConsumerAuthorizeResult';
  allowedCountry: Scalars['Boolean'];
  brandName: Scalars['String'];
  circularPoints: Scalars['Boolean'];
  consumerId: Scalars['String'];
  currency: Scalars['String'];
  locale: Scalars['String'];
  lockEmail: Scalars['Boolean'];
  productSearchEnabled: Scalars['Boolean'];
  requestPotentialsSupported: Scalars['Boolean'];
  shopCurrency: Scalars['String'];
  shopId: Scalars['String'];
  token: Scalars['String'];
  tradeInComments: Scalars['Boolean'];
  tradeInPayoutEnabled: Scalars['Boolean'];
  tradeInPayoutPct: Scalars['Int'];
  wholeSaleActive: Scalars['Boolean'];
};

export type ConsumerCompleteAccessResult = {
  __typename?: 'ConsumerCompleteAccessResult';
  status: Scalars['String'];
};

/** List of items with pagination. */
export type ConsumerConsumerPagination = {
  __typename?: 'ConsumerConsumerPagination';
  /** Total object count. */
  count?: Maybe<Scalars['Int']>;
  /** Array of objects. */
  items?: Maybe<Array<Consumer>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

/** Input for consumer creastion */
export type ConsumerCreate2Input = {
  /** Country of consumer */
  countryCode?: InputMaybe<Scalars['String']>;
  /** Optionally some custom data for the consumer */
  customData?: InputMaybe<Scalars['String']>;
  /** Optionally a custom id for the consumer */
  customId?: InputMaybe<Scalars['String']>;
  /** Consumer email */
  email?: InputMaybe<Scalars['String']>;
  /** External system id for this consumer */
  externalId: Scalars['String'];
  /** Language of consumer */
  language?: InputMaybe<Scalars['String']>;
  /** Consumer name */
  name?: InputMaybe<Scalars['String']>;
  /** Consumer phone */
  phone?: InputMaybe<Scalars['String']>;
  /** Zipcode for consumer */
  zipCode?: InputMaybe<Scalars['String']>;
};

export type ConsumerEvent = {
  __typename?: 'ConsumerEvent';
  _id: Scalars['MongoID'];
  consumer?: Maybe<Consumer>;
  consumerId: Scalars['MongoID'];
  data?: Maybe<Scalars['JSON']>;
  dateTime: Scalars['Date'];
  event: Scalars['String'];
  exportedToKlaviyo?: Maybe<Scalars['Boolean']>;
  exportedToStatistics?: Maybe<Scalars['Boolean']>;
  maildata?: Maybe<ConsumerEventMaildata>;
  shopId: Scalars['MongoID'];
  subEvent?: Maybe<Scalars['String']>;
};

/** List of items with pagination. */
export type ConsumerEventConsumerEventPagination = {
  __typename?: 'ConsumerEventConsumerEventPagination';
  /** Total object count. */
  count?: Maybe<Scalars['Int']>;
  /** Array of objects. */
  items?: Maybe<Array<ConsumerEvent>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type ConsumerEventMaildata = {
  __typename?: 'ConsumerEventMaildata';
  bounced?: Maybe<Scalars['Boolean']>;
  clicked?: Maybe<Scalars['Boolean']>;
  delivered?: Maybe<Scalars['Boolean']>;
  lastUpdate?: Maybe<Scalars['Date']>;
  messageId?: Maybe<Scalars['String']>;
  opened?: Maybe<Scalars['Boolean']>;
  spam?: Maybe<Scalars['Boolean']>;
};

export enum ConsumerIdentifierEnum {
  EMAIL = 'EMAIL',
  EXTERNALID = 'EXTERNALID',
  PHONE = 'PHONE'
}

export type ConsumerInput = {
  _id?: InputMaybe<Scalars['MongoID']>;
  /** Whether this consumer accepts marketing mails */
  acceptsMarketing?: InputMaybe<Scalars['Boolean']>;
  accountType?: InputMaybe<Scalars['String']>;
  add1?: InputMaybe<Scalars['String']>;
  add2?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  company?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  countryCode?: InputMaybe<Scalars['String']>;
  currency?: InputMaybe<Scalars['String']>;
  /** Custom data for the consumer */
  customData?: InputMaybe<Scalars['JSON']>;
  /** Optionally a custom id for the consumer */
  customId?: InputMaybe<Scalars['String']>;
  disableContact?: InputMaybe<Scalars['Boolean']>;
  externalId?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  journey?: InputMaybe<Array<InputMaybe<ConsumerJourneyInput>>>;
  lastName?: InputMaybe<Scalars['String']>;
  latestOfferMail?: InputMaybe<Scalars['Date']>;
  locale?: InputMaybe<Scalars['String']>;
  mail?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  personId?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  /** Whether this is a proxy account for another consumer */
  proxyAccount?: InputMaybe<Scalars['Boolean']>;
  /** Whether this consumer was created by a consumer himself or by a trusted source */
  selfCreated?: InputMaybe<Scalars['Boolean']>;
  shopId?: InputMaybe<Scalars['MongoID']>;
  zipCode?: InputMaybe<Scalars['String']>;
};

export type ConsumerJourney = {
  __typename?: 'ConsumerJourney';
  _id?: Maybe<Scalars['MongoID']>;
  /** The date of the journey entry */
  date: Scalars['Date'];
  /** The type of journey entry */
  entryType: EnumConsumerJourneyEntryType;
};

export type ConsumerJourneyInput = {
  _id?: InputMaybe<Scalars['MongoID']>;
  /** The date of the journey entry */
  date: Scalars['Date'];
  /** The type of journey entry */
  entryType: EnumConsumerJourneyEntryType;
};

export type ConsumerMailUpdateInput = {
  /** Mail bounched */
  bounced?: InputMaybe<Scalars['Boolean']>;
  /** Link in mail was clicked */
  clicked?: InputMaybe<Scalars['Boolean']>;
  /** Mail has been delivered */
  delivered?: InputMaybe<Scalars['Boolean']>;
  /** The mail message ID */
  messageId: Scalars['String'];
  /** Mail was opened */
  opened?: InputMaybe<Scalars['Boolean']>;
  /** User marked the mail as spam */
  spam?: InputMaybe<Scalars['Boolean']>;
};

export type ConsumerRejectAccessResult = {
  __typename?: 'ConsumerRejectAccessResult';
  status: Scalars['String'];
};

export type ConsumerSendCode = {
  __typename?: 'ConsumerSendCode';
  status: Scalars['String'];
};

export type ConsumerSendMail = {
  __typename?: 'ConsumerSendMail';
  status: Scalars['String'];
};

export type ConsumerStatistics = {
  __typename?: 'ConsumerStatistics';
  /** The total number of orders */
  orders?: Maybe<Scalars['Int']>;
  /** The total amount of discounts applied to orders before tax */
  ordersTotalDiscountedPreTax?: Maybe<Scalars['Int']>;
  /** The total number of trade-ins */
  tradeIns?: Maybe<Scalars['Int']>;
};

/** Profile fields to merge into the synchronized consumer. */
export type ConsumerSynchronizeInput = {
  countryCode?: InputMaybe<Scalars['String']>;
  customData?: InputMaybe<Scalars['String']>;
  customId?: InputMaybe<Scalars['String']>;
  externalId?: InputMaybe<Scalars['String']>;
  language?: InputMaybe<Scalars['String']>;
  mail?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  zipCode?: InputMaybe<Scalars['String']>;
};

export type ConsumerVerifyCode = {
  __typename?: 'ConsumerVerifyCode';
  accessToken?: Maybe<Scalars['String']>;
  status: Scalars['String'];
};

export type ConsumersPaging = {
  __typename?: 'ConsumersPaging';
  data?: Maybe<Array<Maybe<Consumer>>>;
  page: Scalars['Int'];
  pages: Scalars['Int'];
  total: Scalars['Int'];
};

export type Country = {
  __typename?: 'Country';
  code: Scalars['String'];
  currency: Scalars['String'];
  name: Scalars['String'];
};

export type CreateOneBrandProductGroupInput = {
  /** Is the group active for everything */
  active: Scalars['Boolean'];
  /** Is the group active for potential linking */
  activePotentials?: InputMaybe<Scalars['Boolean']>;
  /** Is the group active for promoting brand items */
  activePromotions?: InputMaybe<Scalars['Boolean']>;
  brandHouseId: Scalars['MongoID'];
  /** The name of the group */
  name: Scalars['String'];
};

export type CreateOneBrandProductGroupPayload = {
  __typename?: 'CreateOneBrandProductGroupPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<BrandProductGroup>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']>;
};

export type CreateOneCampaignInput = {
  /** The brand house id of the campaign */
  brandHouseId: Scalars['MongoID'];
  /** The name of the campaign */
  campaignName: Scalars['String'];
  /** The status of the campaign */
  disabled?: InputMaybe<Scalars['Boolean']>;
  /** The start date of the campaign */
  fromDate: Scalars['Date'];
  /** The percentage discount of the campaign */
  percentage: Scalars['Float'];
  /** The shop id of the campaign */
  shopId?: InputMaybe<Scalars['MongoID']>;
  /** The end date of the campaign */
  toDate: Scalars['Date'];
};

export type CreateOneCampaignPayload = {
  __typename?: 'CreateOneCampaignPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<Campaign>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']>;
};

export type CreateOneCircularPointInput = {
  /** Whether the circularpoint point transaction has been activated for a tradein, or executed with the external service provider for a payout */
  activated: Scalars['Boolean'];
  /** The consumer id / account id, owning the points */
  consumerId: Scalars['MongoID'];
  createdAt?: InputMaybe<Scalars['Date']>;
  /** Whether this has been processed by the circular points engine */
  eventProcessed: Scalars['Boolean'];
  /** The shop */
  shopId: Scalars['MongoID'];
  /** Optionally data from the source that is relevant to the circular point */
  sourceData?: InputMaybe<CircularPointSourceDataInput>;
  /** The source of the circularpoint transaction, tradein id, conversion id, etc */
  sourceObjectId: Scalars['MongoID'];
  /** The type of the transaction source, tradein or conversion */
  sourceType: EnumCircularPointSourceType;
  updatedAt?: InputMaybe<Scalars['Date']>;
  /** The change in points for this transaction. Can be a negative or positive value. */
  value: Scalars['Float'];
};

export type CreateOneCircularPointPayload = {
  __typename?: 'CreateOneCircularPointPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<CircularPoint>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']>;
};

export type CreateOneIntegrationConnectorInput = {
  activeFor?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  autoInstallFor?: InputMaybe<Array<InputMaybe<EnumIntegrationConnectorAutoInstallFor>>>;
  cloudTasks?: InputMaybe<IntegrationConnectorCloudTasksInput>;
  /** Whether this connector has been deleted */
  deleted?: InputMaybe<Scalars['Boolean']>;
  /** The runtime that dispatches this connector; missing means FUNCTIONS2 for backwards compatibility */
  dispatcher?: InputMaybe<EnumIntegrationConnectorDispatcher>;
  eventbus?: InputMaybe<IntegrationConnectorEventbusInput>;
  fields?: InputMaybe<Array<InputMaybe<IntegrationConnectorFieldsInput>>>;
  /** Icon for the connector */
  icon?: InputMaybe<Scalars['String']>;
  messages?: InputMaybe<Array<InputMaybe<EnumIntegrationConnectorMessages>>>;
  /** The name of the connector */
  name: Scalars['String'];
  optionals?: InputMaybe<Array<InputMaybe<EnumIntegrationConnectorOptionals>>>;
  refTypes?: InputMaybe<Array<InputMaybe<EnumIntegrationConnectorRefTypes>>>;
  /** The type of connector */
  type: EnumIntegrationConnectorType;
  /** The latest entity that updated this connector */
  updatedBy?: InputMaybe<ObjectPatchesUpdatedByInput>;
  webhook?: InputMaybe<IntegrationConnectorWebhookInput>;
};

export type CreateOneIntegrationConnectorPayload = {
  __typename?: 'CreateOneIntegrationConnectorPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<IntegrationConnector>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']>;
};

export type CreateOneInvoiceAdjustmentInput = {
  amount: Scalars['Float'];
  brandHouseId: Scalars['MongoID'];
  description: Scalars['String'];
};

export type CreateOneInvoiceAdjustmentPayload = {
  __typename?: 'CreateOneInvoiceAdjustmentPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<InvoiceAdjustment>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']>;
};

export type CreateOneParcelInput = {
  /** The brand that owns this parcel */
  brandHouseId: Scalars['MongoID'];
  /** Optional comment for the parcel */
  comment?: InputMaybe<Scalars['String']>;
  /** Items in the parcel */
  items?: InputMaybe<Array<InputMaybe<ParcelItemsInput>>>;
  /** When provided, no shipping label is created via carrier — tracking is managed externally */
  manualTracking?: InputMaybe<ParcelManualTrackingInput>;
  /** The date of the parcel creation */
  parcelDate: Scalars['Date'];
  /** The receiver of the parcel */
  receiver: AddressInfoInput;
  /** The sender of the parcel */
  sender: AddressInfoInput;
  /** The carrier of the parcel */
  shippingCarrierId?: InputMaybe<Scalars['MongoID']>;
  /** The shop that owns this parcel */
  shopId?: InputMaybe<Scalars['MongoID']>;
};

export type CreateOneParcelPayload = {
  __typename?: 'CreateOneParcelPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<Parcel>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']>;
};

export type CreateOneRespondentInput = {
  /** The answers made by this respondent */
  answers: Array<InputMaybe<RespondentAnswersInput>>;
  shopId: Scalars['MongoID'];
  surveyId: Scalars['MongoID'];
};

export type CreateOneRespondentPayload = {
  __typename?: 'CreateOneRespondentPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<Respondent>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']>;
};

export type CreateOneScheduledEventInput = {
  /** Optionally data that will be sent with the event */
  data?: InputMaybe<Scalars['JSON']>;
  /** The timestamp of when the event should be executed */
  executeAt: Scalars['Date'];
  /** The timestamp of when the event was executed */
  executed?: InputMaybe<Scalars['Date']>;
  /** The referenced object this event is attached to */
  refId: Scalars['MongoID'];
  /** The referenced object type */
  refType: EnumScheduledEventRefType;
};

export type CreateOneScheduledEventPayload = {
  __typename?: 'CreateOneScheduledEventPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<ScheduledEvent>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']>;
};

export type CreateOneShippingLabelInput = {
  archived?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Date']>;
  deletedBy?: InputMaybe<Scalars['String']>;
  deletedTs?: InputMaybe<Scalars['Date']>;
  deliveryDate?: InputMaybe<Scalars['Date']>;
  deliveryStatus?: InputMaybe<EnumShippingLabelDeliveryStatus>;
  labelCode?: InputMaybe<Scalars['String']>;
  labelExternalId?: InputMaybe<Scalars['String']>;
  labelFailed?: InputMaybe<Scalars['Boolean']>;
  labelFailedCount?: InputMaybe<Scalars['Float']>;
  labelImageId?: InputMaybe<Scalars['MongoID']>;
  lastUpdate?: InputMaybe<Scalars['Date']>;
  packageCode?: InputMaybe<Scalars['String']>;
  qrImageId?: InputMaybe<Scalars['MongoID']>;
  qrPngId?: InputMaybe<Scalars['MongoID']>;
  receiver?: InputMaybe<AddressInfoInput>;
  sender?: InputMaybe<AddressInfoInput>;
  shippingCarrierId: Scalars['MongoID'];
  shopId: Scalars['MongoID'];
  tracking?: InputMaybe<ShippingLabelTrackingInput>;
  updatedAt?: InputMaybe<Scalars['Date']>;
  updatedBy?: InputMaybe<ObjectPatchesUpdatedByInput>;
};

export type CreateOneShippingLabelPayload = {
  __typename?: 'CreateOneShippingLabelPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<ShippingLabel>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']>;
};

export type CreateOneSystemMessageInput = {
  /** The target audience (SYSADM, ADMIN, BRAND) */
  audience: EnumSystemMessageAudience;
  /** If the audience is a brandhouse, this is the brandhouse id */
  audienceBrandId?: InputMaybe<Scalars['MongoID']>;
  description: Scalars['String'];
  /** The type of message (CRITICAL, WARNING, INFORMATION) */
  messageType: EnumSystemMessageMessageType;
  /** Subject used to group repeated messages while unacknowledged */
  subject: Scalars['String'];
};

export type CreateOneSystemMessagePayload = {
  __typename?: 'CreateOneSystemMessagePayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<SystemMessage>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']>;
};

export type CreateOneVoucherAdjustmentInput = {
  /** The adjustment amount in vouchers currency */
  amount: Scalars['Float'];
  /** Set by the creator: also apply this adjustment to the voucher's external gift card (passive vouchers only). Adjustments without it never change the gift card */
  applyToGiftCard?: InputMaybe<Scalars['Boolean']>;
  /** If this adjustment is a correction to the original voucher value */
  correction?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Date']>;
  /** The adjustment date */
  date: Scalars['Date'];
  /** Reason for adjustment */
  reason: Scalars['String'];
  /** The shop that owns the usage refund */
  shopId: Scalars['MongoID'];
  updatedAt?: InputMaybe<Scalars['Date']>;
  updatedBy?: InputMaybe<ObjectPatchesUpdatedByInput>;
  /** The voucher */
  voucherId: Scalars['MongoID'];
};

export type CreateOneVoucherAdjustmentPayload = {
  __typename?: 'CreateOneVoucherAdjustmentPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<VoucherAdjustment>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']>;
};

export type CreateOneWholeSaleCategoryInput = {
  advanced?: InputMaybe<Scalars['Boolean']>;
  /** Soft-delete flag. When true, the category is hidden from listings but retained so historical TradeInItems can still resolve it. */
  deleted?: InputMaybe<Scalars['Boolean']>;
  iconId?: InputMaybe<Scalars['MongoID']>;
  name: Scalars['String'];
  nameLocalized?: InputMaybe<Array<InputMaybe<LocalizationEntryInput>>>;
  rules?: InputMaybe<Array<InputMaybe<WholeSaleCategoryRulesInput>>>;
  section?: InputMaybe<Scalars['String']>;
  sectionLocalized?: InputMaybe<Array<InputMaybe<LocalizationEntryInput>>>;
  shopId: Scalars['MongoID'];
  /** The other of this category */
  sortOrder?: InputMaybe<Scalars['Float']>;
  updatedBy?: InputMaybe<ObjectPatchesUpdatedByInput>;
  value: Scalars['Float'];
  voucherStrategy?: InputMaybe<EnumWholeSaleCategoryVoucherStrategy>;
};

export type CreateOneWholeSaleCategoryPayload = {
  __typename?: 'CreateOneWholeSaleCategoryPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<WholeSaleCategory>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']>;
};

export type Currency = {
  __typename?: 'Currency';
  /** Whether the currency is active */
  active?: Maybe<Scalars['Boolean']>;
  /** The ISO 4217 currency code */
  currency: Scalars['String'];
};

export type CurrencyConversion = {
  __typename?: 'CurrencyConversion';
  currency: Scalars['String'];
  value: Scalars['Float'];
};

export type CurrencyInput = {
  /** Whether the currency is active */
  active?: InputMaybe<Scalars['Boolean']>;
  /** The ISO 4217 currency code */
  currency: Scalars['String'];
};

export type DataView = {
  __typename?: 'DataView';
  _id: Scalars['MongoID'];
  brandHouseId?: Maybe<Scalars['MongoID']>;
  createdAt: Scalars['Date'];
  expiresAt: Scalars['Date'];
  /** Opaque to Core. Producers may store display data for the rows, such as columns and per-row values; consumers render what they understand. */
  metadata?: Maybe<Scalars['JSON']>;
  rowIds: Array<Maybe<Scalars['MongoID']>>;
  /** Type of entities in this view */
  type: DataViewTypeEnum;
  viewName?: Maybe<Scalars['String']>;
};

export enum DataViewTypeEnum {
  BrandItem = 'BrandItem',
  Consumer = 'Consumer',
  Order = 'Order',
  TradeIn = 'TradeIn'
}

export enum DifferenceTypeEnum {
  MISSING_IN_A = 'MISSING_IN_A',
  MISSING_IN_B = 'MISSING_IN_B',
  ONLY_IN_A = 'ONLY_IN_A',
  ONLY_IN_B = 'ONLY_IN_B',
  VALUE_MISMATCH = 'VALUE_MISMATCH'
}

export type DigitalPassport = {
  __typename?: 'DigitalPassport';
  /** The access token */
  accessToken: Scalars['String'];
  /** The status of the digital passport */
  status: Scalars['Float'];
  /** The url to the digital passport tradein */
  url: Scalars['String'];
};

export type Dropoff = {
  __typename?: 'Dropoff';
  address?: Maybe<Scalars['String']>;
  address2?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  in_delivery?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  opening_hours?: Maybe<Array<Maybe<Scalars['String']>>>;
  out_delivery?: Maybe<Scalars['Boolean']>;
  qr_code?: Maybe<Scalars['Boolean']>;
  zipcode?: Maybe<Scalars['String']>;
};

/** The referenced object type, Shop, BrandHouse, LogisticsPartner */
export enum EnumAddressInfoRefType {
  BRAND = 'BRAND',
  LOGISTICSPARTNER = 'LOGISTICSPARTNER',
  SHOP = 'SHOP'
}

export enum EnumBrandItemAttributesApparentFabricType {
  canvas = 'canvas',
  corduroy = 'corduroy',
  denim = 'denim',
  fleece = 'fleece',
  fuzzy = 'fuzzy',
  glossy = 'glossy',
  jersey = 'jersey',
  knit = 'knit',
  lace = 'lace',
  leather = 'leather',
  metal = 'metal',
  nylon = 'nylon',
  plastic = 'plastic',
  polyester = 'polyester',
  ribbed = 'ribbed',
  satin = 'satin',
  sequined = 'sequined',
  sheer = 'sheer',
  silk = 'silk',
  stretch = 'stretch',
  suede = 'suede',
  velvet = 'velvet',
  woven = 'woven'
}

export enum EnumBrandItemAttributesFormalityLevel {
  athletic = 'athletic',
  business_casual = 'business_casual',
  business_formal = 'business_formal',
  casual = 'casual',
  formal = 'formal',
  functional = 'functional',
  loungewear = 'loungewear',
  smart_casual = 'smart_casual'
}

export enum EnumBrandItemAttributesNeckline {
  boat = 'boat',
  collar = 'collar',
  cowl = 'cowl',
  crew = 'crew',
  halter = 'halter',
  hood = 'hood',
  off_shoulder = 'off_shoulder',
  scoop = 'scoop',
  strapless = 'strapless',
  turtle = 'turtle',
  v_neck = 'v_neck'
}

export enum EnumBrandItemAttributesNotableFeatures {
  belt = 'belt',
  buttons = 'buttons',
  cutouts = 'cutouts',
  embellishments = 'embellishments',
  hood = 'hood',
  logo = 'logo',
  pleats = 'pleats',
  pockets = 'pockets',
  ruffles = 'ruffles',
  zippers = 'zippers'
}

export enum EnumBrandItemAttributesPattern {
  abstract = 'abstract',
  animal_print = 'animal_print',
  camouflage = 'camouflage',
  floral = 'floral',
  geometric = 'geometric',
  graphic = 'graphic',
  paisley = 'paisley',
  plaid = 'plaid',
  polka_dots = 'polka_dots',
  solid = 'solid',
  stripes = 'stripes'
}

export enum EnumBrandItemAttributesPrimaryColor {
  beige = 'beige',
  black = 'black',
  blue = 'blue',
  brown = 'brown',
  gray = 'gray',
  green = 'green',
  metallic = 'metallic',
  multicolor = 'multicolor',
  navy = 'navy',
  orange = 'orange',
  pink = 'pink',
  purple = 'purple',
  red = 'red',
  white = 'white',
  yellow = 'yellow'
}

export enum EnumBrandItemAttributesSeasonSuitability {
  fall = 'fall',
  spring = 'spring',
  summer = 'summer',
  winter = 'winter',
  year_round = 'year_round'
}

export enum EnumBrandItemAttributesSecondaryColors {
  beige = 'beige',
  black = 'black',
  blue = 'blue',
  brown = 'brown',
  gray = 'gray',
  green = 'green',
  metallic = 'metallic',
  multicolor = 'multicolor',
  navy = 'navy',
  orange = 'orange',
  pink = 'pink',
  purple = 'purple',
  red = 'red',
  white = 'white',
  yellow = 'yellow'
}

export enum EnumBrandItemAttributesSubType {
  beanie = 'beanie',
  bomber_jacket = 'bomber_jacket',
  bracelet = 'bracelet',
  brooch = 'brooch',
  cap = 'cap',
  denim_jacket = 'denim_jacket',
  earrings = 'earrings',
  hunting_jacket = 'hunting_jacket',
  leather_jacket = 'leather_jacket',
  necklace = 'necklace',
  other = 'other',
  other_gloves = 'other_gloves',
  puffer_jacket = 'puffer_jacket',
  rain_jacket = 'rain_jacket',
  rain_set = 'rain_set',
  ring = 'ring',
  ski_gloves = 'ski_gloves',
  summer_hat = 'summer_hat',
  winter_hat = 'winter_hat'
}

export enum EnumBrandItemAttributesTextureAppearance {
  cable_knit = 'cable_knit',
  coated = 'coated',
  distressed = 'distressed',
  embossed = 'embossed',
  embroidered = 'embroidered',
  fuzzy = 'fuzzy',
  glossy = 'glossy',
  lace = 'lace',
  matte = 'matte',
  pebbled = 'pebbled',
  quilted = 'quilted',
  ribbed = 'ribbed',
  smooth = 'smooth'
}

export enum EnumBrandItemAttributesType {
  activewear = 'activewear',
  bag = 'bag',
  belt = 'belt',
  blazer = 'blazer',
  blouse = 'blouse',
  bodysuit = 'bodysuit',
  boots = 'boots',
  cardigan = 'cardigan',
  coat = 'coat',
  dress = 'dress',
  flats = 'flats',
  hat = 'hat',
  heels = 'heels',
  hoodie = 'hoodie',
  jacket = 'jacket',
  jeans = 'jeans',
  jewelry = 'jewelry',
  jumpsuit = 'jumpsuit',
  leggings = 'leggings',
  lingerie = 'lingerie',
  loafers = 'loafers',
  other = 'other',
  outerwear_set = 'outerwear_set',
  pants = 'pants',
  romper = 'romper',
  sandals = 'sandals',
  scarf = 'scarf',
  shirt = 'shirt',
  shoes = 'shoes',
  shorts = 'shorts',
  skirt = 'skirt',
  sleepingbag = 'sleepingbag',
  slippers = 'slippers',
  sneakers = 'sneakers',
  suit = 'suit',
  sunglasses = 'sunglasses',
  support_pillow = 'support_pillow',
  sweater = 'sweater',
  sweatshirt = 'sweatshirt',
  swimwear = 'swimwear',
  t_shirt = 't_shirt',
  tank_top = 'tank_top',
  tent = 'tent',
  vest = 'vest',
  watch = 'watch'
}

/** Why the boost ended */
export enum EnumBrandItemBoostEndedReason {
  CANCELLED = 'CANCELLED',
  EXPIRED = 'EXPIRED',
  REPLACED = 'REPLACED'
}

export enum EnumBrandItemImagePerspective {
  BACK = 'BACK',
  DETAIL = 'DETAIL',
  FRONT = 'FRONT',
  OTHER = 'OTHER'
}

export enum EnumBrandItemImageType {
  FOCUS = 'FOCUS',
  MODEL = 'MODEL',
  OTHER = 'OTHER',
  PACK = 'PACK'
}

/** State of the branditem */
export enum EnumBrandItemItemState {
  DRAFT = 'DRAFT',
  NONE = 'NONE',
  READY = 'READY',
  REVIEW = 'REVIEW'
}

/** The type of source this branditem is from */
export enum EnumBrandItemSourceType {
  CLAIM = 'CLAIM',
  NEWITEM = 'NEWITEM',
  SAMPLE = 'SAMPLE',
  SECONDHAND = 'SECONDHAND'
}

/** The current state of the VAS process for this item */
export enum EnumBrandItemVasState {
  COMPLETED = 'COMPLETED',
  DISCARDED = 'DISCARDED',
  PROGRESSING = 'PROGRESSING',
  RECEIVED = 'RECEIVED',
  REPAIRING = 'REPAIRING',
  WASHING = 'WASHING'
}

/** The VAS contract version for this item */
export enum EnumBrandItemVasType {
  VAS1_0 = 'VAS1_0',
  VAS2_0 = 'VAS2_0'
}

export enum EnumBrandProductImagePerspective {
  BACK = 'BACK',
  DETAIL = 'DETAIL',
  FRONT = 'FRONT',
  OTHER = 'OTHER'
}

export enum EnumBrandProductImageType {
  FOCUS = 'FOCUS',
  MODEL = 'MODEL',
  OTHER = 'OTHER',
  PACK = 'PACK'
}

export enum EnumBrandRuleDigitalPassportValue {
  RRP = 'RRP',
  SP = 'SP',
  SPORIGINAL = 'SPORIGINAL'
}

/** The minimum price, relative to RRP or SP */
export enum EnumBrandRuleMinimumPriceType {
  RRP = 'RRP',
  SP = 'SP',
  SPORIGINAL = 'SPORIGINAL'
}

export enum EnumBrandRuleSecondhandVoucherValue {
  RRP = 'RRP',
  SP = 'SP',
  SPORIGINAL = 'SPORIGINAL'
}

export enum EnumBrandRuleTradeInSearchAmountsExpressionsOperation {
  CONTAINS = 'CONTAINS',
  ENDSWITH = 'ENDSWITH',
  EXCLUDE = 'EXCLUDE',
  INCLUDE = 'INCLUDE',
  STARTSWITH = 'STARTSWITH'
}

export enum EnumBrandRuleTradeInSearchAmountsExpressionsValueType {
  COLLECTION = 'COLLECTION',
  EAN = 'EAN',
  METAFIELD = 'METAFIELD',
  NAME = 'NAME',
  SKU = 'SKU',
  TAG = 'TAG',
  TYPE = 'TYPE',
  VENDOR = 'VENDOR'
}

export enum EnumBrandRuleVoucherStrategy {
  HANDIN = 'HANDIN',
  INSTANT = 'INSTANT',
  RECEIVED = 'RECEIVED'
}

export enum EnumBrandRuleVoucherValue {
  RRP = 'RRP',
  SP = 'SP',
  SPORIGINAL = 'SPORIGINAL'
}

/** Enabled messages for legacy integration */
export enum EnumBrandSettingLegacyIntegrationDisabledMessages {
  CANCELLED = 'CANCELLED',
  CAPTURE = 'CAPTURE',
  CONSUMERACTIVITY = 'CONSUMERACTIVITY',
  CREATEORDER = 'CREATEORDER',
  CREATEPARCEL = 'CREATEPARCEL',
  CREATESHIPPINGLABEL = 'CREATESHIPPINGLABEL',
  CREATETRADEIN = 'CREATETRADEIN',
  DELETE = 'DELETE',
  FULFILL = 'FULFILL',
  INIT = 'INIT',
  OPTIMIZEBYSALESRANK = 'OPTIMIZEBYSALESRANK',
  PERIODICREPORT = 'PERIODICREPORT',
  REFUND = 'REFUND',
  REMOVEBG = 'REMOVEBG',
  REQUESTACCESS = 'REQUESTACCESS',
  REQUESTORDERS = 'REQUESTORDERS',
  REQUESTPOTENTIALS = 'REQUESTPOTENTIALS',
  REQUESTPRODUCTS = 'REQUESTPRODUCTS',
  REQUESTVOUCHERS = 'REQUESTVOUCHERS',
  SCHEDULEDEVENT = 'SCHEDULEDEVENT',
  SENDMAIL = 'SENDMAIL',
  UPDATEBRAND = 'UPDATEBRAND',
  UPDATEBRANDITEM = 'UPDATEBRANDITEM',
  UPDATECATEGORY = 'UPDATECATEGORY',
  UPDATECONFIG = 'UPDATECONFIG',
  UPDATEINVENTORY = 'UPDATEINVENTORY',
  UPDATEINVOICE = 'UPDATEINVOICE',
  UPDATEORDER = 'UPDATEORDER',
  UPDATEPARCEL = 'UPDATEPARCEL',
  UPDATEPOTENTIALS = 'UPDATEPOTENTIALS',
  UPDATESHIPPINGLABEL = 'UPDATESHIPPINGLABEL',
  UPDATESHOP = 'UPDATESHOP',
  UPDATESTOCKITEMS = 'UPDATESTOCKITEMS',
  UPDATETRADEIN = 'UPDATETRADEIN',
  UPDATEVOUCHER = 'UPDATEVOUCHER'
}

/** How to identify colors on master data */
export enum EnumBrandSettingMasterDataConsolidateColorStrategy {
  PRODUCT_INTERNAL_COLOR = 'PRODUCT_INTERNAL_COLOR',
  PRODUCT_METAFIELD = 'PRODUCT_METAFIELD',
  PRODUCT_NAME_DASH_SUFFIX = 'PRODUCT_NAME_DASH_SUFFIX',
  PRODUCT_NAME_KNOWN_COLORS = 'PRODUCT_NAME_KNOWN_COLORS',
  PRODUCT_NAME_PARANTHESIS = 'PRODUCT_NAME_PARANTHESIS',
  PRODUCT_NAME_PIPE_SUFFIX = 'PRODUCT_NAME_PIPE_SUFFIX',
  PRODUCT_TAG_PREFIX = 'PRODUCT_TAG_PREFIX',
  VARIANT_ATTRIBUTE = 'VARIANT_ATTRIBUTE',
  VARIANT_SKU_PATTERN = 'VARIANT_SKU_PATTERN'
}

/** The field that we are consolidating on */
export enum EnumBrandSettingMasterDataConsolidateField {
  EAN = 'EAN',
  SKU = 'SKU'
}

/** Secondary identify color strategy */
export enum EnumBrandSettingMasterDataConsolidateSecondaryColorStrategy {
  PRODUCT_INTERNAL_COLOR = 'PRODUCT_INTERNAL_COLOR',
  PRODUCT_METAFIELD = 'PRODUCT_METAFIELD',
  PRODUCT_NAME_DASH_SUFFIX = 'PRODUCT_NAME_DASH_SUFFIX',
  PRODUCT_NAME_KNOWN_COLORS = 'PRODUCT_NAME_KNOWN_COLORS',
  PRODUCT_NAME_PARANTHESIS = 'PRODUCT_NAME_PARANTHESIS',
  PRODUCT_NAME_PIPE_SUFFIX = 'PRODUCT_NAME_PIPE_SUFFIX',
  PRODUCT_TAG_PREFIX = 'PRODUCT_TAG_PREFIX',
  VARIANT_ATTRIBUTE = 'VARIANT_ATTRIBUTE',
  VARIANT_SKU_PATTERN = 'VARIANT_SKU_PATTERN'
}

/** Tertiary identify color strategy */
export enum EnumBrandSettingMasterDataConsolidateTertiaryColorStrategy {
  PRODUCT_INTERNAL_COLOR = 'PRODUCT_INTERNAL_COLOR',
  PRODUCT_METAFIELD = 'PRODUCT_METAFIELD',
  PRODUCT_NAME_DASH_SUFFIX = 'PRODUCT_NAME_DASH_SUFFIX',
  PRODUCT_NAME_KNOWN_COLORS = 'PRODUCT_NAME_KNOWN_COLORS',
  PRODUCT_NAME_PARANTHESIS = 'PRODUCT_NAME_PARANTHESIS',
  PRODUCT_NAME_PIPE_SUFFIX = 'PRODUCT_NAME_PIPE_SUFFIX',
  PRODUCT_TAG_PREFIX = 'PRODUCT_TAG_PREFIX',
  VARIANT_ATTRIBUTE = 'VARIANT_ATTRIBUTE',
  VARIANT_SKU_PATTERN = 'VARIANT_SKU_PATTERN'
}

export enum EnumBrandSettingSellPriceAdvancedType {
  productType = 'productType',
  source = 'source',
  tag = 'tag'
}

export enum EnumBrandSettingStockItemConfigAutoDataOperator {
  exclucde = 'exclucde',
  include = 'include'
}

export enum EnumBrandSettingStockItemConfigAutoDataSearch {
  both = 'both',
  prefix = 'prefix',
  suffix = 'suffix'
}

export enum EnumBrandSettingStockItemConfigAutoDataTarget {
  meta = 'meta',
  tag = 'tag'
}

/** Optional strategy for resolving missing stockitem colors from product titles */
export enum EnumBrandSettingStockItemConfigColorStrategy {
  PRODUCT_NAME_DASH_SUFFIX = 'PRODUCT_NAME_DASH_SUFFIX',
  PRODUCT_NAME_PARANTHESIS = 'PRODUCT_NAME_PARANTHESIS',
  PRODUCT_NAME_PIPE_SUFFIX = 'PRODUCT_NAME_PIPE_SUFFIX'
}

/** Controls the order of the images, when querying on stockitems */
export enum EnumBrandSettingStockItemConfigImageSorting {
  ORGFIRSTMIDDLELAST = 'ORGFIRSTMIDDLELAST',
  ORIGINALFIRST = 'ORIGINALFIRST',
  ORIGINALLAST = 'ORIGINALLAST',
  STANDARD = 'STANDARD'
}

export enum EnumBrandSettingStockItemConfigMasterImageTypes {
  FOCUS = 'FOCUS',
  MODEL = 'MODEL',
  OTHER = 'OTHER',
  PACK = 'PACK'
}

/** How the SKU should be generated for new stockitems */
export enum EnumBrandSettingStockItemConfigSkuStrategy {
  BRANDITEMSKU = 'BRANDITEMSKU',
  ORIGINALEAN = 'ORIGINALEAN',
  UNIQUE = 'UNIQUE'
}

/** Contain will make sure the image is contained wihtin the size, cover will make sure the image is covered. Use alignment to control placement of image */
export enum EnumBrandSettingThumbnailsStrategy {
  contain = 'contain',
  cover = 'cover'
}

/** Whether the tradein app should utilize hashes or browser address for state - default is browser */
export enum EnumBrandSettingTradeInRouter {
  BROWSER = 'BROWSER',
  HASH = 'HASH',
  PARAMETER = 'PARAMETER'
}

export enum EnumBrickMailMailsMailType {
  BRICK = 'BRICK',
  HTML = 'HTML'
}

/** The type of payout */
export enum EnumCircularPayoutTypePayoutType {
  creditcard = 'creditcard',
  mobilepay = 'mobilepay',
  voucher = 'voucher'
}

/** The type of the transaction source, tradein or conversion */
export enum EnumCircularPointSourceType {
  payout = 'payout',
  tradeIn = 'tradeIn'
}

/** The type of journey entry */
export enum EnumConsumerJourneyEntryType {
  OUTBOUND = 'OUTBOUND',
  REQUEST = 'REQUEST',
  WHOLESALE = 'WHOLESALE'
}

export enum EnumDataViewType {
  BrandItem = 'BrandItem',
  Consumer = 'Consumer',
  Order = 'Order',
  TradeIn = 'TradeIn'
}

/** The message type */
export enum EnumIntegrationConfigMessage {
  CANCELLED = 'CANCELLED',
  CAPTURE = 'CAPTURE',
  CONSUMERACTIVITY = 'CONSUMERACTIVITY',
  CREATEORDER = 'CREATEORDER',
  CREATEPARCEL = 'CREATEPARCEL',
  CREATESHIPPINGLABEL = 'CREATESHIPPINGLABEL',
  CREATETRADEIN = 'CREATETRADEIN',
  DELETE = 'DELETE',
  FULFILL = 'FULFILL',
  INIT = 'INIT',
  OPTIMIZEBYSALESRANK = 'OPTIMIZEBYSALESRANK',
  PERIODICREPORT = 'PERIODICREPORT',
  REFUND = 'REFUND',
  REMOVEBG = 'REMOVEBG',
  REQUESTACCESS = 'REQUESTACCESS',
  REQUESTORDERS = 'REQUESTORDERS',
  REQUESTPOTENTIALS = 'REQUESTPOTENTIALS',
  REQUESTPRODUCTS = 'REQUESTPRODUCTS',
  REQUESTVOUCHERS = 'REQUESTVOUCHERS',
  SCHEDULEDEVENT = 'SCHEDULEDEVENT',
  SENDMAIL = 'SENDMAIL',
  UPDATEBRAND = 'UPDATEBRAND',
  UPDATEBRANDITEM = 'UPDATEBRANDITEM',
  UPDATECATEGORY = 'UPDATECATEGORY',
  UPDATECONFIG = 'UPDATECONFIG',
  UPDATEINVENTORY = 'UPDATEINVENTORY',
  UPDATEINVOICE = 'UPDATEINVOICE',
  UPDATEORDER = 'UPDATEORDER',
  UPDATEPARCEL = 'UPDATEPARCEL',
  UPDATEPOTENTIALS = 'UPDATEPOTENTIALS',
  UPDATESHIPPINGLABEL = 'UPDATESHIPPINGLABEL',
  UPDATESHOP = 'UPDATESHOP',
  UPDATESTOCKITEMS = 'UPDATESTOCKITEMS',
  UPDATETRADEIN = 'UPDATETRADEIN',
  UPDATEVOUCHER = 'UPDATEVOUCHER'
}

/** The storefront types that will autoinstall this connector */
export enum EnumIntegrationConnectorAutoInstallFor {
  custom = 'custom',
  magento = 'magento',
  salesforce = 'salesforce',
  shopify = 'shopify',
  shopware = 'shopware',
  woocommerce = 'woocommerce'
}

/** The runtime that dispatches this connector; missing means FUNCTIONS2 for backwards compatibility */
export enum EnumIntegrationConnectorDispatcher {
  FUNCTIONS2 = 'FUNCTIONS2',
  INTEGRATION = 'INTEGRATION'
}

/** The messages supported by the connector */
export enum EnumIntegrationConnectorMessages {
  CANCELLED = 'CANCELLED',
  CAPTURE = 'CAPTURE',
  CONSUMERACTIVITY = 'CONSUMERACTIVITY',
  CREATEORDER = 'CREATEORDER',
  CREATEPARCEL = 'CREATEPARCEL',
  CREATESHIPPINGLABEL = 'CREATESHIPPINGLABEL',
  CREATETRADEIN = 'CREATETRADEIN',
  DELETE = 'DELETE',
  FULFILL = 'FULFILL',
  INIT = 'INIT',
  OPTIMIZEBYSALESRANK = 'OPTIMIZEBYSALESRANK',
  PERIODICREPORT = 'PERIODICREPORT',
  REFUND = 'REFUND',
  REMOVEBG = 'REMOVEBG',
  REQUESTACCESS = 'REQUESTACCESS',
  REQUESTORDERS = 'REQUESTORDERS',
  REQUESTPOTENTIALS = 'REQUESTPOTENTIALS',
  REQUESTPRODUCTS = 'REQUESTPRODUCTS',
  REQUESTVOUCHERS = 'REQUESTVOUCHERS',
  SCHEDULEDEVENT = 'SCHEDULEDEVENT',
  SENDMAIL = 'SENDMAIL',
  UPDATEBRAND = 'UPDATEBRAND',
  UPDATEBRANDITEM = 'UPDATEBRANDITEM',
  UPDATECATEGORY = 'UPDATECATEGORY',
  UPDATECONFIG = 'UPDATECONFIG',
  UPDATEINVENTORY = 'UPDATEINVENTORY',
  UPDATEINVOICE = 'UPDATEINVOICE',
  UPDATEORDER = 'UPDATEORDER',
  UPDATEPARCEL = 'UPDATEPARCEL',
  UPDATEPOTENTIALS = 'UPDATEPOTENTIALS',
  UPDATESHIPPINGLABEL = 'UPDATESHIPPINGLABEL',
  UPDATESHOP = 'UPDATESHOP',
  UPDATESTOCKITEMS = 'UPDATESTOCKITEMS',
  UPDATETRADEIN = 'UPDATETRADEIN',
  UPDATEVOUCHER = 'UPDATEVOUCHER'
}

/** Which messages are optionals */
export enum EnumIntegrationConnectorOptionals {
  CANCELLED = 'CANCELLED',
  CAPTURE = 'CAPTURE',
  CONSUMERACTIVITY = 'CONSUMERACTIVITY',
  CREATEORDER = 'CREATEORDER',
  CREATEPARCEL = 'CREATEPARCEL',
  CREATESHIPPINGLABEL = 'CREATESHIPPINGLABEL',
  CREATETRADEIN = 'CREATETRADEIN',
  DELETE = 'DELETE',
  FULFILL = 'FULFILL',
  INIT = 'INIT',
  OPTIMIZEBYSALESRANK = 'OPTIMIZEBYSALESRANK',
  PERIODICREPORT = 'PERIODICREPORT',
  REFUND = 'REFUND',
  REMOVEBG = 'REMOVEBG',
  REQUESTACCESS = 'REQUESTACCESS',
  REQUESTORDERS = 'REQUESTORDERS',
  REQUESTPOTENTIALS = 'REQUESTPOTENTIALS',
  REQUESTPRODUCTS = 'REQUESTPRODUCTS',
  REQUESTVOUCHERS = 'REQUESTVOUCHERS',
  SCHEDULEDEVENT = 'SCHEDULEDEVENT',
  SENDMAIL = 'SENDMAIL',
  UPDATEBRAND = 'UPDATEBRAND',
  UPDATEBRANDITEM = 'UPDATEBRANDITEM',
  UPDATECATEGORY = 'UPDATECATEGORY',
  UPDATECONFIG = 'UPDATECONFIG',
  UPDATEINVENTORY = 'UPDATEINVENTORY',
  UPDATEINVOICE = 'UPDATEINVOICE',
  UPDATEORDER = 'UPDATEORDER',
  UPDATEPARCEL = 'UPDATEPARCEL',
  UPDATEPOTENTIALS = 'UPDATEPOTENTIALS',
  UPDATESHIPPINGLABEL = 'UPDATESHIPPINGLABEL',
  UPDATESHOP = 'UPDATESHOP',
  UPDATESTOCKITEMS = 'UPDATESTOCKITEMS',
  UPDATETRADEIN = 'UPDATETRADEIN',
  UPDATEVOUCHER = 'UPDATEVOUCHER'
}

export enum EnumIntegrationConnectorRefType {
  BRANDHOUSE = 'BRANDHOUSE',
  LOGISTICSPARTNER = 'LOGISTICSPARTNER',
  SHOP = 'SHOP'
}

/** What type this connector is referenced to */
export enum EnumIntegrationConnectorRefTypes {
  BRANDHOUSE = 'BRANDHOUSE',
  LOGISTICSPARTNER = 'LOGISTICSPARTNER',
  SHOP = 'SHOP'
}

/** The type of connector */
export enum EnumIntegrationConnectorType {
  CLOUD_TASKS = 'CLOUD_TASKS',
  EVENTBUS = 'EVENTBUS',
  WEBHOOK = 'WEBHOOK'
}

/** The mode of the instance */
export enum EnumIntegrationInstanceMode {
  development = 'development',
  production = 'production',
  test = 'test'
}

/** What type this connector is referenced to */
export enum EnumIntegrationInstanceRefType {
  BRANDHOUSE = 'BRANDHOUSE',
  LOGISTICSPARTNER = 'LOGISTICSPARTNER',
  SHOP = 'SHOP'
}

/** The message type */
export enum EnumIntegrationMessageMessage {
  CANCELLED = 'CANCELLED',
  CAPTURE = 'CAPTURE',
  CONSUMERACTIVITY = 'CONSUMERACTIVITY',
  CREATEORDER = 'CREATEORDER',
  CREATEPARCEL = 'CREATEPARCEL',
  CREATESHIPPINGLABEL = 'CREATESHIPPINGLABEL',
  CREATETRADEIN = 'CREATETRADEIN',
  DELETE = 'DELETE',
  FULFILL = 'FULFILL',
  INIT = 'INIT',
  OPTIMIZEBYSALESRANK = 'OPTIMIZEBYSALESRANK',
  PERIODICREPORT = 'PERIODICREPORT',
  REFUND = 'REFUND',
  REMOVEBG = 'REMOVEBG',
  REQUESTACCESS = 'REQUESTACCESS',
  REQUESTORDERS = 'REQUESTORDERS',
  REQUESTPOTENTIALS = 'REQUESTPOTENTIALS',
  REQUESTPRODUCTS = 'REQUESTPRODUCTS',
  REQUESTVOUCHERS = 'REQUESTVOUCHERS',
  SCHEDULEDEVENT = 'SCHEDULEDEVENT',
  SENDMAIL = 'SENDMAIL',
  UPDATEBRAND = 'UPDATEBRAND',
  UPDATEBRANDITEM = 'UPDATEBRANDITEM',
  UPDATECATEGORY = 'UPDATECATEGORY',
  UPDATECONFIG = 'UPDATECONFIG',
  UPDATEINVENTORY = 'UPDATEINVENTORY',
  UPDATEINVOICE = 'UPDATEINVOICE',
  UPDATEORDER = 'UPDATEORDER',
  UPDATEPARCEL = 'UPDATEPARCEL',
  UPDATEPOTENTIALS = 'UPDATEPOTENTIALS',
  UPDATESHIPPINGLABEL = 'UPDATESHIPPINGLABEL',
  UPDATESHOP = 'UPDATESHOP',
  UPDATESTOCKITEMS = 'UPDATESTOCKITEMS',
  UPDATETRADEIN = 'UPDATETRADEIN',
  UPDATEVOUCHER = 'UPDATEVOUCHER'
}

export enum EnumInvoiceLineLineType {
  adjustment = 'adjustment',
  item = 'item',
  order_commission = 'order_commission',
  order_pickpack = 'order_pickpack',
  order_return = 'order_return',
  platform_fee = 'platform_fee',
  shipping_order = 'shipping_order',
  shipping_return = 'shipping_return',
  shipping_tradein = 'shipping_tradein'
}

export enum EnumItemIssueLocation {
  BACK = 'BACK',
  FRONT = 'FRONT',
  INSIDE = 'INSIDE'
}

/** Type of the value, required */
export enum EnumMetaFieldInstanceType {
  ArrayOfString = 'ArrayOfString',
  Json = 'Json',
  LocaleString = 'LocaleString',
  Number = 'Number',
  Text = 'Text'
}

/** Type of the value, required */
export enum EnumMetaFieldType {
  ArrayOfString = 'ArrayOfString',
  Json = 'Json',
  LocaleString = 'LocaleString',
  Number = 'Number',
  Text = 'Text'
}

/** The type of the ref id */
export enum EnumOptionSetRefType {
  BRANDHOUSE = 'BRANDHOUSE',
  LOGISTICSPARTNER = 'LOGISTICSPARTNER',
  SHIPPINGCARRIER = 'SHIPPINGCARRIER',
  SHOP = 'SHOP'
}

export enum EnumOptionSetTarget {
  CANCELCODE = 'CANCELCODE',
  DROPOFF = 'DROPOFF',
  ISSUECODE = 'ISSUECODE',
  ITEM = 'ITEM',
  ITEM_COLOR = 'ITEM_COLOR',
  RETURNCODE = 'RETURNCODE',
  VENDOR = 'VENDOR'
}

/** The value type of the option set */
export enum EnumOptionSetValueType {
  SELECT = 'SELECT',
  TEXT = 'TEXT'
}

/** Selected carrier for this package */
export enum EnumOrder2CarrierInputCarrier {
  B2C = 'B2C',
  DAO = 'DAO',
  DHL = 'DHL',
  DPOST = 'DPOST',
  GLS = 'GLS',
  PNO = 'PNO',
  UPS = 'UPS'
}

/** Selected delivery service for this package */
export enum EnumOrder2CarrierInputDelivery {
  BUSINESS = 'BUSINESS',
  CLICKCOLLECT = 'CLICKCOLLECT',
  HOME = 'HOME',
  SHOP = 'SHOP'
}

export enum EnumOrder2FulState {
  FULFILLED = 'FULFILLED',
  IN_PROGRESS = 'IN_PROGRESS',
  ON_HOLD = 'ON_HOLD',
  OPEN = 'OPEN',
  PARTIALLY_FULFILLED = 'PARTIALLY_FULFILLED',
  PENDING_FULFILLMENT = 'PENDING_FULFILLMENT',
  SCHEDULED = 'SCHEDULED',
  UNFULFILLED = 'UNFULFILLED'
}

export enum EnumOrder2OrderState {
  CANCELLED = 'CANCELLED',
  COMPLETED = 'COMPLETED',
  OPEN = 'OPEN',
  PARTIAL = 'PARTIAL'
}

export enum EnumOrder2PayState {
  OTHER = 'OTHER',
  PAID = 'PAID',
  PENDING = 'PENDING',
  REFUNDED = 'REFUNDED',
  UNPAID = 'UNPAID'
}

export enum EnumOrder2ReturnInfoCarrier {
  b2c_europe = 'b2c_europe',
  dao = 'dao',
  deutsche_post = 'deutsche_post',
  dhl = 'dhl',
  dhl_express = 'dhl_express',
  gls = 'gls',
  parcelplus = 'parcelplus',
  pdk = 'pdk',
  ups = 'ups'
}

export enum EnumOrder2TrackingInfoCarrier {
  b2c_europe = 'b2c_europe',
  dao = 'dao',
  deutsche_post = 'deutsche_post',
  dhl = 'dhl',
  dhl_express = 'dhl_express',
  gls = 'gls',
  parcelplus = 'parcelplus',
  pdk = 'pdk',
  ups = 'ups'
}

export enum EnumOrder2TrackingOrderState {
  ERROR = 'ERROR',
  NOTSENT = 'NOTSENT',
  PICKUP_AVAILABLE = 'PICKUP_AVAILABLE',
  RECEIVED = 'RECEIVED',
  TRANSIT = 'TRANSIT'
}

export enum EnumOrder2TrackingReturnState {
  ERROR = 'ERROR',
  NOTSENT = 'NOTSENT',
  PICKUP_AVAILABLE = 'PICKUP_AVAILABLE',
  RECEIVED = 'RECEIVED',
  TRANSIT = 'TRANSIT'
}

export enum EnumParcelItemsRefType {
  BRANDITEM = 'BRANDITEM',
  PARCEL = 'PARCEL',
  RETURN = 'RETURN',
  STOCKITEM = 'STOCKITEM',
  TRADEIN = 'TRADEIN'
}

export enum EnumPotentialCancelledReason {
  ItemCancelled = 'ItemCancelled',
  ItemExcluded = 'ItemExcluded',
  ItemRefunded = 'ItemRefunded',
  NULL = 'NULL'
}

/** How masterdata identified this potential on its last answered identification (NONE when no variant was found) */
export enum EnumPotentialIdentifiedBy {
  EAN = 'EAN',
  NONE = 'NONE',
  NULL = 'NULL',
  SKU = 'SKU'
}

/** If the owner of this potential was contacting with trade-in offers for this */
export enum EnumPotentialNotified {
  COUNTRYINVALID = 'COUNTRYINVALID',
  NOTALLOWED = 'NOTALLOWED',
  NOTSENT = 'NOTSENT',
  SENT = 'SENT'
}

/** The source of the potential, e.g. order, wholesale */
export enum EnumPotentialSourceType {
  DIGITALPASS = 'DIGITALPASS',
  ONLINE = 'ONLINE',
  RECIEPT = 'RECIEPT',
  SEARCH = 'SEARCH',
  WHOLESALE = 'WHOLESALE'
}

/** When this trade-in value is activated */
export enum EnumPotentialValueActivation {
  HANDIN = 'HANDIN',
  INSTANT = 'INSTANT',
  RECEIVED = 'RECEIVED'
}

/** If the owner of this potential was contacting with trade-in offers for this */
export enum EnumPotentialValuePotentialNotified {
  COUNTRYINVALID = 'COUNTRYINVALID',
  NOTALLOWED = 'NOTALLOWED',
  NOTSENT = 'NOTSENT',
  SENT = 'SENT'
}

export enum EnumProductImagePerspective {
  BACK = 'BACK',
  DETAIL = 'DETAIL',
  FRONT = 'FRONT',
  OTHER = 'OTHER'
}

export enum EnumProductImageType {
  FOCUS = 'FOCUS',
  MODEL = 'MODEL',
  OTHER = 'OTHER',
  PACK = 'PACK'
}

/** The referenced object type */
export enum EnumScheduledEventRefType {
  BRANDHOUSE = 'BRANDHOUSE',
  LOGISTICSPARTNER = 'LOGISTICSPARTNER',
  SHOP = 'SHOP'
}

export enum EnumShippingCarrierCarrier {
  B2C = 'B2C',
  DAO = 'DAO',
  DHL = 'DHL',
  DPOST = 'DPOST',
  GLS = 'GLS',
  PNO = 'PNO',
  UPS = 'UPS'
}

/** The carrier used for the Carrier Gateway API input */
export enum EnumShippingCarrierCarrierGatewayInputCarrier {
  DHL_EXPRESS = 'DHL_EXPRESS',
  GLS = 'GLS'
}

/** The carrier that will be used to output the shipment */
export enum EnumShippingCarrierCarrierGatewayOutputCarrier {
  b2c_europe = 'b2c_europe',
  dao = 'dao',
  deutsche_post = 'deutsche_post',
  dhl = 'dhl',
  dhl_express = 'dhl_express',
  gls = 'gls',
  parcelplus = 'parcelplus',
  pdk = 'pdk',
  ups = 'ups'
}

export enum EnumShippingCarrierTypeName {
  PACKAGE = 'PACKAGE',
  RETURN = 'RETURN'
}

export enum EnumShippingLabelDeliveryStatus {
  DELIVERED = 'DELIVERED',
  PROGRESSING = 'PROGRESSING',
  UNKNOWN = 'UNKNOWN',
  WAITING = 'WAITING',
  WARNING = 'WARNING'
}

export enum EnumShopFrontendType {
  custom = 'custom',
  magento = 'magento',
  salesforce = 'salesforce',
  shopify = 'shopify',
  shopware = 'shopware',
  woocommerce = 'woocommerce'
}

/** The severity of the status message */
export enum EnumStatusType {
  ERROR = 'ERROR',
  INFO = 'INFO',
  SUCCESS = 'SUCCESS',
  WARN = 'WARN'
}

export enum EnumStockItemImagePerspective {
  BACK = 'BACK',
  DETAIL = 'DETAIL',
  FRONT = 'FRONT',
  OTHER = 'OTHER'
}

export enum EnumStockItemImageType {
  FOCUS = 'FOCUS',
  MODEL = 'MODEL',
  OTHER = 'OTHER',
  PACK = 'PACK'
}

/** The type of source this stockitem is from */
export enum EnumStockItemSourceType {
  CLAIM = 'CLAIM',
  NEWITEM = 'NEWITEM',
  SAMPLE = 'SAMPLE',
  SECONDHAND = 'SECONDHAND'
}

/** The target audience (SYSADM, ADMIN, BRAND) */
export enum EnumSystemMessageAudience {
  ADMIN = 'ADMIN',
  BRAND = 'BRAND',
  SYSADM = 'SYSADM'
}

/** The type of message (CRITICAL, WARNING, INFORMATION) */
export enum EnumSystemMessageMessageType {
  CRITICAL = 'CRITICAL',
  INFORMATION = 'INFORMATION',
  WARNING = 'WARNING'
}

export enum EnumTradeInActivationStrategy {
  HANDIN = 'HANDIN',
  INSTANT = 'INSTANT',
  RECEIVED = 'RECEIVED'
}

/** The reason for rejecting the tradein item */
export enum EnumTradeInItemRejected {
  ITEMBADCONDITION = 'ITEMBADCONDITION',
  ITEMMISSINGCARELABEL = 'ITEMMISSINGCARELABEL',
  ITEMNOTINPACKAGE = 'ITEMNOTINPACKAGE',
  ITEMPARTOFSET = 'ITEMPARTOFSET',
  ITEMWRONGBRAND = 'ITEMWRONGBRAND',
  NOSIZEONITEM = 'NOSIZEONITEM',
  OTHER = 'OTHER'
}

/** The source of the item, e.g. ONLINE, WHOLESALE, RECIEPT, SEARCH, DIGITALPASS */
export enum EnumTradeInItemSourceType {
  DIGITALPASS = 'DIGITALPASS',
  ONLINE = 'ONLINE',
  RECIEPT = 'RECIEPT',
  SEARCH = 'SEARCH',
  WHOLESALE = 'WHOLESALE'
}

/** The payout type */
export enum EnumTradeInPayoutType {
  PAYOUT = 'PAYOUT',
  VOUCHER = 'VOUCHER'
}

/** The source of the tradein */
export enum EnumTradeInSource {
  ONLINE = 'ONLINE',
  STORE = 'STORE'
}

/** PENDING until the integration has applied the adjustment to the gift card (APPLIED) or given up (FAILED) */
export enum EnumVoucherAdjustmentGiftCardSyncStatus {
  APPLIED = 'APPLIED',
  FAILED = 'FAILED',
  PENDING = 'PENDING'
}

/** The type of refund */
export enum EnumVoucherUsageRefundRefundType {
  giftcard = 'giftcard',
  item = 'item',
  refund = 'refund',
  shipping = 'shipping'
}

export enum EnumVoucherVoucherStrategy {
  HANDIN = 'HANDIN',
  INSTANT = 'INSTANT',
  RECEIVED = 'RECEIVED'
}

export enum EnumWholeSaleCategoryRulesExpressionsExpressionType {
  COL = 'COL',
  SKU = 'SKU',
  TAG = 'TAG'
}

export enum EnumWholeSaleCategoryRulesExpressionsOperator {
  EXCLUDING = 'EXCLUDING',
  INCLUDING = 'INCLUDING'
}

export enum EnumWholeSaleCategoryVoucherStrategy {
  HANDIN = 'HANDIN',
  INSTANT = 'INSTANT',
  RECEIVED = 'RECEIVED'
}

export type ErrorInterface = {
  /** Generic error message */
  message?: Maybe<Scalars['String']>;
};

export type ExternOrder = {
  __typename?: 'ExternOrder';
  _createdAt?: Maybe<Scalars['Date']>;
  _id: Scalars['MongoID'];
  _updatedAt?: Maybe<Scalars['Date']>;
  acceptsMarketing?: Maybe<Scalars['Boolean']>;
  cancelledAt?: Maybe<Scalars['Date']>;
  createdAt?: Maybe<Scalars['Date']>;
  currencyCode?: Maybe<Scalars['String']>;
  customer?: Maybe<ExternOrderCustomer>;
  externOrderId?: Maybe<Scalars['String']>;
  lineItems?: Maybe<Array<Maybe<ExternOrderLineItems>>>;
  name?: Maybe<Scalars['String']>;
  shippingAddress?: Maybe<ExternOrderShippingAddress>;
  shopId: Scalars['MongoID'];
  totalDiscountSet?: Maybe<ExternOrderTotalPriceSet>;
  totalPriceSet?: Maybe<ExternOrderTotalPriceSet>;
  totalShippingPriceSet?: Maybe<ExternOrderTotalPriceSet>;
  updatedAt?: Maybe<Scalars['Date']>;
  /** Create2STAY Voucher linked to this order */
  voucherUsage?: Maybe<VoucherUsage>;
};

export type ExternOrder2 = {
  __typename?: 'ExternOrder2';
  _createdAt?: Maybe<Scalars['Date']>;
  _id: Scalars['MongoID'];
  _updatedAt?: Maybe<Scalars['Date']>;
  acceptsMarketing?: Maybe<Scalars['Boolean']>;
  cancelledAt?: Maybe<Scalars['Date']>;
  createdAt?: Maybe<Scalars['Date']>;
  /** The currency for this order, all values will be in this currency */
  currencyCode: Scalars['String'];
  customer?: Maybe<ExternOrder2Customer>;
  /** The external id of this order, must be unique */
  externOrderId: Scalars['String'];
  lineItems?: Maybe<Array<Maybe<ExternOrder2LineItems>>>;
  /** The external order name */
  name?: Maybe<Scalars['String']>;
  shopId: Scalars['MongoID'];
  updatedAt?: Maybe<Scalars['Date']>;
  /** Create2STAY Voucher linked to this order */
  voucherUsage?: Maybe<VoucherUsage>;
};

export type ExternOrder2Customer = {
  __typename?: 'ExternOrder2Customer';
  createdAt?: Maybe<Scalars['Date']>;
  email?: Maybe<Scalars['String']>;
  externCustomerId?: Maybe<Scalars['String']>;
  locale?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
};

export type ExternOrder2CustomerInput = {
  createdAt?: InputMaybe<Scalars['Date']>;
  email?: InputMaybe<Scalars['String']>;
  externCustomerId?: InputMaybe<Scalars['String']>;
  locale?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
};

export type ExternOrder2LineItems = {
  __typename?: 'ExternOrder2LineItems';
  /** Current items bought, refunded/returned items deducted */
  currentQuantity?: Maybe<Scalars['Float']>;
  /** The discounted price including tax */
  discountedPrice: Scalars['Float'];
  /** The discounted price excluding tax */
  discountedPricePreTax: Scalars['Float'];
  ean?: Maybe<Scalars['String']>;
  /** The primary identifier for the lineitem, must be supplied and be unique */
  externLineId: Scalars['String'];
  externProductId?: Maybe<Scalars['String']>;
  externVariantId?: Maybe<Scalars['String']>;
  /** Number of items bought */
  quantity: Scalars['Float'];
  /** The original price including tax */
  salesPrice: Scalars['Float'];
  sku?: Maybe<Scalars['String']>;
};

export type ExternOrder2LineItemsInput = {
  /** Current items bought, refunded/returned items deducted */
  currentQuantity?: InputMaybe<Scalars['Float']>;
  /** The discounted price including tax */
  discountedPrice: Scalars['Float'];
  /** The discounted price excluding tax */
  discountedPricePreTax: Scalars['Float'];
  ean?: InputMaybe<Scalars['String']>;
  /** The primary identifier for the lineitem, must be supplied and be unique */
  externLineId: Scalars['String'];
  externProductId?: InputMaybe<Scalars['String']>;
  externVariantId?: InputMaybe<Scalars['String']>;
  /** Number of items bought */
  quantity: Scalars['Float'];
  /** The original price including tax */
  salesPrice: Scalars['Float'];
  sku?: InputMaybe<Scalars['String']>;
};

export type ExternOrder2SynchronizeInput = {
  acceptsMarketing?: InputMaybe<Scalars['Boolean']>;
  cancelledAt?: InputMaybe<Scalars['Date']>;
  createdAt?: InputMaybe<Scalars['Date']>;
  /** The currency for this order, all values will be in this currency */
  currencyCode: Scalars['String'];
  customer?: InputMaybe<ExternOrder2CustomerInput>;
  /** The external id of this order, must be unique */
  externOrderId: Scalars['String'];
  lineItems?: InputMaybe<Array<InputMaybe<ExternOrder2LineItemsInput>>>;
  /** The external order name */
  name?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Date']>;
};

export type ExternOrderCustomer = {
  __typename?: 'ExternOrderCustomer';
  createdAt?: Maybe<Scalars['Date']>;
  email?: Maybe<Scalars['String']>;
  externCustomerId?: Maybe<Scalars['String']>;
  locale?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
};

export type ExternOrderCustomerInput = {
  createdAt?: InputMaybe<Scalars['Date']>;
  email?: InputMaybe<Scalars['String']>;
  externCustomerId?: InputMaybe<Scalars['String']>;
  locale?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
};

export type ExternOrderLineItems = {
  __typename?: 'ExternOrderLineItems';
  discountedTotalSet?: Maybe<ExternOrderTotalPriceSet>;
  externLineItemId?: Maybe<Scalars['String']>;
  externProductId?: Maybe<Scalars['String']>;
  externVariantId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  originalTotalSet?: Maybe<ExternOrderTotalPriceSet>;
  quantity?: Maybe<Scalars['Float']>;
  sku?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type ExternOrderLineItemsInput = {
  discountedTotalSet?: InputMaybe<ExternOrderTotalPriceSetInput>;
  externLineItemId?: InputMaybe<Scalars['String']>;
  externProductId?: InputMaybe<Scalars['String']>;
  externVariantId?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  originalTotalSet?: InputMaybe<ExternOrderTotalPriceSetInput>;
  quantity?: InputMaybe<Scalars['Float']>;
  sku?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};

export type ExternOrderShippingAddress = {
  __typename?: 'ExternOrderShippingAddress';
  address1?: Maybe<Scalars['String']>;
  address2?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  company?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  countryCode?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  zip?: Maybe<Scalars['String']>;
};

export type ExternOrderShippingAddressInput = {
  address1?: InputMaybe<Scalars['String']>;
  address2?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  company?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  countryCode?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  zip?: InputMaybe<Scalars['String']>;
};

export type ExternOrderSynchronizeInput = {
  acceptsMarketing?: InputMaybe<Scalars['Boolean']>;
  cancelledAt?: InputMaybe<Scalars['Date']>;
  createdAt?: InputMaybe<Scalars['Date']>;
  currencyCode?: InputMaybe<Scalars['String']>;
  customer?: InputMaybe<ExternOrderCustomerInput>;
  externOrderId?: InputMaybe<Scalars['String']>;
  lineItems?: InputMaybe<Array<InputMaybe<ExternOrderLineItemsInput>>>;
  name?: InputMaybe<Scalars['String']>;
  shippingAddress?: InputMaybe<ExternOrderShippingAddressInput>;
  totalDiscountSet?: InputMaybe<ExternOrderTotalPriceSetInput>;
  totalPriceSet?: InputMaybe<ExternOrderTotalPriceSetInput>;
  totalShippingPriceSet?: InputMaybe<ExternOrderTotalPriceSetInput>;
  updatedAt?: InputMaybe<Scalars['Date']>;
};

export type ExternOrderTotalPriceSet = {
  __typename?: 'ExternOrderTotalPriceSet';
  amount?: Maybe<Scalars['Float']>;
  currencyCode?: Maybe<Scalars['String']>;
};

export type ExternOrderTotalPriceSetInput = {
  amount?: InputMaybe<Scalars['Float']>;
  currencyCode?: InputMaybe<Scalars['String']>;
};

export type ExternalLink = {
  __typename?: 'ExternalLink';
  /** The fully qualified URL */
  url?: Maybe<Scalars['String']>;
};

export type FilterCountIntegrationConnectorActiveForOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterCountIntegrationConnectorCloudTasksInput = {
  development?: InputMaybe<FilterCountIntegrationConnectorCloudTasksProductionInput>;
  production?: InputMaybe<FilterCountIntegrationConnectorCloudTasksProductionInput>;
  test?: InputMaybe<FilterCountIntegrationConnectorCloudTasksProductionInput>;
};

export type FilterCountIntegrationConnectorCloudTasksProductionInput = {
  /** The OIDC audience override; defaults to targetUrl when omitted */
  audience?: InputMaybe<Scalars['String']>;
  /** The Cloud Tasks queue name only; GCP project and location live in the runtime configuration of the distributor */
  queue: Scalars['String'];
  /** The HTTPS URL of the connector receiver that Cloud Tasks will POST to */
  targetUrl: Scalars['String'];
};

export type FilterCountIntegrationConnectorEventbusInput = {
  development?: InputMaybe<FilterCountIntegrationConnectorEventbusProductionInput>;
  production?: InputMaybe<FilterCountIntegrationConnectorEventbusProductionInput>;
  test?: InputMaybe<FilterCountIntegrationConnectorEventbusProductionInput>;
};

export type FilterCountIntegrationConnectorEventbusProductionInput = {
  /** The servicebus connection string */
  serviceBus: Scalars['String'];
  /** The topic for the servicebus */
  topic: Scalars['String'];
};

export type FilterCountIntegrationConnectorFieldsInput = {
  _id?: InputMaybe<Scalars['MongoID']>;
  /** Default value for the field */
  defaultValue?: InputMaybe<Scalars['String']>;
  /** Description of the field */
  description?: InputMaybe<Scalars['String']>;
  /** The field */
  field?: InputMaybe<Scalars['String']>;
  /** Namespace grouping of multiple fields */
  namespace?: InputMaybe<Scalars['String']>;
  options?: InputMaybe<Array<InputMaybe<FilterCountIntegrationConnectorFieldsOptionsInput>>>;
  /** Whether the field is required */
  required?: InputMaybe<Scalars['Boolean']>;
  /** text, number, json */
  type?: InputMaybe<Scalars['String']>;
};

export type FilterCountIntegrationConnectorFieldsOptionsInput = {
  /** Option label */
  label?: InputMaybe<Scalars['String']>;
  /** The value when the option is selected */
  value?: InputMaybe<Scalars['JSON']>;
};

export type FilterCountIntegrationConnectorInput = {
  AND?: InputMaybe<Array<FilterCountIntegrationConnectorInput>>;
  OR?: InputMaybe<Array<FilterCountIntegrationConnectorInput>>;
  _id?: InputMaybe<Scalars['MongoID']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountIntegrationConnectorOperatorsInput>;
  activeFor?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  autoInstallFor?: InputMaybe<Array<InputMaybe<EnumIntegrationConnectorAutoInstallFor>>>;
  cloudTasks?: InputMaybe<FilterCountIntegrationConnectorCloudTasksInput>;
  /** Whether this connector has been deleted */
  deleted?: InputMaybe<Scalars['Boolean']>;
  /** The runtime that dispatches this connector; missing means FUNCTIONS2 for backwards compatibility */
  dispatcher?: InputMaybe<EnumIntegrationConnectorDispatcher>;
  eventbus?: InputMaybe<FilterCountIntegrationConnectorEventbusInput>;
  fields?: InputMaybe<Array<InputMaybe<FilterCountIntegrationConnectorFieldsInput>>>;
  /** Icon for the connector */
  icon?: InputMaybe<Scalars['String']>;
  messages?: InputMaybe<Array<InputMaybe<EnumIntegrationConnectorMessages>>>;
  /** The name of the connector */
  name?: InputMaybe<Scalars['String']>;
  optionals?: InputMaybe<Array<InputMaybe<EnumIntegrationConnectorOptionals>>>;
  refTypes?: InputMaybe<Array<InputMaybe<EnumIntegrationConnectorRefTypes>>>;
  /** The type of connector */
  type?: InputMaybe<EnumIntegrationConnectorType>;
  /** The latest entity that updated this connector */
  updatedBy?: InputMaybe<FilterCountObjectPatchesUpdatedByInput>;
  webhook?: InputMaybe<FilterCountIntegrationConnectorWebhookInput>;
};

export type FilterCountIntegrationConnectorNameOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterCountIntegrationConnectorOperatorsInput = {
  _id?: InputMaybe<FilterCountIntegrationConnector_IdOperatorsInput>;
  activeFor?: InputMaybe<FilterCountIntegrationConnectorActiveForOperatorsInput>;
  name?: InputMaybe<FilterCountIntegrationConnectorNameOperatorsInput>;
  refTypes?: InputMaybe<FilterCountIntegrationConnectorRefTypesOperatorsInput>;
};

export type FilterCountIntegrationConnectorRefTypesOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<EnumIntegrationConnectorRefTypes>;
  gte?: InputMaybe<EnumIntegrationConnectorRefTypes>;
  in?: InputMaybe<Array<InputMaybe<EnumIntegrationConnectorRefTypes>>>;
  lt?: InputMaybe<EnumIntegrationConnectorRefTypes>;
  lte?: InputMaybe<EnumIntegrationConnectorRefTypes>;
  ne?: InputMaybe<EnumIntegrationConnectorRefTypes>;
  nin?: InputMaybe<Array<InputMaybe<EnumIntegrationConnectorRefTypes>>>;
};

export type FilterCountIntegrationConnectorWebhookInput = {
  development?: InputMaybe<FilterCountIntegrationConnectorWebhookProductionInput>;
  production?: InputMaybe<FilterCountIntegrationConnectorWebhookProductionInput>;
  test?: InputMaybe<FilterCountIntegrationConnectorWebhookProductionInput>;
};

export type FilterCountIntegrationConnectorWebhookProductionInput = {
  /** Custom headers to include in the webhook request */
  headers?: InputMaybe<Scalars['JSON']>;
  /** The URL that will receive the POST payload message */
  url: Scalars['String'];
};

export type FilterCountIntegrationConnector_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterCountLocalizationEntryInput = {
  /** ISO Locale code */
  locale?: InputMaybe<Scalars['String']>;
  /** The localized text */
  value?: InputMaybe<Scalars['String']>;
};

export type FilterCountObjectPatchesUpdatedByInput = {
  ref?: InputMaybe<Scalars['MongoID']>;
  type?: InputMaybe<Scalars['String']>;
};

export type FilterCountOrder2BrandHouseIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterCountOrder2CarrierInfoInput = {
  _id?: InputMaybe<Scalars['MongoID']>;
  carrierIdentifier?: InputMaybe<Scalars['String']>;
  code?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};

export type FilterCountOrder2CarrierInputInput = {
  /** Selected carrier for this package */
  carrier?: InputMaybe<EnumOrder2CarrierInputCarrier>;
  /** Selected delivery service for this package */
  delivery?: InputMaybe<EnumOrder2CarrierInputDelivery>;
  /** Express delivery */
  express?: InputMaybe<Scalars['Boolean']>;
  /** Optionally an additional service id / pickup point information for this package */
  serviceId?: InputMaybe<Scalars['String']>;
};

export type FilterCountOrder2ConsumerInput = {
  _id?: InputMaybe<Scalars['MongoID']>;
  add1?: InputMaybe<Scalars['String']>;
  add2?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  countryCode?: InputMaybe<Scalars['String']>;
  externalId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  language?: InputMaybe<Scalars['String']>;
  mail?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  zipCode?: InputMaybe<Scalars['String']>;
};

export type FilterCountOrder2FulStateOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<EnumOrder2FulState>;
  gte?: InputMaybe<EnumOrder2FulState>;
  in?: InputMaybe<Array<InputMaybe<EnumOrder2FulState>>>;
  lt?: InputMaybe<EnumOrder2FulState>;
  lte?: InputMaybe<EnumOrder2FulState>;
  ne?: InputMaybe<EnumOrder2FulState>;
  nin?: InputMaybe<Array<InputMaybe<EnumOrder2FulState>>>;
};

export type FilterCountOrder2Input = {
  AND?: InputMaybe<Array<FilterCountOrder2Input>>;
  OR?: InputMaybe<Array<FilterCountOrder2Input>>;
  _id?: InputMaybe<Scalars['MongoID']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountOrder2OperatorsInput>;
  billingAddress?: InputMaybe<FilterCountOrder2ShippingAddressInput>;
  brandHouseId?: InputMaybe<Scalars['MongoID']>;
  captureFailedTs?: InputMaybe<Scalars['Date']>;
  captureNotified?: InputMaybe<Scalars['Boolean']>;
  captureRequests?: InputMaybe<Scalars['Float']>;
  /** The total amount to be captured for this order */
  captureTotal?: InputMaybe<Scalars['Float']>;
  carrierInfo?: InputMaybe<FilterCountOrder2CarrierInfoInput>;
  carrierInput?: InputMaybe<FilterCountOrder2CarrierInputInput>;
  /** Comment for the order */
  comment?: InputMaybe<Scalars['String']>;
  consumer?: InputMaybe<FilterCountOrder2ConsumerInput>;
  consumerId?: InputMaybe<Scalars['MongoID']>;
  createdAt?: InputMaybe<Scalars['Date']>;
  /** Currency for this order */
  currency?: InputMaybe<Scalars['String']>;
  /** Custom data for the order */
  customData?: InputMaybe<Scalars['JSON']>;
  /** Soft delete */
  deleted?: InputMaybe<Scalars['Boolean']>;
  exportedToWMS?: InputMaybe<Scalars['Boolean']>;
  externalId?: InputMaybe<Scalars['String']>;
  /** A free return order is not reduced by the brand's return freight (refundAdjustment) when a line is returned */
  freeReturn?: InputMaybe<Scalars['Boolean']>;
  fulState?: InputMaybe<EnumOrder2FulState>;
  /** Whether this is a new order */
  isNewOrder?: InputMaybe<Scalars['Boolean']>;
  locked?: InputMaybe<Scalars['String']>;
  notified?: InputMaybe<Scalars['Boolean']>;
  notifiedConsumer?: InputMaybe<Scalars['Boolean']>;
  /** True while the sales channel holds the order back from fulfilment (e.g. a Shopify fulfillment hold on one of its lines). Its items stay sold, but the warehouse must not pick it */
  onHold?: InputMaybe<Scalars['Boolean']>;
  orderDate?: InputMaybe<Scalars['Date']>;
  orderName?: InputMaybe<Scalars['String']>;
  orderState?: InputMaybe<EnumOrder2OrderState>;
  orderUrl?: InputMaybe<Scalars['String']>;
  payState?: InputMaybe<EnumOrder2PayState>;
  /** True if the order is a proforma order */
  proforma?: InputMaybe<Scalars['Boolean']>;
  /** True if the order commission can be invoiced, even if it is a proforma order */
  proformaInvoiceCommission?: InputMaybe<Scalars['Boolean']>;
  /** True if the order pickpack can be invoiced, even if it is a proforma order */
  proformaInvoicePickPack?: InputMaybe<Scalars['Boolean']>;
  /** True if the order shipping can be invoiced, even if it is a proforma order */
  proformaInvoiceShipping?: InputMaybe<Scalars['Boolean']>;
  refundAdjusted?: InputMaybe<Scalars['Boolean']>;
  /** The returnDeadline for an order is typically determined by the settings, but its possible to set the returnDeadline to override that */
  returnDeadline?: InputMaybe<Scalars['Date']>;
  returnInfo?: InputMaybe<FilterCountOrder2ReturnInfoInput>;
  returnShippingLabelId?: InputMaybe<Scalars['MongoID']>;
  shippingAddress?: InputMaybe<FilterCountOrder2ShippingAddressInput>;
  shippingAddressInternal?: InputMaybe<FilterCountOrder2ShippingAddressInput>;
  shopId?: InputMaybe<Scalars['MongoID']>;
  /** A silenced order will not show as unfulfilled or active in statistics */
  silenced?: InputMaybe<Scalars['Boolean']>;
  splitOrder?: InputMaybe<Scalars['Boolean']>;
  trackingInfo?: InputMaybe<FilterCountOrder2TrackingInfoInput>;
  /** If the tracking mail has been sent to the consumer */
  trackingMailSent?: InputMaybe<Scalars['Boolean']>;
  trackingOrderId?: InputMaybe<Scalars['Float']>;
  trackingOrderState?: InputMaybe<EnumOrder2TrackingOrderState>;
  trackingReturnState?: InputMaybe<EnumOrder2TrackingReturnState>;
  updatedAt?: InputMaybe<Scalars['Date']>;
  updatedBy?: InputMaybe<FilterCountObjectPatchesUpdatedByInput>;
  /** Timestamp of the latest orderline that has been updated */
  updatedLineTs?: InputMaybe<Scalars['Date']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterCountOrder2OperatorsInput = {
  _id?: InputMaybe<FilterCountOrder2_IdOperatorsInput>;
  brandHouseId?: InputMaybe<FilterCountOrder2BrandHouseIdOperatorsInput>;
  fulState?: InputMaybe<FilterCountOrder2FulStateOperatorsInput>;
  orderDate?: InputMaybe<FilterCountOrder2OrderDateOperatorsInput>;
  orderName?: InputMaybe<FilterCountOrder2OrderNameOperatorsInput>;
  orderState?: InputMaybe<FilterCountOrder2OrderStateOperatorsInput>;
  payState?: InputMaybe<FilterCountOrder2PayStateOperatorsInput>;
  proforma?: InputMaybe<FilterCountOrder2ProformaOperatorsInput>;
  shopId?: InputMaybe<FilterCountOrder2ShopIdOperatorsInput>;
  silenced?: InputMaybe<FilterCountOrder2SilencedOperatorsInput>;
  splitOrder?: InputMaybe<FilterCountOrder2SplitOrderOperatorsInput>;
  trackingOrderState?: InputMaybe<FilterCountOrder2TrackingOrderStateOperatorsInput>;
  trackingReturnState?: InputMaybe<FilterCountOrder2TrackingReturnStateOperatorsInput>;
  updatedLineTs?: InputMaybe<FilterCountOrder2UpdatedLineTsOperatorsInput>;
};

export type FilterCountOrder2OrderDateOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Date']>;
  gte?: InputMaybe<Scalars['Date']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  lt?: InputMaybe<Scalars['Date']>;
  lte?: InputMaybe<Scalars['Date']>;
  ne?: InputMaybe<Scalars['Date']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
};

export type FilterCountOrder2OrderNameOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterCountOrder2OrderStateOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<EnumOrder2OrderState>;
  gte?: InputMaybe<EnumOrder2OrderState>;
  in?: InputMaybe<Array<InputMaybe<EnumOrder2OrderState>>>;
  lt?: InputMaybe<EnumOrder2OrderState>;
  lte?: InputMaybe<EnumOrder2OrderState>;
  ne?: InputMaybe<EnumOrder2OrderState>;
  nin?: InputMaybe<Array<InputMaybe<EnumOrder2OrderState>>>;
};

export type FilterCountOrder2PayStateOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<EnumOrder2PayState>;
  gte?: InputMaybe<EnumOrder2PayState>;
  in?: InputMaybe<Array<InputMaybe<EnumOrder2PayState>>>;
  lt?: InputMaybe<EnumOrder2PayState>;
  lte?: InputMaybe<EnumOrder2PayState>;
  ne?: InputMaybe<EnumOrder2PayState>;
  nin?: InputMaybe<Array<InputMaybe<EnumOrder2PayState>>>;
};

export type FilterCountOrder2ProformaOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Boolean']>;
  gte?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  lt?: InputMaybe<Scalars['Boolean']>;
  lte?: InputMaybe<Scalars['Boolean']>;
  ne?: InputMaybe<Scalars['Boolean']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
};

export type FilterCountOrder2ReturnInfoInput = {
  carrier?: InputMaybe<EnumOrder2ReturnInfoCarrier>;
  number?: InputMaybe<Scalars['String']>;
};

export type FilterCountOrder2ShippingAddressInput = {
  _id?: InputMaybe<Scalars['MongoID']>;
  add1?: InputMaybe<Scalars['String']>;
  add2?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  company?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  countryCode?: InputMaybe<Scalars['String']>;
  mail?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  zipCode?: InputMaybe<Scalars['String']>;
};

export type FilterCountOrder2ShopIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterCountOrder2SilencedOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Boolean']>;
  gte?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  lt?: InputMaybe<Scalars['Boolean']>;
  lte?: InputMaybe<Scalars['Boolean']>;
  ne?: InputMaybe<Scalars['Boolean']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
};

export type FilterCountOrder2SplitOrderOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Boolean']>;
  gte?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  lt?: InputMaybe<Scalars['Boolean']>;
  lte?: InputMaybe<Scalars['Boolean']>;
  ne?: InputMaybe<Scalars['Boolean']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
};

export type FilterCountOrder2TrackingInfoInput = {
  carrier?: InputMaybe<EnumOrder2TrackingInfoCarrier>;
  number?: InputMaybe<Scalars['String']>;
};

export type FilterCountOrder2TrackingOrderStateOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<EnumOrder2TrackingOrderState>;
  gte?: InputMaybe<EnumOrder2TrackingOrderState>;
  in?: InputMaybe<Array<InputMaybe<EnumOrder2TrackingOrderState>>>;
  lt?: InputMaybe<EnumOrder2TrackingOrderState>;
  lte?: InputMaybe<EnumOrder2TrackingOrderState>;
  ne?: InputMaybe<EnumOrder2TrackingOrderState>;
  nin?: InputMaybe<Array<InputMaybe<EnumOrder2TrackingOrderState>>>;
};

export type FilterCountOrder2TrackingReturnStateOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<EnumOrder2TrackingReturnState>;
  gte?: InputMaybe<EnumOrder2TrackingReturnState>;
  in?: InputMaybe<Array<InputMaybe<EnumOrder2TrackingReturnState>>>;
  lt?: InputMaybe<EnumOrder2TrackingReturnState>;
  lte?: InputMaybe<EnumOrder2TrackingReturnState>;
  ne?: InputMaybe<EnumOrder2TrackingReturnState>;
  nin?: InputMaybe<Array<InputMaybe<EnumOrder2TrackingReturnState>>>;
};

export type FilterCountOrder2UpdatedLineTsOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Date']>;
  gte?: InputMaybe<Scalars['Date']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  lt?: InputMaybe<Scalars['Date']>;
  lte?: InputMaybe<Scalars['Date']>;
  ne?: InputMaybe<Scalars['Date']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
};

export type FilterCountOrder2_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterCountPricingInput = {
  /** The ISO currency code */
  currency: Scalars['String'];
  /** The pricing value */
  value: Scalars['Float'];
};

export type FilterCountStockItemColorOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterCountStockItemCreatedAtOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Date']>;
  gte?: InputMaybe<Scalars['Date']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  lt?: InputMaybe<Scalars['Date']>;
  lte?: InputMaybe<Scalars['Date']>;
  ne?: InputMaybe<Scalars['Date']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
};

export type FilterCountStockItemEanOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterCountStockItemInput = {
  AND?: InputMaybe<Array<FilterCountStockItemInput>>;
  OR?: InputMaybe<Array<FilterCountStockItemInput>>;
  _id?: InputMaybe<Scalars['MongoID']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountStockItemOperatorsInput>;
  active?: InputMaybe<Scalars['Boolean']>;
  beforePrice?: InputMaybe<Scalars['Float']>;
  beforePrices?: InputMaybe<Array<InputMaybe<FilterCountPricingInput>>>;
  /** This is the branditem that is the parent for this shop / stockitem */
  brandItemId?: InputMaybe<Scalars['MongoID']>;
  /** This item has been confirmed at the logisticspartner at the given date */
  checked?: InputMaybe<Scalars['Date']>;
  color?: InputMaybe<Scalars['String']>;
  colorLocalized?: InputMaybe<Array<InputMaybe<FilterCountLocalizationEntryInput>>>;
  /** The tariff code for use in customs declarations. */
  commodityCode?: InputMaybe<Scalars['String']>;
  /** The condition of the item 1-3 */
  condition?: InputMaybe<Scalars['Float']>;
  /** The ISO 3166-1 alpha-2 country code of origin. */
  countryOrigin?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['Date']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  description?: InputMaybe<Scalars['String']>;
  descriptionLocalized?: InputMaybe<Array<InputMaybe<FilterCountLocalizationEntryInput>>>;
  draft?: InputMaybe<Scalars['Boolean']>;
  ean?: InputMaybe<Scalars['String']>;
  ecommerceId?: InputMaybe<Scalars['String']>;
  externId?: InputMaybe<Scalars['String']>;
  hasErrors?: InputMaybe<Scalars['Boolean']>;
  hasProblems?: InputMaybe<Scalars['Boolean']>;
  imageIds?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  isSold?: InputMaybe<Scalars['Boolean']>;
  itemNr?: InputMaybe<Scalars['Float']>;
  itemSku?: InputMaybe<Scalars['String']>;
  /** This item is registered missing by the logisticspartner at the given date */
  missing?: InputMaybe<Scalars['Date']>;
  note?: InputMaybe<Scalars['String']>;
  originalEan?: InputMaybe<Scalars['String']>;
  problems?: InputMaybe<Array<InputMaybe<FilterCountStockItemProblemsInput>>>;
  productType?: InputMaybe<Scalars['String']>;
  /** This is the master data product variant that this stockitem is connected to */
  productVariantId?: InputMaybe<Scalars['MongoID']>;
  /** This is the master data product variant size that this stockitem is connected to */
  productVariantSizeId?: InputMaybe<Scalars['MongoID']>;
  published?: InputMaybe<Scalars['Boolean']>;
  review?: InputMaybe<Scalars['Boolean']>;
  reviewed?: InputMaybe<Scalars['Date']>;
  sellingPrice?: InputMaybe<Scalars['Float']>;
  sellingPrices?: InputMaybe<Array<InputMaybe<FilterCountPricingInput>>>;
  shopId?: InputMaybe<Scalars['MongoID']>;
  size?: InputMaybe<Scalars['String']>;
  sku?: InputMaybe<Scalars['String']>;
  /** The sortorder of the stockitem */
  sortorder?: InputMaybe<Scalars['Float']>;
  source?: InputMaybe<Scalars['String']>;
  /** The type of source this stockitem is from */
  sourceType?: InputMaybe<EnumStockItemSourceType>;
  stockLocation?: InputMaybe<Scalars['String']>;
  stockLocationBag?: InputMaybe<Scalars['String']>;
  stockLocationTs?: InputMaybe<Scalars['Date']>;
  /** The url to the product in the shop */
  storeFrontUrl?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  titleLocalized?: InputMaybe<Array<InputMaybe<FilterCountLocalizationEntryInput>>>;
  tradeInItemId?: InputMaybe<Scalars['MongoID']>;
  updatedAt?: InputMaybe<Scalars['Date']>;
  updatedBy?: InputMaybe<FilterCountObjectPatchesUpdatedByInput>;
  vendor?: InputMaybe<Scalars['String']>;
};

export type FilterCountStockItemItemNrOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  ne?: InputMaybe<Scalars['Float']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

export type FilterCountStockItemItemSkuOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterCountStockItemMissingOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Date']>;
  gte?: InputMaybe<Scalars['Date']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  lt?: InputMaybe<Scalars['Date']>;
  lte?: InputMaybe<Scalars['Date']>;
  ne?: InputMaybe<Scalars['Date']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterCountStockItemOperatorsInput = {
  _id?: InputMaybe<FilterCountStockItem_IdOperatorsInput>;
  color?: InputMaybe<FilterCountStockItemColorOperatorsInput>;
  createdAt?: InputMaybe<FilterCountStockItemCreatedAtOperatorsInput>;
  ean?: InputMaybe<FilterCountStockItemEanOperatorsInput>;
  itemNr?: InputMaybe<FilterCountStockItemItemNrOperatorsInput>;
  itemSku?: InputMaybe<FilterCountStockItemItemSkuOperatorsInput>;
  missing?: InputMaybe<FilterCountStockItemMissingOperatorsInput>;
  originalEan?: InputMaybe<FilterCountStockItemOriginalEanOperatorsInput>;
  reviewed?: InputMaybe<FilterCountStockItemReviewedOperatorsInput>;
  size?: InputMaybe<FilterCountStockItemSizeOperatorsInput>;
  sourceType?: InputMaybe<FilterCountStockItemSourceTypeOperatorsInput>;
  stockLocation?: InputMaybe<FilterCountStockItemStockLocationOperatorsInput>;
  stockLocationTs?: InputMaybe<FilterCountStockItemStockLocationTsOperatorsInput>;
  title?: InputMaybe<FilterCountStockItemTitleOperatorsInput>;
  updatedAt?: InputMaybe<FilterCountStockItemUpdatedAtOperatorsInput>;
};

export type FilterCountStockItemOriginalEanOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterCountStockItemProblemsInput = {
  _id?: InputMaybe<Scalars['MongoID']>;
  createdAt?: InputMaybe<Scalars['Date']>;
  description?: InputMaybe<Scalars['String']>;
  solved?: InputMaybe<Scalars['Boolean']>;
};

export type FilterCountStockItemReviewedOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Date']>;
  gte?: InputMaybe<Scalars['Date']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  lt?: InputMaybe<Scalars['Date']>;
  lte?: InputMaybe<Scalars['Date']>;
  ne?: InputMaybe<Scalars['Date']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
};

export type FilterCountStockItemSizeOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterCountStockItemSourceTypeOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<EnumStockItemSourceType>;
  gte?: InputMaybe<EnumStockItemSourceType>;
  in?: InputMaybe<Array<InputMaybe<EnumStockItemSourceType>>>;
  lt?: InputMaybe<EnumStockItemSourceType>;
  lte?: InputMaybe<EnumStockItemSourceType>;
  ne?: InputMaybe<EnumStockItemSourceType>;
  nin?: InputMaybe<Array<InputMaybe<EnumStockItemSourceType>>>;
};

export type FilterCountStockItemStockLocationOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterCountStockItemStockLocationTsOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Date']>;
  gte?: InputMaybe<Scalars['Date']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  lt?: InputMaybe<Scalars['Date']>;
  lte?: InputMaybe<Scalars['Date']>;
  ne?: InputMaybe<Scalars['Date']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
};

export type FilterCountStockItemTitleOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterCountStockItemUpdatedAtOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Date']>;
  gte?: InputMaybe<Scalars['Date']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  lt?: InputMaybe<Scalars['Date']>;
  lte?: InputMaybe<Scalars['Date']>;
  ne?: InputMaybe<Scalars['Date']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
};

export type FilterCountStockItem_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyAddressInfoInput = {
  add1?: InputMaybe<Scalars['String']>;
  add2?: InputMaybe<Scalars['String']>;
  attention?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  countryCode?: InputMaybe<Scalars['String']>;
  mail?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  /** Optionally the address can come from a referenced object that has address info */
  refId?: InputMaybe<Scalars['MongoID']>;
  /** The referenced object type, Shop, BrandHouse, LogisticsPartner */
  refType?: InputMaybe<EnumAddressInfoRefType>;
  zipCode?: InputMaybe<Scalars['String']>;
};

export type FilterFindManyBrandHouseDeactivatedOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Boolean']>;
  gte?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  lt?: InputMaybe<Scalars['Boolean']>;
  lte?: InputMaybe<Scalars['Boolean']>;
  ne?: InputMaybe<Scalars['Boolean']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
};

export type FilterFindManyBrandHouseInitialsOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyBrandHouseInput = {
  AND?: InputMaybe<Array<FilterFindManyBrandHouseInput>>;
  OR?: InputMaybe<Array<FilterFindManyBrandHouseInput>>;
  _id?: InputMaybe<Scalars['MongoID']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyBrandHouseOperatorsInput>;
  address?: InputMaybe<FilterFindManyAddressInfoInput>;
  apiKey?: InputMaybe<Scalars['String']>;
  apiSecret?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['Date']>;
  /** Brandhouse has been deactivated */
  deactivated?: InputMaybe<Scalars['Boolean']>;
  initials?: InputMaybe<Scalars['String']>;
  license?: InputMaybe<Scalars['String']>;
  logisticsPartnerId?: InputMaybe<Scalars['MongoID']>;
  name?: InputMaybe<Scalars['String']>;
  /** When true, all configuration changes require an audit note with explanation */
  requireChangeExplanation?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['Date']>;
  updatedBy?: InputMaybe<FilterFindManyObjectPatchesUpdatedByInput>;
};

export type FilterFindManyBrandHouseNameOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyBrandHouseOperatorsInput = {
  _id?: InputMaybe<FilterFindManyBrandHouse_IdOperatorsInput>;
  deactivated?: InputMaybe<FilterFindManyBrandHouseDeactivatedOperatorsInput>;
  initials?: InputMaybe<FilterFindManyBrandHouseInitialsOperatorsInput>;
  name?: InputMaybe<FilterFindManyBrandHouseNameOperatorsInput>;
};

export type FilterFindManyBrandHouse_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyBrandItemAttributesApparentFabricTypeOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<EnumBrandItemAttributesApparentFabricType>;
  gte?: InputMaybe<EnumBrandItemAttributesApparentFabricType>;
  in?: InputMaybe<Array<InputMaybe<EnumBrandItemAttributesApparentFabricType>>>;
  lt?: InputMaybe<EnumBrandItemAttributesApparentFabricType>;
  lte?: InputMaybe<EnumBrandItemAttributesApparentFabricType>;
  ne?: InputMaybe<EnumBrandItemAttributesApparentFabricType>;
  nin?: InputMaybe<Array<InputMaybe<EnumBrandItemAttributesApparentFabricType>>>;
};

export type FilterFindManyBrandItemAttributesFormalityLevelOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<EnumBrandItemAttributesFormalityLevel>;
  gte?: InputMaybe<EnumBrandItemAttributesFormalityLevel>;
  in?: InputMaybe<Array<InputMaybe<EnumBrandItemAttributesFormalityLevel>>>;
  lt?: InputMaybe<EnumBrandItemAttributesFormalityLevel>;
  lte?: InputMaybe<EnumBrandItemAttributesFormalityLevel>;
  ne?: InputMaybe<EnumBrandItemAttributesFormalityLevel>;
  nin?: InputMaybe<Array<InputMaybe<EnumBrandItemAttributesFormalityLevel>>>;
};

export type FilterFindManyBrandItemAttributesInput = {
  apparentFabricType?: InputMaybe<EnumBrandItemAttributesApparentFabricType>;
  confidence?: InputMaybe<Scalars['Float']>;
  dataProblem?: InputMaybe<Scalars['String']>;
  dateScanned?: InputMaybe<Scalars['Date']>;
  formalityLevel?: InputMaybe<EnumBrandItemAttributesFormalityLevel>;
  graphicKeywords?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  neckline?: InputMaybe<EnumBrandItemAttributesNeckline>;
  notableFeatures?: InputMaybe<Array<InputMaybe<EnumBrandItemAttributesNotableFeatures>>>;
  pattern?: InputMaybe<EnumBrandItemAttributesPattern>;
  primaryColor?: InputMaybe<EnumBrandItemAttributesPrimaryColor>;
  seasonSuitability?: InputMaybe<Array<InputMaybe<EnumBrandItemAttributesSeasonSuitability>>>;
  secondaryColors?: InputMaybe<Array<InputMaybe<EnumBrandItemAttributesSecondaryColors>>>;
  size?: InputMaybe<Scalars['String']>;
  subType?: InputMaybe<EnumBrandItemAttributesSubType>;
  textureAppearance?: InputMaybe<EnumBrandItemAttributesTextureAppearance>;
  type?: InputMaybe<EnumBrandItemAttributesType>;
};

export type FilterFindManyBrandItemAttributesOperatorsInput = {
  apparentFabricType?: InputMaybe<FilterFindManyBrandItemAttributesApparentFabricTypeOperatorsInput>;
  formalityLevel?: InputMaybe<FilterFindManyBrandItemAttributesFormalityLevelOperatorsInput>;
  pattern?: InputMaybe<FilterFindManyBrandItemAttributesPatternOperatorsInput>;
  primaryColor?: InputMaybe<FilterFindManyBrandItemAttributesPrimaryColorOperatorsInput>;
  seasonSuitability?: InputMaybe<FilterFindManyBrandItemAttributesSeasonSuitabilityOperatorsInput>;
  type?: InputMaybe<FilterFindManyBrandItemAttributesTypeOperatorsInput>;
};

export type FilterFindManyBrandItemAttributesPatternOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<EnumBrandItemAttributesPattern>;
  gte?: InputMaybe<EnumBrandItemAttributesPattern>;
  in?: InputMaybe<Array<InputMaybe<EnumBrandItemAttributesPattern>>>;
  lt?: InputMaybe<EnumBrandItemAttributesPattern>;
  lte?: InputMaybe<EnumBrandItemAttributesPattern>;
  ne?: InputMaybe<EnumBrandItemAttributesPattern>;
  nin?: InputMaybe<Array<InputMaybe<EnumBrandItemAttributesPattern>>>;
};

export type FilterFindManyBrandItemAttributesPrimaryColorOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<EnumBrandItemAttributesPrimaryColor>;
  gte?: InputMaybe<EnumBrandItemAttributesPrimaryColor>;
  in?: InputMaybe<Array<InputMaybe<EnumBrandItemAttributesPrimaryColor>>>;
  lt?: InputMaybe<EnumBrandItemAttributesPrimaryColor>;
  lte?: InputMaybe<EnumBrandItemAttributesPrimaryColor>;
  ne?: InputMaybe<EnumBrandItemAttributesPrimaryColor>;
  nin?: InputMaybe<Array<InputMaybe<EnumBrandItemAttributesPrimaryColor>>>;
};

export type FilterFindManyBrandItemAttributesSeasonSuitabilityOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<EnumBrandItemAttributesSeasonSuitability>;
  gte?: InputMaybe<EnumBrandItemAttributesSeasonSuitability>;
  in?: InputMaybe<Array<InputMaybe<EnumBrandItemAttributesSeasonSuitability>>>;
  lt?: InputMaybe<EnumBrandItemAttributesSeasonSuitability>;
  lte?: InputMaybe<EnumBrandItemAttributesSeasonSuitability>;
  ne?: InputMaybe<EnumBrandItemAttributesSeasonSuitability>;
  nin?: InputMaybe<Array<InputMaybe<EnumBrandItemAttributesSeasonSuitability>>>;
};

export type FilterFindManyBrandItemAttributesTypeOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<EnumBrandItemAttributesType>;
  gte?: InputMaybe<EnumBrandItemAttributesType>;
  in?: InputMaybe<Array<InputMaybe<EnumBrandItemAttributesType>>>;
  lt?: InputMaybe<EnumBrandItemAttributesType>;
  lte?: InputMaybe<EnumBrandItemAttributesType>;
  ne?: InputMaybe<EnumBrandItemAttributesType>;
  nin?: InputMaybe<Array<InputMaybe<EnumBrandItemAttributesType>>>;
};

export type FilterFindManyBrandItemBrandHouseIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyBrandItemCreatedAtOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Date']>;
  gte?: InputMaybe<Scalars['Date']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  lt?: InputMaybe<Scalars['Date']>;
  lte?: InputMaybe<Scalars['Date']>;
  ne?: InputMaybe<Scalars['Date']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
};

export type FilterFindManyBrandItemDaysOfflineOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  ne?: InputMaybe<Scalars['Float']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

export type FilterFindManyBrandItemDiscardedOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Date']>;
  gte?: InputMaybe<Scalars['Date']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  lt?: InputMaybe<Scalars['Date']>;
  lte?: InputMaybe<Scalars['Date']>;
  ne?: InputMaybe<Scalars['Date']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
};

export type FilterFindManyBrandItemFirstListedDateOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Date']>;
  gte?: InputMaybe<Scalars['Date']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  lt?: InputMaybe<Scalars['Date']>;
  lte?: InputMaybe<Scalars['Date']>;
  ne?: InputMaybe<Scalars['Date']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
};

export type FilterFindManyBrandItemHasCommentOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Boolean']>;
  gte?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  lt?: InputMaybe<Scalars['Boolean']>;
  lte?: InputMaybe<Scalars['Boolean']>;
  ne?: InputMaybe<Scalars['Boolean']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
};

export type FilterFindManyBrandItemHasCustomImagesOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Boolean']>;
  gte?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  lt?: InputMaybe<Scalars['Boolean']>;
  lte?: InputMaybe<Scalars['Boolean']>;
  ne?: InputMaybe<Scalars['Boolean']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
};

export type FilterFindManyBrandItemHasLocationOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Boolean']>;
  gte?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  lt?: InputMaybe<Scalars['Boolean']>;
  lte?: InputMaybe<Scalars['Boolean']>;
  ne?: InputMaybe<Scalars['Boolean']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
};

export type FilterFindManyBrandItemHasTranslatedCommentOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Boolean']>;
  gte?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  lt?: InputMaybe<Scalars['Boolean']>;
  lte?: InputMaybe<Scalars['Boolean']>;
  ne?: InputMaybe<Scalars['Boolean']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
};

export type FilterFindManyBrandItemInput = {
  AND?: InputMaybe<Array<FilterFindManyBrandItemInput>>;
  OR?: InputMaybe<Array<FilterFindManyBrandItemInput>>;
  _id?: InputMaybe<Scalars['MongoID']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyBrandItemOperatorsInput>;
  /** Attributes of the clothing item */
  attributes?: InputMaybe<FilterFindManyBrandItemAttributesInput>;
  beforePrices?: InputMaybe<Array<InputMaybe<FilterFindManyPricingInput>>>;
  brandHouseId?: InputMaybe<Scalars['MongoID']>;
  /** The master data variant/size */
  brandProductSizeId?: InputMaybe<Scalars['MongoID']>;
  /** The master data variant */
  brandProductVariantId?: InputMaybe<Scalars['MongoID']>;
  /** This item has been confirmed at the logisticspartner at the given date */
  checked?: InputMaybe<Scalars['Date']>;
  /** Localized color of the item */
  colorLocalized?: InputMaybe<Array<InputMaybe<FilterFindManyLocalizationEntryInput>>>;
  /** True if the comment has been approved */
  commentApproved?: InputMaybe<Scalars['Boolean']>;
  /** Previous owner comments for the item, localized */
  commentLocalized?: InputMaybe<Array<InputMaybe<FilterFindManyLocalizationEntryInput>>>;
  /** The commodityCode of this brand item */
  commodityCode?: InputMaybe<Scalars['String']>;
  /** Condition of the item, between 1 and 3 */
  condition?: InputMaybe<Scalars['Float']>;
  /** The countryOrigin of this brand item */
  countryOrigin?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['Date']>;
  /** Total days this item has been offline since firstListedDate */
  daysOffline?: InputMaybe<Scalars['Float']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  /** Localized description of the item */
  descriptionLocalized?: InputMaybe<Array<InputMaybe<FilterFindManyLocalizationEntryInput>>>;
  directPrices?: InputMaybe<Array<InputMaybe<FilterFindManyPricingInput>>>;
  /** If true, the RRP list price is disabled */
  disableRRPListPrice?: InputMaybe<Scalars['Boolean']>;
  /** The date this item was discarded by the owner - a discarded item is not for sale */
  discarded?: InputMaybe<Scalars['Date']>;
  externalId?: InputMaybe<Scalars['String']>;
  /** The date when this item was first listed for sale (never recalculated) */
  firstListedDate?: InputMaybe<Scalars['Date']>;
  /** Cached key of the group of interchangeable items this item belongs to, set by the integrity event */
  groupKey?: InputMaybe<Scalars['String']>;
  hasComment?: InputMaybe<Scalars['Boolean']>;
  hasCustomImages?: InputMaybe<Scalars['Boolean']>;
  hasErrors?: InputMaybe<Scalars['Boolean']>;
  hasLocation?: InputMaybe<Scalars['Boolean']>;
  hasMasterData?: InputMaybe<Scalars['Boolean']>;
  hasProblems?: InputMaybe<Scalars['Boolean']>;
  hasTranslatedComment?: InputMaybe<Scalars['Boolean']>;
  /** 512-dimensional embedding vector for the primary image */
  imageEmbedding?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  /** If true, the manufacturer is invalid */
  invalidManufacturer?: InputMaybe<Scalars['Boolean']>;
  isSold?: InputMaybe<Scalars['Boolean']>;
  isTradeIn?: InputMaybe<Scalars['Boolean']>;
  /** Internal EAN number for this brand-item */
  itemEan?: InputMaybe<Scalars['String']>;
  /** Extra data about the brand item */
  itemMetas?: InputMaybe<Array<InputMaybe<FilterFindManyMetaFieldInstanceInput>>>;
  /** The itemNr is a unique number for each branditem in context of the brandhouse */
  itemNr?: InputMaybe<Scalars['Float']>;
  /** State of the branditem */
  itemState?: InputMaybe<EnumBrandItemItemState>;
  /** Tags for the brand item */
  itemTags?: InputMaybe<Array<InputMaybe<FilterFindManyBrandItemTagInput>>>;
  masterDataInfo?: InputMaybe<FilterFindManyBrandItemMasterDataInfoInput>;
  /** Localized MAS masterdata metafields used as the source for item metafield resolution */
  masterDataLocalizedMetafields?: InputMaybe<Array<InputMaybe<FilterFindManyLocalizedMetaFieldInstanceInput>>>;
  /** MAS masterdata metafields used as the source for item metafield resolution */
  masterDataMetafields?: InputMaybe<Array<InputMaybe<FilterFindManyMetaFieldInput>>>;
  /** When MAS masterdata was last pulled into this item */
  masterDataPulledAt?: InputMaybe<Scalars['Date']>;
  masterDataSnapshot?: InputMaybe<FilterFindManyBrandItemMasterDataSnapshotInput>;
  /** The external MAS masterdata variant id */
  masterDataVariantId?: InputMaybe<Scalars['String']>;
  /** This item is registered missing by the logisticspartner at the given date */
  missing?: InputMaybe<Scalars['Date']>;
  /** Localized name of the item */
  nameLocalized?: InputMaybe<Array<InputMaybe<FilterFindManyLocalizationEntryInput>>>;
  note?: InputMaybe<Scalars['String']>;
  /** The options of this branditem */
  options?: InputMaybe<Array<InputMaybe<FilterFindManyOptionInstanceInput>>>;
  /** The originalEan of this brand item */
  originalEan?: InputMaybe<Scalars['String']>;
  /** The originalSku of this brand item */
  originalSku?: InputMaybe<Scalars['String']>;
  problems?: InputMaybe<Array<InputMaybe<FilterFindManyBrandItemProblemInput>>>;
  /** Cached, true while an older item in the same group is for sale and this one waits its turn */
  queued?: InputMaybe<Scalars['Boolean']>;
  reviewInfos?: InputMaybe<Array<InputMaybe<FilterFindManyBrandItemReviewInfoInput>>>;
  /** Cached, true when the item would be for sale on its own: ready and active in a shop, located, unsold and free of blockers */
  saleable?: InputMaybe<Scalars['Boolean']>;
  /** Score indicating how sellable the item is (0-100) */
  salesScore?: InputMaybe<Scalars['Float']>;
  /** Timestamp when the sales score was last calculated */
  salesScoreTs?: InputMaybe<Scalars['Date']>;
  /** Localized size of the item */
  sizeLocalized?: InputMaybe<Array<InputMaybe<FilterFindManyLocalizationEntryInput>>>;
  /** The date this item was sold */
  soldTs?: InputMaybe<Scalars['Date']>;
  /** The sortorder of this branditem */
  sortorder?: InputMaybe<Scalars['Float']>;
  /** The type of source this branditem is from */
  sourceType?: InputMaybe<EnumBrandItemSourceType>;
  stockLocation?: InputMaybe<Scalars['String']>;
  /** The barcode of the bag that the item is placed in at the stock location */
  stockLocationBag?: InputMaybe<Scalars['String']>;
  stockLocationTs?: InputMaybe<Scalars['Date']>;
  /** True if this item is a test item */
  test?: InputMaybe<Scalars['Boolean']>;
  /** Link to the tradein item, if applicable */
  tradeInItemId?: InputMaybe<Scalars['MongoID']>;
  /** The product type of this brand item */
  typeLocalized?: InputMaybe<Array<InputMaybe<FilterFindManyLocalizationEntryInput>>>;
  /** This item is registered out of warehouse by the logisticspartner at the given date */
  unavailable?: InputMaybe<Scalars['Date']>;
  updatedAt?: InputMaybe<Scalars['Date']>;
  updatedBy?: InputMaybe<FilterFindManyObjectPatchesUpdatedByInput>;
  vasId?: InputMaybe<Scalars['String']>;
  /** Image references received from VAS for this item */
  vasImages?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** The current state of the VAS process for this item */
  vasState?: InputMaybe<EnumBrandItemVasState>;
  /** The VAS contract version for this item */
  vasType?: InputMaybe<EnumBrandItemVasType>;
  /** The vendor type of this brand item */
  vendor?: InputMaybe<Scalars['String']>;
  /** Total page views for this item across all shops */
  views?: InputMaybe<Scalars['Float']>;
  /** Total unique visitors for this item across all shops */
  visitors?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyBrandItemInvalidManufacturerOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Boolean']>;
  gte?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  lt?: InputMaybe<Scalars['Boolean']>;
  lte?: InputMaybe<Scalars['Boolean']>;
  ne?: InputMaybe<Scalars['Boolean']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
};

export type FilterFindManyBrandItemIsTradeInOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Boolean']>;
  gte?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  lt?: InputMaybe<Scalars['Boolean']>;
  lte?: InputMaybe<Scalars['Boolean']>;
  ne?: InputMaybe<Scalars['Boolean']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
};

export type FilterFindManyBrandItemLayawayBrandItemIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyBrandItemLayawayCreatedAtOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Date']>;
  gte?: InputMaybe<Scalars['Date']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  lt?: InputMaybe<Scalars['Date']>;
  lte?: InputMaybe<Scalars['Date']>;
  ne?: InputMaybe<Scalars['Date']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
};

export type FilterFindManyBrandItemLayawayInput = {
  AND?: InputMaybe<Array<FilterFindManyBrandItemLayawayInput>>;
  OR?: InputMaybe<Array<FilterFindManyBrandItemLayawayInput>>;
  _id?: InputMaybe<Scalars['MongoID']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyBrandItemLayawayOperatorsInput>;
  /** Reference to the BrandItem */
  brandItemId?: InputMaybe<Scalars['MongoID']>;
  createdAt?: InputMaybe<Scalars['Date']>;
  /** Stock location of the item */
  stockLocation?: InputMaybe<Scalars['String']>;
  /** Stock location bag of the item */
  stockLocationBag?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Date']>;
  /** Who made this location change */
  updatedBy?: InputMaybe<FilterFindManyObjectPatchesUpdatedByInput>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyBrandItemLayawayOperatorsInput = {
  _id?: InputMaybe<FilterFindManyBrandItemLayaway_IdOperatorsInput>;
  brandItemId?: InputMaybe<FilterFindManyBrandItemLayawayBrandItemIdOperatorsInput>;
  createdAt?: InputMaybe<FilterFindManyBrandItemLayawayCreatedAtOperatorsInput>;
  updatedBy?: InputMaybe<FilterFindManyBrandItemLayawayUpdatedByOperatorsInput>;
};

export type FilterFindManyBrandItemLayawayUpdatedByOperatorsInput = {
  ref?: InputMaybe<FilterFindManyBrandItemLayawayUpdatedByRefOperatorsInput>;
};

export type FilterFindManyBrandItemLayawayUpdatedByRefOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyBrandItemLayaway_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyBrandItemMasterDataInfoInput = {
  /** Color pf product */
  color?: InputMaybe<Scalars['String']>;
  /** Master data ean */
  ean?: InputMaybe<Scalars['String']>;
  /** External ID */
  externalId?: InputMaybe<Scalars['String']>;
  /** Name of product */
  name?: InputMaybe<Scalars['String']>;
  /** Size of product */
  size?: InputMaybe<Scalars['String']>;
  /** Master data sku */
  sku?: InputMaybe<Scalars['String']>;
};

export type FilterFindManyBrandItemMasterDataSnapshotInput = {
  /** Source BrandProduct at time of snapshot */
  brandProductId?: InputMaybe<Scalars['MongoID']>;
  /** Source BrandProductSize at time of snapshot */
  brandProductSizeId?: InputMaybe<Scalars['MongoID']>;
  /** Source BrandProductVariant at time of snapshot */
  brandProductVariantId?: InputMaybe<Scalars['MongoID']>;
  /** Localized product metafields at time of snapshot */
  localizedMetaFields?: InputMaybe<Array<InputMaybe<FilterFindManyLocalizedMetaFieldInstanceInput>>>;
  /** Product metafields at time of snapshot */
  metaFields?: InputMaybe<Array<InputMaybe<FilterFindManyMetaFieldInput>>>;
  /** Size metafields at time of snapshot */
  sizeMetaFields?: InputMaybe<Array<InputMaybe<FilterFindManyMetaFieldInput>>>;
  /** When the snapshot was taken */
  snapshotTs?: InputMaybe<Scalars['Date']>;
  /** Product tags at time of snapshot */
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Variant weight at time of snapshot */
  weight?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyBrandItemMissingOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Date']>;
  gte?: InputMaybe<Scalars['Date']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  lt?: InputMaybe<Scalars['Date']>;
  lte?: InputMaybe<Scalars['Date']>;
  ne?: InputMaybe<Scalars['Date']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyBrandItemOperatorsInput = {
  _id?: InputMaybe<FilterFindManyBrandItem_IdOperatorsInput>;
  attributes?: InputMaybe<FilterFindManyBrandItemAttributesOperatorsInput>;
  brandHouseId?: InputMaybe<FilterFindManyBrandItemBrandHouseIdOperatorsInput>;
  createdAt?: InputMaybe<FilterFindManyBrandItemCreatedAtOperatorsInput>;
  daysOffline?: InputMaybe<FilterFindManyBrandItemDaysOfflineOperatorsInput>;
  discarded?: InputMaybe<FilterFindManyBrandItemDiscardedOperatorsInput>;
  firstListedDate?: InputMaybe<FilterFindManyBrandItemFirstListedDateOperatorsInput>;
  hasComment?: InputMaybe<FilterFindManyBrandItemHasCommentOperatorsInput>;
  hasCustomImages?: InputMaybe<FilterFindManyBrandItemHasCustomImagesOperatorsInput>;
  hasLocation?: InputMaybe<FilterFindManyBrandItemHasLocationOperatorsInput>;
  hasTranslatedComment?: InputMaybe<FilterFindManyBrandItemHasTranslatedCommentOperatorsInput>;
  invalidManufacturer?: InputMaybe<FilterFindManyBrandItemInvalidManufacturerOperatorsInput>;
  isTradeIn?: InputMaybe<FilterFindManyBrandItemIsTradeInOperatorsInput>;
  missing?: InputMaybe<FilterFindManyBrandItemMissingOperatorsInput>;
  salesScore?: InputMaybe<FilterFindManyBrandItemSalesScoreOperatorsInput>;
  soldTs?: InputMaybe<FilterFindManyBrandItemSoldTsOperatorsInput>;
  sourceType?: InputMaybe<FilterFindManyBrandItemSourceTypeOperatorsInput>;
  stockLocation?: InputMaybe<FilterFindManyBrandItemStockLocationOperatorsInput>;
  stockLocationBag?: InputMaybe<FilterFindManyBrandItemStockLocationBagOperatorsInput>;
  stockLocationTs?: InputMaybe<FilterFindManyBrandItemStockLocationTsOperatorsInput>;
  updatedAt?: InputMaybe<FilterFindManyBrandItemUpdatedAtOperatorsInput>;
  vasId?: InputMaybe<FilterFindManyBrandItemVasIdOperatorsInput>;
  vasState?: InputMaybe<FilterFindManyBrandItemVasStateOperatorsInput>;
};

export type FilterFindManyBrandItemProblemInput = {
  createdAt?: InputMaybe<Scalars['Date']>;
  description?: InputMaybe<Scalars['String']>;
  solved?: InputMaybe<Scalars['Boolean']>;
};

export type FilterFindManyBrandItemReviewInfoInput = {
  type?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

export type FilterFindManyBrandItemSalesScoreOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  ne?: InputMaybe<Scalars['Float']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

export type FilterFindManyBrandItemSoldTsOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Date']>;
  gte?: InputMaybe<Scalars['Date']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  lt?: InputMaybe<Scalars['Date']>;
  lte?: InputMaybe<Scalars['Date']>;
  ne?: InputMaybe<Scalars['Date']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
};

export type FilterFindManyBrandItemSourceTypeOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<EnumBrandItemSourceType>;
  gte?: InputMaybe<EnumBrandItemSourceType>;
  in?: InputMaybe<Array<InputMaybe<EnumBrandItemSourceType>>>;
  lt?: InputMaybe<EnumBrandItemSourceType>;
  lte?: InputMaybe<EnumBrandItemSourceType>;
  ne?: InputMaybe<EnumBrandItemSourceType>;
  nin?: InputMaybe<Array<InputMaybe<EnumBrandItemSourceType>>>;
};

export type FilterFindManyBrandItemStockLocationBagOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyBrandItemStockLocationOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyBrandItemStockLocationTsOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Date']>;
  gte?: InputMaybe<Scalars['Date']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  lt?: InputMaybe<Scalars['Date']>;
  lte?: InputMaybe<Scalars['Date']>;
  ne?: InputMaybe<Scalars['Date']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
};

export type FilterFindManyBrandItemTagInput = {
  auto?: InputMaybe<Scalars['Boolean']>;
  tag?: InputMaybe<Scalars['String']>;
};

export type FilterFindManyBrandItemUpdatedAtOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Date']>;
  gte?: InputMaybe<Scalars['Date']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  lt?: InputMaybe<Scalars['Date']>;
  lte?: InputMaybe<Scalars['Date']>;
  ne?: InputMaybe<Scalars['Date']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
};

export type FilterFindManyBrandItemVasIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyBrandItemVasStateOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<EnumBrandItemVasState>;
  gte?: InputMaybe<EnumBrandItemVasState>;
  in?: InputMaybe<Array<InputMaybe<EnumBrandItemVasState>>>;
  lt?: InputMaybe<EnumBrandItemVasState>;
  lte?: InputMaybe<EnumBrandItemVasState>;
  ne?: InputMaybe<EnumBrandItemVasState>;
  nin?: InputMaybe<Array<InputMaybe<EnumBrandItemVasState>>>;
};

export type FilterFindManyBrandItem_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyBrandProductBrandHouseIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyBrandProductGroupBrandHouseIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyBrandProductGroupInput = {
  AND?: InputMaybe<Array<FilterFindManyBrandProductGroupInput>>;
  OR?: InputMaybe<Array<FilterFindManyBrandProductGroupInput>>;
  _id?: InputMaybe<Scalars['MongoID']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyBrandProductGroupOperatorsInput>;
  /** Is the group active for everything */
  active?: InputMaybe<Scalars['Boolean']>;
  /** Is the group active for potential linking */
  activePotentials?: InputMaybe<Scalars['Boolean']>;
  /** Is the group active for promoting brand items */
  activePromotions?: InputMaybe<Scalars['Boolean']>;
  brandHouseId?: InputMaybe<Scalars['MongoID']>;
  /** The name of the group */
  name?: InputMaybe<Scalars['String']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyBrandProductGroupOperatorsInput = {
  _id?: InputMaybe<FilterFindManyBrandProductGroup_IdOperatorsInput>;
  brandHouseId?: InputMaybe<FilterFindManyBrandProductGroupBrandHouseIdOperatorsInput>;
};

export type FilterFindManyBrandProductGroup_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyBrandProductImageInput = {
  AND?: InputMaybe<Array<FilterFindManyBrandProductImageInput>>;
  OR?: InputMaybe<Array<FilterFindManyBrandProductImageInput>>;
  _id?: InputMaybe<Scalars['MongoID']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyBrandProductImageOperatorsInput>;
  archivedImage?: InputMaybe<Scalars['Boolean']>;
  archivedThumb?: InputMaybe<Scalars['Boolean']>;
  brandHouseId?: InputMaybe<Scalars['MongoID']>;
  /** The product that owns this image */
  brandProductId?: InputMaybe<Scalars['MongoID']>;
  /** The variant that owns this image */
  brandProductVariantId?: InputMaybe<Scalars['MongoID']>;
  /** Colors represented by this image */
  colors?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAt?: InputMaybe<Scalars['Date']>;
  /** Custom data for the image */
  customData?: InputMaybe<Scalars['JSON']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  error?: InputMaybe<Scalars['String']>;
  errorCount?: InputMaybe<Scalars['Float']>;
  /** An image unique external identifier */
  externalId?: InputMaybe<Scalars['String']>;
  /** The group that this product belongs to */
  groupId?: InputMaybe<Scalars['MongoID']>;
  imageAltText?: InputMaybe<Scalars['String']>;
  /** The storage ID of the file, will be null until the image is successfully stored */
  imageId?: InputMaybe<Scalars['MongoID']>;
  /** The md5 hash of the image, used to compare images */
  imageMd5?: InputMaybe<Scalars['String']>;
  /**
   * If the image was processed by us / background removal, then this contains the version of the processing
   * use this to determine if the background process needs to be redone
   */
  imageRemoveBgVersion?: InputMaybe<Scalars['Float']>;
  /** An optional language tag for the image */
  language?: InputMaybe<Scalars['String']>;
  lastUpdate?: InputMaybe<Scalars['Date']>;
  /** Extra data about the image, localized */
  localizedMetaFields?: InputMaybe<Array<InputMaybe<FilterFindManyLocalizedMetaFieldInstanceInput>>>;
  /** Extra data about the image */
  metaFields?: InputMaybe<Array<InputMaybe<FilterFindManyMetaFieldInput>>>;
  /** The storage ID of the original image file, typically the same as imageId - but if the imageId can be modified */
  originalId?: InputMaybe<Scalars['MongoID']>;
  /** The md5 hash of the original image, used to compare images */
  originalMd5?: InputMaybe<Scalars['String']>;
  perspective?: InputMaybe<EnumBrandProductImagePerspective>;
  sortOrder?: InputMaybe<Scalars['Float']>;
  sourceUrl?: InputMaybe<Scalars['String']>;
  /** The storage ID of the thumbnail file, will be null until the image is successfully stored */
  thumbnailId?: InputMaybe<Scalars['MongoID']>;
  type?: InputMaybe<EnumBrandProductImageType>;
  updatedAt?: InputMaybe<Scalars['Date']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyBrandProductImageOperatorsInput = {
  _id?: InputMaybe<FilterFindManyBrandProductImage_IdOperatorsInput>;
};

export type FilterFindManyBrandProductImage_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyBrandProductInput = {
  AND?: InputMaybe<Array<FilterFindManyBrandProductInput>>;
  OR?: InputMaybe<Array<FilterFindManyBrandProductInput>>;
  _id?: InputMaybe<Scalars['MongoID']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyBrandProductOperatorsInput>;
  /** The brand that owns this product */
  brandHouseId?: InputMaybe<Scalars['MongoID']>;
  /** Collections associated with this product */
  collections?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAt?: InputMaybe<Scalars['Date']>;
  /** Custom data for the product */
  customData?: InputMaybe<Scalars['JSON']>;
  /** True if this variant has been deleted */
  deleted?: InputMaybe<Scalars['Boolean']>;
  /** The product description */
  description?: InputMaybe<Scalars['String']>;
  /** The product description localized */
  descriptionLocalized?: InputMaybe<Array<InputMaybe<FilterFindManyLocalizationEntryInput>>>;
  /** Whether to disable the RRP list price */
  disableRRPListPrice?: InputMaybe<Scalars['Boolean']>;
  /** Whether this product is disabled and shouldn't be used in the platform at all */
  disabled?: InputMaybe<Scalars['Boolean']>;
  /** A product unique external identifier */
  externalId?: InputMaybe<Scalars['String']>;
  /** The group that this product belongs to */
  groupId?: InputMaybe<Scalars['MongoID']>;
  /** Extra data about the product, localized */
  localizedMetaFields?: InputMaybe<Array<InputMaybe<FilterFindManyLocalizedMetaFieldInstanceInput>>>;
  /** Extra data about the product */
  metaFields?: InputMaybe<Array<InputMaybe<FilterFindManyMetaFieldInput>>>;
  /** The same of the product */
  name?: InputMaybe<Scalars['String']>;
  /** The name of the product localized */
  nameLocalized?: InputMaybe<Array<InputMaybe<FilterFindManyLocalizationEntryInput>>>;
  /** Whether this product is a preowned product */
  preOwned?: InputMaybe<Scalars['Boolean']>;
  /** Source of the brandproduct, such as imported, shopify, salesforce etc */
  source?: InputMaybe<Scalars['String']>;
  /** The style number should optimally be a joining identifier for a number of variants. Internally this number is not used for this purpose though */
  style?: InputMaybe<Scalars['String']>;
  /** Tags associated with this product */
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** The type of product */
  type?: InputMaybe<Scalars['String']>;
  /** The product type, a translateable field */
  typeLocalized?: InputMaybe<Array<InputMaybe<FilterFindManyLocalizationEntryInput>>>;
  updatedAt?: InputMaybe<Scalars['Date']>;
  /** The latest user that updated this */
  updatedBy?: InputMaybe<FilterFindManyObjectPatchesUpdatedByInput>;
  /** The vendor of this product */
  vendor?: InputMaybe<Scalars['String']>;
  /** The weight of this item in grams */
  weight?: InputMaybe<Scalars['Float']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyBrandProductOperatorsInput = {
  _id?: InputMaybe<FilterFindManyBrandProduct_IdOperatorsInput>;
  brandHouseId?: InputMaybe<FilterFindManyBrandProductBrandHouseIdOperatorsInput>;
  style?: InputMaybe<FilterFindManyBrandProductStyleOperatorsInput>;
};

export type FilterFindManyBrandProductSizeBrandHouseIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyBrandProductSizeInput = {
  AND?: InputMaybe<Array<FilterFindManyBrandProductSizeInput>>;
  OR?: InputMaybe<Array<FilterFindManyBrandProductSizeInput>>;
  _id?: InputMaybe<Scalars['MongoID']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyBrandProductSizeOperatorsInput>;
  /** The brand that owns this variant */
  brandHouseId?: InputMaybe<Scalars['MongoID']>;
  brandProductId?: InputMaybe<Scalars['MongoID']>;
  /** The variant that owns this size */
  brandProductVariantId?: InputMaybe<Scalars['MongoID']>;
  createdAt?: InputMaybe<Scalars['Date']>;
  /** True if this product has been deleted */
  deleted?: InputMaybe<Scalars['Boolean']>;
  /** The EAN-13 of this variant */
  ean?: InputMaybe<Scalars['String']>;
  /** A variant unique external identifier */
  externalId?: InputMaybe<Scalars['String']>;
  /** The group that this product belongs to */
  groupId?: InputMaybe<Scalars['MongoID']>;
  /** Extra data about the size, localized */
  localizedMetaFields?: InputMaybe<Array<InputMaybe<FilterFindManyLocalizedMetaFieldInstanceInput>>>;
  /** Extra data about the variant */
  metaFields?: InputMaybe<Array<InputMaybe<FilterFindManyMetaFieldInput>>>;
  /** The size of this variant */
  size?: InputMaybe<Scalars['String']>;
  /** The size of this variant translated into the supported languages */
  sizeLocalized?: InputMaybe<Array<InputMaybe<FilterFindManyLocalizationEntryInput>>>;
  /** The SKU of this variant */
  sku?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Date']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyBrandProductSizeOperatorsInput = {
  _id?: InputMaybe<FilterFindManyBrandProductSize_IdOperatorsInput>;
  brandHouseId?: InputMaybe<FilterFindManyBrandProductSizeBrandHouseIdOperatorsInput>;
};

export type FilterFindManyBrandProductSize_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyBrandProductStyleOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyBrandProductVariantBrandHouseIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyBrandProductVariantInput = {
  AND?: InputMaybe<Array<FilterFindManyBrandProductVariantInput>>;
  OR?: InputMaybe<Array<FilterFindManyBrandProductVariantInput>>;
  _id?: InputMaybe<Scalars['MongoID']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyBrandProductVariantOperatorsInput>;
  /** The brand that owns this variant */
  brandHouseId?: InputMaybe<Scalars['MongoID']>;
  brandProductId?: InputMaybe<Scalars['MongoID']>;
  /** The color of this variant */
  color?: InputMaybe<Scalars['String']>;
  /** The color of this variant translated into the supported languages */
  colorLocalized?: InputMaybe<Array<InputMaybe<FilterFindManyLocalizationEntryInput>>>;
  /** The tariff code for use in customs declarations. */
  commodityCode?: InputMaybe<Scalars['String']>;
  /** The ISO 3166-1 alpha-2 country code of origin. */
  countryOrigin?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['Date']>;
  /** Custom data for the product */
  customData?: InputMaybe<Scalars['JSON']>;
  /** True if this variant should not be used in the platform */
  deactivated?: InputMaybe<Scalars['Boolean']>;
  /** True if this product has been deleted */
  deleted?: InputMaybe<Scalars['Boolean']>;
  /** The EAN-13 of this variant */
  ean?: InputMaybe<Scalars['String']>;
  /** A variant unique external identifier */
  externalId?: InputMaybe<Scalars['String']>;
  /** The group that this product belongs to */
  groupId?: InputMaybe<Scalars['MongoID']>;
  /** 712-dimensional embedding vector for the variant's packshot image */
  imageEmbedding?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  /** Extra data about the variant, localized */
  localizedMetaFields?: InputMaybe<Array<InputMaybe<FilterFindManyLocalizedMetaFieldInstanceInput>>>;
  /** Extra data about the variant */
  metaFields?: InputMaybe<Array<InputMaybe<FilterFindManyMetaFieldInput>>>;
  /** The RRP prices for this variant */
  rrp?: InputMaybe<Array<InputMaybe<FilterFindManyPricingInput>>>;
  /** The size of this variant translated into the supported languages - DEPRECATED */
  sizeLocalized?: InputMaybe<Array<InputMaybe<FilterFindManyLocalizationEntryInput>>>;
  /** The SKU of this variant */
  sku?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Date']>;
  /** The weight of this variant in grams */
  weight?: InputMaybe<Scalars['Float']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyBrandProductVariantOperatorsInput = {
  _id?: InputMaybe<FilterFindManyBrandProductVariant_IdOperatorsInput>;
  brandHouseId?: InputMaybe<FilterFindManyBrandProductVariantBrandHouseIdOperatorsInput>;
  sku?: InputMaybe<FilterFindManyBrandProductVariantSkuOperatorsInput>;
};

export type FilterFindManyBrandProductVariantSkuOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyBrandProductVariant_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyBrandProduct_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyCampaignBrandHouseIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyCampaignInput = {
  AND?: InputMaybe<Array<FilterFindManyCampaignInput>>;
  OR?: InputMaybe<Array<FilterFindManyCampaignInput>>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyCampaignOperatorsInput>;
  /** The brand house id of the campaign */
  brandHouseId?: InputMaybe<Scalars['MongoID']>;
  /** The name of the campaign */
  campaignName?: InputMaybe<Scalars['String']>;
  /** The status of the campaign */
  disabled?: InputMaybe<Scalars['Boolean']>;
  /** The start date of the campaign */
  fromDate?: InputMaybe<Scalars['Date']>;
  /** The percentage discount of the campaign */
  percentage?: InputMaybe<Scalars['Float']>;
  /** The shop id of the campaign */
  shopId?: InputMaybe<Scalars['MongoID']>;
  /** The end date of the campaign */
  toDate?: InputMaybe<Scalars['Date']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyCampaignOperatorsInput = {
  brandHouseId?: InputMaybe<FilterFindManyCampaignBrandHouseIdOperatorsInput>;
  shopId?: InputMaybe<FilterFindManyCampaignShopIdOperatorsInput>;
};

export type FilterFindManyCampaignShopIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyCircularPayoutInstanceInput = {
  _id?: InputMaybe<Scalars['MongoID']>;
  accountNr?: InputMaybe<Scalars['String']>;
  currency: Scalars['String'];
  /** The type of circular payout */
  payoutId: Scalars['MongoID'];
  phoneNr?: InputMaybe<Scalars['String']>;
  regNr?: InputMaybe<Scalars['String']>;
  /** Optionally a tradein that was directly converted for this payout */
  tradeInId?: InputMaybe<Scalars['MongoID']>;
};

export type FilterFindManyCircularPayoutTypeInput = {
  AND?: InputMaybe<Array<FilterFindManyCircularPayoutTypeInput>>;
  OR?: InputMaybe<Array<FilterFindManyCircularPayoutTypeInput>>;
  _id?: InputMaybe<Scalars['MongoID']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyCircularPayoutTypeOperatorsInput>;
  createdAt?: InputMaybe<Scalars['Date']>;
  /** The default payout ratio, a number between 0 and 1 */
  defaultRatio?: InputMaybe<Scalars['Float']>;
  /** The name of the payout */
  name?: InputMaybe<Scalars['String']>;
  /** The type of payout */
  payoutType?: InputMaybe<EnumCircularPayoutTypePayoutType>;
  updatedAt?: InputMaybe<Scalars['Date']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyCircularPayoutTypeOperatorsInput = {
  _id?: InputMaybe<FilterFindManyCircularPayoutType_IdOperatorsInput>;
};

export type FilterFindManyCircularPayoutType_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyCircularPointConsumerIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyCircularPointEventProcessedOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Boolean']>;
  gte?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  lt?: InputMaybe<Scalars['Boolean']>;
  lte?: InputMaybe<Scalars['Boolean']>;
  ne?: InputMaybe<Scalars['Boolean']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
};

export type FilterFindManyCircularPointInput = {
  AND?: InputMaybe<Array<FilterFindManyCircularPointInput>>;
  OR?: InputMaybe<Array<FilterFindManyCircularPointInput>>;
  _id?: InputMaybe<Scalars['MongoID']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyCircularPointOperatorsInput>;
  /** Whether the circularpoint point transaction has been activated for a tradein, or executed with the external service provider for a payout */
  activated?: InputMaybe<Scalars['Boolean']>;
  /** The consumer id / account id, owning the points */
  consumerId?: InputMaybe<Scalars['MongoID']>;
  createdAt?: InputMaybe<Scalars['Date']>;
  /** Whether this has been processed by the circular points engine */
  eventProcessed?: InputMaybe<Scalars['Boolean']>;
  /** The shop */
  shopId?: InputMaybe<Scalars['MongoID']>;
  /** Optionally data from the source that is relevant to the circular point */
  sourceData?: InputMaybe<FilterFindManyCircularPointSourceDataInput>;
  /** The source of the circularpoint transaction, tradein id, conversion id, etc */
  sourceObjectId?: InputMaybe<Scalars['MongoID']>;
  /** The type of the transaction source, tradein or conversion */
  sourceType?: InputMaybe<EnumCircularPointSourceType>;
  updatedAt?: InputMaybe<Scalars['Date']>;
  /** The change in points for this transaction. Can be a negative or positive value. */
  value?: InputMaybe<Scalars['Float']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyCircularPointOperatorsInput = {
  _id?: InputMaybe<FilterFindManyCircularPoint_IdOperatorsInput>;
  consumerId?: InputMaybe<FilterFindManyCircularPointConsumerIdOperatorsInput>;
  eventProcessed?: InputMaybe<FilterFindManyCircularPointEventProcessedOperatorsInput>;
  shopId?: InputMaybe<FilterFindManyCircularPointShopIdOperatorsInput>;
  sourceObjectId?: InputMaybe<FilterFindManyCircularPointSourceObjectIdOperatorsInput>;
};

export type FilterFindManyCircularPointShopIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyCircularPointSourceDataInput = {
  _id?: InputMaybe<Scalars['MongoID']>;
  actualPayout?: InputMaybe<FilterFindManyCircularPayoutInstanceInput>;
  postPayout?: InputMaybe<FilterFindManyCircularPayoutInstanceInput>;
};

export type FilterFindManyCircularPointSourceObjectIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyCircularPoint_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyConsumerBrandHouseIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyConsumerEventEventOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyConsumerEventInput = {
  AND?: InputMaybe<Array<FilterFindManyConsumerEventInput>>;
  OR?: InputMaybe<Array<FilterFindManyConsumerEventInput>>;
  _id?: InputMaybe<Scalars['MongoID']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyConsumerEventOperatorsInput>;
  consumerId?: InputMaybe<Scalars['MongoID']>;
  data?: InputMaybe<Scalars['JSON']>;
  dateTime?: InputMaybe<Scalars['Date']>;
  event?: InputMaybe<Scalars['String']>;
  exportedToKlaviyo?: InputMaybe<Scalars['Boolean']>;
  exportedToStatistics?: InputMaybe<Scalars['Boolean']>;
  maildata?: InputMaybe<FilterFindManyConsumerEventMaildataInput>;
  shopId?: InputMaybe<Scalars['MongoID']>;
  subEvent?: InputMaybe<Scalars['String']>;
};

export type FilterFindManyConsumerEventMaildataInput = {
  bounced?: InputMaybe<Scalars['Boolean']>;
  clicked?: InputMaybe<Scalars['Boolean']>;
  delivered?: InputMaybe<Scalars['Boolean']>;
  lastUpdate?: InputMaybe<Scalars['Date']>;
  messageId?: InputMaybe<Scalars['String']>;
  opened?: InputMaybe<Scalars['Boolean']>;
  spam?: InputMaybe<Scalars['Boolean']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyConsumerEventOperatorsInput = {
  _id?: InputMaybe<FilterFindManyConsumerEvent_IdOperatorsInput>;
  event?: InputMaybe<FilterFindManyConsumerEventEventOperatorsInput>;
  subEvent?: InputMaybe<FilterFindManyConsumerEventSubEventOperatorsInput>;
};

export type FilterFindManyConsumerEventSubEventOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyConsumerEvent_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyConsumerInput = {
  AND?: InputMaybe<Array<FilterFindManyConsumerInput>>;
  OR?: InputMaybe<Array<FilterFindManyConsumerInput>>;
  _id?: InputMaybe<Scalars['MongoID']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyConsumerOperatorsInput>;
  /** Whether this consumer accepts marketing mails */
  acceptsMarketing?: InputMaybe<Scalars['Boolean']>;
  accessToken?: InputMaybe<Scalars['String']>;
  accountType?: InputMaybe<Scalars['String']>;
  add1?: InputMaybe<Scalars['String']>;
  add2?: InputMaybe<Scalars['String']>;
  brandHouseId?: InputMaybe<Scalars['MongoID']>;
  city?: InputMaybe<Scalars['String']>;
  company?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  countryCode?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['Date']>;
  currency?: InputMaybe<Scalars['String']>;
  /** Custom data for the consumer */
  customData?: InputMaybe<Scalars['JSON']>;
  /** Optionally a custom id for the consumer */
  customId?: InputMaybe<Scalars['String']>;
  disableContact?: InputMaybe<Scalars['Boolean']>;
  externalId?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  journey?: InputMaybe<Array<InputMaybe<FilterFindManyConsumerJourneyInput>>>;
  lastLogin?: InputMaybe<Scalars['Date']>;
  lastName?: InputMaybe<Scalars['String']>;
  latestOfferMail?: InputMaybe<Scalars['Date']>;
  locale?: InputMaybe<Scalars['String']>;
  mail?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  personId?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  /** Whether this is a proxy account for another consumer */
  proxyAccount?: InputMaybe<Scalars['Boolean']>;
  /** Whether this consumer was created by a consumer himself or by a trusted source */
  selfCreated?: InputMaybe<Scalars['Boolean']>;
  shopId?: InputMaybe<Scalars['MongoID']>;
  updatedAt?: InputMaybe<Scalars['Date']>;
  zipCode?: InputMaybe<Scalars['String']>;
};

export type FilterFindManyConsumerJourneyInput = {
  _id?: InputMaybe<Scalars['MongoID']>;
  /** The date of the journey entry */
  date?: InputMaybe<Scalars['Date']>;
  /** The type of journey entry */
  entryType?: InputMaybe<EnumConsumerJourneyEntryType>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyConsumerOperatorsInput = {
  _id?: InputMaybe<FilterFindManyConsumer_IdOperatorsInput>;
  brandHouseId?: InputMaybe<FilterFindManyConsumerBrandHouseIdOperatorsInput>;
  shopId?: InputMaybe<FilterFindManyConsumerShopIdOperatorsInput>;
};

export type FilterFindManyConsumerShopIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyConsumer_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyDataViewBrandHouseIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyDataViewExpiresAtOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Date']>;
  gte?: InputMaybe<Scalars['Date']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  lt?: InputMaybe<Scalars['Date']>;
  lte?: InputMaybe<Scalars['Date']>;
  ne?: InputMaybe<Scalars['Date']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
};

export type FilterFindManyDataViewInput = {
  AND?: InputMaybe<Array<FilterFindManyDataViewInput>>;
  OR?: InputMaybe<Array<FilterFindManyDataViewInput>>;
  _id?: InputMaybe<Scalars['MongoID']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyDataViewOperatorsInput>;
  brandHouseId?: InputMaybe<Scalars['MongoID']>;
  createdAt?: InputMaybe<Scalars['Date']>;
  expiresAt?: InputMaybe<Scalars['Date']>;
  metadata?: InputMaybe<Scalars['JSON']>;
  rowIds?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  type?: InputMaybe<EnumDataViewType>;
  viewName?: InputMaybe<Scalars['String']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyDataViewOperatorsInput = {
  _id?: InputMaybe<FilterFindManyDataView_IdOperatorsInput>;
  brandHouseId?: InputMaybe<FilterFindManyDataViewBrandHouseIdOperatorsInput>;
  expiresAt?: InputMaybe<FilterFindManyDataViewExpiresAtOperatorsInput>;
  type?: InputMaybe<FilterFindManyDataViewTypeOperatorsInput>;
};

export type FilterFindManyDataViewTypeOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<EnumDataViewType>;
  gte?: InputMaybe<EnumDataViewType>;
  in?: InputMaybe<Array<InputMaybe<EnumDataViewType>>>;
  lt?: InputMaybe<EnumDataViewType>;
  lte?: InputMaybe<EnumDataViewType>;
  ne?: InputMaybe<EnumDataViewType>;
  nin?: InputMaybe<Array<InputMaybe<EnumDataViewType>>>;
};

export type FilterFindManyDataView_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyExternOrder2CustomerInput = {
  createdAt?: InputMaybe<Scalars['Date']>;
  email?: InputMaybe<Scalars['String']>;
  externCustomerId?: InputMaybe<Scalars['String']>;
  locale?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
};

export type FilterFindManyExternOrder2Input = {
  AND?: InputMaybe<Array<FilterFindManyExternOrder2Input>>;
  OR?: InputMaybe<Array<FilterFindManyExternOrder2Input>>;
  _createdAt?: InputMaybe<Scalars['Date']>;
  _id?: InputMaybe<Scalars['MongoID']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyExternOrder2OperatorsInput>;
  _updatedAt?: InputMaybe<Scalars['Date']>;
  acceptsMarketing?: InputMaybe<Scalars['Boolean']>;
  cancelledAt?: InputMaybe<Scalars['Date']>;
  createdAt?: InputMaybe<Scalars['Date']>;
  /** The currency for this order, all values will be in this currency */
  currencyCode?: InputMaybe<Scalars['String']>;
  customer?: InputMaybe<FilterFindManyExternOrder2CustomerInput>;
  /** The external id of this order, must be unique */
  externOrderId?: InputMaybe<Scalars['String']>;
  lineItems?: InputMaybe<Array<InputMaybe<FilterFindManyExternOrder2LineItemsInput>>>;
  /** The external order name */
  name?: InputMaybe<Scalars['String']>;
  shopId?: InputMaybe<Scalars['MongoID']>;
  updatedAt?: InputMaybe<Scalars['Date']>;
};

export type FilterFindManyExternOrder2LineItemsInput = {
  /** Current items bought, refunded/returned items deducted */
  currentQuantity?: InputMaybe<Scalars['Float']>;
  /** The discounted price including tax */
  discountedPrice?: InputMaybe<Scalars['Float']>;
  /** The discounted price excluding tax */
  discountedPricePreTax?: InputMaybe<Scalars['Float']>;
  ean?: InputMaybe<Scalars['String']>;
  /** The primary identifier for the lineitem, must be supplied and be unique */
  externLineId?: InputMaybe<Scalars['String']>;
  externProductId?: InputMaybe<Scalars['String']>;
  externVariantId?: InputMaybe<Scalars['String']>;
  /** Number of items bought */
  quantity?: InputMaybe<Scalars['Float']>;
  /** The original price including tax */
  salesPrice?: InputMaybe<Scalars['Float']>;
  sku?: InputMaybe<Scalars['String']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyExternOrder2OperatorsInput = {
  _id?: InputMaybe<FilterFindManyExternOrder2_IdOperatorsInput>;
};

export type FilterFindManyExternOrder2_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyExternOrderCustomerInput = {
  createdAt?: InputMaybe<Scalars['Date']>;
  email?: InputMaybe<Scalars['String']>;
  externCustomerId?: InputMaybe<Scalars['String']>;
  locale?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
};

export type FilterFindManyExternOrderInput = {
  AND?: InputMaybe<Array<FilterFindManyExternOrderInput>>;
  OR?: InputMaybe<Array<FilterFindManyExternOrderInput>>;
  _createdAt?: InputMaybe<Scalars['Date']>;
  _id?: InputMaybe<Scalars['MongoID']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyExternOrderOperatorsInput>;
  _updatedAt?: InputMaybe<Scalars['Date']>;
  acceptsMarketing?: InputMaybe<Scalars['Boolean']>;
  cancelledAt?: InputMaybe<Scalars['Date']>;
  createdAt?: InputMaybe<Scalars['Date']>;
  currencyCode?: InputMaybe<Scalars['String']>;
  customer?: InputMaybe<FilterFindManyExternOrderCustomerInput>;
  externOrderId?: InputMaybe<Scalars['String']>;
  lineItems?: InputMaybe<Array<InputMaybe<FilterFindManyExternOrderLineItemsInput>>>;
  name?: InputMaybe<Scalars['String']>;
  shippingAddress?: InputMaybe<FilterFindManyExternOrderShippingAddressInput>;
  shopId?: InputMaybe<Scalars['MongoID']>;
  totalDiscountSet?: InputMaybe<FilterFindManyExternOrderTotalPriceSetInput>;
  totalPriceSet?: InputMaybe<FilterFindManyExternOrderTotalPriceSetInput>;
  totalShippingPriceSet?: InputMaybe<FilterFindManyExternOrderTotalPriceSetInput>;
  updatedAt?: InputMaybe<Scalars['Date']>;
};

export type FilterFindManyExternOrderLineItemsInput = {
  discountedTotalSet?: InputMaybe<FilterFindManyExternOrderTotalPriceSetInput>;
  externLineItemId?: InputMaybe<Scalars['String']>;
  externProductId?: InputMaybe<Scalars['String']>;
  externVariantId?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  originalTotalSet?: InputMaybe<FilterFindManyExternOrderTotalPriceSetInput>;
  quantity?: InputMaybe<Scalars['Float']>;
  sku?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyExternOrderOperatorsInput = {
  _id?: InputMaybe<FilterFindManyExternOrder_IdOperatorsInput>;
};

export type FilterFindManyExternOrderShippingAddressInput = {
  address1?: InputMaybe<Scalars['String']>;
  address2?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  company?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  countryCode?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  zip?: InputMaybe<Scalars['String']>;
};

export type FilterFindManyExternOrderTotalPriceSetInput = {
  amount?: InputMaybe<Scalars['Float']>;
  currencyCode?: InputMaybe<Scalars['String']>;
};

export type FilterFindManyExternOrder_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyIntegrationConnectorActiveForOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyIntegrationConnectorCloudTasksInput = {
  development?: InputMaybe<FilterFindManyIntegrationConnectorCloudTasksProductionInput>;
  production?: InputMaybe<FilterFindManyIntegrationConnectorCloudTasksProductionInput>;
  test?: InputMaybe<FilterFindManyIntegrationConnectorCloudTasksProductionInput>;
};

export type FilterFindManyIntegrationConnectorCloudTasksProductionInput = {
  /** The OIDC audience override; defaults to targetUrl when omitted */
  audience?: InputMaybe<Scalars['String']>;
  /** The Cloud Tasks queue name only; GCP project and location live in the runtime configuration of the distributor */
  queue: Scalars['String'];
  /** The HTTPS URL of the connector receiver that Cloud Tasks will POST to */
  targetUrl: Scalars['String'];
};

export type FilterFindManyIntegrationConnectorEventbusInput = {
  development?: InputMaybe<FilterFindManyIntegrationConnectorEventbusProductionInput>;
  production?: InputMaybe<FilterFindManyIntegrationConnectorEventbusProductionInput>;
  test?: InputMaybe<FilterFindManyIntegrationConnectorEventbusProductionInput>;
};

export type FilterFindManyIntegrationConnectorEventbusProductionInput = {
  /** The servicebus connection string */
  serviceBus: Scalars['String'];
  /** The topic for the servicebus */
  topic: Scalars['String'];
};

export type FilterFindManyIntegrationConnectorFieldsInput = {
  _id?: InputMaybe<Scalars['MongoID']>;
  /** Default value for the field */
  defaultValue?: InputMaybe<Scalars['String']>;
  /** Description of the field */
  description?: InputMaybe<Scalars['String']>;
  /** The field */
  field?: InputMaybe<Scalars['String']>;
  /** Namespace grouping of multiple fields */
  namespace?: InputMaybe<Scalars['String']>;
  options?: InputMaybe<Array<InputMaybe<FilterFindManyIntegrationConnectorFieldsOptionsInput>>>;
  /** Whether the field is required */
  required?: InputMaybe<Scalars['Boolean']>;
  /** text, number, json */
  type?: InputMaybe<Scalars['String']>;
};

export type FilterFindManyIntegrationConnectorFieldsOptionsInput = {
  /** Option label */
  label?: InputMaybe<Scalars['String']>;
  /** The value when the option is selected */
  value?: InputMaybe<Scalars['JSON']>;
};

export type FilterFindManyIntegrationConnectorInput = {
  AND?: InputMaybe<Array<FilterFindManyIntegrationConnectorInput>>;
  OR?: InputMaybe<Array<FilterFindManyIntegrationConnectorInput>>;
  _id?: InputMaybe<Scalars['MongoID']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyIntegrationConnectorOperatorsInput>;
  activeFor?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  autoInstallFor?: InputMaybe<Array<InputMaybe<EnumIntegrationConnectorAutoInstallFor>>>;
  cloudTasks?: InputMaybe<FilterFindManyIntegrationConnectorCloudTasksInput>;
  /** Whether this connector has been deleted */
  deleted?: InputMaybe<Scalars['Boolean']>;
  /** The runtime that dispatches this connector; missing means FUNCTIONS2 for backwards compatibility */
  dispatcher?: InputMaybe<EnumIntegrationConnectorDispatcher>;
  eventbus?: InputMaybe<FilterFindManyIntegrationConnectorEventbusInput>;
  fields?: InputMaybe<Array<InputMaybe<FilterFindManyIntegrationConnectorFieldsInput>>>;
  /** Icon for the connector */
  icon?: InputMaybe<Scalars['String']>;
  messages?: InputMaybe<Array<InputMaybe<EnumIntegrationConnectorMessages>>>;
  /** The name of the connector */
  name?: InputMaybe<Scalars['String']>;
  optionals?: InputMaybe<Array<InputMaybe<EnumIntegrationConnectorOptionals>>>;
  refTypes?: InputMaybe<Array<InputMaybe<EnumIntegrationConnectorRefTypes>>>;
  /** The type of connector */
  type?: InputMaybe<EnumIntegrationConnectorType>;
  /** The latest entity that updated this connector */
  updatedBy?: InputMaybe<FilterFindManyObjectPatchesUpdatedByInput>;
  webhook?: InputMaybe<FilterFindManyIntegrationConnectorWebhookInput>;
};

export type FilterFindManyIntegrationConnectorNameOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyIntegrationConnectorOperatorsInput = {
  _id?: InputMaybe<FilterFindManyIntegrationConnector_IdOperatorsInput>;
  activeFor?: InputMaybe<FilterFindManyIntegrationConnectorActiveForOperatorsInput>;
  name?: InputMaybe<FilterFindManyIntegrationConnectorNameOperatorsInput>;
  refTypes?: InputMaybe<FilterFindManyIntegrationConnectorRefTypesOperatorsInput>;
};

export type FilterFindManyIntegrationConnectorRefTypesOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<EnumIntegrationConnectorRefTypes>;
  gte?: InputMaybe<EnumIntegrationConnectorRefTypes>;
  in?: InputMaybe<Array<InputMaybe<EnumIntegrationConnectorRefTypes>>>;
  lt?: InputMaybe<EnumIntegrationConnectorRefTypes>;
  lte?: InputMaybe<EnumIntegrationConnectorRefTypes>;
  ne?: InputMaybe<EnumIntegrationConnectorRefTypes>;
  nin?: InputMaybe<Array<InputMaybe<EnumIntegrationConnectorRefTypes>>>;
};

export type FilterFindManyIntegrationConnectorWebhookInput = {
  development?: InputMaybe<FilterFindManyIntegrationConnectorWebhookProductionInput>;
  production?: InputMaybe<FilterFindManyIntegrationConnectorWebhookProductionInput>;
  test?: InputMaybe<FilterFindManyIntegrationConnectorWebhookProductionInput>;
};

export type FilterFindManyIntegrationConnectorWebhookProductionInput = {
  /** Custom headers to include in the webhook request */
  headers?: InputMaybe<Scalars['JSON']>;
  /** The URL that will receive the POST payload message */
  url: Scalars['String'];
};

export type FilterFindManyIntegrationConnector_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyIntegrationInstanceInput = {
  AND?: InputMaybe<Array<FilterFindManyIntegrationInstanceInput>>;
  OR?: InputMaybe<Array<FilterFindManyIntegrationInstanceInput>>;
  _id?: InputMaybe<Scalars['MongoID']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyIntegrationInstanceOperatorsInput>;
  /** The connector that was installed */
  connectorId?: InputMaybe<Scalars['MongoID']>;
  /** Whether the install has been deleted */
  deleted?: InputMaybe<Scalars['Boolean']>;
  /** Whether the install has been enabled */
  enabled?: InputMaybe<Scalars['Boolean']>;
  /** The mode of the instance */
  mode?: InputMaybe<EnumIntegrationInstanceMode>;
  /** The name of the instance */
  name?: InputMaybe<Scalars['String']>;
  /** The owner of the install */
  refId?: InputMaybe<Scalars['MongoID']>;
  /** What type this connector is referenced to */
  refType?: InputMaybe<EnumIntegrationInstanceRefType>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyIntegrationInstanceOperatorsInput = {
  _id?: InputMaybe<FilterFindManyIntegrationInstance_IdOperatorsInput>;
  refId?: InputMaybe<FilterFindManyIntegrationInstanceRefIdOperatorsInput>;
};

export type FilterFindManyIntegrationInstanceRefIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyIntegrationInstance_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyIntegrationMessageInput = {
  AND?: InputMaybe<Array<FilterFindManyIntegrationMessageInput>>;
  OR?: InputMaybe<Array<FilterFindManyIntegrationMessageInput>>;
  _id?: InputMaybe<Scalars['MongoID']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyIntegrationMessageOperatorsInput>;
  /** The timestamp of the message ackknowledgement, webhooks will set this instantly based on 200 OK response. Servicebus implementationw will need to send an ackknowledge event. */
  acknowledged?: InputMaybe<Scalars['Date']>;
  /** Timestamp of the message creation */
  created?: InputMaybe<Scalars['Date']>;
  /** The source environment of this message : production, development or test */
  env?: InputMaybe<Scalars['String']>;
  /** If the message was unable to be delivered, this will have contain a timestamp of when we gave up */
  failed?: InputMaybe<Scalars['Date']>;
  /** The instance identifier */
  instanceId?: InputMaybe<Scalars['MongoID']>;
  lockedId?: InputMaybe<Scalars['String']>;
  /** The message type */
  message?: InputMaybe<EnumIntegrationMessageMessage>;
  /** True if failure */
  messageFailed?: InputMaybe<Scalars['Boolean']>;
  /** True if ignored */
  messageIgnored?: InputMaybe<Scalars['Boolean']>;
  /** If this message is a retry message, then this points the the previous message that initiated the retry */
  parentId?: InputMaybe<Scalars['MongoID']>;
  /** Optionally a payload for the message */
  payload?: InputMaybe<Scalars['JSON']>;
  /** A token that can be used to read the message */
  readToken?: InputMaybe<Scalars['String']>;
  /** The referenced object this message originated from */
  refId?: InputMaybe<Scalars['MongoID']>;
  /** The referenced object type, Shop, BrandHouse, LogisticsPartner */
  refType?: InputMaybe<Scalars['String']>;
  /** Dispatcher-private fence for result writes. Only 0 (job accepted) and 1 (terminal job result) are defined; a result may only be replaced by a strictly newer sequence. Absent for single-reply messages */
  replySequence?: InputMaybe<Scalars['Float']>;
  /** Optionally a result data blob for the message */
  result?: InputMaybe<Scalars['JSON']>;
  /** If a result data blob was stored, then this timestamp holds the timestamp for it - otherwise null */
  resultTs?: InputMaybe<Scalars['Date']>;
  /** The timestamp of when the message should be sent, this is typically used when retrying failed messages, but can be used for any message delaying */
  sendAt?: InputMaybe<Scalars['Date']>;
  /** Timestamp of when the message was last sent */
  sent?: InputMaybe<Scalars['Date']>;
  /** The number of times we have sent this message */
  sentCount?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyIntegrationMessageLockedIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyIntegrationMessageMessageFailedOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Boolean']>;
  gte?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  lt?: InputMaybe<Scalars['Boolean']>;
  lte?: InputMaybe<Scalars['Boolean']>;
  ne?: InputMaybe<Scalars['Boolean']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyIntegrationMessageOperatorsInput = {
  _id?: InputMaybe<FilterFindManyIntegrationMessage_IdOperatorsInput>;
  lockedId?: InputMaybe<FilterFindManyIntegrationMessageLockedIdOperatorsInput>;
  messageFailed?: InputMaybe<FilterFindManyIntegrationMessageMessageFailedOperatorsInput>;
  refId?: InputMaybe<FilterFindManyIntegrationMessageRefIdOperatorsInput>;
};

export type FilterFindManyIntegrationMessageRefIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyIntegrationMessage_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyInvoiceAdjustmentBrandHouseIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyInvoiceAdjustmentCreatedAtOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Date']>;
  gte?: InputMaybe<Scalars['Date']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  lt?: InputMaybe<Scalars['Date']>;
  lte?: InputMaybe<Scalars['Date']>;
  ne?: InputMaybe<Scalars['Date']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
};

export type FilterFindManyInvoiceAdjustmentInput = {
  AND?: InputMaybe<Array<FilterFindManyInvoiceAdjustmentInput>>;
  OR?: InputMaybe<Array<FilterFindManyInvoiceAdjustmentInput>>;
  _id?: InputMaybe<Scalars['MongoID']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyInvoiceAdjustmentOperatorsInput>;
  amount?: InputMaybe<Scalars['Float']>;
  brandHouseId?: InputMaybe<Scalars['MongoID']>;
  createdAt?: InputMaybe<Scalars['Date']>;
  description?: InputMaybe<Scalars['String']>;
  updatedBy?: InputMaybe<FilterFindManyObjectPatchesUpdatedByInput>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyInvoiceAdjustmentOperatorsInput = {
  _id?: InputMaybe<FilterFindManyInvoiceAdjustment_IdOperatorsInput>;
  brandHouseId?: InputMaybe<FilterFindManyInvoiceAdjustmentBrandHouseIdOperatorsInput>;
  createdAt?: InputMaybe<FilterFindManyInvoiceAdjustmentCreatedAtOperatorsInput>;
};

export type FilterFindManyInvoiceAdjustment_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyInvoiceLineBrandHouseIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyInvoiceLineInput = {
  AND?: InputMaybe<Array<FilterFindManyInvoiceLineInput>>;
  OR?: InputMaybe<Array<FilterFindManyInvoiceLineInput>>;
  _id?: InputMaybe<Scalars['MongoID']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyInvoiceLineOperatorsInput>;
  brandHouseId?: InputMaybe<Scalars['MongoID']>;
  cost?: InputMaybe<Scalars['Float']>;
  createdAt?: InputMaybe<Scalars['Date']>;
  currency?: InputMaybe<Scalars['String']>;
  invoiceId?: InputMaybe<Scalars['MongoID']>;
  /** The calculated date for this invoice line, and depends on when the invoicing is enabled for the customer */
  lineDate?: InputMaybe<Scalars['Date']>;
  lineId?: InputMaybe<Scalars['String']>;
  lineIndex?: InputMaybe<Scalars['Float']>;
  lineType?: InputMaybe<EnumInvoiceLineLineType>;
  updatedAt?: InputMaybe<Scalars['Date']>;
};

export type FilterFindManyInvoiceLineInvoiceIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyInvoiceLineLineTypeOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<EnumInvoiceLineLineType>;
  gte?: InputMaybe<EnumInvoiceLineLineType>;
  in?: InputMaybe<Array<InputMaybe<EnumInvoiceLineLineType>>>;
  lt?: InputMaybe<EnumInvoiceLineLineType>;
  lte?: InputMaybe<EnumInvoiceLineLineType>;
  ne?: InputMaybe<EnumInvoiceLineLineType>;
  nin?: InputMaybe<Array<InputMaybe<EnumInvoiceLineLineType>>>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyInvoiceLineOperatorsInput = {
  _id?: InputMaybe<FilterFindManyInvoiceLine_IdOperatorsInput>;
  brandHouseId?: InputMaybe<FilterFindManyInvoiceLineBrandHouseIdOperatorsInput>;
  invoiceId?: InputMaybe<FilterFindManyInvoiceLineInvoiceIdOperatorsInput>;
  lineType?: InputMaybe<FilterFindManyInvoiceLineLineTypeOperatorsInput>;
};

export type FilterFindManyInvoiceLine_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyItemIssueInput = {
  AND?: InputMaybe<Array<FilterFindManyItemIssueInput>>;
  OR?: InputMaybe<Array<FilterFindManyItemIssueInput>>;
  brandHouseId?: InputMaybe<Scalars['MongoID']>;
  brandItemId?: InputMaybe<Scalars['MongoID']>;
  externId?: InputMaybe<Scalars['String']>;
  /** URL to the image of the issue */
  imageUrl?: InputMaybe<Scalars['String']>;
  issue?: InputMaybe<Scalars['String']>;
  location?: InputMaybe<EnumItemIssueLocation>;
  /** Marker X position as percent (0-100) of image width, origin top-left */
  markX?: InputMaybe<Scalars['Float']>;
  /** Marker Y position as percent (0-100) of image height, origin top-left */
  markY?: InputMaybe<Scalars['Float']>;
  /** Coordinate of the issue, A1, B2, etc. */
  point?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyLocalizationEntryInput = {
  /** ISO Locale code */
  locale?: InputMaybe<Scalars['String']>;
  /** The localized text */
  value?: InputMaybe<Scalars['String']>;
};

export type FilterFindManyLocalizedMetaFieldInstanceInput = {
  /** The language of the localized metafields */
  language?: InputMaybe<Scalars['String']>;
  /** The metafields */
  metaFields?: InputMaybe<Array<InputMaybe<MetaFieldInput>>>;
};

export type FilterFindManyLogisticsPartnerAutoretouchInput = {
  accessToken?: InputMaybe<Scalars['String']>;
  expireTs?: InputMaybe<Scalars['Date']>;
  refreshToken?: InputMaybe<Scalars['String']>;
};

export type FilterFindManyLogisticsPartnerInput = {
  AND?: InputMaybe<Array<FilterFindManyLogisticsPartnerInput>>;
  OR?: InputMaybe<Array<FilterFindManyLogisticsPartnerInput>>;
  _id?: InputMaybe<Scalars['MongoID']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyLogisticsPartnerOperatorsInput>;
  address?: InputMaybe<Scalars['String']>;
  address2?: InputMaybe<Scalars['String']>;
  /** API KEY for the logisticspartner, use this to obtain an accessToken */
  apiKey?: InputMaybe<Scalars['String']>;
  /** API Secret for the logisticspartner, use this to obtain an accessToken */
  apiSecret?: InputMaybe<Scalars['String']>;
  attention?: InputMaybe<Scalars['String']>;
  autoretouch?: InputMaybe<FilterFindManyLogisticsPartnerAutoretouchInput>;
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  countryCode?: InputMaybe<Scalars['String']>;
  mail?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  zipCode?: InputMaybe<Scalars['String']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyLogisticsPartnerOperatorsInput = {
  _id?: InputMaybe<FilterFindManyLogisticsPartner_IdOperatorsInput>;
};

export type FilterFindManyLogisticsPartner_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyMetaFieldInput = {
  /** Custom data to the metafield */
  customData?: InputMaybe<Scalars['JSON']>;
  /** The key to identify the metafield within a namespace */
  key: Scalars['String'];
  /** Optionally a namespace for the metafield, used to group related fields */
  namespace?: InputMaybe<Scalars['String']>;
  /** Type of the value, required */
  type?: InputMaybe<EnumMetaFieldType>;
  /** The metafield value, JSON data */
  value: Scalars['JSON'];
};

export type FilterFindManyMetaFieldInstanceInput = {
  /** If the metafield was auto added by configuration */
  auto?: InputMaybe<Scalars['Boolean']>;
  /** Custom data to the metafield */
  customData?: InputMaybe<Scalars['JSON']>;
  /** The key to identify the metafield within a namespace */
  key?: InputMaybe<Scalars['String']>;
  /** Optionally a namespace for the metafield, used to group related fields */
  namespace?: InputMaybe<Scalars['String']>;
  /** Type of the value, required */
  type?: InputMaybe<EnumMetaFieldInstanceType>;
  /** The metafield value, JSON data */
  value?: InputMaybe<Scalars['JSON']>;
};

export type FilterFindManyNfcInput = {
  AND?: InputMaybe<Array<FilterFindManyNfcInput>>;
  OR?: InputMaybe<Array<FilterFindManyNfcInput>>;
  _id?: InputMaybe<Scalars['MongoID']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyNfcOperatorsInput>;
  brandItemId?: InputMaybe<Scalars['MongoID']>;
  /** The NFC tag identifier */
  identifier?: InputMaybe<Scalars['String']>;
  stockItemId?: InputMaybe<Scalars['MongoID']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyNfcOperatorsInput = {
  _id?: InputMaybe<FilterFindManyNfc_IdOperatorsInput>;
};

export type FilterFindManyNfc_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyObjectPatchesAuditNoteIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyObjectPatchesBrandHouseIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyObjectPatchesInput = {
  AND?: InputMaybe<Array<FilterFindManyObjectPatchesInput>>;
  OR?: InputMaybe<Array<FilterFindManyObjectPatchesInput>>;
  _id?: InputMaybe<Scalars['MongoID']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyObjectPatchesOperatorsInput>;
  auditNoteId?: InputMaybe<Scalars['MongoID']>;
  brandHouseId?: InputMaybe<Scalars['MongoID']>;
  /** If true, then the patch has been compacted */
  compacted?: InputMaybe<Scalars['Boolean']>;
  date?: InputMaybe<Scalars['Date']>;
  ops?: InputMaybe<Array<InputMaybe<FilterFindManyObjectPatchesOpsInput>>>;
  ref?: InputMaybe<Scalars['MongoID']>;
  shopId?: InputMaybe<Scalars['MongoID']>;
  type?: InputMaybe<Scalars['String']>;
  updatedBy?: InputMaybe<FilterFindManyObjectPatchesUpdatedByInput>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyObjectPatchesOperatorsInput = {
  _id?: InputMaybe<FilterFindManyObjectPatches_IdOperatorsInput>;
  auditNoteId?: InputMaybe<FilterFindManyObjectPatchesAuditNoteIdOperatorsInput>;
  brandHouseId?: InputMaybe<FilterFindManyObjectPatchesBrandHouseIdOperatorsInput>;
  ref?: InputMaybe<FilterFindManyObjectPatchesRefOperatorsInput>;
  shopId?: InputMaybe<FilterFindManyObjectPatchesShopIdOperatorsInput>;
};

export type FilterFindManyObjectPatchesOpsInput = {
  op?: InputMaybe<Scalars['String']>;
  path?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['JSON']>;
};

export type FilterFindManyObjectPatchesRefOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyObjectPatchesShopIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyObjectPatchesUpdatedByInput = {
  ref?: InputMaybe<Scalars['MongoID']>;
  type?: InputMaybe<Scalars['String']>;
};

export type FilterFindManyObjectPatches_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyOptionInstanceInput = {
  optionSetId?: InputMaybe<Scalars['MongoID']>;
  /** The value of the option value for the option set */
  optionValue?: InputMaybe<Scalars['String']>;
  /** The id of the option value for the option set */
  optionValueId?: InputMaybe<Scalars['MongoID']>;
};

export type FilterFindManyOptionSetInput = {
  AND?: InputMaybe<Array<FilterFindManyOptionSetInput>>;
  OR?: InputMaybe<Array<FilterFindManyOptionSetInput>>;
  _id?: InputMaybe<Scalars['MongoID']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyOptionSetOperatorsInput>;
  /** If true, the option set is active */
  active?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Date']>;
  /** If true, the option set is deleted */
  deleted?: InputMaybe<Scalars['Boolean']>;
  /** The external id of the option set */
  externalId?: InputMaybe<Scalars['String']>;
  /** The key of the option set */
  key?: InputMaybe<Scalars['String']>;
  /** The id of the item that the option set is for */
  refId?: InputMaybe<Scalars['MongoID']>;
  /** The type of the ref id */
  refType?: InputMaybe<EnumOptionSetRefType>;
  /** If true, then the option set will be required when used with the target */
  required?: InputMaybe<Scalars['Boolean']>;
  /** The section of the target that the option set should be shown for */
  section?: InputMaybe<Scalars['String']>;
  target?: InputMaybe<EnumOptionSetTarget>;
  /** The title of the option set */
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Date']>;
  updatedBy?: InputMaybe<FilterFindManyObjectPatchesUpdatedByInput>;
  /** The value type of the option set */
  valueType?: InputMaybe<EnumOptionSetValueType>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyOptionSetOperatorsInput = {
  _id?: InputMaybe<FilterFindManyOptionSet_IdOperatorsInput>;
  refId?: InputMaybe<FilterFindManyOptionSetRefIdOperatorsInput>;
};

export type FilterFindManyOptionSetRefIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyOptionSet_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyOptionValueInput = {
  AND?: InputMaybe<Array<FilterFindManyOptionValueInput>>;
  OR?: InputMaybe<Array<FilterFindManyOptionValueInput>>;
  _id?: InputMaybe<Scalars['MongoID']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyOptionValueOperatorsInput>;
  createdAt?: InputMaybe<Scalars['Date']>;
  /** Custom data for the option value */
  customData?: InputMaybe<Scalars['JSON']>;
  /** If true, the option is deleted */
  deleted?: InputMaybe<Scalars['Boolean']>;
  /** The external id of the option value */
  externalId?: InputMaybe<Scalars['String']>;
  /** The label of option */
  label?: InputMaybe<Scalars['String']>;
  /** The localizations of the option */
  localizations?: InputMaybe<Array<InputMaybe<FilterFindManyLocalizationEntryInput>>>;
  /** The option set id */
  optionSetId?: InputMaybe<Scalars['MongoID']>;
  /** The id of the object that owns the value */
  refId?: InputMaybe<Scalars['MongoID']>;
  /** The sort order of the option */
  sortorder?: InputMaybe<Scalars['Float']>;
  updatedAt?: InputMaybe<Scalars['Date']>;
  updatedBy?: InputMaybe<FilterFindManyObjectPatchesUpdatedByInput>;
  /** The value of the option */
  value?: InputMaybe<Scalars['String']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyOptionValueOperatorsInput = {
  _id?: InputMaybe<FilterFindManyOptionValue_IdOperatorsInput>;
};

export type FilterFindManyOptionValue_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyOrder2BrandHouseIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyOrder2CarrierInfoInput = {
  _id?: InputMaybe<Scalars['MongoID']>;
  carrierIdentifier?: InputMaybe<Scalars['String']>;
  code?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};

export type FilterFindManyOrder2CarrierInputInput = {
  /** Selected carrier for this package */
  carrier?: InputMaybe<EnumOrder2CarrierInputCarrier>;
  /** Selected delivery service for this package */
  delivery?: InputMaybe<EnumOrder2CarrierInputDelivery>;
  /** Express delivery */
  express?: InputMaybe<Scalars['Boolean']>;
  /** Optionally an additional service id / pickup point information for this package */
  serviceId?: InputMaybe<Scalars['String']>;
};

export type FilterFindManyOrder2ConsumerInput = {
  _id?: InputMaybe<Scalars['MongoID']>;
  add1?: InputMaybe<Scalars['String']>;
  add2?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  countryCode?: InputMaybe<Scalars['String']>;
  externalId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  language?: InputMaybe<Scalars['String']>;
  mail?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  zipCode?: InputMaybe<Scalars['String']>;
};

export type FilterFindManyOrder2FulStateOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<EnumOrder2FulState>;
  gte?: InputMaybe<EnumOrder2FulState>;
  in?: InputMaybe<Array<InputMaybe<EnumOrder2FulState>>>;
  lt?: InputMaybe<EnumOrder2FulState>;
  lte?: InputMaybe<EnumOrder2FulState>;
  ne?: InputMaybe<EnumOrder2FulState>;
  nin?: InputMaybe<Array<InputMaybe<EnumOrder2FulState>>>;
};

export type FilterFindManyOrder2Input = {
  AND?: InputMaybe<Array<FilterFindManyOrder2Input>>;
  OR?: InputMaybe<Array<FilterFindManyOrder2Input>>;
  _id?: InputMaybe<Scalars['MongoID']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyOrder2OperatorsInput>;
  billingAddress?: InputMaybe<FilterFindManyOrder2ShippingAddressInput>;
  brandHouseId?: InputMaybe<Scalars['MongoID']>;
  captureFailedTs?: InputMaybe<Scalars['Date']>;
  captureNotified?: InputMaybe<Scalars['Boolean']>;
  captureRequests?: InputMaybe<Scalars['Float']>;
  /** The total amount to be captured for this order */
  captureTotal?: InputMaybe<Scalars['Float']>;
  carrierInfo?: InputMaybe<FilterFindManyOrder2CarrierInfoInput>;
  carrierInput?: InputMaybe<FilterFindManyOrder2CarrierInputInput>;
  /** Comment for the order */
  comment?: InputMaybe<Scalars['String']>;
  consumer?: InputMaybe<FilterFindManyOrder2ConsumerInput>;
  consumerId?: InputMaybe<Scalars['MongoID']>;
  createdAt?: InputMaybe<Scalars['Date']>;
  /** Currency for this order */
  currency?: InputMaybe<Scalars['String']>;
  /** Custom data for the order */
  customData?: InputMaybe<Scalars['JSON']>;
  /** Soft delete */
  deleted?: InputMaybe<Scalars['Boolean']>;
  exportedToWMS?: InputMaybe<Scalars['Boolean']>;
  externalId?: InputMaybe<Scalars['String']>;
  /** A free return order is not reduced by the brand's return freight (refundAdjustment) when a line is returned */
  freeReturn?: InputMaybe<Scalars['Boolean']>;
  fulState?: InputMaybe<EnumOrder2FulState>;
  /** Whether this is a new order */
  isNewOrder?: InputMaybe<Scalars['Boolean']>;
  locked?: InputMaybe<Scalars['String']>;
  notified?: InputMaybe<Scalars['Boolean']>;
  notifiedConsumer?: InputMaybe<Scalars['Boolean']>;
  /** True while the sales channel holds the order back from fulfilment (e.g. a Shopify fulfillment hold on one of its lines). Its items stay sold, but the warehouse must not pick it */
  onHold?: InputMaybe<Scalars['Boolean']>;
  orderDate?: InputMaybe<Scalars['Date']>;
  orderName?: InputMaybe<Scalars['String']>;
  orderState?: InputMaybe<EnumOrder2OrderState>;
  orderUrl?: InputMaybe<Scalars['String']>;
  payState?: InputMaybe<EnumOrder2PayState>;
  /** True if the order is a proforma order */
  proforma?: InputMaybe<Scalars['Boolean']>;
  /** True if the order commission can be invoiced, even if it is a proforma order */
  proformaInvoiceCommission?: InputMaybe<Scalars['Boolean']>;
  /** True if the order pickpack can be invoiced, even if it is a proforma order */
  proformaInvoicePickPack?: InputMaybe<Scalars['Boolean']>;
  /** True if the order shipping can be invoiced, even if it is a proforma order */
  proformaInvoiceShipping?: InputMaybe<Scalars['Boolean']>;
  refundAdjusted?: InputMaybe<Scalars['Boolean']>;
  /** The returnDeadline for an order is typically determined by the settings, but its possible to set the returnDeadline to override that */
  returnDeadline?: InputMaybe<Scalars['Date']>;
  returnInfo?: InputMaybe<FilterFindManyOrder2ReturnInfoInput>;
  returnShippingLabelId?: InputMaybe<Scalars['MongoID']>;
  shippingAddress?: InputMaybe<FilterFindManyOrder2ShippingAddressInput>;
  shippingAddressInternal?: InputMaybe<FilterFindManyOrder2ShippingAddressInput>;
  shopId?: InputMaybe<Scalars['MongoID']>;
  /** A silenced order will not show as unfulfilled or active in statistics */
  silenced?: InputMaybe<Scalars['Boolean']>;
  splitOrder?: InputMaybe<Scalars['Boolean']>;
  trackingInfo?: InputMaybe<FilterFindManyOrder2TrackingInfoInput>;
  /** If the tracking mail has been sent to the consumer */
  trackingMailSent?: InputMaybe<Scalars['Boolean']>;
  trackingOrderId?: InputMaybe<Scalars['Float']>;
  trackingOrderState?: InputMaybe<EnumOrder2TrackingOrderState>;
  trackingReturnState?: InputMaybe<EnumOrder2TrackingReturnState>;
  updatedAt?: InputMaybe<Scalars['Date']>;
  updatedBy?: InputMaybe<FilterFindManyObjectPatchesUpdatedByInput>;
  /** Timestamp of the latest orderline that has been updated */
  updatedLineTs?: InputMaybe<Scalars['Date']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyOrder2OperatorsInput = {
  _id?: InputMaybe<FilterFindManyOrder2_IdOperatorsInput>;
  brandHouseId?: InputMaybe<FilterFindManyOrder2BrandHouseIdOperatorsInput>;
  fulState?: InputMaybe<FilterFindManyOrder2FulStateOperatorsInput>;
  orderDate?: InputMaybe<FilterFindManyOrder2OrderDateOperatorsInput>;
  orderName?: InputMaybe<FilterFindManyOrder2OrderNameOperatorsInput>;
  orderState?: InputMaybe<FilterFindManyOrder2OrderStateOperatorsInput>;
  payState?: InputMaybe<FilterFindManyOrder2PayStateOperatorsInput>;
  proforma?: InputMaybe<FilterFindManyOrder2ProformaOperatorsInput>;
  shopId?: InputMaybe<FilterFindManyOrder2ShopIdOperatorsInput>;
  silenced?: InputMaybe<FilterFindManyOrder2SilencedOperatorsInput>;
  splitOrder?: InputMaybe<FilterFindManyOrder2SplitOrderOperatorsInput>;
  trackingOrderState?: InputMaybe<FilterFindManyOrder2TrackingOrderStateOperatorsInput>;
  trackingReturnState?: InputMaybe<FilterFindManyOrder2TrackingReturnStateOperatorsInput>;
  updatedLineTs?: InputMaybe<FilterFindManyOrder2UpdatedLineTsOperatorsInput>;
};

export type FilterFindManyOrder2OrderDateOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Date']>;
  gte?: InputMaybe<Scalars['Date']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  lt?: InputMaybe<Scalars['Date']>;
  lte?: InputMaybe<Scalars['Date']>;
  ne?: InputMaybe<Scalars['Date']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
};

export type FilterFindManyOrder2OrderNameOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyOrder2OrderStateOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<EnumOrder2OrderState>;
  gte?: InputMaybe<EnumOrder2OrderState>;
  in?: InputMaybe<Array<InputMaybe<EnumOrder2OrderState>>>;
  lt?: InputMaybe<EnumOrder2OrderState>;
  lte?: InputMaybe<EnumOrder2OrderState>;
  ne?: InputMaybe<EnumOrder2OrderState>;
  nin?: InputMaybe<Array<InputMaybe<EnumOrder2OrderState>>>;
};

export type FilterFindManyOrder2PayStateOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<EnumOrder2PayState>;
  gte?: InputMaybe<EnumOrder2PayState>;
  in?: InputMaybe<Array<InputMaybe<EnumOrder2PayState>>>;
  lt?: InputMaybe<EnumOrder2PayState>;
  lte?: InputMaybe<EnumOrder2PayState>;
  ne?: InputMaybe<EnumOrder2PayState>;
  nin?: InputMaybe<Array<InputMaybe<EnumOrder2PayState>>>;
};

export type FilterFindManyOrder2ProformaOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Boolean']>;
  gte?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  lt?: InputMaybe<Scalars['Boolean']>;
  lte?: InputMaybe<Scalars['Boolean']>;
  ne?: InputMaybe<Scalars['Boolean']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
};

export type FilterFindManyOrder2ReturnInfoInput = {
  carrier?: InputMaybe<EnumOrder2ReturnInfoCarrier>;
  number?: InputMaybe<Scalars['String']>;
};

export type FilterFindManyOrder2ShippingAddressInput = {
  _id?: InputMaybe<Scalars['MongoID']>;
  add1?: InputMaybe<Scalars['String']>;
  add2?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  company?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  countryCode?: InputMaybe<Scalars['String']>;
  mail?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  zipCode?: InputMaybe<Scalars['String']>;
};

export type FilterFindManyOrder2ShopIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyOrder2SilencedOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Boolean']>;
  gte?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  lt?: InputMaybe<Scalars['Boolean']>;
  lte?: InputMaybe<Scalars['Boolean']>;
  ne?: InputMaybe<Scalars['Boolean']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
};

export type FilterFindManyOrder2SplitOrderOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Boolean']>;
  gte?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  lt?: InputMaybe<Scalars['Boolean']>;
  lte?: InputMaybe<Scalars['Boolean']>;
  ne?: InputMaybe<Scalars['Boolean']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
};

export type FilterFindManyOrder2TrackingInfoInput = {
  carrier?: InputMaybe<EnumOrder2TrackingInfoCarrier>;
  number?: InputMaybe<Scalars['String']>;
};

export type FilterFindManyOrder2TrackingOrderStateOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<EnumOrder2TrackingOrderState>;
  gte?: InputMaybe<EnumOrder2TrackingOrderState>;
  in?: InputMaybe<Array<InputMaybe<EnumOrder2TrackingOrderState>>>;
  lt?: InputMaybe<EnumOrder2TrackingOrderState>;
  lte?: InputMaybe<EnumOrder2TrackingOrderState>;
  ne?: InputMaybe<EnumOrder2TrackingOrderState>;
  nin?: InputMaybe<Array<InputMaybe<EnumOrder2TrackingOrderState>>>;
};

export type FilterFindManyOrder2TrackingReturnStateOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<EnumOrder2TrackingReturnState>;
  gte?: InputMaybe<EnumOrder2TrackingReturnState>;
  in?: InputMaybe<Array<InputMaybe<EnumOrder2TrackingReturnState>>>;
  lt?: InputMaybe<EnumOrder2TrackingReturnState>;
  lte?: InputMaybe<EnumOrder2TrackingReturnState>;
  ne?: InputMaybe<EnumOrder2TrackingReturnState>;
  nin?: InputMaybe<Array<InputMaybe<EnumOrder2TrackingReturnState>>>;
};

export type FilterFindManyOrder2UpdatedLineTsOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Date']>;
  gte?: InputMaybe<Scalars['Date']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  lt?: InputMaybe<Scalars['Date']>;
  lte?: InputMaybe<Scalars['Date']>;
  ne?: InputMaybe<Scalars['Date']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
};

export type FilterFindManyOrder2_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyParcelBrandHouseIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyParcelInput = {
  AND?: InputMaybe<Array<FilterFindManyParcelInput>>;
  OR?: InputMaybe<Array<FilterFindManyParcelInput>>;
  _id?: InputMaybe<Scalars['MongoID']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyParcelOperatorsInput>;
  /** The brand that owns this parcel */
  brandHouseId?: InputMaybe<Scalars['MongoID']>;
  /** Optional comment for the parcel */
  comment?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['Date']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  /** Items in the parcel */
  items?: InputMaybe<Array<InputMaybe<FilterFindManyParcelItemsInput>>>;
  /** The date of the parcel creation */
  parcelDate?: InputMaybe<Scalars['Date']>;
  /** The receiver of the parcel */
  receiver?: InputMaybe<FilterFindManyAddressInfoInput>;
  /** The sender of the parcel */
  sender?: InputMaybe<FilterFindManyAddressInfoInput>;
  /** The carrier of the parcel */
  shippingCarrierId?: InputMaybe<Scalars['MongoID']>;
  shippingLabelId?: InputMaybe<Scalars['MongoID']>;
  /** The shop that owns this parcel */
  shopId?: InputMaybe<Scalars['MongoID']>;
  updatedAt?: InputMaybe<Scalars['Date']>;
};

export type FilterFindManyParcelItemsInput = {
  refId?: InputMaybe<Scalars['MongoID']>;
  refType?: InputMaybe<EnumParcelItemsRefType>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyParcelOperatorsInput = {
  _id?: InputMaybe<FilterFindManyParcel_IdOperatorsInput>;
  brandHouseId?: InputMaybe<FilterFindManyParcelBrandHouseIdOperatorsInput>;
};

export type FilterFindManyParcel_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyPlannedMailInput = {
  AND?: InputMaybe<Array<FilterFindManyPlannedMailInput>>;
  OR?: InputMaybe<Array<FilterFindManyPlannedMailInput>>;
  _id?: InputMaybe<Scalars['MongoID']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyPlannedMailOperatorsInput>;
  mailType?: InputMaybe<Scalars['String']>;
  objectId?: InputMaybe<Scalars['String']>;
  objectType?: InputMaybe<Scalars['String']>;
  sendAt?: InputMaybe<Scalars['Date']>;
  sent?: InputMaybe<Scalars['Date']>;
  sentStatus?: InputMaybe<Scalars['String']>;
  shopId?: InputMaybe<Scalars['MongoID']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyPlannedMailOperatorsInput = {
  _id?: InputMaybe<FilterFindManyPlannedMail_IdOperatorsInput>;
  shopId?: InputMaybe<FilterFindManyPlannedMailShopIdOperatorsInput>;
};

export type FilterFindManyPlannedMailShopIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyPlannedMail_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyPotentialBrandHouseIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyPotentialInput = {
  AND?: InputMaybe<Array<FilterFindManyPotentialInput>>;
  OR?: InputMaybe<Array<FilterFindManyPotentialInput>>;
  _id?: InputMaybe<Scalars['MongoID']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyPotentialOperatorsInput>;
  batchSerial?: InputMaybe<Scalars['String']>;
  brandHouseId?: InputMaybe<Scalars['MongoID']>;
  /** The brand product that this potential is related to */
  brandProductId?: InputMaybe<Scalars['MongoID']>;
  /** The brand product size that this potential is related to */
  brandProductSizeId?: InputMaybe<Scalars['MongoID']>;
  /** The brand product variant that this potential is related to */
  brandProductVariantId?: InputMaybe<Scalars['MongoID']>;
  cancelled?: InputMaybe<Scalars['Boolean']>;
  cancelledReason?: InputMaybe<EnumPotentialCancelledReason>;
  color?: InputMaybe<Scalars['String']>;
  consumerId?: InputMaybe<Scalars['MongoID']>;
  createdAt?: InputMaybe<Scalars['Date']>;
  description?: InputMaybe<Scalars['String']>;
  ean?: InputMaybe<Scalars['String']>;
  externDate?: InputMaybe<Scalars['Date']>;
  externGroupId?: InputMaybe<Scalars['String']>;
  externUrl?: InputMaybe<Scalars['String']>;
  /** True if this potential is free to be added to anyones tradein */
  freePotential?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['String']>;
  /** How masterdata identified this potential on its last answered identification (NONE when no variant was found) */
  identifiedBy?: InputMaybe<EnumPotentialIdentifiedBy>;
  imageIds?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  isUsingFakeProduct?: InputMaybe<Scalars['Boolean']>;
  /** The last time masterdata answered an identification for this potential */
  linkTs?: InputMaybe<Scalars['Date']>;
  lockedTs?: InputMaybe<Scalars['Date']>;
  /** The MAS masterdata variant id this potential is related to */
  masterVariantId?: InputMaybe<Scalars['String']>;
  masterVariantImageId?: InputMaybe<Scalars['String']>;
  masterVariantImageUrl?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  /** Whether this potential has no "date", its not actually bought, or we dont know the date - means that any date check in the tradein rules will be voided */
  noDate?: InputMaybe<Scalars['Boolean']>;
  /** If the owner of this potential was contacting with trade-in offers for this */
  notified?: InputMaybe<EnumPotentialNotified>;
  /** When was the owner of this potential contacting regarding trade-in offers */
  notifiedTs?: InputMaybe<Scalars['Date']>;
  /** The id of the product this potential is related to */
  productId?: InputMaybe<Scalars['MongoID']>;
  /** The id of the product variant this potential is related to */
  productVariantId?: InputMaybe<Scalars['MongoID']>;
  /** The id of the product variant this potential is related to */
  productVariantSizeId?: InputMaybe<Scalars['MongoID']>;
  rrp?: InputMaybe<Scalars['Float']>;
  shopId?: InputMaybe<Scalars['MongoID']>;
  size?: InputMaybe<Scalars['String']>;
  sku?: InputMaybe<Scalars['String']>;
  /** The source of the potential, e.g. order, wholesale */
  sourceType?: InputMaybe<EnumPotentialSourceType>;
  sp?: InputMaybe<Scalars['Float']>;
  spOriginal?: InputMaybe<Scalars['Float']>;
  tradeInItemId?: InputMaybe<Scalars['MongoID']>;
  updatedAt?: InputMaybe<Scalars['Date']>;
  wholeSale?: InputMaybe<FilterFindManyPotentialWholeSaleInput>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyPotentialOperatorsInput = {
  _id?: InputMaybe<FilterFindManyPotential_IdOperatorsInput>;
  brandHouseId?: InputMaybe<FilterFindManyPotentialBrandHouseIdOperatorsInput>;
  shopId?: InputMaybe<FilterFindManyPotentialShopIdOperatorsInput>;
};

export type FilterFindManyPotentialShopIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyPotentialWholeSaleInput = {
  _id?: InputMaybe<Scalars['MongoID']>;
  categoryId?: InputMaybe<Scalars['MongoID']>;
  name?: InputMaybe<Scalars['String']>;
  ruleId?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyPotential_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyPricingInput = {
  /** The ISO currency code */
  currency: Scalars['String'];
  /** The pricing value */
  value: Scalars['Float'];
};

export type FilterFindManyProductBatchSerialOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyProductBrandProductIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyProductInput = {
  AND?: InputMaybe<Array<FilterFindManyProductInput>>;
  OR?: InputMaybe<Array<FilterFindManyProductInput>>;
  _id?: InputMaybe<Scalars['MongoID']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyProductOperatorsInput>;
  batchSerial?: InputMaybe<Scalars['String']>;
  /** The brandproduct that is the master data for this product */
  brandProductId?: InputMaybe<Scalars['MongoID']>;
  collections?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAt?: InputMaybe<Scalars['Date']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  description?: InputMaybe<Scalars['String']>;
  descriptionLocalized?: InputMaybe<Array<InputMaybe<FilterFindManyLocalizationEntryInput>>>;
  disabled?: InputMaybe<Scalars['Boolean']>;
  externalId?: InputMaybe<Scalars['String']>;
  isPotential?: InputMaybe<Scalars['Boolean']>;
  isPreOwned?: InputMaybe<Scalars['Boolean']>;
  metaFields?: InputMaybe<Array<InputMaybe<FilterFindManyMetaFieldInput>>>;
  name?: InputMaybe<Scalars['String']>;
  nameLocalized?: InputMaybe<Array<InputMaybe<FilterFindManyLocalizationEntryInput>>>;
  productType?: InputMaybe<Scalars['String']>;
  productVendor?: InputMaybe<Scalars['String']>;
  shopId?: InputMaybe<Scalars['MongoID']>;
  style?: InputMaybe<Scalars['String']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAt?: InputMaybe<Scalars['Date']>;
};

export type FilterFindManyProductIsPreOwnedOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Boolean']>;
  gte?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  lt?: InputMaybe<Scalars['Boolean']>;
  lte?: InputMaybe<Scalars['Boolean']>;
  ne?: InputMaybe<Scalars['Boolean']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
};

export type FilterFindManyProductNameOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyProductOperatorsInput = {
  _id?: InputMaybe<FilterFindManyProduct_IdOperatorsInput>;
  batchSerial?: InputMaybe<FilterFindManyProductBatchSerialOperatorsInput>;
  brandProductId?: InputMaybe<FilterFindManyProductBrandProductIdOperatorsInput>;
  isPreOwned?: InputMaybe<FilterFindManyProductIsPreOwnedOperatorsInput>;
  name?: InputMaybe<FilterFindManyProductNameOperatorsInput>;
  productType?: InputMaybe<FilterFindManyProductProductTypeOperatorsInput>;
  productVendor?: InputMaybe<FilterFindManyProductProductVendorOperatorsInput>;
  shopId?: InputMaybe<FilterFindManyProductShopIdOperatorsInput>;
  style?: InputMaybe<FilterFindManyProductStyleOperatorsInput>;
};

export type FilterFindManyProductProductTypeOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyProductProductVendorOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyProductShopIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyProductStyleOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyProductVariantInput = {
  AND?: InputMaybe<Array<FilterFindManyProductVariantInput>>;
  OR?: InputMaybe<Array<FilterFindManyProductVariantInput>>;
  _id?: InputMaybe<Scalars['MongoID']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyProductVariantOperatorsInput>;
  batchSerial?: InputMaybe<Scalars['String']>;
  brandProductVariantId?: InputMaybe<Scalars['MongoID']>;
  color?: InputMaybe<Scalars['String']>;
  /** The tariff code for use in customs declarations. */
  commodityCode?: InputMaybe<Scalars['String']>;
  /** The ISO 3166-1 alpha-2 country code of origin. */
  countryOrigin?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['Date']>;
  deactivated?: InputMaybe<Scalars['Boolean']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  ean?: InputMaybe<Scalars['String']>;
  externalId?: InputMaybe<Scalars['String']>;
  imageUrls?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  isPotential?: InputMaybe<Scalars['Boolean']>;
  metaFields?: InputMaybe<Array<InputMaybe<FilterFindManyMetaFieldInput>>>;
  productId?: InputMaybe<Scalars['MongoID']>;
  rrp?: InputMaybe<Array<InputMaybe<FilterFindManyPricingInput>>>;
  shopId?: InputMaybe<Scalars['MongoID']>;
  size?: InputMaybe<Scalars['String']>;
  sku?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Date']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyProductVariantOperatorsInput = {
  _id?: InputMaybe<FilterFindManyProductVariant_IdOperatorsInput>;
  shopId?: InputMaybe<FilterFindManyProductVariantShopIdOperatorsInput>;
};

export type FilterFindManyProductVariantShopIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyProductVariantSizeInput = {
  AND?: InputMaybe<Array<FilterFindManyProductVariantSizeInput>>;
  OR?: InputMaybe<Array<FilterFindManyProductVariantSizeInput>>;
  _id?: InputMaybe<Scalars['MongoID']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyProductVariantSizeOperatorsInput>;
  createdAt?: InputMaybe<Scalars['Date']>;
  /** True if this product has been deleted */
  deleted?: InputMaybe<Scalars['Boolean']>;
  /** The EAN-13 of this variant */
  ean?: InputMaybe<Scalars['String']>;
  /** A variant unique external identifier */
  externalId?: InputMaybe<Scalars['String']>;
  /** Extra data about the variant */
  metaFields?: InputMaybe<Array<InputMaybe<FilterFindManyMetaFieldInput>>>;
  productId?: InputMaybe<Scalars['MongoID']>;
  /** The variant that owns this size */
  productVariantId?: InputMaybe<Scalars['MongoID']>;
  /** The shop that owns this variant */
  shopId?: InputMaybe<Scalars['MongoID']>;
  /** The size */
  size?: InputMaybe<Scalars['String']>;
  /** The SKU of this variant */
  sku?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Date']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyProductVariantSizeOperatorsInput = {
  _id?: InputMaybe<FilterFindManyProductVariantSize_IdOperatorsInput>;
  shopId?: InputMaybe<FilterFindManyProductVariantSizeShopIdOperatorsInput>;
};

export type FilterFindManyProductVariantSizeShopIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyProductVariantSize_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyProductVariant_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyProduct_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyRespondentAnswersInput = {
  /** The id of the question */
  questionId?: InputMaybe<Scalars['String']>;
  /** The choice answer id */
  valueC?: InputMaybe<Scalars['String']>;
  /** The text answer */
  valueT?: InputMaybe<Scalars['String']>;
};

export type FilterFindManyRespondentInput = {
  AND?: InputMaybe<Array<FilterFindManyRespondentInput>>;
  OR?: InputMaybe<Array<FilterFindManyRespondentInput>>;
  _id?: InputMaybe<Scalars['MongoID']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyRespondentOperatorsInput>;
  /** The answers made by this respondent */
  answers?: InputMaybe<Array<InputMaybe<FilterFindManyRespondentAnswersInput>>>;
  shopId?: InputMaybe<Scalars['MongoID']>;
  surveyId?: InputMaybe<Scalars['MongoID']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyRespondentOperatorsInput = {
  _id?: InputMaybe<FilterFindManyRespondent_IdOperatorsInput>;
};

export type FilterFindManyRespondent_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyScheduledEventExecutedOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Date']>;
  gte?: InputMaybe<Scalars['Date']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  lt?: InputMaybe<Scalars['Date']>;
  lte?: InputMaybe<Scalars['Date']>;
  ne?: InputMaybe<Scalars['Date']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
};

export type FilterFindManyScheduledEventInput = {
  AND?: InputMaybe<Array<FilterFindManyScheduledEventInput>>;
  OR?: InputMaybe<Array<FilterFindManyScheduledEventInput>>;
  _id?: InputMaybe<Scalars['MongoID']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyScheduledEventOperatorsInput>;
  /** Optionally data that will be sent with the event */
  data?: InputMaybe<Scalars['JSON']>;
  /** The timestamp of when the event should be executed */
  executeAt?: InputMaybe<Scalars['Date']>;
  /** The timestamp of when the event was executed */
  executed?: InputMaybe<Scalars['Date']>;
  /** The referenced object this event is attached to */
  refId?: InputMaybe<Scalars['MongoID']>;
  /** The referenced object type */
  refType?: InputMaybe<EnumScheduledEventRefType>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyScheduledEventOperatorsInput = {
  _id?: InputMaybe<FilterFindManyScheduledEvent_IdOperatorsInput>;
  executed?: InputMaybe<FilterFindManyScheduledEventExecutedOperatorsInput>;
};

export type FilterFindManyScheduledEvent_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyShopInput = {
  AND?: InputMaybe<Array<FilterFindManyShopInput>>;
  OR?: InputMaybe<Array<FilterFindManyShopInput>>;
  _id?: InputMaybe<Scalars['MongoID']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyShopOperatorsInput>;
  address?: InputMaybe<FilterFindManyAddressInfoInput>;
  brandHouseId?: InputMaybe<Scalars['MongoID']>;
  closeDate?: InputMaybe<Scalars['Date']>;
  configuration?: InputMaybe<Scalars['JSON']>;
  createdAt?: InputMaybe<Scalars['Date']>;
  currency?: InputMaybe<Scalars['String']>;
  disableContactResetDate?: InputMaybe<Scalars['Date']>;
  disabled?: InputMaybe<Scalars['Boolean']>;
  externalId?: InputMaybe<Scalars['String']>;
  externalName?: InputMaybe<Scalars['String']>;
  frontendType?: InputMaybe<EnumShopFrontendType>;
  generateThumbnails?: InputMaybe<Scalars['Boolean']>;
  /** Last time an action distribute was triggered */
  lastActionDistribute?: InputMaybe<Scalars['Date']>;
  /** Last time a klaviyo sync was triggered */
  lastKlaviyoSync?: InputMaybe<Scalars['Date']>;
  live?: InputMaybe<Scalars['Boolean']>;
  liveDate?: InputMaybe<Scalars['Date']>;
  locales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  logisticsPartnerId?: InputMaybe<Scalars['MongoID']>;
  logo?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  ressourceRedirectUrl?: InputMaybe<Scalars['String']>;
  shopCollectionUrl?: InputMaybe<Scalars['String']>;
  /** Timestamp when statistics were last updated */
  statUpdateTs?: InputMaybe<Scalars['Date']>;
  synchronizeActions?: InputMaybe<Scalars['Date']>;
  synchronizeHooks?: InputMaybe<Scalars['Date']>;
  synchronizeOrders?: InputMaybe<Scalars['Date']>;
  synchronizeProducts?: InputMaybe<Scalars['Date']>;
  tradeInBaseUrl?: InputMaybe<Scalars['String']>;
  updateVouchers?: InputMaybe<Scalars['Boolean']>;
  updateVouchersDate?: InputMaybe<Scalars['Date']>;
  updatedAt?: InputMaybe<Scalars['Date']>;
  updatedBy?: InputMaybe<FilterFindManyObjectPatchesUpdatedByInput>;
  wholeSaleActive?: InputMaybe<Scalars['Boolean']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyShopOperatorsInput = {
  _id?: InputMaybe<FilterFindManyShop_IdOperatorsInput>;
};

export type FilterFindManyShop_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyStockItemColorOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyStockItemCreatedAtOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Date']>;
  gte?: InputMaybe<Scalars['Date']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  lt?: InputMaybe<Scalars['Date']>;
  lte?: InputMaybe<Scalars['Date']>;
  ne?: InputMaybe<Scalars['Date']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
};

export type FilterFindManyStockItemEanOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyStockItemInput = {
  AND?: InputMaybe<Array<FilterFindManyStockItemInput>>;
  OR?: InputMaybe<Array<FilterFindManyStockItemInput>>;
  _id?: InputMaybe<Scalars['MongoID']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyStockItemOperatorsInput>;
  active?: InputMaybe<Scalars['Boolean']>;
  beforePrice?: InputMaybe<Scalars['Float']>;
  beforePrices?: InputMaybe<Array<InputMaybe<FilterFindManyPricingInput>>>;
  /** This is the branditem that is the parent for this shop / stockitem */
  brandItemId?: InputMaybe<Scalars['MongoID']>;
  /** This item has been confirmed at the logisticspartner at the given date */
  checked?: InputMaybe<Scalars['Date']>;
  color?: InputMaybe<Scalars['String']>;
  colorLocalized?: InputMaybe<Array<InputMaybe<FilterFindManyLocalizationEntryInput>>>;
  /** The tariff code for use in customs declarations. */
  commodityCode?: InputMaybe<Scalars['String']>;
  /** The condition of the item 1-3 */
  condition?: InputMaybe<Scalars['Float']>;
  /** The ISO 3166-1 alpha-2 country code of origin. */
  countryOrigin?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['Date']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  description?: InputMaybe<Scalars['String']>;
  descriptionLocalized?: InputMaybe<Array<InputMaybe<FilterFindManyLocalizationEntryInput>>>;
  draft?: InputMaybe<Scalars['Boolean']>;
  ean?: InputMaybe<Scalars['String']>;
  ecommerceId?: InputMaybe<Scalars['String']>;
  externId?: InputMaybe<Scalars['String']>;
  hasErrors?: InputMaybe<Scalars['Boolean']>;
  hasProblems?: InputMaybe<Scalars['Boolean']>;
  imageIds?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  isSold?: InputMaybe<Scalars['Boolean']>;
  itemNr?: InputMaybe<Scalars['Float']>;
  itemSku?: InputMaybe<Scalars['String']>;
  /** This item is registered missing by the logisticspartner at the given date */
  missing?: InputMaybe<Scalars['Date']>;
  note?: InputMaybe<Scalars['String']>;
  originalEan?: InputMaybe<Scalars['String']>;
  problems?: InputMaybe<Array<InputMaybe<FilterFindManyStockItemProblemsInput>>>;
  productType?: InputMaybe<Scalars['String']>;
  /** This is the master data product variant that this stockitem is connected to */
  productVariantId?: InputMaybe<Scalars['MongoID']>;
  /** This is the master data product variant size that this stockitem is connected to */
  productVariantSizeId?: InputMaybe<Scalars['MongoID']>;
  published?: InputMaybe<Scalars['Boolean']>;
  review?: InputMaybe<Scalars['Boolean']>;
  reviewed?: InputMaybe<Scalars['Date']>;
  sellingPrice?: InputMaybe<Scalars['Float']>;
  sellingPrices?: InputMaybe<Array<InputMaybe<FilterFindManyPricingInput>>>;
  shopId?: InputMaybe<Scalars['MongoID']>;
  size?: InputMaybe<Scalars['String']>;
  sku?: InputMaybe<Scalars['String']>;
  /** The sortorder of the stockitem */
  sortorder?: InputMaybe<Scalars['Float']>;
  source?: InputMaybe<Scalars['String']>;
  /** The type of source this stockitem is from */
  sourceType?: InputMaybe<EnumStockItemSourceType>;
  stockLocation?: InputMaybe<Scalars['String']>;
  stockLocationBag?: InputMaybe<Scalars['String']>;
  stockLocationTs?: InputMaybe<Scalars['Date']>;
  /** The url to the product in the shop */
  storeFrontUrl?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  titleLocalized?: InputMaybe<Array<InputMaybe<FilterFindManyLocalizationEntryInput>>>;
  tradeInItemId?: InputMaybe<Scalars['MongoID']>;
  updatedAt?: InputMaybe<Scalars['Date']>;
  updatedBy?: InputMaybe<FilterFindManyObjectPatchesUpdatedByInput>;
  vendor?: InputMaybe<Scalars['String']>;
};

export type FilterFindManyStockItemItemNrOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  ne?: InputMaybe<Scalars['Float']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

export type FilterFindManyStockItemItemSkuOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyStockItemMissingOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Date']>;
  gte?: InputMaybe<Scalars['Date']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  lt?: InputMaybe<Scalars['Date']>;
  lte?: InputMaybe<Scalars['Date']>;
  ne?: InputMaybe<Scalars['Date']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyStockItemOperatorsInput = {
  _id?: InputMaybe<FilterFindManyStockItem_IdOperatorsInput>;
  color?: InputMaybe<FilterFindManyStockItemColorOperatorsInput>;
  createdAt?: InputMaybe<FilterFindManyStockItemCreatedAtOperatorsInput>;
  ean?: InputMaybe<FilterFindManyStockItemEanOperatorsInput>;
  itemNr?: InputMaybe<FilterFindManyStockItemItemNrOperatorsInput>;
  itemSku?: InputMaybe<FilterFindManyStockItemItemSkuOperatorsInput>;
  missing?: InputMaybe<FilterFindManyStockItemMissingOperatorsInput>;
  originalEan?: InputMaybe<FilterFindManyStockItemOriginalEanOperatorsInput>;
  reviewed?: InputMaybe<FilterFindManyStockItemReviewedOperatorsInput>;
  size?: InputMaybe<FilterFindManyStockItemSizeOperatorsInput>;
  sourceType?: InputMaybe<FilterFindManyStockItemSourceTypeOperatorsInput>;
  stockLocation?: InputMaybe<FilterFindManyStockItemStockLocationOperatorsInput>;
  stockLocationTs?: InputMaybe<FilterFindManyStockItemStockLocationTsOperatorsInput>;
  title?: InputMaybe<FilterFindManyStockItemTitleOperatorsInput>;
  updatedAt?: InputMaybe<FilterFindManyStockItemUpdatedAtOperatorsInput>;
};

export type FilterFindManyStockItemOriginalEanOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyStockItemProblemsInput = {
  _id?: InputMaybe<Scalars['MongoID']>;
  createdAt?: InputMaybe<Scalars['Date']>;
  description?: InputMaybe<Scalars['String']>;
  solved?: InputMaybe<Scalars['Boolean']>;
};

export type FilterFindManyStockItemReviewedOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Date']>;
  gte?: InputMaybe<Scalars['Date']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  lt?: InputMaybe<Scalars['Date']>;
  lte?: InputMaybe<Scalars['Date']>;
  ne?: InputMaybe<Scalars['Date']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
};

export type FilterFindManyStockItemSizeOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyStockItemSourceTypeOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<EnumStockItemSourceType>;
  gte?: InputMaybe<EnumStockItemSourceType>;
  in?: InputMaybe<Array<InputMaybe<EnumStockItemSourceType>>>;
  lt?: InputMaybe<EnumStockItemSourceType>;
  lte?: InputMaybe<EnumStockItemSourceType>;
  ne?: InputMaybe<EnumStockItemSourceType>;
  nin?: InputMaybe<Array<InputMaybe<EnumStockItemSourceType>>>;
};

export type FilterFindManyStockItemStockLocationOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyStockItemStockLocationTsOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Date']>;
  gte?: InputMaybe<Scalars['Date']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  lt?: InputMaybe<Scalars['Date']>;
  lte?: InputMaybe<Scalars['Date']>;
  ne?: InputMaybe<Scalars['Date']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
};

export type FilterFindManyStockItemTitleOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyStockItemUpdatedAtOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Date']>;
  gte?: InputMaybe<Scalars['Date']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  lt?: InputMaybe<Scalars['Date']>;
  lte?: InputMaybe<Scalars['Date']>;
  ne?: InputMaybe<Scalars['Date']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
};

export type FilterFindManyStockItem_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManySystemMessageEntriesInput = {
  /** The occurrence message */
  text?: InputMaybe<Scalars['String']>;
  /** When this occurrence was recorded */
  timestamp?: InputMaybe<Scalars['Date']>;
};

export type FilterFindManySystemMessageInput = {
  AND?: InputMaybe<Array<FilterFindManySystemMessageInput>>;
  OR?: InputMaybe<Array<FilterFindManySystemMessageInput>>;
  _id?: InputMaybe<Scalars['MongoID']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManySystemMessageOperatorsInput>;
  /** The timestamp when the message was acknowledged */
  acknowledgedTs?: InputMaybe<Scalars['Date']>;
  /** The target audience (SYSADM, ADMIN, BRAND) */
  audience?: InputMaybe<EnumSystemMessageAudience>;
  /** If the audience is a brandhouse, this is the brandhouse id */
  audienceBrandId?: InputMaybe<Scalars['MongoID']>;
  createdAt?: InputMaybe<Scalars['Date']>;
  /** Collected occurrences of this message */
  entries?: InputMaybe<Array<InputMaybe<FilterFindManySystemMessageEntriesInput>>>;
  /** When the message was last appended to - drives the 30 day TTL */
  lastActivityTs?: InputMaybe<Scalars['Date']>;
  /** The type of message (CRITICAL, WARNING, INFORMATION) */
  messageType?: InputMaybe<EnumSystemMessageMessageType>;
  /** Subject used to group repeated messages while unacknowledged */
  subject?: InputMaybe<Scalars['String']>;
  /** When the message was first created */
  timestamp?: InputMaybe<Scalars['Date']>;
  updatedAt?: InputMaybe<Scalars['Date']>;
};

export type FilterFindManySystemMessageLastActivityTsOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Date']>;
  gte?: InputMaybe<Scalars['Date']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  lt?: InputMaybe<Scalars['Date']>;
  lte?: InputMaybe<Scalars['Date']>;
  ne?: InputMaybe<Scalars['Date']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManySystemMessageOperatorsInput = {
  _id?: InputMaybe<FilterFindManySystemMessage_IdOperatorsInput>;
  lastActivityTs?: InputMaybe<FilterFindManySystemMessageLastActivityTsOperatorsInput>;
  subject?: InputMaybe<FilterFindManySystemMessageSubjectOperatorsInput>;
};

export type FilterFindManySystemMessageSubjectOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManySystemMessage_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyTrackingBrandHouseIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyTrackingInput = {
  AND?: InputMaybe<Array<FilterFindManyTrackingInput>>;
  OR?: InputMaybe<Array<FilterFindManyTrackingInput>>;
  _id?: InputMaybe<Scalars['MongoID']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyTrackingOperatorsInput>;
  brandHouseId?: InputMaybe<Scalars['MongoID']>;
  browser?: InputMaybe<Scalars['String']>;
  endpoint?: InputMaybe<Scalars['String']>;
  ip?: InputMaybe<Scalars['String']>;
  objectId?: InputMaybe<Scalars['String']>;
  objectPayload?: InputMaybe<Scalars['JSON']>;
  objectType?: InputMaybe<Scalars['String']>;
  shopId?: InputMaybe<Scalars['MongoID']>;
  ts?: InputMaybe<Scalars['Date']>;
};

export type FilterFindManyTrackingObjectIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyTrackingOperatorsInput = {
  _id?: InputMaybe<FilterFindManyTracking_IdOperatorsInput>;
  brandHouseId?: InputMaybe<FilterFindManyTrackingBrandHouseIdOperatorsInput>;
  objectId?: InputMaybe<FilterFindManyTrackingObjectIdOperatorsInput>;
  shopId?: InputMaybe<FilterFindManyTrackingShopIdOperatorsInput>;
};

export type FilterFindManyTrackingShopIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyTracking_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyTradeInBrandHouseIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyTradeInDateTimeOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Date']>;
  gte?: InputMaybe<Scalars['Date']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  lt?: InputMaybe<Scalars['Date']>;
  lte?: InputMaybe<Scalars['Date']>;
  ne?: InputMaybe<Scalars['Date']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
};

export type FilterFindManyTradeInDeletedTsOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Date']>;
  gte?: InputMaybe<Scalars['Date']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  lt?: InputMaybe<Scalars['Date']>;
  lte?: InputMaybe<Scalars['Date']>;
  ne?: InputMaybe<Scalars['Date']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
};

export type FilterFindManyTradeInInput = {
  AND?: InputMaybe<Array<FilterFindManyTradeInInput>>;
  OR?: InputMaybe<Array<FilterFindManyTradeInInput>>;
  _id?: InputMaybe<Scalars['MongoID']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyTradeInOperatorsInput>;
  activationStrategy?: InputMaybe<EnumTradeInActivationStrategy>;
  brandHouseId?: InputMaybe<Scalars['MongoID']>;
  /** A comment about the tradein */
  comment?: InputMaybe<Scalars['String']>;
  /** The consumer id */
  consumerId?: InputMaybe<Scalars['MongoID']>;
  createdAt?: InputMaybe<Scalars['Date']>;
  /** If true, the tradein has custom carrier/delivery logic */
  customCarrier?: InputMaybe<Scalars['Boolean']>;
  dateTime?: InputMaybe<Scalars['Date']>;
  deletedBy?: InputMaybe<Scalars['String']>;
  deletedTs?: InputMaybe<Scalars['Date']>;
  notified?: InputMaybe<Scalars['Boolean']>;
  /** The payout type */
  payoutType?: InputMaybe<EnumTradeInPayoutType>;
  pickupNotified?: InputMaybe<Scalars['Boolean']>;
  pickupProcessed?: InputMaybe<Scalars['Boolean']>;
  /** We got the package? */
  registered?: InputMaybe<Scalars['Boolean']>;
  /** The date we got the package */
  registeredTs?: InputMaybe<Scalars['Date']>;
  remindedCount?: InputMaybe<Scalars['Float']>;
  remindedTs?: InputMaybe<Scalars['Date']>;
  /** The shipping carrier used for this tradein */
  shippingCarrierId?: InputMaybe<Scalars['MongoID']>;
  shippingLabelId?: InputMaybe<Scalars['MongoID']>;
  shopId?: InputMaybe<Scalars['MongoID']>;
  /** The source of the tradein */
  source?: InputMaybe<EnumTradeInSource>;
  /** Optionally a note about the source of the tradein */
  sourceNote?: InputMaybe<Scalars['String']>;
  tradeInNr?: InputMaybe<Scalars['Float']>;
  updatedAt?: InputMaybe<Scalars['Date']>;
  updatedBy?: InputMaybe<FilterFindManyObjectPatchesUpdatedByInput>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyTradeInOperatorsInput = {
  _id?: InputMaybe<FilterFindManyTradeIn_IdOperatorsInput>;
  brandHouseId?: InputMaybe<FilterFindManyTradeInBrandHouseIdOperatorsInput>;
  dateTime?: InputMaybe<FilterFindManyTradeInDateTimeOperatorsInput>;
  deletedTs?: InputMaybe<FilterFindManyTradeInDeletedTsOperatorsInput>;
  payoutType?: InputMaybe<FilterFindManyTradeInPayoutTypeOperatorsInput>;
  registered?: InputMaybe<FilterFindManyTradeInRegisteredOperatorsInput>;
  registeredTs?: InputMaybe<FilterFindManyTradeInRegisteredTsOperatorsInput>;
  shopId?: InputMaybe<FilterFindManyTradeInShopIdOperatorsInput>;
  tradeInNr?: InputMaybe<FilterFindManyTradeInTradeInNrOperatorsInput>;
};

export type FilterFindManyTradeInPayoutTypeOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<EnumTradeInPayoutType>;
  gte?: InputMaybe<EnumTradeInPayoutType>;
  in?: InputMaybe<Array<InputMaybe<EnumTradeInPayoutType>>>;
  lt?: InputMaybe<EnumTradeInPayoutType>;
  lte?: InputMaybe<EnumTradeInPayoutType>;
  ne?: InputMaybe<EnumTradeInPayoutType>;
  nin?: InputMaybe<Array<InputMaybe<EnumTradeInPayoutType>>>;
};

export type FilterFindManyTradeInRegisteredOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Boolean']>;
  gte?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  lt?: InputMaybe<Scalars['Boolean']>;
  lte?: InputMaybe<Scalars['Boolean']>;
  ne?: InputMaybe<Scalars['Boolean']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
};

export type FilterFindManyTradeInRegisteredTsOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Date']>;
  gte?: InputMaybe<Scalars['Date']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  lt?: InputMaybe<Scalars['Date']>;
  lte?: InputMaybe<Scalars['Date']>;
  ne?: InputMaybe<Scalars['Date']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
};

export type FilterFindManyTradeInShopIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyTradeInTradeInNrOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  ne?: InputMaybe<Scalars['Float']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

export type FilterFindManyTradeIn_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyUserEmailOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyUserInput = {
  AND?: InputMaybe<Array<FilterFindManyUserInput>>;
  OR?: InputMaybe<Array<FilterFindManyUserInput>>;
  _id?: InputMaybe<Scalars['MongoID']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyUserOperatorsInput>;
  /** If true, then user has access to everything */
  administrator?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Date']>;
  /** True if the user has been disabled */
  disabled?: InputMaybe<Scalars['Boolean']>;
  email?: InputMaybe<Scalars['String']>;
  lastIp?: InputMaybe<Scalars['String']>;
  lastLoginAt?: InputMaybe<Scalars['Date']>;
  name?: InputMaybe<Scalars['String']>;
  /** Link to OAuth2 user ID */
  oauthSubject?: InputMaybe<Scalars['String']>;
  /** Can contain any reference to another object, that the user is linked to - this has no effect on the users access whatsoever */
  parentId?: InputMaybe<Scalars['MongoID']>;
  resetToken?: InputMaybe<Scalars['String']>;
  resetTokenTs?: InputMaybe<Scalars['Date']>;
  /** If true, then user has a simplified view */
  simplified?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['Date']>;
};

export type FilterFindManyUserOauthSubjectOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyUserOperatorsInput = {
  _id?: InputMaybe<FilterFindManyUser_IdOperatorsInput>;
  email?: InputMaybe<FilterFindManyUserEmailOperatorsInput>;
  oauthSubject?: InputMaybe<FilterFindManyUserOauthSubjectOperatorsInput>;
};

export type FilterFindManyUser_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyVoucherAdjustmentGiftCardSyncInput = {
  /** The amount applied to the gift card in its own currency, signed like the adjustment (negative = debit) */
  amount?: InputMaybe<Scalars['Float']>;
  /** The currency of amount, i.e. the gift card's currency */
  currency?: InputMaybe<Scalars['String']>;
  /** Why the adjustment could not be applied to the gift card */
  error?: InputMaybe<Scalars['String']>;
  /** When the integration applied the adjustment or gave up */
  processedAt?: InputMaybe<Scalars['Date']>;
  /** PENDING until the integration has applied the adjustment to the gift card (APPLIED) or given up (FAILED) */
  status?: InputMaybe<EnumVoucherAdjustmentGiftCardSyncStatus>;
  /** The external transaction that applied the adjustment, e.g. a Shopify gift card credit or debit transaction id */
  transactionId?: InputMaybe<Scalars['String']>;
};

export type FilterFindManyVoucherAdjustmentInput = {
  AND?: InputMaybe<Array<FilterFindManyVoucherAdjustmentInput>>;
  OR?: InputMaybe<Array<FilterFindManyVoucherAdjustmentInput>>;
  _id?: InputMaybe<Scalars['MongoID']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyVoucherAdjustmentOperatorsInput>;
  /** The adjustment amount in vouchers currency */
  amount?: InputMaybe<Scalars['Float']>;
  /** Set by the creator: also apply this adjustment to the voucher's external gift card (passive vouchers only). Adjustments without it never change the gift card */
  applyToGiftCard?: InputMaybe<Scalars['Boolean']>;
  /** If this adjustment is a correction to the original voucher value */
  correction?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Date']>;
  /** The adjustment date */
  date?: InputMaybe<Scalars['Date']>;
  /** Where applying this adjustment to the gift card stands; only present when applyToGiftCard is set */
  giftCardSync?: InputMaybe<FilterFindManyVoucherAdjustmentGiftCardSyncInput>;
  /** Reason for adjustment */
  reason?: InputMaybe<Scalars['String']>;
  /** The shop that owns the usage refund */
  shopId?: InputMaybe<Scalars['MongoID']>;
  updatedAt?: InputMaybe<Scalars['Date']>;
  updatedBy?: InputMaybe<FilterFindManyObjectPatchesUpdatedByInput>;
  /** The voucher */
  voucherId?: InputMaybe<Scalars['MongoID']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyVoucherAdjustmentOperatorsInput = {
  _id?: InputMaybe<FilterFindManyVoucherAdjustment_IdOperatorsInput>;
  voucherId?: InputMaybe<FilterFindManyVoucherAdjustmentVoucherIdOperatorsInput>;
};

export type FilterFindManyVoucherAdjustmentVoucherIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyVoucherAdjustment_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyVoucherBrandHouseIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyVoucherCodeOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyVoucherExternIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyVoucherInput = {
  AND?: InputMaybe<Array<FilterFindManyVoucherInput>>;
  OR?: InputMaybe<Array<FilterFindManyVoucherInput>>;
  _id?: InputMaybe<Scalars['MongoID']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyVoucherOperatorsInput>;
  brandHouseId?: InputMaybe<Scalars['MongoID']>;
  code?: InputMaybe<Scalars['String']>;
  /** An alias for the voucher, this alias is typically used when an external voucher service produces other codes than C2S */
  codeAlias?: InputMaybe<Scalars['String']>;
  consumerId?: InputMaybe<Scalars['MongoID']>;
  createdAt?: InputMaybe<Scalars['Date']>;
  currency?: InputMaybe<Scalars['String']>;
  /** Custom data for the voucher */
  customData?: InputMaybe<Scalars['JSON']>;
  deleted?: InputMaybe<Scalars['Date']>;
  /** If there is a date, then this voucher is disabled since this date. It should not exist in external shop and should not be useable. It should still be monitored and updated. */
  disabled?: InputMaybe<Scalars['Date']>;
  expireDate?: InputMaybe<Scalars['Date']>;
  /** ID of the voucher in any external storefront. The existence of this ID indicates that the voucher has been created at the storefront */
  externId?: InputMaybe<Scalars['String']>;
  minimumPurchase?: InputMaybe<Scalars['Float']>;
  /** The value of the voucher, as it was last communicated to the customer */
  notificationValue?: InputMaybe<Scalars['Float']>;
  /** Whether this reward is handled completely by an external system. If true, then we will not try to calculate the remaining value of the voucher - and we expect the value to be updated by external integration */
  passive?: InputMaybe<Scalars['Boolean']>;
  /** The value to be paid out to the customer, after applying payout percentage or rules */
  payoutValue?: InputMaybe<Scalars['Float']>;
  shopId?: InputMaybe<Scalars['MongoID']>;
  tradeInId?: InputMaybe<Scalars['MongoID']>;
  /** Will be updated to reflect the registration timestamp from connected tradeins */
  tradeInReceivedTs?: InputMaybe<Scalars['Date']>;
  updatedAt?: InputMaybe<Scalars['Date']>;
  used?: InputMaybe<Scalars['Date']>;
  value?: InputMaybe<Scalars['Float']>;
  voucherPdf?: InputMaybe<Array<InputMaybe<FilterFindManyVoucherPdfInput>>>;
  voucherStrategy?: InputMaybe<EnumVoucherVoucherStrategy>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyVoucherOperatorsInput = {
  _id?: InputMaybe<FilterFindManyVoucher_IdOperatorsInput>;
  brandHouseId?: InputMaybe<FilterFindManyVoucherBrandHouseIdOperatorsInput>;
  code?: InputMaybe<FilterFindManyVoucherCodeOperatorsInput>;
  externId?: InputMaybe<FilterFindManyVoucherExternIdOperatorsInput>;
  shopId?: InputMaybe<FilterFindManyVoucherShopIdOperatorsInput>;
  tradeInId?: InputMaybe<FilterFindManyVoucherTradeInIdOperatorsInput>;
};

export type FilterFindManyVoucherPdfInput = {
  /** The language of the pdf */
  language?: InputMaybe<Scalars['String']>;
  /** If set, then this points to the storage file that contains the voucher as a PDF (english) */
  pdfId?: InputMaybe<Scalars['MongoID']>;
};

export type FilterFindManyVoucherShopIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyVoucherTradeInIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyVoucherUsageInput = {
  AND?: InputMaybe<Array<FilterFindManyVoucherUsageInput>>;
  OR?: InputMaybe<Array<FilterFindManyVoucherUsageInput>>;
  _id?: InputMaybe<Scalars['MongoID']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyVoucherUsageOperatorsInput>;
  /** The date of the usage cancellation, if cancelled - this usage will be ignored when calculating voucher balance */
  cancelDate?: InputMaybe<Scalars['Date']>;
  createdAt?: InputMaybe<Scalars['Date']>;
  /** The external ID of the order that triggered a voucher action. There can be multiple actions for the same order. */
  externOrderId?: InputMaybe<Scalars['String']>;
  items?: InputMaybe<Array<InputMaybe<FilterFindManyVoucherUsageItemsInput>>>;
  /** Shipping cost */
  shippingAmount?: InputMaybe<Scalars['Float']>;
  shopId?: InputMaybe<Scalars['MongoID']>;
  updatedAt?: InputMaybe<Scalars['Date']>;
  /** The date of usage */
  usageDate?: InputMaybe<Scalars['Date']>;
  voucherId?: InputMaybe<Scalars['MongoID']>;
};

export type FilterFindManyVoucherUsageItemsInput = {
  /** The discounted price for item(s) in shop currency */
  discountedPrice?: InputMaybe<Scalars['Float']>;
  /** The discounted price before tax for item(s) in shop currency */
  discountedPricePreTax?: InputMaybe<Scalars['Float']>;
  /** The external ID of the lineitem */
  externLineItemId?: InputMaybe<Scalars['String']>;
  /** The original price for item(s) in shop currency */
  price?: InputMaybe<Scalars['Float']>;
  /** The number of items bought */
  quantity?: InputMaybe<Scalars['Float']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyVoucherUsageOperatorsInput = {
  _id?: InputMaybe<FilterFindManyVoucherUsage_IdOperatorsInput>;
  shopId?: InputMaybe<FilterFindManyVoucherUsageShopIdOperatorsInput>;
  usageDate?: InputMaybe<FilterFindManyVoucherUsageUsageDateOperatorsInput>;
};

export type FilterFindManyVoucherUsageRefundInput = {
  AND?: InputMaybe<Array<FilterFindManyVoucherUsageRefundInput>>;
  OR?: InputMaybe<Array<FilterFindManyVoucherUsageRefundInput>>;
  _id?: InputMaybe<Scalars['MongoID']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyVoucherUsageRefundOperatorsInput>;
  /** The refund amount */
  amount?: InputMaybe<Scalars['Float']>;
  createdAt?: InputMaybe<Scalars['Date']>;
  /** Refund ID */
  externRefundId?: InputMaybe<Scalars['String']>;
  /** Whether the refund has been processed by the platform */
  processed?: InputMaybe<Scalars['Boolean']>;
  /** The date of the refund */
  refundDate?: InputMaybe<Scalars['Date']>;
  refundItems?: InputMaybe<Array<InputMaybe<FilterFindManyVoucherUsageRefundRefundItemsInput>>>;
  /** The type of refund */
  refundType?: InputMaybe<EnumVoucherUsageRefundRefundType>;
  /** The shop that owns the usage refund */
  shopId?: InputMaybe<Scalars['MongoID']>;
  updatedAt?: InputMaybe<Scalars['Date']>;
  /** The voucher usage that this refund is related to */
  voucherUsageId?: InputMaybe<Scalars['MongoID']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyVoucherUsageRefundOperatorsInput = {
  _id?: InputMaybe<FilterFindManyVoucherUsageRefund_IdOperatorsInput>;
  refundDate?: InputMaybe<FilterFindManyVoucherUsageRefundRefundDateOperatorsInput>;
  voucherUsageId?: InputMaybe<FilterFindManyVoucherUsageRefundVoucherUsageIdOperatorsInput>;
};

export type FilterFindManyVoucherUsageRefundRefundDateOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Date']>;
  gte?: InputMaybe<Scalars['Date']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  lt?: InputMaybe<Scalars['Date']>;
  lte?: InputMaybe<Scalars['Date']>;
  ne?: InputMaybe<Scalars['Date']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
};

export type FilterFindManyVoucherUsageRefundRefundItemsInput = {
  /** Line item ID */
  externLineItemId?: InputMaybe<Scalars['String']>;
  /** Number of items refunded */
  quantity?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyVoucherUsageRefundVoucherUsageIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyVoucherUsageRefund_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyVoucherUsageShopIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyVoucherUsageUsageDateOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Date']>;
  gte?: InputMaybe<Scalars['Date']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  lt?: InputMaybe<Scalars['Date']>;
  lte?: InputMaybe<Scalars['Date']>;
  ne?: InputMaybe<Scalars['Date']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
};

export type FilterFindManyVoucherUsage_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyVoucher_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyWholeSaleCategoryInput = {
  AND?: InputMaybe<Array<FilterFindManyWholeSaleCategoryInput>>;
  OR?: InputMaybe<Array<FilterFindManyWholeSaleCategoryInput>>;
  _id?: InputMaybe<Scalars['MongoID']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyWholeSaleCategoryOperatorsInput>;
  advanced?: InputMaybe<Scalars['Boolean']>;
  /** Soft-delete flag. When true, the category is hidden from listings but retained so historical TradeInItems can still resolve it. */
  deleted?: InputMaybe<Scalars['Boolean']>;
  iconId?: InputMaybe<Scalars['MongoID']>;
  name?: InputMaybe<Scalars['String']>;
  nameLocalized?: InputMaybe<Array<InputMaybe<FilterFindManyLocalizationEntryInput>>>;
  rules?: InputMaybe<Array<InputMaybe<FilterFindManyWholeSaleCategoryRulesInput>>>;
  section?: InputMaybe<Scalars['String']>;
  sectionLocalized?: InputMaybe<Array<InputMaybe<FilterFindManyLocalizationEntryInput>>>;
  shopId?: InputMaybe<Scalars['MongoID']>;
  /** The other of this category */
  sortOrder?: InputMaybe<Scalars['Float']>;
  updatedBy?: InputMaybe<FilterFindManyObjectPatchesUpdatedByInput>;
  value?: InputMaybe<Scalars['Float']>;
  voucherStrategy?: InputMaybe<EnumWholeSaleCategoryVoucherStrategy>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyWholeSaleCategoryOperatorsInput = {
  _id?: InputMaybe<FilterFindManyWholeSaleCategory_IdOperatorsInput>;
  shopId?: InputMaybe<FilterFindManyWholeSaleCategoryShopIdOperatorsInput>;
  sortOrder?: InputMaybe<FilterFindManyWholeSaleCategorySortOrderOperatorsInput>;
};

export type FilterFindManyWholeSaleCategoryRulesExpressionsInput = {
  _id?: InputMaybe<Scalars['MongoID']>;
  /** Product collection in external shop, see valid collections on Shop.productCollections */
  col?: InputMaybe<Scalars['String']>;
  expressionType?: InputMaybe<EnumWholeSaleCategoryRulesExpressionsExpressionType>;
  operator?: InputMaybe<EnumWholeSaleCategoryRulesExpressionsOperator>;
  sku?: InputMaybe<Scalars['String']>;
  /** Product tag, see valid tags on Shop.productTags */
  tag?: InputMaybe<Scalars['String']>;
};

export type FilterFindManyWholeSaleCategoryRulesInput = {
  _id?: InputMaybe<Scalars['MongoID']>;
  active?: InputMaybe<Scalars['Boolean']>;
  expressions?: InputMaybe<Array<InputMaybe<FilterFindManyWholeSaleCategoryRulesExpressionsInput>>>;
  name?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyWholeSaleCategoryShopIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyWholeSaleCategorySortOrderOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  ne?: InputMaybe<Scalars['Float']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

export type FilterFindManyWholeSaleCategory_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindOneBrandApiAutoretouchInput = {
  autoProcess?: InputMaybe<Scalars['Boolean']>;
  autoRotate?: InputMaybe<Scalars['Float']>;
  workflowId?: InputMaybe<Scalars['String']>;
};

export type FilterFindOneBrandApiB2ceuropeInput = {
  password?: InputMaybe<Scalars['String']>;
  userid?: InputMaybe<Scalars['String']>;
};

export type FilterFindOneBrandApiBurdInput = {
  password?: InputMaybe<Scalars['String']>;
  username?: InputMaybe<Scalars['String']>;
};

export type FilterFindOneBrandApiExternShopInput = {
  serviceBus?: InputMaybe<Scalars['String']>;
  topic?: InputMaybe<Scalars['String']>;
};

export type FilterFindOneBrandApiInput = {
  AND?: InputMaybe<Array<FilterFindOneBrandApiInput>>;
  OR?: InputMaybe<Array<FilterFindOneBrandApiInput>>;
  _id?: InputMaybe<Scalars['MongoID']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOneBrandApiOperatorsInput>;
  autoPublish?: InputMaybe<Scalars['Boolean']>;
  autoretouch?: InputMaybe<FilterFindOneBrandApiAutoretouchInput>;
  b2ceurope?: InputMaybe<FilterFindOneBrandApiB2ceuropeInput>;
  burd?: InputMaybe<FilterFindOneBrandApiBurdInput>;
  createdAt?: InputMaybe<Scalars['Date']>;
  externShop?: InputMaybe<FilterFindOneBrandApiExternShopInput>;
  googleTrackingId?: InputMaybe<Scalars['String']>;
  sendgrid?: InputMaybe<FilterFindOneBrandApiSendgridInput>;
  shopId?: InputMaybe<Scalars['MongoID']>;
  shopify?: InputMaybe<FilterFindOneBrandApiShopifyInput>;
  spy?: InputMaybe<FilterFindOneBrandApiSpyInput>;
  traede?: InputMaybe<FilterFindOneBrandApiTraedeInput>;
  updatedAt?: InputMaybe<Scalars['Date']>;
  updatedBy?: InputMaybe<FilterFindOneObjectPatchesUpdatedByInput>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOneBrandApiOperatorsInput = {
  _id?: InputMaybe<FilterFindOneBrandApi_IdOperatorsInput>;
};

export type FilterFindOneBrandApiSendgridInput = {
  from?: InputMaybe<Scalars['String']>;
  fromEmail?: InputMaybe<Scalars['String']>;
  token?: InputMaybe<Scalars['String']>;
};

export type FilterFindOneBrandApiShopifyInput = {
  capture?: InputMaybe<Scalars['Boolean']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  options?: InputMaybe<FilterFindOneBrandApiShopifyOptionsInput>;
  refund?: InputMaybe<Scalars['Boolean']>;
  shopifyLocationId?: InputMaybe<Scalars['String']>;
};

export type FilterFindOneBrandApiShopifyOptionsInput = {
  color?: InputMaybe<Scalars['Boolean']>;
  colorName?: InputMaybe<Scalars['String']>;
  size?: InputMaybe<Scalars['Boolean']>;
  sizeName?: InputMaybe<Scalars['String']>;
};

export type FilterFindOneBrandApiSpyInput = {
  captureUrl?: InputMaybe<Scalars['String']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  refundUrl?: InputMaybe<Scalars['String']>;
};

export type FilterFindOneBrandApiTraedeInput = {
  accessToken?: InputMaybe<Scalars['String']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  itemNumberPrefix?: InputMaybe<Scalars['String']>;
};

export type FilterFindOneBrandApi_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindOneObjectPatchesUpdatedByInput = {
  ref?: InputMaybe<Scalars['MongoID']>;
  type?: InputMaybe<Scalars['String']>;
};

export type FilterFindOneTradeInBrandHouseIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindOneTradeInDateTimeOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Date']>;
  gte?: InputMaybe<Scalars['Date']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  lt?: InputMaybe<Scalars['Date']>;
  lte?: InputMaybe<Scalars['Date']>;
  ne?: InputMaybe<Scalars['Date']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
};

export type FilterFindOneTradeInDeletedTsOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Date']>;
  gte?: InputMaybe<Scalars['Date']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  lt?: InputMaybe<Scalars['Date']>;
  lte?: InputMaybe<Scalars['Date']>;
  ne?: InputMaybe<Scalars['Date']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
};

export type FilterFindOneTradeInInput = {
  AND?: InputMaybe<Array<FilterFindOneTradeInInput>>;
  OR?: InputMaybe<Array<FilterFindOneTradeInInput>>;
  _id?: InputMaybe<Scalars['MongoID']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOneTradeInOperatorsInput>;
  activationStrategy?: InputMaybe<EnumTradeInActivationStrategy>;
  brandHouseId?: InputMaybe<Scalars['MongoID']>;
  /** A comment about the tradein */
  comment?: InputMaybe<Scalars['String']>;
  /** The consumer id */
  consumerId?: InputMaybe<Scalars['MongoID']>;
  createdAt?: InputMaybe<Scalars['Date']>;
  /** If true, the tradein has custom carrier/delivery logic */
  customCarrier?: InputMaybe<Scalars['Boolean']>;
  dateTime?: InputMaybe<Scalars['Date']>;
  deletedBy?: InputMaybe<Scalars['String']>;
  deletedTs?: InputMaybe<Scalars['Date']>;
  notified?: InputMaybe<Scalars['Boolean']>;
  /** The payout type */
  payoutType?: InputMaybe<EnumTradeInPayoutType>;
  pickupNotified?: InputMaybe<Scalars['Boolean']>;
  pickupProcessed?: InputMaybe<Scalars['Boolean']>;
  /** We got the package? */
  registered?: InputMaybe<Scalars['Boolean']>;
  /** The date we got the package */
  registeredTs?: InputMaybe<Scalars['Date']>;
  remindedCount?: InputMaybe<Scalars['Float']>;
  remindedTs?: InputMaybe<Scalars['Date']>;
  /** The shipping carrier used for this tradein */
  shippingCarrierId?: InputMaybe<Scalars['MongoID']>;
  shippingLabelId?: InputMaybe<Scalars['MongoID']>;
  shopId?: InputMaybe<Scalars['MongoID']>;
  /** The source of the tradein */
  source?: InputMaybe<EnumTradeInSource>;
  /** Optionally a note about the source of the tradein */
  sourceNote?: InputMaybe<Scalars['String']>;
  tradeInNr?: InputMaybe<Scalars['Float']>;
  updatedAt?: InputMaybe<Scalars['Date']>;
  updatedBy?: InputMaybe<FilterFindOneObjectPatchesUpdatedByInput>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOneTradeInOperatorsInput = {
  _id?: InputMaybe<FilterFindOneTradeIn_IdOperatorsInput>;
  brandHouseId?: InputMaybe<FilterFindOneTradeInBrandHouseIdOperatorsInput>;
  dateTime?: InputMaybe<FilterFindOneTradeInDateTimeOperatorsInput>;
  deletedTs?: InputMaybe<FilterFindOneTradeInDeletedTsOperatorsInput>;
  payoutType?: InputMaybe<FilterFindOneTradeInPayoutTypeOperatorsInput>;
  registered?: InputMaybe<FilterFindOneTradeInRegisteredOperatorsInput>;
  registeredTs?: InputMaybe<FilterFindOneTradeInRegisteredTsOperatorsInput>;
  shopId?: InputMaybe<FilterFindOneTradeInShopIdOperatorsInput>;
  tradeInNr?: InputMaybe<FilterFindOneTradeInTradeInNrOperatorsInput>;
};

export type FilterFindOneTradeInPayoutTypeOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<EnumTradeInPayoutType>;
  gte?: InputMaybe<EnumTradeInPayoutType>;
  in?: InputMaybe<Array<InputMaybe<EnumTradeInPayoutType>>>;
  lt?: InputMaybe<EnumTradeInPayoutType>;
  lte?: InputMaybe<EnumTradeInPayoutType>;
  ne?: InputMaybe<EnumTradeInPayoutType>;
  nin?: InputMaybe<Array<InputMaybe<EnumTradeInPayoutType>>>;
};

export type FilterFindOneTradeInRegisteredOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Boolean']>;
  gte?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  lt?: InputMaybe<Scalars['Boolean']>;
  lte?: InputMaybe<Scalars['Boolean']>;
  ne?: InputMaybe<Scalars['Boolean']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
};

export type FilterFindOneTradeInRegisteredTsOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Date']>;
  gte?: InputMaybe<Scalars['Date']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  lt?: InputMaybe<Scalars['Date']>;
  lte?: InputMaybe<Scalars['Date']>;
  ne?: InputMaybe<Scalars['Date']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
};

export type FilterFindOneTradeInShopIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindOneTradeInTradeInNrOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  ne?: InputMaybe<Scalars['Float']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

export type FilterFindOneTradeIn_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterRemoveOneIntegrationConnectorActiveForOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterRemoveOneIntegrationConnectorCloudTasksInput = {
  development?: InputMaybe<FilterRemoveOneIntegrationConnectorCloudTasksProductionInput>;
  production?: InputMaybe<FilterRemoveOneIntegrationConnectorCloudTasksProductionInput>;
  test?: InputMaybe<FilterRemoveOneIntegrationConnectorCloudTasksProductionInput>;
};

export type FilterRemoveOneIntegrationConnectorCloudTasksProductionInput = {
  /** The OIDC audience override; defaults to targetUrl when omitted */
  audience?: InputMaybe<Scalars['String']>;
  /** The Cloud Tasks queue name only; GCP project and location live in the runtime configuration of the distributor */
  queue: Scalars['String'];
  /** The HTTPS URL of the connector receiver that Cloud Tasks will POST to */
  targetUrl: Scalars['String'];
};

export type FilterRemoveOneIntegrationConnectorEventbusInput = {
  development?: InputMaybe<FilterRemoveOneIntegrationConnectorEventbusProductionInput>;
  production?: InputMaybe<FilterRemoveOneIntegrationConnectorEventbusProductionInput>;
  test?: InputMaybe<FilterRemoveOneIntegrationConnectorEventbusProductionInput>;
};

export type FilterRemoveOneIntegrationConnectorEventbusProductionInput = {
  /** The servicebus connection string */
  serviceBus: Scalars['String'];
  /** The topic for the servicebus */
  topic: Scalars['String'];
};

export type FilterRemoveOneIntegrationConnectorFieldsInput = {
  _id?: InputMaybe<Scalars['MongoID']>;
  /** Default value for the field */
  defaultValue?: InputMaybe<Scalars['String']>;
  /** Description of the field */
  description?: InputMaybe<Scalars['String']>;
  /** The field */
  field?: InputMaybe<Scalars['String']>;
  /** Namespace grouping of multiple fields */
  namespace?: InputMaybe<Scalars['String']>;
  options?: InputMaybe<Array<InputMaybe<FilterRemoveOneIntegrationConnectorFieldsOptionsInput>>>;
  /** Whether the field is required */
  required?: InputMaybe<Scalars['Boolean']>;
  /** text, number, json */
  type?: InputMaybe<Scalars['String']>;
};

export type FilterRemoveOneIntegrationConnectorFieldsOptionsInput = {
  /** Option label */
  label?: InputMaybe<Scalars['String']>;
  /** The value when the option is selected */
  value?: InputMaybe<Scalars['JSON']>;
};

export type FilterRemoveOneIntegrationConnectorInput = {
  AND?: InputMaybe<Array<FilterRemoveOneIntegrationConnectorInput>>;
  OR?: InputMaybe<Array<FilterRemoveOneIntegrationConnectorInput>>;
  _id?: InputMaybe<Scalars['MongoID']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterRemoveOneIntegrationConnectorOperatorsInput>;
  activeFor?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  autoInstallFor?: InputMaybe<Array<InputMaybe<EnumIntegrationConnectorAutoInstallFor>>>;
  cloudTasks?: InputMaybe<FilterRemoveOneIntegrationConnectorCloudTasksInput>;
  /** Whether this connector has been deleted */
  deleted?: InputMaybe<Scalars['Boolean']>;
  /** The runtime that dispatches this connector; missing means FUNCTIONS2 for backwards compatibility */
  dispatcher?: InputMaybe<EnumIntegrationConnectorDispatcher>;
  eventbus?: InputMaybe<FilterRemoveOneIntegrationConnectorEventbusInput>;
  fields?: InputMaybe<Array<InputMaybe<FilterRemoveOneIntegrationConnectorFieldsInput>>>;
  /** Icon for the connector */
  icon?: InputMaybe<Scalars['String']>;
  messages?: InputMaybe<Array<InputMaybe<EnumIntegrationConnectorMessages>>>;
  /** The name of the connector */
  name?: InputMaybe<Scalars['String']>;
  optionals?: InputMaybe<Array<InputMaybe<EnumIntegrationConnectorOptionals>>>;
  refTypes?: InputMaybe<Array<InputMaybe<EnumIntegrationConnectorRefTypes>>>;
  /** The type of connector */
  type?: InputMaybe<EnumIntegrationConnectorType>;
  /** The latest entity that updated this connector */
  updatedBy?: InputMaybe<FilterRemoveOneObjectPatchesUpdatedByInput>;
  webhook?: InputMaybe<FilterRemoveOneIntegrationConnectorWebhookInput>;
};

export type FilterRemoveOneIntegrationConnectorNameOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterRemoveOneIntegrationConnectorOperatorsInput = {
  _id?: InputMaybe<FilterRemoveOneIntegrationConnector_IdOperatorsInput>;
  activeFor?: InputMaybe<FilterRemoveOneIntegrationConnectorActiveForOperatorsInput>;
  name?: InputMaybe<FilterRemoveOneIntegrationConnectorNameOperatorsInput>;
  refTypes?: InputMaybe<FilterRemoveOneIntegrationConnectorRefTypesOperatorsInput>;
};

export type FilterRemoveOneIntegrationConnectorRefTypesOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<EnumIntegrationConnectorRefTypes>;
  gte?: InputMaybe<EnumIntegrationConnectorRefTypes>;
  in?: InputMaybe<Array<InputMaybe<EnumIntegrationConnectorRefTypes>>>;
  lt?: InputMaybe<EnumIntegrationConnectorRefTypes>;
  lte?: InputMaybe<EnumIntegrationConnectorRefTypes>;
  ne?: InputMaybe<EnumIntegrationConnectorRefTypes>;
  nin?: InputMaybe<Array<InputMaybe<EnumIntegrationConnectorRefTypes>>>;
};

export type FilterRemoveOneIntegrationConnectorWebhookInput = {
  development?: InputMaybe<FilterRemoveOneIntegrationConnectorWebhookProductionInput>;
  production?: InputMaybe<FilterRemoveOneIntegrationConnectorWebhookProductionInput>;
  test?: InputMaybe<FilterRemoveOneIntegrationConnectorWebhookProductionInput>;
};

export type FilterRemoveOneIntegrationConnectorWebhookProductionInput = {
  /** Custom headers to include in the webhook request */
  headers?: InputMaybe<Scalars['JSON']>;
  /** The URL that will receive the POST payload message */
  url: Scalars['String'];
};

export type FilterRemoveOneIntegrationConnector_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterRemoveOneObjectPatchesUpdatedByInput = {
  ref?: InputMaybe<Scalars['MongoID']>;
  type?: InputMaybe<Scalars['String']>;
};

export type FilterUpdateOneAddressInfoInput = {
  add1?: InputMaybe<Scalars['String']>;
  add2?: InputMaybe<Scalars['String']>;
  attention?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  countryCode?: InputMaybe<Scalars['String']>;
  mail?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  /** Optionally the address can come from a referenced object that has address info */
  refId?: InputMaybe<Scalars['MongoID']>;
  /** The referenced object type, Shop, BrandHouse, LogisticsPartner */
  refType?: InputMaybe<EnumAddressInfoRefType>;
  zipCode?: InputMaybe<Scalars['String']>;
};

export type FilterUpdateOneLocalizationEntryInput = {
  /** ISO Locale code */
  locale?: InputMaybe<Scalars['String']>;
  /** The localized text */
  value?: InputMaybe<Scalars['String']>;
};

export type FilterUpdateOneObjectPatchesUpdatedByInput = {
  ref?: InputMaybe<Scalars['MongoID']>;
  type?: InputMaybe<Scalars['String']>;
};

export type FilterUpdateOneParcelBrandHouseIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterUpdateOneParcelInput = {
  AND?: InputMaybe<Array<FilterUpdateOneParcelInput>>;
  OR?: InputMaybe<Array<FilterUpdateOneParcelInput>>;
  _id?: InputMaybe<Scalars['MongoID']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterUpdateOneParcelOperatorsInput>;
  /** The brand that owns this parcel */
  brandHouseId?: InputMaybe<Scalars['MongoID']>;
  /** Optional comment for the parcel */
  comment?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['Date']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  /** Items in the parcel */
  items?: InputMaybe<Array<InputMaybe<FilterUpdateOneParcelItemsInput>>>;
  /** The date of the parcel creation */
  parcelDate?: InputMaybe<Scalars['Date']>;
  /** The receiver of the parcel */
  receiver?: InputMaybe<FilterUpdateOneAddressInfoInput>;
  /** The sender of the parcel */
  sender?: InputMaybe<FilterUpdateOneAddressInfoInput>;
  /** The carrier of the parcel */
  shippingCarrierId?: InputMaybe<Scalars['MongoID']>;
  shippingLabelId?: InputMaybe<Scalars['MongoID']>;
  /** The shop that owns this parcel */
  shopId?: InputMaybe<Scalars['MongoID']>;
  updatedAt?: InputMaybe<Scalars['Date']>;
};

export type FilterUpdateOneParcelItemsInput = {
  refId?: InputMaybe<Scalars['MongoID']>;
  refType?: InputMaybe<EnumParcelItemsRefType>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterUpdateOneParcelOperatorsInput = {
  _id?: InputMaybe<FilterUpdateOneParcel_IdOperatorsInput>;
  brandHouseId?: InputMaybe<FilterUpdateOneParcelBrandHouseIdOperatorsInput>;
};

export type FilterUpdateOneParcel_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterUpdateOnePlannedMailInput = {
  AND?: InputMaybe<Array<FilterUpdateOnePlannedMailInput>>;
  OR?: InputMaybe<Array<FilterUpdateOnePlannedMailInput>>;
  _id?: InputMaybe<Scalars['MongoID']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterUpdateOnePlannedMailOperatorsInput>;
  mailType?: InputMaybe<Scalars['String']>;
  objectId?: InputMaybe<Scalars['String']>;
  objectType?: InputMaybe<Scalars['String']>;
  sendAt?: InputMaybe<Scalars['Date']>;
  sent?: InputMaybe<Scalars['Date']>;
  sentStatus?: InputMaybe<Scalars['String']>;
  shopId?: InputMaybe<Scalars['MongoID']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterUpdateOnePlannedMailOperatorsInput = {
  _id?: InputMaybe<FilterUpdateOnePlannedMail_IdOperatorsInput>;
  shopId?: InputMaybe<FilterUpdateOnePlannedMailShopIdOperatorsInput>;
};

export type FilterUpdateOnePlannedMailShopIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterUpdateOnePlannedMail_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterUpdateOneScheduledEventExecutedOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Date']>;
  gte?: InputMaybe<Scalars['Date']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  lt?: InputMaybe<Scalars['Date']>;
  lte?: InputMaybe<Scalars['Date']>;
  ne?: InputMaybe<Scalars['Date']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
};

export type FilterUpdateOneScheduledEventInput = {
  AND?: InputMaybe<Array<FilterUpdateOneScheduledEventInput>>;
  OR?: InputMaybe<Array<FilterUpdateOneScheduledEventInput>>;
  _id?: InputMaybe<Scalars['MongoID']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterUpdateOneScheduledEventOperatorsInput>;
  /** Optionally data that will be sent with the event */
  data?: InputMaybe<Scalars['JSON']>;
  /** The timestamp of when the event should be executed */
  executeAt?: InputMaybe<Scalars['Date']>;
  /** The timestamp of when the event was executed */
  executed?: InputMaybe<Scalars['Date']>;
  /** The referenced object this event is attached to */
  refId?: InputMaybe<Scalars['MongoID']>;
  /** The referenced object type */
  refType?: InputMaybe<EnumScheduledEventRefType>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterUpdateOneScheduledEventOperatorsInput = {
  _id?: InputMaybe<FilterUpdateOneScheduledEvent_IdOperatorsInput>;
  executed?: InputMaybe<FilterUpdateOneScheduledEventExecutedOperatorsInput>;
};

export type FilterUpdateOneScheduledEvent_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterUpdateOneShippingLabelInput = {
  AND?: InputMaybe<Array<FilterUpdateOneShippingLabelInput>>;
  OR?: InputMaybe<Array<FilterUpdateOneShippingLabelInput>>;
  _id?: InputMaybe<Scalars['MongoID']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterUpdateOneShippingLabelOperatorsInput>;
  archived?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Date']>;
  deletedBy?: InputMaybe<Scalars['String']>;
  deletedTs?: InputMaybe<Scalars['Date']>;
  deliveryDate?: InputMaybe<Scalars['Date']>;
  deliveryStatus?: InputMaybe<EnumShippingLabelDeliveryStatus>;
  labelCode?: InputMaybe<Scalars['String']>;
  labelExternalId?: InputMaybe<Scalars['String']>;
  labelFailed?: InputMaybe<Scalars['Boolean']>;
  labelFailedCount?: InputMaybe<Scalars['Float']>;
  labelImageId?: InputMaybe<Scalars['MongoID']>;
  lastUpdate?: InputMaybe<Scalars['Date']>;
  packageCode?: InputMaybe<Scalars['String']>;
  qrImageId?: InputMaybe<Scalars['MongoID']>;
  qrPngId?: InputMaybe<Scalars['MongoID']>;
  receiver?: InputMaybe<FilterUpdateOneAddressInfoInput>;
  sender?: InputMaybe<FilterUpdateOneAddressInfoInput>;
  shippingCarrierId?: InputMaybe<Scalars['MongoID']>;
  shopId?: InputMaybe<Scalars['MongoID']>;
  tracking?: InputMaybe<FilterUpdateOneShippingLabelTrackingInput>;
  updatedAt?: InputMaybe<Scalars['Date']>;
  updatedBy?: InputMaybe<FilterUpdateOneObjectPatchesUpdatedByInput>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterUpdateOneShippingLabelOperatorsInput = {
  _id?: InputMaybe<FilterUpdateOneShippingLabel_IdOperatorsInput>;
};

export type FilterUpdateOneShippingLabelTrackingInput = {
  carrierCode?: InputMaybe<Scalars['String']>;
  countryCode?: InputMaybe<Scalars['String']>;
  location?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  statusFailed?: InputMaybe<Scalars['Boolean']>;
  statusText?: InputMaybe<Scalars['String']>;
  time?: InputMaybe<Scalars['Date']>;
  trackingCode?: InputMaybe<Scalars['String']>;
};

export type FilterUpdateOneShippingLabel_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterUpdateOneShopInput = {
  AND?: InputMaybe<Array<FilterUpdateOneShopInput>>;
  OR?: InputMaybe<Array<FilterUpdateOneShopInput>>;
  _id?: InputMaybe<Scalars['MongoID']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterUpdateOneShopOperatorsInput>;
  address?: InputMaybe<FilterUpdateOneAddressInfoInput>;
  brandHouseId?: InputMaybe<Scalars['MongoID']>;
  closeDate?: InputMaybe<Scalars['Date']>;
  configuration?: InputMaybe<Scalars['JSON']>;
  createdAt?: InputMaybe<Scalars['Date']>;
  currency?: InputMaybe<Scalars['String']>;
  disableContactResetDate?: InputMaybe<Scalars['Date']>;
  disabled?: InputMaybe<Scalars['Boolean']>;
  externalId?: InputMaybe<Scalars['String']>;
  externalName?: InputMaybe<Scalars['String']>;
  frontendType?: InputMaybe<EnumShopFrontendType>;
  generateThumbnails?: InputMaybe<Scalars['Boolean']>;
  /** Last time an action distribute was triggered */
  lastActionDistribute?: InputMaybe<Scalars['Date']>;
  /** Last time a klaviyo sync was triggered */
  lastKlaviyoSync?: InputMaybe<Scalars['Date']>;
  live?: InputMaybe<Scalars['Boolean']>;
  liveDate?: InputMaybe<Scalars['Date']>;
  locales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  logisticsPartnerId?: InputMaybe<Scalars['MongoID']>;
  logo?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  ressourceRedirectUrl?: InputMaybe<Scalars['String']>;
  shopCollectionUrl?: InputMaybe<Scalars['String']>;
  /** Timestamp when statistics were last updated */
  statUpdateTs?: InputMaybe<Scalars['Date']>;
  synchronizeActions?: InputMaybe<Scalars['Date']>;
  synchronizeHooks?: InputMaybe<Scalars['Date']>;
  synchronizeOrders?: InputMaybe<Scalars['Date']>;
  synchronizeProducts?: InputMaybe<Scalars['Date']>;
  tradeInBaseUrl?: InputMaybe<Scalars['String']>;
  updateVouchers?: InputMaybe<Scalars['Boolean']>;
  updateVouchersDate?: InputMaybe<Scalars['Date']>;
  updatedAt?: InputMaybe<Scalars['Date']>;
  updatedBy?: InputMaybe<FilterUpdateOneObjectPatchesUpdatedByInput>;
  wholeSaleActive?: InputMaybe<Scalars['Boolean']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterUpdateOneShopOperatorsInput = {
  _id?: InputMaybe<FilterUpdateOneShop_IdOperatorsInput>;
};

export type FilterUpdateOneShop_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterUpdateOneSystemMessageEntriesInput = {
  /** The occurrence message */
  text?: InputMaybe<Scalars['String']>;
  /** When this occurrence was recorded */
  timestamp?: InputMaybe<Scalars['Date']>;
};

export type FilterUpdateOneSystemMessageInput = {
  AND?: InputMaybe<Array<FilterUpdateOneSystemMessageInput>>;
  OR?: InputMaybe<Array<FilterUpdateOneSystemMessageInput>>;
  _id?: InputMaybe<Scalars['MongoID']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterUpdateOneSystemMessageOperatorsInput>;
  /** The timestamp when the message was acknowledged */
  acknowledgedTs?: InputMaybe<Scalars['Date']>;
  /** The target audience (SYSADM, ADMIN, BRAND) */
  audience?: InputMaybe<EnumSystemMessageAudience>;
  /** If the audience is a brandhouse, this is the brandhouse id */
  audienceBrandId?: InputMaybe<Scalars['MongoID']>;
  createdAt?: InputMaybe<Scalars['Date']>;
  /** Collected occurrences of this message */
  entries?: InputMaybe<Array<InputMaybe<FilterUpdateOneSystemMessageEntriesInput>>>;
  /** When the message was last appended to - drives the 30 day TTL */
  lastActivityTs?: InputMaybe<Scalars['Date']>;
  /** The type of message (CRITICAL, WARNING, INFORMATION) */
  messageType?: InputMaybe<EnumSystemMessageMessageType>;
  /** Subject used to group repeated messages while unacknowledged */
  subject?: InputMaybe<Scalars['String']>;
  /** When the message was first created */
  timestamp?: InputMaybe<Scalars['Date']>;
  updatedAt?: InputMaybe<Scalars['Date']>;
};

export type FilterUpdateOneSystemMessageLastActivityTsOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Date']>;
  gte?: InputMaybe<Scalars['Date']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  lt?: InputMaybe<Scalars['Date']>;
  lte?: InputMaybe<Scalars['Date']>;
  ne?: InputMaybe<Scalars['Date']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterUpdateOneSystemMessageOperatorsInput = {
  _id?: InputMaybe<FilterUpdateOneSystemMessage_IdOperatorsInput>;
  lastActivityTs?: InputMaybe<FilterUpdateOneSystemMessageLastActivityTsOperatorsInput>;
  subject?: InputMaybe<FilterUpdateOneSystemMessageSubjectOperatorsInput>;
};

export type FilterUpdateOneSystemMessageSubjectOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterUpdateOneSystemMessage_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterUpdateOneWholeSaleCategoryInput = {
  AND?: InputMaybe<Array<FilterUpdateOneWholeSaleCategoryInput>>;
  OR?: InputMaybe<Array<FilterUpdateOneWholeSaleCategoryInput>>;
  _id?: InputMaybe<Scalars['MongoID']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterUpdateOneWholeSaleCategoryOperatorsInput>;
  advanced?: InputMaybe<Scalars['Boolean']>;
  /** Soft-delete flag. When true, the category is hidden from listings but retained so historical TradeInItems can still resolve it. */
  deleted?: InputMaybe<Scalars['Boolean']>;
  iconId?: InputMaybe<Scalars['MongoID']>;
  name?: InputMaybe<Scalars['String']>;
  nameLocalized?: InputMaybe<Array<InputMaybe<FilterUpdateOneLocalizationEntryInput>>>;
  rules?: InputMaybe<Array<InputMaybe<FilterUpdateOneWholeSaleCategoryRulesInput>>>;
  section?: InputMaybe<Scalars['String']>;
  sectionLocalized?: InputMaybe<Array<InputMaybe<FilterUpdateOneLocalizationEntryInput>>>;
  shopId?: InputMaybe<Scalars['MongoID']>;
  /** The other of this category */
  sortOrder?: InputMaybe<Scalars['Float']>;
  updatedBy?: InputMaybe<FilterUpdateOneObjectPatchesUpdatedByInput>;
  value?: InputMaybe<Scalars['Float']>;
  voucherStrategy?: InputMaybe<EnumWholeSaleCategoryVoucherStrategy>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterUpdateOneWholeSaleCategoryOperatorsInput = {
  _id?: InputMaybe<FilterUpdateOneWholeSaleCategory_IdOperatorsInput>;
  shopId?: InputMaybe<FilterUpdateOneWholeSaleCategoryShopIdOperatorsInput>;
  sortOrder?: InputMaybe<FilterUpdateOneWholeSaleCategorySortOrderOperatorsInput>;
};

export type FilterUpdateOneWholeSaleCategoryRulesExpressionsInput = {
  _id?: InputMaybe<Scalars['MongoID']>;
  /** Product collection in external shop, see valid collections on Shop.productCollections */
  col?: InputMaybe<Scalars['String']>;
  expressionType?: InputMaybe<EnumWholeSaleCategoryRulesExpressionsExpressionType>;
  operator?: InputMaybe<EnumWholeSaleCategoryRulesExpressionsOperator>;
  sku?: InputMaybe<Scalars['String']>;
  /** Product tag, see valid tags on Shop.productTags */
  tag?: InputMaybe<Scalars['String']>;
};

export type FilterUpdateOneWholeSaleCategoryRulesInput = {
  _id?: InputMaybe<Scalars['MongoID']>;
  active?: InputMaybe<Scalars['Boolean']>;
  expressions?: InputMaybe<Array<InputMaybe<FilterUpdateOneWholeSaleCategoryRulesExpressionsInput>>>;
  name?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterUpdateOneWholeSaleCategoryShopIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterUpdateOneWholeSaleCategorySortOrderOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  ne?: InputMaybe<Scalars['Float']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

export type FilterUpdateOneWholeSaleCategory_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export enum ImagePerspectiveEnum {
  BACK = 'BACK',
  DETAIL = 'DETAIL',
  FRONT = 'FRONT',
  OTHER = 'OTHER'
}

export enum ImageTypeEnum {
  FOCUS = 'FOCUS',
  MODEL = 'MODEL',
  OTHER = 'OTHER',
  PACK = 'PACK'
}

export type ImageUpload = {
  __typename?: 'ImageUpload';
  _id: Scalars['MongoID'];
  brandHouseId?: Maybe<Scalars['MongoID']>;
  imageId: Scalars['MongoID'];
  /** The md5 hash of the image, used when comparing images */
  imageMd5?: Maybe<Scalars['String']>;
  shopId?: Maybe<Scalars['MongoID']>;
  /** URL to the uploaded image */
  url: Scalars['String'];
};

export enum InstanceModeEnum {
  development = 'development',
  production = 'production',
  test = 'test'
}

export type IntegrationConfig = {
  __typename?: 'IntegrationConfig';
  _id: Scalars['MongoID'];
  /** Milliseconds to hold the message back on fan-out sends; targeted sends ignore it */
  delayMs?: Maybe<Scalars['Float']>;
  /** Whether the message for the connector is enabled */
  enabled: Scalars['Boolean'];
  /** The instance */
  instanceId: Scalars['MongoID'];
  /** The message type */
  message: EnumIntegrationConfigMessage;
  /** The referenced object that owns this message configuration */
  refId: Scalars['MongoID'];
};

export type IntegrationConnector = {
  __typename?: 'IntegrationConnector';
  _id: Scalars['MongoID'];
  activeFor?: Maybe<Array<Maybe<Scalars['MongoID']>>>;
  autoInstallFor?: Maybe<Array<Maybe<EnumIntegrationConnectorAutoInstallFor>>>;
  cloudTasks?: Maybe<IntegrationConnectorCloudTasks>;
  /** Whether this connector has been deleted */
  deleted?: Maybe<Scalars['Boolean']>;
  /** The runtime that dispatches this connector; missing means FUNCTIONS2 for backwards compatibility */
  dispatcher?: Maybe<EnumIntegrationConnectorDispatcher>;
  eventbus?: Maybe<IntegrationConnectorEventbus>;
  fields?: Maybe<Array<Maybe<IntegrationConnectorFields>>>;
  /** Icon for the connector */
  icon?: Maybe<Scalars['String']>;
  /** Installs of this connector */
  instances?: Maybe<Array<Maybe<IntegrationInstance>>>;
  messages?: Maybe<Array<Maybe<EnumIntegrationConnectorMessages>>>;
  /** The name of the connector */
  name: Scalars['String'];
  optionals?: Maybe<Array<Maybe<EnumIntegrationConnectorOptionals>>>;
  refTypes?: Maybe<Array<Maybe<EnumIntegrationConnectorRefTypes>>>;
  /** The type of connector */
  type: EnumIntegrationConnectorType;
  /** The latest entity that updated this connector */
  updatedBy?: Maybe<ObjectPatchesUpdatedBy>;
  webhook?: Maybe<IntegrationConnectorWebhook>;
};

export type IntegrationConnectorCloudTasks = {
  __typename?: 'IntegrationConnectorCloudTasks';
  development?: Maybe<IntegrationConnectorCloudTasksProduction>;
  production?: Maybe<IntegrationConnectorCloudTasksProduction>;
  test?: Maybe<IntegrationConnectorCloudTasksProduction>;
};

export type IntegrationConnectorCloudTasksInput = {
  development?: InputMaybe<IntegrationConnectorCloudTasksProductionInput>;
  production?: InputMaybe<IntegrationConnectorCloudTasksProductionInput>;
  test?: InputMaybe<IntegrationConnectorCloudTasksProductionInput>;
};

export type IntegrationConnectorCloudTasksProduction = {
  __typename?: 'IntegrationConnectorCloudTasksProduction';
  /** The OIDC audience override; defaults to targetUrl when omitted */
  audience?: Maybe<Scalars['String']>;
  /** The Cloud Tasks queue name only; GCP project and location live in the runtime configuration of the distributor */
  queue: Scalars['String'];
  /** The HTTPS URL of the connector receiver that Cloud Tasks will POST to */
  targetUrl: Scalars['String'];
};

export type IntegrationConnectorCloudTasksProductionInput = {
  /** The OIDC audience override; defaults to targetUrl when omitted */
  audience?: InputMaybe<Scalars['String']>;
  /** The Cloud Tasks queue name only; GCP project and location live in the runtime configuration of the distributor */
  queue: Scalars['String'];
  /** The HTTPS URL of the connector receiver that Cloud Tasks will POST to */
  targetUrl: Scalars['String'];
};

export type IntegrationConnectorEventbus = {
  __typename?: 'IntegrationConnectorEventbus';
  development?: Maybe<IntegrationConnectorEventbusProduction>;
  production?: Maybe<IntegrationConnectorEventbusProduction>;
  test?: Maybe<IntegrationConnectorEventbusProduction>;
};

export type IntegrationConnectorEventbusInput = {
  development?: InputMaybe<IntegrationConnectorEventbusProductionInput>;
  production?: InputMaybe<IntegrationConnectorEventbusProductionInput>;
  test?: InputMaybe<IntegrationConnectorEventbusProductionInput>;
};

export type IntegrationConnectorEventbusProduction = {
  __typename?: 'IntegrationConnectorEventbusProduction';
  /** The servicebus connection string */
  serviceBus: Scalars['String'];
  /** The topic for the servicebus */
  topic: Scalars['String'];
};

export type IntegrationConnectorEventbusProductionInput = {
  /** The servicebus connection string */
  serviceBus: Scalars['String'];
  /** The topic for the servicebus */
  topic: Scalars['String'];
};

export type IntegrationConnectorFields = {
  __typename?: 'IntegrationConnectorFields';
  _id?: Maybe<Scalars['MongoID']>;
  /** Default value for the field */
  defaultValue?: Maybe<Scalars['String']>;
  /** Description of the field */
  description: Scalars['String'];
  /** The field */
  field: Scalars['String'];
  /** Namespace grouping of multiple fields */
  namespace: Scalars['String'];
  options?: Maybe<Array<Maybe<IntegrationConnectorFieldsOptions>>>;
  /** Whether the field is required */
  required?: Maybe<Scalars['Boolean']>;
  /** text, number, json */
  type: Scalars['String'];
};

export type IntegrationConnectorFieldsInput = {
  _id?: InputMaybe<Scalars['MongoID']>;
  /** Default value for the field */
  defaultValue?: InputMaybe<Scalars['String']>;
  /** Description of the field */
  description: Scalars['String'];
  /** The field */
  field: Scalars['String'];
  /** Namespace grouping of multiple fields */
  namespace: Scalars['String'];
  options?: InputMaybe<Array<InputMaybe<IntegrationConnectorFieldsOptionsInput>>>;
  /** Whether the field is required */
  required?: InputMaybe<Scalars['Boolean']>;
  /** text, number, json */
  type: Scalars['String'];
};

export type IntegrationConnectorFieldsOptions = {
  __typename?: 'IntegrationConnectorFieldsOptions';
  /** Option label */
  label: Scalars['String'];
  /** The value when the option is selected */
  value: Scalars['JSON'];
};

export type IntegrationConnectorFieldsOptionsInput = {
  /** Option label */
  label: Scalars['String'];
  /** The value when the option is selected */
  value: Scalars['JSON'];
};

export type IntegrationConnectorWebhook = {
  __typename?: 'IntegrationConnectorWebhook';
  development?: Maybe<IntegrationConnectorWebhookProduction>;
  production?: Maybe<IntegrationConnectorWebhookProduction>;
  test?: Maybe<IntegrationConnectorWebhookProduction>;
};

export type IntegrationConnectorWebhookInput = {
  development?: InputMaybe<IntegrationConnectorWebhookProductionInput>;
  production?: InputMaybe<IntegrationConnectorWebhookProductionInput>;
  test?: InputMaybe<IntegrationConnectorWebhookProductionInput>;
};

export type IntegrationConnectorWebhookProduction = {
  __typename?: 'IntegrationConnectorWebhookProduction';
  /** Custom headers to include in the webhook request */
  headers?: Maybe<Scalars['JSON']>;
  /** The URL that will receive the POST payload message */
  url: Scalars['String'];
};

export type IntegrationConnectorWebhookProductionInput = {
  /** Custom headers to include in the webhook request */
  headers?: InputMaybe<Scalars['JSON']>;
  /** The URL that will receive the POST payload message */
  url: Scalars['String'];
};

export type IntegrationInstance = {
  __typename?: 'IntegrationInstance';
  _id: Scalars['MongoID'];
  /** List of configs for this instance */
  configs?: Maybe<Array<Maybe<IntegrationConfig>>>;
  /** The connector */
  connector?: Maybe<IntegrationConnector>;
  /** The connector that was installed */
  connectorId: Scalars['MongoID'];
  /** Whether the install has been deleted */
  deleted?: Maybe<Scalars['Boolean']>;
  /** Whether the install has been enabled */
  enabled: Scalars['Boolean'];
  /** The mode of the instance */
  mode: EnumIntegrationInstanceMode;
  /** Name of the instance */
  name: Scalars['String'];
  /** The brandHouse referenced object */
  refBrandHouse?: Maybe<BrandHouse>;
  /** The owner of the install */
  refId: Scalars['MongoID'];
  /** The logisticspartner referenced object */
  refLogisticsPartner?: Maybe<LogisticsPartner>;
  /** Name of the object that owns this instance */
  refName?: Maybe<Scalars['String']>;
  /** The shop referenced object */
  refShop?: Maybe<Shop>;
  /** What type this connector is referenced to */
  refType: EnumIntegrationInstanceRefType;
  /** List of settings for this instance */
  settings?: Maybe<Array<Maybe<IntegrationSetting>>>;
};

export type IntegrationMessage = {
  __typename?: 'IntegrationMessage';
  _id: Scalars['MongoID'];
  /** The timestamp of the message ackknowledgement, webhooks will set this instantly based on 200 OK response. Servicebus implementationw will need to send an ackknowledge event. */
  acknowledged?: Maybe<Scalars['Date']>;
  /** Timestamp of the message creation */
  created: Scalars['Date'];
  /** The source environment of this message : production, development or test */
  env?: Maybe<Scalars['String']>;
  /** If the message was unable to be delivered, this will have contain a timestamp of when we gave up */
  failed?: Maybe<Scalars['Date']>;
  /** The instance for this message */
  instance?: Maybe<IntegrationInstance>;
  /** The instance identifier */
  instanceId: Scalars['MongoID'];
  lockedId?: Maybe<Scalars['String']>;
  /** The message type */
  message: EnumIntegrationMessageMessage;
  /** True if failure */
  messageFailed?: Maybe<Scalars['Boolean']>;
  /** True if ignored */
  messageIgnored?: Maybe<Scalars['Boolean']>;
  /** If this message is a retry message, then this points the the previous message that initiated the retry */
  parentId?: Maybe<Scalars['MongoID']>;
  /** Optionally a payload for the message */
  payload?: Maybe<Scalars['JSON']>;
  /** The brandHouse referenced object */
  refBrandHouse?: Maybe<BrandHouse>;
  /** The referenced object this message originated from */
  refId: Scalars['MongoID'];
  /** The logisticspartner referenced object */
  refLogisticsPartner?: Maybe<LogisticsPartner>;
  /** The shop referenced object */
  refShop?: Maybe<Shop>;
  /** The referenced object type, Shop, BrandHouse, LogisticsPartner */
  refType: Scalars['String'];
  /** Dispatcher-private fence for result writes. Only 0 (job accepted) and 1 (terminal job result) are defined; a result may only be replaced by a strictly newer sequence. Absent for single-reply messages */
  replySequence?: Maybe<Scalars['Float']>;
  /** Optionally a result data blob for the message */
  result?: Maybe<Scalars['JSON']>;
  /** If a result data blob was stored, then this timestamp holds the timestamp for it - otherwise null */
  resultTs?: Maybe<Scalars['Date']>;
  /** The timestamp of when the message should be sent, this is typically used when retrying failed messages, but can be used for any message delaying */
  sendAt?: Maybe<Scalars['Date']>;
  /** Timestamp of when the message was last sent */
  sent?: Maybe<Scalars['Date']>;
  /** The number of times we have sent this message */
  sentCount: Scalars['Float'];
};

export enum IntegrationMessageEnum {
  CANCELLED = 'CANCELLED',
  CAPTURE = 'CAPTURE',
  CONSUMERACTIVITY = 'CONSUMERACTIVITY',
  CREATEORDER = 'CREATEORDER',
  CREATEPARCEL = 'CREATEPARCEL',
  CREATESHIPPINGLABEL = 'CREATESHIPPINGLABEL',
  CREATETRADEIN = 'CREATETRADEIN',
  DELETE = 'DELETE',
  FULFILL = 'FULFILL',
  INIT = 'INIT',
  OPTIMIZEBYSALESRANK = 'OPTIMIZEBYSALESRANK',
  PERIODICREPORT = 'PERIODICREPORT',
  REFUND = 'REFUND',
  REMOVEBG = 'REMOVEBG',
  REQUESTACCESS = 'REQUESTACCESS',
  REQUESTORDERS = 'REQUESTORDERS',
  REQUESTPOTENTIALS = 'REQUESTPOTENTIALS',
  REQUESTPRODUCTS = 'REQUESTPRODUCTS',
  REQUESTVOUCHERS = 'REQUESTVOUCHERS',
  SCHEDULEDEVENT = 'SCHEDULEDEVENT',
  SENDMAIL = 'SENDMAIL',
  UPDATEBRAND = 'UPDATEBRAND',
  UPDATEBRANDITEM = 'UPDATEBRANDITEM',
  UPDATECATEGORY = 'UPDATECATEGORY',
  UPDATECONFIG = 'UPDATECONFIG',
  UPDATEINVENTORY = 'UPDATEINVENTORY',
  UPDATEINVOICE = 'UPDATEINVOICE',
  UPDATEORDER = 'UPDATEORDER',
  UPDATEPARCEL = 'UPDATEPARCEL',
  UPDATEPOTENTIALS = 'UPDATEPOTENTIALS',
  UPDATESHIPPINGLABEL = 'UPDATESHIPPINGLABEL',
  UPDATESHOP = 'UPDATESHOP',
  UPDATESTOCKITEMS = 'UPDATESTOCKITEMS',
  UPDATETRADEIN = 'UPDATETRADEIN',
  UPDATEVOUCHER = 'UPDATEVOUCHER'
}

/** List of items with pagination. */
export type IntegrationMessageIntegrationMessagePagination = {
  __typename?: 'IntegrationMessageIntegrationMessagePagination';
  /** Total object count. */
  count?: Maybe<Scalars['Int']>;
  /** Array of objects. */
  items?: Maybe<Array<IntegrationMessage>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type IntegrationMessageResult = {
  __typename?: 'IntegrationMessageResult';
  messageFailed?: Maybe<Scalars['Boolean']>;
  messageIgnored?: Maybe<Scalars['Boolean']>;
  result?: Maybe<Scalars['JSON']>;
  resultTs?: Maybe<Scalars['Date']>;
};

export type IntegrationSetting = {
  __typename?: 'IntegrationSetting';
  _id: Scalars['MongoID'];
  /** The instance */
  instanceId: Scalars['MongoID'];
  /** The key of the setting */
  key: Scalars['String'];
  /** The referenced object, owner of this setting */
  refId: Scalars['MongoID'];
  /** The value of the setting */
  value?: Maybe<Scalars['JSON']>;
};

export type IntegrationSettingInInput = {
  /** The key of the setting */
  key: Scalars['String'];
  /** The value of the setting */
  value?: InputMaybe<Scalars['JSON']>;
};

export type Invoice = {
  __typename?: 'Invoice';
  _id: Scalars['MongoID'];
  /** The brandhouse */
  brandHouse?: Maybe<BrandHouse>;
  brandHouseId: Scalars['MongoID'];
  currency?: Maybe<Scalars['String']>;
  invoiceDate?: Maybe<Scalars['Date']>;
  invoiceId: Scalars['String'];
  locked?: Maybe<Scalars['Boolean']>;
  paid?: Maybe<Scalars['Boolean']>;
  /** Total amount of this invoice */
  total?: Maybe<InvoiceTotal>;
  updatedBy?: Maybe<ObjectPatchesUpdatedBy>;
};

export type InvoiceAdjustment = {
  __typename?: 'InvoiceAdjustment';
  _id: Scalars['MongoID'];
  amount: Scalars['Float'];
  /** The brandhouse */
  brandHouse?: Maybe<BrandHouse>;
  brandHouseId: Scalars['MongoID'];
  createdAt?: Maybe<Scalars['Date']>;
  description: Scalars['String'];
  /** The current invoice settings for this brandhouse. */
  settings?: Maybe<InvoiceSetting>;
  updatedBy?: Maybe<ObjectPatchesUpdatedBy>;
};

export type InvoiceLine = {
  __typename?: 'InvoiceLine';
  _id: Scalars['MongoID'];
  brandHouseId: Scalars['MongoID'];
  cost: Scalars['Float'];
  createdAt?: Maybe<Scalars['Date']>;
  currency: Scalars['String'];
  /** The invoice this line belongs to */
  invoice?: Maybe<Invoice>;
  invoiceId: Scalars['MongoID'];
  /** The calculated date for this invoice line, and depends on when the invoicing is enabled for the customer */
  lineDate: Scalars['Date'];
  lineId: Scalars['String'];
  lineIndex: Scalars['Float'];
  lineType: EnumInvoiceLineLineType;
  updatedAt?: Maybe<Scalars['Date']>;
};

export type InvoiceSetting = {
  __typename?: 'InvoiceSetting';
  _id: Scalars['MongoID'];
  /** The brandhouse for this invoice settings */
  brandHouse?: Maybe<BrandHouse>;
  brandHouseId: Scalars['MongoID'];
  costPerItem?: Maybe<Scalars['Float']>;
  currency?: Maybe<Scalars['String']>;
  /** Custom data for the invoice settings */
  customData?: Maybe<Scalars['JSON']>;
  fee?: Maybe<Scalars['Float']>;
  minPlatformCost?: Maybe<Scalars['Float']>;
  shops?: Maybe<Array<Maybe<InvoiceSettingShops>>>;
  updatedBy?: Maybe<ObjectPatchesUpdatedBy>;
};

export type InvoiceSettingInput = {
  _id?: InputMaybe<Scalars['MongoID']>;
  brandHouseId: Scalars['MongoID'];
  costPerItem?: InputMaybe<Scalars['Float']>;
  currency?: InputMaybe<Scalars['String']>;
  /** Custom data for the invoice settings */
  customData?: InputMaybe<Scalars['JSON']>;
  fee?: InputMaybe<Scalars['Float']>;
  minPlatformCost?: InputMaybe<Scalars['Float']>;
  shops?: InputMaybe<Array<InputMaybe<InvoiceSettingShopsInput>>>;
  updatedBy?: InputMaybe<ObjectPatchesUpdatedByInput>;
};

export type InvoiceSettingShops = {
  __typename?: 'InvoiceSettingShops';
  _id?: Maybe<Scalars['MongoID']>;
  comment?: Maybe<Scalars['String']>;
  costPerItem: Scalars['Float'];
  pickPackFee: Scalars['Float'];
  saleCommisionPct: Scalars['Float'];
  shippingOrder: Scalars['Float'];
  shippingReturn: Scalars['Float'];
  shippingTradeIn: Scalars['Float'];
  shopId: Scalars['MongoID'];
};

export type InvoiceSettingShopsInput = {
  _id?: InputMaybe<Scalars['MongoID']>;
  comment?: InputMaybe<Scalars['String']>;
  costPerItem: Scalars['Float'];
  pickPackFee: Scalars['Float'];
  saleCommisionPct: Scalars['Float'];
  shippingOrder: Scalars['Float'];
  shippingReturn: Scalars['Float'];
  shippingTradeIn: Scalars['Float'];
  shopId: Scalars['MongoID'];
};

export type InvoiceTotal = {
  __typename?: 'InvoiceTotal';
  sections?: Maybe<Array<Maybe<InvoiceTotalSection>>>;
  total: Scalars['Float'];
};

export type InvoiceTotalSection = {
  __typename?: 'InvoiceTotalSection';
  lines?: Maybe<Array<Maybe<InvoiceTotalValue>>>;
  title: Scalars['String'];
  total: Scalars['Float'];
};

export type InvoiceTotalValue = {
  __typename?: 'InvoiceTotalValue';
  count: Scalars['Int'];
  lineType: EnumInvoiceLineLineType;
  sum: Scalars['Float'];
  title: Scalars['String'];
};

export type ItemImageInfo = {
  __typename?: 'ItemImageInfo';
  altText?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  imageMd5?: Maybe<Scalars['String']>;
  imageUrl: Scalars['String'];
  localImagePath?: Maybe<Scalars['String']>;
  masterDataImage: Scalars['Boolean'];
  version: Scalars['Float'];
};

export type ItemIssue = {
  __typename?: 'ItemIssue';
  _id: Scalars['MongoID'];
  brandHouseId: Scalars['MongoID'];
  /** The brand item this issue belongs to */
  brandItem?: Maybe<BrandItemResolved>;
  brandItemId: Scalars['MongoID'];
  /** The date when the issue was created */
  createdAt?: Maybe<Scalars['Date']>;
  deleted?: Maybe<Scalars['Boolean']>;
  externId?: Maybe<Scalars['String']>;
  /** URL to the image of the issue */
  imageUrl?: Maybe<Scalars['String']>;
  issue: Scalars['String'];
  location?: Maybe<EnumItemIssueLocation>;
  /** Marker X position as percent (0-100) of image width, origin top-left */
  markX?: Maybe<Scalars['Float']>;
  /** Marker Y position as percent (0-100) of image height, origin top-left */
  markY?: Maybe<Scalars['Float']>;
  /** Coordinate of the issue, A1, B2, etc. */
  point?: Maybe<Scalars['String']>;
  processedId?: Maybe<Scalars['MongoID']>;
  /** The processed image url of the issue, will return null until the image is processed */
  processedUrl?: Maybe<Scalars['String']>;
  sortOrder?: Maybe<Scalars['Float']>;
  updatedBy?: Maybe<ObjectPatchesUpdatedBy>;
};


export type ItemIssueProcessedUrlArgs = {
  failOnError?: InputMaybe<Scalars['Boolean']>;
};

export type ItemIssueInput = {
  externId?: InputMaybe<Scalars['String']>;
  /** URL to the image of the issue */
  imageUrl?: InputMaybe<Scalars['String']>;
  issue: Scalars['String'];
  location?: InputMaybe<EnumItemIssueLocation>;
  /** Marker X position as percent (0-100) of image width, origin top-left */
  markX?: InputMaybe<Scalars['Float']>;
  /** Marker Y position as percent (0-100) of image height, origin top-left */
  markY?: InputMaybe<Scalars['Float']>;
  /** Coordinate of the issue, A1, B2, etc. */
  point?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Scalars['Float']>;
};

/** List of items with pagination. */
export type ItemIssueItemIssuesPagination = {
  __typename?: 'ItemIssueItemIssuesPagination';
  /** Total object count. */
  count?: Maybe<Scalars['Int']>;
  /** Array of objects. */
  items?: Maybe<Array<ItemIssue>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

/** How a related-items group was found. Connectors must ignore values they do not know. */
export enum ItemRelationMatch {
  MASTERDATA = 'MASTERDATA'
}

export enum ItemSourceType {
  CLAIM = 'CLAIM',
  NEWITEM = 'NEWITEM',
  SAMPLE = 'SAMPLE',
  SECONDHAND = 'SECONDHAND'
}

export type Localization = {
  __typename?: 'Localization';
  /** The default value of this key */
  default?: Maybe<Scalars['String']>;
  /** Whether this value was inherited from the brand */
  inherited: Scalars['Boolean'];
  key?: Maybe<Scalars['String']>;
  language?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type LocalizationEntry = {
  __typename?: 'LocalizationEntry';
  /** ISO Locale code */
  locale: Scalars['String'];
  /** The localized text */
  value: Scalars['String'];
};

export type LocalizationEntryInput = {
  /** ISO Locale code */
  locale: Scalars['String'];
  /** The localized text */
  value: Scalars['String'];
};

export type LocalizationInput = {
  key?: InputMaybe<Scalars['String']>;
  language?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

export type LocalizedMetaFieldInstance = {
  __typename?: 'LocalizedMetaFieldInstance';
  /** The language of the localized metafields */
  language?: Maybe<Scalars['String']>;
  /** The metafields */
  metaFields?: Maybe<Array<Maybe<MetaField>>>;
};

export type LocalizedMetaFieldInstanceInput = {
  /** The language of the localized metafields */
  language?: InputMaybe<Scalars['String']>;
  /** The metafields */
  metaFields?: InputMaybe<Array<InputMaybe<MetaFieldInput>>>;
};

export type LoginResult = {
  __typename?: 'LoginResult';
  simplified: Scalars['Boolean'];
  token: Scalars['String'];
  userType: Scalars['String'];
};

export type LogisticsPartner = {
  __typename?: 'LogisticsPartner';
  _id: Scalars['MongoID'];
  address?: Maybe<Scalars['String']>;
  address2?: Maybe<Scalars['String']>;
  /** API KEY for the logisticspartner, use this to obtain an accessToken */
  apiKey?: Maybe<Scalars['String']>;
  /** API Secret for the logisticspartner, use this to obtain an accessToken */
  apiSecret?: Maybe<Scalars['String']>;
  attention?: Maybe<Scalars['String']>;
  autoretouch?: Maybe<LogisticsPartnerAutoretouch>;
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  countryCode?: Maybe<Scalars['String']>;
  mail?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  zipCode?: Maybe<Scalars['String']>;
};

export type LogisticsPartnerAutoretouch = {
  __typename?: 'LogisticsPartnerAutoretouch';
  accessToken?: Maybe<Scalars['String']>;
  expireTs?: Maybe<Scalars['Date']>;
  refreshToken?: Maybe<Scalars['String']>;
};

export type MasterDataImage = {
  __typename?: 'MasterDataImage';
  _id?: Maybe<Scalars['String']>;
  perspective?: Maybe<Scalars['String']>;
  position?: Maybe<Scalars['Float']>;
  thumbUrl?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type MasterDataKeyValue = {
  __typename?: 'MasterDataKeyValue';
  key: Scalars['String'];
  value: Scalars['String'];
};

export type MasterDataLocalizedValue = {
  __typename?: 'MasterDataLocalizedValue';
  locale: Scalars['String'];
  value: Scalars['String'];
};

export type MasterDataProduct = {
  __typename?: 'MasterDataProduct';
  _id: Scalars['String'];
  externalId?: Maybe<Scalars['String']>;
  images?: Maybe<Array<Maybe<MasterDataImage>>>;
  name?: Maybe<Array<Maybe<MasterDataLocalizedValue>>>;
  options?: Maybe<Array<Maybe<MasterDataProductOption>>>;
  style?: Maybe<Scalars['String']>;
  tags?: Maybe<Array<Maybe<Scalars['String']>>>;
  type?: Maybe<Array<Maybe<MasterDataLocalizedValue>>>;
  variants?: Maybe<Array<Maybe<MasterDataVariant>>>;
  vendor?: Maybe<Array<Maybe<MasterDataLocalizedValue>>>;
};

export type MasterDataProductOption = {
  __typename?: 'MasterDataProductOption';
  key: Scalars['String'];
  name?: Maybe<Array<Maybe<MasterDataLocalizedValue>>>;
  type?: Maybe<Scalars['String']>;
};

export type MasterDataVariant = {
  __typename?: 'MasterDataVariant';
  _id: Scalars['String'];
  ean?: Maybe<Scalars['String']>;
  externalId?: Maybe<Scalars['String']>;
  images?: Maybe<Array<Maybe<MasterDataImage>>>;
  options?: Maybe<Array<Maybe<MasterDataKeyValue>>>;
  sku?: Maybe<Scalars['String']>;
};

export type MasterDataVisualSearchHit = {
  __typename?: 'MasterDataVisualSearchHit';
  imageUrl?: Maybe<Scalars['String']>;
  product?: Maybe<MasterDataProduct>;
  score: Scalars['Float'];
};

export type MetaField = {
  __typename?: 'MetaField';
  /** Custom data to the metafield */
  customData?: Maybe<Scalars['JSON']>;
  /** The key to identify the metafield within a namespace */
  key: Scalars['String'];
  /** Optionally a namespace for the metafield, used to group related fields */
  namespace?: Maybe<Scalars['String']>;
  /** Type of the value, required */
  type?: Maybe<EnumMetaFieldType>;
  /** The metafield value, JSON data */
  value: Scalars['JSON'];
};

export type MetaFieldInput = {
  /** Custom data to the metafield */
  customData?: InputMaybe<Scalars['JSON']>;
  /** The key to identify the metafield within a namespace */
  key: Scalars['String'];
  /** Optionally a namespace for the metafield, used to group related fields */
  namespace?: InputMaybe<Scalars['String']>;
  /** Type of the value, required */
  type?: InputMaybe<EnumMetaFieldType>;
  /** The metafield value, JSON data */
  value: Scalars['JSON'];
};

export type MetaFieldInstance = {
  __typename?: 'MetaFieldInstance';
  /** If the metafield was auto added by configuration */
  auto?: Maybe<Scalars['Boolean']>;
  /** Custom data to the metafield */
  customData?: Maybe<Scalars['JSON']>;
  /** The key to identify the metafield within a namespace */
  key: Scalars['String'];
  /** Optionally a namespace for the metafield, used to group related fields */
  namespace?: Maybe<Scalars['String']>;
  /** Type of the value, required */
  type?: Maybe<EnumMetaFieldInstanceType>;
  /** The metafield value, JSON data */
  value: Scalars['JSON'];
};

export type MetaFieldInstanceInput = {
  /** If the metafield was auto added by configuration */
  auto?: InputMaybe<Scalars['Boolean']>;
  /** Custom data to the metafield */
  customData?: InputMaybe<Scalars['JSON']>;
  /** The key to identify the metafield within a namespace */
  key: Scalars['String'];
  /** Optionally a namespace for the metafield, used to group related fields */
  namespace?: InputMaybe<Scalars['String']>;
  /** Type of the value, required */
  type?: InputMaybe<EnumMetaFieldInstanceType>;
  /** The metafield value, JSON data */
  value: Scalars['JSON'];
};

export type MongoError = ErrorInterface & {
  __typename?: 'MongoError';
  /** MongoDB error code */
  code?: Maybe<Scalars['Int']>;
  /** MongoDB error message */
  message?: Maybe<Scalars['String']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  ApproveImageAudit?: Maybe<BrandItemImage>;
  /** Create an audit note with explanation. Required before making configuration changes when requireChangeExplanation is enabled on the brand. */
  AuditNoteCreate?: Maybe<AuditNote>;
  BrandApiUpdate?: Maybe<BrandApi>;
  BrandCarrierActivate?: Maybe<BrandCarrier>;
  BrandHouseAuthorize?: Maybe<AuthorizeResult>;
  BrandHouseCreate?: Maybe<BrandHouse>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  BrandHouseUpdate?: Maybe<UpdateByIdBrandHousePayload>;
  /** Updates the branditem caches */
  BrandItemAdjustAutoImages?: Maybe<Scalars['Boolean']>;
  /** Links a BrandItem to a masterdata (MAS) variant: sets masterDataVariantId, unsets the legacy brandProductSize/snapshot fields, and pulls fresh MAS data. Replaces any legacy snapshot link. */
  BrandItemAttachMasterDataVariant?: Maybe<BrandItem>;
  /** Attaches masterdata to a branditem by copying (snapshotting) all masterdata fields into the item's own fields. The item will NOT have a live reference to masterdata, making it immune to future masterdata changes. */
  BrandItemAttachSnapshot?: Maybe<BrandItem>;
  /** Ends the item's active boost immediately and propagates normal price and ordering to storefronts (C2S-1103) */
  BrandItemBoostCancel?: Maybe<BrandItem>;
  /** Starts (or replaces) a time-limited boost on a READY, unsold item: a price discount, top-of-collection visibility, or both. The boost starts immediately and ends at endTs (C2S-1103) */
  BrandItemBoostSet?: Maybe<BrandItem>;
  /** Updates the branditem caches */
  BrandItemCalculatePrices?: Maybe<Array<Maybe<Pricing>>>;
  /** Updates the inventory checked and missing flag for this branditem */
  BrandItemChecked?: Maybe<BrandItem>;
  /** Will delete the branditem */
  BrandItemDelete?: Maybe<BrandItem>;
  /** Will update the group for the given branditems, only brandItems that as updated will be returned */
  BrandItemGroupUpdate?: Maybe<Array<Maybe<BrandItem>>>;
  BrandItemImageClearRemoveBgResult?: Maybe<BrandItemImage>;
  /** Updates the branditem caches */
  BrandItemImageRotate?: Maybe<BrandItemImage>;
  /** Triggers integration updates for the provided brand items */
  BrandItemIntegrationUpdate: Scalars['Boolean'];
  /** Triggers the OPTIMIZEBYSALESRANK integration message to all shops belonging to the specified brandHouse */
  BrandItemOptimizeBySalesRank: Scalars['Boolean'];
  /** Promotes a branditem to being a source for a new masterdata */
  BrandItemPromote?: Maybe<BrandItem>;
  /** This mutation will ensure that a stockitem in the specific shop exists for the given brandItem. If the stockitem already exists, nothing will be done */
  BrandItemPush?: Maybe<Array<Maybe<BrandItemShopInfo>>>;
  /** This mutation will trigger a new retouch on all images that needs a retouch */
  BrandItemRetouch?: Maybe<Array<Maybe<BrandItem>>>;
  /** This mutation will either save an existing branditem or create a new one */
  BrandItemUpdate?: Maybe<BrandItem>;
  /** Updates the branditem caches */
  BrandItemUpdateCache: Scalars['Boolean'];
  /** Updates the branditem identifiers */
  BrandItemUpdateIdentifiers: Scalars['Boolean'];
  /** Will update the price for any currency configured on the brandhouse, that is not set on the item - as long as one price is set */
  BrandItemUpdatePrices?: Maybe<Array<Maybe<BrandItem>>>;
  /** Queues a missing-only MAS masterdata backfill for linked BrandItems */
  BrandItemsBackfillMasterData?: Maybe<BrandItemMasterDataBackfillResult>;
  /** Queues an admin-approved BrandItem migration to MAS masterDataVariantId */
  BrandItemsMigrateToMasterDataVariant?: Maybe<BrandItemMasterDataMigrationRun>;
  /** Queues an admin-only preview for migrating BrandItems to MAS masterDataVariantId */
  BrandItemsPreviewMasterDataVariantMigration?: Maybe<BrandItemMasterDataMigrationRun>;
  /** Publishes / unpublishes many brand items across storefronts in one call. Storefronts not listed in `shops` are left untouched, and only items not already in the requested state are written. Like BrandItemPush, publishing an item moves it to READY. */
  BrandItemsPublish?: Maybe<BrandItemsPublishResult>;
  /** Queues a fresh MAS masterdata refresh for linked BrandItems */
  BrandItemsRefreshMasterData?: Maybe<BrandItemMasterDataRefreshResult>;
  BrandLocalizationsUpdate?: Maybe<Array<Maybe<Localization>>>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  BrandProductGroupCreate?: Maybe<CreateOneBrandProductGroupPayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  BrandProductGroupUpdate?: Maybe<UpdateByIdBrandProductGroupPayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  BrandProductImageUpdate?: Maybe<UpdateByIdBrandProductImagePayload>;
  BrandProductImport: Scalars['Boolean'];
  BrandProductReset: Scalars['Boolean'];
  BrandProductSynchronize?: Maybe<BrandProduct>;
  BrandProductVariantRebuildIndex: Scalars['Int'];
  BrandRuleActivation?: Maybe<BrandRule>;
  BrandRuleCreate?: Maybe<BrandRule>;
  BrandRuleDelete?: Maybe<BrandRule>;
  BrandRuleUpdate?: Maybe<BrandRule>;
  BrandRuleUpdateStatistics: Scalars['Boolean'];
  /** Copy BrandSetting fields from sourceShopId to targetShopId. Both shops must belong to the same brand house. Identity, language, country, contact, and external-integration fields are not copied. */
  BrandSettingsCopy?: Maybe<BrandSetting>;
  BrandSettingsUpdate?: Maybe<BrandSetting>;
  BrickMailActivate?: Maybe<BrickMail>;
  BrickMailCopy: Scalars['Boolean'];
  BrickMailReset: Scalars['Boolean'];
  BrickMailReset2: Scalars['Boolean'];
  BrickMailTest: Scalars['String'];
  BrickMailUpdate?: Maybe<Array<Maybe<BrickMailValidation>>>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  CampaignCreate?: Maybe<CreateOneCampaignPayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  CampaignUpdate?: Maybe<UpdateByIdCampaignPayload>;
  CircularPayout?: Maybe<CircularPoint>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  CircularPayoutUpdateById?: Maybe<UpdateByIdCircularPayoutTypePayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  CircularPointCreate?: Maybe<CreateOneCircularPointPayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  CircularPointUpdate?: Maybe<UpdateByIdCircularPointPayload>;
  /** Mutation that will update the synchronization timestamps for the given services */
  CompleteSynchronize?: Maybe<SyncCompleteResult>;
  /** Unified consumer access request. When an integration handles REQUESTACCESS, it must either: (1) create the consumer and call ConsumerCompleteAccess, or (2) call ConsumerRejectAccess if the consumer is not found. */
  ConsumerAccessRequest?: Maybe<ConsumerAccessRequestResult>;
  ConsumerActivitySetup: Scalars['String'];
  /** Completes the consumer access flow after integration processing. The backend derives authMethod from the stored integration message. */
  ConsumerCompleteAccess?: Maybe<ConsumerCompleteAccessResult>;
  ConsumerCreate?: Maybe<Consumer>;
  ConsumerCreate2?: Maybe<Consumer>;
  ConsumerJourneyRebuild?: Maybe<Scalars['Boolean']>;
  ConsumerLogin?: Maybe<ConsumerAuthorizeResult>;
  /** Updates mail state */
  ConsumerMailUpdate: Scalars['Boolean'];
  ConsumerMerge?: Maybe<Consumer>;
  /** Called by integrations when the consumer is not found. Sends an 'unknown' email if sendMail was true in the original request. */
  ConsumerRejectAccess?: Maybe<ConsumerRejectAccessResult>;
  ConsumerRequestAccess?: Maybe<ConsumerSendMail>;
  /** Will trigger the request for access flow, and return the tokens for the messages sent - these tokens can be used to query for status */
  ConsumerRequestAccessFlow?: Maybe<Array<Scalars['String']>>;
  /** Will trigger the request for potentials, and return the tokens for the messages sent - these tokens can be used to query for status */
  ConsumerRequestPotentials?: Maybe<Array<Scalars['String']>>;
  ConsumerSendCode?: Maybe<ConsumerSendCode>;
  ConsumerSendEmail: Scalars['Boolean'];
  /** Idempotent get-or-create for non-selfCreated consumers, keyed by the given identifier+identifierType. Returns the existing consumer (merging in non-null input fields) or creates a new one with selfCreated=false and personId set to the identifier. */
  ConsumerSynchronize?: Maybe<Consumer>;
  ConsumerUpdate?: Maybe<Consumer>;
  ConsumerVerifyCode?: Maybe<ConsumerVerifyCode>;
  CurrencyConvert?: Maybe<CurrencyConversion>;
  DataViewCreate?: Maybe<DataView>;
  DigitalPassportInit?: Maybe<DigitalPassport>;
  ExternOrder2Synchronize?: Maybe<ExternOrder2>;
  ExternOrderSynchronize?: Maybe<ExternOrder>;
  /** Snooze an audit result out of the queue for 24 hours; it reappears once the hide window passes. Does not change audit/go-live state. */
  HideImageAudit?: Maybe<BrandItemImage>;
  ImageRotate?: Maybe<ImageUpload>;
  IntegrationConfigUpdate?: Maybe<IntegrationConfig>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  IntegrationConnectorCreate?: Maybe<CreateOneIntegrationConnectorPayload>;
  /** Remove one document: 1) Remove with hooks via findOneAndRemove. 2) Return removed document. */
  IntegrationConnectorDelete?: Maybe<RemoveOneIntegrationConnectorPayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  IntegrationConnectorUpdate?: Maybe<UpdateByIdIntegrationConnectorPayload>;
  IntegrationDelete?: Maybe<Array<Maybe<IntegrationConfig>>>;
  /** Will install the given connector and enable all its currently supported messages. */
  IntegrationInstall?: Maybe<IntegrationInstance>;
  /** Will execute the given integration function and return tokens that can be used by IntegrationMessage to query for status and results */
  IntegrationMessageExecute?: Maybe<Array<Scalars['String']>>;
  /** Rerunning deliberately performs the connector action again. This is not exactly-once and may repeat downstream side effects if the original action actually succeeded. */
  IntegrationMessageRerun: IntegrationMessage;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  IntegrationMessageUpdate?: Maybe<UpdateByIdIntegrationMessagePayload>;
  /** Re-initializes the integration instance by sending an init message. */
  IntegrationReInitialize?: Maybe<IntegrationInstance>;
  IntegrationSettingUpdate?: Maybe<Array<Maybe<IntegrationSetting>>>;
  /** Will uninstall the given connector. */
  IntegrationUnInstall?: Maybe<IntegrationInstance>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  InvoiceAdjustmentCreate?: Maybe<CreateOneInvoiceAdjustmentPayload>;
  InvoiceDelete: Scalars['Boolean'];
  InvoiceRebuild: Scalars['Boolean'];
  /** Resets all invoices newer than the provided invoice, will return a list of reset invoices */
  InvoiceReset?: Maybe<Array<Maybe<Invoice>>>;
  InvoiceSettingUpdate?: Maybe<InvoiceSetting>;
  InvoiceUpdate?: Maybe<Invoice>;
  /** Synchronizes the option set with the given input */
  ItemIssueSynchronize?: Maybe<Array<Maybe<ItemIssue>>>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  ItemIssueUpdate?: Maybe<UpdateByIdItemIssuePayload>;
  /** Will start the klaviyo synchronization. */
  KlaviyoSynchronize?: Maybe<Scalars['String']>;
  LogisticsPartnerAuthorize?: Maybe<AuthorizeResult>;
  LogisticsPartnerCreate?: Maybe<LogisticsPartner>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  LogisticsPartnerUpdate?: Maybe<UpdateByIdLogisticsPartnerPayload>;
  /** Resets the checked flag on all stock items- used when counting stock */
  LogisticsStockItemsCheckedReset?: Maybe<Scalars['Boolean']>;
  /** Synchronizes the option set with the given input */
  OptionSynchronize?: Maybe<OptionSet>;
  OrderCapture?: Maybe<Order2>;
  /** Mutation that will create and register a return label for the order */
  OrderCreateReturn: ShippingLabel;
  /** Extend the return deadline for orders placed within a date range. Only updates orders where the new deadline actually extends beyond their normal deadline. If brandHouseId is not provided, admin access is required and all active brandHouses are processed. */
  OrderExtendReturnDeadline?: Maybe<OrderExtendReturnDeadlineResult>;
  OrderFulfill?: Maybe<Order2>;
  /** Send a delivery note print request to the order's current logistics partner and return status tokens. */
  OrderPrintDeliveryNote: Array<Scalars['String']>;
  /** Mutation that registers externally provided tracking information for a return without creating a shipping label */
  OrderRegisterReturn: Order2;
  /** Resend the order's CREATEORDER message to one integration installation and return status tokens. Administrators only. */
  OrderResendCreate: Array<Scalars['String']>;
  /** Clears return data on an order (returnShippingLabelId, returnInfo, and all OrderLineReturn records), allowing a new return to be created */
  OrderResetReturn: Order2;
  OrderSetTracking?: Maybe<Order2>;
  /** Use this to update an order from an external system. */
  OrderSynchronize?: Maybe<Order2>;
  /** Use this to update the order in create2STAY. */
  OrderUpdate?: Maybe<Order2>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  ParcelCreate?: Maybe<CreateOneParcelPayload>;
  /** Will update the tracking status of a parcel, return true if successful, false if not. Requires admin access. */
  ParcelTrackingUpdate?: Maybe<Scalars['Boolean']>;
  /** Update one document: 1) Retrieve one document via findOne. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  ParcelUpdate?: Maybe<UpdateOneParcelPayload>;
  /** Update one document: 1) Retrieve one document via findOne. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  PlannedMailUpdate?: Maybe<UpdateOnePlannedMailPayload>;
  PotentialCreate?: Maybe<Potential>;
  PotentialDelete?: Maybe<Potential>;
  PotentialDistribute: Scalars['Boolean'];
  PotentialSynchronize?: Maybe<Array<Maybe<Potential>>>;
  PotentialSynchronize2?: Maybe<Array<Maybe<Potential>>>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  PotentialUpdate?: Maybe<UpdateByIdPotentialPayload>;
  ProductDisable?: Maybe<Product>;
  ProductImageCreate?: Maybe<Array<Maybe<ProductImage>>>;
  ProductSynchronize?: Maybe<Product>;
  ProductSynchronizeTranslations?: Maybe<Product>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  ProductUpdateById?: Maybe<UpdateByIdProductPayload>;
  ProductsAutocomplete?: Maybe<Array<Maybe<Product>>>;
  QRSessionCreate?: Maybe<QrSession>;
  QRSessionUpdate?: Maybe<QrSession>;
  RejectImageAudit?: Maybe<BrandItemImage>;
  /** Reject a background-removal audit result and pause the brand item by adding a 'Retake photos' problem. The item is blocked from go-live in every shop until that problem is solved. */
  RejectImageAuditRetake?: Maybe<BrandItemImage>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  ScheduledEventCreate?: Maybe<CreateOneScheduledEventPayload>;
  /** Update one document: 1) Retrieve one document via findOne. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  ScheduledEventUpdate?: Maybe<UpdateOneScheduledEventPayload>;
  SendSystemMail: Scalars['Boolean'];
  ShippingCarrierUpdate?: Maybe<ShippingCarrier>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  ShippingLabelCreate?: Maybe<CreateOneShippingLabelPayload>;
  /** Update one document: 1) Retrieve one document via findOne. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  ShippingLabelUpdate?: Maybe<UpdateOneShippingLabelPayload>;
  /** Mutation that will create and register a shop given its license key and some required info */
  ShopCreate?: Maybe<Shop>;
  /** Mutation that will create and register an external shop given its license key and some required info */
  ShopCreate2?: Maybe<Shop>;
  /** Deletes the shop and ALL its data from the service. This cant be undone, so be careful. Cant delete LIVE shops */
  ShopDelete?: Maybe<Shop>;
  /** Will trigger a maintainance of the shop and mark the it as live */
  ShopLaunch?: Maybe<Shop>;
  /** Resets the shop and its data */
  ShopReset?: Maybe<Shop>;
  /** Updates core shop properties */
  ShopUpdate?: Maybe<Shop>;
  /** Update one document: 1) Retrieve one document via findOne. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  ShopUpdateOne?: Maybe<UpdateOneShopPayload>;
  /** Will initiate a synchronization with the external shop. This will trigger a webhook/eventbus call to the external shop */
  StartSynchronize?: Maybe<SyncResult>;
  /** Updates the inventory checked and missing flag for this stockitem */
  StockItemChecked?: Maybe<StockItem>;
  StockItemCreate?: Maybe<StockItem>;
  StockItemCreateEmpty?: Maybe<StockItem>;
  StockItemDelete?: Maybe<StockItem>;
  StockItemImageAutoRetouch?: Maybe<StockItemImage>;
  StockItemImageAutoRetouch2?: Maybe<Array<Maybe<StockItemImage>>>;
  StockItemImageAutoRetouchAll?: Maybe<Array<Maybe<StockItemImage>>>;
  StockItemImageCreate?: Maybe<StockItemImage>;
  StockItemImageCreate2?: Maybe<StockItemImage>;
  StockItemImageDelete?: Maybe<StockItemImage>;
  StockItemImageRotate?: Maybe<StockItemImage>;
  StockItemImageSetOrder?: Maybe<Array<Maybe<StockItemImage>>>;
  /** Synchronizes the images of the stockitem */
  StockItemImageSynchronize?: Maybe<StockItem>;
  StockItemImageUpdate?: Maybe<StockItemImage>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  StockItemImageUpdateById?: Maybe<UpdateByIdStockItemImagePayload>;
  /** Updates the stockitem inventory, 0 */
  StockItemInventoryUpdate?: Maybe<StockItem>;
  /** Pushes a notification to the external shop that it should update our version of the stockitem with their data */
  StockItemPull?: Maybe<Scalars['Boolean']>;
  /** Resets the itemSku of all stockitems */
  StockItemResetSKU?: Maybe<Array<Maybe<StockItem>>>;
  StockItemUpdate?: Maybe<StockItem>;
  /** Calculates the selling price of the input stockitem */
  StockItemsRecalculatePrice?: Maybe<Scalars['Float']>;
  /** Updates the stockitems selling prices */
  StockItemsRecalculatePrices?: Maybe<Array<Maybe<StockItem>>>;
  /** Registration of an already stored file. The file must be located in one of the designated directories */
  StorageFileRegister?: Maybe<StorageFile>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  SurveyRespondentCreate?: Maybe<CreateOneRespondentPayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  SurveyUpdate?: Maybe<UpdateByIdSurveyPayload>;
  /** Update one document: 1) Retrieve one document via findOne. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  SystemMessageAcknowledge?: Maybe<UpdateOneSystemMessagePayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  SystemMessageCreate?: Maybe<CreateOneSystemMessagePayload>;
  TradeInCreate?: Maybe<TradeIn>;
  TradeInDelete?: Maybe<TradeIn>;
  /** Deletes the tradein */
  TradeInDelete2?: Maybe<TradeIn>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  TradeInItemUpdateById?: Maybe<UpdateByIdTradeInItemPayload>;
  /** Will remove the items from the tradein, and will rebalance the vouchers issued. Make sure the vouchers hasnt been used before running this mutation. */
  TradeInItemsReject?: Maybe<Array<Maybe<TradeInItem>>>;
  /** Resync all tradeins for a brand house by triggering handleTradeInUpdated for each */
  TradeInResync?: Maybe<TradeInResyncResult>;
  /** Synchronize a tradein with the system, this will create a new tradein if the ID is not provided, or update the tradein if the ID is provided. If the delete flag is set to true, the tradein will be deleted. */
  TradeInSynchronize?: Maybe<TradeIn>;
  /** Will update the tradein */
  TradeInUpdate?: Maybe<TradeIn>;
  /** Toggle the disable bit of a users access to brand / logisticspartner */
  UserAccessToggle?: Maybe<UserAccess>;
  /** Invites the user identified by the email to access either a brandhouse or a logisticspartner at the platform. If the user does not exist, then the user will be able to create an account before accepting the actual access */
  UserInvite?: Maybe<UserAccess>;
  /** The current user accepts the invitation to access a ressource on the platform */
  UserInviteAccept?: Maybe<UserAccess>;
  /** The user joins the platform */
  UserInviteJoin?: Maybe<LoginResult>;
  UserLogin?: Maybe<LoginResult>;
  /** Recovers the password of the user and sends a mail with a link */
  UserRecoverPassword?: Maybe<Scalars['Boolean']>;
  UserRefresh?: Maybe<RefreshResult>;
  /** Resets the account password */
  UserResetPassword?: Maybe<Scalars['Boolean']>;
  /** Updates the password of the user */
  UserUpdatePassword?: Maybe<User>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  VoucherAdjustmentCreate?: Maybe<CreateOneVoucherAdjustmentPayload>;
  /** Called by the integration that holds the voucher's gift card, to record whether it applied an adjustment created with applyToGiftCard. Only a PENDING adjustment changes; reporting the recorded outcome again is a no-op. */
  VoucherAdjustmentGiftCardSyncUpdate?: Maybe<VoucherAdjustment>;
  VoucherDelete?: Maybe<Voucher>;
  /** Enable / disable voucher */
  VoucherEnable?: Maybe<Voucher>;
  /** Called by the integration when the voucher has been generated in the storefront. The storefront must supply a externId in order to activate the voucher flow. The storefront can remove the externId to signal that the voucher has been removed. */
  VoucherFrontUpdate?: Maybe<Voucher>;
  /** Deletes the vouchers and generates a new one with a total sum matching the input vouchers */
  VoucherMerge?: Maybe<Voucher>;
  /** Instantly sends reminders to all customers that has unused vouchers */
  VoucherSendReminder: Scalars['Boolean'];
  VoucherSynchronize?: Maybe<Voucher>;
  /** This mutation will synchronize the voucher usage */
  VoucherUsageSynchronize?: Maybe<VoucherUsage>;
  /** Copy all non-deleted WholeSaleCategory documents from one shop to another within the same brand house. Refuses if the target already has categories. */
  WholeSaleCategoryCopy?: Maybe<Array<Maybe<WholeSaleCategory>>>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  WholeSaleCategoryCreate?: Maybe<CreateOneWholeSaleCategoryPayload>;
  WholeSaleCategoryDelete?: Maybe<WholeSaleCategory>;
  /** Update one document: 1) Retrieve one document via findOne. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  WholeSaleCategoryUpdate?: Maybe<UpdateOneWholeSaleCategoryPayload>;
};


export type MutationApproveImageAuditArgs = {
  brandItemImageId: Scalars['MongoID'];
};


export type MutationAuditNoteCreateArgs = {
  brandHouseId?: InputMaybe<Scalars['MongoID']>;
  explanation: Scalars['String'];
  shopId?: InputMaybe<Scalars['MongoID']>;
};


export type MutationBrandApiUpdateArgs = {
  api?: InputMaybe<BrandApiInput>;
  shopId: Scalars['String'];
};


export type MutationBrandCarrierActivateArgs = {
  active: Scalars['Boolean'];
  brandHouseId: Scalars['MongoID'];
  shippingCarrierId: Scalars['MongoID'];
};


export type MutationBrandHouseAuthorizeArgs = {
  license: Scalars['String'];
  shopId?: InputMaybe<Scalars['String']>;
};


export type MutationBrandHouseCreateArgs = {
  logisticsPartnerId: Scalars['String'];
  name: Scalars['String'];
};


export type MutationBrandHouseUpdateArgs = {
  _id: Scalars['MongoID'];
  record: UpdateByIdBrandHouseInput;
};


export type MutationBrandItemAdjustAutoImagesArgs = {
  brandItemId: Scalars['MongoID'];
};


export type MutationBrandItemAttachMasterDataVariantArgs = {
  brandItemId: Scalars['MongoID'];
  masterDataVariantId: Scalars['String'];
};


export type MutationBrandItemAttachSnapshotArgs = {
  brandItemId: Scalars['MongoID'];
  brandProductSizeId: Scalars['MongoID'];
};


export type MutationBrandItemBoostCancelArgs = {
  brandItemId: Scalars['MongoID'];
};


export type MutationBrandItemBoostSetArgs = {
  brandItemId: Scalars['MongoID'];
  endTs: Scalars['Date'];
  pricePct?: InputMaybe<Scalars['Int']>;
  visibility: Scalars['Boolean'];
};


export type MutationBrandItemCalculatePricesArgs = {
  brandHouseId: Scalars['MongoID'];
  item?: InputMaybe<BrandItemInputInput>;
  shopId?: InputMaybe<Scalars['MongoID']>;
};


export type MutationBrandItemCheckedArgs = {
  brandItemId: Scalars['MongoID'];
  checked?: InputMaybe<Scalars['Boolean']>;
  missing?: InputMaybe<Scalars['Boolean']>;
};


export type MutationBrandItemDeleteArgs = {
  brandItemId: Scalars['MongoID'];
};


export type MutationBrandItemGroupUpdateArgs = {
  brandItemIds?: InputMaybe<Array<Scalars['MongoID']>>;
};


export type MutationBrandItemImageClearRemoveBgResultArgs = {
  brandItemImageId: Scalars['MongoID'];
};


export type MutationBrandItemImageRotateArgs = {
  brandHouseId: Scalars['MongoID'];
  imageId: Scalars['MongoID'];
  rotate: Scalars['Float'];
};


export type MutationBrandItemIntegrationUpdateArgs = {
  brandItemIds: Array<Scalars['MongoID']>;
  instanceId: Scalars['MongoID'];
};


export type MutationBrandItemOptimizeBySalesRankArgs = {
  brandHouseId: Scalars['MongoID'];
};


export type MutationBrandItemPromoteArgs = {
  brandItemId: Scalars['MongoID'];
};


export type MutationBrandItemPushArgs = {
  active: Scalars['Boolean'];
  brandItemId: Scalars['MongoID'];
  shopId?: InputMaybe<Scalars['MongoID']>;
};


export type MutationBrandItemRetouchArgs = {
  brandItemIds: Array<Scalars['MongoID']>;
};


export type MutationBrandItemUpdateArgs = {
  brandHouseId: Scalars['MongoID'];
  input?: InputMaybe<BrandItemInputInput>;
  silent?: InputMaybe<Scalars['Boolean']>;
  snapshotAfter?: InputMaybe<Scalars['Boolean']>;
};


export type MutationBrandItemUpdateCacheArgs = {
  brandHouseId?: InputMaybe<Scalars['MongoID']>;
  brandItemId?: InputMaybe<Scalars['MongoID']>;
  silent?: InputMaybe<Scalars['Boolean']>;
};


export type MutationBrandItemUpdateIdentifiersArgs = {
  brandHouseId: Scalars['MongoID'];
};


export type MutationBrandItemUpdatePricesArgs = {
  brandItemIds?: InputMaybe<Array<Scalars['MongoID']>>;
};


export type MutationBrandItemsBackfillMasterDataArgs = {
  brandItemIds: Array<Scalars['MongoID']>;
};


export type MutationBrandItemsMigrateToMasterDataVariantArgs = {
  selections: Array<BrandItemMasterDataMigrationSelectionInput>;
  sourcePreviewRunId?: InputMaybe<Scalars['MongoID']>;
};


export type MutationBrandItemsPreviewMasterDataVariantMigrationArgs = {
  brandItemIds: Array<Scalars['MongoID']>;
};


export type MutationBrandItemsPublishArgs = {
  brandItemIds: Array<Scalars['MongoID']>;
  shops: Array<BrandItemsPublishShopInput>;
};


export type MutationBrandItemsRefreshMasterDataArgs = {
  brandItemIds: Array<Scalars['MongoID']>;
  refreshImages?: InputMaybe<Scalars['Boolean']>;
};


export type MutationBrandLocalizationsUpdateArgs = {
  auditNoteId?: InputMaybe<Scalars['MongoID']>;
  brandHouseId?: InputMaybe<Scalars['MongoID']>;
  localizations?: InputMaybe<Array<InputMaybe<LocalizationInput>>>;
  shopId?: InputMaybe<Scalars['MongoID']>;
  type: Scalars['String'];
};


export type MutationBrandProductGroupCreateArgs = {
  record: CreateOneBrandProductGroupInput;
};


export type MutationBrandProductGroupUpdateArgs = {
  _id: Scalars['MongoID'];
  record: UpdateByIdBrandProductGroupInput;
};


export type MutationBrandProductImageUpdateArgs = {
  _id: Scalars['MongoID'];
  record: UpdateByIdBrandProductImageInput;
};


export type MutationBrandProductImportArgs = {
  brandHouseId: Scalars['MongoID'];
  productId?: InputMaybe<Scalars['MongoID']>;
};


export type MutationBrandProductResetArgs = {
  brandHouseId: Scalars['MongoID'];
  groupId: Scalars['MongoID'];
  potentials?: InputMaybe<Scalars['Boolean']>;
};


export type MutationBrandProductSynchronizeArgs = {
  brandHouseId: Scalars['MongoID'];
  input?: InputMaybe<BrandProductSynchronizeInput>;
  mode?: InputMaybe<BrandSynchronizeMode>;
  source?: InputMaybe<Scalars['String']>;
};


export type MutationBrandProductVariantRebuildIndexArgs = {
  brandHouseId: Scalars['MongoID'];
};


export type MutationBrandRuleActivationArgs = {
  active: Scalars['Boolean'];
  auditNoteId?: InputMaybe<Scalars['MongoID']>;
  ruleId: Scalars['MongoID'];
  shopId: Scalars['MongoID'];
};


export type MutationBrandRuleCreateArgs = {
  auditNoteId?: InputMaybe<Scalars['MongoID']>;
  shopId: Scalars['MongoID'];
};


export type MutationBrandRuleDeleteArgs = {
  auditNoteId?: InputMaybe<Scalars['MongoID']>;
  ruleId: Scalars['MongoID'];
  shopId: Scalars['MongoID'];
};


export type MutationBrandRuleUpdateArgs = {
  auditNoteId?: InputMaybe<Scalars['MongoID']>;
  rule?: InputMaybe<BrandRuleInput>;
};


export type MutationBrandRuleUpdateStatisticsArgs = {
  shopId: Scalars['MongoID'];
};


export type MutationBrandSettingsCopyArgs = {
  auditNoteId?: InputMaybe<Scalars['MongoID']>;
  sourceShopId: Scalars['MongoID'];
  targetShopId: Scalars['MongoID'];
};


export type MutationBrandSettingsUpdateArgs = {
  api?: InputMaybe<BrandSettingInput>;
  auditNoteId?: InputMaybe<Scalars['MongoID']>;
  brandHouseId?: InputMaybe<Scalars['MongoID']>;
  shopId?: InputMaybe<Scalars['MongoID']>;
};


export type MutationBrickMailActivateArgs = {
  active: Scalars['Boolean'];
  auditNoteId?: InputMaybe<Scalars['MongoID']>;
  mailType: Scalars['String'];
  shopId: Scalars['String'];
};


export type MutationBrickMailCopyArgs = {
  auditNoteId?: InputMaybe<Scalars['MongoID']>;
  defaultLocale: Scalars['String'];
  sourceShopId: Scalars['MongoID'];
  targetShopId: Scalars['MongoID'];
};


export type MutationBrickMailResetArgs = {
  alignText?: InputMaybe<Scalars['String']>;
  auditNoteId?: InputMaybe<Scalars['MongoID']>;
  backgroundColor: Scalars['String'];
  bodyPadding: Scalars['String'];
  boxBackgroundColor: Scalars['String'];
  boxBorderColor: Scalars['String'];
  boxTextColor: Scalars['String'];
  color: Scalars['String'];
  conceptName: Scalars['String'];
  conceptPrefix: Scalars['String'];
  configHeader?: InputMaybe<Scalars['String']>;
  disableTitle: Scalars['Boolean'];
  font: Scalars['String'];
  fontSize?: InputMaybe<Scalars['String']>;
  footer?: InputMaybe<Scalars['String']>;
  frame: Scalars['String'];
  frameColor: Scalars['String'];
  fromMail: Scalars['String'];
  header?: InputMaybe<Scalars['String']>;
  language?: InputMaybe<Scalars['String']>;
  logoBackgroundColor: Scalars['String'];
  logoUrl: Scalars['String'];
  mailType?: InputMaybe<Scalars['String']>;
  resetAll: Scalars['Boolean'];
  resetBasics: Scalars['Boolean'];
  resetBricks: Scalars['Boolean'];
  resetFooter: Scalars['Boolean'];
  resetHeader: Scalars['Boolean'];
  shopId: Scalars['String'];
  shopName: Scalars['String'];
  shopUrl: Scalars['String'];
  textBackgroundColor: Scalars['String'];
};


export type MutationBrickMailReset2Args = {
  alignText?: InputMaybe<Scalars['String']>;
  auditNoteId?: InputMaybe<Scalars['MongoID']>;
  backgroundColor?: InputMaybe<Scalars['String']>;
  bodyPadding?: InputMaybe<Scalars['String']>;
  boxBackgroundColor?: InputMaybe<Scalars['String']>;
  boxBorderColor?: InputMaybe<Scalars['String']>;
  boxTextColor?: InputMaybe<Scalars['String']>;
  color?: InputMaybe<Scalars['String']>;
  font?: InputMaybe<Scalars['String']>;
  footer?: InputMaybe<Scalars['String']>;
  frame?: InputMaybe<Scalars['String']>;
  frameColor?: InputMaybe<Scalars['String']>;
  fromMail?: InputMaybe<Scalars['String']>;
  header?: InputMaybe<Scalars['String']>;
  logoBackgroundColor?: InputMaybe<Scalars['String']>;
  logoUrl?: InputMaybe<Scalars['String']>;
  shopId: Scalars['String'];
  shopUrl?: InputMaybe<Scalars['String']>;
  textBackgroundColor?: InputMaybe<Scalars['String']>;
};


export type MutationBrickMailTestArgs = {
  activations: Scalars['Boolean'];
  consumerEmail?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  language: Scalars['String'];
  mailType: Scalars['String'];
  onlyConnectors?: InputMaybe<Scalars['Boolean']>;
  shopId: Scalars['String'];
};


export type MutationBrickMailUpdateArgs = {
  auditNoteId?: InputMaybe<Scalars['MongoID']>;
  input?: InputMaybe<Array<InputMaybe<BrickMailMailsInput>>>;
  mailType: Scalars['String'];
  shopId: Scalars['MongoID'];
};


export type MutationCampaignCreateArgs = {
  record: CreateOneCampaignInput;
};


export type MutationCampaignUpdateArgs = {
  _id: Scalars['MongoID'];
  record: UpdateByIdCampaignInput;
};


export type MutationCircularPayoutArgs = {
  amount: Scalars['Float'];
  consumerId: Scalars['MongoID'];
  options?: InputMaybe<CircularPayoutInstanceInput>;
};


export type MutationCircularPayoutUpdateByIdArgs = {
  _id: Scalars['MongoID'];
  record: UpdateByIdCircularPayoutTypeInput;
};


export type MutationCircularPointCreateArgs = {
  record: CreateOneCircularPointInput;
};


export type MutationCircularPointUpdateArgs = {
  _id: Scalars['MongoID'];
  record: UpdateByIdCircularPointInput;
};


export type MutationCompleteSynchronizeArgs = {
  service: Scalars['String'];
  shopId: Scalars['String'];
};


export type MutationConsumerAccessRequestArgs = {
  authMethod: ConsumerAuthMethodEnum;
  consumerId?: InputMaybe<Scalars['MongoID']>;
  identifier: Scalars['String'];
  onlyDefaultFlow?: InputMaybe<Scalars['Boolean']>;
  sendMail?: InputMaybe<Scalars['Boolean']>;
  shopId: Scalars['MongoID'];
};


export type MutationConsumerActivitySetupArgs = {
  email: Scalars['String'];
  instanceId: Scalars['MongoID'];
};


export type MutationConsumerCompleteAccessArgs = {
  consumerId: Scalars['MongoID'];
  messageId: Scalars['MongoID'];
  shopId: Scalars['MongoID'];
};


export type MutationConsumerCreateArgs = {
  countryCode?: InputMaybe<Scalars['String']>;
  currency?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  locale?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  shopId: Scalars['String'];
  zipCode?: InputMaybe<Scalars['String']>;
};


export type MutationConsumerCreate2Args = {
  input: ConsumerCreate2Input;
  shopId: Scalars['MongoID'];
};


export type MutationConsumerLoginArgs = {
  countryCode?: InputMaybe<Scalars['String']>;
  currency?: InputMaybe<Scalars['String']>;
  language?: InputMaybe<Scalars['String']>;
  multiLogin?: InputMaybe<Scalars['Boolean']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  shopId: Scalars['String'];
  token: Scalars['String'];
};


export type MutationConsumerMailUpdateArgs = {
  input?: InputMaybe<ConsumerMailUpdateInput>;
  shopId: Scalars['MongoID'];
};


export type MutationConsumerMergeArgs = {
  consumerIds: Array<Scalars['MongoID']>;
};


export type MutationConsumerRejectAccessArgs = {
  messageId: Scalars['MongoID'];
};


export type MutationConsumerRequestAccessArgs = {
  consumerId?: InputMaybe<Scalars['MongoID']>;
  mail?: InputMaybe<Scalars['String']>;
  onlyDefaultFlow?: InputMaybe<Scalars['Boolean']>;
  shopId: Scalars['MongoID'];
};


export type MutationConsumerRequestAccessFlowArgs = {
  identifier: Scalars['String'];
  identifierType: ConsumerIdentifierEnum;
  parameters?: InputMaybe<Scalars['JSON']>;
  sendMail?: InputMaybe<Scalars['Boolean']>;
  shopId: Scalars['MongoID'];
};


export type MutationConsumerRequestPotentialsArgs = {
  consumerId?: InputMaybe<Scalars['MongoID']>;
  identifier?: InputMaybe<Scalars['String']>;
  identifierType?: InputMaybe<ConsumerIdentifierEnum>;
  parameters?: InputMaybe<Scalars['JSON']>;
  shopId: Scalars['MongoID'];
};


export type MutationConsumerSendCodeArgs = {
  onlyDefaultFlow?: InputMaybe<Scalars['Boolean']>;
  phoneNumber: Scalars['String'];
  shopId: Scalars['MongoID'];
};


export type MutationConsumerSendEmailArgs = {
  mailtype?: InputMaybe<BrickMailTypeEnum>;
  options: Scalars['JSON'];
  shopId: Scalars['MongoID'];
};


export type MutationConsumerSynchronizeArgs = {
  identifier: Scalars['String'];
  identifierType: ConsumerIdentifierEnum;
  input: ConsumerSynchronizeInput;
  shopId: Scalars['MongoID'];
};


export type MutationConsumerUpdateArgs = {
  consumer: ConsumerInput;
};


export type MutationConsumerVerifyCodeArgs = {
  code: Scalars['String'];
  phoneNumber: Scalars['String'];
  shopId: Scalars['MongoID'];
};


export type MutationCurrencyConvertArgs = {
  amount: Scalars['Float'];
  currency: Scalars['String'];
  shopId: Scalars['String'];
};


export type MutationDataViewCreateArgs = {
  brandHouseId?: InputMaybe<Scalars['MongoID']>;
  metadata?: InputMaybe<Scalars['JSON']>;
  rowIds: Array<Scalars['MongoID']>;
  ttlHours?: InputMaybe<Scalars['Int']>;
  type: DataViewTypeEnum;
  viewName?: InputMaybe<Scalars['String']>;
};


export type MutationDigitalPassportInitArgs = {
  country?: InputMaybe<Scalars['String']>;
  currency?: InputMaybe<Scalars['String']>;
  ean?: InputMaybe<Scalars['String']>;
  language?: InputMaybe<Scalars['String']>;
  rrp?: InputMaybe<Scalars['Float']>;
  shopId: Scalars['MongoID'];
  size?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};


export type MutationExternOrder2SynchronizeArgs = {
  order?: InputMaybe<ExternOrder2SynchronizeInput>;
  shopId: Scalars['MongoID'];
};


export type MutationExternOrderSynchronizeArgs = {
  order?: InputMaybe<ExternOrderSynchronizeInput>;
  shopId: Scalars['MongoID'];
};


export type MutationHideImageAuditArgs = {
  brandItemImageId: Scalars['MongoID'];
};


export type MutationImageRotateArgs = {
  imageId: Scalars['MongoID'];
  rotate: Scalars['Int'];
};


export type MutationIntegrationConfigUpdateArgs = {
  enabled: Scalars['Boolean'];
  instanceId: Scalars['MongoID'];
  message?: InputMaybe<IntegrationMessageEnum>;
};


export type MutationIntegrationConnectorCreateArgs = {
  record: CreateOneIntegrationConnectorInput;
};


export type MutationIntegrationConnectorDeleteArgs = {
  filter?: InputMaybe<FilterRemoveOneIntegrationConnectorInput>;
  sort?: InputMaybe<SortRemoveOneIntegrationConnectorInput>;
};


export type MutationIntegrationConnectorUpdateArgs = {
  _id: Scalars['MongoID'];
  record: UpdateByIdIntegrationConnectorInput;
};


export type MutationIntegrationDeleteArgs = {
  connectorId: Scalars['MongoID'];
  enabled: Scalars['Boolean'];
  message?: InputMaybe<IntegrationMessageEnum>;
  refId: Scalars['MongoID'];
  refType?: InputMaybe<EnumIntegrationConnectorRefType>;
};


export type MutationIntegrationInstallArgs = {
  connectorId: Scalars['MongoID'];
  mode?: InputMaybe<InstanceModeEnum>;
  refId: Scalars['MongoID'];
  refType?: InputMaybe<EnumIntegrationConnectorRefType>;
};


export type MutationIntegrationMessageExecuteArgs = {
  arguments?: InputMaybe<Array<Scalars['JSON']>>;
  name: Scalars['String'];
  refId: Scalars['MongoID'];
  refType?: InputMaybe<EnumIntegrationConnectorRefType>;
};


export type MutationIntegrationMessageRerunArgs = {
  messageId: Scalars['MongoID'];
};


export type MutationIntegrationMessageUpdateArgs = {
  _id: Scalars['MongoID'];
  record: UpdateByIdIntegrationMessageInput;
};


export type MutationIntegrationReInitializeArgs = {
  instanceId: Scalars['MongoID'];
};


export type MutationIntegrationSettingUpdateArgs = {
  input?: InputMaybe<Array<InputMaybe<IntegrationSettingInInput>>>;
  instanceId: Scalars['MongoID'];
};


export type MutationIntegrationUnInstallArgs = {
  instanceId: Scalars['MongoID'];
  refId: Scalars['MongoID'];
  refType?: InputMaybe<EnumIntegrationConnectorRefType>;
};


export type MutationInvoiceAdjustmentCreateArgs = {
  record: CreateOneInvoiceAdjustmentInput;
};


export type MutationInvoiceDeleteArgs = {
  brandHouseId: Scalars['MongoID'];
  invoiceId: Scalars['String'];
};


export type MutationInvoiceRebuildArgs = {
  brandHouseId: Scalars['MongoID'];
};


export type MutationInvoiceResetArgs = {
  brandHouseId?: InputMaybe<Scalars['MongoID']>;
  invoiceId: Scalars['String'];
};


export type MutationInvoiceSettingUpdateArgs = {
  record?: InputMaybe<InvoiceSettingInput>;
};


export type MutationInvoiceUpdateArgs = {
  brandHouseId: Scalars['MongoID'];
  invoiceId: Scalars['String'];
  locked?: InputMaybe<Scalars['Boolean']>;
  paid?: InputMaybe<Scalars['Boolean']>;
};


export type MutationItemIssueSynchronizeArgs = {
  brandItemId: Scalars['MongoID'];
  input?: InputMaybe<Array<InputMaybe<ItemIssueInput>>>;
};


export type MutationItemIssueUpdateArgs = {
  _id: Scalars['MongoID'];
  record: UpdateByIdItemIssueInput;
};


export type MutationKlaviyoSynchronizeArgs = {
  full?: InputMaybe<Scalars['Boolean']>;
  shopId: Scalars['MongoID'];
};


export type MutationLogisticsPartnerAuthorizeArgs = {
  apiKey: Scalars['String'];
  apiSecret: Scalars['String'];
};


export type MutationLogisticsPartnerCreateArgs = {
  address?: InputMaybe<Scalars['String']>;
  address2?: InputMaybe<Scalars['String']>;
  attention?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  countryCode?: InputMaybe<Scalars['String']>;
  mail?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  phone?: InputMaybe<Scalars['String']>;
  zipCode?: InputMaybe<Scalars['String']>;
};


export type MutationLogisticsPartnerUpdateArgs = {
  _id: Scalars['MongoID'];
  record: UpdateByIdLogisticsPartnerInput;
};


export type MutationLogisticsStockItemsCheckedResetArgs = {
  logisticsPartnerId: Scalars['String'];
};


export type MutationOptionSynchronizeArgs = {
  input?: InputMaybe<OptionSetInput>;
  mode?: InputMaybe<SynchronizeMode>;
};


export type MutationOrderCaptureArgs = {
  forced?: InputMaybe<Scalars['Boolean']>;
  orderId: Scalars['String'];
  shopId: Scalars['String'];
};


export type MutationOrderCreateReturnArgs = {
  carrierId: Scalars['MongoID'];
  orderId: Scalars['MongoID'];
  returnLines?: InputMaybe<Array<OrderLineReturnInput>>;
  sender?: InputMaybe<AddressInfoInput>;
};


export type MutationOrderExtendReturnDeadlineArgs = {
  brandHouseId?: InputMaybe<Scalars['MongoID']>;
  ordersPlacedAfter: Scalars['Date'];
  ordersPlacedBefore?: InputMaybe<Scalars['Date']>;
  returnDeadline: Scalars['Date'];
};


export type MutationOrderFulfillArgs = {
  orderId: Scalars['String'];
  returnCarrier?: InputMaybe<Scalars['String']>;
  returnNumber?: InputMaybe<Scalars['String']>;
  shopId: Scalars['String'];
  trackingCarrier?: InputMaybe<Scalars['String']>;
  trackingNumber?: InputMaybe<Scalars['String']>;
};


export type MutationOrderPrintDeliveryNoteArgs = {
  orderId: Scalars['MongoID'];
};


export type MutationOrderRegisterReturnArgs = {
  carrier: EnumOrder2ReturnInfoCarrier;
  orderId: Scalars['MongoID'];
  returnLines?: InputMaybe<Array<OrderLineReturnInput>>;
  trackingNos: Array<Scalars['String']>;
};


export type MutationOrderResendCreateArgs = {
  instanceId: Scalars['MongoID'];
  orderId: Scalars['MongoID'];
};


export type MutationOrderResetReturnArgs = {
  orderId: Scalars['MongoID'];
};


export type MutationOrderSetTrackingArgs = {
  orderId: Scalars['MongoID'];
  silent?: InputMaybe<Scalars['Boolean']>;
  trackingOrderId: Scalars['Float'];
};


export type MutationOrderSynchronizeArgs = {
  mode?: InputMaybe<SynchronizeMode>;
  order?: InputMaybe<OrderSynchronizeInput>;
};


export type MutationOrderUpdateArgs = {
  order?: InputMaybe<OrderUpdateInput2>;
  shopId: Scalars['String'];
};


export type MutationParcelCreateArgs = {
  record: CreateOneParcelInput;
};


export type MutationParcelTrackingUpdateArgs = {
  deliveryDate?: InputMaybe<Scalars['Date']>;
  input?: InputMaybe<ParcelTrackingInput>;
  orderId?: InputMaybe<Scalars['MongoID']>;
  tradeInId?: InputMaybe<Scalars['MongoID']>;
};


export type MutationParcelUpdateArgs = {
  filter?: InputMaybe<FilterUpdateOneParcelInput>;
  record: UpdateOneParcelInput;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortUpdateOneParcelInput>;
};


export type MutationPlannedMailUpdateArgs = {
  filter?: InputMaybe<FilterUpdateOnePlannedMailInput>;
  record: UpdateOnePlannedMailInput;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortUpdateOnePlannedMailInput>;
};


export type MutationPotentialCreateArgs = {
  brandProductSizeId?: InputMaybe<Scalars['MongoID']>;
  brandProductVariantId?: InputMaybe<Scalars['MongoID']>;
  categoryId?: InputMaybe<Scalars['MongoID']>;
  consumerId: Scalars['MongoID'];
  currency?: InputMaybe<Scalars['String']>;
  imageId?: InputMaybe<Scalars['MongoID']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  masterVariantId?: InputMaybe<Scalars['String']>;
  productVariantId?: InputMaybe<Scalars['MongoID']>;
  productVariantSizeId?: InputMaybe<Scalars['MongoID']>;
  ruleId?: InputMaybe<Scalars['MongoID']>;
};


export type MutationPotentialDeleteArgs = {
  potentialId: Scalars['MongoID'];
};


export type MutationPotentialDistributeArgs = {
  shopId: Scalars['MongoID'];
};


export type MutationPotentialSynchronizeArgs = {
  consumerId?: InputMaybe<Scalars['MongoID']>;
  shopId: Scalars['MongoID'];
  tradeIn?: InputMaybe<PotentialSynchronize2Input>;
  updateOffers?: InputMaybe<Scalars['Boolean']>;
};


export type MutationPotentialSynchronize2Args = {
  consumerId?: InputMaybe<Scalars['MongoID']>;
  shopId: Scalars['String'];
  tradeIn?: InputMaybe<PotentialSynchronize2Input>;
  updateOffers?: InputMaybe<Scalars['Boolean']>;
};


export type MutationPotentialUpdateArgs = {
  _id: Scalars['MongoID'];
  record: UpdateByIdPotentialInput;
};


export type MutationProductDisableArgs = {
  disable: Scalars['Boolean'];
  id: Scalars['MongoID'];
};


export type MutationProductImageCreateArgs = {
  altText?: InputMaybe<Scalars['String']>;
  imageUrl: Scalars['String'];
  productId?: InputMaybe<Scalars['String']>;
  shopId: Scalars['String'];
  variantId?: InputMaybe<Scalars['String']>;
};


export type MutationProductSynchronizeArgs = {
  mode: ProductSynchronizeMode;
  product?: InputMaybe<ProductSynchronizeInput>;
  shopId: Scalars['MongoID'];
};


export type MutationProductSynchronizeTranslationsArgs = {
  shopId: Scalars['MongoID'];
  translations?: InputMaybe<ProductSynchronizeTranslationsInput>;
};


export type MutationProductUpdateByIdArgs = {
  _id: Scalars['MongoID'];
  record: UpdateByIdProductInput;
};


export type MutationProductsAutocompleteArgs = {
  query: Scalars['String'];
  shopId: Scalars['String'];
};


export type MutationQrSessionCreateArgs = {
  logisticsPartnerId: Scalars['String'];
};


export type MutationQrSessionUpdateArgs = {
  code?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
};


export type MutationRejectImageAuditArgs = {
  brandItemImageId: Scalars['MongoID'];
  uploadId?: InputMaybe<Scalars['MongoID']>;
};


export type MutationRejectImageAuditRetakeArgs = {
  brandItemImageId: Scalars['MongoID'];
};


export type MutationScheduledEventCreateArgs = {
  record: CreateOneScheduledEventInput;
};


export type MutationScheduledEventUpdateArgs = {
  filter?: InputMaybe<FilterUpdateOneScheduledEventInput>;
  record: UpdateOneScheduledEventInput;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortUpdateOneScheduledEventInput>;
};


export type MutationSendSystemMailArgs = {
  cc?: InputMaybe<Array<Scalars['String']>>;
  content: Scalars['String'];
  from?: InputMaybe<Scalars['String']>;
  fromEmail?: InputMaybe<Scalars['String']>;
  subject: Scalars['String'];
  to: Scalars['String'];
};


export type MutationShippingCarrierUpdateArgs = {
  id: Scalars['MongoID'];
  input?: InputMaybe<ShippingCarrierInput>;
};


export type MutationShippingLabelCreateArgs = {
  record: CreateOneShippingLabelInput;
};


export type MutationShippingLabelUpdateArgs = {
  filter?: InputMaybe<FilterUpdateOneShippingLabelInput>;
  record: UpdateOneShippingLabelInput;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortUpdateOneShippingLabelInput>;
};


export type MutationShopCreateArgs = {
  currency: Scalars['String'];
  frontendType: EnumShopFrontendType;
  license: Scalars['String'];
  mainCountryCode: Scalars['String'];
  name: Scalars['String'];
  primaryLocale: Scalars['String'];
  secondaryLocales?: InputMaybe<Array<Scalars['String']>>;
  serviceBus?: InputMaybe<Scalars['String']>;
  serviceBusTopic?: InputMaybe<Scalars['String']>;
  shop: Scalars['String'];
  tradeInBaseUrl: Scalars['String'];
};


export type MutationShopCreate2Args = {
  configuration?: InputMaybe<Scalars['JSON']>;
  externId: Scalars['String'];
  frontendType: EnumShopFrontendType;
  license: Scalars['String'];
  name: Scalars['String'];
};


export type MutationShopDeleteArgs = {
  shopId: Scalars['String'];
};


export type MutationShopLaunchArgs = {
  shopId: Scalars['String'];
};


export type MutationShopResetArgs = {
  shopId: Scalars['MongoID'];
};


export type MutationShopUpdateArgs = {
  shop?: InputMaybe<ShopUpdateInput>;
  shopId: Scalars['String'];
};


export type MutationShopUpdateOneArgs = {
  filter?: InputMaybe<FilterUpdateOneShopInput>;
  record: UpdateOneShopInput;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortUpdateOneShopInput>;
};


export type MutationStartSynchronizeArgs = {
  externalId?: InputMaybe<Scalars['String']>;
  force?: InputMaybe<Scalars['Boolean']>;
  service: Scalars['String'];
  shopId: Scalars['String'];
  type?: InputMaybe<Scalars['String']>;
};


export type MutationStockItemCheckedArgs = {
  checked?: InputMaybe<Scalars['Boolean']>;
  missing?: InputMaybe<Scalars['Boolean']>;
  stockItemId: Scalars['String'];
};


export type MutationStockItemCreateArgs = {
  shopId: Scalars['String'];
  tradeInItemId: Scalars['String'];
};


export type MutationStockItemCreateEmptyArgs = {
  shopId: Scalars['String'];
  stockItem?: InputMaybe<StockItemUpdateInput>;
};


export type MutationStockItemDeleteArgs = {
  shopId: Scalars['String'];
  stockItemId: Scalars['String'];
};


export type MutationStockItemImageAutoRetouchArgs = {
  process: Scalars['Boolean'];
  shopId: Scalars['String'];
  stockItemImageId: Scalars['String'];
};


export type MutationStockItemImageAutoRetouch2Args = {
  process: Scalars['Boolean'];
  shopId: Scalars['String'];
  stockItemId: Scalars['String'];
};


export type MutationStockItemImageAutoRetouchAllArgs = {
  shopId: Scalars['String'];
};


export type MutationStockItemImageCreateArgs = {
  perspective?: InputMaybe<ImagePerspectiveEnum>;
  process?: InputMaybe<Scalars['Boolean']>;
  shopId: Scalars['String'];
  silent?: InputMaybe<Scalars['Boolean']>;
  stockItemId: Scalars['String'];
  type?: InputMaybe<ImageTypeEnum>;
  uploadId: Scalars['String'];
};


export type MutationStockItemImageCreate2Args = {
  autoretouch?: InputMaybe<Scalars['Boolean']>;
  imageUrl: Scalars['String'];
  perspective?: InputMaybe<ImagePerspectiveEnum>;
  publish?: InputMaybe<Scalars['Boolean']>;
  shopId: Scalars['String'];
  silent?: InputMaybe<Scalars['Boolean']>;
  stockItemId: Scalars['String'];
  type?: InputMaybe<ImageTypeEnum>;
};


export type MutationStockItemImageDeleteArgs = {
  shopId: Scalars['String'];
  stockItemImageId: Scalars['String'];
};


export type MutationStockItemImageRotateArgs = {
  imageId: Scalars['String'];
  rotate: Scalars['Float'];
  shopId: Scalars['String'];
};


export type MutationStockItemImageSetOrderArgs = {
  imageIds?: InputMaybe<Array<Scalars['String']>>;
  shopId: Scalars['String'];
  stockItemId: Scalars['String'];
};


export type MutationStockItemImageSynchronizeArgs = {
  stockItemId: Scalars['MongoID'];
};


export type MutationStockItemImageUpdateArgs = {
  imageId: Scalars['String'];
  shopId: Scalars['String'];
  sortOrder: Scalars['Float'];
};


export type MutationStockItemImageUpdateByIdArgs = {
  _id: Scalars['MongoID'];
  record: UpdateByIdStockItemImageInput;
};


export type MutationStockItemInventoryUpdateArgs = {
  stockItemId: Scalars['MongoID'];
};


export type MutationStockItemPullArgs = {
  stockItemId: Scalars['String'];
};


export type MutationStockItemResetSkuArgs = {
  shopId: Scalars['MongoID'];
};


export type MutationStockItemUpdateArgs = {
  shopId: Scalars['String'];
  silent?: InputMaybe<Scalars['Boolean']>;
  stockItem?: InputMaybe<StockItemUpdateInput>;
};


export type MutationStockItemsRecalculatePriceArgs = {
  shopId: Scalars['String'];
  stockItem?: InputMaybe<StockItemUpdateInput>;
};


export type MutationStockItemsRecalculatePricesArgs = {
  shopId: Scalars['String'];
};


export type MutationStorageFileRegisterArgs = {
  brandHouseId?: InputMaybe<Scalars['MongoID']>;
  input?: InputMaybe<StorageFileCreateInput>;
  shopId?: InputMaybe<Scalars['MongoID']>;
};


export type MutationSurveyRespondentCreateArgs = {
  record: CreateOneRespondentInput;
};


export type MutationSurveyUpdateArgs = {
  _id: Scalars['MongoID'];
  record: UpdateByIdSurveyInput;
};


export type MutationSystemMessageAcknowledgeArgs = {
  filter?: InputMaybe<FilterUpdateOneSystemMessageInput>;
  record: UpdateOneSystemMessageInput;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortUpdateOneSystemMessageInput>;
};


export type MutationSystemMessageCreateArgs = {
  record: CreateOneSystemMessageInput;
};


export type MutationTradeInCreateArgs = {
  brandCarrierId?: InputMaybe<Scalars['MongoID']>;
  comments?: InputMaybe<Array<InputMaybe<TradeInCommentInput>>>;
  consumerId: Scalars['MongoID'];
  payout?: InputMaybe<EnumTradeInPayoutType>;
  potentialIds?: InputMaybe<Array<Scalars['MongoID']>>;
  received?: InputMaybe<Scalars['Boolean']>;
  source?: InputMaybe<EnumTradeInSource>;
  sourceNote?: InputMaybe<Scalars['String']>;
};


export type MutationTradeInDeleteArgs = {
  shopId: Scalars['String'];
  tradeInId: Scalars['String'];
};


export type MutationTradeInDelete2Args = {
  tradeInId: Scalars['MongoID'];
};


export type MutationTradeInItemUpdateByIdArgs = {
  _id: Scalars['MongoID'];
  record: UpdateByIdTradeInItemInput;
};


export type MutationTradeInItemsRejectArgs = {
  rejected: TradeInItemRejectReasonEnum;
  tradeInId: Scalars['MongoID'];
  tradeInItemIds?: InputMaybe<Array<Scalars['MongoID']>>;
};


export type MutationTradeInResyncArgs = {
  brandHouseId: Scalars['MongoID'];
  instanceId?: InputMaybe<Scalars['String']>;
};


export type MutationTradeInSynchronizeArgs = {
  input: TradeInSynchronizeInput;
};


export type MutationTradeInUpdateArgs = {
  input?: InputMaybe<TradeInUpdateInput>;
  potentialIds?: InputMaybe<Array<Scalars['MongoID']>>;
  tradeInId: Scalars['MongoID'];
};


export type MutationUserAccessToggleArgs = {
  accessId: Scalars['MongoID'];
  disabled: Scalars['Boolean'];
};


export type MutationUserInviteArgs = {
  brandHouseId?: InputMaybe<Scalars['MongoID']>;
  email: Scalars['String'];
  logisticsPartnerId?: InputMaybe<Scalars['MongoID']>;
};


export type MutationUserInviteAcceptArgs = {
  inviteToken: Scalars['String'];
};


export type MutationUserInviteJoinArgs = {
  name: Scalars['String'];
  password: Scalars['String'];
  resetToken: Scalars['String'];
};


export type MutationUserLoginArgs = {
  email: Scalars['String'];
  password: Scalars['String'];
};


export type MutationUserRecoverPasswordArgs = {
  email: Scalars['String'];
};


export type MutationUserRefreshArgs = {
  token: Scalars['String'];
};


export type MutationUserResetPasswordArgs = {
  password: Scalars['String'];
  resetToken: Scalars['String'];
};


export type MutationUserUpdatePasswordArgs = {
  newPassword: Scalars['String'];
  password: Scalars['String'];
  username: Scalars['String'];
};


export type MutationVoucherAdjustmentCreateArgs = {
  record: CreateOneVoucherAdjustmentInput;
};


export type MutationVoucherAdjustmentGiftCardSyncUpdateArgs = {
  adjustmentId: Scalars['MongoID'];
  input: VoucherAdjustmentGiftCardSyncInput;
  shopId: Scalars['MongoID'];
};


export type MutationVoucherDeleteArgs = {
  id: Scalars['String'];
  shopId: Scalars['String'];
};


export type MutationVoucherEnableArgs = {
  enable: Scalars['Boolean'];
  voucherId: Scalars['MongoID'];
};


export type MutationVoucherFrontUpdateArgs = {
  code: Scalars['String'];
  input?: InputMaybe<VoucherFrontUpdateInput>;
  shopId: Scalars['MongoID'];
};


export type MutationVoucherMergeArgs = {
  shopId: Scalars['String'];
  targetTradeIn: Scalars['String'];
  voucherIds: Array<Scalars['String']>;
};


export type MutationVoucherSendReminderArgs = {
  shopId: Scalars['MongoID'];
};


export type MutationVoucherSynchronizeArgs = {
  code: Scalars['String'];
  shopId: Scalars['String'];
  silent?: InputMaybe<Scalars['Boolean']>;
  used?: InputMaybe<Scalars['String']>;
};


export type MutationVoucherUsageSynchronizeArgs = {
  input?: InputMaybe<VoucherUsageInput>;
  shopId: Scalars['MongoID'];
};


export type MutationWholeSaleCategoryCopyArgs = {
  convertCurrency?: InputMaybe<Scalars['Boolean']>;
  sourceShopId: Scalars['MongoID'];
  targetShopId: Scalars['MongoID'];
  translate?: InputMaybe<Scalars['Boolean']>;
};


export type MutationWholeSaleCategoryCreateArgs = {
  record: CreateOneWholeSaleCategoryInput;
};


export type MutationWholeSaleCategoryDeleteArgs = {
  categoryId: Scalars['String'];
  shopId: Scalars['String'];
};


export type MutationWholeSaleCategoryUpdateArgs = {
  filter?: InputMaybe<FilterUpdateOneWholeSaleCategoryInput>;
  record: UpdateOneWholeSaleCategoryInput;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortUpdateOneWholeSaleCategoryInput>;
};

export type Nfc = {
  __typename?: 'NFC';
  _id: Scalars['MongoID'];
  /** The BrandItem for this NFC Tag */
  brandItem?: Maybe<BrandItem>;
  brandItemId?: Maybe<Scalars['MongoID']>;
  /** The NFC tag identifier */
  identifier: Scalars['String'];
  /** The StockItem for this NFC Tag */
  stockItem?: Maybe<StockItem>;
  stockItemId?: Maybe<Scalars['MongoID']>;
};

export type ObjectPatches = {
  __typename?: 'ObjectPatches';
  _id: Scalars['MongoID'];
  auditNoteId?: Maybe<Scalars['MongoID']>;
  brandHouseId?: Maybe<Scalars['MongoID']>;
  /** If true, then the patch has been compacted */
  compacted?: Maybe<Scalars['Boolean']>;
  date: Scalars['Date'];
  ops?: Maybe<Array<Maybe<ObjectPatchesOps>>>;
  ref: Scalars['MongoID'];
  shopId?: Maybe<Scalars['MongoID']>;
  type: Scalars['String'];
  updatedBy?: Maybe<ObjectPatchesUpdatedBy>;
};

export type ObjectPatchesOps = {
  __typename?: 'ObjectPatchesOps';
  op?: Maybe<Scalars['String']>;
  path?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['JSON']>;
};

/** List of items with pagination. */
export type ObjectPatchesPatchItem = {
  __typename?: 'ObjectPatchesPatchItem';
  /** Total object count. */
  count?: Maybe<Scalars['Int']>;
  /** Array of objects. */
  items?: Maybe<Array<ObjectPatches>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type ObjectPatchesUpdatedBy = {
  __typename?: 'ObjectPatchesUpdatedBy';
  ref?: Maybe<Scalars['MongoID']>;
  type: Scalars['String'];
};

export type ObjectPatchesUpdatedByInput = {
  ref?: InputMaybe<Scalars['MongoID']>;
  type: Scalars['String'];
};

export type OneOfInput = {
  _id?: InputMaybe<Scalars['MongoID']>;
  externalId?: InputMaybe<Scalars['String']>;
};

export type OptionInstance = {
  __typename?: 'OptionInstance';
  key: Scalars['String'];
  keyExternalId?: Maybe<Scalars['String']>;
  optionSetId: Scalars['MongoID'];
  /** The value of the option value for the option set */
  optionValue?: Maybe<Scalars['String']>;
  /** The id of the option value for the option set */
  optionValueId?: Maybe<Scalars['MongoID']>;
  value: Scalars['String'];
  valueExternalId?: Maybe<Scalars['String']>;
  valueLocalizations?: Maybe<Array<Maybe<LocalizationEntry>>>;
};

export type OptionInstanceInput = {
  optionSetId: Scalars['MongoID'];
  /** The value of the option value for the option set */
  optionValue?: InputMaybe<Scalars['String']>;
  /** The id of the option value for the option set */
  optionValueId?: InputMaybe<Scalars['MongoID']>;
};

export type OptionSet = {
  __typename?: 'OptionSet';
  _id: Scalars['MongoID'];
  /** If true, the option set is active */
  active?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['Date']>;
  /** If true, the option set is deleted */
  deleted?: Maybe<Scalars['Boolean']>;
  /** The external id of the option set */
  externalId?: Maybe<Scalars['String']>;
  /** The key of the option set */
  key: Scalars['String'];
  /** The id of the item that the option set is for */
  refId: Scalars['MongoID'];
  /** The type of the ref id */
  refType: EnumOptionSetRefType;
  /** If true, then the option set will be required when used with the target */
  required?: Maybe<Scalars['Boolean']>;
  /** The section of the target that the option set should be shown for */
  section?: Maybe<Scalars['String']>;
  target: EnumOptionSetTarget;
  /** The title of the option set */
  title: Scalars['String'];
  updatedAt?: Maybe<Scalars['Date']>;
  updatedBy?: Maybe<ObjectPatchesUpdatedBy>;
  /** The value type of the option set */
  valueType: EnumOptionSetValueType;
  values?: Maybe<Array<Maybe<OptionValue>>>;
};

/** Input data for option sets */
export type OptionSetInput = {
  /** If true, the option set is active */
  active?: InputMaybe<Scalars['Boolean']>;
  /** If true, the option set is deleted */
  deleted?: InputMaybe<Scalars['Boolean']>;
  /** The external identifier of the option set, use it to reference this set later */
  externalId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<OneOfInput>;
  /** The key of the option set */
  key?: InputMaybe<Scalars['String']>;
  /** The id of the item that the option set is for */
  refId?: InputMaybe<Scalars['MongoID']>;
  /** The type of the ref id */
  refType: EnumOptionSetRefType;
  /** The target of the option set */
  target: EnumOptionSetTarget;
  /** The title of the option set */
  title?: InputMaybe<Scalars['String']>;
  /** The value type of the option set */
  valueType: EnumOptionSetValueType;
  /** The values of the option set */
  values?: InputMaybe<Array<InputMaybe<OptionValueInput>>>;
};

export type OptionValue = {
  __typename?: 'OptionValue';
  _id: Scalars['MongoID'];
  createdAt?: Maybe<Scalars['Date']>;
  /** Custom data for the option value */
  customData?: Maybe<Scalars['JSON']>;
  /** If true, the option is deleted */
  deleted?: Maybe<Scalars['Boolean']>;
  /** The external id of the option value */
  externalId?: Maybe<Scalars['String']>;
  /** The label of option */
  label: Scalars['String'];
  /** The localizations of the option */
  localizations?: Maybe<Array<Maybe<LocalizationEntry>>>;
  /** The option set id */
  optionSetId: Scalars['MongoID'];
  /** The id of the object that owns the value */
  refId: Scalars['MongoID'];
  /** The sort order of the option */
  sortorder: Scalars['Float'];
  updatedAt?: Maybe<Scalars['Date']>;
  updatedBy?: Maybe<ObjectPatchesUpdatedBy>;
  /** The value of the option */
  value: Scalars['String'];
};

/** Input values for option sets */
export type OptionValueInput = {
  /** Custom data for the option value */
  customData?: InputMaybe<Scalars['JSON']>;
  /** If true, the option is deleted */
  deleted?: InputMaybe<Scalars['Boolean']>;
  /** The external identifier of the option value, use it to reference this value later */
  externalId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<OneOfInput>;
  /** The label of the option */
  label?: InputMaybe<Scalars['String']>;
  /** The localizations of the option */
  localizations?: InputMaybe<Array<InputMaybe<LocalizationEntryInput>>>;
  /** The sortorder of the option */
  sortorder?: InputMaybe<Scalars['Int']>;
  /** The value of the option */
  value?: InputMaybe<Scalars['String']>;
};

export type Order2 = {
  __typename?: 'Order2';
  _id: Scalars['MongoID'];
  billingAddress?: Maybe<Order2ShippingAddress>;
  brandHouseId?: Maybe<Scalars['MongoID']>;
  captureFailedTs?: Maybe<Scalars['Date']>;
  captureNotified?: Maybe<Scalars['Boolean']>;
  captureRequests?: Maybe<Scalars['Float']>;
  /** The total amount to be captured for this order */
  captureTotal?: Maybe<Scalars['Float']>;
  carrierInfo?: Maybe<Order2CarrierInfo>;
  carrierInput?: Maybe<Order2CarrierInput>;
  /** Comment for the order */
  comment?: Maybe<Scalars['String']>;
  consumer: Order2Consumer;
  /** The email of the consumer */
  consumerEmail?: Maybe<Scalars['String']>;
  consumerId?: Maybe<Scalars['MongoID']>;
  /** The name of the consumer */
  consumerName?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['Date']>;
  /** Currency for this order */
  currency?: Maybe<Scalars['String']>;
  /** Custom data for the order */
  customData?: Maybe<Scalars['JSON']>;
  /** Soft delete */
  deleted?: Maybe<Scalars['Boolean']>;
  /** Delivery note for this order */
  deliveryNoteUrl: Scalars['String'];
  exportedToWMS?: Maybe<Scalars['Boolean']>;
  /** External order data */
  externOrder?: Maybe<ExternOrder2>;
  externalId: Scalars['String'];
  /** A free return order is not reduced by the brand's return freight (refundAdjustment) when a line is returned */
  freeReturn?: Maybe<Scalars['Boolean']>;
  fulState?: Maybe<EnumOrder2FulState>;
  /** The internal consumer */
  internalConsumer?: Maybe<Consumer>;
  /** Whether this is a new order */
  isNewOrder?: Maybe<Scalars['Boolean']>;
  items?: Maybe<Array<Maybe<StockItem>>>;
  lines?: Maybe<Array<Maybe<Order2Item>>>;
  locked?: Maybe<Scalars['String']>;
  notified?: Maybe<Scalars['Boolean']>;
  notifiedConsumer?: Maybe<Scalars['Boolean']>;
  /** True while the sales channel holds the order back from fulfilment (e.g. a Shopify fulfillment hold on one of its lines). Its items stay sold, but the warehouse must not pick it */
  onHold?: Maybe<Scalars['Boolean']>;
  orderDate: Scalars['Date'];
  orderName?: Maybe<Scalars['String']>;
  orderState: EnumOrder2OrderState;
  orderUrl?: Maybe<Scalars['String']>;
  payState: EnumOrder2PayState;
  /** True if the order is a proforma order */
  proforma?: Maybe<Scalars['Boolean']>;
  /** True if the order commission can be invoiced, even if it is a proforma order */
  proformaInvoiceCommission?: Maybe<Scalars['Boolean']>;
  /** True if the order pickpack can be invoiced, even if it is a proforma order */
  proformaInvoicePickPack?: Maybe<Scalars['Boolean']>;
  /** True if the order shipping can be invoiced, even if it is a proforma order */
  proformaInvoiceShipping?: Maybe<Scalars['Boolean']>;
  refundAdjusted?: Maybe<Scalars['Boolean']>;
  /** Whether returns are allowed for this order */
  returnAllowed: Scalars['Boolean'];
  /** The deadline for returns, null if no deadline exists */
  returnDeadline?: Maybe<Scalars['Date']>;
  returnInfo?: Maybe<Order2ReturnInfo>;
  returnLabelToken: Scalars['String'];
  /** URL for the return label */
  returnLabelUrl?: Maybe<Scalars['String']>;
  /** The return lines for this order */
  returnLines?: Maybe<Array<Maybe<Order2ItemReturn>>>;
  /** The return shipping label */
  returnShippingLabel?: Maybe<ShippingLabel>;
  returnShippingLabelId?: Maybe<Scalars['MongoID']>;
  shippingAddress?: Maybe<Order2ShippingAddress>;
  shippingAddressInternal?: Maybe<Order2ShippingAddress>;
  /** The shop that owns this order */
  shop?: Maybe<Shop>;
  shopId: Scalars['MongoID'];
  /** A silenced order will not show as unfulfilled or active in statistics */
  silenced?: Maybe<Scalars['Boolean']>;
  splitOrder?: Maybe<Scalars['Boolean']>;
  /** Statistics for the order */
  statistics?: Maybe<OrderStatistics>;
  trackingInfo?: Maybe<Order2TrackingInfo>;
  /** If the tracking mail has been sent to the consumer */
  trackingMailSent?: Maybe<Scalars['Boolean']>;
  trackingOrderId?: Maybe<Scalars['Float']>;
  trackingOrderState?: Maybe<EnumOrder2TrackingOrderState>;
  trackingReturnState?: Maybe<EnumOrder2TrackingReturnState>;
  /** Public tracking page; redirects to the carrier when tracking is available */
  trackingUrl?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['Date']>;
  updatedBy?: Maybe<ObjectPatchesUpdatedBy>;
  /** Timestamp of the latest orderline that has been updated */
  updatedLineTs?: Maybe<Scalars['Date']>;
};


export type Order2StatisticsArgs = {
  currency?: InputMaybe<Scalars['String']>;
};

export type Order2CarrierInfo = {
  __typename?: 'Order2CarrierInfo';
  _id?: Maybe<Scalars['MongoID']>;
  carrierIdentifier?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type Order2CarrierInfoInput = {
  carrierIdentifier?: InputMaybe<Scalars['String']>;
  code?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};

export type Order2CarrierInput = {
  __typename?: 'Order2CarrierInput';
  /** Selected carrier for this package */
  carrier: EnumOrder2CarrierInputCarrier;
  /** Selected delivery service for this package */
  delivery: EnumOrder2CarrierInputDelivery;
  /** Express delivery */
  express: Scalars['Boolean'];
  /** Optionally an additional service id / pickup point information for this package */
  serviceId?: Maybe<Scalars['String']>;
};

export type Order2CarrierInputInput = {
  /** Selected carrier for this package */
  carrier: EnumOrder2CarrierInputCarrier;
  /** Selected delivery service for this package */
  delivery: EnumOrder2CarrierInputDelivery;
  /** Express delivery */
  express: Scalars['Boolean'];
  /** Optionally an additional service id / pickup point information for this package */
  serviceId?: InputMaybe<Scalars['String']>;
};

export type Order2Consumer = {
  __typename?: 'Order2Consumer';
  _id?: Maybe<Scalars['MongoID']>;
  add1?: Maybe<Scalars['String']>;
  add2?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  countryCode?: Maybe<Scalars['String']>;
  externalId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  language?: Maybe<Scalars['String']>;
  mail?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  zipCode?: Maybe<Scalars['String']>;
};

export type Order2ConsumerInput = {
  add1?: InputMaybe<Scalars['String']>;
  add2?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  countryCode?: InputMaybe<Scalars['String']>;
  externalId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  language?: InputMaybe<Scalars['String']>;
  mail?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  zipCode?: InputMaybe<Scalars['String']>;
};

export type Order2Item = {
  __typename?: 'Order2Item';
  _id: Scalars['MongoID'];
  cancelled?: Maybe<Scalars['Boolean']>;
  cancelledNr?: Maybe<Scalars['Float']>;
  /** Reason for cancellation, customer specific code */
  cancelledReason?: Maybe<Scalars['String']>;
  cancelledTs?: Maybe<Scalars['Date']>;
  createdAt?: Maybe<Scalars['Date']>;
  currency?: Maybe<Scalars['String']>;
  /** Custom data for the orderline */
  customData?: Maybe<Scalars['JSON']>;
  deleted?: Maybe<Scalars['Boolean']>;
  discountedPrice?: Maybe<Scalars['Float']>;
  discountedPricePreTax?: Maybe<Scalars['Float']>;
  /** The external id of the order line */
  externalLineId: Scalars['String'];
  fulfilled?: Maybe<Scalars['Boolean']>;
  item?: Maybe<StockItem>;
  /** The order that owns this line */
  order?: Maybe<Order2>;
  orderId: Scalars['MongoID'];
  /** The quantity of the orderline, if not present then 1 is assumed */
  quantity?: Maybe<Scalars['Float']>;
  /** True if the orderline should be refunded, see the refunded field that indicates whether an actual refund has been issued */
  refund?: Maybe<Scalars['Boolean']>;
  refunded?: Maybe<Scalars['Date']>;
  returned?: Maybe<Scalars['Boolean']>;
  returnedNr?: Maybe<Scalars['Float']>;
  /** Reason for return, customer specific code */
  returnedReason?: Maybe<Scalars['String']>;
  returnedTs?: Maybe<Scalars['Date']>;
  /** The sales price, if not provided then order currency */
  salesPrice?: Maybe<Scalars['Float']>;
  /** The sales price before tax in selected currency, if not provided then shop currency. Uses the tax rate the line was sold with, falling back to the shop's VAT rate when the line reports none or 0% */
  salesPricePreTax?: Maybe<Scalars['Float']>;
  /** The shop that owns this order */
  shop?: Maybe<Shop>;
  shopId: Scalars['MongoID'];
  /** Statistics for the order line */
  statistics?: Maybe<OrderLineStatistics>;
  /** The stock item that this line is for */
  stockItem?: Maybe<StockItemResolved>;
  stockItemId: Scalars['MongoID'];
  /** The tax rate the sales channel applied to this line, as a fraction (0.25 = 25% VAT). The sum of all tax lines; 0 for untaxed sales such as exports or reverse charge */
  taxRate?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Date']>;
  updatedBy?: Maybe<ObjectPatchesUpdatedBy>;
};


export type Order2ItemSalesPriceArgs = {
  currency?: InputMaybe<Scalars['String']>;
};


export type Order2ItemSalesPricePreTaxArgs = {
  currency?: InputMaybe<Scalars['String']>;
};


export type Order2ItemStatisticsArgs = {
  currency?: InputMaybe<Scalars['String']>;
};

export type Order2ItemReturn = {
  __typename?: 'Order2ItemReturn';
  _id: Scalars['MongoID'];
  brandHouseId: Scalars['MongoID'];
  createdAt?: Maybe<Scalars['Date']>;
  orderId: Scalars['MongoID'];
  orderLineId: Scalars['MongoID'];
  /** Reason for the return */
  returnReason: Scalars['String'];
  updatedAt?: Maybe<Scalars['Date']>;
  updatedBy?: Maybe<ObjectPatchesUpdatedBy>;
};

/** List of items with pagination. */
export type Order2OrderPagination = {
  __typename?: 'Order2OrderPagination';
  /** Total object count. */
  count?: Maybe<Scalars['Int']>;
  /** Array of objects. */
  items?: Maybe<Array<Order2>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type Order2ReturnInfo = {
  __typename?: 'Order2ReturnInfo';
  carrier?: Maybe<EnumOrder2ReturnInfoCarrier>;
  number?: Maybe<Scalars['String']>;
};

export type Order2ReturnInfoInput = {
  carrier?: InputMaybe<EnumOrder2ReturnInfoCarrier>;
  number?: InputMaybe<Scalars['String']>;
};

export type Order2ShippingAddress = {
  __typename?: 'Order2ShippingAddress';
  _id?: Maybe<Scalars['MongoID']>;
  add1?: Maybe<Scalars['String']>;
  add2?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  company?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  countryCode?: Maybe<Scalars['String']>;
  mail?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  zipCode?: Maybe<Scalars['String']>;
};

export type Order2ShippingAddressInput = {
  add1?: InputMaybe<Scalars['String']>;
  add2?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  company?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  countryCode?: InputMaybe<Scalars['String']>;
  mail?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  zipCode?: InputMaybe<Scalars['String']>;
};

export type Order2TrackingInfo = {
  __typename?: 'Order2TrackingInfo';
  carrier?: Maybe<EnumOrder2TrackingInfoCarrier>;
  number?: Maybe<Scalars['String']>;
};

export type OrderExtendReturnDeadlineResult = {
  __typename?: 'OrderExtendReturnDeadlineResult';
  matchedCount: Scalars['Int'];
  modifiedCount: Scalars['Int'];
};

export type OrderLineReturnInput = {
  orderLineId: Scalars['MongoID'];
  /** Reason for the return */
  returnReason: Scalars['String'];
};

export type OrderLineStatistics = {
  __typename?: 'OrderLineStatistics';
  /** Whether the orderline was cancelled */
  cancelled: Scalars['Boolean'];
  /** Whether the customer is ordering for the first time */
  firstTimeCustomer?: Maybe<Scalars['Boolean']>;
  /** Whether the orderline was refunded */
  refunded: Scalars['Boolean'];
  /** The percentage saved on the order */
  savingPercent?: Maybe<Scalars['Float']>;
  /** The total value of the order */
  value?: Maybe<Scalars['Float']>;
  /** The currency of the total value */
  valueCurrency?: Maybe<Scalars['String']>;
  /** The number of visitors to the item in the shop */
  views: Scalars['Float'];
};

export type OrderLineSynchronizeInput = {
  cancelled?: InputMaybe<Scalars['Boolean']>;
  cancelledNr?: InputMaybe<Scalars['Float']>;
  /** Reason for cancellation, customer specific code */
  cancelledReason?: InputMaybe<Scalars['String']>;
  cancelledTs?: InputMaybe<Scalars['Date']>;
  currency?: InputMaybe<Scalars['String']>;
  /** Custom data for the orderline */
  customData?: InputMaybe<Scalars['JSON']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  discountedPrice?: InputMaybe<Scalars['Float']>;
  discountedPricePreTax?: InputMaybe<Scalars['Float']>;
  ean?: InputMaybe<Scalars['String']>;
  /** The external id of the order line */
  externalLineId?: InputMaybe<Scalars['String']>;
  fulfilled?: InputMaybe<Scalars['Boolean']>;
  /** If provided, then exactly one of the id or externalLineId must be set and will be used to identify an existing line */
  id?: InputMaybe<OneOfInput>;
  /** The quantity of the orderline, if not present then 1 is assumed */
  quantity?: InputMaybe<Scalars['Float']>;
  /** True if the orderline should be refunded, see the refunded field that indicates whether an actual refund has been issued */
  refund?: InputMaybe<Scalars['Boolean']>;
  refunded?: InputMaybe<Scalars['Date']>;
  returned?: InputMaybe<Scalars['Boolean']>;
  /** Reason for return, customer specific code */
  returnedReason?: InputMaybe<Scalars['String']>;
  salesPrice?: InputMaybe<Scalars['Float']>;
  sku?: InputMaybe<Scalars['String']>;
  /** The tax rate the sales channel applied to this line, as a fraction (0.25 = 25% VAT). The sum of all tax lines; 0 for untaxed sales such as exports or reverse charge */
  taxRate?: InputMaybe<Scalars['Float']>;
  updatedBy?: InputMaybe<ObjectPatchesUpdatedByInput>;
};

export type OrderStatistics = {
  __typename?: 'OrderStatistics';
  /** Whether the customer is ordering for the first time */
  firstTimeCustomer?: Maybe<Scalars['Boolean']>;
  /** The number of items in the order */
  items?: Maybe<Scalars['Int']>;
  /** The percentage saved on the order */
  savingPercent?: Maybe<Scalars['Float']>;
  /** The total value of the order */
  value?: Maybe<Scalars['Float']>;
  /** The currency of the total value */
  valueCurrency?: Maybe<Scalars['String']>;
};

export type OrderSynchronizeInput = {
  billingAddress?: InputMaybe<Order2ShippingAddressInput>;
  captureFailedTs?: InputMaybe<Scalars['Date']>;
  captureNotified?: InputMaybe<Scalars['Boolean']>;
  /** The total amount to be captured for this order */
  captureTotal?: InputMaybe<Scalars['Float']>;
  carrierInfo?: InputMaybe<Order2CarrierInfoInput>;
  carrierInput?: InputMaybe<Order2CarrierInputInput>;
  /** Comment for the order */
  comment?: InputMaybe<Scalars['String']>;
  consumer?: InputMaybe<Order2ConsumerInput>;
  /** Currency for this order */
  currency?: InputMaybe<Scalars['String']>;
  /** Custom data for the order */
  customData?: InputMaybe<Scalars['JSON']>;
  /** Soft delete */
  deleted?: InputMaybe<Scalars['Boolean']>;
  externalId?: InputMaybe<Scalars['String']>;
  /** A free return order is not reduced by the brand's return freight (refundAdjustment) when a line is returned */
  freeReturn?: InputMaybe<Scalars['Boolean']>;
  fulState?: InputMaybe<EnumOrder2FulState>;
  /** If provided, then exactly one of the id or externalId must be set, and will be used to identify an existing order */
  id?: InputMaybe<OneOfInput>;
  /** Whether this is a new order */
  isNewOrder?: InputMaybe<Scalars['Boolean']>;
  lines?: InputMaybe<Array<InputMaybe<OrderLineSynchronizeInput>>>;
  locked?: InputMaybe<Scalars['String']>;
  /** True while the sales channel holds the order back from fulfilment (e.g. a Shopify fulfillment hold on one of its lines). Its items stay sold, but the warehouse must not pick it */
  onHold?: InputMaybe<Scalars['Boolean']>;
  orderDate?: InputMaybe<Scalars['Date']>;
  orderName?: InputMaybe<Scalars['String']>;
  orderState?: InputMaybe<EnumOrder2OrderState>;
  orderUrl?: InputMaybe<Scalars['String']>;
  payState?: InputMaybe<EnumOrder2PayState>;
  /** True if the order is a proforma order */
  proforma?: InputMaybe<Scalars['Boolean']>;
  /** True if the order commission can be invoiced, even if it is a proforma order */
  proformaInvoiceCommission?: InputMaybe<Scalars['Boolean']>;
  /** True if the order pickpack can be invoiced, even if it is a proforma order */
  proformaInvoicePickPack?: InputMaybe<Scalars['Boolean']>;
  /** True if the order shipping can be invoiced, even if it is a proforma order */
  proformaInvoiceShipping?: InputMaybe<Scalars['Boolean']>;
  /** The returnDeadline for an order is typically determined by the settings, but its possible to set the returnDeadline to override that */
  returnDeadline?: InputMaybe<Scalars['Date']>;
  returnInfo?: InputMaybe<Order2ReturnInfoInput>;
  returnShippingLabelId?: InputMaybe<Scalars['MongoID']>;
  shippingAddress?: InputMaybe<Order2ShippingAddressInput>;
  shippingAddressInternal?: InputMaybe<Order2ShippingAddressInput>;
  shopId?: InputMaybe<Scalars['MongoID']>;
  /** A silenced order will not show as unfulfilled or active in statistics */
  silenced?: InputMaybe<Scalars['Boolean']>;
  splitOrder?: InputMaybe<Scalars['Boolean']>;
  /** If the tracking mail has been sent to the consumer */
  trackingMailSent?: InputMaybe<Scalars['Boolean']>;
  trackingOrderState?: InputMaybe<EnumOrder2TrackingOrderState>;
  trackingReturnState?: InputMaybe<EnumOrder2TrackingReturnState>;
  updatedBy?: InputMaybe<ObjectPatchesUpdatedByInput>;
  /** Timestamp of the latest orderline that has been updated */
  updatedLineTs?: InputMaybe<Scalars['Date']>;
};

export type OrderUpdateInput2 = {
  billingAddress?: InputMaybe<Order2ShippingAddressInput>;
  captureFailedTs?: InputMaybe<Scalars['Date']>;
  captureNotified?: InputMaybe<Scalars['Boolean']>;
  /** The total amount to be captured for this order */
  captureTotal?: InputMaybe<Scalars['Float']>;
  carrierInfo?: InputMaybe<Order2CarrierInfoInput>;
  carrierInput?: InputMaybe<Order2CarrierInputInput>;
  /** Comment for the order */
  comment?: InputMaybe<Scalars['String']>;
  consumer?: InputMaybe<Order2ConsumerInput>;
  /** Currency for this order */
  currency?: InputMaybe<Scalars['String']>;
  /** Custom data for the order */
  customData?: InputMaybe<Scalars['JSON']>;
  /** Soft delete */
  deleted?: InputMaybe<Scalars['Boolean']>;
  externalId: Scalars['String'];
  /** A free return order is not reduced by the brand's return freight (refundAdjustment) when a line is returned */
  freeReturn?: InputMaybe<Scalars['Boolean']>;
  fulState?: InputMaybe<EnumOrder2FulState>;
  /** Whether this is a new order */
  isNewOrder?: InputMaybe<Scalars['Boolean']>;
  lines?: InputMaybe<Array<InputMaybe<OrderUpdateLineInput2>>>;
  locked?: InputMaybe<Scalars['String']>;
  /** True while the sales channel holds the order back from fulfilment (e.g. a Shopify fulfillment hold on one of its lines). Its items stay sold, but the warehouse must not pick it */
  onHold?: InputMaybe<Scalars['Boolean']>;
  orderDate?: InputMaybe<Scalars['Date']>;
  orderName?: InputMaybe<Scalars['String']>;
  orderState?: InputMaybe<EnumOrder2OrderState>;
  orderUrl?: InputMaybe<Scalars['String']>;
  payState?: InputMaybe<EnumOrder2PayState>;
  /** True if the order is a proforma order */
  proforma?: InputMaybe<Scalars['Boolean']>;
  /** True if the order commission can be invoiced, even if it is a proforma order */
  proformaInvoiceCommission?: InputMaybe<Scalars['Boolean']>;
  /** True if the order pickpack can be invoiced, even if it is a proforma order */
  proformaInvoicePickPack?: InputMaybe<Scalars['Boolean']>;
  /** True if the order shipping can be invoiced, even if it is a proforma order */
  proformaInvoiceShipping?: InputMaybe<Scalars['Boolean']>;
  /** The returnDeadline for an order is typically determined by the settings, but its possible to set the returnDeadline to override that */
  returnDeadline?: InputMaybe<Scalars['Date']>;
  returnInfo?: InputMaybe<Order2ReturnInfoInput>;
  returnShippingLabelId?: InputMaybe<Scalars['MongoID']>;
  shippingAddress?: InputMaybe<Order2ShippingAddressInput>;
  shippingAddressInternal?: InputMaybe<Order2ShippingAddressInput>;
  /** A silenced order will not show as unfulfilled or active in statistics */
  silenced?: InputMaybe<Scalars['Boolean']>;
  splitOrder?: InputMaybe<Scalars['Boolean']>;
  /** If the tracking mail has been sent to the consumer */
  trackingMailSent?: InputMaybe<Scalars['Boolean']>;
  trackingOrderState?: InputMaybe<EnumOrder2TrackingOrderState>;
  trackingReturnState?: InputMaybe<EnumOrder2TrackingReturnState>;
  updatedBy?: InputMaybe<ObjectPatchesUpdatedByInput>;
  /** Timestamp of the latest orderline that has been updated */
  updatedLineTs?: InputMaybe<Scalars['Date']>;
};

export type OrderUpdateLineInput2 = {
  cancelled?: InputMaybe<Scalars['Boolean']>;
  cancelledNr?: InputMaybe<Scalars['Float']>;
  /** Reason for cancellation, customer specific code */
  cancelledReason?: InputMaybe<Scalars['String']>;
  cancelledTs?: InputMaybe<Scalars['Date']>;
  currency?: InputMaybe<Scalars['String']>;
  /** Custom data for the orderline */
  customData?: InputMaybe<Scalars['JSON']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  discountedPrice?: InputMaybe<Scalars['Float']>;
  discountedPricePreTax?: InputMaybe<Scalars['Float']>;
  ean?: InputMaybe<Scalars['String']>;
  /** The external id of the order line */
  externalLineId: Scalars['String'];
  fulfilled?: InputMaybe<Scalars['Boolean']>;
  /** The quantity of the orderline, if not present then 1 is assumed */
  quantity?: InputMaybe<Scalars['Float']>;
  /** True if the orderline should be refunded, see the refunded field that indicates whether an actual refund has been issued */
  refund?: InputMaybe<Scalars['Boolean']>;
  refunded?: InputMaybe<Scalars['Date']>;
  /** Reason for return, customer specific code */
  returnedReason?: InputMaybe<Scalars['String']>;
  salesPrice?: InputMaybe<Scalars['Float']>;
  sku?: InputMaybe<Scalars['String']>;
  /** The tax rate the sales channel applied to this line, as a fraction (0.25 = 25% VAT). The sum of all tax lines; 0 for untaxed sales such as exports or reverse charge */
  taxRate?: InputMaybe<Scalars['Float']>;
  updatedBy?: InputMaybe<ObjectPatchesUpdatedByInput>;
};

export type PaginationInfo = {
  __typename?: 'PaginationInfo';
  currentPage: Scalars['Int'];
  hasNextPage?: Maybe<Scalars['Boolean']>;
  hasPreviousPage?: Maybe<Scalars['Boolean']>;
  itemCount?: Maybe<Scalars['Int']>;
  pageCount?: Maybe<Scalars['Int']>;
  perPage: Scalars['Int'];
};

export type Parcel = {
  __typename?: 'Parcel';
  _id: Scalars['MongoID'];
  /** The brand that owns this parcel */
  brandHouseId: Scalars['MongoID'];
  /** Optional comment for the parcel */
  comment?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['Date']>;
  deleted?: Maybe<Scalars['Boolean']>;
  /** Items in the parcel */
  items?: Maybe<Array<Maybe<ParcelItems>>>;
  /** The date of the parcel creation */
  parcelDate: Scalars['Date'];
  /** The receiver of the parcel */
  receiver: AddressInfo;
  /** The sender of the parcel */
  sender: AddressInfo;
  /** The shipping carrier for this parcel */
  shippingCarrier?: Maybe<ShippingCarrier>;
  /** The carrier of the parcel */
  shippingCarrierId?: Maybe<Scalars['MongoID']>;
  /** The shipping label for this parcel */
  shippingLabel?: Maybe<ShippingLabel>;
  shippingLabelId?: Maybe<Scalars['MongoID']>;
  /** The shop that owns this parcel */
  shopId?: Maybe<Scalars['MongoID']>;
  updatedAt?: Maybe<Scalars['Date']>;
};

export type ParcelItems = {
  __typename?: 'ParcelItems';
  refId: Scalars['MongoID'];
  refType: EnumParcelItemsRefType;
};

export type ParcelItemsInput = {
  refId: Scalars['MongoID'];
  refType: EnumParcelItemsRefType;
};

export type ParcelManualTrackingInput = {
  packageCode: Scalars['String'];
};

/** List of items with pagination. */
export type ParcelParcelPagination = {
  __typename?: 'ParcelParcelPagination';
  /** Total object count. */
  count?: Maybe<Scalars['Int']>;
  /** Array of objects. */
  items?: Maybe<Array<Parcel>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export enum ParcelTrackingCarrier {
  b2c_europe = 'b2c_europe',
  dao = 'dao',
  deutsche_post = 'deutsche_post',
  dhl = 'dhl',
  dhl_express = 'dhl_express',
  gls = 'gls',
  parcelplus = 'parcelplus',
  pdk = 'pdk',
  ups = 'ups'
}

export type ParcelTrackingInput = {
  /** The carrier */
  carrier: ParcelTrackingCarrier;
  /** The tracking code */
  code: Scalars['String'];
  /** The status of the parcel */
  status: ParcelTrackingStatus;
};

export enum ParcelTrackingStatus {
  AVAILABLEFORPICKUP = 'AVAILABLEFORPICKUP',
  DELIVERED = 'DELIVERED',
  EXCEPTION = 'EXCEPTION',
  EXPIRED = 'EXPIRED',
  FAILEDATTEMPT = 'FAILEDATTEMPT',
  INFORECEIVED = 'INFORECEIVED',
  INTRANSIT = 'INTRANSIT',
  OUTFORDELIVERY = 'OUTFORDELIVERY',
  PENDING = 'PENDING'
}

export type PathDifference = {
  __typename?: 'PathDifference';
  differenceType?: Maybe<DifferenceTypeEnum>;
  modelName: Scalars['String'];
  path: Scalars['String'];
  valueA?: Maybe<Scalars['JSON']>;
  valueB?: Maybe<Scalars['JSON']>;
};

export type PlannedMail = {
  __typename?: 'PlannedMail';
  _id: Scalars['MongoID'];
  mailType: Scalars['String'];
  objectId: Scalars['String'];
  objectType: Scalars['String'];
  sendAt: Scalars['Date'];
  sent?: Maybe<Scalars['Date']>;
  sentStatus?: Maybe<Scalars['String']>;
  shopId: Scalars['MongoID'];
};

/** List of items with pagination. */
export type PlannedMailPlannedMailPagination = {
  __typename?: 'PlannedMailPlannedMailPagination';
  /** Total object count. */
  count?: Maybe<Scalars['Int']>;
  /** Array of objects. */
  items?: Maybe<Array<PlannedMail>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type Potential = {
  __typename?: 'Potential';
  _id: Scalars['MongoID'];
  batchSerial?: Maybe<Scalars['String']>;
  brandHouseId?: Maybe<Scalars['MongoID']>;
  /** The brand product that this potential is related to */
  brandProductId?: Maybe<Scalars['MongoID']>;
  /** The brand product size that this potential is related to */
  brandProductSizeId?: Maybe<Scalars['MongoID']>;
  /** The brand product variant that this potential is derived from */
  brandProductVariant?: Maybe<BrandProductVariant>;
  /** The brand product variant that this potential is related to */
  brandProductVariantId?: Maybe<Scalars['MongoID']>;
  cancelled?: Maybe<Scalars['Boolean']>;
  cancelledReason?: Maybe<EnumPotentialCancelledReason>;
  color?: Maybe<Scalars['String']>;
  consumer?: Maybe<Consumer>;
  consumerId: Scalars['MongoID'];
  createdAt?: Maybe<Scalars['Date']>;
  description?: Maybe<Scalars['String']>;
  ean?: Maybe<Scalars['String']>;
  externDate?: Maybe<Scalars['Date']>;
  externGroupId?: Maybe<Scalars['String']>;
  externUrl?: Maybe<Scalars['String']>;
  /** True if this potential is free to be added to anyones tradein */
  freePotential?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  /** How masterdata identified this potential on its last answered identification (NONE when no variant was found) */
  identifiedBy?: Maybe<EnumPotentialIdentifiedBy>;
  imageIds?: Maybe<Array<Maybe<Scalars['MongoID']>>>;
  imageUrls?: Maybe<Array<Scalars['String']>>;
  isUsingFakeProduct?: Maybe<Scalars['Boolean']>;
  /** The last time masterdata answered an identification for this potential */
  linkTs?: Maybe<Scalars['Date']>;
  lockedTs?: Maybe<Scalars['Date']>;
  /** The MAS masterdata variant id this potential is related to */
  masterVariantId?: Maybe<Scalars['String']>;
  masterVariantImageId?: Maybe<Scalars['String']>;
  masterVariantImageUrl?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  /** Whether this potential has no "date", its not actually bought, or we dont know the date - means that any date check in the tradein rules will be voided */
  noDate?: Maybe<Scalars['Boolean']>;
  /** If the owner of this potential was contacting with trade-in offers for this */
  notified?: Maybe<EnumPotentialNotified>;
  /** When was the owner of this potential contacting regarding trade-in offers */
  notifiedTs?: Maybe<Scalars['Date']>;
  /** The trade-in value for this potential */
  offer?: Maybe<PotentialValue>;
  /** DEPRECATED. The product this potential trade-in is derived from */
  product?: Maybe<Product>;
  /** The id of the product this potential is related to */
  productId?: Maybe<Scalars['MongoID']>;
  /** The product variant that this potential is derived from */
  productVariant?: Maybe<ProductVariant>;
  /** The id of the product variant this potential is related to */
  productVariantId?: Maybe<Scalars['MongoID']>;
  /** The id of the product variant this potential is related to */
  productVariantSizeId?: Maybe<Scalars['MongoID']>;
  rrp?: Maybe<Scalars['Float']>;
  /** The shop that owns this potential */
  shop?: Maybe<Shop>;
  shopId?: Maybe<Scalars['MongoID']>;
  size?: Maybe<Scalars['String']>;
  sku?: Maybe<Scalars['String']>;
  /** The source of the potential */
  sourceType?: Maybe<PotentialSourceTypeEnum>;
  sp?: Maybe<Scalars['Float']>;
  spOriginal?: Maybe<Scalars['Float']>;
  /** Status of this potential */
  status?: Maybe<Status>;
  /** The tradeIn item for this potential */
  tradeInItem?: Maybe<TradeInItem>;
  tradeInItemId?: Maybe<Scalars['MongoID']>;
  updatedAt?: Maybe<Scalars['Date']>;
  wholeSale?: Maybe<PotentialWholeSale>;
};


export type PotentialOfferArgs = {
  brandRuleId?: InputMaybe<Scalars['MongoID']>;
  live?: InputMaybe<Scalars['Boolean']>;
};


export type PotentialStatusArgs = {
  brandRuleId?: InputMaybe<Scalars['MongoID']>;
  live?: InputMaybe<Scalars['Boolean']>;
};

export enum PotentialAccountEnum {
  CUSTOMID = 'CUSTOMID',
  EMAIL = 'EMAIL',
  EXTERNALID = 'EXTERNALID',
  PERSONID = 'PERSONID',
  PHONE = 'PHONE'
}

/** Potentials by account */
export type PotentialByAccount = {
  __typename?: 'PotentialByAccount';
  /** The email of the customer */
  email?: Maybe<Scalars['String']>;
  /** The potentials that cant be traded back */
  exclusions?: Maybe<Array<PotentialByAccountItem>>;
  /** The customer identifier */
  id: Scalars['MongoID'];
  /** The name of the customer */
  name?: Maybe<Scalars['String']>;
  /** The phone of the customer */
  phone?: Maybe<Scalars['String']>;
  /** The potentials that can be traded back */
  potentials?: Maybe<Array<PotentialByAccountItem>>;
  /** Type of account */
  type: PotentialAccountEnum;
};

/** Item in an account */
export type PotentialByAccountItem = {
  __typename?: 'PotentialByAccountItem';
  /** The currency of the tradein value */
  currency: Scalars['String'];
  /** The ID of the potential */
  id: Scalars['String'];
  /** An image of the product */
  image?: Maybe<Scalars['String']>;
  /** Name of the product */
  name?: Maybe<Scalars['String']>;
  /** The date of the order */
  orderDate?: Maybe<Scalars['Date']>;
  /** The type of the item */
  type: Scalars['String'];
  /** The tradein value of the potential */
  value?: Maybe<Scalars['Float']>;
};

/** Item for a consumer */
export type PotentialOfferItem = {
  __typename?: 'PotentialOfferItem';
  /** The potential external id */
  externalId: Scalars['String'];
  /** An image of the product */
  image?: Maybe<Scalars['String']>;
  /** The date of the order */
  orderDate?: Maybe<Scalars['Date']>;
  /** The DE date of the order */
  orderDateDE?: Maybe<Scalars['String']>;
  /** The DK date of the order */
  orderDateDK?: Maybe<Scalars['String']>;
  /** The UK date of the order */
  orderDateUK?: Maybe<Scalars['String']>;
  /** The ID of the potential */
  title: Scalars['String'];
  /** Name of the product */
  voucher?: Maybe<Scalars['String']>;
  /** The tradein value of the potential */
  voucherCurrency?: Maybe<Scalars['String']>;
  /** The tradein value of the potential */
  voucherValue?: Maybe<Scalars['Float']>;
};

/** Potential offers for consumer */
export type PotentialOffers = {
  __typename?: 'PotentialOffers';
  /** The brand house id */
  brandHouseId: Scalars['MongoID'];
  /** The date of the latest offer */
  daysLatestOrder?: Maybe<Scalars['Int']>;
  /** The customer email / identifier */
  email: Scalars['String'];
  /** The customer external id */
  externalId?: Maybe<Scalars['String']>;
  /** The customer email / identifier */
  login: Scalars['String'];
  /** The date of the oldest offer */
  offerDate?: Maybe<Scalars['Date']>;
  /** The date of the latest offer */
  offerLatest?: Maybe<Scalars['Date']>;
  /** The  that can be traded back */
  offers?: Maybe<Array<PotentialOfferItem>>;
  /** The customer email / identifier */
  offersCount: Scalars['Int'];
  /** The date of the latest offer */
  timestamp?: Maybe<Scalars['Date']>;
  /** The total value of the offers */
  value?: Maybe<Scalars['Int']>;
  /** The currency of the total value */
  valueCurrency?: Maybe<Scalars['String']>;
};

/** List of items with pagination. */
export type PotentialPotentialDtcPagination = {
  __typename?: 'PotentialPotentialDTCPagination';
  /** Total object count. */
  count?: Maybe<Scalars['Int']>;
  /** Array of objects. */
  items?: Maybe<Array<Potential>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

/** List of items with pagination. */
export type PotentialPotentialPagination = {
  __typename?: 'PotentialPotentialPagination';
  /** Total object count. */
  count?: Maybe<Scalars['Int']>;
  /** Array of objects. */
  items?: Maybe<Array<Potential>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export enum PotentialSourceTypeEnum {
  DIGITALPASS = 'DIGITALPASS',
  ONLINE = 'ONLINE',
  RECIEPT = 'RECIEPT',
  SEARCH = 'SEARCH',
  WHOLESALE = 'WHOLESALE'
}

/** Data for potential synchronization of 1 item */
export type PotentialSynchronize2Input = {
  consumer?: InputMaybe<PotentialSynchronize2InputConsumer>;
  currency?: InputMaybe<Scalars['String']>;
  dateTime: Scalars['Date'];
  externId: Scalars['String'];
  externUrl?: InputMaybe<Scalars['String']>;
  freePotentials?: InputMaybe<Scalars['Boolean']>;
  items?: InputMaybe<Array<InputMaybe<PotentialSynchronize2InputItem>>>;
  /** Whether its an online item or pos item */
  sourceType?: InputMaybe<PotentialSourceTypeEnum>;
};

/** Consumer information for Synchronization of items */
export type PotentialSynchronize2InputConsumer = {
  acceptsMarketing: Scalars['Boolean'];
  accountType?: InputMaybe<Scalars['String']>;
  add1?: InputMaybe<Scalars['String']>;
  add2?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  company?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  countryCode?: InputMaybe<Scalars['String']>;
  externalId?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  lastName?: InputMaybe<Scalars['String']>;
  locale?: InputMaybe<Scalars['String']>;
  mail?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  zipCode?: InputMaybe<Scalars['String']>;
};

/** Item information for Synchronization of items */
export type PotentialSynchronize2InputItem = {
  cancelled: Scalars['Boolean'];
  cancelledReason?: InputMaybe<CancelReason>;
  color?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  /** Barcode of the sold variant */
  ean?: InputMaybe<Scalars['String']>;
  /** Platform variant id (e.g. Shopify ProductVariant GID); informational, not used for masterdata identification */
  externalId?: InputMaybe<Scalars['String']>;
  /** A brand unique identifier, must identify this concrete potential and none other */
  id: Scalars['String'];
  name?: InputMaybe<Scalars['String']>;
  noDate?: InputMaybe<Scalars['Boolean']>;
  /** Price of the item, if no currency is provided then shop currency is assumed */
  price?: InputMaybe<Scalars['Float']>;
  /** Original price of the item, before any discounts */
  priceOriginal?: InputMaybe<Scalars['Float']>;
  size?: InputMaybe<Scalars['String']>;
  /** Legacy Core product ids; when given, the line is not identified through masterdata */
  sizeId?: InputMaybe<Scalars['String']>;
  sku?: InputMaybe<Scalars['String']>;
  /** Legacy Core product ids; when given, the line is not identified through masterdata */
  variantId?: InputMaybe<Scalars['String']>;
  wholeSaleCategoryId?: InputMaybe<Scalars['String']>;
  wholeSaleImageId?: InputMaybe<Scalars['String']>;
  wholeSaleValue?: InputMaybe<Scalars['Int']>;
};

export type PotentialValue = {
  __typename?: 'PotentialValue';
  _id: Scalars['MongoID'];
  /** When this trade-in value is activated */
  activation?: Maybe<EnumPotentialValueActivation>;
  /** Whether the brandrule that generated this value is/was active */
  brandRuleActive: Scalars['Boolean'];
  /** The id of the brandrule that generated this value */
  brandRuleId: Scalars['MongoID'];
  /** Whether the brandrule that generated this value matched */
  brandRuleMatches: Scalars['Boolean'];
  /** The version of the brandrule that generated this value */
  brandRuleVersion: Scalars['Float'];
  /** The consumer that gets this offer */
  consumerId: Scalars['MongoID'];
  /** The currency */
  currency: Scalars['String'];
  /** The value that was exported to external systems, used to detect required updates */
  exportedValue?: Maybe<Scalars['Float']>;
  /** The values exported to different marketing integrations, instanceId -> value */
  exportedValues?: Maybe<Scalars['JSON']>;
  /** The fingerprint of the potential's valuation inputs this value was computed from; absent on values computed before fingerprints existed */
  inputsFingerprint?: Maybe<Scalars['String']>;
  /** The date that this offer can be sent to the consumer */
  notifyDate?: Maybe<Scalars['Date']>;
  /** The potential item that this value is linked to */
  potentialId: Scalars['MongoID'];
  /** If the owner of this potential was contacting with trade-in offers for this */
  potentialNotified: EnumPotentialValuePotentialNotified;
  /** The shop that owns this value */
  shopId?: Maybe<Scalars['MongoID']>;
  /** The timestamp of the last update to this potentialvalue */
  ts: Scalars['Date'];
  /** Whether this offer is valid for tradein */
  validForTradeIn?: Maybe<Scalars['Boolean']>;
  /** The value of the potential */
  value?: Maybe<Scalars['Float']>;
  /** Whether this is a wholesale potential value */
  wholeSale: Scalars['Boolean'];
};

export type PotentialWholeSale = {
  __typename?: 'PotentialWholeSale';
  _id?: Maybe<Scalars['MongoID']>;
  categoryId?: Maybe<Scalars['MongoID']>;
  name?: Maybe<Scalars['String']>;
  ruleId?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['Float']>;
};

export type Pricing = {
  __typename?: 'Pricing';
  /** The ISO currency code */
  currency: Scalars['String'];
  /** The pricing value */
  value: Scalars['Float'];
};

export type PricingInput = {
  /** The ISO currency code */
  currency: Scalars['String'];
  /** The pricing value */
  value: Scalars['Float'];
};

export type Product = {
  __typename?: 'Product';
  _id: Scalars['MongoID'];
  batchSerial?: Maybe<Scalars['String']>;
  /** The brandproduct that is the master data for this product */
  brandProductId?: Maybe<Scalars['MongoID']>;
  collections?: Maybe<Array<Maybe<Scalars['String']>>>;
  createdAt?: Maybe<Scalars['Date']>;
  deleted?: Maybe<Scalars['Boolean']>;
  description?: Maybe<Scalars['String']>;
  descriptionLocalized?: Maybe<Array<Maybe<LocalizationEntry>>>;
  disabled?: Maybe<Scalars['Boolean']>;
  externalId?: Maybe<Scalars['String']>;
  /** Images for this product */
  images?: Maybe<Array<Maybe<Scalars['String']>>>;
  isPotential?: Maybe<Scalars['Boolean']>;
  isPreOwned?: Maybe<Scalars['Boolean']>;
  metaFields?: Maybe<Array<Maybe<MetaField>>>;
  name: Scalars['String'];
  nameLocalized?: Maybe<Array<Maybe<LocalizationEntry>>>;
  productType?: Maybe<Scalars['String']>;
  productVariants?: Maybe<Array<Maybe<ProductVariant>>>;
  productVendor?: Maybe<Scalars['String']>;
  shopId: Scalars['MongoID'];
  style?: Maybe<Scalars['String']>;
  tags?: Maybe<Array<Maybe<Scalars['String']>>>;
  updatedAt?: Maybe<Scalars['Date']>;
};

export type ProductImage = {
  __typename?: 'ProductImage';
  _id: Scalars['MongoID'];
  archivedImage?: Maybe<Scalars['Boolean']>;
  archivedThumb?: Maybe<Scalars['Boolean']>;
  /** The master data image for this */
  brandImageId?: Maybe<Scalars['MongoID']>;
  createdAt?: Maybe<Scalars['Date']>;
  /** Indicates if this is the default image for the variant */
  defaultImage?: Maybe<Scalars['Boolean']>;
  deleted?: Maybe<Scalars['Boolean']>;
  error?: Maybe<Scalars['String']>;
  errorCount?: Maybe<Scalars['Float']>;
  /** An image unique external identifier for the variant */
  externalId?: Maybe<Scalars['String']>;
  imageAltText?: Maybe<Scalars['String']>;
  imageId?: Maybe<Scalars['MongoID']>;
  /** The md5 hash of the image, used to compare images */
  imageMd5?: Maybe<Scalars['String']>;
  /** Image url */
  imageUrl?: Maybe<Scalars['String']>;
  lastUpdate?: Maybe<Scalars['Date']>;
  perspective?: Maybe<EnumProductImagePerspective>;
  productId?: Maybe<Scalars['MongoID']>;
  productVariantId?: Maybe<Scalars['MongoID']>;
  shopId: Scalars['MongoID'];
  sortOrder?: Maybe<Scalars['Float']>;
  sourceUrl?: Maybe<Scalars['String']>;
  /** Contains a hash of the settings that was used to generate the thumbnail. Used to detect changes to actual thumbnail settings and the generated thumbnails */
  thumbnailHash?: Maybe<Scalars['Float']>;
  thumbnailId?: Maybe<Scalars['MongoID']>;
  type?: Maybe<EnumProductImageType>;
  updatedAt?: Maybe<Scalars['Date']>;
  watermarkedId?: Maybe<Scalars['MongoID']>;
};

export type ProductImageSynchronizeInput = {
  /** Whether this is the default image for the variant */
  defaultImage?: InputMaybe<Scalars['Boolean']>;
  /** Shop unique identifier for the variant, should always be provided - the sourceUrl will be used if not */
  externalId?: InputMaybe<Scalars['String']>;
  /** Image alt text */
  imageAltText?: InputMaybe<Scalars['String']>;
  /** The perspective of the image */
  perspective?: InputMaybe<ImagePerspectiveEnum>;
  /** Images will be sorted ascending by this number */
  sortOrder?: InputMaybe<Scalars['Int']>;
  /** The external URL of this image */
  sourceUrl: Scalars['String'];
  /** The type of image */
  type?: InputMaybe<ImageTypeEnum>;
};

export type ProductPaging = {
  __typename?: 'ProductPaging';
  data?: Maybe<Array<Maybe<Product>>>;
  page: Scalars['Int'];
  pages: Scalars['Int'];
  total: Scalars['Int'];
};

/** List of items with pagination. */
export type ProductProductPagination = {
  __typename?: 'ProductProductPagination';
  /** Total object count. */
  count?: Maybe<Scalars['Int']>;
  /** Array of objects. */
  items?: Maybe<Array<Product>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type ProductStatistic = {
  __typename?: 'ProductStatistic';
  productsNoImages?: Maybe<Array<Maybe<Scalars['String']>>>;
  variants: Scalars['Int'];
  variantsImages: Scalars['Int'];
  variantsNoImages: Scalars['Int'];
  variantsNoThumbnails: Scalars['Int'];
  variantsThumbnails: Scalars['Int'];
};

export type ProductSynchronizeInput = {
  /** Source of the synchronize */
  batchSerial?: InputMaybe<Scalars['String']>;
  /** A list of collections that this product has been part of */
  collections?: InputMaybe<Array<Scalars['String']>>;
  /** The description of the product localized */
  description?: InputMaybe<Scalars['String']>;
  /** The description of the product localized */
  descriptionLocalized?: InputMaybe<Array<InputMaybe<LocalizationEntryInput>>>;
  /** Shop Unique identifier for the product */
  externalId: Scalars['String'];
  /** Whether this is a preowned style */
  isPreOwned?: InputMaybe<Scalars['Boolean']>;
  /** Additional data for product */
  metaFields?: InputMaybe<Array<MetaFieldInput>>;
  /** The name of the product */
  name?: InputMaybe<Scalars['String']>;
  /** The name of the product localized */
  nameLocalized?: InputMaybe<Array<InputMaybe<LocalizationEntryInput>>>;
  /** Type of product */
  productType?: InputMaybe<Scalars['String']>;
  /** Vendor of product */
  productVendor?: InputMaybe<Scalars['String']>;
  /** Style number for the product */
  style?: InputMaybe<Scalars['String']>;
  /** A list of tags for the product */
  tags?: InputMaybe<Array<Scalars['String']>>;
  /** Variants for this product */
  variants?: InputMaybe<Array<ProductVariantSynchronizeInput>>;
};

export enum ProductSynchronizeMode {
  MERGE = 'MERGE',
  REPLACE = 'REPLACE',
  UPDATEIMAGES = 'UPDATEIMAGES'
}

export type ProductSynchronizeTranslationsInput = {
  /** The description of the product localized */
  descriptionLocalized?: InputMaybe<Array<InputMaybe<LocalizationEntryInput>>>;
  /** Shop Unique identifier for the product */
  externalId: Scalars['String'];
  /** The name of the product localized */
  nameLocalized?: InputMaybe<Array<InputMaybe<LocalizationEntryInput>>>;
  /** The product type localizations */
  productType?: InputMaybe<Array<InputMaybe<LocalizationEntryInput>>>;
};

export type ProductVariant = {
  __typename?: 'ProductVariant';
  _id: Scalars['MongoID'];
  batchSerial?: Maybe<Scalars['String']>;
  brandProductVariantId?: Maybe<Scalars['MongoID']>;
  color?: Maybe<Scalars['String']>;
  /** The tariff code for use in customs declarations. */
  commodityCode?: Maybe<Scalars['String']>;
  /** The ISO 3166-1 alpha-2 country code of origin. */
  countryOrigin?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['Date']>;
  deactivated?: Maybe<Scalars['Boolean']>;
  deleted?: Maybe<Scalars['Boolean']>;
  ean?: Maybe<Scalars['String']>;
  externalId?: Maybe<Scalars['String']>;
  imageUrls?: Maybe<Array<Scalars['String']>>;
  /** Returns a list of images for this variant */
  images?: Maybe<Array<Maybe<ProductImage>>>;
  isPotential?: Maybe<Scalars['Boolean']>;
  metaFields?: Maybe<Array<Maybe<MetaField>>>;
  product?: Maybe<Product>;
  productId: Scalars['MongoID'];
  rrp?: Maybe<Array<Maybe<Pricing>>>;
  /** The shop */
  shop?: Maybe<Shop>;
  shopId: Scalars['MongoID'];
  size?: Maybe<Scalars['String']>;
  /** Returns a list of sizes for this variant */
  sizes?: Maybe<Array<Maybe<ProductVariantSize>>>;
  sku?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['Date']>;
};

/** List of items with pagination. */
export type ProductVariantProductVariantPagination = {
  __typename?: 'ProductVariantProductVariantPagination';
  /** Total object count. */
  count?: Maybe<Scalars['Int']>;
  /** Array of objects. */
  items?: Maybe<Array<ProductVariant>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type ProductVariantSize = {
  __typename?: 'ProductVariantSize';
  _id: Scalars['MongoID'];
  createdAt?: Maybe<Scalars['Date']>;
  /** True if this product has been deleted */
  deleted?: Maybe<Scalars['Boolean']>;
  /** The EAN-13 of this variant */
  ean?: Maybe<Scalars['String']>;
  /** A variant unique external identifier */
  externalId: Scalars['String'];
  /** Extra data about the variant */
  metaFields?: Maybe<Array<Maybe<MetaField>>>;
  productId: Scalars['MongoID'];
  /** Returns the product variant that owns this size */
  productVariant?: Maybe<ProductVariant>;
  /** The variant that owns this size */
  productVariantId: Scalars['MongoID'];
  /** The shop that owns this variant */
  shopId: Scalars['MongoID'];
  /** The size */
  size: Scalars['String'];
  /** The SKU of this variant */
  sku?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['Date']>;
};

export type ProductVariantSizeSynchronizeInput = {
  /** Whether this size is deleted */
  deleted?: InputMaybe<Scalars['Boolean']>;
  /** The EAN number */
  ean?: InputMaybe<Scalars['String']>;
  /** Shop unique identifier for the variant, should always be provided - the sourceUrl will be used if not */
  externalId?: InputMaybe<Scalars['String']>;
  /** Additional data */
  metaFields?: InputMaybe<Array<MetaFieldInput>>;
  /** The size */
  size: Scalars['String'];
  /** SKU */
  sku?: InputMaybe<Scalars['String']>;
};

export type ProductVariantSynchronizeInput = {
  /** Color for the variant */
  color?: InputMaybe<Scalars['String']>;
  /** The tariff code for use in customs declarations */
  commodityCode?: InputMaybe<Scalars['String']>;
  /** The ISO 3166-1 alpha-2 country code of origin */
  countryOrigin?: InputMaybe<Scalars['String']>;
  /** Whether this variant is deactivated for use */
  deactivated?: InputMaybe<Scalars['Boolean']>;
  /** The EAN number of the variant */
  ean?: InputMaybe<Scalars['String']>;
  /** Shop Unique identifier for the variant */
  externalId: Scalars['String'];
  /** Images for this variant */
  images?: InputMaybe<Array<ProductImageSynchronizeInput>>;
  /** RRP for this variant */
  rrp?: InputMaybe<Array<PricingInput>>;
  /** Size for the variant */
  size?: InputMaybe<Scalars['String']>;
  /** Size for the variant */
  sizes?: InputMaybe<Array<ProductVariantSizeSynchronizeInput>>;
  /** SKU for the variant */
  sku?: InputMaybe<Scalars['String']>;
};

export type QrSession = {
  __typename?: 'QRSession';
  _id: Scalars['MongoID'];
  code?: Maybe<Scalars['String']>;
  logisticsPartnerId: Scalars['MongoID'];
  updateTs?: Maybe<Scalars['Date']>;
  userId: Scalars['MongoID'];
};

export type Query = {
  __typename?: 'Query';
  /** Get a single audit note by ID */
  AuditNote?: Maybe<AuditNote>;
  /** List recent audit notes for a brand house */
  AuditNotes?: Maybe<Array<Maybe<AuditNote>>>;
  /** Lists the workflow schema from the autoretouch service */
  AutoRetouchWorkflows?: Maybe<Array<Maybe<AutoRetouchWorkflow>>>;
  BrandApiGet?: Maybe<BrandApi>;
  BrandCarrier?: Maybe<BrandCarrier>;
  BrandCircular?: Maybe<CircularSettings>;
  BrandHouse?: Maybe<BrandHouse>;
  /** Searches the masterdata (MAS) catalog for a BrandHouse by SKU, EAN or name. Returns matching styles with their variants. Empty when the BrandHouse has no MAS brand. */
  BrandHouseMasterDataSearch?: Maybe<Array<Maybe<MasterDataProduct>>>;
  /** Visual-similarity masterdata (MAS) search for a BrandHouse. The masterdata service classifies the supplied image and returns the best-matching styles with a score. Empty when the BrandHouse has no MAS brand. */
  BrandHouseMasterDataVisualSearch?: Maybe<Array<Maybe<MasterDataVisualSearchHit>>>;
  BrandHouses: Array<BrandHouse>;
  BrandItem?: Maybe<BrandItem>;
  BrandItemImage?: Maybe<BrandItemImage>;
  BrandItemImagesRequireAudit?: Maybe<Array<BrandItemImage>>;
  BrandItemLayaway?: Maybe<BrandItemLayaway>;
  /** Get all layaway history for a specific brand item */
  BrandItemLayawayHistory?: Maybe<Array<Maybe<BrandItemLayaway>>>;
  BrandItemLayawayMany: Array<BrandItemLayaway>;
  BrandItemLayawayPagination?: Maybe<BrandItemLayawayBrandItemLayawayPagination>;
  BrandItemMany: Array<BrandItem>;
  /** Gets item results for a BrandItem MAS migration run */
  BrandItemMasterDataMigrationItems?: Maybe<Array<Maybe<BrandItemMasterDataMigrationItem>>>;
  /** Gets a BrandItem MAS migration run */
  BrandItemMasterDataMigrationRun?: Maybe<BrandItemMasterDataMigrationRun>;
  /** Will return master images for this item */
  BrandItemMasterImages?: Maybe<Array<Maybe<BrandItemMasterImage>>>;
  BrandItemPagination?: Maybe<BrandItemBrandItemPagination>;
  /** Will detect any problems with this branditem, optionally for a given storefront/shop */
  BrandItemProblems?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Returns up to 10 unique identifiers (EAN, SKU, or externalId) from different BrandProducts for brand items matching type AND primaryColor, scored by additional attribute matches including notable features */
  BrandItemRelatedIdentifiers: Array<Scalars['String']>;
  /** Returns unique identifiers (EAN, SKU, or externalId) from BrandProductVariants with similar images based on image embeddings using MongoDB Atlas Vector Search. Items are sorted by similarity score (most similar first). */
  BrandItemSimilarByImage: Array<Scalars['String']>;
  /** Will return branditems by their ids */
  BrandItems?: Maybe<Array<Maybe<BrandItem>>>;
  BrandLayout?: Maybe<TradeInLayout>;
  BrandLocalizations?: Maybe<Array<Maybe<Localization>>>;
  BrandProduct?: Maybe<BrandProduct>;
  BrandProductGroup?: Maybe<BrandProductGroup>;
  BrandProductGroups: Array<BrandProductGroup>;
  BrandProductImage?: Maybe<BrandProductImage>;
  BrandProductImages: Array<BrandProductImage>;
  BrandProductSize?: Maybe<BrandProductSize>;
  BrandProductSizes: Array<BrandProductSize>;
  BrandProductVariant?: Maybe<BrandProductVariant>;
  BrandProductVariants: Array<BrandProductVariant>;
  BrandProducts: Array<BrandProduct>;
  BrandProductsPagination?: Maybe<BrandProductBrandProductsPagination>;
  BrandRule?: Maybe<BrandRule>;
  BrandRules?: Maybe<Array<Maybe<BrandRule>>>;
  BrandSettings?: Maybe<BrandSetting>;
  BrandTrackingId?: Maybe<Scalars['String']>;
  BrickMail?: Maybe<BrickMail>;
  BrickMailTypeByID?: Maybe<BrickMailType>;
  BrickMailTypes?: Maybe<Array<Maybe<BrickMailType>>>;
  BrickMails?: Maybe<Array<Maybe<BrickMail>>>;
  Campaign?: Maybe<Campaign>;
  Campaigns: Array<Campaign>;
  CircularAccountById?: Maybe<CircularAccount>;
  CircularPayoutById?: Maybe<CircularPayoutType>;
  CircularPayoutMany: Array<CircularPayoutType>;
  CircularPointById?: Maybe<CircularPoint>;
  CircularPointMany: Array<CircularPoint>;
  ConfigCompare?: Maybe<ConfigCompareResult>;
  /** Find a ConsumerAccount by identifier across all shops in a brandHouse */
  ConsumerAccount?: Maybe<ConsumerAccount>;
  ConsumerById?: Maybe<Consumer>;
  /** Returns a consumer given its personId - the personId can be mail in some cases, but also external identifiers */
  ConsumerByIdentifier?: Maybe<Array<Maybe<Consumer>>>;
  /** Returns a list of carriers that are active for this consumer */
  ConsumerCarriers?: Maybe<Array<Maybe<BrandCarrier>>>;
  ConsumerDropoffs?: Maybe<Array<Maybe<Dropoff>>>;
  ConsumerEventPagination?: Maybe<ConsumerEventConsumerEventPagination>;
  ConsumerPagination?: Maybe<ConsumerConsumerPagination>;
  ConsumerPotentials?: Maybe<Array<Maybe<Potential>>>;
  ConsumerTradeIns?: Maybe<Array<Maybe<TradeIn>>>;
  /** Returns consumers, meant to be used in paged lists */
  Consumers?: Maybe<ConsumersPaging>;
  ConsumersFindMany: Array<Consumer>;
  ConvertCurrency?: Maybe<Pricing>;
  ConvertCurrencyForConsumer?: Maybe<Pricing>;
  Countries?: Maybe<Array<Maybe<Country>>>;
  CurrentConsumer?: Maybe<Consumer>;
  CurrentUser?: Maybe<User>;
  DataView?: Maybe<DataView>;
  DataViewList: Array<DataView>;
  ExternOrder2ByID?: Maybe<ExternOrder2>;
  ExternOrderByID?: Maybe<ExternOrder>;
  ExternOrders2Many: Array<ExternOrder2>;
  ExternOrdersMany: Array<ExternOrder>;
  Image?: Maybe<ImageUpload>;
  IntegrationConfig?: Maybe<Array<Maybe<IntegrationConfig>>>;
  IntegrationConnector?: Maybe<IntegrationConnector>;
  IntegrationConnectors: Array<IntegrationConnector>;
  IntegrationConnectorsCount?: Maybe<Scalars['Int']>;
  IntegrationInstance?: Maybe<IntegrationInstance>;
  IntegrationInstances: Array<IntegrationInstance>;
  IntegrationMessage?: Maybe<Array<Maybe<IntegrationMessageResult>>>;
  IntegrationMessageById?: Maybe<IntegrationMessage>;
  IntegrationMessages?: Maybe<IntegrationMessageIntegrationMessagePagination>;
  Invoice?: Maybe<Invoice>;
  InvoiceAdjustment?: Maybe<InvoiceAdjustment>;
  InvoiceAdjustments: Array<InvoiceAdjustment>;
  InvoiceIds?: Maybe<Array<Scalars['String']>>;
  InvoiceLines: Array<InvoiceLine>;
  InvoiceSetting?: Maybe<InvoiceSetting>;
  Invoices?: Maybe<Array<Maybe<Invoice>>>;
  ItemIssue?: Maybe<ItemIssue>;
  ItemIssues?: Maybe<ItemIssueItemIssuesPagination>;
  LogisticsPartner?: Maybe<LogisticsPartner>;
  LogisticsPartners: Array<LogisticsPartner>;
  /** Returns (potentially) all stockitems, useable by logisticspartners */
  LogisticsStockItems?: Maybe<Array<Maybe<StockItem>>>;
  NFCMany: Array<Nfc>;
  Option?: Maybe<OptionSet>;
  OptionValue?: Maybe<OptionValue>;
  OptionValues: Array<OptionValue>;
  Options: Array<OptionSet>;
  Order?: Maybe<Order2>;
  OrderById?: Maybe<Order2>;
  OrderCount?: Maybe<Scalars['Int']>;
  OrderLineById?: Maybe<Order2Item>;
  OrderPagination?: Maybe<Order2OrderPagination>;
  Orders?: Maybe<Array<Maybe<Order2>>>;
  Parcel?: Maybe<Parcel>;
  Parcels: Array<Parcel>;
  ParcelsPagination?: Maybe<ParcelParcelPagination>;
  PatchMany: Array<ObjectPatches>;
  PatchPagination?: Maybe<ObjectPatchesPatchItem>;
  PlannedMailById?: Maybe<PlannedMail>;
  PlannedMailsPagination?: Maybe<PlannedMailPlannedMailPagination>;
  Potential?: Maybe<Potential>;
  PotentialOffers?: Maybe<PotentialOffers>;
  Potentials: Array<Potential>;
  PotentialsByAccount?: Maybe<Array<PotentialByAccount>>;
  PotentialsByShop?: Maybe<Array<PotentialByAccount>>;
  PotentialsDTCPagination?: Maybe<PotentialPotentialPagination>;
  PotentialsPagination?: Maybe<PotentialPotentialDtcPagination>;
  ProductById?: Maybe<Product>;
  /** Returns the images we have stored for the given product variant */
  ProductImages?: Maybe<Array<Maybe<ProductImage>>>;
  ProductMany: Array<Product>;
  /** Returns statistics about products */
  ProductStatistics?: Maybe<ProductStatistic>;
  ProductVariant?: Maybe<ProductVariant>;
  ProductVariantById?: Maybe<ProductVariant>;
  ProductVariantMany: Array<ProductVariant>;
  ProductVariantSize?: Maybe<ProductVariantSize>;
  ProductVariantSizes: Array<ProductVariantSize>;
  ProductVariantsPagination?: Maybe<ProductVariantProductVariantPagination>;
  /** Returns products, meant to be used in paged lists, use ProductMany to query on all products */
  Products?: Maybe<ProductPaging>;
  ProductsByIDS: Array<Product>;
  ProductsPagination?: Maybe<ProductProductPagination>;
  PublicVoucherValue?: Maybe<Pricing>;
  PublicVoucherValue2?: Maybe<Pricing>;
  QRSession?: Maybe<QrSession>;
  QRSessions?: Maybe<Array<Maybe<QrSession>>>;
  ScheduledEventById?: Maybe<ScheduledEvent>;
  ScheduledEventsPagination?: Maybe<ScheduledEventScheduledEventPagination>;
  ShippingCarrier?: Maybe<ShippingCarrier>;
  ShippingCarriers?: Maybe<Array<Maybe<ShippingCarrier>>>;
  ShippingCarriersActive?: Maybe<Array<Maybe<ShippingCarrier>>>;
  ShippingCarriersForParcel?: Maybe<Array<Maybe<ShippingCarrier>>>;
  ShippingCarriersLP?: Maybe<Array<Maybe<ShippingCarrier>>>;
  ShippingCosts?: Maybe<Array<Maybe<ShippingCostOutput>>>;
  ShippingLabel?: Maybe<ShippingLabel>;
  Shop?: Maybe<Shop>;
  ShopById?: Maybe<Shop>;
  /** Returns a list of countries active for the given shop */
  ShopCountries?: Maybe<Array<Maybe<Country>>>;
  /** Returns a list of languages active for the given shop */
  ShopLanguages?: Maybe<Array<Scalars['String']>>;
  ShopMany: Array<Shop>;
  Shops: Array<Shop>;
  StockItem?: Maybe<StockItem>;
  StockItemById?: Maybe<StockItem>;
  StockItemCount?: Maybe<Scalars['Int']>;
  StockItemImage?: Maybe<StockItemImage>;
  StockItemImageById?: Maybe<StockItemImage>;
  StockItemImages?: Maybe<Array<Maybe<StockItemImage>>>;
  StockItemMany: Array<StockItem>;
  StockItemPagination?: Maybe<StockItemStockItemPagination>;
  /** The related-items groups a stock item belongs to in its shop, at most one per matchedBy: the for-sale stock items that are the same product. A group is left out when the stock item is alone in it. */
  StockItemRelated: Array<StockItemRelatedGroup>;
  /** All related-items groups of two or more for-sale stock items in the shop. With stockItemIds, only the groups in which one of them is a for-sale member; ids of other shops are ignored, an empty list gives no groups, and an item no longer for sale is in no group here (StockItemRelated still answers its siblings). */
  StockItemRelatedGroups: Array<StockItemRelatedGroup>;
  StockItems: Array<StockItem>;
  /** Will return stockitems by their ids */
  StockItems2?: Maybe<Array<Maybe<StockItem>>>;
  /** Returns a list of c2s stockitems that are available for creation in the external shop */
  StockItemsForShop?: Maybe<Array<Maybe<StockItemForSale>>>;
  /** Returns a list of c2s stockitems that are available for creation in the external shop */
  StockItemsForShop2?: Maybe<Array<Maybe<StockItemForSale2>>>;
  StorageFileById?: Maybe<StorageFile>;
  Survey?: Maybe<Survey>;
  SurveyRespondent?: Maybe<Respondent>;
  SurveyRespondents: Array<Respondent>;
  SystemMessage?: Maybe<SystemMessage>;
  SystemMessages: Array<SystemMessage>;
  TrackingCount: Scalars['Int'];
  TrackingMany: Array<Tracking>;
  TrackingPagination?: Maybe<TrackingTrackingPagination>;
  TradeIn?: Maybe<TradeIn>;
  TradeInById?: Maybe<TradeIn>;
  TradeInConfig?: Maybe<TradeInConfig>;
  TradeInItemById?: Maybe<TradeInItem>;
  /** Returns TradeInItems */
  TradeInItems?: Maybe<Array<Maybe<TradeInItem>>>;
  /** Returns TradeInItems, meant to be used in paged lists, use TradeInItems to query on all tradeinitems */
  TradeInItems2?: Maybe<TradeInItemPaging>;
  /** Returns TradeInItems for the given tradein */
  TradeInItems3?: Maybe<Array<Maybe<TradeInItem>>>;
  TradeInMany: Array<TradeIn>;
  TradeInOne?: Maybe<TradeIn>;
  TradeInPagination?: Maybe<TradeInTradeInPagination>;
  TradeInURL?: Maybe<ExternalLink>;
  TradeIns: Array<TradeIn>;
  User?: Maybe<User>;
  UserAccesses?: Maybe<Array<Maybe<UserAccess>>>;
  UserInviteVerify?: Maybe<Scalars['String']>;
  /** Verifies the quality of the password */
  UserVerifyPassword?: Maybe<VerifyResult>;
  UserVerifyResetToken?: Maybe<Scalars['String']>;
  Users: Array<User>;
  Voucher?: Maybe<Voucher>;
  VoucherAdjustment?: Maybe<VoucherAdjustment>;
  VoucherAdjustments: Array<VoucherAdjustment>;
  VoucherByExternId?: Maybe<Voucher>;
  VoucherById?: Maybe<Voucher>;
  VoucherByIds?: Maybe<Array<Maybe<Voucher>>>;
  VoucherPagination?: Maybe<VoucherVoucherPagination>;
  VoucherTransactions?: Maybe<Array<Maybe<VoucherTransaction>>>;
  VoucherUsageRefunds: Array<VoucherUsageRefund>;
  VoucherUsages: Array<VoucherUsage>;
  Vouchers: Array<Voucher>;
  WarehouseLocations?: Maybe<Array<Maybe<WarehouseLocation>>>;
  WholeSaleCategories: Array<WholeSaleCategory>;
  WholeSaleCategory?: Maybe<WholeSaleCategory>;
  WholeSaleConfig?: Maybe<WholeSaleConfigType>;
  WholeSaleProducts?: Maybe<Array<Maybe<WholeSaleProduct>>>;
  WholeSaleRuleStatistics?: Maybe<WholeSaleStatistics>;
};


export type QueryAuditNoteArgs = {
  id: Scalars['MongoID'];
};


export type QueryAuditNotesArgs = {
  brandHouseId: Scalars['MongoID'];
};


export type QueryAutoRetouchWorkflowsArgs = {
  shopId: Scalars['MongoID'];
};


export type QueryBrandApiGetArgs = {
  filter?: InputMaybe<FilterFindOneBrandApiInput>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindOneBrandApiInput>;
};


export type QueryBrandCarrierArgs = {
  brandHouseId: Scalars['MongoID'];
  shippingCarrierId: Scalars['MongoID'];
};


export type QueryBrandCircularArgs = {
  shopId: Scalars['MongoID'];
};


export type QueryBrandHouseArgs = {
  id: Scalars['MongoID'];
};


export type QueryBrandHouseMasterDataSearchArgs = {
  brandHouseId: Scalars['MongoID'];
  search: Scalars['String'];
};


export type QueryBrandHouseMasterDataVisualSearchArgs = {
  brandHouseId: Scalars['MongoID'];
  imageUrl: Scalars['String'];
  maxResults?: InputMaybe<Scalars['Int']>;
};


export type QueryBrandHousesArgs = {
  filter?: InputMaybe<FilterFindManyBrandHouseInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyBrandHouseInput>;
};


export type QueryBrandItemArgs = {
  _id: Scalars['MongoID'];
};


export type QueryBrandItemImageArgs = {
  _id: Scalars['MongoID'];
};


export type QueryBrandItemLayawayArgs = {
  _id: Scalars['MongoID'];
};


export type QueryBrandItemLayawayHistoryArgs = {
  brandItemId: Scalars['MongoID'];
};


export type QueryBrandItemLayawayManyArgs = {
  filter?: InputMaybe<FilterFindManyBrandItemLayawayInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyBrandItemLayawayInput>;
};


export type QueryBrandItemLayawayPaginationArgs = {
  filter?: InputMaybe<FilterFindManyBrandItemLayawayInput>;
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<SortFindManyBrandItemLayawayInput>;
};


export type QueryBrandItemManyArgs = {
  filter?: InputMaybe<FilterFindManyBrandItemInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyBrandItemInput>;
};


export type QueryBrandItemMasterDataMigrationItemsArgs = {
  runId: Scalars['MongoID'];
};


export type QueryBrandItemMasterDataMigrationRunArgs = {
  id: Scalars['MongoID'];
};


export type QueryBrandItemMasterImagesArgs = {
  brandItemId: Scalars['MongoID'];
};


export type QueryBrandItemPaginationArgs = {
  filter?: InputMaybe<FilterFindManyBrandItemInput>;
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<SortFindManyBrandItemInput>;
  viewId?: InputMaybe<Scalars['MongoID']>;
};


export type QueryBrandItemProblemsArgs = {
  brandItemId: Scalars['MongoID'];
  shopId?: InputMaybe<Scalars['MongoID']>;
};


export type QueryBrandItemRelatedIdentifiersArgs = {
  brandItemId: Scalars['MongoID'];
};


export type QueryBrandItemSimilarByImageArgs = {
  brandItemId: Scalars['MongoID'];
  includeCategories?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
};


export type QueryBrandItemsArgs = {
  ids?: InputMaybe<Array<Scalars['MongoID']>>;
};


export type QueryBrandLayoutArgs = {
  brandHouseId?: InputMaybe<Scalars['MongoID']>;
  shopId?: InputMaybe<Scalars['MongoID']>;
};


export type QueryBrandLocalizationsArgs = {
  brandHouseId?: InputMaybe<Scalars['MongoID']>;
  language?: InputMaybe<Scalars['String']>;
  shopId?: InputMaybe<Scalars['MongoID']>;
  type: Scalars['String'];
};


export type QueryBrandProductArgs = {
  _id: Scalars['MongoID'];
};


export type QueryBrandProductGroupArgs = {
  _id: Scalars['MongoID'];
};


export type QueryBrandProductGroupsArgs = {
  filter?: InputMaybe<FilterFindManyBrandProductGroupInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyBrandProductGroupInput>;
};


export type QueryBrandProductImageArgs = {
  _id: Scalars['MongoID'];
};


export type QueryBrandProductImagesArgs = {
  filter?: InputMaybe<FilterFindManyBrandProductImageInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyBrandProductImageInput>;
};


export type QueryBrandProductSizeArgs = {
  _id: Scalars['MongoID'];
};


export type QueryBrandProductSizesArgs = {
  filter?: InputMaybe<FilterFindManyBrandProductSizeInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyBrandProductSizeInput>;
};


export type QueryBrandProductVariantArgs = {
  _id: Scalars['MongoID'];
};


export type QueryBrandProductVariantsArgs = {
  filter?: InputMaybe<FilterFindManyBrandProductVariantInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyBrandProductVariantInput>;
};


export type QueryBrandProductsArgs = {
  filter?: InputMaybe<FilterFindManyBrandProductInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyBrandProductInput>;
};


export type QueryBrandProductsPaginationArgs = {
  filter?: InputMaybe<FilterFindManyBrandProductInput>;
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<SortFindManyBrandProductInput>;
};


export type QueryBrandRuleArgs = {
  _id: Scalars['MongoID'];
};


export type QueryBrandRulesArgs = {
  shopId: Scalars['MongoID'];
};


export type QueryBrandSettingsArgs = {
  brandHouseId?: InputMaybe<Scalars['MongoID']>;
  refId?: InputMaybe<Scalars['MongoID']>;
  shopId?: InputMaybe<Scalars['MongoID']>;
};


export type QueryBrandTrackingIdArgs = {
  shopId: Scalars['MongoID'];
  type?: InputMaybe<Scalars['String']>;
};


export type QueryBrickMailArgs = {
  mailType: Scalars['String'];
  shopId: Scalars['MongoID'];
};


export type QueryBrickMailTypeByIdArgs = {
  mailType: Scalars['String'];
  shopId: Scalars['MongoID'];
};


export type QueryBrickMailTypesArgs = {
  shopId: Scalars['String'];
};


export type QueryBrickMailsArgs = {
  shopId: Scalars['MongoID'];
};


export type QueryCampaignArgs = {
  _id: Scalars['MongoID'];
};


export type QueryCampaignsArgs = {
  filter?: InputMaybe<FilterFindManyCampaignInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyCampaignInput>;
};


export type QueryCircularAccountByIdArgs = {
  consumerId: Scalars['MongoID'];
};


export type QueryCircularPayoutByIdArgs = {
  _id: Scalars['MongoID'];
};


export type QueryCircularPayoutManyArgs = {
  filter?: InputMaybe<FilterFindManyCircularPayoutTypeInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyCircularPayoutTypeInput>;
};


export type QueryCircularPointByIdArgs = {
  _id: Scalars['MongoID'];
};


export type QueryCircularPointManyArgs = {
  filter?: InputMaybe<FilterFindManyCircularPointInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyCircularPointInput>;
};


export type QueryConfigCompareArgs = {
  brandHouseIdA?: InputMaybe<Scalars['MongoID']>;
  brandHouseIdB?: InputMaybe<Scalars['MongoID']>;
  models?: InputMaybe<Array<Scalars['String']>>;
  shopIdA?: InputMaybe<Scalars['MongoID']>;
  shopIdB?: InputMaybe<Scalars['MongoID']>;
};


export type QueryConsumerAccountArgs = {
  brandHouseId: Scalars['MongoID'];
  id: Scalars['String'];
  idType: ConsumerIdentifierEnum;
};


export type QueryConsumerByIdArgs = {
  _id: Scalars['MongoID'];
};


export type QueryConsumerByIdentifierArgs = {
  identifier: Scalars['String'];
  identifierType: ConsumerIdentifierEnum;
  selfCreated?: InputMaybe<Scalars['Boolean']>;
  shopId: Scalars['MongoID'];
};


export type QueryConsumerCarriersArgs = {
  consumerId: Scalars['String'];
  shopId: Scalars['String'];
};


export type QueryConsumerEventPaginationArgs = {
  filter?: InputMaybe<FilterFindManyConsumerEventInput>;
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<SortFindManyConsumerEventInput>;
};


export type QueryConsumerPaginationArgs = {
  filter?: InputMaybe<FilterFindManyConsumerInput>;
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<SortFindManyConsumerInput>;
  viewId?: InputMaybe<Scalars['MongoID']>;
};


export type QueryConsumerPotentialsArgs = {
  consumerId?: InputMaybe<Scalars['MongoID']>;
};


export type QueryConsumersArgs = {
  filter?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['String']>;
  orderBy?: InputMaybe<Scalars['String']>;
  page: Scalars['Int'];
  pageSize: Scalars['Int'];
  shopId: Scalars['String'];
};


export type QueryConsumersFindManyArgs = {
  filter?: InputMaybe<FilterFindManyConsumerInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyConsumerInput>;
};


export type QueryConvertCurrencyArgs = {
  inputCurrency: Scalars['String'];
  inputValue: Scalars['Float'];
  outputCurrency: Scalars['String'];
  ratesFromShopId?: InputMaybe<Scalars['MongoID']>;
};


export type QueryConvertCurrencyForConsumerArgs = {
  consumerId: Scalars['MongoID'];
  inputCurrency: Scalars['String'];
  inputValue: Scalars['Float'];
};


export type QueryDataViewArgs = {
  _id: Scalars['MongoID'];
};


export type QueryDataViewListArgs = {
  filter?: InputMaybe<FilterFindManyDataViewInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyDataViewInput>;
};


export type QueryExternOrder2ByIdArgs = {
  _id: Scalars['MongoID'];
};


export type QueryExternOrderByIdArgs = {
  _id: Scalars['MongoID'];
};


export type QueryExternOrders2ManyArgs = {
  filter?: InputMaybe<FilterFindManyExternOrder2Input>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyExternOrder2Input>;
};


export type QueryExternOrdersManyArgs = {
  filter?: InputMaybe<FilterFindManyExternOrderInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyExternOrderInput>;
};


export type QueryImageArgs = {
  _id: Scalars['MongoID'];
};


export type QueryIntegrationConfigArgs = {
  refId: Scalars['MongoID'];
  refType?: InputMaybe<EnumIntegrationConnectorRefType>;
};


export type QueryIntegrationConnectorArgs = {
  _id: Scalars['MongoID'];
};


export type QueryIntegrationConnectorsArgs = {
  filter?: InputMaybe<FilterFindManyIntegrationConnectorInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyIntegrationConnectorInput>;
};


export type QueryIntegrationConnectorsCountArgs = {
  filter?: InputMaybe<FilterCountIntegrationConnectorInput>;
};


export type QueryIntegrationInstanceArgs = {
  _id: Scalars['MongoID'];
};


export type QueryIntegrationInstancesArgs = {
  filter?: InputMaybe<FilterFindManyIntegrationInstanceInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyIntegrationInstanceInput>;
};


export type QueryIntegrationMessageArgs = {
  tokens?: InputMaybe<Array<Scalars['String']>>;
};


export type QueryIntegrationMessageByIdArgs = {
  _id: Scalars['MongoID'];
};


export type QueryIntegrationMessagesArgs = {
  filter?: InputMaybe<FilterFindManyIntegrationMessageInput>;
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<SortFindManyIntegrationMessageInput>;
};


export type QueryInvoiceArgs = {
  _id: Scalars['MongoID'];
};


export type QueryInvoiceAdjustmentArgs = {
  _id: Scalars['MongoID'];
};


export type QueryInvoiceAdjustmentsArgs = {
  filter?: InputMaybe<FilterFindManyInvoiceAdjustmentInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyInvoiceAdjustmentInput>;
};


export type QueryInvoiceIdsArgs = {
  brandHouseId?: InputMaybe<Scalars['String']>;
};


export type QueryInvoiceLinesArgs = {
  filter?: InputMaybe<FilterFindManyInvoiceLineInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyInvoiceLineInput>;
};


export type QueryInvoiceSettingArgs = {
  brandHouseId: Scalars['MongoID'];
};


export type QueryInvoicesArgs = {
  brandHouseId?: InputMaybe<Scalars['MongoID']>;
  limit?: InputMaybe<Scalars['Int']>;
};


export type QueryItemIssueArgs = {
  _id: Scalars['MongoID'];
};


export type QueryItemIssuesArgs = {
  filter?: InputMaybe<FilterFindManyItemIssueInput>;
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<SortFindManyItemIssueInput>;
};


export type QueryLogisticsPartnerArgs = {
  _id: Scalars['MongoID'];
};


export type QueryLogisticsPartnersArgs = {
  filter?: InputMaybe<FilterFindManyLogisticsPartnerInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyLogisticsPartnerInput>;
};


export type QueryLogisticsStockItemsArgs = {
  hideChecked?: InputMaybe<Scalars['Boolean']>;
  hideSold?: InputMaybe<Scalars['Boolean']>;
  hideWithLocation?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Float']>;
  logisticsPartnerId: Scalars['String'];
};


export type QueryNfcManyArgs = {
  filter?: InputMaybe<FilterFindManyNfcInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyNfcInput>;
};


export type QueryOptionArgs = {
  _id: Scalars['MongoID'];
};


export type QueryOptionValueArgs = {
  _id: Scalars['MongoID'];
};


export type QueryOptionValuesArgs = {
  filter?: InputMaybe<FilterFindManyOptionValueInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyOptionValueInput>;
};


export type QueryOptionsArgs = {
  filter?: InputMaybe<FilterFindManyOptionSetInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyOptionSetInput>;
};


export type QueryOrderArgs = {
  id: Scalars['String'];
};


export type QueryOrderByIdArgs = {
  _id: Scalars['MongoID'];
};


export type QueryOrderCountArgs = {
  filter?: InputMaybe<FilterCountOrder2Input>;
};


export type QueryOrderLineByIdArgs = {
  _id: Scalars['MongoID'];
};


export type QueryOrderPaginationArgs = {
  filter?: InputMaybe<FilterFindManyOrder2Input>;
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<SortFindManyOrder2Input>;
  viewId?: InputMaybe<Scalars['MongoID']>;
};


export type QueryOrdersArgs = {
  consumerId?: InputMaybe<Scalars['String']>;
  shopId: Scalars['String'];
};


export type QueryParcelArgs = {
  _id: Scalars['MongoID'];
};


export type QueryParcelsArgs = {
  filter?: InputMaybe<FilterFindManyParcelInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyParcelInput>;
};


export type QueryParcelsPaginationArgs = {
  filter?: InputMaybe<FilterFindManyParcelInput>;
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<SortFindManyParcelInput>;
};


export type QueryPatchManyArgs = {
  filter?: InputMaybe<FilterFindManyObjectPatchesInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyObjectPatchesInput>;
};


export type QueryPatchPaginationArgs = {
  filter?: InputMaybe<FilterFindManyObjectPatchesInput>;
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<SortFindManyObjectPatchesInput>;
};


export type QueryPlannedMailByIdArgs = {
  _id: Scalars['MongoID'];
};


export type QueryPlannedMailsPaginationArgs = {
  filter?: InputMaybe<FilterFindManyPlannedMailInput>;
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<SortFindManyPlannedMailInput>;
};


export type QueryPotentialArgs = {
  _id: Scalars['MongoID'];
};


export type QueryPotentialOffersArgs = {
  consumerId: Scalars['MongoID'];
};


export type QueryPotentialsArgs = {
  filter?: InputMaybe<FilterFindManyPotentialInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyPotentialInput>;
};


export type QueryPotentialsByAccountArgs = {
  brandId: Scalars['MongoID'];
  identifier: Scalars['String'];
  type: PotentialAccountEnum;
};


export type QueryPotentialsByShopArgs = {
  identifier: Scalars['String'];
  shopId: Scalars['MongoID'];
  type: PotentialAccountEnum;
};


export type QueryPotentialsDtcPaginationArgs = {
  filter?: InputMaybe<FilterFindManyPotentialInput>;
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<SortFindManyPotentialInput>;
};


export type QueryPotentialsPaginationArgs = {
  filter?: InputMaybe<FilterFindManyPotentialInput>;
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<SortFindManyPotentialInput>;
};


export type QueryProductByIdArgs = {
  _id: Scalars['MongoID'];
};


export type QueryProductImagesArgs = {
  shopId: Scalars['String'];
  variantId: Scalars['String'];
};


export type QueryProductManyArgs = {
  filter?: InputMaybe<FilterFindManyProductInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyProductInput>;
};


export type QueryProductStatisticsArgs = {
  shopId: Scalars['String'];
};


export type QueryProductVariantArgs = {
  id: Scalars['String'];
};


export type QueryProductVariantByIdArgs = {
  _id: Scalars['MongoID'];
};


export type QueryProductVariantManyArgs = {
  filter?: InputMaybe<FilterFindManyProductVariantInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyProductVariantInput>;
};


export type QueryProductVariantSizeArgs = {
  _id: Scalars['MongoID'];
};


export type QueryProductVariantSizesArgs = {
  filter?: InputMaybe<FilterFindManyProductVariantSizeInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyProductVariantSizeInput>;
};


export type QueryProductVariantsPaginationArgs = {
  filter?: InputMaybe<FilterFindManyProductVariantInput>;
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<SortFindManyProductVariantInput>;
};


export type QueryProductsArgs = {
  filter?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['String']>;
  orderBy?: InputMaybe<Scalars['String']>;
  page: Scalars['Int'];
  pageSize: Scalars['Int'];
  shopId: Scalars['String'];
};


export type QueryProductsByIdsArgs = {
  _ids: Array<Scalars['MongoID']>;
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindByIdsProductInput>;
};


export type QueryProductsPaginationArgs = {
  filter?: InputMaybe<FilterFindManyProductInput>;
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<SortFindManyProductInput>;
};


export type QueryPublicVoucherValueArgs = {
  actualSalesPrice: Scalars['Int'];
  actualSalesPriceOriginal?: InputMaybe<Scalars['Int']>;
  brandId?: InputMaybe<Scalars['MongoID']>;
  compareAtPrice?: InputMaybe<Scalars['Int']>;
  currency?: InputMaybe<Scalars['String']>;
  externProductId: Scalars['String'];
  externVariantId: Scalars['String'];
  shopId?: InputMaybe<Scalars['MongoID']>;
};


export type QueryPublicVoucherValue2Args = {
  actualSalesPrice: Scalars['Int'];
  actualSalesPriceOriginal?: InputMaybe<Scalars['Int']>;
  brandId?: InputMaybe<Scalars['String']>;
  compareAtPrice?: InputMaybe<Scalars['Int']>;
  currency?: InputMaybe<Scalars['String']>;
  externProductId: Scalars['String'];
  externVariantId: Scalars['String'];
  shopId?: InputMaybe<Scalars['String']>;
};


export type QueryQrSessionArgs = {
  id: Scalars['String'];
};


export type QueryQrSessionsArgs = {
  logisticsPartnerId: Scalars['String'];
};


export type QueryScheduledEventByIdArgs = {
  _id: Scalars['MongoID'];
};


export type QueryScheduledEventsPaginationArgs = {
  filter?: InputMaybe<FilterFindManyScheduledEventInput>;
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<SortFindManyScheduledEventInput>;
};


export type QueryShippingCarrierArgs = {
  id: Scalars['MongoID'];
};


export type QueryShippingCarriersArgs = {
  brandHouseId: Scalars['MongoID'];
};


export type QueryShippingCarriersActiveArgs = {
  orderId: Scalars['MongoID'];
};


export type QueryShippingCarriersForParcelArgs = {
  receiver?: InputMaybe<ShippingCarriersForParcelReceiverInput>;
  shopId: Scalars['MongoID'];
};


export type QueryShippingCarriersLpArgs = {
  logisticsPartnerId?: InputMaybe<Scalars['MongoID']>;
};


export type QueryShippingCostsArgs = {
  currency: Scalars['String'];
  includeVat?: InputMaybe<Scalars['Boolean']>;
  queries: Array<ShippingCostInput>;
};


export type QueryShippingLabelArgs = {
  _id: Scalars['MongoID'];
};


export type QueryShopArgs = {
  _id: Scalars['MongoID'];
};


export type QueryShopByIdArgs = {
  _id: Scalars['MongoID'];
};


export type QueryShopCountriesArgs = {
  shopId: Scalars['MongoID'];
};


export type QueryShopLanguagesArgs = {
  shopId: Scalars['MongoID'];
  type?: InputMaybe<Scalars['String']>;
};


export type QueryShopManyArgs = {
  filter?: InputMaybe<FilterFindManyShopInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyShopInput>;
};


export type QueryShopsArgs = {
  filter?: InputMaybe<FilterFindManyShopInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyShopInput>;
};


export type QueryStockItemArgs = {
  _id: Scalars['MongoID'];
};


export type QueryStockItemByIdArgs = {
  _id: Scalars['MongoID'];
};


export type QueryStockItemCountArgs = {
  filter?: InputMaybe<FilterCountStockItemInput>;
};


export type QueryStockItemImageArgs = {
  shopId?: InputMaybe<Scalars['String']>;
  stockItemImageId?: InputMaybe<Scalars['String']>;
};


export type QueryStockItemImageByIdArgs = {
  _id: Scalars['MongoID'];
};


export type QueryStockItemImagesArgs = {
  shopId?: InputMaybe<Scalars['String']>;
  stockItemId?: InputMaybe<Scalars['String']>;
};


export type QueryStockItemManyArgs = {
  filter?: InputMaybe<FilterFindManyStockItemInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyStockItemInput>;
};


export type QueryStockItemPaginationArgs = {
  filter?: InputMaybe<FilterFindManyStockItemInput>;
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<SortFindManyStockItemInput>;
};


export type QueryStockItemRelatedArgs = {
  stockItemId: Scalars['MongoID'];
};


export type QueryStockItemRelatedGroupsArgs = {
  shopId: Scalars['MongoID'];
  stockItemIds?: InputMaybe<Array<Scalars['MongoID']>>;
};


export type QueryStockItemsArgs = {
  filter?: InputMaybe<FilterFindManyStockItemInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyStockItemInput>;
};


export type QueryStockItems2Args = {
  ids?: InputMaybe<Array<Scalars['MongoID']>>;
};


export type QueryStockItemsForShopArgs = {
  shopId: Scalars['String'];
};


export type QueryStockItemsForShop2Args = {
  shopId: Scalars['MongoID'];
};


export type QueryStorageFileByIdArgs = {
  _id: Scalars['MongoID'];
};


export type QuerySurveyArgs = {
  _id: Scalars['MongoID'];
};


export type QuerySurveyRespondentArgs = {
  _id: Scalars['MongoID'];
};


export type QuerySurveyRespondentsArgs = {
  filter?: InputMaybe<FilterFindManyRespondentInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyRespondentInput>;
};


export type QuerySystemMessageArgs = {
  _id: Scalars['MongoID'];
};


export type QuerySystemMessagesArgs = {
  filter?: InputMaybe<FilterFindManySystemMessageInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManySystemMessageInput>;
};


export type QueryTrackingCountArgs = {
  objectType: Scalars['String'];
  periodFrom: Scalars['Date'];
  periodTo: Scalars['Date'];
  shopId: Scalars['MongoID'];
};


export type QueryTrackingManyArgs = {
  filter?: InputMaybe<FilterFindManyTrackingInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyTrackingInput>;
};


export type QueryTrackingPaginationArgs = {
  filter?: InputMaybe<FilterFindManyTrackingInput>;
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<SortFindManyTrackingInput>;
};


export type QueryTradeInArgs = {
  _id: Scalars['MongoID'];
};


export type QueryTradeInByIdArgs = {
  _id: Scalars['MongoID'];
};


export type QueryTradeInConfigArgs = {
  shopId: Scalars['MongoID'];
};


export type QueryTradeInItemByIdArgs = {
  _id: Scalars['MongoID'];
};


export type QueryTradeInItemsArgs = {
  includeRegistered?: InputMaybe<Scalars['Boolean']>;
  includeRejected?: InputMaybe<Scalars['Boolean']>;
  includeStocked?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Float']>;
  shopId?: InputMaybe<Scalars['String']>;
};


export type QueryTradeInItems2Args = {
  filter?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['String']>;
  orderBy?: InputMaybe<Scalars['String']>;
  page: Scalars['Int'];
  pageSize: Scalars['Int'];
  shopId?: InputMaybe<Scalars['String']>;
};


export type QueryTradeInItems3Args = {
  tradeInId: Scalars['MongoID'];
};


export type QueryTradeInManyArgs = {
  filter?: InputMaybe<FilterFindManyTradeInInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyTradeInInput>;
};


export type QueryTradeInOneArgs = {
  filter?: InputMaybe<FilterFindOneTradeInInput>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindOneTradeInInput>;
};


export type QueryTradeInPaginationArgs = {
  filter?: InputMaybe<FilterFindManyTradeInInput>;
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<SortFindManyTradeInInput>;
  viewId?: InputMaybe<Scalars['MongoID']>;
};


export type QueryTradeInUrlArgs = {
  consumerId: Scalars['MongoID'];
};


export type QueryTradeInsArgs = {
  filter?: InputMaybe<FilterFindManyTradeInInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyTradeInInput>;
};


export type QueryUserArgs = {
  _id: Scalars['MongoID'];
};


export type QueryUserAccessesArgs = {
  brandHouseId?: InputMaybe<Scalars['MongoID']>;
  logisticsPartnerId?: InputMaybe<Scalars['MongoID']>;
};


export type QueryUserInviteVerifyArgs = {
  token: Scalars['String'];
};


export type QueryUserVerifyPasswordArgs = {
  password: Scalars['String'];
};


export type QueryUserVerifyResetTokenArgs = {
  token: Scalars['String'];
};


export type QueryUsersArgs = {
  filter?: InputMaybe<FilterFindManyUserInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyUserInput>;
};


export type QueryVoucherArgs = {
  code: Scalars['String'];
  shopId: Scalars['String'];
};


export type QueryVoucherAdjustmentArgs = {
  _id: Scalars['MongoID'];
};


export type QueryVoucherAdjustmentsArgs = {
  filter?: InputMaybe<FilterFindManyVoucherAdjustmentInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyVoucherAdjustmentInput>;
};


export type QueryVoucherByExternIdArgs = {
  externId: Scalars['String'];
  shopId: Scalars['MongoID'];
};


export type QueryVoucherByIdArgs = {
  _id: Scalars['MongoID'];
};


export type QueryVoucherByIdsArgs = {
  ids: Array<Scalars['MongoID']>;
};


export type QueryVoucherPaginationArgs = {
  filter?: InputMaybe<FilterFindManyVoucherInput>;
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<SortFindManyVoucherInput>;
};


export type QueryVoucherTransactionsArgs = {
  currency?: InputMaybe<Scalars['String']>;
  voucherId: Scalars['MongoID'];
};


export type QueryVoucherUsageRefundsArgs = {
  filter?: InputMaybe<FilterFindManyVoucherUsageRefundInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyVoucherUsageRefundInput>;
};


export type QueryVoucherUsagesArgs = {
  filter?: InputMaybe<FilterFindManyVoucherUsageInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyVoucherUsageInput>;
};


export type QueryVouchersArgs = {
  filter?: InputMaybe<FilterFindManyVoucherInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyVoucherInput>;
};


export type QueryWarehouseLocationsArgs = {
  logisticsPartnerId?: InputMaybe<Scalars['MongoID']>;
};


export type QueryWholeSaleCategoriesArgs = {
  filter?: InputMaybe<FilterFindManyWholeSaleCategoryInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyWholeSaleCategoryInput>;
};


export type QueryWholeSaleCategoryArgs = {
  _id: Scalars['MongoID'];
};


export type QueryWholeSaleConfigArgs = {
  language?: InputMaybe<Scalars['String']>;
  shopId: Scalars['MongoID'];
};


export type QueryWholeSaleProductsArgs = {
  categoryId: Scalars['String'];
  consumerId: Scalars['String'];
  search?: InputMaybe<Scalars['String']>;
};


export type QueryWholeSaleRuleStatisticsArgs = {
  rule?: InputMaybe<WholeSaleCategoryRulesInput>;
  shopId: Scalars['String'];
};

export type RefreshResult = {
  __typename?: 'RefreshResult';
  token: Scalars['String'];
};

export type RemoveOneIntegrationConnectorPayload = {
  __typename?: 'RemoveOneIntegrationConnectorPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Removed document */
  record?: Maybe<IntegrationConnector>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']>;
};

export type Respondent = {
  __typename?: 'Respondent';
  _id: Scalars['MongoID'];
  /** The answers made by this respondent */
  answers: Array<Maybe<RespondentAnswers>>;
  shopId: Scalars['MongoID'];
  surveyId: Scalars['MongoID'];
};

export type RespondentAnswers = {
  __typename?: 'RespondentAnswers';
  /** The id of the question */
  questionId: Scalars['String'];
  /** The choice answer id */
  valueC?: Maybe<Scalars['String']>;
  /** The text answer */
  valueT?: Maybe<Scalars['String']>;
};

export type RespondentAnswersInput = {
  /** The id of the question */
  questionId: Scalars['String'];
  /** The choice answer id */
  valueC?: InputMaybe<Scalars['String']>;
  /** The text answer */
  valueT?: InputMaybe<Scalars['String']>;
};

export type RuntimeError = ErrorInterface & {
  __typename?: 'RuntimeError';
  /** Runtime error message */
  message?: Maybe<Scalars['String']>;
};

export type ScheduledEvent = {
  __typename?: 'ScheduledEvent';
  _id: Scalars['MongoID'];
  /** Optionally data that will be sent with the event */
  data?: Maybe<Scalars['JSON']>;
  /** The timestamp of when the event should be executed */
  executeAt: Scalars['Date'];
  /** The timestamp of when the event was executed */
  executed?: Maybe<Scalars['Date']>;
  /** The referenced object this event is attached to */
  refId: Scalars['MongoID'];
  /** The referenced object type */
  refType: EnumScheduledEventRefType;
};

/** List of items with pagination. */
export type ScheduledEventScheduledEventPagination = {
  __typename?: 'ScheduledEventScheduledEventPagination';
  /** Total object count. */
  count?: Maybe<Scalars['Int']>;
  /** Array of objects. */
  items?: Maybe<Array<ScheduledEvent>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type ShippingCarrier = {
  __typename?: 'ShippingCarrier';
  _id: Scalars['MongoID'];
  activeFor?: Maybe<Array<Maybe<Scalars['MongoID']>>>;
  b2ceurope?: Maybe<Scalars['Boolean']>;
  carrier?: Maybe<EnumShippingCarrierCarrier>;
  carrierGateway?: Maybe<ShippingCarrierCarrierGateway>;
  carrierId?: Maybe<Scalars['String']>;
  /** Whether this carrier is a custom carrier */
  customCarrier?: Maybe<Scalars['Boolean']>;
  description?: Maybe<Scalars['String']>;
  expression?: Maybe<Scalars['String']>;
  externalCode?: Maybe<Scalars['String']>;
  externalName?: Maybe<Scalars['String']>;
  localizationKey?: Maybe<Scalars['String']>;
  logisticsPartnerId?: Maybe<Scalars['MongoID']>;
  logo?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  shipmondo?: Maybe<ShippingCarrierShipmondo>;
  typeName?: Maybe<EnumShippingCarrierTypeName>;
};

export type ShippingCarrierCarrierGateway = {
  __typename?: 'ShippingCarrierCarrierGateway';
  apiKey?: Maybe<Scalars['String']>;
  /** The carrier used for the Carrier Gateway API input */
  inputCarrier?: Maybe<EnumShippingCarrierCarrierGatewayInputCarrier>;
  /** The carrier that will be used to output the shipment */
  outputCarrier?: Maybe<EnumShippingCarrierCarrierGatewayOutputCarrier>;
  /** Whether the carrier supports QR codes */
  supportQR?: Maybe<Scalars['Boolean']>;
};

export type ShippingCarrierCarrierGatewayInput = {
  apiKey?: InputMaybe<Scalars['String']>;
  /** The carrier used for the Carrier Gateway API input */
  inputCarrier?: InputMaybe<EnumShippingCarrierCarrierGatewayInputCarrier>;
  /** The carrier that will be used to output the shipment */
  outputCarrier?: InputMaybe<EnumShippingCarrierCarrierGatewayOutputCarrier>;
  /** Whether the carrier supports QR codes */
  supportQR?: InputMaybe<Scalars['Boolean']>;
};

export type ShippingCarrierInput = {
  _id?: InputMaybe<Scalars['MongoID']>;
  activeFor?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  b2ceurope?: InputMaybe<Scalars['Boolean']>;
  carrier?: InputMaybe<EnumShippingCarrierCarrier>;
  carrierGateway?: InputMaybe<ShippingCarrierCarrierGatewayInput>;
  carrierId?: InputMaybe<Scalars['String']>;
  /** Whether this carrier is a custom carrier */
  customCarrier?: InputMaybe<Scalars['Boolean']>;
  description?: InputMaybe<Scalars['String']>;
  expression?: InputMaybe<Scalars['String']>;
  externalCode?: InputMaybe<Scalars['String']>;
  externalName?: InputMaybe<Scalars['String']>;
  localizationKey?: InputMaybe<Scalars['String']>;
  logisticsPartnerId?: InputMaybe<Scalars['MongoID']>;
  logo?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  shipmondo?: InputMaybe<ShippingCarrierShipmondoInput>;
  typeName?: InputMaybe<EnumShippingCarrierTypeName>;
};

export type ShippingCarrierShipmondo = {
  __typename?: 'ShippingCarrierShipmondo';
  carrier?: Maybe<Scalars['String']>;
  carrierCode?: Maybe<Scalars['String']>;
  carrierSecondary?: Maybe<Scalars['String']>;
  customerNumber?: Maybe<Scalars['JSON']>;
  customs?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  height?: Maybe<Scalars['Float']>;
  length?: Maybe<Scalars['Float']>;
  ownAgreement?: Maybe<Scalars['Boolean']>;
  qrSize?: Maybe<Scalars['Float']>;
  qrX?: Maybe<Scalars['String']>;
  qrY?: Maybe<Scalars['String']>;
  serviceCodes?: Maybe<Scalars['String']>;
  testMode?: Maybe<Scalars['Boolean']>;
  width?: Maybe<Scalars['Float']>;
};

export type ShippingCarrierShipmondoInput = {
  carrier?: InputMaybe<Scalars['String']>;
  carrierCode?: InputMaybe<Scalars['String']>;
  carrierSecondary?: InputMaybe<Scalars['String']>;
  customerNumber?: InputMaybe<Scalars['JSON']>;
  customs?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  height?: InputMaybe<Scalars['Float']>;
  length?: InputMaybe<Scalars['Float']>;
  ownAgreement?: InputMaybe<Scalars['Boolean']>;
  qrSize?: InputMaybe<Scalars['Float']>;
  qrX?: InputMaybe<Scalars['String']>;
  qrY?: InputMaybe<Scalars['String']>;
  serviceCodes?: InputMaybe<Scalars['String']>;
  testMode?: InputMaybe<Scalars['Boolean']>;
  width?: InputMaybe<Scalars['Float']>;
};

export type ShippingCarriersForParcelReceiverInput = {
  add1?: InputMaybe<Scalars['String']>;
  add2?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  countryCode?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  zipCode?: InputMaybe<Scalars['String']>;
};

export enum ShippingCostCarrier {
  b2c_europe = 'b2c_europe',
  dao = 'dao',
  deutsche_post = 'deutsche_post',
  dhl = 'dhl',
  dhl_express = 'dhl_express',
  gls = 'gls',
  parcelplus = 'parcelplus',
  pdk = 'pdk',
  ups = 'ups'
}

export enum ShippingCostDirection {
  outbound = 'outbound',
  return = 'return'
}

export type ShippingCostInput = {
  carrier: ShippingCostCarrier;
  country: Scalars['String'];
  direction?: InputMaybe<ShippingCostDirection>;
  weight: Scalars['Float'];
};

export type ShippingCostOutput = {
  __typename?: 'ShippingCostOutput';
  carrier: ShippingCostCarrier;
  cost?: Maybe<Scalars['Float']>;
  country: Scalars['String'];
  currency: Scalars['String'];
  direction: ShippingCostDirection;
  weight: Scalars['Float'];
};

export type ShippingLabel = {
  __typename?: 'ShippingLabel';
  _id: Scalars['MongoID'];
  archived?: Maybe<Scalars['Boolean']>;
  /** The carrier for this shipping label */
  carrier?: Maybe<ShippingCarrier>;
  createdAt?: Maybe<Scalars['Date']>;
  deletedBy?: Maybe<Scalars['String']>;
  deletedTs?: Maybe<Scalars['Date']>;
  deliveryDate?: Maybe<Scalars['Date']>;
  deliveryStatus?: Maybe<EnumShippingLabelDeliveryStatus>;
  labelCode?: Maybe<Scalars['String']>;
  labelExternalId?: Maybe<Scalars['String']>;
  labelFailed?: Maybe<Scalars['Boolean']>;
  labelFailedCount?: Maybe<Scalars['Float']>;
  labelImageId?: Maybe<Scalars['MongoID']>;
  lastUpdate?: Maybe<Scalars['Date']>;
  /** The package code for this shipping label */
  packageCode?: Maybe<Scalars['String']>;
  /** The parcel that this shipping label is for */
  parcel?: Maybe<Parcel>;
  qrImageId?: Maybe<Scalars['MongoID']>;
  /** URL for the QR code image */
  qrImageUrl?: Maybe<Scalars['String']>;
  qrPngId?: Maybe<Scalars['MongoID']>;
  /** URL for the QR code */
  qrUrl?: Maybe<Scalars['String']>;
  receiver?: Maybe<AddressInfo>;
  /** The return order that this shipping label is for */
  returnOrder?: Maybe<Order2>;
  sender?: Maybe<AddressInfo>;
  shippingCarrierId: Scalars['MongoID'];
  shopId: Scalars['MongoID'];
  tracking?: Maybe<ShippingLabelTracking>;
  /** URL for tracking the package */
  trackingUrl?: Maybe<Scalars['String']>;
  /** The trade-in that this shipping label is for */
  tradeIn?: Maybe<TradeIn>;
  updatedAt?: Maybe<Scalars['Date']>;
  updatedBy?: Maybe<ObjectPatchesUpdatedBy>;
  /** URL for the packaging label, not applicable to code based solutions */
  url?: Maybe<Scalars['String']>;
};

export type ShippingLabelTracking = {
  __typename?: 'ShippingLabelTracking';
  carrierCode?: Maybe<Scalars['String']>;
  countryCode?: Maybe<Scalars['String']>;
  location?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  statusFailed?: Maybe<Scalars['Boolean']>;
  statusText?: Maybe<Scalars['String']>;
  time?: Maybe<Scalars['Date']>;
  trackingCode?: Maybe<Scalars['String']>;
};

export type ShippingLabelTrackingInput = {
  carrierCode?: InputMaybe<Scalars['String']>;
  countryCode?: InputMaybe<Scalars['String']>;
  location?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  statusFailed?: InputMaybe<Scalars['Boolean']>;
  statusText?: InputMaybe<Scalars['String']>;
  time?: InputMaybe<Scalars['Date']>;
  trackingCode?: InputMaybe<Scalars['String']>;
};

export type Shop = {
  __typename?: 'Shop';
  _id: Scalars['MongoID'];
  address?: Maybe<AddressInfo>;
  /** The API settings for the shop */
  api?: Maybe<BrandApi>;
  /** The brandhouse this shop resides below */
  brandHouse?: Maybe<BrandHouse>;
  brandHouseId: Scalars['MongoID'];
  /** All BrickMail configurations for this shop */
  brickMails?: Maybe<Array<Maybe<BrickMail>>>;
  /** Wholesale categories for this shop */
  categories?: Maybe<Array<Maybe<WholeSaleCategory>>>;
  closeDate?: Maybe<Scalars['Date']>;
  /** List of all colors found on variants for this shop */
  colors?: Maybe<Array<Scalars['String']>>;
  /** Conditions */
  conditions?: Maybe<Array<Maybe<ShopConditionPublic>>>;
  configuration?: Maybe<Scalars['JSON']>;
  createdAt?: Maybe<Scalars['Date']>;
  currency?: Maybe<Scalars['String']>;
  disableContactResetDate?: Maybe<Scalars['Date']>;
  disabled?: Maybe<Scalars['Boolean']>;
  externalId?: Maybe<Scalars['String']>;
  externalName?: Maybe<Scalars['String']>;
  frontendType: EnumShopFrontendType;
  generateThumbnails?: Maybe<Scalars['Boolean']>;
  /** Last time an action distribute was triggered */
  lastActionDistribute?: Maybe<Scalars['Date']>;
  /** Last time a klaviyo sync was triggered */
  lastKlaviyoSync?: Maybe<Scalars['Date']>;
  live?: Maybe<Scalars['Boolean']>;
  liveDate?: Maybe<Scalars['Date']>;
  locales?: Maybe<Array<Maybe<Scalars['String']>>>;
  logisticsPartnerId: Scalars['MongoID'];
  logo?: Maybe<Scalars['String']>;
  /** The locale that masterdata from shop comes in */
  masterDataLocale: Scalars['String'];
  name?: Maybe<Scalars['String']>;
  /** The primary locale for this shop */
  primaryLocale: Scalars['String'];
  /** List of all product batches for this shop */
  productBatches?: Maybe<Array<Scalars['String']>>;
  /** List of all collections found on masterdata products of this shop's brand house */
  productCollections?: Maybe<Array<Scalars['String']>>;
  /** List of all metafield values found on the given key */
  productMetaFieldValues?: Maybe<Array<Scalars['String']>>;
  /** List of all tags found on masterdata products of this shop's brand house */
  productTags?: Maybe<Array<Scalars['String']>>;
  /** List of all product types found on masterdata products of this shop's brand house, in every language */
  productTypes?: Maybe<Array<Scalars['String']>>;
  /** List of all product vendors found on masterdata products of this shop's brand house, in every language */
  productVendors?: Maybe<Array<Scalars['String']>>;
  ressourceRedirectUrl?: Maybe<Scalars['String']>;
  /** List of brandrules for shop */
  rules?: Maybe<Array<Maybe<BrandRule>>>;
  /** Brand settings */
  settings?: Maybe<BrandSetting>;
  shopCollectionUrl?: Maybe<Scalars['String']>;
  /** List of all sizes found on variants for this shop */
  sizes?: Maybe<Array<Scalars['String']>>;
  /** Timestamp when statistics were last updated */
  statUpdateTs?: Maybe<Scalars['Date']>;
  /** Statistics for this shop */
  statistics?: Maybe<ShopStatistics>;
  /** The primary locale for stockitems */
  stockItemLocalePrimary: Scalars['String'];
  /** List of active locales for stockitem translations */
  stockItemLocales: Array<Scalars['String']>;
  synchronizeActions?: Maybe<Scalars['Date']>;
  synchronizeHooks?: Maybe<Scalars['Date']>;
  synchronizeOrders?: Maybe<Scalars['Date']>;
  synchronizeProducts?: Maybe<Scalars['Date']>;
  tradeInBaseUrl?: Maybe<Scalars['String']>;
  /** The primary locale for tradeins */
  tradeInLocalePrimary: Scalars['String'];
  /** List of locales for tradeIn app */
  tradeInLocales: Array<Scalars['String']>;
  updateVouchers?: Maybe<Scalars['Boolean']>;
  updateVouchersDate?: Maybe<Scalars['Date']>;
  updatedAt?: Maybe<Scalars['Date']>;
  updatedBy?: Maybe<ObjectPatchesUpdatedBy>;
  wholeSaleActive?: Maybe<Scalars['Boolean']>;
};


export type ShopProductMetaFieldValuesArgs = {
  key: Scalars['String'];
};


export type ShopStatisticsArgs = {
  periodFrom: Scalars['Date'];
  periodTo: Scalars['Date'];
};

/** Conditions for the public */
export type ShopConditionPublic = {
  __typename?: 'ShopConditionPublic';
  condition: Scalars['Int'];
  description: Scalars['String'];
  name: Scalars['String'];
};

export type ShopStatistics = {
  __typename?: 'ShopStatistics';
  /** Total number of orders in the external shop for a given period. */
  externOrders: Scalars['Int'];
  /** The total number of views for stockitems, including bots and crawlers. */
  stockItemViews: Scalars['Int'];
  /** The number of actual visitors for stockitems, bots and crawlers are excluded and grouped by identifiable information such as IP / UserAgent. */
  stockItemVisitors: Scalars['Int'];
  /** Total number of stockitems for sale in the shop. */
  stockItemsForSale: Scalars['Int'];
};

/** The shop fields that can be updated using mutation ShopUpdate */
export type ShopUpdateInput = {
  address?: InputMaybe<AddressInfoInput>;
  closeDate?: InputMaybe<Scalars['Date']>;
  configuration?: InputMaybe<Scalars['JSON']>;
  currency?: InputMaybe<Scalars['String']>;
  disableContactResetDate?: InputMaybe<Scalars['Date']>;
  disabled?: InputMaybe<Scalars['Boolean']>;
  externalName?: InputMaybe<Scalars['String']>;
  frontendType: EnumShopFrontendType;
  generateThumbnails?: InputMaybe<Scalars['Boolean']>;
  /** Last time an action distribute was triggered */
  lastActionDistribute?: InputMaybe<Scalars['Date']>;
  /** Last time a klaviyo sync was triggered */
  lastKlaviyoSync?: InputMaybe<Scalars['Date']>;
  live?: InputMaybe<Scalars['Boolean']>;
  liveDate?: InputMaybe<Scalars['Date']>;
  locales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  logo?: InputMaybe<Scalars['String']>;
  ressourceRedirectUrl?: InputMaybe<Scalars['String']>;
  shopCollectionUrl?: InputMaybe<Scalars['String']>;
  /** Timestamp when statistics were last updated */
  statUpdateTs?: InputMaybe<Scalars['Date']>;
  tradeInBaseUrl?: InputMaybe<Scalars['String']>;
  updateVouchers?: InputMaybe<Scalars['Boolean']>;
  updateVouchersDate?: InputMaybe<Scalars['Date']>;
  updatedBy?: InputMaybe<ObjectPatchesUpdatedByInput>;
};

export enum SortFindByIdsProductInput {
  BATCHSERIAL_ASC = 'BATCHSERIAL_ASC',
  BATCHSERIAL_DESC = 'BATCHSERIAL_DESC',
  BRANDPRODUCTID_ASC = 'BRANDPRODUCTID_ASC',
  BRANDPRODUCTID_DESC = 'BRANDPRODUCTID_DESC',
  ISPREOWNED_ASC = 'ISPREOWNED_ASC',
  ISPREOWNED_DESC = 'ISPREOWNED_DESC',
  NAME_ASC = 'NAME_ASC',
  NAME_DESC = 'NAME_DESC',
  PRODUCTTYPE_ASC = 'PRODUCTTYPE_ASC',
  PRODUCTTYPE_DESC = 'PRODUCTTYPE_DESC',
  PRODUCTVENDOR_ASC = 'PRODUCTVENDOR_ASC',
  PRODUCTVENDOR_DESC = 'PRODUCTVENDOR_DESC',
  SHOPID_ASC = 'SHOPID_ASC',
  SHOPID_DESC = 'SHOPID_DESC',
  STYLE_ASC = 'STYLE_ASC',
  STYLE_DESC = 'STYLE_DESC',
  _ID_ASC = '_ID_ASC',
  _ID_DESC = '_ID_DESC'
}

export enum SortFindManyBrandHouseInput {
  DEACTIVATED_ASC = 'DEACTIVATED_ASC',
  DEACTIVATED_DESC = 'DEACTIVATED_DESC',
  INITIALS_ASC = 'INITIALS_ASC',
  INITIALS_DESC = 'INITIALS_DESC',
  NAME_ASC = 'NAME_ASC',
  NAME_DESC = 'NAME_DESC',
  _ID_ASC = '_ID_ASC',
  _ID_DESC = '_ID_DESC'
}

export enum SortFindManyBrandItemInput {
  ATTRIBUTES__APPARENTFABRICTYPE_ASC = 'ATTRIBUTES__APPARENTFABRICTYPE_ASC',
  ATTRIBUTES__APPARENTFABRICTYPE_DESC = 'ATTRIBUTES__APPARENTFABRICTYPE_DESC',
  ATTRIBUTES__FORMALITYLEVEL_ASC = 'ATTRIBUTES__FORMALITYLEVEL_ASC',
  ATTRIBUTES__FORMALITYLEVEL_DESC = 'ATTRIBUTES__FORMALITYLEVEL_DESC',
  ATTRIBUTES__PATTERN_ASC = 'ATTRIBUTES__PATTERN_ASC',
  ATTRIBUTES__PATTERN_DESC = 'ATTRIBUTES__PATTERN_DESC',
  ATTRIBUTES__PRIMARYCOLOR_ASC = 'ATTRIBUTES__PRIMARYCOLOR_ASC',
  ATTRIBUTES__PRIMARYCOLOR_DESC = 'ATTRIBUTES__PRIMARYCOLOR_DESC',
  ATTRIBUTES__SEASONSUITABILITY_ASC = 'ATTRIBUTES__SEASONSUITABILITY_ASC',
  ATTRIBUTES__SEASONSUITABILITY_DESC = 'ATTRIBUTES__SEASONSUITABILITY_DESC',
  ATTRIBUTES__TYPE_ASC = 'ATTRIBUTES__TYPE_ASC',
  ATTRIBUTES__TYPE_DESC = 'ATTRIBUTES__TYPE_DESC',
  BRANDHOUSEID_ASC = 'BRANDHOUSEID_ASC',
  BRANDHOUSEID_DESC = 'BRANDHOUSEID_DESC',
  BRANDHOUSEID__ATTRIBUTES__FORMALITYLEVEL_ASC = 'BRANDHOUSEID__ATTRIBUTES__FORMALITYLEVEL_ASC',
  BRANDHOUSEID__ATTRIBUTES__FORMALITYLEVEL_DESC = 'BRANDHOUSEID__ATTRIBUTES__FORMALITYLEVEL_DESC',
  BRANDHOUSEID__ATTRIBUTES__PRIMARYCOLOR_ASC = 'BRANDHOUSEID__ATTRIBUTES__PRIMARYCOLOR_ASC',
  BRANDHOUSEID__ATTRIBUTES__PRIMARYCOLOR_DESC = 'BRANDHOUSEID__ATTRIBUTES__PRIMARYCOLOR_DESC',
  BRANDHOUSEID__ATTRIBUTES__TYPE_ASC = 'BRANDHOUSEID__ATTRIBUTES__TYPE_ASC',
  BRANDHOUSEID__ATTRIBUTES__TYPE_DESC = 'BRANDHOUSEID__ATTRIBUTES__TYPE_DESC',
  BRANDHOUSEID__DAYSOFFLINE_ASC = 'BRANDHOUSEID__DAYSOFFLINE_ASC',
  BRANDHOUSEID__DAYSOFFLINE_DESC = 'BRANDHOUSEID__DAYSOFFLINE_DESC',
  BRANDHOUSEID__DISCARDED_ASC = 'BRANDHOUSEID__DISCARDED_ASC',
  BRANDHOUSEID__DISCARDED_DESC = 'BRANDHOUSEID__DISCARDED_DESC',
  BRANDHOUSEID__EXTERNALID_ASC = 'BRANDHOUSEID__EXTERNALID_ASC',
  BRANDHOUSEID__EXTERNALID_DESC = 'BRANDHOUSEID__EXTERNALID_DESC',
  BRANDHOUSEID__FIRSTLISTEDDATE_ASC = 'BRANDHOUSEID__FIRSTLISTEDDATE_ASC',
  BRANDHOUSEID__FIRSTLISTEDDATE_DESC = 'BRANDHOUSEID__FIRSTLISTEDDATE_DESC',
  BRANDHOUSEID__GROUPKEY_ASC = 'BRANDHOUSEID__GROUPKEY_ASC',
  BRANDHOUSEID__GROUPKEY_DESC = 'BRANDHOUSEID__GROUPKEY_DESC',
  BRANDHOUSEID__HASMASTERDATA_ASC = 'BRANDHOUSEID__HASMASTERDATA_ASC',
  BRANDHOUSEID__HASMASTERDATA_DESC = 'BRANDHOUSEID__HASMASTERDATA_DESC',
  BRANDHOUSEID__HASMASTERDATA__HASCUSTOMIMAGES_ASC = 'BRANDHOUSEID__HASMASTERDATA__HASCUSTOMIMAGES_ASC',
  BRANDHOUSEID__HASMASTERDATA__HASCUSTOMIMAGES_DESC = 'BRANDHOUSEID__HASMASTERDATA__HASCUSTOMIMAGES_DESC',
  BRANDHOUSEID__HASMASTERDATA__HASCUSTOMIMAGES__STOCKLOCATION_ASC = 'BRANDHOUSEID__HASMASTERDATA__HASCUSTOMIMAGES__STOCKLOCATION_ASC',
  BRANDHOUSEID__HASMASTERDATA__HASCUSTOMIMAGES__STOCKLOCATION_DESC = 'BRANDHOUSEID__HASMASTERDATA__HASCUSTOMIMAGES__STOCKLOCATION_DESC',
  BRANDHOUSEID__HASMASTERDATA__HASCUSTOMIMAGES__STOCKLOCATION__MISSING_ASC = 'BRANDHOUSEID__HASMASTERDATA__HASCUSTOMIMAGES__STOCKLOCATION__MISSING_ASC',
  BRANDHOUSEID__HASMASTERDATA__HASCUSTOMIMAGES__STOCKLOCATION__MISSING_DESC = 'BRANDHOUSEID__HASMASTERDATA__HASCUSTOMIMAGES__STOCKLOCATION__MISSING_DESC',
  BRANDHOUSEID__HASMASTERDATA__HASCUSTOMIMAGES__STOCKLOCATION__MISSING__HASLOCATION_ASC = 'BRANDHOUSEID__HASMASTERDATA__HASCUSTOMIMAGES__STOCKLOCATION__MISSING__HASLOCATION_ASC',
  BRANDHOUSEID__HASMASTERDATA__HASCUSTOMIMAGES__STOCKLOCATION__MISSING__HASLOCATION_DESC = 'BRANDHOUSEID__HASMASTERDATA__HASCUSTOMIMAGES__STOCKLOCATION__MISSING__HASLOCATION_DESC',
  BRANDHOUSEID__HASMASTERDATA__HASCUSTOMIMAGES__STOCKLOCATION__MISSING__HASLOCATION__CREATEDAT_ASC = 'BRANDHOUSEID__HASMASTERDATA__HASCUSTOMIMAGES__STOCKLOCATION__MISSING__HASLOCATION__CREATEDAT_ASC',
  BRANDHOUSEID__HASMASTERDATA__HASCUSTOMIMAGES__STOCKLOCATION__MISSING__HASLOCATION__CREATEDAT_DESC = 'BRANDHOUSEID__HASMASTERDATA__HASCUSTOMIMAGES__STOCKLOCATION__MISSING__HASLOCATION__CREATEDAT_DESC',
  BRANDHOUSEID__HASMASTERDATA__HASCUSTOMIMAGES__STOCKLOCATION__MISSING__HASLOCATION__CREATEDAT__UPDATEDAT_ASC = 'BRANDHOUSEID__HASMASTERDATA__HASCUSTOMIMAGES__STOCKLOCATION__MISSING__HASLOCATION__CREATEDAT__UPDATEDAT_ASC',
  BRANDHOUSEID__HASMASTERDATA__HASCUSTOMIMAGES__STOCKLOCATION__MISSING__HASLOCATION__CREATEDAT__UPDATEDAT_DESC = 'BRANDHOUSEID__HASMASTERDATA__HASCUSTOMIMAGES__STOCKLOCATION__MISSING__HASLOCATION__CREATEDAT__UPDATEDAT_DESC',
  BRANDHOUSEID__HASMASTERDATA__HASCUSTOMIMAGES__STOCKLOCATION__MISSING__HASLOCATION__CREATEDAT__UPDATEDAT__STOCKLOCATIONTS_ASC = 'BRANDHOUSEID__HASMASTERDATA__HASCUSTOMIMAGES__STOCKLOCATION__MISSING__HASLOCATION__CREATEDAT__UPDATEDAT__STOCKLOCATIONTS_ASC',
  BRANDHOUSEID__HASMASTERDATA__HASCUSTOMIMAGES__STOCKLOCATION__MISSING__HASLOCATION__CREATEDAT__UPDATEDAT__STOCKLOCATIONTS_DESC = 'BRANDHOUSEID__HASMASTERDATA__HASCUSTOMIMAGES__STOCKLOCATION__MISSING__HASLOCATION__CREATEDAT__UPDATEDAT__STOCKLOCATIONTS_DESC',
  BRANDHOUSEID__HASMASTERDATA__HASCUSTOMIMAGES__STOCKLOCATION__MISSING__HASLOCATION__CREATEDAT__UPDATEDAT__STOCKLOCATIONTS__SOLDTS_ASC = 'BRANDHOUSEID__HASMASTERDATA__HASCUSTOMIMAGES__STOCKLOCATION__MISSING__HASLOCATION__CREATEDAT__UPDATEDAT__STOCKLOCATIONTS__SOLDTS_ASC',
  BRANDHOUSEID__HASMASTERDATA__HASCUSTOMIMAGES__STOCKLOCATION__MISSING__HASLOCATION__CREATEDAT__UPDATEDAT__STOCKLOCATIONTS__SOLDTS_DESC = 'BRANDHOUSEID__HASMASTERDATA__HASCUSTOMIMAGES__STOCKLOCATION__MISSING__HASLOCATION__CREATEDAT__UPDATEDAT__STOCKLOCATIONTS__SOLDTS_DESC',
  BRANDHOUSEID__ISTRADEIN_ASC = 'BRANDHOUSEID__ISTRADEIN_ASC',
  BRANDHOUSEID__ISTRADEIN_DESC = 'BRANDHOUSEID__ISTRADEIN_DESC',
  BRANDHOUSEID__MASTERDATAVARIANTID_ASC = 'BRANDHOUSEID__MASTERDATAVARIANTID_ASC',
  BRANDHOUSEID__MASTERDATAVARIANTID_DESC = 'BRANDHOUSEID__MASTERDATAVARIANTID_DESC',
  BRANDHOUSEID__QUEUED_ASC = 'BRANDHOUSEID__QUEUED_ASC',
  BRANDHOUSEID__QUEUED_DESC = 'BRANDHOUSEID__QUEUED_DESC',
  BRANDHOUSEID__SALEABLE_ASC = 'BRANDHOUSEID__SALEABLE_ASC',
  BRANDHOUSEID__SALEABLE_DESC = 'BRANDHOUSEID__SALEABLE_DESC',
  BRANDHOUSEID__SALESSCORE_ASC = 'BRANDHOUSEID__SALESSCORE_ASC',
  BRANDHOUSEID__SALESSCORE_DESC = 'BRANDHOUSEID__SALESSCORE_DESC',
  BRANDHOUSEID__VASID_ASC = 'BRANDHOUSEID__VASID_ASC',
  BRANDHOUSEID__VASID_DESC = 'BRANDHOUSEID__VASID_DESC',
  CREATEDAT_ASC = 'CREATEDAT_ASC',
  CREATEDAT_DESC = 'CREATEDAT_DESC',
  DAYSOFFLINE_ASC = 'DAYSOFFLINE_ASC',
  DAYSOFFLINE_DESC = 'DAYSOFFLINE_DESC',
  DISCARDED_ASC = 'DISCARDED_ASC',
  DISCARDED_DESC = 'DISCARDED_DESC',
  FIRSTLISTEDDATE_ASC = 'FIRSTLISTEDDATE_ASC',
  FIRSTLISTEDDATE_DESC = 'FIRSTLISTEDDATE_DESC',
  HASCOMMENT_ASC = 'HASCOMMENT_ASC',
  HASCOMMENT_DESC = 'HASCOMMENT_DESC',
  HASCUSTOMIMAGES_ASC = 'HASCUSTOMIMAGES_ASC',
  HASCUSTOMIMAGES_DESC = 'HASCUSTOMIMAGES_DESC',
  HASLOCATION_ASC = 'HASLOCATION_ASC',
  HASLOCATION_DESC = 'HASLOCATION_DESC',
  HASTRANSLATEDCOMMENT_ASC = 'HASTRANSLATEDCOMMENT_ASC',
  HASTRANSLATEDCOMMENT_DESC = 'HASTRANSLATEDCOMMENT_DESC',
  INVALIDMANUFACTURER_ASC = 'INVALIDMANUFACTURER_ASC',
  INVALIDMANUFACTURER_DESC = 'INVALIDMANUFACTURER_DESC',
  ISTRADEIN_ASC = 'ISTRADEIN_ASC',
  ISTRADEIN_DESC = 'ISTRADEIN_DESC',
  MISSING_ASC = 'MISSING_ASC',
  MISSING_DESC = 'MISSING_DESC',
  SALESSCORE_ASC = 'SALESSCORE_ASC',
  SALESSCORE_DESC = 'SALESSCORE_DESC',
  SOLDTS_ASC = 'SOLDTS_ASC',
  SOLDTS_DESC = 'SOLDTS_DESC',
  SOURCETYPE_ASC = 'SOURCETYPE_ASC',
  SOURCETYPE_DESC = 'SOURCETYPE_DESC',
  STOCKLOCATIONBAG_ASC = 'STOCKLOCATIONBAG_ASC',
  STOCKLOCATIONBAG_DESC = 'STOCKLOCATIONBAG_DESC',
  STOCKLOCATIONBAG__UPDATEDAT_ASC = 'STOCKLOCATIONBAG__UPDATEDAT_ASC',
  STOCKLOCATIONBAG__UPDATEDAT_DESC = 'STOCKLOCATIONBAG__UPDATEDAT_DESC',
  STOCKLOCATIONTS_ASC = 'STOCKLOCATIONTS_ASC',
  STOCKLOCATIONTS_DESC = 'STOCKLOCATIONTS_DESC',
  STOCKLOCATION_ASC = 'STOCKLOCATION_ASC',
  STOCKLOCATION_DESC = 'STOCKLOCATION_DESC',
  UPDATEDAT_ASC = 'UPDATEDAT_ASC',
  UPDATEDAT_DESC = 'UPDATEDAT_DESC',
  VASID_ASC = 'VASID_ASC',
  VASID_DESC = 'VASID_DESC',
  VASSTATE_ASC = 'VASSTATE_ASC',
  VASSTATE_DESC = 'VASSTATE_DESC',
  _ID_ASC = '_ID_ASC',
  _ID_DESC = '_ID_DESC'
}

export enum SortFindManyBrandItemLayawayInput {
  BRANDITEMID_ASC = 'BRANDITEMID_ASC',
  BRANDITEMID_DESC = 'BRANDITEMID_DESC',
  BRANDITEMID__CREATEDAT_ASC = 'BRANDITEMID__CREATEDAT_ASC',
  BRANDITEMID__CREATEDAT_DESC = 'BRANDITEMID__CREATEDAT_DESC',
  CREATEDAT_ASC = 'CREATEDAT_ASC',
  CREATEDAT_DESC = 'CREATEDAT_DESC',
  UPDATEDBY__REF_ASC = 'UPDATEDBY__REF_ASC',
  UPDATEDBY__REF_DESC = 'UPDATEDBY__REF_DESC',
  UPDATEDBY__REF__CREATEDAT_ASC = 'UPDATEDBY__REF__CREATEDAT_ASC',
  UPDATEDBY__REF__CREATEDAT_DESC = 'UPDATEDBY__REF__CREATEDAT_DESC',
  _ID_ASC = '_ID_ASC',
  _ID_DESC = '_ID_DESC'
}

export enum SortFindManyBrandProductGroupInput {
  BRANDHOUSEID_ASC = 'BRANDHOUSEID_ASC',
  BRANDHOUSEID_DESC = 'BRANDHOUSEID_DESC',
  BRANDHOUSEID__ACTIVE_ASC = 'BRANDHOUSEID__ACTIVE_ASC',
  BRANDHOUSEID__ACTIVE_DESC = 'BRANDHOUSEID__ACTIVE_DESC',
  _ID_ASC = '_ID_ASC',
  _ID_DESC = '_ID_DESC'
}

export enum SortFindManyBrandProductImageInput {
  _ID_ASC = '_ID_ASC',
  _ID_DESC = '_ID_DESC'
}

export enum SortFindManyBrandProductInput {
  BRANDHOUSEID_ASC = 'BRANDHOUSEID_ASC',
  BRANDHOUSEID_DESC = 'BRANDHOUSEID_DESC',
  BRANDHOUSEID__GROUPID_ASC = 'BRANDHOUSEID__GROUPID_ASC',
  BRANDHOUSEID__GROUPID_DESC = 'BRANDHOUSEID__GROUPID_DESC',
  BRANDHOUSEID__GROUPID__EXTERNALID_ASC = 'BRANDHOUSEID__GROUPID__EXTERNALID_ASC',
  BRANDHOUSEID__GROUPID__EXTERNALID_DESC = 'BRANDHOUSEID__GROUPID__EXTERNALID_DESC',
  STYLE_ASC = 'STYLE_ASC',
  STYLE_DESC = 'STYLE_DESC',
  _ID_ASC = '_ID_ASC',
  _ID_DESC = '_ID_DESC'
}

export enum SortFindManyBrandProductSizeInput {
  BRANDHOUSEID_ASC = 'BRANDHOUSEID_ASC',
  BRANDHOUSEID_DESC = 'BRANDHOUSEID_DESC',
  BRANDHOUSEID__BRANDPRODUCTID_ASC = 'BRANDHOUSEID__BRANDPRODUCTID_ASC',
  BRANDHOUSEID__BRANDPRODUCTID_DESC = 'BRANDHOUSEID__BRANDPRODUCTID_DESC',
  BRANDHOUSEID__BRANDPRODUCTID__BRANDPRODUCTVARIANTID_ASC = 'BRANDHOUSEID__BRANDPRODUCTID__BRANDPRODUCTVARIANTID_ASC',
  BRANDHOUSEID__BRANDPRODUCTID__BRANDPRODUCTVARIANTID_DESC = 'BRANDHOUSEID__BRANDPRODUCTID__BRANDPRODUCTVARIANTID_DESC',
  BRANDHOUSEID__BRANDPRODUCTID__BRANDPRODUCTVARIANTID__EXTERNALID_ASC = 'BRANDHOUSEID__BRANDPRODUCTID__BRANDPRODUCTVARIANTID__EXTERNALID_ASC',
  BRANDHOUSEID__BRANDPRODUCTID__BRANDPRODUCTVARIANTID__EXTERNALID_DESC = 'BRANDHOUSEID__BRANDPRODUCTID__BRANDPRODUCTVARIANTID__EXTERNALID_DESC',
  _ID_ASC = '_ID_ASC',
  _ID_DESC = '_ID_DESC'
}

export enum SortFindManyBrandProductVariantInput {
  BRANDHOUSEID_ASC = 'BRANDHOUSEID_ASC',
  BRANDHOUSEID_DESC = 'BRANDHOUSEID_DESC',
  BRANDHOUSEID__GROUPID_ASC = 'BRANDHOUSEID__GROUPID_ASC',
  BRANDHOUSEID__GROUPID_DESC = 'BRANDHOUSEID__GROUPID_DESC',
  SKU_ASC = 'SKU_ASC',
  SKU_DESC = 'SKU_DESC',
  _ID_ASC = '_ID_ASC',
  _ID_DESC = '_ID_DESC'
}

export enum SortFindManyCampaignInput {
  BRANDHOUSEID_ASC = 'BRANDHOUSEID_ASC',
  BRANDHOUSEID_DESC = 'BRANDHOUSEID_DESC',
  BRANDHOUSEID__FROMDATE_ASC = 'BRANDHOUSEID__FROMDATE_ASC',
  BRANDHOUSEID__FROMDATE_DESC = 'BRANDHOUSEID__FROMDATE_DESC',
  BRANDHOUSEID__FROMDATE__TODATE_ASC = 'BRANDHOUSEID__FROMDATE__TODATE_ASC',
  BRANDHOUSEID__FROMDATE__TODATE_DESC = 'BRANDHOUSEID__FROMDATE__TODATE_DESC',
  COMPLETED_ASC = 'COMPLETED_ASC',
  COMPLETED_DESC = 'COMPLETED_DESC',
  SHOPID_ASC = 'SHOPID_ASC',
  SHOPID_DESC = 'SHOPID_DESC',
  SHOPID__BRANDHOUSEID_ASC = 'SHOPID__BRANDHOUSEID_ASC',
  SHOPID__BRANDHOUSEID_DESC = 'SHOPID__BRANDHOUSEID_DESC',
  SHOPID__BRANDHOUSEID__FROMDATE_ASC = 'SHOPID__BRANDHOUSEID__FROMDATE_ASC',
  SHOPID__BRANDHOUSEID__FROMDATE_DESC = 'SHOPID__BRANDHOUSEID__FROMDATE_DESC',
  SHOPID__BRANDHOUSEID__FROMDATE__TODATE_ASC = 'SHOPID__BRANDHOUSEID__FROMDATE__TODATE_ASC',
  SHOPID__BRANDHOUSEID__FROMDATE__TODATE_DESC = 'SHOPID__BRANDHOUSEID__FROMDATE__TODATE_DESC',
  _ID_ASC = '_ID_ASC',
  _ID_DESC = '_ID_DESC'
}

export enum SortFindManyCircularPayoutTypeInput {
  _ID_ASC = '_ID_ASC',
  _ID_DESC = '_ID_DESC'
}

export enum SortFindManyCircularPointInput {
  CONSUMERID_ASC = 'CONSUMERID_ASC',
  CONSUMERID_DESC = 'CONSUMERID_DESC',
  EVENTPROCESSED_ASC = 'EVENTPROCESSED_ASC',
  EVENTPROCESSED_DESC = 'EVENTPROCESSED_DESC',
  SHOPID_ASC = 'SHOPID_ASC',
  SHOPID_DESC = 'SHOPID_DESC',
  SOURCEOBJECTID_ASC = 'SOURCEOBJECTID_ASC',
  SOURCEOBJECTID_DESC = 'SOURCEOBJECTID_DESC',
  _ID_ASC = '_ID_ASC',
  _ID_DESC = '_ID_DESC'
}

export enum SortFindManyConsumerEventInput {
  EVENT_ASC = 'EVENT_ASC',
  EVENT_DESC = 'EVENT_DESC',
  SUBEVENT_ASC = 'SUBEVENT_ASC',
  SUBEVENT_DESC = 'SUBEVENT_DESC',
  _ID_ASC = '_ID_ASC',
  _ID_DESC = '_ID_DESC'
}

export enum SortFindManyConsumerInput {
  BRANDHOUSEID_ASC = 'BRANDHOUSEID_ASC',
  BRANDHOUSEID_DESC = 'BRANDHOUSEID_DESC',
  SHOPID_ASC = 'SHOPID_ASC',
  SHOPID_DESC = 'SHOPID_DESC',
  SHOPID__CUSTOMID_ASC = 'SHOPID__CUSTOMID_ASC',
  SHOPID__CUSTOMID_DESC = 'SHOPID__CUSTOMID_DESC',
  SHOPID__EXTERNALID_ASC = 'SHOPID__EXTERNALID_ASC',
  SHOPID__EXTERNALID_DESC = 'SHOPID__EXTERNALID_DESC',
  SHOPID__MAIL_ASC = 'SHOPID__MAIL_ASC',
  SHOPID__MAIL_DESC = 'SHOPID__MAIL_DESC',
  SHOPID__PERSONID_ASC = 'SHOPID__PERSONID_ASC',
  SHOPID__PERSONID_DESC = 'SHOPID__PERSONID_DESC',
  SHOPID__PHONE_ASC = 'SHOPID__PHONE_ASC',
  SHOPID__PHONE_DESC = 'SHOPID__PHONE_DESC',
  _ID_ASC = '_ID_ASC',
  _ID_DESC = '_ID_DESC'
}

export enum SortFindManyDataViewInput {
  BRANDHOUSEID_ASC = 'BRANDHOUSEID_ASC',
  BRANDHOUSEID_DESC = 'BRANDHOUSEID_DESC',
  EXPIRESAT_ASC = 'EXPIRESAT_ASC',
  EXPIRESAT_DESC = 'EXPIRESAT_DESC',
  TYPE_ASC = 'TYPE_ASC',
  TYPE_DESC = 'TYPE_DESC',
  _ID_ASC = '_ID_ASC',
  _ID_DESC = '_ID_DESC'
}

export enum SortFindManyExternOrder2Input {
  _ID_ASC = '_ID_ASC',
  _ID_DESC = '_ID_DESC'
}

export enum SortFindManyExternOrderInput {
  _ID_ASC = '_ID_ASC',
  _ID_DESC = '_ID_DESC'
}

export enum SortFindManyIntegrationConnectorInput {
  ACTIVEFOR_ASC = 'ACTIVEFOR_ASC',
  ACTIVEFOR_DESC = 'ACTIVEFOR_DESC',
  NAME_ASC = 'NAME_ASC',
  NAME_DESC = 'NAME_DESC',
  REFTYPES_ASC = 'REFTYPES_ASC',
  REFTYPES_DESC = 'REFTYPES_DESC',
  _ID_ASC = '_ID_ASC',
  _ID_DESC = '_ID_DESC'
}

export enum SortFindManyIntegrationInstanceInput {
  REFID_ASC = 'REFID_ASC',
  REFID_DESC = 'REFID_DESC',
  REFID__CONNECTORID_ASC = 'REFID__CONNECTORID_ASC',
  REFID__CONNECTORID_DESC = 'REFID__CONNECTORID_DESC',
  REFID__CONNECTORID__DELETED_ASC = 'REFID__CONNECTORID__DELETED_ASC',
  REFID__CONNECTORID__DELETED_DESC = 'REFID__CONNECTORID__DELETED_DESC',
  _ID_ASC = '_ID_ASC',
  _ID_DESC = '_ID_DESC'
}

export enum SortFindManyIntegrationMessageInput {
  LOCKEDID_ASC = 'LOCKEDID_ASC',
  LOCKEDID_DESC = 'LOCKEDID_DESC',
  MESSAGEFAILED_ASC = 'MESSAGEFAILED_ASC',
  MESSAGEFAILED_DESC = 'MESSAGEFAILED_DESC',
  REFID_ASC = 'REFID_ASC',
  REFID_DESC = 'REFID_DESC',
  REFID__MESSAGEID_ASC = 'REFID__MESSAGEID_ASC',
  REFID__MESSAGEID_DESC = 'REFID__MESSAGEID_DESC',
  REFID__MESSAGEID__SENT_ASC = 'REFID__MESSAGEID__SENT_ASC',
  REFID__MESSAGEID__SENT_DESC = 'REFID__MESSAGEID__SENT_DESC',
  REFID__MESSAGEID__SENT__ACKNOWLEDGED_ASC = 'REFID__MESSAGEID__SENT__ACKNOWLEDGED_ASC',
  REFID__MESSAGEID__SENT__ACKNOWLEDGED_DESC = 'REFID__MESSAGEID__SENT__ACKNOWLEDGED_DESC',
  REFID__MESSAGEID__SENT__ACKNOWLEDGED__FAILED_ASC = 'REFID__MESSAGEID__SENT__ACKNOWLEDGED__FAILED_ASC',
  REFID__MESSAGEID__SENT__ACKNOWLEDGED__FAILED_DESC = 'REFID__MESSAGEID__SENT__ACKNOWLEDGED__FAILED_DESC',
  REFID__MESSAGE_ASC = 'REFID__MESSAGE_ASC',
  REFID__MESSAGE_DESC = 'REFID__MESSAGE_DESC',
  _ID_ASC = '_ID_ASC',
  _ID_DESC = '_ID_DESC'
}

export enum SortFindManyInvoiceAdjustmentInput {
  BRANDHOUSEID_ASC = 'BRANDHOUSEID_ASC',
  BRANDHOUSEID_DESC = 'BRANDHOUSEID_DESC',
  CREATEDAT_ASC = 'CREATEDAT_ASC',
  CREATEDAT_DESC = 'CREATEDAT_DESC',
  _ID_ASC = '_ID_ASC',
  _ID_DESC = '_ID_DESC'
}

export enum SortFindManyInvoiceLineInput {
  BRANDHOUSEID_ASC = 'BRANDHOUSEID_ASC',
  BRANDHOUSEID_DESC = 'BRANDHOUSEID_DESC',
  INVOICEID_ASC = 'INVOICEID_ASC',
  INVOICEID_DESC = 'INVOICEID_DESC',
  LINETYPE_ASC = 'LINETYPE_ASC',
  LINETYPE_DESC = 'LINETYPE_DESC',
  LINETYPE__LINEID_ASC = 'LINETYPE__LINEID_ASC',
  LINETYPE__LINEID_DESC = 'LINETYPE__LINEID_DESC',
  _ID_ASC = '_ID_ASC',
  _ID_DESC = '_ID_DESC'
}

export enum SortFindManyItemIssueInput {
  BRANDHOUSEID_ASC = 'BRANDHOUSEID_ASC',
  BRANDHOUSEID_DESC = 'BRANDHOUSEID_DESC',
  BRANDITEMID_ASC = 'BRANDITEMID_ASC',
  BRANDITEMID_DESC = 'BRANDITEMID_DESC',
  _ID_ASC = '_ID_ASC',
  _ID_DESC = '_ID_DESC'
}

export enum SortFindManyLogisticsPartnerInput {
  _ID_ASC = '_ID_ASC',
  _ID_DESC = '_ID_DESC'
}

export enum SortFindManyNfcInput {
  _ID_ASC = '_ID_ASC',
  _ID_DESC = '_ID_DESC'
}

export enum SortFindManyObjectPatchesInput {
  AUDITNOTEID_ASC = 'AUDITNOTEID_ASC',
  AUDITNOTEID_DESC = 'AUDITNOTEID_DESC',
  BRANDHOUSEID_ASC = 'BRANDHOUSEID_ASC',
  BRANDHOUSEID_DESC = 'BRANDHOUSEID_DESC',
  REF_ASC = 'REF_ASC',
  REF_DESC = 'REF_DESC',
  SHOPID_ASC = 'SHOPID_ASC',
  SHOPID_DESC = 'SHOPID_DESC',
  _ID_ASC = '_ID_ASC',
  _ID_DESC = '_ID_DESC'
}

export enum SortFindManyOptionSetInput {
  REFID_ASC = 'REFID_ASC',
  REFID_DESC = 'REFID_DESC',
  REFID__TARGET_ASC = 'REFID__TARGET_ASC',
  REFID__TARGET_DESC = 'REFID__TARGET_DESC',
  _ID_ASC = '_ID_ASC',
  _ID_DESC = '_ID_DESC'
}

export enum SortFindManyOptionValueInput {
  _ID_ASC = '_ID_ASC',
  _ID_DESC = '_ID_DESC'
}

export enum SortFindManyOrder2Input {
  BRANDHOUSEID_ASC = 'BRANDHOUSEID_ASC',
  BRANDHOUSEID_DESC = 'BRANDHOUSEID_DESC',
  FULSTATE_ASC = 'FULSTATE_ASC',
  FULSTATE_DESC = 'FULSTATE_DESC',
  ORDERDATE_ASC = 'ORDERDATE_ASC',
  ORDERDATE_DESC = 'ORDERDATE_DESC',
  ORDERNAME_ASC = 'ORDERNAME_ASC',
  ORDERNAME_DESC = 'ORDERNAME_DESC',
  ORDERSTATE_ASC = 'ORDERSTATE_ASC',
  ORDERSTATE_DESC = 'ORDERSTATE_DESC',
  PAYSTATE_ASC = 'PAYSTATE_ASC',
  PAYSTATE_DESC = 'PAYSTATE_DESC',
  PROFORMA_ASC = 'PROFORMA_ASC',
  PROFORMA_DESC = 'PROFORMA_DESC',
  SHOPID_ASC = 'SHOPID_ASC',
  SHOPID_DESC = 'SHOPID_DESC',
  SILENCED_ASC = 'SILENCED_ASC',
  SILENCED_DESC = 'SILENCED_DESC',
  SPLITORDER_ASC = 'SPLITORDER_ASC',
  SPLITORDER_DESC = 'SPLITORDER_DESC',
  TRACKINGORDERSTATE_ASC = 'TRACKINGORDERSTATE_ASC',
  TRACKINGORDERSTATE_DESC = 'TRACKINGORDERSTATE_DESC',
  TRACKINGRETURNSTATE_ASC = 'TRACKINGRETURNSTATE_ASC',
  TRACKINGRETURNSTATE_DESC = 'TRACKINGRETURNSTATE_DESC',
  UPDATEDLINETS_ASC = 'UPDATEDLINETS_ASC',
  UPDATEDLINETS_DESC = 'UPDATEDLINETS_DESC',
  _ID_ASC = '_ID_ASC',
  _ID_DESC = '_ID_DESC'
}

export enum SortFindManyParcelInput {
  BRANDHOUSEID_ASC = 'BRANDHOUSEID_ASC',
  BRANDHOUSEID_DESC = 'BRANDHOUSEID_DESC',
  BRANDHOUSEID__SHOPID_ASC = 'BRANDHOUSEID__SHOPID_ASC',
  BRANDHOUSEID__SHOPID_DESC = 'BRANDHOUSEID__SHOPID_DESC',
  BRANDHOUSEID__SHOPID__PARCELDATE_ASC = 'BRANDHOUSEID__SHOPID__PARCELDATE_ASC',
  BRANDHOUSEID__SHOPID__PARCELDATE_DESC = 'BRANDHOUSEID__SHOPID__PARCELDATE_DESC',
  _ID_ASC = '_ID_ASC',
  _ID_DESC = '_ID_DESC'
}

export enum SortFindManyPlannedMailInput {
  SHOPID_ASC = 'SHOPID_ASC',
  SHOPID_DESC = 'SHOPID_DESC',
  SHOPID__OBJECTTYPE_ASC = 'SHOPID__OBJECTTYPE_ASC',
  SHOPID__OBJECTTYPE_DESC = 'SHOPID__OBJECTTYPE_DESC',
  SHOPID__OBJECTTYPE__OBJECTID_ASC = 'SHOPID__OBJECTTYPE__OBJECTID_ASC',
  SHOPID__OBJECTTYPE__OBJECTID_DESC = 'SHOPID__OBJECTTYPE__OBJECTID_DESC',
  SHOPID__SENDAT_ASC = 'SHOPID__SENDAT_ASC',
  SHOPID__SENDAT_DESC = 'SHOPID__SENDAT_DESC',
  _ID_ASC = '_ID_ASC',
  _ID_DESC = '_ID_DESC'
}

export enum SortFindManyPotentialInput {
  BRANDHOUSEID_ASC = 'BRANDHOUSEID_ASC',
  BRANDHOUSEID_DESC = 'BRANDHOUSEID_DESC',
  SHOPID_ASC = 'SHOPID_ASC',
  SHOPID_DESC = 'SHOPID_DESC',
  SHOPID__BRANDPRODUCTVARIANTID_ASC = 'SHOPID__BRANDPRODUCTVARIANTID_ASC',
  SHOPID__BRANDPRODUCTVARIANTID_DESC = 'SHOPID__BRANDPRODUCTVARIANTID_DESC',
  SHOPID__EXTERNDATE_ASC = 'SHOPID__EXTERNDATE_ASC',
  SHOPID__EXTERNDATE_DESC = 'SHOPID__EXTERNDATE_DESC',
  SHOPID__NAME_ASC = 'SHOPID__NAME_ASC',
  SHOPID__NAME_DESC = 'SHOPID__NAME_DESC',
  SHOPID__PRODUCTVARIANTID_ASC = 'SHOPID__PRODUCTVARIANTID_ASC',
  SHOPID__PRODUCTVARIANTID_DESC = 'SHOPID__PRODUCTVARIANTID_DESC',
  _ID_ASC = '_ID_ASC',
  _ID_DESC = '_ID_DESC'
}

export enum SortFindManyProductInput {
  BATCHSERIAL_ASC = 'BATCHSERIAL_ASC',
  BATCHSERIAL_DESC = 'BATCHSERIAL_DESC',
  BRANDPRODUCTID_ASC = 'BRANDPRODUCTID_ASC',
  BRANDPRODUCTID_DESC = 'BRANDPRODUCTID_DESC',
  ISPREOWNED_ASC = 'ISPREOWNED_ASC',
  ISPREOWNED_DESC = 'ISPREOWNED_DESC',
  NAME_ASC = 'NAME_ASC',
  NAME_DESC = 'NAME_DESC',
  PRODUCTTYPE_ASC = 'PRODUCTTYPE_ASC',
  PRODUCTTYPE_DESC = 'PRODUCTTYPE_DESC',
  PRODUCTVENDOR_ASC = 'PRODUCTVENDOR_ASC',
  PRODUCTVENDOR_DESC = 'PRODUCTVENDOR_DESC',
  SHOPID_ASC = 'SHOPID_ASC',
  SHOPID_DESC = 'SHOPID_DESC',
  STYLE_ASC = 'STYLE_ASC',
  STYLE_DESC = 'STYLE_DESC',
  _ID_ASC = '_ID_ASC',
  _ID_DESC = '_ID_DESC'
}

export enum SortFindManyProductVariantInput {
  SHOPID_ASC = 'SHOPID_ASC',
  SHOPID_DESC = 'SHOPID_DESC',
  _ID_ASC = '_ID_ASC',
  _ID_DESC = '_ID_DESC'
}

export enum SortFindManyProductVariantSizeInput {
  SHOPID_ASC = 'SHOPID_ASC',
  SHOPID_DESC = 'SHOPID_DESC',
  SHOPID__PRODUCTID_ASC = 'SHOPID__PRODUCTID_ASC',
  SHOPID__PRODUCTID_DESC = 'SHOPID__PRODUCTID_DESC',
  SHOPID__PRODUCTID__PRODUCTVARIANTID_ASC = 'SHOPID__PRODUCTID__PRODUCTVARIANTID_ASC',
  SHOPID__PRODUCTID__PRODUCTVARIANTID_DESC = 'SHOPID__PRODUCTID__PRODUCTVARIANTID_DESC',
  SHOPID__PRODUCTID__PRODUCTVARIANTID__EXTERNALID_ASC = 'SHOPID__PRODUCTID__PRODUCTVARIANTID__EXTERNALID_ASC',
  SHOPID__PRODUCTID__PRODUCTVARIANTID__EXTERNALID_DESC = 'SHOPID__PRODUCTID__PRODUCTVARIANTID__EXTERNALID_DESC',
  _ID_ASC = '_ID_ASC',
  _ID_DESC = '_ID_DESC'
}

export enum SortFindManyRespondentInput {
  _ID_ASC = '_ID_ASC',
  _ID_DESC = '_ID_DESC'
}

export enum SortFindManyScheduledEventInput {
  EXECUTED_ASC = 'EXECUTED_ASC',
  EXECUTED_DESC = 'EXECUTED_DESC',
  EXECUTED__EXECUTEAT_ASC = 'EXECUTED__EXECUTEAT_ASC',
  EXECUTED__EXECUTEAT_DESC = 'EXECUTED__EXECUTEAT_DESC',
  _ID_ASC = '_ID_ASC',
  _ID_DESC = '_ID_DESC'
}

export enum SortFindManyShopInput {
  _ID_ASC = '_ID_ASC',
  _ID_DESC = '_ID_DESC'
}

export enum SortFindManyStockItemInput {
  COLOR_ASC = 'COLOR_ASC',
  COLOR_DESC = 'COLOR_DESC',
  CREATEDAT_ASC = 'CREATEDAT_ASC',
  CREATEDAT_DESC = 'CREATEDAT_DESC',
  EAN_ASC = 'EAN_ASC',
  EAN_DESC = 'EAN_DESC',
  ITEMNR_ASC = 'ITEMNR_ASC',
  ITEMNR_DESC = 'ITEMNR_DESC',
  ITEMSKU_ASC = 'ITEMSKU_ASC',
  ITEMSKU_DESC = 'ITEMSKU_DESC',
  MISSING_ASC = 'MISSING_ASC',
  MISSING_DESC = 'MISSING_DESC',
  ORIGINALEAN_ASC = 'ORIGINALEAN_ASC',
  ORIGINALEAN_DESC = 'ORIGINALEAN_DESC',
  REVIEWED_ASC = 'REVIEWED_ASC',
  REVIEWED_DESC = 'REVIEWED_DESC',
  SIZE_ASC = 'SIZE_ASC',
  SIZE_DESC = 'SIZE_DESC',
  SOURCETYPE_ASC = 'SOURCETYPE_ASC',
  SOURCETYPE_DESC = 'SOURCETYPE_DESC',
  STOCKLOCATIONTS_ASC = 'STOCKLOCATIONTS_ASC',
  STOCKLOCATIONTS_DESC = 'STOCKLOCATIONTS_DESC',
  STOCKLOCATION_ASC = 'STOCKLOCATION_ASC',
  STOCKLOCATION_DESC = 'STOCKLOCATION_DESC',
  TITLE_ASC = 'TITLE_ASC',
  TITLE_DESC = 'TITLE_DESC',
  UPDATEDAT_ASC = 'UPDATEDAT_ASC',
  UPDATEDAT_DESC = 'UPDATEDAT_DESC',
  _ID_ASC = '_ID_ASC',
  _ID_DESC = '_ID_DESC'
}

export enum SortFindManySystemMessageInput {
  LASTACTIVITYTS_ASC = 'LASTACTIVITYTS_ASC',
  LASTACTIVITYTS_DESC = 'LASTACTIVITYTS_DESC',
  SUBJECT_ASC = 'SUBJECT_ASC',
  SUBJECT_DESC = 'SUBJECT_DESC',
  SUBJECT__AUDIENCE_ASC = 'SUBJECT__AUDIENCE_ASC',
  SUBJECT__AUDIENCE_DESC = 'SUBJECT__AUDIENCE_DESC',
  SUBJECT__AUDIENCE__AUDIENCEBRANDID_ASC = 'SUBJECT__AUDIENCE__AUDIENCEBRANDID_ASC',
  SUBJECT__AUDIENCE__AUDIENCEBRANDID_DESC = 'SUBJECT__AUDIENCE__AUDIENCEBRANDID_DESC',
  SUBJECT__AUDIENCE__AUDIENCEBRANDID__MESSAGETYPE_ASC = 'SUBJECT__AUDIENCE__AUDIENCEBRANDID__MESSAGETYPE_ASC',
  SUBJECT__AUDIENCE__AUDIENCEBRANDID__MESSAGETYPE_DESC = 'SUBJECT__AUDIENCE__AUDIENCEBRANDID__MESSAGETYPE_DESC',
  _ID_ASC = '_ID_ASC',
  _ID_DESC = '_ID_DESC'
}

export enum SortFindManyTrackingInput {
  BRANDHOUSEID_ASC = 'BRANDHOUSEID_ASC',
  BRANDHOUSEID_DESC = 'BRANDHOUSEID_DESC',
  BRANDHOUSEID__OBJECTID_ASC = 'BRANDHOUSEID__OBJECTID_ASC',
  BRANDHOUSEID__OBJECTID_DESC = 'BRANDHOUSEID__OBJECTID_DESC',
  OBJECTID_ASC = 'OBJECTID_ASC',
  OBJECTID_DESC = 'OBJECTID_DESC',
  SHOPID_ASC = 'SHOPID_ASC',
  SHOPID_DESC = 'SHOPID_DESC',
  _ID_ASC = '_ID_ASC',
  _ID_DESC = '_ID_DESC'
}

export enum SortFindManyTradeInInput {
  BRANDHOUSEID_ASC = 'BRANDHOUSEID_ASC',
  BRANDHOUSEID_DESC = 'BRANDHOUSEID_DESC',
  DATETIME_ASC = 'DATETIME_ASC',
  DATETIME_DESC = 'DATETIME_DESC',
  DELETEDTS_ASC = 'DELETEDTS_ASC',
  DELETEDTS_DESC = 'DELETEDTS_DESC',
  PAYOUTTYPE_ASC = 'PAYOUTTYPE_ASC',
  PAYOUTTYPE_DESC = 'PAYOUTTYPE_DESC',
  REGISTEREDTS_ASC = 'REGISTEREDTS_ASC',
  REGISTEREDTS_DESC = 'REGISTEREDTS_DESC',
  REGISTERED_ASC = 'REGISTERED_ASC',
  REGISTERED_DESC = 'REGISTERED_DESC',
  SHOPID_ASC = 'SHOPID_ASC',
  SHOPID_DESC = 'SHOPID_DESC',
  TRADEINNR_ASC = 'TRADEINNR_ASC',
  TRADEINNR_DESC = 'TRADEINNR_DESC',
  _ID_ASC = '_ID_ASC',
  _ID_DESC = '_ID_DESC'
}

export enum SortFindManyUserInput {
  EMAIL_ASC = 'EMAIL_ASC',
  EMAIL_DESC = 'EMAIL_DESC',
  OAUTHSUBJECT_ASC = 'OAUTHSUBJECT_ASC',
  OAUTHSUBJECT_DESC = 'OAUTHSUBJECT_DESC',
  _ID_ASC = '_ID_ASC',
  _ID_DESC = '_ID_DESC'
}

export enum SortFindManyVoucherAdjustmentInput {
  VOUCHERID_ASC = 'VOUCHERID_ASC',
  VOUCHERID_DESC = 'VOUCHERID_DESC',
  _ID_ASC = '_ID_ASC',
  _ID_DESC = '_ID_DESC'
}

export enum SortFindManyVoucherInput {
  BRANDHOUSEID_ASC = 'BRANDHOUSEID_ASC',
  BRANDHOUSEID_DESC = 'BRANDHOUSEID_DESC',
  BRANDHOUSEID__SHOPID_ASC = 'BRANDHOUSEID__SHOPID_ASC',
  BRANDHOUSEID__SHOPID_DESC = 'BRANDHOUSEID__SHOPID_DESC',
  CODE_ASC = 'CODE_ASC',
  CODE_DESC = 'CODE_DESC',
  EXTERNID_ASC = 'EXTERNID_ASC',
  EXTERNID_DESC = 'EXTERNID_DESC',
  EXTERNID__ACTIVATED_ASC = 'EXTERNID__ACTIVATED_ASC',
  EXTERNID__ACTIVATED_DESC = 'EXTERNID__ACTIVATED_DESC',
  SHOPID_ASC = 'SHOPID_ASC',
  SHOPID_DESC = 'SHOPID_DESC',
  SHOPID__ACTIVATEVOUCHER_ASC = 'SHOPID__ACTIVATEVOUCHER_ASC',
  SHOPID__ACTIVATEVOUCHER_DESC = 'SHOPID__ACTIVATEVOUCHER_DESC',
  SHOPID__ACTIVATEVOUCHER__ACTIVATEVOUCHERTS_ASC = 'SHOPID__ACTIVATEVOUCHER__ACTIVATEVOUCHERTS_ASC',
  SHOPID__ACTIVATEVOUCHER__ACTIVATEVOUCHERTS_DESC = 'SHOPID__ACTIVATEVOUCHER__ACTIVATEVOUCHERTS_DESC',
  SHOPID__CODE_ASC = 'SHOPID__CODE_ASC',
  SHOPID__CODE_DESC = 'SHOPID__CODE_DESC',
  SHOPID__PASSIVE_ASC = 'SHOPID__PASSIVE_ASC',
  SHOPID__PASSIVE_DESC = 'SHOPID__PASSIVE_DESC',
  SHOPID__PASSIVE__UPDATEDAT_ASC = 'SHOPID__PASSIVE__UPDATEDAT_ASC',
  SHOPID__PASSIVE__UPDATEDAT_DESC = 'SHOPID__PASSIVE__UPDATEDAT_DESC',
  TRADEINID_ASC = 'TRADEINID_ASC',
  TRADEINID_DESC = 'TRADEINID_DESC',
  _ID_ASC = '_ID_ASC',
  _ID_DESC = '_ID_DESC'
}

export enum SortFindManyVoucherUsageInput {
  SHOPID_ASC = 'SHOPID_ASC',
  SHOPID_DESC = 'SHOPID_DESC',
  SHOPID__VOUCHERID_ASC = 'SHOPID__VOUCHERID_ASC',
  SHOPID__VOUCHERID_DESC = 'SHOPID__VOUCHERID_DESC',
  SHOPID__VOUCHERID__EXTERNORDERID_ASC = 'SHOPID__VOUCHERID__EXTERNORDERID_ASC',
  SHOPID__VOUCHERID__EXTERNORDERID_DESC = 'SHOPID__VOUCHERID__EXTERNORDERID_DESC',
  USAGEDATE_ASC = 'USAGEDATE_ASC',
  USAGEDATE_DESC = 'USAGEDATE_DESC',
  _ID_ASC = '_ID_ASC',
  _ID_DESC = '_ID_DESC'
}

export enum SortFindManyVoucherUsageRefundInput {
  REFUNDDATE_ASC = 'REFUNDDATE_ASC',
  REFUNDDATE_DESC = 'REFUNDDATE_DESC',
  VOUCHERUSAGEID_ASC = 'VOUCHERUSAGEID_ASC',
  VOUCHERUSAGEID_DESC = 'VOUCHERUSAGEID_DESC',
  _ID_ASC = '_ID_ASC',
  _ID_DESC = '_ID_DESC'
}

export enum SortFindManyWholeSaleCategoryInput {
  /** The order of the categories when presented to a user */
  PRESENTATION = 'PRESENTATION',
  SHOPID_ASC = 'SHOPID_ASC',
  SHOPID_DESC = 'SHOPID_DESC',
  SORTORDER_ASC = 'SORTORDER_ASC',
  SORTORDER_DESC = 'SORTORDER_DESC',
  _ID_ASC = '_ID_ASC',
  _ID_DESC = '_ID_DESC'
}

export enum SortFindOneBrandApiInput {
  _ID_ASC = '_ID_ASC',
  _ID_DESC = '_ID_DESC'
}

export enum SortFindOneTradeInInput {
  BRANDHOUSEID_ASC = 'BRANDHOUSEID_ASC',
  BRANDHOUSEID_DESC = 'BRANDHOUSEID_DESC',
  DATETIME_ASC = 'DATETIME_ASC',
  DATETIME_DESC = 'DATETIME_DESC',
  DELETEDTS_ASC = 'DELETEDTS_ASC',
  DELETEDTS_DESC = 'DELETEDTS_DESC',
  PAYOUTTYPE_ASC = 'PAYOUTTYPE_ASC',
  PAYOUTTYPE_DESC = 'PAYOUTTYPE_DESC',
  REGISTEREDTS_ASC = 'REGISTEREDTS_ASC',
  REGISTEREDTS_DESC = 'REGISTEREDTS_DESC',
  REGISTERED_ASC = 'REGISTERED_ASC',
  REGISTERED_DESC = 'REGISTERED_DESC',
  SHOPID_ASC = 'SHOPID_ASC',
  SHOPID_DESC = 'SHOPID_DESC',
  TRADEINNR_ASC = 'TRADEINNR_ASC',
  TRADEINNR_DESC = 'TRADEINNR_DESC',
  _ID_ASC = '_ID_ASC',
  _ID_DESC = '_ID_DESC'
}

export enum SortRemoveOneIntegrationConnectorInput {
  ACTIVEFOR_ASC = 'ACTIVEFOR_ASC',
  ACTIVEFOR_DESC = 'ACTIVEFOR_DESC',
  NAME_ASC = 'NAME_ASC',
  NAME_DESC = 'NAME_DESC',
  REFTYPES_ASC = 'REFTYPES_ASC',
  REFTYPES_DESC = 'REFTYPES_DESC',
  _ID_ASC = '_ID_ASC',
  _ID_DESC = '_ID_DESC'
}

export enum SortUpdateOneParcelInput {
  BRANDHOUSEID_ASC = 'BRANDHOUSEID_ASC',
  BRANDHOUSEID_DESC = 'BRANDHOUSEID_DESC',
  BRANDHOUSEID__SHOPID_ASC = 'BRANDHOUSEID__SHOPID_ASC',
  BRANDHOUSEID__SHOPID_DESC = 'BRANDHOUSEID__SHOPID_DESC',
  BRANDHOUSEID__SHOPID__PARCELDATE_ASC = 'BRANDHOUSEID__SHOPID__PARCELDATE_ASC',
  BRANDHOUSEID__SHOPID__PARCELDATE_DESC = 'BRANDHOUSEID__SHOPID__PARCELDATE_DESC',
  _ID_ASC = '_ID_ASC',
  _ID_DESC = '_ID_DESC'
}

export enum SortUpdateOnePlannedMailInput {
  SHOPID_ASC = 'SHOPID_ASC',
  SHOPID_DESC = 'SHOPID_DESC',
  SHOPID__OBJECTTYPE_ASC = 'SHOPID__OBJECTTYPE_ASC',
  SHOPID__OBJECTTYPE_DESC = 'SHOPID__OBJECTTYPE_DESC',
  SHOPID__OBJECTTYPE__OBJECTID_ASC = 'SHOPID__OBJECTTYPE__OBJECTID_ASC',
  SHOPID__OBJECTTYPE__OBJECTID_DESC = 'SHOPID__OBJECTTYPE__OBJECTID_DESC',
  SHOPID__SENDAT_ASC = 'SHOPID__SENDAT_ASC',
  SHOPID__SENDAT_DESC = 'SHOPID__SENDAT_DESC',
  _ID_ASC = '_ID_ASC',
  _ID_DESC = '_ID_DESC'
}

export enum SortUpdateOneScheduledEventInput {
  EXECUTED_ASC = 'EXECUTED_ASC',
  EXECUTED_DESC = 'EXECUTED_DESC',
  EXECUTED__EXECUTEAT_ASC = 'EXECUTED__EXECUTEAT_ASC',
  EXECUTED__EXECUTEAT_DESC = 'EXECUTED__EXECUTEAT_DESC',
  _ID_ASC = '_ID_ASC',
  _ID_DESC = '_ID_DESC'
}

export enum SortUpdateOneShippingLabelInput {
  _ID_ASC = '_ID_ASC',
  _ID_DESC = '_ID_DESC'
}

export enum SortUpdateOneShopInput {
  _ID_ASC = '_ID_ASC',
  _ID_DESC = '_ID_DESC'
}

export enum SortUpdateOneSystemMessageInput {
  LASTACTIVITYTS_ASC = 'LASTACTIVITYTS_ASC',
  LASTACTIVITYTS_DESC = 'LASTACTIVITYTS_DESC',
  SUBJECT_ASC = 'SUBJECT_ASC',
  SUBJECT_DESC = 'SUBJECT_DESC',
  SUBJECT__AUDIENCE_ASC = 'SUBJECT__AUDIENCE_ASC',
  SUBJECT__AUDIENCE_DESC = 'SUBJECT__AUDIENCE_DESC',
  SUBJECT__AUDIENCE__AUDIENCEBRANDID_ASC = 'SUBJECT__AUDIENCE__AUDIENCEBRANDID_ASC',
  SUBJECT__AUDIENCE__AUDIENCEBRANDID_DESC = 'SUBJECT__AUDIENCE__AUDIENCEBRANDID_DESC',
  SUBJECT__AUDIENCE__AUDIENCEBRANDID__MESSAGETYPE_ASC = 'SUBJECT__AUDIENCE__AUDIENCEBRANDID__MESSAGETYPE_ASC',
  SUBJECT__AUDIENCE__AUDIENCEBRANDID__MESSAGETYPE_DESC = 'SUBJECT__AUDIENCE__AUDIENCEBRANDID__MESSAGETYPE_DESC',
  _ID_ASC = '_ID_ASC',
  _ID_DESC = '_ID_DESC'
}

export enum SortUpdateOneWholeSaleCategoryInput {
  SHOPID_ASC = 'SHOPID_ASC',
  SHOPID_DESC = 'SHOPID_DESC',
  SORTORDER_ASC = 'SORTORDER_ASC',
  SORTORDER_DESC = 'SORTORDER_DESC',
  _ID_ASC = '_ID_ASC',
  _ID_DESC = '_ID_DESC'
}

export type Status = {
  __typename?: 'Status';
  /** The date of the message */
  date?: Maybe<Scalars['Date']>;
  /** The status message */
  message: Scalars['String'];
  /** The severity of the status message */
  type: EnumStatusType;
};

export type StockItem = {
  __typename?: 'StockItem';
  _id: Scalars['MongoID'];
  active?: Maybe<Scalars['Boolean']>;
  beforePrice?: Maybe<Scalars['Float']>;
  beforePrices?: Maybe<Array<Maybe<Pricing>>>;
  /** The branditem for this stockitem */
  brandItem?: Maybe<BrandItem>;
  /** This is the branditem that is the parent for this shop / stockitem */
  brandItemId?: Maybe<Scalars['MongoID']>;
  /** Product type using the shop override first, then the linked BrandItem typeLocalized, translated attributes.type (da/de/en/nb/sv/fr/nl/es), then Unknown. */
  calculatedType: Scalars['String'];
  /** This item has been confirmed at the logisticspartner at the given date */
  checked?: Maybe<Scalars['Date']>;
  color?: Maybe<Scalars['String']>;
  colorLocalized?: Maybe<Array<Maybe<LocalizationEntry>>>;
  /** The tariff code for use in customs declarations. */
  commodityCode?: Maybe<Scalars['String']>;
  /** The condition of the item 1-3 */
  condition?: Maybe<Scalars['Float']>;
  /** The condition description */
  conditionDescription?: Maybe<Scalars['String']>;
  /** The ISO 3166-1 alpha-2 country code of origin. */
  countryOrigin?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['Date']>;
  /** Returns a list of data problems */
  dataErrors?: Maybe<Array<Scalars['String']>>;
  deleted?: Maybe<Scalars['Boolean']>;
  description?: Maybe<Scalars['String']>;
  descriptionLocalized?: Maybe<Array<Maybe<LocalizationEntry>>>;
  draft?: Maybe<Scalars['Boolean']>;
  ean?: Maybe<Scalars['String']>;
  ecommerceId?: Maybe<Scalars['String']>;
  /** Whether the logistics partner has checked this stockitem since last recount */
  effectiveChecked: Scalars['Boolean'];
  /** The effective color of this stockitem */
  effectiveColor?: Maybe<Scalars['String']>;
  /** The effective colors of this stockitem */
  effectiveColors?: Maybe<Array<Maybe<LocalizationEntry>>>;
  /** The effective description that ensures the description appendage will be added, if present */
  effectiveDescription?: Maybe<Scalars['String']>;
  /** The effective descriptions */
  effectiveDescriptions?: Maybe<Array<Maybe<LocalizationEntry>>>;
  /** Whether the logistics partner has marked this this stockitem as lost */
  effectiveMissing: Scalars['Boolean'];
  /** The effective title, that will ensure titleprefix and optionally the color will be added */
  effectiveTitle: Scalars['String'];
  /** The effective titles */
  effectiveTitles?: Maybe<Array<Maybe<LocalizationEntry>>>;
  externId?: Maybe<Scalars['String']>;
  /** URL to the external product ressource */
  externUrl?: Maybe<Scalars['String']>;
  /** The brand item's cached group of interchangeable items (same style, colour and size); null when it cannot be grouped or the stock item is standalone */
  groupKey?: Maybe<Scalars['String']>;
  /** True if this item has errors */
  hasErrors: Scalars['Boolean'];
  hasProblems?: Maybe<Scalars['Boolean']>;
  imageIds?: Maybe<Array<Maybe<Scalars['MongoID']>>>;
  /** Returns a list of imageurls, deprecated - use imageInfo */
  imageUrls?: Maybe<Array<Scalars['String']>>;
  /** Returns an array of images for this stockitem */
  images?: Maybe<Array<Maybe<StockItemImage>>>;
  /** Returns a list of image info */
  imagesInfo?: Maybe<Array<Maybe<ItemImageInfo>>>;
  /** Whether this stockitem is in-season */
  isInSeason: Scalars['Boolean'];
  isSold?: Maybe<Scalars['Boolean']>;
  /** The issues for this item */
  issues?: Maybe<Array<Maybe<ItemIssue>>>;
  /** Will calculate the item age based on the tradein, if it exists, otherwise based on creation date - returns number of days old */
  itemAge?: Maybe<Scalars['Float']>;
  /** The metas for this stockitem */
  itemMetas?: Maybe<Array<Maybe<MetaFieldInstance>>>;
  itemNr?: Maybe<Scalars['Float']>;
  /** Whether the itemNr is broken */
  itemNrBroken: Scalars['Boolean'];
  /** The SKU for this stockitem */
  itemSku: Scalars['String'];
  /** Will return a status of this item */
  itemStatus: StockItemStatus;
  /** The tags for this stockitem */
  itemTags?: Maybe<Array<Maybe<StockItemTag>>>;
  /** List price for this stockitem in shop currencyy */
  listPrice?: Maybe<Scalars['Float']>;
  /** List prices for this stockitem */
  listPrices?: Maybe<Array<Maybe<Pricing>>>;
  /** This item is registered missing by the logisticspartner at the given date */
  missing?: Maybe<Scalars['Date']>;
  /** The NFC Tag for this stockitem */
  nfcTag?: Maybe<Scalars['String']>;
  note?: Maybe<Scalars['String']>;
  /** The options for this item */
  options?: Maybe<Array<Maybe<OptionInstance>>>;
  /** If this stockitem has an active orderline (its been sold) then this will be returned here */
  orderline?: Maybe<Order2Item>;
  /** Will return all historic orderlines (including returns) for this stockitem */
  orderlines?: Maybe<Array<Maybe<Order2Item>>>;
  originalEan?: Maybe<Scalars['String']>;
  problems?: Maybe<Array<Maybe<StockItemProblems>>>;
  /** The product this stockitem is based on */
  product?: Maybe<Product>;
  productType?: Maybe<Scalars['String']>;
  /** The productvariant this stockitem is based on */
  productVariant?: Maybe<ProductVariant>;
  /** This is the master data product variant that this stockitem is connected to */
  productVariantId?: Maybe<Scalars['MongoID']>;
  /** This is the master data product variant size that this stockitem is connected to */
  productVariantSizeId?: Maybe<Scalars['MongoID']>;
  published?: Maybe<Scalars['Boolean']>;
  /** The brand item's cached queued flag: waiting behind an identical item that is for sale */
  queued?: Maybe<Scalars['Boolean']>;
  resolved?: Maybe<StockItemResolved>;
  review?: Maybe<Scalars['Boolean']>;
  reviewed?: Maybe<Scalars['Date']>;
  /** The brand item's cached saleable flag: ready and active in a shop, located, unsold and free of blockers */
  saleable?: Maybe<Scalars['Boolean']>;
  sellingPrice?: Maybe<Scalars['Float']>;
  sellingPrices?: Maybe<Array<Maybe<Pricing>>>;
  /** The shop */
  shop?: Maybe<Shop>;
  shopId: Scalars['MongoID'];
  size?: Maybe<Scalars['String']>;
  sku?: Maybe<Scalars['String']>;
  /** The sortorder of the stockitem */
  sortorder?: Maybe<Scalars['Float']>;
  source?: Maybe<Scalars['String']>;
  /** The source type for this item */
  sourceType?: Maybe<ItemSourceType>;
  /** Statistics for this stockitem */
  statistics?: Maybe<StockItemStatistics>;
  stockLocation?: Maybe<Scalars['String']>;
  /** The stock location bag for this stockitem */
  stockLocationBag?: Maybe<Scalars['String']>;
  stockLocationTs?: Maybe<Scalars['Date']>;
  /** The url to the product in the shop */
  storeFrontUrl?: Maybe<Scalars['String']>;
  /** Returns a list of tags for this stockitem, use itemTags to see where the tag originated from */
  tags?: Maybe<Array<Scalars['String']>>;
  title?: Maybe<Scalars['String']>;
  titleLocalized?: Maybe<Array<Maybe<LocalizationEntry>>>;
  /** Returns the tradein item that this stockitem was made from */
  tradeInItem?: Maybe<TradeInItem>;
  tradeInItemId?: Maybe<Scalars['MongoID']>;
  updatedAt?: Maybe<Scalars['Date']>;
  updatedBy?: Maybe<ObjectPatchesUpdatedBy>;
  vendor?: Maybe<Scalars['String']>;
};


export type StockItemCalculatedTypeArgs = {
  language: Scalars['String'];
};


export type StockItemEffectiveColorArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


export type StockItemEffectiveDescriptionArgs = {
  locale?: InputMaybe<Scalars['String']>;
  removeHtml?: InputMaybe<Scalars['Boolean']>;
};


export type StockItemEffectiveTitleArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


export type StockItemImageUrlsArgs = {
  failOnError?: InputMaybe<Scalars['Boolean']>;
};


export type StockItemImagesInfoArgs = {
  failOnError?: InputMaybe<Scalars['Boolean']>;
};


export type StockItemResolvedArgs = {
  applyFallbackLocale?: InputMaybe<Scalars['Boolean']>;
};


export type StockItemStatisticsArgs = {
  date?: InputMaybe<Scalars['Date']>;
};

export type StockItemForSale = {
  __typename?: 'StockItemForSale';
  item?: Maybe<StockItem>;
  soldTs?: Maybe<Scalars['Date']>;
  status?: Maybe<StockItemStatus>;
};

export type StockItemForSale2 = {
  __typename?: 'StockItemForSale2';
  isForSale: Scalars['Boolean'];
  isInSeason: Scalars['Boolean'];
  item?: Maybe<StockItem>;
  status: Scalars['String'];
};

export type StockItemImage = {
  __typename?: 'StockItemImage';
  _id: Scalars['MongoID'];
  /** Alternative descriptive text for the image */
  altText?: Maybe<Scalars['String']>;
  brandItemImageId?: Maybe<Scalars['MongoID']>;
  /** True if this image has been deleted */
  deleted?: Maybe<Scalars['Boolean']>;
  /** The alt text for the image, can be undefined */
  effectiveAltText?: Maybe<Scalars['String']>;
  externId?: Maybe<Scalars['String']>;
  failed?: Maybe<Scalars['Boolean']>;
  imageId?: Maybe<Scalars['MongoID']>;
  /** The md5 hash of the image, used to compare images */
  imageMd5?: Maybe<Scalars['String']>;
  /** URL to the processed image */
  imageUrl?: Maybe<Scalars['String']>;
  lockedTs?: Maybe<Scalars['Date']>;
  perspective?: Maybe<EnumStockItemImagePerspective>;
  process?: Maybe<Scalars['Boolean']>;
  shopId: Scalars['MongoID'];
  sortOrder?: Maybe<Scalars['Float']>;
  sourceId: Scalars['MongoID'];
  /** The md5 hash of the image, used to compare images */
  sourceMd5?: Maybe<Scalars['String']>;
  /** URL to the original uploaded image */
  sourceUrl: Scalars['String'];
  stockItemId: Scalars['MongoID'];
  type?: Maybe<EnumStockItemImageType>;
  updatedBy?: Maybe<ObjectPatchesUpdatedBy>;
};

export type StockItemProblems = {
  __typename?: 'StockItemProblems';
  _id?: Maybe<Scalars['MongoID']>;
  createdAt?: Maybe<Scalars['Date']>;
  description?: Maybe<Scalars['String']>;
  solved?: Maybe<Scalars['Boolean']>;
};

export type StockItemProblemsInput = {
  _id?: InputMaybe<Scalars['MongoID']>;
  createdAt?: InputMaybe<Scalars['Date']>;
  description?: InputMaybe<Scalars['String']>;
  solved?: InputMaybe<Scalars['Boolean']>;
};

export type StockItemRelatedGroup = {
  __typename?: 'StockItemRelatedGroup';
  /** Every for-sale stock item of the group in the shop */
  items: Array<StockItem>;
  /** Unique within its matchedBy; for MASTERDATA, the masterdata product family id */
  key: Scalars['String'];
  /** How the group was found */
  matchedBy: ItemRelationMatch;
};

export type StockItemResolved = {
  __typename?: 'StockItemResolved';
  _id: Scalars['MongoID'];
  active?: Maybe<Scalars['Boolean']>;
  beforePrice?: Maybe<Scalars['Float']>;
  beforePrices?: Maybe<Array<Maybe<Pricing>>>;
  /** The branditem for this stockitem */
  brandItem?: Maybe<BrandItem>;
  /** This is the branditem that is the parent for this shop / stockitem */
  brandItemId?: Maybe<Scalars['MongoID']>;
  /** Product type using the shop override first, then the linked BrandItem typeLocalized, translated attributes.type (da/de/en/nb/sv/fr/nl/es), then Unknown. */
  calculatedType: Scalars['String'];
  /** This item has been confirmed at the logisticspartner at the given date */
  checked?: Maybe<Scalars['Date']>;
  color?: Maybe<Scalars['String']>;
  colorLocalized?: Maybe<Array<Maybe<LocalizationEntry>>>;
  /** The tariff code for use in customs declarations. */
  commodityCode?: Maybe<Scalars['String']>;
  /** The condition of the item 1-3 */
  condition?: Maybe<Scalars['Float']>;
  /** The condition description */
  conditionDescription?: Maybe<Scalars['String']>;
  /** The ISO 3166-1 alpha-2 country code of origin. */
  countryOrigin?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['Date']>;
  /** Returns a list of data problems */
  dataErrors?: Maybe<Array<Scalars['String']>>;
  deleted?: Maybe<Scalars['Boolean']>;
  description?: Maybe<Scalars['String']>;
  descriptionLocalized?: Maybe<Array<Maybe<LocalizationEntry>>>;
  draft?: Maybe<Scalars['Boolean']>;
  ean?: Maybe<Scalars['String']>;
  ecommerceId?: Maybe<Scalars['String']>;
  /** Whether the logistics partner has checked this stockitem since last recount */
  effectiveChecked: Scalars['Boolean'];
  /** The effective color of this stockitem */
  effectiveColor?: Maybe<Scalars['String']>;
  /** The effective colors of this stockitem */
  effectiveColors?: Maybe<Array<Maybe<LocalizationEntry>>>;
  /** The effective description that ensures the description appendage will be added, if present */
  effectiveDescription?: Maybe<Scalars['String']>;
  /** The effective descriptions */
  effectiveDescriptions?: Maybe<Array<Maybe<LocalizationEntry>>>;
  /** Whether the logistics partner has marked this this stockitem as lost */
  effectiveMissing: Scalars['Boolean'];
  /** The effective title, that will ensure titleprefix and optionally the color will be added */
  effectiveTitle: Scalars['String'];
  /** The effective titles */
  effectiveTitles?: Maybe<Array<Maybe<LocalizationEntry>>>;
  externId?: Maybe<Scalars['String']>;
  /** URL to the external product ressource */
  externUrl?: Maybe<Scalars['String']>;
  /** The brand item's cached group of interchangeable items (same style, colour and size); null when it cannot be grouped or the stock item is standalone */
  groupKey?: Maybe<Scalars['String']>;
  /** True if this item has errors */
  hasErrors: Scalars['Boolean'];
  hasProblems?: Maybe<Scalars['Boolean']>;
  imageIds?: Maybe<Array<Maybe<Scalars['MongoID']>>>;
  /** Returns a list of imageurls, deprecated - use imageInfo */
  imageUrls?: Maybe<Array<Scalars['String']>>;
  /** Returns an array of images for this stockitem */
  images?: Maybe<Array<Maybe<StockItemImage>>>;
  /** Returns a list of image info */
  imagesInfo?: Maybe<Array<Maybe<ItemImageInfo>>>;
  /** Whether this stockitem is in-season */
  isInSeason: Scalars['Boolean'];
  isSold?: Maybe<Scalars['Boolean']>;
  /** The issues for this item */
  issues?: Maybe<Array<Maybe<ItemIssue>>>;
  /** Will calculate the item age based on the tradein, if it exists, otherwise based on creation date - returns number of days old */
  itemAge?: Maybe<Scalars['Float']>;
  /** The metas for this stockitem */
  itemMetas?: Maybe<Array<Maybe<MetaFieldInstance>>>;
  itemNr?: Maybe<Scalars['Float']>;
  /** Whether the itemNr is broken */
  itemNrBroken: Scalars['Boolean'];
  /** The SKU for this stockitem */
  itemSku: Scalars['String'];
  /** Will return a status of this item */
  itemStatus: StockItemStatus;
  /** The tags for this stockitem */
  itemTags?: Maybe<Array<Maybe<StockItemTag>>>;
  /** List price for this stockitem in shop currencyy */
  listPrice?: Maybe<Scalars['Float']>;
  /** List prices for this stockitem */
  listPrices?: Maybe<Array<Maybe<Pricing>>>;
  /** This item is registered missing by the logisticspartner at the given date */
  missing?: Maybe<Scalars['Date']>;
  /** The NFC Tag for this stockitem */
  nfcTag?: Maybe<Scalars['String']>;
  note?: Maybe<Scalars['String']>;
  /** The options for this item */
  options?: Maybe<Array<Maybe<OptionInstance>>>;
  /** If this stockitem has an active orderline (its been sold) then this will be returned here */
  orderline?: Maybe<Order2Item>;
  /** Will return all historic orderlines (including returns) for this stockitem */
  orderlines?: Maybe<Array<Maybe<Order2Item>>>;
  originalEan?: Maybe<Scalars['String']>;
  problems?: Maybe<Array<Maybe<StockItemProblems>>>;
  /** The product this stockitem is based on */
  product?: Maybe<Product>;
  productType?: Maybe<Scalars['String']>;
  /** The productvariant this stockitem is based on */
  productVariant?: Maybe<ProductVariant>;
  /** This is the master data product variant that this stockitem is connected to */
  productVariantId?: Maybe<Scalars['MongoID']>;
  /** This is the master data product variant size that this stockitem is connected to */
  productVariantSizeId?: Maybe<Scalars['MongoID']>;
  published?: Maybe<Scalars['Boolean']>;
  /** The brand item's cached queued flag: waiting behind an identical item that is for sale */
  queued?: Maybe<Scalars['Boolean']>;
  review?: Maybe<Scalars['Boolean']>;
  reviewed?: Maybe<Scalars['Date']>;
  /** The brand item's cached saleable flag: ready and active in a shop, located, unsold and free of blockers */
  saleable?: Maybe<Scalars['Boolean']>;
  sellingPrice?: Maybe<Scalars['Float']>;
  sellingPrices?: Maybe<Array<Maybe<Pricing>>>;
  /** The shop */
  shop?: Maybe<Shop>;
  shopId: Scalars['MongoID'];
  size?: Maybe<Scalars['String']>;
  sku?: Maybe<Scalars['String']>;
  /** The sortorder of the stockitem */
  sortorder?: Maybe<Scalars['Float']>;
  source?: Maybe<Scalars['String']>;
  /** The source type for this item */
  sourceType?: Maybe<ItemSourceType>;
  stockLocation?: Maybe<Scalars['String']>;
  /** The stock location bag for this stockitem */
  stockLocationBag?: Maybe<Scalars['String']>;
  stockLocationTs?: Maybe<Scalars['Date']>;
  /** The url to the product in the shop */
  storeFrontUrl?: Maybe<Scalars['String']>;
  /** Returns a list of tags for this stockitem, use itemTags to see where the tag originated from */
  tags?: Maybe<Array<Scalars['String']>>;
  title?: Maybe<Scalars['String']>;
  titleLocalized?: Maybe<Array<Maybe<LocalizationEntry>>>;
  /** Returns the tradein item that this stockitem was made from */
  tradeInItem?: Maybe<TradeInItem>;
  tradeInItemId?: Maybe<Scalars['MongoID']>;
  updatedAt?: Maybe<Scalars['Date']>;
  updatedBy?: Maybe<ObjectPatchesUpdatedBy>;
  vendor?: Maybe<Scalars['String']>;
};


export type StockItemResolvedCalculatedTypeArgs = {
  language: Scalars['String'];
};


export type StockItemResolvedEffectiveColorArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


export type StockItemResolvedEffectiveDescriptionArgs = {
  locale?: InputMaybe<Scalars['String']>;
  removeHtml?: InputMaybe<Scalars['Boolean']>;
};


export type StockItemResolvedEffectiveTitleArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


export type StockItemResolvedImageUrlsArgs = {
  failOnError?: InputMaybe<Scalars['Boolean']>;
};


export type StockItemResolvedImagesInfoArgs = {
  failOnError?: InputMaybe<Scalars['Boolean']>;
};

export type StockItemStatistics = {
  __typename?: 'StockItemStatistics';
  /** The number of cancellations of the stock item */
  cancelled?: Maybe<Scalars['Int']>;
  /** The number of refunds of the stock item */
  refunds?: Maybe<Scalars['Int']>;
  /** The number of sales of the stock item */
  sales?: Maybe<Scalars['Int']>;
  /** The number of visitors to the stock item */
  views?: Maybe<Scalars['Int']>;
};

export enum StockItemStatus {
  DRAFT = 'DRAFT',
  REVIEW = 'REVIEW',
  SALE = 'SALE',
  SOLD = 'SOLD'
}

/** List of items with pagination. */
export type StockItemStockItemPagination = {
  __typename?: 'StockItemStockItemPagination';
  /** Total object count. */
  count?: Maybe<Scalars['Int']>;
  /** Array of objects. */
  items?: Maybe<Array<StockItem>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type StockItemTag = {
  __typename?: 'StockItemTag';
  _id?: Maybe<Scalars['MongoID']>;
  auto?: Maybe<Scalars['Boolean']>;
  tag?: Maybe<Scalars['String']>;
};

export type StockItemUpdateInput = {
  _id?: InputMaybe<Scalars['MongoID']>;
  active?: InputMaybe<Scalars['Boolean']>;
  beforePrice?: InputMaybe<Scalars['Float']>;
  beforePrices?: InputMaybe<Array<InputMaybe<PricingInput>>>;
  /** This is the branditem that is the parent for this shop / stockitem */
  brandItemId?: InputMaybe<Scalars['MongoID']>;
  /** This item has been confirmed at the logisticspartner at the given date */
  checked?: InputMaybe<Scalars['Date']>;
  color?: InputMaybe<Scalars['String']>;
  colorLocalized?: InputMaybe<Array<InputMaybe<LocalizationEntryInput>>>;
  /** The tariff code for use in customs declarations. */
  commodityCode?: InputMaybe<Scalars['String']>;
  /** The condition of the item 1-3 */
  condition?: InputMaybe<Scalars['Float']>;
  /** The ISO 3166-1 alpha-2 country code of origin. */
  countryOrigin?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['Date']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  description?: InputMaybe<Scalars['String']>;
  descriptionLocalized?: InputMaybe<Array<InputMaybe<LocalizationEntryInput>>>;
  draft?: InputMaybe<Scalars['Boolean']>;
  ean?: InputMaybe<Scalars['String']>;
  ecommerceId?: InputMaybe<Scalars['String']>;
  externId?: InputMaybe<Scalars['String']>;
  hasErrors?: InputMaybe<Scalars['Boolean']>;
  hasProblems?: InputMaybe<Scalars['Boolean']>;
  imageIds?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  isSold?: InputMaybe<Scalars['Boolean']>;
  itemSku?: InputMaybe<Scalars['String']>;
  /** This item is registered missing by the logisticspartner at the given date */
  missing?: InputMaybe<Scalars['Date']>;
  /** The NFC tag for this stockitem */
  nfcTag?: InputMaybe<Scalars['String']>;
  note?: InputMaybe<Scalars['String']>;
  originalEan?: InputMaybe<Scalars['String']>;
  problems?: InputMaybe<Array<InputMaybe<StockItemProblemsInput>>>;
  productType?: InputMaybe<Scalars['String']>;
  /** This is the master data product variant that this stockitem is connected to */
  productVariantId?: InputMaybe<Scalars['MongoID']>;
  /** This is the master data product variant size that this stockitem is connected to */
  productVariantSizeId?: InputMaybe<Scalars['MongoID']>;
  published?: InputMaybe<Scalars['Boolean']>;
  review?: InputMaybe<Scalars['Boolean']>;
  reviewed?: InputMaybe<Scalars['Date']>;
  sellingPrice?: InputMaybe<Scalars['Float']>;
  sellingPrices?: InputMaybe<Array<InputMaybe<PricingInput>>>;
  size?: InputMaybe<Scalars['String']>;
  sku?: InputMaybe<Scalars['String']>;
  /** The sortorder of the stockitem */
  sortorder?: InputMaybe<Scalars['Float']>;
  source?: InputMaybe<Scalars['String']>;
  /** Source type for this stockitem */
  sourceType?: InputMaybe<ItemSourceType>;
  stockLocation?: InputMaybe<Scalars['String']>;
  stockLocationBag?: InputMaybe<Scalars['String']>;
  stockLocationTs?: InputMaybe<Scalars['Date']>;
  /** The url to the product in the shop */
  storeFrontUrl?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  titleLocalized?: InputMaybe<Array<InputMaybe<LocalizationEntryInput>>>;
  updatedAt?: InputMaybe<Scalars['Date']>;
  updatedBy?: InputMaybe<ObjectPatchesUpdatedByInput>;
  vendor?: InputMaybe<Scalars['String']>;
};

export enum StorageContainerEnum {
  BRANDPRODUCT_IMAGES = 'BRANDPRODUCT_IMAGES',
  DOCUMENT_CONTAINER = 'DOCUMENT_CONTAINER',
  PRODUCT_IMAGES = 'PRODUCT_IMAGES',
  SHIPPING_LABELS = 'SHIPPING_LABELS',
  STOCKITEM_IMAGES = 'STOCKITEM_IMAGES',
  UPLOAD_IMAGES = 'UPLOAD_IMAGES',
  VOUCHER_CONTAINER = 'VOUCHER_CONTAINER'
}

export type StorageFile = {
  __typename?: 'StorageFile';
  _id: Scalars['MongoID'];
  brandHouseId?: Maybe<Scalars['MongoID']>;
  contentType?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['Date']>;
  directory?: Maybe<Scalars['String']>;
  filename?: Maybe<Scalars['String']>;
  /** The md5 hash of the file, used when comparing files */
  md5?: Maybe<Scalars['String']>;
  shopId?: Maybe<Scalars['MongoID']>;
  updatedAt?: Maybe<Scalars['Date']>;
  /** URL to the stored file */
  url: Scalars['String'];
  validated?: Maybe<Scalars['Boolean']>;
};

/** Input for a storage file createion */
export type StorageFileCreateInput = {
  /** The directory for the storage file */
  container?: InputMaybe<StorageContainerEnum>;
  contentType?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['Date']>;
  filename?: InputMaybe<Scalars['String']>;
  /** The md5 hash of the file, used when comparing files */
  md5?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Date']>;
};

export type Survey = {
  __typename?: 'Survey';
  _id: Scalars['MongoID'];
  /** The questions in this survey */
  questions: Array<Maybe<SurveyQuestions>>;
  /** Title of this survey */
  title: Scalars['String'];
};

export type SurveyQuestions = {
  __typename?: 'SurveyQuestions';
  choices?: Maybe<Array<Maybe<SurveyQuestionsChoices>>>;
  /** A survey unique identifier for this question */
  id: Scalars['String'];
  /** The question text */
  question: Scalars['String'];
  surveyId: Scalars['MongoID'];
};

export type SurveyQuestionsChoices = {
  __typename?: 'SurveyQuestionsChoices';
  /** The choice text */
  choice: Scalars['String'];
  /** Unique choice ID for the question */
  id: Scalars['String'];
  /** Numeric representation of this choice */
  value: Scalars['Float'];
};

export type SyncCompleteResult = {
  __typename?: 'SyncCompleteResult';
  status: Scalars['String'];
};

export type SyncResult = {
  __typename?: 'SyncResult';
  status: Scalars['String'];
};

export enum SynchronizeMode {
  MERGE = 'MERGE',
  REPLACE = 'REPLACE'
}

export type SystemMessage = {
  __typename?: 'SystemMessage';
  _id: Scalars['MongoID'];
  /** The timestamp when the message was acknowledged */
  acknowledgedTs?: Maybe<Scalars['Date']>;
  /** The target audience (SYSADM, ADMIN, BRAND) */
  audience: EnumSystemMessageAudience;
  /** If the audience is a brandhouse, this is the brandhouse id */
  audienceBrandId?: Maybe<Scalars['MongoID']>;
  createdAt?: Maybe<Scalars['Date']>;
  /** Collected occurrences of this message */
  entries: Array<Maybe<SystemMessageEntries>>;
  /** When the message was last appended to - drives the 30 day TTL */
  lastActivityTs: Scalars['Date'];
  /** The type of message (CRITICAL, WARNING, INFORMATION) */
  messageType: EnumSystemMessageMessageType;
  /** Subject used to group repeated messages while unacknowledged */
  subject: Scalars['String'];
  /** When the message was first created */
  timestamp: Scalars['Date'];
  updatedAt?: Maybe<Scalars['Date']>;
};

export type SystemMessageEntries = {
  __typename?: 'SystemMessageEntries';
  /** The occurrence message */
  text: Scalars['String'];
  /** When this occurrence was recorded */
  timestamp: Scalars['Date'];
};

export type Tracking = {
  __typename?: 'Tracking';
  _id: Scalars['MongoID'];
  brandHouseId?: Maybe<Scalars['MongoID']>;
  browser?: Maybe<Scalars['String']>;
  endpoint?: Maybe<Scalars['String']>;
  ip?: Maybe<Scalars['String']>;
  objectId?: Maybe<Scalars['String']>;
  objectPayload?: Maybe<Scalars['JSON']>;
  objectType?: Maybe<Scalars['String']>;
  shopId: Scalars['MongoID'];
  ts?: Maybe<Scalars['Date']>;
};

/** List of items with pagination. */
export type TrackingTrackingPagination = {
  __typename?: 'TrackingTrackingPagination';
  /** Total object count. */
  count?: Maybe<Scalars['Int']>;
  /** Array of objects. */
  items?: Maybe<Array<Tracking>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type TradeIn = {
  __typename?: 'TradeIn';
  _id: Scalars['MongoID'];
  activationStrategy?: Maybe<EnumTradeInActivationStrategy>;
  brandCarrier?: Maybe<BrandCarrier>;
  brandHouseId: Scalars['MongoID'];
  /** Circular points for this tradein */
  circularPoints?: Maybe<Array<Maybe<CircularPoint>>>;
  /** A comment about the tradein */
  comment?: Maybe<Scalars['String']>;
  /** The consumer that created this tradein */
  consumer?: Maybe<Consumer>;
  /** The consumer id */
  consumerId: Scalars['MongoID'];
  createdAt?: Maybe<Scalars['Date']>;
  /** If true, the tradein has custom carrier/delivery logic */
  customCarrier?: Maybe<Scalars['Boolean']>;
  dateTime: Scalars['Date'];
  deletedBy?: Maybe<Scalars['String']>;
  deletedTs?: Maybe<Scalars['Date']>;
  /** Trade-in note PDF for this tradein */
  deliveryNoteUrl: Scalars['String'];
  /** Dropoff points for the consumer that made this tradein */
  dropOffPoints?: Maybe<Array<Maybe<Dropoff>>>;
  /** Whether this tradein has a bonus */
  hasBonus?: Maybe<Scalars['Boolean']>;
  items?: Maybe<Array<Maybe<TradeInItem>>>;
  /** Optionally a shipping label for this tradein */
  label?: Maybe<ShippingLabel>;
  notified?: Maybe<Scalars['Boolean']>;
  /** The payout type */
  payoutType?: Maybe<EnumTradeInPayoutType>;
  pickupNotified?: Maybe<Scalars['Boolean']>;
  pickupProcessed?: Maybe<Scalars['Boolean']>;
  /** We got the package? */
  registered?: Maybe<Scalars['Boolean']>;
  /** The date we got the package */
  registeredTs?: Maybe<Scalars['Date']>;
  remindedCount?: Maybe<Scalars['Float']>;
  remindedTs?: Maybe<Scalars['Date']>;
  /** The shipping carrier selected for this tradein */
  shippingCarrier?: Maybe<ShippingCarrier>;
  /** The shipping carrier used for this tradein */
  shippingCarrierId?: Maybe<Scalars['MongoID']>;
  shippingLabelId?: Maybe<Scalars['MongoID']>;
  /** @deprecated Deprecated, see shippingCarrier */
  shippingType?: Maybe<Scalars['String']>;
  /** The shop that owns this tradein */
  shop?: Maybe<Shop>;
  shopId: Scalars['MongoID'];
  /** The source of the tradein */
  source: EnumTradeInSource;
  /** Optionally a note about the source of the tradein */
  sourceNote?: Maybe<Scalars['String']>;
  /** Statistics for this tradein */
  statistics?: Maybe<TradeInStatistics>;
  /** The status of the tradein */
  status?: Maybe<TradeInStatusEnum>;
  tradeInNr?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Date']>;
  updatedBy?: Maybe<ObjectPatchesUpdatedBy>;
  /** Vouchers for this tradein */
  vouchers?: Maybe<Array<Maybe<Voucher>>>;
};


export type TradeInStatisticsArgs = {
  currency?: InputMaybe<Scalars['String']>;
};

export type TradeInCommentInput = {
  comment: Scalars['String'];
  potentialId: Scalars['MongoID'];
};

/** Configuration for the tradein app */
export type TradeInConfig = {
  __typename?: 'TradeInConfig';
  /** The enabled consumer authentication methods for this shop */
  authMethods: Array<Scalars['String']>;
  /** The brand house ID */
  brandHouseId: Scalars['MongoID'];
  /** The default image for the shop */
  defaultImage?: Maybe<Scalars['String']>;
  /** Whether to hide the language selector */
  hideLanguageSelector?: Maybe<Scalars['Boolean']>;
  /** An expression that will, if provided, need to evaluate to false on email in order to allow tradein */
  invalidEmailReg?: Maybe<Scalars['String']>;
  /** The maximum allowed voucher given from a trade-in, 0 is no maxiumum */
  maximumVoucher: Scalars['Float'];
  /** Whether product search is enabled */
  productSearchEnabled: Scalars['Boolean'];
  /** The mask to use for product search */
  productSearchMask?: Maybe<Scalars['String']>;
  /** The currency of the shop / storefront */
  shopCurrency: Scalars['String'];
  /** The calculated voucher activation strategy for the shop */
  voucherStrategy: EnumTradeInActivationStrategy;
  /** Whether tradeins by category is allowed */
  wholeSaleActive: Scalars['Boolean'];
};

export type TradeInItem = {
  __typename?: 'TradeInItem';
  _id: Scalars['MongoID'];
  /** The bonus value of the trade-in item in shop currency */
  bonus?: Maybe<Scalars['Float']>;
  /** Will return the stockitem for this tradein, might return null */
  brandItem?: Maybe<BrandItem>;
  /** Will return the brandproduct size for this tradein, can return null if no brand variant is assigned */
  brandProductSize?: Maybe<BrandProductSize>;
  brandProductSizeId?: Maybe<Scalars['MongoID']>;
  /** Will return the brand productvariant for this tradein, can return null if no brand variant is assigned */
  brandProductVariant?: Maybe<BrandProductVariant>;
  brandProductVariantId?: Maybe<Scalars['MongoID']>;
  color?: Maybe<Scalars['String']>;
  /** A comment from the previous owner  */
  comment?: Maybe<Scalars['String']>;
  condition?: Maybe<Scalars['Float']>;
  consumer?: Maybe<Consumer>;
  createdAt?: Maybe<Scalars['Date']>;
  /** The currency of the tradein item value */
  currency?: Maybe<Scalars['String']>;
  /** Custom data for the tradein item */
  customData?: Maybe<Scalars['JSON']>;
  deletedBy?: Maybe<Scalars['String']>;
  deletedTs?: Maybe<Scalars['Date']>;
  description?: Maybe<Scalars['String']>;
  /** The purchase/order date from the originating system */
  externDate?: Maybe<Scalars['Date']>;
  /** The external order line id from the originating system (e.g. order line item id) */
  externLineId?: Maybe<Scalars['String']>;
  /** The external order id that groups multiple line items (e.g. order id) */
  externOrderId?: Maybe<Scalars['String']>;
  /** The actual sales price paid by the consumer */
  externPurchasePrice?: Maybe<Scalars['Float']>;
  externUrl?: Maybe<Scalars['String']>;
  /** The external id of the tradein item, use this to match with external systems */
  externalId?: Maybe<Scalars['String']>;
  /** Returns the identifier information for this trade-in item */
  identifier?: Maybe<TradeInItemIdentifier>;
  imageIds?: Maybe<Array<Maybe<Scalars['MongoID']>>>;
  imageUrls?: Maybe<Array<Scalars['String']>>;
  /** Value of the item in voucher/tradein currency */
  itemValue?: Maybe<Scalars['Float']>;
  /** The MAS masterdata variant id this trade-in item is related to */
  masterVariantId?: Maybe<Scalars['String']>;
  masterVariantImageId?: Maybe<Scalars['String']>;
  masterVariantImageUrl?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  potential?: Maybe<Potential>;
  /** Will return the shop productvariant for this tradein, can return null if no shop variant is assigned */
  productVariant?: Maybe<ProductVariant>;
  productVariantId?: Maybe<Scalars['MongoID']>;
  /** Will return the shop productvariant size for this tradein, can return null if no shop variant is assigned */
  productVariantSize?: Maybe<ProductVariantSize>;
  productVariantSizeId?: Maybe<Scalars['MongoID']>;
  /** The reason for rejecting the tradein item */
  rejected?: Maybe<EnumTradeInItemRejected>;
  /** Price calculation */
  resellPrice?: Maybe<Pricing>;
  shop?: Maybe<Shop>;
  shopId?: Maybe<Scalars['MongoID']>;
  size?: Maybe<Scalars['String']>;
  sku?: Maybe<Scalars['String']>;
  /** The source of the item, e.g. ONLINE, WHOLESALE, RECIEPT, SEARCH, DIGITALPASS */
  sourceType?: Maybe<EnumTradeInItemSourceType>;
  /** Will return the stockitem for this tradein, might return null */
  stockItem?: Maybe<StockItem>;
  tradeIn?: Maybe<TradeIn>;
  tradeInId?: Maybe<Scalars['MongoID']>;
  updatedAt?: Maybe<Scalars['Date']>;
  updatedBy?: Maybe<ObjectPatchesUpdatedBy>;
  /** Value of the item, by default in shop currency */
  value?: Maybe<Scalars['Float']>;
  wholeSale?: Maybe<PotentialWholeSale>;
  /** The whole sale section of the item, if applicable */
  wholeSaleSection?: Maybe<Scalars['String']>;
};


export type TradeInItemValueArgs = {
  currency?: InputMaybe<Scalars['String']>;
};

export type TradeInItemIdentifier = {
  __typename?: 'TradeInItemIdentifier';
  /** The color of the item, if available */
  color?: Maybe<Scalars['String']>;
  /** The identity string (SKU, style, or category name) */
  identity: Scalars['String'];
  /** The origin of the trade-in item */
  origin?: Maybe<TradeInItemIdentifierOrigin>;
  /** The type of identifier */
  type?: Maybe<TradeInItemIdentifierType>;
};

export enum TradeInItemIdentifierOrigin {
  online = 'online',
  wholesale = 'wholesale'
}

export enum TradeInItemIdentifierType {
  category = 'category',
  sku = 'sku',
  style = 'style'
}

export type TradeInItemPaging = {
  __typename?: 'TradeInItemPaging';
  data?: Maybe<Array<Maybe<TradeInItem>>>;
  page: Scalars['Int'];
  pages: Scalars['Int'];
  total: Scalars['Int'];
};

export enum TradeInItemRejectReasonEnum {
  ITEMBADCONDITION = 'ITEMBADCONDITION',
  ITEMMISSINGCARELABEL = 'ITEMMISSINGCARELABEL',
  ITEMNOTINPACKAGE = 'ITEMNOTINPACKAGE',
  ITEMPARTOFSET = 'ITEMPARTOFSET',
  ITEMWRONGBRAND = 'ITEMWRONGBRAND',
  NOSIZEONITEM = 'NOSIZEONITEM',
  OTHER = 'OTHER'
}

export type TradeInLayout = {
  __typename?: 'TradeInLayout';
  _id?: Maybe<Scalars['MongoID']>;
  additionalCss?: Maybe<Scalars['String']>;
  contrastPanel?: Maybe<TradeInLayoutMainPanel>;
  disableIcons?: Maybe<Scalars['Boolean']>;
  fontFamily?: Maybe<Scalars['String']>;
  frontPanel?: Maybe<TradeInLayoutMainPanel>;
  h1?: Maybe<TradeInLayoutH1>;
  h2?: Maybe<TradeInLayoutH1>;
  mainPanel?: Maybe<TradeInLayoutMainPanel>;
  subtext?: Maybe<TradeInLayoutH1>;
  text?: Maybe<TradeInLayoutH1>;
  widgets?: Maybe<TradeInLayoutWidgets>;
};

export type TradeInLayoutH1 = {
  __typename?: 'TradeInLayoutH1';
  fontFamily?: Maybe<Scalars['String']>;
  fontSize?: Maybe<Scalars['String']>;
  fontWeight?: Maybe<Scalars['String']>;
  textColor?: Maybe<Scalars['String']>;
  uppercase?: Maybe<Scalars['Boolean']>;
};

export type TradeInLayoutH1Input = {
  fontFamily?: InputMaybe<Scalars['String']>;
  fontSize?: InputMaybe<Scalars['String']>;
  fontWeight?: InputMaybe<Scalars['String']>;
  textColor?: InputMaybe<Scalars['String']>;
  uppercase?: InputMaybe<Scalars['Boolean']>;
};

export type TradeInLayoutInput = {
  _id?: InputMaybe<Scalars['MongoID']>;
  additionalCss?: InputMaybe<Scalars['String']>;
  contrastPanel?: InputMaybe<TradeInLayoutMainPanelInput>;
  disableIcons?: InputMaybe<Scalars['Boolean']>;
  fontFamily?: InputMaybe<Scalars['String']>;
  frontPanel?: InputMaybe<TradeInLayoutMainPanelInput>;
  h1?: InputMaybe<TradeInLayoutH1Input>;
  h2?: InputMaybe<TradeInLayoutH1Input>;
  mainPanel?: InputMaybe<TradeInLayoutMainPanelInput>;
  subtext?: InputMaybe<TradeInLayoutH1Input>;
  text?: InputMaybe<TradeInLayoutH1Input>;
  widgets?: InputMaybe<TradeInLayoutWidgetsInput>;
};

export type TradeInLayoutMainPanel = {
  __typename?: 'TradeInLayoutMainPanel';
  backgroundColor?: Maybe<Scalars['String']>;
  mainButton?: Maybe<TradeInLayoutMainPanelMainButton>;
  secondaryButton?: Maybe<TradeInLayoutMainPanelMainButton>;
  textColor?: Maybe<Scalars['String']>;
};

export type TradeInLayoutMainPanelInput = {
  backgroundColor?: InputMaybe<Scalars['String']>;
  mainButton?: InputMaybe<TradeInLayoutMainPanelMainButtonInput>;
  secondaryButton?: InputMaybe<TradeInLayoutMainPanelMainButtonInput>;
  textColor?: InputMaybe<Scalars['String']>;
};

export type TradeInLayoutMainPanelMainButton = {
  __typename?: 'TradeInLayoutMainPanelMainButton';
  border?: Maybe<Scalars['String']>;
  buttonColor?: Maybe<Scalars['String']>;
  disabledButtonColor?: Maybe<Scalars['String']>;
  disabledTextColor?: Maybe<Scalars['String']>;
  fontFamily?: Maybe<Scalars['String']>;
  fontSize?: Maybe<Scalars['String']>;
  fontWeight?: Maybe<Scalars['String']>;
  hoverButtonColor?: Maybe<Scalars['String']>;
  hoverTextColor?: Maybe<Scalars['String']>;
  textColor?: Maybe<Scalars['String']>;
};

export type TradeInLayoutMainPanelMainButtonInput = {
  border?: InputMaybe<Scalars['String']>;
  buttonColor?: InputMaybe<Scalars['String']>;
  disabledButtonColor?: InputMaybe<Scalars['String']>;
  disabledTextColor?: InputMaybe<Scalars['String']>;
  fontFamily?: InputMaybe<Scalars['String']>;
  fontSize?: InputMaybe<Scalars['String']>;
  fontWeight?: InputMaybe<Scalars['String']>;
  hoverButtonColor?: InputMaybe<Scalars['String']>;
  hoverTextColor?: InputMaybe<Scalars['String']>;
  textColor?: InputMaybe<Scalars['String']>;
};

export type TradeInLayoutWidgets = {
  __typename?: 'TradeInLayoutWidgets';
  accessBoxBorder?: Maybe<Scalars['String']>;
  actionItemBorderColor?: Maybe<Scalars['String']>;
  addItemButton?: Maybe<TradeInLayoutMainPanelMainButton>;
  addItemButtonBlank?: Maybe<TradeInLayoutMainPanelMainButton>;
  addItemIconColor?: Maybe<Scalars['String']>;
  addItemIconColorBlank?: Maybe<Scalars['String']>;
  addItemIconHide?: Maybe<Scalars['Boolean']>;
  borderRadius?: Maybe<Scalars['String']>;
  cartBackgroundColor?: Maybe<Scalars['String']>;
  cartTextColor?: Maybe<Scalars['String']>;
  categoryBorderColor?: Maybe<Scalars['String']>;
  categoryIconPadding?: Maybe<Scalars['Float']>;
  categoryIconSize?: Maybe<Scalars['Float']>;
  categoryRadius?: Maybe<Scalars['String']>;
  continueButton?: Maybe<TradeInLayoutMainPanelMainButton>;
  returnItem?: Maybe<TradeInLayoutWidgetsReturnItem>;
  selectionColor?: Maybe<Scalars['String']>;
  selectionTextColor?: Maybe<Scalars['String']>;
  stepperBorderWidth?: Maybe<Scalars['String']>;
  uploadPhoto?: Maybe<TradeInLayoutWidgetsUploadPhoto>;
};

export type TradeInLayoutWidgetsInput = {
  accessBoxBorder?: InputMaybe<Scalars['String']>;
  actionItemBorderColor?: InputMaybe<Scalars['String']>;
  addItemButton?: InputMaybe<TradeInLayoutMainPanelMainButtonInput>;
  addItemButtonBlank?: InputMaybe<TradeInLayoutMainPanelMainButtonInput>;
  addItemIconColor?: InputMaybe<Scalars['String']>;
  addItemIconColorBlank?: InputMaybe<Scalars['String']>;
  addItemIconHide?: InputMaybe<Scalars['Boolean']>;
  borderRadius?: InputMaybe<Scalars['String']>;
  cartBackgroundColor?: InputMaybe<Scalars['String']>;
  cartTextColor?: InputMaybe<Scalars['String']>;
  categoryBorderColor?: InputMaybe<Scalars['String']>;
  categoryIconPadding?: InputMaybe<Scalars['Float']>;
  categoryIconSize?: InputMaybe<Scalars['Float']>;
  categoryRadius?: InputMaybe<Scalars['String']>;
  continueButton?: InputMaybe<TradeInLayoutMainPanelMainButtonInput>;
  returnItem?: InputMaybe<TradeInLayoutWidgetsReturnItemInput>;
  selectionColor?: InputMaybe<Scalars['String']>;
  selectionTextColor?: InputMaybe<Scalars['String']>;
  stepperBorderWidth?: InputMaybe<Scalars['String']>;
  uploadPhoto?: InputMaybe<TradeInLayoutWidgetsUploadPhotoInput>;
};

export type TradeInLayoutWidgetsReturnItem = {
  __typename?: 'TradeInLayoutWidgetsReturnItem';
  backgroundColor?: Maybe<Scalars['String']>;
  border?: Maybe<Scalars['String']>;
  fontFamily?: Maybe<Scalars['String']>;
  fontSize?: Maybe<Scalars['String']>;
  fontWeight?: Maybe<Scalars['String']>;
  scale?: Maybe<Scalars['Float']>;
  textColor?: Maybe<Scalars['String']>;
};

export type TradeInLayoutWidgetsReturnItemInput = {
  backgroundColor?: InputMaybe<Scalars['String']>;
  border?: InputMaybe<Scalars['String']>;
  fontFamily?: InputMaybe<Scalars['String']>;
  fontSize?: InputMaybe<Scalars['String']>;
  fontWeight?: InputMaybe<Scalars['String']>;
  scale?: InputMaybe<Scalars['Float']>;
  textColor?: InputMaybe<Scalars['String']>;
};

export type TradeInLayoutWidgetsUploadPhoto = {
  __typename?: 'TradeInLayoutWidgetsUploadPhoto';
  border?: Maybe<Scalars['String']>;
  color?: Maybe<Scalars['String']>;
  disabledBorder?: Maybe<Scalars['String']>;
  disabledColor?: Maybe<Scalars['String']>;
};

export type TradeInLayoutWidgetsUploadPhotoInput = {
  border?: InputMaybe<Scalars['String']>;
  color?: InputMaybe<Scalars['String']>;
  disabledBorder?: InputMaybe<Scalars['String']>;
  disabledColor?: InputMaybe<Scalars['String']>;
};

export type TradeInResyncResult = {
  __typename?: 'TradeInResyncResult';
  /** Number of tradeins resynced */
  count: Scalars['Int'];
};

export type TradeInStatistics = {
  __typename?: 'TradeInStatistics';
  /** The average age of the items traded in (only includes items where we know the original buy date) */
  ageOfItems?: Maybe<Scalars['Float']>;
  /** The number of items traded in for business-to-consumer */
  bcItems?: Maybe<Scalars['Float']>;
  /** The number of items traded in for wholesale */
  wsItems?: Maybe<Scalars['Float']>;
  /** The number of items traded in for wholesale that was searched for */
  wsSearch?: Maybe<Scalars['Float']>;
};

export enum TradeInStatusEnum {
  DELIVERED = 'DELIVERED',
  INITIAL = 'INITIAL',
  RECEIVED = 'RECEIVED',
  TRANSIT = 'TRANSIT'
}

export type TradeInSynchronizeImageInput = {
  /** The ID of the item to add, the ID here is the ID of the category, masterdata or potential */
  imageId?: InputMaybe<Scalars['MongoID']>;
  /** The URL of the image */
  url?: InputMaybe<Scalars['String']>;
};

export type TradeInSynchronizeInput = {
  /** The ID of the tradein to synchronize, if not provided a new tradein will be created */
  _id?: InputMaybe<Scalars['MongoID']>;
  /** The activation strategy for the tradein */
  activationStrategy?: InputMaybe<EnumTradeInActivationStrategy>;
  /** Optional bonus for the tradein, this will be added to the total value of the tradein */
  bonus?: InputMaybe<Scalars['Float']>;
  /** A comment about the tradein */
  comment?: InputMaybe<Scalars['String']>;
  /** If creating a new tradein, then the consumerId must be provided - which is the owner of the new tradein */
  consumerId?: InputMaybe<Scalars['MongoID']>;
  /** If true, the tradein has custom carrier/delivery logic */
  customCarrier?: InputMaybe<Scalars['Boolean']>;
  /** Whether to delete the tradein */
  delete?: InputMaybe<Scalars['Boolean']>;
  /** The items for the tradein */
  items?: InputMaybe<Array<TradeInSynchronizeItemInput>>;
  /** The payout type */
  payoutType?: InputMaybe<EnumTradeInPayoutType>;
  /** We got the package? */
  registered?: InputMaybe<Scalars['Boolean']>;
  /** The shipping carrier used for this tradein */
  shippingCarrierId?: InputMaybe<Scalars['MongoID']>;
  /** The source of the tradein */
  source?: InputMaybe<EnumTradeInSource>;
  /** Optionally a note about the source of the tradein */
  sourceNote?: InputMaybe<Scalars['String']>;
};

export type TradeInSynchronizeItemInput = {
  /** The ID of tradein item, if not provided then a new item will be created */
  _id?: InputMaybe<Scalars['MongoID']>;
  /** Brand product size id */
  brandProductSizeId?: InputMaybe<Scalars['MongoID']>;
  /** Brand product variant id */
  brandProductVariantId?: InputMaybe<Scalars['MongoID']>;
  /** Whole sale category id */
  categoryId?: InputMaybe<Scalars['MongoID']>;
  /** Optional color of the item */
  color?: InputMaybe<Scalars['String']>;
  /** Optional comment for the item */
  comment?: InputMaybe<Scalars['String']>;
  /** External ID */
  externalId?: InputMaybe<Scalars['String']>;
  /** Optionally images for the item */
  image?: InputMaybe<TradeInSynchronizeImageInput>;
  /** Use this to allow the server to find the masterdata for the tradein item, do not use this if you are setting brandProductSizeId */
  itemId?: InputMaybe<Scalars['MongoID']>;
  /** Selected MAS masterdata variant. Null explicitly clears identification; omit to retain it. */
  masterVariantId?: InputMaybe<Scalars['String']>;
  /** Optional name of the item */
  name?: InputMaybe<Scalars['String']>;
  /** If this item represents a potential ID, then use that instead of all other properties */
  potentialId?: InputMaybe<Scalars['MongoID']>;
  /** If the item is rejected, then the reason for rejection */
  rejected?: InputMaybe<EnumTradeInItemRejected>;
  /** Optional size of the item */
  size?: InputMaybe<Scalars['String']>;
  /** Optional sku of the item */
  sku?: InputMaybe<Scalars['String']>;
  /** Optional custom currency for the item, if tradeInValue is set, this must also be set */
  tradeInCurrency?: InputMaybe<Scalars['String']>;
  /** Optional custom value for the item, will override any value from the item, must also set tradeInCurrency */
  tradeInValue?: InputMaybe<Scalars['Float']>;
};

/** List of items with pagination. */
export type TradeInTradeInPagination = {
  __typename?: 'TradeInTradeInPagination';
  /** Total object count. */
  count?: Maybe<Scalars['Int']>;
  /** Array of objects. */
  items?: Maybe<Array<TradeIn>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type TradeInUpdateInput = {
  activationStrategy?: InputMaybe<EnumTradeInActivationStrategy>;
  /** A comment about the tradein */
  comment?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['Date']>;
  /** If true, the tradein has custom carrier/delivery logic */
  customCarrier?: InputMaybe<Scalars['Boolean']>;
  deletedBy?: InputMaybe<Scalars['String']>;
  deletedTs?: InputMaybe<Scalars['Date']>;
  notified?: InputMaybe<Scalars['Boolean']>;
  /** The payout type */
  payoutType?: InputMaybe<EnumTradeInPayoutType>;
  pickupNotified?: InputMaybe<Scalars['Boolean']>;
  pickupProcessed?: InputMaybe<Scalars['Boolean']>;
  /** We got the package? */
  registered?: InputMaybe<Scalars['Boolean']>;
  remindedCount?: InputMaybe<Scalars['Float']>;
  remindedTs?: InputMaybe<Scalars['Date']>;
  shippingLabelId?: InputMaybe<Scalars['MongoID']>;
  /** The source of the tradein */
  source?: InputMaybe<EnumTradeInSource>;
  /** Optionally a note about the source of the tradein */
  sourceNote?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Date']>;
  updatedBy?: InputMaybe<ObjectPatchesUpdatedByInput>;
};

export type UpdateByIdAddressInfoInput = {
  add1?: InputMaybe<Scalars['String']>;
  add2?: InputMaybe<Scalars['String']>;
  attention?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  countryCode?: InputMaybe<Scalars['String']>;
  mail?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  /** Optionally the address can come from a referenced object that has address info */
  refId?: InputMaybe<Scalars['MongoID']>;
  /** The referenced object type, Shop, BrandHouse, LogisticsPartner */
  refType?: InputMaybe<EnumAddressInfoRefType>;
  zipCode?: InputMaybe<Scalars['String']>;
};

export type UpdateByIdBrandHouseInput = {
  address?: InputMaybe<UpdateByIdAddressInfoInput>;
  apiKey?: InputMaybe<Scalars['String']>;
  apiSecret?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['Date']>;
  /** Brandhouse has been deactivated */
  deactivated?: InputMaybe<Scalars['Boolean']>;
  initials?: InputMaybe<Scalars['String']>;
  license?: InputMaybe<Scalars['String']>;
  logisticsPartnerId?: InputMaybe<Scalars['MongoID']>;
  name?: InputMaybe<Scalars['String']>;
  /** When true, all configuration changes require an audit note with explanation */
  requireChangeExplanation?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['Date']>;
  updatedBy?: InputMaybe<UpdateByIdObjectPatchesUpdatedByInput>;
};

export type UpdateByIdBrandHousePayload = {
  __typename?: 'UpdateByIdBrandHousePayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<BrandHouse>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']>;
};

export type UpdateByIdBrandProductGroupInput = {
  /** Is the group active for everything */
  active?: InputMaybe<Scalars['Boolean']>;
  /** Is the group active for potential linking */
  activePotentials?: InputMaybe<Scalars['Boolean']>;
  /** Is the group active for promoting brand items */
  activePromotions?: InputMaybe<Scalars['Boolean']>;
  brandHouseId?: InputMaybe<Scalars['MongoID']>;
  /** The name of the group */
  name?: InputMaybe<Scalars['String']>;
};

export type UpdateByIdBrandProductGroupPayload = {
  __typename?: 'UpdateByIdBrandProductGroupPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<BrandProductGroup>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']>;
};

export type UpdateByIdBrandProductImageInput = {
  archivedImage?: InputMaybe<Scalars['Boolean']>;
  archivedThumb?: InputMaybe<Scalars['Boolean']>;
  brandHouseId?: InputMaybe<Scalars['MongoID']>;
  /** The product that owns this image */
  brandProductId?: InputMaybe<Scalars['MongoID']>;
  /** The variant that owns this image */
  brandProductVariantId?: InputMaybe<Scalars['MongoID']>;
  /** Colors represented by this image */
  colors?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAt?: InputMaybe<Scalars['Date']>;
  /** Custom data for the image */
  customData?: InputMaybe<Scalars['JSON']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  error?: InputMaybe<Scalars['String']>;
  errorCount?: InputMaybe<Scalars['Float']>;
  /** An image unique external identifier */
  externalId?: InputMaybe<Scalars['String']>;
  /** The group that this product belongs to */
  groupId?: InputMaybe<Scalars['MongoID']>;
  imageAltText?: InputMaybe<Scalars['String']>;
  /** The storage ID of the file, will be null until the image is successfully stored */
  imageId?: InputMaybe<Scalars['MongoID']>;
  /** The md5 hash of the image, used to compare images */
  imageMd5?: InputMaybe<Scalars['String']>;
  /**
   * If the image was processed by us / background removal, then this contains the version of the processing
   * use this to determine if the background process needs to be redone
   */
  imageRemoveBgVersion?: InputMaybe<Scalars['Float']>;
  /** An optional language tag for the image */
  language?: InputMaybe<Scalars['String']>;
  lastUpdate?: InputMaybe<Scalars['Date']>;
  /** Extra data about the image, localized */
  localizedMetaFields?: InputMaybe<Array<InputMaybe<UpdateByIdLocalizedMetaFieldInstanceInput>>>;
  /** Extra data about the image */
  metaFields?: InputMaybe<Array<InputMaybe<UpdateByIdMetaFieldInput>>>;
  /** The storage ID of the original image file, typically the same as imageId - but if the imageId can be modified */
  originalId?: InputMaybe<Scalars['MongoID']>;
  /** The md5 hash of the original image, used to compare images */
  originalMd5?: InputMaybe<Scalars['String']>;
  perspective?: InputMaybe<EnumBrandProductImagePerspective>;
  sortOrder?: InputMaybe<Scalars['Float']>;
  sourceUrl?: InputMaybe<Scalars['String']>;
  /** The storage ID of the thumbnail file, will be null until the image is successfully stored */
  thumbnailId?: InputMaybe<Scalars['MongoID']>;
  type?: InputMaybe<EnumBrandProductImageType>;
  updatedAt?: InputMaybe<Scalars['Date']>;
};

export type UpdateByIdBrandProductImagePayload = {
  __typename?: 'UpdateByIdBrandProductImagePayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<BrandProductImage>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']>;
};

export type UpdateByIdCampaignInput = {
  /** The brand house id of the campaign */
  brandHouseId?: InputMaybe<Scalars['MongoID']>;
  /** The name of the campaign */
  campaignName?: InputMaybe<Scalars['String']>;
  /** The status of the campaign */
  disabled?: InputMaybe<Scalars['Boolean']>;
  /** The start date of the campaign */
  fromDate?: InputMaybe<Scalars['Date']>;
  /** The percentage discount of the campaign */
  percentage?: InputMaybe<Scalars['Float']>;
  /** The shop id of the campaign */
  shopId?: InputMaybe<Scalars['MongoID']>;
  /** The end date of the campaign */
  toDate?: InputMaybe<Scalars['Date']>;
};

export type UpdateByIdCampaignPayload = {
  __typename?: 'UpdateByIdCampaignPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<Campaign>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']>;
};

export type UpdateByIdCircularPayoutInstanceInput = {
  _id?: InputMaybe<Scalars['MongoID']>;
  accountNr?: InputMaybe<Scalars['String']>;
  currency: Scalars['String'];
  /** The type of circular payout */
  payoutId: Scalars['MongoID'];
  phoneNr?: InputMaybe<Scalars['String']>;
  regNr?: InputMaybe<Scalars['String']>;
  /** Optionally a tradein that was directly converted for this payout */
  tradeInId?: InputMaybe<Scalars['MongoID']>;
};

export type UpdateByIdCircularPayoutTypeInput = {
  createdAt?: InputMaybe<Scalars['Date']>;
  /** The default payout ratio, a number between 0 and 1 */
  defaultRatio?: InputMaybe<Scalars['Float']>;
  /** The name of the payout */
  name?: InputMaybe<Scalars['String']>;
  /** The type of payout */
  payoutType?: InputMaybe<EnumCircularPayoutTypePayoutType>;
  updatedAt?: InputMaybe<Scalars['Date']>;
};

export type UpdateByIdCircularPayoutTypePayload = {
  __typename?: 'UpdateByIdCircularPayoutTypePayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<CircularPayoutType>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']>;
};

export type UpdateByIdCircularPointInput = {
  /** Whether the circularpoint point transaction has been activated for a tradein, or executed with the external service provider for a payout */
  activated?: InputMaybe<Scalars['Boolean']>;
  /** The consumer id / account id, owning the points */
  consumerId?: InputMaybe<Scalars['MongoID']>;
  createdAt?: InputMaybe<Scalars['Date']>;
  /** Whether this has been processed by the circular points engine */
  eventProcessed?: InputMaybe<Scalars['Boolean']>;
  /** The shop */
  shopId?: InputMaybe<Scalars['MongoID']>;
  /** Optionally data from the source that is relevant to the circular point */
  sourceData?: InputMaybe<UpdateByIdCircularPointSourceDataInput>;
  /** The source of the circularpoint transaction, tradein id, conversion id, etc */
  sourceObjectId?: InputMaybe<Scalars['MongoID']>;
  /** The type of the transaction source, tradein or conversion */
  sourceType?: InputMaybe<EnumCircularPointSourceType>;
  updatedAt?: InputMaybe<Scalars['Date']>;
  /** The change in points for this transaction. Can be a negative or positive value. */
  value?: InputMaybe<Scalars['Float']>;
};

export type UpdateByIdCircularPointPayload = {
  __typename?: 'UpdateByIdCircularPointPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<CircularPoint>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']>;
};

export type UpdateByIdCircularPointSourceDataInput = {
  _id?: InputMaybe<Scalars['MongoID']>;
  actualPayout?: InputMaybe<UpdateByIdCircularPayoutInstanceInput>;
  postPayout?: InputMaybe<UpdateByIdCircularPayoutInstanceInput>;
};

export type UpdateByIdIntegrationConnectorCloudTasksInput = {
  development?: InputMaybe<UpdateByIdIntegrationConnectorCloudTasksProductionInput>;
  production?: InputMaybe<UpdateByIdIntegrationConnectorCloudTasksProductionInput>;
  test?: InputMaybe<UpdateByIdIntegrationConnectorCloudTasksProductionInput>;
};

export type UpdateByIdIntegrationConnectorCloudTasksProductionInput = {
  /** The OIDC audience override; defaults to targetUrl when omitted */
  audience?: InputMaybe<Scalars['String']>;
  /** The Cloud Tasks queue name only; GCP project and location live in the runtime configuration of the distributor */
  queue: Scalars['String'];
  /** The HTTPS URL of the connector receiver that Cloud Tasks will POST to */
  targetUrl: Scalars['String'];
};

export type UpdateByIdIntegrationConnectorEventbusInput = {
  development?: InputMaybe<UpdateByIdIntegrationConnectorEventbusProductionInput>;
  production?: InputMaybe<UpdateByIdIntegrationConnectorEventbusProductionInput>;
  test?: InputMaybe<UpdateByIdIntegrationConnectorEventbusProductionInput>;
};

export type UpdateByIdIntegrationConnectorEventbusProductionInput = {
  /** The servicebus connection string */
  serviceBus: Scalars['String'];
  /** The topic for the servicebus */
  topic: Scalars['String'];
};

export type UpdateByIdIntegrationConnectorFieldsInput = {
  _id?: InputMaybe<Scalars['MongoID']>;
  /** Default value for the field */
  defaultValue?: InputMaybe<Scalars['String']>;
  /** Description of the field */
  description?: InputMaybe<Scalars['String']>;
  /** The field */
  field?: InputMaybe<Scalars['String']>;
  /** Namespace grouping of multiple fields */
  namespace?: InputMaybe<Scalars['String']>;
  options?: InputMaybe<Array<InputMaybe<UpdateByIdIntegrationConnectorFieldsOptionsInput>>>;
  /** Whether the field is required */
  required?: InputMaybe<Scalars['Boolean']>;
  /** text, number, json */
  type?: InputMaybe<Scalars['String']>;
};

export type UpdateByIdIntegrationConnectorFieldsOptionsInput = {
  /** Option label */
  label?: InputMaybe<Scalars['String']>;
  /** The value when the option is selected */
  value?: InputMaybe<Scalars['JSON']>;
};

export type UpdateByIdIntegrationConnectorInput = {
  activeFor?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  autoInstallFor?: InputMaybe<Array<InputMaybe<EnumIntegrationConnectorAutoInstallFor>>>;
  cloudTasks?: InputMaybe<UpdateByIdIntegrationConnectorCloudTasksInput>;
  /** Whether this connector has been deleted */
  deleted?: InputMaybe<Scalars['Boolean']>;
  /** The runtime that dispatches this connector; missing means FUNCTIONS2 for backwards compatibility */
  dispatcher?: InputMaybe<EnumIntegrationConnectorDispatcher>;
  eventbus?: InputMaybe<UpdateByIdIntegrationConnectorEventbusInput>;
  fields?: InputMaybe<Array<InputMaybe<UpdateByIdIntegrationConnectorFieldsInput>>>;
  /** Icon for the connector */
  icon?: InputMaybe<Scalars['String']>;
  messages?: InputMaybe<Array<InputMaybe<EnumIntegrationConnectorMessages>>>;
  /** The name of the connector */
  name?: InputMaybe<Scalars['String']>;
  optionals?: InputMaybe<Array<InputMaybe<EnumIntegrationConnectorOptionals>>>;
  refTypes?: InputMaybe<Array<InputMaybe<EnumIntegrationConnectorRefTypes>>>;
  /** The type of connector */
  type?: InputMaybe<EnumIntegrationConnectorType>;
  /** The latest entity that updated this connector */
  updatedBy?: InputMaybe<UpdateByIdObjectPatchesUpdatedByInput>;
  webhook?: InputMaybe<UpdateByIdIntegrationConnectorWebhookInput>;
};

export type UpdateByIdIntegrationConnectorPayload = {
  __typename?: 'UpdateByIdIntegrationConnectorPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<IntegrationConnector>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']>;
};

export type UpdateByIdIntegrationConnectorWebhookInput = {
  development?: InputMaybe<UpdateByIdIntegrationConnectorWebhookProductionInput>;
  production?: InputMaybe<UpdateByIdIntegrationConnectorWebhookProductionInput>;
  test?: InputMaybe<UpdateByIdIntegrationConnectorWebhookProductionInput>;
};

export type UpdateByIdIntegrationConnectorWebhookProductionInput = {
  /** Custom headers to include in the webhook request */
  headers?: InputMaybe<Scalars['JSON']>;
  /** The URL that will receive the POST payload message */
  url: Scalars['String'];
};

export type UpdateByIdIntegrationMessageInput = {
  /** The timestamp of the message ackknowledgement, webhooks will set this instantly based on 200 OK response. Servicebus implementationw will need to send an ackknowledge event. */
  acknowledged?: InputMaybe<Scalars['Date']>;
  /** Timestamp of the message creation */
  created?: InputMaybe<Scalars['Date']>;
  /** The source environment of this message : production, development or test */
  env?: InputMaybe<Scalars['String']>;
  /** If the message was unable to be delivered, this will have contain a timestamp of when we gave up */
  failed?: InputMaybe<Scalars['Date']>;
  /** The instance identifier */
  instanceId?: InputMaybe<Scalars['MongoID']>;
  lockedId?: InputMaybe<Scalars['String']>;
  /** The message type */
  message?: InputMaybe<EnumIntegrationMessageMessage>;
  /** True if failure */
  messageFailed?: InputMaybe<Scalars['Boolean']>;
  /** True if ignored */
  messageIgnored?: InputMaybe<Scalars['Boolean']>;
  /** If this message is a retry message, then this points the the previous message that initiated the retry */
  parentId?: InputMaybe<Scalars['MongoID']>;
  /** Optionally a payload for the message */
  payload?: InputMaybe<Scalars['JSON']>;
  /** A token that can be used to read the message */
  readToken?: InputMaybe<Scalars['String']>;
  /** The referenced object this message originated from */
  refId?: InputMaybe<Scalars['MongoID']>;
  /** The referenced object type, Shop, BrandHouse, LogisticsPartner */
  refType?: InputMaybe<Scalars['String']>;
  /** Dispatcher-private fence for result writes. Only 0 (job accepted) and 1 (terminal job result) are defined; a result may only be replaced by a strictly newer sequence. Absent for single-reply messages */
  replySequence?: InputMaybe<Scalars['Float']>;
  /** Optionally a result data blob for the message */
  result?: InputMaybe<Scalars['JSON']>;
  /** If a result data blob was stored, then this timestamp holds the timestamp for it - otherwise null */
  resultTs?: InputMaybe<Scalars['Date']>;
  /** The timestamp of when the message should be sent, this is typically used when retrying failed messages, but can be used for any message delaying */
  sendAt?: InputMaybe<Scalars['Date']>;
  /** Timestamp of when the message was last sent */
  sent?: InputMaybe<Scalars['Date']>;
  /** The number of times we have sent this message */
  sentCount?: InputMaybe<Scalars['Float']>;
};

export type UpdateByIdIntegrationMessagePayload = {
  __typename?: 'UpdateByIdIntegrationMessagePayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<IntegrationMessage>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']>;
};

export type UpdateByIdItemIssueInput = {
  externId?: InputMaybe<Scalars['String']>;
  /** URL to the image of the issue */
  imageUrl?: InputMaybe<Scalars['String']>;
  issue?: InputMaybe<Scalars['String']>;
  location?: InputMaybe<EnumItemIssueLocation>;
  /** Marker X position as percent (0-100) of image width, origin top-left */
  markX?: InputMaybe<Scalars['Float']>;
  /** Marker Y position as percent (0-100) of image height, origin top-left */
  markY?: InputMaybe<Scalars['Float']>;
  /** Coordinate of the issue, A1, B2, etc. */
  point?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Scalars['Float']>;
};

export type UpdateByIdItemIssuePayload = {
  __typename?: 'UpdateByIdItemIssuePayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<ItemIssue>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']>;
};

export type UpdateByIdLocalizationEntryInput = {
  /** ISO Locale code */
  locale?: InputMaybe<Scalars['String']>;
  /** The localized text */
  value?: InputMaybe<Scalars['String']>;
};

export type UpdateByIdLocalizedMetaFieldInstanceInput = {
  /** The language of the localized metafields */
  language?: InputMaybe<Scalars['String']>;
  /** The metafields */
  metaFields?: InputMaybe<Array<InputMaybe<MetaFieldInput>>>;
};

export type UpdateByIdLogisticsPartnerAutoretouchInput = {
  accessToken?: InputMaybe<Scalars['String']>;
  expireTs?: InputMaybe<Scalars['Date']>;
  refreshToken?: InputMaybe<Scalars['String']>;
};

export type UpdateByIdLogisticsPartnerInput = {
  address?: InputMaybe<Scalars['String']>;
  address2?: InputMaybe<Scalars['String']>;
  /** API KEY for the logisticspartner, use this to obtain an accessToken */
  apiKey?: InputMaybe<Scalars['String']>;
  /** API Secret for the logisticspartner, use this to obtain an accessToken */
  apiSecret?: InputMaybe<Scalars['String']>;
  attention?: InputMaybe<Scalars['String']>;
  autoretouch?: InputMaybe<UpdateByIdLogisticsPartnerAutoretouchInput>;
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  countryCode?: InputMaybe<Scalars['String']>;
  mail?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  zipCode?: InputMaybe<Scalars['String']>;
};

export type UpdateByIdLogisticsPartnerPayload = {
  __typename?: 'UpdateByIdLogisticsPartnerPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<LogisticsPartner>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']>;
};

export type UpdateByIdMetaFieldInput = {
  /** Custom data to the metafield */
  customData?: InputMaybe<Scalars['JSON']>;
  /** The key to identify the metafield within a namespace */
  key: Scalars['String'];
  /** Optionally a namespace for the metafield, used to group related fields */
  namespace?: InputMaybe<Scalars['String']>;
  /** Type of the value, required */
  type?: InputMaybe<EnumMetaFieldType>;
  /** The metafield value, JSON data */
  value: Scalars['JSON'];
};

export type UpdateByIdObjectPatchesUpdatedByInput = {
  ref?: InputMaybe<Scalars['MongoID']>;
  type?: InputMaybe<Scalars['String']>;
};

export type UpdateByIdPotentialInput = {
  batchSerial?: InputMaybe<Scalars['String']>;
  brandHouseId?: InputMaybe<Scalars['MongoID']>;
  /** The brand product that this potential is related to */
  brandProductId?: InputMaybe<Scalars['MongoID']>;
  /** The brand product size that this potential is related to */
  brandProductSizeId?: InputMaybe<Scalars['MongoID']>;
  /** The brand product variant that this potential is related to */
  brandProductVariantId?: InputMaybe<Scalars['MongoID']>;
  cancelled?: InputMaybe<Scalars['Boolean']>;
  cancelledReason?: InputMaybe<EnumPotentialCancelledReason>;
  color?: InputMaybe<Scalars['String']>;
  consumerId?: InputMaybe<Scalars['MongoID']>;
  createdAt?: InputMaybe<Scalars['Date']>;
  description?: InputMaybe<Scalars['String']>;
  ean?: InputMaybe<Scalars['String']>;
  externDate?: InputMaybe<Scalars['Date']>;
  externGroupId?: InputMaybe<Scalars['String']>;
  externUrl?: InputMaybe<Scalars['String']>;
  /** True if this potential is free to be added to anyones tradein */
  freePotential?: InputMaybe<Scalars['Boolean']>;
  /** How masterdata identified this potential on its last answered identification (NONE when no variant was found) */
  identifiedBy?: InputMaybe<EnumPotentialIdentifiedBy>;
  imageIds?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  isUsingFakeProduct?: InputMaybe<Scalars['Boolean']>;
  /** The last time masterdata answered an identification for this potential */
  linkTs?: InputMaybe<Scalars['Date']>;
  lockedTs?: InputMaybe<Scalars['Date']>;
  /** The MAS masterdata variant id this potential is related to */
  masterVariantId?: InputMaybe<Scalars['String']>;
  masterVariantImageId?: InputMaybe<Scalars['String']>;
  masterVariantImageUrl?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  /** Whether this potential has no "date", its not actually bought, or we dont know the date - means that any date check in the tradein rules will be voided */
  noDate?: InputMaybe<Scalars['Boolean']>;
  /** If the owner of this potential was contacting with trade-in offers for this */
  notified?: InputMaybe<EnumPotentialNotified>;
  /** When was the owner of this potential contacting regarding trade-in offers */
  notifiedTs?: InputMaybe<Scalars['Date']>;
  /** The id of the product this potential is related to */
  productId?: InputMaybe<Scalars['MongoID']>;
  /** The id of the product variant this potential is related to */
  productVariantId?: InputMaybe<Scalars['MongoID']>;
  /** The id of the product variant this potential is related to */
  productVariantSizeId?: InputMaybe<Scalars['MongoID']>;
  rrp?: InputMaybe<Scalars['Float']>;
  shopId?: InputMaybe<Scalars['MongoID']>;
  size?: InputMaybe<Scalars['String']>;
  sku?: InputMaybe<Scalars['String']>;
  /** The source of the potential, e.g. order, wholesale */
  sourceType?: InputMaybe<EnumPotentialSourceType>;
  sp?: InputMaybe<Scalars['Float']>;
  spOriginal?: InputMaybe<Scalars['Float']>;
  tradeInItemId?: InputMaybe<Scalars['MongoID']>;
  updatedAt?: InputMaybe<Scalars['Date']>;
  wholeSale?: InputMaybe<UpdateByIdPotentialWholeSaleInput>;
};

export type UpdateByIdPotentialPayload = {
  __typename?: 'UpdateByIdPotentialPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<Potential>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']>;
};

export type UpdateByIdPotentialWholeSaleInput = {
  _id?: InputMaybe<Scalars['MongoID']>;
  categoryId?: InputMaybe<Scalars['MongoID']>;
  name?: InputMaybe<Scalars['String']>;
  ruleId?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type UpdateByIdProductInput = {
  batchSerial?: InputMaybe<Scalars['String']>;
  /** The brandproduct that is the master data for this product */
  brandProductId?: InputMaybe<Scalars['MongoID']>;
  collections?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAt?: InputMaybe<Scalars['Date']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  description?: InputMaybe<Scalars['String']>;
  descriptionLocalized?: InputMaybe<Array<InputMaybe<UpdateByIdLocalizationEntryInput>>>;
  disabled?: InputMaybe<Scalars['Boolean']>;
  externalId?: InputMaybe<Scalars['String']>;
  isPotential?: InputMaybe<Scalars['Boolean']>;
  isPreOwned?: InputMaybe<Scalars['Boolean']>;
  metaFields?: InputMaybe<Array<InputMaybe<UpdateByIdMetaFieldInput>>>;
  name?: InputMaybe<Scalars['String']>;
  nameLocalized?: InputMaybe<Array<InputMaybe<UpdateByIdLocalizationEntryInput>>>;
  productType?: InputMaybe<Scalars['String']>;
  productVendor?: InputMaybe<Scalars['String']>;
  shopId?: InputMaybe<Scalars['MongoID']>;
  style?: InputMaybe<Scalars['String']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAt?: InputMaybe<Scalars['Date']>;
};

export type UpdateByIdProductPayload = {
  __typename?: 'UpdateByIdProductPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<Product>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']>;
};

export type UpdateByIdStockItemImageInput = {
  /** Alternative descriptive text for the image */
  altText?: InputMaybe<Scalars['String']>;
  brandItemImageId?: InputMaybe<Scalars['MongoID']>;
  /** True if this image has been deleted */
  deleted?: InputMaybe<Scalars['Boolean']>;
  externId?: InputMaybe<Scalars['String']>;
  failed?: InputMaybe<Scalars['Boolean']>;
  imageId?: InputMaybe<Scalars['MongoID']>;
  /** The md5 hash of the image, used to compare images */
  imageMd5?: InputMaybe<Scalars['String']>;
  lockedTs?: InputMaybe<Scalars['Date']>;
  perspective?: InputMaybe<EnumStockItemImagePerspective>;
  process?: InputMaybe<Scalars['Boolean']>;
  shopId?: InputMaybe<Scalars['MongoID']>;
  sortOrder?: InputMaybe<Scalars['Float']>;
  sourceId?: InputMaybe<Scalars['MongoID']>;
  /** The md5 hash of the image, used to compare images */
  sourceMd5?: InputMaybe<Scalars['String']>;
  stockItemId?: InputMaybe<Scalars['MongoID']>;
  type?: InputMaybe<EnumStockItemImageType>;
  updatedBy?: InputMaybe<UpdateByIdObjectPatchesUpdatedByInput>;
};

export type UpdateByIdStockItemImagePayload = {
  __typename?: 'UpdateByIdStockItemImagePayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<StockItemImage>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']>;
};

export type UpdateByIdSurveyInput = {
  /** The questions in this survey */
  questions?: InputMaybe<Array<InputMaybe<UpdateByIdSurveyQuestionsInput>>>;
  /** Title of this survey */
  title?: InputMaybe<Scalars['String']>;
};

export type UpdateByIdSurveyPayload = {
  __typename?: 'UpdateByIdSurveyPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<Survey>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']>;
};

export type UpdateByIdSurveyQuestionsChoicesInput = {
  /** The choice text */
  choice?: InputMaybe<Scalars['String']>;
  /** Unique choice ID for the question */
  id?: InputMaybe<Scalars['String']>;
  /** Numeric representation of this choice */
  value?: InputMaybe<Scalars['Float']>;
};

export type UpdateByIdSurveyQuestionsInput = {
  choices?: InputMaybe<Array<InputMaybe<UpdateByIdSurveyQuestionsChoicesInput>>>;
  /** A survey unique identifier for this question */
  id?: InputMaybe<Scalars['String']>;
  /** The question text */
  question?: InputMaybe<Scalars['String']>;
  surveyId?: InputMaybe<Scalars['MongoID']>;
};

export type UpdateByIdTradeInItemInput = {
  /** The bonus value of the trade-in item in shop currency */
  bonus?: InputMaybe<Scalars['Float']>;
  brandProductSizeId?: InputMaybe<Scalars['MongoID']>;
  brandProductVariantId?: InputMaybe<Scalars['MongoID']>;
  color?: InputMaybe<Scalars['String']>;
  /** A comment from the previous owner  */
  comment?: InputMaybe<Scalars['String']>;
  condition?: InputMaybe<Scalars['Float']>;
  createdAt?: InputMaybe<Scalars['Date']>;
  /** The currency of the tradein item value */
  currency?: InputMaybe<Scalars['String']>;
  /** Custom data for the tradein item */
  customData?: InputMaybe<Scalars['JSON']>;
  deletedBy?: InputMaybe<Scalars['String']>;
  deletedTs?: InputMaybe<Scalars['Date']>;
  description?: InputMaybe<Scalars['String']>;
  /** The purchase/order date from the originating system */
  externDate?: InputMaybe<Scalars['Date']>;
  /** The external order line id from the originating system (e.g. order line item id) */
  externLineId?: InputMaybe<Scalars['String']>;
  /** The external order id that groups multiple line items (e.g. order id) */
  externOrderId?: InputMaybe<Scalars['String']>;
  /** The actual sales price paid by the consumer */
  externPurchasePrice?: InputMaybe<Scalars['Float']>;
  externUrl?: InputMaybe<Scalars['String']>;
  /** The external id of the tradein item, use this to match with external systems */
  externalId?: InputMaybe<Scalars['String']>;
  imageIds?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  /** The MAS masterdata variant id this trade-in item is related to */
  masterVariantId?: InputMaybe<Scalars['String']>;
  masterVariantImageId?: InputMaybe<Scalars['String']>;
  masterVariantImageUrl?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  productVariantId?: InputMaybe<Scalars['MongoID']>;
  productVariantSizeId?: InputMaybe<Scalars['MongoID']>;
  /** The reason for rejecting the tradein item */
  rejected?: InputMaybe<EnumTradeInItemRejected>;
  shopId?: InputMaybe<Scalars['MongoID']>;
  size?: InputMaybe<Scalars['String']>;
  sku?: InputMaybe<Scalars['String']>;
  /** The source of the item, e.g. ONLINE, WHOLESALE, RECIEPT, SEARCH, DIGITALPASS */
  sourceType?: InputMaybe<EnumTradeInItemSourceType>;
  tradeInId?: InputMaybe<Scalars['MongoID']>;
  updatedAt?: InputMaybe<Scalars['Date']>;
  updatedBy?: InputMaybe<UpdateByIdObjectPatchesUpdatedByInput>;
  /** The value of the trade-in item in shop currency */
  value?: InputMaybe<Scalars['Float']>;
  wholeSale?: InputMaybe<UpdateByIdPotentialWholeSaleInput>;
};

export type UpdateByIdTradeInItemPayload = {
  __typename?: 'UpdateByIdTradeInItemPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<TradeInItem>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']>;
};

export type UpdateOneAddressInfoInput = {
  add1?: InputMaybe<Scalars['String']>;
  add2?: InputMaybe<Scalars['String']>;
  attention?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  countryCode?: InputMaybe<Scalars['String']>;
  mail?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  /** Optionally the address can come from a referenced object that has address info */
  refId?: InputMaybe<Scalars['MongoID']>;
  /** The referenced object type, Shop, BrandHouse, LogisticsPartner */
  refType?: InputMaybe<EnumAddressInfoRefType>;
  zipCode?: InputMaybe<Scalars['String']>;
};

export type UpdateOneLocalizationEntryInput = {
  /** ISO Locale code */
  locale?: InputMaybe<Scalars['String']>;
  /** The localized text */
  value?: InputMaybe<Scalars['String']>;
};

export type UpdateOneObjectPatchesUpdatedByInput = {
  ref?: InputMaybe<Scalars['MongoID']>;
  type?: InputMaybe<Scalars['String']>;
};

export type UpdateOneParcelInput = {
  /** The brand that owns this parcel */
  brandHouseId?: InputMaybe<Scalars['MongoID']>;
  /** Optional comment for the parcel */
  comment?: InputMaybe<Scalars['String']>;
  /** Items in the parcel */
  items?: InputMaybe<Array<InputMaybe<UpdateOneParcelItemsInput>>>;
  /** The date of the parcel creation */
  parcelDate?: InputMaybe<Scalars['Date']>;
  /** The receiver of the parcel */
  receiver?: InputMaybe<UpdateOneAddressInfoInput>;
  /** The sender of the parcel */
  sender?: InputMaybe<UpdateOneAddressInfoInput>;
  /** The carrier of the parcel */
  shippingCarrierId?: InputMaybe<Scalars['MongoID']>;
  /** The shop that owns this parcel */
  shopId?: InputMaybe<Scalars['MongoID']>;
};

export type UpdateOneParcelItemsInput = {
  refId?: InputMaybe<Scalars['MongoID']>;
  refType?: InputMaybe<EnumParcelItemsRefType>;
};

export type UpdateOneParcelPayload = {
  __typename?: 'UpdateOneParcelPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<Parcel>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']>;
};

export type UpdateOnePlannedMailInput = {
  mailType?: InputMaybe<Scalars['String']>;
  objectId?: InputMaybe<Scalars['String']>;
  objectType?: InputMaybe<Scalars['String']>;
  sendAt?: InputMaybe<Scalars['Date']>;
  sent?: InputMaybe<Scalars['Date']>;
  sentStatus?: InputMaybe<Scalars['String']>;
  shopId?: InputMaybe<Scalars['MongoID']>;
};

export type UpdateOnePlannedMailPayload = {
  __typename?: 'UpdateOnePlannedMailPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<PlannedMail>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']>;
};

export type UpdateOneScheduledEventInput = {
  /** Optionally data that will be sent with the event */
  data?: InputMaybe<Scalars['JSON']>;
  /** The timestamp of when the event should be executed */
  executeAt?: InputMaybe<Scalars['Date']>;
  /** The timestamp of when the event was executed */
  executed?: InputMaybe<Scalars['Date']>;
  /** The referenced object this event is attached to */
  refId?: InputMaybe<Scalars['MongoID']>;
  /** The referenced object type */
  refType?: InputMaybe<EnumScheduledEventRefType>;
};

export type UpdateOneScheduledEventPayload = {
  __typename?: 'UpdateOneScheduledEventPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<ScheduledEvent>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']>;
};

export type UpdateOneShippingLabelInput = {
  archived?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Date']>;
  deletedBy?: InputMaybe<Scalars['String']>;
  deletedTs?: InputMaybe<Scalars['Date']>;
  deliveryDate?: InputMaybe<Scalars['Date']>;
  deliveryStatus?: InputMaybe<EnumShippingLabelDeliveryStatus>;
  labelCode?: InputMaybe<Scalars['String']>;
  labelExternalId?: InputMaybe<Scalars['String']>;
  labelFailed?: InputMaybe<Scalars['Boolean']>;
  labelFailedCount?: InputMaybe<Scalars['Float']>;
  labelImageId?: InputMaybe<Scalars['MongoID']>;
  lastUpdate?: InputMaybe<Scalars['Date']>;
  packageCode?: InputMaybe<Scalars['String']>;
  qrImageId?: InputMaybe<Scalars['MongoID']>;
  qrPngId?: InputMaybe<Scalars['MongoID']>;
  receiver?: InputMaybe<UpdateOneAddressInfoInput>;
  sender?: InputMaybe<UpdateOneAddressInfoInput>;
  shippingCarrierId?: InputMaybe<Scalars['MongoID']>;
  shopId?: InputMaybe<Scalars['MongoID']>;
  tracking?: InputMaybe<UpdateOneShippingLabelTrackingInput>;
  updatedAt?: InputMaybe<Scalars['Date']>;
  updatedBy?: InputMaybe<UpdateOneObjectPatchesUpdatedByInput>;
};

export type UpdateOneShippingLabelPayload = {
  __typename?: 'UpdateOneShippingLabelPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<ShippingLabel>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']>;
};

export type UpdateOneShippingLabelTrackingInput = {
  carrierCode?: InputMaybe<Scalars['String']>;
  countryCode?: InputMaybe<Scalars['String']>;
  location?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  statusFailed?: InputMaybe<Scalars['Boolean']>;
  statusText?: InputMaybe<Scalars['String']>;
  time?: InputMaybe<Scalars['Date']>;
  trackingCode?: InputMaybe<Scalars['String']>;
};

export type UpdateOneShopInput = {
  address?: InputMaybe<UpdateOneAddressInfoInput>;
  brandHouseId?: InputMaybe<Scalars['MongoID']>;
  closeDate?: InputMaybe<Scalars['Date']>;
  configuration?: InputMaybe<Scalars['JSON']>;
  createdAt?: InputMaybe<Scalars['Date']>;
  currency?: InputMaybe<Scalars['String']>;
  disableContactResetDate?: InputMaybe<Scalars['Date']>;
  disabled?: InputMaybe<Scalars['Boolean']>;
  externalId?: InputMaybe<Scalars['String']>;
  externalName?: InputMaybe<Scalars['String']>;
  frontendType?: InputMaybe<EnumShopFrontendType>;
  generateThumbnails?: InputMaybe<Scalars['Boolean']>;
  /** Last time an action distribute was triggered */
  lastActionDistribute?: InputMaybe<Scalars['Date']>;
  /** Last time a klaviyo sync was triggered */
  lastKlaviyoSync?: InputMaybe<Scalars['Date']>;
  live?: InputMaybe<Scalars['Boolean']>;
  liveDate?: InputMaybe<Scalars['Date']>;
  locales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  logisticsPartnerId?: InputMaybe<Scalars['MongoID']>;
  logo?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  ressourceRedirectUrl?: InputMaybe<Scalars['String']>;
  shopCollectionUrl?: InputMaybe<Scalars['String']>;
  /** Timestamp when statistics were last updated */
  statUpdateTs?: InputMaybe<Scalars['Date']>;
  synchronizeActions?: InputMaybe<Scalars['Date']>;
  synchronizeHooks?: InputMaybe<Scalars['Date']>;
  synchronizeOrders?: InputMaybe<Scalars['Date']>;
  synchronizeProducts?: InputMaybe<Scalars['Date']>;
  tradeInBaseUrl?: InputMaybe<Scalars['String']>;
  updateVouchers?: InputMaybe<Scalars['Boolean']>;
  updateVouchersDate?: InputMaybe<Scalars['Date']>;
  updatedAt?: InputMaybe<Scalars['Date']>;
  updatedBy?: InputMaybe<UpdateOneObjectPatchesUpdatedByInput>;
  wholeSaleActive?: InputMaybe<Scalars['Boolean']>;
};

export type UpdateOneShopPayload = {
  __typename?: 'UpdateOneShopPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<Shop>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']>;
};

export type UpdateOneSystemMessageInput = {
  acknowledgedTs?: InputMaybe<Scalars['Date']>;
};

export type UpdateOneSystemMessagePayload = {
  __typename?: 'UpdateOneSystemMessagePayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<SystemMessage>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']>;
};

export type UpdateOneWholeSaleCategoryInput = {
  advanced?: InputMaybe<Scalars['Boolean']>;
  /** Soft-delete flag. When true, the category is hidden from listings but retained so historical TradeInItems can still resolve it. */
  deleted?: InputMaybe<Scalars['Boolean']>;
  iconId?: InputMaybe<Scalars['MongoID']>;
  name?: InputMaybe<Scalars['String']>;
  nameLocalized?: InputMaybe<Array<InputMaybe<UpdateOneLocalizationEntryInput>>>;
  rules?: InputMaybe<Array<InputMaybe<UpdateOneWholeSaleCategoryRulesInput>>>;
  section?: InputMaybe<Scalars['String']>;
  sectionLocalized?: InputMaybe<Array<InputMaybe<UpdateOneLocalizationEntryInput>>>;
  shopId?: InputMaybe<Scalars['MongoID']>;
  /** The other of this category */
  sortOrder?: InputMaybe<Scalars['Float']>;
  updatedBy?: InputMaybe<UpdateOneObjectPatchesUpdatedByInput>;
  value?: InputMaybe<Scalars['Float']>;
  voucherStrategy?: InputMaybe<EnumWholeSaleCategoryVoucherStrategy>;
};

export type UpdateOneWholeSaleCategoryPayload = {
  __typename?: 'UpdateOneWholeSaleCategoryPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<WholeSaleCategory>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']>;
};

export type UpdateOneWholeSaleCategoryRulesExpressionsInput = {
  _id?: InputMaybe<Scalars['MongoID']>;
  /** Product collection in external shop, see valid collections on Shop.productCollections */
  col?: InputMaybe<Scalars['String']>;
  expressionType?: InputMaybe<EnumWholeSaleCategoryRulesExpressionsExpressionType>;
  operator?: InputMaybe<EnumWholeSaleCategoryRulesExpressionsOperator>;
  sku?: InputMaybe<Scalars['String']>;
  /** Product tag, see valid tags on Shop.productTags */
  tag?: InputMaybe<Scalars['String']>;
};

export type UpdateOneWholeSaleCategoryRulesInput = {
  _id?: InputMaybe<Scalars['MongoID']>;
  active?: InputMaybe<Scalars['Boolean']>;
  expressions?: InputMaybe<Array<InputMaybe<UpdateOneWholeSaleCategoryRulesExpressionsInput>>>;
  name?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type User = {
  __typename?: 'User';
  _id: Scalars['MongoID'];
  /** Returns information about user accesses */
  access?: Maybe<Array<Maybe<UserAccess>>>;
  /** If true, then user has access to everything */
  administrator?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['Date']>;
  /** True if the user has been disabled */
  disabled?: Maybe<Scalars['Boolean']>;
  email: Scalars['String'];
  lastIp?: Maybe<Scalars['String']>;
  lastLoginAt?: Maybe<Scalars['Date']>;
  name?: Maybe<Scalars['String']>;
  /** Link to OAuth2 user ID */
  oauthSubject?: Maybe<Scalars['String']>;
  /** Can contain any reference to another object, that the user is linked to - this has no effect on the users access whatsoever */
  parentId?: Maybe<Scalars['MongoID']>;
  resetToken?: Maybe<Scalars['String']>;
  resetTokenTs?: Maybe<Scalars['Date']>;
  /** If true, then user has a simplified view */
  simplified?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['Date']>;
};


export type UserAccessArgs = {
  all?: InputMaybe<Scalars['Boolean']>;
};

export type UserAccess = {
  __typename?: 'UserAccess';
  _id: Scalars['MongoID'];
  brandHouseId?: Maybe<Scalars['MongoID']>;
  /** The name of the brandhouse */
  brandHouseName?: Maybe<Scalars['String']>;
  /** True if the user has been disabled */
  disabled?: Maybe<Scalars['Boolean']>;
  inviteToken?: Maybe<Scalars['String']>;
  inviteTokenTs?: Maybe<Scalars['Date']>;
  logisticsPartnerId?: Maybe<Scalars['MongoID']>;
  /** The name of the logistics partner */
  logisticsPartnerName?: Maybe<Scalars['String']>;
  /** The user that has this access */
  user?: Maybe<User>;
  userId?: Maybe<Scalars['MongoID']>;
};

export type ValidationError = ErrorInterface & {
  __typename?: 'ValidationError';
  /** List of validator errors */
  errors?: Maybe<Array<ValidatorError>>;
  /** Combined error message from all validators */
  message?: Maybe<Scalars['String']>;
};

export type ValidatorError = {
  __typename?: 'ValidatorError';
  /** Input record idx in array which occurs the validation error. This `idx` is useful for createMany operation. For singular operations it always be 0. For *Many operations `idx` represents record index in array received from user. */
  idx: Scalars['Int'];
  /** Validation error message */
  message?: Maybe<Scalars['String']>;
  /** Source of the validation error from the model path */
  path?: Maybe<Scalars['String']>;
  /** Field value which occurs the validation error */
  value?: Maybe<Scalars['JSON']>;
};

export type VerifyResult = {
  __typename?: 'VerifyResult';
  id?: Maybe<Scalars['Int']>;
  value?: Maybe<Scalars['String']>;
};

export type Voucher = {
  __typename?: 'Voucher';
  _id: Scalars['MongoID'];
  activated: Scalars['Boolean'];
  adjustments?: Maybe<Array<VoucherAdjustment>>;
  brandHouseId: Scalars['MongoID'];
  code?: Maybe<Scalars['String']>;
  /** An alias for the voucher, this alias is typically used when an external voucher service produces other codes than C2S */
  codeAlias?: Maybe<Scalars['String']>;
  consumer?: Maybe<Consumer>;
  consumerId: Scalars['MongoID'];
  createdAt?: Maybe<Scalars['Date']>;
  currency?: Maybe<Scalars['String']>;
  /** The current value of the voucher */
  currentValue?: Maybe<Scalars['Float']>;
  /** Custom data for the voucher */
  customData?: Maybe<Scalars['JSON']>;
  deleted?: Maybe<Scalars['Date']>;
  /** If there is a date, then this voucher is disabled since this date. It should not exist in external shop and should not be useable. It should still be monitored and updated. */
  disabled?: Maybe<Scalars['Date']>;
  expireDate?: Maybe<Scalars['Date']>;
  /** The expiration date of the voucher */
  expireDateFormat?: Maybe<Scalars['String']>;
  /** ID of the voucher in any external storefront. The existence of this ID indicates that the voucher has been created at the storefront */
  externId?: Maybe<Scalars['String']>;
  minimumPurchase?: Maybe<Scalars['Float']>;
  newVoucherUsage: Scalars['Boolean'];
  /** The value of the voucher, as it was last communicated to the customer */
  notificationValue?: Maybe<Scalars['Float']>;
  /** Whether this reward is handled completely by an external system. If true, then we will not try to calculate the remaining value of the voucher - and we expect the value to be updated by external integration */
  passive?: Maybe<Scalars['Boolean']>;
  /** The value to be paid out to the customer, after applying payout percentage or rules */
  payoutValue?: Maybe<Scalars['Float']>;
  shop?: Maybe<Shop>;
  shopId: Scalars['MongoID'];
  /** Voucher statistics */
  statistics?: Maybe<VoucherStatistics>;
  tradeIn?: Maybe<TradeIn>;
  tradeInId?: Maybe<Scalars['MongoID']>;
  /** Will be updated to reflect the registration timestamp from connected tradeins */
  tradeInReceivedTs?: Maybe<Scalars['Date']>;
  updatedAt?: Maybe<Scalars['Date']>;
  usages?: Maybe<Array<VoucherUsage>>;
  used?: Maybe<Scalars['Date']>;
  value?: Maybe<Scalars['Float']>;
  /** PDFs for the voucher */
  voucherPdf?: Maybe<Array<VoucherPdf>>;
  voucherStrategy?: Maybe<EnumVoucherVoucherStrategy>;
};


export type VoucherExpireDateFormatArgs = {
  format?: InputMaybe<Scalars['String']>;
};


export type VoucherStatisticsArgs = {
  currency?: InputMaybe<Scalars['String']>;
};

export type VoucherAdjustment = {
  __typename?: 'VoucherAdjustment';
  _id: Scalars['MongoID'];
  /** The adjustment amount in vouchers currency */
  amount: Scalars['Float'];
  /** Set by the creator: also apply this adjustment to the voucher's external gift card (passive vouchers only). Adjustments without it never change the gift card */
  applyToGiftCard?: Maybe<Scalars['Boolean']>;
  /** If this adjustment is a correction to the original voucher value */
  correction?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['Date']>;
  /** The adjustment date */
  date: Scalars['Date'];
  /** Where applying this adjustment to the gift card stands; only present when applyToGiftCard is set */
  giftCardSync?: Maybe<VoucherAdjustmentGiftCardSync>;
  /** Reason for adjustment */
  reason: Scalars['String'];
  /** The shop that owns the usage refund */
  shopId: Scalars['MongoID'];
  updatedAt?: Maybe<Scalars['Date']>;
  updatedBy?: Maybe<ObjectPatchesUpdatedBy>;
  /** The voucher */
  voucherId: Scalars['MongoID'];
};

export type VoucherAdjustmentGiftCardSync = {
  __typename?: 'VoucherAdjustmentGiftCardSync';
  /** The amount applied to the gift card in its own currency, signed like the adjustment (negative = debit) */
  amount?: Maybe<Scalars['Float']>;
  /** The currency of amount, i.e. the gift card's currency */
  currency?: Maybe<Scalars['String']>;
  /** Why the adjustment could not be applied to the gift card */
  error?: Maybe<Scalars['String']>;
  /** When the integration applied the adjustment or gave up */
  processedAt?: Maybe<Scalars['Date']>;
  /** PENDING until the integration has applied the adjustment to the gift card (APPLIED) or given up (FAILED) */
  status: EnumVoucherAdjustmentGiftCardSyncStatus;
  /** The external transaction that applied the adjustment, e.g. a Shopify gift card credit or debit transaction id */
  transactionId?: Maybe<Scalars['String']>;
};

/** The outcome of applying an adjustment to the voucher's external gift card */
export type VoucherAdjustmentGiftCardSyncInput = {
  /** The amount applied to the gift card in its own currency, signed like the adjustment (negative = debit) */
  amount?: InputMaybe<Scalars['Float']>;
  /** The gift card's currency */
  currency?: InputMaybe<Scalars['String']>;
  /** Required for FAILED: why the adjustment could not be applied */
  error?: InputMaybe<Scalars['String']>;
  /** When it was applied or given up; defaults to now */
  processedAt?: InputMaybe<Scalars['Date']>;
  /** APPLIED or FAILED */
  status: EnumVoucherAdjustmentGiftCardSyncStatus;
  /** Required for APPLIED: the external transaction that applied the adjustment */
  transactionId?: InputMaybe<Scalars['String']>;
};

/** Input data for voucher updates */
export type VoucherFrontPdfInput = {
  /** The language of the giftcard */
  language: Scalars['String'];
  /** The url to the giftcard - must be a pdf */
  url: Scalars['String'];
};

/** Input data for voucher updates */
export type VoucherFrontUpdateInput = {
  /** Alias for the voucher */
  alias?: InputMaybe<Scalars['String']>;
  /** The current value of the voucher, only provide this for passive vouchers */
  currentValue?: InputMaybe<Scalars['Float']>;
  /** The currency of the current value, only provide this for passive vouchers */
  currentValueCurrency?: InputMaybe<Scalars['String']>;
  /** Custom data stored with the voucher */
  customData?: InputMaybe<Scalars['JSON']>;
  /** Updates the external id on the voucher */
  externId: Scalars['String'];
  /** Whether this reward is handled completely by an external system. If true, then the platform will not try to calculate the remaining value of the reward - and we expect the value and state of the voucher to be updated by external integration */
  passive?: InputMaybe<Scalars['Boolean']>;
  /** If provided - the PDF at the URL will be downloaded and linked to the voucher */
  pdfUrl?: InputMaybe<Array<InputMaybe<VoucherFrontPdfInput>>>;
};

export type VoucherPdf = {
  __typename?: 'VoucherPdf';
  /** The language of the pdf */
  language?: Maybe<Scalars['String']>;
  /** If set, then this points to the storage file that contains the voucher as a PDF (english) */
  pdfId?: Maybe<Scalars['MongoID']>;
  /** URL to the voucher PDF */
  url?: Maybe<Scalars['String']>;
};

export type VoucherStatistics = {
  __typename?: 'VoucherStatistics';
  /** Whether the voucher is active or not */
  active?: Maybe<Scalars['Boolean']>;
  /** The currency for these statistics */
  currency?: Maybe<Scalars['String']>;
  /** The number of days before the voucher is first used */
  daysBeforeUsage?: Maybe<Scalars['Float']>;
  /** The total value of the reward */
  reward?: Maybe<Scalars['Float']>;
  /** The amount of money spent on order divided by the voucher value */
  smashFactor?: Maybe<Scalars['Float']>;
  /** The total amount of money spent using the voucher */
  spending?: Maybe<Scalars['Float']>;
  /** The date the voucher was first used */
  usageDate?: Maybe<Scalars['Date']>;
};

/** Represents a transaction for a voucher, including issuance, usage, refund, and adjustments */
export type VoucherTransaction = {
  __typename?: 'VoucherTransaction';
  _id: Scalars['MongoID'];
  amount: Scalars['Float'];
  balance: Scalars['Float'];
  brandHouseId: Scalars['MongoID'];
  consumerEmail: Scalars['String'];
  consumerId: Scalars['MongoID'];
  currency: Scalars['String'];
  date: Scalars['Date'];
  deleted: Scalars['Boolean'];
  externOrderId?: Maybe<Scalars['String']>;
  reason?: Maybe<Scalars['String']>;
  receivedTs?: Maybe<Scalars['Date']>;
  /** The shop associated with this transaction */
  shop?: Maybe<Shop>;
  shopId: Scalars['MongoID'];
  shopName: Scalars['String'];
  spending: Scalars['Float'];
  /** The tradein associated with this transaction */
  tradeIn?: Maybe<TradeIn>;
  tradeInId: Scalars['MongoID'];
  type?: Maybe<VoucherTransactionEnumType>;
  /** URL to the external ressource for this transaction */
  url?: Maybe<Scalars['String']>;
  /** The user associated with this transaction */
  user?: Maybe<User>;
  /** The voucher associated with this transaction */
  voucher?: Maybe<Voucher>;
  voucherCode: Scalars['String'];
  voucherId: Scalars['MongoID'];
};

/** Types of voucher transactions */
export enum VoucherTransactionEnumType {
  ADJUST = 'ADJUST',
  ISSUED = 'ISSUED',
  REFUND = 'REFUND',
  USAGE = 'USAGE'
}

export type VoucherUsage = {
  __typename?: 'VoucherUsage';
  _id: Scalars['MongoID'];
  /** The date of the usage cancellation, if cancelled - this usage will be ignored when calculating voucher balance */
  cancelDate?: Maybe<Scalars['Date']>;
  createdAt?: Maybe<Scalars['Date']>;
  /** The external ID of the order that triggered a voucher action. There can be multiple actions for the same order. */
  externOrderId: Scalars['String'];
  /** URL to the external order ressource for this usage */
  externUrl?: Maybe<Scalars['String']>;
  /** The external order */
  externalOrder?: Maybe<ExternOrder2>;
  items?: Maybe<Array<Maybe<VoucherUsageItems>>>;
  /** Refunds for this voucher usage */
  refunds?: Maybe<Array<Maybe<VoucherUsageRefund>>>;
  /** Shipping cost */
  shippingAmount: Scalars['Float'];
  shopId: Scalars['MongoID'];
  updatedAt?: Maybe<Scalars['Date']>;
  /** The date of usage */
  usageDate: Scalars['Date'];
  /** Voucher for this voucher usage */
  voucher?: Maybe<Voucher>;
  voucherId: Scalars['MongoID'];
};

export type VoucherUsageInput = {
  /** The date of the usage cancellation, if cancelled - this usage will be ignored when calculating voucher balance */
  cancelDate?: InputMaybe<Scalars['Date']>;
  /** The voucher code */
  code: Scalars['String'];
  /** The external ID of the order that triggered a voucher action. There can be multiple actions for the same order. */
  externOrderId: Scalars['String'];
  items?: InputMaybe<Array<InputMaybe<VoucherUsageItemsInput>>>;
  refunds?: InputMaybe<Array<InputMaybe<VoucherUsageRefundInput>>>;
  /** Shipping cost */
  shippingAmount: Scalars['Float'];
  /** The date of usage */
  usageDate: Scalars['Date'];
};

export type VoucherUsageItems = {
  __typename?: 'VoucherUsageItems';
  /** The discounted price for item(s) in shop currency */
  discountedPrice: Scalars['Float'];
  /** The discounted price before tax for item(s) in shop currency */
  discountedPricePreTax: Scalars['Float'];
  /** The external ID of the lineitem */
  externLineItemId: Scalars['String'];
  /** The original price for item(s) in shop currency */
  price: Scalars['Float'];
  /** The number of items bought */
  quantity: Scalars['Float'];
};

export type VoucherUsageItemsInput = {
  /** The discounted price for item(s) in shop currency */
  discountedPrice: Scalars['Float'];
  /** The discounted price before tax for item(s) in shop currency */
  discountedPricePreTax: Scalars['Float'];
  /** The external ID of the lineitem */
  externLineItemId: Scalars['String'];
  /** The original price for item(s) in shop currency */
  price: Scalars['Float'];
  /** The number of items bought */
  quantity: Scalars['Float'];
};

export type VoucherUsageRefund = {
  __typename?: 'VoucherUsageRefund';
  _id: Scalars['MongoID'];
  /** The refund amount */
  amount: Scalars['Float'];
  createdAt?: Maybe<Scalars['Date']>;
  /** Refund ID */
  externRefundId: Scalars['String'];
  /** Whether the refund has been processed by the platform */
  processed: Scalars['Boolean'];
  /** The date of the refund */
  refundDate: Scalars['Date'];
  refundItems?: Maybe<Array<Maybe<VoucherUsageRefundRefundItems>>>;
  /** The type of refund */
  refundType: EnumVoucherUsageRefundRefundType;
  /** The shop that owns the usage refund */
  shopId: Scalars['MongoID'];
  updatedAt?: Maybe<Scalars['Date']>;
  /** Voucher Usage refund */
  voucherUsage?: Maybe<VoucherUsage>;
  /** The voucher usage that this refund is related to */
  voucherUsageId: Scalars['MongoID'];
};

export type VoucherUsageRefundInput = {
  /** The refund amount */
  amount: Scalars['Float'];
  /** Refund ID */
  externRefundId: Scalars['String'];
  /** The date of the refund */
  refundDate: Scalars['Date'];
  refundItems?: InputMaybe<Array<InputMaybe<VoucherUsageRefundRefundItemsInput>>>;
  /** The type of refund */
  refundType: EnumVoucherUsageRefundRefundType;
};

export type VoucherUsageRefundRefundItems = {
  __typename?: 'VoucherUsageRefundRefundItems';
  /** Line item ID */
  externLineItemId: Scalars['String'];
  /** Number of items refunded */
  quantity: Scalars['Float'];
};

export type VoucherUsageRefundRefundItemsInput = {
  /** Line item ID */
  externLineItemId: Scalars['String'];
  /** Number of items refunded */
  quantity: Scalars['Float'];
};

/** List of items with pagination. */
export type VoucherVoucherPagination = {
  __typename?: 'VoucherVoucherPagination';
  /** Total object count. */
  count?: Maybe<Scalars['Int']>;
  /** Array of objects. */
  items?: Maybe<Array<Voucher>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type WarehouseLocation = {
  __typename?: 'WarehouseLocation';
  _id?: Maybe<Scalars['String']>;
  /** Whether all items in this location has been checked */
  checked: Scalars['Boolean'];
  count: Scalars['Float'];
  items?: Maybe<Array<Maybe<StockItem>>>;
};

export type WholeSaleCategory = {
  __typename?: 'WholeSaleCategory';
  _id: Scalars['MongoID'];
  advanced?: Maybe<Scalars['Boolean']>;
  /** Soft-delete flag. When true, the category is hidden from listings but retained so historical TradeInItems can still resolve it. */
  deleted?: Maybe<Scalars['Boolean']>;
  iconId?: Maybe<Scalars['MongoID']>;
  /** Gets the name of the category, if no locale is provided then the default name is returned */
  name: Scalars['String'];
  nameLocalized?: Maybe<Array<Maybe<LocalizationEntry>>>;
  rules?: Maybe<Array<Maybe<WholeSaleCategoryRules>>>;
  section?: Maybe<Scalars['String']>;
  sectionLocalized?: Maybe<Array<Maybe<LocalizationEntry>>>;
  shopId: Scalars['MongoID'];
  /** The other of this category */
  sortOrder?: Maybe<Scalars['Float']>;
  updatedBy?: Maybe<ObjectPatchesUpdatedBy>;
  value: Scalars['Float'];
  voucherStrategy?: Maybe<EnumWholeSaleCategoryVoucherStrategy>;
};


export type WholeSaleCategoryNameArgs = {
  locale?: InputMaybe<Scalars['String']>;
};

export type WholeSaleCategoryRules = {
  __typename?: 'WholeSaleCategoryRules';
  _id?: Maybe<Scalars['MongoID']>;
  active?: Maybe<Scalars['Boolean']>;
  expressions?: Maybe<Array<Maybe<WholeSaleCategoryRulesExpressions>>>;
  name?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['Float']>;
};

export type WholeSaleCategoryRulesExpressions = {
  __typename?: 'WholeSaleCategoryRulesExpressions';
  _id?: Maybe<Scalars['MongoID']>;
  /** Product collection in external shop, see valid collections on Shop.productCollections */
  col?: Maybe<Scalars['String']>;
  expressionType: EnumWholeSaleCategoryRulesExpressionsExpressionType;
  operator: EnumWholeSaleCategoryRulesExpressionsOperator;
  sku?: Maybe<Scalars['String']>;
  /** Product tag, see valid tags on Shop.productTags */
  tag?: Maybe<Scalars['String']>;
};

export type WholeSaleCategoryRulesExpressionsInput = {
  _id?: InputMaybe<Scalars['MongoID']>;
  /** Product collection in external shop, see valid collections on Shop.productCollections */
  col?: InputMaybe<Scalars['String']>;
  expressionType: EnumWholeSaleCategoryRulesExpressionsExpressionType;
  operator: EnumWholeSaleCategoryRulesExpressionsOperator;
  sku?: InputMaybe<Scalars['String']>;
  /** Product tag, see valid tags on Shop.productTags */
  tag?: InputMaybe<Scalars['String']>;
};

export type WholeSaleCategoryRulesInput = {
  _id?: InputMaybe<Scalars['MongoID']>;
  active?: InputMaybe<Scalars['Boolean']>;
  expressions?: InputMaybe<Array<InputMaybe<WholeSaleCategoryRulesExpressionsInput>>>;
  name?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type WholeSaleConfigType = {
  __typename?: 'WholeSaleConfigType';
  active: Scalars['Boolean'];
  currency: Scalars['String'];
};

export type WholeSaleProduct = {
  __typename?: 'WholeSaleProduct';
  _id: Scalars['String'];
  description: Scalars['String'];
  name: Scalars['String'];
  ruleId: Scalars['String'];
  score: Scalars['Float'];
  style?: Maybe<Scalars['String']>;
  variants?: Maybe<Array<Maybe<WholeSaleVariant>>>;
};

export type WholeSaleStatistics = {
  __typename?: 'WholeSaleStatistics';
  count?: Maybe<Scalars['Float']>;
  sample?: Maybe<Array<Maybe<WholeSaleProduct>>>;
};

export type WholeSaleVariant = {
  __typename?: 'WholeSaleVariant';
  _id: Scalars['String'];
  color?: Maybe<Scalars['String']>;
  credit?: Maybe<WholeSaleVariantCredit>;
  ean?: Maybe<Scalars['String']>;
  /** Images for this product variant */
  images?: Maybe<Array<Maybe<Scalars['String']>>>;
  score: Scalars['Float'];
  size?: Maybe<Scalars['String']>;
  sku?: Maybe<Scalars['String']>;
};

export type WholeSaleVariantCredit = {
  __typename?: 'WholeSaleVariantCredit';
  currency: Scalars['String'];
  value: Scalars['Float'];
};

export type UserLoginMutationVariables = Exact<{
  email: Scalars['String'];
  password: Scalars['String'];
}>;


export type UserLoginMutation = { __typename?: 'Mutation', UserLogin?: { __typename?: 'LoginResult', token: string, userType: string, simplified: boolean } | null };

export type SystemMessagesForNotificationQueryVariables = Exact<{
  filter?: InputMaybe<FilterFindManySystemMessageInput>;
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type SystemMessagesForNotificationQuery = { __typename?: 'Query', SystemMessages: Array<{ __typename?: 'SystemMessage', _id: any, subject: string, audience: EnumSystemMessageAudience, audienceBrandId?: any | null, acknowledgedTs?: Date | null, messageType: EnumSystemMessageMessageType, timestamp: Date, lastActivityTs: Date, entries: Array<{ __typename?: 'SystemMessageEntries', timestamp: Date, text: string } | null> }> };

export type SystemMessageNotificationAcknowledgeMutationVariables = Exact<{
  filter: FilterUpdateOneSystemMessageInput;
  record: UpdateOneSystemMessageInput;
}>;


export type SystemMessageNotificationAcknowledgeMutation = { __typename?: 'Mutation', SystemMessageAcknowledge?: { __typename?: 'UpdateOneSystemMessagePayload', record?: { __typename?: 'SystemMessage', _id: any, acknowledgedTs?: Date | null } | null } | null };

export type DataViewColumnsQueryVariables = Exact<{
  viewId: Scalars['MongoID'];
}>;


export type DataViewColumnsQuery = { __typename?: 'Query', DataView?: { __typename?: 'DataView', _id: any, type: DataViewTypeEnum, expiresAt: Date, viewName?: string | null, rowIds: Array<any | null>, metadata?: any | null } | null };

export type NavigationDataQueryVariables = Exact<{ [key: string]: never; }>;


export type NavigationDataQuery = { __typename?: 'Query', CurrentUser?: { __typename?: 'User', _id: any, administrator?: boolean | null } | null, BrandHouses: Array<{ __typename?: 'BrandHouse', _id: any, name?: string | null, deactivated?: boolean | null, requireChangeExplanation?: boolean | null, shops?: Array<{ __typename?: 'Shop', _id: any, name?: string | null, disabled?: boolean | null, live?: boolean | null } | null> | null, settings?: { __typename?: 'BrandSetting', useBrandItems?: boolean | null } | null }>, LogisticsPartners: Array<{ __typename?: 'LogisticsPartner', _id: any, name?: string | null }> };

export type ResetPasswordSendMutationVariables = Exact<{
  email: Scalars['String'];
}>;


export type ResetPasswordSendMutation = { __typename?: 'Mutation', UserRecoverPassword?: boolean | null };

export type InviteJoinVerifyTokenQueryVariables = Exact<{
  token: Scalars['String'];
}>;


export type InviteJoinVerifyTokenQuery = { __typename?: 'Query', UserVerifyResetToken?: string | null };

export type InviteJoinVerifyPasswordQueryVariables = Exact<{
  password: Scalars['String'];
}>;


export type InviteJoinVerifyPasswordQuery = { __typename?: 'Query', UserVerifyPassword?: { __typename?: 'VerifyResult', id?: number | null, value?: string | null } | null };

export type InviteJoinUpdateMutationVariables = Exact<{
  token: Scalars['String'];
  name: Scalars['String'];
  password: Scalars['String'];
}>;


export type InviteJoinUpdateMutation = { __typename?: 'Mutation', UserInviteJoin?: { __typename?: 'LoginResult', token: string, userType: string } | null };

export type ResetPasswordVerifyTokenQueryVariables = Exact<{
  token: Scalars['String'];
}>;


export type ResetPasswordVerifyTokenQuery = { __typename?: 'Query', UserVerifyResetToken?: string | null };

export type ResetPasswordVerifyPasswordQueryVariables = Exact<{
  password: Scalars['String'];
}>;


export type ResetPasswordVerifyPasswordQuery = { __typename?: 'Query', UserVerifyPassword?: { __typename?: 'VerifyResult', id?: number | null, value?: string | null } | null };

export type ResetPasswordUpdateMutationVariables = Exact<{
  token: Scalars['String'];
  password: Scalars['String'];
}>;


export type ResetPasswordUpdateMutation = { __typename?: 'Mutation', UserResetPassword?: boolean | null };

export type InviteAcceptPageCurrentUserQueryVariables = Exact<{ [key: string]: never; }>;


export type InviteAcceptPageCurrentUserQuery = { __typename?: 'Query', CurrentUser?: { __typename?: 'User', _id: any, name?: string | null, access?: Array<{ __typename?: 'UserAccess', inviteTokenTs?: Date | null, inviteToken?: string | null, brandHouseName?: string | null, logisticsPartnerName?: string | null, disabled?: boolean | null } | null> | null } | null };

export type InviteAcceptInviteMutationVariables = Exact<{
  token: Scalars['String'];
}>;


export type InviteAcceptInviteMutation = { __typename?: 'Mutation', UserInviteAccept?: { __typename?: 'UserAccess', _id: any } | null };

export type ConnectorEditPageQueryVariables = Exact<{
  connectorId: Scalars['MongoID'];
}>;


export type ConnectorEditPageQuery = { __typename?: 'Query', IntegrationConnector?: { __typename?: 'IntegrationConnector', _id: any, name: string, refTypes?: Array<EnumIntegrationConnectorRefTypes | null> | null, deleted?: boolean | null, activeFor?: Array<any | null> | null, autoInstallFor?: Array<EnumIntegrationConnectorAutoInstallFor | null> | null, type: EnumIntegrationConnectorType, dispatcher?: EnumIntegrationConnectorDispatcher | null, messages?: Array<EnumIntegrationConnectorMessages | null> | null, optionals?: Array<EnumIntegrationConnectorOptionals | null> | null, eventbus?: { __typename?: 'IntegrationConnectorEventbus', development?: { __typename?: 'IntegrationConnectorEventbusProduction', serviceBus: string, topic: string } | null, production?: { __typename?: 'IntegrationConnectorEventbusProduction', topic: string, serviceBus: string } | null, test?: { __typename?: 'IntegrationConnectorEventbusProduction', serviceBus: string, topic: string } | null } | null, webhook?: { __typename?: 'IntegrationConnectorWebhook', development?: { __typename?: 'IntegrationConnectorWebhookProduction', headers?: any | null, url: string } | null, production?: { __typename?: 'IntegrationConnectorWebhookProduction', headers?: any | null, url: string } | null, test?: { __typename?: 'IntegrationConnectorWebhookProduction', headers?: any | null, url: string } | null } | null, cloudTasks?: { __typename?: 'IntegrationConnectorCloudTasks', development?: { __typename?: 'IntegrationConnectorCloudTasksProduction', queue: string, targetUrl: string, audience?: string | null } | null, production?: { __typename?: 'IntegrationConnectorCloudTasksProduction', queue: string, targetUrl: string, audience?: string | null } | null, test?: { __typename?: 'IntegrationConnectorCloudTasksProduction', queue: string, targetUrl: string, audience?: string | null } | null } | null, fields?: Array<{ __typename?: 'IntegrationConnectorFields', namespace: string, field: string, description: string, type: string, required?: boolean | null, defaultValue?: string | null, options?: Array<{ __typename?: 'IntegrationConnectorFieldsOptions', label: string, value: any } | null> | null } | null> | null } | null };

export type IntegrationFragment = { __typename?: 'IntegrationConnector', _id: any, name: string, refTypes?: Array<EnumIntegrationConnectorRefTypes | null> | null, deleted?: boolean | null, activeFor?: Array<any | null> | null, autoInstallFor?: Array<EnumIntegrationConnectorAutoInstallFor | null> | null, type: EnumIntegrationConnectorType, dispatcher?: EnumIntegrationConnectorDispatcher | null, messages?: Array<EnumIntegrationConnectorMessages | null> | null, optionals?: Array<EnumIntegrationConnectorOptionals | null> | null, eventbus?: { __typename?: 'IntegrationConnectorEventbus', development?: { __typename?: 'IntegrationConnectorEventbusProduction', serviceBus: string, topic: string } | null, production?: { __typename?: 'IntegrationConnectorEventbusProduction', topic: string, serviceBus: string } | null, test?: { __typename?: 'IntegrationConnectorEventbusProduction', serviceBus: string, topic: string } | null } | null, webhook?: { __typename?: 'IntegrationConnectorWebhook', development?: { __typename?: 'IntegrationConnectorWebhookProduction', headers?: any | null, url: string } | null, production?: { __typename?: 'IntegrationConnectorWebhookProduction', headers?: any | null, url: string } | null, test?: { __typename?: 'IntegrationConnectorWebhookProduction', headers?: any | null, url: string } | null } | null, cloudTasks?: { __typename?: 'IntegrationConnectorCloudTasks', development?: { __typename?: 'IntegrationConnectorCloudTasksProduction', queue: string, targetUrl: string, audience?: string | null } | null, production?: { __typename?: 'IntegrationConnectorCloudTasksProduction', queue: string, targetUrl: string, audience?: string | null } | null, test?: { __typename?: 'IntegrationConnectorCloudTasksProduction', queue: string, targetUrl: string, audience?: string | null } | null } | null, fields?: Array<{ __typename?: 'IntegrationConnectorFields', namespace: string, field: string, description: string, type: string, required?: boolean | null, defaultValue?: string | null, options?: Array<{ __typename?: 'IntegrationConnectorFieldsOptions', label: string, value: any } | null> | null } | null> | null };

export type ConnectorEditPageUpdateMutationVariables = Exact<{
  connectorId: Scalars['MongoID'];
  input: UpdateByIdIntegrationConnectorInput;
}>;


export type ConnectorEditPageUpdateMutation = { __typename?: 'Mutation', IntegrationConnectorUpdate?: { __typename?: 'UpdateByIdIntegrationConnectorPayload', recordId?: any | null, record?: { __typename?: 'IntegrationConnector', _id: any, name: string, refTypes?: Array<EnumIntegrationConnectorRefTypes | null> | null, deleted?: boolean | null, activeFor?: Array<any | null> | null, autoInstallFor?: Array<EnumIntegrationConnectorAutoInstallFor | null> | null, type: EnumIntegrationConnectorType, dispatcher?: EnumIntegrationConnectorDispatcher | null, messages?: Array<EnumIntegrationConnectorMessages | null> | null, optionals?: Array<EnumIntegrationConnectorOptionals | null> | null, eventbus?: { __typename?: 'IntegrationConnectorEventbus', development?: { __typename?: 'IntegrationConnectorEventbusProduction', serviceBus: string, topic: string } | null, production?: { __typename?: 'IntegrationConnectorEventbusProduction', topic: string, serviceBus: string } | null, test?: { __typename?: 'IntegrationConnectorEventbusProduction', serviceBus: string, topic: string } | null } | null, webhook?: { __typename?: 'IntegrationConnectorWebhook', development?: { __typename?: 'IntegrationConnectorWebhookProduction', headers?: any | null, url: string } | null, production?: { __typename?: 'IntegrationConnectorWebhookProduction', headers?: any | null, url: string } | null, test?: { __typename?: 'IntegrationConnectorWebhookProduction', headers?: any | null, url: string } | null } | null, cloudTasks?: { __typename?: 'IntegrationConnectorCloudTasks', development?: { __typename?: 'IntegrationConnectorCloudTasksProduction', queue: string, targetUrl: string, audience?: string | null } | null, production?: { __typename?: 'IntegrationConnectorCloudTasksProduction', queue: string, targetUrl: string, audience?: string | null } | null, test?: { __typename?: 'IntegrationConnectorCloudTasksProduction', queue: string, targetUrl: string, audience?: string | null } | null } | null, fields?: Array<{ __typename?: 'IntegrationConnectorFields', namespace: string, field: string, description: string, type: string, required?: boolean | null, defaultValue?: string | null, options?: Array<{ __typename?: 'IntegrationConnectorFieldsOptions', label: string, value: any } | null> | null } | null> | null } | null, error?: { __typename?: 'MongoError', message?: string | null } | { __typename?: 'RuntimeError', message?: string | null } | { __typename?: 'ValidationError', message?: string | null } | null } | null };

export type ConnectorEditPageCreateMutationVariables = Exact<{
  input: CreateOneIntegrationConnectorInput;
}>;


export type ConnectorEditPageCreateMutation = { __typename?: 'Mutation', IntegrationConnectorCreate?: { __typename?: 'CreateOneIntegrationConnectorPayload', recordId?: any | null, record?: { __typename?: 'IntegrationConnector', _id: any, name: string, refTypes?: Array<EnumIntegrationConnectorRefTypes | null> | null, deleted?: boolean | null, activeFor?: Array<any | null> | null, autoInstallFor?: Array<EnumIntegrationConnectorAutoInstallFor | null> | null, type: EnumIntegrationConnectorType, dispatcher?: EnumIntegrationConnectorDispatcher | null, messages?: Array<EnumIntegrationConnectorMessages | null> | null, optionals?: Array<EnumIntegrationConnectorOptionals | null> | null, eventbus?: { __typename?: 'IntegrationConnectorEventbus', development?: { __typename?: 'IntegrationConnectorEventbusProduction', serviceBus: string, topic: string } | null, production?: { __typename?: 'IntegrationConnectorEventbusProduction', topic: string, serviceBus: string } | null, test?: { __typename?: 'IntegrationConnectorEventbusProduction', serviceBus: string, topic: string } | null } | null, webhook?: { __typename?: 'IntegrationConnectorWebhook', development?: { __typename?: 'IntegrationConnectorWebhookProduction', headers?: any | null, url: string } | null, production?: { __typename?: 'IntegrationConnectorWebhookProduction', headers?: any | null, url: string } | null, test?: { __typename?: 'IntegrationConnectorWebhookProduction', headers?: any | null, url: string } | null } | null, cloudTasks?: { __typename?: 'IntegrationConnectorCloudTasks', development?: { __typename?: 'IntegrationConnectorCloudTasksProduction', queue: string, targetUrl: string, audience?: string | null } | null, production?: { __typename?: 'IntegrationConnectorCloudTasksProduction', queue: string, targetUrl: string, audience?: string | null } | null, test?: { __typename?: 'IntegrationConnectorCloudTasksProduction', queue: string, targetUrl: string, audience?: string | null } | null } | null, fields?: Array<{ __typename?: 'IntegrationConnectorFields', namespace: string, field: string, description: string, type: string, required?: boolean | null, defaultValue?: string | null, options?: Array<{ __typename?: 'IntegrationConnectorFieldsOptions', label: string, value: any } | null> | null } | null> | null } | null, error?: { __typename?: 'MongoError', message?: string | null } | { __typename?: 'RuntimeError', message?: string | null } | { __typename?: 'ValidationError', message?: string | null } | null } | null };

export type ConnectorsPageListQueryVariables = Exact<{
  limit: Scalars['Int'];
  skip: Scalars['Int'];
}>;


export type ConnectorsPageListQuery = { __typename?: 'Query', IntegrationConnectorsCount?: number | null, IntegrationConnectors: Array<{ __typename?: 'IntegrationConnector', _id: any, name: string, refTypes?: Array<EnumIntegrationConnectorRefTypes | null> | null, deleted?: boolean | null, activeFor?: Array<any | null> | null, autoInstallFor?: Array<EnumIntegrationConnectorAutoInstallFor | null> | null, messages?: Array<EnumIntegrationConnectorMessages | null> | null, optionals?: Array<EnumIntegrationConnectorOptionals | null> | null, instances?: Array<{ __typename?: 'IntegrationInstance', refName?: string | null } | null> | null, eventbus?: { __typename?: 'IntegrationConnectorEventbus', development?: { __typename?: 'IntegrationConnectorEventbusProduction', serviceBus: string, topic: string } | null, production?: { __typename?: 'IntegrationConnectorEventbusProduction', topic: string, serviceBus: string } | null, test?: { __typename?: 'IntegrationConnectorEventbusProduction', serviceBus: string, topic: string } | null } | null, fields?: Array<{ __typename?: 'IntegrationConnectorFields', namespace: string, field: string, description: string, type: string, defaultValue?: string | null, required?: boolean | null, options?: Array<{ __typename?: 'IntegrationConnectorFieldsOptions', label: string } | null> | null } | null> | null, webhook?: { __typename?: 'IntegrationConnectorWebhook', test?: { __typename?: 'IntegrationConnectorWebhookProduction', url: string } | null, production?: { __typename?: 'IntegrationConnectorWebhookProduction', url: string } | null, development?: { __typename?: 'IntegrationConnectorWebhookProduction', url: string } | null } | null }> };

export type InstallsPageGetQueryVariables = Exact<{
  connectorId: Scalars['MongoID'];
}>;


export type InstallsPageGetQuery = { __typename?: 'Query', IntegrationInstances: Array<{ __typename?: 'IntegrationInstance', _id: any, refId: any, refType: EnumIntegrationInstanceRefType, enabled: boolean, refShop?: { __typename?: 'Shop', _id: any, name?: string | null, brandHouseId: any } | null, refBrandHouse?: { __typename?: 'BrandHouse', _id: any, name?: string | null } | null, refLogisticsPartner?: { __typename?: 'LogisticsPartner', _id: any, name?: string | null } | null, configs?: Array<{ __typename?: 'IntegrationConfig', message: EnumIntegrationConfigMessage, enabled: boolean } | null> | null, connector?: { __typename?: 'IntegrationConnector', messages?: Array<EnumIntegrationConnectorMessages | null> | null } | null }> };

export type InstallsPageReInitMutationVariables = Exact<{
  instanceId: Scalars['MongoID'];
}>;


export type InstallsPageReInitMutation = { __typename?: 'Mutation', IntegrationReInitialize?: { __typename?: 'IntegrationInstance', _id: any } | null };

export type MessageDetailPageGetQueryVariables = Exact<{
  messageId: Scalars['MongoID'];
}>;


export type MessageDetailPageGetQuery = { __typename?: 'Query', IntegrationMessageById?: { __typename?: 'IntegrationMessage', _id: any, parentId?: any | null, messageFailed?: boolean | null, messageIgnored?: boolean | null, payload?: any | null, result?: any | null, created: Date, sent?: Date | null, sendAt?: Date | null, sentCount: number, acknowledged?: Date | null, resultTs?: Date | null, failed?: Date | null, replySequence?: number | null, env?: string | null, lockedId?: string | null, refId: any, refType: string, instanceId: any, message: EnumIntegrationMessageMessage, refShop?: { __typename?: 'Shop', _id: any, name?: string | null } | null, refBrandHouse?: { __typename?: 'BrandHouse', _id: any, name?: string | null } | null, refLogisticsPartner?: { __typename?: 'LogisticsPartner', _id: any, name?: string | null } | null, instance?: { __typename?: 'IntegrationInstance', _id: any, name: string, mode: EnumIntegrationInstanceMode, enabled: boolean, deleted?: boolean | null, refName?: string | null, refType: EnumIntegrationInstanceRefType, connectorId: any, connector?: { __typename?: 'IntegrationConnector', _id: any, name: string, type: EnumIntegrationConnectorType, dispatcher?: EnumIntegrationConnectorDispatcher | null } | null } | null } | null };

export type IntegrationMessageFragment = { __typename?: 'IntegrationMessage', _id: any, parentId?: any | null, messageFailed?: boolean | null, messageIgnored?: boolean | null, payload?: any | null, result?: any | null, created: Date, sent?: Date | null, sendAt?: Date | null, sentCount: number, acknowledged?: Date | null, resultTs?: Date | null, failed?: Date | null, replySequence?: number | null, env?: string | null, lockedId?: string | null, refId: any, refType: string, instanceId: any, message: EnumIntegrationMessageMessage, refShop?: { __typename?: 'Shop', _id: any, name?: string | null } | null, refBrandHouse?: { __typename?: 'BrandHouse', _id: any, name?: string | null } | null, refLogisticsPartner?: { __typename?: 'LogisticsPartner', _id: any, name?: string | null } | null, instance?: { __typename?: 'IntegrationInstance', _id: any, name: string, mode: EnumIntegrationInstanceMode, enabled: boolean, deleted?: boolean | null, refName?: string | null, refType: EnumIntegrationInstanceRefType, connectorId: any, connector?: { __typename?: 'IntegrationConnector', _id: any, name: string, type: EnumIntegrationConnectorType, dispatcher?: EnumIntegrationConnectorDispatcher | null } | null } | null };

export type IntegrationMessageChainFragment = { __typename?: 'IntegrationMessage', _id: any, parentId?: any | null, message: EnumIntegrationMessageMessage, created: Date, sendAt?: Date | null, sent?: Date | null, resultTs?: Date | null, failed?: Date | null, messageFailed?: boolean | null, messageIgnored?: boolean | null, sentCount: number };

export type MessageChainNodeQueryVariables = Exact<{
  messageId: Scalars['MongoID'];
}>;


export type MessageChainNodeQuery = { __typename?: 'Query', IntegrationMessageById?: { __typename?: 'IntegrationMessage', _id: any, parentId?: any | null, message: EnumIntegrationMessageMessage, created: Date, sendAt?: Date | null, sent?: Date | null, resultTs?: Date | null, failed?: Date | null, messageFailed?: boolean | null, messageIgnored?: boolean | null, sentCount: number } | null };

export type MessageChainChildrenQueryVariables = Exact<{
  parentId: Scalars['MongoID'];
}>;


export type MessageChainChildrenQuery = { __typename?: 'Query', IntegrationMessages?: { __typename?: 'IntegrationMessageIntegrationMessagePagination', items?: Array<{ __typename?: 'IntegrationMessage', _id: any, parentId?: any | null, message: EnumIntegrationMessageMessage, created: Date, sendAt?: Date | null, sent?: Date | null, resultTs?: Date | null, failed?: Date | null, messageFailed?: boolean | null, messageIgnored?: boolean | null, sentCount: number }> | null } | null };

export type RerunMessageMutationVariables = Exact<{
  messageId: Scalars['MongoID'];
}>;


export type RerunMessageMutation = { __typename?: 'Mutation', IntegrationMessageRerun: { __typename?: 'IntegrationMessage', _id: any, parentId?: any | null, message: EnumIntegrationMessageMessage, instanceId: any, created: Date } };

export type IntegrationConnectorsQueryVariables = Exact<{ [key: string]: never; }>;


export type IntegrationConnectorsQuery = { __typename?: 'Query', IntegrationInstances: Array<{ __typename?: 'IntegrationInstance', _id: any, refName?: string | null, connector?: { __typename?: 'IntegrationConnector', name: string } | null }> };

export type IntegrationMessagesManyQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<FilterFindManyIntegrationMessageInput>;
  sort?: InputMaybe<SortFindManyIntegrationMessageInput>;
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
}>;


export type IntegrationMessagesManyQuery = { __typename?: 'Query', IntegrationMessages?: { __typename?: 'IntegrationMessageIntegrationMessagePagination', count?: number | null, items?: Array<{ __typename?: 'IntegrationMessage', _id: any, refId: any, refType: string, created: Date, message: EnumIntegrationMessageMessage, resultTs?: Date | null, result?: any | null, acknowledged?: Date | null, messageFailed?: boolean | null, messageIgnored?: boolean | null, sent?: Date | null, sendAt?: Date | null, failed?: Date | null, instanceId: any, instance?: { __typename?: 'IntegrationInstance', name: string } | null, refShop?: { __typename?: 'Shop', name?: string | null } | null, refBrandHouse?: { __typename?: 'BrandHouse', name?: string | null } | null, refLogisticsPartner?: { __typename?: 'LogisticsPartner', name?: string | null } | null }> | null } | null };

export type IntegrationListFragment = { __typename?: 'IntegrationMessage', _id: any, refId: any, refType: string, created: Date, message: EnumIntegrationMessageMessage, resultTs?: Date | null, result?: any | null, acknowledged?: Date | null, messageFailed?: boolean | null, messageIgnored?: boolean | null, sent?: Date | null, sendAt?: Date | null, failed?: Date | null, instanceId: any, instance?: { __typename?: 'IntegrationInstance', name: string } | null, refShop?: { __typename?: 'Shop', name?: string | null } | null, refBrandHouse?: { __typename?: 'BrandHouse', name?: string | null } | null, refLogisticsPartner?: { __typename?: 'LogisticsPartner', name?: string | null } | null };

export type MessagesPageInstanceQueryVariables = Exact<{
  instanceId: Scalars['MongoID'];
}>;


export type MessagesPageInstanceQuery = { __typename?: 'Query', IntegrationInstance?: { __typename?: 'IntegrationInstance', _id: any, name: string } | null };

export type SystemMessagesQueryVariables = Exact<{
  filter?: InputMaybe<FilterFindManySystemMessageInput>;
  sort?: InputMaybe<SortFindManySystemMessageInput>;
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type SystemMessagesQuery = { __typename?: 'Query', SystemMessages: Array<{ __typename?: 'SystemMessage', _id: any, subject: string, messageType: EnumSystemMessageMessageType, audience: EnumSystemMessageAudience, audienceBrandId?: any | null, timestamp: Date, lastActivityTs: Date, acknowledgedTs?: Date | null, entries: Array<{ __typename?: 'SystemMessageEntries', timestamp: Date, text: string } | null> }> };

export type SystemMessageAcknowledgeMutationVariables = Exact<{
  filter: FilterUpdateOneSystemMessageInput;
  record: UpdateOneSystemMessageInput;
}>;


export type SystemMessageAcknowledgeMutation = { __typename?: 'Mutation', SystemMessageAcknowledge?: { __typename?: 'UpdateOneSystemMessagePayload', record?: { __typename?: 'SystemMessage', _id: any, subject: string, messageType: EnumSystemMessageMessageType, audience: EnumSystemMessageAudience, audienceBrandId?: any | null, timestamp: Date, lastActivityTs: Date, acknowledgedTs?: Date | null, entries: Array<{ __typename?: 'SystemMessageEntries', timestamp: Date, text: string } | null> } | null } | null };

export type AuditChangesQueryVariables = Exact<{ [key: string]: never; }>;


export type AuditChangesQuery = { __typename?: 'Query', PatchPagination?: { __typename?: 'ObjectPatchesPatchItem', count?: number | null, items?: Array<{ __typename?: 'ObjectPatches', _id: any, type: string, shopId?: any | null, brandHouseId?: any | null, date: Date, updatedBy?: { __typename?: 'ObjectPatchesUpdatedBy', type: string, ref?: any | null } | null, ops?: Array<{ __typename?: 'ObjectPatchesOps', value?: any | null, op?: string | null, path?: string | null } | null> | null }> | null, pageInfo: { __typename?: 'PaginationInfo', hasNextPage?: boolean | null } } | null };

export type ObjectPatchFragment = { __typename?: 'ObjectPatches', _id: any, type: string, shopId?: any | null, brandHouseId?: any | null, date: Date, updatedBy?: { __typename?: 'ObjectPatchesUpdatedBy', type: string, ref?: any | null } | null, ops?: Array<{ __typename?: 'ObjectPatchesOps', value?: any | null, op?: string | null, path?: string | null } | null> | null };

export type BrandItemImagesRequireAuditQueryVariables = Exact<{ [key: string]: never; }>;


export type BrandItemImagesRequireAuditQuery = { __typename?: 'Query', BrandItemImagesRequireAudit?: Array<{ __typename?: 'BrandItemImage', _id: any, brandItemId: any, brandHouseId: any, uploadUrl?: string | null, imageUrl?: string | null, requireAudit?: boolean | null, sortOrder?: number | null }> | null };

export type ApproveImageAuditMutationVariables = Exact<{
  brandItemImageId: Scalars['MongoID'];
}>;


export type ApproveImageAuditMutation = { __typename?: 'Mutation', ApproveImageAudit?: { __typename?: 'BrandItemImage', _id: any, brandItemId: any, brandHouseId: any, uploadUrl?: string | null, imageUrl?: string | null, requireAudit?: boolean | null, sortOrder?: number | null } | null };

export type RejectImageAuditMutationVariables = Exact<{
  brandItemImageId: Scalars['MongoID'];
  uploadId?: InputMaybe<Scalars['MongoID']>;
}>;


export type RejectImageAuditMutation = { __typename?: 'Mutation', RejectImageAudit?: { __typename?: 'BrandItemImage', _id: any, brandItemId: any, brandHouseId: any, uploadUrl?: string | null, imageUrl?: string | null, requireAudit?: boolean | null, sortOrder?: number | null } | null };

export type RejectImageAuditRetakeMutationVariables = Exact<{
  brandItemImageId: Scalars['MongoID'];
}>;


export type RejectImageAuditRetakeMutation = { __typename?: 'Mutation', RejectImageAuditRetake?: { __typename?: 'BrandItemImage', _id: any, brandItemId: any, brandHouseId: any, uploadUrl?: string | null, imageUrl?: string | null, requireAudit?: boolean | null, sortOrder?: number | null } | null };

export type HideImageAuditMutationVariables = Exact<{
  brandItemImageId: Scalars['MongoID'];
}>;


export type HideImageAuditMutation = { __typename?: 'Mutation', HideImageAudit?: { __typename?: 'BrandItemImage', _id: any, brandItemId: any, brandHouseId: any, uploadUrl?: string | null, imageUrl?: string | null, requireAudit?: boolean | null, sortOrder?: number | null } | null };

export type BrandItemImageClearRemoveBgResultMutationVariables = Exact<{
  brandItemImageId: Scalars['MongoID'];
}>;


export type BrandItemImageClearRemoveBgResultMutation = { __typename?: 'Mutation', BrandItemImageClearRemoveBgResult?: { __typename?: 'BrandItemImage', _id: any, brandItemId: any, brandHouseId: any, uploadUrl?: string | null, imageUrl?: string | null, requireAudit?: boolean | null, sortOrder?: number | null } | null };

export type MasMigrationRunQueryVariables = Exact<{
  id: Scalars['MongoID'];
}>;


export type MasMigrationRunQuery = { __typename?: 'Query', BrandItemMasterDataMigrationRun?: { __typename?: 'BrandItemMasterDataMigrationRun', _id: any, type?: BrandItemMasterDataMigrationRunKind | null, status?: BrandItemMasterDataMigrationRunStatus | null, requestedCount: number, processedCount: number, matchedCount: number, reviewCount: number, noMatchCount: number, migratedCount: number, staleCount: number, failedCount: number, sourcePreviewRunId?: any | null, createdAt?: Date | null, updatedAt?: Date | null } | null };

export type MasMigrationItemsQueryVariables = Exact<{
  runId: Scalars['MongoID'];
}>;


export type MasMigrationItemsQuery = { __typename?: 'Query', BrandItemMasterDataMigrationItems?: Array<{ __typename?: 'BrandItemMasterDataMigrationItem', _id: any, brandItemId: any, brandHouseId?: any | null, status?: BrandItemMasterDataMigrationItemStatus | null, proposedMasterDataProductId?: string | null, proposedMasterDataVariantId?: string | null, confidence?: number | null, reasons?: Array<string> | null, error?: string | null, processedAt?: Date | null, signals?: Array<{ __typename?: 'BrandItemMasterDataMigrationSignal', type?: BrandItemMasterDataMigrationSignalType | null, result?: BrandItemMasterDataMigrationSignalResult | null, weight?: BrandItemMasterDataMigrationSignalWeight | null, score?: number | null, detail?: string | null } | null> | null, current?: { __typename?: 'BrandItemMasterDataMigrationFieldSnapshot', name?: string | null, style?: string | null, vendor?: string | null, type?: string | null, color?: string | null, size?: string | null, ean?: string | null, sku?: string | null, externalId?: string | null, brandId?: string | null } | null, candidate?: { __typename?: 'BrandItemMasterDataMigrationFieldSnapshot', name?: string | null, style?: string | null, vendor?: string | null, type?: string | null, color?: string | null, size?: string | null, ean?: string | null, sku?: string | null, externalId?: string | null, brandId?: string | null } | null } | null> | null };

export type MasMigrationMigrateMutationVariables = Exact<{
  selections: Array<BrandItemMasterDataMigrationSelectionInput> | BrandItemMasterDataMigrationSelectionInput;
  sourcePreviewRunId?: InputMaybe<Scalars['MongoID']>;
}>;


export type MasMigrationMigrateMutation = { __typename?: 'Mutation', BrandItemsMigrateToMasterDataVariant?: { __typename?: 'BrandItemMasterDataMigrationRun', _id: any, status?: BrandItemMasterDataMigrationRunStatus | null, requestedCount: number } | null };

export type MasMigrationRePreviewMutationVariables = Exact<{
  brandItemIds: Array<Scalars['MongoID']> | Scalars['MongoID'];
}>;


export type MasMigrationRePreviewMutation = { __typename?: 'Mutation', BrandItemsPreviewMasterDataVariantMigration?: { __typename?: 'BrandItemMasterDataMigrationRun', _id: any, status?: BrandItemMasterDataMigrationRunStatus | null, requestedCount: number } | null };

export type ShippingBrandsQueryVariables = Exact<{ [key: string]: never; }>;


export type ShippingBrandsQuery = { __typename?: 'Query', BrandHouses: Array<{ __typename?: 'BrandHouse', _id: any, name?: string | null }> };

export type ShippingCarrierEditQueryVariables = Exact<{
  id: Scalars['MongoID'];
}>;


export type ShippingCarrierEditQuery = { __typename?: 'Query', ShippingCarrier?: { __typename?: 'ShippingCarrier', _id: any, logo?: string | null, name?: string | null, carrier?: EnumShippingCarrierCarrier | null, carrierId?: string | null, description?: string | null, externalName?: string | null, externalCode?: string | null, expression?: string | null, activeFor?: Array<any | null> | null, localizationKey?: string | null, b2ceurope?: boolean | null, customCarrier?: boolean | null, shipmondo?: { __typename?: 'ShippingCarrierShipmondo', ownAgreement?: boolean | null, testMode?: boolean | null, carrier?: string | null, carrierSecondary?: string | null, carrierCode?: string | null, serviceCodes?: string | null, customerNumber?: any | null, qrX?: string | null, qrY?: string | null, qrSize?: number | null, width?: number | null, height?: number | null, length?: number | null, description?: string | null, customs?: string | null } | null, carrierGateway?: { __typename?: 'ShippingCarrierCarrierGateway', apiKey?: string | null, inputCarrier?: EnumShippingCarrierCarrierGatewayInputCarrier | null, outputCarrier?: EnumShippingCarrierCarrierGatewayOutputCarrier | null, supportQR?: boolean | null } | null } | null };

export type ShippingCarrierUpdateMutationVariables = Exact<{
  id: Scalars['MongoID'];
  input: ShippingCarrierInput;
}>;


export type ShippingCarrierUpdateMutation = { __typename?: 'Mutation', ShippingCarrierUpdate?: { __typename?: 'ShippingCarrier', _id: any } | null };

export type ShippingCarriersLpQueryVariables = Exact<{ [key: string]: never; }>;


export type ShippingCarriersLpQuery = { __typename?: 'Query', ShippingCarriersLP?: Array<{ __typename?: 'ShippingCarrier', _id: any, logo?: string | null, name?: string | null, description?: string | null, expression?: string | null, shipmondo?: { __typename?: 'ShippingCarrierShipmondo', ownAgreement?: boolean | null, testMode?: boolean | null, carrier?: string | null, carrierCode?: string | null, serviceCodes?: string | null, customerNumber?: any | null, qrX?: string | null, qrY?: string | null, qrSize?: number | null, width?: number | null, height?: number | null, length?: number | null, description?: string | null } | null } | null> | null };

export type BrandItemBoostFieldsFragment = { __typename?: 'BrandItemBoost', pricePct?: number | null, visibility: boolean, startTs: Date, endTs: Date, endedTs?: Date | null, active: boolean };

export type BrandItemBoostStateFragment = { __typename?: 'BrandItem', _id: any, salesRank: number, sellingPrices?: Array<{ __typename?: 'Pricing', value: number, currency: string } | null> | null, activeBoost?: { __typename?: 'BrandItemBoost', pricePct?: number | null, visibility: boolean, startTs: Date, endTs: Date, endedTs?: Date | null, active: boolean } | null };

export type BrandItemBoostItemsQueryVariables = Exact<{
  brandItemIds?: InputMaybe<Array<Scalars['MongoID']> | Scalars['MongoID']>;
}>;


export type BrandItemBoostItemsQuery = { __typename?: 'Query', BrandItems?: Array<{ __typename?: 'BrandItem', itemNr: number, itemState: EnumBrandItemItemState, discarded?: Date | null, soldTs?: Date | null, imageUrls?: Array<string> | null, _id: any, salesRank: number, sellingPrices?: Array<{ __typename?: 'Pricing', value: number, currency: string } | null> | null, activeBoost?: { __typename?: 'BrandItemBoost', pricePct?: number | null, visibility: boolean, startTs: Date, endTs: Date, endedTs?: Date | null, active: boolean } | null } | null> | null };

export type BrandItemBoostSetMutationVariables = Exact<{
  brandItemId: Scalars['MongoID'];
  endTs: Scalars['Date'];
  pricePct?: InputMaybe<Scalars['Int']>;
  visibility: Scalars['Boolean'];
}>;


export type BrandItemBoostSetMutation = { __typename?: 'Mutation', BrandItemBoostSet?: { __typename?: 'BrandItem', _id: any, salesRank: number, sellingPrices?: Array<{ __typename?: 'Pricing', value: number, currency: string } | null> | null, activeBoost?: { __typename?: 'BrandItemBoost', pricePct?: number | null, visibility: boolean, startTs: Date, endTs: Date, endedTs?: Date | null, active: boolean } | null } | null };

export type BrandItemBoostCancelMutationVariables = Exact<{
  brandItemId: Scalars['MongoID'];
}>;


export type BrandItemBoostCancelMutation = { __typename?: 'Mutation', BrandItemBoostCancel?: { __typename?: 'BrandItem', _id: any, salesRank: number, sellingPrices?: Array<{ __typename?: 'Pricing', value: number, currency: string } | null> | null, activeBoost?: { __typename?: 'BrandItemBoost', pricePct?: number | null, visibility: boolean, startTs: Date, endTs: Date, endedTs?: Date | null, active: boolean } | null } | null };

export type ExportBrandItemsQueryVariables = Exact<{
  brandItemIds?: InputMaybe<Array<Scalars['MongoID']> | Scalars['MongoID']>;
  currency: Scalars['String'];
}>;


export type ExportBrandItemsQuery = { __typename?: 'Query', BrandItems?: Array<{ __typename?: 'BrandItem', _id: any, resolved?: { __typename?: 'BrandItemResolved', _id: any, itemNr: number, itemSku: string, note?: string | null, condition: number, itemState: EnumBrandItemItemState, missing?: Date | null, stockLocation?: string | null, imageUrls?: Array<string> | null, createdAt?: Date | null, itemEan: string, originalEan?: string | null, originalSku?: string | null, vendor?: string | null, tags?: Array<string> | null, isSold: boolean, soldTs?: Date | null, sourceType?: ItemSourceType | null, hasProblems?: boolean | null, hasErrors: boolean, daysForSale?: number | null, nameLocalized?: Array<{ __typename?: 'LocalizationEntry', value: string, locale: string } | null> | null, beforePrices?: Array<{ __typename?: 'Pricing', value: number, currency: string } | null> | null, colorLocalized?: Array<{ __typename?: 'LocalizationEntry', value: string, locale: string } | null> | null, sizeLocalized?: Array<{ __typename?: 'LocalizationEntry', value: string, locale: string } | null> | null, typeLocalized?: Array<{ __typename?: 'LocalizationEntry', value: string, locale: string } | null> | null, orderline?: { __typename?: 'Order2Item', salesPricePreTax?: number | null } | null, tradeInItem?: { __typename?: 'TradeInItem', value?: number | null, currency?: string | null } | null, invoiceLine?: { __typename?: 'InvoiceLine', _id: any, lineDate: Date, invoiceId: any, invoice?: { __typename?: 'Invoice', _id: any, invoiceId: string } | null } | null } | null } | null> | null };

export type BrandItemImportSearchQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  brandHouseId: Scalars['MongoID'];
}>;


export type BrandItemImportSearchQuery = { __typename?: 'Query', BrandProductsPagination?: { __typename?: 'BrandProductBrandProductsPagination', count?: number | null, pageInfo: { __typename?: 'PaginationInfo', perPage: number, currentPage: number, hasNextPage?: boolean | null, hasPreviousPage?: boolean | null, itemCount?: number | null, pageCount?: number | null }, items?: Array<{ __typename?: 'BrandProduct', _id: any, style?: string | null, imageUrls?: Array<string> | null, nameLocalized: Array<{ __typename?: 'LocalizationEntry', locale: string, value: string } | null>, variants?: Array<{ __typename?: 'BrandProductVariant', _id: any, colorLocalized?: Array<{ __typename?: 'LocalizationEntry', value: string, locale: string } | null> | null, sizes?: Array<{ __typename?: 'BrandProductSize', sku?: string | null, ean?: string | null, sizeLocalized: Array<{ __typename?: 'LocalizationEntry', value: string, locale: string } | null> } | null> | null } | null> | null }> | null } | null };

export type BrandItemImportSearchFragment = { __typename?: 'BrandProduct', _id: any, style?: string | null, imageUrls?: Array<string> | null, nameLocalized: Array<{ __typename?: 'LocalizationEntry', locale: string, value: string } | null>, variants?: Array<{ __typename?: 'BrandProductVariant', _id: any, colorLocalized?: Array<{ __typename?: 'LocalizationEntry', value: string, locale: string } | null> | null, sizes?: Array<{ __typename?: 'BrandProductSize', sku?: string | null, ean?: string | null, sizeLocalized: Array<{ __typename?: 'LocalizationEntry', value: string, locale: string } | null> } | null> | null } | null> | null };

export type BrandItemLogisticsQueryVariables = Exact<{
  brandItemId: Scalars['MongoID'];
}>;


export type BrandItemLogisticsQuery = { __typename?: 'Query', BrandItem?: { __typename?: 'BrandItem', _id: any, brandHouseId: any, vas?: Array<{ __typename?: 'BrandItemVas', vasId: string, vasName: string, sortingOrder?: number | null, completed: boolean, completedBy?: string | null, startDate?: Date | null, completedDate?: Date | null, workflowName?: string | null, workflowTs?: Date | null } | null> | null } | null };

export type BrandItemStatusProblemsQueryVariables = Exact<{
  brandItemId: Scalars['MongoID'];
  shopId?: InputMaybe<Scalars['MongoID']>;
}>;


export type BrandItemStatusProblemsQuery = { __typename?: 'Query', BrandItemProblems?: Array<string | null> | null };

export type BrandItemMultiSettingsQueryVariables = Exact<{
  brandHouseId: Scalars['MongoID'];
}>;


export type BrandItemMultiSettingsQuery = { __typename?: 'Query', BrandSettings?: { __typename?: 'BrandSetting', _id?: any | null, locales?: Array<{ __typename?: 'BrandLocale', locale: string, activeItems?: boolean | null } | null> | null, stockItemConfig?: { __typename?: 'BrandSettingStockItemConfig', currencies?: Array<{ __typename?: 'Currency', currency: string, active?: boolean | null } | null> | null } | null } | null };

export type BrandItemMultiQueryVariables = Exact<{
  brandItemIds?: InputMaybe<Array<Scalars['MongoID']> | Scalars['MongoID']>;
}>;


export type BrandItemMultiQuery = { __typename?: 'Query', BrandItems?: Array<{ __typename?: 'BrandItem', _id: any, itemNr: number, imageUrls?: Array<string> | null, itemState: EnumBrandItemItemState, condition: number, originalSku?: string | null, originalEan?: string | null, vendor?: string | null, sortorder?: number | null, test?: boolean | null, resolved?: { __typename?: 'BrandItemResolved', _id: any, itemNr: number, imageUrls?: Array<string> | null, itemState: EnumBrandItemItemState, condition: number, originalSku?: string | null, originalEan?: string | null, vendor?: string | null, sortorder?: number | null, test?: boolean | null, nameLocalized?: Array<{ __typename?: 'LocalizationEntry', locale: string, value: string } | null> | null, descriptionLocalized?: Array<{ __typename?: 'LocalizationEntry', locale: string, value: string } | null> | null, sizeLocalized?: Array<{ __typename?: 'LocalizationEntry', locale: string, value: string } | null> | null, colorLocalized?: Array<{ __typename?: 'LocalizationEntry', locale: string, value: string } | null> | null, beforePrices?: Array<{ __typename?: 'Pricing', value: number, currency: string } | null> | null, typeLocalized?: Array<{ __typename?: 'LocalizationEntry', locale: string, value: string } | null> | null } | null, nameLocalized?: Array<{ __typename?: 'LocalizationEntry', locale: string, value: string } | null> | null, descriptionLocalized?: Array<{ __typename?: 'LocalizationEntry', locale: string, value: string } | null> | null, sizeLocalized?: Array<{ __typename?: 'LocalizationEntry', locale: string, value: string } | null> | null, colorLocalized?: Array<{ __typename?: 'LocalizationEntry', locale: string, value: string } | null> | null, beforePrices?: Array<{ __typename?: 'Pricing', value: number, currency: string } | null> | null, typeLocalized?: Array<{ __typename?: 'LocalizationEntry', locale: string, value: string } | null> | null } | null> | null };

export type BrandItemMultiUpdateMutationVariables = Exact<{
  brandHouseId: Scalars['MongoID'];
  input?: InputMaybe<BrandItemInputInput>;
}>;


export type BrandItemMultiUpdateMutation = { __typename?: 'Mutation', BrandItemUpdate?: { __typename?: 'BrandItem', _id: any, itemNr: number, imageUrls?: Array<string> | null, itemState: EnumBrandItemItemState, condition: number, originalSku?: string | null, originalEan?: string | null, vendor?: string | null, sortorder?: number | null, test?: boolean | null, nameLocalized?: Array<{ __typename?: 'LocalizationEntry', locale: string, value: string } | null> | null, descriptionLocalized?: Array<{ __typename?: 'LocalizationEntry', locale: string, value: string } | null> | null, sizeLocalized?: Array<{ __typename?: 'LocalizationEntry', locale: string, value: string } | null> | null, colorLocalized?: Array<{ __typename?: 'LocalizationEntry', locale: string, value: string } | null> | null, beforePrices?: Array<{ __typename?: 'Pricing', value: number, currency: string } | null> | null, typeLocalized?: Array<{ __typename?: 'LocalizationEntry', locale: string, value: string } | null> | null } | null };

export type BrandItemMultiFragment = { __typename?: 'BrandItem', _id: any, itemNr: number, imageUrls?: Array<string> | null, itemState: EnumBrandItemItemState, condition: number, originalSku?: string | null, originalEan?: string | null, vendor?: string | null, sortorder?: number | null, test?: boolean | null, nameLocalized?: Array<{ __typename?: 'LocalizationEntry', locale: string, value: string } | null> | null, descriptionLocalized?: Array<{ __typename?: 'LocalizationEntry', locale: string, value: string } | null> | null, sizeLocalized?: Array<{ __typename?: 'LocalizationEntry', locale: string, value: string } | null> | null, colorLocalized?: Array<{ __typename?: 'LocalizationEntry', locale: string, value: string } | null> | null, beforePrices?: Array<{ __typename?: 'Pricing', value: number, currency: string } | null> | null, typeLocalized?: Array<{ __typename?: 'LocalizationEntry', locale: string, value: string } | null> | null };

export type BrandItemMultiResolvedFragment = { __typename?: 'BrandItemResolved', _id: any, itemNr: number, imageUrls?: Array<string> | null, itemState: EnumBrandItemItemState, condition: number, originalSku?: string | null, originalEan?: string | null, vendor?: string | null, sortorder?: number | null, test?: boolean | null, nameLocalized?: Array<{ __typename?: 'LocalizationEntry', locale: string, value: string } | null> | null, descriptionLocalized?: Array<{ __typename?: 'LocalizationEntry', locale: string, value: string } | null> | null, sizeLocalized?: Array<{ __typename?: 'LocalizationEntry', locale: string, value: string } | null> | null, colorLocalized?: Array<{ __typename?: 'LocalizationEntry', locale: string, value: string } | null> | null, beforePrices?: Array<{ __typename?: 'Pricing', value: number, currency: string } | null> | null, typeLocalized?: Array<{ __typename?: 'LocalizationEntry', locale: string, value: string } | null> | null };

export type BrandItemOrdersQueryVariables = Exact<{
  brandItemId: Scalars['MongoID'];
}>;


export type BrandItemOrdersQuery = { __typename?: 'Query', BrandItem?: { __typename?: 'BrandItem', _id: any, resolved?: { __typename?: 'BrandItemResolved', nameLocalized?: Array<{ __typename?: 'LocalizationEntry', value: string, locale: string } | null> | null } | null, shops?: Array<{ __typename?: 'BrandItemShopInfo', _id: any, shop?: { __typename?: 'Shop', _id: any, name?: string | null } | null, stockItem?: { __typename?: 'StockItemResolved', _id: any, orderlines?: Array<{ __typename?: 'Order2Item', _id: any, returned?: boolean | null, order?: { __typename?: 'Order2', _id: any, orderName?: string | null, orderDate: Date, orderUrl?: string | null, consumer: { __typename?: 'Order2Consumer', name?: string | null, mail?: string | null } } | null } | null> | null } | null } | null> | null } | null };

export type BrandItemPublishItemsQueryVariables = Exact<{
  brandItemIds?: InputMaybe<Array<Scalars['MongoID']> | Scalars['MongoID']>;
}>;


export type BrandItemPublishItemsQuery = { __typename?: 'Query', BrandItems?: Array<{ __typename?: 'BrandItem', _id: any, shops?: Array<{ __typename?: 'BrandItemShopInfo', _id: any, shopId: any, active: boolean } | null> | null } | null> | null };

export type BrandItemsPublishMutationVariables = Exact<{
  brandItemIds: Array<Scalars['MongoID']> | Scalars['MongoID'];
  shops: Array<BrandItemsPublishShopInput> | BrandItemsPublishShopInput;
}>;


export type BrandItemsPublishMutation = { __typename?: 'Mutation', BrandItemsPublish?: { __typename?: 'BrandItemsPublishResult', requested: number, changed: number, unchanged: number, skipped: number } | null };

export type BrandItemStatusItemQueryVariables = Exact<{
  brandItemId: Scalars['MongoID'];
}>;


export type BrandItemStatusItemQuery = { __typename?: 'Query', BrandItem?: { __typename?: 'BrandItem', _id: any, brandHouseId: any, resolved?: { __typename?: 'BrandItemResolved', nameLocalized?: Array<{ __typename?: 'LocalizationEntry', value: string, locale: string } | null> | null } | null, shops?: Array<{ __typename?: 'BrandItemShopInfo', _id: any, active: boolean, brandItemId: any, shopId: any, shop?: { __typename?: 'Shop', _id: any, name?: string | null, frontendType: EnumShopFrontendType, currency?: string | null } | null, stockItem?: { __typename?: 'StockItemResolved', _id: any, queued?: boolean | null, sellingPrice?: number | null, externId?: string | null, externUrl?: string | null, itemSku: string } | null } | null> | null } | null };

export type BrandItemStatusPushMutationVariables = Exact<{
  brandItemId: Scalars['MongoID'];
  shopId?: InputMaybe<Scalars['MongoID']>;
  active: Scalars['Boolean'];
}>;


export type BrandItemStatusPushMutation = { __typename?: 'Mutation', BrandItemPush?: Array<{ __typename?: 'BrandItemShopInfo', _id: any, shopId: any, active: boolean } | null> | null };

export type BrandItemTrackingShopsQueryVariables = Exact<{
  brandItemId: Scalars['MongoID'];
}>;


export type BrandItemTrackingShopsQuery = { __typename?: 'Query', BrandItem?: { __typename?: 'BrandItem', shops?: Array<{ __typename?: 'BrandItemShopInfo', shopId: any, stockItemId?: any | null } | null> | null } | null };

export type OrderCreateMutationVariables = Exact<{
  order: OrderSynchronizeInput;
}>;


export type OrderCreateMutation = { __typename?: 'Mutation', OrderSynchronize?: { __typename?: 'Order2', _id: any } | null };

export type BrandItemsBrandSettingsQueryVariables = Exact<{
  brandHouseId?: InputMaybe<Scalars['MongoID']>;
}>;


export type BrandItemsBrandSettingsQuery = { __typename?: 'Query', BrandSettings?: { __typename?: 'BrandSetting', tradeInComments?: boolean | null, locales?: Array<{ __typename?: 'BrandLocale', locale: string, activeItems?: boolean | null } | null> | null, stockItemConfig?: { __typename?: 'BrandSettingStockItemConfig', currencies?: Array<{ __typename?: 'Currency', active?: boolean | null, currency: string } | null> | null } | null } | null, BrandHouses: Array<{ __typename?: 'BrandHouse', _id: any, name?: string | null }> };

export type BrandItemsListManyQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<FilterFindManyBrandItemInput>;
  sort?: InputMaybe<SortFindManyBrandItemInput>;
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
  viewId?: InputMaybe<Scalars['MongoID']>;
}>;


export type BrandItemsListManyQuery = { __typename?: 'Query', BrandItemPagination?: { __typename?: 'BrandItemBrandItemPagination', count?: number | null, pageInfo: { __typename?: 'PaginationInfo', perPage: number, currentPage: number, hasNextPage?: boolean | null, hasPreviousPage?: boolean | null, itemCount?: number | null, pageCount?: number | null }, items?: Array<{ __typename?: 'BrandItem', _id: any, resolved?: { __typename?: 'BrandItemResolved', _id: any, brandHouseId: any, brandProductSizeId?: any | null, itemNr: number, itemSku: string, tradeInItemId?: any | null, isTradeIn: boolean, createdAt?: Date | null, condition: number, imageUrls?: Array<string> | null, originalSku?: string | null, originalEan?: string | null, itemEan: string, itemState: EnumBrandItemItemState, checked?: Date | null, effectiveChecked: boolean, effectiveMissing: boolean, stockLocation?: string | null, stockLocationTs?: Date | null, stockLocationBag?: string | null, isSold: boolean, soldTs?: Date | null, isInSeason: boolean, note?: string | null, hasErrors: boolean, hasProblems?: boolean | null, hasComment?: boolean | null, hasTranslatedComment?: boolean | null, commentApproved?: boolean | null, stateAggregation?: BrandItemAggregatedStateEnum | null, sortorder?: number | null, invalidManufacturer?: boolean | null, vendor?: string | null, test?: boolean | null, legacyGroup: boolean, externalId?: string | null, vasId?: string | null, brandHouse?: { __typename?: 'BrandHouse', _id: any, name?: string | null } | null, nameLocalized?: Array<{ __typename?: 'LocalizationEntry', locale: string, value: string } | null> | null, descriptionLocalized?: Array<{ __typename?: 'LocalizationEntry', locale: string, value: string } | null> | null, typeLocalized?: Array<{ __typename?: 'LocalizationEntry', locale: string, value: string } | null> | null, images?: Array<{ __typename?: 'BrandItemImage', process?: boolean | null, imageId?: any | null, imageUrl?: string | null, brandProductImageUrl?: string | null } | null> | null, beforePrices?: Array<{ __typename?: 'Pricing', currency: string, value: number } | null> | null, sellingPrices?: Array<{ __typename?: 'Pricing', currency: string, value: number } | null> | null, activeBoost?: { __typename?: 'BrandItemBoost', pricePct?: number | null, visibility: boolean, startTs: Date, endTs: Date, endedTs?: Date | null, active: boolean } | null, colorLocalized?: Array<{ __typename?: 'LocalizationEntry', locale: string, value: string } | null> | null, sizeLocalized?: Array<{ __typename?: 'LocalizationEntry', locale: string, value: string } | null> | null, commentLocalized?: Array<{ __typename?: 'LocalizationEntry', locale: string, value: string } | null> | null, options?: Array<{ __typename?: 'OptionInstance', key: string, value: string } | null> | null, shops?: Array<{ __typename?: 'BrandItemShopInfo', _id: any, shopId: any, active: boolean } | null> | null, problems?: Array<{ __typename?: 'BrandItemProblem', solved: boolean, description?: string | null, createdAt?: Date | null } | null> | null, vas?: Array<{ __typename?: 'BrandItemVas', vasId: string, vasName: string, completedBy?: string | null, sortingOrder?: number | null } | null> | null, attributes?: { __typename?: 'BrandItemAttributes', type: EnumBrandItemAttributesType, apparentFabricType: EnumBrandItemAttributesApparentFabricType, formalityLevel: EnumBrandItemAttributesFormalityLevel, neckline?: EnumBrandItemAttributesNeckline | null, pattern: EnumBrandItemAttributesPattern, primaryColor: EnumBrandItemAttributesPrimaryColor, seasonSuitability?: Array<EnumBrandItemAttributesSeasonSuitability | null> | null, secondaryColors?: Array<EnumBrandItemAttributesSecondaryColors | null> | null, textureAppearance: EnumBrandItemAttributesTextureAppearance } | null, reviewInfos?: Array<{ __typename?: 'BrandItemReviewInfo', type: string, value: string } | null> | null } | null }> | null } | null };

export type BrandItemsListByIdsQueryVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['MongoID']> | Scalars['MongoID']>;
}>;


export type BrandItemsListByIdsQuery = { __typename?: 'Query', BrandItems?: Array<{ __typename?: 'BrandItem', _id: any, resolved?: { __typename?: 'BrandItemResolved', _id: any, brandHouseId: any, brandProductSizeId?: any | null, itemNr: number, itemSku: string, tradeInItemId?: any | null, isTradeIn: boolean, createdAt?: Date | null, condition: number, imageUrls?: Array<string> | null, originalSku?: string | null, originalEan?: string | null, itemEan: string, itemState: EnumBrandItemItemState, checked?: Date | null, effectiveChecked: boolean, effectiveMissing: boolean, stockLocation?: string | null, stockLocationTs?: Date | null, stockLocationBag?: string | null, isSold: boolean, soldTs?: Date | null, isInSeason: boolean, note?: string | null, hasErrors: boolean, hasProblems?: boolean | null, hasComment?: boolean | null, hasTranslatedComment?: boolean | null, commentApproved?: boolean | null, stateAggregation?: BrandItemAggregatedStateEnum | null, sortorder?: number | null, invalidManufacturer?: boolean | null, vendor?: string | null, test?: boolean | null, legacyGroup: boolean, externalId?: string | null, vasId?: string | null, brandHouse?: { __typename?: 'BrandHouse', _id: any, name?: string | null } | null, nameLocalized?: Array<{ __typename?: 'LocalizationEntry', locale: string, value: string } | null> | null, descriptionLocalized?: Array<{ __typename?: 'LocalizationEntry', locale: string, value: string } | null> | null, typeLocalized?: Array<{ __typename?: 'LocalizationEntry', locale: string, value: string } | null> | null, images?: Array<{ __typename?: 'BrandItemImage', process?: boolean | null, imageId?: any | null, imageUrl?: string | null, brandProductImageUrl?: string | null } | null> | null, beforePrices?: Array<{ __typename?: 'Pricing', currency: string, value: number } | null> | null, sellingPrices?: Array<{ __typename?: 'Pricing', currency: string, value: number } | null> | null, activeBoost?: { __typename?: 'BrandItemBoost', pricePct?: number | null, visibility: boolean, startTs: Date, endTs: Date, endedTs?: Date | null, active: boolean } | null, colorLocalized?: Array<{ __typename?: 'LocalizationEntry', locale: string, value: string } | null> | null, sizeLocalized?: Array<{ __typename?: 'LocalizationEntry', locale: string, value: string } | null> | null, commentLocalized?: Array<{ __typename?: 'LocalizationEntry', locale: string, value: string } | null> | null, options?: Array<{ __typename?: 'OptionInstance', key: string, value: string } | null> | null, shops?: Array<{ __typename?: 'BrandItemShopInfo', _id: any, shopId: any, active: boolean } | null> | null, problems?: Array<{ __typename?: 'BrandItemProblem', solved: boolean, description?: string | null, createdAt?: Date | null } | null> | null, vas?: Array<{ __typename?: 'BrandItemVas', vasId: string, vasName: string, completedBy?: string | null, sortingOrder?: number | null } | null> | null, attributes?: { __typename?: 'BrandItemAttributes', type: EnumBrandItemAttributesType, apparentFabricType: EnumBrandItemAttributesApparentFabricType, formalityLevel: EnumBrandItemAttributesFormalityLevel, neckline?: EnumBrandItemAttributesNeckline | null, pattern: EnumBrandItemAttributesPattern, primaryColor: EnumBrandItemAttributesPrimaryColor, seasonSuitability?: Array<EnumBrandItemAttributesSeasonSuitability | null> | null, secondaryColors?: Array<EnumBrandItemAttributesSecondaryColors | null> | null, textureAppearance: EnumBrandItemAttributesTextureAppearance } | null, reviewInfos?: Array<{ __typename?: 'BrandItemReviewInfo', type: string, value: string } | null> | null } | null } | null> | null };

export type FlexBrandItemFragment = { __typename?: 'BrandItemResolved', _id: any, brandHouseId: any, brandProductSizeId?: any | null, itemNr: number, itemSku: string, tradeInItemId?: any | null, isTradeIn: boolean, createdAt?: Date | null, condition: number, imageUrls?: Array<string> | null, originalSku?: string | null, originalEan?: string | null, itemEan: string, itemState: EnumBrandItemItemState, checked?: Date | null, effectiveChecked: boolean, effectiveMissing: boolean, stockLocation?: string | null, stockLocationTs?: Date | null, stockLocationBag?: string | null, isSold: boolean, soldTs?: Date | null, isInSeason: boolean, note?: string | null, hasErrors: boolean, hasProblems?: boolean | null, hasComment?: boolean | null, hasTranslatedComment?: boolean | null, commentApproved?: boolean | null, stateAggregation?: BrandItemAggregatedStateEnum | null, sortorder?: number | null, invalidManufacturer?: boolean | null, vendor?: string | null, test?: boolean | null, legacyGroup: boolean, externalId?: string | null, vasId?: string | null, brandHouse?: { __typename?: 'BrandHouse', _id: any, name?: string | null } | null, nameLocalized?: Array<{ __typename?: 'LocalizationEntry', locale: string, value: string } | null> | null, descriptionLocalized?: Array<{ __typename?: 'LocalizationEntry', locale: string, value: string } | null> | null, typeLocalized?: Array<{ __typename?: 'LocalizationEntry', locale: string, value: string } | null> | null, images?: Array<{ __typename?: 'BrandItemImage', process?: boolean | null, imageId?: any | null, imageUrl?: string | null, brandProductImageUrl?: string | null } | null> | null, beforePrices?: Array<{ __typename?: 'Pricing', currency: string, value: number } | null> | null, sellingPrices?: Array<{ __typename?: 'Pricing', currency: string, value: number } | null> | null, activeBoost?: { __typename?: 'BrandItemBoost', pricePct?: number | null, visibility: boolean, startTs: Date, endTs: Date, endedTs?: Date | null, active: boolean } | null, colorLocalized?: Array<{ __typename?: 'LocalizationEntry', locale: string, value: string } | null> | null, sizeLocalized?: Array<{ __typename?: 'LocalizationEntry', locale: string, value: string } | null> | null, commentLocalized?: Array<{ __typename?: 'LocalizationEntry', locale: string, value: string } | null> | null, options?: Array<{ __typename?: 'OptionInstance', key: string, value: string } | null> | null, shops?: Array<{ __typename?: 'BrandItemShopInfo', _id: any, shopId: any, active: boolean } | null> | null, problems?: Array<{ __typename?: 'BrandItemProblem', solved: boolean, description?: string | null, createdAt?: Date | null } | null> | null, vas?: Array<{ __typename?: 'BrandItemVas', vasId: string, vasName: string, completedBy?: string | null, sortingOrder?: number | null } | null> | null, attributes?: { __typename?: 'BrandItemAttributes', type: EnumBrandItemAttributesType, apparentFabricType: EnumBrandItemAttributesApparentFabricType, formalityLevel: EnumBrandItemAttributesFormalityLevel, neckline?: EnumBrandItemAttributesNeckline | null, pattern: EnumBrandItemAttributesPattern, primaryColor: EnumBrandItemAttributesPrimaryColor, seasonSuitability?: Array<EnumBrandItemAttributesSeasonSuitability | null> | null, secondaryColors?: Array<EnumBrandItemAttributesSecondaryColors | null> | null, textureAppearance: EnumBrandItemAttributesTextureAppearance } | null, reviewInfos?: Array<{ __typename?: 'BrandItemReviewInfo', type: string, value: string } | null> | null };

export type BrandItemsPageShopsQueryVariables = Exact<{
  brandHouseId: Scalars['MongoID'];
}>;


export type BrandItemsPageShopsQuery = { __typename?: 'Query', BrandSettings?: { __typename?: 'BrandSetting', _id?: any | null, useBrandItems?: boolean | null, locales?: Array<{ __typename?: 'BrandLocale', locale: string, activeItems?: boolean | null } | null> | null } | null, ShopMany: Array<{ __typename?: 'Shop', _id: any, name?: string | null, disabled?: boolean | null, live?: boolean | null, currency?: string | null }>, IntegrationInstances: Array<{ __typename?: 'IntegrationInstance', _id: any, name: string, connector?: { __typename?: 'IntegrationConnector', messages?: Array<EnumIntegrationConnectorMessages | null> | null } | null }> };

export type BrandItemsUpdateCacheMutationVariables = Exact<{
  brandItemId: Scalars['MongoID'];
}>;


export type BrandItemsUpdateCacheMutation = { __typename?: 'Mutation', BrandItemUpdateCache: boolean };

export type BrandItemDeleteMutationVariables = Exact<{
  brandItemId: Scalars['MongoID'];
}>;


export type BrandItemDeleteMutation = { __typename?: 'Mutation', BrandItemDelete?: { __typename?: 'BrandItem', _id: any } | null };

export type BrandItemRetouchMutationVariables = Exact<{
  ids: Array<Scalars['MongoID']> | Scalars['MongoID'];
}>;


export type BrandItemRetouchMutation = { __typename?: 'Mutation', BrandItemRetouch?: Array<{ __typename?: 'BrandItem', _id: any, imageUrls?: Array<string> | null, images?: Array<{ __typename?: 'BrandItemImage', _id: any, imageUrl?: string | null } | null> | null } | null> | null };

export type BrandItemsPageChangeStateMutationVariables = Exact<{
  brandHouseId: Scalars['MongoID'];
  id: Scalars['MongoID'];
  state: BrandItemStateEnum;
}>;


export type BrandItemsPageChangeStateMutation = { __typename?: 'Mutation', BrandItemUpdate?: { __typename?: 'BrandItem', _id: any, itemState: EnumBrandItemItemState } | null };

export type BrandItemsPageChangeSortOrderMutationVariables = Exact<{
  brandHouseId: Scalars['MongoID'];
  id: Scalars['MongoID'];
  order: Scalars['Int'];
}>;


export type BrandItemsPageChangeSortOrderMutation = { __typename?: 'Mutation', BrandItemUpdate?: { __typename?: 'BrandItem', _id: any, sortorder?: number | null } | null };

export type BrandItemImageAutoAdjustMutationVariables = Exact<{
  brandItemId: Scalars['MongoID'];
}>;


export type BrandItemImageAutoAdjustMutation = { __typename?: 'Mutation', BrandItemAdjustAutoImages?: boolean | null };

export type BrandItemUpdateGroupMutationVariables = Exact<{
  brandItemIds?: InputMaybe<Array<Scalars['MongoID']> | Scalars['MongoID']>;
}>;


export type BrandItemUpdateGroupMutation = { __typename?: 'Mutation', BrandItemGroupUpdate?: Array<{ __typename?: 'BrandItem', _id: any } | null> | null };

export type BrandItemUpdatePricesMutationVariables = Exact<{
  brandItemIds: Array<Scalars['MongoID']> | Scalars['MongoID'];
}>;


export type BrandItemUpdatePricesMutation = { __typename?: 'Mutation', BrandItemUpdatePrices?: Array<{ __typename?: 'BrandItem', _id: any, beforePrices?: Array<{ __typename?: 'Pricing', value: number, currency: string } | null> | null } | null> | null };

export type BrandItemUpdateIntegrationMutationVariables = Exact<{
  brandItemIds: Array<Scalars['MongoID']> | Scalars['MongoID'];
  instanceId: Scalars['MongoID'];
}>;


export type BrandItemUpdateIntegrationMutation = { __typename?: 'Mutation', BrandItemIntegrationUpdate: boolean };

export type OptimizeBrandItemsBySalesRankMutationVariables = Exact<{
  brandHouseId: Scalars['MongoID'];
}>;


export type OptimizeBrandItemsBySalesRankMutation = { __typename?: 'Mutation', BrandItemOptimizeBySalesRank: boolean };

export type BrandItemsPreviewMasMigrationMutationVariables = Exact<{
  brandItemIds: Array<Scalars['MongoID']> | Scalars['MongoID'];
}>;


export type BrandItemsPreviewMasMigrationMutation = { __typename?: 'Mutation', BrandItemsPreviewMasterDataVariantMigration?: { __typename?: 'BrandItemMasterDataMigrationRun', _id: any, status?: BrandItemMasterDataMigrationRunStatus | null, requestedCount: number } | null };

export type BrandItemsBackfillMasterDataMutationVariables = Exact<{
  brandItemIds: Array<Scalars['MongoID']> | Scalars['MongoID'];
}>;


export type BrandItemsBackfillMasterDataMutation = { __typename?: 'Mutation', BrandItemsBackfillMasterData?: { __typename?: 'BrandItemMasterDataBackfillResult', requested: number, queued: number, skipped: number } | null };

export type BrandItemsRefreshMasterDataMutationVariables = Exact<{
  brandItemIds: Array<Scalars['MongoID']> | Scalars['MongoID'];
}>;


export type BrandItemsRefreshMasterDataMutation = { __typename?: 'Mutation', BrandItemsRefreshMasterData?: { __typename?: 'BrandItemMasterDataRefreshResult', requested: number, queued: number, skipped: number } | null };

export type BrandItemCreateFromMasterDataMutationVariables = Exact<{
  brandHouseId: Scalars['MongoID'];
  masterDataVariantId: Scalars['String'];
}>;


export type BrandItemCreateFromMasterDataMutation = { __typename?: 'Mutation', BrandItemUpdate?: { __typename?: 'BrandItem', _id: any } | null };

export type BrandMessagesShopsQueryVariables = Exact<{
  brandHouseId: Scalars['MongoID'];
}>;


export type BrandMessagesShopsQuery = { __typename?: 'Query', ShopMany: Array<{ __typename?: 'Shop', _id: any }> };

export type BrandMessagesInstancesQueryVariables = Exact<{
  instanceFilter?: InputMaybe<FilterFindManyIntegrationInstanceInput>;
}>;


export type BrandMessagesInstancesQuery = { __typename?: 'Query', IntegrationInstances: Array<{ __typename?: 'IntegrationInstance', _id: any }> };

export type BrandOrdersPageShopsQueryVariables = Exact<{
  brandHouseId: Scalars['MongoID'];
  instanceFilter?: InputMaybe<FilterFindManyIntegrationInstanceInput>;
}>;


export type BrandOrdersPageShopsQuery = { __typename?: 'Query', ShopMany: Array<{ __typename?: 'Shop', _id: any, name?: string | null }>, IntegrationInstances: Array<{ __typename?: 'IntegrationInstance', _id: any, name: string, refId: any, connector?: { __typename?: 'IntegrationConnector', messages?: Array<EnumIntegrationConnectorMessages | null> | null } | null }> };

export type BrandOrdersPageSelectedOrdersQueryVariables = Exact<{
  orderIds?: InputMaybe<Array<Scalars['MongoID']> | Scalars['MongoID']>;
}>;


export type BrandOrdersPageSelectedOrdersQuery = { __typename?: 'Query', OrderPagination?: { __typename?: 'Order2OrderPagination', items?: Array<{ __typename?: 'Order2', _id: any, shopId: any }> | null } | null };

export type OrderIntegrationExecuteMutationVariables = Exact<{
  refId: Scalars['MongoID'];
  arguments?: InputMaybe<Array<Scalars['JSON']> | Scalars['JSON']>;
}>;


export type OrderIntegrationExecuteMutation = { __typename?: 'Mutation', IntegrationMessageExecute?: Array<string> | null };

export type BrandOrdersPageSynchronizeMutationVariables = Exact<{
  shopId: Scalars['String'];
  service: Scalars['String'];
}>;


export type BrandOrdersPageSynchronizeMutation = { __typename?: 'Mutation', StartSynchronize?: { __typename?: 'SyncResult', status: string } | null };

export type ShopDeleteMutationVariables = Exact<{
  shopId: Scalars['String'];
}>;


export type ShopDeleteMutation = { __typename?: 'Mutation', ShopDelete?: { __typename?: 'Shop', _id: any, name?: string | null } | null };

export type ShopLaunchMutationVariables = Exact<{
  shopId: Scalars['String'];
}>;


export type ShopLaunchMutation = { __typename?: 'Mutation', ShopLaunch?: { __typename?: 'Shop', _id: any } | null };

export type BrandPageBrandByIdQueryVariables = Exact<{
  shopId: Scalars['MongoID'];
}>;


export type BrandPageBrandByIdQuery = { __typename?: 'Query', ShopById?: { __typename?: 'Shop', _id: any, name?: string | null, live?: boolean | null, tradeInBaseUrl?: string | null, shopCollectionUrl?: string | null, currency?: string | null, disableContactResetDate?: Date | null } | null };

export type BrandProductListPaginationQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<FilterFindManyBrandProductInput>;
  sort?: InputMaybe<SortFindManyBrandProductInput>;
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
}>;


export type BrandProductListPaginationQuery = { __typename?: 'Query', BrandProductsPagination?: { __typename?: 'BrandProductBrandProductsPagination', count?: number | null, pageInfo: { __typename?: 'PaginationInfo', perPage: number, currentPage: number, hasNextPage?: boolean | null, hasPreviousPage?: boolean | null, itemCount?: number | null, pageCount?: number | null }, items?: Array<{ __typename?: 'BrandProduct', _id: any, style?: string | null, imageUrls?: Array<string> | null, nameLocalized: Array<{ __typename?: 'LocalizationEntry', locale: string, value: string } | null> }> | null } | null };

export type ProductPaginationFragment = { __typename?: 'BrandProduct', _id: any, style?: string | null, imageUrls?: Array<string> | null, nameLocalized: Array<{ __typename?: 'LocalizationEntry', locale: string, value: string } | null> };

export type BrandProductListSourcesQueryVariables = Exact<{
  brandHouseId: Scalars['MongoID'];
}>;


export type BrandProductListSourcesQuery = { __typename?: 'Query', BrandProductGroups: Array<{ __typename?: 'BrandProductGroup', _id: any, name: string, activePromotions?: boolean | null, active: boolean }> };

export type CampaignCreateMutationVariables = Exact<{
  input: CreateOneCampaignInput;
}>;


export type CampaignCreateMutation = { __typename?: 'Mutation', CampaignCreate?: { __typename?: 'CreateOneCampaignPayload', record?: { __typename?: 'Campaign', _id: any, campaignName: string, fromDate: Date, toDate: Date, percentage: number, disabled?: boolean | null, active: boolean, completed?: boolean | null, startedTs?: Date | null, endedTs?: Date | null } | null, error?: { __typename?: 'MongoError', message?: string | null } | { __typename?: 'RuntimeError', message?: string | null } | { __typename?: 'ValidationError', message?: string | null } | null } | null };

export type CampaignUpdateMutationVariables = Exact<{
  _id: Scalars['MongoID'];
  input: UpdateByIdCampaignInput;
}>;


export type CampaignUpdateMutation = { __typename?: 'Mutation', CampaignUpdate?: { __typename?: 'UpdateByIdCampaignPayload', record?: { __typename?: 'Campaign', _id: any, campaignName: string, fromDate: Date, toDate: Date, percentage: number, disabled?: boolean | null, active: boolean, completed?: boolean | null, startedTs?: Date | null, endedTs?: Date | null } | null, error?: { __typename?: 'MongoError', message?: string | null } | { __typename?: 'RuntimeError', message?: string | null } | { __typename?: 'ValidationError', message?: string | null } | null } | null };

export type CampaignsQueryVariables = Exact<{
  brandHouseId: Scalars['MongoID'];
}>;


export type CampaignsQuery = { __typename?: 'Query', Campaigns: Array<{ __typename?: 'Campaign', _id: any, campaignName: string, fromDate: Date, toDate: Date, percentage: number, disabled?: boolean | null, active: boolean, completed?: boolean | null, startedTs?: Date | null, endedTs?: Date | null }> };

export type CampaignFragment = { __typename?: 'Campaign', _id: any, campaignName: string, fromDate: Date, toDate: Date, percentage: number, disabled?: boolean | null, active: boolean, completed?: boolean | null, startedTs?: Date | null, endedTs?: Date | null };

export type ConsumerEventPaginationQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<FilterFindManyConsumerEventInput>;
  sort?: InputMaybe<SortFindManyConsumerEventInput>;
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
}>;


export type ConsumerEventPaginationQuery = { __typename?: 'Query', ConsumerEventPagination?: { __typename?: 'ConsumerEventConsumerEventPagination', count?: number | null, pageInfo: { __typename?: 'PaginationInfo', perPage: number, currentPage: number, hasNextPage?: boolean | null, hasPreviousPage?: boolean | null, itemCount?: number | null, pageCount?: number | null }, items?: Array<{ __typename?: 'ConsumerEvent', _id: any, dateTime: Date, consumerId: any, event: string, subEvent?: string | null, consumer?: { __typename?: 'Consumer', _id: any, firstName?: string | null, lastName?: string | null, mail?: string | null, selfCreated?: boolean | null } | null, maildata?: { __typename?: 'ConsumerEventMaildata', delivered?: boolean | null, opened?: boolean | null, clicked?: boolean | null, bounced?: boolean | null, spam?: boolean | null } | null }> | null } | null };

export type DashboardPageBrandQueryVariables = Exact<{
  id: Scalars['MongoID'];
}>;


export type DashboardPageBrandQuery = { __typename?: 'Query', BrandHouse?: { __typename?: 'BrandHouse', _id: any, name?: string | null, shops?: Array<{ __typename?: 'Shop', _id: any, name?: string | null, currency?: string | null, liveDate?: Date | null } | null> | null } | null };

export type MasterDataSearchProductFragment = { __typename?: 'MasterDataProduct', _id: string, externalId?: string | null, style?: string | null, name?: Array<{ __typename?: 'MasterDataLocalizedValue', locale: string, value: string } | null> | null, images?: Array<{ __typename?: 'MasterDataImage', _id?: string | null, thumbUrl?: string | null } | null> | null, options?: Array<{ __typename?: 'MasterDataProductOption', key: string, type?: string | null, name?: Array<{ __typename?: 'MasterDataLocalizedValue', locale: string, value: string } | null> | null } | null> | null, variants?: Array<{ __typename?: 'MasterDataVariant', _id: string, externalId?: string | null, sku?: string | null, ean?: string | null, options?: Array<{ __typename?: 'MasterDataKeyValue', key: string, value: string } | null> | null, images?: Array<{ __typename?: 'MasterDataImage', _id?: string | null, thumbUrl?: string | null } | null> | null } | null> | null };

export type MasterDataSearchDialogSearchQueryVariables = Exact<{
  brandHouseId: Scalars['MongoID'];
  search: Scalars['String'];
}>;


export type MasterDataSearchDialogSearchQuery = { __typename?: 'Query', BrandHouseMasterDataSearch?: Array<{ __typename?: 'MasterDataProduct', _id: string, externalId?: string | null, style?: string | null, name?: Array<{ __typename?: 'MasterDataLocalizedValue', locale: string, value: string } | null> | null, images?: Array<{ __typename?: 'MasterDataImage', _id?: string | null, thumbUrl?: string | null } | null> | null, options?: Array<{ __typename?: 'MasterDataProductOption', key: string, type?: string | null, name?: Array<{ __typename?: 'MasterDataLocalizedValue', locale: string, value: string } | null> | null } | null> | null, variants?: Array<{ __typename?: 'MasterDataVariant', _id: string, externalId?: string | null, sku?: string | null, ean?: string | null, options?: Array<{ __typename?: 'MasterDataKeyValue', key: string, value: string } | null> | null, images?: Array<{ __typename?: 'MasterDataImage', _id?: string | null, thumbUrl?: string | null } | null> | null } | null> | null } | null> | null };

export type MasterDataSearchDialogVisualQueryVariables = Exact<{
  brandHouseId: Scalars['MongoID'];
  imageUrl: Scalars['String'];
  maxResults?: InputMaybe<Scalars['Int']>;
}>;


export type MasterDataSearchDialogVisualQuery = { __typename?: 'Query', BrandHouseMasterDataVisualSearch?: Array<{ __typename?: 'MasterDataVisualSearchHit', score: number, imageUrl?: string | null, product?: { __typename?: 'MasterDataProduct', _id: string, externalId?: string | null, style?: string | null, name?: Array<{ __typename?: 'MasterDataLocalizedValue', locale: string, value: string } | null> | null, images?: Array<{ __typename?: 'MasterDataImage', _id?: string | null, thumbUrl?: string | null } | null> | null, options?: Array<{ __typename?: 'MasterDataProductOption', key: string, type?: string | null, name?: Array<{ __typename?: 'MasterDataLocalizedValue', locale: string, value: string } | null> | null } | null> | null, variants?: Array<{ __typename?: 'MasterDataVariant', _id: string, externalId?: string | null, sku?: string | null, ean?: string | null, options?: Array<{ __typename?: 'MasterDataKeyValue', key: string, value: string } | null> | null, images?: Array<{ __typename?: 'MasterDataImage', _id?: string | null, thumbUrl?: string | null } | null> | null } | null> | null } | null } | null> | null };

export type MasterDataSearchDialogUploadQueryVariables = Exact<{
  imageId: Scalars['MongoID'];
}>;


export type MasterDataSearchDialogUploadQuery = { __typename?: 'Query', Image?: { __typename?: 'ImageUpload', _id: any, url: string } | null };

export type ProformaOrderAddressesQueryVariables = Exact<{
  brandHouseId: Scalars['MongoID'];
  shopId: Scalars['MongoID'];
}>;


export type ProformaOrderAddressesQuery = { __typename?: 'Query', BrandHouse?: { __typename?: 'BrandHouse', _id: any, logisticsPartnerId: any, address?: { __typename?: 'AddressInfo', name?: string | null, attention?: string | null, add1?: string | null, add2?: string | null, zipCode?: string | null, city?: string | null, countryCode?: string | null, mail?: string | null, phone?: string | null } | null } | null, Shop?: { __typename?: 'Shop', _id: any, address?: { __typename?: 'AddressInfo', name?: string | null, attention?: string | null, add1?: string | null, add2?: string | null, zipCode?: string | null, city?: string | null, countryCode?: string | null, mail?: string | null, phone?: string | null } | null } | null };

export type ProformaOrderLogisticsPartnerQueryVariables = Exact<{
  logisticsPartnerId: Scalars['MongoID'];
}>;


export type ProformaOrderLogisticsPartnerQuery = { __typename?: 'Query', LogisticsPartner?: { __typename?: 'LogisticsPartner', _id: any, name?: string | null, address?: string | null, address2?: string | null, zipCode?: string | null, city?: string | null, country?: string | null, countryCode?: string | null, mail?: string | null, phone?: string | null } | null };

export type ProformaAddressInfoFragment = { __typename?: 'AddressInfo', name?: string | null, attention?: string | null, add1?: string | null, add2?: string | null, zipCode?: string | null, city?: string | null, countryCode?: string | null, mail?: string | null, phone?: string | null };

export type ProformaLogisticsPartnerAddressFragment = { __typename?: 'LogisticsPartner', _id: any, name?: string | null, address?: string | null, address2?: string | null, zipCode?: string | null, city?: string | null, country?: string | null, countryCode?: string | null, mail?: string | null, phone?: string | null };

export type RecalculatePricesMutationVariables = Exact<{
  brandHouseId: Scalars['MongoID'];
  input?: InputMaybe<BrandItemInputInput>;
}>;


export type RecalculatePricesMutation = { __typename?: 'Mutation', BrandItemCalculatePrices?: Array<{ __typename?: 'Pricing', value: number, currency: string } | null> | null };

export type ImageEditorImageQueryVariables = Exact<{
  imageId: Scalars['MongoID'];
}>;


export type ImageEditorImageQuery = { __typename?: 'Query', Image?: { __typename?: 'ImageUpload', _id: any, url: string } | null };

export type ItemEditorImageQueryVariables = Exact<{
  imageId: Scalars['MongoID'];
}>;


export type ItemEditorImageQuery = { __typename?: 'Query', Image?: { __typename?: 'ImageUpload', _id: any, url: string } | null };

export type ItemEditorImage2QueryVariables = Exact<{
  imageId: Scalars['MongoID'];
}>;


export type ItemEditorImage2Query = { __typename?: 'Query', StorageFileById?: { __typename?: 'StorageFile', _id: any, url: string } | null };

export type ItemEditorProductImageQueryVariables = Exact<{
  imageId: Scalars['MongoID'];
}>;


export type ItemEditorProductImageQuery = { __typename?: 'Query', BrandProductImage?: { __typename?: 'BrandProductImage', _id: any, imageUrl?: string | null } | null };

export type BrandItemImageQueryVariables = Exact<{
  imageId: Scalars['MongoID'];
}>;


export type BrandItemImageQuery = { __typename?: 'Query', BrandItemImage?: { __typename?: 'BrandItemImage', _id: any, processStart?: Date | null, processError?: string | null, imageId?: any | null, uploadId?: any | null, originalImage?: boolean | null } | null };

export type BrandItemMasterImagesQueryVariables = Exact<{
  brandItemId: Scalars['MongoID'];
}>;


export type BrandItemMasterImagesQuery = { __typename?: 'Query', BrandItemMasterImages?: Array<{ __typename?: 'BrandItemMasterImage', externId?: string | null, imageId?: string | null, imageUrl: string, color?: string | null, type?: ImageTypeEnum | null, perspective?: ImagePerspectiveEnum | null, altText?: string | null, sourceType?: BrandItemMasterImageSourceType | null } | null> | null };

export type BrandItemPageSettingsQueryVariables = Exact<{
  brandHouseId: Scalars['MongoID'];
}>;


export type BrandItemPageSettingsQuery = { __typename?: 'Query', ShopMany: Array<{ __typename?: 'Shop', _id: any, live?: boolean | null, settings?: { __typename?: 'BrandSetting', stockItemConfig?: { __typename?: 'BrandSettingStockItemConfig', masterImageTypes?: Array<EnumBrandSettingStockItemConfigMasterImageTypes | null> | null, masterImageCount?: number | null } | null } | null }> };

export type BrandOptionsQueryVariables = Exact<{
  brandHouseId: Scalars['MongoID'];
}>;


export type BrandOptionsQuery = { __typename?: 'Query', itemOptions: Array<{ __typename?: 'OptionSet', _id: any, key: string, title: string, valueType: EnumOptionSetValueType, values?: Array<{ __typename?: 'OptionValue', _id: any, value: string, label: string } | null> | null }>, itemColors: Array<{ __typename?: 'OptionSet', _id: any, key: string, title: string, valueType: EnumOptionSetValueType, values?: Array<{ __typename?: 'OptionValue', _id: any, value: string, label: string } | null> | null }>, itemVendors: Array<{ __typename?: 'OptionSet', _id: any, key: string, title: string, valueType: EnumOptionSetValueType, values?: Array<{ __typename?: 'OptionValue', _id: any, value: string, label: string } | null> | null }> };

export type OptionFragment = { __typename?: 'OptionSet', _id: any, key: string, title: string, valueType: EnumOptionSetValueType, values?: Array<{ __typename?: 'OptionValue', _id: any, value: string, label: string } | null> | null };

export type BrandItemQueryVariables = Exact<{
  brandItemId: Scalars['MongoID'];
}>;


export type BrandItemQuery = { __typename?: 'Query', BrandItem?: { __typename?: 'BrandItem', _id: any, createdAt?: Date | null, updatedAt?: Date | null, tradeInItemId?: any | null, vasId?: string | null, vasType?: BrandItemVasTypeEnum | null, vasImages?: Array<string | null> | null, sortorder?: number | null, disableRRPListPrice?: boolean | null, brandProductSizeId?: any | null, commentApproved?: boolean | null, condition: number, itemNr: number, itemState: EnumBrandItemItemState, itemEan: string, commodityCode?: string | null, countryOrigin?: string | null, originalEan?: string | null, originalSku?: string | null, stockLocation?: string | null, stockLocationBag?: string | null, checked?: Date | null, effectiveChecked: boolean, missing?: Date | null, effectiveMissing: boolean, unavailable?: Date | null, discarded?: Date | null, nfcTag?: string | null, note?: string | null, vendor?: string | null, sourceType?: ItemSourceType | null, test?: boolean | null, deleted?: boolean | null, masterDataVariantId?: string | null, resolved?: { __typename?: 'BrandItemResolved', _id: any, brandProductSizeId?: any | null, disableRRPListPrice?: boolean | null, sortorder?: number | null, commentApproved?: boolean | null, condition: number, itemNr: number, itemState: EnumBrandItemItemState, itemEan: string, vasId?: string | null, vasType?: BrandItemVasTypeEnum | null, commodityCode?: string | null, countryOrigin?: string | null, originalEan?: string | null, originalSku?: string | null, stockLocation?: string | null, stockLocationBag?: string | null, checked?: Date | null, effectiveChecked: boolean, missing?: Date | null, effectiveMissing: boolean, unavailable?: Date | null, discarded?: Date | null, nfcTag?: string | null, vendor?: string | null, sourceType?: ItemSourceType | null, nameLocalized?: Array<{ __typename?: 'LocalizationEntry', locale: string, value: string } | null> | null, descriptionLocalized?: Array<{ __typename?: 'LocalizationEntry', locale: string, value: string } | null> | null, colorLocalized?: Array<{ __typename?: 'LocalizationEntry', locale: string, value: string } | null> | null, sizeLocalized?: Array<{ __typename?: 'LocalizationEntry', locale: string, value: string } | null> | null, typeLocalized?: Array<{ __typename?: 'LocalizationEntry', locale: string, value: string } | null> | null, commentLocalized?: Array<{ __typename?: 'LocalizationEntry', locale: string, value: string } | null> | null, beforePrices?: Array<{ __typename?: 'Pricing', currency: string, value: number } | null> | null, itemTags?: Array<{ __typename?: 'BrandItemTag', auto?: boolean | null, tag?: string | null } | null> | null, problems?: Array<{ __typename?: 'BrandItemProblem', createdAt?: Date | null, description?: string | null, solved: boolean } | null> | null, images?: Array<{ __typename?: 'BrandItemImage', _id: any, uploadId?: any | null, uploadUrl?: string | null, imageId?: any | null, imageUrl?: string | null, altText?: string | null, process?: boolean | null, processStart?: Date | null, processError?: string | null, brandProductImageId?: any | null, brandProductImageUrl?: string | null, originalImage?: boolean | null } | null> | null, options?: Array<{ __typename?: 'OptionInstance', optionSetId: any, optionValueId?: any | null, optionValue?: string | null } | null> | null, masterDataInfo?: { __typename?: 'BrandItemMasterDataInfo', name?: string | null, sku?: string | null, size?: string | null, color?: string | null, ean?: string | null, externalId?: string | null } | null, masterDataProduct?: { __typename?: 'BrandProduct', _id: any } | null } | null, shops?: Array<{ __typename?: 'BrandItemShopInfo', shopId: any, active: boolean, shop?: { __typename?: 'Shop', live?: boolean | null } | null } | null> | null, updatedBy?: { __typename?: 'ObjectPatchesUpdatedBy', ref?: any | null, type: string } | null, tradeInItem?: { __typename?: 'TradeInItem', _id: any, tradeInId?: any | null, name?: string | null, value?: number | null, sku?: string | null, shopId?: any | null, tradeIn?: { __typename?: 'TradeIn', _id: any, consumerId: any, consumer?: { __typename?: 'Consumer', _id: any, name?: string | null } | null } | null, identifier?: { __typename?: 'TradeInItemIdentifier', color?: string | null, identity: string, origin?: TradeInItemIdentifierOrigin | null, type?: TradeInItemIdentifierType | null } | null, shop?: { __typename?: 'Shop', _id: any, name?: string | null, currency?: string | null } | null, potential?: { __typename?: 'Potential', _id: any, imageUrls?: Array<string> | null } | null } | null, nameLocalized?: Array<{ __typename?: 'LocalizationEntry', locale: string, value: string } | null> | null, descriptionLocalized?: Array<{ __typename?: 'LocalizationEntry', locale: string, value: string } | null> | null, colorLocalized?: Array<{ __typename?: 'LocalizationEntry', locale: string, value: string } | null> | null, sizeLocalized?: Array<{ __typename?: 'LocalizationEntry', locale: string, value: string } | null> | null, typeLocalized?: Array<{ __typename?: 'LocalizationEntry', locale: string, value: string } | null> | null, commentLocalized?: Array<{ __typename?: 'LocalizationEntry', locale: string, value: string } | null> | null, directPrices?: Array<{ __typename?: 'Pricing', currency: string, value: number } | null> | null, sellingPrices?: Array<{ __typename?: 'Pricing', currency: string, value: number } | null> | null, activeBoost?: { __typename?: 'BrandItemBoost', pricePct?: number | null, visibility: boolean, startTs: Date, endTs: Date, endedTs?: Date | null, active: boolean } | null, beforePrices?: Array<{ __typename?: 'Pricing', currency: string, value: number } | null> | null, problems?: Array<{ __typename?: 'BrandItemProblem', createdAt?: Date | null, description?: string | null, solved: boolean } | null> | null, images?: Array<{ __typename?: 'BrandItemImage', _id: any, uploadId?: any | null, uploadUrl?: string | null, imageId?: any | null, imageUrl?: string | null, altText?: string | null, process?: boolean | null, processStart?: Date | null, processError?: string | null, brandProductImageId?: any | null, brandProductImageUrl?: string | null, originalImage?: boolean | null } | null> | null, itemTags?: Array<{ __typename?: 'BrandItemTag', auto?: boolean | null, tag?: string | null } | null> | null, itemMetas?: Array<{ __typename?: 'MetaFieldInstance', namespace?: string | null, type?: EnumMetaFieldInstanceType | null, value: any, key: string, auto?: boolean | null } | null> | null, options?: Array<{ __typename?: 'OptionInstance', optionSetId: any, optionValueId?: any | null, optionValue?: string | null } | null> | null, reviewInfos?: Array<{ __typename?: 'BrandItemReviewInfo', type: string, value: string } | null> | null, masterDataProduct?: { __typename?: 'BrandProduct', _id: any } | null, masterDataSnapshot?: { __typename?: 'BrandItemMasterDataSnapshot', brandProductSizeId?: any | null } | null, invoiceLine?: { __typename?: 'InvoiceLine', invoice?: { __typename?: 'Invoice', invoiceId: string } | null } | null } | null };

export type BrandItemConflictCheckQueryVariables = Exact<{
  brandItemId: Scalars['MongoID'];
}>;


export type BrandItemConflictCheckQuery = { __typename?: 'Query', BrandItem?: { __typename?: 'BrandItem', _id: any, updatedAt?: Date | null, updatedBy?: { __typename?: 'ObjectPatchesUpdatedBy', ref?: any | null, type: string } | null } | null, PatchPagination?: { __typename?: 'ObjectPatchesPatchItem', items?: Array<{ __typename?: 'ObjectPatches', _id: any, date: Date, updatedBy?: { __typename?: 'ObjectPatchesUpdatedBy', ref?: any | null, type: string } | null, ops?: Array<{ __typename?: 'ObjectPatchesOps', op?: string | null, path?: string | null, value?: any | null } | null> | null }> | null } | null };

export type BrandItemPageProductVariantSizeQueryVariables = Exact<{
  brandProductSizeId: Scalars['MongoID'];
}>;


export type BrandItemPageProductVariantSizeQuery = { __typename?: 'Query', BrandProductSize?: { __typename?: 'BrandProductSize', _id: any, ean?: string | null, sku?: string | null, sizeLocalized: Array<{ __typename?: 'LocalizationEntry', locale: string, value: string } | null>, brandVariant?: { __typename?: 'BrandProductVariant', _id: any, brandProduct?: { __typename?: 'BrandProduct', vendor?: string | null, nameLocalized: Array<{ __typename?: 'LocalizationEntry', locale: string, value: string } | null>, descriptionLocalized: Array<{ __typename?: 'LocalizationEntry', locale: string, value: string } | null>, typeLocalized?: Array<{ __typename?: 'LocalizationEntry', locale: string, value: string } | null> | null } | null, rrp?: Array<{ __typename?: 'Pricing', currency: string, value: number } | null> | null, colorLocalized?: Array<{ __typename?: 'LocalizationEntry', locale: string, value: string } | null> | null, images?: Array<{ __typename?: 'BrandProductImage', _id: any, imageId?: any | null, imageUrl?: string | null, type?: EnumBrandProductImageType | null } | null> | null } | null } | null };

export type BrandItemUpdateMutationVariables = Exact<{
  brandHouseId: Scalars['MongoID'];
  input?: InputMaybe<BrandItemInputInput>;
}>;


export type BrandItemUpdateMutation = { __typename?: 'Mutation', BrandItemUpdate?: { __typename?: 'BrandItem', _id: any, createdAt?: Date | null, updatedAt?: Date | null, tradeInItemId?: any | null, vasId?: string | null, vasType?: BrandItemVasTypeEnum | null, vasImages?: Array<string | null> | null, sortorder?: number | null, disableRRPListPrice?: boolean | null, brandProductSizeId?: any | null, commentApproved?: boolean | null, condition: number, itemNr: number, itemState: EnumBrandItemItemState, itemEan: string, commodityCode?: string | null, countryOrigin?: string | null, originalEan?: string | null, originalSku?: string | null, stockLocation?: string | null, stockLocationBag?: string | null, checked?: Date | null, effectiveChecked: boolean, missing?: Date | null, effectiveMissing: boolean, unavailable?: Date | null, discarded?: Date | null, nfcTag?: string | null, note?: string | null, vendor?: string | null, sourceType?: ItemSourceType | null, test?: boolean | null, deleted?: boolean | null, masterDataVariantId?: string | null, resolved?: { __typename?: 'BrandItemResolved', _id: any, brandProductSizeId?: any | null, disableRRPListPrice?: boolean | null, sortorder?: number | null, commentApproved?: boolean | null, condition: number, itemNr: number, itemState: EnumBrandItemItemState, itemEan: string, vasId?: string | null, vasType?: BrandItemVasTypeEnum | null, commodityCode?: string | null, countryOrigin?: string | null, originalEan?: string | null, originalSku?: string | null, stockLocation?: string | null, stockLocationBag?: string | null, checked?: Date | null, effectiveChecked: boolean, missing?: Date | null, effectiveMissing: boolean, unavailable?: Date | null, discarded?: Date | null, nfcTag?: string | null, vendor?: string | null, sourceType?: ItemSourceType | null, nameLocalized?: Array<{ __typename?: 'LocalizationEntry', locale: string, value: string } | null> | null, descriptionLocalized?: Array<{ __typename?: 'LocalizationEntry', locale: string, value: string } | null> | null, colorLocalized?: Array<{ __typename?: 'LocalizationEntry', locale: string, value: string } | null> | null, sizeLocalized?: Array<{ __typename?: 'LocalizationEntry', locale: string, value: string } | null> | null, typeLocalized?: Array<{ __typename?: 'LocalizationEntry', locale: string, value: string } | null> | null, commentLocalized?: Array<{ __typename?: 'LocalizationEntry', locale: string, value: string } | null> | null, beforePrices?: Array<{ __typename?: 'Pricing', currency: string, value: number } | null> | null, itemTags?: Array<{ __typename?: 'BrandItemTag', auto?: boolean | null, tag?: string | null } | null> | null, problems?: Array<{ __typename?: 'BrandItemProblem', createdAt?: Date | null, description?: string | null, solved: boolean } | null> | null, images?: Array<{ __typename?: 'BrandItemImage', _id: any, uploadId?: any | null, uploadUrl?: string | null, imageId?: any | null, imageUrl?: string | null, altText?: string | null, process?: boolean | null, processStart?: Date | null, processError?: string | null, brandProductImageId?: any | null, brandProductImageUrl?: string | null, originalImage?: boolean | null } | null> | null, options?: Array<{ __typename?: 'OptionInstance', optionSetId: any, optionValueId?: any | null, optionValue?: string | null } | null> | null, masterDataInfo?: { __typename?: 'BrandItemMasterDataInfo', name?: string | null, sku?: string | null, size?: string | null, color?: string | null, ean?: string | null, externalId?: string | null } | null, masterDataProduct?: { __typename?: 'BrandProduct', _id: any } | null } | null, brandProductSize?: { __typename?: 'BrandProductSize', brandVariant?: { __typename?: 'BrandProductVariant', images?: Array<{ __typename?: 'BrandProductImage', _id: any } | null> | null } | null } | null, updatedBy?: { __typename?: 'ObjectPatchesUpdatedBy', ref?: any | null, type: string } | null, tradeInItem?: { __typename?: 'TradeInItem', _id: any, tradeInId?: any | null, name?: string | null, value?: number | null, sku?: string | null, shopId?: any | null, tradeIn?: { __typename?: 'TradeIn', _id: any, consumerId: any, consumer?: { __typename?: 'Consumer', _id: any, name?: string | null } | null } | null, identifier?: { __typename?: 'TradeInItemIdentifier', color?: string | null, identity: string, origin?: TradeInItemIdentifierOrigin | null, type?: TradeInItemIdentifierType | null } | null, shop?: { __typename?: 'Shop', _id: any, name?: string | null, currency?: string | null } | null, potential?: { __typename?: 'Potential', _id: any, imageUrls?: Array<string> | null } | null } | null, nameLocalized?: Array<{ __typename?: 'LocalizationEntry', locale: string, value: string } | null> | null, descriptionLocalized?: Array<{ __typename?: 'LocalizationEntry', locale: string, value: string } | null> | null, colorLocalized?: Array<{ __typename?: 'LocalizationEntry', locale: string, value: string } | null> | null, sizeLocalized?: Array<{ __typename?: 'LocalizationEntry', locale: string, value: string } | null> | null, typeLocalized?: Array<{ __typename?: 'LocalizationEntry', locale: string, value: string } | null> | null, commentLocalized?: Array<{ __typename?: 'LocalizationEntry', locale: string, value: string } | null> | null, directPrices?: Array<{ __typename?: 'Pricing', currency: string, value: number } | null> | null, sellingPrices?: Array<{ __typename?: 'Pricing', currency: string, value: number } | null> | null, activeBoost?: { __typename?: 'BrandItemBoost', pricePct?: number | null, visibility: boolean, startTs: Date, endTs: Date, endedTs?: Date | null, active: boolean } | null, beforePrices?: Array<{ __typename?: 'Pricing', currency: string, value: number } | null> | null, problems?: Array<{ __typename?: 'BrandItemProblem', createdAt?: Date | null, description?: string | null, solved: boolean } | null> | null, images?: Array<{ __typename?: 'BrandItemImage', _id: any, uploadId?: any | null, uploadUrl?: string | null, imageId?: any | null, imageUrl?: string | null, altText?: string | null, process?: boolean | null, processStart?: Date | null, processError?: string | null, brandProductImageId?: any | null, brandProductImageUrl?: string | null, originalImage?: boolean | null } | null> | null, itemTags?: Array<{ __typename?: 'BrandItemTag', auto?: boolean | null, tag?: string | null } | null> | null, itemMetas?: Array<{ __typename?: 'MetaFieldInstance', namespace?: string | null, type?: EnumMetaFieldInstanceType | null, value: any, key: string, auto?: boolean | null } | null> | null, options?: Array<{ __typename?: 'OptionInstance', optionSetId: any, optionValueId?: any | null, optionValue?: string | null } | null> | null, reviewInfos?: Array<{ __typename?: 'BrandItemReviewInfo', type: string, value: string } | null> | null, masterDataProduct?: { __typename?: 'BrandProduct', _id: any } | null, masterDataSnapshot?: { __typename?: 'BrandItemMasterDataSnapshot', brandProductSizeId?: any | null } | null, invoiceLine?: { __typename?: 'InvoiceLine', invoice?: { __typename?: 'Invoice', invoiceId: string } | null } | null } | null };

export type BrandItemAttachSnapshotMutationVariables = Exact<{
  brandItemId: Scalars['MongoID'];
  brandProductSizeId: Scalars['MongoID'];
}>;


export type BrandItemAttachSnapshotMutation = { __typename?: 'Mutation', BrandItemAttachSnapshot?: { __typename?: 'BrandItem', _id: any, createdAt?: Date | null, updatedAt?: Date | null, tradeInItemId?: any | null, vasId?: string | null, vasType?: BrandItemVasTypeEnum | null, vasImages?: Array<string | null> | null, sortorder?: number | null, disableRRPListPrice?: boolean | null, brandProductSizeId?: any | null, commentApproved?: boolean | null, condition: number, itemNr: number, itemState: EnumBrandItemItemState, itemEan: string, commodityCode?: string | null, countryOrigin?: string | null, originalEan?: string | null, originalSku?: string | null, stockLocation?: string | null, stockLocationBag?: string | null, checked?: Date | null, effectiveChecked: boolean, missing?: Date | null, effectiveMissing: boolean, unavailable?: Date | null, discarded?: Date | null, nfcTag?: string | null, note?: string | null, vendor?: string | null, sourceType?: ItemSourceType | null, test?: boolean | null, deleted?: boolean | null, masterDataVariantId?: string | null, resolved?: { __typename?: 'BrandItemResolved', _id: any, brandProductSizeId?: any | null, disableRRPListPrice?: boolean | null, sortorder?: number | null, commentApproved?: boolean | null, condition: number, itemNr: number, itemState: EnumBrandItemItemState, itemEan: string, vasId?: string | null, vasType?: BrandItemVasTypeEnum | null, commodityCode?: string | null, countryOrigin?: string | null, originalEan?: string | null, originalSku?: string | null, stockLocation?: string | null, stockLocationBag?: string | null, checked?: Date | null, effectiveChecked: boolean, missing?: Date | null, effectiveMissing: boolean, unavailable?: Date | null, discarded?: Date | null, nfcTag?: string | null, vendor?: string | null, sourceType?: ItemSourceType | null, nameLocalized?: Array<{ __typename?: 'LocalizationEntry', locale: string, value: string } | null> | null, descriptionLocalized?: Array<{ __typename?: 'LocalizationEntry', locale: string, value: string } | null> | null, colorLocalized?: Array<{ __typename?: 'LocalizationEntry', locale: string, value: string } | null> | null, sizeLocalized?: Array<{ __typename?: 'LocalizationEntry', locale: string, value: string } | null> | null, typeLocalized?: Array<{ __typename?: 'LocalizationEntry', locale: string, value: string } | null> | null, commentLocalized?: Array<{ __typename?: 'LocalizationEntry', locale: string, value: string } | null> | null, beforePrices?: Array<{ __typename?: 'Pricing', currency: string, value: number } | null> | null, itemTags?: Array<{ __typename?: 'BrandItemTag', auto?: boolean | null, tag?: string | null } | null> | null, problems?: Array<{ __typename?: 'BrandItemProblem', createdAt?: Date | null, description?: string | null, solved: boolean } | null> | null, images?: Array<{ __typename?: 'BrandItemImage', _id: any, uploadId?: any | null, uploadUrl?: string | null, imageId?: any | null, imageUrl?: string | null, altText?: string | null, process?: boolean | null, processStart?: Date | null, processError?: string | null, brandProductImageId?: any | null, brandProductImageUrl?: string | null, originalImage?: boolean | null } | null> | null, options?: Array<{ __typename?: 'OptionInstance', optionSetId: any, optionValueId?: any | null, optionValue?: string | null } | null> | null, masterDataInfo?: { __typename?: 'BrandItemMasterDataInfo', name?: string | null, sku?: string | null, size?: string | null, color?: string | null, ean?: string | null, externalId?: string | null } | null, masterDataProduct?: { __typename?: 'BrandProduct', _id: any } | null } | null, updatedBy?: { __typename?: 'ObjectPatchesUpdatedBy', ref?: any | null, type: string } | null, tradeInItem?: { __typename?: 'TradeInItem', _id: any, tradeInId?: any | null, name?: string | null, value?: number | null, sku?: string | null, shopId?: any | null, tradeIn?: { __typename?: 'TradeIn', _id: any, consumerId: any, consumer?: { __typename?: 'Consumer', _id: any, name?: string | null } | null } | null, identifier?: { __typename?: 'TradeInItemIdentifier', color?: string | null, identity: string, origin?: TradeInItemIdentifierOrigin | null, type?: TradeInItemIdentifierType | null } | null, shop?: { __typename?: 'Shop', _id: any, name?: string | null, currency?: string | null } | null, potential?: { __typename?: 'Potential', _id: any, imageUrls?: Array<string> | null } | null } | null, nameLocalized?: Array<{ __typename?: 'LocalizationEntry', locale: string, value: string } | null> | null, descriptionLocalized?: Array<{ __typename?: 'LocalizationEntry', locale: string, value: string } | null> | null, colorLocalized?: Array<{ __typename?: 'LocalizationEntry', locale: string, value: string } | null> | null, sizeLocalized?: Array<{ __typename?: 'LocalizationEntry', locale: string, value: string } | null> | null, typeLocalized?: Array<{ __typename?: 'LocalizationEntry', locale: string, value: string } | null> | null, commentLocalized?: Array<{ __typename?: 'LocalizationEntry', locale: string, value: string } | null> | null, directPrices?: Array<{ __typename?: 'Pricing', currency: string, value: number } | null> | null, sellingPrices?: Array<{ __typename?: 'Pricing', currency: string, value: number } | null> | null, activeBoost?: { __typename?: 'BrandItemBoost', pricePct?: number | null, visibility: boolean, startTs: Date, endTs: Date, endedTs?: Date | null, active: boolean } | null, beforePrices?: Array<{ __typename?: 'Pricing', currency: string, value: number } | null> | null, problems?: Array<{ __typename?: 'BrandItemProblem', createdAt?: Date | null, description?: string | null, solved: boolean } | null> | null, images?: Array<{ __typename?: 'BrandItemImage', _id: any, uploadId?: any | null, uploadUrl?: string | null, imageId?: any | null, imageUrl?: string | null, altText?: string | null, process?: boolean | null, processStart?: Date | null, processError?: string | null, brandProductImageId?: any | null, brandProductImageUrl?: string | null, originalImage?: boolean | null } | null> | null, itemTags?: Array<{ __typename?: 'BrandItemTag', auto?: boolean | null, tag?: string | null } | null> | null, itemMetas?: Array<{ __typename?: 'MetaFieldInstance', namespace?: string | null, type?: EnumMetaFieldInstanceType | null, value: any, key: string, auto?: boolean | null } | null> | null, options?: Array<{ __typename?: 'OptionInstance', optionSetId: any, optionValueId?: any | null, optionValue?: string | null } | null> | null, reviewInfos?: Array<{ __typename?: 'BrandItemReviewInfo', type: string, value: string } | null> | null, masterDataProduct?: { __typename?: 'BrandProduct', _id: any } | null, masterDataSnapshot?: { __typename?: 'BrandItemMasterDataSnapshot', brandProductSizeId?: any | null } | null, invoiceLine?: { __typename?: 'InvoiceLine', invoice?: { __typename?: 'Invoice', invoiceId: string } | null } | null } | null };

export type BrandItemAttachMasterDataVariantMutationVariables = Exact<{
  brandItemId: Scalars['MongoID'];
  masterDataVariantId: Scalars['String'];
}>;


export type BrandItemAttachMasterDataVariantMutation = { __typename?: 'Mutation', BrandItemAttachMasterDataVariant?: { __typename?: 'BrandItem', _id: any, createdAt?: Date | null, updatedAt?: Date | null, tradeInItemId?: any | null, vasId?: string | null, vasType?: BrandItemVasTypeEnum | null, vasImages?: Array<string | null> | null, sortorder?: number | null, disableRRPListPrice?: boolean | null, brandProductSizeId?: any | null, commentApproved?: boolean | null, condition: number, itemNr: number, itemState: EnumBrandItemItemState, itemEan: string, commodityCode?: string | null, countryOrigin?: string | null, originalEan?: string | null, originalSku?: string | null, stockLocation?: string | null, stockLocationBag?: string | null, checked?: Date | null, effectiveChecked: boolean, missing?: Date | null, effectiveMissing: boolean, unavailable?: Date | null, discarded?: Date | null, nfcTag?: string | null, note?: string | null, vendor?: string | null, sourceType?: ItemSourceType | null, test?: boolean | null, deleted?: boolean | null, masterDataVariantId?: string | null, resolved?: { __typename?: 'BrandItemResolved', _id: any, brandProductSizeId?: any | null, disableRRPListPrice?: boolean | null, sortorder?: number | null, commentApproved?: boolean | null, condition: number, itemNr: number, itemState: EnumBrandItemItemState, itemEan: string, vasId?: string | null, vasType?: BrandItemVasTypeEnum | null, commodityCode?: string | null, countryOrigin?: string | null, originalEan?: string | null, originalSku?: string | null, stockLocation?: string | null, stockLocationBag?: string | null, checked?: Date | null, effectiveChecked: boolean, missing?: Date | null, effectiveMissing: boolean, unavailable?: Date | null, discarded?: Date | null, nfcTag?: string | null, vendor?: string | null, sourceType?: ItemSourceType | null, nameLocalized?: Array<{ __typename?: 'LocalizationEntry', locale: string, value: string } | null> | null, descriptionLocalized?: Array<{ __typename?: 'LocalizationEntry', locale: string, value: string } | null> | null, colorLocalized?: Array<{ __typename?: 'LocalizationEntry', locale: string, value: string } | null> | null, sizeLocalized?: Array<{ __typename?: 'LocalizationEntry', locale: string, value: string } | null> | null, typeLocalized?: Array<{ __typename?: 'LocalizationEntry', locale: string, value: string } | null> | null, commentLocalized?: Array<{ __typename?: 'LocalizationEntry', locale: string, value: string } | null> | null, beforePrices?: Array<{ __typename?: 'Pricing', currency: string, value: number } | null> | null, itemTags?: Array<{ __typename?: 'BrandItemTag', auto?: boolean | null, tag?: string | null } | null> | null, problems?: Array<{ __typename?: 'BrandItemProblem', createdAt?: Date | null, description?: string | null, solved: boolean } | null> | null, images?: Array<{ __typename?: 'BrandItemImage', _id: any, uploadId?: any | null, uploadUrl?: string | null, imageId?: any | null, imageUrl?: string | null, altText?: string | null, process?: boolean | null, processStart?: Date | null, processError?: string | null, brandProductImageId?: any | null, brandProductImageUrl?: string | null, originalImage?: boolean | null } | null> | null, options?: Array<{ __typename?: 'OptionInstance', optionSetId: any, optionValueId?: any | null, optionValue?: string | null } | null> | null, masterDataInfo?: { __typename?: 'BrandItemMasterDataInfo', name?: string | null, sku?: string | null, size?: string | null, color?: string | null, ean?: string | null, externalId?: string | null } | null, masterDataProduct?: { __typename?: 'BrandProduct', _id: any } | null } | null, updatedBy?: { __typename?: 'ObjectPatchesUpdatedBy', ref?: any | null, type: string } | null, tradeInItem?: { __typename?: 'TradeInItem', _id: any, tradeInId?: any | null, name?: string | null, value?: number | null, sku?: string | null, shopId?: any | null, tradeIn?: { __typename?: 'TradeIn', _id: any, consumerId: any, consumer?: { __typename?: 'Consumer', _id: any, name?: string | null } | null } | null, identifier?: { __typename?: 'TradeInItemIdentifier', color?: string | null, identity: string, origin?: TradeInItemIdentifierOrigin | null, type?: TradeInItemIdentifierType | null } | null, shop?: { __typename?: 'Shop', _id: any, name?: string | null, currency?: string | null } | null, potential?: { __typename?: 'Potential', _id: any, imageUrls?: Array<string> | null } | null } | null, nameLocalized?: Array<{ __typename?: 'LocalizationEntry', locale: string, value: string } | null> | null, descriptionLocalized?: Array<{ __typename?: 'LocalizationEntry', locale: string, value: string } | null> | null, colorLocalized?: Array<{ __typename?: 'LocalizationEntry', locale: string, value: string } | null> | null, sizeLocalized?: Array<{ __typename?: 'LocalizationEntry', locale: string, value: string } | null> | null, typeLocalized?: Array<{ __typename?: 'LocalizationEntry', locale: string, value: string } | null> | null, commentLocalized?: Array<{ __typename?: 'LocalizationEntry', locale: string, value: string } | null> | null, directPrices?: Array<{ __typename?: 'Pricing', currency: string, value: number } | null> | null, sellingPrices?: Array<{ __typename?: 'Pricing', currency: string, value: number } | null> | null, activeBoost?: { __typename?: 'BrandItemBoost', pricePct?: number | null, visibility: boolean, startTs: Date, endTs: Date, endedTs?: Date | null, active: boolean } | null, beforePrices?: Array<{ __typename?: 'Pricing', currency: string, value: number } | null> | null, problems?: Array<{ __typename?: 'BrandItemProblem', createdAt?: Date | null, description?: string | null, solved: boolean } | null> | null, images?: Array<{ __typename?: 'BrandItemImage', _id: any, uploadId?: any | null, uploadUrl?: string | null, imageId?: any | null, imageUrl?: string | null, altText?: string | null, process?: boolean | null, processStart?: Date | null, processError?: string | null, brandProductImageId?: any | null, brandProductImageUrl?: string | null, originalImage?: boolean | null } | null> | null, itemTags?: Array<{ __typename?: 'BrandItemTag', auto?: boolean | null, tag?: string | null } | null> | null, itemMetas?: Array<{ __typename?: 'MetaFieldInstance', namespace?: string | null, type?: EnumMetaFieldInstanceType | null, value: any, key: string, auto?: boolean | null } | null> | null, options?: Array<{ __typename?: 'OptionInstance', optionSetId: any, optionValueId?: any | null, optionValue?: string | null } | null> | null, reviewInfos?: Array<{ __typename?: 'BrandItemReviewInfo', type: string, value: string } | null> | null, masterDataProduct?: { __typename?: 'BrandProduct', _id: any } | null, masterDataSnapshot?: { __typename?: 'BrandItemMasterDataSnapshot', brandProductSizeId?: any | null } | null, invoiceLine?: { __typename?: 'InvoiceLine', invoice?: { __typename?: 'Invoice', invoiceId: string } | null } | null } | null };

export type FragmentBrandItemFragment = { __typename?: 'BrandItem', _id: any, createdAt?: Date | null, updatedAt?: Date | null, tradeInItemId?: any | null, vasId?: string | null, vasType?: BrandItemVasTypeEnum | null, vasImages?: Array<string | null> | null, sortorder?: number | null, disableRRPListPrice?: boolean | null, brandProductSizeId?: any | null, commentApproved?: boolean | null, condition: number, itemNr: number, itemState: EnumBrandItemItemState, itemEan: string, commodityCode?: string | null, countryOrigin?: string | null, originalEan?: string | null, originalSku?: string | null, stockLocation?: string | null, stockLocationBag?: string | null, checked?: Date | null, effectiveChecked: boolean, missing?: Date | null, effectiveMissing: boolean, unavailable?: Date | null, discarded?: Date | null, nfcTag?: string | null, note?: string | null, vendor?: string | null, sourceType?: ItemSourceType | null, test?: boolean | null, deleted?: boolean | null, masterDataVariantId?: string | null, updatedBy?: { __typename?: 'ObjectPatchesUpdatedBy', ref?: any | null, type: string } | null, tradeInItem?: { __typename?: 'TradeInItem', _id: any, tradeInId?: any | null, name?: string | null, value?: number | null, sku?: string | null, shopId?: any | null, tradeIn?: { __typename?: 'TradeIn', _id: any, consumerId: any, consumer?: { __typename?: 'Consumer', _id: any, name?: string | null } | null } | null, identifier?: { __typename?: 'TradeInItemIdentifier', color?: string | null, identity: string, origin?: TradeInItemIdentifierOrigin | null, type?: TradeInItemIdentifierType | null } | null, shop?: { __typename?: 'Shop', _id: any, name?: string | null, currency?: string | null } | null, potential?: { __typename?: 'Potential', _id: any, imageUrls?: Array<string> | null } | null } | null, nameLocalized?: Array<{ __typename?: 'LocalizationEntry', locale: string, value: string } | null> | null, descriptionLocalized?: Array<{ __typename?: 'LocalizationEntry', locale: string, value: string } | null> | null, colorLocalized?: Array<{ __typename?: 'LocalizationEntry', locale: string, value: string } | null> | null, sizeLocalized?: Array<{ __typename?: 'LocalizationEntry', locale: string, value: string } | null> | null, typeLocalized?: Array<{ __typename?: 'LocalizationEntry', locale: string, value: string } | null> | null, commentLocalized?: Array<{ __typename?: 'LocalizationEntry', locale: string, value: string } | null> | null, directPrices?: Array<{ __typename?: 'Pricing', currency: string, value: number } | null> | null, sellingPrices?: Array<{ __typename?: 'Pricing', currency: string, value: number } | null> | null, activeBoost?: { __typename?: 'BrandItemBoost', pricePct?: number | null, visibility: boolean, startTs: Date, endTs: Date, endedTs?: Date | null, active: boolean } | null, beforePrices?: Array<{ __typename?: 'Pricing', currency: string, value: number } | null> | null, problems?: Array<{ __typename?: 'BrandItemProblem', createdAt?: Date | null, description?: string | null, solved: boolean } | null> | null, images?: Array<{ __typename?: 'BrandItemImage', _id: any, uploadId?: any | null, uploadUrl?: string | null, imageId?: any | null, imageUrl?: string | null, altText?: string | null, process?: boolean | null, processStart?: Date | null, processError?: string | null, brandProductImageId?: any | null, brandProductImageUrl?: string | null, originalImage?: boolean | null } | null> | null, itemTags?: Array<{ __typename?: 'BrandItemTag', auto?: boolean | null, tag?: string | null } | null> | null, itemMetas?: Array<{ __typename?: 'MetaFieldInstance', namespace?: string | null, type?: EnumMetaFieldInstanceType | null, value: any, key: string, auto?: boolean | null } | null> | null, options?: Array<{ __typename?: 'OptionInstance', optionSetId: any, optionValueId?: any | null, optionValue?: string | null } | null> | null, reviewInfos?: Array<{ __typename?: 'BrandItemReviewInfo', type: string, value: string } | null> | null, masterDataProduct?: { __typename?: 'BrandProduct', _id: any } | null, masterDataSnapshot?: { __typename?: 'BrandItemMasterDataSnapshot', brandProductSizeId?: any | null } | null, invoiceLine?: { __typename?: 'InvoiceLine', invoice?: { __typename?: 'Invoice', invoiceId: string } | null } | null };

export type FragmentBrandItemResolvedFragment = { __typename?: 'BrandItemResolved', _id: any, brandProductSizeId?: any | null, disableRRPListPrice?: boolean | null, sortorder?: number | null, commentApproved?: boolean | null, condition: number, itemNr: number, itemState: EnumBrandItemItemState, itemEan: string, vasId?: string | null, vasType?: BrandItemVasTypeEnum | null, commodityCode?: string | null, countryOrigin?: string | null, originalEan?: string | null, originalSku?: string | null, stockLocation?: string | null, stockLocationBag?: string | null, checked?: Date | null, effectiveChecked: boolean, missing?: Date | null, effectiveMissing: boolean, unavailable?: Date | null, discarded?: Date | null, nfcTag?: string | null, vendor?: string | null, sourceType?: ItemSourceType | null, nameLocalized?: Array<{ __typename?: 'LocalizationEntry', locale: string, value: string } | null> | null, descriptionLocalized?: Array<{ __typename?: 'LocalizationEntry', locale: string, value: string } | null> | null, colorLocalized?: Array<{ __typename?: 'LocalizationEntry', locale: string, value: string } | null> | null, sizeLocalized?: Array<{ __typename?: 'LocalizationEntry', locale: string, value: string } | null> | null, typeLocalized?: Array<{ __typename?: 'LocalizationEntry', locale: string, value: string } | null> | null, commentLocalized?: Array<{ __typename?: 'LocalizationEntry', locale: string, value: string } | null> | null, beforePrices?: Array<{ __typename?: 'Pricing', currency: string, value: number } | null> | null, itemTags?: Array<{ __typename?: 'BrandItemTag', auto?: boolean | null, tag?: string | null } | null> | null, problems?: Array<{ __typename?: 'BrandItemProblem', createdAt?: Date | null, description?: string | null, solved: boolean } | null> | null, images?: Array<{ __typename?: 'BrandItemImage', _id: any, uploadId?: any | null, uploadUrl?: string | null, imageId?: any | null, imageUrl?: string | null, altText?: string | null, process?: boolean | null, processStart?: Date | null, processError?: string | null, brandProductImageId?: any | null, brandProductImageUrl?: string | null, originalImage?: boolean | null } | null> | null, options?: Array<{ __typename?: 'OptionInstance', optionSetId: any, optionValueId?: any | null, optionValue?: string | null } | null> | null, masterDataInfo?: { __typename?: 'BrandItemMasterDataInfo', name?: string | null, sku?: string | null, size?: string | null, color?: string | null, ean?: string | null, externalId?: string | null } | null, masterDataProduct?: { __typename?: 'BrandProduct', _id: any } | null };

export type BrandItemSettingsQueryVariables = Exact<{
  brandHouseId: Scalars['MongoID'];
}>;


export type BrandItemSettingsQuery = { __typename?: 'Query', BrandSettings?: { __typename?: 'BrandSetting', _id?: any | null, tradeInComments?: boolean | null, locales?: Array<{ __typename?: 'BrandLocale', locale: string, activeItems?: boolean | null } | null> | null, stockItemConfig?: { __typename?: 'BrandSettingStockItemConfig', titlePrefix?: string | null, vendor?: string | null, currencies?: Array<{ __typename?: 'Currency', currency: string, active?: boolean | null } | null> | null } | null } | null, ShopMany: Array<{ __typename?: 'Shop', _id: any, live?: boolean | null, settings?: { __typename?: 'BrandSetting', stockItemConfig?: { __typename?: 'BrandSettingStockItemConfig', titlePrefix?: string | null, vendor?: string | null } | null } | null }>, BrandHouse?: { __typename?: 'BrandHouse', _id: any, productTags?: Array<string> | null, productTypes?: Array<{ __typename?: 'LocalizationEntry', locale: string, value: string } | null> | null } | null };

export type BrandItemPageDeleteMutationVariables = Exact<{
  brandItemId: Scalars['MongoID'];
}>;


export type BrandItemPageDeleteMutation = { __typename?: 'Mutation', BrandItemDelete?: { __typename?: 'BrandItem', _id: any, deleted?: boolean | null } | null };

export type BrandItemMasterDataQueryVariables = Exact<{
  brandProductSizeId: Scalars['MongoID'];
}>;


export type BrandItemMasterDataQuery = { __typename?: 'Query', BrandProductSize?: { __typename?: 'BrandProductSize', externalId: string, ean?: string | null, sku?: string | null, brandVariant?: { __typename?: 'BrandProductVariant', _id: any, color?: string | null, imageUrls?: Array<string> | null, colorLocalized?: Array<{ __typename?: 'LocalizationEntry', locale: string, value: string } | null> | null, brandProduct?: { __typename?: 'BrandProduct', _id: any, collections?: Array<string | null> | null, tags?: Array<string | null> | null, name?: string | null, nameLocalized: Array<{ __typename?: 'LocalizationEntry', locale: string, value: string } | null> } | null, images?: Array<{ __typename?: 'BrandProductImage', _id: any, imageId?: any | null, imageUrl?: string | null, type?: EnumBrandProductImageType | null } | null> | null } | null } | null };

export type PromoteToMasterDataMutationVariables = Exact<{
  brandItemId: Scalars['MongoID'];
}>;


export type PromoteToMasterDataMutation = { __typename?: 'Mutation', BrandItemPromote?: { __typename?: 'BrandItem', _id: any, createdAt?: Date | null, updatedAt?: Date | null, tradeInItemId?: any | null, vasId?: string | null, vasType?: BrandItemVasTypeEnum | null, vasImages?: Array<string | null> | null, sortorder?: number | null, disableRRPListPrice?: boolean | null, brandProductSizeId?: any | null, commentApproved?: boolean | null, condition: number, itemNr: number, itemState: EnumBrandItemItemState, itemEan: string, commodityCode?: string | null, countryOrigin?: string | null, originalEan?: string | null, originalSku?: string | null, stockLocation?: string | null, stockLocationBag?: string | null, checked?: Date | null, effectiveChecked: boolean, missing?: Date | null, effectiveMissing: boolean, unavailable?: Date | null, discarded?: Date | null, nfcTag?: string | null, note?: string | null, vendor?: string | null, sourceType?: ItemSourceType | null, test?: boolean | null, deleted?: boolean | null, masterDataVariantId?: string | null, resolved?: { __typename?: 'BrandItemResolved', _id: any, brandProductSizeId?: any | null, disableRRPListPrice?: boolean | null, sortorder?: number | null, commentApproved?: boolean | null, condition: number, itemNr: number, itemState: EnumBrandItemItemState, itemEan: string, vasId?: string | null, vasType?: BrandItemVasTypeEnum | null, commodityCode?: string | null, countryOrigin?: string | null, originalEan?: string | null, originalSku?: string | null, stockLocation?: string | null, stockLocationBag?: string | null, checked?: Date | null, effectiveChecked: boolean, missing?: Date | null, effectiveMissing: boolean, unavailable?: Date | null, discarded?: Date | null, nfcTag?: string | null, vendor?: string | null, sourceType?: ItemSourceType | null, nameLocalized?: Array<{ __typename?: 'LocalizationEntry', locale: string, value: string } | null> | null, descriptionLocalized?: Array<{ __typename?: 'LocalizationEntry', locale: string, value: string } | null> | null, colorLocalized?: Array<{ __typename?: 'LocalizationEntry', locale: string, value: string } | null> | null, sizeLocalized?: Array<{ __typename?: 'LocalizationEntry', locale: string, value: string } | null> | null, typeLocalized?: Array<{ __typename?: 'LocalizationEntry', locale: string, value: string } | null> | null, commentLocalized?: Array<{ __typename?: 'LocalizationEntry', locale: string, value: string } | null> | null, beforePrices?: Array<{ __typename?: 'Pricing', currency: string, value: number } | null> | null, itemTags?: Array<{ __typename?: 'BrandItemTag', auto?: boolean | null, tag?: string | null } | null> | null, problems?: Array<{ __typename?: 'BrandItemProblem', createdAt?: Date | null, description?: string | null, solved: boolean } | null> | null, images?: Array<{ __typename?: 'BrandItemImage', _id: any, uploadId?: any | null, uploadUrl?: string | null, imageId?: any | null, imageUrl?: string | null, altText?: string | null, process?: boolean | null, processStart?: Date | null, processError?: string | null, brandProductImageId?: any | null, brandProductImageUrl?: string | null, originalImage?: boolean | null } | null> | null, options?: Array<{ __typename?: 'OptionInstance', optionSetId: any, optionValueId?: any | null, optionValue?: string | null } | null> | null, masterDataInfo?: { __typename?: 'BrandItemMasterDataInfo', name?: string | null, sku?: string | null, size?: string | null, color?: string | null, ean?: string | null, externalId?: string | null } | null, masterDataProduct?: { __typename?: 'BrandProduct', _id: any } | null } | null, updatedBy?: { __typename?: 'ObjectPatchesUpdatedBy', ref?: any | null, type: string } | null, tradeInItem?: { __typename?: 'TradeInItem', _id: any, tradeInId?: any | null, name?: string | null, value?: number | null, sku?: string | null, shopId?: any | null, tradeIn?: { __typename?: 'TradeIn', _id: any, consumerId: any, consumer?: { __typename?: 'Consumer', _id: any, name?: string | null } | null } | null, identifier?: { __typename?: 'TradeInItemIdentifier', color?: string | null, identity: string, origin?: TradeInItemIdentifierOrigin | null, type?: TradeInItemIdentifierType | null } | null, shop?: { __typename?: 'Shop', _id: any, name?: string | null, currency?: string | null } | null, potential?: { __typename?: 'Potential', _id: any, imageUrls?: Array<string> | null } | null } | null, nameLocalized?: Array<{ __typename?: 'LocalizationEntry', locale: string, value: string } | null> | null, descriptionLocalized?: Array<{ __typename?: 'LocalizationEntry', locale: string, value: string } | null> | null, colorLocalized?: Array<{ __typename?: 'LocalizationEntry', locale: string, value: string } | null> | null, sizeLocalized?: Array<{ __typename?: 'LocalizationEntry', locale: string, value: string } | null> | null, typeLocalized?: Array<{ __typename?: 'LocalizationEntry', locale: string, value: string } | null> | null, commentLocalized?: Array<{ __typename?: 'LocalizationEntry', locale: string, value: string } | null> | null, directPrices?: Array<{ __typename?: 'Pricing', currency: string, value: number } | null> | null, sellingPrices?: Array<{ __typename?: 'Pricing', currency: string, value: number } | null> | null, activeBoost?: { __typename?: 'BrandItemBoost', pricePct?: number | null, visibility: boolean, startTs: Date, endTs: Date, endedTs?: Date | null, active: boolean } | null, beforePrices?: Array<{ __typename?: 'Pricing', currency: string, value: number } | null> | null, problems?: Array<{ __typename?: 'BrandItemProblem', createdAt?: Date | null, description?: string | null, solved: boolean } | null> | null, images?: Array<{ __typename?: 'BrandItemImage', _id: any, uploadId?: any | null, uploadUrl?: string | null, imageId?: any | null, imageUrl?: string | null, altText?: string | null, process?: boolean | null, processStart?: Date | null, processError?: string | null, brandProductImageId?: any | null, brandProductImageUrl?: string | null, originalImage?: boolean | null } | null> | null, itemTags?: Array<{ __typename?: 'BrandItemTag', auto?: boolean | null, tag?: string | null } | null> | null, itemMetas?: Array<{ __typename?: 'MetaFieldInstance', namespace?: string | null, type?: EnumMetaFieldInstanceType | null, value: any, key: string, auto?: boolean | null } | null> | null, options?: Array<{ __typename?: 'OptionInstance', optionSetId: any, optionValueId?: any | null, optionValue?: string | null } | null> | null, reviewInfos?: Array<{ __typename?: 'BrandItemReviewInfo', type: string, value: string } | null> | null, masterDataProduct?: { __typename?: 'BrandProduct', _id: any } | null, masterDataSnapshot?: { __typename?: 'BrandItemMasterDataSnapshot', brandProductSizeId?: any | null } | null, invoiceLine?: { __typename?: 'InvoiceLine', invoice?: { __typename?: 'Invoice', invoiceId: string } | null } | null } | null };

export type RelatedIdentifiersQueryVariables = Exact<{
  brandItemId: Scalars['MongoID'];
}>;


export type RelatedIdentifiersQuery = { __typename?: 'Query', BrandItemRelatedIdentifiers: Array<string> };

export type ItemIssuesQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<FilterFindManyItemIssueInput>;
  sort?: InputMaybe<SortFindManyItemIssueInput>;
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
}>;


export type ItemIssuesQuery = { __typename?: 'Query', ItemIssues?: { __typename?: 'ItemIssueItemIssuesPagination', count?: number | null, items?: Array<{ __typename?: 'ItemIssue', _id: any, brandHouseId: any, brandItemId: any, location?: EnumItemIssueLocation | null, point?: string | null, markX?: number | null, markY?: number | null, issue: string, imageUrl?: string | null, processedUrl?: string | null, createdAt?: Date | null, brandItem?: { __typename?: 'BrandItemResolved', itemSku: string, nameLocalized?: Array<{ __typename?: 'LocalizationEntry', locale: string, value: string } | null> | null, brandHouse?: { __typename?: 'BrandHouse', _id: any, name?: string | null } | null } | null }> | null } | null };

export type ItemIssueFragment = { __typename?: 'ItemIssue', _id: any, brandHouseId: any, brandItemId: any, location?: EnumItemIssueLocation | null, point?: string | null, markX?: number | null, markY?: number | null, issue: string, imageUrl?: string | null, processedUrl?: string | null, createdAt?: Date | null, brandItem?: { __typename?: 'BrandItemResolved', itemSku: string, nameLocalized?: Array<{ __typename?: 'LocalizationEntry', locale: string, value: string } | null> | null, brandHouse?: { __typename?: 'BrandHouse', _id: any, name?: string | null } | null } | null };

export type BrandConsumersPagePaginationQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<SortFindManyConsumerInput>;
  filter?: InputMaybe<FilterFindManyConsumerInput>;
  viewId?: InputMaybe<Scalars['MongoID']>;
}>;


export type BrandConsumersPagePaginationQuery = { __typename?: 'Query', ConsumerPagination?: { __typename?: 'ConsumerConsumerPagination', count?: number | null, items?: Array<{ __typename?: 'Consumer', _id: any, name?: string | null, firstName?: string | null, lastName?: string | null, mail?: string | null, phone?: string | null, add1?: string | null, add2?: string | null, zipCode?: string | null, city?: string | null, country?: string | null, countryCode?: string | null, acceptsMarketing?: boolean | null, selfCreated?: boolean | null, proxyAccount?: boolean | null, shopId?: any | null, createdAt?: Date | null, lastLogin?: Date | null, statistics?: { __typename?: 'ConsumerStatistics', tradeIns?: number | null, orders?: number | null } | null, shop?: { __typename?: 'Shop', _id: any, name?: string | null } | null }> | null } | null };

export type BrandConsumersPageSelectAllQueryVariables = Exact<{
  filter?: InputMaybe<FilterFindManyConsumerInput>;
  viewId?: InputMaybe<Scalars['MongoID']>;
}>;


export type BrandConsumersPageSelectAllQuery = { __typename?: 'Query', ConsumerPagination?: { __typename?: 'ConsumerConsumerPagination', items?: Array<{ __typename?: 'Consumer', _id: any }> | null } | null };

export type BrandConsumersPageShopsQueryVariables = Exact<{
  brandHouseId: Scalars['MongoID'];
}>;


export type BrandConsumersPageShopsQuery = { __typename?: 'Query', ShopMany: Array<{ __typename?: 'Shop', _id: any, name?: string | null }> };

export type BrandConsumersPageMergeMutationVariables = Exact<{
  consumerIds: Array<Scalars['MongoID']> | Scalars['MongoID'];
}>;


export type BrandConsumersPageMergeMutation = { __typename?: 'Mutation', ConsumerMerge?: { __typename?: 'Consumer', id?: string | null } | null };

export type BrandConsumersPageRequestPotentialsMutationVariables = Exact<{
  shopId: Scalars['MongoID'];
  identifier: Scalars['String'];
  identifierType: ConsumerIdentifierEnum;
}>;


export type BrandConsumersPageRequestPotentialsMutation = { __typename?: 'Mutation', ConsumerRequestPotentials?: Array<string> | null };

export type BrandConsumersPageIntegrationMessageQueryVariables = Exact<{
  tokens?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type BrandConsumersPageIntegrationMessageQuery = { __typename?: 'Query', IntegrationMessage?: Array<{ __typename?: 'IntegrationMessageResult', result?: any | null, messageFailed?: boolean | null, resultTs?: Date | null } | null> | null };

export type BrandConsumersPageRequestPotentialsShopsQueryVariables = Exact<{
  brandHouseId: Scalars['MongoID'];
}>;


export type BrandConsumersPageRequestPotentialsShopsQuery = { __typename?: 'Query', ShopMany: Array<{ __typename?: 'Shop', _id: any, name?: string | null }> };

export type DashboardBrandItemDrilldownItemsQueryVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['MongoID']> | Scalars['MongoID']>;
}>;


export type DashboardBrandItemDrilldownItemsQuery = { __typename?: 'Query', BrandItems?: Array<{ __typename?: 'BrandItem', _id: any, itemNr: number, itemState: EnumBrandItemItemState, discarded?: Date | null, soldTs?: Date | null, resolved?: { __typename?: 'BrandItemResolved', _id: any, brandHouseId: any, brandProductSizeId?: any | null, itemNr: number, itemSku: string, tradeInItemId?: any | null, isTradeIn: boolean, createdAt?: Date | null, condition: number, imageUrls?: Array<string> | null, originalSku?: string | null, originalEan?: string | null, itemEan: string, itemState: EnumBrandItemItemState, checked?: Date | null, effectiveChecked: boolean, effectiveMissing: boolean, stockLocation?: string | null, stockLocationTs?: Date | null, stockLocationBag?: string | null, isSold: boolean, soldTs?: Date | null, isInSeason: boolean, note?: string | null, hasErrors: boolean, hasProblems?: boolean | null, hasComment?: boolean | null, hasTranslatedComment?: boolean | null, commentApproved?: boolean | null, stateAggregation?: BrandItemAggregatedStateEnum | null, sortorder?: number | null, invalidManufacturer?: boolean | null, vendor?: string | null, test?: boolean | null, legacyGroup: boolean, externalId?: string | null, vasId?: string | null, brandHouse?: { __typename?: 'BrandHouse', _id: any, name?: string | null } | null, nameLocalized?: Array<{ __typename?: 'LocalizationEntry', locale: string, value: string } | null> | null, descriptionLocalized?: Array<{ __typename?: 'LocalizationEntry', locale: string, value: string } | null> | null, typeLocalized?: Array<{ __typename?: 'LocalizationEntry', locale: string, value: string } | null> | null, images?: Array<{ __typename?: 'BrandItemImage', process?: boolean | null, imageId?: any | null, imageUrl?: string | null, brandProductImageUrl?: string | null } | null> | null, beforePrices?: Array<{ __typename?: 'Pricing', currency: string, value: number } | null> | null, sellingPrices?: Array<{ __typename?: 'Pricing', currency: string, value: number } | null> | null, activeBoost?: { __typename?: 'BrandItemBoost', pricePct?: number | null, visibility: boolean, startTs: Date, endTs: Date, endedTs?: Date | null, active: boolean } | null, colorLocalized?: Array<{ __typename?: 'LocalizationEntry', locale: string, value: string } | null> | null, sizeLocalized?: Array<{ __typename?: 'LocalizationEntry', locale: string, value: string } | null> | null, commentLocalized?: Array<{ __typename?: 'LocalizationEntry', locale: string, value: string } | null> | null, options?: Array<{ __typename?: 'OptionInstance', key: string, value: string } | null> | null, shops?: Array<{ __typename?: 'BrandItemShopInfo', _id: any, shopId: any, active: boolean } | null> | null, problems?: Array<{ __typename?: 'BrandItemProblem', solved: boolean, description?: string | null, createdAt?: Date | null } | null> | null, vas?: Array<{ __typename?: 'BrandItemVas', vasId: string, vasName: string, completedBy?: string | null, sortingOrder?: number | null } | null> | null, attributes?: { __typename?: 'BrandItemAttributes', type: EnumBrandItemAttributesType, apparentFabricType: EnumBrandItemAttributesApparentFabricType, formalityLevel: EnumBrandItemAttributesFormalityLevel, neckline?: EnumBrandItemAttributesNeckline | null, pattern: EnumBrandItemAttributesPattern, primaryColor: EnumBrandItemAttributesPrimaryColor, seasonSuitability?: Array<EnumBrandItemAttributesSeasonSuitability | null> | null, secondaryColors?: Array<EnumBrandItemAttributesSecondaryColors | null> | null, textureAppearance: EnumBrandItemAttributesTextureAppearance } | null, reviewInfos?: Array<{ __typename?: 'BrandItemReviewInfo', type: string, value: string } | null> | null } | null } | null> | null };

export type DashboardBrandItemTimelineQueryVariables = Exact<{
  brandItemId: Scalars['MongoID'];
  brandHouseId: Scalars['MongoID'];
}>;


export type DashboardBrandItemTimelineQuery = { __typename?: 'Query', BrandItem?: { __typename?: 'BrandItem', _id: any, createdAt?: Date | null, daysForSale?: number | null, discarded?: Date | null, firstListedDate?: Date | null, soldTs?: Date | null, views?: number | null, tradeInItem?: { __typename?: 'TradeInItem', _id: any, createdAt?: Date | null, tradeIn?: { __typename?: 'TradeIn', _id: any, dateTime: Date, registeredTs?: Date | null, tradeInNr?: number | null } | null } | null, vas?: Array<{ __typename?: 'BrandItemVas', vasId: string, vasName: string, completed: boolean, completedDate?: Date | null, workflowName?: string | null } | null> | null, shops?: Array<{ __typename?: 'BrandItemShopInfo', _id: any, shop?: { __typename?: 'Shop', _id: any, name?: string | null } | null, stockItem?: { __typename?: 'StockItemResolved', _id: any, orderlines?: Array<{ __typename?: 'Order2Item', _id: any, cancelled?: boolean | null, returned?: boolean | null, returnedTs?: Date | null, order?: { __typename?: 'Order2', _id: any, orderName?: string | null, orderDate: Date, returnLines?: Array<{ __typename?: 'Order2ItemReturn', _id: any, createdAt?: Date | null, orderLineId: any, returnReason: string } | null> | null } | null } | null> | null } | null } | null> | null } | null, Options: Array<{ __typename?: 'OptionSet', _id: any, key: string, title: string, valueType: EnumOptionSetValueType, values?: Array<{ __typename?: 'OptionValue', _id: any, value: string, label: string } | null> | null }> };

export type MasterDataProductSettingsQueryVariables = Exact<{
  brandHouseId: Scalars['MongoID'];
}>;


export type MasterDataProductSettingsQuery = { __typename?: 'Query', BrandSettings?: { __typename?: 'BrandSetting', _id?: any | null, locales?: Array<{ __typename?: 'BrandLocale', activeItems?: boolean | null, locale: string } | null> | null, stockItemConfig?: { __typename?: 'BrandSettingStockItemConfig', currencies?: Array<{ __typename?: 'Currency', currency: string, active?: boolean | null } | null> | null } | null } | null };

export type MasterDataProductQueryVariables = Exact<{
  id: Scalars['MongoID'];
}>;


export type MasterDataProductQuery = { __typename?: 'Query', BrandProduct?: { __typename?: 'BrandProduct', _id: any, groupId: any, externalId: string, brandHouseId?: any | null, createdAt?: Date | null, updatedAt?: Date | null, source?: string | null, disabled?: boolean | null, deleted?: boolean | null, collections?: Array<string | null> | null, tags?: Array<string | null> | null, disableRRPListPrice?: boolean | null, vendor?: string | null, nameLocalized: Array<{ __typename?: 'LocalizationEntry', value: string, locale: string } | null>, descriptionLocalized: Array<{ __typename?: 'LocalizationEntry', value: string, locale: string } | null>, typeLocalized?: Array<{ __typename?: 'LocalizationEntry', value: string, locale: string } | null> | null, metaFields?: Array<{ __typename?: 'MetaField', key: string, namespace?: string | null, type?: EnumMetaFieldType | null, value: any, customData?: any | null } | null> | null, localizedMetaFields?: Array<{ __typename?: 'LocalizedMetaFieldInstance', language?: string | null, metaFields?: Array<{ __typename?: 'MetaField', key: string, namespace?: string | null, type?: EnumMetaFieldType | null, value: any, customData?: any | null } | null> | null } | null> | null, variants?: Array<{ __typename?: 'BrandProductVariant', _id: any, externalId: string, sku?: string | null, deleted?: boolean | null, deactivated?: boolean | null, commodityCode?: string | null, countryOrigin?: string | null, colorLocalized?: Array<{ __typename?: 'LocalizationEntry', value: string, locale: string } | null> | null, metaFields?: Array<{ __typename?: 'MetaField', namespace?: string | null, type?: EnumMetaFieldType | null, value: any, customData?: any | null } | null> | null, rrp?: Array<{ __typename?: 'Pricing', currency: string, value: number } | null> | null, sizes?: Array<{ __typename?: 'BrandProductSize', _id: any, externalId: string, sku?: string | null, ean?: string | null, deleted?: boolean | null, sizeLocalized: Array<{ __typename?: 'LocalizationEntry', value: string, locale: string } | null>, metaFields?: Array<{ __typename?: 'MetaField', namespace?: string | null, type?: EnumMetaFieldType | null, value: any, customData?: any | null } | null> | null } | null> | null, images?: Array<{ __typename?: 'BrandProductImage', _id: any, externalId: string, deleted?: boolean | null, imageAltText?: string | null, imageId?: any | null, originalId?: any | null, colors?: Array<string | null> | null, type?: EnumBrandProductImageType | null, perspective?: EnumBrandProductImagePerspective | null, imageUrl?: string | null } | null> | null } | null> | null } | null };

export type MasterDataSynchronizeMutationVariables = Exact<{
  brandHouseId: Scalars['MongoID'];
  input: BrandProductSynchronizeInput;
}>;


export type MasterDataSynchronizeMutation = { __typename?: 'Mutation', BrandProductSynchronize?: { __typename?: 'BrandProduct', _id: any, groupId: any, externalId: string, brandHouseId?: any | null, createdAt?: Date | null, updatedAt?: Date | null, source?: string | null, disabled?: boolean | null, deleted?: boolean | null, collections?: Array<string | null> | null, tags?: Array<string | null> | null, disableRRPListPrice?: boolean | null, vendor?: string | null, nameLocalized: Array<{ __typename?: 'LocalizationEntry', value: string, locale: string } | null>, descriptionLocalized: Array<{ __typename?: 'LocalizationEntry', value: string, locale: string } | null>, typeLocalized?: Array<{ __typename?: 'LocalizationEntry', value: string, locale: string } | null> | null, metaFields?: Array<{ __typename?: 'MetaField', key: string, namespace?: string | null, type?: EnumMetaFieldType | null, value: any, customData?: any | null } | null> | null, localizedMetaFields?: Array<{ __typename?: 'LocalizedMetaFieldInstance', language?: string | null, metaFields?: Array<{ __typename?: 'MetaField', key: string, namespace?: string | null, type?: EnumMetaFieldType | null, value: any, customData?: any | null } | null> | null } | null> | null, variants?: Array<{ __typename?: 'BrandProductVariant', _id: any, externalId: string, sku?: string | null, deleted?: boolean | null, deactivated?: boolean | null, commodityCode?: string | null, countryOrigin?: string | null, colorLocalized?: Array<{ __typename?: 'LocalizationEntry', value: string, locale: string } | null> | null, metaFields?: Array<{ __typename?: 'MetaField', namespace?: string | null, type?: EnumMetaFieldType | null, value: any, customData?: any | null } | null> | null, rrp?: Array<{ __typename?: 'Pricing', currency: string, value: number } | null> | null, sizes?: Array<{ __typename?: 'BrandProductSize', _id: any, externalId: string, sku?: string | null, ean?: string | null, deleted?: boolean | null, sizeLocalized: Array<{ __typename?: 'LocalizationEntry', value: string, locale: string } | null>, metaFields?: Array<{ __typename?: 'MetaField', namespace?: string | null, type?: EnumMetaFieldType | null, value: any, customData?: any | null } | null> | null } | null> | null, images?: Array<{ __typename?: 'BrandProductImage', _id: any, externalId: string, deleted?: boolean | null, imageAltText?: string | null, imageId?: any | null, originalId?: any | null, colors?: Array<string | null> | null, type?: EnumBrandProductImageType | null, perspective?: EnumBrandProductImagePerspective | null, imageUrl?: string | null } | null> | null } | null> | null } | null };

export type BrandProductFragment = { __typename?: 'BrandProduct', _id: any, groupId: any, externalId: string, brandHouseId?: any | null, createdAt?: Date | null, updatedAt?: Date | null, source?: string | null, disabled?: boolean | null, deleted?: boolean | null, collections?: Array<string | null> | null, tags?: Array<string | null> | null, disableRRPListPrice?: boolean | null, vendor?: string | null, nameLocalized: Array<{ __typename?: 'LocalizationEntry', value: string, locale: string } | null>, descriptionLocalized: Array<{ __typename?: 'LocalizationEntry', value: string, locale: string } | null>, typeLocalized?: Array<{ __typename?: 'LocalizationEntry', value: string, locale: string } | null> | null, metaFields?: Array<{ __typename?: 'MetaField', key: string, namespace?: string | null, type?: EnumMetaFieldType | null, value: any, customData?: any | null } | null> | null, localizedMetaFields?: Array<{ __typename?: 'LocalizedMetaFieldInstance', language?: string | null, metaFields?: Array<{ __typename?: 'MetaField', key: string, namespace?: string | null, type?: EnumMetaFieldType | null, value: any, customData?: any | null } | null> | null } | null> | null, variants?: Array<{ __typename?: 'BrandProductVariant', _id: any, externalId: string, sku?: string | null, deleted?: boolean | null, deactivated?: boolean | null, commodityCode?: string | null, countryOrigin?: string | null, colorLocalized?: Array<{ __typename?: 'LocalizationEntry', value: string, locale: string } | null> | null, metaFields?: Array<{ __typename?: 'MetaField', namespace?: string | null, type?: EnumMetaFieldType | null, value: any, customData?: any | null } | null> | null, rrp?: Array<{ __typename?: 'Pricing', currency: string, value: number } | null> | null, sizes?: Array<{ __typename?: 'BrandProductSize', _id: any, externalId: string, sku?: string | null, ean?: string | null, deleted?: boolean | null, sizeLocalized: Array<{ __typename?: 'LocalizationEntry', value: string, locale: string } | null>, metaFields?: Array<{ __typename?: 'MetaField', namespace?: string | null, type?: EnumMetaFieldType | null, value: any, customData?: any | null } | null> | null } | null> | null, images?: Array<{ __typename?: 'BrandProductImage', _id: any, externalId: string, deleted?: boolean | null, imageAltText?: string | null, imageId?: any | null, originalId?: any | null, colors?: Array<string | null> | null, type?: EnumBrandProductImageType | null, perspective?: EnumBrandProductImagePerspective | null, imageUrl?: string | null } | null> | null } | null> | null };

export type GroupsQueryVariables = Exact<{
  brandHouseId: Scalars['MongoID'];
}>;


export type GroupsQuery = { __typename?: 'Query', BrandProductGroups: Array<{ __typename?: 'BrandProductGroup', _id: any, name: string, active: boolean, activePotentials?: boolean | null, activePromotions?: boolean | null }> };

export type GroupCreateMutationVariables = Exact<{
  input: CreateOneBrandProductGroupInput;
}>;


export type GroupCreateMutation = { __typename?: 'Mutation', BrandProductGroupCreate?: { __typename?: 'CreateOneBrandProductGroupPayload', recordId?: any | null, record?: { __typename?: 'BrandProductGroup', _id: any, name: string, active: boolean, activePotentials?: boolean | null, activePromotions?: boolean | null } | null, error?: { __typename?: 'MongoError', message?: string | null } | { __typename?: 'RuntimeError', message?: string | null } | { __typename?: 'ValidationError', message?: string | null } | null } | null };

export type GroupUpdateMutationVariables = Exact<{
  groupId: Scalars['MongoID'];
  input: UpdateByIdBrandProductGroupInput;
}>;


export type GroupUpdateMutation = { __typename?: 'Mutation', BrandProductGroupUpdate?: { __typename?: 'UpdateByIdBrandProductGroupPayload', recordId?: any | null, record?: { __typename?: 'BrandProductGroup', _id: any, name: string, active: boolean, activePotentials?: boolean | null, activePromotions?: boolean | null } | null, error?: { __typename?: 'MongoError', message?: string | null } | { __typename?: 'RuntimeError', message?: string | null } | { __typename?: 'ValidationError', message?: string | null } | null } | null };

export type GroupFragment = { __typename?: 'BrandProductGroup', _id: any, name: string, active: boolean, activePotentials?: boolean | null, activePromotions?: boolean | null };

export type MasterDataGroupsQueryVariables = Exact<{
  brandHouseId: Scalars['MongoID'];
}>;


export type MasterDataGroupsQuery = { __typename?: 'Query', BrandProductGroups: Array<{ __typename?: 'BrandProductGroup', _id: any, name: string, active: boolean }> };

export type MasterDataPageShopsQueryVariables = Exact<{
  brandHouseId: Scalars['MongoID'];
}>;


export type MasterDataPageShopsQuery = { __typename?: 'Query', ShopMany: Array<{ __typename?: 'Shop', _id: any, name?: string | null }> };

export type MasterDataSyncBrandMutationVariables = Exact<{
  refId: Scalars['MongoID'];
  arguments?: InputMaybe<Array<Scalars['JSON']> | Scalars['JSON']>;
}>;


export type MasterDataSyncBrandMutation = { __typename?: 'Mutation', IntegrationMessageExecute?: Array<string> | null };

export type MasterDataSyncShopMutationVariables = Exact<{
  refId: Scalars['MongoID'];
  arguments?: InputMaybe<Array<Scalars['JSON']> | Scalars['JSON']>;
}>;


export type MasterDataSyncShopMutation = { __typename?: 'Mutation', IntegrationMessageExecute?: Array<string> | null };

export type BrandTradeInDialogVariantsQueryVariables = Exact<{
  brandProductId?: InputMaybe<Scalars['MongoID']>;
}>;


export type BrandTradeInDialogVariantsQuery = { __typename?: 'Query', BrandProductVariants: Array<{ __typename?: 'BrandProductVariant', _id: any, imageUrls?: Array<string> | null, brandProduct?: { __typename?: 'BrandProduct', _id: any, nameLocalized: Array<{ __typename?: 'LocalizationEntry', locale: string, value: string } | null> } | null, sizes?: Array<{ __typename?: 'BrandProductSize', _id: any, ean?: string | null, sku?: string | null, sizeLocalized: Array<{ __typename?: 'LocalizationEntry', value: string, locale: string } | null>, brandVariant?: { __typename?: 'BrandProductVariant', _id: any, colorLocalized?: Array<{ __typename?: 'LocalizationEntry', value: string, locale: string } | null> | null, brandProduct?: { __typename?: 'BrandProduct', nameLocalized: Array<{ __typename?: 'LocalizationEntry', value: string, locale: string } | null> } | null } | null } | null> | null, colorLocalized?: Array<{ __typename?: 'LocalizationEntry', locale: string, value: string } | null> | null }> };

export type BrandTradeInDialogFragment = { __typename?: 'BrandProductVariant', _id: any, imageUrls?: Array<string> | null, brandProduct?: { __typename?: 'BrandProduct', _id: any, nameLocalized: Array<{ __typename?: 'LocalizationEntry', locale: string, value: string } | null> } | null, sizes?: Array<{ __typename?: 'BrandProductSize', _id: any, ean?: string | null, sku?: string | null, sizeLocalized: Array<{ __typename?: 'LocalizationEntry', value: string, locale: string } | null>, brandVariant?: { __typename?: 'BrandProductVariant', _id: any, colorLocalized?: Array<{ __typename?: 'LocalizationEntry', value: string, locale: string } | null> | null, brandProduct?: { __typename?: 'BrandProduct', nameLocalized: Array<{ __typename?: 'LocalizationEntry', value: string, locale: string } | null> } | null } | null } | null> | null, colorLocalized?: Array<{ __typename?: 'LocalizationEntry', locale: string, value: string } | null> | null };

export type BrandTradeInSizeFragment = { __typename?: 'BrandProductSize', _id: any, ean?: string | null, sku?: string | null, sizeLocalized: Array<{ __typename?: 'LocalizationEntry', value: string, locale: string } | null>, brandVariant?: { __typename?: 'BrandProductVariant', _id: any, colorLocalized?: Array<{ __typename?: 'LocalizationEntry', value: string, locale: string } | null> | null, brandProduct?: { __typename?: 'BrandProduct', nameLocalized: Array<{ __typename?: 'LocalizationEntry', value: string, locale: string } | null> } | null } | null };

export type BrandTradeInSettingsQueryVariables = Exact<{
  brandHouseID: Scalars['MongoID'];
}>;


export type BrandTradeInSettingsQuery = { __typename?: 'Query', BrandSettings?: { __typename?: 'BrandSetting', _id?: any | null, useBrandItems?: boolean | null } | null };

export type BrandTradeInQueryVariables = Exact<{
  tradeInId: Scalars['MongoID'];
}>;


export type BrandTradeInQuery = { __typename?: 'Query', TradeInById?: { __typename?: 'TradeIn', _id: any, dateTime: Date, registered?: boolean | null, registeredTs?: Date | null, comment?: string | null, notified?: boolean | null, shippingType?: string | null, shippingCarrierId?: any | null, tradeInNr?: number | null, deliveryNoteUrl: string, shopId: any, hasBonus?: boolean | null, shippingLabelId?: any | null, consumerId: any, payoutType?: EnumTradeInPayoutType | null, shop?: { __typename?: 'Shop', currency?: string | null, _id: any, tradeInBaseUrl?: string | null, categories?: Array<{ __typename?: 'WholeSaleCategory', _id: any, name: string, value: number } | null> | null, conditions?: Array<{ __typename?: 'ShopConditionPublic', condition: number, name: string, description: string } | null> | null } | null, vouchers?: Array<{ __typename?: 'Voucher', _id: any, value?: number | null, currency?: string | null, code?: string | null, voucherStrategy?: EnumVoucherVoucherStrategy | null, activated: boolean, used?: Date | null, payoutValue?: number | null } | null> | null, label?: { __typename?: 'ShippingLabel', deliveryDate?: Date | null, deliveryStatus?: EnumShippingLabelDeliveryStatus | null, url?: string | null, qrUrl?: string | null, trackingUrl?: string | null, carrier?: { __typename?: 'ShippingCarrier', carrierId?: string | null, name?: string | null } | null } | null, consumer?: { __typename?: 'Consumer', _id: any, language?: string | null, externalId?: string | null, id?: string | null, name?: string | null, add1?: string | null, add2?: string | null, zipCode?: string | null, country?: string | null, countryCode?: string | null, mail?: string | null, acceptsMarketing?: boolean | null, personId?: string | null, currency: string } | null } | null };

export type BrandWholeSaleCreateMutationVariables = Exact<{
  consumerId: Scalars['MongoID'];
  categoryId: Scalars['MongoID'];
}>;


export type BrandWholeSaleCreateMutation = { __typename?: 'Mutation', PotentialCreate?: { __typename?: 'Potential', _id: any } | null };

export type BrandTradeInItemsQueryVariables = Exact<{
  tradeInId: Scalars['MongoID'];
}>;


export type BrandTradeInItemsQuery = { __typename?: 'Query', TradeInItems3?: Array<{ __typename?: 'TradeInItem', _id: any, name?: string | null, sku?: string | null, size?: string | null, color?: string | null, condition?: number | null, externUrl?: string | null, rejected?: EnumTradeInItemRejected | null, brandProductSizeId?: any | null, productVariantId?: any | null, brandProductVariantId?: any | null, imageUrls?: Array<string> | null, itemValue?: number | null, currency?: string | null, bonus?: number | null, brandItem?: { __typename?: 'BrandItem', condition: number, _id: any } | null, productVariant?: { __typename?: 'ProductVariant', _id: any, color?: string | null, size?: string | null, sku?: string | null, product?: { __typename?: 'Product', _id: any, name: string } | null } | null, brandProductVariant?: { __typename?: 'BrandProductVariant', _id: any, brandProduct?: { __typename?: 'BrandProduct', _id: any, tags?: Array<string | null> | null, nameLocalized: Array<{ __typename?: 'LocalizationEntry', locale: string, value: string } | null> } | null, colorLocalized?: Array<{ __typename?: 'LocalizationEntry', value: string, locale: string } | null> | null, sizes?: Array<{ __typename?: 'BrandProductSize', _id: any, sku?: string | null, ean?: string | null, sizeLocalized: Array<{ __typename?: 'LocalizationEntry', value: string, locale: string } | null> } | null> | null, images?: Array<{ __typename?: 'BrandProductImage', _id: any } | null> | null } | null, wholeSale?: { __typename?: 'PotentialWholeSale', categoryId?: any | null, name?: string | null, value?: number | null } | null, stockItem?: { __typename?: 'StockItem', _id: any, shopId: any } | null, potential?: { __typename?: 'Potential', externUrl?: string | null, rrp?: number | null, sp?: number | null } | null } | null> | null };

export type BrandTradeInFragment = { __typename?: 'TradeIn', _id: any, dateTime: Date, registered?: boolean | null, registeredTs?: Date | null, comment?: string | null, notified?: boolean | null, shippingType?: string | null, shippingCarrierId?: any | null, tradeInNr?: number | null, deliveryNoteUrl: string, shopId: any, hasBonus?: boolean | null, shippingLabelId?: any | null, consumerId: any, payoutType?: EnumTradeInPayoutType | null, shop?: { __typename?: 'Shop', _id: any, tradeInBaseUrl?: string | null, currency?: string | null, conditions?: Array<{ __typename?: 'ShopConditionPublic', condition: number, name: string, description: string } | null> | null } | null, vouchers?: Array<{ __typename?: 'Voucher', _id: any, value?: number | null, currency?: string | null, code?: string | null, voucherStrategy?: EnumVoucherVoucherStrategy | null, activated: boolean, used?: Date | null, payoutValue?: number | null } | null> | null, label?: { __typename?: 'ShippingLabel', deliveryDate?: Date | null, deliveryStatus?: EnumShippingLabelDeliveryStatus | null, url?: string | null, qrUrl?: string | null, trackingUrl?: string | null, carrier?: { __typename?: 'ShippingCarrier', carrierId?: string | null, name?: string | null } | null } | null, consumer?: { __typename?: 'Consumer', _id: any, language?: string | null, externalId?: string | null, id?: string | null, name?: string | null, add1?: string | null, add2?: string | null, zipCode?: string | null, country?: string | null, countryCode?: string | null, mail?: string | null, acceptsMarketing?: boolean | null, personId?: string | null, currency: string } | null };

export type BrandTradeInUpdateMutationVariables = Exact<{
  id: Scalars['MongoID'];
  input: TradeInUpdateInput;
  items?: InputMaybe<Array<Scalars['MongoID']> | Scalars['MongoID']>;
}>;


export type BrandTradeInUpdateMutation = { __typename?: 'Mutation', TradeInUpdate?: { __typename?: 'TradeIn', _id: any, dateTime: Date, registered?: boolean | null, registeredTs?: Date | null, comment?: string | null, notified?: boolean | null, shippingType?: string | null, shippingCarrierId?: any | null, tradeInNr?: number | null, deliveryNoteUrl: string, shopId: any, hasBonus?: boolean | null, shippingLabelId?: any | null, consumerId: any, payoutType?: EnumTradeInPayoutType | null, shop?: { __typename?: 'Shop', _id: any, tradeInBaseUrl?: string | null, currency?: string | null, conditions?: Array<{ __typename?: 'ShopConditionPublic', condition: number, name: string, description: string } | null> | null } | null, vouchers?: Array<{ __typename?: 'Voucher', _id: any, value?: number | null, currency?: string | null, code?: string | null, voucherStrategy?: EnumVoucherVoucherStrategy | null, activated: boolean, used?: Date | null, payoutValue?: number | null } | null> | null, label?: { __typename?: 'ShippingLabel', deliveryDate?: Date | null, deliveryStatus?: EnumShippingLabelDeliveryStatus | null, url?: string | null, qrUrl?: string | null, trackingUrl?: string | null, carrier?: { __typename?: 'ShippingCarrier', carrierId?: string | null, name?: string | null } | null } | null, consumer?: { __typename?: 'Consumer', _id: any, language?: string | null, externalId?: string | null, id?: string | null, name?: string | null, add1?: string | null, add2?: string | null, zipCode?: string | null, country?: string | null, countryCode?: string | null, mail?: string | null, acceptsMarketing?: boolean | null, personId?: string | null, currency: string } | null } | null };

export type BrandTradeInItemUpdateMutationVariables = Exact<{
  id: Scalars['MongoID'];
  record: UpdateByIdTradeInItemInput;
}>;


export type BrandTradeInItemUpdateMutation = { __typename?: 'Mutation', TradeInItemUpdateById?: { __typename?: 'UpdateByIdTradeInItemPayload', recordId?: any | null } | null };

export type BrandTradeInItemsRemoveMutationVariables = Exact<{
  tradeInId: Scalars['MongoID'];
  items: Array<Scalars['MongoID']> | Scalars['MongoID'];
  reject: TradeInItemRejectReasonEnum;
}>;


export type BrandTradeInItemsRemoveMutation = { __typename?: 'Mutation', TradeInItemsReject?: Array<{ __typename?: 'TradeInItem', _id: any } | null> | null };

export type BrandTradeInDeleteMutationVariables = Exact<{
  tradeInId: Scalars['MongoID'];
}>;


export type BrandTradeInDeleteMutation = { __typename?: 'Mutation', TradeInDelete2?: { __typename?: 'TradeIn', _id: any } | null };

export type BrandTradeInCreateItemMutationVariables = Exact<{
  brandHouseId: Scalars['MongoID'];
  input?: InputMaybe<BrandItemInputInput>;
}>;


export type BrandTradeInCreateItemMutation = { __typename?: 'Mutation', BrandItemUpdate?: { __typename?: 'BrandItem', _id: any, tradeInItemId?: any | null } | null };

export type BrandTradeInSynchronizeMutationVariables = Exact<{
  input: TradeInSynchronizeInput;
}>;


export type BrandTradeInSynchronizeMutation = { __typename?: 'Mutation', TradeInSynchronize?: { __typename?: 'TradeIn', _id: any, comment?: string | null } | null };

export type BrandTradeInsListPageShopsQueryVariables = Exact<{
  brandHouseId: Scalars['MongoID'];
  instanceFilter?: InputMaybe<FilterFindManyIntegrationInstanceInput>;
}>;


export type BrandTradeInsListPageShopsQuery = { __typename?: 'Query', ShopMany: Array<{ __typename?: 'Shop', _id: any, name?: string | null }>, IntegrationInstances: Array<{ __typename?: 'IntegrationInstance', _id: any, name: string, refId: any, connector?: { __typename?: 'IntegrationConnector', messages?: Array<EnumIntegrationConnectorMessages | null> | null } | null }> };

export type BrandTradeInsListPageSelectedTradeInsQueryVariables = Exact<{
  tradeInIds?: InputMaybe<Array<Scalars['MongoID']> | Scalars['MongoID']>;
}>;


export type BrandTradeInsListPageSelectedTradeInsQuery = { __typename?: 'Query', TradeInPagination?: { __typename?: 'TradeInTradeInPagination', items?: Array<{ __typename?: 'TradeIn', _id: any, shopId: any }> | null } | null };

export type TradeInIntegrationExecuteMutationVariables = Exact<{
  refId: Scalars['MongoID'];
  arguments?: InputMaybe<Array<Scalars['JSON']> | Scalars['JSON']>;
}>;


export type TradeInIntegrationExecuteMutation = { __typename?: 'Mutation', IntegrationMessageExecute?: Array<string> | null };

export type VoucherPageVoucherQueryVariables = Exact<{
  id: Scalars['MongoID'];
}>;


export type VoucherPageVoucherQuery = { __typename?: 'Query', VoucherById?: { __typename?: 'Voucher', _id: any, code?: string | null, shopId: any, currentValue?: number | null, value?: number | null, currency?: string | null, voucherStrategy?: EnumVoucherVoucherStrategy | null, used?: Date | null, activated: boolean, expireDate?: Date | null, consumerId: any, deleted?: Date | null, minimumPurchase?: number | null, newVoucherUsage: boolean, disabled?: Date | null, passive?: boolean | null } | null };

export type VoucherPageSynchronizeMutationVariables = Exact<{
  shopId: Scalars['String'];
  code: Scalars['String'];
}>;


export type VoucherPageSynchronizeMutation = { __typename?: 'Mutation', VoucherSynchronize?: { __typename?: 'Voucher', _id: any } | null };

export type VoucherPageAdjustmentMutationVariables = Exact<{
  adjustment: CreateOneVoucherAdjustmentInput;
}>;


export type VoucherPageAdjustmentMutation = { __typename?: 'Mutation', VoucherAdjustmentCreate?: { __typename?: 'CreateOneVoucherAdjustmentPayload', recordId?: any | null, record?: { __typename?: 'VoucherAdjustment', _id: any, amount: number, reason: string, date: Date } | null, error?: { __typename?: 'MongoError', message?: string | null } | { __typename?: 'RuntimeError', message?: string | null } | { __typename?: 'ValidationError', message?: string | null } | null } | null };

export type VoucherPageSendReceivedMailMutationVariables = Exact<{
  shopId: Scalars['MongoID'];
  options: Scalars['JSON'];
}>;


export type VoucherPageSendReceivedMailMutation = { __typename?: 'Mutation', ConsumerSendEmail: boolean };

export type VoucherPanelVoucherQueryVariables = Exact<{
  id: Scalars['MongoID'];
}>;


export type VoucherPanelVoucherQuery = { __typename?: 'Query', VoucherById?: { __typename?: 'Voucher', _id: any, shopId: any, code?: string | null, codeAlias?: string | null, currentValue?: number | null, value?: number | null, currency?: string | null, voucherStrategy?: EnumVoucherVoucherStrategy | null, used?: Date | null, activated: boolean, expireDate?: Date | null, consumerId: any, deleted?: Date | null, minimumPurchase?: number | null, newVoucherUsage: boolean, disabled?: Date | null, voucherPdf?: Array<{ __typename?: 'VoucherPdf', url?: string | null, language?: string | null }> | null } | null };

export type VoucherEnableDisableMutationVariables = Exact<{
  voucherId: Scalars['MongoID'];
  enable: Scalars['Boolean'];
}>;


export type VoucherEnableDisableMutation = { __typename?: 'Mutation', VoucherEnable?: { __typename?: 'Voucher', _id: any, disabled?: Date | null } | null };

export type VoucherUsagesQueryVariables = Exact<{
  voucherId: Scalars['MongoID'];
}>;


export type VoucherUsagesQuery = { __typename?: 'Query', VoucherById?: { __typename?: 'Voucher', _id: any, shopId: any, deleted?: Date | null, currency?: string | null, value?: number | null, createdAt?: Date | null, consumerId: any, tradeInId?: any | null, passive?: boolean | null } | null, VoucherTransactions?: Array<{ __typename?: 'VoucherTransaction', _id: any, date: Date, type?: VoucherTransactionEnumType | null, amount: number, spending: number, balance: number, url?: string | null, reason?: string | null, user?: { __typename?: 'User', name?: string | null } | null } | null> | null };

export type VoucherUsagesGiftCardSyncQueryVariables = Exact<{
  shopId: Scalars['MongoID'];
  voucherId: Scalars['MongoID'];
}>;


export type VoucherUsagesGiftCardSyncQuery = { __typename?: 'Query', VoucherAdjustments: Array<{ __typename?: 'VoucherAdjustment', _id: any, giftCardSync?: { __typename?: 'VoucherAdjustmentGiftCardSync', status: EnumVoucherAdjustmentGiftCardSyncStatus, amount?: number | null, currency?: string | null, error?: string | null } | null }> };

export type ExportVouchersQueryVariables = Exact<{
  voucherIds: Array<Scalars['MongoID']> | Scalars['MongoID'];
  currency: Scalars['String'];
}>;


export type ExportVouchersQuery = { __typename?: 'Query', VoucherByIds?: Array<{ __typename?: 'Voucher', _id: any, currentValue?: number | null, value?: number | null, currency?: string | null, code?: string | null, codeAlias?: string | null, tradeInReceivedTs?: Date | null, voucherStrategy?: EnumVoucherVoucherStrategy | null, minimumPurchase?: number | null, activated: boolean, disabled?: Date | null, deleted?: Date | null, passive?: boolean | null, tradeIn?: { __typename?: 'TradeIn', dateTime: Date, registered?: boolean | null, registeredTs?: Date | null } | null, statistics?: { __typename?: 'VoucherStatistics', daysBeforeUsage?: number | null, spending?: number | null, usageDate?: Date | null, smashFactor?: number | null } | null, consumer?: { __typename?: 'Consumer', _id: any, name?: string | null, mail?: string | null } | null } | null> | null };

export type VouchersPagePaginationQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<SortFindManyVoucherInput>;
  filter?: InputMaybe<FilterFindManyVoucherInput>;
}>;


export type VouchersPagePaginationQuery = { __typename?: 'Query', VoucherPagination?: { __typename?: 'VoucherVoucherPagination', count?: number | null, items?: Array<{ __typename?: 'Voucher', _id: any, shopId: any, code?: string | null, codeAlias?: string | null, value?: number | null, currentValue?: number | null, currency?: string | null, voucherStrategy?: EnumVoucherVoucherStrategy | null, activated: boolean, consumerId: any, createdAt?: Date | null, deleted?: Date | null, used?: Date | null, tradeInId?: any | null, newVoucherUsage: boolean, passive?: boolean | null, consumer?: { __typename?: 'Consumer', _id: any, firstName?: string | null, lastName?: string | null, mail?: string | null } | null }> | null } | null };

export type VouchersPageSelectAllQueryVariables = Exact<{
  filter?: InputMaybe<FilterFindManyVoucherInput>;
}>;


export type VouchersPageSelectAllQuery = { __typename?: 'Query', VoucherPagination?: { __typename?: 'VoucherVoucherPagination', items?: Array<{ __typename?: 'Voucher', _id: any }> | null } | null };

export type VouchersPageMergeMutationVariables = Exact<{
  shopId: Scalars['String'];
  tradeInId: Scalars['String'];
  vouchers: Array<Scalars['String']> | Scalars['String'];
}>;


export type VouchersPageMergeMutation = { __typename?: 'Mutation', VoucherMerge?: { __typename?: 'Voucher', _id: any, code?: string | null } | null };

export type VouchersPageVoucherDeleteMutationVariables = Exact<{
  shopId: Scalars['String'];
  voucherId: Scalars['String'];
}>;


export type VouchersPageVoucherDeleteMutation = { __typename?: 'Mutation', VoucherDelete?: { __typename?: 'Voucher', _id: any } | null };

export type VouchersPageByIdsQueryVariables = Exact<{
  voucherIds: Array<Scalars['MongoID']> | Scalars['MongoID'];
}>;


export type VouchersPageByIdsQuery = { __typename?: 'Query', VoucherByIds?: Array<{ __typename?: 'Voucher', _id: any, shopId: any, code?: string | null, tradeInId?: any | null } | null> | null };

export type VouchersPageSynchronizeMutationVariables = Exact<{
  shopId: Scalars['String'];
  code: Scalars['String'];
}>;


export type VouchersPageSynchronizeMutation = { __typename?: 'Mutation', VoucherSynchronize?: { __typename?: 'Voucher', _id: any } | null };

export type BrandsPageBrandHouseQueryVariables = Exact<{
  brandHouseId: Scalars['MongoID'];
}>;


export type BrandsPageBrandHouseQuery = { __typename?: 'Query', BrandHouse?: { __typename?: 'BrandHouse', _id: any, license?: string | null, name?: string | null } | null };

export type BrandsPageLoginAsMutationVariables = Exact<{
  license: Scalars['String'];
  shopId: Scalars['String'];
}>;


export type BrandsPageLoginAsMutation = { __typename?: 'Mutation', BrandHouseAuthorize?: { __typename?: 'AuthorizeResult', url: string } | null };

export type BrandsPageLogisticsPartnersQueryVariables = Exact<{ [key: string]: never; }>;


export type BrandsPageLogisticsPartnersQuery = { __typename?: 'Query', LogisticsPartners: Array<{ __typename?: 'LogisticsPartner', _id: any, name?: string | null }> };

export type BrandHouseShopsQueryVariables = Exact<{
  brandHouseId: Scalars['MongoID'];
}>;


export type BrandHouseShopsQuery = { __typename?: 'Query', ShopMany: Array<{ __typename?: 'Shop', _id: any, name?: string | null, externalId?: string | null, currency?: string | null, live?: boolean | null, wholeSaleActive?: boolean | null }> };

export type AuditNoteDetailsQueryVariables = Exact<{
  auditNoteId: Scalars['MongoID'];
}>;


export type AuditNoteDetailsQuery = { __typename?: 'Query', AuditNote?: { __typename?: 'AuditNote', _id: any, explanation: string, createdAt?: Date | null } | null, PatchMany: Array<{ __typename?: 'ObjectPatches', _id: any, type: string, ref: any, shopId?: any | null, brandHouseId?: any | null, date: Date, updatedBy?: { __typename?: 'ObjectPatchesUpdatedBy', type: string, ref?: any | null } | null, ops?: Array<{ __typename?: 'ObjectPatchesOps', value?: any | null, op?: string | null, path?: string | null } | null> | null }> };

export type AuditNoteDetailsUserQueryVariables = Exact<{
  id: Scalars['MongoID'];
}>;


export type AuditNoteDetailsUserQuery = { __typename?: 'Query', User?: { __typename?: 'User', name?: string | null, email: string } | null };

export type AuditNotesPageQueryVariables = Exact<{
  brandHouseId: Scalars['MongoID'];
}>;


export type AuditNotesPageQuery = { __typename?: 'Query', AuditNotes?: Array<{ __typename?: 'AuditNote', _id: any, explanation: string, createdAt?: Date | null } | null> | null };

export type AuditNotesPageCreateMutationVariables = Exact<{
  brandHouseId: Scalars['MongoID'];
  explanation: Scalars['String'];
}>;


export type AuditNotesPageCreateMutation = { __typename?: 'Mutation', AuditNoteCreate?: { __typename?: 'AuditNote', _id: any } | null };

export type InvoiceLineOrderQueryVariables = Exact<{
  lineId: Scalars['MongoID'];
}>;


export type InvoiceLineOrderQuery = { __typename?: 'Query', OrderLineById?: { __typename?: 'Order2Item', cancelled?: boolean | null, discountedPricePreTax?: number | null, order?: { __typename?: 'Order2', _id: any, orderName?: string | null, orderDate: Date, lines?: Array<{ __typename?: 'Order2Item', stockItem?: { __typename?: 'StockItemResolved', itemNr?: number | null, title?: string | null, imageUrls?: Array<string> | null, shopId: any } | null } | null> | null } | null, stockItem?: { __typename?: 'StockItemResolved', itemNr?: number | null, title?: string | null, imageUrls?: Array<string> | null, shopId: any } | null } | null, OrderById?: { __typename?: 'Order2', _id: any, orderName?: string | null, orderDate: Date, lines?: Array<{ __typename?: 'Order2Item', stockItem?: { __typename?: 'StockItemResolved', itemNr?: number | null, title?: string | null, imageUrls?: Array<string> | null, shopId: any } | null } | null> | null } | null };

export type InvoiceOrderFragment = { __typename?: 'Order2', _id: any, orderName?: string | null, orderDate: Date, lines?: Array<{ __typename?: 'Order2Item', stockItem?: { __typename?: 'StockItemResolved', itemNr?: number | null, title?: string | null, imageUrls?: Array<string> | null, shopId: any } | null } | null> | null };

export type InvoiceLineFragment = { __typename?: 'Order2Item', cancelled?: boolean | null, discountedPricePreTax?: number | null, order?: { __typename?: 'Order2', _id: any, orderName?: string | null, orderDate: Date, lines?: Array<{ __typename?: 'Order2Item', stockItem?: { __typename?: 'StockItemResolved', itemNr?: number | null, title?: string | null, imageUrls?: Array<string> | null, shopId: any } | null } | null> | null } | null, stockItem?: { __typename?: 'StockItemResolved', itemNr?: number | null, title?: string | null, imageUrls?: Array<string> | null, shopId: any } | null };

export type InvoiceLineStockItemQueryVariables = Exact<{
  stockItemId: Scalars['MongoID'];
}>;


export type InvoiceLineStockItemQuery = { __typename?: 'Query', StockItemById?: { __typename?: 'StockItem', _id: any, resolved?: { __typename?: 'StockItemResolved', itemNr?: number | null, title?: string | null, imageUrls?: Array<string> | null, createdAt?: Date | null } | null } | null, BrandItem?: { __typename?: 'BrandItem', _id: any, resolved?: { __typename?: 'BrandItemResolved', itemNr: number, imageUrls?: Array<string> | null, createdAt?: Date | null, nameLocalized?: Array<{ __typename?: 'LocalizationEntry', value: string, locale: string } | null> | null } | null } | null };

export type InvoiceLineTradeInQueryVariables = Exact<{
  tradeInId: Scalars['MongoID'];
}>;


export type InvoiceLineTradeInQuery = { __typename?: 'Query', TradeInById?: { __typename?: 'TradeIn', _id: any, tradeInNr?: number | null, createdAt?: Date | null, items?: Array<{ __typename?: 'TradeInItem', _id: any, name?: string | null, imageUrls?: Array<string> | null } | null> | null } | null };

export type InvoiceSettingsQueryVariables = Exact<{
  brandHouseId: Scalars['MongoID'];
}>;


export type InvoiceSettingsQuery = { __typename?: 'Query', InvoiceSetting?: { __typename?: 'InvoiceSetting', _id: any, brandHouseId: any, currency?: string | null, fee?: number | null, minPlatformCost?: number | null, costPerItem?: number | null, customData?: any | null, shops?: Array<{ __typename?: 'InvoiceSettingShops', shopId: any, comment?: string | null, costPerItem: number, pickPackFee: number, saleCommisionPct: number, shippingOrder: number, shippingReturn: number, shippingTradeIn: number } | null> | null } | null, BrandHouse?: { __typename?: 'BrandHouse', _id: any, shops?: Array<{ __typename?: 'Shop', _id: any, name?: string | null, currency?: string | null } | null> | null } | null };

export type InvoiceFragment = { __typename?: 'InvoiceSetting', _id: any, brandHouseId: any, currency?: string | null, fee?: number | null, minPlatformCost?: number | null, costPerItem?: number | null, customData?: any | null, shops?: Array<{ __typename?: 'InvoiceSettingShops', shopId: any, comment?: string | null, costPerItem: number, pickPackFee: number, saleCommisionPct: number, shippingOrder: number, shippingReturn: number, shippingTradeIn: number } | null> | null };

export type InvoiceSettingsUpdateMutationVariables = Exact<{
  settings: InvoiceSettingInput;
}>;


export type InvoiceSettingsUpdateMutation = { __typename?: 'Mutation', InvoiceSettingUpdate?: { __typename?: 'InvoiceSetting', _id: any, brandHouseId: any, currency?: string | null, fee?: number | null, minPlatformCost?: number | null, costPerItem?: number | null, customData?: any | null, shops?: Array<{ __typename?: 'InvoiceSettingShops', shopId: any, comment?: string | null, costPerItem: number, pickPackFee: number, saleCommisionPct: number, shippingOrder: number, shippingReturn: number, shippingTradeIn: number } | null> | null } | null };

export type InvoicesQueryVariables = Exact<{
  brandHouseId: Scalars['MongoID'];
}>;


export type InvoicesQuery = { __typename?: 'Query', Invoices?: Array<{ __typename?: 'Invoice', _id: any, brandHouseId: any, invoiceId: string, invoiceDate?: Date | null, locked?: boolean | null, paid?: boolean | null, currency?: string | null, total?: { __typename?: 'InvoiceTotal', total: number, sections?: Array<{ __typename?: 'InvoiceTotalSection', total: number, title: string, lines?: Array<{ __typename?: 'InvoiceTotalValue', lineType: EnumInvoiceLineLineType, title: string, count: number, sum: number } | null> | null } | null> | null } | null } | null> | null };

export type InvoiceResetMutationVariables = Exact<{
  brandHouseId: Scalars['MongoID'];
  invoiceId: Scalars['String'];
}>;


export type InvoiceResetMutation = { __typename?: 'Mutation', InvoiceReset?: Array<{ __typename?: 'Invoice', _id: any } | null> | null };

export type InvoiceLinesQueryVariables = Exact<{
  invoiceId: Scalars['MongoID'];
  lineType: EnumInvoiceLineLineType;
}>;


export type InvoiceLinesQuery = { __typename?: 'Query', InvoiceLines: Array<{ __typename?: 'InvoiceLine', _id: any, brandHouseId: any, invoiceId: any, cost: number, currency: string, lineType: EnumInvoiceLineLineType, lineId: string, lineDate: Date, createdAt?: Date | null }> };

export type InvoicePageUpdateMutationVariables = Exact<{
  brandHouseId: Scalars['MongoID'];
  invoiceId: Scalars['String'];
  locked?: InputMaybe<Scalars['Boolean']>;
  paid?: InputMaybe<Scalars['Boolean']>;
}>;


export type InvoicePageUpdateMutation = { __typename?: 'Mutation', InvoiceUpdate?: { __typename?: 'Invoice', _id: any, paid?: boolean | null, locked?: boolean | null } | null };

export type InvoicePageDeleteMutationVariables = Exact<{
  brandHouseId: Scalars['MongoID'];
  invoiceId: Scalars['String'];
}>;


export type InvoicePageDeleteMutation = { __typename?: 'Mutation', InvoiceDelete: boolean };

export type InvoiceRebuildBrandMutationVariables = Exact<{
  brandHouseId: Scalars['MongoID'];
}>;


export type InvoiceRebuildBrandMutation = { __typename?: 'Mutation', InvoiceRebuild: boolean };

export type InvoiceAdjustmentsQueryVariables = Exact<{
  brandHouseId: Scalars['MongoID'];
}>;


export type InvoiceAdjustmentsQuery = { __typename?: 'Query', InvoiceAdjustments: Array<{ __typename?: 'InvoiceAdjustment', _id: any, amount: number, createdAt?: Date | null, description: string }> };

export type InvoiceAdjustmentCreateMutationVariables = Exact<{
  input: CreateOneInvoiceAdjustmentInput;
}>;


export type InvoiceAdjustmentCreateMutation = { __typename?: 'Mutation', InvoiceAdjustmentCreate?: { __typename?: 'CreateOneInvoiceAdjustmentPayload', record?: { __typename?: 'InvoiceAdjustment', _id: any, amount: number, createdAt?: Date | null, description: string } | null } | null };

export type ObjectHistoryQueryVariables = Exact<{
  ref: Scalars['MongoID'];
}>;


export type ObjectHistoryQuery = { __typename?: 'Query', PatchPagination?: { __typename?: 'ObjectPatchesPatchItem', count?: number | null, items?: Array<{ __typename?: 'ObjectPatches', _id: any, type: string, shopId?: any | null, brandHouseId?: any | null, date: Date, updatedBy?: { __typename?: 'ObjectPatchesUpdatedBy', type: string, ref?: any | null } | null, ops?: Array<{ __typename?: 'ObjectPatchesOps', value?: any | null, op?: string | null, path?: string | null } | null> | null }> | null, pageInfo: { __typename?: 'PaginationInfo', hasNextPage?: boolean | null } } | null };

export type ObjectHistoryUserQueryVariables = Exact<{
  id: Scalars['MongoID'];
}>;


export type ObjectHistoryUserQuery = { __typename?: 'Query', User?: { __typename?: 'User', name?: string | null, email: string } | null };

export type ListsTradeInsListQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<FilterFindManyTradeInInput>;
  sort?: InputMaybe<SortFindManyTradeInInput>;
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
  viewId?: InputMaybe<Scalars['MongoID']>;
}>;


export type ListsTradeInsListQuery = { __typename?: 'Query', TradeInPagination?: { __typename?: 'TradeInTradeInPagination', count?: number | null, pageInfo: { __typename?: 'PaginationInfo', perPage: number, currentPage: number, hasNextPage?: boolean | null, hasPreviousPage?: boolean | null, itemCount?: number | null, pageCount?: number | null }, items?: Array<{ __typename?: 'TradeIn', _id: any, brandHouseId: any, tradeInNr?: number | null, consumerId: any, dateTime: Date, registered?: boolean | null, payoutType?: EnumTradeInPayoutType | null, shopId: any, source: EnumTradeInSource, consumer?: { __typename?: 'Consumer', name?: string | null, mail?: string | null, country?: string | null } | null, vouchers?: Array<{ __typename?: 'Voucher', code?: string | null, value?: number | null, currency?: string | null, activated: boolean, used?: Date | null, deleted?: Date | null, payoutValue?: number | null } | null> | null, shop?: { __typename?: 'Shop', currency?: string | null, name?: string | null, externalName?: string | null } | null, label?: { __typename?: 'ShippingLabel', deliveryStatus?: EnumShippingLabelDeliveryStatus | null, carrier?: { __typename?: 'ShippingCarrier', name?: string | null } | null } | null, items?: Array<{ __typename?: 'TradeInItem', _id: any, rejected?: EnumTradeInItemRejected | null, imageUrls?: Array<string> | null, bonus?: number | null, stockItem?: { __typename?: 'StockItem', _id: any } | null, brandItem?: { __typename?: 'BrandItem', _id: any } | null } | null> | null }> | null } | null };

export type ListsTradeInFragment = { __typename?: 'TradeIn', _id: any, brandHouseId: any, tradeInNr?: number | null, consumerId: any, dateTime: Date, registered?: boolean | null, payoutType?: EnumTradeInPayoutType | null, shopId: any, source: EnumTradeInSource, consumer?: { __typename?: 'Consumer', name?: string | null, mail?: string | null, country?: string | null } | null, vouchers?: Array<{ __typename?: 'Voucher', code?: string | null, value?: number | null, currency?: string | null, activated: boolean, used?: Date | null, deleted?: Date | null, payoutValue?: number | null } | null> | null, shop?: { __typename?: 'Shop', currency?: string | null, name?: string | null, externalName?: string | null } | null, label?: { __typename?: 'ShippingLabel', deliveryStatus?: EnumShippingLabelDeliveryStatus | null, carrier?: { __typename?: 'ShippingCarrier', name?: string | null } | null } | null, items?: Array<{ __typename?: 'TradeInItem', _id: any, rejected?: EnumTradeInItemRejected | null, imageUrls?: Array<string> | null, bonus?: number | null, stockItem?: { __typename?: 'StockItem', _id: any } | null, brandItem?: { __typename?: 'BrandItem', _id: any } | null } | null> | null };

export type ListTrackingViewDataQueryVariables = Exact<{
  filter: FilterFindManyTrackingInput;
}>;


export type ListTrackingViewDataQuery = { __typename?: 'Query', TrackingMany: Array<{ __typename?: 'Tracking', _id: any, shopId: any, ts?: Date | null, objectId?: string | null, objectType?: string | null, objectPayload?: any | null, browser?: string | null, ip?: string | null }> };

export type ListTrackingDataQueryVariables = Exact<{
  filter: FilterFindManyTrackingInput;
}>;


export type ListTrackingDataQuery = { __typename?: 'Query', TrackingPagination?: { __typename?: 'TrackingTrackingPagination', count?: number | null, items?: Array<{ __typename?: 'Tracking', _id: any, shopId: any, ts?: Date | null, objectId?: string | null, objectType?: string | null, objectPayload?: any | null, browser?: string | null, ip?: string | null }> | null } | null };

export type ListTrackingStockItemQueryVariables = Exact<{
  stockItemId: Scalars['MongoID'];
}>;


export type ListTrackingStockItemQuery = { __typename?: 'Query', StockItemById?: { __typename?: 'StockItem', _id: any, title?: string | null, imageUrls?: Array<string> | null, isSold?: boolean | null, shopId: any, shop?: { __typename?: 'Shop', brandHouseId: any } | null } | null };

export type ListTrackingBrandQueryVariables = Exact<{
  shopId: Scalars['MongoID'];
}>;


export type ListTrackingBrandQuery = { __typename?: 'Query', ShopById?: { __typename?: 'Shop', _id: any, name?: string | null, brandHouseId: any } | null };

export type ListTrackingVariantByIdQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type ListTrackingVariantByIdQuery = { __typename?: 'Query', ProductVariant?: { __typename?: 'ProductVariant', _id: any, productId: any, shopId: any, imageUrls?: Array<string> | null, product?: { __typename?: 'Product', name: string } | null, shop?: { __typename?: 'Shop', brandHouseId: any } | null } | null };

export type ExportTradeInsConsumerQueryVariables = Exact<{
  consumerId: Scalars['MongoID'];
  dateTime: Scalars['Date'];
  now: Scalars['Date'];
}>;


export type ExportTradeInsConsumerQuery = { __typename?: 'Query', ConsumerById?: { __typename?: 'Consumer', statisticsBefore?: { __typename?: 'ConsumerStatistics', orders?: number | null, tradeIns?: number | null } | null, statisticsAfter?: { __typename?: 'ConsumerStatistics', orders?: number | null, tradeIns?: number | null } | null } | null };

export type ExportTradeInsQueryVariables = Exact<{
  tradeIns?: InputMaybe<Array<Scalars['MongoID']> | Scalars['MongoID']>;
  currency: Scalars['String'];
}>;


export type ExportTradeInsQuery = { __typename?: 'Query', TradeIns: Array<{ __typename?: 'TradeIn', _id: any, tradeInNr?: number | null, dateTime: Date, shopId: any, registered?: boolean | null, shippingCarrierId?: any | null, shop?: { __typename?: 'Shop', name?: string | null } | null, label?: { __typename?: 'ShippingLabel', deliveryStatus?: EnumShippingLabelDeliveryStatus | null, qrUrl?: string | null } | null, shippingCarrier?: { __typename?: 'ShippingCarrier', name?: string | null } | null, items?: Array<{ __typename?: 'TradeInItem', _id: any, imageUrls?: Array<string> | null, name?: string | null, value?: number | null, condition?: number | null, rejected?: EnumTradeInItemRejected | null, bonus?: number | null, wholeSale?: { __typename?: 'PotentialWholeSale', name?: string | null, value?: number | null } | null, brandItem?: { __typename?: 'BrandItem', isSold: boolean, orderline?: { __typename?: 'Order2Item', salesPricePreTax?: number | null, discountedPrice?: number | null, order?: { __typename?: 'Order2', orderDate: Date } | null } | null, resolved?: { __typename?: 'BrandItemResolved', originalSku?: string | null, sizeLocalized?: Array<{ __typename?: 'LocalizationEntry', value: string, locale: string } | null> | null, nameLocalized?: Array<{ __typename?: 'LocalizationEntry', locale: string, value: string } | null> | null } | null } | null, stockItem?: { __typename?: 'StockItem', isSold?: boolean | null, resolved?: { __typename?: 'StockItemResolved', title?: string | null, size?: string | null, condition?: number | null, sku?: string | null } | null, orderline?: { __typename?: 'Order2Item', salesPricePreTax?: number | null, order?: { __typename?: 'Order2', orderDate: Date } | null } | null } | null } | null> | null, consumer?: { __typename?: 'Consumer', _id: any, name?: string | null, mail?: string | null, phone?: string | null, phoneE164?: string | null } | null, vouchers?: Array<{ __typename?: 'Voucher', value?: number | null, currency?: string | null, statistics?: { __typename?: 'VoucherStatistics', reward?: number | null, smashFactor?: number | null, spending?: number | null, usageDate?: Date | null, active?: boolean | null } | null } | null> | null }> };

export type TradeInExportFragment = { __typename?: 'TradeIn', _id: any, tradeInNr?: number | null, dateTime: Date, shopId: any, registered?: boolean | null, shippingCarrierId?: any | null, shop?: { __typename?: 'Shop', name?: string | null } | null, label?: { __typename?: 'ShippingLabel', deliveryStatus?: EnumShippingLabelDeliveryStatus | null, qrUrl?: string | null } | null, shippingCarrier?: { __typename?: 'ShippingCarrier', name?: string | null } | null, items?: Array<{ __typename?: 'TradeInItem', _id: any, imageUrls?: Array<string> | null, name?: string | null, value?: number | null, condition?: number | null, rejected?: EnumTradeInItemRejected | null, bonus?: number | null, wholeSale?: { __typename?: 'PotentialWholeSale', name?: string | null, value?: number | null } | null, brandItem?: { __typename?: 'BrandItem', isSold: boolean, orderline?: { __typename?: 'Order2Item', salesPricePreTax?: number | null, discountedPrice?: number | null, order?: { __typename?: 'Order2', orderDate: Date } | null } | null, resolved?: { __typename?: 'BrandItemResolved', originalSku?: string | null, sizeLocalized?: Array<{ __typename?: 'LocalizationEntry', value: string, locale: string } | null> | null, nameLocalized?: Array<{ __typename?: 'LocalizationEntry', locale: string, value: string } | null> | null } | null } | null, stockItem?: { __typename?: 'StockItem', isSold?: boolean | null, resolved?: { __typename?: 'StockItemResolved', title?: string | null, size?: string | null, condition?: number | null, sku?: string | null } | null, orderline?: { __typename?: 'Order2Item', salesPricePreTax?: number | null, order?: { __typename?: 'Order2', orderDate: Date } | null } | null } | null } | null> | null, consumer?: { __typename?: 'Consumer', _id: any, name?: string | null, mail?: string | null, phone?: string | null, phoneE164?: string | null } | null, vouchers?: Array<{ __typename?: 'Voucher', value?: number | null, currency?: string | null, statistics?: { __typename?: 'VoucherStatistics', reward?: number | null, smashFactor?: number | null, spending?: number | null, usageDate?: Date | null, active?: boolean | null } | null } | null> | null };

export type TradeInExportItemFragment = { __typename?: 'TradeInItem', _id: any, imageUrls?: Array<string> | null, name?: string | null, value?: number | null, condition?: number | null, rejected?: EnumTradeInItemRejected | null, bonus?: number | null, wholeSale?: { __typename?: 'PotentialWholeSale', name?: string | null, value?: number | null } | null, brandItem?: { __typename?: 'BrandItem', isSold: boolean, orderline?: { __typename?: 'Order2Item', salesPricePreTax?: number | null, discountedPrice?: number | null, order?: { __typename?: 'Order2', orderDate: Date } | null } | null, resolved?: { __typename?: 'BrandItemResolved', originalSku?: string | null, sizeLocalized?: Array<{ __typename?: 'LocalizationEntry', value: string, locale: string } | null> | null, nameLocalized?: Array<{ __typename?: 'LocalizationEntry', locale: string, value: string } | null> | null } | null } | null, stockItem?: { __typename?: 'StockItem', isSold?: boolean | null, resolved?: { __typename?: 'StockItemResolved', title?: string | null, size?: string | null, condition?: number | null, sku?: string | null } | null, orderline?: { __typename?: 'Order2Item', salesPricePreTax?: number | null, order?: { __typename?: 'Order2', orderDate: Date } | null } | null } | null };

export type ExportTradeInItemsQueryVariables = Exact<{
  tradeIns?: InputMaybe<Array<Scalars['MongoID']> | Scalars['MongoID']>;
}>;


export type ExportTradeInItemsQuery = { __typename?: 'Query', TradeIns: Array<{ __typename?: 'TradeIn', _id: any, tradeInNr?: number | null, dateTime: Date, shopId: any, registered?: boolean | null, shippingCarrierId?: any | null, shop?: { __typename?: 'Shop', name?: string | null } | null, label?: { __typename?: 'ShippingLabel', deliveryStatus?: EnumShippingLabelDeliveryStatus | null, qrUrl?: string | null } | null, shippingCarrier?: { __typename?: 'ShippingCarrier', name?: string | null } | null, items?: Array<{ __typename?: 'TradeInItem', _id: any, imageUrls?: Array<string> | null, name?: string | null, value?: number | null, condition?: number | null, rejected?: EnumTradeInItemRejected | null, bonus?: number | null, wholeSale?: { __typename?: 'PotentialWholeSale', name?: string | null, value?: number | null } | null, brandItem?: { __typename?: 'BrandItem', isSold: boolean, condition: number, resolved?: { __typename?: 'BrandItemResolved', originalSku?: string | null, sizeLocalized?: Array<{ __typename?: 'LocalizationEntry', value: string, locale: string } | null> | null, nameLocalized?: Array<{ __typename?: 'LocalizationEntry', locale: string, value: string } | null> | null, orderline?: { __typename?: 'Order2Item', discountedPrice?: number | null } | null } | null } | null, stockItem?: { __typename?: 'StockItem', isSold?: boolean | null, resolved?: { __typename?: 'StockItemResolved', title?: string | null, size?: string | null, condition?: number | null, sku?: string | null } | null, orderline?: { __typename?: 'Order2Item', discountedPrice?: number | null, order?: { __typename?: 'Order2', orderDate: Date } | null } | null } | null } | null> | null, consumer?: { __typename?: 'Consumer', _id: any, name?: string | null, mail?: string | null, phone?: string | null, phoneE164?: string | null } | null, vouchers?: Array<{ __typename?: 'Voucher', value?: number | null, currency?: string | null } | null> | null }> };

export type TradeInExportItemsFragment = { __typename?: 'TradeIn', _id: any, tradeInNr?: number | null, dateTime: Date, shopId: any, registered?: boolean | null, shippingCarrierId?: any | null, shop?: { __typename?: 'Shop', name?: string | null } | null, label?: { __typename?: 'ShippingLabel', deliveryStatus?: EnumShippingLabelDeliveryStatus | null, qrUrl?: string | null } | null, shippingCarrier?: { __typename?: 'ShippingCarrier', name?: string | null } | null, items?: Array<{ __typename?: 'TradeInItem', _id: any, imageUrls?: Array<string> | null, name?: string | null, value?: number | null, condition?: number | null, rejected?: EnumTradeInItemRejected | null, bonus?: number | null, wholeSale?: { __typename?: 'PotentialWholeSale', name?: string | null, value?: number | null } | null, brandItem?: { __typename?: 'BrandItem', isSold: boolean, condition: number, resolved?: { __typename?: 'BrandItemResolved', originalSku?: string | null, sizeLocalized?: Array<{ __typename?: 'LocalizationEntry', value: string, locale: string } | null> | null, nameLocalized?: Array<{ __typename?: 'LocalizationEntry', locale: string, value: string } | null> | null, orderline?: { __typename?: 'Order2Item', discountedPrice?: number | null } | null } | null } | null, stockItem?: { __typename?: 'StockItem', isSold?: boolean | null, resolved?: { __typename?: 'StockItemResolved', title?: string | null, size?: string | null, condition?: number | null, sku?: string | null } | null, orderline?: { __typename?: 'Order2Item', discountedPrice?: number | null, order?: { __typename?: 'Order2', orderDate: Date } | null } | null } | null } | null> | null, consumer?: { __typename?: 'Consumer', _id: any, name?: string | null, mail?: string | null, phone?: string | null, phoneE164?: string | null } | null, vouchers?: Array<{ __typename?: 'Voucher', value?: number | null, currency?: string | null } | null> | null };

export type TradeInExportItemItemFragment = { __typename?: 'TradeInItem', _id: any, imageUrls?: Array<string> | null, name?: string | null, value?: number | null, condition?: number | null, rejected?: EnumTradeInItemRejected | null, bonus?: number | null, wholeSale?: { __typename?: 'PotentialWholeSale', name?: string | null, value?: number | null } | null, brandItem?: { __typename?: 'BrandItem', isSold: boolean, condition: number, resolved?: { __typename?: 'BrandItemResolved', originalSku?: string | null, sizeLocalized?: Array<{ __typename?: 'LocalizationEntry', value: string, locale: string } | null> | null, nameLocalized?: Array<{ __typename?: 'LocalizationEntry', locale: string, value: string } | null> | null, orderline?: { __typename?: 'Order2Item', discountedPrice?: number | null } | null } | null } | null, stockItem?: { __typename?: 'StockItem', isSold?: boolean | null, resolved?: { __typename?: 'StockItemResolved', title?: string | null, size?: string | null, condition?: number | null, sku?: string | null } | null, orderline?: { __typename?: 'Order2Item', discountedPrice?: number | null, order?: { __typename?: 'Order2', orderDate: Date } | null } | null } | null };

export type LogisticsBrandItemsPagePushMutationVariables = Exact<{
  brandItemId: Scalars['MongoID'];
  active: Scalars['Boolean'];
}>;


export type LogisticsBrandItemsPagePushMutation = { __typename?: 'Mutation', BrandItemPush?: Array<{ __typename?: 'BrandItemShopInfo', _id: any, active: boolean, shopId: any } | null> | null };

export type LogisticsBrandItemRetouchMutationVariables = Exact<{
  ids: Array<Scalars['MongoID']> | Scalars['MongoID'];
}>;


export type LogisticsBrandItemRetouchMutation = { __typename?: 'Mutation', BrandItemRetouch?: Array<{ __typename?: 'BrandItem', _id: any, imageUrls?: Array<string> | null, images?: Array<{ __typename?: 'BrandItemImage', _id: any, imageUrl?: string | null } | null> | null } | null> | null };

export type LogisticsBrandItemInfoQueryVariables = Exact<{
  brandItemId: Scalars['MongoID'];
}>;


export type LogisticsBrandItemInfoQuery = { __typename?: 'Query', BrandItem?: { __typename?: 'BrandItem', _id: any, brandHouseId: any } | null };

export type LogisticsPartnerListFieldsFragment = { __typename?: 'LogisticsPartner', _id: any, name?: string | null, city?: string | null, country?: string | null, mail?: string | null, phone?: string | null };

export type LogisticsPartnerFieldsFragment = { __typename?: 'LogisticsPartner', attention?: string | null, address?: string | null, address2?: string | null, zipCode?: string | null, countryCode?: string | null, apiKey?: string | null, apiSecret?: string | null, _id: any, name?: string | null, city?: string | null, country?: string | null, mail?: string | null, phone?: string | null };

export type LogisticsPartnersPageQueryVariables = Exact<{ [key: string]: never; }>;


export type LogisticsPartnersPageQuery = { __typename?: 'Query', LogisticsPartners: Array<{ __typename?: 'LogisticsPartner', _id: any, name?: string | null, city?: string | null, country?: string | null, mail?: string | null, phone?: string | null }> };

export type LogisticsPartnerSettingsPageQueryVariables = Exact<{
  id: Scalars['MongoID'];
}>;


export type LogisticsPartnerSettingsPageQuery = { __typename?: 'Query', LogisticsPartner?: { __typename?: 'LogisticsPartner', attention?: string | null, address?: string | null, address2?: string | null, zipCode?: string | null, countryCode?: string | null, apiKey?: string | null, apiSecret?: string | null, _id: any, name?: string | null, city?: string | null, country?: string | null, mail?: string | null, phone?: string | null } | null };

export type LogisticsPartnersPageCreateMutationVariables = Exact<{
  name: Scalars['String'];
  attention?: InputMaybe<Scalars['String']>;
  address?: InputMaybe<Scalars['String']>;
  address2?: InputMaybe<Scalars['String']>;
  zipCode?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  countryCode?: InputMaybe<Scalars['String']>;
  mail?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
}>;


export type LogisticsPartnersPageCreateMutation = { __typename?: 'Mutation', LogisticsPartnerCreate?: { __typename?: 'LogisticsPartner', attention?: string | null, address?: string | null, address2?: string | null, zipCode?: string | null, countryCode?: string | null, apiKey?: string | null, apiSecret?: string | null, _id: any, name?: string | null, city?: string | null, country?: string | null, mail?: string | null, phone?: string | null } | null };

export type LogisticsPartnerSettingsPageUpdateMutationVariables = Exact<{
  id: Scalars['MongoID'];
  input: UpdateByIdLogisticsPartnerInput;
}>;


export type LogisticsPartnerSettingsPageUpdateMutation = { __typename?: 'Mutation', LogisticsPartnerUpdate?: { __typename?: 'UpdateByIdLogisticsPartnerPayload', recordId?: any | null, record?: { __typename?: 'LogisticsPartner', attention?: string | null, address?: string | null, address2?: string | null, zipCode?: string | null, countryCode?: string | null, apiKey?: string | null, apiSecret?: string | null, _id: any, name?: string | null, city?: string | null, country?: string | null, mail?: string | null, phone?: string | null } | null, error?: { __typename?: 'MongoError', message?: string | null } | { __typename?: 'RuntimeError', message?: string | null } | { __typename?: 'ValidationError', message?: string | null } | null } | null };

export type LogisticsProductsPageBrandQueryVariables = Exact<{
  shopId: Scalars['MongoID'];
}>;


export type LogisticsProductsPageBrandQuery = { __typename?: 'Query', ShopById?: { __typename?: 'Shop', _id: any, brandHouseId: any } | null };

export type InventoryItemStockItemQueryVariables = Exact<{
  stockItemId: Scalars['MongoID'];
}>;


export type InventoryItemStockItemQuery = { __typename?: 'Query', StockItemById?: { __typename?: 'StockItem', _id: any, title?: string | null, color?: string | null, size?: string | null, condition?: number | null, sku?: string | null, imageUrls?: Array<string> | null, effectiveChecked: boolean, shopId: any, shop?: { __typename?: 'Shop', name?: string | null, brandHouseId: any } | null } | null };

export type InventoryItemCheckMutationVariables = Exact<{
  stockItemId: Scalars['String'];
  checked: Scalars['Boolean'];
}>;


export type InventoryItemCheckMutation = { __typename?: 'Mutation', StockItemChecked?: { __typename?: 'StockItem', _id: any, checked?: Date | null } | null };

export type InventoryPageLocationsQueryVariables = Exact<{ [key: string]: never; }>;


export type InventoryPageLocationsQuery = { __typename?: 'Query', WarehouseLocations?: Array<{ __typename?: 'WarehouseLocation', _id?: string | null, count: number, checked: boolean, items?: Array<{ __typename?: 'StockItem', _id: any, effectiveChecked: boolean } | null> | null } | null> | null };

export type InventoryPageItemsUpdateQueryVariables = Exact<{
  query?: InputMaybe<FilterFindManyStockItemInput>;
}>;


export type InventoryPageItemsUpdateQuery = { __typename?: 'Query', StockItems: Array<{ __typename?: 'StockItem', _id: any, effectiveChecked: boolean }> };

export type InventoryPageResetMutationVariables = Exact<{
  lpId: Scalars['String'];
}>;


export type InventoryPageResetMutation = { __typename?: 'Mutation', LogisticsStockItemsCheckedReset?: boolean | null };

export type NfcTagsQueryVariables = Exact<{ [key: string]: never; }>;


export type NfcTagsQuery = { __typename?: 'Query', NFCMany: Array<{ __typename?: 'NFC', identifier: string, stockItem?: { __typename?: 'StockItem', _id: any, itemNr?: number | null, shop?: { __typename?: 'Shop', _id: any, name?: string | null, brandHouseId: any } | null } | null, brandItem?: { __typename?: 'BrandItem', _id: any, itemNr: number, brandHouse?: { __typename?: 'BrandHouse', _id: any, name?: string | null } | null } | null }> };

export type NfcFragment = { __typename?: 'NFC', identifier: string, stockItem?: { __typename?: 'StockItem', _id: any, itemNr?: number | null, shop?: { __typename?: 'Shop', _id: any, name?: string | null, brandHouseId: any } | null } | null, brandItem?: { __typename?: 'BrandItem', _id: any, itemNr: number, brandHouse?: { __typename?: 'BrandHouse', _id: any, name?: string | null } | null } | null };

export type BrandSettingsPageHouseQueryVariables = Exact<{
  brandHouseId: Scalars['MongoID'];
}>;


export type BrandSettingsPageHouseQuery = { __typename?: 'Query', BrandHouse?: { __typename?: 'BrandHouse', _id: any, name?: string | null } | null };

export type ShopTabsShopsQueryVariables = Exact<{
  brandHouseId?: InputMaybe<Scalars['MongoID']>;
}>;


export type ShopTabsShopsQuery = { __typename?: 'Query', ShopMany: Array<{ __typename?: 'Shop', _id: any, name?: string | null }> };

export type HistorySettingsBrandQueryVariables = Exact<{
  refId: Scalars['MongoID'];
}>;


export type HistorySettingsBrandQuery = { __typename?: 'Query', BrandSettings?: { __typename?: 'BrandSetting', _id?: any | null } | null };

export type MasterDataSettingsQueryVariables = Exact<{
  brandHouseId: Scalars['MongoID'];
}>;


export type MasterDataSettingsQuery = { __typename?: 'Query', BrandSettings?: { __typename?: 'BrandSetting', _id?: any | null, masterDataRemoveBg?: boolean | null, masterDataRemoveBgVersion?: number | null, masterDataUseProductImages?: boolean | null, useBrandItems?: boolean | null, masterDataConsolidate?: { __typename?: 'BrandSettingMasterDataConsolidate', enabled: boolean, field: EnumBrandSettingMasterDataConsolidateField, lastUpdate?: Date | null, enableLanguageDetect?: boolean | null, colorStrategy?: EnumBrandSettingMasterDataConsolidateColorStrategy | null, colorIdentifier?: string | null, secondaryColorStrategy?: EnumBrandSettingMasterDataConsolidateSecondaryColorStrategy | null, secondaryColorIdentifier?: string | null, tertiaryColorStrategy?: EnumBrandSettingMasterDataConsolidateTertiaryColorStrategy | null, tertiaryColorIdentifier?: string | null, variantIdFromSkuRegExp?: string | null, autoMerge?: boolean | null, autoMergeFromTs?: Date | null, autoMergeGroupId?: any | null } | null } | null, BrandProductGroups: Array<{ __typename?: 'BrandProductGroup', _id: any, name: string }> };

export type MasterDataFragment = { __typename?: 'BrandSetting', _id?: any | null, masterDataRemoveBg?: boolean | null, masterDataRemoveBgVersion?: number | null, masterDataUseProductImages?: boolean | null, useBrandItems?: boolean | null, masterDataConsolidate?: { __typename?: 'BrandSettingMasterDataConsolidate', enabled: boolean, field: EnumBrandSettingMasterDataConsolidateField, lastUpdate?: Date | null, enableLanguageDetect?: boolean | null, colorStrategy?: EnumBrandSettingMasterDataConsolidateColorStrategy | null, colorIdentifier?: string | null, secondaryColorStrategy?: EnumBrandSettingMasterDataConsolidateSecondaryColorStrategy | null, secondaryColorIdentifier?: string | null, tertiaryColorStrategy?: EnumBrandSettingMasterDataConsolidateTertiaryColorStrategy | null, tertiaryColorIdentifier?: string | null, variantIdFromSkuRegExp?: string | null, autoMerge?: boolean | null, autoMergeFromTs?: Date | null, autoMergeGroupId?: any | null } | null };

export type MasterDataSettingsSaveMutationVariables = Exact<{
  brandHouseId: Scalars['MongoID'];
  input: BrandSettingMasterDataConsolidateInput;
  useBrandItems: Scalars['Boolean'];
  removeBg: Scalars['Boolean'];
  removeBgVersion: Scalars['Float'];
  masterDataUseProductImages: Scalars['Boolean'];
  auditNoteId?: InputMaybe<Scalars['MongoID']>;
}>;


export type MasterDataSettingsSaveMutation = { __typename?: 'Mutation', BrandSettingsUpdate?: { __typename?: 'BrandSetting', _id?: any | null, masterDataRemoveBg?: boolean | null, masterDataRemoveBgVersion?: number | null, masterDataUseProductImages?: boolean | null, useBrandItems?: boolean | null, masterDataConsolidate?: { __typename?: 'BrandSettingMasterDataConsolidate', enabled: boolean, field: EnumBrandSettingMasterDataConsolidateField, lastUpdate?: Date | null, enableLanguageDetect?: boolean | null, colorStrategy?: EnumBrandSettingMasterDataConsolidateColorStrategy | null, colorIdentifier?: string | null, secondaryColorStrategy?: EnumBrandSettingMasterDataConsolidateSecondaryColorStrategy | null, secondaryColorIdentifier?: string | null, tertiaryColorStrategy?: EnumBrandSettingMasterDataConsolidateTertiaryColorStrategy | null, tertiaryColorIdentifier?: string | null, variantIdFromSkuRegExp?: string | null, autoMerge?: boolean | null, autoMergeFromTs?: Date | null, autoMergeGroupId?: any | null } | null } | null };

export type MasterDataConsolidationStartMutationVariables = Exact<{
  brandHouseId: Scalars['MongoID'];
}>;


export type MasterDataConsolidationStartMutation = { __typename?: 'Mutation', BrandProductImport: boolean };

export type MasterDataRequestProductsMutationVariables = Exact<{
  refId: Scalars['MongoID'];
  refType?: InputMaybe<EnumIntegrationConnectorRefType>;
  args?: InputMaybe<Array<Scalars['JSON']> | Scalars['JSON']>;
}>;


export type MasterDataRequestProductsMutation = { __typename?: 'Mutation', IntegrationMessageExecute?: Array<string> | null };

export type GetOptionSetsQueryVariables = Exact<{
  refId: Scalars['MongoID'];
}>;


export type GetOptionSetsQuery = { __typename?: 'Query', Options: Array<{ __typename?: 'OptionSet', _id: any, externalId?: string | null, refId: any, title: string, target: EnumOptionSetTarget, active?: boolean | null, key: string, valueType: EnumOptionSetValueType, values?: Array<{ __typename?: 'OptionValue', _id: any, refId: any, optionSetId: any, value: string, label: string, sortorder: number, deleted?: boolean | null, createdAt?: Date | null, updatedAt?: Date | null, customData?: any | null, externalId?: string | null, localizations?: Array<{ __typename?: 'LocalizationEntry', value: string, locale: string } | null> | null } | null> | null }> };

export type GetOptionSetQueryVariables = Exact<{
  id: Scalars['MongoID'];
}>;


export type GetOptionSetQuery = { __typename?: 'Query', Option?: { __typename?: 'OptionSet', _id: any, externalId?: string | null, refId: any, title: string, target: EnumOptionSetTarget, active?: boolean | null, key: string, valueType: EnumOptionSetValueType, values?: Array<{ __typename?: 'OptionValue', _id: any, refId: any, optionSetId: any, value: string, label: string, sortorder: number, deleted?: boolean | null, createdAt?: Date | null, updatedAt?: Date | null, customData?: any | null, externalId?: string | null, localizations?: Array<{ __typename?: 'LocalizationEntry', value: string, locale: string } | null> | null } | null> | null } | null };

export type OptionsSynchronizeMutationVariables = Exact<{
  input: OptionSetInput;
}>;


export type OptionsSynchronizeMutation = { __typename?: 'Mutation', OptionSynchronize?: { __typename?: 'OptionSet', _id: any, externalId?: string | null, refId: any, title: string, target: EnumOptionSetTarget, active?: boolean | null, key: string, valueType: EnumOptionSetValueType, values?: Array<{ __typename?: 'OptionValue', _id: any, refId: any, optionSetId: any, value: string, label: string, sortorder: number, deleted?: boolean | null, createdAt?: Date | null, updatedAt?: Date | null, customData?: any | null, externalId?: string | null, localizations?: Array<{ __typename?: 'LocalizationEntry', value: string, locale: string } | null> | null } | null> | null } | null };

export type OptionSetDataFragment = { __typename?: 'OptionSet', _id: any, externalId?: string | null, refId: any, title: string, target: EnumOptionSetTarget, active?: boolean | null, key: string, valueType: EnumOptionSetValueType, values?: Array<{ __typename?: 'OptionValue', _id: any, refId: any, optionSetId: any, value: string, label: string, sortorder: number, deleted?: boolean | null, createdAt?: Date | null, updatedAt?: Date | null, customData?: any | null, externalId?: string | null, localizations?: Array<{ __typename?: 'LocalizationEntry', value: string, locale: string } | null> | null } | null> | null };

export type ContactPersonSettingsQueryVariables = Exact<{
  brandHouseId: Scalars['MongoID'];
}>;


export type ContactPersonSettingsQuery = { __typename?: 'Query', BrandSettings?: { __typename?: 'BrandSetting', _id?: any | null, contactPerson?: string | null, contactPersonEmail?: string | null } | null };

export type ContactPersonSettingsUpdateMutationVariables = Exact<{
  brandHouseId: Scalars['MongoID'];
  input: BrandSettingInput;
  auditNoteId?: InputMaybe<Scalars['MongoID']>;
}>;


export type ContactPersonSettingsUpdateMutation = { __typename?: 'Mutation', BrandSettingsUpdate?: { __typename?: 'BrandSetting', _id?: any | null, contactPerson?: string | null, contactPersonEmail?: string | null } | null };

export type ContactPersonFragment = { __typename?: 'BrandSetting', _id?: any | null, contactPerson?: string | null, contactPersonEmail?: string | null };

export type UsersInviteSendMutationVariables = Exact<{
  brandHouseId?: InputMaybe<Scalars['MongoID']>;
  email: Scalars['String'];
}>;


export type UsersInviteSendMutation = { __typename?: 'Mutation', UserInvite?: { __typename?: 'UserAccess', brandHouseId?: any | null, brandHouseName?: string | null, inviteTokenTs?: Date | null, user?: { __typename?: 'User', _id: any, name?: string | null, email: string, resetTokenTs?: Date | null } | null } | null };

export type UserAccessesQueryVariables = Exact<{
  brandHouseId?: InputMaybe<Scalars['MongoID']>;
}>;


export type UserAccessesQuery = { __typename?: 'Query', UserAccesses?: Array<{ __typename?: 'UserAccess', _id: any, brandHouseId?: any | null, brandHouseName?: string | null, logisticsPartnerId?: any | null, logisticsPartnerName?: string | null, inviteTokenTs?: Date | null, disabled?: boolean | null, user?: { __typename?: 'User', _id: any, name?: string | null, email: string, lastLoginAt?: Date | null, resetTokenTs?: Date | null } | null } | null> | null };

export type UserAccessToggleMutationVariables = Exact<{
  id: Scalars['MongoID'];
  disabled: Scalars['Boolean'];
}>;


export type UserAccessToggleMutation = { __typename?: 'Mutation', UserAccessToggle?: { __typename?: 'UserAccess', _id: any, disabled?: boolean | null } | null };

export type ShopConnectorMenuQueryVariables = Exact<{ [key: string]: never; }>;


export type ShopConnectorMenuQuery = { __typename?: 'Query', IntegrationConnectors: Array<{ __typename?: 'IntegrationConnector', _id: any, name: string, type: EnumIntegrationConnectorType, refTypes?: Array<EnumIntegrationConnectorRefTypes | null> | null, activeFor?: Array<any | null> | null, autoInstallFor?: Array<EnumIntegrationConnectorAutoInstallFor | null> | null, messages?: Array<EnumIntegrationConnectorMessages | null> | null }> };

export type ConfigCompareQueryVariables = Exact<{
  shopIdA?: InputMaybe<Scalars['MongoID']>;
  brandHouseIdA?: InputMaybe<Scalars['MongoID']>;
  shopIdB?: InputMaybe<Scalars['MongoID']>;
  brandHouseIdB?: InputMaybe<Scalars['MongoID']>;
  models?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type ConfigCompareQuery = { __typename?: 'Query', ConfigCompare?: { __typename?: 'ConfigCompareResult', nameA: string, nameB: string, comparedAt: Date, summary?: { __typename?: 'ConfigCompareSummary', totalDifferences: number, byModel?: Array<{ __typename?: 'ConfigCompareModelSummary', modelName: string, count: number } | null> | null } | null, differences?: Array<{ __typename?: 'PathDifference', path: string, valueA?: any | null, valueB?: any | null, differenceType?: DifferenceTypeEnum | null, modelName: string } | null> | null } | null };

export type DetailsPageBrandByIdQueryVariables = Exact<{
  id: Scalars['MongoID'];
}>;


export type DetailsPageBrandByIdQuery = { __typename?: 'Query', BrandHouse?: { __typename?: 'BrandHouse', _id: any, name?: string | null, license?: string | null, deactivated?: boolean | null, logisticsPartnerId: any, shops?: Array<{ __typename?: 'Shop', _id: any, externalId?: string | null, name?: string | null, currency?: string | null, live?: boolean | null, frontendType: EnumShopFrontendType } | null> | null, address?: { __typename?: 'AddressInfo', name?: string | null, attention?: string | null, add1?: string | null, add2?: string | null, zipCode?: string | null, city?: string | null, countryCode?: string | null, phone?: string | null, mail?: string | null } | null } | null, LogisticsPartners: Array<{ __typename?: 'LogisticsPartner', _id: any, name?: string | null }> };

export type DetailsPageBrandUpdateMutationVariables = Exact<{
  id: Scalars['MongoID'];
  input: UpdateByIdBrandHouseInput;
}>;


export type DetailsPageBrandUpdateMutation = { __typename?: 'Mutation', BrandHouseUpdate?: { __typename?: 'UpdateByIdBrandHousePayload', record?: { __typename?: 'BrandHouse', _id: any, name?: string | null, logisticsPartnerId: any } | null } | null };

export type BrandHouseShopFragment = { __typename?: 'Shop', _id: any, externalId?: string | null, name?: string | null, currency?: string | null, live?: boolean | null, frontendType: EnumShopFrontendType };

export type RefIntegrationSettingsQueryVariables = Exact<{
  instanceId: Scalars['MongoID'];
}>;


export type RefIntegrationSettingsQuery = { __typename?: 'Query', IntegrationInstance?: { __typename?: 'IntegrationInstance', _id: any, name: string, connector?: { __typename?: 'IntegrationConnector', _id: any, name: string, messages?: Array<EnumIntegrationConnectorMessages | null> | null, fields?: Array<{ __typename?: 'IntegrationConnectorFields', field: string, description: string, namespace: string, type: string, options?: Array<{ __typename?: 'IntegrationConnectorFieldsOptions', value: any, label: string } | null> | null } | null> | null } | null, settings?: Array<{ __typename?: 'IntegrationSetting', _id: any, refId: any, instanceId: any, key: string, value?: any | null } | null> | null, configs?: Array<{ __typename?: 'IntegrationConfig', _id: any, refId: any, message: EnumIntegrationConfigMessage, enabled: boolean } | null> | null } | null };

export type RefIntegrationSettingUpdateMutationVariables = Exact<{
  instanceId: Scalars['MongoID'];
  input?: InputMaybe<Array<IntegrationSettingInInput> | IntegrationSettingInInput>;
}>;


export type RefIntegrationSettingUpdateMutation = { __typename?: 'Mutation', IntegrationSettingUpdate?: Array<{ __typename?: 'IntegrationSetting', _id: any, refId: any, instanceId: any, key: string, value?: any | null } | null> | null };

export type RefIntegrationMessageUpdateMutationVariables = Exact<{
  instanceId: Scalars['MongoID'];
  message?: InputMaybe<IntegrationMessageEnum>;
  enabled: Scalars['Boolean'];
}>;


export type RefIntegrationMessageUpdateMutation = { __typename?: 'Mutation', IntegrationConfigUpdate?: { __typename?: 'IntegrationConfig', _id: any, message: EnumIntegrationConfigMessage, instanceId: any, refId: any } | null };

export type RefConsumerActivitySetupMutationVariables = Exact<{
  instanceId: Scalars['MongoID'];
  email: Scalars['String'];
}>;


export type RefConsumerActivitySetupMutation = { __typename?: 'Mutation', ConsumerActivitySetup: string };

export type RefIntegrationConfigQueryVariables = Exact<{
  refId: Scalars['MongoID'];
}>;


export type RefIntegrationConfigQuery = { __typename?: 'Query', IntegrationConnectors: Array<{ __typename?: 'IntegrationConnector', _id: any, name: string, icon?: string | null, activeFor?: Array<any | null> | null, type: EnumIntegrationConnectorType, messages?: Array<EnumIntegrationConnectorMessages | null> | null }>, IntegrationInstances: Array<{ __typename?: 'IntegrationInstance', _id: any, name: string, connectorId: any, enabled: boolean, deleted?: boolean | null, mode: EnumIntegrationInstanceMode, configs?: Array<{ __typename?: 'IntegrationConfig', _id: any, message: EnumIntegrationConfigMessage, enabled: boolean } | null> | null }> };

export type RefIntegrationInstallConnectorMutationVariables = Exact<{
  refId: Scalars['MongoID'];
  connectorId: Scalars['MongoID'];
  refType: EnumIntegrationConnectorRefType;
}>;


export type RefIntegrationInstallConnectorMutation = { __typename?: 'Mutation', IntegrationInstall?: { __typename?: 'IntegrationInstance', _id: any, connectorId: any, refId: any, enabled: boolean, deleted?: boolean | null } | null };

export type RefIntegrationUninstallMutationVariables = Exact<{
  refId: Scalars['MongoID'];
  refType: EnumIntegrationConnectorRefType;
  instanceId: Scalars['MongoID'];
}>;


export type RefIntegrationUninstallMutation = { __typename?: 'Mutation', IntegrationUnInstall?: { __typename?: 'IntegrationInstance', _id: any, name: string, deleted?: boolean | null, enabled: boolean } | null };

export type SalesforceEditGetQueryVariables = Exact<{
  brandHouseId: Scalars['MongoID'];
}>;


export type SalesforceEditGetQuery = { __typename?: 'Query', BrandHouse?: { __typename?: 'BrandHouse', _id: any, license?: string | null } | null };

export type SalesforceEditShopQueryVariables = Exact<{
  shop: Scalars['MongoID'];
}>;


export type SalesforceEditShopQuery = { __typename?: 'Query', ShopById?: { __typename?: 'Shop', _id: any, externalId?: string | null, name?: string | null, configuration?: any | null, logisticsPartnerId: any } | null, LogisticsPartners: Array<{ __typename?: 'LogisticsPartner', _id: any, name?: string | null }> };

export type SalesforceEditCreateMutationVariables = Exact<{
  name: Scalars['String'];
  externId: Scalars['String'];
  license: Scalars['String'];
  config?: InputMaybe<Scalars['JSON']>;
}>;


export type SalesforceEditCreateMutation = { __typename?: 'Mutation', ShopCreate2?: { __typename?: 'Shop', _id: any } | null };

export type SalesforceEditUpdateMutationVariables = Exact<{
  shopId: Scalars['String'];
  data: Scalars['JSON'];
}>;


export type SalesforceEditUpdateMutation = { __typename?: 'Mutation', ShopUpdate?: { __typename?: 'Shop', _id: any, configuration?: any | null } | null };

export type ShopCreateGetQueryVariables = Exact<{
  brandHouseId: Scalars['MongoID'];
}>;


export type ShopCreateGetQuery = { __typename?: 'Query', BrandHouse?: { __typename?: 'BrandHouse', _id: any, license?: string | null } | null };

export type ShopCreateMutationVariables = Exact<{
  name: Scalars['String'];
  currency: Scalars['String'];
  locale: Scalars['String'];
  license: Scalars['String'];
  frontendType: EnumShopFrontendType;
  mainCountryCode: Scalars['String'];
  shop: Scalars['String'];
  tradeInBaseUrl: Scalars['String'];
}>;


export type ShopCreateMutation = { __typename?: 'Mutation', ShopCreate?: { __typename?: 'Shop', _id: any } | null };

export type ShopIntegrationConfigQueryVariables = Exact<{
  shopId: Scalars['MongoID'];
}>;


export type ShopIntegrationConfigQuery = { __typename?: 'Query', BrandSettings?: { __typename?: 'BrandSetting', _id?: any | null, legacyIntegrationDisabled?: boolean | null, legacyIntegrationDisabledMessages?: Array<EnumBrandSettingLegacyIntegrationDisabledMessages | null> | null } | null };

export type ShopSettingsShopQueryVariables = Exact<{
  shopId: Scalars['MongoID'];
}>;


export type ShopSettingsShopQuery = { __typename?: 'Query', ShopById?: { __typename?: 'Shop', _id: any, name?: string | null, live?: boolean | null, liveDate?: Date | null, closeDate?: Date | null, tradeInBaseUrl?: string | null, shopCollectionUrl?: string | null, currency?: string | null, disableContactResetDate?: Date | null, frontendType: EnumShopFrontendType, logisticsPartnerId: any } | null, LogisticsPartners: Array<{ __typename?: 'LogisticsPartner', _id: any, name?: string | null }> };

export type ShopSettingsShopUpdateMutationVariables = Exact<{
  shopId: Scalars['String'];
  shop: ShopUpdateInput;
}>;


export type ShopSettingsShopUpdateMutation = { __typename?: 'Mutation', ShopUpdate?: { __typename?: 'Shop', _id: any } | null };

export type ShopResetMutationVariables = Exact<{
  shopId: Scalars['MongoID'];
}>;


export type ShopResetMutation = { __typename?: 'Mutation', ShopReset?: { __typename?: 'Shop', _id: any } | null };

export type ShopSettingsLogisticsPartnerUpdateMutationVariables = Exact<{
  shopId: Scalars['MongoID'];
  logisticsPartnerId: Scalars['MongoID'];
}>;


export type ShopSettingsLogisticsPartnerUpdateMutation = { __typename?: 'Mutation', ShopUpdateOne?: { __typename?: 'UpdateOneShopPayload', recordId?: any | null, record?: { __typename?: 'Shop', _id: any, logisticsPartnerId: any } | null } | null };

export type AutoTagShopQueryVariables = Exact<{
  shopId: Scalars['MongoID'];
}>;


export type AutoTagShopQuery = { __typename?: 'Query', ShopById?: { __typename?: 'Shop', _id: any, productTags?: Array<string> | null } | null };

export type AutoTagBrandQueryVariables = Exact<{
  brandHouseId: Scalars['MongoID'];
}>;


export type AutoTagBrandQuery = { __typename?: 'Query', BrandHouse?: { __typename?: 'BrandHouse', _id: any, productTags?: Array<string> | null } | null };

export type AutoTagSettingsQueryVariables = Exact<{
  shopId?: InputMaybe<Scalars['MongoID']>;
  brandHouseId?: InputMaybe<Scalars['MongoID']>;
}>;


export type AutoTagSettingsQuery = { __typename?: 'Query', BrandSettings?: { __typename?: 'BrandSetting', _id?: any | null, stockItemConfig?: { __typename?: 'BrandSettingStockItemConfig', titlePrefix?: string | null, titleSeperator?: string | null, titleAdvanced?: string | null, appendSeperator?: string | null, appendColor?: boolean | null, appendSize?: boolean | null, descriptionSuffix?: string | null, template?: string | null, imageAltText?: string | null, originalImageAltText?: string | null, vendor?: string | null, imageSorting?: EnumBrandSettingStockItemConfigImageSorting | null, skuStrategy?: EnumBrandSettingStockItemConfigSkuStrategy | null, colorStrategy?: EnumBrandSettingStockItemConfigColorStrategy | null, imageRotate?: number | null, masterImageCount?: number | null, masterImageTypes?: Array<EnumBrandSettingStockItemConfigMasterImageTypes | null> | null, itemRuleColor?: boolean | null, itemRuleSize?: boolean | null, itemRuleOther?: boolean | null, itemRulePrice?: boolean | null, itemRuleImages?: number | null, requireReview?: boolean | null, queueDuplicates?: boolean | null, descriptionSuffixLocalized?: Array<{ __typename?: 'LocalizationEntry', locale: string, value: string } | null> | null, currencies?: Array<{ __typename?: 'Currency', currency: string, active?: boolean | null } | null> | null, autoData?: Array<{ __typename?: 'BrandSettingStockItemConfigAutoData', target: EnumBrandSettingStockItemConfigAutoDataTarget, operator: EnumBrandSettingStockItemConfigAutoDataOperator, tag: string, search: EnumBrandSettingStockItemConfigAutoDataSearch } | null> | null, extraMeta?: Array<{ __typename?: 'MetaFieldInstance', key: string, value: any, type?: EnumMetaFieldInstanceType | null, auto?: boolean | null, namespace?: string | null } | null> | null, extraTags?: Array<{ __typename?: 'BrandSettingStockItemConfigExtraTags', active?: boolean | null, tag: string } | null> | null, imageAltTextLocalized?: Array<{ __typename?: 'LocalizationEntry', locale: string, value: string } | null> | null, originalImageAltTextLocalized?: Array<{ __typename?: 'LocalizationEntry', locale: string, value: string } | null> | null, overrides?: { __typename?: 'BrandSettingStockItemConfigOverrides', productType?: string | null, vendor?: string | null } | null, itemRules?: Array<{ __typename?: 'BrandSettingStockItemConfigItemRules', message: string, expression: string } | null> | null, replacements?: Array<{ __typename?: 'BrandSettingStockItemConfigReplacements', locales?: Array<string | null> | null, search: string, replace: string } | null> | null } | null } | null };

export type AutoTagSettingsUpdateMutationVariables = Exact<{
  shopId?: InputMaybe<Scalars['MongoID']>;
  brandHouseId?: InputMaybe<Scalars['MongoID']>;
  stockConfig?: InputMaybe<BrandSettingStockItemConfigInput>;
  auditNoteId?: InputMaybe<Scalars['MongoID']>;
}>;


export type AutoTagSettingsUpdateMutation = { __typename?: 'Mutation', BrandSettingsUpdate?: { __typename?: 'BrandSetting', _id?: any | null, stockItemConfig?: { __typename?: 'BrandSettingStockItemConfig', titlePrefix?: string | null, titleSeperator?: string | null, titleAdvanced?: string | null, appendSeperator?: string | null, appendColor?: boolean | null, appendSize?: boolean | null, descriptionSuffix?: string | null, template?: string | null, imageAltText?: string | null, originalImageAltText?: string | null, vendor?: string | null, imageSorting?: EnumBrandSettingStockItemConfigImageSorting | null, skuStrategy?: EnumBrandSettingStockItemConfigSkuStrategy | null, colorStrategy?: EnumBrandSettingStockItemConfigColorStrategy | null, imageRotate?: number | null, masterImageCount?: number | null, masterImageTypes?: Array<EnumBrandSettingStockItemConfigMasterImageTypes | null> | null, itemRuleColor?: boolean | null, itemRuleSize?: boolean | null, itemRuleOther?: boolean | null, itemRulePrice?: boolean | null, itemRuleImages?: number | null, requireReview?: boolean | null, queueDuplicates?: boolean | null, descriptionSuffixLocalized?: Array<{ __typename?: 'LocalizationEntry', locale: string, value: string } | null> | null, currencies?: Array<{ __typename?: 'Currency', currency: string, active?: boolean | null } | null> | null, autoData?: Array<{ __typename?: 'BrandSettingStockItemConfigAutoData', target: EnumBrandSettingStockItemConfigAutoDataTarget, operator: EnumBrandSettingStockItemConfigAutoDataOperator, tag: string, search: EnumBrandSettingStockItemConfigAutoDataSearch } | null> | null, extraMeta?: Array<{ __typename?: 'MetaFieldInstance', key: string, value: any, type?: EnumMetaFieldInstanceType | null, auto?: boolean | null, namespace?: string | null } | null> | null, extraTags?: Array<{ __typename?: 'BrandSettingStockItemConfigExtraTags', active?: boolean | null, tag: string } | null> | null, imageAltTextLocalized?: Array<{ __typename?: 'LocalizationEntry', locale: string, value: string } | null> | null, originalImageAltTextLocalized?: Array<{ __typename?: 'LocalizationEntry', locale: string, value: string } | null> | null, overrides?: { __typename?: 'BrandSettingStockItemConfigOverrides', productType?: string | null, vendor?: string | null } | null, itemRules?: Array<{ __typename?: 'BrandSettingStockItemConfigItemRules', message: string, expression: string } | null> | null, replacements?: Array<{ __typename?: 'BrandSettingStockItemConfigReplacements', locales?: Array<string | null> | null, search: string, replace: string } | null> | null } | null } | null };

export type BasicSettingsShopQueryVariables = Exact<{
  shopId: Scalars['MongoID'];
}>;


export type BasicSettingsShopQuery = { __typename?: 'Query', ShopById?: { __typename?: 'Shop', _id: any, stockItemLocalePrimary: string, stockItemLocales: Array<string> } | null };

export type BasicSettingsStockQueryVariables = Exact<{
  shopId?: InputMaybe<Scalars['MongoID']>;
  brandHouseId?: InputMaybe<Scalars['MongoID']>;
}>;


export type BasicSettingsStockQuery = { __typename?: 'Query', BrandSettings?: { __typename?: 'BrandSetting', _id?: any | null, defaultCountryOfOrigin?: string | null, locales?: Array<{ __typename?: 'BrandLocale', activeItems?: boolean | null, locale: string } | null> | null, stockItemConfig?: { __typename?: 'BrandSettingStockItemConfig', titlePrefix?: string | null, titleSeperator?: string | null, titleAdvanced?: string | null, appendSeperator?: string | null, appendColor?: boolean | null, appendSize?: boolean | null, descriptionSuffix?: string | null, template?: string | null, imageAltText?: string | null, originalImageAltText?: string | null, vendor?: string | null, imageSorting?: EnumBrandSettingStockItemConfigImageSorting | null, skuStrategy?: EnumBrandSettingStockItemConfigSkuStrategy | null, colorStrategy?: EnumBrandSettingStockItemConfigColorStrategy | null, imageRotate?: number | null, masterImageCount?: number | null, masterImageTypes?: Array<EnumBrandSettingStockItemConfigMasterImageTypes | null> | null, itemRuleColor?: boolean | null, itemRuleSize?: boolean | null, itemRuleOther?: boolean | null, itemRulePrice?: boolean | null, itemRuleImages?: number | null, requireReview?: boolean | null, queueDuplicates?: boolean | null, descriptionSuffixLocalized?: Array<{ __typename?: 'LocalizationEntry', locale: string, value: string } | null> | null, currencies?: Array<{ __typename?: 'Currency', currency: string, active?: boolean | null } | null> | null, autoData?: Array<{ __typename?: 'BrandSettingStockItemConfigAutoData', target: EnumBrandSettingStockItemConfigAutoDataTarget, operator: EnumBrandSettingStockItemConfigAutoDataOperator, tag: string, search: EnumBrandSettingStockItemConfigAutoDataSearch } | null> | null, extraMeta?: Array<{ __typename?: 'MetaFieldInstance', key: string, value: any, type?: EnumMetaFieldInstanceType | null, auto?: boolean | null, namespace?: string | null } | null> | null, extraTags?: Array<{ __typename?: 'BrandSettingStockItemConfigExtraTags', active?: boolean | null, tag: string } | null> | null, imageAltTextLocalized?: Array<{ __typename?: 'LocalizationEntry', locale: string, value: string } | null> | null, originalImageAltTextLocalized?: Array<{ __typename?: 'LocalizationEntry', locale: string, value: string } | null> | null, overrides?: { __typename?: 'BrandSettingStockItemConfigOverrides', productType?: string | null, vendor?: string | null } | null, itemRules?: Array<{ __typename?: 'BrandSettingStockItemConfigItemRules', message: string, expression: string } | null> | null, replacements?: Array<{ __typename?: 'BrandSettingStockItemConfigReplacements', locales?: Array<string | null> | null, search: string, replace: string } | null> | null } | null } | null };

export type BasicSettingsStockUpdateMutationVariables = Exact<{
  shopId?: InputMaybe<Scalars['MongoID']>;
  brandHouseId?: InputMaybe<Scalars['MongoID']>;
  stockConfig?: InputMaybe<BrandSettingStockItemConfigInput>;
  defaultCountryOfOrigin?: InputMaybe<Scalars['String']>;
  auditNoteId?: InputMaybe<Scalars['MongoID']>;
}>;


export type BasicSettingsStockUpdateMutation = { __typename?: 'Mutation', BrandSettingsUpdate?: { __typename?: 'BrandSetting', _id?: any | null, defaultCountryOfOrigin?: string | null, stockItemConfig?: { __typename?: 'BrandSettingStockItemConfig', titlePrefix?: string | null, titleSeperator?: string | null, titleAdvanced?: string | null, appendSeperator?: string | null, appendColor?: boolean | null, appendSize?: boolean | null, descriptionSuffix?: string | null, template?: string | null, imageAltText?: string | null, originalImageAltText?: string | null, vendor?: string | null, imageSorting?: EnumBrandSettingStockItemConfigImageSorting | null, skuStrategy?: EnumBrandSettingStockItemConfigSkuStrategy | null, colorStrategy?: EnumBrandSettingStockItemConfigColorStrategy | null, imageRotate?: number | null, masterImageCount?: number | null, masterImageTypes?: Array<EnumBrandSettingStockItemConfigMasterImageTypes | null> | null, itemRuleColor?: boolean | null, itemRuleSize?: boolean | null, itemRuleOther?: boolean | null, itemRulePrice?: boolean | null, itemRuleImages?: number | null, requireReview?: boolean | null, queueDuplicates?: boolean | null, descriptionSuffixLocalized?: Array<{ __typename?: 'LocalizationEntry', locale: string, value: string } | null> | null, currencies?: Array<{ __typename?: 'Currency', currency: string, active?: boolean | null } | null> | null, autoData?: Array<{ __typename?: 'BrandSettingStockItemConfigAutoData', target: EnumBrandSettingStockItemConfigAutoDataTarget, operator: EnumBrandSettingStockItemConfigAutoDataOperator, tag: string, search: EnumBrandSettingStockItemConfigAutoDataSearch } | null> | null, extraMeta?: Array<{ __typename?: 'MetaFieldInstance', key: string, value: any, type?: EnumMetaFieldInstanceType | null, auto?: boolean | null, namespace?: string | null } | null> | null, extraTags?: Array<{ __typename?: 'BrandSettingStockItemConfigExtraTags', active?: boolean | null, tag: string } | null> | null, imageAltTextLocalized?: Array<{ __typename?: 'LocalizationEntry', locale: string, value: string } | null> | null, originalImageAltTextLocalized?: Array<{ __typename?: 'LocalizationEntry', locale: string, value: string } | null> | null, overrides?: { __typename?: 'BrandSettingStockItemConfigOverrides', productType?: string | null, vendor?: string | null } | null, itemRules?: Array<{ __typename?: 'BrandSettingStockItemConfigItemRules', message: string, expression: string } | null> | null, replacements?: Array<{ __typename?: 'BrandSettingStockItemConfigReplacements', locales?: Array<string | null> | null, search: string, replace: string } | null> | null } | null } | null };

export type LocaleItemSettingsQueryVariables = Exact<{
  shopId?: InputMaybe<Scalars['MongoID']>;
}>;


export type LocaleItemSettingsQuery = { __typename?: 'Query', BrandSettings?: { __typename?: 'BrandSetting', _id?: any | null, stockItemConfig?: { __typename?: 'BrandSettingStockItemConfig', titlePrefix?: string | null, titleSeperator?: string | null, titleAdvanced?: string | null, appendSeperator?: string | null, appendColor?: boolean | null, appendSize?: boolean | null, descriptionSuffix?: string | null, template?: string | null, imageAltText?: string | null, originalImageAltText?: string | null, vendor?: string | null, imageSorting?: EnumBrandSettingStockItemConfigImageSorting | null, skuStrategy?: EnumBrandSettingStockItemConfigSkuStrategy | null, colorStrategy?: EnumBrandSettingStockItemConfigColorStrategy | null, imageRotate?: number | null, masterImageCount?: number | null, masterImageTypes?: Array<EnumBrandSettingStockItemConfigMasterImageTypes | null> | null, itemRuleColor?: boolean | null, itemRuleSize?: boolean | null, itemRuleOther?: boolean | null, itemRulePrice?: boolean | null, itemRuleImages?: number | null, requireReview?: boolean | null, queueDuplicates?: boolean | null, descriptionSuffixLocalized?: Array<{ __typename?: 'LocalizationEntry', locale: string, value: string } | null> | null, currencies?: Array<{ __typename?: 'Currency', currency: string, active?: boolean | null } | null> | null, autoData?: Array<{ __typename?: 'BrandSettingStockItemConfigAutoData', target: EnumBrandSettingStockItemConfigAutoDataTarget, operator: EnumBrandSettingStockItemConfigAutoDataOperator, tag: string, search: EnumBrandSettingStockItemConfigAutoDataSearch } | null> | null, extraMeta?: Array<{ __typename?: 'MetaFieldInstance', key: string, value: any, type?: EnumMetaFieldInstanceType | null, auto?: boolean | null, namespace?: string | null } | null> | null, extraTags?: Array<{ __typename?: 'BrandSettingStockItemConfigExtraTags', active?: boolean | null, tag: string } | null> | null, imageAltTextLocalized?: Array<{ __typename?: 'LocalizationEntry', locale: string, value: string } | null> | null, originalImageAltTextLocalized?: Array<{ __typename?: 'LocalizationEntry', locale: string, value: string } | null> | null, overrides?: { __typename?: 'BrandSettingStockItemConfigOverrides', productType?: string | null, vendor?: string | null } | null, itemRules?: Array<{ __typename?: 'BrandSettingStockItemConfigItemRules', message: string, expression: string } | null> | null, replacements?: Array<{ __typename?: 'BrandSettingStockItemConfigReplacements', locales?: Array<string | null> | null, search: string, replace: string } | null> | null } | null } | null };

export type LocaleItemSettingsUpdateMutationVariables = Exact<{
  shopId?: InputMaybe<Scalars['MongoID']>;
  stockConfig?: InputMaybe<BrandSettingStockItemConfigInput>;
  auditNoteId?: InputMaybe<Scalars['MongoID']>;
}>;


export type LocaleItemSettingsUpdateMutation = { __typename?: 'Mutation', BrandSettingsUpdate?: { __typename?: 'BrandSetting', _id?: any | null, stockItemConfig?: { __typename?: 'BrandSettingStockItemConfig', titlePrefix?: string | null, titleSeperator?: string | null, titleAdvanced?: string | null, appendSeperator?: string | null, appendColor?: boolean | null, appendSize?: boolean | null, descriptionSuffix?: string | null, template?: string | null, imageAltText?: string | null, originalImageAltText?: string | null, vendor?: string | null, imageSorting?: EnumBrandSettingStockItemConfigImageSorting | null, skuStrategy?: EnumBrandSettingStockItemConfigSkuStrategy | null, colorStrategy?: EnumBrandSettingStockItemConfigColorStrategy | null, imageRotate?: number | null, masterImageCount?: number | null, masterImageTypes?: Array<EnumBrandSettingStockItemConfigMasterImageTypes | null> | null, itemRuleColor?: boolean | null, itemRuleSize?: boolean | null, itemRuleOther?: boolean | null, itemRulePrice?: boolean | null, itemRuleImages?: number | null, requireReview?: boolean | null, queueDuplicates?: boolean | null, descriptionSuffixLocalized?: Array<{ __typename?: 'LocalizationEntry', locale: string, value: string } | null> | null, currencies?: Array<{ __typename?: 'Currency', currency: string, active?: boolean | null } | null> | null, autoData?: Array<{ __typename?: 'BrandSettingStockItemConfigAutoData', target: EnumBrandSettingStockItemConfigAutoDataTarget, operator: EnumBrandSettingStockItemConfigAutoDataOperator, tag: string, search: EnumBrandSettingStockItemConfigAutoDataSearch } | null> | null, extraMeta?: Array<{ __typename?: 'MetaFieldInstance', key: string, value: any, type?: EnumMetaFieldInstanceType | null, auto?: boolean | null, namespace?: string | null } | null> | null, extraTags?: Array<{ __typename?: 'BrandSettingStockItemConfigExtraTags', active?: boolean | null, tag: string } | null> | null, imageAltTextLocalized?: Array<{ __typename?: 'LocalizationEntry', locale: string, value: string } | null> | null, originalImageAltTextLocalized?: Array<{ __typename?: 'LocalizationEntry', locale: string, value: string } | null> | null, overrides?: { __typename?: 'BrandSettingStockItemConfigOverrides', productType?: string | null, vendor?: string | null } | null, itemRules?: Array<{ __typename?: 'BrandSettingStockItemConfigItemRules', message: string, expression: string } | null> | null, replacements?: Array<{ __typename?: 'BrandSettingStockItemConfigReplacements', locales?: Array<string | null> | null, search: string, replace: string } | null> | null } | null } | null };

export type LocaleItemBrandHouseSettingsQueryVariables = Exact<{
  brandHouseId?: InputMaybe<Scalars['MongoID']>;
}>;


export type LocaleItemBrandHouseSettingsQuery = { __typename?: 'Query', BrandSettings?: { __typename?: 'BrandSetting', _id?: any | null, stockItemConfig?: { __typename?: 'BrandSettingStockItemConfig', titlePrefix?: string | null, titleSeperator?: string | null, titleAdvanced?: string | null, appendSeperator?: string | null, appendColor?: boolean | null, appendSize?: boolean | null, descriptionSuffix?: string | null, template?: string | null, imageAltText?: string | null, originalImageAltText?: string | null, vendor?: string | null, imageSorting?: EnumBrandSettingStockItemConfigImageSorting | null, skuStrategy?: EnumBrandSettingStockItemConfigSkuStrategy | null, colorStrategy?: EnumBrandSettingStockItemConfigColorStrategy | null, imageRotate?: number | null, masterImageCount?: number | null, masterImageTypes?: Array<EnumBrandSettingStockItemConfigMasterImageTypes | null> | null, itemRuleColor?: boolean | null, itemRuleSize?: boolean | null, itemRuleOther?: boolean | null, itemRulePrice?: boolean | null, itemRuleImages?: number | null, requireReview?: boolean | null, queueDuplicates?: boolean | null, descriptionSuffixLocalized?: Array<{ __typename?: 'LocalizationEntry', locale: string, value: string } | null> | null, currencies?: Array<{ __typename?: 'Currency', currency: string, active?: boolean | null } | null> | null, autoData?: Array<{ __typename?: 'BrandSettingStockItemConfigAutoData', target: EnumBrandSettingStockItemConfigAutoDataTarget, operator: EnumBrandSettingStockItemConfigAutoDataOperator, tag: string, search: EnumBrandSettingStockItemConfigAutoDataSearch } | null> | null, extraMeta?: Array<{ __typename?: 'MetaFieldInstance', key: string, value: any, type?: EnumMetaFieldInstanceType | null, auto?: boolean | null, namespace?: string | null } | null> | null, extraTags?: Array<{ __typename?: 'BrandSettingStockItemConfigExtraTags', active?: boolean | null, tag: string } | null> | null, imageAltTextLocalized?: Array<{ __typename?: 'LocalizationEntry', locale: string, value: string } | null> | null, originalImageAltTextLocalized?: Array<{ __typename?: 'LocalizationEntry', locale: string, value: string } | null> | null, overrides?: { __typename?: 'BrandSettingStockItemConfigOverrides', productType?: string | null, vendor?: string | null } | null, itemRules?: Array<{ __typename?: 'BrandSettingStockItemConfigItemRules', message: string, expression: string } | null> | null, replacements?: Array<{ __typename?: 'BrandSettingStockItemConfigReplacements', locales?: Array<string | null> | null, search: string, replace: string } | null> | null } | null } | null };

export type LocaleItemBrandHouseSettingsUpdateMutationVariables = Exact<{
  brandHouseId?: InputMaybe<Scalars['MongoID']>;
  stockConfig?: InputMaybe<BrandSettingStockItemConfigInput>;
  auditNoteId?: InputMaybe<Scalars['MongoID']>;
}>;


export type LocaleItemBrandHouseSettingsUpdateMutation = { __typename?: 'Mutation', BrandSettingsUpdate?: { __typename?: 'BrandSetting', _id?: any | null, stockItemConfig?: { __typename?: 'BrandSettingStockItemConfig', titlePrefix?: string | null, titleSeperator?: string | null, titleAdvanced?: string | null, appendSeperator?: string | null, appendColor?: boolean | null, appendSize?: boolean | null, descriptionSuffix?: string | null, template?: string | null, imageAltText?: string | null, originalImageAltText?: string | null, vendor?: string | null, imageSorting?: EnumBrandSettingStockItemConfigImageSorting | null, skuStrategy?: EnumBrandSettingStockItemConfigSkuStrategy | null, colorStrategy?: EnumBrandSettingStockItemConfigColorStrategy | null, imageRotate?: number | null, masterImageCount?: number | null, masterImageTypes?: Array<EnumBrandSettingStockItemConfigMasterImageTypes | null> | null, itemRuleColor?: boolean | null, itemRuleSize?: boolean | null, itemRuleOther?: boolean | null, itemRulePrice?: boolean | null, itemRuleImages?: number | null, requireReview?: boolean | null, queueDuplicates?: boolean | null, descriptionSuffixLocalized?: Array<{ __typename?: 'LocalizationEntry', locale: string, value: string } | null> | null, currencies?: Array<{ __typename?: 'Currency', currency: string, active?: boolean | null } | null> | null, autoData?: Array<{ __typename?: 'BrandSettingStockItemConfigAutoData', target: EnumBrandSettingStockItemConfigAutoDataTarget, operator: EnumBrandSettingStockItemConfigAutoDataOperator, tag: string, search: EnumBrandSettingStockItemConfigAutoDataSearch } | null> | null, extraMeta?: Array<{ __typename?: 'MetaFieldInstance', key: string, value: any, type?: EnumMetaFieldInstanceType | null, auto?: boolean | null, namespace?: string | null } | null> | null, extraTags?: Array<{ __typename?: 'BrandSettingStockItemConfigExtraTags', active?: boolean | null, tag: string } | null> | null, imageAltTextLocalized?: Array<{ __typename?: 'LocalizationEntry', locale: string, value: string } | null> | null, originalImageAltTextLocalized?: Array<{ __typename?: 'LocalizationEntry', locale: string, value: string } | null> | null, overrides?: { __typename?: 'BrandSettingStockItemConfigOverrides', productType?: string | null, vendor?: string | null } | null, itemRules?: Array<{ __typename?: 'BrandSettingStockItemConfigItemRules', message: string, expression: string } | null> | null, replacements?: Array<{ __typename?: 'BrandSettingStockItemConfigReplacements', locales?: Array<string | null> | null, search: string, replace: string } | null> | null } | null } | null };

export type SellingPriceSettingsShopQueryVariables = Exact<{
  shopId: Scalars['MongoID'];
}>;


export type SellingPriceSettingsShopQuery = { __typename?: 'Query', ShopById?: { __typename?: 'Shop', _id: any, productTags?: Array<string> | null, productTypes?: Array<string> | null, conditions?: Array<{ __typename?: 'ShopConditionPublic', condition: number, name: string, description: string } | null> | null } | null };

export type SellingPriceSettingsBrandQueryVariables = Exact<{
  brandId: Scalars['MongoID'];
}>;


export type SellingPriceSettingsBrandQuery = { __typename?: 'Query', BrandHouse?: { __typename?: 'BrandHouse', _id: any, conditions?: Array<{ __typename?: 'BrandConditionPublic', condition: number, name: string, description: string } | null> | null } | null };

export type SellingPriceSettingsQueryVariables = Exact<{
  shopId?: InputMaybe<Scalars['MongoID']>;
  brandHouseId?: InputMaybe<Scalars['MongoID']>;
}>;


export type SellingPriceSettingsQuery = { __typename?: 'Query', BrandSettings?: { __typename?: 'BrandSetting', _id?: any | null, disableRRPListPrice?: boolean | null, sellPrice?: Array<{ __typename?: 'BrandSettingSellPrice', condition?: number | null, pct?: number | null } | null> | null, sellPriceAdvanced?: Array<{ __typename?: 'BrandSettingSellPriceAdvanced', value: string, type?: EnumBrandSettingSellPriceAdvancedType | null, sellPrice?: Array<{ __typename?: 'BrandSettingSellPriceAdvancedSellPrice', condition?: number | null, pct?: number | null } | null> | null } | null> | null } | null };

export type SellingPriceSettingsUpdateMutationVariables = Exact<{
  shopId?: InputMaybe<Scalars['MongoID']>;
  brandHouseId?: InputMaybe<Scalars['MongoID']>;
  sellPrice?: InputMaybe<Array<BrandSettingSellPriceInput> | BrandSettingSellPriceInput>;
  advanced?: InputMaybe<Array<BrandSettingSellPriceAdvancedInput> | BrandSettingSellPriceAdvancedInput>;
  disableRRPListPrice: Scalars['Boolean'];
  auditNoteId?: InputMaybe<Scalars['MongoID']>;
}>;


export type SellingPriceSettingsUpdateMutation = { __typename?: 'Mutation', BrandSettingsUpdate?: { __typename?: 'BrandSetting', _id?: any | null, disableRRPListPrice?: boolean | null, sellPrice?: Array<{ __typename?: 'BrandSettingSellPrice', condition?: number | null, pct?: number | null } | null> | null, sellPriceAdvanced?: Array<{ __typename?: 'BrandSettingSellPriceAdvanced', value: string, type?: EnumBrandSettingSellPriceAdvancedType | null, sellPrice?: Array<{ __typename?: 'BrandSettingSellPriceAdvancedSellPrice', condition?: number | null, pct?: number | null } | null> | null } | null> | null } | null };

export type SellingPriceSettingsFragment = { __typename?: 'BrandSetting', _id?: any | null, disableRRPListPrice?: boolean | null, sellPrice?: Array<{ __typename?: 'BrandSettingSellPrice', condition?: number | null, pct?: number | null } | null> | null, sellPriceAdvanced?: Array<{ __typename?: 'BrandSettingSellPriceAdvanced', value: string, type?: EnumBrandSettingSellPriceAdvancedType | null, sellPrice?: Array<{ __typename?: 'BrandSettingSellPriceAdvancedSellPrice', condition?: number | null, pct?: number | null } | null> | null } | null> | null };

export type SettingsStockItemFragment = { __typename?: 'BrandSettingStockItemConfig', titlePrefix?: string | null, titleSeperator?: string | null, titleAdvanced?: string | null, appendSeperator?: string | null, appendColor?: boolean | null, appendSize?: boolean | null, descriptionSuffix?: string | null, template?: string | null, imageAltText?: string | null, originalImageAltText?: string | null, vendor?: string | null, imageSorting?: EnumBrandSettingStockItemConfigImageSorting | null, skuStrategy?: EnumBrandSettingStockItemConfigSkuStrategy | null, colorStrategy?: EnumBrandSettingStockItemConfigColorStrategy | null, imageRotate?: number | null, masterImageCount?: number | null, masterImageTypes?: Array<EnumBrandSettingStockItemConfigMasterImageTypes | null> | null, itemRuleColor?: boolean | null, itemRuleSize?: boolean | null, itemRuleOther?: boolean | null, itemRulePrice?: boolean | null, itemRuleImages?: number | null, requireReview?: boolean | null, queueDuplicates?: boolean | null, descriptionSuffixLocalized?: Array<{ __typename?: 'LocalizationEntry', locale: string, value: string } | null> | null, currencies?: Array<{ __typename?: 'Currency', currency: string, active?: boolean | null } | null> | null, autoData?: Array<{ __typename?: 'BrandSettingStockItemConfigAutoData', target: EnumBrandSettingStockItemConfigAutoDataTarget, operator: EnumBrandSettingStockItemConfigAutoDataOperator, tag: string, search: EnumBrandSettingStockItemConfigAutoDataSearch } | null> | null, extraMeta?: Array<{ __typename?: 'MetaFieldInstance', key: string, value: any, type?: EnumMetaFieldInstanceType | null, auto?: boolean | null, namespace?: string | null } | null> | null, extraTags?: Array<{ __typename?: 'BrandSettingStockItemConfigExtraTags', active?: boolean | null, tag: string } | null> | null, imageAltTextLocalized?: Array<{ __typename?: 'LocalizationEntry', locale: string, value: string } | null> | null, originalImageAltTextLocalized?: Array<{ __typename?: 'LocalizationEntry', locale: string, value: string } | null> | null, overrides?: { __typename?: 'BrandSettingStockItemConfigOverrides', productType?: string | null, vendor?: string | null } | null, itemRules?: Array<{ __typename?: 'BrandSettingStockItemConfigItemRules', message: string, expression: string } | null> | null, replacements?: Array<{ __typename?: 'BrandSettingStockItemConfigReplacements', locales?: Array<string | null> | null, search: string, replace: string } | null> | null };

export type LanguageSettingsQueryVariables = Exact<{
  shopId?: InputMaybe<Scalars['MongoID']>;
  brandHouseId?: InputMaybe<Scalars['MongoID']>;
}>;


export type LanguageSettingsQuery = { __typename?: 'Query', BrandSettings?: { __typename?: 'BrandSetting', _id?: any | null, masterDataLocale?: string | null, fallbackLocale?: string | null, locales?: Array<{ __typename?: 'BrandLocale', locale: string, activeItems?: boolean | null, activeTradeIn?: boolean | null } | null> | null } | null };

export type LanguageSettingsUpdateMutationVariables = Exact<{
  shopId?: InputMaybe<Scalars['MongoID']>;
  brandHouseId?: InputMaybe<Scalars['MongoID']>;
  masterDataLocale: Scalars['String'];
  fallbackLocale?: InputMaybe<Scalars['String']>;
  locales?: InputMaybe<Array<BrandLocaleInput> | BrandLocaleInput>;
  auditNoteId?: InputMaybe<Scalars['MongoID']>;
}>;


export type LanguageSettingsUpdateMutation = { __typename?: 'Mutation', BrandSettingsUpdate?: { __typename?: 'BrandSetting', _id?: any | null, masterDataLocale?: string | null, fallbackLocale?: string | null, locales?: Array<{ __typename?: 'BrandLocale', locale: string, activeItems?: boolean | null, activeTradeIn?: boolean | null } | null> | null } | null };

export type LanguagesFragment = { __typename?: 'BrandSetting', _id?: any | null, masterDataLocale?: string | null, fallbackLocale?: string | null, locales?: Array<{ __typename?: 'BrandLocale', locale: string, activeItems?: boolean | null, activeTradeIn?: boolean | null } | null> | null };

export type KlaviyoInstancesQueryVariables = Exact<{
  refId: Scalars['MongoID'];
}>;


export type KlaviyoInstancesQuery = { __typename?: 'Query', IntegrationInstances: Array<{ __typename?: 'IntegrationInstance', _id: any }> };

export type KlaviyoInstallMutationVariables = Exact<{
  refId: Scalars['MongoID'];
  refType: EnumIntegrationConnectorRefType;
}>;


export type KlaviyoInstallMutation = { __typename?: 'Mutation', IntegrationInstall?: { __typename?: 'IntegrationInstance', _id: any } | null };

export type KlaviyoFragment = { __typename?: 'IntegrationInstance', _id: any };

export type BrickMailGetQueryVariables = Exact<{
  shopId: Scalars['MongoID'];
  type: Scalars['String'];
}>;


export type BrickMailGetQuery = { __typename?: 'Query', BrickMail?: { __typename?: 'BrickMail', _id: any, type?: string | null, mails?: Array<{ __typename?: 'BrickMailMails', language?: string | null, mail?: any | null, mailType?: EnumBrickMailMailsMailType | null, htmlMail?: { __typename?: 'BrickMailMailsHtmlMail', subject?: string | null, html?: string | null, from?: { __typename?: 'BrickMailMailsHtmlMailFrom', name?: string | null, mail?: string | null } | null } | null } | null> | null } | null, BrickMailTypeByID?: { __typename?: 'BrickMailType', title: string, description: string } | null, ShopById?: { __typename?: 'Shop', tradeInLocales: Array<string> } | null };

export type BrickMailFragment = { __typename?: 'BrickMailMails', language?: string | null, mail?: any | null, mailType?: EnumBrickMailMailsMailType | null, htmlMail?: { __typename?: 'BrickMailMailsHtmlMail', subject?: string | null, html?: string | null, from?: { __typename?: 'BrickMailMailsHtmlMailFrom', name?: string | null, mail?: string | null } | null } | null };

export type BrickMailUpdateMutationVariables = Exact<{
  shopId: Scalars['MongoID'];
  type: Scalars['String'];
  input?: InputMaybe<Array<BrickMailMailsInput> | BrickMailMailsInput>;
  auditNoteId?: InputMaybe<Scalars['MongoID']>;
}>;


export type BrickMailUpdateMutation = { __typename?: 'Mutation', BrickMailUpdate?: Array<{ __typename?: 'BrickMailValidation', locale: string, message?: any | null, result?: BrickMailValidationResultEnum | null } | null> | null };

export type BrickMailTestMutationVariables = Exact<{
  shopId: Scalars['String'];
  type: Scalars['String'];
  email: Scalars['String'];
  language: Scalars['String'];
  activations: Scalars['Boolean'];
  testMail?: InputMaybe<Scalars['String']>;
}>;


export type BrickMailTestMutation = { __typename?: 'Mutation', BrickMailTest: string };

export type BrickMailGetTypesQueryVariables = Exact<{
  shopId: Scalars['String'];
}>;


export type BrickMailGetTypesQuery = { __typename?: 'Query', BrickMailTypes?: Array<{ __typename?: 'BrickMailType', type: string, title: string, description: string, active: boolean } | null> | null };

export type BrickMailActivateMutationVariables = Exact<{
  shopId: Scalars['String'];
  mailType: Scalars['String'];
  active: Scalars['Boolean'];
  auditNoteId?: InputMaybe<Scalars['MongoID']>;
}>;


export type BrickMailActivateMutation = { __typename?: 'Mutation', BrickMailActivate?: { __typename?: 'BrickMail', _id: any, active?: boolean | null } | null };

export type ReminderMailSettingsQueryVariables = Exact<{
  shopId: Scalars['MongoID'];
}>;


export type ReminderMailSettingsQuery = { __typename?: 'Query', BrandSettings?: { __typename?: 'BrandSetting', _id?: any | null, plannedMailsTradeIn?: { __typename?: 'BrandSettingPlannedMailsTradeIn', repeatCount?: number | null, repeatDelay?: number | null, startAfter?: number | null } | null, plannedMailsVoucher?: { __typename?: 'BrandSettingPlannedMailsVoucher', repeatCount?: number | null, repeatDelay?: number | null, startAfter?: number | null } | null } | null };

export type ReminderMailVoucherUpdateMutationVariables = Exact<{
  shopId: Scalars['MongoID'];
  voucher: BrandSettingPlannedMailsVoucherInput;
  auditNoteId?: InputMaybe<Scalars['MongoID']>;
}>;


export type ReminderMailVoucherUpdateMutation = { __typename?: 'Mutation', BrandSettingsUpdate?: { __typename?: 'BrandSetting', _id?: any | null, plannedMailsVoucher?: { __typename?: 'BrandSettingPlannedMailsVoucher', repeatCount?: number | null, repeatDelay?: number | null, startAfter?: number | null } | null } | null };

export type ReminderMailTradeInUpdateMutationVariables = Exact<{
  shopId: Scalars['MongoID'];
  voucher: BrandSettingPlannedMailsTradeInInput;
  auditNoteId?: InputMaybe<Scalars['MongoID']>;
}>;


export type ReminderMailTradeInUpdateMutation = { __typename?: 'Mutation', BrandSettingsUpdate?: { __typename?: 'BrandSetting', _id?: any | null, plannedMailsTradeIn?: { __typename?: 'BrandSettingPlannedMailsTradeIn', repeatCount?: number | null, repeatDelay?: number | null, startAfter?: number | null } | null } | null };

export type ExportMailsQueryVariables = Exact<{
  shopId: Scalars['MongoID'];
}>;


export type ExportMailsQuery = { __typename?: 'Query', BrickMails?: Array<{ __typename?: 'BrickMail', _id: any, type?: string | null, active?: boolean | null, mails?: Array<{ __typename?: 'BrickMailMails', mailType?: EnumBrickMailMailsMailType | null, mail?: any | null, language?: string | null } | null> | null } | null> | null };

export type MailFragment = { __typename?: 'BrickMail', _id: any, type?: string | null, active?: boolean | null, mails?: Array<{ __typename?: 'BrickMailMails', mailType?: EnumBrickMailMailsMailType | null, mail?: any | null, language?: string | null } | null> | null };

export type OrderSettingsQueryVariables = Exact<{
  shopId?: InputMaybe<Scalars['MongoID']>;
  brandHouseId?: InputMaybe<Scalars['MongoID']>;
}>;


export type OrderSettingsQuery = { __typename?: 'Query', BrandSettings?: { __typename?: 'BrandSetting', _id?: any | null, order?: { __typename?: 'BrandSettingOrder', deliveryNote?: any | null, gbEori?: string | null, vatRate?: number | null, externalWms?: boolean | null, externalWarehouse?: boolean | null, returnMaxDays?: number | null, refundAdjustment?: { __typename?: 'BrandSettingOrderRefundAdjustment', reason: string, oncePerOrder: boolean, adjust?: Array<{ __typename?: 'Pricing', currency: string, value: number } | null> | null } | null } | null, stockItemConfig?: { __typename?: 'BrandSettingStockItemConfig', currencies?: Array<{ __typename?: 'Currency', currency: string, active?: boolean | null } | null> | null } | null } | null };

export type OrderSettingsUpdateMutationVariables = Exact<{
  shopId?: InputMaybe<Scalars['MongoID']>;
  brandHouseId?: InputMaybe<Scalars['MongoID']>;
  input: BrandSettingOrderInput;
  auditNoteId?: InputMaybe<Scalars['MongoID']>;
}>;


export type OrderSettingsUpdateMutation = { __typename?: 'Mutation', BrandSettingsUpdate?: { __typename?: 'BrandSetting', _id?: any | null, order?: { __typename?: 'BrandSettingOrder', deliveryNote?: any | null, gbEori?: string | null, vatRate?: number | null, externalWms?: boolean | null, externalWarehouse?: boolean | null, returnMaxDays?: number | null, refundAdjustment?: { __typename?: 'BrandSettingOrderRefundAdjustment', reason: string, oncePerOrder: boolean, adjust?: Array<{ __typename?: 'Pricing', currency: string, value: number } | null> | null } | null } | null } | null };

export type OrderSettingsFragment = { __typename?: 'BrandSettingOrder', deliveryNote?: any | null, gbEori?: string | null, vatRate?: number | null, externalWms?: boolean | null, externalWarehouse?: boolean | null, returnMaxDays?: number | null, refundAdjustment?: { __typename?: 'BrandSettingOrderRefundAdjustment', reason: string, oncePerOrder: boolean, adjust?: Array<{ __typename?: 'Pricing', currency: string, value: number } | null> | null } | null };

export type CircularPageQueryVariables = Exact<{
  shopId?: InputMaybe<Scalars['MongoID']>;
  brandHouseId?: InputMaybe<Scalars['MongoID']>;
}>;


export type CircularPageQuery = { __typename?: 'Query', BrandSettings?: { __typename?: 'BrandSetting', _id?: any | null, circular?: { __typename?: 'CircularSettings', _id?: any | null, activationDate?: Date | null, payoutTypes?: Array<{ __typename?: 'CircularPayoutRatio', _id?: any | null, payoutId: any, type: string, ratio: number, active: boolean, name: string } | null> | null } | null } | null, CircularPayoutMany: Array<{ __typename?: 'CircularPayoutType', _id: any, name: string, payoutType: EnumCircularPayoutTypePayoutType, defaultRatio: number }> };

export type CircularPageUpdateMutationVariables = Exact<{
  shopId?: InputMaybe<Scalars['MongoID']>;
  brandHouseId?: InputMaybe<Scalars['MongoID']>;
  input?: InputMaybe<CircularSettingsInput>;
  auditNoteId?: InputMaybe<Scalars['MongoID']>;
}>;


export type CircularPageUpdateMutation = { __typename?: 'Mutation', BrandSettingsUpdate?: { __typename?: 'BrandSetting', _id?: any | null, circular?: { __typename?: 'CircularSettings', _id?: any | null, activationDate?: Date | null, payoutTypes?: Array<{ __typename?: 'CircularPayoutRatio', _id?: any | null, payoutId: any, type: string, ratio: number, active: boolean, name: string } | null> | null } | null } | null };

export type CircularFragment = { __typename?: 'BrandSetting', _id?: any | null, circular?: { __typename?: 'CircularSettings', _id?: any | null, activationDate?: Date | null, payoutTypes?: Array<{ __typename?: 'CircularPayoutRatio', _id?: any | null, payoutId: any, type: string, ratio: number, active: boolean, name: string } | null> | null } | null };

export type VouchersPageQueryVariables = Exact<{
  shopId?: InputMaybe<Scalars['MongoID']>;
  brandHouseId?: InputMaybe<Scalars['MongoID']>;
}>;


export type VouchersPageQuery = { __typename?: 'Query', BrandSettings?: { __typename?: 'BrandSetting', _id?: any | null, voucher?: { __typename?: 'BrandSettingVoucher', prefix?: string | null, expireDays?: number | null, minimumPurchase?: number | null, refundApproval?: boolean | null, newVoucherUsage?: boolean | null, maximumValue?: number | null, minimumPurchaseExt?: Array<{ __typename?: 'BrandSettingVoucherMinimumPurchaseExt', minimumPurchase?: number | null, valueMax?: number | null } | null> | null } | null } | null };

export type VouchersPageUpdateMutationVariables = Exact<{
  shopId?: InputMaybe<Scalars['MongoID']>;
  brandHouseId?: InputMaybe<Scalars['MongoID']>;
  input?: InputMaybe<BrandSettingVoucherInput>;
  auditNoteId?: InputMaybe<Scalars['MongoID']>;
}>;


export type VouchersPageUpdateMutation = { __typename?: 'Mutation', BrandSettingsUpdate?: { __typename?: 'BrandSetting', _id?: any | null, voucher?: { __typename?: 'BrandSettingVoucher', prefix?: string | null, expireDays?: number | null, minimumPurchase?: number | null, refundApproval?: boolean | null, newVoucherUsage?: boolean | null, maximumValue?: number | null, minimumPurchaseExt?: Array<{ __typename?: 'BrandSettingVoucherMinimumPurchaseExt', minimumPurchase?: number | null, valueMax?: number | null } | null> | null } | null } | null };

export type VoucherSettingsFragment = { __typename?: 'BrandSetting', _id?: any | null, voucher?: { __typename?: 'BrandSettingVoucher', prefix?: string | null, expireDays?: number | null, minimumPurchase?: number | null, refundApproval?: boolean | null, newVoucherUsage?: boolean | null, maximumValue?: number | null, minimumPurchaseExt?: Array<{ __typename?: 'BrandSettingVoucherMinimumPurchaseExt', minimumPurchase?: number | null, valueMax?: number | null } | null> | null } | null };

export type AnalyticsGetQueryVariables = Exact<{
  shopId?: InputMaybe<Scalars['MongoID']>;
  brandHouseId?: InputMaybe<Scalars['MongoID']>;
}>;


export type AnalyticsGetQuery = { __typename?: 'Query', BrandSettings?: { __typename?: 'BrandSetting', _id?: any | null, tradeIn2Analytics?: { __typename?: 'BrandSettingTradeIn2Analytics', ga4Property?: string | null, uaProperty?: string | null } | null } | null };

export type AnalyticsUpdateMutationVariables = Exact<{
  shopId?: InputMaybe<Scalars['MongoID']>;
  brandHouseId?: InputMaybe<Scalars['MongoID']>;
  input: BrandSettingTradeIn2AnalyticsInput;
  auditNoteId?: InputMaybe<Scalars['MongoID']>;
}>;


export type AnalyticsUpdateMutation = { __typename?: 'Mutation', BrandSettingsUpdate?: { __typename?: 'BrandSetting', _id?: any | null, tradeIn2Analytics?: { __typename?: 'BrandSettingTradeIn2Analytics', ga4Property?: string | null, uaProperty?: string | null } | null } | null };

export type AnalyticsFragment = { __typename?: 'BrandSetting', _id?: any | null, tradeIn2Analytics?: { __typename?: 'BrandSettingTradeIn2Analytics', ga4Property?: string | null, uaProperty?: string | null } | null };

export type ShopAppLayoutQueryVariables = Exact<{
  shopId?: InputMaybe<Scalars['MongoID']>;
  brandHouseId?: InputMaybe<Scalars['MongoID']>;
}>;


export type ShopAppLayoutQuery = { __typename?: 'Query', BrandSettings?: { __typename?: 'BrandSetting', _id?: any | null, defaultProductImage?: string | null, tradeIn2?: { __typename?: 'TradeInLayout', fontFamily?: string | null, disableIcons?: boolean | null, additionalCss?: string | null, h1?: { __typename?: 'TradeInLayoutH1', fontSize?: string | null, fontFamily?: string | null, fontWeight?: string | null, textColor?: string | null, uppercase?: boolean | null } | null, h2?: { __typename?: 'TradeInLayoutH1', fontSize?: string | null, fontFamily?: string | null, fontWeight?: string | null, textColor?: string | null, uppercase?: boolean | null } | null, text?: { __typename?: 'TradeInLayoutH1', fontSize?: string | null, fontFamily?: string | null, fontWeight?: string | null, textColor?: string | null, uppercase?: boolean | null } | null, subtext?: { __typename?: 'TradeInLayoutH1', fontSize?: string | null, fontFamily?: string | null, fontWeight?: string | null, textColor?: string | null, uppercase?: boolean | null } | null, mainPanel?: { __typename?: 'TradeInLayoutMainPanel', backgroundColor?: string | null, textColor?: string | null, mainButton?: { __typename?: 'TradeInLayoutMainPanelMainButton', textColor?: string | null, buttonColor?: string | null, disabledTextColor?: string | null, disabledButtonColor?: string | null, hoverTextColor?: string | null, hoverButtonColor?: string | null, fontFamily?: string | null, fontSize?: string | null, fontWeight?: string | null, border?: string | null } | null, secondaryButton?: { __typename?: 'TradeInLayoutMainPanelMainButton', textColor?: string | null, buttonColor?: string | null, disabledTextColor?: string | null, disabledButtonColor?: string | null, hoverTextColor?: string | null, hoverButtonColor?: string | null, fontFamily?: string | null, fontSize?: string | null, fontWeight?: string | null, border?: string | null } | null } | null, contrastPanel?: { __typename?: 'TradeInLayoutMainPanel', backgroundColor?: string | null, textColor?: string | null, mainButton?: { __typename?: 'TradeInLayoutMainPanelMainButton', textColor?: string | null, buttonColor?: string | null, disabledTextColor?: string | null, disabledButtonColor?: string | null, hoverTextColor?: string | null, hoverButtonColor?: string | null, fontFamily?: string | null, fontSize?: string | null, fontWeight?: string | null, border?: string | null } | null, secondaryButton?: { __typename?: 'TradeInLayoutMainPanelMainButton', textColor?: string | null, buttonColor?: string | null, disabledTextColor?: string | null, disabledButtonColor?: string | null, hoverTextColor?: string | null, hoverButtonColor?: string | null, fontFamily?: string | null, fontSize?: string | null, fontWeight?: string | null, border?: string | null } | null } | null, frontPanel?: { __typename?: 'TradeInLayoutMainPanel', backgroundColor?: string | null, textColor?: string | null, mainButton?: { __typename?: 'TradeInLayoutMainPanelMainButton', textColor?: string | null, buttonColor?: string | null, disabledTextColor?: string | null, disabledButtonColor?: string | null, hoverTextColor?: string | null, hoverButtonColor?: string | null, fontFamily?: string | null, fontSize?: string | null, fontWeight?: string | null, border?: string | null } | null, secondaryButton?: { __typename?: 'TradeInLayoutMainPanelMainButton', textColor?: string | null, buttonColor?: string | null, disabledTextColor?: string | null, disabledButtonColor?: string | null, hoverTextColor?: string | null, hoverButtonColor?: string | null, fontFamily?: string | null, fontSize?: string | null, fontWeight?: string | null, border?: string | null } | null } | null, widgets?: { __typename?: 'TradeInLayoutWidgets', accessBoxBorder?: string | null, actionItemBorderColor?: string | null, categoryBorderColor?: string | null, categoryRadius?: string | null, categoryIconSize?: number | null, categoryIconPadding?: number | null, selectionColor?: string | null, selectionTextColor?: string | null, cartBackgroundColor?: string | null, cartTextColor?: string | null, borderRadius?: string | null, addItemIconHide?: boolean | null, addItemIconColor?: string | null, addItemIconColorBlank?: string | null, stepperBorderWidth?: string | null, addItemButton?: { __typename?: 'TradeInLayoutMainPanelMainButton', textColor?: string | null, buttonColor?: string | null, disabledTextColor?: string | null, disabledButtonColor?: string | null, hoverTextColor?: string | null, hoverButtonColor?: string | null, fontFamily?: string | null, fontSize?: string | null, fontWeight?: string | null, border?: string | null } | null, addItemButtonBlank?: { __typename?: 'TradeInLayoutMainPanelMainButton', textColor?: string | null, buttonColor?: string | null, disabledTextColor?: string | null, disabledButtonColor?: string | null, hoverTextColor?: string | null, hoverButtonColor?: string | null, fontFamily?: string | null, fontSize?: string | null, fontWeight?: string | null, border?: string | null } | null, continueButton?: { __typename?: 'TradeInLayoutMainPanelMainButton', textColor?: string | null, buttonColor?: string | null, disabledTextColor?: string | null, disabledButtonColor?: string | null, hoverTextColor?: string | null, hoverButtonColor?: string | null, fontFamily?: string | null, fontSize?: string | null, fontWeight?: string | null, border?: string | null } | null, uploadPhoto?: { __typename?: 'TradeInLayoutWidgetsUploadPhoto', border?: string | null, disabledBorder?: string | null, color?: string | null, disabledColor?: string | null } | null, returnItem?: { __typename?: 'TradeInLayoutWidgetsReturnItem', textColor?: string | null, backgroundColor?: string | null, fontSize?: string | null, fontFamily?: string | null, fontWeight?: string | null, border?: string | null, scale?: number | null } | null } | null } | null } | null };

export type ShopAppLayoutUpdateMutationVariables = Exact<{
  shopId?: InputMaybe<Scalars['MongoID']>;
  brandHouseId?: InputMaybe<Scalars['MongoID']>;
  api?: InputMaybe<BrandSettingInput>;
  auditNoteId?: InputMaybe<Scalars['MongoID']>;
}>;


export type ShopAppLayoutUpdateMutation = { __typename?: 'Mutation', BrandSettingsUpdate?: { __typename?: 'BrandSetting', _id?: any | null } | null };

export type TradeInLayoutFragment = { __typename?: 'TradeInLayout', fontFamily?: string | null, disableIcons?: boolean | null, additionalCss?: string | null, h1?: { __typename?: 'TradeInLayoutH1', fontSize?: string | null, fontFamily?: string | null, fontWeight?: string | null, textColor?: string | null, uppercase?: boolean | null } | null, h2?: { __typename?: 'TradeInLayoutH1', fontSize?: string | null, fontFamily?: string | null, fontWeight?: string | null, textColor?: string | null, uppercase?: boolean | null } | null, text?: { __typename?: 'TradeInLayoutH1', fontSize?: string | null, fontFamily?: string | null, fontWeight?: string | null, textColor?: string | null, uppercase?: boolean | null } | null, subtext?: { __typename?: 'TradeInLayoutH1', fontSize?: string | null, fontFamily?: string | null, fontWeight?: string | null, textColor?: string | null, uppercase?: boolean | null } | null, mainPanel?: { __typename?: 'TradeInLayoutMainPanel', backgroundColor?: string | null, textColor?: string | null, mainButton?: { __typename?: 'TradeInLayoutMainPanelMainButton', textColor?: string | null, buttonColor?: string | null, disabledTextColor?: string | null, disabledButtonColor?: string | null, hoverTextColor?: string | null, hoverButtonColor?: string | null, fontFamily?: string | null, fontSize?: string | null, fontWeight?: string | null, border?: string | null } | null, secondaryButton?: { __typename?: 'TradeInLayoutMainPanelMainButton', textColor?: string | null, buttonColor?: string | null, disabledTextColor?: string | null, disabledButtonColor?: string | null, hoverTextColor?: string | null, hoverButtonColor?: string | null, fontFamily?: string | null, fontSize?: string | null, fontWeight?: string | null, border?: string | null } | null } | null, contrastPanel?: { __typename?: 'TradeInLayoutMainPanel', backgroundColor?: string | null, textColor?: string | null, mainButton?: { __typename?: 'TradeInLayoutMainPanelMainButton', textColor?: string | null, buttonColor?: string | null, disabledTextColor?: string | null, disabledButtonColor?: string | null, hoverTextColor?: string | null, hoverButtonColor?: string | null, fontFamily?: string | null, fontSize?: string | null, fontWeight?: string | null, border?: string | null } | null, secondaryButton?: { __typename?: 'TradeInLayoutMainPanelMainButton', textColor?: string | null, buttonColor?: string | null, disabledTextColor?: string | null, disabledButtonColor?: string | null, hoverTextColor?: string | null, hoverButtonColor?: string | null, fontFamily?: string | null, fontSize?: string | null, fontWeight?: string | null, border?: string | null } | null } | null, frontPanel?: { __typename?: 'TradeInLayoutMainPanel', backgroundColor?: string | null, textColor?: string | null, mainButton?: { __typename?: 'TradeInLayoutMainPanelMainButton', textColor?: string | null, buttonColor?: string | null, disabledTextColor?: string | null, disabledButtonColor?: string | null, hoverTextColor?: string | null, hoverButtonColor?: string | null, fontFamily?: string | null, fontSize?: string | null, fontWeight?: string | null, border?: string | null } | null, secondaryButton?: { __typename?: 'TradeInLayoutMainPanelMainButton', textColor?: string | null, buttonColor?: string | null, disabledTextColor?: string | null, disabledButtonColor?: string | null, hoverTextColor?: string | null, hoverButtonColor?: string | null, fontFamily?: string | null, fontSize?: string | null, fontWeight?: string | null, border?: string | null } | null } | null, widgets?: { __typename?: 'TradeInLayoutWidgets', accessBoxBorder?: string | null, actionItemBorderColor?: string | null, categoryBorderColor?: string | null, categoryRadius?: string | null, categoryIconSize?: number | null, categoryIconPadding?: number | null, selectionColor?: string | null, selectionTextColor?: string | null, cartBackgroundColor?: string | null, cartTextColor?: string | null, borderRadius?: string | null, addItemIconHide?: boolean | null, addItemIconColor?: string | null, addItemIconColorBlank?: string | null, stepperBorderWidth?: string | null, addItemButton?: { __typename?: 'TradeInLayoutMainPanelMainButton', textColor?: string | null, buttonColor?: string | null, disabledTextColor?: string | null, disabledButtonColor?: string | null, hoverTextColor?: string | null, hoverButtonColor?: string | null, fontFamily?: string | null, fontSize?: string | null, fontWeight?: string | null, border?: string | null } | null, addItemButtonBlank?: { __typename?: 'TradeInLayoutMainPanelMainButton', textColor?: string | null, buttonColor?: string | null, disabledTextColor?: string | null, disabledButtonColor?: string | null, hoverTextColor?: string | null, hoverButtonColor?: string | null, fontFamily?: string | null, fontSize?: string | null, fontWeight?: string | null, border?: string | null } | null, continueButton?: { __typename?: 'TradeInLayoutMainPanelMainButton', textColor?: string | null, buttonColor?: string | null, disabledTextColor?: string | null, disabledButtonColor?: string | null, hoverTextColor?: string | null, hoverButtonColor?: string | null, fontFamily?: string | null, fontSize?: string | null, fontWeight?: string | null, border?: string | null } | null, uploadPhoto?: { __typename?: 'TradeInLayoutWidgetsUploadPhoto', border?: string | null, disabledBorder?: string | null, color?: string | null, disabledColor?: string | null } | null, returnItem?: { __typename?: 'TradeInLayoutWidgetsReturnItem', textColor?: string | null, backgroundColor?: string | null, fontSize?: string | null, fontFamily?: string | null, fontWeight?: string | null, border?: string | null, scale?: number | null } | null } | null };

export type PanelFragment = { __typename?: 'TradeInLayoutMainPanel', backgroundColor?: string | null, textColor?: string | null, mainButton?: { __typename?: 'TradeInLayoutMainPanelMainButton', textColor?: string | null, buttonColor?: string | null, disabledTextColor?: string | null, disabledButtonColor?: string | null, hoverTextColor?: string | null, hoverButtonColor?: string | null, fontFamily?: string | null, fontSize?: string | null, fontWeight?: string | null, border?: string | null } | null, secondaryButton?: { __typename?: 'TradeInLayoutMainPanelMainButton', textColor?: string | null, buttonColor?: string | null, disabledTextColor?: string | null, disabledButtonColor?: string | null, hoverTextColor?: string | null, hoverButtonColor?: string | null, fontFamily?: string | null, fontSize?: string | null, fontWeight?: string | null, border?: string | null } | null };

export type ReturnItemFragment = { __typename?: 'TradeInLayoutWidgetsReturnItem', textColor?: string | null, backgroundColor?: string | null, fontSize?: string | null, fontFamily?: string | null, fontWeight?: string | null, border?: string | null, scale?: number | null };

export type UploadPhotoFragment = { __typename?: 'TradeInLayoutWidgetsUploadPhoto', border?: string | null, disabledBorder?: string | null, color?: string | null, disabledColor?: string | null };

export type TypographyFragment = { __typename?: 'TradeInLayoutH1', fontSize?: string | null, fontFamily?: string | null, fontWeight?: string | null, textColor?: string | null, uppercase?: boolean | null };

export type ButtonFragment = { __typename?: 'TradeInLayoutMainPanelMainButton', textColor?: string | null, buttonColor?: string | null, disabledTextColor?: string | null, disabledButtonColor?: string | null, hoverTextColor?: string | null, hoverButtonColor?: string | null, fontFamily?: string | null, fontSize?: string | null, fontWeight?: string | null, border?: string | null };

export type TradeInCountriesQueryVariables = Exact<{
  shopId?: InputMaybe<Scalars['MongoID']>;
  brandHouseId?: InputMaybe<Scalars['MongoID']>;
}>;


export type TradeInCountriesQuery = { __typename?: 'Query', BrandSettings?: { __typename?: 'BrandSetting', _id?: any | null, countries?: { __typename?: 'BrandSettingCountries', DK?: { __typename?: 'BrandSettingCountriesDK', currency?: string | null, enabled?: boolean | null, vat?: number | null } | null, DE?: { __typename?: 'BrandSettingCountriesDE', currency?: string | null, enabled?: boolean | null, vat?: number | null } | null, AT?: { __typename?: 'BrandSettingCountriesAT', currency?: string | null, enabled?: boolean | null, vat?: number | null } | null, NL?: { __typename?: 'BrandSettingCountriesNL', vat?: number | null, enabled?: boolean | null, currency?: string | null } | null, SE?: { __typename?: 'BrandSettingCountriesSE', currency?: string | null, enabled?: boolean | null, vat?: number | null } | null, BE?: { __typename?: 'BrandSettingCountriesBE', currency?: string | null, enabled?: boolean | null, vat?: number | null } | null, IE?: { __typename?: 'BrandSettingCountriesIE', currency?: string | null, enabled?: boolean | null, vat?: number | null } | null, FR?: { __typename?: 'BrandSettingCountriesFR', currency?: string | null, enabled?: boolean | null, vat?: number | null } | null, ES?: { __typename?: 'BrandSettingCountriesES', currency?: string | null, enabled?: boolean | null, vat?: number | null } | null, RO?: { __typename?: 'BrandSettingCountriesRO', currency?: string | null, enabled?: boolean | null, vat?: number | null } | null, PL?: { __typename?: 'BrandSettingCountriesPL', enabled?: boolean | null, currency?: string | null, vat?: number | null } | null, SI?: { __typename?: 'BrandSettingCountriesSI', enabled?: boolean | null, currency?: string | null, vat?: number | null } | null, SK?: { __typename?: 'BrandSettingCountriesSK', enabled?: boolean | null, currency?: string | null, vat?: number | null } | null, GB?: { __typename?: 'BrandSettingCountriesGB', enabled?: boolean | null, currency?: string | null, vat?: number | null } | null, CZ?: { __typename?: 'BrandSettingCountriesCZ', currency?: string | null, enabled?: boolean | null, vat?: number | null } | null, IT?: { __typename?: 'BrandSettingCountriesIT', currency?: string | null, enabled?: boolean | null, vat?: number | null } | null, FI?: { __typename?: 'BrandSettingCountriesFI', currency?: string | null, enabled?: boolean | null, vat?: number | null } | null, HU?: { __typename?: 'BrandSettingCountriesHU', currency?: string | null, enabled?: boolean | null, vat?: number | null } | null, PT?: { __typename?: 'BrandSettingCountriesPT', currency?: string | null, enabled?: boolean | null, vat?: number | null } | null, LT?: { __typename?: 'BrandSettingCountriesLT', currency?: string | null, enabled?: boolean | null, vat?: number | null } | null, LV?: { __typename?: 'BrandSettingCountriesLV', currency?: string | null, enabled?: boolean | null, vat?: number | null } | null, EE?: { __typename?: 'BrandSettingCountriesEE', currency?: string | null, enabled?: boolean | null, vat?: number | null } | null, HR?: { __typename?: 'BrandSettingCountriesHR', currency?: string | null, enabled?: boolean | null, vat?: number | null } | null, BG?: { __typename?: 'BrandSettingCountriesBG', currency?: string | null, enabled?: boolean | null, vat?: number | null } | null, CY?: { __typename?: 'BrandSettingCountriesCY', currency?: string | null, enabled?: boolean | null, vat?: number | null } | null, MT?: { __typename?: 'BrandSettingCountriesMT', currency?: string | null, enabled?: boolean | null, vat?: number | null } | null, LU?: { __typename?: 'BrandSettingCountriesLU', currency?: string | null, enabled?: boolean | null, vat?: number | null } | null, GR?: { __typename?: 'BrandSettingCountriesGR', currency?: string | null, enabled?: boolean | null, vat?: number | null } | null, NO?: { __typename?: 'BrandSettingCountriesNO', currency?: string | null, enabled?: boolean | null, vat?: number | null } | null } | null } | null };

export type TradeInCountriesUpdateMutationVariables = Exact<{
  shopId?: InputMaybe<Scalars['MongoID']>;
  brandHouseId?: InputMaybe<Scalars['MongoID']>;
  countries: BrandSettingCountriesInput;
  locales?: InputMaybe<Array<BrandLocaleInput> | BrandLocaleInput>;
  auditNoteId?: InputMaybe<Scalars['MongoID']>;
}>;


export type TradeInCountriesUpdateMutation = { __typename?: 'Mutation', BrandSettingsUpdate?: { __typename?: 'BrandSetting', _id?: any | null, countries?: { __typename?: 'BrandSettingCountries', DK?: { __typename?: 'BrandSettingCountriesDK', currency?: string | null, enabled?: boolean | null, vat?: number | null } | null, DE?: { __typename?: 'BrandSettingCountriesDE', currency?: string | null, enabled?: boolean | null, vat?: number | null } | null, AT?: { __typename?: 'BrandSettingCountriesAT', currency?: string | null, enabled?: boolean | null, vat?: number | null } | null, NL?: { __typename?: 'BrandSettingCountriesNL', vat?: number | null, enabled?: boolean | null, currency?: string | null } | null, SE?: { __typename?: 'BrandSettingCountriesSE', currency?: string | null, enabled?: boolean | null, vat?: number | null } | null, BE?: { __typename?: 'BrandSettingCountriesBE', currency?: string | null, enabled?: boolean | null, vat?: number | null } | null, IE?: { __typename?: 'BrandSettingCountriesIE', currency?: string | null, enabled?: boolean | null, vat?: number | null } | null, FR?: { __typename?: 'BrandSettingCountriesFR', currency?: string | null, enabled?: boolean | null, vat?: number | null } | null, ES?: { __typename?: 'BrandSettingCountriesES', currency?: string | null, enabled?: boolean | null, vat?: number | null } | null, RO?: { __typename?: 'BrandSettingCountriesRO', currency?: string | null, enabled?: boolean | null, vat?: number | null } | null, PL?: { __typename?: 'BrandSettingCountriesPL', enabled?: boolean | null, currency?: string | null, vat?: number | null } | null, SI?: { __typename?: 'BrandSettingCountriesSI', enabled?: boolean | null, currency?: string | null, vat?: number | null } | null, SK?: { __typename?: 'BrandSettingCountriesSK', enabled?: boolean | null, currency?: string | null, vat?: number | null } | null, GB?: { __typename?: 'BrandSettingCountriesGB', enabled?: boolean | null, currency?: string | null, vat?: number | null } | null, CZ?: { __typename?: 'BrandSettingCountriesCZ', currency?: string | null, enabled?: boolean | null, vat?: number | null } | null, IT?: { __typename?: 'BrandSettingCountriesIT', currency?: string | null, enabled?: boolean | null, vat?: number | null } | null, FI?: { __typename?: 'BrandSettingCountriesFI', currency?: string | null, enabled?: boolean | null, vat?: number | null } | null, HU?: { __typename?: 'BrandSettingCountriesHU', currency?: string | null, enabled?: boolean | null, vat?: number | null } | null, PT?: { __typename?: 'BrandSettingCountriesPT', currency?: string | null, enabled?: boolean | null, vat?: number | null } | null, LT?: { __typename?: 'BrandSettingCountriesLT', currency?: string | null, enabled?: boolean | null, vat?: number | null } | null, LV?: { __typename?: 'BrandSettingCountriesLV', currency?: string | null, enabled?: boolean | null, vat?: number | null } | null, EE?: { __typename?: 'BrandSettingCountriesEE', currency?: string | null, enabled?: boolean | null, vat?: number | null } | null, HR?: { __typename?: 'BrandSettingCountriesHR', currency?: string | null, enabled?: boolean | null, vat?: number | null } | null, BG?: { __typename?: 'BrandSettingCountriesBG', currency?: string | null, enabled?: boolean | null, vat?: number | null } | null, CY?: { __typename?: 'BrandSettingCountriesCY', currency?: string | null, enabled?: boolean | null, vat?: number | null } | null, MT?: { __typename?: 'BrandSettingCountriesMT', currency?: string | null, enabled?: boolean | null, vat?: number | null } | null, LU?: { __typename?: 'BrandSettingCountriesLU', currency?: string | null, enabled?: boolean | null, vat?: number | null } | null, GR?: { __typename?: 'BrandSettingCountriesGR', currency?: string | null, enabled?: boolean | null, vat?: number | null } | null, NO?: { __typename?: 'BrandSettingCountriesNO', currency?: string | null, enabled?: boolean | null, vat?: number | null } | null } | null } | null };

export type TradeInCountriesFragment = { __typename?: 'BrandSetting', _id?: any | null, countries?: { __typename?: 'BrandSettingCountries', DK?: { __typename?: 'BrandSettingCountriesDK', currency?: string | null, enabled?: boolean | null, vat?: number | null } | null, DE?: { __typename?: 'BrandSettingCountriesDE', currency?: string | null, enabled?: boolean | null, vat?: number | null } | null, AT?: { __typename?: 'BrandSettingCountriesAT', currency?: string | null, enabled?: boolean | null, vat?: number | null } | null, NL?: { __typename?: 'BrandSettingCountriesNL', vat?: number | null, enabled?: boolean | null, currency?: string | null } | null, SE?: { __typename?: 'BrandSettingCountriesSE', currency?: string | null, enabled?: boolean | null, vat?: number | null } | null, BE?: { __typename?: 'BrandSettingCountriesBE', currency?: string | null, enabled?: boolean | null, vat?: number | null } | null, IE?: { __typename?: 'BrandSettingCountriesIE', currency?: string | null, enabled?: boolean | null, vat?: number | null } | null, FR?: { __typename?: 'BrandSettingCountriesFR', currency?: string | null, enabled?: boolean | null, vat?: number | null } | null, ES?: { __typename?: 'BrandSettingCountriesES', currency?: string | null, enabled?: boolean | null, vat?: number | null } | null, RO?: { __typename?: 'BrandSettingCountriesRO', currency?: string | null, enabled?: boolean | null, vat?: number | null } | null, PL?: { __typename?: 'BrandSettingCountriesPL', enabled?: boolean | null, currency?: string | null, vat?: number | null } | null, SI?: { __typename?: 'BrandSettingCountriesSI', enabled?: boolean | null, currency?: string | null, vat?: number | null } | null, SK?: { __typename?: 'BrandSettingCountriesSK', enabled?: boolean | null, currency?: string | null, vat?: number | null } | null, GB?: { __typename?: 'BrandSettingCountriesGB', enabled?: boolean | null, currency?: string | null, vat?: number | null } | null, CZ?: { __typename?: 'BrandSettingCountriesCZ', currency?: string | null, enabled?: boolean | null, vat?: number | null } | null, IT?: { __typename?: 'BrandSettingCountriesIT', currency?: string | null, enabled?: boolean | null, vat?: number | null } | null, FI?: { __typename?: 'BrandSettingCountriesFI', currency?: string | null, enabled?: boolean | null, vat?: number | null } | null, HU?: { __typename?: 'BrandSettingCountriesHU', currency?: string | null, enabled?: boolean | null, vat?: number | null } | null, PT?: { __typename?: 'BrandSettingCountriesPT', currency?: string | null, enabled?: boolean | null, vat?: number | null } | null, LT?: { __typename?: 'BrandSettingCountriesLT', currency?: string | null, enabled?: boolean | null, vat?: number | null } | null, LV?: { __typename?: 'BrandSettingCountriesLV', currency?: string | null, enabled?: boolean | null, vat?: number | null } | null, EE?: { __typename?: 'BrandSettingCountriesEE', currency?: string | null, enabled?: boolean | null, vat?: number | null } | null, HR?: { __typename?: 'BrandSettingCountriesHR', currency?: string | null, enabled?: boolean | null, vat?: number | null } | null, BG?: { __typename?: 'BrandSettingCountriesBG', currency?: string | null, enabled?: boolean | null, vat?: number | null } | null, CY?: { __typename?: 'BrandSettingCountriesCY', currency?: string | null, enabled?: boolean | null, vat?: number | null } | null, MT?: { __typename?: 'BrandSettingCountriesMT', currency?: string | null, enabled?: boolean | null, vat?: number | null } | null, LU?: { __typename?: 'BrandSettingCountriesLU', currency?: string | null, enabled?: boolean | null, vat?: number | null } | null, GR?: { __typename?: 'BrandSettingCountriesGR', currency?: string | null, enabled?: boolean | null, vat?: number | null } | null, NO?: { __typename?: 'BrandSettingCountriesNO', currency?: string | null, enabled?: boolean | null, vat?: number | null } | null } | null };

export type ShippingCarriersQueryVariables = Exact<{
  brandHouseId: Scalars['MongoID'];
}>;


export type ShippingCarriersQuery = { __typename?: 'Query', ShippingCarriers?: Array<{ __typename?: 'ShippingCarrier', _id: any, logo?: string | null, name?: string | null, description?: string | null } | null> | null };

export type ShippingCarrierQueryVariables = Exact<{
  brandHouseId: Scalars['MongoID'];
  shippingCarrierId: Scalars['MongoID'];
}>;


export type ShippingCarrierQuery = { __typename?: 'Query', BrandCarrier?: { __typename?: 'BrandCarrier', _id: any, active?: boolean | null } | null };

export type ShippingCarrierActivateMutationVariables = Exact<{
  brandHouseId: Scalars['MongoID'];
  shippingCarrierId: Scalars['MongoID'];
  active: Scalars['Boolean'];
}>;


export type ShippingCarrierActivateMutation = { __typename?: 'Mutation', BrandCarrierActivate?: { __typename?: 'BrandCarrier', _id: any, active?: boolean | null } | null };

export type BrandAppLocalizationsQueryVariables = Exact<{
  id: Scalars['MongoID'];
  type: Scalars['String'];
}>;


export type BrandAppLocalizationsQuery = { __typename?: 'Query', BrandLocalizations?: Array<{ __typename?: 'Localization', language?: string | null, key?: string | null, value?: string | null, default?: string | null, inherited: boolean } | null> | null, BrandSettings?: { __typename?: 'BrandSetting', locales?: Array<{ __typename?: 'BrandLocale', locale: string, activeTradeIn?: boolean | null, activeItems?: boolean | null } | null> | null } | null };

export type ShopAppLocalizationsQueryVariables = Exact<{
  id: Scalars['MongoID'];
  type: Scalars['String'];
}>;


export type ShopAppLocalizationsQuery = { __typename?: 'Query', BrandLocalizations?: Array<{ __typename?: 'Localization', language?: string | null, key?: string | null, value?: string | null, default?: string | null, inherited: boolean } | null> | null, BrandSettings?: { __typename?: 'BrandSetting', locales?: Array<{ __typename?: 'BrandLocale', locale: string, activeItems?: boolean | null, activeTradeIn?: boolean | null } | null> | null } | null };

export type ShopAppLocalizationsUpdateMutationVariables = Exact<{
  id: Scalars['MongoID'];
  type: Scalars['String'];
  input?: InputMaybe<Array<InputMaybe<LocalizationInput>> | InputMaybe<LocalizationInput>>;
  auditNoteId?: InputMaybe<Scalars['MongoID']>;
}>;


export type ShopAppLocalizationsUpdateMutation = { __typename?: 'Mutation', BrandLocalizationsUpdate?: Array<{ __typename?: 'Localization', key?: string | null } | null> | null };

export type BrandAppShopsQueryVariables = Exact<{
  id: Scalars['MongoID'];
}>;


export type BrandAppShopsQuery = { __typename?: 'Query', Shops: Array<{ __typename?: 'Shop', _id: any, name?: string | null }> };

export type BrandAppLocalizationsUpdateMutationVariables = Exact<{
  id: Scalars['MongoID'];
  type: Scalars['String'];
  input?: InputMaybe<Array<InputMaybe<LocalizationInput>> | InputMaybe<LocalizationInput>>;
  auditNoteId?: InputMaybe<Scalars['MongoID']>;
}>;


export type BrandAppLocalizationsUpdateMutation = { __typename?: 'Mutation', BrandLocalizationsUpdate?: Array<{ __typename?: 'Localization', key?: string | null } | null> | null };

export type BrandSearchIndexesQueryVariables = Exact<{
  brandHouseId: Scalars['MongoID'];
}>;


export type BrandSearchIndexesQuery = { __typename?: 'Query', BrandProductGroups: Array<{ __typename?: 'BrandProductGroup', _id: any, name: string }> };

export type ConsumerSettingsQueryVariables = Exact<{
  shopId?: InputMaybe<Scalars['MongoID']>;
  brandHouseId?: InputMaybe<Scalars['MongoID']>;
}>;


export type ConsumerSettingsQuery = { __typename?: 'Query', BrandSettings?: { __typename?: 'BrandSetting', _id?: any | null, defaultProductImage?: string | null, tradeIn2InvalidEmailExp?: string | null, tradeInProductSearch?: boolean | null, tradeInProductSearchMask?: string | null, tradeInProductSearchGroupId?: any | null, tradeInProductSearchImagesOnly?: boolean | null, tradeInPayoutEnabled?: boolean | null, tradeInPayoutPct?: number | null, tradeInHideLanguageSelector?: boolean | null, tradeInComments?: boolean | null, digitalPassportActive?: boolean | null, tradeInPointsRate?: number | null, tradeInPointsEnabled?: boolean | null, tradeInVoucherDeduction?: boolean | null, tradeInLoginWithoutData?: boolean | null, shopCurrency?: string | null, consumer?: { __typename?: 'BrandSettingConsumer', lockEmail?: boolean | null, authMethods?: Array<string | null> | null } | null } | null };

export type ConsumerSettingsSaveMutationVariables = Exact<{
  shopId?: InputMaybe<Scalars['MongoID']>;
  brandHouseId?: InputMaybe<Scalars['MongoID']>;
  input: BrandSettingInput;
  auditNoteId?: InputMaybe<Scalars['MongoID']>;
}>;


export type ConsumerSettingsSaveMutation = { __typename?: 'Mutation', BrandSettingsUpdate?: { __typename?: 'BrandSetting', _id?: any | null, defaultProductImage?: string | null, tradeIn2InvalidEmailExp?: string | null, tradeInProductSearch?: boolean | null, tradeInProductSearchMask?: string | null, tradeInProductSearchGroupId?: any | null, tradeInProductSearchImagesOnly?: boolean | null, tradeInPayoutEnabled?: boolean | null, tradeInPayoutPct?: number | null, tradeInHideLanguageSelector?: boolean | null, tradeInComments?: boolean | null, digitalPassportActive?: boolean | null, tradeInPointsRate?: number | null, tradeInPointsEnabled?: boolean | null, tradeInVoucherDeduction?: boolean | null, tradeInLoginWithoutData?: boolean | null, shopCurrency?: string | null, consumer?: { __typename?: 'BrandSettingConsumer', lockEmail?: boolean | null, authMethods?: Array<string | null> | null } | null } | null };

export type BrandSettingsFragment = { __typename?: 'BrandSetting', _id?: any | null, defaultProductImage?: string | null, tradeIn2InvalidEmailExp?: string | null, tradeInProductSearch?: boolean | null, tradeInProductSearchMask?: string | null, tradeInProductSearchGroupId?: any | null, tradeInProductSearchImagesOnly?: boolean | null, tradeInPayoutEnabled?: boolean | null, tradeInPayoutPct?: number | null, tradeInHideLanguageSelector?: boolean | null, tradeInComments?: boolean | null, digitalPassportActive?: boolean | null, tradeInPointsRate?: number | null, tradeInPointsEnabled?: boolean | null, tradeInVoucherDeduction?: boolean | null, tradeInLoginWithoutData?: boolean | null, shopCurrency?: string | null, consumer?: { __typename?: 'BrandSettingConsumer', lockEmail?: boolean | null, authMethods?: Array<string | null> | null } | null };

export type ShippingCostsQueryVariables = Exact<{
  queries: Array<ShippingCostInput> | ShippingCostInput;
  currency: Scalars['String'];
  includeVat?: InputMaybe<Scalars['Boolean']>;
}>;


export type ShippingCostsQuery = { __typename?: 'Query', ShippingCosts?: Array<{ __typename?: 'ShippingCostOutput', carrier: ShippingCostCarrier, country: string, weight: number, cost?: number | null, currency: string, direction: ShippingCostDirection } | null> | null };

export type CircularPointsPanelQueryVariables = Exact<{
  consumerId: Scalars['MongoID'];
}>;


export type CircularPointsPanelQuery = { __typename?: 'Query', CircularAccountById?: { __typename?: 'CircularAccount', consumerId: any, shopId: any, total: number, pending: number, points?: Array<{ __typename?: 'CircularPoint', value: number, sourceType: EnumCircularPointSourceType, activated: boolean } | null> | null } | null };

export type PanelConsumerByIdQueryVariables = Exact<{
  consumerId: Scalars['MongoID'];
}>;


export type PanelConsumerByIdQuery = { __typename?: 'Query', ConsumerById?: { __typename?: 'Consumer', _id: any, firstName?: string | null, lastName?: string | null, add1?: string | null, add2?: string | null, zipCode?: string | null, city?: string | null, country?: string | null, locale?: string | null, mail?: string | null, phone?: string | null, acceptsMarketing?: boolean | null, accessToken?: string | null, lastLogin?: Date | null, selfCreated?: boolean | null, createdAt?: Date | null, shopId?: any | null, externalId?: string | null, externUrl?: string | null, tradeInAppUrl: string, shop?: { __typename?: 'Shop', _id: any, brandHouseId: any, tradeInBaseUrl?: string | null, currency?: string | null } | null } | null, TradeInMany: Array<{ __typename?: 'TradeIn', _id: any }> };

export type PanelExternConsumerByIdQueryVariables = Exact<{
  consumerId: Scalars['String'];
}>;


export type PanelExternConsumerByIdQuery = { __typename?: 'Query', ExternOrders2Many: Array<{ __typename?: 'ExternOrder2', _id: any, lineItems?: Array<{ __typename?: 'ExternOrder2LineItems', discountedPricePreTax: number } | null> | null }> };

export type InvoicesListInvoicesQueryVariables = Exact<{
  brandHouseId?: InputMaybe<Scalars['MongoID']>;
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type InvoicesListInvoicesQuery = { __typename?: 'Query', InvoiceIds?: Array<string> | null, Invoices?: Array<{ __typename?: 'Invoice', _id: any, brandHouseId: any, invoiceId: string, invoiceDate?: Date | null, locked?: boolean | null, paid?: boolean | null, currency?: string | null, brandHouse?: { __typename?: 'BrandHouse', name?: string | null } | null, total?: { __typename?: 'InvoiceTotal', total: number, sections?: Array<{ __typename?: 'InvoiceTotalSection', total: number, title: string, lines?: Array<{ __typename?: 'InvoiceTotalValue', lineType: EnumInvoiceLineLineType, title: string, count: number, sum: number } | null> | null } | null> | null } | null } | null> | null };

export type InvoicesListLinesQueryVariables = Exact<{
  invoiceId: Scalars['MongoID'];
  lineType: EnumInvoiceLineLineType;
}>;


export type InvoicesListLinesQuery = { __typename?: 'Query', InvoiceLines: Array<{ __typename?: 'InvoiceLine', _id: any, invoiceId: any, cost: number, currency: string, lineType: EnumInvoiceLineLineType, lineId: string, createdAt?: Date | null }> };

export type InvoicesListLineStockItemQueryVariables = Exact<{
  stockItemId: Scalars['MongoID'];
}>;


export type InvoicesListLineStockItemQuery = { __typename?: 'Query', StockItemById?: { __typename?: 'StockItem', _id: any, itemNr?: number | null, title?: string | null, imageUrls?: Array<string> | null, shopId: any, shop?: { __typename?: 'Shop', _id: any, brandHouse?: { __typename?: 'BrandHouse', _id: any } | null } | null } | null };

export type InvoicesListConversionQueryVariables = Exact<{
  inputCurrency: Scalars['String'];
  inputValue: Scalars['Float'];
  outputCurrency: Scalars['String'];
}>;


export type InvoicesListConversionQuery = { __typename?: 'Query', ConvertCurrency?: { __typename?: 'Pricing', value: number, currency: string } | null };

export type InvoicesListResetMutationVariables = Exact<{
  invoiceId: Scalars['String'];
}>;


export type InvoicesListResetMutation = { __typename?: 'Mutation', InvoiceReset?: Array<{ __typename?: 'Invoice', _id: any } | null> | null };

export type ExportOrderLinesQueryVariables = Exact<{
  orderIds?: InputMaybe<Array<Scalars['MongoID']> | Scalars['MongoID']>;
  currency: Scalars['String'];
}>;


export type ExportOrderLinesQuery = { __typename?: 'Query', OrderPagination?: { __typename?: 'Order2OrderPagination', items?: Array<{ __typename?: 'Order2', _id: any, orderDate: Date, orderName?: string | null, lines?: Array<{ __typename?: 'Order2Item', _id: any, salesPricePreTax?: number | null, returned?: boolean | null, returnedReason?: string | null, item?: { __typename?: 'StockItem', brandItem?: { __typename?: 'BrandItem', itemNr: number, resolved?: { __typename?: 'BrandItemResolved', itemSku: string, nameLocalized?: Array<{ __typename?: 'LocalizationEntry', value: string, locale: string } | null> | null } | null, tradeInItem?: { __typename?: 'TradeInItem', value?: number | null } | null } | null } | null } | null> | null }> | null } | null };

export type OrderLinesExportFragment = { __typename?: 'Order2', _id: any, orderDate: Date, orderName?: string | null, lines?: Array<{ __typename?: 'Order2Item', _id: any, salesPricePreTax?: number | null, returned?: boolean | null, returnedReason?: string | null, item?: { __typename?: 'StockItem', brandItem?: { __typename?: 'BrandItem', itemNr: number, resolved?: { __typename?: 'BrandItemResolved', itemSku: string, nameLocalized?: Array<{ __typename?: 'LocalizationEntry', value: string, locale: string } | null> | null } | null, tradeInItem?: { __typename?: 'TradeInItem', value?: number | null } | null } | null } | null } | null> | null };

export type OrderExportLine2Fragment = { __typename?: 'Order2Item', _id: any, salesPricePreTax?: number | null, returned?: boolean | null, returnedReason?: string | null, item?: { __typename?: 'StockItem', brandItem?: { __typename?: 'BrandItem', itemNr: number, resolved?: { __typename?: 'BrandItemResolved', itemSku: string, nameLocalized?: Array<{ __typename?: 'LocalizationEntry', value: string, locale: string } | null> | null } | null, tradeInItem?: { __typename?: 'TradeInItem', value?: number | null } | null } | null } | null };

export type ExportOrderConsumerQueryVariables = Exact<{
  shopId: Scalars['MongoID'];
  mail: Scalars['String'];
  dateTime: Scalars['Date'];
  now: Scalars['Date'];
}>;


export type ExportOrderConsumerQuery = { __typename?: 'Query', ConsumerByIdentifier?: Array<{ __typename?: 'Consumer', statisticsBefore?: { __typename?: 'ConsumerStatistics', orders?: number | null, tradeIns?: number | null } | null, statisticsAfter?: { __typename?: 'ConsumerStatistics', orders?: number | null, tradeIns?: number | null } | null } | null> | null };

export type ExportOrdersQueryVariables = Exact<{
  orderIds?: InputMaybe<Array<Scalars['MongoID']> | Scalars['MongoID']>;
  currency: Scalars['String'];
}>;


export type ExportOrdersQuery = { __typename?: 'Query', OrderPagination?: { __typename?: 'Order2OrderPagination', items?: Array<{ __typename?: 'Order2', _id: any, shopId: any, orderDate: Date, orderName?: string | null, consumerEmail?: string | null, lines?: Array<{ __typename?: 'Order2Item', _id: any, salesPricePreTax?: number | null, returned?: boolean | null, returnedReason?: string | null, item?: { __typename?: 'StockItem', brandItem?: { __typename?: 'BrandItem', itemNr: number, resolved?: { __typename?: 'BrandItemResolved', itemSku: string, nameLocalized?: Array<{ __typename?: 'LocalizationEntry', value: string, locale: string } | null> | null } | null, tradeInItem?: { __typename?: 'TradeInItem', value?: number | null } | null } | null } | null } | null> | null }> | null } | null };

export type OrderExportFragment = { __typename?: 'Order2', _id: any, shopId: any, orderDate: Date, orderName?: string | null, consumerEmail?: string | null, lines?: Array<{ __typename?: 'Order2Item', _id: any, salesPricePreTax?: number | null, returned?: boolean | null, returnedReason?: string | null, item?: { __typename?: 'StockItem', brandItem?: { __typename?: 'BrandItem', itemNr: number, resolved?: { __typename?: 'BrandItemResolved', itemSku: string, nameLocalized?: Array<{ __typename?: 'LocalizationEntry', value: string, locale: string } | null> | null } | null, tradeInItem?: { __typename?: 'TradeInItem', value?: number | null } | null } | null } | null } | null> | null };

export type OrderExportLineFragment = { __typename?: 'Order2Item', _id: any, salesPricePreTax?: number | null, returned?: boolean | null, returnedReason?: string | null, item?: { __typename?: 'StockItem', brandItem?: { __typename?: 'BrandItem', itemNr: number, resolved?: { __typename?: 'BrandItemResolved', itemSku: string, nameLocalized?: Array<{ __typename?: 'LocalizationEntry', value: string, locale: string } | null> | null } | null, tradeInItem?: { __typename?: 'TradeInItem', value?: number | null } | null } | null } | null };

export type OrdersListQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<FilterFindManyOrder2Input>;
  sort?: InputMaybe<SortFindManyOrder2Input>;
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
  viewId?: InputMaybe<Scalars['MongoID']>;
}>;


export type OrdersListQuery = { __typename?: 'Query', OrderPagination?: { __typename?: 'Order2OrderPagination', count?: number | null, pageInfo: { __typename?: 'PaginationInfo', perPage: number, currentPage: number, hasNextPage?: boolean | null, hasPreviousPage?: boolean | null, itemCount?: number | null, pageCount?: number | null }, items?: Array<{ __typename?: 'Order2', _id: any, shopId: any, orderDate: Date, orderUrl?: string | null, orderName?: string | null, payState: EnumOrder2PayState, orderState: EnumOrder2OrderState, fulState?: EnumOrder2FulState | null, trackingOrderState?: EnumOrder2TrackingOrderState | null, trackingReturnState?: EnumOrder2TrackingReturnState | null, proforma?: boolean | null, consumer: { __typename?: 'Order2Consumer', name?: string | null, mail?: string | null, phone?: string | null }, shop?: { __typename?: 'Shop', brandHouseId: any, name?: string | null } | null, lines?: Array<{ __typename?: 'Order2Item', _id: any, returned?: boolean | null, cancelled?: boolean | null, discountedPrice?: number | null, stockItem?: { __typename?: 'StockItemResolved', imageUrls?: Array<string> | null } | null } | null> | null }> | null } | null };

export type OrderFragment = { __typename?: 'Order2', _id: any, shopId: any, orderDate: Date, orderUrl?: string | null, orderName?: string | null, payState: EnumOrder2PayState, orderState: EnumOrder2OrderState, fulState?: EnumOrder2FulState | null, trackingOrderState?: EnumOrder2TrackingOrderState | null, trackingReturnState?: EnumOrder2TrackingReturnState | null, proforma?: boolean | null, consumer: { __typename?: 'Order2Consumer', name?: string | null, mail?: string | null, phone?: string | null }, shop?: { __typename?: 'Shop', brandHouseId: any, name?: string | null } | null, lines?: Array<{ __typename?: 'Order2Item', _id: any, returned?: boolean | null, cancelled?: boolean | null, discountedPrice?: number | null, stockItem?: { __typename?: 'StockItemResolved', imageUrls?: Array<string> | null } | null } | null> | null };

export type OrdersSelectAllQueryVariables = Exact<{
  filter?: InputMaybe<FilterFindManyOrder2Input>;
  sort?: InputMaybe<SortFindManyOrder2Input>;
  viewId?: InputMaybe<Scalars['MongoID']>;
}>;


export type OrdersSelectAllQuery = { __typename?: 'Query', OrderPagination?: { __typename?: 'Order2OrderPagination', items?: Array<{ __typename?: 'Order2', _id: any }> | null } | null };

export type PotentialsListPaginationQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<FilterFindManyPotentialInput>;
  sort?: InputMaybe<SortFindManyPotentialInput>;
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
}>;


export type PotentialsListPaginationQuery = { __typename?: 'Query', PotentialsPagination?: { __typename?: 'PotentialPotentialDTCPagination', count?: number | null, pageInfo: { __typename?: 'PaginationInfo', perPage: number, currentPage: number, hasNextPage?: boolean | null, hasPreviousPage?: boolean | null, itemCount?: number | null, pageCount?: number | null }, items?: Array<{ __typename?: 'Potential', _id: any, externUrl?: string | null, externDate?: Date | null, name?: string | null, sku?: string | null, color?: string | null, size?: string | null, ean?: string | null, rrp?: number | null, sp?: number | null, cancelled?: boolean | null, consumerId: any, imageUrls?: Array<string> | null, notified?: EnumPotentialNotified | null, notifiedTs?: Date | null, sourceType?: PotentialSourceTypeEnum | null, offer?: { __typename?: 'PotentialValue', value?: number | null, currency: string, notifyDate?: Date | null, activation?: EnumPotentialValueActivation | null } | null, consumer?: { __typename?: 'Consumer', _id: any, firstName?: string | null, lastName?: string | null } | null, wholeSale?: { __typename?: 'PotentialWholeSale', categoryId?: any | null, name?: string | null, value?: number | null } | null }> | null } | null };

export type ViewProductVariantsSizesQueryVariables = Exact<{
  shopId: Scalars['MongoID'];
}>;


export type ViewProductVariantsSizesQuery = { __typename?: 'Query', ShopById?: { __typename?: 'Shop', _id: any, sizes?: Array<string> | null, colors?: Array<string> | null, productBatches?: Array<string> | null } | null };

export type ViewProductVariantsManyQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<FilterFindManyProductVariantInput>;
  sort?: InputMaybe<SortFindManyProductVariantInput>;
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
}>;


export type ViewProductVariantsManyQuery = { __typename?: 'Query', ProductVariantsPagination?: { __typename?: 'ProductVariantProductVariantPagination', count?: number | null, pageInfo: { __typename?: 'PaginationInfo', perPage: number, currentPage: number, hasNextPage?: boolean | null, hasPreviousPage?: boolean | null, itemCount?: number | null, pageCount?: number | null }, items?: Array<{ __typename?: 'ProductVariant', _id: any, productId: any, shopId: any, imageUrls?: Array<string> | null, color?: string | null, sku?: string | null, ean?: string | null, batchSerial?: string | null, product?: { __typename?: 'Product', name: string, tags?: Array<string | null> | null, productType?: string | null, isPreOwned?: boolean | null, description?: string | null } | null, rrp?: Array<{ __typename?: 'Pricing', value: number, currency: string } | null> | null, sizes?: Array<{ __typename?: 'ProductVariantSize', _id: any, size: string, ean?: string | null, sku?: string | null } | null> | null }> | null } | null };

export type ViewProductVariantFragment = { __typename?: 'ProductVariant', _id: any, productId: any, shopId: any, imageUrls?: Array<string> | null, color?: string | null, sku?: string | null, ean?: string | null, batchSerial?: string | null, product?: { __typename?: 'Product', name: string, tags?: Array<string | null> | null, productType?: string | null, isPreOwned?: boolean | null, description?: string | null } | null, rrp?: Array<{ __typename?: 'Pricing', value: number, currency: string } | null> | null, sizes?: Array<{ __typename?: 'ProductVariantSize', _id: any, size: string, ean?: string | null, sku?: string | null } | null> | null };

export type ProductListBatchesQueryVariables = Exact<{
  shopId: Scalars['MongoID'];
}>;


export type ProductListBatchesQuery = { __typename?: 'Query', ShopById?: { __typename?: 'Shop', _id: any, sizes?: Array<string> | null, colors?: Array<string> | null, productBatches?: Array<string> | null } | null };

export type ProductListPaginationQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<FilterFindManyProductInput>;
  sort?: InputMaybe<SortFindManyProductInput>;
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
}>;


export type ProductListPaginationQuery = { __typename?: 'Query', ProductsPagination?: { __typename?: 'ProductProductPagination', count?: number | null, pageInfo: { __typename?: 'PaginationInfo', perPage: number, currentPage: number, hasNextPage?: boolean | null, hasPreviousPage?: boolean | null, itemCount?: number | null, pageCount?: number | null }, items?: Array<{ __typename?: 'Product', _id: any, name: string, style?: string | null, productType?: string | null, productVendor?: string | null, images?: Array<string | null> | null }> | null } | null };

export type ProductListProductFragment = { __typename?: 'Product', _id: any, name: string, style?: string | null, productType?: string | null, productVendor?: string | null, images?: Array<string | null> | null };

export type StockItemsColumnsCurrencyQueryVariables = Exact<{
  shopId: Scalars['MongoID'];
}>;


export type StockItemsColumnsCurrencyQuery = { __typename?: 'Query', ShopById?: { __typename?: 'Shop', _id: any, currency?: string | null } | null };

export type StockItemListBrandsQueryVariables = Exact<{ [key: string]: never; }>;


export type StockItemListBrandsQuery = { __typename?: 'Query', ShopMany: Array<{ __typename?: 'Shop', _id: any, externalName?: string | null }> };

export type StockItemsListManyQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<FilterFindManyStockItemInput>;
  sort?: InputMaybe<SortFindManyStockItemInput>;
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
}>;


export type StockItemsListManyQuery = { __typename?: 'Query', StockItemPagination?: { __typename?: 'StockItemStockItemPagination', count?: number | null, pageInfo: { __typename?: 'PaginationInfo', perPage: number, currentPage: number, hasNextPage?: boolean | null, hasPreviousPage?: boolean | null, itemCount?: number | null, pageCount?: number | null }, items?: Array<{ __typename?: 'StockItem', _id: any, resolved?: { __typename?: 'StockItemResolved', _id: any, shopId: any, brandItemId?: any | null, itemNr?: number | null, itemSku: string, tradeInItemId?: any | null, title?: string | null, description?: string | null, createdAt?: Date | null, condition?: number | null, productType?: string | null, imageUrls?: Array<string> | null, sellingPrice?: number | null, beforePrice?: number | null, sku?: string | null, ean?: string | null, originalEan?: string | null, color?: string | null, size?: string | null, published?: boolean | null, draft?: boolean | null, review?: boolean | null, checked?: Date | null, effectiveChecked: boolean, effectiveMissing: boolean, stockLocation?: string | null, stockLocationTs?: Date | null, isSold?: boolean | null, queued?: boolean | null, isInSeason: boolean, note?: string | null, hasErrors: boolean, dataErrors?: Array<string> | null, hasProblems?: boolean | null, itemNrBroken: boolean, shop?: { __typename?: 'Shop', _id: any, externalName?: string | null } | null, images?: Array<{ __typename?: 'StockItemImage', process?: boolean | null, imageId?: any | null, imageUrl?: string | null } | null> | null } | null }> | null } | null };

export type FlexStockItemFragment = { __typename?: 'StockItemResolved', _id: any, shopId: any, brandItemId?: any | null, itemNr?: number | null, itemSku: string, tradeInItemId?: any | null, title?: string | null, description?: string | null, createdAt?: Date | null, condition?: number | null, productType?: string | null, imageUrls?: Array<string> | null, sellingPrice?: number | null, beforePrice?: number | null, sku?: string | null, ean?: string | null, originalEan?: string | null, color?: string | null, size?: string | null, published?: boolean | null, draft?: boolean | null, review?: boolean | null, checked?: Date | null, effectiveChecked: boolean, effectiveMissing: boolean, stockLocation?: string | null, stockLocationTs?: Date | null, isSold?: boolean | null, queued?: boolean | null, isInSeason: boolean, note?: string | null, hasErrors: boolean, dataErrors?: Array<string> | null, hasProblems?: boolean | null, itemNrBroken: boolean, shop?: { __typename?: 'Shop', _id: any, externalName?: string | null } | null, images?: Array<{ __typename?: 'StockItemImage', process?: boolean | null, imageId?: any | null, imageUrl?: string | null } | null> | null };

export type TradeInListQueryVariables = Exact<{
  shopId: Scalars['MongoID'];
  registered: Scalars['Boolean'];
  limit: Scalars['Int'];
}>;


export type TradeInListQuery = { __typename?: 'Query', TradeIns: Array<{ __typename?: 'TradeIn', _id: any, tradeInNr?: number | null, shopId: any, dateTime: Date, registered?: boolean | null, registeredTs?: Date | null, consumer?: { __typename?: 'Consumer', firstName?: string | null, lastName?: string | null } | null, shippingCarrier?: { __typename?: 'ShippingCarrier', carrierId?: string | null, name?: string | null } | null, label?: { __typename?: 'ShippingLabel', deliveryDate?: Date | null, deliveryStatus?: EnumShippingLabelDeliveryStatus | null } | null, items?: Array<{ __typename?: 'TradeInItem', _id: any, imageUrls?: Array<string> | null, rejected?: EnumTradeInItemRejected | null, wholeSale?: { __typename?: 'PotentialWholeSale', _id?: any | null } | null, brandItem?: { __typename?: 'BrandItem', _id: any } | null, stockItem?: { __typename?: 'StockItem', _id: any } | null } | null> | null }> };

export type DtcEditBrandByIdQueryVariables = Exact<{
  shopId: Scalars['MongoID'];
}>;


export type DtcEditBrandByIdQuery = { __typename?: 'Query', ShopById?: { __typename?: 'Shop', _id: any, brandHouseId: any, name?: string | null, tradeInBaseUrl?: string | null, currency?: string | null, conditions?: Array<{ __typename?: 'ShopConditionPublic', condition: number, name: string, description: string } | null> | null, settings?: { __typename?: 'BrandSetting', digitalPassportActive?: boolean | null, stockItemConfig?: { __typename?: 'BrandSettingStockItemConfig', titlePrefix?: string | null } | null } | null } | null };

export type DtcEditBrandFragment = { __typename?: 'Shop', _id: any, brandHouseId: any, name?: string | null, tradeInBaseUrl?: string | null, currency?: string | null, conditions?: Array<{ __typename?: 'ShopConditionPublic', condition: number, name: string, description: string } | null> | null, settings?: { __typename?: 'BrandSetting', digitalPassportActive?: boolean | null, stockItemConfig?: { __typename?: 'BrandSettingStockItemConfig', titlePrefix?: string | null } | null } | null };

export type DtcEditBrandRuleQueryVariables = Exact<{
  ruleId: Scalars['MongoID'];
}>;


export type DtcEditBrandRuleQuery = { __typename?: 'Query', BrandRule?: { __typename?: 'BrandRule', _id: any, shopId: any, active?: boolean | null, periodFrom?: Date | null, periodTo?: Date | null, priority?: number | null, minimumPrice?: number | null, minimumPriceType?: EnumBrandRuleMinimumPriceType | null, minimumAge?: number | null, maximumAge?: number | null, marketingDelay?: number | null, voucherStrategy: EnumBrandRuleVoucherStrategy, voucherValue: EnumBrandRuleVoucherValue, tradeInPricePct: number, tradeInSearchPct?: number | null, secondhandTradeInPct: number, secondhandVoucherValue: EnumBrandRuleSecondhandVoucherValue, digitalPassportPct?: number | null, digitalPassportValue?: EnumBrandRuleDigitalPassportValue | null, products?: { __typename?: 'BrandRuleProducts', ids?: Array<any | null> | null, tags?: Array<string | null> | null, collections?: Array<string | null> | null } | null, voucherAmounts?: Array<{ __typename?: 'BrandRuleTradeInSearchAmounts', _id?: any | null, tag?: string | null, value: number, active: boolean, expressions?: Array<{ __typename?: 'BrandRuleTradeInSearchAmountsExpressions', key?: string | null, operation: EnumBrandRuleTradeInSearchAmountsExpressionsOperation, value?: Array<string | null> | null, valueType: EnumBrandRuleTradeInSearchAmountsExpressionsValueType } | null> | null } | null> | null, tradeInSearchAmounts?: Array<{ __typename?: 'BrandRuleTradeInSearchAmounts', _id?: any | null, tag?: string | null, value: number, active: boolean, expressions?: Array<{ __typename?: 'BrandRuleTradeInSearchAmountsExpressions', key?: string | null, operation: EnumBrandRuleTradeInSearchAmountsExpressionsOperation, value?: Array<string | null> | null, valueType: EnumBrandRuleTradeInSearchAmountsExpressionsValueType } | null> | null } | null> | null, expressions?: Array<{ __typename?: 'BrandRuleTradeInSearchAmountsExpressions', key?: string | null, operation: EnumBrandRuleTradeInSearchAmountsExpressionsOperation, value?: Array<string | null> | null, valueType: EnumBrandRuleTradeInSearchAmountsExpressionsValueType } | null> | null } | null };

export type DtcEditBrandRuleFragment = { __typename?: 'BrandRule', _id: any, shopId: any, active?: boolean | null, periodFrom?: Date | null, periodTo?: Date | null, priority?: number | null, minimumPrice?: number | null, minimumPriceType?: EnumBrandRuleMinimumPriceType | null, minimumAge?: number | null, maximumAge?: number | null, marketingDelay?: number | null, voucherStrategy: EnumBrandRuleVoucherStrategy, voucherValue: EnumBrandRuleVoucherValue, tradeInPricePct: number, tradeInSearchPct?: number | null, secondhandTradeInPct: number, secondhandVoucherValue: EnumBrandRuleSecondhandVoucherValue, digitalPassportPct?: number | null, digitalPassportValue?: EnumBrandRuleDigitalPassportValue | null, products?: { __typename?: 'BrandRuleProducts', ids?: Array<any | null> | null, tags?: Array<string | null> | null, collections?: Array<string | null> | null } | null, voucherAmounts?: Array<{ __typename?: 'BrandRuleTradeInSearchAmounts', _id?: any | null, tag?: string | null, value: number, active: boolean, expressions?: Array<{ __typename?: 'BrandRuleTradeInSearchAmountsExpressions', key?: string | null, operation: EnumBrandRuleTradeInSearchAmountsExpressionsOperation, value?: Array<string | null> | null, valueType: EnumBrandRuleTradeInSearchAmountsExpressionsValueType } | null> | null } | null> | null, tradeInSearchAmounts?: Array<{ __typename?: 'BrandRuleTradeInSearchAmounts', _id?: any | null, tag?: string | null, value: number, active: boolean, expressions?: Array<{ __typename?: 'BrandRuleTradeInSearchAmountsExpressions', key?: string | null, operation: EnumBrandRuleTradeInSearchAmountsExpressionsOperation, value?: Array<string | null> | null, valueType: EnumBrandRuleTradeInSearchAmountsExpressionsValueType } | null> | null } | null> | null, expressions?: Array<{ __typename?: 'BrandRuleTradeInSearchAmountsExpressions', key?: string | null, operation: EnumBrandRuleTradeInSearchAmountsExpressionsOperation, value?: Array<string | null> | null, valueType: EnumBrandRuleTradeInSearchAmountsExpressionsValueType } | null> | null };

export type DtcEditBrandRuleUpdateMutationVariables = Exact<{
  rule?: InputMaybe<BrandRuleInput>;
  auditNoteId?: InputMaybe<Scalars['MongoID']>;
}>;


export type DtcEditBrandRuleUpdateMutation = { __typename?: 'Mutation', BrandRuleUpdate?: { __typename?: 'BrandRule', _id: any } | null };

export type VoucherEditorTagsQueryVariables = Exact<{
  shopId: Scalars['MongoID'];
}>;


export type VoucherEditorTagsQuery = { __typename?: 'Query', ShopById?: { __typename?: 'Shop', _id: any, productTags?: Array<string> | null } | null };

export type ProductEditorBrandByIdQueryVariables = Exact<{
  shopId: Scalars['MongoID'];
}>;


export type ProductEditorBrandByIdQuery = { __typename?: 'Query', ShopById?: { __typename?: 'Shop', _id: any, name?: string | null, tradeInBaseUrl?: string | null, currency?: string | null, productTags?: Array<string> | null, productCollections?: Array<string> | null, productTypes?: Array<string> | null, productVendors?: Array<string> | null } | null };

export type DtcRedirectRulesQueryVariables = Exact<{
  shopId: Scalars['MongoID'];
}>;


export type DtcRedirectRulesQuery = { __typename?: 'Query', BrandRules?: Array<{ __typename?: 'BrandRule', _id: any, active?: boolean | null } | null> | null };

export type DtcBrandRulesQueryVariables = Exact<{
  shopId: Scalars['MongoID'];
}>;


export type DtcBrandRulesQuery = { __typename?: 'Query', BrandRules?: Array<{ __typename?: 'BrandRule', _id: any, active?: boolean | null, priority?: number | null } | null> | null };

export type DtcBrandRuleQueryVariables = Exact<{
  ruleId: Scalars['MongoID'];
}>;


export type DtcBrandRuleQuery = { __typename?: 'Query', BrandRule?: { __typename?: 'BrandRule', _id: any, shopId: any, active?: boolean | null, periodFrom?: Date | null, periodTo?: Date | null, priority?: number | null, tradeInPricePct: number, minimumPrice?: number | null, minimumAge?: number | null, maximumAge?: number | null, marketingDelay?: number | null, voucherStrategy: EnumBrandRuleVoucherStrategy, voucherValue: EnumBrandRuleVoucherValue, products?: { __typename?: 'BrandRuleProducts', ids?: Array<any | null> | null, tags?: Array<string | null> | null, collections?: Array<string | null> | null } | null, expressions?: Array<{ __typename?: 'BrandRuleTradeInSearchAmountsExpressions', operation: EnumBrandRuleTradeInSearchAmountsExpressionsOperation, valueType: EnumBrandRuleTradeInSearchAmountsExpressionsValueType, value?: Array<string | null> | null } | null> | null } | null };

export type DtcViewBrandByIdQueryVariables = Exact<{
  shopId: Scalars['MongoID'];
}>;


export type DtcViewBrandByIdQuery = { __typename?: 'Query', ShopById?: { __typename?: 'Shop', _id: any, brandHouseId: any, name?: string | null, tradeInBaseUrl?: string | null, currency?: string | null, conditions?: Array<{ __typename?: 'ShopConditionPublic', condition: number, name: string, description: string } | null> | null, settings?: { __typename?: 'BrandSetting', klaviyoConfig?: { __typename?: 'BrandSettingKlaviyoConfig', enabled?: boolean | null } | null } | null } | null };

export type DtcShopFragment = { __typename?: 'Shop', _id: any, brandHouseId: any, name?: string | null, tradeInBaseUrl?: string | null, currency?: string | null, conditions?: Array<{ __typename?: 'ShopConditionPublic', condition: number, name: string, description: string } | null> | null, settings?: { __typename?: 'BrandSetting', klaviyoConfig?: { __typename?: 'BrandSettingKlaviyoConfig', enabled?: boolean | null } | null } | null };

export type BrandRuleActivationMutationVariables = Exact<{
  shopId: Scalars['MongoID'];
  ruleId: Scalars['MongoID'];
  active: Scalars['Boolean'];
  auditNoteId?: InputMaybe<Scalars['MongoID']>;
}>;


export type BrandRuleActivationMutation = { __typename?: 'Mutation', BrandRuleActivation?: { __typename?: 'BrandRule', _id: any, active?: boolean | null } | null };

export type BrandRuleCreateMutationVariables = Exact<{
  shopId: Scalars['MongoID'];
  auditNoteId?: InputMaybe<Scalars['MongoID']>;
}>;


export type BrandRuleCreateMutation = { __typename?: 'Mutation', BrandRuleCreate?: { __typename?: 'BrandRule', _id: any, shopId: any, active?: boolean | null, periodFrom?: Date | null, periodTo?: Date | null, priority?: number | null, tradeInPricePct: number, minimumPrice?: number | null, minimumAge?: number | null, maximumAge?: number | null, marketingDelay?: number | null, voucherStrategy: EnumBrandRuleVoucherStrategy, voucherValue: EnumBrandRuleVoucherValue, products?: { __typename?: 'BrandRuleProducts', ids?: Array<any | null> | null, tags?: Array<string | null> | null, collections?: Array<string | null> | null } | null } | null };

export type BrandRuleFragmentCreateFragment = { __typename?: 'BrandRule', _id: any, shopId: any, active?: boolean | null, periodFrom?: Date | null, periodTo?: Date | null, priority?: number | null, tradeInPricePct: number, minimumPrice?: number | null, minimumAge?: number | null, maximumAge?: number | null, marketingDelay?: number | null, voucherStrategy: EnumBrandRuleVoucherStrategy, voucherValue: EnumBrandRuleVoucherValue, products?: { __typename?: 'BrandRuleProducts', ids?: Array<any | null> | null, tags?: Array<string | null> | null, collections?: Array<string | null> | null } | null };

export type BrandRuleStatisticsQueryVariables = Exact<{
  brandRuleId: Scalars['MongoID'];
}>;


export type BrandRuleStatisticsQuery = { __typename?: 'Query', BrandRule?: { __typename?: 'BrandRule', _id: any, shopId: any, statistics?: { __typename?: 'BrandRuleStatistics', items: number, itemsTotal: number, consumers: number, consumersTotal: number, sendingFuture: number, sendingNow: number, voucherSum: number, voucherTotal: number } | null } | null };

export type DtcSendMailsMutationVariables = Exact<{
  shopId: Scalars['MongoID'];
}>;


export type DtcSendMailsMutation = { __typename?: 'Mutation', PotentialDistribute: boolean };

export type DtcRebuildStatisticsMutationVariables = Exact<{
  shopId: Scalars['MongoID'];
}>;


export type DtcRebuildStatisticsMutation = { __typename?: 'Mutation', BrandRuleUpdateStatistics: boolean };

export type DtcPotentialsListPaginationQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<FilterFindManyPotentialInput>;
  sort?: InputMaybe<SortFindManyPotentialInput>;
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
  brandRuleId: Scalars['MongoID'];
}>;


export type DtcPotentialsListPaginationQuery = { __typename?: 'Query', PotentialsDTCPagination?: { __typename?: 'PotentialPotentialPagination', count?: number | null, pageInfo: { __typename?: 'PaginationInfo', perPage: number, currentPage: number, hasNextPage?: boolean | null, hasPreviousPage?: boolean | null, itemCount?: number | null, pageCount?: number | null }, items?: Array<{ __typename?: 'Potential', _id: any, externUrl?: string | null, externDate?: Date | null, name?: string | null, sku?: string | null, color?: string | null, size?: string | null, ean?: string | null, rrp?: number | null, sp?: number | null, productVariantId?: any | null, consumerId: any, shop?: { __typename?: 'Shop', currency?: string | null } | null, status?: { __typename?: 'Status', message: string, type: EnumStatusType, date?: Date | null } | null, offer?: { __typename?: 'PotentialValue', value?: number | null, currency: string, activation?: EnumPotentialValueActivation | null, notifyDate?: Date | null } | null, consumer?: { __typename?: 'Consumer', _id: any, firstName?: string | null, lastName?: string | null, mail?: string | null, disableContact?: boolean | null, accountType?: string | null } | null, wholeSale?: { __typename?: 'PotentialWholeSale', categoryId?: any | null, name?: string | null, value?: number | null } | null }> | null } | null };

export type DtcFragment = { __typename?: 'Potential', _id: any, externUrl?: string | null, externDate?: Date | null, name?: string | null, sku?: string | null, color?: string | null, size?: string | null, ean?: string | null, rrp?: number | null, sp?: number | null, productVariantId?: any | null, consumerId: any, shop?: { __typename?: 'Shop', currency?: string | null } | null, status?: { __typename?: 'Status', message: string, type: EnumStatusType, date?: Date | null } | null, offer?: { __typename?: 'PotentialValue', value?: number | null, currency: string, activation?: EnumPotentialValueActivation | null, notifyDate?: Date | null } | null, consumer?: { __typename?: 'Consumer', _id: any, firstName?: string | null, lastName?: string | null, mail?: string | null, disableContact?: boolean | null, accountType?: string | null } | null, wholeSale?: { __typename?: 'PotentialWholeSale', categoryId?: any | null, name?: string | null, value?: number | null } | null };

export type OrderPageSynchronzieOrderMutationVariables = Exact<{
  shopId: Scalars['String'];
  service: Scalars['String'];
  externalId?: InputMaybe<Scalars['String']>;
}>;


export type OrderPageSynchronzieOrderMutation = { __typename?: 'Mutation', StartSynchronize?: { __typename?: 'SyncResult', status: string } | null };

export type OrderPageBrandQueryVariables = Exact<{
  id: Scalars['MongoID'];
}>;


export type OrderPageBrandQuery = { __typename?: 'Query', ShopById?: { __typename?: 'Shop', _id: any, currency?: string | null, brandHouseId: any, logisticsPartnerId: any } | null };

export type OrderPageOrderQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type OrderPageOrderQuery = { __typename?: 'Query', Order?: { __typename?: 'Order2', _id: any, externalId: string, orderName?: string | null, comment?: string | null, orderDate: Date, orderUrl?: string | null, fulState?: EnumOrder2FulState | null, payState: EnumOrder2PayState, orderState: EnumOrder2OrderState, updatedAt?: Date | null, notified?: boolean | null, notifiedConsumer?: boolean | null, exportedToWMS?: boolean | null, trackingUrl?: string | null, returnLabelUrl?: string | null, returnDeadline?: Date | null, freeReturn?: boolean | null, silenced?: boolean | null, currency?: string | null, proforma?: boolean | null, proformaInvoiceCommission?: boolean | null, proformaInvoicePickPack?: boolean | null, proformaInvoiceShipping?: boolean | null, deliveryNoteUrl: string, consumer: { __typename?: 'Order2Consumer', id?: string | null, name?: string | null, add1?: string | null, add2?: string | null, zipCode?: string | null, city?: string | null, phone?: string | null, country?: string | null, mail?: string | null, language?: string | null }, lines?: Array<{ __typename?: 'Order2Item', _id: any, externalLineId: string, returned?: boolean | null, cancelled?: boolean | null, fulfilled?: boolean | null, salesPrice?: number | null, discountedPrice?: number | null, currency?: string | null, item?: { __typename?: 'StockItem', _id: any, sku?: string | null, itemSku: string, ean?: string | null, originalEan?: string | null, title?: string | null, imageUrls?: Array<string> | null, itemNr?: number | null, color?: string | null, size?: string | null, sellingPrice?: number | null, stockLocation?: string | null, brandItemId?: any | null, brandItem?: { __typename?: 'BrandItem', _id: any, unavailable?: Date | null } | null } | null } | null> | null, trackingInfo?: { __typename?: 'Order2TrackingInfo', number?: string | null, carrier?: EnumOrder2TrackingInfoCarrier | null } | null, returnInfo?: { __typename?: 'Order2ReturnInfo', carrier?: EnumOrder2ReturnInfoCarrier | null, number?: string | null } | null, shippingAddress?: { __typename?: 'Order2ShippingAddress', name?: string | null, company?: string | null, add1?: string | null, add2?: string | null, zipCode?: string | null, city?: string | null, countryCode?: string | null, country?: string | null, phone?: string | null, mail?: string | null } | null, shippingAddressInternal?: { __typename?: 'Order2ShippingAddress', name?: string | null, company?: string | null, add1?: string | null, add2?: string | null, zipCode?: string | null, city?: string | null, countryCode?: string | null, country?: string | null, phone?: string | null, mail?: string | null } | null } | null };

export type OrderPageFragment = { __typename?: 'Order2', _id: any, externalId: string, orderName?: string | null, comment?: string | null, orderDate: Date, orderUrl?: string | null, fulState?: EnumOrder2FulState | null, payState: EnumOrder2PayState, orderState: EnumOrder2OrderState, updatedAt?: Date | null, notified?: boolean | null, notifiedConsumer?: boolean | null, exportedToWMS?: boolean | null, trackingUrl?: string | null, returnLabelUrl?: string | null, returnDeadline?: Date | null, freeReturn?: boolean | null, silenced?: boolean | null, currency?: string | null, proforma?: boolean | null, proformaInvoiceCommission?: boolean | null, proformaInvoicePickPack?: boolean | null, proformaInvoiceShipping?: boolean | null, deliveryNoteUrl: string, consumer: { __typename?: 'Order2Consumer', id?: string | null, name?: string | null, add1?: string | null, add2?: string | null, zipCode?: string | null, city?: string | null, phone?: string | null, country?: string | null, mail?: string | null, language?: string | null }, lines?: Array<{ __typename?: 'Order2Item', _id: any, externalLineId: string, returned?: boolean | null, cancelled?: boolean | null, fulfilled?: boolean | null, salesPrice?: number | null, discountedPrice?: number | null, currency?: string | null, item?: { __typename?: 'StockItem', _id: any, sku?: string | null, itemSku: string, ean?: string | null, originalEan?: string | null, title?: string | null, imageUrls?: Array<string> | null, itemNr?: number | null, color?: string | null, size?: string | null, sellingPrice?: number | null, stockLocation?: string | null, brandItemId?: any | null, brandItem?: { __typename?: 'BrandItem', _id: any, unavailable?: Date | null } | null } | null } | null> | null, trackingInfo?: { __typename?: 'Order2TrackingInfo', number?: string | null, carrier?: EnumOrder2TrackingInfoCarrier | null } | null, returnInfo?: { __typename?: 'Order2ReturnInfo', carrier?: EnumOrder2ReturnInfoCarrier | null, number?: string | null } | null, shippingAddress?: { __typename?: 'Order2ShippingAddress', name?: string | null, company?: string | null, add1?: string | null, add2?: string | null, zipCode?: string | null, city?: string | null, countryCode?: string | null, country?: string | null, phone?: string | null, mail?: string | null } | null, shippingAddressInternal?: { __typename?: 'Order2ShippingAddress', name?: string | null, company?: string | null, add1?: string | null, add2?: string | null, zipCode?: string | null, city?: string | null, countryCode?: string | null, country?: string | null, phone?: string | null, mail?: string | null } | null };

export type OrderAddressFragment = { __typename?: 'Order2ShippingAddress', name?: string | null, company?: string | null, add1?: string | null, add2?: string | null, zipCode?: string | null, city?: string | null, countryCode?: string | null, country?: string | null, phone?: string | null, mail?: string | null };

export type OrderPageOrderLineFragment = { __typename?: 'Order2Item', _id: any, externalLineId: string, returned?: boolean | null, cancelled?: boolean | null, fulfilled?: boolean | null, salesPrice?: number | null, discountedPrice?: number | null, currency?: string | null, item?: { __typename?: 'StockItem', _id: any, sku?: string | null, itemSku: string, ean?: string | null, originalEan?: string | null, title?: string | null, imageUrls?: Array<string> | null, itemNr?: number | null, color?: string | null, size?: string | null, sellingPrice?: number | null, stockLocation?: string | null, brandItemId?: any | null, brandItem?: { __typename?: 'BrandItem', _id: any, unavailable?: Date | null } | null } | null };

export type OrderPageOrderUpdateMutationVariables = Exact<{
  shopId: Scalars['String'];
  order: OrderUpdateInput2;
}>;


export type OrderPageOrderUpdateMutation = { __typename?: 'Mutation', OrderUpdate?: { __typename?: 'Order2', _id: any, externalId: string, orderName?: string | null, comment?: string | null, orderDate: Date, orderUrl?: string | null, fulState?: EnumOrder2FulState | null, payState: EnumOrder2PayState, orderState: EnumOrder2OrderState, updatedAt?: Date | null, notified?: boolean | null, notifiedConsumer?: boolean | null, exportedToWMS?: boolean | null, trackingUrl?: string | null, returnLabelUrl?: string | null, returnDeadline?: Date | null, freeReturn?: boolean | null, silenced?: boolean | null, currency?: string | null, proforma?: boolean | null, proformaInvoiceCommission?: boolean | null, proformaInvoicePickPack?: boolean | null, proformaInvoiceShipping?: boolean | null, deliveryNoteUrl: string, consumer: { __typename?: 'Order2Consumer', id?: string | null, name?: string | null, add1?: string | null, add2?: string | null, zipCode?: string | null, city?: string | null, phone?: string | null, country?: string | null, mail?: string | null, language?: string | null }, lines?: Array<{ __typename?: 'Order2Item', _id: any, externalLineId: string, returned?: boolean | null, cancelled?: boolean | null, fulfilled?: boolean | null, salesPrice?: number | null, discountedPrice?: number | null, currency?: string | null, item?: { __typename?: 'StockItem', _id: any, sku?: string | null, itemSku: string, ean?: string | null, originalEan?: string | null, title?: string | null, imageUrls?: Array<string> | null, itemNr?: number | null, color?: string | null, size?: string | null, sellingPrice?: number | null, stockLocation?: string | null, brandItemId?: any | null, brandItem?: { __typename?: 'BrandItem', _id: any, unavailable?: Date | null } | null } | null } | null> | null, trackingInfo?: { __typename?: 'Order2TrackingInfo', number?: string | null, carrier?: EnumOrder2TrackingInfoCarrier | null } | null, returnInfo?: { __typename?: 'Order2ReturnInfo', carrier?: EnumOrder2ReturnInfoCarrier | null, number?: string | null } | null, shippingAddress?: { __typename?: 'Order2ShippingAddress', name?: string | null, company?: string | null, add1?: string | null, add2?: string | null, zipCode?: string | null, city?: string | null, countryCode?: string | null, country?: string | null, phone?: string | null, mail?: string | null } | null, shippingAddressInternal?: { __typename?: 'Order2ShippingAddress', name?: string | null, company?: string | null, add1?: string | null, add2?: string | null, zipCode?: string | null, city?: string | null, countryCode?: string | null, country?: string | null, phone?: string | null, mail?: string | null } | null } | null };

export type OrderSynchronizeMutationVariables = Exact<{
  input: OrderSynchronizeInput;
}>;


export type OrderSynchronizeMutation = { __typename?: 'Mutation', OrderSynchronize?: { __typename?: 'Order2', _id: any, externalId: string, orderName?: string | null, comment?: string | null, orderDate: Date, orderUrl?: string | null, fulState?: EnumOrder2FulState | null, payState: EnumOrder2PayState, orderState: EnumOrder2OrderState, updatedAt?: Date | null, notified?: boolean | null, notifiedConsumer?: boolean | null, exportedToWMS?: boolean | null, trackingUrl?: string | null, returnLabelUrl?: string | null, returnDeadline?: Date | null, freeReturn?: boolean | null, silenced?: boolean | null, currency?: string | null, proforma?: boolean | null, proformaInvoiceCommission?: boolean | null, proformaInvoicePickPack?: boolean | null, proformaInvoiceShipping?: boolean | null, deliveryNoteUrl: string, consumer: { __typename?: 'Order2Consumer', id?: string | null, name?: string | null, add1?: string | null, add2?: string | null, zipCode?: string | null, city?: string | null, phone?: string | null, country?: string | null, mail?: string | null, language?: string | null }, lines?: Array<{ __typename?: 'Order2Item', _id: any, externalLineId: string, returned?: boolean | null, cancelled?: boolean | null, fulfilled?: boolean | null, salesPrice?: number | null, discountedPrice?: number | null, currency?: string | null, item?: { __typename?: 'StockItem', _id: any, sku?: string | null, itemSku: string, ean?: string | null, originalEan?: string | null, title?: string | null, imageUrls?: Array<string> | null, itemNr?: number | null, color?: string | null, size?: string | null, sellingPrice?: number | null, stockLocation?: string | null, brandItemId?: any | null, brandItem?: { __typename?: 'BrandItem', _id: any, unavailable?: Date | null } | null } | null } | null> | null, trackingInfo?: { __typename?: 'Order2TrackingInfo', number?: string | null, carrier?: EnumOrder2TrackingInfoCarrier | null } | null, returnInfo?: { __typename?: 'Order2ReturnInfo', carrier?: EnumOrder2ReturnInfoCarrier | null, number?: string | null } | null, shippingAddress?: { __typename?: 'Order2ShippingAddress', name?: string | null, company?: string | null, add1?: string | null, add2?: string | null, zipCode?: string | null, city?: string | null, countryCode?: string | null, country?: string | null, phone?: string | null, mail?: string | null } | null, shippingAddressInternal?: { __typename?: 'Order2ShippingAddress', name?: string | null, company?: string | null, add1?: string | null, add2?: string | null, zipCode?: string | null, city?: string | null, countryCode?: string | null, country?: string | null, phone?: string | null, mail?: string | null } | null } | null };

export type PrintDeliveryNoteMutationVariables = Exact<{
  orderId: Scalars['MongoID'];
}>;


export type PrintDeliveryNoteMutation = { __typename?: 'Mutation', OrderPrintDeliveryNote: Array<string> };

export type OrderPageIntegrationInstancesQueryVariables = Exact<{
  filter?: InputMaybe<FilterFindManyIntegrationInstanceInput>;
}>;


export type OrderPageIntegrationInstancesQuery = { __typename?: 'Query', IntegrationInstances: Array<{ __typename?: 'IntegrationInstance', _id: any, name: string, refType: EnumIntegrationInstanceRefType, connector?: { __typename?: 'IntegrationConnector', messages?: Array<EnumIntegrationConnectorMessages | null> | null } | null }> };

export type OrderPageResendCreateMutationVariables = Exact<{
  orderId: Scalars['MongoID'];
  instanceId: Scalars['MongoID'];
}>;


export type OrderPageResendCreateMutation = { __typename?: 'Mutation', OrderResendCreate: Array<string> };

export type OrderPageIntegrationMessageStatusQueryVariables = Exact<{
  tokens: Array<Scalars['String']> | Scalars['String'];
}>;


export type OrderPageIntegrationMessageStatusQuery = { __typename?: 'Query', IntegrationMessage?: Array<{ __typename?: 'IntegrationMessageResult', resultTs?: Date | null, messageFailed?: boolean | null, messageIgnored?: boolean | null } | null> | null };

export type OrderPageUpdateBrandItemMutationVariables = Exact<{
  brandHouseId: Scalars['MongoID'];
  input: BrandItemInputInput;
}>;


export type OrderPageUpdateBrandItemMutation = { __typename?: 'Mutation', BrandItemUpdate?: { __typename?: 'BrandItem', _id: any, unavailable?: Date | null } | null };

export type OrderResetReturnMutationVariables = Exact<{
  orderId: Scalars['MongoID'];
}>;


export type OrderResetReturnMutation = { __typename?: 'Mutation', OrderResetReturn: { __typename?: 'Order2', _id: any, externalId: string, orderName?: string | null, comment?: string | null, orderDate: Date, orderUrl?: string | null, fulState?: EnumOrder2FulState | null, payState: EnumOrder2PayState, orderState: EnumOrder2OrderState, updatedAt?: Date | null, notified?: boolean | null, notifiedConsumer?: boolean | null, exportedToWMS?: boolean | null, trackingUrl?: string | null, returnLabelUrl?: string | null, returnDeadline?: Date | null, freeReturn?: boolean | null, silenced?: boolean | null, currency?: string | null, proforma?: boolean | null, proformaInvoiceCommission?: boolean | null, proformaInvoicePickPack?: boolean | null, proformaInvoiceShipping?: boolean | null, deliveryNoteUrl: string, consumer: { __typename?: 'Order2Consumer', id?: string | null, name?: string | null, add1?: string | null, add2?: string | null, zipCode?: string | null, city?: string | null, phone?: string | null, country?: string | null, mail?: string | null, language?: string | null }, lines?: Array<{ __typename?: 'Order2Item', _id: any, externalLineId: string, returned?: boolean | null, cancelled?: boolean | null, fulfilled?: boolean | null, salesPrice?: number | null, discountedPrice?: number | null, currency?: string | null, item?: { __typename?: 'StockItem', _id: any, sku?: string | null, itemSku: string, ean?: string | null, originalEan?: string | null, title?: string | null, imageUrls?: Array<string> | null, itemNr?: number | null, color?: string | null, size?: string | null, sellingPrice?: number | null, stockLocation?: string | null, brandItemId?: any | null, brandItem?: { __typename?: 'BrandItem', _id: any, unavailable?: Date | null } | null } | null } | null> | null, trackingInfo?: { __typename?: 'Order2TrackingInfo', number?: string | null, carrier?: EnumOrder2TrackingInfoCarrier | null } | null, returnInfo?: { __typename?: 'Order2ReturnInfo', carrier?: EnumOrder2ReturnInfoCarrier | null, number?: string | null } | null, shippingAddress?: { __typename?: 'Order2ShippingAddress', name?: string | null, company?: string | null, add1?: string | null, add2?: string | null, zipCode?: string | null, city?: string | null, countryCode?: string | null, country?: string | null, phone?: string | null, mail?: string | null } | null, shippingAddressInternal?: { __typename?: 'Order2ShippingAddress', name?: string | null, company?: string | null, add1?: string | null, add2?: string | null, zipCode?: string | null, city?: string | null, countryCode?: string | null, country?: string | null, phone?: string | null, mail?: string | null } | null } };

export type OrderUpdateReasonsQueryVariables = Exact<{
  brandHouseId: Scalars['MongoID'];
  target: EnumOptionSetTarget;
}>;


export type OrderUpdateReasonsQuery = { __typename?: 'Query', Options: Array<{ __typename?: 'OptionSet', _id: any, key: string, title: string, valueType: EnumOptionSetValueType, values?: Array<{ __typename?: 'OptionValue', _id: any, value: string, label: string } | null> | null }> };

export type ReasonOptionFragment = { __typename?: 'OptionSet', _id: any, key: string, title: string, valueType: EnumOptionSetValueType, values?: Array<{ __typename?: 'OptionValue', _id: any, value: string, label: string } | null> | null };

export type ParcelsListQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<FilterFindManyParcelInput>;
  sort?: InputMaybe<SortFindManyParcelInput>;
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
}>;


export type ParcelsListQuery = { __typename?: 'Query', ParcelsPagination?: { __typename?: 'ParcelParcelPagination', count?: number | null, pageInfo: { __typename?: 'PaginationInfo', perPage: number, currentPage: number, hasNextPage?: boolean | null, hasPreviousPage?: boolean | null, itemCount?: number | null, pageCount?: number | null }, items?: Array<{ __typename?: 'Parcel', _id: any, comment?: string | null, parcelDate: Date, shopId?: any | null, items?: Array<{ __typename?: 'ParcelItems', refId: any, refType: EnumParcelItemsRefType } | null> | null, receiver: { __typename?: 'AddressInfo', name?: string | null, attention?: string | null, add1?: string | null, add2?: string | null, zipCode?: string | null, city?: string | null, countryCode?: string | null, phone?: string | null, mail?: string | null, refId?: any | null, refType?: EnumAddressInfoRefType | null }, sender: { __typename?: 'AddressInfo', name?: string | null, attention?: string | null, add1?: string | null, add2?: string | null, zipCode?: string | null, city?: string | null, countryCode?: string | null, phone?: string | null, mail?: string | null, refId?: any | null, refType?: EnumAddressInfoRefType | null }, shippingLabel?: { __typename?: 'ShippingLabel', deliveryStatus?: EnumShippingLabelDeliveryStatus | null, packageCode?: string | null, sender?: { __typename?: 'AddressInfo', name?: string | null, attention?: string | null, add1?: string | null, add2?: string | null, zipCode?: string | null, city?: string | null, countryCode?: string | null, phone?: string | null, mail?: string | null, refId?: any | null, refType?: EnumAddressInfoRefType | null } | null, receiver?: { __typename?: 'AddressInfo', name?: string | null, attention?: string | null, add1?: string | null, add2?: string | null, zipCode?: string | null, city?: string | null, countryCode?: string | null, phone?: string | null, mail?: string | null, refId?: any | null, refType?: EnumAddressInfoRefType | null } | null } | null, shippingCarrier?: { __typename?: 'ShippingCarrier', _id: any, name?: string | null } | null }> | null } | null };

export type ParcelFragment = { __typename?: 'Parcel', _id: any, comment?: string | null, parcelDate: Date, shopId?: any | null, items?: Array<{ __typename?: 'ParcelItems', refId: any, refType: EnumParcelItemsRefType } | null> | null, receiver: { __typename?: 'AddressInfo', name?: string | null, attention?: string | null, add1?: string | null, add2?: string | null, zipCode?: string | null, city?: string | null, countryCode?: string | null, phone?: string | null, mail?: string | null, refId?: any | null, refType?: EnumAddressInfoRefType | null }, sender: { __typename?: 'AddressInfo', name?: string | null, attention?: string | null, add1?: string | null, add2?: string | null, zipCode?: string | null, city?: string | null, countryCode?: string | null, phone?: string | null, mail?: string | null, refId?: any | null, refType?: EnumAddressInfoRefType | null }, shippingLabel?: { __typename?: 'ShippingLabel', deliveryStatus?: EnumShippingLabelDeliveryStatus | null, packageCode?: string | null, sender?: { __typename?: 'AddressInfo', name?: string | null, attention?: string | null, add1?: string | null, add2?: string | null, zipCode?: string | null, city?: string | null, countryCode?: string | null, phone?: string | null, mail?: string | null, refId?: any | null, refType?: EnumAddressInfoRefType | null } | null, receiver?: { __typename?: 'AddressInfo', name?: string | null, attention?: string | null, add1?: string | null, add2?: string | null, zipCode?: string | null, city?: string | null, countryCode?: string | null, phone?: string | null, mail?: string | null, refId?: any | null, refType?: EnumAddressInfoRefType | null } | null } | null, shippingCarrier?: { __typename?: 'ShippingCarrier', _id: any, name?: string | null } | null };

export type AddressFragment = { __typename?: 'AddressInfo', name?: string | null, attention?: string | null, add1?: string | null, add2?: string | null, zipCode?: string | null, city?: string | null, countryCode?: string | null, phone?: string | null, mail?: string | null, refId?: any | null, refType?: EnumAddressInfoRefType | null };

export type ParcelShopNameQueryVariables = Exact<{
  id: Scalars['MongoID'];
}>;


export type ParcelShopNameQuery = { __typename?: 'Query', ShopById?: { __typename?: 'Shop', _id: any, name?: string | null } | null };

export type ParcelLogisticsPartnerNameQueryVariables = Exact<{
  id: Scalars['MongoID'];
}>;


export type ParcelLogisticsPartnerNameQuery = { __typename?: 'Query', LogisticsPartner?: { __typename?: 'LogisticsPartner', _id: any, name?: string | null } | null };

export type ParcelsPageQueryVariables = Exact<{
  shopId: Scalars['MongoID'];
}>;


export type ParcelsPageQuery = { __typename?: 'Query', Parcels: Array<{ __typename?: 'Parcel', _id: any, comment?: string | null, parcelDate: Date, shopId?: any | null, items?: Array<{ __typename?: 'ParcelItems', refId: any, refType: EnumParcelItemsRefType } | null> | null, receiver: { __typename?: 'AddressInfo', name?: string | null, attention?: string | null, add1?: string | null, add2?: string | null, zipCode?: string | null, city?: string | null, countryCode?: string | null, phone?: string | null, mail?: string | null, refId?: any | null, refType?: EnumAddressInfoRefType | null }, sender: { __typename?: 'AddressInfo', name?: string | null, attention?: string | null, add1?: string | null, add2?: string | null, zipCode?: string | null, city?: string | null, countryCode?: string | null, phone?: string | null, mail?: string | null, refId?: any | null, refType?: EnumAddressInfoRefType | null }, shippingLabel?: { __typename?: 'ShippingLabel', deliveryStatus?: EnumShippingLabelDeliveryStatus | null, packageCode?: string | null, sender?: { __typename?: 'AddressInfo', name?: string | null, attention?: string | null, add1?: string | null, add2?: string | null, zipCode?: string | null, city?: string | null, countryCode?: string | null, phone?: string | null, mail?: string | null, refId?: any | null, refType?: EnumAddressInfoRefType | null } | null, receiver?: { __typename?: 'AddressInfo', name?: string | null, attention?: string | null, add1?: string | null, add2?: string | null, zipCode?: string | null, city?: string | null, countryCode?: string | null, phone?: string | null, mail?: string | null, refId?: any | null, refType?: EnumAddressInfoRefType | null } | null } | null, shippingCarrier?: { __typename?: 'ShippingCarrier', _id: any, name?: string | null } | null }> };

export type ParcelsPageCreateMutationVariables = Exact<{
  input: CreateOneParcelInput;
}>;


export type ParcelsPageCreateMutation = { __typename?: 'Mutation', ParcelCreate?: { __typename?: 'CreateOneParcelPayload', recordId?: any | null, record?: { __typename?: 'Parcel', _id: any, comment?: string | null, parcelDate: Date, shopId?: any | null, items?: Array<{ __typename?: 'ParcelItems', refId: any, refType: EnumParcelItemsRefType } | null> | null, receiver: { __typename?: 'AddressInfo', name?: string | null, attention?: string | null, add1?: string | null, add2?: string | null, zipCode?: string | null, city?: string | null, countryCode?: string | null, phone?: string | null, mail?: string | null, refId?: any | null, refType?: EnumAddressInfoRefType | null }, sender: { __typename?: 'AddressInfo', name?: string | null, attention?: string | null, add1?: string | null, add2?: string | null, zipCode?: string | null, city?: string | null, countryCode?: string | null, phone?: string | null, mail?: string | null, refId?: any | null, refType?: EnumAddressInfoRefType | null }, shippingLabel?: { __typename?: 'ShippingLabel', deliveryStatus?: EnumShippingLabelDeliveryStatus | null, packageCode?: string | null, sender?: { __typename?: 'AddressInfo', name?: string | null, attention?: string | null, add1?: string | null, add2?: string | null, zipCode?: string | null, city?: string | null, countryCode?: string | null, phone?: string | null, mail?: string | null, refId?: any | null, refType?: EnumAddressInfoRefType | null } | null, receiver?: { __typename?: 'AddressInfo', name?: string | null, attention?: string | null, add1?: string | null, add2?: string | null, zipCode?: string | null, city?: string | null, countryCode?: string | null, phone?: string | null, mail?: string | null, refId?: any | null, refType?: EnumAddressInfoRefType | null } | null } | null, shippingCarrier?: { __typename?: 'ShippingCarrier', _id: any, name?: string | null } | null } | null } | null };

export type ParcelsPageCarriersQueryVariables = Exact<{
  shopId: Scalars['MongoID'];
  receiver?: InputMaybe<ShippingCarriersForParcelReceiverInput>;
}>;


export type ParcelsPageCarriersQuery = { __typename?: 'Query', ShippingCarriersForParcel?: Array<{ __typename?: 'ShippingCarrier', _id: any, name?: string | null, logo?: string | null } | null> | null };

export type ParcelsPageShopsQueryVariables = Exact<{
  brandHouseId: Scalars['MongoID'];
}>;


export type ParcelsPageShopsQuery = { __typename?: 'Query', ShopMany: Array<{ __typename?: 'Shop', _id: any, name?: string | null, logisticsPartnerId: any }> };

export type ParcelsPageLogisticsPartnerQueryVariables = Exact<{
  id: Scalars['MongoID'];
}>;


export type ParcelsPageLogisticsPartnerQuery = { __typename?: 'Query', LogisticsPartner?: { __typename?: 'LogisticsPartner', _id: any, countryCode?: string | null } | null };

export type IntegrationBrandByIdQueryVariables = Exact<{
  shopId: Scalars['MongoID'];
}>;


export type IntegrationBrandByIdQuery = { __typename?: 'Query', ShopById?: { __typename?: 'Shop', _id: any, name?: string | null, externalId?: string | null, synchronizeActions?: Date | null, synchronizeOrders?: Date | null, synchronizeProducts?: Date | null, synchronizeHooks?: Date | null } | null };

export type ShopDataPageSynchronizeMutationVariables = Exact<{
  shopId: Scalars['String'];
  service: Scalars['String'];
}>;


export type ShopDataPageSynchronizeMutation = { __typename?: 'Mutation', StartSynchronize?: { __typename?: 'SyncResult', status: string } | null };

export type ConsumerPageFetchPotentialsMutationVariables = Exact<{
  shopId: Scalars['MongoID'];
  consumerId: Scalars['MongoID'];
}>;


export type ConsumerPageFetchPotentialsMutation = { __typename?: 'Mutation', ConsumerRequestPotentials?: Array<string> | null };

export type ConsumerUpdateMutationVariables = Exact<{
  input: ConsumerInput;
}>;


export type ConsumerUpdateMutation = { __typename?: 'Mutation', ConsumerUpdate?: { __typename?: 'Consumer', _id: any } | null };

export type ConsumersPageMergeMutationVariables = Exact<{
  consumerIds: Array<Scalars['MongoID']> | Scalars['MongoID'];
}>;


export type ConsumersPageMergeMutation = { __typename?: 'Mutation', ConsumerMerge?: { __typename?: 'Consumer', id?: string | null } | null };

export type ConsumerRequestAccessMutationVariables = Exact<{
  shopId: Scalars['MongoID'];
  mail: Scalars['String'];
}>;


export type ConsumerRequestAccessMutation = { __typename?: 'Mutation', ConsumerRequestAccessFlow?: Array<string> | null };

export type PotentialCreateMutationVariables = Exact<{
  consumerId: Scalars['MongoID'];
  masterVariantId: Scalars['String'];
}>;


export type PotentialCreateMutation = { __typename?: 'Mutation', PotentialCreate?: { __typename?: 'Potential', _id: any } | null };

export type ProductDetailVariantsQueryVariables = Exact<{
  productId: Scalars['MongoID'];
}>;


export type ProductDetailVariantsQuery = { __typename?: 'Query', ProductById?: { __typename?: 'Product', _id: any, name: string, description?: string | null, createdAt?: Date | null, updatedAt?: Date | null, disabled?: boolean | null, deleted?: boolean | null, isPotential?: boolean | null, isPreOwned?: boolean | null, style?: string | null, tags?: Array<string | null> | null, collections?: Array<string | null> | null, productVariants?: Array<{ __typename?: 'ProductVariant', _id: any, externalId?: string | null, sku?: string | null, ean?: string | null, size?: string | null, color?: string | null, imageUrls?: Array<string> | null, countryOrigin?: string | null, commodityCode?: string | null, rrp?: Array<{ __typename?: 'Pricing', value: number, currency: string } | null> | null } | null> | null } | null };

export type ProductDetailDisableMutationVariables = Exact<{
  productId: Scalars['MongoID'];
  disable: Scalars['Boolean'];
}>;


export type ProductDetailDisableMutation = { __typename?: 'Mutation', ProductDisable?: { __typename?: 'Product', _id: any, disabled?: boolean | null } | null };

export type BrandProductImportMutationVariables = Exact<{
  brandHouseID: Scalars['MongoID'];
  productID: Scalars['MongoID'];
}>;


export type BrandProductImportMutation = { __typename?: 'Mutation', BrandProductImport: boolean };

export type ProductsPageStatisticsQueryVariables = Exact<{
  shopId: Scalars['String'];
}>;


export type ProductsPageStatisticsQuery = { __typename?: 'Query', ProductStatistics?: { __typename?: 'ProductStatistic', variants: number, variantsImages: number, variantsNoImages: number, variantsNoThumbnails: number, variantsThumbnails: number, productsNoImages?: Array<string | null> | null } | null };

export type ImportDialogStockItemQueryVariables = Exact<{
  stockItemId: Scalars['MongoID'];
}>;


export type ImportDialogStockItemQuery = { __typename?: 'Query', StockItem?: { __typename?: 'StockItem', _id: any, originalEan?: string | null, sku?: string | null } | null };

export type ImportDialogProductQueryVariables = Exact<{
  shopId: Scalars['MongoID'];
  sku?: InputMaybe<Scalars['String']>;
  ean?: InputMaybe<Scalars['String']>;
}>;


export type ImportDialogProductQuery = { __typename?: 'Query', ProductVariantMany: Array<{ __typename?: 'ProductVariant', _id: any, productId: any, sku?: string | null, ean?: string | null, size?: string | null, color?: string | null, imageUrls?: Array<string> | null, product?: { __typename?: 'Product', _id: any, name: string, style?: string | null } | null }> };

export type ImportDialogCreateImageMutationVariables = Exact<{
  shopId: Scalars['String'];
  stockItemId: Scalars['String'];
  imageUrl: Scalars['String'];
}>;


export type ImportDialogCreateImageMutation = { __typename?: 'Mutation', StockItemImageCreate2?: { __typename?: 'StockItemImage', _id: any } | null };

export type ExportStockItemsQueryVariables = Exact<{
  stockItemIds?: InputMaybe<Array<Scalars['MongoID']> | Scalars['MongoID']>;
}>;


export type ExportStockItemsQuery = { __typename?: 'Query', StockItems2?: Array<{ __typename?: 'StockItem', _id: any, resolved?: { __typename?: 'StockItemResolved', _id: any, itemNr?: number | null, condition?: number | null, isSold?: boolean | null, stockLocation?: string | null, imageUrls?: Array<string> | null, effectiveTitle: string, effectiveMissing: boolean, effectiveChecked: boolean, sellingPrice?: number | null, beforePrice?: number | null, ean?: string | null, effectiveColor?: string | null, size?: string | null, originalEan?: string | null, sku?: string | null, vendor?: string | null } | null } | null> | null };

export type StockItemImagesRotateMutationVariables = Exact<{
  shopId: Scalars['String'];
  imageId: Scalars['String'];
  rotate: Scalars['Float'];
}>;


export type StockItemImagesRotateMutation = { __typename?: 'Mutation', StockItemImageRotate?: { __typename?: 'StockItemImage', _id: any, sourceId: any, sourceUrl: string, imageId?: any | null, imageUrl?: string | null } | null };

export type StockItemImageAltTextQueryVariables = Exact<{
  imageId: Scalars['MongoID'];
}>;


export type StockItemImageAltTextQuery = { __typename?: 'Query', StockItemImageById?: { __typename?: 'StockItemImage', _id: any, altText?: string | null } | null };

export type StockItemImageAltTextSaveMutationVariables = Exact<{
  imageId: Scalars['MongoID'];
  input: UpdateByIdStockItemImageInput;
}>;


export type StockItemImageAltTextSaveMutation = { __typename?: 'Mutation', StockItemImageUpdateById?: { __typename?: 'UpdateByIdStockItemImagePayload', record?: { __typename?: 'StockItemImage', _id: any } | null } | null };

export type StockItemsPageBrandQueryVariables = Exact<{
  shopId: Scalars['MongoID'];
}>;


export type StockItemsPageBrandQuery = { __typename?: 'Query', ShopById?: { __typename?: 'Shop', _id: any, currency?: string | null, brandHouseId: any, brandHouse?: { __typename?: 'BrandHouse', _id: any, settings?: { __typename?: 'BrandSetting', useBrandItems?: boolean | null } | null } | null } | null };

export type ReprocessAllImagesMutationVariables = Exact<{
  shopId: Scalars['String'];
}>;


export type ReprocessAllImagesMutation = { __typename?: 'Mutation', StockItemImageAutoRetouchAll?: Array<{ __typename?: 'StockItemImage', _id: any } | null> | null };

export type ReprocessStockItemImagesMutationVariables = Exact<{
  shopId: Scalars['String'];
  stockItemId: Scalars['String'];
}>;


export type ReprocessStockItemImagesMutation = { __typename?: 'Mutation', StockItemImageAutoRetouch2?: Array<{ __typename?: 'StockItemImage', _id: any } | null> | null };

export type StockItemsRecalculatePricesMutationVariables = Exact<{
  shopId: Scalars['String'];
}>;


export type StockItemsRecalculatePricesMutation = { __typename?: 'Mutation', StockItemsRecalculatePrices?: Array<{ __typename?: 'StockItem', _id: any, sellingPrice?: number | null, beforePrice?: number | null } | null> | null };

export type StockItemsPagePublishMutationVariables = Exact<{
  shopId: Scalars['String'];
  stockItem: StockItemUpdateInput;
}>;


export type StockItemsPagePublishMutation = { __typename?: 'Mutation', StockItemUpdate?: { __typename?: 'StockItem', _id: any, published?: boolean | null, draft?: boolean | null, review?: boolean | null } | null };

export type StockItemImageSynchronizeMutationVariables = Exact<{
  stockItem: Scalars['MongoID'];
}>;


export type StockItemImageSynchronizeMutation = { __typename?: 'Mutation', StockItemImageSynchronize?: { __typename?: 'StockItem', _id: any, images?: Array<{ __typename?: 'StockItemImage', _id: any } | null> | null } | null };

export type StockItemProductInfoQueryVariables = Exact<{
  productId: Scalars['MongoID'];
}>;


export type StockItemProductInfoQuery = { __typename?: 'Query', ProductById?: { __typename?: 'Product', _id: any, description?: string | null } | null };

export type StockItemFormBrandSettingQueryVariables = Exact<{
  shopId: Scalars['MongoID'];
}>;


export type StockItemFormBrandSettingQuery = { __typename?: 'Query', BrandSettings?: { __typename?: 'BrandSetting', _id?: any | null, shopId?: any | null, pricingTags?: Array<string> | null, locales?: Array<{ __typename?: 'BrandLocale', locale: string, activeItems?: boolean | null } | null> | null, stockItemConfig?: { __typename?: 'BrandSettingStockItemConfig', titlePrefix?: string | null, appendColor?: boolean | null, appendSize?: boolean | null, descriptionSuffix?: string | null } | null, sellPrice?: Array<{ __typename?: 'BrandSettingSellPrice', condition?: number | null, pct?: number | null } | null> | null } | null };

export type StockItemFormStockItemUpdateMutationVariables = Exact<{
  shopId: Scalars['String'];
  stockItem: StockItemUpdateInput;
}>;


export type StockItemFormStockItemUpdateMutation = { __typename?: 'Mutation', StockItemUpdate?: { __typename?: 'StockItem', _id: any, externId?: string | null, brandItemId?: any | null, tradeInItemId?: any | null, itemNr?: number | null, itemSku: string, title?: string | null, description?: string | null, productType?: string | null, vendor?: string | null, imageIds?: Array<any | null> | null, imageUrls?: Array<string> | null, originalEan?: string | null, ean?: string | null, sku?: string | null, size?: string | null, color?: string | null, beforePrice?: number | null, sellingPrice?: number | null, condition?: number | null, active?: boolean | null, draft?: boolean | null, published?: boolean | null, review?: boolean | null, itemStatus: StockItemStatus, note?: string | null, nfcTag?: string | null, externUrl?: string | null, stockLocation?: string | null, checked?: Date | null, missing?: Date | null, effectiveMissing: boolean, hasErrors: boolean, dataErrors?: Array<string> | null, shopId: any, itemAge?: number | null, createdAt?: Date | null, sourceType?: ItemSourceType | null, titleLocalized?: Array<{ __typename?: 'LocalizationEntry', locale: string, value: string } | null> | null, descriptionLocalized?: Array<{ __typename?: 'LocalizationEntry', locale: string, value: string } | null> | null, colorLocalized?: Array<{ __typename?: 'LocalizationEntry', locale: string, value: string } | null> | null, itemTags?: Array<{ __typename?: 'StockItemTag', tag?: string | null, auto?: boolean | null } | null> | null, problems?: Array<{ __typename?: 'StockItemProblems', _id?: any | null, solved?: boolean | null, description?: string | null, createdAt?: Date | null } | null> | null, tradeInItem?: { __typename?: 'TradeInItem', tradeInId?: any | null, value?: number | null, tradeIn?: { __typename?: 'TradeIn', consumerId: any, consumer?: { __typename?: 'Consumer', name?: string | null } | null, vouchers?: Array<{ __typename?: 'Voucher', value?: number | null } | null> | null } | null } | null, shop?: { __typename?: 'Shop', currency?: string | null, productTags?: Array<string> | null, locales?: Array<string | null> | null, productTypes?: Array<string> | null } | null, orderlines?: Array<{ __typename?: 'Order2Item', _id: any, salesPrice?: number | null, returnedTs?: Date | null, order?: { __typename?: 'Order2', _id: any, orderName?: string | null, orderDate: Date } | null } | null> | null, resolved?: { __typename?: 'StockItemResolved', brandItemId?: any | null, title?: string | null } | null } | null };

export type StockItemFormRecalculatePriceMutationVariables = Exact<{
  shopId: Scalars['String'];
  stockItem?: InputMaybe<StockItemUpdateInput>;
}>;


export type StockItemFormRecalculatePriceMutation = { __typename?: 'Mutation', StockItemsRecalculatePrice?: number | null };

export type StockItemFormStockItemByIdQueryVariables = Exact<{
  stockItemId: Scalars['MongoID'];
}>;


export type StockItemFormStockItemByIdQuery = { __typename?: 'Query', StockItemById?: { __typename?: 'StockItem', _id: any, externId?: string | null, brandItemId?: any | null, tradeInItemId?: any | null, itemNr?: number | null, itemSku: string, title?: string | null, description?: string | null, productType?: string | null, vendor?: string | null, imageIds?: Array<any | null> | null, imageUrls?: Array<string> | null, originalEan?: string | null, ean?: string | null, sku?: string | null, size?: string | null, color?: string | null, beforePrice?: number | null, sellingPrice?: number | null, condition?: number | null, active?: boolean | null, draft?: boolean | null, published?: boolean | null, review?: boolean | null, itemStatus: StockItemStatus, note?: string | null, nfcTag?: string | null, externUrl?: string | null, stockLocation?: string | null, checked?: Date | null, missing?: Date | null, effectiveMissing: boolean, hasErrors: boolean, dataErrors?: Array<string> | null, shopId: any, itemAge?: number | null, createdAt?: Date | null, sourceType?: ItemSourceType | null, titleLocalized?: Array<{ __typename?: 'LocalizationEntry', locale: string, value: string } | null> | null, descriptionLocalized?: Array<{ __typename?: 'LocalizationEntry', locale: string, value: string } | null> | null, colorLocalized?: Array<{ __typename?: 'LocalizationEntry', locale: string, value: string } | null> | null, itemTags?: Array<{ __typename?: 'StockItemTag', tag?: string | null, auto?: boolean | null } | null> | null, problems?: Array<{ __typename?: 'StockItemProblems', _id?: any | null, solved?: boolean | null, description?: string | null, createdAt?: Date | null } | null> | null, tradeInItem?: { __typename?: 'TradeInItem', tradeInId?: any | null, value?: number | null, tradeIn?: { __typename?: 'TradeIn', consumerId: any, consumer?: { __typename?: 'Consumer', name?: string | null } | null, vouchers?: Array<{ __typename?: 'Voucher', value?: number | null } | null> | null } | null } | null, shop?: { __typename?: 'Shop', currency?: string | null, productTags?: Array<string> | null, locales?: Array<string | null> | null, productTypes?: Array<string> | null } | null, orderlines?: Array<{ __typename?: 'Order2Item', _id: any, salesPrice?: number | null, returnedTs?: Date | null, order?: { __typename?: 'Order2', _id: any, orderName?: string | null, orderDate: Date } | null } | null> | null, resolved?: { __typename?: 'StockItemResolved', brandItemId?: any | null, title?: string | null } | null } | null };

export type StockItemFragment = { __typename?: 'StockItem', _id: any, externId?: string | null, brandItemId?: any | null, tradeInItemId?: any | null, itemNr?: number | null, itemSku: string, title?: string | null, description?: string | null, productType?: string | null, vendor?: string | null, imageIds?: Array<any | null> | null, imageUrls?: Array<string> | null, originalEan?: string | null, ean?: string | null, sku?: string | null, size?: string | null, color?: string | null, beforePrice?: number | null, sellingPrice?: number | null, condition?: number | null, active?: boolean | null, draft?: boolean | null, published?: boolean | null, review?: boolean | null, itemStatus: StockItemStatus, note?: string | null, nfcTag?: string | null, externUrl?: string | null, stockLocation?: string | null, checked?: Date | null, missing?: Date | null, effectiveMissing: boolean, hasErrors: boolean, dataErrors?: Array<string> | null, shopId: any, itemAge?: number | null, createdAt?: Date | null, sourceType?: ItemSourceType | null, titleLocalized?: Array<{ __typename?: 'LocalizationEntry', locale: string, value: string } | null> | null, descriptionLocalized?: Array<{ __typename?: 'LocalizationEntry', locale: string, value: string } | null> | null, colorLocalized?: Array<{ __typename?: 'LocalizationEntry', locale: string, value: string } | null> | null, itemTags?: Array<{ __typename?: 'StockItemTag', tag?: string | null, auto?: boolean | null } | null> | null, problems?: Array<{ __typename?: 'StockItemProblems', _id?: any | null, solved?: boolean | null, description?: string | null, createdAt?: Date | null } | null> | null, tradeInItem?: { __typename?: 'TradeInItem', tradeInId?: any | null, value?: number | null, tradeIn?: { __typename?: 'TradeIn', consumerId: any, consumer?: { __typename?: 'Consumer', name?: string | null } | null, vouchers?: Array<{ __typename?: 'Voucher', value?: number | null } | null> | null } | null } | null, shop?: { __typename?: 'Shop', currency?: string | null, productTags?: Array<string> | null, locales?: Array<string | null> | null, productTypes?: Array<string> | null } | null, orderlines?: Array<{ __typename?: 'Order2Item', _id: any, salesPrice?: number | null, returnedTs?: Date | null, order?: { __typename?: 'Order2', _id: any, orderName?: string | null, orderDate: Date } | null } | null> | null, resolved?: { __typename?: 'StockItemResolved', brandItemId?: any | null, title?: string | null } | null };

export type StockItemImagesQueryVariables = Exact<{
  shopId: Scalars['String'];
  stockItemId: Scalars['String'];
}>;


export type StockItemImagesQuery = { __typename?: 'Query', StockItemImages?: Array<{ __typename?: 'StockItemImage', _id: any, sourceId: any, sourceUrl: string, imageId?: any | null, imageUrl?: string | null, process?: boolean | null, failed?: boolean | null, sortOrder?: number | null, effectiveAltText?: string | null } | null> | null };

export type StockItemImageQueryVariables = Exact<{
  shopId: Scalars['String'];
  stockItemImageId: Scalars['String'];
}>;


export type StockItemImageQuery = { __typename?: 'Query', StockItemImage?: { __typename?: 'StockItemImage', _id: any, sourceId: any, sourceUrl: string, imageId?: any | null, imageUrl?: string | null, process?: boolean | null, failed?: boolean | null, sortOrder?: number | null } | null };

export type StockItemImageCreateMutationVariables = Exact<{
  shopId: Scalars['String'];
  stockItemId: Scalars['String'];
  uploadId: Scalars['String'];
}>;


export type StockItemImageCreateMutation = { __typename?: 'Mutation', StockItemImageCreate?: { __typename?: 'StockItemImage', _id: any, sourceId: any, sourceUrl: string, imageId?: any | null, imageUrl?: string | null, sortOrder?: number | null } | null };

export type StockItemImageDeleteMutationVariables = Exact<{
  shopId: Scalars['String'];
  stockItemImageId: Scalars['String'];
}>;


export type StockItemImageDeleteMutation = { __typename?: 'Mutation', StockItemImageDelete?: { __typename?: 'StockItemImage', _id: any } | null };

export type StockItemImageAutoRetouchMutationVariables = Exact<{
  shopId: Scalars['String'];
  stockItemImageId: Scalars['String'];
  process: Scalars['Boolean'];
}>;


export type StockItemImageAutoRetouchMutation = { __typename?: 'Mutation', StockItemImageAutoRetouch?: { __typename?: 'StockItemImage', _id: any, sourceId: any, sourceUrl: string, imageId?: any | null, imageUrl?: string | null, process?: boolean | null, sortOrder?: number | null } | null };

export type StockItemImageUpdateMutationVariables = Exact<{
  shopId: Scalars['String'];
  imageId: Scalars['String'];
  sortOrder: Scalars['Float'];
}>;


export type StockItemImageUpdateMutation = { __typename?: 'Mutation', StockItemImageUpdate?: { __typename?: 'StockItemImage', _id: any, sortOrder?: number | null } | null };

export type StockItemImageSetOrderMutationVariables = Exact<{
  shopId: Scalars['String'];
  stockItemId: Scalars['String'];
  imageIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type StockItemImageSetOrderMutation = { __typename?: 'Mutation', StockItemImageSetOrder?: Array<{ __typename?: 'StockItemImage', _id: any, sortOrder?: number | null } | null> | null };

export type StockItemMultiSettingsQueryVariables = Exact<{
  shopId: Scalars['MongoID'];
}>;


export type StockItemMultiSettingsQuery = { __typename?: 'Query', Shop?: { __typename?: 'Shop', _id: any, currency?: string | null } | null, BrandSettings?: { __typename?: 'BrandSetting', _id?: any | null, locales?: Array<{ __typename?: 'BrandLocale', locale: string, activeItems?: boolean | null } | null> | null, stockItemConfig?: { __typename?: 'BrandSettingStockItemConfig', currencies?: Array<{ __typename?: 'Currency', currency: string, active?: boolean | null } | null> | null } | null } | null };

export type StockItemMultiQueryVariables = Exact<{
  StockItemIds?: InputMaybe<Array<Scalars['MongoID']> | Scalars['MongoID']>;
}>;


export type StockItemMultiQuery = { __typename?: 'Query', StockItems2?: Array<{ __typename?: 'StockItem', _id: any, itemNr?: number | null, imageUrls?: Array<string> | null, condition?: number | null, title?: string | null, description?: string | null, size?: string | null, color?: string | null, beforePrice?: number | null, sellingPrice?: number | null, productType?: string | null, sku?: string | null, originalEan?: string | null, vendor?: string | null, productVariantId?: any | null, reviewed?: Date | null } | null> | null };

export type StockItemMultiUpdateMutationVariables = Exact<{
  shopId: Scalars['String'];
  input?: InputMaybe<StockItemUpdateInput>;
}>;


export type StockItemMultiUpdateMutation = { __typename?: 'Mutation', StockItemUpdate?: { __typename?: 'StockItem', _id: any, itemNr?: number | null, imageUrls?: Array<string> | null, condition?: number | null, title?: string | null, description?: string | null, size?: string | null, color?: string | null, beforePrice?: number | null, sellingPrice?: number | null, productType?: string | null, sku?: string | null, originalEan?: string | null, vendor?: string | null, productVariantId?: any | null, reviewed?: Date | null } | null };

export type StockItemMultiFragment = { __typename?: 'StockItem', _id: any, itemNr?: number | null, imageUrls?: Array<string> | null, condition?: number | null, title?: string | null, description?: string | null, size?: string | null, color?: string | null, beforePrice?: number | null, sellingPrice?: number | null, productType?: string | null, sku?: string | null, originalEan?: string | null, vendor?: string | null, productVariantId?: any | null, reviewed?: Date | null };

export type StockItemMultiRecalculatePriceMutationVariables = Exact<{
  shopId: Scalars['String'];
  stockItem?: InputMaybe<StockItemUpdateInput>;
}>;


export type StockItemMultiRecalculatePriceMutation = { __typename?: 'Mutation', StockItemsRecalculatePrice?: number | null };

export type TrackingPageQueryVariables = Exact<{
  shopId: Scalars['MongoID'];
}>;


export type TrackingPageQuery = { __typename?: 'Query', BrandSettings?: { __typename?: 'BrandSetting', _id?: any | null, tracking?: boolean | null } | null };

export type TrackingPageUpdateMutationVariables = Exact<{
  shopId: Scalars['MongoID'];
  tracking: Scalars['Boolean'];
  auditNoteId?: InputMaybe<Scalars['MongoID']>;
}>;


export type TrackingPageUpdateMutation = { __typename?: 'Mutation', BrandSettingsUpdate?: { __typename?: 'BrandSetting', _id?: any | null, tracking?: boolean | null } | null };

export type ConsumerPlannedMailsQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<FilterFindManyPlannedMailInput>;
  sort?: InputMaybe<SortFindManyPlannedMailInput>;
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
}>;


export type ConsumerPlannedMailsQuery = { __typename?: 'Query', PlannedMailsPagination?: { __typename?: 'PlannedMailPlannedMailPagination', count?: number | null, pageInfo: { __typename?: 'PaginationInfo', perPage: number, currentPage: number, hasNextPage?: boolean | null, hasPreviousPage?: boolean | null, itemCount?: number | null, pageCount?: number | null }, items?: Array<{ __typename?: 'PlannedMail', _id: any, mailType: string, objectId: string, objectType: string, sent?: Date | null, sentStatus?: string | null, sendAt: Date }> | null } | null };

export type ConsumerEventsTradeInQueryVariables = Exact<{
  tradeInID: Scalars['MongoID'];
}>;


export type ConsumerEventsTradeInQuery = { __typename?: 'Query', TradeIn?: { __typename?: 'TradeIn', _id: any, tradeInNr?: number | null, consumerId: any, consumer?: { __typename?: 'Consumer', name?: string | null, mail?: string | null } | null } | null };

export type ConsumerEventsVoucherQueryVariables = Exact<{
  voucherID: Scalars['MongoID'];
}>;


export type ConsumerEventsVoucherQuery = { __typename?: 'Query', VoucherById?: { __typename?: 'Voucher', _id: any, code?: string | null, used?: Date | null, currentValue?: number | null, consumerId: any, consumer?: { __typename?: 'Consumer', name?: string | null, mail?: string | null } | null } | null };

export type ConsumerMailResendMutationVariables = Exact<{
  mailId?: InputMaybe<Scalars['MongoID']>;
}>;


export type ConsumerMailResendMutation = { __typename?: 'Mutation', PlannedMailUpdate?: { __typename?: 'UpdateOnePlannedMailPayload', recordId?: any | null } | null };

export type ConsumerSendAllMutationVariables = Exact<{
  shopId: Scalars['MongoID'];
}>;


export type ConsumerSendAllMutation = { __typename?: 'Mutation', VoucherSendReminder: boolean };

export type TradeInPageShopQueryVariables = Exact<{
  shopId: Scalars['MongoID'];
}>;


export type TradeInPageShopQuery = { __typename?: 'Query', ShopById?: { __typename?: 'Shop', _id: any, tradeInBaseUrl?: string | null, currency?: string | null, brandHouseId: any, conditions?: Array<{ __typename?: 'ShopConditionPublic', condition: number, name: string, description: string } | null> | null, brandHouse?: { __typename?: 'BrandHouse', _id: any, settings?: { __typename?: 'BrandSetting', useBrandItems?: boolean | null } | null } | null } | null };

export type TradeInPageByIdQueryVariables = Exact<{
  tradeInId: Scalars['MongoID'];
}>;


export type TradeInPageByIdQuery = { __typename?: 'Query', TradeInById?: { __typename?: 'TradeIn', _id: any, dateTime: Date, registered?: boolean | null, registeredTs?: Date | null, notified?: boolean | null, shippingType?: string | null, shippingCarrierId?: any | null, tradeInNr?: number | null, deliveryNoteUrl: string, consumerId: any, hasBonus?: boolean | null, vouchers?: Array<{ __typename?: 'Voucher', _id: any, value?: number | null, currency?: string | null, code?: string | null, voucherStrategy?: EnumVoucherVoucherStrategy | null, activated: boolean } | null> | null, circularPoints?: Array<{ __typename?: 'CircularPoint', _id: any, value: number, activated: boolean } | null> | null, label?: { __typename?: 'ShippingLabel', deliveryDate?: Date | null, deliveryStatus?: EnumShippingLabelDeliveryStatus | null, url?: string | null } | null, items?: Array<{ __typename?: 'TradeInItem', _id: any, name?: string | null, sku?: string | null, size?: string | null, color?: string | null, condition?: number | null, externUrl?: string | null, bonus?: number | null, productVariantId?: any | null, imageUrls?: Array<string> | null, rejected?: EnumTradeInItemRejected | null, productVariant?: { __typename?: 'ProductVariant', _id: any, color?: string | null, size?: string | null, sku?: string | null, product?: { __typename?: 'Product', _id: any, name: string } | null } | null, wholeSale?: { __typename?: 'PotentialWholeSale', categoryId?: any | null, name?: string | null, value?: number | null } | null, stockItem?: { __typename?: 'StockItem', _id: any } | null, potential?: { __typename?: 'Potential', externUrl?: string | null, rrp?: number | null, sp?: number | null } | null } | null> | null } | null };

export type ShopTradeInItemsRemoveMutationVariables = Exact<{
  tradeInId: Scalars['MongoID'];
  tradeInItemsId: Array<Scalars['MongoID']> | Scalars['MongoID'];
  reject: TradeInItemRejectReasonEnum;
}>;


export type ShopTradeInItemsRemoveMutation = { __typename?: 'Mutation', TradeInItemsReject?: Array<{ __typename?: 'TradeInItem', _id: any } | null> | null };

export type MainTradeInItemUpdateByIdMutationVariables = Exact<{
  id: Scalars['MongoID'];
  record: UpdateByIdTradeInItemInput;
}>;


export type MainTradeInItemUpdateByIdMutation = { __typename?: 'Mutation', TradeInItemUpdateById?: { __typename?: 'UpdateByIdTradeInItemPayload', recordId?: any | null } | null };

export type WholeSaleEditCategoryGetQueryVariables = Exact<{
  categoryId: Scalars['MongoID'];
}>;


export type WholeSaleEditCategoryGetQuery = { __typename?: 'Query', WholeSaleCategory?: { __typename?: 'WholeSaleCategory', _id: any, shopId: any, iconId?: any | null, name: string, section?: string | null, advanced?: boolean | null, value: number, voucherStrategy?: EnumWholeSaleCategoryVoucherStrategy | null, sortOrder?: number | null, nameLocalized?: Array<{ __typename?: 'LocalizationEntry', value: string, locale: string } | null> | null, sectionLocalized?: Array<{ __typename?: 'LocalizationEntry', value: string, locale: string } | null> | null, rules?: Array<{ __typename?: 'WholeSaleCategoryRules', _id?: any | null, name?: string | null, active?: boolean | null, value?: number | null, expressions?: Array<{ __typename?: 'WholeSaleCategoryRulesExpressions', _id?: any | null, operator: EnumWholeSaleCategoryRulesExpressionsOperator, expressionType: EnumWholeSaleCategoryRulesExpressionsExpressionType, sku?: string | null, col?: string | null, tag?: string | null } | null> | null } | null> | null } | null };

export type WholeSaleCategoryFragment = { __typename?: 'WholeSaleCategory', _id: any, shopId: any, iconId?: any | null, name: string, section?: string | null, advanced?: boolean | null, value: number, voucherStrategy?: EnumWholeSaleCategoryVoucherStrategy | null, sortOrder?: number | null, nameLocalized?: Array<{ __typename?: 'LocalizationEntry', value: string, locale: string } | null> | null, sectionLocalized?: Array<{ __typename?: 'LocalizationEntry', value: string, locale: string } | null> | null, rules?: Array<{ __typename?: 'WholeSaleCategoryRules', _id?: any | null, name?: string | null, active?: boolean | null, value?: number | null, expressions?: Array<{ __typename?: 'WholeSaleCategoryRulesExpressions', _id?: any | null, operator: EnumWholeSaleCategoryRulesExpressionsOperator, expressionType: EnumWholeSaleCategoryRulesExpressionsExpressionType, sku?: string | null, col?: string | null, tag?: string | null } | null> | null } | null> | null };

export type WholeSaleEditCategoryRuleFragment = { __typename?: 'WholeSaleCategoryRules', _id?: any | null, name?: string | null, active?: boolean | null, value?: number | null, expressions?: Array<{ __typename?: 'WholeSaleCategoryRulesExpressions', _id?: any | null, operator: EnumWholeSaleCategoryRulesExpressionsOperator, expressionType: EnumWholeSaleCategoryRulesExpressionsExpressionType, sku?: string | null, col?: string | null, tag?: string | null } | null> | null };

export type WholeSaleEditCategoryExpressionFragment = { __typename?: 'WholeSaleCategoryRulesExpressions', _id?: any | null, operator: EnumWholeSaleCategoryRulesExpressionsOperator, expressionType: EnumWholeSaleCategoryRulesExpressionsExpressionType, sku?: string | null, col?: string | null, tag?: string | null };

export type WholeSaleEditCategoryUpdateMutationVariables = Exact<{
  categoryId: Scalars['MongoID'];
  record: UpdateOneWholeSaleCategoryInput;
}>;


export type WholeSaleEditCategoryUpdateMutation = { __typename?: 'Mutation', WholeSaleCategoryUpdate?: { __typename?: 'UpdateOneWholeSaleCategoryPayload', recordId?: any | null, record?: { __typename?: 'WholeSaleCategory', _id: any, shopId: any, iconId?: any | null, name: string, section?: string | null, advanced?: boolean | null, value: number, voucherStrategy?: EnumWholeSaleCategoryVoucherStrategy | null, sortOrder?: number | null, nameLocalized?: Array<{ __typename?: 'LocalizationEntry', value: string, locale: string } | null> | null, sectionLocalized?: Array<{ __typename?: 'LocalizationEntry', value: string, locale: string } | null> | null, rules?: Array<{ __typename?: 'WholeSaleCategoryRules', _id?: any | null, name?: string | null, active?: boolean | null, value?: number | null, expressions?: Array<{ __typename?: 'WholeSaleCategoryRulesExpressions', _id?: any | null, operator: EnumWholeSaleCategoryRulesExpressionsOperator, expressionType: EnumWholeSaleCategoryRulesExpressionsExpressionType, sku?: string | null, col?: string | null, tag?: string | null } | null> | null } | null> | null } | null } | null };

export type WholeSaleEditCategoryDeleteMutationVariables = Exact<{
  shopId: Scalars['String'];
  categoryId: Scalars['String'];
}>;


export type WholeSaleEditCategoryDeleteMutation = { __typename?: 'Mutation', WholeSaleCategoryDelete?: { __typename?: 'WholeSaleCategory', _id: any } | null };

export type WholeSaleCategoryCreateMutationVariables = Exact<{
  record: CreateOneWholeSaleCategoryInput;
}>;


export type WholeSaleCategoryCreateMutation = { __typename?: 'Mutation', WholeSaleCategoryCreate?: { __typename?: 'CreateOneWholeSaleCategoryPayload', recordId?: any | null } | null };

export type WholeSaleCategoryEditBrandQueryVariables = Exact<{
  shopId: Scalars['MongoID'];
}>;


export type WholeSaleCategoryEditBrandQuery = { __typename?: 'Query', ShopById?: { __typename?: 'Shop', _id: any, productTags?: Array<string> | null, productCollections?: Array<string> | null } | null };

export type WholeSaleStatisticsQueryVariables = Exact<{
  shopId: Scalars['String'];
  rule: WholeSaleCategoryRulesInput;
}>;


export type WholeSaleStatisticsQuery = { __typename?: 'Query', WholeSaleRuleStatistics?: { __typename?: 'WholeSaleStatistics', count?: number | null, sample?: Array<{ __typename?: 'WholeSaleProduct', _id: string, name: string, variants?: Array<{ __typename?: 'WholeSaleVariant', sku?: string | null, images?: Array<string | null> | null } | null> | null } | null> | null } | null };

export type WholeSaleProductFragment = { __typename?: 'WholeSaleProduct', _id: string, name: string, variants?: Array<{ __typename?: 'WholeSaleVariant', sku?: string | null, images?: Array<string | null> | null } | null> | null };

export type WholeSaleLocalesQueryVariables = Exact<{
  shopId: Scalars['MongoID'];
}>;


export type WholeSaleLocalesQuery = { __typename?: 'Query', ShopById?: { __typename?: 'Shop', _id: any, tradeInLocalePrimary: string, tradeInLocales: Array<string> } | null };

export type WholeSaleActiveQueryVariables = Exact<{
  shopId: Scalars['MongoID'];
}>;


export type WholeSaleActiveQuery = { __typename?: 'Query', ShopById?: { __typename?: 'Shop', _id: any, wholeSaleActive?: boolean | null } | null };

export type WholeSaleActivateMutationVariables = Exact<{
  shopId: Scalars['MongoID'];
  active: Scalars['Boolean'];
}>;


export type WholeSaleActivateMutation = { __typename?: 'Mutation', ShopUpdateOne?: { __typename?: 'UpdateOneShopPayload', recordId?: any | null } | null };

export type WholeSaleCategoriesQueryVariables = Exact<{
  shopId: Scalars['MongoID'];
}>;


export type WholeSaleCategoriesQuery = { __typename?: 'Query', WholeSaleCategories: Array<{ __typename?: 'WholeSaleCategory', _id: any, iconId?: any | null, name: string, section?: string | null, value: number, voucherStrategy?: EnumWholeSaleCategoryVoucherStrategy | null }> };

export const IntegrationFragmentDoc = gql`
    fragment integrationFragment on IntegrationConnector {
  _id
  name
  refTypes
  deleted
  activeFor
  autoInstallFor
  type
  dispatcher
  eventbus {
    development {
      serviceBus
      topic
    }
    production {
      topic
      serviceBus
    }
    test {
      serviceBus
      topic
    }
  }
  webhook {
    development {
      headers
      url
    }
    production {
      headers
      url
    }
    test {
      headers
      url
    }
  }
  cloudTasks {
    development {
      queue
      targetUrl
      audience
    }
    production {
      queue
      targetUrl
      audience
    }
    test {
      queue
      targetUrl
      audience
    }
  }
  fields {
    namespace
    field
    description
    type
    options {
      label
      value
    }
    required
    defaultValue
  }
  messages
  optionals
}
    `;
export const IntegrationMessageFragmentDoc = gql`
    fragment IntegrationMessageFragment on IntegrationMessage {
  _id
  parentId
  messageFailed
  messageIgnored
  payload
  result
  created
  sent
  sendAt
  sentCount
  acknowledged
  resultTs
  failed
  replySequence
  env
  lockedId
  refId
  refType
  refShop {
    _id
    name
  }
  refBrandHouse {
    _id
    name
  }
  refLogisticsPartner {
    _id
    name
  }
  instanceId
  instance {
    _id
    name
    mode
    enabled
    deleted
    refName
    refType
    connectorId
    connector {
      _id
      name
      type
      dispatcher
    }
  }
  message
}
    `;
export const IntegrationMessageChainFragmentDoc = gql`
    fragment IntegrationMessageChainFragment on IntegrationMessage {
  _id
  parentId
  message
  created
  sendAt
  sent
  resultTs
  failed
  messageFailed
  messageIgnored
  sentCount
}
    `;
export const IntegrationListFragmentDoc = gql`
    fragment IntegrationListFragment on IntegrationMessage {
  _id
  refId
  refType
  created
  message
  resultTs
  result
  acknowledged
  messageFailed
  messageIgnored
  sent
  sendAt
  failed
  instanceId
  instance {
    name
  }
  refShop {
    name
  }
  refBrandHouse {
    name
  }
  refLogisticsPartner {
    name
  }
}
    `;
export const ObjectPatchFragmentDoc = gql`
    fragment ObjectPatchFragment on ObjectPatches {
  _id
  type
  shopId
  brandHouseId
  updatedBy {
    type
    ref
  }
  date
  ops {
    value
    op
    path
  }
}
    `;
export const BrandItemBoostFieldsFragmentDoc = gql`
    fragment BrandItemBoostFields on BrandItemBoost {
  pricePct
  visibility
  startTs
  endTs
  endedTs
  active
}
    `;
export const BrandItemBoostStateFragmentDoc = gql`
    fragment BrandItemBoostState on BrandItem {
  _id
  salesRank
  sellingPrices {
    value
    currency
  }
  activeBoost {
    ...BrandItemBoostFields
  }
}
    ${BrandItemBoostFieldsFragmentDoc}`;
export const BrandItemImportSearchFragmentDoc = gql`
    fragment BrandItemImportSearchFragment on BrandProduct {
  _id
  nameLocalized {
    locale
    value
  }
  variants {
    _id
    colorLocalized {
      value
      locale
    }
    sizes {
      sizeLocalized {
        value
        locale
      }
      sku
      ean
    }
  }
  style
  imageUrls
}
    `;
export const BrandItemMultiFragmentDoc = gql`
    fragment BrandItemMultiFragment on BrandItem {
  _id
  itemNr
  imageUrls
  itemState
  condition
  nameLocalized {
    locale
    value
  }
  descriptionLocalized {
    locale
    value
  }
  sizeLocalized {
    locale
    value
  }
  colorLocalized {
    locale
    value
  }
  beforePrices {
    value
    currency
  }
  typeLocalized {
    locale
    value
  }
  originalSku
  originalEan
  vendor
  sortorder
  test
}
    `;
export const BrandItemMultiResolvedFragmentDoc = gql`
    fragment BrandItemMultiResolvedFragment on BrandItemResolved {
  _id
  itemNr
  imageUrls
  itemState
  condition
  nameLocalized {
    locale
    value
  }
  descriptionLocalized {
    locale
    value
  }
  sizeLocalized {
    locale
    value
  }
  colorLocalized {
    locale
    value
  }
  beforePrices {
    value
    currency
  }
  typeLocalized {
    locale
    value
  }
  originalSku
  originalEan
  vendor
  sortorder
  test
}
    `;
export const FlexBrandItemFragmentDoc = gql`
    fragment FlexBrandItem on BrandItemResolved {
  _id
  brandHouseId
  brandProductSizeId
  brandHouse {
    _id
    name
  }
  itemNr
  itemSku
  tradeInItemId
  isTradeIn
  nameLocalized {
    locale
    value
  }
  descriptionLocalized {
    locale
    value
  }
  createdAt
  condition
  typeLocalized {
    locale
    value
  }
  images {
    process
    imageId
    imageUrl
    brandProductImageUrl
  }
  imageUrls(potentialImages: true)
  beforePrices {
    currency
    value
  }
  sellingPrices {
    currency
    value
  }
  activeBoost {
    ...BrandItemBoostFields
  }
  originalSku
  originalEan
  itemEan
  colorLocalized {
    locale
    value
  }
  sizeLocalized {
    locale
    value
  }
  itemState
  checked
  effectiveChecked
  effectiveMissing
  stockLocation
  stockLocationTs
  stockLocationBag
  isSold
  soldTs
  isInSeason
  note
  hasErrors
  hasProblems
  hasComment
  hasTranslatedComment
  commentApproved
  commentLocalized {
    locale
    value
  }
  stateAggregation
  options {
    key
    value
  }
  sortorder
  invalidManufacturer
  vendor
  test
  legacyGroup
  shops {
    _id
    shopId
    active
  }
  problems {
    solved
    description
    createdAt
  }
  externalId
  vasId
  vas {
    vasId
    vasName
    completedBy
    sortingOrder
  }
  attributes {
    type
    apparentFabricType
    formalityLevel
    neckline
    pattern
    primaryColor
    seasonSuitability
    secondaryColors
    textureAppearance
  }
  reviewInfos {
    type
    value
  }
}
    ${BrandItemBoostFieldsFragmentDoc}`;
export const ProductPaginationFragmentDoc = gql`
    fragment ProductPaginationFragment on BrandProduct {
  _id
  nameLocalized {
    locale
    value
  }
  style
  imageUrls
}
    `;
export const CampaignFragmentDoc = gql`
    fragment Campaign on Campaign {
  _id
  campaignName
  fromDate
  toDate
  percentage
  disabled
  active
  completed
  startedTs
  endedTs
}
    `;
export const MasterDataSearchProductFragmentDoc = gql`
    fragment MasterDataSearchProduct on MasterDataProduct {
  _id
  externalId
  style
  name {
    locale
    value
  }
  images {
    _id
    thumbUrl
  }
  options {
    key
    type
    name {
      locale
      value
    }
  }
  variants {
    _id
    externalId
    sku
    ean
    options {
      key
      value
    }
    images {
      _id
      thumbUrl
    }
  }
}
    `;
export const ProformaAddressInfoFragmentDoc = gql`
    fragment ProformaAddressInfo on AddressInfo {
  name
  attention
  add1
  add2
  zipCode
  city
  countryCode
  mail
  phone
}
    `;
export const ProformaLogisticsPartnerAddressFragmentDoc = gql`
    fragment ProformaLogisticsPartnerAddress on LogisticsPartner {
  _id
  name
  address
  address2
  zipCode
  city
  country
  countryCode
  mail
  phone
}
    `;
export const OptionFragmentDoc = gql`
    fragment OptionFragment on OptionSet {
  _id
  key
  title
  valueType
  values {
    _id
    value
    label
  }
}
    `;
export const FragmentBrandItemFragmentDoc = gql`
    fragment FragmentBrandItem on BrandItem {
  _id
  createdAt
  updatedAt
  updatedBy {
    ref
    type
  }
  tradeInItemId
  vasId
  vasType
  vasImages
  sortorder
  disableRRPListPrice
  tradeInItem {
    _id
    tradeInId
    name
    value
    tradeIn {
      _id
      consumerId
      consumer {
        _id
        name
      }
    }
    identifier {
      color
      identity
      origin
      type
    }
    sku
    shopId
    shop {
      _id
      name
      currency
    }
    potential {
      _id
      imageUrls
    }
  }
  brandProductSizeId
  nameLocalized {
    locale
    value
  }
  descriptionLocalized {
    locale
    value
  }
  colorLocalized {
    locale
    value
  }
  sizeLocalized {
    locale
    value
  }
  typeLocalized {
    locale
    value
  }
  commentLocalized {
    locale
    value
  }
  commentApproved
  directPrices {
    currency
    value
  }
  sellingPrices {
    currency
    value
  }
  activeBoost {
    ...BrandItemBoostFields
  }
  beforePrices {
    currency
    value
  }
  condition
  itemNr
  itemState
  itemEan
  commodityCode
  countryOrigin
  originalEan
  originalSku
  stockLocation
  stockLocationBag
  checked
  effectiveChecked
  missing
  effectiveMissing
  unavailable
  discarded
  nfcTag
  note
  problems {
    createdAt
    description
    solved
  }
  images {
    _id
    uploadId
    uploadUrl
    imageId
    imageUrl
    altText
    process
    processStart
    processError
    brandProductImageId
    brandProductImageUrl
    originalImage
  }
  vendor
  itemTags(includeAuto: true) {
    auto
    tag
  }
  itemMetas {
    namespace
    type
    value
    key
    auto
  }
  sourceType
  options {
    optionSetId
    optionValueId
    optionValue
  }
  test
  deleted
  reviewInfos {
    type
    value
  }
  masterDataVariantId
  masterDataProduct {
    _id
  }
  masterDataSnapshot {
    brandProductSizeId
  }
  invoiceLine {
    invoice {
      invoiceId
    }
  }
}
    ${BrandItemBoostFieldsFragmentDoc}`;
export const FragmentBrandItemResolvedFragmentDoc = gql`
    fragment FragmentBrandItemResolved on BrandItemResolved {
  _id
  brandProductSizeId
  disableRRPListPrice
  sortorder
  nameLocalized {
    locale
    value
  }
  descriptionLocalized {
    locale
    value
  }
  colorLocalized {
    locale
    value
  }
  sizeLocalized {
    locale
    value
  }
  typeLocalized {
    locale
    value
  }
  commentLocalized {
    locale
    value
  }
  commentApproved
  beforePrices {
    currency
    value
  }
  condition
  itemNr
  itemState
  itemTags {
    auto
    tag
  }
  itemEan
  vasId
  vasType
  commodityCode
  countryOrigin
  originalEan
  originalSku
  stockLocation
  stockLocationBag
  checked
  effectiveChecked
  missing
  effectiveMissing
  unavailable
  discarded
  nfcTag
  problems {
    createdAt
    description
    solved
  }
  images {
    _id
    uploadId
    uploadUrl
    imageId
    imageUrl
    altText
    process
    processStart
    processError
    brandProductImageId
    brandProductImageUrl
    originalImage
  }
  vendor
  sourceType
  options {
    optionSetId
    optionValueId
    optionValue
  }
  masterDataInfo {
    name
    sku
    size
    color
    ean
    externalId
  }
  masterDataProduct {
    _id
  }
}
    `;
export const ItemIssueFragmentDoc = gql`
    fragment ItemIssueFragment on ItemIssue {
  _id
  brandHouseId
  brandItemId
  location
  point
  markX
  markY
  issue
  imageUrl
  processedUrl
  createdAt
  brandItem {
    itemSku
    nameLocalized {
      locale
      value
    }
    brandHouse {
      _id
      name
    }
  }
}
    `;
export const BrandProductFragmentDoc = gql`
    fragment brandProductFragment on BrandProduct {
  _id
  groupId
  externalId
  brandHouseId
  createdAt
  updatedAt
  source
  disabled
  deleted
  collections
  tags
  disableRRPListPrice
  nameLocalized {
    value
    locale
  }
  descriptionLocalized {
    value
    locale
  }
  typeLocalized {
    value
    locale
  }
  vendor
  metaFields {
    key
    namespace
    type
    value
    customData
  }
  localizedMetaFields {
    language
    metaFields {
      key
      namespace
      type
      value
      customData
    }
  }
  variants {
    _id
    externalId
    sku
    deleted
    deactivated
    colorLocalized {
      value
      locale
    }
    commodityCode
    countryOrigin
    metaFields {
      namespace
      type
      value
      customData
    }
    rrp {
      currency
      value
    }
    sizes {
      _id
      externalId
      sku
      ean
      deleted
      sizeLocalized {
        value
        locale
      }
      metaFields {
        namespace
        type
        value
        customData
      }
    }
    images {
      _id
      externalId
      deleted
      imageAltText
      imageId
      originalId
      colors
      type
      perspective
      imageUrl
    }
  }
}
    `;
export const GroupFragmentDoc = gql`
    fragment GroupFragment on BrandProductGroup {
  _id
  name
  active
  activePotentials
  activePromotions
}
    `;
export const BrandTradeInSizeFragmentDoc = gql`
    fragment BrandTradeInSizeFragment on BrandProductSize {
  _id
  ean
  sku
  sizeLocalized {
    value
    locale
  }
  brandVariant {
    _id
    colorLocalized {
      value
      locale
    }
    brandProduct {
      nameLocalized {
        value
        locale
      }
    }
  }
}
    `;
export const BrandTradeInDialogFragmentDoc = gql`
    fragment BrandTradeInDialogFragment on BrandProductVariant {
  _id
  brandProduct {
    _id
    nameLocalized {
      locale
      value
    }
  }
  sizes {
    ...BrandTradeInSizeFragment
  }
  colorLocalized {
    locale
    value
  }
  imageUrls
}
    ${BrandTradeInSizeFragmentDoc}`;
export const BrandTradeInFragmentDoc = gql`
    fragment BrandTradeInFragment on TradeIn {
  _id
  dateTime
  registered
  registeredTs
  comment
  notified
  shippingType
  shippingCarrierId
  tradeInNr
  deliveryNoteUrl
  shopId
  shop {
    _id
    tradeInBaseUrl
    currency
    conditions {
      condition
      name
      description
    }
  }
  hasBonus
  vouchers {
    _id
    value
    currency
    code
    voucherStrategy
    activated
    used
    payoutValue
  }
  shippingLabelId
  label {
    deliveryDate
    deliveryStatus
    url
    qrUrl
    trackingUrl
    carrier {
      carrierId
      name
    }
  }
  consumerId
  consumer {
    _id
    language
    externalId
    id
    name
    add1
    add2
    zipCode
    country
    countryCode
    mail
    acceptsMarketing
    personId
    currency
  }
  payoutType
}
    `;
export const InvoiceOrderFragmentDoc = gql`
    fragment InvoiceOrder on Order2 {
  _id
  orderName
  orderDate
  lines {
    stockItem {
      itemNr
      title
      imageUrls
      shopId
    }
  }
}
    `;
export const InvoiceLineFragmentDoc = gql`
    fragment InvoiceLine on Order2Item {
  order {
    ...InvoiceOrder
  }
  cancelled
  discountedPricePreTax
  stockItem {
    itemNr
    title
    imageUrls
    shopId
  }
}
    ${InvoiceOrderFragmentDoc}`;
export const InvoiceFragmentDoc = gql`
    fragment InvoiceFragment on InvoiceSetting {
  _id
  brandHouseId
  currency
  fee
  minPlatformCost
  costPerItem
  shops {
    shopId
    comment
    costPerItem
    pickPackFee
    saleCommisionPct
    shippingOrder
    shippingReturn
    shippingTradeIn
  }
  customData
}
    `;
export const ListsTradeInFragmentDoc = gql`
    fragment ListsTradeInFragment on TradeIn {
  _id
  brandHouseId
  tradeInNr
  consumerId
  consumer {
    name
    mail
    country
  }
  dateTime
  registered
  payoutType
  vouchers {
    code
    value
    currency
    activated
    used
    deleted
    payoutValue
  }
  shopId
  shop {
    currency
    name
    externalName
  }
  label {
    deliveryStatus
    carrier {
      name
    }
  }
  source
  items {
    _id
    stockItem {
      _id
    }
    brandItem {
      _id
    }
    rejected
    imageUrls
    bonus
  }
}
    `;
export const TradeInExportItemFragmentDoc = gql`
    fragment TradeInExportItem on TradeInItem {
  _id
  imageUrls
  wholeSale {
    name
    value
  }
  name
  value
  condition
  rejected
  bonus
  brandItem {
    isSold
    orderline {
      salesPricePreTax(currency: $currency)
      order {
        orderDate
      }
      discountedPrice
    }
    resolved {
      originalSku
      sizeLocalized {
        value
        locale
      }
      nameLocalized {
        locale
        value
      }
    }
  }
  stockItem {
    isSold
    resolved {
      title
      size
      condition
      sku
    }
    orderline {
      salesPricePreTax(currency: $currency)
      order {
        orderDate
      }
    }
  }
}
    `;
export const TradeInExportFragmentDoc = gql`
    fragment TradeInExport on TradeIn {
  _id
  tradeInNr
  dateTime
  shopId
  shop {
    name
  }
  registered
  shippingCarrierId
  label {
    deliveryStatus
    qrUrl
  }
  shippingCarrier {
    name
  }
  items {
    ...TradeInExportItem
  }
  consumer {
    _id
    name
    mail
    phone
    phoneE164
  }
  vouchers {
    value
    currency
    statistics(currency: $currency) {
      reward
      smashFactor
      spending
      reward
      usageDate
      active
    }
  }
}
    ${TradeInExportItemFragmentDoc}`;
export const TradeInExportItemItemFragmentDoc = gql`
    fragment TradeInExportItemItem on TradeInItem {
  _id
  imageUrls
  wholeSale {
    name
    value
  }
  name
  value
  condition
  rejected
  bonus
  brandItem {
    isSold
    condition
    resolved {
      originalSku
      sizeLocalized {
        value
        locale
      }
      nameLocalized {
        locale
        value
      }
      orderline {
        discountedPrice
      }
    }
  }
  stockItem {
    isSold
    resolved {
      title
      size
      condition
      sku
    }
    orderline {
      order {
        orderDate
      }
      discountedPrice
    }
  }
}
    `;
export const TradeInExportItemsFragmentDoc = gql`
    fragment TradeInExportItems on TradeIn {
  _id
  tradeInNr
  dateTime
  shopId
  shop {
    name
  }
  registered
  shippingCarrierId
  label {
    deliveryStatus
    qrUrl
  }
  shippingCarrier {
    name
  }
  items {
    ...TradeInExportItemItem
  }
  consumer {
    _id
    name
    mail
    phone
    phoneE164
  }
  vouchers {
    value
    currency
  }
}
    ${TradeInExportItemItemFragmentDoc}`;
export const LogisticsPartnerListFieldsFragmentDoc = gql`
    fragment LogisticsPartnerListFields on LogisticsPartner {
  _id
  name
  city
  country
  mail
  phone
}
    `;
export const LogisticsPartnerFieldsFragmentDoc = gql`
    fragment LogisticsPartnerFields on LogisticsPartner {
  ...LogisticsPartnerListFields
  attention
  address
  address2
  zipCode
  countryCode
  apiKey
  apiSecret
}
    ${LogisticsPartnerListFieldsFragmentDoc}`;
export const NfcFragmentDoc = gql`
    fragment NFCFragment on NFC {
  identifier
  stockItem {
    _id
    shop {
      _id
      name
      brandHouseId
    }
    itemNr
  }
  brandItem {
    _id
    brandHouse {
      _id
      name
    }
    itemNr
  }
}
    `;
export const MasterDataFragmentDoc = gql`
    fragment MasterData on BrandSetting {
  _id
  masterDataConsolidate {
    enabled
    field
    lastUpdate
    enableLanguageDetect
    colorStrategy
    colorIdentifier
    secondaryColorStrategy
    secondaryColorIdentifier
    tertiaryColorStrategy
    tertiaryColorIdentifier
    variantIdFromSkuRegExp
    autoMerge
    autoMergeFromTs
    autoMergeGroupId
  }
  masterDataRemoveBg
  masterDataRemoveBgVersion
  masterDataUseProductImages
  useBrandItems
}
    `;
export const OptionSetDataFragmentDoc = gql`
    fragment OptionSetDataFragment on OptionSet {
  _id
  externalId
  refId
  title
  target
  active
  key
  valueType
  values {
    _id
    refId
    optionSetId
    value
    label
    sortorder
    deleted
    createdAt
    updatedAt
    customData
    externalId
    localizations {
      value
      locale
    }
  }
}
    `;
export const ContactPersonFragmentDoc = gql`
    fragment ContactPersonFragment on BrandSetting {
  _id
  contactPerson
  contactPersonEmail
}
    `;
export const BrandHouseShopFragmentDoc = gql`
    fragment BrandHouseShop on Shop {
  _id
  externalId
  name
  currency
  live
  frontendType
}
    `;
export const SellingPriceSettingsFragmentDoc = gql`
    fragment SellingPriceSettingsFragment on BrandSetting {
  _id
  sellPrice {
    condition
    pct
  }
  sellPriceAdvanced {
    value
    type
    sellPrice {
      condition
      pct
    }
  }
  disableRRPListPrice
}
    `;
export const SettingsStockItemFragmentDoc = gql`
    fragment SettingsStockItemFragment on BrandSettingStockItemConfig {
  titlePrefix
  titleSeperator
  titleAdvanced
  appendSeperator
  appendColor
  appendSize
  descriptionSuffix
  descriptionSuffixLocalized {
    locale
    value
  }
  currencies {
    currency
    active
  }
  template
  autoData {
    target
    operator
    tag
    search
  }
  extraMeta {
    key
    value
    type
    auto
    namespace
  }
  extraTags {
    active
    tag
  }
  imageAltText
  imageAltTextLocalized {
    locale
    value
  }
  originalImageAltText
  originalImageAltTextLocalized {
    locale
    value
  }
  vendor
  imageSorting
  overrides {
    productType
    vendor
  }
  skuStrategy
  colorStrategy
  imageRotate
  masterImageCount
  masterImageTypes
  itemRules {
    message
    expression
  }
  itemRuleColor
  itemRuleSize
  itemRuleOther
  itemRulePrice
  itemRuleImages
  requireReview
  queueDuplicates
  replacements {
    locales
    search
    replace
  }
}
    `;
export const LanguagesFragmentDoc = gql`
    fragment LanguagesFragment on BrandSetting {
  _id
  masterDataLocale
  fallbackLocale
  locales {
    locale
    activeItems
    activeTradeIn
  }
}
    `;
export const KlaviyoFragmentDoc = gql`
    fragment klaviyo on IntegrationInstance {
  _id
}
    `;
export const BrickMailFragmentDoc = gql`
    fragment BrickMailFragment on BrickMailMails {
  language
  mail
  htmlMail {
    from {
      name
      mail
    }
    subject
    html
  }
  mailType
}
    `;
export const MailFragmentDoc = gql`
    fragment MailFragment on BrickMail {
  _id
  type
  mails {
    mailType
    mail
    language
  }
  active
}
    `;
export const OrderSettingsFragmentDoc = gql`
    fragment OrderSettingsFragment on BrandSettingOrder {
  refundAdjustment {
    adjust {
      currency
      value
    }
    reason
    oncePerOrder
  }
  deliveryNote
  gbEori
  vatRate
  externalWms
  externalWarehouse
  returnMaxDays
}
    `;
export const CircularFragmentDoc = gql`
    fragment CircularFragment on BrandSetting {
  _id
  circular {
    _id
    activationDate
    payoutTypes {
      _id
      payoutId
      type
      ratio
      active
      name
    }
  }
}
    `;
export const VoucherSettingsFragmentDoc = gql`
    fragment VoucherSettingsFragment on BrandSetting {
  _id
  voucher {
    prefix
    expireDays
    minimumPurchase
    minimumPurchaseExt {
      minimumPurchase
      valueMax
    }
    refundApproval
    newVoucherUsage
    maximumValue
  }
}
    `;
export const AnalyticsFragmentDoc = gql`
    fragment AnalyticsFragment on BrandSetting {
  _id
  tradeIn2Analytics {
    ga4Property
    uaProperty
  }
}
    `;
export const TypographyFragmentDoc = gql`
    fragment Typography on TradeInLayoutH1 {
  fontSize
  fontFamily
  fontWeight
  textColor
  uppercase
}
    `;
export const ButtonFragmentDoc = gql`
    fragment Button on TradeInLayoutMainPanelMainButton {
  textColor
  buttonColor
  disabledTextColor
  disabledButtonColor
  hoverTextColor
  hoverButtonColor
  fontFamily
  fontSize
  fontWeight
  border
}
    `;
export const PanelFragmentDoc = gql`
    fragment PanelFragment on TradeInLayoutMainPanel {
  backgroundColor
  textColor
  mainButton {
    ...Button
  }
  secondaryButton {
    ...Button
  }
}
    ${ButtonFragmentDoc}`;
export const UploadPhotoFragmentDoc = gql`
    fragment UploadPhoto on TradeInLayoutWidgetsUploadPhoto {
  border
  disabledBorder
  color
  disabledColor
}
    `;
export const ReturnItemFragmentDoc = gql`
    fragment ReturnItem on TradeInLayoutWidgetsReturnItem {
  textColor
  backgroundColor
  fontSize
  fontFamily
  fontWeight
  border
  scale
}
    `;
export const TradeInLayoutFragmentDoc = gql`
    fragment TradeInLayout on TradeInLayout {
  fontFamily
  h1 {
    ...Typography
  }
  h2 {
    ...Typography
  }
  text {
    ...Typography
  }
  subtext {
    ...Typography
  }
  mainPanel {
    ...PanelFragment
  }
  contrastPanel {
    ...PanelFragment
  }
  frontPanel {
    ...PanelFragment
  }
  widgets {
    accessBoxBorder
    actionItemBorderColor
    categoryBorderColor
    categoryRadius
    categoryIconSize
    categoryIconPadding
    selectionColor
    selectionTextColor
    cartBackgroundColor
    cartTextColor
    borderRadius
    addItemButton {
      ...Button
    }
    addItemButtonBlank {
      ...Button
    }
    addItemIconHide
    addItemIconColor
    addItemIconColorBlank
    stepperBorderWidth
    continueButton {
      ...Button
    }
    uploadPhoto {
      ...UploadPhoto
    }
    returnItem {
      ...ReturnItem
    }
  }
  disableIcons
  additionalCss
}
    ${TypographyFragmentDoc}
${PanelFragmentDoc}
${ButtonFragmentDoc}
${UploadPhotoFragmentDoc}
${ReturnItemFragmentDoc}`;
export const TradeInCountriesFragmentDoc = gql`
    fragment TradeInCountriesFragment on BrandSetting {
  _id
  countries {
    DK {
      currency
      enabled
      vat
    }
    DE {
      currency
      enabled
      vat
    }
    AT {
      currency
      enabled
      vat
    }
    NL {
      vat
      enabled
      currency
    }
    SE {
      currency
      enabled
      vat
    }
    BE {
      currency
      enabled
      vat
    }
    IE {
      currency
      enabled
      vat
    }
    FR {
      currency
      enabled
      vat
    }
    ES {
      currency
      enabled
      vat
    }
    RO {
      currency
      enabled
      vat
    }
    PL {
      enabled
      currency
      vat
    }
    SI {
      enabled
      currency
      vat
    }
    SK {
      enabled
      currency
      vat
    }
    GB {
      enabled
      currency
      vat
    }
    CZ {
      currency
      enabled
      vat
    }
    IT {
      currency
      enabled
      vat
    }
    FI {
      currency
      enabled
      vat
    }
    HU {
      currency
      enabled
      vat
    }
    PT {
      currency
      enabled
      vat
    }
    LT {
      currency
      enabled
      vat
    }
    LV {
      currency
      enabled
      vat
    }
    EE {
      currency
      enabled
      vat
    }
    HR {
      currency
      enabled
      vat
    }
    BG {
      currency
      enabled
      vat
    }
    CY {
      currency
      enabled
      vat
    }
    MT {
      currency
      enabled
      vat
    }
    LU {
      currency
      enabled
      vat
    }
    GR {
      currency
      enabled
      vat
    }
    NO {
      currency
      enabled
      vat
    }
  }
}
    `;
export const BrandSettingsFragmentDoc = gql`
    fragment BrandSettingsFragment on BrandSetting {
  _id
  consumer {
    lockEmail
    authMethods
  }
  defaultProductImage
  tradeIn2InvalidEmailExp
  tradeInProductSearch
  tradeInProductSearchMask
  tradeInProductSearchGroupId
  tradeInProductSearchImagesOnly
  tradeInPayoutEnabled
  tradeInPayoutPct
  tradeInHideLanguageSelector
  tradeInComments
  digitalPassportActive
  tradeInPointsRate
  tradeInPointsEnabled
  tradeInVoucherDeduction
  tradeInLoginWithoutData
  shopCurrency
}
    `;
export const OrderExportLine2FragmentDoc = gql`
    fragment OrderExportLine2 on Order2Item {
  _id
  salesPricePreTax(currency: $currency)
  returned
  returnedReason
  item {
    brandItem {
      itemNr
      resolved {
        itemSku
        nameLocalized {
          value
          locale
        }
      }
      tradeInItem {
        value(currency: $currency)
      }
    }
  }
}
    `;
export const OrderLinesExportFragmentDoc = gql`
    fragment OrderLinesExport on Order2 {
  _id
  orderDate
  orderName
  lines {
    ...OrderExportLine2
  }
}
    ${OrderExportLine2FragmentDoc}`;
export const OrderExportLineFragmentDoc = gql`
    fragment OrderExportLine on Order2Item {
  _id
  salesPricePreTax(currency: $currency)
  returned
  returnedReason
  item {
    brandItem {
      itemNr
      resolved {
        itemSku
        nameLocalized {
          value
          locale
        }
      }
      tradeInItem {
        value(currency: $currency)
      }
    }
  }
}
    `;
export const OrderExportFragmentDoc = gql`
    fragment OrderExport on Order2 {
  _id
  shopId
  orderDate
  orderName
  consumerEmail
  lines {
    ...OrderExportLine
  }
}
    ${OrderExportLineFragmentDoc}`;
export const OrderFragmentDoc = gql`
    fragment OrderFragment on Order2 {
  _id
  consumer {
    name
    mail
    phone
  }
  shopId
  shop {
    brandHouseId
    name
  }
  orderDate
  orderUrl
  orderName
  lines {
    _id
    returned
    cancelled
    discountedPrice
    stockItem {
      imageUrls
    }
  }
  payState
  orderState
  fulState
  trackingOrderState
  trackingReturnState
  proforma
}
    `;
export const ViewProductVariantFragmentDoc = gql`
    fragment ViewProductVariantFragment on ProductVariant {
  _id
  productId
  shopId
  product {
    name
    tags
    productType
    isPreOwned
    description
  }
  imageUrls
  color
  sku
  ean
  batchSerial
  rrp {
    value
    currency
  }
  sizes {
    _id
    size
    ean
    sku
  }
}
    `;
export const ProductListProductFragmentDoc = gql`
    fragment ProductListProductFragment on Product {
  _id
  name
  style
  productType
  productVendor
  images
}
    `;
export const FlexStockItemFragmentDoc = gql`
    fragment FlexStockItem on StockItemResolved {
  _id
  shopId
  brandItemId
  shop {
    _id
    externalName
  }
  itemNr
  itemSku
  tradeInItemId
  title
  description
  createdAt
  condition
  productType
  imageUrls
  images {
    process
    imageId
    imageUrl
  }
  sellingPrice
  beforePrice
  sku
  ean
  originalEan
  color
  size
  published
  draft
  review
  checked
  effectiveChecked
  effectiveMissing
  stockLocation
  stockLocationTs
  isSold
  queued
  isInSeason
  note
  hasErrors
  dataErrors
  hasProblems
  itemNrBroken
}
    `;
export const DtcEditBrandFragmentDoc = gql`
    fragment DTCEditBrandFragment on Shop {
  _id
  brandHouseId
  name
  tradeInBaseUrl
  currency
  conditions {
    condition
    name
    description
  }
  settings {
    stockItemConfig {
      titlePrefix
    }
    digitalPassportActive
  }
}
    `;
export const DtcEditBrandRuleFragmentDoc = gql`
    fragment DTCEditBrandRuleFragment on BrandRule {
  _id
  shopId
  active
  periodFrom
  periodTo
  priority
  products {
    ids
    tags
    collections
  }
  minimumPrice
  minimumPriceType
  minimumAge
  maximumAge
  marketingDelay
  voucherStrategy
  voucherValue
  tradeInPricePct
  tradeInSearchPct
  secondhandTradeInPct
  secondhandVoucherValue
  digitalPassportPct
  digitalPassportValue
  voucherAmounts {
    _id
    tag
    value
    active
    expressions {
      key
      operation
      value
      valueType
    }
  }
  tradeInSearchAmounts {
    _id
    tag
    value
    active
    expressions {
      key
      operation
      value
      valueType
    }
  }
  expressions {
    key
    operation
    value
    valueType
  }
}
    `;
export const DtcShopFragmentDoc = gql`
    fragment DTCShopFragment on Shop {
  _id
  brandHouseId
  name
  tradeInBaseUrl
  currency
  conditions {
    condition
    name
    description
  }
  settings {
    klaviyoConfig {
      enabled
    }
  }
}
    `;
export const BrandRuleFragmentCreateFragmentDoc = gql`
    fragment BrandRuleFragmentCreate on BrandRule {
  _id
  shopId
  active
  periodFrom
  periodTo
  priority
  products {
    ids
    tags
    collections
  }
  tradeInPricePct
  minimumPrice
  minimumAge
  maximumAge
  marketingDelay
  voucherStrategy
  voucherValue
}
    `;
export const DtcFragmentDoc = gql`
    fragment DTCFragment on Potential {
  _id
  externUrl
  externDate
  name
  sku
  color
  size
  ean
  rrp
  sp
  shop {
    currency
  }
  productVariantId
  status(brandRuleId: $brandRuleId, live: false) {
    message
    type
    date
  }
  offer(brandRuleId: $brandRuleId, live: false) {
    value
    currency
    activation
    notifyDate
  }
  consumerId
  consumer {
    _id
    firstName
    lastName
    mail
    disableContact
    accountType
  }
  wholeSale {
    categoryId
    name
    value
  }
}
    `;
export const OrderPageOrderLineFragmentDoc = gql`
    fragment OrderPageOrderLine on Order2Item {
  _id
  externalLineId
  returned
  cancelled
  fulfilled
  salesPrice
  discountedPrice
  currency
  item {
    _id
    sku
    itemSku
    ean
    originalEan
    title
    imageUrls
    itemNr
    color
    size
    sellingPrice
    stockLocation
    brandItemId
    brandItem {
      _id
      unavailable
    }
  }
}
    `;
export const OrderAddressFragmentDoc = gql`
    fragment OrderAddress on Order2ShippingAddress {
  name
  company
  add1
  add2
  zipCode
  city
  countryCode
  country
  phone
  mail
}
    `;
export const OrderPageFragmentDoc = gql`
    fragment OrderPageFragment on Order2 {
  _id
  externalId
  orderName
  comment
  consumer {
    id
    name
    add1
    add2
    zipCode
    city
    phone
    country
    mail
    language
  }
  orderDate
  orderUrl
  lines {
    ...OrderPageOrderLine
  }
  fulState
  payState
  orderState
  updatedAt
  notified
  notifiedConsumer
  exportedToWMS
  trackingInfo {
    number
    carrier
  }
  trackingUrl
  returnInfo {
    carrier
    number
  }
  shippingAddress {
    ...OrderAddress
  }
  shippingAddressInternal {
    ...OrderAddress
  }
  returnLabelUrl
  returnDeadline
  freeReturn
  silenced
  currency
  proforma
  proformaInvoiceCommission
  proformaInvoicePickPack
  proformaInvoiceShipping
  deliveryNoteUrl
}
    ${OrderPageOrderLineFragmentDoc}
${OrderAddressFragmentDoc}`;
export const ReasonOptionFragmentDoc = gql`
    fragment ReasonOptionFragment on OptionSet {
  _id
  key
  title
  valueType
  values {
    _id
    value
    label
  }
}
    `;
export const AddressFragmentDoc = gql`
    fragment AddressFragment on AddressInfo {
  name
  attention
  add1
  add2
  zipCode
  city
  countryCode
  phone
  mail
  refId
  refType
}
    `;
export const ParcelFragmentDoc = gql`
    fragment ParcelFragment on Parcel {
  _id
  comment
  parcelDate
  shopId
  items {
    refId
    refType
  }
  receiver {
    ...AddressFragment
  }
  sender {
    ...AddressFragment
  }
  shippingLabel {
    deliveryStatus
    packageCode
    sender {
      ...AddressFragment
    }
    receiver {
      ...AddressFragment
    }
  }
  shippingCarrier {
    _id
    name
  }
}
    ${AddressFragmentDoc}`;
export const StockItemFragmentDoc = gql`
    fragment StockItemFragment on StockItem {
  _id
  externId
  brandItemId
  tradeInItemId
  itemNr
  itemSku
  title
  titleLocalized {
    locale
    value
  }
  description
  descriptionLocalized {
    locale
    value
  }
  productType
  vendor
  imageIds
  imageUrls
  originalEan
  ean
  sku
  size
  color
  colorLocalized {
    locale
    value
  }
  beforePrice
  sellingPrice
  condition
  active
  draft
  published
  review
  itemStatus
  note
  nfcTag
  externUrl
  stockLocation
  checked
  missing
  effectiveMissing
  itemTags {
    tag
    auto
  }
  problems {
    _id
    solved
    description
    createdAt
  }
  hasErrors
  dataErrors
  tradeInItem {
    tradeInId
    tradeIn {
      consumerId
      consumer {
        name
      }
      vouchers {
        value
      }
    }
    value
  }
  shopId
  shop {
    currency
    productTags
    locales
    productTypes
  }
  itemAge
  createdAt
  orderlines {
    _id
    salesPrice
    returnedTs
    order {
      _id
      orderName
      orderDate
    }
  }
  resolved {
    brandItemId
    title
  }
  sourceType
}
    `;
export const StockItemMultiFragmentDoc = gql`
    fragment StockItemMultiFragment on StockItem {
  _id
  itemNr
  imageUrls
  condition
  title
  description
  size
  color
  beforePrice
  sellingPrice
  productType
  sku
  originalEan
  vendor
  productVariantId
  reviewed
}
    `;
export const WholeSaleEditCategoryExpressionFragmentDoc = gql`
    fragment WholeSaleEditCategoryExpressionFragment on WholeSaleCategoryRulesExpressions {
  _id
  operator
  expressionType
  sku
  col
  tag
}
    `;
export const WholeSaleEditCategoryRuleFragmentDoc = gql`
    fragment WholeSaleEditCategoryRuleFragment on WholeSaleCategoryRules {
  _id
  name
  active
  value
  expressions {
    ...WholeSaleEditCategoryExpressionFragment
  }
}
    ${WholeSaleEditCategoryExpressionFragmentDoc}`;
export const WholeSaleCategoryFragmentDoc = gql`
    fragment WholeSaleCategoryFragment on WholeSaleCategory {
  _id
  shopId
  iconId
  name
  nameLocalized {
    value
    locale
  }
  section
  sectionLocalized {
    value
    locale
  }
  advanced
  value
  voucherStrategy
  rules {
    ...WholeSaleEditCategoryRuleFragment
  }
  sortOrder
}
    ${WholeSaleEditCategoryRuleFragmentDoc}`;
export const WholeSaleProductFragmentDoc = gql`
    fragment WholeSaleProductFragment on WholeSaleProduct {
  _id
  name
  variants {
    sku
    images
  }
}
    `;
export const UserLoginDocument = gql`
    mutation UserLogin($email: String!, $password: String!) {
  UserLogin(email: $email, password: $password) {
    token
    userType
    simplified
  }
}
    `;
export type UserLoginMutationFn = Apollo.MutationFunction<UserLoginMutation, UserLoginMutationVariables>;

/**
 * __useUserLoginMutation__
 *
 * To run a mutation, you first call `useUserLoginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserLoginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userLoginMutation, { data, loading, error }] = useUserLoginMutation({
 *   variables: {
 *      email: // value for 'email'
 *      password: // value for 'password'
 *   },
 * });
 */
export function useUserLoginMutation(baseOptions?: Apollo.MutationHookOptions<UserLoginMutation, UserLoginMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UserLoginMutation, UserLoginMutationVariables>(UserLoginDocument, options);
      }
export type UserLoginMutationHookResult = ReturnType<typeof useUserLoginMutation>;
export type UserLoginMutationResult = Apollo.MutationResult<UserLoginMutation>;
export type UserLoginMutationOptions = Apollo.BaseMutationOptions<UserLoginMutation, UserLoginMutationVariables>;
export const SystemMessagesForNotificationDocument = gql`
    query systemMessagesForNotification($filter: FilterFindManySystemMessageInput, $limit: Int) {
  SystemMessages(filter: $filter, limit: $limit) {
    _id
    subject
    entries {
      timestamp
      text
    }
    audience
    audienceBrandId
    acknowledgedTs
    messageType
    timestamp
    lastActivityTs
  }
}
    `;

/**
 * __useSystemMessagesForNotificationQuery__
 *
 * To run a query within a React component, call `useSystemMessagesForNotificationQuery` and pass it any options that fit your needs.
 * When your component renders, `useSystemMessagesForNotificationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSystemMessagesForNotificationQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useSystemMessagesForNotificationQuery(baseOptions?: Apollo.QueryHookOptions<SystemMessagesForNotificationQuery, SystemMessagesForNotificationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SystemMessagesForNotificationQuery, SystemMessagesForNotificationQueryVariables>(SystemMessagesForNotificationDocument, options);
      }
export function useSystemMessagesForNotificationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SystemMessagesForNotificationQuery, SystemMessagesForNotificationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SystemMessagesForNotificationQuery, SystemMessagesForNotificationQueryVariables>(SystemMessagesForNotificationDocument, options);
        }
export type SystemMessagesForNotificationQueryHookResult = ReturnType<typeof useSystemMessagesForNotificationQuery>;
export type SystemMessagesForNotificationLazyQueryHookResult = ReturnType<typeof useSystemMessagesForNotificationLazyQuery>;
export type SystemMessagesForNotificationQueryResult = Apollo.QueryResult<SystemMessagesForNotificationQuery, SystemMessagesForNotificationQueryVariables>;
export const SystemMessageNotificationAcknowledgeDocument = gql`
    mutation systemMessageNotificationAcknowledge($filter: FilterUpdateOneSystemMessageInput!, $record: UpdateOneSystemMessageInput!) {
  SystemMessageAcknowledge(filter: $filter, record: $record) {
    record {
      _id
      acknowledgedTs
    }
  }
}
    `;
export type SystemMessageNotificationAcknowledgeMutationFn = Apollo.MutationFunction<SystemMessageNotificationAcknowledgeMutation, SystemMessageNotificationAcknowledgeMutationVariables>;

/**
 * __useSystemMessageNotificationAcknowledgeMutation__
 *
 * To run a mutation, you first call `useSystemMessageNotificationAcknowledgeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSystemMessageNotificationAcknowledgeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [systemMessageNotificationAcknowledgeMutation, { data, loading, error }] = useSystemMessageNotificationAcknowledgeMutation({
 *   variables: {
 *      filter: // value for 'filter'
 *      record: // value for 'record'
 *   },
 * });
 */
export function useSystemMessageNotificationAcknowledgeMutation(baseOptions?: Apollo.MutationHookOptions<SystemMessageNotificationAcknowledgeMutation, SystemMessageNotificationAcknowledgeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SystemMessageNotificationAcknowledgeMutation, SystemMessageNotificationAcknowledgeMutationVariables>(SystemMessageNotificationAcknowledgeDocument, options);
      }
export type SystemMessageNotificationAcknowledgeMutationHookResult = ReturnType<typeof useSystemMessageNotificationAcknowledgeMutation>;
export type SystemMessageNotificationAcknowledgeMutationResult = Apollo.MutationResult<SystemMessageNotificationAcknowledgeMutation>;
export type SystemMessageNotificationAcknowledgeMutationOptions = Apollo.BaseMutationOptions<SystemMessageNotificationAcknowledgeMutation, SystemMessageNotificationAcknowledgeMutationVariables>;
export const DataViewColumnsDocument = gql`
    query DataViewColumns($viewId: MongoID!) {
  DataView(_id: $viewId) {
    _id
    type
    expiresAt
    viewName
    rowIds
    metadata
  }
}
    `;

/**
 * __useDataViewColumnsQuery__
 *
 * To run a query within a React component, call `useDataViewColumnsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDataViewColumnsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDataViewColumnsQuery({
 *   variables: {
 *      viewId: // value for 'viewId'
 *   },
 * });
 */
export function useDataViewColumnsQuery(baseOptions: Apollo.QueryHookOptions<DataViewColumnsQuery, DataViewColumnsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DataViewColumnsQuery, DataViewColumnsQueryVariables>(DataViewColumnsDocument, options);
      }
export function useDataViewColumnsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DataViewColumnsQuery, DataViewColumnsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DataViewColumnsQuery, DataViewColumnsQueryVariables>(DataViewColumnsDocument, options);
        }
export type DataViewColumnsQueryHookResult = ReturnType<typeof useDataViewColumnsQuery>;
export type DataViewColumnsLazyQueryHookResult = ReturnType<typeof useDataViewColumnsLazyQuery>;
export type DataViewColumnsQueryResult = Apollo.QueryResult<DataViewColumnsQuery, DataViewColumnsQueryVariables>;
export const NavigationDataDocument = gql`
    query NavigationData {
  CurrentUser {
    _id
    administrator
  }
  BrandHouses {
    _id
    name
    deactivated
    requireChangeExplanation
    shops {
      _id
      name
      disabled
      live
    }
    settings {
      useBrandItems
    }
  }
  LogisticsPartners {
    _id
    name
  }
}
    `;

/**
 * __useNavigationDataQuery__
 *
 * To run a query within a React component, call `useNavigationDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useNavigationDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNavigationDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useNavigationDataQuery(baseOptions?: Apollo.QueryHookOptions<NavigationDataQuery, NavigationDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NavigationDataQuery, NavigationDataQueryVariables>(NavigationDataDocument, options);
      }
export function useNavigationDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NavigationDataQuery, NavigationDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NavigationDataQuery, NavigationDataQueryVariables>(NavigationDataDocument, options);
        }
export type NavigationDataQueryHookResult = ReturnType<typeof useNavigationDataQuery>;
export type NavigationDataLazyQueryHookResult = ReturnType<typeof useNavigationDataLazyQuery>;
export type NavigationDataQueryResult = Apollo.QueryResult<NavigationDataQuery, NavigationDataQueryVariables>;
export const ResetPasswordSendDocument = gql`
    mutation ResetPasswordSend($email: String!) {
  UserRecoverPassword(email: $email)
}
    `;
export type ResetPasswordSendMutationFn = Apollo.MutationFunction<ResetPasswordSendMutation, ResetPasswordSendMutationVariables>;

/**
 * __useResetPasswordSendMutation__
 *
 * To run a mutation, you first call `useResetPasswordSendMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetPasswordSendMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetPasswordSendMutation, { data, loading, error }] = useResetPasswordSendMutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useResetPasswordSendMutation(baseOptions?: Apollo.MutationHookOptions<ResetPasswordSendMutation, ResetPasswordSendMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResetPasswordSendMutation, ResetPasswordSendMutationVariables>(ResetPasswordSendDocument, options);
      }
export type ResetPasswordSendMutationHookResult = ReturnType<typeof useResetPasswordSendMutation>;
export type ResetPasswordSendMutationResult = Apollo.MutationResult<ResetPasswordSendMutation>;
export type ResetPasswordSendMutationOptions = Apollo.BaseMutationOptions<ResetPasswordSendMutation, ResetPasswordSendMutationVariables>;
export const InviteJoinVerifyTokenDocument = gql`
    query InviteJoinVerifyToken($token: String!) {
  UserVerifyResetToken(token: $token)
}
    `;

/**
 * __useInviteJoinVerifyTokenQuery__
 *
 * To run a query within a React component, call `useInviteJoinVerifyTokenQuery` and pass it any options that fit your needs.
 * When your component renders, `useInviteJoinVerifyTokenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInviteJoinVerifyTokenQuery({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useInviteJoinVerifyTokenQuery(baseOptions: Apollo.QueryHookOptions<InviteJoinVerifyTokenQuery, InviteJoinVerifyTokenQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InviteJoinVerifyTokenQuery, InviteJoinVerifyTokenQueryVariables>(InviteJoinVerifyTokenDocument, options);
      }
export function useInviteJoinVerifyTokenLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InviteJoinVerifyTokenQuery, InviteJoinVerifyTokenQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InviteJoinVerifyTokenQuery, InviteJoinVerifyTokenQueryVariables>(InviteJoinVerifyTokenDocument, options);
        }
export type InviteJoinVerifyTokenQueryHookResult = ReturnType<typeof useInviteJoinVerifyTokenQuery>;
export type InviteJoinVerifyTokenLazyQueryHookResult = ReturnType<typeof useInviteJoinVerifyTokenLazyQuery>;
export type InviteJoinVerifyTokenQueryResult = Apollo.QueryResult<InviteJoinVerifyTokenQuery, InviteJoinVerifyTokenQueryVariables>;
export const InviteJoinVerifyPasswordDocument = gql`
    query InviteJoinVerifyPassword($password: String!) {
  UserVerifyPassword(password: $password) {
    id
    value
  }
}
    `;

/**
 * __useInviteJoinVerifyPasswordQuery__
 *
 * To run a query within a React component, call `useInviteJoinVerifyPasswordQuery` and pass it any options that fit your needs.
 * When your component renders, `useInviteJoinVerifyPasswordQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInviteJoinVerifyPasswordQuery({
 *   variables: {
 *      password: // value for 'password'
 *   },
 * });
 */
export function useInviteJoinVerifyPasswordQuery(baseOptions: Apollo.QueryHookOptions<InviteJoinVerifyPasswordQuery, InviteJoinVerifyPasswordQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InviteJoinVerifyPasswordQuery, InviteJoinVerifyPasswordQueryVariables>(InviteJoinVerifyPasswordDocument, options);
      }
export function useInviteJoinVerifyPasswordLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InviteJoinVerifyPasswordQuery, InviteJoinVerifyPasswordQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InviteJoinVerifyPasswordQuery, InviteJoinVerifyPasswordQueryVariables>(InviteJoinVerifyPasswordDocument, options);
        }
export type InviteJoinVerifyPasswordQueryHookResult = ReturnType<typeof useInviteJoinVerifyPasswordQuery>;
export type InviteJoinVerifyPasswordLazyQueryHookResult = ReturnType<typeof useInviteJoinVerifyPasswordLazyQuery>;
export type InviteJoinVerifyPasswordQueryResult = Apollo.QueryResult<InviteJoinVerifyPasswordQuery, InviteJoinVerifyPasswordQueryVariables>;
export const InviteJoinUpdateDocument = gql`
    mutation InviteJoinUpdate($token: String!, $name: String!, $password: String!) {
  UserInviteJoin(name: $name, resetToken: $token, password: $password) {
    token
    userType
  }
}
    `;
export type InviteJoinUpdateMutationFn = Apollo.MutationFunction<InviteJoinUpdateMutation, InviteJoinUpdateMutationVariables>;

/**
 * __useInviteJoinUpdateMutation__
 *
 * To run a mutation, you first call `useInviteJoinUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInviteJoinUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [inviteJoinUpdateMutation, { data, loading, error }] = useInviteJoinUpdateMutation({
 *   variables: {
 *      token: // value for 'token'
 *      name: // value for 'name'
 *      password: // value for 'password'
 *   },
 * });
 */
export function useInviteJoinUpdateMutation(baseOptions?: Apollo.MutationHookOptions<InviteJoinUpdateMutation, InviteJoinUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InviteJoinUpdateMutation, InviteJoinUpdateMutationVariables>(InviteJoinUpdateDocument, options);
      }
export type InviteJoinUpdateMutationHookResult = ReturnType<typeof useInviteJoinUpdateMutation>;
export type InviteJoinUpdateMutationResult = Apollo.MutationResult<InviteJoinUpdateMutation>;
export type InviteJoinUpdateMutationOptions = Apollo.BaseMutationOptions<InviteJoinUpdateMutation, InviteJoinUpdateMutationVariables>;
export const ResetPasswordVerifyTokenDocument = gql`
    query ResetPasswordVerifyToken($token: String!) {
  UserVerifyResetToken(token: $token)
}
    `;

/**
 * __useResetPasswordVerifyTokenQuery__
 *
 * To run a query within a React component, call `useResetPasswordVerifyTokenQuery` and pass it any options that fit your needs.
 * When your component renders, `useResetPasswordVerifyTokenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useResetPasswordVerifyTokenQuery({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useResetPasswordVerifyTokenQuery(baseOptions: Apollo.QueryHookOptions<ResetPasswordVerifyTokenQuery, ResetPasswordVerifyTokenQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ResetPasswordVerifyTokenQuery, ResetPasswordVerifyTokenQueryVariables>(ResetPasswordVerifyTokenDocument, options);
      }
export function useResetPasswordVerifyTokenLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ResetPasswordVerifyTokenQuery, ResetPasswordVerifyTokenQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ResetPasswordVerifyTokenQuery, ResetPasswordVerifyTokenQueryVariables>(ResetPasswordVerifyTokenDocument, options);
        }
export type ResetPasswordVerifyTokenQueryHookResult = ReturnType<typeof useResetPasswordVerifyTokenQuery>;
export type ResetPasswordVerifyTokenLazyQueryHookResult = ReturnType<typeof useResetPasswordVerifyTokenLazyQuery>;
export type ResetPasswordVerifyTokenQueryResult = Apollo.QueryResult<ResetPasswordVerifyTokenQuery, ResetPasswordVerifyTokenQueryVariables>;
export const ResetPasswordVerifyPasswordDocument = gql`
    query ResetPasswordVerifyPassword($password: String!) {
  UserVerifyPassword(password: $password) {
    id
    value
  }
}
    `;

/**
 * __useResetPasswordVerifyPasswordQuery__
 *
 * To run a query within a React component, call `useResetPasswordVerifyPasswordQuery` and pass it any options that fit your needs.
 * When your component renders, `useResetPasswordVerifyPasswordQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useResetPasswordVerifyPasswordQuery({
 *   variables: {
 *      password: // value for 'password'
 *   },
 * });
 */
export function useResetPasswordVerifyPasswordQuery(baseOptions: Apollo.QueryHookOptions<ResetPasswordVerifyPasswordQuery, ResetPasswordVerifyPasswordQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ResetPasswordVerifyPasswordQuery, ResetPasswordVerifyPasswordQueryVariables>(ResetPasswordVerifyPasswordDocument, options);
      }
export function useResetPasswordVerifyPasswordLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ResetPasswordVerifyPasswordQuery, ResetPasswordVerifyPasswordQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ResetPasswordVerifyPasswordQuery, ResetPasswordVerifyPasswordQueryVariables>(ResetPasswordVerifyPasswordDocument, options);
        }
export type ResetPasswordVerifyPasswordQueryHookResult = ReturnType<typeof useResetPasswordVerifyPasswordQuery>;
export type ResetPasswordVerifyPasswordLazyQueryHookResult = ReturnType<typeof useResetPasswordVerifyPasswordLazyQuery>;
export type ResetPasswordVerifyPasswordQueryResult = Apollo.QueryResult<ResetPasswordVerifyPasswordQuery, ResetPasswordVerifyPasswordQueryVariables>;
export const ResetPasswordUpdateDocument = gql`
    mutation ResetPasswordUpdate($token: String!, $password: String!) {
  UserResetPassword(resetToken: $token, password: $password)
}
    `;
export type ResetPasswordUpdateMutationFn = Apollo.MutationFunction<ResetPasswordUpdateMutation, ResetPasswordUpdateMutationVariables>;

/**
 * __useResetPasswordUpdateMutation__
 *
 * To run a mutation, you first call `useResetPasswordUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetPasswordUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetPasswordUpdateMutation, { data, loading, error }] = useResetPasswordUpdateMutation({
 *   variables: {
 *      token: // value for 'token'
 *      password: // value for 'password'
 *   },
 * });
 */
export function useResetPasswordUpdateMutation(baseOptions?: Apollo.MutationHookOptions<ResetPasswordUpdateMutation, ResetPasswordUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResetPasswordUpdateMutation, ResetPasswordUpdateMutationVariables>(ResetPasswordUpdateDocument, options);
      }
export type ResetPasswordUpdateMutationHookResult = ReturnType<typeof useResetPasswordUpdateMutation>;
export type ResetPasswordUpdateMutationResult = Apollo.MutationResult<ResetPasswordUpdateMutation>;
export type ResetPasswordUpdateMutationOptions = Apollo.BaseMutationOptions<ResetPasswordUpdateMutation, ResetPasswordUpdateMutationVariables>;
export const InviteAcceptPageCurrentUserDocument = gql`
    query InviteAcceptPageCurrentUser {
  CurrentUser {
    _id
    name
    access(all: true) {
      inviteTokenTs
      inviteToken
      brandHouseName
      logisticsPartnerName
      disabled
    }
  }
}
    `;

/**
 * __useInviteAcceptPageCurrentUserQuery__
 *
 * To run a query within a React component, call `useInviteAcceptPageCurrentUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useInviteAcceptPageCurrentUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInviteAcceptPageCurrentUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useInviteAcceptPageCurrentUserQuery(baseOptions?: Apollo.QueryHookOptions<InviteAcceptPageCurrentUserQuery, InviteAcceptPageCurrentUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InviteAcceptPageCurrentUserQuery, InviteAcceptPageCurrentUserQueryVariables>(InviteAcceptPageCurrentUserDocument, options);
      }
export function useInviteAcceptPageCurrentUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InviteAcceptPageCurrentUserQuery, InviteAcceptPageCurrentUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InviteAcceptPageCurrentUserQuery, InviteAcceptPageCurrentUserQueryVariables>(InviteAcceptPageCurrentUserDocument, options);
        }
export type InviteAcceptPageCurrentUserQueryHookResult = ReturnType<typeof useInviteAcceptPageCurrentUserQuery>;
export type InviteAcceptPageCurrentUserLazyQueryHookResult = ReturnType<typeof useInviteAcceptPageCurrentUserLazyQuery>;
export type InviteAcceptPageCurrentUserQueryResult = Apollo.QueryResult<InviteAcceptPageCurrentUserQuery, InviteAcceptPageCurrentUserQueryVariables>;
export const InviteAcceptInviteDocument = gql`
    mutation InviteAcceptInvite($token: String!) {
  UserInviteAccept(inviteToken: $token) {
    _id
  }
}
    `;
export type InviteAcceptInviteMutationFn = Apollo.MutationFunction<InviteAcceptInviteMutation, InviteAcceptInviteMutationVariables>;

/**
 * __useInviteAcceptInviteMutation__
 *
 * To run a mutation, you first call `useInviteAcceptInviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInviteAcceptInviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [inviteAcceptInviteMutation, { data, loading, error }] = useInviteAcceptInviteMutation({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useInviteAcceptInviteMutation(baseOptions?: Apollo.MutationHookOptions<InviteAcceptInviteMutation, InviteAcceptInviteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InviteAcceptInviteMutation, InviteAcceptInviteMutationVariables>(InviteAcceptInviteDocument, options);
      }
export type InviteAcceptInviteMutationHookResult = ReturnType<typeof useInviteAcceptInviteMutation>;
export type InviteAcceptInviteMutationResult = Apollo.MutationResult<InviteAcceptInviteMutation>;
export type InviteAcceptInviteMutationOptions = Apollo.BaseMutationOptions<InviteAcceptInviteMutation, InviteAcceptInviteMutationVariables>;
export const ConnectorEditPageDocument = gql`
    query ConnectorEditPage($connectorId: MongoID!) {
  IntegrationConnector(_id: $connectorId) {
    ...integrationFragment
  }
}
    ${IntegrationFragmentDoc}`;

/**
 * __useConnectorEditPageQuery__
 *
 * To run a query within a React component, call `useConnectorEditPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useConnectorEditPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConnectorEditPageQuery({
 *   variables: {
 *      connectorId: // value for 'connectorId'
 *   },
 * });
 */
export function useConnectorEditPageQuery(baseOptions: Apollo.QueryHookOptions<ConnectorEditPageQuery, ConnectorEditPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ConnectorEditPageQuery, ConnectorEditPageQueryVariables>(ConnectorEditPageDocument, options);
      }
export function useConnectorEditPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ConnectorEditPageQuery, ConnectorEditPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ConnectorEditPageQuery, ConnectorEditPageQueryVariables>(ConnectorEditPageDocument, options);
        }
export type ConnectorEditPageQueryHookResult = ReturnType<typeof useConnectorEditPageQuery>;
export type ConnectorEditPageLazyQueryHookResult = ReturnType<typeof useConnectorEditPageLazyQuery>;
export type ConnectorEditPageQueryResult = Apollo.QueryResult<ConnectorEditPageQuery, ConnectorEditPageQueryVariables>;
export const ConnectorEditPageUpdateDocument = gql`
    mutation ConnectorEditPageUpdate($connectorId: MongoID!, $input: UpdateByIdIntegrationConnectorInput!) {
  IntegrationConnectorUpdate(_id: $connectorId, record: $input) {
    recordId
    record {
      ...integrationFragment
    }
    error {
      message
    }
  }
}
    ${IntegrationFragmentDoc}`;
export type ConnectorEditPageUpdateMutationFn = Apollo.MutationFunction<ConnectorEditPageUpdateMutation, ConnectorEditPageUpdateMutationVariables>;

/**
 * __useConnectorEditPageUpdateMutation__
 *
 * To run a mutation, you first call `useConnectorEditPageUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConnectorEditPageUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [connectorEditPageUpdateMutation, { data, loading, error }] = useConnectorEditPageUpdateMutation({
 *   variables: {
 *      connectorId: // value for 'connectorId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useConnectorEditPageUpdateMutation(baseOptions?: Apollo.MutationHookOptions<ConnectorEditPageUpdateMutation, ConnectorEditPageUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConnectorEditPageUpdateMutation, ConnectorEditPageUpdateMutationVariables>(ConnectorEditPageUpdateDocument, options);
      }
export type ConnectorEditPageUpdateMutationHookResult = ReturnType<typeof useConnectorEditPageUpdateMutation>;
export type ConnectorEditPageUpdateMutationResult = Apollo.MutationResult<ConnectorEditPageUpdateMutation>;
export type ConnectorEditPageUpdateMutationOptions = Apollo.BaseMutationOptions<ConnectorEditPageUpdateMutation, ConnectorEditPageUpdateMutationVariables>;
export const ConnectorEditPageCreateDocument = gql`
    mutation ConnectorEditPageCreate($input: CreateOneIntegrationConnectorInput!) {
  IntegrationConnectorCreate(record: $input) {
    recordId
    record {
      ...integrationFragment
    }
    error {
      message
    }
  }
}
    ${IntegrationFragmentDoc}`;
export type ConnectorEditPageCreateMutationFn = Apollo.MutationFunction<ConnectorEditPageCreateMutation, ConnectorEditPageCreateMutationVariables>;

/**
 * __useConnectorEditPageCreateMutation__
 *
 * To run a mutation, you first call `useConnectorEditPageCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConnectorEditPageCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [connectorEditPageCreateMutation, { data, loading, error }] = useConnectorEditPageCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useConnectorEditPageCreateMutation(baseOptions?: Apollo.MutationHookOptions<ConnectorEditPageCreateMutation, ConnectorEditPageCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConnectorEditPageCreateMutation, ConnectorEditPageCreateMutationVariables>(ConnectorEditPageCreateDocument, options);
      }
export type ConnectorEditPageCreateMutationHookResult = ReturnType<typeof useConnectorEditPageCreateMutation>;
export type ConnectorEditPageCreateMutationResult = Apollo.MutationResult<ConnectorEditPageCreateMutation>;
export type ConnectorEditPageCreateMutationOptions = Apollo.BaseMutationOptions<ConnectorEditPageCreateMutation, ConnectorEditPageCreateMutationVariables>;
export const ConnectorsPageListDocument = gql`
    query ConnectorsPageList($limit: Int!, $skip: Int!) {
  IntegrationConnectors(limit: $limit, skip: $skip, sort: NAME_ASC) {
    _id
    name
    refTypes
    deleted
    activeFor
    autoInstallFor
    instances {
      refName
    }
    eventbus {
      development {
        serviceBus
        topic
      }
      production {
        topic
        serviceBus
      }
      test {
        serviceBus
        topic
      }
    }
    fields {
      namespace
      field
      description
      type
      options {
        label
        label
      }
      defaultValue
      required
    }
    webhook {
      test {
        url
      }
      production {
        url
      }
      development {
        url
      }
    }
    messages
    optionals
  }
  IntegrationConnectorsCount
}
    `;

/**
 * __useConnectorsPageListQuery__
 *
 * To run a query within a React component, call `useConnectorsPageListQuery` and pass it any options that fit your needs.
 * When your component renders, `useConnectorsPageListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConnectorsPageListQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      skip: // value for 'skip'
 *   },
 * });
 */
export function useConnectorsPageListQuery(baseOptions: Apollo.QueryHookOptions<ConnectorsPageListQuery, ConnectorsPageListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ConnectorsPageListQuery, ConnectorsPageListQueryVariables>(ConnectorsPageListDocument, options);
      }
export function useConnectorsPageListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ConnectorsPageListQuery, ConnectorsPageListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ConnectorsPageListQuery, ConnectorsPageListQueryVariables>(ConnectorsPageListDocument, options);
        }
export type ConnectorsPageListQueryHookResult = ReturnType<typeof useConnectorsPageListQuery>;
export type ConnectorsPageListLazyQueryHookResult = ReturnType<typeof useConnectorsPageListLazyQuery>;
export type ConnectorsPageListQueryResult = Apollo.QueryResult<ConnectorsPageListQuery, ConnectorsPageListQueryVariables>;
export const InstallsPageGetDocument = gql`
    query InstallsPageGet($connectorId: MongoID!) {
  IntegrationInstances(filter: {connectorId: $connectorId}) {
    _id
    refId
    refType
    enabled
    refShop {
      _id
      name
      brandHouseId
    }
    refBrandHouse {
      _id
      name
    }
    refLogisticsPartner {
      _id
      name
    }
    configs {
      message
      enabled
    }
    connector {
      messages
    }
  }
}
    `;

/**
 * __useInstallsPageGetQuery__
 *
 * To run a query within a React component, call `useInstallsPageGetQuery` and pass it any options that fit your needs.
 * When your component renders, `useInstallsPageGetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInstallsPageGetQuery({
 *   variables: {
 *      connectorId: // value for 'connectorId'
 *   },
 * });
 */
export function useInstallsPageGetQuery(baseOptions: Apollo.QueryHookOptions<InstallsPageGetQuery, InstallsPageGetQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InstallsPageGetQuery, InstallsPageGetQueryVariables>(InstallsPageGetDocument, options);
      }
export function useInstallsPageGetLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InstallsPageGetQuery, InstallsPageGetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InstallsPageGetQuery, InstallsPageGetQueryVariables>(InstallsPageGetDocument, options);
        }
export type InstallsPageGetQueryHookResult = ReturnType<typeof useInstallsPageGetQuery>;
export type InstallsPageGetLazyQueryHookResult = ReturnType<typeof useInstallsPageGetLazyQuery>;
export type InstallsPageGetQueryResult = Apollo.QueryResult<InstallsPageGetQuery, InstallsPageGetQueryVariables>;
export const InstallsPageReInitDocument = gql`
    mutation InstallsPageReInit($instanceId: MongoID!) {
  IntegrationReInitialize(instanceId: $instanceId) {
    _id
  }
}
    `;
export type InstallsPageReInitMutationFn = Apollo.MutationFunction<InstallsPageReInitMutation, InstallsPageReInitMutationVariables>;

/**
 * __useInstallsPageReInitMutation__
 *
 * To run a mutation, you first call `useInstallsPageReInitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInstallsPageReInitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [installsPageReInitMutation, { data, loading, error }] = useInstallsPageReInitMutation({
 *   variables: {
 *      instanceId: // value for 'instanceId'
 *   },
 * });
 */
export function useInstallsPageReInitMutation(baseOptions?: Apollo.MutationHookOptions<InstallsPageReInitMutation, InstallsPageReInitMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InstallsPageReInitMutation, InstallsPageReInitMutationVariables>(InstallsPageReInitDocument, options);
      }
export type InstallsPageReInitMutationHookResult = ReturnType<typeof useInstallsPageReInitMutation>;
export type InstallsPageReInitMutationResult = Apollo.MutationResult<InstallsPageReInitMutation>;
export type InstallsPageReInitMutationOptions = Apollo.BaseMutationOptions<InstallsPageReInitMutation, InstallsPageReInitMutationVariables>;
export const MessageDetailPageGetDocument = gql`
    query MessageDetailPageGet($messageId: MongoID!) {
  IntegrationMessageById(_id: $messageId) {
    ...IntegrationMessageFragment
  }
}
    ${IntegrationMessageFragmentDoc}`;

/**
 * __useMessageDetailPageGetQuery__
 *
 * To run a query within a React component, call `useMessageDetailPageGetQuery` and pass it any options that fit your needs.
 * When your component renders, `useMessageDetailPageGetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMessageDetailPageGetQuery({
 *   variables: {
 *      messageId: // value for 'messageId'
 *   },
 * });
 */
export function useMessageDetailPageGetQuery(baseOptions: Apollo.QueryHookOptions<MessageDetailPageGetQuery, MessageDetailPageGetQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MessageDetailPageGetQuery, MessageDetailPageGetQueryVariables>(MessageDetailPageGetDocument, options);
      }
export function useMessageDetailPageGetLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MessageDetailPageGetQuery, MessageDetailPageGetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MessageDetailPageGetQuery, MessageDetailPageGetQueryVariables>(MessageDetailPageGetDocument, options);
        }
export type MessageDetailPageGetQueryHookResult = ReturnType<typeof useMessageDetailPageGetQuery>;
export type MessageDetailPageGetLazyQueryHookResult = ReturnType<typeof useMessageDetailPageGetLazyQuery>;
export type MessageDetailPageGetQueryResult = Apollo.QueryResult<MessageDetailPageGetQuery, MessageDetailPageGetQueryVariables>;
export const MessageChainNodeDocument = gql`
    query MessageChainNode($messageId: MongoID!) {
  IntegrationMessageById(_id: $messageId) {
    ...IntegrationMessageChainFragment
  }
}
    ${IntegrationMessageChainFragmentDoc}`;

/**
 * __useMessageChainNodeQuery__
 *
 * To run a query within a React component, call `useMessageChainNodeQuery` and pass it any options that fit your needs.
 * When your component renders, `useMessageChainNodeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMessageChainNodeQuery({
 *   variables: {
 *      messageId: // value for 'messageId'
 *   },
 * });
 */
export function useMessageChainNodeQuery(baseOptions: Apollo.QueryHookOptions<MessageChainNodeQuery, MessageChainNodeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MessageChainNodeQuery, MessageChainNodeQueryVariables>(MessageChainNodeDocument, options);
      }
export function useMessageChainNodeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MessageChainNodeQuery, MessageChainNodeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MessageChainNodeQuery, MessageChainNodeQueryVariables>(MessageChainNodeDocument, options);
        }
export type MessageChainNodeQueryHookResult = ReturnType<typeof useMessageChainNodeQuery>;
export type MessageChainNodeLazyQueryHookResult = ReturnType<typeof useMessageChainNodeLazyQuery>;
export type MessageChainNodeQueryResult = Apollo.QueryResult<MessageChainNodeQuery, MessageChainNodeQueryVariables>;
export const MessageChainChildrenDocument = gql`
    query MessageChainChildren($parentId: MongoID!) {
  IntegrationMessages(filter: {parentId: $parentId}, sort: _ID_ASC, perPage: 20) {
    items {
      ...IntegrationMessageChainFragment
    }
  }
}
    ${IntegrationMessageChainFragmentDoc}`;

/**
 * __useMessageChainChildrenQuery__
 *
 * To run a query within a React component, call `useMessageChainChildrenQuery` and pass it any options that fit your needs.
 * When your component renders, `useMessageChainChildrenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMessageChainChildrenQuery({
 *   variables: {
 *      parentId: // value for 'parentId'
 *   },
 * });
 */
export function useMessageChainChildrenQuery(baseOptions: Apollo.QueryHookOptions<MessageChainChildrenQuery, MessageChainChildrenQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MessageChainChildrenQuery, MessageChainChildrenQueryVariables>(MessageChainChildrenDocument, options);
      }
export function useMessageChainChildrenLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MessageChainChildrenQuery, MessageChainChildrenQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MessageChainChildrenQuery, MessageChainChildrenQueryVariables>(MessageChainChildrenDocument, options);
        }
export type MessageChainChildrenQueryHookResult = ReturnType<typeof useMessageChainChildrenQuery>;
export type MessageChainChildrenLazyQueryHookResult = ReturnType<typeof useMessageChainChildrenLazyQuery>;
export type MessageChainChildrenQueryResult = Apollo.QueryResult<MessageChainChildrenQuery, MessageChainChildrenQueryVariables>;
export const RerunMessageDocument = gql`
    mutation rerunMessage($messageId: MongoID!) {
  IntegrationMessageRerun(messageId: $messageId) {
    _id
    parentId
    message
    instanceId
    created
  }
}
    `;
export type RerunMessageMutationFn = Apollo.MutationFunction<RerunMessageMutation, RerunMessageMutationVariables>;

/**
 * __useRerunMessageMutation__
 *
 * To run a mutation, you first call `useRerunMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRerunMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rerunMessageMutation, { data, loading, error }] = useRerunMessageMutation({
 *   variables: {
 *      messageId: // value for 'messageId'
 *   },
 * });
 */
export function useRerunMessageMutation(baseOptions?: Apollo.MutationHookOptions<RerunMessageMutation, RerunMessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RerunMessageMutation, RerunMessageMutationVariables>(RerunMessageDocument, options);
      }
export type RerunMessageMutationHookResult = ReturnType<typeof useRerunMessageMutation>;
export type RerunMessageMutationResult = Apollo.MutationResult<RerunMessageMutation>;
export type RerunMessageMutationOptions = Apollo.BaseMutationOptions<RerunMessageMutation, RerunMessageMutationVariables>;
export const IntegrationConnectorsDocument = gql`
    query IntegrationConnectors {
  IntegrationInstances(limit: 1000, sort: REFID_ASC) {
    _id
    refName
    connector {
      name
    }
  }
}
    `;

/**
 * __useIntegrationConnectorsQuery__
 *
 * To run a query within a React component, call `useIntegrationConnectorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useIntegrationConnectorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIntegrationConnectorsQuery({
 *   variables: {
 *   },
 * });
 */
export function useIntegrationConnectorsQuery(baseOptions?: Apollo.QueryHookOptions<IntegrationConnectorsQuery, IntegrationConnectorsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IntegrationConnectorsQuery, IntegrationConnectorsQueryVariables>(IntegrationConnectorsDocument, options);
      }
export function useIntegrationConnectorsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IntegrationConnectorsQuery, IntegrationConnectorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IntegrationConnectorsQuery, IntegrationConnectorsQueryVariables>(IntegrationConnectorsDocument, options);
        }
export type IntegrationConnectorsQueryHookResult = ReturnType<typeof useIntegrationConnectorsQuery>;
export type IntegrationConnectorsLazyQueryHookResult = ReturnType<typeof useIntegrationConnectorsLazyQuery>;
export type IntegrationConnectorsQueryResult = Apollo.QueryResult<IntegrationConnectorsQuery, IntegrationConnectorsQueryVariables>;
export const IntegrationMessagesManyDocument = gql`
    query IntegrationMessagesMany($search: String, $filter: FilterFindManyIntegrationMessageInput, $sort: SortFindManyIntegrationMessageInput, $page: Int, $perPage: Int) {
  IntegrationMessages(
    search: $search
    filter: $filter
    sort: $sort
    page: $page
    perPage: $perPage
  ) {
    count
    items {
      ...IntegrationListFragment
    }
  }
}
    ${IntegrationListFragmentDoc}`;

/**
 * __useIntegrationMessagesManyQuery__
 *
 * To run a query within a React component, call `useIntegrationMessagesManyQuery` and pass it any options that fit your needs.
 * When your component renders, `useIntegrationMessagesManyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIntegrationMessagesManyQuery({
 *   variables: {
 *      search: // value for 'search'
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *   },
 * });
 */
export function useIntegrationMessagesManyQuery(baseOptions?: Apollo.QueryHookOptions<IntegrationMessagesManyQuery, IntegrationMessagesManyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IntegrationMessagesManyQuery, IntegrationMessagesManyQueryVariables>(IntegrationMessagesManyDocument, options);
      }
export function useIntegrationMessagesManyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IntegrationMessagesManyQuery, IntegrationMessagesManyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IntegrationMessagesManyQuery, IntegrationMessagesManyQueryVariables>(IntegrationMessagesManyDocument, options);
        }
export type IntegrationMessagesManyQueryHookResult = ReturnType<typeof useIntegrationMessagesManyQuery>;
export type IntegrationMessagesManyLazyQueryHookResult = ReturnType<typeof useIntegrationMessagesManyLazyQuery>;
export type IntegrationMessagesManyQueryResult = Apollo.QueryResult<IntegrationMessagesManyQuery, IntegrationMessagesManyQueryVariables>;
export const MessagesPageInstanceDocument = gql`
    query MessagesPageInstance($instanceId: MongoID!) {
  IntegrationInstance(_id: $instanceId) {
    _id
    name
  }
}
    `;

/**
 * __useMessagesPageInstanceQuery__
 *
 * To run a query within a React component, call `useMessagesPageInstanceQuery` and pass it any options that fit your needs.
 * When your component renders, `useMessagesPageInstanceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMessagesPageInstanceQuery({
 *   variables: {
 *      instanceId: // value for 'instanceId'
 *   },
 * });
 */
export function useMessagesPageInstanceQuery(baseOptions: Apollo.QueryHookOptions<MessagesPageInstanceQuery, MessagesPageInstanceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MessagesPageInstanceQuery, MessagesPageInstanceQueryVariables>(MessagesPageInstanceDocument, options);
      }
export function useMessagesPageInstanceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MessagesPageInstanceQuery, MessagesPageInstanceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MessagesPageInstanceQuery, MessagesPageInstanceQueryVariables>(MessagesPageInstanceDocument, options);
        }
export type MessagesPageInstanceQueryHookResult = ReturnType<typeof useMessagesPageInstanceQuery>;
export type MessagesPageInstanceLazyQueryHookResult = ReturnType<typeof useMessagesPageInstanceLazyQuery>;
export type MessagesPageInstanceQueryResult = Apollo.QueryResult<MessagesPageInstanceQuery, MessagesPageInstanceQueryVariables>;
export const SystemMessagesDocument = gql`
    query systemMessages($filter: FilterFindManySystemMessageInput, $sort: SortFindManySystemMessageInput, $limit: Int) {
  SystemMessages(filter: $filter, sort: $sort, limit: $limit) {
    _id
    subject
    entries {
      timestamp
      text
    }
    messageType
    audience
    audienceBrandId
    timestamp
    lastActivityTs
    acknowledgedTs
  }
}
    `;

/**
 * __useSystemMessagesQuery__
 *
 * To run a query within a React component, call `useSystemMessagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSystemMessagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSystemMessagesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useSystemMessagesQuery(baseOptions?: Apollo.QueryHookOptions<SystemMessagesQuery, SystemMessagesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SystemMessagesQuery, SystemMessagesQueryVariables>(SystemMessagesDocument, options);
      }
export function useSystemMessagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SystemMessagesQuery, SystemMessagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SystemMessagesQuery, SystemMessagesQueryVariables>(SystemMessagesDocument, options);
        }
export type SystemMessagesQueryHookResult = ReturnType<typeof useSystemMessagesQuery>;
export type SystemMessagesLazyQueryHookResult = ReturnType<typeof useSystemMessagesLazyQuery>;
export type SystemMessagesQueryResult = Apollo.QueryResult<SystemMessagesQuery, SystemMessagesQueryVariables>;
export const SystemMessageAcknowledgeDocument = gql`
    mutation systemMessageAcknowledge($filter: FilterUpdateOneSystemMessageInput!, $record: UpdateOneSystemMessageInput!) {
  SystemMessageAcknowledge(filter: $filter, record: $record) {
    record {
      _id
      subject
      entries {
        timestamp
        text
      }
      messageType
      audience
      audienceBrandId
      timestamp
      lastActivityTs
      acknowledgedTs
    }
  }
}
    `;
export type SystemMessageAcknowledgeMutationFn = Apollo.MutationFunction<SystemMessageAcknowledgeMutation, SystemMessageAcknowledgeMutationVariables>;

/**
 * __useSystemMessageAcknowledgeMutation__
 *
 * To run a mutation, you first call `useSystemMessageAcknowledgeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSystemMessageAcknowledgeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [systemMessageAcknowledgeMutation, { data, loading, error }] = useSystemMessageAcknowledgeMutation({
 *   variables: {
 *      filter: // value for 'filter'
 *      record: // value for 'record'
 *   },
 * });
 */
export function useSystemMessageAcknowledgeMutation(baseOptions?: Apollo.MutationHookOptions<SystemMessageAcknowledgeMutation, SystemMessageAcknowledgeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SystemMessageAcknowledgeMutation, SystemMessageAcknowledgeMutationVariables>(SystemMessageAcknowledgeDocument, options);
      }
export type SystemMessageAcknowledgeMutationHookResult = ReturnType<typeof useSystemMessageAcknowledgeMutation>;
export type SystemMessageAcknowledgeMutationResult = Apollo.MutationResult<SystemMessageAcknowledgeMutation>;
export type SystemMessageAcknowledgeMutationOptions = Apollo.BaseMutationOptions<SystemMessageAcknowledgeMutation, SystemMessageAcknowledgeMutationVariables>;
export const AuditChangesDocument = gql`
    query AuditChanges {
  PatchPagination(sort: _ID_DESC, perPage: 100, page: 1) {
    count
    items {
      ...ObjectPatchFragment
    }
    pageInfo {
      hasNextPage
    }
  }
}
    ${ObjectPatchFragmentDoc}`;

/**
 * __useAuditChangesQuery__
 *
 * To run a query within a React component, call `useAuditChangesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAuditChangesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAuditChangesQuery({
 *   variables: {
 *   },
 * });
 */
export function useAuditChangesQuery(baseOptions?: Apollo.QueryHookOptions<AuditChangesQuery, AuditChangesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AuditChangesQuery, AuditChangesQueryVariables>(AuditChangesDocument, options);
      }
export function useAuditChangesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AuditChangesQuery, AuditChangesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AuditChangesQuery, AuditChangesQueryVariables>(AuditChangesDocument, options);
        }
export type AuditChangesQueryHookResult = ReturnType<typeof useAuditChangesQuery>;
export type AuditChangesLazyQueryHookResult = ReturnType<typeof useAuditChangesLazyQuery>;
export type AuditChangesQueryResult = Apollo.QueryResult<AuditChangesQuery, AuditChangesQueryVariables>;
export const BrandItemImagesRequireAuditDocument = gql`
    query BrandItemImagesRequireAudit {
  BrandItemImagesRequireAudit {
    _id
    brandItemId
    brandHouseId
    uploadUrl
    imageUrl
    requireAudit
    sortOrder
  }
}
    `;

/**
 * __useBrandItemImagesRequireAuditQuery__
 *
 * To run a query within a React component, call `useBrandItemImagesRequireAuditQuery` and pass it any options that fit your needs.
 * When your component renders, `useBrandItemImagesRequireAuditQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBrandItemImagesRequireAuditQuery({
 *   variables: {
 *   },
 * });
 */
export function useBrandItemImagesRequireAuditQuery(baseOptions?: Apollo.QueryHookOptions<BrandItemImagesRequireAuditQuery, BrandItemImagesRequireAuditQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BrandItemImagesRequireAuditQuery, BrandItemImagesRequireAuditQueryVariables>(BrandItemImagesRequireAuditDocument, options);
      }
export function useBrandItemImagesRequireAuditLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BrandItemImagesRequireAuditQuery, BrandItemImagesRequireAuditQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BrandItemImagesRequireAuditQuery, BrandItemImagesRequireAuditQueryVariables>(BrandItemImagesRequireAuditDocument, options);
        }
export type BrandItemImagesRequireAuditQueryHookResult = ReturnType<typeof useBrandItemImagesRequireAuditQuery>;
export type BrandItemImagesRequireAuditLazyQueryHookResult = ReturnType<typeof useBrandItemImagesRequireAuditLazyQuery>;
export type BrandItemImagesRequireAuditQueryResult = Apollo.QueryResult<BrandItemImagesRequireAuditQuery, BrandItemImagesRequireAuditQueryVariables>;
export const ApproveImageAuditDocument = gql`
    mutation ApproveImageAudit($brandItemImageId: MongoID!) {
  ApproveImageAudit(brandItemImageId: $brandItemImageId) {
    _id
    brandItemId
    brandHouseId
    uploadUrl
    imageUrl
    requireAudit
    sortOrder
  }
}
    `;
export type ApproveImageAuditMutationFn = Apollo.MutationFunction<ApproveImageAuditMutation, ApproveImageAuditMutationVariables>;

/**
 * __useApproveImageAuditMutation__
 *
 * To run a mutation, you first call `useApproveImageAuditMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApproveImageAuditMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approveImageAuditMutation, { data, loading, error }] = useApproveImageAuditMutation({
 *   variables: {
 *      brandItemImageId: // value for 'brandItemImageId'
 *   },
 * });
 */
export function useApproveImageAuditMutation(baseOptions?: Apollo.MutationHookOptions<ApproveImageAuditMutation, ApproveImageAuditMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApproveImageAuditMutation, ApproveImageAuditMutationVariables>(ApproveImageAuditDocument, options);
      }
export type ApproveImageAuditMutationHookResult = ReturnType<typeof useApproveImageAuditMutation>;
export type ApproveImageAuditMutationResult = Apollo.MutationResult<ApproveImageAuditMutation>;
export type ApproveImageAuditMutationOptions = Apollo.BaseMutationOptions<ApproveImageAuditMutation, ApproveImageAuditMutationVariables>;
export const RejectImageAuditDocument = gql`
    mutation RejectImageAudit($brandItemImageId: MongoID!, $uploadId: MongoID) {
  RejectImageAudit(brandItemImageId: $brandItemImageId, uploadId: $uploadId) {
    _id
    brandItemId
    brandHouseId
    uploadUrl
    imageUrl
    requireAudit
    sortOrder
  }
}
    `;
export type RejectImageAuditMutationFn = Apollo.MutationFunction<RejectImageAuditMutation, RejectImageAuditMutationVariables>;

/**
 * __useRejectImageAuditMutation__
 *
 * To run a mutation, you first call `useRejectImageAuditMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRejectImageAuditMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rejectImageAuditMutation, { data, loading, error }] = useRejectImageAuditMutation({
 *   variables: {
 *      brandItemImageId: // value for 'brandItemImageId'
 *      uploadId: // value for 'uploadId'
 *   },
 * });
 */
export function useRejectImageAuditMutation(baseOptions?: Apollo.MutationHookOptions<RejectImageAuditMutation, RejectImageAuditMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RejectImageAuditMutation, RejectImageAuditMutationVariables>(RejectImageAuditDocument, options);
      }
export type RejectImageAuditMutationHookResult = ReturnType<typeof useRejectImageAuditMutation>;
export type RejectImageAuditMutationResult = Apollo.MutationResult<RejectImageAuditMutation>;
export type RejectImageAuditMutationOptions = Apollo.BaseMutationOptions<RejectImageAuditMutation, RejectImageAuditMutationVariables>;
export const RejectImageAuditRetakeDocument = gql`
    mutation RejectImageAuditRetake($brandItemImageId: MongoID!) {
  RejectImageAuditRetake(brandItemImageId: $brandItemImageId) {
    _id
    brandItemId
    brandHouseId
    uploadUrl
    imageUrl
    requireAudit
    sortOrder
  }
}
    `;
export type RejectImageAuditRetakeMutationFn = Apollo.MutationFunction<RejectImageAuditRetakeMutation, RejectImageAuditRetakeMutationVariables>;

/**
 * __useRejectImageAuditRetakeMutation__
 *
 * To run a mutation, you first call `useRejectImageAuditRetakeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRejectImageAuditRetakeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rejectImageAuditRetakeMutation, { data, loading, error }] = useRejectImageAuditRetakeMutation({
 *   variables: {
 *      brandItemImageId: // value for 'brandItemImageId'
 *   },
 * });
 */
export function useRejectImageAuditRetakeMutation(baseOptions?: Apollo.MutationHookOptions<RejectImageAuditRetakeMutation, RejectImageAuditRetakeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RejectImageAuditRetakeMutation, RejectImageAuditRetakeMutationVariables>(RejectImageAuditRetakeDocument, options);
      }
export type RejectImageAuditRetakeMutationHookResult = ReturnType<typeof useRejectImageAuditRetakeMutation>;
export type RejectImageAuditRetakeMutationResult = Apollo.MutationResult<RejectImageAuditRetakeMutation>;
export type RejectImageAuditRetakeMutationOptions = Apollo.BaseMutationOptions<RejectImageAuditRetakeMutation, RejectImageAuditRetakeMutationVariables>;
export const HideImageAuditDocument = gql`
    mutation HideImageAudit($brandItemImageId: MongoID!) {
  HideImageAudit(brandItemImageId: $brandItemImageId) {
    _id
    brandItemId
    brandHouseId
    uploadUrl
    imageUrl
    requireAudit
    sortOrder
  }
}
    `;
export type HideImageAuditMutationFn = Apollo.MutationFunction<HideImageAuditMutation, HideImageAuditMutationVariables>;

/**
 * __useHideImageAuditMutation__
 *
 * To run a mutation, you first call `useHideImageAuditMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useHideImageAuditMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [hideImageAuditMutation, { data, loading, error }] = useHideImageAuditMutation({
 *   variables: {
 *      brandItemImageId: // value for 'brandItemImageId'
 *   },
 * });
 */
export function useHideImageAuditMutation(baseOptions?: Apollo.MutationHookOptions<HideImageAuditMutation, HideImageAuditMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<HideImageAuditMutation, HideImageAuditMutationVariables>(HideImageAuditDocument, options);
      }
export type HideImageAuditMutationHookResult = ReturnType<typeof useHideImageAuditMutation>;
export type HideImageAuditMutationResult = Apollo.MutationResult<HideImageAuditMutation>;
export type HideImageAuditMutationOptions = Apollo.BaseMutationOptions<HideImageAuditMutation, HideImageAuditMutationVariables>;
export const BrandItemImageClearRemoveBgResultDocument = gql`
    mutation BrandItemImageClearRemoveBgResult($brandItemImageId: MongoID!) {
  BrandItemImageClearRemoveBgResult(brandItemImageId: $brandItemImageId) {
    _id
    brandItemId
    brandHouseId
    uploadUrl
    imageUrl
    requireAudit
    sortOrder
  }
}
    `;
export type BrandItemImageClearRemoveBgResultMutationFn = Apollo.MutationFunction<BrandItemImageClearRemoveBgResultMutation, BrandItemImageClearRemoveBgResultMutationVariables>;

/**
 * __useBrandItemImageClearRemoveBgResultMutation__
 *
 * To run a mutation, you first call `useBrandItemImageClearRemoveBgResultMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBrandItemImageClearRemoveBgResultMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [brandItemImageClearRemoveBgResultMutation, { data, loading, error }] = useBrandItemImageClearRemoveBgResultMutation({
 *   variables: {
 *      brandItemImageId: // value for 'brandItemImageId'
 *   },
 * });
 */
export function useBrandItemImageClearRemoveBgResultMutation(baseOptions?: Apollo.MutationHookOptions<BrandItemImageClearRemoveBgResultMutation, BrandItemImageClearRemoveBgResultMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BrandItemImageClearRemoveBgResultMutation, BrandItemImageClearRemoveBgResultMutationVariables>(BrandItemImageClearRemoveBgResultDocument, options);
      }
export type BrandItemImageClearRemoveBgResultMutationHookResult = ReturnType<typeof useBrandItemImageClearRemoveBgResultMutation>;
export type BrandItemImageClearRemoveBgResultMutationResult = Apollo.MutationResult<BrandItemImageClearRemoveBgResultMutation>;
export type BrandItemImageClearRemoveBgResultMutationOptions = Apollo.BaseMutationOptions<BrandItemImageClearRemoveBgResultMutation, BrandItemImageClearRemoveBgResultMutationVariables>;
export const MasMigrationRunDocument = gql`
    query MasMigrationRun($id: MongoID!) {
  BrandItemMasterDataMigrationRun(id: $id) {
    _id
    type
    status
    requestedCount
    processedCount
    matchedCount
    reviewCount
    noMatchCount
    migratedCount
    staleCount
    failedCount
    sourcePreviewRunId
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useMasMigrationRunQuery__
 *
 * To run a query within a React component, call `useMasMigrationRunQuery` and pass it any options that fit your needs.
 * When your component renders, `useMasMigrationRunQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMasMigrationRunQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMasMigrationRunQuery(baseOptions: Apollo.QueryHookOptions<MasMigrationRunQuery, MasMigrationRunQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MasMigrationRunQuery, MasMigrationRunQueryVariables>(MasMigrationRunDocument, options);
      }
export function useMasMigrationRunLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MasMigrationRunQuery, MasMigrationRunQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MasMigrationRunQuery, MasMigrationRunQueryVariables>(MasMigrationRunDocument, options);
        }
export type MasMigrationRunQueryHookResult = ReturnType<typeof useMasMigrationRunQuery>;
export type MasMigrationRunLazyQueryHookResult = ReturnType<typeof useMasMigrationRunLazyQuery>;
export type MasMigrationRunQueryResult = Apollo.QueryResult<MasMigrationRunQuery, MasMigrationRunQueryVariables>;
export const MasMigrationItemsDocument = gql`
    query MasMigrationItems($runId: MongoID!) {
  BrandItemMasterDataMigrationItems(runId: $runId) {
    _id
    brandItemId
    brandHouseId
    status
    proposedMasterDataProductId
    proposedMasterDataVariantId
    confidence
    signals {
      type
      result
      weight
      score
      detail
    }
    reasons
    current {
      name
      style
      vendor
      type
      color
      size
      ean
      sku
      externalId
      brandId
    }
    candidate {
      name
      style
      vendor
      type
      color
      size
      ean
      sku
      externalId
      brandId
    }
    error
    processedAt
  }
}
    `;

/**
 * __useMasMigrationItemsQuery__
 *
 * To run a query within a React component, call `useMasMigrationItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMasMigrationItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMasMigrationItemsQuery({
 *   variables: {
 *      runId: // value for 'runId'
 *   },
 * });
 */
export function useMasMigrationItemsQuery(baseOptions: Apollo.QueryHookOptions<MasMigrationItemsQuery, MasMigrationItemsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MasMigrationItemsQuery, MasMigrationItemsQueryVariables>(MasMigrationItemsDocument, options);
      }
export function useMasMigrationItemsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MasMigrationItemsQuery, MasMigrationItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MasMigrationItemsQuery, MasMigrationItemsQueryVariables>(MasMigrationItemsDocument, options);
        }
export type MasMigrationItemsQueryHookResult = ReturnType<typeof useMasMigrationItemsQuery>;
export type MasMigrationItemsLazyQueryHookResult = ReturnType<typeof useMasMigrationItemsLazyQuery>;
export type MasMigrationItemsQueryResult = Apollo.QueryResult<MasMigrationItemsQuery, MasMigrationItemsQueryVariables>;
export const MasMigrationMigrateDocument = gql`
    mutation MasMigrationMigrate($selections: [BrandItemMasterDataMigrationSelectionInput!]!, $sourcePreviewRunId: MongoID) {
  BrandItemsMigrateToMasterDataVariant(
    selections: $selections
    sourcePreviewRunId: $sourcePreviewRunId
  ) {
    _id
    status
    requestedCount
  }
}
    `;
export type MasMigrationMigrateMutationFn = Apollo.MutationFunction<MasMigrationMigrateMutation, MasMigrationMigrateMutationVariables>;

/**
 * __useMasMigrationMigrateMutation__
 *
 * To run a mutation, you first call `useMasMigrationMigrateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMasMigrationMigrateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [masMigrationMigrateMutation, { data, loading, error }] = useMasMigrationMigrateMutation({
 *   variables: {
 *      selections: // value for 'selections'
 *      sourcePreviewRunId: // value for 'sourcePreviewRunId'
 *   },
 * });
 */
export function useMasMigrationMigrateMutation(baseOptions?: Apollo.MutationHookOptions<MasMigrationMigrateMutation, MasMigrationMigrateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MasMigrationMigrateMutation, MasMigrationMigrateMutationVariables>(MasMigrationMigrateDocument, options);
      }
export type MasMigrationMigrateMutationHookResult = ReturnType<typeof useMasMigrationMigrateMutation>;
export type MasMigrationMigrateMutationResult = Apollo.MutationResult<MasMigrationMigrateMutation>;
export type MasMigrationMigrateMutationOptions = Apollo.BaseMutationOptions<MasMigrationMigrateMutation, MasMigrationMigrateMutationVariables>;
export const MasMigrationRePreviewDocument = gql`
    mutation MasMigrationRePreview($brandItemIds: [MongoID!]!) {
  BrandItemsPreviewMasterDataVariantMigration(brandItemIds: $brandItemIds) {
    _id
    status
    requestedCount
  }
}
    `;
export type MasMigrationRePreviewMutationFn = Apollo.MutationFunction<MasMigrationRePreviewMutation, MasMigrationRePreviewMutationVariables>;

/**
 * __useMasMigrationRePreviewMutation__
 *
 * To run a mutation, you first call `useMasMigrationRePreviewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMasMigrationRePreviewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [masMigrationRePreviewMutation, { data, loading, error }] = useMasMigrationRePreviewMutation({
 *   variables: {
 *      brandItemIds: // value for 'brandItemIds'
 *   },
 * });
 */
export function useMasMigrationRePreviewMutation(baseOptions?: Apollo.MutationHookOptions<MasMigrationRePreviewMutation, MasMigrationRePreviewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MasMigrationRePreviewMutation, MasMigrationRePreviewMutationVariables>(MasMigrationRePreviewDocument, options);
      }
export type MasMigrationRePreviewMutationHookResult = ReturnType<typeof useMasMigrationRePreviewMutation>;
export type MasMigrationRePreviewMutationResult = Apollo.MutationResult<MasMigrationRePreviewMutation>;
export type MasMigrationRePreviewMutationOptions = Apollo.BaseMutationOptions<MasMigrationRePreviewMutation, MasMigrationRePreviewMutationVariables>;
export const ShippingBrandsDocument = gql`
    query ShippingBrands {
  BrandHouses {
    _id
    name
  }
}
    `;

/**
 * __useShippingBrandsQuery__
 *
 * To run a query within a React component, call `useShippingBrandsQuery` and pass it any options that fit your needs.
 * When your component renders, `useShippingBrandsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShippingBrandsQuery({
 *   variables: {
 *   },
 * });
 */
export function useShippingBrandsQuery(baseOptions?: Apollo.QueryHookOptions<ShippingBrandsQuery, ShippingBrandsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ShippingBrandsQuery, ShippingBrandsQueryVariables>(ShippingBrandsDocument, options);
      }
export function useShippingBrandsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ShippingBrandsQuery, ShippingBrandsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ShippingBrandsQuery, ShippingBrandsQueryVariables>(ShippingBrandsDocument, options);
        }
export type ShippingBrandsQueryHookResult = ReturnType<typeof useShippingBrandsQuery>;
export type ShippingBrandsLazyQueryHookResult = ReturnType<typeof useShippingBrandsLazyQuery>;
export type ShippingBrandsQueryResult = Apollo.QueryResult<ShippingBrandsQuery, ShippingBrandsQueryVariables>;
export const ShippingCarrierEditDocument = gql`
    query ShippingCarrierEdit($id: MongoID!) {
  ShippingCarrier(id: $id) {
    _id
    logo
    name
    carrier
    carrierId
    description
    externalName
    externalCode
    expression
    activeFor
    localizationKey
    shipmondo {
      ownAgreement
      testMode
      carrier
      carrierSecondary
      carrierCode
      serviceCodes
      customerNumber
      qrX
      qrY
      qrSize
      width
      height
      length
      description
      customs
    }
    carrierGateway {
      apiKey
      inputCarrier
      outputCarrier
      supportQR
    }
    b2ceurope
    customCarrier
  }
}
    `;

/**
 * __useShippingCarrierEditQuery__
 *
 * To run a query within a React component, call `useShippingCarrierEditQuery` and pass it any options that fit your needs.
 * When your component renders, `useShippingCarrierEditQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShippingCarrierEditQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useShippingCarrierEditQuery(baseOptions: Apollo.QueryHookOptions<ShippingCarrierEditQuery, ShippingCarrierEditQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ShippingCarrierEditQuery, ShippingCarrierEditQueryVariables>(ShippingCarrierEditDocument, options);
      }
export function useShippingCarrierEditLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ShippingCarrierEditQuery, ShippingCarrierEditQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ShippingCarrierEditQuery, ShippingCarrierEditQueryVariables>(ShippingCarrierEditDocument, options);
        }
export type ShippingCarrierEditQueryHookResult = ReturnType<typeof useShippingCarrierEditQuery>;
export type ShippingCarrierEditLazyQueryHookResult = ReturnType<typeof useShippingCarrierEditLazyQuery>;
export type ShippingCarrierEditQueryResult = Apollo.QueryResult<ShippingCarrierEditQuery, ShippingCarrierEditQueryVariables>;
export const ShippingCarrierUpdateDocument = gql`
    mutation ShippingCarrierUpdate($id: MongoID!, $input: ShippingCarrierInput!) {
  ShippingCarrierUpdate(id: $id, input: $input) {
    _id
  }
}
    `;
export type ShippingCarrierUpdateMutationFn = Apollo.MutationFunction<ShippingCarrierUpdateMutation, ShippingCarrierUpdateMutationVariables>;

/**
 * __useShippingCarrierUpdateMutation__
 *
 * To run a mutation, you first call `useShippingCarrierUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useShippingCarrierUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [shippingCarrierUpdateMutation, { data, loading, error }] = useShippingCarrierUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useShippingCarrierUpdateMutation(baseOptions?: Apollo.MutationHookOptions<ShippingCarrierUpdateMutation, ShippingCarrierUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ShippingCarrierUpdateMutation, ShippingCarrierUpdateMutationVariables>(ShippingCarrierUpdateDocument, options);
      }
export type ShippingCarrierUpdateMutationHookResult = ReturnType<typeof useShippingCarrierUpdateMutation>;
export type ShippingCarrierUpdateMutationResult = Apollo.MutationResult<ShippingCarrierUpdateMutation>;
export type ShippingCarrierUpdateMutationOptions = Apollo.BaseMutationOptions<ShippingCarrierUpdateMutation, ShippingCarrierUpdateMutationVariables>;
export const ShippingCarriersLpDocument = gql`
    query ShippingCarriersLP {
  ShippingCarriersLP {
    _id
    logo
    name
    description
    expression
    shipmondo {
      ownAgreement
      testMode
      carrier
      carrierCode
      serviceCodes
      customerNumber
      qrX
      qrY
      qrSize
      width
      height
      length
      description
    }
  }
}
    `;

/**
 * __useShippingCarriersLpQuery__
 *
 * To run a query within a React component, call `useShippingCarriersLpQuery` and pass it any options that fit your needs.
 * When your component renders, `useShippingCarriersLpQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShippingCarriersLpQuery({
 *   variables: {
 *   },
 * });
 */
export function useShippingCarriersLpQuery(baseOptions?: Apollo.QueryHookOptions<ShippingCarriersLpQuery, ShippingCarriersLpQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ShippingCarriersLpQuery, ShippingCarriersLpQueryVariables>(ShippingCarriersLpDocument, options);
      }
export function useShippingCarriersLpLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ShippingCarriersLpQuery, ShippingCarriersLpQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ShippingCarriersLpQuery, ShippingCarriersLpQueryVariables>(ShippingCarriersLpDocument, options);
        }
export type ShippingCarriersLpQueryHookResult = ReturnType<typeof useShippingCarriersLpQuery>;
export type ShippingCarriersLpLazyQueryHookResult = ReturnType<typeof useShippingCarriersLpLazyQuery>;
export type ShippingCarriersLpQueryResult = Apollo.QueryResult<ShippingCarriersLpQuery, ShippingCarriersLpQueryVariables>;
export const BrandItemBoostItemsDocument = gql`
    query BrandItemBoostItems($brandItemIds: [MongoID!]) {
  BrandItems(ids: $brandItemIds) {
    ...BrandItemBoostState
    itemNr
    itemState
    discarded
    soldTs
    imageUrls
  }
}
    ${BrandItemBoostStateFragmentDoc}`;

/**
 * __useBrandItemBoostItemsQuery__
 *
 * To run a query within a React component, call `useBrandItemBoostItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBrandItemBoostItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBrandItemBoostItemsQuery({
 *   variables: {
 *      brandItemIds: // value for 'brandItemIds'
 *   },
 * });
 */
export function useBrandItemBoostItemsQuery(baseOptions?: Apollo.QueryHookOptions<BrandItemBoostItemsQuery, BrandItemBoostItemsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BrandItemBoostItemsQuery, BrandItemBoostItemsQueryVariables>(BrandItemBoostItemsDocument, options);
      }
export function useBrandItemBoostItemsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BrandItemBoostItemsQuery, BrandItemBoostItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BrandItemBoostItemsQuery, BrandItemBoostItemsQueryVariables>(BrandItemBoostItemsDocument, options);
        }
export type BrandItemBoostItemsQueryHookResult = ReturnType<typeof useBrandItemBoostItemsQuery>;
export type BrandItemBoostItemsLazyQueryHookResult = ReturnType<typeof useBrandItemBoostItemsLazyQuery>;
export type BrandItemBoostItemsQueryResult = Apollo.QueryResult<BrandItemBoostItemsQuery, BrandItemBoostItemsQueryVariables>;
export const BrandItemBoostSetDocument = gql`
    mutation BrandItemBoostSet($brandItemId: MongoID!, $endTs: Date!, $pricePct: Int, $visibility: Boolean!) {
  BrandItemBoostSet(
    brandItemId: $brandItemId
    endTs: $endTs
    pricePct: $pricePct
    visibility: $visibility
  ) {
    ...BrandItemBoostState
  }
}
    ${BrandItemBoostStateFragmentDoc}`;
export type BrandItemBoostSetMutationFn = Apollo.MutationFunction<BrandItemBoostSetMutation, BrandItemBoostSetMutationVariables>;

/**
 * __useBrandItemBoostSetMutation__
 *
 * To run a mutation, you first call `useBrandItemBoostSetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBrandItemBoostSetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [brandItemBoostSetMutation, { data, loading, error }] = useBrandItemBoostSetMutation({
 *   variables: {
 *      brandItemId: // value for 'brandItemId'
 *      endTs: // value for 'endTs'
 *      pricePct: // value for 'pricePct'
 *      visibility: // value for 'visibility'
 *   },
 * });
 */
export function useBrandItemBoostSetMutation(baseOptions?: Apollo.MutationHookOptions<BrandItemBoostSetMutation, BrandItemBoostSetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BrandItemBoostSetMutation, BrandItemBoostSetMutationVariables>(BrandItemBoostSetDocument, options);
      }
export type BrandItemBoostSetMutationHookResult = ReturnType<typeof useBrandItemBoostSetMutation>;
export type BrandItemBoostSetMutationResult = Apollo.MutationResult<BrandItemBoostSetMutation>;
export type BrandItemBoostSetMutationOptions = Apollo.BaseMutationOptions<BrandItemBoostSetMutation, BrandItemBoostSetMutationVariables>;
export const BrandItemBoostCancelDocument = gql`
    mutation BrandItemBoostCancel($brandItemId: MongoID!) {
  BrandItemBoostCancel(brandItemId: $brandItemId) {
    ...BrandItemBoostState
  }
}
    ${BrandItemBoostStateFragmentDoc}`;
export type BrandItemBoostCancelMutationFn = Apollo.MutationFunction<BrandItemBoostCancelMutation, BrandItemBoostCancelMutationVariables>;

/**
 * __useBrandItemBoostCancelMutation__
 *
 * To run a mutation, you first call `useBrandItemBoostCancelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBrandItemBoostCancelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [brandItemBoostCancelMutation, { data, loading, error }] = useBrandItemBoostCancelMutation({
 *   variables: {
 *      brandItemId: // value for 'brandItemId'
 *   },
 * });
 */
export function useBrandItemBoostCancelMutation(baseOptions?: Apollo.MutationHookOptions<BrandItemBoostCancelMutation, BrandItemBoostCancelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BrandItemBoostCancelMutation, BrandItemBoostCancelMutationVariables>(BrandItemBoostCancelDocument, options);
      }
export type BrandItemBoostCancelMutationHookResult = ReturnType<typeof useBrandItemBoostCancelMutation>;
export type BrandItemBoostCancelMutationResult = Apollo.MutationResult<BrandItemBoostCancelMutation>;
export type BrandItemBoostCancelMutationOptions = Apollo.BaseMutationOptions<BrandItemBoostCancelMutation, BrandItemBoostCancelMutationVariables>;
export const ExportBrandItemsDocument = gql`
    query ExportBrandItems($brandItemIds: [MongoID!], $currency: String!) {
  BrandItems(ids: $brandItemIds) {
    _id
    resolved {
      _id
      itemNr
      itemSku
      note
      condition
      itemState
      missing
      stockLocation
      imageUrls
      createdAt
      nameLocalized {
        value
        locale
      }
      beforePrices {
        value
        currency
      }
      itemEan
      colorLocalized {
        value
        locale
      }
      sizeLocalized {
        value
        locale
      }
      originalEan
      originalSku
      vendor
      typeLocalized {
        value
        locale
      }
      tags
      isSold
      soldTs
      orderline {
        salesPricePreTax(currency: $currency)
      }
      tradeInItem {
        value
        currency
      }
      sourceType
      hasProblems
      hasErrors
      invoiceLine {
        _id
        lineDate
        invoiceId
        invoice {
          _id
          invoiceId
        }
      }
      daysForSale
    }
  }
}
    `;

/**
 * __useExportBrandItemsQuery__
 *
 * To run a query within a React component, call `useExportBrandItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useExportBrandItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExportBrandItemsQuery({
 *   variables: {
 *      brandItemIds: // value for 'brandItemIds'
 *      currency: // value for 'currency'
 *   },
 * });
 */
export function useExportBrandItemsQuery(baseOptions: Apollo.QueryHookOptions<ExportBrandItemsQuery, ExportBrandItemsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExportBrandItemsQuery, ExportBrandItemsQueryVariables>(ExportBrandItemsDocument, options);
      }
export function useExportBrandItemsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExportBrandItemsQuery, ExportBrandItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExportBrandItemsQuery, ExportBrandItemsQueryVariables>(ExportBrandItemsDocument, options);
        }
export type ExportBrandItemsQueryHookResult = ReturnType<typeof useExportBrandItemsQuery>;
export type ExportBrandItemsLazyQueryHookResult = ReturnType<typeof useExportBrandItemsLazyQuery>;
export type ExportBrandItemsQueryResult = Apollo.QueryResult<ExportBrandItemsQuery, ExportBrandItemsQueryVariables>;
export const BrandItemImportSearchDocument = gql`
    query BrandItemImportSearch($search: String, $brandHouseId: MongoID!) {
  BrandProductsPagination(
    search: $search
    filter: {_operators: {brandHouseId: {in: [$brandHouseId]}}}
  ) {
    count
    pageInfo {
      perPage
      currentPage
      hasNextPage
      hasPreviousPage
      itemCount
      pageCount
    }
    items {
      ...BrandItemImportSearchFragment
    }
  }
}
    ${BrandItemImportSearchFragmentDoc}`;

/**
 * __useBrandItemImportSearchQuery__
 *
 * To run a query within a React component, call `useBrandItemImportSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useBrandItemImportSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBrandItemImportSearchQuery({
 *   variables: {
 *      search: // value for 'search'
 *      brandHouseId: // value for 'brandHouseId'
 *   },
 * });
 */
export function useBrandItemImportSearchQuery(baseOptions: Apollo.QueryHookOptions<BrandItemImportSearchQuery, BrandItemImportSearchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BrandItemImportSearchQuery, BrandItemImportSearchQueryVariables>(BrandItemImportSearchDocument, options);
      }
export function useBrandItemImportSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BrandItemImportSearchQuery, BrandItemImportSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BrandItemImportSearchQuery, BrandItemImportSearchQueryVariables>(BrandItemImportSearchDocument, options);
        }
export type BrandItemImportSearchQueryHookResult = ReturnType<typeof useBrandItemImportSearchQuery>;
export type BrandItemImportSearchLazyQueryHookResult = ReturnType<typeof useBrandItemImportSearchLazyQuery>;
export type BrandItemImportSearchQueryResult = Apollo.QueryResult<BrandItemImportSearchQuery, BrandItemImportSearchQueryVariables>;
export const BrandItemLogisticsDocument = gql`
    query BrandItemLogistics($brandItemId: MongoID!) {
  BrandItem(_id: $brandItemId) {
    _id
    brandHouseId
    vas {
      vasId
      vasName
      sortingOrder
      completed
      completedBy
      startDate
      completedDate
      workflowName
      workflowTs
    }
  }
}
    `;

/**
 * __useBrandItemLogisticsQuery__
 *
 * To run a query within a React component, call `useBrandItemLogisticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBrandItemLogisticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBrandItemLogisticsQuery({
 *   variables: {
 *      brandItemId: // value for 'brandItemId'
 *   },
 * });
 */
export function useBrandItemLogisticsQuery(baseOptions: Apollo.QueryHookOptions<BrandItemLogisticsQuery, BrandItemLogisticsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BrandItemLogisticsQuery, BrandItemLogisticsQueryVariables>(BrandItemLogisticsDocument, options);
      }
export function useBrandItemLogisticsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BrandItemLogisticsQuery, BrandItemLogisticsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BrandItemLogisticsQuery, BrandItemLogisticsQueryVariables>(BrandItemLogisticsDocument, options);
        }
export type BrandItemLogisticsQueryHookResult = ReturnType<typeof useBrandItemLogisticsQuery>;
export type BrandItemLogisticsLazyQueryHookResult = ReturnType<typeof useBrandItemLogisticsLazyQuery>;
export type BrandItemLogisticsQueryResult = Apollo.QueryResult<BrandItemLogisticsQuery, BrandItemLogisticsQueryVariables>;
export const BrandItemStatusProblemsDocument = gql`
    query BrandItemStatusProblems($brandItemId: MongoID!, $shopId: MongoID) {
  BrandItemProblems(brandItemId: $brandItemId, shopId: $shopId)
}
    `;

/**
 * __useBrandItemStatusProblemsQuery__
 *
 * To run a query within a React component, call `useBrandItemStatusProblemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBrandItemStatusProblemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBrandItemStatusProblemsQuery({
 *   variables: {
 *      brandItemId: // value for 'brandItemId'
 *      shopId: // value for 'shopId'
 *   },
 * });
 */
export function useBrandItemStatusProblemsQuery(baseOptions: Apollo.QueryHookOptions<BrandItemStatusProblemsQuery, BrandItemStatusProblemsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BrandItemStatusProblemsQuery, BrandItemStatusProblemsQueryVariables>(BrandItemStatusProblemsDocument, options);
      }
export function useBrandItemStatusProblemsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BrandItemStatusProblemsQuery, BrandItemStatusProblemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BrandItemStatusProblemsQuery, BrandItemStatusProblemsQueryVariables>(BrandItemStatusProblemsDocument, options);
        }
export type BrandItemStatusProblemsQueryHookResult = ReturnType<typeof useBrandItemStatusProblemsQuery>;
export type BrandItemStatusProblemsLazyQueryHookResult = ReturnType<typeof useBrandItemStatusProblemsLazyQuery>;
export type BrandItemStatusProblemsQueryResult = Apollo.QueryResult<BrandItemStatusProblemsQuery, BrandItemStatusProblemsQueryVariables>;
export const BrandItemMultiSettingsDocument = gql`
    query BrandItemMultiSettings($brandHouseId: MongoID!) {
  BrandSettings(brandHouseId: $brandHouseId) {
    _id
    locales {
      locale
      activeItems
    }
    stockItemConfig {
      currencies {
        currency
        active
      }
    }
  }
}
    `;

/**
 * __useBrandItemMultiSettingsQuery__
 *
 * To run a query within a React component, call `useBrandItemMultiSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBrandItemMultiSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBrandItemMultiSettingsQuery({
 *   variables: {
 *      brandHouseId: // value for 'brandHouseId'
 *   },
 * });
 */
export function useBrandItemMultiSettingsQuery(baseOptions: Apollo.QueryHookOptions<BrandItemMultiSettingsQuery, BrandItemMultiSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BrandItemMultiSettingsQuery, BrandItemMultiSettingsQueryVariables>(BrandItemMultiSettingsDocument, options);
      }
export function useBrandItemMultiSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BrandItemMultiSettingsQuery, BrandItemMultiSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BrandItemMultiSettingsQuery, BrandItemMultiSettingsQueryVariables>(BrandItemMultiSettingsDocument, options);
        }
export type BrandItemMultiSettingsQueryHookResult = ReturnType<typeof useBrandItemMultiSettingsQuery>;
export type BrandItemMultiSettingsLazyQueryHookResult = ReturnType<typeof useBrandItemMultiSettingsLazyQuery>;
export type BrandItemMultiSettingsQueryResult = Apollo.QueryResult<BrandItemMultiSettingsQuery, BrandItemMultiSettingsQueryVariables>;
export const BrandItemMultiDocument = gql`
    query BrandItemMulti($brandItemIds: [MongoID!]) {
  BrandItems(ids: $brandItemIds) {
    ...BrandItemMultiFragment
    resolved {
      ...BrandItemMultiResolvedFragment
    }
  }
}
    ${BrandItemMultiFragmentDoc}
${BrandItemMultiResolvedFragmentDoc}`;

/**
 * __useBrandItemMultiQuery__
 *
 * To run a query within a React component, call `useBrandItemMultiQuery` and pass it any options that fit your needs.
 * When your component renders, `useBrandItemMultiQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBrandItemMultiQuery({
 *   variables: {
 *      brandItemIds: // value for 'brandItemIds'
 *   },
 * });
 */
export function useBrandItemMultiQuery(baseOptions?: Apollo.QueryHookOptions<BrandItemMultiQuery, BrandItemMultiQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BrandItemMultiQuery, BrandItemMultiQueryVariables>(BrandItemMultiDocument, options);
      }
export function useBrandItemMultiLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BrandItemMultiQuery, BrandItemMultiQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BrandItemMultiQuery, BrandItemMultiQueryVariables>(BrandItemMultiDocument, options);
        }
export type BrandItemMultiQueryHookResult = ReturnType<typeof useBrandItemMultiQuery>;
export type BrandItemMultiLazyQueryHookResult = ReturnType<typeof useBrandItemMultiLazyQuery>;
export type BrandItemMultiQueryResult = Apollo.QueryResult<BrandItemMultiQuery, BrandItemMultiQueryVariables>;
export const BrandItemMultiUpdateDocument = gql`
    mutation BrandItemMultiUpdate($brandHouseId: MongoID!, $input: BrandItemInputInput) {
  BrandItemUpdate(brandHouseId: $brandHouseId, input: $input) {
    ...BrandItemMultiFragment
  }
}
    ${BrandItemMultiFragmentDoc}`;
export type BrandItemMultiUpdateMutationFn = Apollo.MutationFunction<BrandItemMultiUpdateMutation, BrandItemMultiUpdateMutationVariables>;

/**
 * __useBrandItemMultiUpdateMutation__
 *
 * To run a mutation, you first call `useBrandItemMultiUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBrandItemMultiUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [brandItemMultiUpdateMutation, { data, loading, error }] = useBrandItemMultiUpdateMutation({
 *   variables: {
 *      brandHouseId: // value for 'brandHouseId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBrandItemMultiUpdateMutation(baseOptions?: Apollo.MutationHookOptions<BrandItemMultiUpdateMutation, BrandItemMultiUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BrandItemMultiUpdateMutation, BrandItemMultiUpdateMutationVariables>(BrandItemMultiUpdateDocument, options);
      }
export type BrandItemMultiUpdateMutationHookResult = ReturnType<typeof useBrandItemMultiUpdateMutation>;
export type BrandItemMultiUpdateMutationResult = Apollo.MutationResult<BrandItemMultiUpdateMutation>;
export type BrandItemMultiUpdateMutationOptions = Apollo.BaseMutationOptions<BrandItemMultiUpdateMutation, BrandItemMultiUpdateMutationVariables>;
export const BrandItemOrdersDocument = gql`
    query BrandItemOrders($brandItemId: MongoID!) {
  BrandItem(_id: $brandItemId) {
    _id
    resolved {
      nameLocalized {
        value
        locale
      }
    }
    shops {
      _id
      shop {
        _id
        name
      }
      stockItem {
        _id
        orderlines {
          _id
          order {
            _id
            orderName
            orderDate
            orderUrl
            consumer {
              name
              mail
            }
          }
          returned
        }
      }
    }
  }
}
    `;

/**
 * __useBrandItemOrdersQuery__
 *
 * To run a query within a React component, call `useBrandItemOrdersQuery` and pass it any options that fit your needs.
 * When your component renders, `useBrandItemOrdersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBrandItemOrdersQuery({
 *   variables: {
 *      brandItemId: // value for 'brandItemId'
 *   },
 * });
 */
export function useBrandItemOrdersQuery(baseOptions: Apollo.QueryHookOptions<BrandItemOrdersQuery, BrandItemOrdersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BrandItemOrdersQuery, BrandItemOrdersQueryVariables>(BrandItemOrdersDocument, options);
      }
export function useBrandItemOrdersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BrandItemOrdersQuery, BrandItemOrdersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BrandItemOrdersQuery, BrandItemOrdersQueryVariables>(BrandItemOrdersDocument, options);
        }
export type BrandItemOrdersQueryHookResult = ReturnType<typeof useBrandItemOrdersQuery>;
export type BrandItemOrdersLazyQueryHookResult = ReturnType<typeof useBrandItemOrdersLazyQuery>;
export type BrandItemOrdersQueryResult = Apollo.QueryResult<BrandItemOrdersQuery, BrandItemOrdersQueryVariables>;
export const BrandItemPublishItemsDocument = gql`
    query BrandItemPublishItems($brandItemIds: [MongoID!]) {
  BrandItems(ids: $brandItemIds) {
    _id
    shops {
      _id
      shopId
      active
    }
  }
}
    `;

/**
 * __useBrandItemPublishItemsQuery__
 *
 * To run a query within a React component, call `useBrandItemPublishItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBrandItemPublishItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBrandItemPublishItemsQuery({
 *   variables: {
 *      brandItemIds: // value for 'brandItemIds'
 *   },
 * });
 */
export function useBrandItemPublishItemsQuery(baseOptions?: Apollo.QueryHookOptions<BrandItemPublishItemsQuery, BrandItemPublishItemsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BrandItemPublishItemsQuery, BrandItemPublishItemsQueryVariables>(BrandItemPublishItemsDocument, options);
      }
export function useBrandItemPublishItemsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BrandItemPublishItemsQuery, BrandItemPublishItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BrandItemPublishItemsQuery, BrandItemPublishItemsQueryVariables>(BrandItemPublishItemsDocument, options);
        }
export type BrandItemPublishItemsQueryHookResult = ReturnType<typeof useBrandItemPublishItemsQuery>;
export type BrandItemPublishItemsLazyQueryHookResult = ReturnType<typeof useBrandItemPublishItemsLazyQuery>;
export type BrandItemPublishItemsQueryResult = Apollo.QueryResult<BrandItemPublishItemsQuery, BrandItemPublishItemsQueryVariables>;
export const BrandItemsPublishDocument = gql`
    mutation BrandItemsPublish($brandItemIds: [MongoID!]!, $shops: [BrandItemsPublishShopInput!]!) {
  BrandItemsPublish(brandItemIds: $brandItemIds, shops: $shops) {
    requested
    changed
    unchanged
    skipped
  }
}
    `;
export type BrandItemsPublishMutationFn = Apollo.MutationFunction<BrandItemsPublishMutation, BrandItemsPublishMutationVariables>;

/**
 * __useBrandItemsPublishMutation__
 *
 * To run a mutation, you first call `useBrandItemsPublishMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBrandItemsPublishMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [brandItemsPublishMutation, { data, loading, error }] = useBrandItemsPublishMutation({
 *   variables: {
 *      brandItemIds: // value for 'brandItemIds'
 *      shops: // value for 'shops'
 *   },
 * });
 */
export function useBrandItemsPublishMutation(baseOptions?: Apollo.MutationHookOptions<BrandItemsPublishMutation, BrandItemsPublishMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BrandItemsPublishMutation, BrandItemsPublishMutationVariables>(BrandItemsPublishDocument, options);
      }
export type BrandItemsPublishMutationHookResult = ReturnType<typeof useBrandItemsPublishMutation>;
export type BrandItemsPublishMutationResult = Apollo.MutationResult<BrandItemsPublishMutation>;
export type BrandItemsPublishMutationOptions = Apollo.BaseMutationOptions<BrandItemsPublishMutation, BrandItemsPublishMutationVariables>;
export const BrandItemStatusItemDocument = gql`
    query BrandItemStatusItem($brandItemId: MongoID!) {
  BrandItem(_id: $brandItemId) {
    _id
    brandHouseId
    resolved {
      nameLocalized {
        value
        locale
      }
    }
    shops {
      _id
      active
      brandItemId
      shopId
      shop {
        _id
        name
        frontendType
        currency
      }
      stockItem {
        _id
        queued
        sellingPrice
        externId
        externUrl
        itemSku
      }
    }
  }
}
    `;

/**
 * __useBrandItemStatusItemQuery__
 *
 * To run a query within a React component, call `useBrandItemStatusItemQuery` and pass it any options that fit your needs.
 * When your component renders, `useBrandItemStatusItemQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBrandItemStatusItemQuery({
 *   variables: {
 *      brandItemId: // value for 'brandItemId'
 *   },
 * });
 */
export function useBrandItemStatusItemQuery(baseOptions: Apollo.QueryHookOptions<BrandItemStatusItemQuery, BrandItemStatusItemQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BrandItemStatusItemQuery, BrandItemStatusItemQueryVariables>(BrandItemStatusItemDocument, options);
      }
export function useBrandItemStatusItemLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BrandItemStatusItemQuery, BrandItemStatusItemQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BrandItemStatusItemQuery, BrandItemStatusItemQueryVariables>(BrandItemStatusItemDocument, options);
        }
export type BrandItemStatusItemQueryHookResult = ReturnType<typeof useBrandItemStatusItemQuery>;
export type BrandItemStatusItemLazyQueryHookResult = ReturnType<typeof useBrandItemStatusItemLazyQuery>;
export type BrandItemStatusItemQueryResult = Apollo.QueryResult<BrandItemStatusItemQuery, BrandItemStatusItemQueryVariables>;
export const BrandItemStatusPushDocument = gql`
    mutation BrandItemStatusPush($brandItemId: MongoID!, $shopId: MongoID, $active: Boolean!) {
  BrandItemPush(brandItemId: $brandItemId, shopId: $shopId, active: $active) {
    _id
    shopId
    active
  }
}
    `;
export type BrandItemStatusPushMutationFn = Apollo.MutationFunction<BrandItemStatusPushMutation, BrandItemStatusPushMutationVariables>;

/**
 * __useBrandItemStatusPushMutation__
 *
 * To run a mutation, you first call `useBrandItemStatusPushMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBrandItemStatusPushMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [brandItemStatusPushMutation, { data, loading, error }] = useBrandItemStatusPushMutation({
 *   variables: {
 *      brandItemId: // value for 'brandItemId'
 *      shopId: // value for 'shopId'
 *      active: // value for 'active'
 *   },
 * });
 */
export function useBrandItemStatusPushMutation(baseOptions?: Apollo.MutationHookOptions<BrandItemStatusPushMutation, BrandItemStatusPushMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BrandItemStatusPushMutation, BrandItemStatusPushMutationVariables>(BrandItemStatusPushDocument, options);
      }
export type BrandItemStatusPushMutationHookResult = ReturnType<typeof useBrandItemStatusPushMutation>;
export type BrandItemStatusPushMutationResult = Apollo.MutationResult<BrandItemStatusPushMutation>;
export type BrandItemStatusPushMutationOptions = Apollo.BaseMutationOptions<BrandItemStatusPushMutation, BrandItemStatusPushMutationVariables>;
export const BrandItemTrackingShopsDocument = gql`
    query BrandItemTrackingShops($brandItemId: MongoID!) {
  BrandItem(_id: $brandItemId) {
    shops {
      shopId
      stockItemId
    }
  }
}
    `;

/**
 * __useBrandItemTrackingShopsQuery__
 *
 * To run a query within a React component, call `useBrandItemTrackingShopsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBrandItemTrackingShopsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBrandItemTrackingShopsQuery({
 *   variables: {
 *      brandItemId: // value for 'brandItemId'
 *   },
 * });
 */
export function useBrandItemTrackingShopsQuery(baseOptions: Apollo.QueryHookOptions<BrandItemTrackingShopsQuery, BrandItemTrackingShopsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BrandItemTrackingShopsQuery, BrandItemTrackingShopsQueryVariables>(BrandItemTrackingShopsDocument, options);
      }
export function useBrandItemTrackingShopsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BrandItemTrackingShopsQuery, BrandItemTrackingShopsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BrandItemTrackingShopsQuery, BrandItemTrackingShopsQueryVariables>(BrandItemTrackingShopsDocument, options);
        }
export type BrandItemTrackingShopsQueryHookResult = ReturnType<typeof useBrandItemTrackingShopsQuery>;
export type BrandItemTrackingShopsLazyQueryHookResult = ReturnType<typeof useBrandItemTrackingShopsLazyQuery>;
export type BrandItemTrackingShopsQueryResult = Apollo.QueryResult<BrandItemTrackingShopsQuery, BrandItemTrackingShopsQueryVariables>;
export const OrderCreateDocument = gql`
    mutation orderCreate($order: OrderSynchronizeInput!) {
  OrderSynchronize(order: $order, mode: MERGE) {
    _id
  }
}
    `;
export type OrderCreateMutationFn = Apollo.MutationFunction<OrderCreateMutation, OrderCreateMutationVariables>;

/**
 * __useOrderCreateMutation__
 *
 * To run a mutation, you first call `useOrderCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOrderCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [orderCreateMutation, { data, loading, error }] = useOrderCreateMutation({
 *   variables: {
 *      order: // value for 'order'
 *   },
 * });
 */
export function useOrderCreateMutation(baseOptions?: Apollo.MutationHookOptions<OrderCreateMutation, OrderCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OrderCreateMutation, OrderCreateMutationVariables>(OrderCreateDocument, options);
      }
export type OrderCreateMutationHookResult = ReturnType<typeof useOrderCreateMutation>;
export type OrderCreateMutationResult = Apollo.MutationResult<OrderCreateMutation>;
export type OrderCreateMutationOptions = Apollo.BaseMutationOptions<OrderCreateMutation, OrderCreateMutationVariables>;
export const BrandItemsBrandSettingsDocument = gql`
    query BrandItemsBrandSettings($brandHouseId: MongoID) {
  BrandSettings(brandHouseId: $brandHouseId) {
    locales {
      locale
      activeItems
    }
    stockItemConfig {
      currencies {
        active
        currency
      }
    }
    tradeInComments
  }
  BrandHouses(filter: {_operators: {deactivated: {ne: true}}}, sort: NAME_ASC) {
    _id
    name
  }
}
    `;

/**
 * __useBrandItemsBrandSettingsQuery__
 *
 * To run a query within a React component, call `useBrandItemsBrandSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBrandItemsBrandSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBrandItemsBrandSettingsQuery({
 *   variables: {
 *      brandHouseId: // value for 'brandHouseId'
 *   },
 * });
 */
export function useBrandItemsBrandSettingsQuery(baseOptions?: Apollo.QueryHookOptions<BrandItemsBrandSettingsQuery, BrandItemsBrandSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BrandItemsBrandSettingsQuery, BrandItemsBrandSettingsQueryVariables>(BrandItemsBrandSettingsDocument, options);
      }
export function useBrandItemsBrandSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BrandItemsBrandSettingsQuery, BrandItemsBrandSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BrandItemsBrandSettingsQuery, BrandItemsBrandSettingsQueryVariables>(BrandItemsBrandSettingsDocument, options);
        }
export type BrandItemsBrandSettingsQueryHookResult = ReturnType<typeof useBrandItemsBrandSettingsQuery>;
export type BrandItemsBrandSettingsLazyQueryHookResult = ReturnType<typeof useBrandItemsBrandSettingsLazyQuery>;
export type BrandItemsBrandSettingsQueryResult = Apollo.QueryResult<BrandItemsBrandSettingsQuery, BrandItemsBrandSettingsQueryVariables>;
export const BrandItemsListManyDocument = gql`
    query BrandItemsListMany($search: String, $filter: FilterFindManyBrandItemInput, $sort: SortFindManyBrandItemInput, $page: Int, $perPage: Int, $viewId: MongoID) {
  BrandItemPagination(
    search: $search
    filter: $filter
    sort: $sort
    page: $page
    perPage: $perPage
    viewId: $viewId
  ) {
    count
    pageInfo {
      perPage
      currentPage
      hasNextPage
      hasPreviousPage
      itemCount
      pageCount
    }
    items {
      _id
      resolved {
        ...FlexBrandItem
      }
    }
  }
}
    ${FlexBrandItemFragmentDoc}`;

/**
 * __useBrandItemsListManyQuery__
 *
 * To run a query within a React component, call `useBrandItemsListManyQuery` and pass it any options that fit your needs.
 * When your component renders, `useBrandItemsListManyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBrandItemsListManyQuery({
 *   variables: {
 *      search: // value for 'search'
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *      viewId: // value for 'viewId'
 *   },
 * });
 */
export function useBrandItemsListManyQuery(baseOptions?: Apollo.QueryHookOptions<BrandItemsListManyQuery, BrandItemsListManyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BrandItemsListManyQuery, BrandItemsListManyQueryVariables>(BrandItemsListManyDocument, options);
      }
export function useBrandItemsListManyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BrandItemsListManyQuery, BrandItemsListManyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BrandItemsListManyQuery, BrandItemsListManyQueryVariables>(BrandItemsListManyDocument, options);
        }
export type BrandItemsListManyQueryHookResult = ReturnType<typeof useBrandItemsListManyQuery>;
export type BrandItemsListManyLazyQueryHookResult = ReturnType<typeof useBrandItemsListManyLazyQuery>;
export type BrandItemsListManyQueryResult = Apollo.QueryResult<BrandItemsListManyQuery, BrandItemsListManyQueryVariables>;
export const BrandItemsListByIdsDocument = gql`
    query BrandItemsListByIds($ids: [MongoID!]) {
  BrandItems(ids: $ids) {
    _id
    resolved {
      ...FlexBrandItem
    }
  }
}
    ${FlexBrandItemFragmentDoc}`;

/**
 * __useBrandItemsListByIdsQuery__
 *
 * To run a query within a React component, call `useBrandItemsListByIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBrandItemsListByIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBrandItemsListByIdsQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useBrandItemsListByIdsQuery(baseOptions?: Apollo.QueryHookOptions<BrandItemsListByIdsQuery, BrandItemsListByIdsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BrandItemsListByIdsQuery, BrandItemsListByIdsQueryVariables>(BrandItemsListByIdsDocument, options);
      }
export function useBrandItemsListByIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BrandItemsListByIdsQuery, BrandItemsListByIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BrandItemsListByIdsQuery, BrandItemsListByIdsQueryVariables>(BrandItemsListByIdsDocument, options);
        }
export type BrandItemsListByIdsQueryHookResult = ReturnType<typeof useBrandItemsListByIdsQuery>;
export type BrandItemsListByIdsLazyQueryHookResult = ReturnType<typeof useBrandItemsListByIdsLazyQuery>;
export type BrandItemsListByIdsQueryResult = Apollo.QueryResult<BrandItemsListByIdsQuery, BrandItemsListByIdsQueryVariables>;
export const BrandItemsPageShopsDocument = gql`
    query BrandItemsPageShops($brandHouseId: MongoID!) {
  BrandSettings(brandHouseId: $brandHouseId) {
    _id
    useBrandItems
    locales {
      locale
      activeItems
    }
  }
  ShopMany(filter: {brandHouseId: $brandHouseId}) {
    _id
    name
    disabled
    live
    currency
  }
  IntegrationInstances(
    filter: {OR: [{refId: $brandHouseId, refType: BRANDHOUSE}, {refType: LOGISTICSPARTNER}]}
  ) {
    _id
    name
    connector {
      messages
    }
  }
}
    `;

/**
 * __useBrandItemsPageShopsQuery__
 *
 * To run a query within a React component, call `useBrandItemsPageShopsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBrandItemsPageShopsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBrandItemsPageShopsQuery({
 *   variables: {
 *      brandHouseId: // value for 'brandHouseId'
 *   },
 * });
 */
export function useBrandItemsPageShopsQuery(baseOptions: Apollo.QueryHookOptions<BrandItemsPageShopsQuery, BrandItemsPageShopsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BrandItemsPageShopsQuery, BrandItemsPageShopsQueryVariables>(BrandItemsPageShopsDocument, options);
      }
export function useBrandItemsPageShopsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BrandItemsPageShopsQuery, BrandItemsPageShopsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BrandItemsPageShopsQuery, BrandItemsPageShopsQueryVariables>(BrandItemsPageShopsDocument, options);
        }
export type BrandItemsPageShopsQueryHookResult = ReturnType<typeof useBrandItemsPageShopsQuery>;
export type BrandItemsPageShopsLazyQueryHookResult = ReturnType<typeof useBrandItemsPageShopsLazyQuery>;
export type BrandItemsPageShopsQueryResult = Apollo.QueryResult<BrandItemsPageShopsQuery, BrandItemsPageShopsQueryVariables>;
export const BrandItemsUpdateCacheDocument = gql`
    mutation BrandItemsUpdateCache($brandItemId: MongoID!) {
  BrandItemUpdateCache(brandItemId: $brandItemId, silent: false)
}
    `;
export type BrandItemsUpdateCacheMutationFn = Apollo.MutationFunction<BrandItemsUpdateCacheMutation, BrandItemsUpdateCacheMutationVariables>;

/**
 * __useBrandItemsUpdateCacheMutation__
 *
 * To run a mutation, you first call `useBrandItemsUpdateCacheMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBrandItemsUpdateCacheMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [brandItemsUpdateCacheMutation, { data, loading, error }] = useBrandItemsUpdateCacheMutation({
 *   variables: {
 *      brandItemId: // value for 'brandItemId'
 *   },
 * });
 */
export function useBrandItemsUpdateCacheMutation(baseOptions?: Apollo.MutationHookOptions<BrandItemsUpdateCacheMutation, BrandItemsUpdateCacheMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BrandItemsUpdateCacheMutation, BrandItemsUpdateCacheMutationVariables>(BrandItemsUpdateCacheDocument, options);
      }
export type BrandItemsUpdateCacheMutationHookResult = ReturnType<typeof useBrandItemsUpdateCacheMutation>;
export type BrandItemsUpdateCacheMutationResult = Apollo.MutationResult<BrandItemsUpdateCacheMutation>;
export type BrandItemsUpdateCacheMutationOptions = Apollo.BaseMutationOptions<BrandItemsUpdateCacheMutation, BrandItemsUpdateCacheMutationVariables>;
export const BrandItemDeleteDocument = gql`
    mutation BrandItemDelete($brandItemId: MongoID!) {
  BrandItemDelete(brandItemId: $brandItemId) {
    _id
  }
}
    `;
export type BrandItemDeleteMutationFn = Apollo.MutationFunction<BrandItemDeleteMutation, BrandItemDeleteMutationVariables>;

/**
 * __useBrandItemDeleteMutation__
 *
 * To run a mutation, you first call `useBrandItemDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBrandItemDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [brandItemDeleteMutation, { data, loading, error }] = useBrandItemDeleteMutation({
 *   variables: {
 *      brandItemId: // value for 'brandItemId'
 *   },
 * });
 */
export function useBrandItemDeleteMutation(baseOptions?: Apollo.MutationHookOptions<BrandItemDeleteMutation, BrandItemDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BrandItemDeleteMutation, BrandItemDeleteMutationVariables>(BrandItemDeleteDocument, options);
      }
export type BrandItemDeleteMutationHookResult = ReturnType<typeof useBrandItemDeleteMutation>;
export type BrandItemDeleteMutationResult = Apollo.MutationResult<BrandItemDeleteMutation>;
export type BrandItemDeleteMutationOptions = Apollo.BaseMutationOptions<BrandItemDeleteMutation, BrandItemDeleteMutationVariables>;
export const BrandItemRetouchDocument = gql`
    mutation BrandItemRetouch($ids: [MongoID!]!) {
  BrandItemRetouch(brandItemIds: $ids) {
    _id
    imageUrls
    images {
      _id
      imageUrl
    }
  }
}
    `;
export type BrandItemRetouchMutationFn = Apollo.MutationFunction<BrandItemRetouchMutation, BrandItemRetouchMutationVariables>;

/**
 * __useBrandItemRetouchMutation__
 *
 * To run a mutation, you first call `useBrandItemRetouchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBrandItemRetouchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [brandItemRetouchMutation, { data, loading, error }] = useBrandItemRetouchMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useBrandItemRetouchMutation(baseOptions?: Apollo.MutationHookOptions<BrandItemRetouchMutation, BrandItemRetouchMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BrandItemRetouchMutation, BrandItemRetouchMutationVariables>(BrandItemRetouchDocument, options);
      }
export type BrandItemRetouchMutationHookResult = ReturnType<typeof useBrandItemRetouchMutation>;
export type BrandItemRetouchMutationResult = Apollo.MutationResult<BrandItemRetouchMutation>;
export type BrandItemRetouchMutationOptions = Apollo.BaseMutationOptions<BrandItemRetouchMutation, BrandItemRetouchMutationVariables>;
export const BrandItemsPageChangeStateDocument = gql`
    mutation BrandItemsPageChangeState($brandHouseId: MongoID!, $id: MongoID!, $state: BrandItemStateEnum!) {
  BrandItemUpdate(
    input: {_id: $id, itemState: $state}
    brandHouseId: $brandHouseId
    silent: false
  ) {
    _id
    itemState
  }
}
    `;
export type BrandItemsPageChangeStateMutationFn = Apollo.MutationFunction<BrandItemsPageChangeStateMutation, BrandItemsPageChangeStateMutationVariables>;

/**
 * __useBrandItemsPageChangeStateMutation__
 *
 * To run a mutation, you first call `useBrandItemsPageChangeStateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBrandItemsPageChangeStateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [brandItemsPageChangeStateMutation, { data, loading, error }] = useBrandItemsPageChangeStateMutation({
 *   variables: {
 *      brandHouseId: // value for 'brandHouseId'
 *      id: // value for 'id'
 *      state: // value for 'state'
 *   },
 * });
 */
export function useBrandItemsPageChangeStateMutation(baseOptions?: Apollo.MutationHookOptions<BrandItemsPageChangeStateMutation, BrandItemsPageChangeStateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BrandItemsPageChangeStateMutation, BrandItemsPageChangeStateMutationVariables>(BrandItemsPageChangeStateDocument, options);
      }
export type BrandItemsPageChangeStateMutationHookResult = ReturnType<typeof useBrandItemsPageChangeStateMutation>;
export type BrandItemsPageChangeStateMutationResult = Apollo.MutationResult<BrandItemsPageChangeStateMutation>;
export type BrandItemsPageChangeStateMutationOptions = Apollo.BaseMutationOptions<BrandItemsPageChangeStateMutation, BrandItemsPageChangeStateMutationVariables>;
export const BrandItemsPageChangeSortOrderDocument = gql`
    mutation BrandItemsPageChangeSortOrder($brandHouseId: MongoID!, $id: MongoID!, $order: Int!) {
  BrandItemUpdate(
    input: {_id: $id, sortorder: $order}
    brandHouseId: $brandHouseId
    silent: false
  ) {
    _id
    sortorder
  }
}
    `;
export type BrandItemsPageChangeSortOrderMutationFn = Apollo.MutationFunction<BrandItemsPageChangeSortOrderMutation, BrandItemsPageChangeSortOrderMutationVariables>;

/**
 * __useBrandItemsPageChangeSortOrderMutation__
 *
 * To run a mutation, you first call `useBrandItemsPageChangeSortOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBrandItemsPageChangeSortOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [brandItemsPageChangeSortOrderMutation, { data, loading, error }] = useBrandItemsPageChangeSortOrderMutation({
 *   variables: {
 *      brandHouseId: // value for 'brandHouseId'
 *      id: // value for 'id'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useBrandItemsPageChangeSortOrderMutation(baseOptions?: Apollo.MutationHookOptions<BrandItemsPageChangeSortOrderMutation, BrandItemsPageChangeSortOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BrandItemsPageChangeSortOrderMutation, BrandItemsPageChangeSortOrderMutationVariables>(BrandItemsPageChangeSortOrderDocument, options);
      }
export type BrandItemsPageChangeSortOrderMutationHookResult = ReturnType<typeof useBrandItemsPageChangeSortOrderMutation>;
export type BrandItemsPageChangeSortOrderMutationResult = Apollo.MutationResult<BrandItemsPageChangeSortOrderMutation>;
export type BrandItemsPageChangeSortOrderMutationOptions = Apollo.BaseMutationOptions<BrandItemsPageChangeSortOrderMutation, BrandItemsPageChangeSortOrderMutationVariables>;
export const BrandItemImageAutoAdjustDocument = gql`
    mutation BrandItemImageAutoAdjust($brandItemId: MongoID!) {
  BrandItemAdjustAutoImages(brandItemId: $brandItemId)
}
    `;
export type BrandItemImageAutoAdjustMutationFn = Apollo.MutationFunction<BrandItemImageAutoAdjustMutation, BrandItemImageAutoAdjustMutationVariables>;

/**
 * __useBrandItemImageAutoAdjustMutation__
 *
 * To run a mutation, you first call `useBrandItemImageAutoAdjustMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBrandItemImageAutoAdjustMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [brandItemImageAutoAdjustMutation, { data, loading, error }] = useBrandItemImageAutoAdjustMutation({
 *   variables: {
 *      brandItemId: // value for 'brandItemId'
 *   },
 * });
 */
export function useBrandItemImageAutoAdjustMutation(baseOptions?: Apollo.MutationHookOptions<BrandItemImageAutoAdjustMutation, BrandItemImageAutoAdjustMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BrandItemImageAutoAdjustMutation, BrandItemImageAutoAdjustMutationVariables>(BrandItemImageAutoAdjustDocument, options);
      }
export type BrandItemImageAutoAdjustMutationHookResult = ReturnType<typeof useBrandItemImageAutoAdjustMutation>;
export type BrandItemImageAutoAdjustMutationResult = Apollo.MutationResult<BrandItemImageAutoAdjustMutation>;
export type BrandItemImageAutoAdjustMutationOptions = Apollo.BaseMutationOptions<BrandItemImageAutoAdjustMutation, BrandItemImageAutoAdjustMutationVariables>;
export const BrandItemUpdateGroupDocument = gql`
    mutation BrandItemUpdateGroup($brandItemIds: [MongoID!]) {
  BrandItemGroupUpdate(brandItemIds: $brandItemIds) {
    _id
  }
}
    `;
export type BrandItemUpdateGroupMutationFn = Apollo.MutationFunction<BrandItemUpdateGroupMutation, BrandItemUpdateGroupMutationVariables>;

/**
 * __useBrandItemUpdateGroupMutation__
 *
 * To run a mutation, you first call `useBrandItemUpdateGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBrandItemUpdateGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [brandItemUpdateGroupMutation, { data, loading, error }] = useBrandItemUpdateGroupMutation({
 *   variables: {
 *      brandItemIds: // value for 'brandItemIds'
 *   },
 * });
 */
export function useBrandItemUpdateGroupMutation(baseOptions?: Apollo.MutationHookOptions<BrandItemUpdateGroupMutation, BrandItemUpdateGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BrandItemUpdateGroupMutation, BrandItemUpdateGroupMutationVariables>(BrandItemUpdateGroupDocument, options);
      }
export type BrandItemUpdateGroupMutationHookResult = ReturnType<typeof useBrandItemUpdateGroupMutation>;
export type BrandItemUpdateGroupMutationResult = Apollo.MutationResult<BrandItemUpdateGroupMutation>;
export type BrandItemUpdateGroupMutationOptions = Apollo.BaseMutationOptions<BrandItemUpdateGroupMutation, BrandItemUpdateGroupMutationVariables>;
export const BrandItemUpdatePricesDocument = gql`
    mutation BrandItemUpdatePrices($brandItemIds: [MongoID!]!) {
  BrandItemUpdatePrices(brandItemIds: $brandItemIds) {
    _id
    beforePrices {
      value
      currency
    }
  }
}
    `;
export type BrandItemUpdatePricesMutationFn = Apollo.MutationFunction<BrandItemUpdatePricesMutation, BrandItemUpdatePricesMutationVariables>;

/**
 * __useBrandItemUpdatePricesMutation__
 *
 * To run a mutation, you first call `useBrandItemUpdatePricesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBrandItemUpdatePricesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [brandItemUpdatePricesMutation, { data, loading, error }] = useBrandItemUpdatePricesMutation({
 *   variables: {
 *      brandItemIds: // value for 'brandItemIds'
 *   },
 * });
 */
export function useBrandItemUpdatePricesMutation(baseOptions?: Apollo.MutationHookOptions<BrandItemUpdatePricesMutation, BrandItemUpdatePricesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BrandItemUpdatePricesMutation, BrandItemUpdatePricesMutationVariables>(BrandItemUpdatePricesDocument, options);
      }
export type BrandItemUpdatePricesMutationHookResult = ReturnType<typeof useBrandItemUpdatePricesMutation>;
export type BrandItemUpdatePricesMutationResult = Apollo.MutationResult<BrandItemUpdatePricesMutation>;
export type BrandItemUpdatePricesMutationOptions = Apollo.BaseMutationOptions<BrandItemUpdatePricesMutation, BrandItemUpdatePricesMutationVariables>;
export const BrandItemUpdateIntegrationDocument = gql`
    mutation BrandItemUpdateIntegration($brandItemIds: [MongoID!]!, $instanceId: MongoID!) {
  BrandItemIntegrationUpdate(brandItemIds: $brandItemIds, instanceId: $instanceId)
}
    `;
export type BrandItemUpdateIntegrationMutationFn = Apollo.MutationFunction<BrandItemUpdateIntegrationMutation, BrandItemUpdateIntegrationMutationVariables>;

/**
 * __useBrandItemUpdateIntegrationMutation__
 *
 * To run a mutation, you first call `useBrandItemUpdateIntegrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBrandItemUpdateIntegrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [brandItemUpdateIntegrationMutation, { data, loading, error }] = useBrandItemUpdateIntegrationMutation({
 *   variables: {
 *      brandItemIds: // value for 'brandItemIds'
 *      instanceId: // value for 'instanceId'
 *   },
 * });
 */
export function useBrandItemUpdateIntegrationMutation(baseOptions?: Apollo.MutationHookOptions<BrandItemUpdateIntegrationMutation, BrandItemUpdateIntegrationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BrandItemUpdateIntegrationMutation, BrandItemUpdateIntegrationMutationVariables>(BrandItemUpdateIntegrationDocument, options);
      }
export type BrandItemUpdateIntegrationMutationHookResult = ReturnType<typeof useBrandItemUpdateIntegrationMutation>;
export type BrandItemUpdateIntegrationMutationResult = Apollo.MutationResult<BrandItemUpdateIntegrationMutation>;
export type BrandItemUpdateIntegrationMutationOptions = Apollo.BaseMutationOptions<BrandItemUpdateIntegrationMutation, BrandItemUpdateIntegrationMutationVariables>;
export const OptimizeBrandItemsBySalesRankDocument = gql`
    mutation OptimizeBrandItemsBySalesRank($brandHouseId: MongoID!) {
  BrandItemOptimizeBySalesRank(brandHouseId: $brandHouseId)
}
    `;
export type OptimizeBrandItemsBySalesRankMutationFn = Apollo.MutationFunction<OptimizeBrandItemsBySalesRankMutation, OptimizeBrandItemsBySalesRankMutationVariables>;

/**
 * __useOptimizeBrandItemsBySalesRankMutation__
 *
 * To run a mutation, you first call `useOptimizeBrandItemsBySalesRankMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOptimizeBrandItemsBySalesRankMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [optimizeBrandItemsBySalesRankMutation, { data, loading, error }] = useOptimizeBrandItemsBySalesRankMutation({
 *   variables: {
 *      brandHouseId: // value for 'brandHouseId'
 *   },
 * });
 */
export function useOptimizeBrandItemsBySalesRankMutation(baseOptions?: Apollo.MutationHookOptions<OptimizeBrandItemsBySalesRankMutation, OptimizeBrandItemsBySalesRankMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OptimizeBrandItemsBySalesRankMutation, OptimizeBrandItemsBySalesRankMutationVariables>(OptimizeBrandItemsBySalesRankDocument, options);
      }
export type OptimizeBrandItemsBySalesRankMutationHookResult = ReturnType<typeof useOptimizeBrandItemsBySalesRankMutation>;
export type OptimizeBrandItemsBySalesRankMutationResult = Apollo.MutationResult<OptimizeBrandItemsBySalesRankMutation>;
export type OptimizeBrandItemsBySalesRankMutationOptions = Apollo.BaseMutationOptions<OptimizeBrandItemsBySalesRankMutation, OptimizeBrandItemsBySalesRankMutationVariables>;
export const BrandItemsPreviewMasMigrationDocument = gql`
    mutation BrandItemsPreviewMasMigration($brandItemIds: [MongoID!]!) {
  BrandItemsPreviewMasterDataVariantMigration(brandItemIds: $brandItemIds) {
    _id
    status
    requestedCount
  }
}
    `;
export type BrandItemsPreviewMasMigrationMutationFn = Apollo.MutationFunction<BrandItemsPreviewMasMigrationMutation, BrandItemsPreviewMasMigrationMutationVariables>;

/**
 * __useBrandItemsPreviewMasMigrationMutation__
 *
 * To run a mutation, you first call `useBrandItemsPreviewMasMigrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBrandItemsPreviewMasMigrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [brandItemsPreviewMasMigrationMutation, { data, loading, error }] = useBrandItemsPreviewMasMigrationMutation({
 *   variables: {
 *      brandItemIds: // value for 'brandItemIds'
 *   },
 * });
 */
export function useBrandItemsPreviewMasMigrationMutation(baseOptions?: Apollo.MutationHookOptions<BrandItemsPreviewMasMigrationMutation, BrandItemsPreviewMasMigrationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BrandItemsPreviewMasMigrationMutation, BrandItemsPreviewMasMigrationMutationVariables>(BrandItemsPreviewMasMigrationDocument, options);
      }
export type BrandItemsPreviewMasMigrationMutationHookResult = ReturnType<typeof useBrandItemsPreviewMasMigrationMutation>;
export type BrandItemsPreviewMasMigrationMutationResult = Apollo.MutationResult<BrandItemsPreviewMasMigrationMutation>;
export type BrandItemsPreviewMasMigrationMutationOptions = Apollo.BaseMutationOptions<BrandItemsPreviewMasMigrationMutation, BrandItemsPreviewMasMigrationMutationVariables>;
export const BrandItemsBackfillMasterDataDocument = gql`
    mutation BrandItemsBackfillMasterData($brandItemIds: [MongoID!]!) {
  BrandItemsBackfillMasterData(brandItemIds: $brandItemIds) {
    requested
    queued
    skipped
  }
}
    `;
export type BrandItemsBackfillMasterDataMutationFn = Apollo.MutationFunction<BrandItemsBackfillMasterDataMutation, BrandItemsBackfillMasterDataMutationVariables>;

/**
 * __useBrandItemsBackfillMasterDataMutation__
 *
 * To run a mutation, you first call `useBrandItemsBackfillMasterDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBrandItemsBackfillMasterDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [brandItemsBackfillMasterDataMutation, { data, loading, error }] = useBrandItemsBackfillMasterDataMutation({
 *   variables: {
 *      brandItemIds: // value for 'brandItemIds'
 *   },
 * });
 */
export function useBrandItemsBackfillMasterDataMutation(baseOptions?: Apollo.MutationHookOptions<BrandItemsBackfillMasterDataMutation, BrandItemsBackfillMasterDataMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BrandItemsBackfillMasterDataMutation, BrandItemsBackfillMasterDataMutationVariables>(BrandItemsBackfillMasterDataDocument, options);
      }
export type BrandItemsBackfillMasterDataMutationHookResult = ReturnType<typeof useBrandItemsBackfillMasterDataMutation>;
export type BrandItemsBackfillMasterDataMutationResult = Apollo.MutationResult<BrandItemsBackfillMasterDataMutation>;
export type BrandItemsBackfillMasterDataMutationOptions = Apollo.BaseMutationOptions<BrandItemsBackfillMasterDataMutation, BrandItemsBackfillMasterDataMutationVariables>;
export const BrandItemsRefreshMasterDataDocument = gql`
    mutation BrandItemsRefreshMasterData($brandItemIds: [MongoID!]!) {
  BrandItemsRefreshMasterData(brandItemIds: $brandItemIds) {
    requested
    queued
    skipped
  }
}
    `;
export type BrandItemsRefreshMasterDataMutationFn = Apollo.MutationFunction<BrandItemsRefreshMasterDataMutation, BrandItemsRefreshMasterDataMutationVariables>;

/**
 * __useBrandItemsRefreshMasterDataMutation__
 *
 * To run a mutation, you first call `useBrandItemsRefreshMasterDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBrandItemsRefreshMasterDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [brandItemsRefreshMasterDataMutation, { data, loading, error }] = useBrandItemsRefreshMasterDataMutation({
 *   variables: {
 *      brandItemIds: // value for 'brandItemIds'
 *   },
 * });
 */
export function useBrandItemsRefreshMasterDataMutation(baseOptions?: Apollo.MutationHookOptions<BrandItemsRefreshMasterDataMutation, BrandItemsRefreshMasterDataMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BrandItemsRefreshMasterDataMutation, BrandItemsRefreshMasterDataMutationVariables>(BrandItemsRefreshMasterDataDocument, options);
      }
export type BrandItemsRefreshMasterDataMutationHookResult = ReturnType<typeof useBrandItemsRefreshMasterDataMutation>;
export type BrandItemsRefreshMasterDataMutationResult = Apollo.MutationResult<BrandItemsRefreshMasterDataMutation>;
export type BrandItemsRefreshMasterDataMutationOptions = Apollo.BaseMutationOptions<BrandItemsRefreshMasterDataMutation, BrandItemsRefreshMasterDataMutationVariables>;
export const BrandItemCreateFromMasterDataDocument = gql`
    mutation BrandItemCreateFromMasterData($brandHouseId: MongoID!, $masterDataVariantId: String!) {
  BrandItemUpdate(
    brandHouseId: $brandHouseId
    input: {masterDataVariantId: $masterDataVariantId, condition: 3}
  ) {
    _id
  }
}
    `;
export type BrandItemCreateFromMasterDataMutationFn = Apollo.MutationFunction<BrandItemCreateFromMasterDataMutation, BrandItemCreateFromMasterDataMutationVariables>;

/**
 * __useBrandItemCreateFromMasterDataMutation__
 *
 * To run a mutation, you first call `useBrandItemCreateFromMasterDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBrandItemCreateFromMasterDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [brandItemCreateFromMasterDataMutation, { data, loading, error }] = useBrandItemCreateFromMasterDataMutation({
 *   variables: {
 *      brandHouseId: // value for 'brandHouseId'
 *      masterDataVariantId: // value for 'masterDataVariantId'
 *   },
 * });
 */
export function useBrandItemCreateFromMasterDataMutation(baseOptions?: Apollo.MutationHookOptions<BrandItemCreateFromMasterDataMutation, BrandItemCreateFromMasterDataMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BrandItemCreateFromMasterDataMutation, BrandItemCreateFromMasterDataMutationVariables>(BrandItemCreateFromMasterDataDocument, options);
      }
export type BrandItemCreateFromMasterDataMutationHookResult = ReturnType<typeof useBrandItemCreateFromMasterDataMutation>;
export type BrandItemCreateFromMasterDataMutationResult = Apollo.MutationResult<BrandItemCreateFromMasterDataMutation>;
export type BrandItemCreateFromMasterDataMutationOptions = Apollo.BaseMutationOptions<BrandItemCreateFromMasterDataMutation, BrandItemCreateFromMasterDataMutationVariables>;
export const BrandMessagesShopsDocument = gql`
    query BrandMessagesShops($brandHouseId: MongoID!) {
  ShopMany(filter: {brandHouseId: $brandHouseId}) {
    _id
  }
}
    `;

/**
 * __useBrandMessagesShopsQuery__
 *
 * To run a query within a React component, call `useBrandMessagesShopsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBrandMessagesShopsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBrandMessagesShopsQuery({
 *   variables: {
 *      brandHouseId: // value for 'brandHouseId'
 *   },
 * });
 */
export function useBrandMessagesShopsQuery(baseOptions: Apollo.QueryHookOptions<BrandMessagesShopsQuery, BrandMessagesShopsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BrandMessagesShopsQuery, BrandMessagesShopsQueryVariables>(BrandMessagesShopsDocument, options);
      }
export function useBrandMessagesShopsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BrandMessagesShopsQuery, BrandMessagesShopsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BrandMessagesShopsQuery, BrandMessagesShopsQueryVariables>(BrandMessagesShopsDocument, options);
        }
export type BrandMessagesShopsQueryHookResult = ReturnType<typeof useBrandMessagesShopsQuery>;
export type BrandMessagesShopsLazyQueryHookResult = ReturnType<typeof useBrandMessagesShopsLazyQuery>;
export type BrandMessagesShopsQueryResult = Apollo.QueryResult<BrandMessagesShopsQuery, BrandMessagesShopsQueryVariables>;
export const BrandMessagesInstancesDocument = gql`
    query BrandMessagesInstances($instanceFilter: FilterFindManyIntegrationInstanceInput) {
  IntegrationInstances(filter: $instanceFilter, limit: 1000) {
    _id
  }
}
    `;

/**
 * __useBrandMessagesInstancesQuery__
 *
 * To run a query within a React component, call `useBrandMessagesInstancesQuery` and pass it any options that fit your needs.
 * When your component renders, `useBrandMessagesInstancesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBrandMessagesInstancesQuery({
 *   variables: {
 *      instanceFilter: // value for 'instanceFilter'
 *   },
 * });
 */
export function useBrandMessagesInstancesQuery(baseOptions?: Apollo.QueryHookOptions<BrandMessagesInstancesQuery, BrandMessagesInstancesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BrandMessagesInstancesQuery, BrandMessagesInstancesQueryVariables>(BrandMessagesInstancesDocument, options);
      }
export function useBrandMessagesInstancesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BrandMessagesInstancesQuery, BrandMessagesInstancesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BrandMessagesInstancesQuery, BrandMessagesInstancesQueryVariables>(BrandMessagesInstancesDocument, options);
        }
export type BrandMessagesInstancesQueryHookResult = ReturnType<typeof useBrandMessagesInstancesQuery>;
export type BrandMessagesInstancesLazyQueryHookResult = ReturnType<typeof useBrandMessagesInstancesLazyQuery>;
export type BrandMessagesInstancesQueryResult = Apollo.QueryResult<BrandMessagesInstancesQuery, BrandMessagesInstancesQueryVariables>;
export const BrandOrdersPageShopsDocument = gql`
    query BrandOrdersPageShops($brandHouseId: MongoID!, $instanceFilter: FilterFindManyIntegrationInstanceInput) {
  ShopMany(filter: {brandHouseId: $brandHouseId}) {
    _id
    name
  }
  IntegrationInstances(filter: $instanceFilter) {
    _id
    name
    refId
    connector {
      messages
    }
  }
}
    `;

/**
 * __useBrandOrdersPageShopsQuery__
 *
 * To run a query within a React component, call `useBrandOrdersPageShopsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBrandOrdersPageShopsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBrandOrdersPageShopsQuery({
 *   variables: {
 *      brandHouseId: // value for 'brandHouseId'
 *      instanceFilter: // value for 'instanceFilter'
 *   },
 * });
 */
export function useBrandOrdersPageShopsQuery(baseOptions: Apollo.QueryHookOptions<BrandOrdersPageShopsQuery, BrandOrdersPageShopsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BrandOrdersPageShopsQuery, BrandOrdersPageShopsQueryVariables>(BrandOrdersPageShopsDocument, options);
      }
export function useBrandOrdersPageShopsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BrandOrdersPageShopsQuery, BrandOrdersPageShopsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BrandOrdersPageShopsQuery, BrandOrdersPageShopsQueryVariables>(BrandOrdersPageShopsDocument, options);
        }
export type BrandOrdersPageShopsQueryHookResult = ReturnType<typeof useBrandOrdersPageShopsQuery>;
export type BrandOrdersPageShopsLazyQueryHookResult = ReturnType<typeof useBrandOrdersPageShopsLazyQuery>;
export type BrandOrdersPageShopsQueryResult = Apollo.QueryResult<BrandOrdersPageShopsQuery, BrandOrdersPageShopsQueryVariables>;
export const BrandOrdersPageSelectedOrdersDocument = gql`
    query BrandOrdersPageSelectedOrders($orderIds: [MongoID!]) {
  OrderPagination(
    filter: {_operators: {_id: {in: $orderIds}}}
    page: 1
    perPage: 10000
  ) {
    items {
      _id
      shopId
    }
  }
}
    `;

/**
 * __useBrandOrdersPageSelectedOrdersQuery__
 *
 * To run a query within a React component, call `useBrandOrdersPageSelectedOrdersQuery` and pass it any options that fit your needs.
 * When your component renders, `useBrandOrdersPageSelectedOrdersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBrandOrdersPageSelectedOrdersQuery({
 *   variables: {
 *      orderIds: // value for 'orderIds'
 *   },
 * });
 */
export function useBrandOrdersPageSelectedOrdersQuery(baseOptions?: Apollo.QueryHookOptions<BrandOrdersPageSelectedOrdersQuery, BrandOrdersPageSelectedOrdersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BrandOrdersPageSelectedOrdersQuery, BrandOrdersPageSelectedOrdersQueryVariables>(BrandOrdersPageSelectedOrdersDocument, options);
      }
export function useBrandOrdersPageSelectedOrdersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BrandOrdersPageSelectedOrdersQuery, BrandOrdersPageSelectedOrdersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BrandOrdersPageSelectedOrdersQuery, BrandOrdersPageSelectedOrdersQueryVariables>(BrandOrdersPageSelectedOrdersDocument, options);
        }
export type BrandOrdersPageSelectedOrdersQueryHookResult = ReturnType<typeof useBrandOrdersPageSelectedOrdersQuery>;
export type BrandOrdersPageSelectedOrdersLazyQueryHookResult = ReturnType<typeof useBrandOrdersPageSelectedOrdersLazyQuery>;
export type BrandOrdersPageSelectedOrdersQueryResult = Apollo.QueryResult<BrandOrdersPageSelectedOrdersQuery, BrandOrdersPageSelectedOrdersQueryVariables>;
export const OrderIntegrationExecuteDocument = gql`
    mutation OrderIntegrationExecute($refId: MongoID!, $arguments: [JSON!]) {
  IntegrationMessageExecute(
    refType: SHOP
    name: "handleOrderUpdated"
    refId: $refId
    arguments: $arguments
  )
}
    `;
export type OrderIntegrationExecuteMutationFn = Apollo.MutationFunction<OrderIntegrationExecuteMutation, OrderIntegrationExecuteMutationVariables>;

/**
 * __useOrderIntegrationExecuteMutation__
 *
 * To run a mutation, you first call `useOrderIntegrationExecuteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOrderIntegrationExecuteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [orderIntegrationExecuteMutation, { data, loading, error }] = useOrderIntegrationExecuteMutation({
 *   variables: {
 *      refId: // value for 'refId'
 *      arguments: // value for 'arguments'
 *   },
 * });
 */
export function useOrderIntegrationExecuteMutation(baseOptions?: Apollo.MutationHookOptions<OrderIntegrationExecuteMutation, OrderIntegrationExecuteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OrderIntegrationExecuteMutation, OrderIntegrationExecuteMutationVariables>(OrderIntegrationExecuteDocument, options);
      }
export type OrderIntegrationExecuteMutationHookResult = ReturnType<typeof useOrderIntegrationExecuteMutation>;
export type OrderIntegrationExecuteMutationResult = Apollo.MutationResult<OrderIntegrationExecuteMutation>;
export type OrderIntegrationExecuteMutationOptions = Apollo.BaseMutationOptions<OrderIntegrationExecuteMutation, OrderIntegrationExecuteMutationVariables>;
export const BrandOrdersPageSynchronizeDocument = gql`
    mutation BrandOrdersPageSynchronize($shopId: String!, $service: String!) {
  StartSynchronize(shopId: $shopId, service: $service) {
    status
  }
}
    `;
export type BrandOrdersPageSynchronizeMutationFn = Apollo.MutationFunction<BrandOrdersPageSynchronizeMutation, BrandOrdersPageSynchronizeMutationVariables>;

/**
 * __useBrandOrdersPageSynchronizeMutation__
 *
 * To run a mutation, you first call `useBrandOrdersPageSynchronizeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBrandOrdersPageSynchronizeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [brandOrdersPageSynchronizeMutation, { data, loading, error }] = useBrandOrdersPageSynchronizeMutation({
 *   variables: {
 *      shopId: // value for 'shopId'
 *      service: // value for 'service'
 *   },
 * });
 */
export function useBrandOrdersPageSynchronizeMutation(baseOptions?: Apollo.MutationHookOptions<BrandOrdersPageSynchronizeMutation, BrandOrdersPageSynchronizeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BrandOrdersPageSynchronizeMutation, BrandOrdersPageSynchronizeMutationVariables>(BrandOrdersPageSynchronizeDocument, options);
      }
export type BrandOrdersPageSynchronizeMutationHookResult = ReturnType<typeof useBrandOrdersPageSynchronizeMutation>;
export type BrandOrdersPageSynchronizeMutationResult = Apollo.MutationResult<BrandOrdersPageSynchronizeMutation>;
export type BrandOrdersPageSynchronizeMutationOptions = Apollo.BaseMutationOptions<BrandOrdersPageSynchronizeMutation, BrandOrdersPageSynchronizeMutationVariables>;
export const ShopDeleteDocument = gql`
    mutation ShopDelete($shopId: String!) {
  ShopDelete(shopId: $shopId) {
    _id
    name
  }
}
    `;
export type ShopDeleteMutationFn = Apollo.MutationFunction<ShopDeleteMutation, ShopDeleteMutationVariables>;

/**
 * __useShopDeleteMutation__
 *
 * To run a mutation, you first call `useShopDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useShopDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [shopDeleteMutation, { data, loading, error }] = useShopDeleteMutation({
 *   variables: {
 *      shopId: // value for 'shopId'
 *   },
 * });
 */
export function useShopDeleteMutation(baseOptions?: Apollo.MutationHookOptions<ShopDeleteMutation, ShopDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ShopDeleteMutation, ShopDeleteMutationVariables>(ShopDeleteDocument, options);
      }
export type ShopDeleteMutationHookResult = ReturnType<typeof useShopDeleteMutation>;
export type ShopDeleteMutationResult = Apollo.MutationResult<ShopDeleteMutation>;
export type ShopDeleteMutationOptions = Apollo.BaseMutationOptions<ShopDeleteMutation, ShopDeleteMutationVariables>;
export const ShopLaunchDocument = gql`
    mutation ShopLaunch($shopId: String!) {
  ShopLaunch(shopId: $shopId) {
    _id
  }
}
    `;
export type ShopLaunchMutationFn = Apollo.MutationFunction<ShopLaunchMutation, ShopLaunchMutationVariables>;

/**
 * __useShopLaunchMutation__
 *
 * To run a mutation, you first call `useShopLaunchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useShopLaunchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [shopLaunchMutation, { data, loading, error }] = useShopLaunchMutation({
 *   variables: {
 *      shopId: // value for 'shopId'
 *   },
 * });
 */
export function useShopLaunchMutation(baseOptions?: Apollo.MutationHookOptions<ShopLaunchMutation, ShopLaunchMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ShopLaunchMutation, ShopLaunchMutationVariables>(ShopLaunchDocument, options);
      }
export type ShopLaunchMutationHookResult = ReturnType<typeof useShopLaunchMutation>;
export type ShopLaunchMutationResult = Apollo.MutationResult<ShopLaunchMutation>;
export type ShopLaunchMutationOptions = Apollo.BaseMutationOptions<ShopLaunchMutation, ShopLaunchMutationVariables>;
export const BrandPageBrandByIdDocument = gql`
    query BrandPageBrandById($shopId: MongoID!) {
  ShopById(_id: $shopId) {
    _id
    name
    live
    tradeInBaseUrl
    shopCollectionUrl
    currency
    disableContactResetDate
  }
}
    `;

/**
 * __useBrandPageBrandByIdQuery__
 *
 * To run a query within a React component, call `useBrandPageBrandByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useBrandPageBrandByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBrandPageBrandByIdQuery({
 *   variables: {
 *      shopId: // value for 'shopId'
 *   },
 * });
 */
export function useBrandPageBrandByIdQuery(baseOptions: Apollo.QueryHookOptions<BrandPageBrandByIdQuery, BrandPageBrandByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BrandPageBrandByIdQuery, BrandPageBrandByIdQueryVariables>(BrandPageBrandByIdDocument, options);
      }
export function useBrandPageBrandByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BrandPageBrandByIdQuery, BrandPageBrandByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BrandPageBrandByIdQuery, BrandPageBrandByIdQueryVariables>(BrandPageBrandByIdDocument, options);
        }
export type BrandPageBrandByIdQueryHookResult = ReturnType<typeof useBrandPageBrandByIdQuery>;
export type BrandPageBrandByIdLazyQueryHookResult = ReturnType<typeof useBrandPageBrandByIdLazyQuery>;
export type BrandPageBrandByIdQueryResult = Apollo.QueryResult<BrandPageBrandByIdQuery, BrandPageBrandByIdQueryVariables>;
export const BrandProductListPaginationDocument = gql`
    query BrandProductListPagination($search: String, $filter: FilterFindManyBrandProductInput, $sort: SortFindManyBrandProductInput, $page: Int, $perPage: Int) {
  BrandProductsPagination(
    search: $search
    filter: $filter
    sort: $sort
    page: $page
    perPage: $perPage
  ) {
    count
    pageInfo {
      perPage
      currentPage
      hasNextPage
      hasPreviousPage
      itemCount
      pageCount
    }
    items {
      ...ProductPaginationFragment
    }
  }
}
    ${ProductPaginationFragmentDoc}`;

/**
 * __useBrandProductListPaginationQuery__
 *
 * To run a query within a React component, call `useBrandProductListPaginationQuery` and pass it any options that fit your needs.
 * When your component renders, `useBrandProductListPaginationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBrandProductListPaginationQuery({
 *   variables: {
 *      search: // value for 'search'
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *   },
 * });
 */
export function useBrandProductListPaginationQuery(baseOptions?: Apollo.QueryHookOptions<BrandProductListPaginationQuery, BrandProductListPaginationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BrandProductListPaginationQuery, BrandProductListPaginationQueryVariables>(BrandProductListPaginationDocument, options);
      }
export function useBrandProductListPaginationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BrandProductListPaginationQuery, BrandProductListPaginationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BrandProductListPaginationQuery, BrandProductListPaginationQueryVariables>(BrandProductListPaginationDocument, options);
        }
export type BrandProductListPaginationQueryHookResult = ReturnType<typeof useBrandProductListPaginationQuery>;
export type BrandProductListPaginationLazyQueryHookResult = ReturnType<typeof useBrandProductListPaginationLazyQuery>;
export type BrandProductListPaginationQueryResult = Apollo.QueryResult<BrandProductListPaginationQuery, BrandProductListPaginationQueryVariables>;
export const BrandProductListSourcesDocument = gql`
    query BrandProductListSources($brandHouseId: MongoID!) {
  BrandProductGroups(filter: {brandHouseId: $brandHouseId}) {
    _id
    name
    activePromotions
    active
  }
}
    `;

/**
 * __useBrandProductListSourcesQuery__
 *
 * To run a query within a React component, call `useBrandProductListSourcesQuery` and pass it any options that fit your needs.
 * When your component renders, `useBrandProductListSourcesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBrandProductListSourcesQuery({
 *   variables: {
 *      brandHouseId: // value for 'brandHouseId'
 *   },
 * });
 */
export function useBrandProductListSourcesQuery(baseOptions: Apollo.QueryHookOptions<BrandProductListSourcesQuery, BrandProductListSourcesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BrandProductListSourcesQuery, BrandProductListSourcesQueryVariables>(BrandProductListSourcesDocument, options);
      }
export function useBrandProductListSourcesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BrandProductListSourcesQuery, BrandProductListSourcesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BrandProductListSourcesQuery, BrandProductListSourcesQueryVariables>(BrandProductListSourcesDocument, options);
        }
export type BrandProductListSourcesQueryHookResult = ReturnType<typeof useBrandProductListSourcesQuery>;
export type BrandProductListSourcesLazyQueryHookResult = ReturnType<typeof useBrandProductListSourcesLazyQuery>;
export type BrandProductListSourcesQueryResult = Apollo.QueryResult<BrandProductListSourcesQuery, BrandProductListSourcesQueryVariables>;
export const CampaignCreateDocument = gql`
    mutation CampaignCreate($input: CreateOneCampaignInput!) {
  CampaignCreate(record: $input) {
    record {
      ...Campaign
    }
    error {
      message
    }
  }
}
    ${CampaignFragmentDoc}`;
export type CampaignCreateMutationFn = Apollo.MutationFunction<CampaignCreateMutation, CampaignCreateMutationVariables>;

/**
 * __useCampaignCreateMutation__
 *
 * To run a mutation, you first call `useCampaignCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCampaignCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [campaignCreateMutation, { data, loading, error }] = useCampaignCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCampaignCreateMutation(baseOptions?: Apollo.MutationHookOptions<CampaignCreateMutation, CampaignCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CampaignCreateMutation, CampaignCreateMutationVariables>(CampaignCreateDocument, options);
      }
export type CampaignCreateMutationHookResult = ReturnType<typeof useCampaignCreateMutation>;
export type CampaignCreateMutationResult = Apollo.MutationResult<CampaignCreateMutation>;
export type CampaignCreateMutationOptions = Apollo.BaseMutationOptions<CampaignCreateMutation, CampaignCreateMutationVariables>;
export const CampaignUpdateDocument = gql`
    mutation CampaignUpdate($_id: MongoID!, $input: UpdateByIdCampaignInput!) {
  CampaignUpdate(_id: $_id, record: $input) {
    record {
      ...Campaign
    }
    error {
      message
    }
  }
}
    ${CampaignFragmentDoc}`;
export type CampaignUpdateMutationFn = Apollo.MutationFunction<CampaignUpdateMutation, CampaignUpdateMutationVariables>;

/**
 * __useCampaignUpdateMutation__
 *
 * To run a mutation, you first call `useCampaignUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCampaignUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [campaignUpdateMutation, { data, loading, error }] = useCampaignUpdateMutation({
 *   variables: {
 *      _id: // value for '_id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCampaignUpdateMutation(baseOptions?: Apollo.MutationHookOptions<CampaignUpdateMutation, CampaignUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CampaignUpdateMutation, CampaignUpdateMutationVariables>(CampaignUpdateDocument, options);
      }
export type CampaignUpdateMutationHookResult = ReturnType<typeof useCampaignUpdateMutation>;
export type CampaignUpdateMutationResult = Apollo.MutationResult<CampaignUpdateMutation>;
export type CampaignUpdateMutationOptions = Apollo.BaseMutationOptions<CampaignUpdateMutation, CampaignUpdateMutationVariables>;
export const CampaignsDocument = gql`
    query Campaigns($brandHouseId: MongoID!) {
  Campaigns(
    filter: {brandHouseId: $brandHouseId}
    sort: BRANDHOUSEID__FROMDATE__TODATE_ASC
    limit: 10000
  ) {
    ...Campaign
  }
}
    ${CampaignFragmentDoc}`;

/**
 * __useCampaignsQuery__
 *
 * To run a query within a React component, call `useCampaignsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCampaignsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCampaignsQuery({
 *   variables: {
 *      brandHouseId: // value for 'brandHouseId'
 *   },
 * });
 */
export function useCampaignsQuery(baseOptions: Apollo.QueryHookOptions<CampaignsQuery, CampaignsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CampaignsQuery, CampaignsQueryVariables>(CampaignsDocument, options);
      }
export function useCampaignsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CampaignsQuery, CampaignsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CampaignsQuery, CampaignsQueryVariables>(CampaignsDocument, options);
        }
export type CampaignsQueryHookResult = ReturnType<typeof useCampaignsQuery>;
export type CampaignsLazyQueryHookResult = ReturnType<typeof useCampaignsLazyQuery>;
export type CampaignsQueryResult = Apollo.QueryResult<CampaignsQuery, CampaignsQueryVariables>;
export const ConsumerEventPaginationDocument = gql`
    query ConsumerEventPagination($search: String, $filter: FilterFindManyConsumerEventInput, $sort: SortFindManyConsumerEventInput, $page: Int, $perPage: Int) {
  ConsumerEventPagination(
    search: $search
    filter: $filter
    sort: $sort
    page: $page
    perPage: $perPage
  ) {
    count
    pageInfo {
      perPage
      currentPage
      hasNextPage
      hasPreviousPage
      itemCount
      pageCount
    }
    items {
      _id
      dateTime
      consumerId
      event
      subEvent
      consumer {
        _id
        firstName
        lastName
        mail
        selfCreated
      }
      maildata {
        delivered
        opened
        clicked
        bounced
        spam
      }
    }
  }
}
    `;

/**
 * __useConsumerEventPaginationQuery__
 *
 * To run a query within a React component, call `useConsumerEventPaginationQuery` and pass it any options that fit your needs.
 * When your component renders, `useConsumerEventPaginationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConsumerEventPaginationQuery({
 *   variables: {
 *      search: // value for 'search'
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *   },
 * });
 */
export function useConsumerEventPaginationQuery(baseOptions?: Apollo.QueryHookOptions<ConsumerEventPaginationQuery, ConsumerEventPaginationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ConsumerEventPaginationQuery, ConsumerEventPaginationQueryVariables>(ConsumerEventPaginationDocument, options);
      }
export function useConsumerEventPaginationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ConsumerEventPaginationQuery, ConsumerEventPaginationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ConsumerEventPaginationQuery, ConsumerEventPaginationQueryVariables>(ConsumerEventPaginationDocument, options);
        }
export type ConsumerEventPaginationQueryHookResult = ReturnType<typeof useConsumerEventPaginationQuery>;
export type ConsumerEventPaginationLazyQueryHookResult = ReturnType<typeof useConsumerEventPaginationLazyQuery>;
export type ConsumerEventPaginationQueryResult = Apollo.QueryResult<ConsumerEventPaginationQuery, ConsumerEventPaginationQueryVariables>;
export const DashboardPageBrandDocument = gql`
    query DashboardPageBrand($id: MongoID!) {
  BrandHouse(id: $id) {
    _id
    name
    shops {
      _id
      name
      currency
      liveDate
    }
  }
}
    `;

/**
 * __useDashboardPageBrandQuery__
 *
 * To run a query within a React component, call `useDashboardPageBrandQuery` and pass it any options that fit your needs.
 * When your component renders, `useDashboardPageBrandQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDashboardPageBrandQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDashboardPageBrandQuery(baseOptions: Apollo.QueryHookOptions<DashboardPageBrandQuery, DashboardPageBrandQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DashboardPageBrandQuery, DashboardPageBrandQueryVariables>(DashboardPageBrandDocument, options);
      }
export function useDashboardPageBrandLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DashboardPageBrandQuery, DashboardPageBrandQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DashboardPageBrandQuery, DashboardPageBrandQueryVariables>(DashboardPageBrandDocument, options);
        }
export type DashboardPageBrandQueryHookResult = ReturnType<typeof useDashboardPageBrandQuery>;
export type DashboardPageBrandLazyQueryHookResult = ReturnType<typeof useDashboardPageBrandLazyQuery>;
export type DashboardPageBrandQueryResult = Apollo.QueryResult<DashboardPageBrandQuery, DashboardPageBrandQueryVariables>;
export const MasterDataSearchDialogSearchDocument = gql`
    query MasterDataSearchDialogSearch($brandHouseId: MongoID!, $search: String!) {
  BrandHouseMasterDataSearch(brandHouseId: $brandHouseId, search: $search) {
    ...MasterDataSearchProduct
  }
}
    ${MasterDataSearchProductFragmentDoc}`;

/**
 * __useMasterDataSearchDialogSearchQuery__
 *
 * To run a query within a React component, call `useMasterDataSearchDialogSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useMasterDataSearchDialogSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMasterDataSearchDialogSearchQuery({
 *   variables: {
 *      brandHouseId: // value for 'brandHouseId'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useMasterDataSearchDialogSearchQuery(baseOptions: Apollo.QueryHookOptions<MasterDataSearchDialogSearchQuery, MasterDataSearchDialogSearchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MasterDataSearchDialogSearchQuery, MasterDataSearchDialogSearchQueryVariables>(MasterDataSearchDialogSearchDocument, options);
      }
export function useMasterDataSearchDialogSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MasterDataSearchDialogSearchQuery, MasterDataSearchDialogSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MasterDataSearchDialogSearchQuery, MasterDataSearchDialogSearchQueryVariables>(MasterDataSearchDialogSearchDocument, options);
        }
export type MasterDataSearchDialogSearchQueryHookResult = ReturnType<typeof useMasterDataSearchDialogSearchQuery>;
export type MasterDataSearchDialogSearchLazyQueryHookResult = ReturnType<typeof useMasterDataSearchDialogSearchLazyQuery>;
export type MasterDataSearchDialogSearchQueryResult = Apollo.QueryResult<MasterDataSearchDialogSearchQuery, MasterDataSearchDialogSearchQueryVariables>;
export const MasterDataSearchDialogVisualDocument = gql`
    query MasterDataSearchDialogVisual($brandHouseId: MongoID!, $imageUrl: String!, $maxResults: Int) {
  BrandHouseMasterDataVisualSearch(
    brandHouseId: $brandHouseId
    imageUrl: $imageUrl
    maxResults: $maxResults
  ) {
    score
    imageUrl
    product {
      ...MasterDataSearchProduct
    }
  }
}
    ${MasterDataSearchProductFragmentDoc}`;

/**
 * __useMasterDataSearchDialogVisualQuery__
 *
 * To run a query within a React component, call `useMasterDataSearchDialogVisualQuery` and pass it any options that fit your needs.
 * When your component renders, `useMasterDataSearchDialogVisualQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMasterDataSearchDialogVisualQuery({
 *   variables: {
 *      brandHouseId: // value for 'brandHouseId'
 *      imageUrl: // value for 'imageUrl'
 *      maxResults: // value for 'maxResults'
 *   },
 * });
 */
export function useMasterDataSearchDialogVisualQuery(baseOptions: Apollo.QueryHookOptions<MasterDataSearchDialogVisualQuery, MasterDataSearchDialogVisualQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MasterDataSearchDialogVisualQuery, MasterDataSearchDialogVisualQueryVariables>(MasterDataSearchDialogVisualDocument, options);
      }
export function useMasterDataSearchDialogVisualLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MasterDataSearchDialogVisualQuery, MasterDataSearchDialogVisualQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MasterDataSearchDialogVisualQuery, MasterDataSearchDialogVisualQueryVariables>(MasterDataSearchDialogVisualDocument, options);
        }
export type MasterDataSearchDialogVisualQueryHookResult = ReturnType<typeof useMasterDataSearchDialogVisualQuery>;
export type MasterDataSearchDialogVisualLazyQueryHookResult = ReturnType<typeof useMasterDataSearchDialogVisualLazyQuery>;
export type MasterDataSearchDialogVisualQueryResult = Apollo.QueryResult<MasterDataSearchDialogVisualQuery, MasterDataSearchDialogVisualQueryVariables>;
export const MasterDataSearchDialogUploadDocument = gql`
    query MasterDataSearchDialogUpload($imageId: MongoID!) {
  Image(_id: $imageId) {
    _id
    url
  }
}
    `;

/**
 * __useMasterDataSearchDialogUploadQuery__
 *
 * To run a query within a React component, call `useMasterDataSearchDialogUploadQuery` and pass it any options that fit your needs.
 * When your component renders, `useMasterDataSearchDialogUploadQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMasterDataSearchDialogUploadQuery({
 *   variables: {
 *      imageId: // value for 'imageId'
 *   },
 * });
 */
export function useMasterDataSearchDialogUploadQuery(baseOptions: Apollo.QueryHookOptions<MasterDataSearchDialogUploadQuery, MasterDataSearchDialogUploadQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MasterDataSearchDialogUploadQuery, MasterDataSearchDialogUploadQueryVariables>(MasterDataSearchDialogUploadDocument, options);
      }
export function useMasterDataSearchDialogUploadLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MasterDataSearchDialogUploadQuery, MasterDataSearchDialogUploadQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MasterDataSearchDialogUploadQuery, MasterDataSearchDialogUploadQueryVariables>(MasterDataSearchDialogUploadDocument, options);
        }
export type MasterDataSearchDialogUploadQueryHookResult = ReturnType<typeof useMasterDataSearchDialogUploadQuery>;
export type MasterDataSearchDialogUploadLazyQueryHookResult = ReturnType<typeof useMasterDataSearchDialogUploadLazyQuery>;
export type MasterDataSearchDialogUploadQueryResult = Apollo.QueryResult<MasterDataSearchDialogUploadQuery, MasterDataSearchDialogUploadQueryVariables>;
export const ProformaOrderAddressesDocument = gql`
    query ProformaOrderAddresses($brandHouseId: MongoID!, $shopId: MongoID!) {
  BrandHouse(id: $brandHouseId) {
    _id
    logisticsPartnerId
    address {
      ...ProformaAddressInfo
    }
  }
  Shop(_id: $shopId) {
    _id
    address {
      ...ProformaAddressInfo
    }
  }
}
    ${ProformaAddressInfoFragmentDoc}`;

/**
 * __useProformaOrderAddressesQuery__
 *
 * To run a query within a React component, call `useProformaOrderAddressesQuery` and pass it any options that fit your needs.
 * When your component renders, `useProformaOrderAddressesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProformaOrderAddressesQuery({
 *   variables: {
 *      brandHouseId: // value for 'brandHouseId'
 *      shopId: // value for 'shopId'
 *   },
 * });
 */
export function useProformaOrderAddressesQuery(baseOptions: Apollo.QueryHookOptions<ProformaOrderAddressesQuery, ProformaOrderAddressesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProformaOrderAddressesQuery, ProformaOrderAddressesQueryVariables>(ProformaOrderAddressesDocument, options);
      }
export function useProformaOrderAddressesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProformaOrderAddressesQuery, ProformaOrderAddressesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProformaOrderAddressesQuery, ProformaOrderAddressesQueryVariables>(ProformaOrderAddressesDocument, options);
        }
export type ProformaOrderAddressesQueryHookResult = ReturnType<typeof useProformaOrderAddressesQuery>;
export type ProformaOrderAddressesLazyQueryHookResult = ReturnType<typeof useProformaOrderAddressesLazyQuery>;
export type ProformaOrderAddressesQueryResult = Apollo.QueryResult<ProformaOrderAddressesQuery, ProformaOrderAddressesQueryVariables>;
export const ProformaOrderLogisticsPartnerDocument = gql`
    query ProformaOrderLogisticsPartner($logisticsPartnerId: MongoID!) {
  LogisticsPartner(_id: $logisticsPartnerId) {
    ...ProformaLogisticsPartnerAddress
  }
}
    ${ProformaLogisticsPartnerAddressFragmentDoc}`;

/**
 * __useProformaOrderLogisticsPartnerQuery__
 *
 * To run a query within a React component, call `useProformaOrderLogisticsPartnerQuery` and pass it any options that fit your needs.
 * When your component renders, `useProformaOrderLogisticsPartnerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProformaOrderLogisticsPartnerQuery({
 *   variables: {
 *      logisticsPartnerId: // value for 'logisticsPartnerId'
 *   },
 * });
 */
export function useProformaOrderLogisticsPartnerQuery(baseOptions: Apollo.QueryHookOptions<ProformaOrderLogisticsPartnerQuery, ProformaOrderLogisticsPartnerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProformaOrderLogisticsPartnerQuery, ProformaOrderLogisticsPartnerQueryVariables>(ProformaOrderLogisticsPartnerDocument, options);
      }
export function useProformaOrderLogisticsPartnerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProformaOrderLogisticsPartnerQuery, ProformaOrderLogisticsPartnerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProformaOrderLogisticsPartnerQuery, ProformaOrderLogisticsPartnerQueryVariables>(ProformaOrderLogisticsPartnerDocument, options);
        }
export type ProformaOrderLogisticsPartnerQueryHookResult = ReturnType<typeof useProformaOrderLogisticsPartnerQuery>;
export type ProformaOrderLogisticsPartnerLazyQueryHookResult = ReturnType<typeof useProformaOrderLogisticsPartnerLazyQuery>;
export type ProformaOrderLogisticsPartnerQueryResult = Apollo.QueryResult<ProformaOrderLogisticsPartnerQuery, ProformaOrderLogisticsPartnerQueryVariables>;
export const RecalculatePricesDocument = gql`
    mutation recalculatePrices($brandHouseId: MongoID!, $input: BrandItemInputInput) {
  BrandItemCalculatePrices(brandHouseId: $brandHouseId, item: $input) {
    value
    currency
  }
}
    `;
export type RecalculatePricesMutationFn = Apollo.MutationFunction<RecalculatePricesMutation, RecalculatePricesMutationVariables>;

/**
 * __useRecalculatePricesMutation__
 *
 * To run a mutation, you first call `useRecalculatePricesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRecalculatePricesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [recalculatePricesMutation, { data, loading, error }] = useRecalculatePricesMutation({
 *   variables: {
 *      brandHouseId: // value for 'brandHouseId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRecalculatePricesMutation(baseOptions?: Apollo.MutationHookOptions<RecalculatePricesMutation, RecalculatePricesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RecalculatePricesMutation, RecalculatePricesMutationVariables>(RecalculatePricesDocument, options);
      }
export type RecalculatePricesMutationHookResult = ReturnType<typeof useRecalculatePricesMutation>;
export type RecalculatePricesMutationResult = Apollo.MutationResult<RecalculatePricesMutation>;
export type RecalculatePricesMutationOptions = Apollo.BaseMutationOptions<RecalculatePricesMutation, RecalculatePricesMutationVariables>;
export const ImageEditorImageDocument = gql`
    query imageEditorImage($imageId: MongoID!) {
  Image(_id: $imageId) {
    _id
    url
  }
}
    `;

/**
 * __useImageEditorImageQuery__
 *
 * To run a query within a React component, call `useImageEditorImageQuery` and pass it any options that fit your needs.
 * When your component renders, `useImageEditorImageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useImageEditorImageQuery({
 *   variables: {
 *      imageId: // value for 'imageId'
 *   },
 * });
 */
export function useImageEditorImageQuery(baseOptions: Apollo.QueryHookOptions<ImageEditorImageQuery, ImageEditorImageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ImageEditorImageQuery, ImageEditorImageQueryVariables>(ImageEditorImageDocument, options);
      }
export function useImageEditorImageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ImageEditorImageQuery, ImageEditorImageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ImageEditorImageQuery, ImageEditorImageQueryVariables>(ImageEditorImageDocument, options);
        }
export type ImageEditorImageQueryHookResult = ReturnType<typeof useImageEditorImageQuery>;
export type ImageEditorImageLazyQueryHookResult = ReturnType<typeof useImageEditorImageLazyQuery>;
export type ImageEditorImageQueryResult = Apollo.QueryResult<ImageEditorImageQuery, ImageEditorImageQueryVariables>;
export const ItemEditorImageDocument = gql`
    query itemEditorImage($imageId: MongoID!) {
  Image(_id: $imageId) {
    _id
    url
  }
}
    `;

/**
 * __useItemEditorImageQuery__
 *
 * To run a query within a React component, call `useItemEditorImageQuery` and pass it any options that fit your needs.
 * When your component renders, `useItemEditorImageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useItemEditorImageQuery({
 *   variables: {
 *      imageId: // value for 'imageId'
 *   },
 * });
 */
export function useItemEditorImageQuery(baseOptions: Apollo.QueryHookOptions<ItemEditorImageQuery, ItemEditorImageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ItemEditorImageQuery, ItemEditorImageQueryVariables>(ItemEditorImageDocument, options);
      }
export function useItemEditorImageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ItemEditorImageQuery, ItemEditorImageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ItemEditorImageQuery, ItemEditorImageQueryVariables>(ItemEditorImageDocument, options);
        }
export type ItemEditorImageQueryHookResult = ReturnType<typeof useItemEditorImageQuery>;
export type ItemEditorImageLazyQueryHookResult = ReturnType<typeof useItemEditorImageLazyQuery>;
export type ItemEditorImageQueryResult = Apollo.QueryResult<ItemEditorImageQuery, ItemEditorImageQueryVariables>;
export const ItemEditorImage2Document = gql`
    query itemEditorImage2($imageId: MongoID!) {
  StorageFileById(_id: $imageId) {
    _id
    url
  }
}
    `;

/**
 * __useItemEditorImage2Query__
 *
 * To run a query within a React component, call `useItemEditorImage2Query` and pass it any options that fit your needs.
 * When your component renders, `useItemEditorImage2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useItemEditorImage2Query({
 *   variables: {
 *      imageId: // value for 'imageId'
 *   },
 * });
 */
export function useItemEditorImage2Query(baseOptions: Apollo.QueryHookOptions<ItemEditorImage2Query, ItemEditorImage2QueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ItemEditorImage2Query, ItemEditorImage2QueryVariables>(ItemEditorImage2Document, options);
      }
export function useItemEditorImage2LazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ItemEditorImage2Query, ItemEditorImage2QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ItemEditorImage2Query, ItemEditorImage2QueryVariables>(ItemEditorImage2Document, options);
        }
export type ItemEditorImage2QueryHookResult = ReturnType<typeof useItemEditorImage2Query>;
export type ItemEditorImage2LazyQueryHookResult = ReturnType<typeof useItemEditorImage2LazyQuery>;
export type ItemEditorImage2QueryResult = Apollo.QueryResult<ItemEditorImage2Query, ItemEditorImage2QueryVariables>;
export const ItemEditorProductImageDocument = gql`
    query itemEditorProductImage($imageId: MongoID!) {
  BrandProductImage(_id: $imageId) {
    _id
    imageUrl
  }
}
    `;

/**
 * __useItemEditorProductImageQuery__
 *
 * To run a query within a React component, call `useItemEditorProductImageQuery` and pass it any options that fit your needs.
 * When your component renders, `useItemEditorProductImageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useItemEditorProductImageQuery({
 *   variables: {
 *      imageId: // value for 'imageId'
 *   },
 * });
 */
export function useItemEditorProductImageQuery(baseOptions: Apollo.QueryHookOptions<ItemEditorProductImageQuery, ItemEditorProductImageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ItemEditorProductImageQuery, ItemEditorProductImageQueryVariables>(ItemEditorProductImageDocument, options);
      }
export function useItemEditorProductImageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ItemEditorProductImageQuery, ItemEditorProductImageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ItemEditorProductImageQuery, ItemEditorProductImageQueryVariables>(ItemEditorProductImageDocument, options);
        }
export type ItemEditorProductImageQueryHookResult = ReturnType<typeof useItemEditorProductImageQuery>;
export type ItemEditorProductImageLazyQueryHookResult = ReturnType<typeof useItemEditorProductImageLazyQuery>;
export type ItemEditorProductImageQueryResult = Apollo.QueryResult<ItemEditorProductImageQuery, ItemEditorProductImageQueryVariables>;
export const BrandItemImageDocument = gql`
    query brandItemImage($imageId: MongoID!) {
  BrandItemImage(_id: $imageId) {
    _id
    processStart
    processError
    imageId
    uploadId
    originalImage
  }
}
    `;

/**
 * __useBrandItemImageQuery__
 *
 * To run a query within a React component, call `useBrandItemImageQuery` and pass it any options that fit your needs.
 * When your component renders, `useBrandItemImageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBrandItemImageQuery({
 *   variables: {
 *      imageId: // value for 'imageId'
 *   },
 * });
 */
export function useBrandItemImageQuery(baseOptions: Apollo.QueryHookOptions<BrandItemImageQuery, BrandItemImageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BrandItemImageQuery, BrandItemImageQueryVariables>(BrandItemImageDocument, options);
      }
export function useBrandItemImageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BrandItemImageQuery, BrandItemImageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BrandItemImageQuery, BrandItemImageQueryVariables>(BrandItemImageDocument, options);
        }
export type BrandItemImageQueryHookResult = ReturnType<typeof useBrandItemImageQuery>;
export type BrandItemImageLazyQueryHookResult = ReturnType<typeof useBrandItemImageLazyQuery>;
export type BrandItemImageQueryResult = Apollo.QueryResult<BrandItemImageQuery, BrandItemImageQueryVariables>;
export const BrandItemMasterImagesDocument = gql`
    query BrandItemMasterImages($brandItemId: MongoID!) {
  BrandItemMasterImages(brandItemId: $brandItemId) {
    externId
    imageId
    imageUrl
    color
    type
    perspective
    altText
    sourceType
  }
}
    `;

/**
 * __useBrandItemMasterImagesQuery__
 *
 * To run a query within a React component, call `useBrandItemMasterImagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useBrandItemMasterImagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBrandItemMasterImagesQuery({
 *   variables: {
 *      brandItemId: // value for 'brandItemId'
 *   },
 * });
 */
export function useBrandItemMasterImagesQuery(baseOptions: Apollo.QueryHookOptions<BrandItemMasterImagesQuery, BrandItemMasterImagesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BrandItemMasterImagesQuery, BrandItemMasterImagesQueryVariables>(BrandItemMasterImagesDocument, options);
      }
export function useBrandItemMasterImagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BrandItemMasterImagesQuery, BrandItemMasterImagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BrandItemMasterImagesQuery, BrandItemMasterImagesQueryVariables>(BrandItemMasterImagesDocument, options);
        }
export type BrandItemMasterImagesQueryHookResult = ReturnType<typeof useBrandItemMasterImagesQuery>;
export type BrandItemMasterImagesLazyQueryHookResult = ReturnType<typeof useBrandItemMasterImagesLazyQuery>;
export type BrandItemMasterImagesQueryResult = Apollo.QueryResult<BrandItemMasterImagesQuery, BrandItemMasterImagesQueryVariables>;
export const BrandItemPageSettingsDocument = gql`
    query brandItemPageSettings($brandHouseId: MongoID!) {
  ShopMany(filter: {brandHouseId: $brandHouseId}) {
    _id
    live
    settings {
      stockItemConfig {
        masterImageTypes
        masterImageCount
      }
    }
  }
}
    `;

/**
 * __useBrandItemPageSettingsQuery__
 *
 * To run a query within a React component, call `useBrandItemPageSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBrandItemPageSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBrandItemPageSettingsQuery({
 *   variables: {
 *      brandHouseId: // value for 'brandHouseId'
 *   },
 * });
 */
export function useBrandItemPageSettingsQuery(baseOptions: Apollo.QueryHookOptions<BrandItemPageSettingsQuery, BrandItemPageSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BrandItemPageSettingsQuery, BrandItemPageSettingsQueryVariables>(BrandItemPageSettingsDocument, options);
      }
export function useBrandItemPageSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BrandItemPageSettingsQuery, BrandItemPageSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BrandItemPageSettingsQuery, BrandItemPageSettingsQueryVariables>(BrandItemPageSettingsDocument, options);
        }
export type BrandItemPageSettingsQueryHookResult = ReturnType<typeof useBrandItemPageSettingsQuery>;
export type BrandItemPageSettingsLazyQueryHookResult = ReturnType<typeof useBrandItemPageSettingsLazyQuery>;
export type BrandItemPageSettingsQueryResult = Apollo.QueryResult<BrandItemPageSettingsQuery, BrandItemPageSettingsQueryVariables>;
export const BrandOptionsDocument = gql`
    query BrandOptions($brandHouseId: MongoID!) {
  itemOptions: Options(
    filter: {refId: $brandHouseId, target: ITEM, deleted: false}
  ) {
    ...OptionFragment
  }
  itemColors: Options(
    filter: {refId: $brandHouseId, target: ITEM_COLOR, deleted: false}
  ) {
    ...OptionFragment
  }
  itemVendors: Options(
    filter: {refId: $brandHouseId, target: VENDOR, deleted: false}
  ) {
    ...OptionFragment
  }
}
    ${OptionFragmentDoc}`;

/**
 * __useBrandOptionsQuery__
 *
 * To run a query within a React component, call `useBrandOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBrandOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBrandOptionsQuery({
 *   variables: {
 *      brandHouseId: // value for 'brandHouseId'
 *   },
 * });
 */
export function useBrandOptionsQuery(baseOptions: Apollo.QueryHookOptions<BrandOptionsQuery, BrandOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BrandOptionsQuery, BrandOptionsQueryVariables>(BrandOptionsDocument, options);
      }
export function useBrandOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BrandOptionsQuery, BrandOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BrandOptionsQuery, BrandOptionsQueryVariables>(BrandOptionsDocument, options);
        }
export type BrandOptionsQueryHookResult = ReturnType<typeof useBrandOptionsQuery>;
export type BrandOptionsLazyQueryHookResult = ReturnType<typeof useBrandOptionsLazyQuery>;
export type BrandOptionsQueryResult = Apollo.QueryResult<BrandOptionsQuery, BrandOptionsQueryVariables>;
export const BrandItemDocument = gql`
    query BrandItem($brandItemId: MongoID!) {
  BrandItem(_id: $brandItemId) {
    ...FragmentBrandItem
    resolved {
      ...FragmentBrandItemResolved
    }
    shops {
      shopId
      active
      shop {
        live
      }
    }
  }
}
    ${FragmentBrandItemFragmentDoc}
${FragmentBrandItemResolvedFragmentDoc}`;

/**
 * __useBrandItemQuery__
 *
 * To run a query within a React component, call `useBrandItemQuery` and pass it any options that fit your needs.
 * When your component renders, `useBrandItemQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBrandItemQuery({
 *   variables: {
 *      brandItemId: // value for 'brandItemId'
 *   },
 * });
 */
export function useBrandItemQuery(baseOptions: Apollo.QueryHookOptions<BrandItemQuery, BrandItemQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BrandItemQuery, BrandItemQueryVariables>(BrandItemDocument, options);
      }
export function useBrandItemLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BrandItemQuery, BrandItemQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BrandItemQuery, BrandItemQueryVariables>(BrandItemDocument, options);
        }
export type BrandItemQueryHookResult = ReturnType<typeof useBrandItemQuery>;
export type BrandItemLazyQueryHookResult = ReturnType<typeof useBrandItemLazyQuery>;
export type BrandItemQueryResult = Apollo.QueryResult<BrandItemQuery, BrandItemQueryVariables>;
export const BrandItemConflictCheckDocument = gql`
    query BrandItemConflictCheck($brandItemId: MongoID!) {
  BrandItem(_id: $brandItemId) {
    _id
    updatedAt
    updatedBy {
      ref
      type
    }
  }
  PatchPagination(
    sort: _ID_DESC
    perPage: 50
    page: 1
    filter: {ref: $brandItemId}
  ) {
    items {
      _id
      date
      updatedBy {
        ref
        type
      }
      ops {
        op
        path
        value
      }
    }
  }
}
    `;

/**
 * __useBrandItemConflictCheckQuery__
 *
 * To run a query within a React component, call `useBrandItemConflictCheckQuery` and pass it any options that fit your needs.
 * When your component renders, `useBrandItemConflictCheckQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBrandItemConflictCheckQuery({
 *   variables: {
 *      brandItemId: // value for 'brandItemId'
 *   },
 * });
 */
export function useBrandItemConflictCheckQuery(baseOptions: Apollo.QueryHookOptions<BrandItemConflictCheckQuery, BrandItemConflictCheckQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BrandItemConflictCheckQuery, BrandItemConflictCheckQueryVariables>(BrandItemConflictCheckDocument, options);
      }
export function useBrandItemConflictCheckLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BrandItemConflictCheckQuery, BrandItemConflictCheckQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BrandItemConflictCheckQuery, BrandItemConflictCheckQueryVariables>(BrandItemConflictCheckDocument, options);
        }
export type BrandItemConflictCheckQueryHookResult = ReturnType<typeof useBrandItemConflictCheckQuery>;
export type BrandItemConflictCheckLazyQueryHookResult = ReturnType<typeof useBrandItemConflictCheckLazyQuery>;
export type BrandItemConflictCheckQueryResult = Apollo.QueryResult<BrandItemConflictCheckQuery, BrandItemConflictCheckQueryVariables>;
export const BrandItemPageProductVariantSizeDocument = gql`
    query BrandItemPageProductVariantSize($brandProductSizeId: MongoID!) {
  BrandProductSize(_id: $brandProductSizeId) {
    _id
    sizeLocalized {
      locale
      value
    }
    ean
    sku
    brandVariant {
      _id
      brandProduct {
        nameLocalized {
          locale
          value
        }
        descriptionLocalized {
          locale
          value
        }
        typeLocalized {
          locale
          value
        }
        vendor
      }
      rrp {
        currency
        value
      }
      colorLocalized {
        locale
        value
      }
      images {
        _id
        imageId
        imageUrl
        type
      }
    }
  }
}
    `;

/**
 * __useBrandItemPageProductVariantSizeQuery__
 *
 * To run a query within a React component, call `useBrandItemPageProductVariantSizeQuery` and pass it any options that fit your needs.
 * When your component renders, `useBrandItemPageProductVariantSizeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBrandItemPageProductVariantSizeQuery({
 *   variables: {
 *      brandProductSizeId: // value for 'brandProductSizeId'
 *   },
 * });
 */
export function useBrandItemPageProductVariantSizeQuery(baseOptions: Apollo.QueryHookOptions<BrandItemPageProductVariantSizeQuery, BrandItemPageProductVariantSizeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BrandItemPageProductVariantSizeQuery, BrandItemPageProductVariantSizeQueryVariables>(BrandItemPageProductVariantSizeDocument, options);
      }
export function useBrandItemPageProductVariantSizeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BrandItemPageProductVariantSizeQuery, BrandItemPageProductVariantSizeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BrandItemPageProductVariantSizeQuery, BrandItemPageProductVariantSizeQueryVariables>(BrandItemPageProductVariantSizeDocument, options);
        }
export type BrandItemPageProductVariantSizeQueryHookResult = ReturnType<typeof useBrandItemPageProductVariantSizeQuery>;
export type BrandItemPageProductVariantSizeLazyQueryHookResult = ReturnType<typeof useBrandItemPageProductVariantSizeLazyQuery>;
export type BrandItemPageProductVariantSizeQueryResult = Apollo.QueryResult<BrandItemPageProductVariantSizeQuery, BrandItemPageProductVariantSizeQueryVariables>;
export const BrandItemUpdateDocument = gql`
    mutation BrandItemUpdate($brandHouseId: MongoID!, $input: BrandItemInputInput) {
  BrandItemUpdate(brandHouseId: $brandHouseId, input: $input) {
    _id
    ...FragmentBrandItem
    resolved {
      ...FragmentBrandItemResolved
    }
    brandProductSize {
      brandVariant {
        images {
          _id
        }
      }
    }
  }
}
    ${FragmentBrandItemFragmentDoc}
${FragmentBrandItemResolvedFragmentDoc}`;
export type BrandItemUpdateMutationFn = Apollo.MutationFunction<BrandItemUpdateMutation, BrandItemUpdateMutationVariables>;

/**
 * __useBrandItemUpdateMutation__
 *
 * To run a mutation, you first call `useBrandItemUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBrandItemUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [brandItemUpdateMutation, { data, loading, error }] = useBrandItemUpdateMutation({
 *   variables: {
 *      brandHouseId: // value for 'brandHouseId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBrandItemUpdateMutation(baseOptions?: Apollo.MutationHookOptions<BrandItemUpdateMutation, BrandItemUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BrandItemUpdateMutation, BrandItemUpdateMutationVariables>(BrandItemUpdateDocument, options);
      }
export type BrandItemUpdateMutationHookResult = ReturnType<typeof useBrandItemUpdateMutation>;
export type BrandItemUpdateMutationResult = Apollo.MutationResult<BrandItemUpdateMutation>;
export type BrandItemUpdateMutationOptions = Apollo.BaseMutationOptions<BrandItemUpdateMutation, BrandItemUpdateMutationVariables>;
export const BrandItemAttachSnapshotDocument = gql`
    mutation BrandItemAttachSnapshot($brandItemId: MongoID!, $brandProductSizeId: MongoID!) {
  BrandItemAttachSnapshot(
    brandItemId: $brandItemId
    brandProductSizeId: $brandProductSizeId
  ) {
    _id
    ...FragmentBrandItem
    resolved {
      ...FragmentBrandItemResolved
    }
  }
}
    ${FragmentBrandItemFragmentDoc}
${FragmentBrandItemResolvedFragmentDoc}`;
export type BrandItemAttachSnapshotMutationFn = Apollo.MutationFunction<BrandItemAttachSnapshotMutation, BrandItemAttachSnapshotMutationVariables>;

/**
 * __useBrandItemAttachSnapshotMutation__
 *
 * To run a mutation, you first call `useBrandItemAttachSnapshotMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBrandItemAttachSnapshotMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [brandItemAttachSnapshotMutation, { data, loading, error }] = useBrandItemAttachSnapshotMutation({
 *   variables: {
 *      brandItemId: // value for 'brandItemId'
 *      brandProductSizeId: // value for 'brandProductSizeId'
 *   },
 * });
 */
export function useBrandItemAttachSnapshotMutation(baseOptions?: Apollo.MutationHookOptions<BrandItemAttachSnapshotMutation, BrandItemAttachSnapshotMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BrandItemAttachSnapshotMutation, BrandItemAttachSnapshotMutationVariables>(BrandItemAttachSnapshotDocument, options);
      }
export type BrandItemAttachSnapshotMutationHookResult = ReturnType<typeof useBrandItemAttachSnapshotMutation>;
export type BrandItemAttachSnapshotMutationResult = Apollo.MutationResult<BrandItemAttachSnapshotMutation>;
export type BrandItemAttachSnapshotMutationOptions = Apollo.BaseMutationOptions<BrandItemAttachSnapshotMutation, BrandItemAttachSnapshotMutationVariables>;
export const BrandItemAttachMasterDataVariantDocument = gql`
    mutation BrandItemAttachMasterDataVariant($brandItemId: MongoID!, $masterDataVariantId: String!) {
  BrandItemAttachMasterDataVariant(
    brandItemId: $brandItemId
    masterDataVariantId: $masterDataVariantId
  ) {
    _id
    ...FragmentBrandItem
    resolved {
      ...FragmentBrandItemResolved
    }
  }
}
    ${FragmentBrandItemFragmentDoc}
${FragmentBrandItemResolvedFragmentDoc}`;
export type BrandItemAttachMasterDataVariantMutationFn = Apollo.MutationFunction<BrandItemAttachMasterDataVariantMutation, BrandItemAttachMasterDataVariantMutationVariables>;

/**
 * __useBrandItemAttachMasterDataVariantMutation__
 *
 * To run a mutation, you first call `useBrandItemAttachMasterDataVariantMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBrandItemAttachMasterDataVariantMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [brandItemAttachMasterDataVariantMutation, { data, loading, error }] = useBrandItemAttachMasterDataVariantMutation({
 *   variables: {
 *      brandItemId: // value for 'brandItemId'
 *      masterDataVariantId: // value for 'masterDataVariantId'
 *   },
 * });
 */
export function useBrandItemAttachMasterDataVariantMutation(baseOptions?: Apollo.MutationHookOptions<BrandItemAttachMasterDataVariantMutation, BrandItemAttachMasterDataVariantMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BrandItemAttachMasterDataVariantMutation, BrandItemAttachMasterDataVariantMutationVariables>(BrandItemAttachMasterDataVariantDocument, options);
      }
export type BrandItemAttachMasterDataVariantMutationHookResult = ReturnType<typeof useBrandItemAttachMasterDataVariantMutation>;
export type BrandItemAttachMasterDataVariantMutationResult = Apollo.MutationResult<BrandItemAttachMasterDataVariantMutation>;
export type BrandItemAttachMasterDataVariantMutationOptions = Apollo.BaseMutationOptions<BrandItemAttachMasterDataVariantMutation, BrandItemAttachMasterDataVariantMutationVariables>;
export const BrandItemSettingsDocument = gql`
    query BrandItemSettings($brandHouseId: MongoID!) {
  BrandSettings(brandHouseId: $brandHouseId) {
    _id
    locales {
      locale
      activeItems
    }
    stockItemConfig {
      currencies {
        currency
        active
      }
      titlePrefix
      vendor
    }
    tradeInComments
  }
  ShopMany(filter: {brandHouseId: $brandHouseId}) {
    _id
    live
    settings {
      stockItemConfig {
        titlePrefix
        vendor
      }
    }
  }
  BrandHouse(id: $brandHouseId) {
    _id
    productTags
    productTypes {
      locale
      value
    }
  }
}
    `;

/**
 * __useBrandItemSettingsQuery__
 *
 * To run a query within a React component, call `useBrandItemSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBrandItemSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBrandItemSettingsQuery({
 *   variables: {
 *      brandHouseId: // value for 'brandHouseId'
 *   },
 * });
 */
export function useBrandItemSettingsQuery(baseOptions: Apollo.QueryHookOptions<BrandItemSettingsQuery, BrandItemSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BrandItemSettingsQuery, BrandItemSettingsQueryVariables>(BrandItemSettingsDocument, options);
      }
export function useBrandItemSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BrandItemSettingsQuery, BrandItemSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BrandItemSettingsQuery, BrandItemSettingsQueryVariables>(BrandItemSettingsDocument, options);
        }
export type BrandItemSettingsQueryHookResult = ReturnType<typeof useBrandItemSettingsQuery>;
export type BrandItemSettingsLazyQueryHookResult = ReturnType<typeof useBrandItemSettingsLazyQuery>;
export type BrandItemSettingsQueryResult = Apollo.QueryResult<BrandItemSettingsQuery, BrandItemSettingsQueryVariables>;
export const BrandItemPageDeleteDocument = gql`
    mutation BrandItemPageDelete($brandItemId: MongoID!) {
  BrandItemDelete(brandItemId: $brandItemId) {
    _id
    deleted
  }
}
    `;
export type BrandItemPageDeleteMutationFn = Apollo.MutationFunction<BrandItemPageDeleteMutation, BrandItemPageDeleteMutationVariables>;

/**
 * __useBrandItemPageDeleteMutation__
 *
 * To run a mutation, you first call `useBrandItemPageDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBrandItemPageDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [brandItemPageDeleteMutation, { data, loading, error }] = useBrandItemPageDeleteMutation({
 *   variables: {
 *      brandItemId: // value for 'brandItemId'
 *   },
 * });
 */
export function useBrandItemPageDeleteMutation(baseOptions?: Apollo.MutationHookOptions<BrandItemPageDeleteMutation, BrandItemPageDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BrandItemPageDeleteMutation, BrandItemPageDeleteMutationVariables>(BrandItemPageDeleteDocument, options);
      }
export type BrandItemPageDeleteMutationHookResult = ReturnType<typeof useBrandItemPageDeleteMutation>;
export type BrandItemPageDeleteMutationResult = Apollo.MutationResult<BrandItemPageDeleteMutation>;
export type BrandItemPageDeleteMutationOptions = Apollo.BaseMutationOptions<BrandItemPageDeleteMutation, BrandItemPageDeleteMutationVariables>;
export const BrandItemMasterDataDocument = gql`
    query BrandItemMasterData($brandProductSizeId: MongoID!) {
  BrandProductSize(_id: $brandProductSizeId) {
    externalId
    ean
    sku
    brandVariant {
      _id
      color
      colorLocalized {
        locale
        value
      }
      brandProduct {
        _id
        collections
        tags
        nameLocalized {
          locale
          value
        }
        name
      }
      images {
        _id
        imageId
        imageUrl
        type
      }
      imageUrls
    }
  }
}
    `;

/**
 * __useBrandItemMasterDataQuery__
 *
 * To run a query within a React component, call `useBrandItemMasterDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useBrandItemMasterDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBrandItemMasterDataQuery({
 *   variables: {
 *      brandProductSizeId: // value for 'brandProductSizeId'
 *   },
 * });
 */
export function useBrandItemMasterDataQuery(baseOptions: Apollo.QueryHookOptions<BrandItemMasterDataQuery, BrandItemMasterDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BrandItemMasterDataQuery, BrandItemMasterDataQueryVariables>(BrandItemMasterDataDocument, options);
      }
export function useBrandItemMasterDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BrandItemMasterDataQuery, BrandItemMasterDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BrandItemMasterDataQuery, BrandItemMasterDataQueryVariables>(BrandItemMasterDataDocument, options);
        }
export type BrandItemMasterDataQueryHookResult = ReturnType<typeof useBrandItemMasterDataQuery>;
export type BrandItemMasterDataLazyQueryHookResult = ReturnType<typeof useBrandItemMasterDataLazyQuery>;
export type BrandItemMasterDataQueryResult = Apollo.QueryResult<BrandItemMasterDataQuery, BrandItemMasterDataQueryVariables>;
export const PromoteToMasterDataDocument = gql`
    mutation promoteToMasterData($brandItemId: MongoID!) {
  BrandItemPromote(brandItemId: $brandItemId) {
    ...FragmentBrandItem
    resolved {
      ...FragmentBrandItemResolved
    }
  }
}
    ${FragmentBrandItemFragmentDoc}
${FragmentBrandItemResolvedFragmentDoc}`;
export type PromoteToMasterDataMutationFn = Apollo.MutationFunction<PromoteToMasterDataMutation, PromoteToMasterDataMutationVariables>;

/**
 * __usePromoteToMasterDataMutation__
 *
 * To run a mutation, you first call `usePromoteToMasterDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePromoteToMasterDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [promoteToMasterDataMutation, { data, loading, error }] = usePromoteToMasterDataMutation({
 *   variables: {
 *      brandItemId: // value for 'brandItemId'
 *   },
 * });
 */
export function usePromoteToMasterDataMutation(baseOptions?: Apollo.MutationHookOptions<PromoteToMasterDataMutation, PromoteToMasterDataMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PromoteToMasterDataMutation, PromoteToMasterDataMutationVariables>(PromoteToMasterDataDocument, options);
      }
export type PromoteToMasterDataMutationHookResult = ReturnType<typeof usePromoteToMasterDataMutation>;
export type PromoteToMasterDataMutationResult = Apollo.MutationResult<PromoteToMasterDataMutation>;
export type PromoteToMasterDataMutationOptions = Apollo.BaseMutationOptions<PromoteToMasterDataMutation, PromoteToMasterDataMutationVariables>;
export const RelatedIdentifiersDocument = gql`
    query relatedIdentifiers($brandItemId: MongoID!) {
  BrandItemRelatedIdentifiers(brandItemId: $brandItemId)
}
    `;

/**
 * __useRelatedIdentifiersQuery__
 *
 * To run a query within a React component, call `useRelatedIdentifiersQuery` and pass it any options that fit your needs.
 * When your component renders, `useRelatedIdentifiersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRelatedIdentifiersQuery({
 *   variables: {
 *      brandItemId: // value for 'brandItemId'
 *   },
 * });
 */
export function useRelatedIdentifiersQuery(baseOptions: Apollo.QueryHookOptions<RelatedIdentifiersQuery, RelatedIdentifiersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RelatedIdentifiersQuery, RelatedIdentifiersQueryVariables>(RelatedIdentifiersDocument, options);
      }
export function useRelatedIdentifiersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RelatedIdentifiersQuery, RelatedIdentifiersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RelatedIdentifiersQuery, RelatedIdentifiersQueryVariables>(RelatedIdentifiersDocument, options);
        }
export type RelatedIdentifiersQueryHookResult = ReturnType<typeof useRelatedIdentifiersQuery>;
export type RelatedIdentifiersLazyQueryHookResult = ReturnType<typeof useRelatedIdentifiersLazyQuery>;
export type RelatedIdentifiersQueryResult = Apollo.QueryResult<RelatedIdentifiersQuery, RelatedIdentifiersQueryVariables>;
export const ItemIssuesDocument = gql`
    query itemIssues($search: String, $filter: FilterFindManyItemIssueInput, $sort: SortFindManyItemIssueInput, $page: Int, $perPage: Int) {
  ItemIssues(
    search: $search
    filter: $filter
    sort: $sort
    page: $page
    perPage: $perPage
  ) {
    count
    items {
      ...ItemIssueFragment
    }
  }
}
    ${ItemIssueFragmentDoc}`;

/**
 * __useItemIssuesQuery__
 *
 * To run a query within a React component, call `useItemIssuesQuery` and pass it any options that fit your needs.
 * When your component renders, `useItemIssuesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useItemIssuesQuery({
 *   variables: {
 *      search: // value for 'search'
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *   },
 * });
 */
export function useItemIssuesQuery(baseOptions?: Apollo.QueryHookOptions<ItemIssuesQuery, ItemIssuesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ItemIssuesQuery, ItemIssuesQueryVariables>(ItemIssuesDocument, options);
      }
export function useItemIssuesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ItemIssuesQuery, ItemIssuesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ItemIssuesQuery, ItemIssuesQueryVariables>(ItemIssuesDocument, options);
        }
export type ItemIssuesQueryHookResult = ReturnType<typeof useItemIssuesQuery>;
export type ItemIssuesLazyQueryHookResult = ReturnType<typeof useItemIssuesLazyQuery>;
export type ItemIssuesQueryResult = Apollo.QueryResult<ItemIssuesQuery, ItemIssuesQueryVariables>;
export const BrandConsumersPagePaginationDocument = gql`
    query BrandConsumersPagePagination($page: Int, $perPage: Int, $search: String, $sort: SortFindManyConsumerInput, $filter: FilterFindManyConsumerInput, $viewId: MongoID) {
  ConsumerPagination(
    page: $page
    perPage: $perPage
    search: $search
    sort: $sort
    filter: $filter
    viewId: $viewId
  ) {
    count
    items {
      _id
      name
      firstName
      lastName
      mail
      phone
      add1
      add2
      zipCode
      city
      country
      countryCode
      statistics {
        tradeIns
        orders
      }
      acceptsMarketing
      selfCreated
      proxyAccount
      shopId
      shop {
        _id
        name
      }
      createdAt
      lastLogin
    }
  }
}
    `;

/**
 * __useBrandConsumersPagePaginationQuery__
 *
 * To run a query within a React component, call `useBrandConsumersPagePaginationQuery` and pass it any options that fit your needs.
 * When your component renders, `useBrandConsumersPagePaginationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBrandConsumersPagePaginationQuery({
 *   variables: {
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *      search: // value for 'search'
 *      sort: // value for 'sort'
 *      filter: // value for 'filter'
 *      viewId: // value for 'viewId'
 *   },
 * });
 */
export function useBrandConsumersPagePaginationQuery(baseOptions?: Apollo.QueryHookOptions<BrandConsumersPagePaginationQuery, BrandConsumersPagePaginationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BrandConsumersPagePaginationQuery, BrandConsumersPagePaginationQueryVariables>(BrandConsumersPagePaginationDocument, options);
      }
export function useBrandConsumersPagePaginationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BrandConsumersPagePaginationQuery, BrandConsumersPagePaginationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BrandConsumersPagePaginationQuery, BrandConsumersPagePaginationQueryVariables>(BrandConsumersPagePaginationDocument, options);
        }
export type BrandConsumersPagePaginationQueryHookResult = ReturnType<typeof useBrandConsumersPagePaginationQuery>;
export type BrandConsumersPagePaginationLazyQueryHookResult = ReturnType<typeof useBrandConsumersPagePaginationLazyQuery>;
export type BrandConsumersPagePaginationQueryResult = Apollo.QueryResult<BrandConsumersPagePaginationQuery, BrandConsumersPagePaginationQueryVariables>;
export const BrandConsumersPageSelectAllDocument = gql`
    query BrandConsumersPageSelectAll($filter: FilterFindManyConsumerInput, $viewId: MongoID) {
  ConsumerPagination(perPage: 10000, filter: $filter, viewId: $viewId) {
    items {
      _id
    }
  }
}
    `;

/**
 * __useBrandConsumersPageSelectAllQuery__
 *
 * To run a query within a React component, call `useBrandConsumersPageSelectAllQuery` and pass it any options that fit your needs.
 * When your component renders, `useBrandConsumersPageSelectAllQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBrandConsumersPageSelectAllQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      viewId: // value for 'viewId'
 *   },
 * });
 */
export function useBrandConsumersPageSelectAllQuery(baseOptions?: Apollo.QueryHookOptions<BrandConsumersPageSelectAllQuery, BrandConsumersPageSelectAllQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BrandConsumersPageSelectAllQuery, BrandConsumersPageSelectAllQueryVariables>(BrandConsumersPageSelectAllDocument, options);
      }
export function useBrandConsumersPageSelectAllLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BrandConsumersPageSelectAllQuery, BrandConsumersPageSelectAllQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BrandConsumersPageSelectAllQuery, BrandConsumersPageSelectAllQueryVariables>(BrandConsumersPageSelectAllDocument, options);
        }
export type BrandConsumersPageSelectAllQueryHookResult = ReturnType<typeof useBrandConsumersPageSelectAllQuery>;
export type BrandConsumersPageSelectAllLazyQueryHookResult = ReturnType<typeof useBrandConsumersPageSelectAllLazyQuery>;
export type BrandConsumersPageSelectAllQueryResult = Apollo.QueryResult<BrandConsumersPageSelectAllQuery, BrandConsumersPageSelectAllQueryVariables>;
export const BrandConsumersPageShopsDocument = gql`
    query BrandConsumersPageShops($brandHouseId: MongoID!) {
  ShopMany(filter: {brandHouseId: $brandHouseId}) {
    _id
    name
  }
}
    `;

/**
 * __useBrandConsumersPageShopsQuery__
 *
 * To run a query within a React component, call `useBrandConsumersPageShopsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBrandConsumersPageShopsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBrandConsumersPageShopsQuery({
 *   variables: {
 *      brandHouseId: // value for 'brandHouseId'
 *   },
 * });
 */
export function useBrandConsumersPageShopsQuery(baseOptions: Apollo.QueryHookOptions<BrandConsumersPageShopsQuery, BrandConsumersPageShopsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BrandConsumersPageShopsQuery, BrandConsumersPageShopsQueryVariables>(BrandConsumersPageShopsDocument, options);
      }
export function useBrandConsumersPageShopsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BrandConsumersPageShopsQuery, BrandConsumersPageShopsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BrandConsumersPageShopsQuery, BrandConsumersPageShopsQueryVariables>(BrandConsumersPageShopsDocument, options);
        }
export type BrandConsumersPageShopsQueryHookResult = ReturnType<typeof useBrandConsumersPageShopsQuery>;
export type BrandConsumersPageShopsLazyQueryHookResult = ReturnType<typeof useBrandConsumersPageShopsLazyQuery>;
export type BrandConsumersPageShopsQueryResult = Apollo.QueryResult<BrandConsumersPageShopsQuery, BrandConsumersPageShopsQueryVariables>;
export const BrandConsumersPageMergeDocument = gql`
    mutation BrandConsumersPageMerge($consumerIds: [MongoID!]!) {
  ConsumerMerge(consumerIds: $consumerIds) {
    id
  }
}
    `;
export type BrandConsumersPageMergeMutationFn = Apollo.MutationFunction<BrandConsumersPageMergeMutation, BrandConsumersPageMergeMutationVariables>;

/**
 * __useBrandConsumersPageMergeMutation__
 *
 * To run a mutation, you first call `useBrandConsumersPageMergeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBrandConsumersPageMergeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [brandConsumersPageMergeMutation, { data, loading, error }] = useBrandConsumersPageMergeMutation({
 *   variables: {
 *      consumerIds: // value for 'consumerIds'
 *   },
 * });
 */
export function useBrandConsumersPageMergeMutation(baseOptions?: Apollo.MutationHookOptions<BrandConsumersPageMergeMutation, BrandConsumersPageMergeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BrandConsumersPageMergeMutation, BrandConsumersPageMergeMutationVariables>(BrandConsumersPageMergeDocument, options);
      }
export type BrandConsumersPageMergeMutationHookResult = ReturnType<typeof useBrandConsumersPageMergeMutation>;
export type BrandConsumersPageMergeMutationResult = Apollo.MutationResult<BrandConsumersPageMergeMutation>;
export type BrandConsumersPageMergeMutationOptions = Apollo.BaseMutationOptions<BrandConsumersPageMergeMutation, BrandConsumersPageMergeMutationVariables>;
export const BrandConsumersPageRequestPotentialsDocument = gql`
    mutation BrandConsumersPageRequestPotentials($shopId: MongoID!, $identifier: String!, $identifierType: ConsumerIdentifierEnum!) {
  ConsumerRequestPotentials(
    shopId: $shopId
    consumerId: "ignore"
    identifier: $identifier
    identifierType: $identifierType
  )
}
    `;
export type BrandConsumersPageRequestPotentialsMutationFn = Apollo.MutationFunction<BrandConsumersPageRequestPotentialsMutation, BrandConsumersPageRequestPotentialsMutationVariables>;

/**
 * __useBrandConsumersPageRequestPotentialsMutation__
 *
 * To run a mutation, you first call `useBrandConsumersPageRequestPotentialsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBrandConsumersPageRequestPotentialsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [brandConsumersPageRequestPotentialsMutation, { data, loading, error }] = useBrandConsumersPageRequestPotentialsMutation({
 *   variables: {
 *      shopId: // value for 'shopId'
 *      identifier: // value for 'identifier'
 *      identifierType: // value for 'identifierType'
 *   },
 * });
 */
export function useBrandConsumersPageRequestPotentialsMutation(baseOptions?: Apollo.MutationHookOptions<BrandConsumersPageRequestPotentialsMutation, BrandConsumersPageRequestPotentialsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BrandConsumersPageRequestPotentialsMutation, BrandConsumersPageRequestPotentialsMutationVariables>(BrandConsumersPageRequestPotentialsDocument, options);
      }
export type BrandConsumersPageRequestPotentialsMutationHookResult = ReturnType<typeof useBrandConsumersPageRequestPotentialsMutation>;
export type BrandConsumersPageRequestPotentialsMutationResult = Apollo.MutationResult<BrandConsumersPageRequestPotentialsMutation>;
export type BrandConsumersPageRequestPotentialsMutationOptions = Apollo.BaseMutationOptions<BrandConsumersPageRequestPotentialsMutation, BrandConsumersPageRequestPotentialsMutationVariables>;
export const BrandConsumersPageIntegrationMessageDocument = gql`
    query BrandConsumersPageIntegrationMessage($tokens: [String!]) {
  IntegrationMessage(tokens: $tokens) {
    result
    messageFailed
    resultTs
  }
}
    `;

/**
 * __useBrandConsumersPageIntegrationMessageQuery__
 *
 * To run a query within a React component, call `useBrandConsumersPageIntegrationMessageQuery` and pass it any options that fit your needs.
 * When your component renders, `useBrandConsumersPageIntegrationMessageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBrandConsumersPageIntegrationMessageQuery({
 *   variables: {
 *      tokens: // value for 'tokens'
 *   },
 * });
 */
export function useBrandConsumersPageIntegrationMessageQuery(baseOptions?: Apollo.QueryHookOptions<BrandConsumersPageIntegrationMessageQuery, BrandConsumersPageIntegrationMessageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BrandConsumersPageIntegrationMessageQuery, BrandConsumersPageIntegrationMessageQueryVariables>(BrandConsumersPageIntegrationMessageDocument, options);
      }
export function useBrandConsumersPageIntegrationMessageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BrandConsumersPageIntegrationMessageQuery, BrandConsumersPageIntegrationMessageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BrandConsumersPageIntegrationMessageQuery, BrandConsumersPageIntegrationMessageQueryVariables>(BrandConsumersPageIntegrationMessageDocument, options);
        }
export type BrandConsumersPageIntegrationMessageQueryHookResult = ReturnType<typeof useBrandConsumersPageIntegrationMessageQuery>;
export type BrandConsumersPageIntegrationMessageLazyQueryHookResult = ReturnType<typeof useBrandConsumersPageIntegrationMessageLazyQuery>;
export type BrandConsumersPageIntegrationMessageQueryResult = Apollo.QueryResult<BrandConsumersPageIntegrationMessageQuery, BrandConsumersPageIntegrationMessageQueryVariables>;
export const BrandConsumersPageRequestPotentialsShopsDocument = gql`
    query BrandConsumersPageRequestPotentialsShops($brandHouseId: MongoID!) {
  ShopMany(filter: {brandHouseId: $brandHouseId}) {
    _id
    name
  }
}
    `;

/**
 * __useBrandConsumersPageRequestPotentialsShopsQuery__
 *
 * To run a query within a React component, call `useBrandConsumersPageRequestPotentialsShopsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBrandConsumersPageRequestPotentialsShopsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBrandConsumersPageRequestPotentialsShopsQuery({
 *   variables: {
 *      brandHouseId: // value for 'brandHouseId'
 *   },
 * });
 */
export function useBrandConsumersPageRequestPotentialsShopsQuery(baseOptions: Apollo.QueryHookOptions<BrandConsumersPageRequestPotentialsShopsQuery, BrandConsumersPageRequestPotentialsShopsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BrandConsumersPageRequestPotentialsShopsQuery, BrandConsumersPageRequestPotentialsShopsQueryVariables>(BrandConsumersPageRequestPotentialsShopsDocument, options);
      }
export function useBrandConsumersPageRequestPotentialsShopsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BrandConsumersPageRequestPotentialsShopsQuery, BrandConsumersPageRequestPotentialsShopsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BrandConsumersPageRequestPotentialsShopsQuery, BrandConsumersPageRequestPotentialsShopsQueryVariables>(BrandConsumersPageRequestPotentialsShopsDocument, options);
        }
export type BrandConsumersPageRequestPotentialsShopsQueryHookResult = ReturnType<typeof useBrandConsumersPageRequestPotentialsShopsQuery>;
export type BrandConsumersPageRequestPotentialsShopsLazyQueryHookResult = ReturnType<typeof useBrandConsumersPageRequestPotentialsShopsLazyQuery>;
export type BrandConsumersPageRequestPotentialsShopsQueryResult = Apollo.QueryResult<BrandConsumersPageRequestPotentialsShopsQuery, BrandConsumersPageRequestPotentialsShopsQueryVariables>;
export const DashboardBrandItemDrilldownItemsDocument = gql`
    query DashboardBrandItemDrilldownItems($ids: [MongoID!]) {
  BrandItems(ids: $ids) {
    _id
    itemNr
    itemState
    discarded
    soldTs
    resolved {
      ...FlexBrandItem
    }
  }
}
    ${FlexBrandItemFragmentDoc}`;

/**
 * __useDashboardBrandItemDrilldownItemsQuery__
 *
 * To run a query within a React component, call `useDashboardBrandItemDrilldownItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDashboardBrandItemDrilldownItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDashboardBrandItemDrilldownItemsQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useDashboardBrandItemDrilldownItemsQuery(baseOptions?: Apollo.QueryHookOptions<DashboardBrandItemDrilldownItemsQuery, DashboardBrandItemDrilldownItemsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DashboardBrandItemDrilldownItemsQuery, DashboardBrandItemDrilldownItemsQueryVariables>(DashboardBrandItemDrilldownItemsDocument, options);
      }
export function useDashboardBrandItemDrilldownItemsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DashboardBrandItemDrilldownItemsQuery, DashboardBrandItemDrilldownItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DashboardBrandItemDrilldownItemsQuery, DashboardBrandItemDrilldownItemsQueryVariables>(DashboardBrandItemDrilldownItemsDocument, options);
        }
export type DashboardBrandItemDrilldownItemsQueryHookResult = ReturnType<typeof useDashboardBrandItemDrilldownItemsQuery>;
export type DashboardBrandItemDrilldownItemsLazyQueryHookResult = ReturnType<typeof useDashboardBrandItemDrilldownItemsLazyQuery>;
export type DashboardBrandItemDrilldownItemsQueryResult = Apollo.QueryResult<DashboardBrandItemDrilldownItemsQuery, DashboardBrandItemDrilldownItemsQueryVariables>;
export const DashboardBrandItemTimelineDocument = gql`
    query DashboardBrandItemTimeline($brandItemId: MongoID!, $brandHouseId: MongoID!) {
  BrandItem(_id: $brandItemId) {
    _id
    createdAt
    daysForSale
    discarded
    firstListedDate
    soldTs
    views
    tradeInItem {
      _id
      createdAt
      tradeIn {
        _id
        dateTime
        registeredTs
        tradeInNr
      }
    }
    vas {
      vasId
      vasName
      completed
      completedDate
      workflowName
    }
    shops {
      _id
      shop {
        _id
        name
      }
      stockItem {
        _id
        orderlines {
          _id
          cancelled
          returned
          returnedTs
          order {
            _id
            orderName
            orderDate
            returnLines {
              _id
              createdAt
              orderLineId
              returnReason
            }
          }
        }
      }
    }
  }
  Options(filter: {refId: $brandHouseId, refType: BRANDHOUSE, target: RETURNCODE}) {
    ...ReasonOptionFragment
  }
}
    ${ReasonOptionFragmentDoc}`;

/**
 * __useDashboardBrandItemTimelineQuery__
 *
 * To run a query within a React component, call `useDashboardBrandItemTimelineQuery` and pass it any options that fit your needs.
 * When your component renders, `useDashboardBrandItemTimelineQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDashboardBrandItemTimelineQuery({
 *   variables: {
 *      brandItemId: // value for 'brandItemId'
 *      brandHouseId: // value for 'brandHouseId'
 *   },
 * });
 */
export function useDashboardBrandItemTimelineQuery(baseOptions: Apollo.QueryHookOptions<DashboardBrandItemTimelineQuery, DashboardBrandItemTimelineQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DashboardBrandItemTimelineQuery, DashboardBrandItemTimelineQueryVariables>(DashboardBrandItemTimelineDocument, options);
      }
export function useDashboardBrandItemTimelineLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DashboardBrandItemTimelineQuery, DashboardBrandItemTimelineQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DashboardBrandItemTimelineQuery, DashboardBrandItemTimelineQueryVariables>(DashboardBrandItemTimelineDocument, options);
        }
export type DashboardBrandItemTimelineQueryHookResult = ReturnType<typeof useDashboardBrandItemTimelineQuery>;
export type DashboardBrandItemTimelineLazyQueryHookResult = ReturnType<typeof useDashboardBrandItemTimelineLazyQuery>;
export type DashboardBrandItemTimelineQueryResult = Apollo.QueryResult<DashboardBrandItemTimelineQuery, DashboardBrandItemTimelineQueryVariables>;
export const MasterDataProductSettingsDocument = gql`
    query masterDataProductSettings($brandHouseId: MongoID!) {
  BrandSettings(brandHouseId: $brandHouseId) {
    _id
    locales {
      activeItems
      locale
    }
    stockItemConfig {
      currencies {
        currency
        active
      }
    }
  }
}
    `;

/**
 * __useMasterDataProductSettingsQuery__
 *
 * To run a query within a React component, call `useMasterDataProductSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMasterDataProductSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMasterDataProductSettingsQuery({
 *   variables: {
 *      brandHouseId: // value for 'brandHouseId'
 *   },
 * });
 */
export function useMasterDataProductSettingsQuery(baseOptions: Apollo.QueryHookOptions<MasterDataProductSettingsQuery, MasterDataProductSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MasterDataProductSettingsQuery, MasterDataProductSettingsQueryVariables>(MasterDataProductSettingsDocument, options);
      }
export function useMasterDataProductSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MasterDataProductSettingsQuery, MasterDataProductSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MasterDataProductSettingsQuery, MasterDataProductSettingsQueryVariables>(MasterDataProductSettingsDocument, options);
        }
export type MasterDataProductSettingsQueryHookResult = ReturnType<typeof useMasterDataProductSettingsQuery>;
export type MasterDataProductSettingsLazyQueryHookResult = ReturnType<typeof useMasterDataProductSettingsLazyQuery>;
export type MasterDataProductSettingsQueryResult = Apollo.QueryResult<MasterDataProductSettingsQuery, MasterDataProductSettingsQueryVariables>;
export const MasterDataProductDocument = gql`
    query masterDataProduct($id: MongoID!) {
  BrandProduct(_id: $id) {
    ...brandProductFragment
  }
}
    ${BrandProductFragmentDoc}`;

/**
 * __useMasterDataProductQuery__
 *
 * To run a query within a React component, call `useMasterDataProductQuery` and pass it any options that fit your needs.
 * When your component renders, `useMasterDataProductQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMasterDataProductQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMasterDataProductQuery(baseOptions: Apollo.QueryHookOptions<MasterDataProductQuery, MasterDataProductQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MasterDataProductQuery, MasterDataProductQueryVariables>(MasterDataProductDocument, options);
      }
export function useMasterDataProductLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MasterDataProductQuery, MasterDataProductQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MasterDataProductQuery, MasterDataProductQueryVariables>(MasterDataProductDocument, options);
        }
export type MasterDataProductQueryHookResult = ReturnType<typeof useMasterDataProductQuery>;
export type MasterDataProductLazyQueryHookResult = ReturnType<typeof useMasterDataProductLazyQuery>;
export type MasterDataProductQueryResult = Apollo.QueryResult<MasterDataProductQuery, MasterDataProductQueryVariables>;
export const MasterDataSynchronizeDocument = gql`
    mutation masterDataSynchronize($brandHouseId: MongoID!, $input: BrandProductSynchronizeInput!) {
  BrandProductSynchronize(
    brandHouseId: $brandHouseId
    input: $input
    source: "Editor"
    mode: REPLACE
  ) {
    ...brandProductFragment
  }
}
    ${BrandProductFragmentDoc}`;
export type MasterDataSynchronizeMutationFn = Apollo.MutationFunction<MasterDataSynchronizeMutation, MasterDataSynchronizeMutationVariables>;

/**
 * __useMasterDataSynchronizeMutation__
 *
 * To run a mutation, you first call `useMasterDataSynchronizeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMasterDataSynchronizeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [masterDataSynchronizeMutation, { data, loading, error }] = useMasterDataSynchronizeMutation({
 *   variables: {
 *      brandHouseId: // value for 'brandHouseId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMasterDataSynchronizeMutation(baseOptions?: Apollo.MutationHookOptions<MasterDataSynchronizeMutation, MasterDataSynchronizeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MasterDataSynchronizeMutation, MasterDataSynchronizeMutationVariables>(MasterDataSynchronizeDocument, options);
      }
export type MasterDataSynchronizeMutationHookResult = ReturnType<typeof useMasterDataSynchronizeMutation>;
export type MasterDataSynchronizeMutationResult = Apollo.MutationResult<MasterDataSynchronizeMutation>;
export type MasterDataSynchronizeMutationOptions = Apollo.BaseMutationOptions<MasterDataSynchronizeMutation, MasterDataSynchronizeMutationVariables>;
export const GroupsDocument = gql`
    query groups($brandHouseId: MongoID!) {
  BrandProductGroups(filter: {brandHouseId: $brandHouseId}) {
    ...GroupFragment
  }
}
    ${GroupFragmentDoc}`;

/**
 * __useGroupsQuery__
 *
 * To run a query within a React component, call `useGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGroupsQuery({
 *   variables: {
 *      brandHouseId: // value for 'brandHouseId'
 *   },
 * });
 */
export function useGroupsQuery(baseOptions: Apollo.QueryHookOptions<GroupsQuery, GroupsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GroupsQuery, GroupsQueryVariables>(GroupsDocument, options);
      }
export function useGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GroupsQuery, GroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GroupsQuery, GroupsQueryVariables>(GroupsDocument, options);
        }
export type GroupsQueryHookResult = ReturnType<typeof useGroupsQuery>;
export type GroupsLazyQueryHookResult = ReturnType<typeof useGroupsLazyQuery>;
export type GroupsQueryResult = Apollo.QueryResult<GroupsQuery, GroupsQueryVariables>;
export const GroupCreateDocument = gql`
    mutation groupCreate($input: CreateOneBrandProductGroupInput!) {
  BrandProductGroupCreate(record: $input) {
    record {
      ...GroupFragment
    }
    error {
      message
    }
    recordId
  }
}
    ${GroupFragmentDoc}`;
export type GroupCreateMutationFn = Apollo.MutationFunction<GroupCreateMutation, GroupCreateMutationVariables>;

/**
 * __useGroupCreateMutation__
 *
 * To run a mutation, you first call `useGroupCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGroupCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [groupCreateMutation, { data, loading, error }] = useGroupCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGroupCreateMutation(baseOptions?: Apollo.MutationHookOptions<GroupCreateMutation, GroupCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GroupCreateMutation, GroupCreateMutationVariables>(GroupCreateDocument, options);
      }
export type GroupCreateMutationHookResult = ReturnType<typeof useGroupCreateMutation>;
export type GroupCreateMutationResult = Apollo.MutationResult<GroupCreateMutation>;
export type GroupCreateMutationOptions = Apollo.BaseMutationOptions<GroupCreateMutation, GroupCreateMutationVariables>;
export const GroupUpdateDocument = gql`
    mutation groupUpdate($groupId: MongoID!, $input: UpdateByIdBrandProductGroupInput!) {
  BrandProductGroupUpdate(_id: $groupId, record: $input) {
    record {
      ...GroupFragment
    }
    error {
      message
    }
    recordId
  }
}
    ${GroupFragmentDoc}`;
export type GroupUpdateMutationFn = Apollo.MutationFunction<GroupUpdateMutation, GroupUpdateMutationVariables>;

/**
 * __useGroupUpdateMutation__
 *
 * To run a mutation, you first call `useGroupUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGroupUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [groupUpdateMutation, { data, loading, error }] = useGroupUpdateMutation({
 *   variables: {
 *      groupId: // value for 'groupId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGroupUpdateMutation(baseOptions?: Apollo.MutationHookOptions<GroupUpdateMutation, GroupUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GroupUpdateMutation, GroupUpdateMutationVariables>(GroupUpdateDocument, options);
      }
export type GroupUpdateMutationHookResult = ReturnType<typeof useGroupUpdateMutation>;
export type GroupUpdateMutationResult = Apollo.MutationResult<GroupUpdateMutation>;
export type GroupUpdateMutationOptions = Apollo.BaseMutationOptions<GroupUpdateMutation, GroupUpdateMutationVariables>;
export const MasterDataGroupsDocument = gql`
    query masterDataGroups($brandHouseId: MongoID!) {
  BrandProductGroups(filter: {brandHouseId: $brandHouseId}) {
    _id
    name
    active
  }
}
    `;

/**
 * __useMasterDataGroupsQuery__
 *
 * To run a query within a React component, call `useMasterDataGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMasterDataGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMasterDataGroupsQuery({
 *   variables: {
 *      brandHouseId: // value for 'brandHouseId'
 *   },
 * });
 */
export function useMasterDataGroupsQuery(baseOptions: Apollo.QueryHookOptions<MasterDataGroupsQuery, MasterDataGroupsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MasterDataGroupsQuery, MasterDataGroupsQueryVariables>(MasterDataGroupsDocument, options);
      }
export function useMasterDataGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MasterDataGroupsQuery, MasterDataGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MasterDataGroupsQuery, MasterDataGroupsQueryVariables>(MasterDataGroupsDocument, options);
        }
export type MasterDataGroupsQueryHookResult = ReturnType<typeof useMasterDataGroupsQuery>;
export type MasterDataGroupsLazyQueryHookResult = ReturnType<typeof useMasterDataGroupsLazyQuery>;
export type MasterDataGroupsQueryResult = Apollo.QueryResult<MasterDataGroupsQuery, MasterDataGroupsQueryVariables>;
export const MasterDataPageShopsDocument = gql`
    query MasterDataPageShops($brandHouseId: MongoID!) {
  ShopMany(filter: {brandHouseId: $brandHouseId}) {
    _id
    name
  }
}
    `;

/**
 * __useMasterDataPageShopsQuery__
 *
 * To run a query within a React component, call `useMasterDataPageShopsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMasterDataPageShopsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMasterDataPageShopsQuery({
 *   variables: {
 *      brandHouseId: // value for 'brandHouseId'
 *   },
 * });
 */
export function useMasterDataPageShopsQuery(baseOptions: Apollo.QueryHookOptions<MasterDataPageShopsQuery, MasterDataPageShopsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MasterDataPageShopsQuery, MasterDataPageShopsQueryVariables>(MasterDataPageShopsDocument, options);
      }
export function useMasterDataPageShopsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MasterDataPageShopsQuery, MasterDataPageShopsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MasterDataPageShopsQuery, MasterDataPageShopsQueryVariables>(MasterDataPageShopsDocument, options);
        }
export type MasterDataPageShopsQueryHookResult = ReturnType<typeof useMasterDataPageShopsQuery>;
export type MasterDataPageShopsLazyQueryHookResult = ReturnType<typeof useMasterDataPageShopsLazyQuery>;
export type MasterDataPageShopsQueryResult = Apollo.QueryResult<MasterDataPageShopsQuery, MasterDataPageShopsQueryVariables>;
export const MasterDataSyncBrandDocument = gql`
    mutation MasterDataSyncBrand($refId: MongoID!, $arguments: [JSON!]) {
  IntegrationMessageExecute(
    refType: BRANDHOUSE
    name: "sendMessageRequestBrandProducts"
    refId: $refId
    arguments: $arguments
  )
}
    `;
export type MasterDataSyncBrandMutationFn = Apollo.MutationFunction<MasterDataSyncBrandMutation, MasterDataSyncBrandMutationVariables>;

/**
 * __useMasterDataSyncBrandMutation__
 *
 * To run a mutation, you first call `useMasterDataSyncBrandMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMasterDataSyncBrandMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [masterDataSyncBrandMutation, { data, loading, error }] = useMasterDataSyncBrandMutation({
 *   variables: {
 *      refId: // value for 'refId'
 *      arguments: // value for 'arguments'
 *   },
 * });
 */
export function useMasterDataSyncBrandMutation(baseOptions?: Apollo.MutationHookOptions<MasterDataSyncBrandMutation, MasterDataSyncBrandMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MasterDataSyncBrandMutation, MasterDataSyncBrandMutationVariables>(MasterDataSyncBrandDocument, options);
      }
export type MasterDataSyncBrandMutationHookResult = ReturnType<typeof useMasterDataSyncBrandMutation>;
export type MasterDataSyncBrandMutationResult = Apollo.MutationResult<MasterDataSyncBrandMutation>;
export type MasterDataSyncBrandMutationOptions = Apollo.BaseMutationOptions<MasterDataSyncBrandMutation, MasterDataSyncBrandMutationVariables>;
export const MasterDataSyncShopDocument = gql`
    mutation MasterDataSyncShop($refId: MongoID!, $arguments: [JSON!]) {
  IntegrationMessageExecute(
    refType: SHOP
    name: "sendMessageRequestShopProducts"
    refId: $refId
    arguments: $arguments
  )
}
    `;
export type MasterDataSyncShopMutationFn = Apollo.MutationFunction<MasterDataSyncShopMutation, MasterDataSyncShopMutationVariables>;

/**
 * __useMasterDataSyncShopMutation__
 *
 * To run a mutation, you first call `useMasterDataSyncShopMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMasterDataSyncShopMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [masterDataSyncShopMutation, { data, loading, error }] = useMasterDataSyncShopMutation({
 *   variables: {
 *      refId: // value for 'refId'
 *      arguments: // value for 'arguments'
 *   },
 * });
 */
export function useMasterDataSyncShopMutation(baseOptions?: Apollo.MutationHookOptions<MasterDataSyncShopMutation, MasterDataSyncShopMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MasterDataSyncShopMutation, MasterDataSyncShopMutationVariables>(MasterDataSyncShopDocument, options);
      }
export type MasterDataSyncShopMutationHookResult = ReturnType<typeof useMasterDataSyncShopMutation>;
export type MasterDataSyncShopMutationResult = Apollo.MutationResult<MasterDataSyncShopMutation>;
export type MasterDataSyncShopMutationOptions = Apollo.BaseMutationOptions<MasterDataSyncShopMutation, MasterDataSyncShopMutationVariables>;
export const BrandTradeInDialogVariantsDocument = gql`
    query BrandTradeInDialogVariants($brandProductId: MongoID) {
  BrandProductVariants(filter: {brandProductId: $brandProductId}) {
    ...BrandTradeInDialogFragment
  }
}
    ${BrandTradeInDialogFragmentDoc}`;

/**
 * __useBrandTradeInDialogVariantsQuery__
 *
 * To run a query within a React component, call `useBrandTradeInDialogVariantsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBrandTradeInDialogVariantsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBrandTradeInDialogVariantsQuery({
 *   variables: {
 *      brandProductId: // value for 'brandProductId'
 *   },
 * });
 */
export function useBrandTradeInDialogVariantsQuery(baseOptions?: Apollo.QueryHookOptions<BrandTradeInDialogVariantsQuery, BrandTradeInDialogVariantsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BrandTradeInDialogVariantsQuery, BrandTradeInDialogVariantsQueryVariables>(BrandTradeInDialogVariantsDocument, options);
      }
export function useBrandTradeInDialogVariantsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BrandTradeInDialogVariantsQuery, BrandTradeInDialogVariantsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BrandTradeInDialogVariantsQuery, BrandTradeInDialogVariantsQueryVariables>(BrandTradeInDialogVariantsDocument, options);
        }
export type BrandTradeInDialogVariantsQueryHookResult = ReturnType<typeof useBrandTradeInDialogVariantsQuery>;
export type BrandTradeInDialogVariantsLazyQueryHookResult = ReturnType<typeof useBrandTradeInDialogVariantsLazyQuery>;
export type BrandTradeInDialogVariantsQueryResult = Apollo.QueryResult<BrandTradeInDialogVariantsQuery, BrandTradeInDialogVariantsQueryVariables>;
export const BrandTradeInSettingsDocument = gql`
    query brandTradeInSettings($brandHouseID: MongoID!) {
  BrandSettings(brandHouseId: $brandHouseID) {
    _id
    useBrandItems
  }
}
    `;

/**
 * __useBrandTradeInSettingsQuery__
 *
 * To run a query within a React component, call `useBrandTradeInSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBrandTradeInSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBrandTradeInSettingsQuery({
 *   variables: {
 *      brandHouseID: // value for 'brandHouseID'
 *   },
 * });
 */
export function useBrandTradeInSettingsQuery(baseOptions: Apollo.QueryHookOptions<BrandTradeInSettingsQuery, BrandTradeInSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BrandTradeInSettingsQuery, BrandTradeInSettingsQueryVariables>(BrandTradeInSettingsDocument, options);
      }
export function useBrandTradeInSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BrandTradeInSettingsQuery, BrandTradeInSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BrandTradeInSettingsQuery, BrandTradeInSettingsQueryVariables>(BrandTradeInSettingsDocument, options);
        }
export type BrandTradeInSettingsQueryHookResult = ReturnType<typeof useBrandTradeInSettingsQuery>;
export type BrandTradeInSettingsLazyQueryHookResult = ReturnType<typeof useBrandTradeInSettingsLazyQuery>;
export type BrandTradeInSettingsQueryResult = Apollo.QueryResult<BrandTradeInSettingsQuery, BrandTradeInSettingsQueryVariables>;
export const BrandTradeInDocument = gql`
    query brandTradeIn($tradeInId: MongoID!) {
  TradeInById(_id: $tradeInId) {
    ...BrandTradeInFragment
    shop {
      categories {
        _id
        name
        value
      }
      currency
    }
  }
}
    ${BrandTradeInFragmentDoc}`;

/**
 * __useBrandTradeInQuery__
 *
 * To run a query within a React component, call `useBrandTradeInQuery` and pass it any options that fit your needs.
 * When your component renders, `useBrandTradeInQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBrandTradeInQuery({
 *   variables: {
 *      tradeInId: // value for 'tradeInId'
 *   },
 * });
 */
export function useBrandTradeInQuery(baseOptions: Apollo.QueryHookOptions<BrandTradeInQuery, BrandTradeInQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BrandTradeInQuery, BrandTradeInQueryVariables>(BrandTradeInDocument, options);
      }
export function useBrandTradeInLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BrandTradeInQuery, BrandTradeInQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BrandTradeInQuery, BrandTradeInQueryVariables>(BrandTradeInDocument, options);
        }
export type BrandTradeInQueryHookResult = ReturnType<typeof useBrandTradeInQuery>;
export type BrandTradeInLazyQueryHookResult = ReturnType<typeof useBrandTradeInLazyQuery>;
export type BrandTradeInQueryResult = Apollo.QueryResult<BrandTradeInQuery, BrandTradeInQueryVariables>;
export const BrandWholeSaleCreateDocument = gql`
    mutation brandWholeSaleCreate($consumerId: MongoID!, $categoryId: MongoID!) {
  PotentialCreate(consumerId: $consumerId, categoryId: $categoryId) {
    _id
  }
}
    `;
export type BrandWholeSaleCreateMutationFn = Apollo.MutationFunction<BrandWholeSaleCreateMutation, BrandWholeSaleCreateMutationVariables>;

/**
 * __useBrandWholeSaleCreateMutation__
 *
 * To run a mutation, you first call `useBrandWholeSaleCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBrandWholeSaleCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [brandWholeSaleCreateMutation, { data, loading, error }] = useBrandWholeSaleCreateMutation({
 *   variables: {
 *      consumerId: // value for 'consumerId'
 *      categoryId: // value for 'categoryId'
 *   },
 * });
 */
export function useBrandWholeSaleCreateMutation(baseOptions?: Apollo.MutationHookOptions<BrandWholeSaleCreateMutation, BrandWholeSaleCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BrandWholeSaleCreateMutation, BrandWholeSaleCreateMutationVariables>(BrandWholeSaleCreateDocument, options);
      }
export type BrandWholeSaleCreateMutationHookResult = ReturnType<typeof useBrandWholeSaleCreateMutation>;
export type BrandWholeSaleCreateMutationResult = Apollo.MutationResult<BrandWholeSaleCreateMutation>;
export type BrandWholeSaleCreateMutationOptions = Apollo.BaseMutationOptions<BrandWholeSaleCreateMutation, BrandWholeSaleCreateMutationVariables>;
export const BrandTradeInItemsDocument = gql`
    query brandTradeInItems($tradeInId: MongoID!) {
  TradeInItems3(tradeInId: $tradeInId) {
    _id
    name
    sku
    size
    color
    condition
    externUrl
    rejected
    brandItem {
      condition
    }
    brandProductSizeId
    productVariantId
    productVariant {
      _id
      product {
        _id
        name
      }
      color
      size
      sku
    }
    brandProductVariantId
    brandProductVariant {
      _id
      brandProduct {
        _id
        tags
        nameLocalized {
          locale
          value
        }
      }
      colorLocalized {
        value
        locale
      }
      sizes {
        _id
        sku
        ean
        sizeLocalized {
          value
          locale
        }
      }
      images {
        _id
      }
    }
    wholeSale {
      categoryId
      name
      value
    }
    imageUrls
    stockItem {
      _id
      shopId
    }
    brandItem {
      _id
    }
    rejected
    potential {
      externUrl
      rrp
      sp
    }
    itemValue
    currency
    bonus
  }
}
    `;

/**
 * __useBrandTradeInItemsQuery__
 *
 * To run a query within a React component, call `useBrandTradeInItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBrandTradeInItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBrandTradeInItemsQuery({
 *   variables: {
 *      tradeInId: // value for 'tradeInId'
 *   },
 * });
 */
export function useBrandTradeInItemsQuery(baseOptions: Apollo.QueryHookOptions<BrandTradeInItemsQuery, BrandTradeInItemsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BrandTradeInItemsQuery, BrandTradeInItemsQueryVariables>(BrandTradeInItemsDocument, options);
      }
export function useBrandTradeInItemsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BrandTradeInItemsQuery, BrandTradeInItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BrandTradeInItemsQuery, BrandTradeInItemsQueryVariables>(BrandTradeInItemsDocument, options);
        }
export type BrandTradeInItemsQueryHookResult = ReturnType<typeof useBrandTradeInItemsQuery>;
export type BrandTradeInItemsLazyQueryHookResult = ReturnType<typeof useBrandTradeInItemsLazyQuery>;
export type BrandTradeInItemsQueryResult = Apollo.QueryResult<BrandTradeInItemsQuery, BrandTradeInItemsQueryVariables>;
export const BrandTradeInUpdateDocument = gql`
    mutation brandTradeInUpdate($id: MongoID!, $input: TradeInUpdateInput!, $items: [MongoID!]) {
  TradeInUpdate(tradeInId: $id, input: $input, potentialIds: $items) {
    ...BrandTradeInFragment
  }
}
    ${BrandTradeInFragmentDoc}`;
export type BrandTradeInUpdateMutationFn = Apollo.MutationFunction<BrandTradeInUpdateMutation, BrandTradeInUpdateMutationVariables>;

/**
 * __useBrandTradeInUpdateMutation__
 *
 * To run a mutation, you first call `useBrandTradeInUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBrandTradeInUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [brandTradeInUpdateMutation, { data, loading, error }] = useBrandTradeInUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *      items: // value for 'items'
 *   },
 * });
 */
export function useBrandTradeInUpdateMutation(baseOptions?: Apollo.MutationHookOptions<BrandTradeInUpdateMutation, BrandTradeInUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BrandTradeInUpdateMutation, BrandTradeInUpdateMutationVariables>(BrandTradeInUpdateDocument, options);
      }
export type BrandTradeInUpdateMutationHookResult = ReturnType<typeof useBrandTradeInUpdateMutation>;
export type BrandTradeInUpdateMutationResult = Apollo.MutationResult<BrandTradeInUpdateMutation>;
export type BrandTradeInUpdateMutationOptions = Apollo.BaseMutationOptions<BrandTradeInUpdateMutation, BrandTradeInUpdateMutationVariables>;
export const BrandTradeInItemUpdateDocument = gql`
    mutation brandTradeInItemUpdate($id: MongoID!, $record: UpdateByIdTradeInItemInput!) {
  TradeInItemUpdateById(_id: $id, record: $record) {
    recordId
  }
}
    `;
export type BrandTradeInItemUpdateMutationFn = Apollo.MutationFunction<BrandTradeInItemUpdateMutation, BrandTradeInItemUpdateMutationVariables>;

/**
 * __useBrandTradeInItemUpdateMutation__
 *
 * To run a mutation, you first call `useBrandTradeInItemUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBrandTradeInItemUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [brandTradeInItemUpdateMutation, { data, loading, error }] = useBrandTradeInItemUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      record: // value for 'record'
 *   },
 * });
 */
export function useBrandTradeInItemUpdateMutation(baseOptions?: Apollo.MutationHookOptions<BrandTradeInItemUpdateMutation, BrandTradeInItemUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BrandTradeInItemUpdateMutation, BrandTradeInItemUpdateMutationVariables>(BrandTradeInItemUpdateDocument, options);
      }
export type BrandTradeInItemUpdateMutationHookResult = ReturnType<typeof useBrandTradeInItemUpdateMutation>;
export type BrandTradeInItemUpdateMutationResult = Apollo.MutationResult<BrandTradeInItemUpdateMutation>;
export type BrandTradeInItemUpdateMutationOptions = Apollo.BaseMutationOptions<BrandTradeInItemUpdateMutation, BrandTradeInItemUpdateMutationVariables>;
export const BrandTradeInItemsRemoveDocument = gql`
    mutation brandTradeInItemsRemove($tradeInId: MongoID!, $items: [MongoID!]!, $reject: TradeInItemRejectReasonEnum!) {
  TradeInItemsReject(
    tradeInId: $tradeInId
    tradeInItemIds: $items
    rejected: $reject
  ) {
    _id
  }
}
    `;
export type BrandTradeInItemsRemoveMutationFn = Apollo.MutationFunction<BrandTradeInItemsRemoveMutation, BrandTradeInItemsRemoveMutationVariables>;

/**
 * __useBrandTradeInItemsRemoveMutation__
 *
 * To run a mutation, you first call `useBrandTradeInItemsRemoveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBrandTradeInItemsRemoveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [brandTradeInItemsRemoveMutation, { data, loading, error }] = useBrandTradeInItemsRemoveMutation({
 *   variables: {
 *      tradeInId: // value for 'tradeInId'
 *      items: // value for 'items'
 *      reject: // value for 'reject'
 *   },
 * });
 */
export function useBrandTradeInItemsRemoveMutation(baseOptions?: Apollo.MutationHookOptions<BrandTradeInItemsRemoveMutation, BrandTradeInItemsRemoveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BrandTradeInItemsRemoveMutation, BrandTradeInItemsRemoveMutationVariables>(BrandTradeInItemsRemoveDocument, options);
      }
export type BrandTradeInItemsRemoveMutationHookResult = ReturnType<typeof useBrandTradeInItemsRemoveMutation>;
export type BrandTradeInItemsRemoveMutationResult = Apollo.MutationResult<BrandTradeInItemsRemoveMutation>;
export type BrandTradeInItemsRemoveMutationOptions = Apollo.BaseMutationOptions<BrandTradeInItemsRemoveMutation, BrandTradeInItemsRemoveMutationVariables>;
export const BrandTradeInDeleteDocument = gql`
    mutation brandTradeInDelete($tradeInId: MongoID!) {
  TradeInDelete2(tradeInId: $tradeInId) {
    _id
  }
}
    `;
export type BrandTradeInDeleteMutationFn = Apollo.MutationFunction<BrandTradeInDeleteMutation, BrandTradeInDeleteMutationVariables>;

/**
 * __useBrandTradeInDeleteMutation__
 *
 * To run a mutation, you first call `useBrandTradeInDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBrandTradeInDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [brandTradeInDeleteMutation, { data, loading, error }] = useBrandTradeInDeleteMutation({
 *   variables: {
 *      tradeInId: // value for 'tradeInId'
 *   },
 * });
 */
export function useBrandTradeInDeleteMutation(baseOptions?: Apollo.MutationHookOptions<BrandTradeInDeleteMutation, BrandTradeInDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BrandTradeInDeleteMutation, BrandTradeInDeleteMutationVariables>(BrandTradeInDeleteDocument, options);
      }
export type BrandTradeInDeleteMutationHookResult = ReturnType<typeof useBrandTradeInDeleteMutation>;
export type BrandTradeInDeleteMutationResult = Apollo.MutationResult<BrandTradeInDeleteMutation>;
export type BrandTradeInDeleteMutationOptions = Apollo.BaseMutationOptions<BrandTradeInDeleteMutation, BrandTradeInDeleteMutationVariables>;
export const BrandTradeInCreateItemDocument = gql`
    mutation brandTradeInCreateItem($brandHouseId: MongoID!, $input: BrandItemInputInput) {
  BrandItemUpdate(brandHouseId: $brandHouseId, input: $input) {
    _id
    tradeInItemId
  }
}
    `;
export type BrandTradeInCreateItemMutationFn = Apollo.MutationFunction<BrandTradeInCreateItemMutation, BrandTradeInCreateItemMutationVariables>;

/**
 * __useBrandTradeInCreateItemMutation__
 *
 * To run a mutation, you first call `useBrandTradeInCreateItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBrandTradeInCreateItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [brandTradeInCreateItemMutation, { data, loading, error }] = useBrandTradeInCreateItemMutation({
 *   variables: {
 *      brandHouseId: // value for 'brandHouseId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBrandTradeInCreateItemMutation(baseOptions?: Apollo.MutationHookOptions<BrandTradeInCreateItemMutation, BrandTradeInCreateItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BrandTradeInCreateItemMutation, BrandTradeInCreateItemMutationVariables>(BrandTradeInCreateItemDocument, options);
      }
export type BrandTradeInCreateItemMutationHookResult = ReturnType<typeof useBrandTradeInCreateItemMutation>;
export type BrandTradeInCreateItemMutationResult = Apollo.MutationResult<BrandTradeInCreateItemMutation>;
export type BrandTradeInCreateItemMutationOptions = Apollo.BaseMutationOptions<BrandTradeInCreateItemMutation, BrandTradeInCreateItemMutationVariables>;
export const BrandTradeInSynchronizeDocument = gql`
    mutation brandTradeInSynchronize($input: TradeInSynchronizeInput!) {
  TradeInSynchronize(input: $input) {
    _id
    comment
  }
}
    `;
export type BrandTradeInSynchronizeMutationFn = Apollo.MutationFunction<BrandTradeInSynchronizeMutation, BrandTradeInSynchronizeMutationVariables>;

/**
 * __useBrandTradeInSynchronizeMutation__
 *
 * To run a mutation, you first call `useBrandTradeInSynchronizeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBrandTradeInSynchronizeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [brandTradeInSynchronizeMutation, { data, loading, error }] = useBrandTradeInSynchronizeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBrandTradeInSynchronizeMutation(baseOptions?: Apollo.MutationHookOptions<BrandTradeInSynchronizeMutation, BrandTradeInSynchronizeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BrandTradeInSynchronizeMutation, BrandTradeInSynchronizeMutationVariables>(BrandTradeInSynchronizeDocument, options);
      }
export type BrandTradeInSynchronizeMutationHookResult = ReturnType<typeof useBrandTradeInSynchronizeMutation>;
export type BrandTradeInSynchronizeMutationResult = Apollo.MutationResult<BrandTradeInSynchronizeMutation>;
export type BrandTradeInSynchronizeMutationOptions = Apollo.BaseMutationOptions<BrandTradeInSynchronizeMutation, BrandTradeInSynchronizeMutationVariables>;
export const BrandTradeInsListPageShopsDocument = gql`
    query BrandTradeInsListPageShops($brandHouseId: MongoID!, $instanceFilter: FilterFindManyIntegrationInstanceInput) {
  ShopMany(filter: {brandHouseId: $brandHouseId}) {
    _id
    name
  }
  IntegrationInstances(filter: $instanceFilter) {
    _id
    name
    refId
    connector {
      messages
    }
  }
}
    `;

/**
 * __useBrandTradeInsListPageShopsQuery__
 *
 * To run a query within a React component, call `useBrandTradeInsListPageShopsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBrandTradeInsListPageShopsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBrandTradeInsListPageShopsQuery({
 *   variables: {
 *      brandHouseId: // value for 'brandHouseId'
 *      instanceFilter: // value for 'instanceFilter'
 *   },
 * });
 */
export function useBrandTradeInsListPageShopsQuery(baseOptions: Apollo.QueryHookOptions<BrandTradeInsListPageShopsQuery, BrandTradeInsListPageShopsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BrandTradeInsListPageShopsQuery, BrandTradeInsListPageShopsQueryVariables>(BrandTradeInsListPageShopsDocument, options);
      }
export function useBrandTradeInsListPageShopsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BrandTradeInsListPageShopsQuery, BrandTradeInsListPageShopsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BrandTradeInsListPageShopsQuery, BrandTradeInsListPageShopsQueryVariables>(BrandTradeInsListPageShopsDocument, options);
        }
export type BrandTradeInsListPageShopsQueryHookResult = ReturnType<typeof useBrandTradeInsListPageShopsQuery>;
export type BrandTradeInsListPageShopsLazyQueryHookResult = ReturnType<typeof useBrandTradeInsListPageShopsLazyQuery>;
export type BrandTradeInsListPageShopsQueryResult = Apollo.QueryResult<BrandTradeInsListPageShopsQuery, BrandTradeInsListPageShopsQueryVariables>;
export const BrandTradeInsListPageSelectedTradeInsDocument = gql`
    query BrandTradeInsListPageSelectedTradeIns($tradeInIds: [MongoID!]) {
  TradeInPagination(
    filter: {_operators: {_id: {in: $tradeInIds}}}
    page: 1
    perPage: 10000
  ) {
    items {
      _id
      shopId
    }
  }
}
    `;

/**
 * __useBrandTradeInsListPageSelectedTradeInsQuery__
 *
 * To run a query within a React component, call `useBrandTradeInsListPageSelectedTradeInsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBrandTradeInsListPageSelectedTradeInsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBrandTradeInsListPageSelectedTradeInsQuery({
 *   variables: {
 *      tradeInIds: // value for 'tradeInIds'
 *   },
 * });
 */
export function useBrandTradeInsListPageSelectedTradeInsQuery(baseOptions?: Apollo.QueryHookOptions<BrandTradeInsListPageSelectedTradeInsQuery, BrandTradeInsListPageSelectedTradeInsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BrandTradeInsListPageSelectedTradeInsQuery, BrandTradeInsListPageSelectedTradeInsQueryVariables>(BrandTradeInsListPageSelectedTradeInsDocument, options);
      }
export function useBrandTradeInsListPageSelectedTradeInsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BrandTradeInsListPageSelectedTradeInsQuery, BrandTradeInsListPageSelectedTradeInsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BrandTradeInsListPageSelectedTradeInsQuery, BrandTradeInsListPageSelectedTradeInsQueryVariables>(BrandTradeInsListPageSelectedTradeInsDocument, options);
        }
export type BrandTradeInsListPageSelectedTradeInsQueryHookResult = ReturnType<typeof useBrandTradeInsListPageSelectedTradeInsQuery>;
export type BrandTradeInsListPageSelectedTradeInsLazyQueryHookResult = ReturnType<typeof useBrandTradeInsListPageSelectedTradeInsLazyQuery>;
export type BrandTradeInsListPageSelectedTradeInsQueryResult = Apollo.QueryResult<BrandTradeInsListPageSelectedTradeInsQuery, BrandTradeInsListPageSelectedTradeInsQueryVariables>;
export const TradeInIntegrationExecuteDocument = gql`
    mutation TradeInIntegrationExecute($refId: MongoID!, $arguments: [JSON!]) {
  IntegrationMessageExecute(
    refType: SHOP
    name: "handleTradeInUpdated"
    refId: $refId
    arguments: $arguments
  )
}
    `;
export type TradeInIntegrationExecuteMutationFn = Apollo.MutationFunction<TradeInIntegrationExecuteMutation, TradeInIntegrationExecuteMutationVariables>;

/**
 * __useTradeInIntegrationExecuteMutation__
 *
 * To run a mutation, you first call `useTradeInIntegrationExecuteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTradeInIntegrationExecuteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [tradeInIntegrationExecuteMutation, { data, loading, error }] = useTradeInIntegrationExecuteMutation({
 *   variables: {
 *      refId: // value for 'refId'
 *      arguments: // value for 'arguments'
 *   },
 * });
 */
export function useTradeInIntegrationExecuteMutation(baseOptions?: Apollo.MutationHookOptions<TradeInIntegrationExecuteMutation, TradeInIntegrationExecuteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TradeInIntegrationExecuteMutation, TradeInIntegrationExecuteMutationVariables>(TradeInIntegrationExecuteDocument, options);
      }
export type TradeInIntegrationExecuteMutationHookResult = ReturnType<typeof useTradeInIntegrationExecuteMutation>;
export type TradeInIntegrationExecuteMutationResult = Apollo.MutationResult<TradeInIntegrationExecuteMutation>;
export type TradeInIntegrationExecuteMutationOptions = Apollo.BaseMutationOptions<TradeInIntegrationExecuteMutation, TradeInIntegrationExecuteMutationVariables>;
export const VoucherPageVoucherDocument = gql`
    query VoucherPageVoucher($id: MongoID!) {
  VoucherById(_id: $id) {
    _id
    code
    shopId
    currentValue
    value
    currency
    voucherStrategy
    used
    activated
    expireDate
    consumerId
    deleted
    minimumPurchase
    newVoucherUsage
    disabled
    passive
  }
}
    `;

/**
 * __useVoucherPageVoucherQuery__
 *
 * To run a query within a React component, call `useVoucherPageVoucherQuery` and pass it any options that fit your needs.
 * When your component renders, `useVoucherPageVoucherQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVoucherPageVoucherQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useVoucherPageVoucherQuery(baseOptions: Apollo.QueryHookOptions<VoucherPageVoucherQuery, VoucherPageVoucherQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<VoucherPageVoucherQuery, VoucherPageVoucherQueryVariables>(VoucherPageVoucherDocument, options);
      }
export function useVoucherPageVoucherLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VoucherPageVoucherQuery, VoucherPageVoucherQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<VoucherPageVoucherQuery, VoucherPageVoucherQueryVariables>(VoucherPageVoucherDocument, options);
        }
export type VoucherPageVoucherQueryHookResult = ReturnType<typeof useVoucherPageVoucherQuery>;
export type VoucherPageVoucherLazyQueryHookResult = ReturnType<typeof useVoucherPageVoucherLazyQuery>;
export type VoucherPageVoucherQueryResult = Apollo.QueryResult<VoucherPageVoucherQuery, VoucherPageVoucherQueryVariables>;
export const VoucherPageSynchronizeDocument = gql`
    mutation VoucherPageSynchronize($shopId: String!, $code: String!) {
  VoucherSynchronize(shopId: $shopId, code: $code) {
    _id
  }
}
    `;
export type VoucherPageSynchronizeMutationFn = Apollo.MutationFunction<VoucherPageSynchronizeMutation, VoucherPageSynchronizeMutationVariables>;

/**
 * __useVoucherPageSynchronizeMutation__
 *
 * To run a mutation, you first call `useVoucherPageSynchronizeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVoucherPageSynchronizeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [voucherPageSynchronizeMutation, { data, loading, error }] = useVoucherPageSynchronizeMutation({
 *   variables: {
 *      shopId: // value for 'shopId'
 *      code: // value for 'code'
 *   },
 * });
 */
export function useVoucherPageSynchronizeMutation(baseOptions?: Apollo.MutationHookOptions<VoucherPageSynchronizeMutation, VoucherPageSynchronizeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VoucherPageSynchronizeMutation, VoucherPageSynchronizeMutationVariables>(VoucherPageSynchronizeDocument, options);
      }
export type VoucherPageSynchronizeMutationHookResult = ReturnType<typeof useVoucherPageSynchronizeMutation>;
export type VoucherPageSynchronizeMutationResult = Apollo.MutationResult<VoucherPageSynchronizeMutation>;
export type VoucherPageSynchronizeMutationOptions = Apollo.BaseMutationOptions<VoucherPageSynchronizeMutation, VoucherPageSynchronizeMutationVariables>;
export const VoucherPageAdjustmentDocument = gql`
    mutation VoucherPageAdjustment($adjustment: CreateOneVoucherAdjustmentInput!) {
  VoucherAdjustmentCreate(record: $adjustment) {
    record {
      _id
      amount
      reason
      date
    }
    recordId
    error {
      message
    }
  }
}
    `;
export type VoucherPageAdjustmentMutationFn = Apollo.MutationFunction<VoucherPageAdjustmentMutation, VoucherPageAdjustmentMutationVariables>;

/**
 * __useVoucherPageAdjustmentMutation__
 *
 * To run a mutation, you first call `useVoucherPageAdjustmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVoucherPageAdjustmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [voucherPageAdjustmentMutation, { data, loading, error }] = useVoucherPageAdjustmentMutation({
 *   variables: {
 *      adjustment: // value for 'adjustment'
 *   },
 * });
 */
export function useVoucherPageAdjustmentMutation(baseOptions?: Apollo.MutationHookOptions<VoucherPageAdjustmentMutation, VoucherPageAdjustmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VoucherPageAdjustmentMutation, VoucherPageAdjustmentMutationVariables>(VoucherPageAdjustmentDocument, options);
      }
export type VoucherPageAdjustmentMutationHookResult = ReturnType<typeof useVoucherPageAdjustmentMutation>;
export type VoucherPageAdjustmentMutationResult = Apollo.MutationResult<VoucherPageAdjustmentMutation>;
export type VoucherPageAdjustmentMutationOptions = Apollo.BaseMutationOptions<VoucherPageAdjustmentMutation, VoucherPageAdjustmentMutationVariables>;
export const VoucherPageSendReceivedMailDocument = gql`
    mutation voucherPageSendReceivedMail($shopId: MongoID!, $options: JSON!) {
  ConsumerSendEmail(shopId: $shopId, mailtype: RECEIVED, options: $options)
}
    `;
export type VoucherPageSendReceivedMailMutationFn = Apollo.MutationFunction<VoucherPageSendReceivedMailMutation, VoucherPageSendReceivedMailMutationVariables>;

/**
 * __useVoucherPageSendReceivedMailMutation__
 *
 * To run a mutation, you first call `useVoucherPageSendReceivedMailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVoucherPageSendReceivedMailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [voucherPageSendReceivedMailMutation, { data, loading, error }] = useVoucherPageSendReceivedMailMutation({
 *   variables: {
 *      shopId: // value for 'shopId'
 *      options: // value for 'options'
 *   },
 * });
 */
export function useVoucherPageSendReceivedMailMutation(baseOptions?: Apollo.MutationHookOptions<VoucherPageSendReceivedMailMutation, VoucherPageSendReceivedMailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VoucherPageSendReceivedMailMutation, VoucherPageSendReceivedMailMutationVariables>(VoucherPageSendReceivedMailDocument, options);
      }
export type VoucherPageSendReceivedMailMutationHookResult = ReturnType<typeof useVoucherPageSendReceivedMailMutation>;
export type VoucherPageSendReceivedMailMutationResult = Apollo.MutationResult<VoucherPageSendReceivedMailMutation>;
export type VoucherPageSendReceivedMailMutationOptions = Apollo.BaseMutationOptions<VoucherPageSendReceivedMailMutation, VoucherPageSendReceivedMailMutationVariables>;
export const VoucherPanelVoucherDocument = gql`
    query VoucherPanelVoucher($id: MongoID!) {
  VoucherById(_id: $id) {
    _id
    shopId
    code
    codeAlias
    currentValue
    value
    currency
    voucherStrategy
    used
    activated
    expireDate
    consumerId
    deleted
    minimumPurchase
    newVoucherUsage
    disabled
    activated
    voucherPdf {
      url
      language
    }
  }
}
    `;

/**
 * __useVoucherPanelVoucherQuery__
 *
 * To run a query within a React component, call `useVoucherPanelVoucherQuery` and pass it any options that fit your needs.
 * When your component renders, `useVoucherPanelVoucherQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVoucherPanelVoucherQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useVoucherPanelVoucherQuery(baseOptions: Apollo.QueryHookOptions<VoucherPanelVoucherQuery, VoucherPanelVoucherQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<VoucherPanelVoucherQuery, VoucherPanelVoucherQueryVariables>(VoucherPanelVoucherDocument, options);
      }
export function useVoucherPanelVoucherLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VoucherPanelVoucherQuery, VoucherPanelVoucherQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<VoucherPanelVoucherQuery, VoucherPanelVoucherQueryVariables>(VoucherPanelVoucherDocument, options);
        }
export type VoucherPanelVoucherQueryHookResult = ReturnType<typeof useVoucherPanelVoucherQuery>;
export type VoucherPanelVoucherLazyQueryHookResult = ReturnType<typeof useVoucherPanelVoucherLazyQuery>;
export type VoucherPanelVoucherQueryResult = Apollo.QueryResult<VoucherPanelVoucherQuery, VoucherPanelVoucherQueryVariables>;
export const VoucherEnableDisableDocument = gql`
    mutation VoucherEnableDisable($voucherId: MongoID!, $enable: Boolean!) {
  VoucherEnable(voucherId: $voucherId, enable: $enable) {
    _id
    disabled
  }
}
    `;
export type VoucherEnableDisableMutationFn = Apollo.MutationFunction<VoucherEnableDisableMutation, VoucherEnableDisableMutationVariables>;

/**
 * __useVoucherEnableDisableMutation__
 *
 * To run a mutation, you first call `useVoucherEnableDisableMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVoucherEnableDisableMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [voucherEnableDisableMutation, { data, loading, error }] = useVoucherEnableDisableMutation({
 *   variables: {
 *      voucherId: // value for 'voucherId'
 *      enable: // value for 'enable'
 *   },
 * });
 */
export function useVoucherEnableDisableMutation(baseOptions?: Apollo.MutationHookOptions<VoucherEnableDisableMutation, VoucherEnableDisableMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VoucherEnableDisableMutation, VoucherEnableDisableMutationVariables>(VoucherEnableDisableDocument, options);
      }
export type VoucherEnableDisableMutationHookResult = ReturnType<typeof useVoucherEnableDisableMutation>;
export type VoucherEnableDisableMutationResult = Apollo.MutationResult<VoucherEnableDisableMutation>;
export type VoucherEnableDisableMutationOptions = Apollo.BaseMutationOptions<VoucherEnableDisableMutation, VoucherEnableDisableMutationVariables>;
export const VoucherUsagesDocument = gql`
    query VoucherUsages($voucherId: MongoID!) {
  VoucherById(_id: $voucherId) {
    _id
    shopId
    deleted
    currency
    value
    createdAt
    consumerId
    tradeInId
    passive
  }
  VoucherTransactions(voucherId: $voucherId) {
    _id
    date
    type
    amount
    spending
    balance
    url
    reason
    user {
      name
    }
  }
}
    `;

/**
 * __useVoucherUsagesQuery__
 *
 * To run a query within a React component, call `useVoucherUsagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useVoucherUsagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVoucherUsagesQuery({
 *   variables: {
 *      voucherId: // value for 'voucherId'
 *   },
 * });
 */
export function useVoucherUsagesQuery(baseOptions: Apollo.QueryHookOptions<VoucherUsagesQuery, VoucherUsagesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<VoucherUsagesQuery, VoucherUsagesQueryVariables>(VoucherUsagesDocument, options);
      }
export function useVoucherUsagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VoucherUsagesQuery, VoucherUsagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<VoucherUsagesQuery, VoucherUsagesQueryVariables>(VoucherUsagesDocument, options);
        }
export type VoucherUsagesQueryHookResult = ReturnType<typeof useVoucherUsagesQuery>;
export type VoucherUsagesLazyQueryHookResult = ReturnType<typeof useVoucherUsagesLazyQuery>;
export type VoucherUsagesQueryResult = Apollo.QueryResult<VoucherUsagesQuery, VoucherUsagesQueryVariables>;
export const VoucherUsagesGiftCardSyncDocument = gql`
    query VoucherUsagesGiftCardSync($shopId: MongoID!, $voucherId: MongoID!) {
  VoucherAdjustments(
    filter: {shopId: $shopId, voucherId: $voucherId, applyToGiftCard: true}
    limit: 100
  ) {
    _id
    giftCardSync {
      status
      amount
      currency
      error
    }
  }
}
    `;

/**
 * __useVoucherUsagesGiftCardSyncQuery__
 *
 * To run a query within a React component, call `useVoucherUsagesGiftCardSyncQuery` and pass it any options that fit your needs.
 * When your component renders, `useVoucherUsagesGiftCardSyncQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVoucherUsagesGiftCardSyncQuery({
 *   variables: {
 *      shopId: // value for 'shopId'
 *      voucherId: // value for 'voucherId'
 *   },
 * });
 */
export function useVoucherUsagesGiftCardSyncQuery(baseOptions: Apollo.QueryHookOptions<VoucherUsagesGiftCardSyncQuery, VoucherUsagesGiftCardSyncQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<VoucherUsagesGiftCardSyncQuery, VoucherUsagesGiftCardSyncQueryVariables>(VoucherUsagesGiftCardSyncDocument, options);
      }
export function useVoucherUsagesGiftCardSyncLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VoucherUsagesGiftCardSyncQuery, VoucherUsagesGiftCardSyncQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<VoucherUsagesGiftCardSyncQuery, VoucherUsagesGiftCardSyncQueryVariables>(VoucherUsagesGiftCardSyncDocument, options);
        }
export type VoucherUsagesGiftCardSyncQueryHookResult = ReturnType<typeof useVoucherUsagesGiftCardSyncQuery>;
export type VoucherUsagesGiftCardSyncLazyQueryHookResult = ReturnType<typeof useVoucherUsagesGiftCardSyncLazyQuery>;
export type VoucherUsagesGiftCardSyncQueryResult = Apollo.QueryResult<VoucherUsagesGiftCardSyncQuery, VoucherUsagesGiftCardSyncQueryVariables>;
export const ExportVouchersDocument = gql`
    query ExportVouchers($voucherIds: [MongoID!]!, $currency: String!) {
  VoucherByIds(ids: $voucherIds) {
    _id
    currentValue
    value
    currency
    code
    codeAlias
    tradeIn {
      dateTime
      registered
      registeredTs
    }
    statistics(currency: $currency) {
      daysBeforeUsage
      spending
      usageDate
      smashFactor
    }
    consumer {
      _id
      name
      mail
    }
    tradeInReceivedTs
    voucherStrategy
    minimumPurchase
    activated
    disabled
    deleted
    passive
  }
}
    `;

/**
 * __useExportVouchersQuery__
 *
 * To run a query within a React component, call `useExportVouchersQuery` and pass it any options that fit your needs.
 * When your component renders, `useExportVouchersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExportVouchersQuery({
 *   variables: {
 *      voucherIds: // value for 'voucherIds'
 *      currency: // value for 'currency'
 *   },
 * });
 */
export function useExportVouchersQuery(baseOptions: Apollo.QueryHookOptions<ExportVouchersQuery, ExportVouchersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExportVouchersQuery, ExportVouchersQueryVariables>(ExportVouchersDocument, options);
      }
export function useExportVouchersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExportVouchersQuery, ExportVouchersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExportVouchersQuery, ExportVouchersQueryVariables>(ExportVouchersDocument, options);
        }
export type ExportVouchersQueryHookResult = ReturnType<typeof useExportVouchersQuery>;
export type ExportVouchersLazyQueryHookResult = ReturnType<typeof useExportVouchersLazyQuery>;
export type ExportVouchersQueryResult = Apollo.QueryResult<ExportVouchersQuery, ExportVouchersQueryVariables>;
export const VouchersPagePaginationDocument = gql`
    query VouchersPagePagination($page: Int, $perPage: Int, $search: String, $sort: SortFindManyVoucherInput, $filter: FilterFindManyVoucherInput) {
  VoucherPagination(
    page: $page
    perPage: $perPage
    search: $search
    sort: $sort
    filter: $filter
  ) {
    count
    items {
      _id
      shopId
      code
      codeAlias
      value
      currentValue
      currency
      voucherStrategy
      activated
      consumerId
      consumer {
        _id
        firstName
        lastName
        mail
      }
      createdAt
      deleted
      used
      tradeInId
      newVoucherUsage
      passive
    }
  }
}
    `;

/**
 * __useVouchersPagePaginationQuery__
 *
 * To run a query within a React component, call `useVouchersPagePaginationQuery` and pass it any options that fit your needs.
 * When your component renders, `useVouchersPagePaginationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVouchersPagePaginationQuery({
 *   variables: {
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *      search: // value for 'search'
 *      sort: // value for 'sort'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useVouchersPagePaginationQuery(baseOptions?: Apollo.QueryHookOptions<VouchersPagePaginationQuery, VouchersPagePaginationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<VouchersPagePaginationQuery, VouchersPagePaginationQueryVariables>(VouchersPagePaginationDocument, options);
      }
export function useVouchersPagePaginationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VouchersPagePaginationQuery, VouchersPagePaginationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<VouchersPagePaginationQuery, VouchersPagePaginationQueryVariables>(VouchersPagePaginationDocument, options);
        }
export type VouchersPagePaginationQueryHookResult = ReturnType<typeof useVouchersPagePaginationQuery>;
export type VouchersPagePaginationLazyQueryHookResult = ReturnType<typeof useVouchersPagePaginationLazyQuery>;
export type VouchersPagePaginationQueryResult = Apollo.QueryResult<VouchersPagePaginationQuery, VouchersPagePaginationQueryVariables>;
export const VouchersPageSelectAllDocument = gql`
    query VouchersPageSelectAll($filter: FilterFindManyVoucherInput) {
  VoucherPagination(perPage: 10000, filter: $filter) {
    items {
      _id
    }
  }
}
    `;

/**
 * __useVouchersPageSelectAllQuery__
 *
 * To run a query within a React component, call `useVouchersPageSelectAllQuery` and pass it any options that fit your needs.
 * When your component renders, `useVouchersPageSelectAllQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVouchersPageSelectAllQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useVouchersPageSelectAllQuery(baseOptions?: Apollo.QueryHookOptions<VouchersPageSelectAllQuery, VouchersPageSelectAllQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<VouchersPageSelectAllQuery, VouchersPageSelectAllQueryVariables>(VouchersPageSelectAllDocument, options);
      }
export function useVouchersPageSelectAllLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VouchersPageSelectAllQuery, VouchersPageSelectAllQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<VouchersPageSelectAllQuery, VouchersPageSelectAllQueryVariables>(VouchersPageSelectAllDocument, options);
        }
export type VouchersPageSelectAllQueryHookResult = ReturnType<typeof useVouchersPageSelectAllQuery>;
export type VouchersPageSelectAllLazyQueryHookResult = ReturnType<typeof useVouchersPageSelectAllLazyQuery>;
export type VouchersPageSelectAllQueryResult = Apollo.QueryResult<VouchersPageSelectAllQuery, VouchersPageSelectAllQueryVariables>;
export const VouchersPageMergeDocument = gql`
    mutation VouchersPageMerge($shopId: String!, $tradeInId: String!, $vouchers: [String!]!) {
  VoucherMerge(shopId: $shopId, targetTradeIn: $tradeInId, voucherIds: $vouchers) {
    _id
    code
  }
}
    `;
export type VouchersPageMergeMutationFn = Apollo.MutationFunction<VouchersPageMergeMutation, VouchersPageMergeMutationVariables>;

/**
 * __useVouchersPageMergeMutation__
 *
 * To run a mutation, you first call `useVouchersPageMergeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVouchersPageMergeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [vouchersPageMergeMutation, { data, loading, error }] = useVouchersPageMergeMutation({
 *   variables: {
 *      shopId: // value for 'shopId'
 *      tradeInId: // value for 'tradeInId'
 *      vouchers: // value for 'vouchers'
 *   },
 * });
 */
export function useVouchersPageMergeMutation(baseOptions?: Apollo.MutationHookOptions<VouchersPageMergeMutation, VouchersPageMergeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VouchersPageMergeMutation, VouchersPageMergeMutationVariables>(VouchersPageMergeDocument, options);
      }
export type VouchersPageMergeMutationHookResult = ReturnType<typeof useVouchersPageMergeMutation>;
export type VouchersPageMergeMutationResult = Apollo.MutationResult<VouchersPageMergeMutation>;
export type VouchersPageMergeMutationOptions = Apollo.BaseMutationOptions<VouchersPageMergeMutation, VouchersPageMergeMutationVariables>;
export const VouchersPageVoucherDeleteDocument = gql`
    mutation VouchersPageVoucherDelete($shopId: String!, $voucherId: String!) {
  VoucherDelete(shopId: $shopId, id: $voucherId) {
    _id
  }
}
    `;
export type VouchersPageVoucherDeleteMutationFn = Apollo.MutationFunction<VouchersPageVoucherDeleteMutation, VouchersPageVoucherDeleteMutationVariables>;

/**
 * __useVouchersPageVoucherDeleteMutation__
 *
 * To run a mutation, you first call `useVouchersPageVoucherDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVouchersPageVoucherDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [vouchersPageVoucherDeleteMutation, { data, loading, error }] = useVouchersPageVoucherDeleteMutation({
 *   variables: {
 *      shopId: // value for 'shopId'
 *      voucherId: // value for 'voucherId'
 *   },
 * });
 */
export function useVouchersPageVoucherDeleteMutation(baseOptions?: Apollo.MutationHookOptions<VouchersPageVoucherDeleteMutation, VouchersPageVoucherDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VouchersPageVoucherDeleteMutation, VouchersPageVoucherDeleteMutationVariables>(VouchersPageVoucherDeleteDocument, options);
      }
export type VouchersPageVoucherDeleteMutationHookResult = ReturnType<typeof useVouchersPageVoucherDeleteMutation>;
export type VouchersPageVoucherDeleteMutationResult = Apollo.MutationResult<VouchersPageVoucherDeleteMutation>;
export type VouchersPageVoucherDeleteMutationOptions = Apollo.BaseMutationOptions<VouchersPageVoucherDeleteMutation, VouchersPageVoucherDeleteMutationVariables>;
export const VouchersPageByIdsDocument = gql`
    query VouchersPageByIds($voucherIds: [MongoID!]!) {
  VoucherByIds(ids: $voucherIds) {
    _id
    shopId
    code
    tradeInId
  }
}
    `;

/**
 * __useVouchersPageByIdsQuery__
 *
 * To run a query within a React component, call `useVouchersPageByIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useVouchersPageByIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVouchersPageByIdsQuery({
 *   variables: {
 *      voucherIds: // value for 'voucherIds'
 *   },
 * });
 */
export function useVouchersPageByIdsQuery(baseOptions: Apollo.QueryHookOptions<VouchersPageByIdsQuery, VouchersPageByIdsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<VouchersPageByIdsQuery, VouchersPageByIdsQueryVariables>(VouchersPageByIdsDocument, options);
      }
export function useVouchersPageByIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VouchersPageByIdsQuery, VouchersPageByIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<VouchersPageByIdsQuery, VouchersPageByIdsQueryVariables>(VouchersPageByIdsDocument, options);
        }
export type VouchersPageByIdsQueryHookResult = ReturnType<typeof useVouchersPageByIdsQuery>;
export type VouchersPageByIdsLazyQueryHookResult = ReturnType<typeof useVouchersPageByIdsLazyQuery>;
export type VouchersPageByIdsQueryResult = Apollo.QueryResult<VouchersPageByIdsQuery, VouchersPageByIdsQueryVariables>;
export const VouchersPageSynchronizeDocument = gql`
    mutation VouchersPageSynchronize($shopId: String!, $code: String!) {
  VoucherSynchronize(shopId: $shopId, code: $code) {
    _id
  }
}
    `;
export type VouchersPageSynchronizeMutationFn = Apollo.MutationFunction<VouchersPageSynchronizeMutation, VouchersPageSynchronizeMutationVariables>;

/**
 * __useVouchersPageSynchronizeMutation__
 *
 * To run a mutation, you first call `useVouchersPageSynchronizeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVouchersPageSynchronizeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [vouchersPageSynchronizeMutation, { data, loading, error }] = useVouchersPageSynchronizeMutation({
 *   variables: {
 *      shopId: // value for 'shopId'
 *      code: // value for 'code'
 *   },
 * });
 */
export function useVouchersPageSynchronizeMutation(baseOptions?: Apollo.MutationHookOptions<VouchersPageSynchronizeMutation, VouchersPageSynchronizeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VouchersPageSynchronizeMutation, VouchersPageSynchronizeMutationVariables>(VouchersPageSynchronizeDocument, options);
      }
export type VouchersPageSynchronizeMutationHookResult = ReturnType<typeof useVouchersPageSynchronizeMutation>;
export type VouchersPageSynchronizeMutationResult = Apollo.MutationResult<VouchersPageSynchronizeMutation>;
export type VouchersPageSynchronizeMutationOptions = Apollo.BaseMutationOptions<VouchersPageSynchronizeMutation, VouchersPageSynchronizeMutationVariables>;
export const BrandsPageBrandHouseDocument = gql`
    query brandsPageBrandHouse($brandHouseId: MongoID!) {
  BrandHouse(id: $brandHouseId) {
    _id
    license
    name
  }
}
    `;

/**
 * __useBrandsPageBrandHouseQuery__
 *
 * To run a query within a React component, call `useBrandsPageBrandHouseQuery` and pass it any options that fit your needs.
 * When your component renders, `useBrandsPageBrandHouseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBrandsPageBrandHouseQuery({
 *   variables: {
 *      brandHouseId: // value for 'brandHouseId'
 *   },
 * });
 */
export function useBrandsPageBrandHouseQuery(baseOptions: Apollo.QueryHookOptions<BrandsPageBrandHouseQuery, BrandsPageBrandHouseQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BrandsPageBrandHouseQuery, BrandsPageBrandHouseQueryVariables>(BrandsPageBrandHouseDocument, options);
      }
export function useBrandsPageBrandHouseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BrandsPageBrandHouseQuery, BrandsPageBrandHouseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BrandsPageBrandHouseQuery, BrandsPageBrandHouseQueryVariables>(BrandsPageBrandHouseDocument, options);
        }
export type BrandsPageBrandHouseQueryHookResult = ReturnType<typeof useBrandsPageBrandHouseQuery>;
export type BrandsPageBrandHouseLazyQueryHookResult = ReturnType<typeof useBrandsPageBrandHouseLazyQuery>;
export type BrandsPageBrandHouseQueryResult = Apollo.QueryResult<BrandsPageBrandHouseQuery, BrandsPageBrandHouseQueryVariables>;
export const BrandsPageLoginAsDocument = gql`
    mutation brandsPageLoginAs($license: String!, $shopId: String!) {
  BrandHouseAuthorize(license: $license, shopId: $shopId) {
    url
  }
}
    `;
export type BrandsPageLoginAsMutationFn = Apollo.MutationFunction<BrandsPageLoginAsMutation, BrandsPageLoginAsMutationVariables>;

/**
 * __useBrandsPageLoginAsMutation__
 *
 * To run a mutation, you first call `useBrandsPageLoginAsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBrandsPageLoginAsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [brandsPageLoginAsMutation, { data, loading, error }] = useBrandsPageLoginAsMutation({
 *   variables: {
 *      license: // value for 'license'
 *      shopId: // value for 'shopId'
 *   },
 * });
 */
export function useBrandsPageLoginAsMutation(baseOptions?: Apollo.MutationHookOptions<BrandsPageLoginAsMutation, BrandsPageLoginAsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BrandsPageLoginAsMutation, BrandsPageLoginAsMutationVariables>(BrandsPageLoginAsDocument, options);
      }
export type BrandsPageLoginAsMutationHookResult = ReturnType<typeof useBrandsPageLoginAsMutation>;
export type BrandsPageLoginAsMutationResult = Apollo.MutationResult<BrandsPageLoginAsMutation>;
export type BrandsPageLoginAsMutationOptions = Apollo.BaseMutationOptions<BrandsPageLoginAsMutation, BrandsPageLoginAsMutationVariables>;
export const BrandsPageLogisticsPartnersDocument = gql`
    query BrandsPageLogisticsPartners {
  LogisticsPartners {
    _id
    name
  }
}
    `;

/**
 * __useBrandsPageLogisticsPartnersQuery__
 *
 * To run a query within a React component, call `useBrandsPageLogisticsPartnersQuery` and pass it any options that fit your needs.
 * When your component renders, `useBrandsPageLogisticsPartnersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBrandsPageLogisticsPartnersQuery({
 *   variables: {
 *   },
 * });
 */
export function useBrandsPageLogisticsPartnersQuery(baseOptions?: Apollo.QueryHookOptions<BrandsPageLogisticsPartnersQuery, BrandsPageLogisticsPartnersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BrandsPageLogisticsPartnersQuery, BrandsPageLogisticsPartnersQueryVariables>(BrandsPageLogisticsPartnersDocument, options);
      }
export function useBrandsPageLogisticsPartnersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BrandsPageLogisticsPartnersQuery, BrandsPageLogisticsPartnersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BrandsPageLogisticsPartnersQuery, BrandsPageLogisticsPartnersQueryVariables>(BrandsPageLogisticsPartnersDocument, options);
        }
export type BrandsPageLogisticsPartnersQueryHookResult = ReturnType<typeof useBrandsPageLogisticsPartnersQuery>;
export type BrandsPageLogisticsPartnersLazyQueryHookResult = ReturnType<typeof useBrandsPageLogisticsPartnersLazyQuery>;
export type BrandsPageLogisticsPartnersQueryResult = Apollo.QueryResult<BrandsPageLogisticsPartnersQuery, BrandsPageLogisticsPartnersQueryVariables>;
export const BrandHouseShopsDocument = gql`
    query BrandHouseShops($brandHouseId: MongoID!) {
  ShopMany(filter: {brandHouseId: $brandHouseId}) {
    _id
    name
    externalId
    currency
    live
    wholeSaleActive
  }
}
    `;

/**
 * __useBrandHouseShopsQuery__
 *
 * To run a query within a React component, call `useBrandHouseShopsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBrandHouseShopsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBrandHouseShopsQuery({
 *   variables: {
 *      brandHouseId: // value for 'brandHouseId'
 *   },
 * });
 */
export function useBrandHouseShopsQuery(baseOptions: Apollo.QueryHookOptions<BrandHouseShopsQuery, BrandHouseShopsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BrandHouseShopsQuery, BrandHouseShopsQueryVariables>(BrandHouseShopsDocument, options);
      }
export function useBrandHouseShopsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BrandHouseShopsQuery, BrandHouseShopsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BrandHouseShopsQuery, BrandHouseShopsQueryVariables>(BrandHouseShopsDocument, options);
        }
export type BrandHouseShopsQueryHookResult = ReturnType<typeof useBrandHouseShopsQuery>;
export type BrandHouseShopsLazyQueryHookResult = ReturnType<typeof useBrandHouseShopsLazyQuery>;
export type BrandHouseShopsQueryResult = Apollo.QueryResult<BrandHouseShopsQuery, BrandHouseShopsQueryVariables>;
export const AuditNoteDetailsDocument = gql`
    query AuditNoteDetails($auditNoteId: MongoID!) {
  AuditNote(id: $auditNoteId) {
    _id
    explanation
    createdAt
  }
  PatchMany(filter: {auditNoteId: $auditNoteId}, sort: _ID_DESC, limit: 100) {
    _id
    type
    ref
    shopId
    brandHouseId
    date
    updatedBy {
      type
      ref
    }
    ops {
      value
      op
      path
    }
  }
}
    `;

/**
 * __useAuditNoteDetailsQuery__
 *
 * To run a query within a React component, call `useAuditNoteDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAuditNoteDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAuditNoteDetailsQuery({
 *   variables: {
 *      auditNoteId: // value for 'auditNoteId'
 *   },
 * });
 */
export function useAuditNoteDetailsQuery(baseOptions: Apollo.QueryHookOptions<AuditNoteDetailsQuery, AuditNoteDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AuditNoteDetailsQuery, AuditNoteDetailsQueryVariables>(AuditNoteDetailsDocument, options);
      }
export function useAuditNoteDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AuditNoteDetailsQuery, AuditNoteDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AuditNoteDetailsQuery, AuditNoteDetailsQueryVariables>(AuditNoteDetailsDocument, options);
        }
export type AuditNoteDetailsQueryHookResult = ReturnType<typeof useAuditNoteDetailsQuery>;
export type AuditNoteDetailsLazyQueryHookResult = ReturnType<typeof useAuditNoteDetailsLazyQuery>;
export type AuditNoteDetailsQueryResult = Apollo.QueryResult<AuditNoteDetailsQuery, AuditNoteDetailsQueryVariables>;
export const AuditNoteDetailsUserDocument = gql`
    query AuditNoteDetailsUser($id: MongoID!) {
  User(_id: $id) {
    name
    email
  }
}
    `;

/**
 * __useAuditNoteDetailsUserQuery__
 *
 * To run a query within a React component, call `useAuditNoteDetailsUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useAuditNoteDetailsUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAuditNoteDetailsUserQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAuditNoteDetailsUserQuery(baseOptions: Apollo.QueryHookOptions<AuditNoteDetailsUserQuery, AuditNoteDetailsUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AuditNoteDetailsUserQuery, AuditNoteDetailsUserQueryVariables>(AuditNoteDetailsUserDocument, options);
      }
export function useAuditNoteDetailsUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AuditNoteDetailsUserQuery, AuditNoteDetailsUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AuditNoteDetailsUserQuery, AuditNoteDetailsUserQueryVariables>(AuditNoteDetailsUserDocument, options);
        }
export type AuditNoteDetailsUserQueryHookResult = ReturnType<typeof useAuditNoteDetailsUserQuery>;
export type AuditNoteDetailsUserLazyQueryHookResult = ReturnType<typeof useAuditNoteDetailsUserLazyQuery>;
export type AuditNoteDetailsUserQueryResult = Apollo.QueryResult<AuditNoteDetailsUserQuery, AuditNoteDetailsUserQueryVariables>;
export const AuditNotesPageQueryDocument = gql`
    query AuditNotesPageQuery($brandHouseId: MongoID!) {
  AuditNotes(brandHouseId: $brandHouseId) {
    _id
    explanation
    createdAt
  }
}
    `;

/**
 * __useAuditNotesPageQuery__
 *
 * To run a query within a React component, call `useAuditNotesPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useAuditNotesPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAuditNotesPageQuery({
 *   variables: {
 *      brandHouseId: // value for 'brandHouseId'
 *   },
 * });
 */
export function useAuditNotesPageQuery(baseOptions: Apollo.QueryHookOptions<AuditNotesPageQuery, AuditNotesPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AuditNotesPageQuery, AuditNotesPageQueryVariables>(AuditNotesPageQueryDocument, options);
      }
export function useAuditNotesPageQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AuditNotesPageQuery, AuditNotesPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AuditNotesPageQuery, AuditNotesPageQueryVariables>(AuditNotesPageQueryDocument, options);
        }
export type AuditNotesPageQueryHookResult = ReturnType<typeof useAuditNotesPageQuery>;
export type AuditNotesPageQueryLazyQueryHookResult = ReturnType<typeof useAuditNotesPageQueryLazyQuery>;
export type AuditNotesPageQueryQueryResult = Apollo.QueryResult<AuditNotesPageQuery, AuditNotesPageQueryVariables>;
export const AuditNotesPageCreateDocument = gql`
    mutation AuditNotesPageCreate($brandHouseId: MongoID!, $explanation: String!) {
  AuditNoteCreate(brandHouseId: $brandHouseId, explanation: $explanation) {
    _id
  }
}
    `;
export type AuditNotesPageCreateMutationFn = Apollo.MutationFunction<AuditNotesPageCreateMutation, AuditNotesPageCreateMutationVariables>;

/**
 * __useAuditNotesPageCreateMutation__
 *
 * To run a mutation, you first call `useAuditNotesPageCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAuditNotesPageCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [auditNotesPageCreateMutation, { data, loading, error }] = useAuditNotesPageCreateMutation({
 *   variables: {
 *      brandHouseId: // value for 'brandHouseId'
 *      explanation: // value for 'explanation'
 *   },
 * });
 */
export function useAuditNotesPageCreateMutation(baseOptions?: Apollo.MutationHookOptions<AuditNotesPageCreateMutation, AuditNotesPageCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AuditNotesPageCreateMutation, AuditNotesPageCreateMutationVariables>(AuditNotesPageCreateDocument, options);
      }
export type AuditNotesPageCreateMutationHookResult = ReturnType<typeof useAuditNotesPageCreateMutation>;
export type AuditNotesPageCreateMutationResult = Apollo.MutationResult<AuditNotesPageCreateMutation>;
export type AuditNotesPageCreateMutationOptions = Apollo.BaseMutationOptions<AuditNotesPageCreateMutation, AuditNotesPageCreateMutationVariables>;
export const InvoiceLineOrderDocument = gql`
    query InvoiceLineOrder($lineId: MongoID!) {
  OrderLineById(_id: $lineId) {
    ...InvoiceLine
  }
  OrderById(_id: $lineId) {
    ...InvoiceOrder
  }
}
    ${InvoiceLineFragmentDoc}
${InvoiceOrderFragmentDoc}`;

/**
 * __useInvoiceLineOrderQuery__
 *
 * To run a query within a React component, call `useInvoiceLineOrderQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvoiceLineOrderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvoiceLineOrderQuery({
 *   variables: {
 *      lineId: // value for 'lineId'
 *   },
 * });
 */
export function useInvoiceLineOrderQuery(baseOptions: Apollo.QueryHookOptions<InvoiceLineOrderQuery, InvoiceLineOrderQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InvoiceLineOrderQuery, InvoiceLineOrderQueryVariables>(InvoiceLineOrderDocument, options);
      }
export function useInvoiceLineOrderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InvoiceLineOrderQuery, InvoiceLineOrderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InvoiceLineOrderQuery, InvoiceLineOrderQueryVariables>(InvoiceLineOrderDocument, options);
        }
export type InvoiceLineOrderQueryHookResult = ReturnType<typeof useInvoiceLineOrderQuery>;
export type InvoiceLineOrderLazyQueryHookResult = ReturnType<typeof useInvoiceLineOrderLazyQuery>;
export type InvoiceLineOrderQueryResult = Apollo.QueryResult<InvoiceLineOrderQuery, InvoiceLineOrderQueryVariables>;
export const InvoiceLineStockItemDocument = gql`
    query InvoiceLineStockItem($stockItemId: MongoID!) {
  StockItemById(_id: $stockItemId) {
    _id
    resolved {
      itemNr
      title
      imageUrls
      createdAt
    }
  }
  BrandItem(_id: $stockItemId) {
    _id
    resolved {
      itemNr
      nameLocalized {
        value
        locale
      }
      imageUrls
      createdAt
    }
  }
}
    `;

/**
 * __useInvoiceLineStockItemQuery__
 *
 * To run a query within a React component, call `useInvoiceLineStockItemQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvoiceLineStockItemQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvoiceLineStockItemQuery({
 *   variables: {
 *      stockItemId: // value for 'stockItemId'
 *   },
 * });
 */
export function useInvoiceLineStockItemQuery(baseOptions: Apollo.QueryHookOptions<InvoiceLineStockItemQuery, InvoiceLineStockItemQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InvoiceLineStockItemQuery, InvoiceLineStockItemQueryVariables>(InvoiceLineStockItemDocument, options);
      }
export function useInvoiceLineStockItemLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InvoiceLineStockItemQuery, InvoiceLineStockItemQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InvoiceLineStockItemQuery, InvoiceLineStockItemQueryVariables>(InvoiceLineStockItemDocument, options);
        }
export type InvoiceLineStockItemQueryHookResult = ReturnType<typeof useInvoiceLineStockItemQuery>;
export type InvoiceLineStockItemLazyQueryHookResult = ReturnType<typeof useInvoiceLineStockItemLazyQuery>;
export type InvoiceLineStockItemQueryResult = Apollo.QueryResult<InvoiceLineStockItemQuery, InvoiceLineStockItemQueryVariables>;
export const InvoiceLineTradeInDocument = gql`
    query InvoiceLineTradeIn($tradeInId: MongoID!) {
  TradeInById(_id: $tradeInId) {
    _id
    tradeInNr
    createdAt
    items {
      _id
      name
      imageUrls
    }
  }
}
    `;

/**
 * __useInvoiceLineTradeInQuery__
 *
 * To run a query within a React component, call `useInvoiceLineTradeInQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvoiceLineTradeInQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvoiceLineTradeInQuery({
 *   variables: {
 *      tradeInId: // value for 'tradeInId'
 *   },
 * });
 */
export function useInvoiceLineTradeInQuery(baseOptions: Apollo.QueryHookOptions<InvoiceLineTradeInQuery, InvoiceLineTradeInQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InvoiceLineTradeInQuery, InvoiceLineTradeInQueryVariables>(InvoiceLineTradeInDocument, options);
      }
export function useInvoiceLineTradeInLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InvoiceLineTradeInQuery, InvoiceLineTradeInQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InvoiceLineTradeInQuery, InvoiceLineTradeInQueryVariables>(InvoiceLineTradeInDocument, options);
        }
export type InvoiceLineTradeInQueryHookResult = ReturnType<typeof useInvoiceLineTradeInQuery>;
export type InvoiceLineTradeInLazyQueryHookResult = ReturnType<typeof useInvoiceLineTradeInLazyQuery>;
export type InvoiceLineTradeInQueryResult = Apollo.QueryResult<InvoiceLineTradeInQuery, InvoiceLineTradeInQueryVariables>;
export const InvoiceSettingsDocument = gql`
    query InvoiceSettings($brandHouseId: MongoID!) {
  InvoiceSetting(brandHouseId: $brandHouseId) {
    ...InvoiceFragment
  }
  BrandHouse(id: $brandHouseId) {
    _id
    shops {
      _id
      name
      currency
    }
  }
}
    ${InvoiceFragmentDoc}`;

/**
 * __useInvoiceSettingsQuery__
 *
 * To run a query within a React component, call `useInvoiceSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvoiceSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvoiceSettingsQuery({
 *   variables: {
 *      brandHouseId: // value for 'brandHouseId'
 *   },
 * });
 */
export function useInvoiceSettingsQuery(baseOptions: Apollo.QueryHookOptions<InvoiceSettingsQuery, InvoiceSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InvoiceSettingsQuery, InvoiceSettingsQueryVariables>(InvoiceSettingsDocument, options);
      }
export function useInvoiceSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InvoiceSettingsQuery, InvoiceSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InvoiceSettingsQuery, InvoiceSettingsQueryVariables>(InvoiceSettingsDocument, options);
        }
export type InvoiceSettingsQueryHookResult = ReturnType<typeof useInvoiceSettingsQuery>;
export type InvoiceSettingsLazyQueryHookResult = ReturnType<typeof useInvoiceSettingsLazyQuery>;
export type InvoiceSettingsQueryResult = Apollo.QueryResult<InvoiceSettingsQuery, InvoiceSettingsQueryVariables>;
export const InvoiceSettingsUpdateDocument = gql`
    mutation InvoiceSettingsUpdate($settings: InvoiceSettingInput!) {
  InvoiceSettingUpdate(record: $settings) {
    ...InvoiceFragment
  }
}
    ${InvoiceFragmentDoc}`;
export type InvoiceSettingsUpdateMutationFn = Apollo.MutationFunction<InvoiceSettingsUpdateMutation, InvoiceSettingsUpdateMutationVariables>;

/**
 * __useInvoiceSettingsUpdateMutation__
 *
 * To run a mutation, you first call `useInvoiceSettingsUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInvoiceSettingsUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [invoiceSettingsUpdateMutation, { data, loading, error }] = useInvoiceSettingsUpdateMutation({
 *   variables: {
 *      settings: // value for 'settings'
 *   },
 * });
 */
export function useInvoiceSettingsUpdateMutation(baseOptions?: Apollo.MutationHookOptions<InvoiceSettingsUpdateMutation, InvoiceSettingsUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InvoiceSettingsUpdateMutation, InvoiceSettingsUpdateMutationVariables>(InvoiceSettingsUpdateDocument, options);
      }
export type InvoiceSettingsUpdateMutationHookResult = ReturnType<typeof useInvoiceSettingsUpdateMutation>;
export type InvoiceSettingsUpdateMutationResult = Apollo.MutationResult<InvoiceSettingsUpdateMutation>;
export type InvoiceSettingsUpdateMutationOptions = Apollo.BaseMutationOptions<InvoiceSettingsUpdateMutation, InvoiceSettingsUpdateMutationVariables>;
export const InvoicesDocument = gql`
    query Invoices($brandHouseId: MongoID!) {
  Invoices(brandHouseId: $brandHouseId, limit: 10000) {
    _id
    brandHouseId
    invoiceId
    invoiceDate
    locked
    paid
    total {
      total
      sections {
        total
        title
        lines {
          lineType
          title
          count
          sum
        }
      }
    }
    currency
  }
}
    `;

/**
 * __useInvoicesQuery__
 *
 * To run a query within a React component, call `useInvoicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvoicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvoicesQuery({
 *   variables: {
 *      brandHouseId: // value for 'brandHouseId'
 *   },
 * });
 */
export function useInvoicesQuery(baseOptions: Apollo.QueryHookOptions<InvoicesQuery, InvoicesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InvoicesQuery, InvoicesQueryVariables>(InvoicesDocument, options);
      }
export function useInvoicesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InvoicesQuery, InvoicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InvoicesQuery, InvoicesQueryVariables>(InvoicesDocument, options);
        }
export type InvoicesQueryHookResult = ReturnType<typeof useInvoicesQuery>;
export type InvoicesLazyQueryHookResult = ReturnType<typeof useInvoicesLazyQuery>;
export type InvoicesQueryResult = Apollo.QueryResult<InvoicesQuery, InvoicesQueryVariables>;
export const InvoiceResetDocument = gql`
    mutation InvoiceReset($brandHouseId: MongoID!, $invoiceId: String!) {
  InvoiceReset(brandHouseId: $brandHouseId, invoiceId: $invoiceId) {
    _id
  }
}
    `;
export type InvoiceResetMutationFn = Apollo.MutationFunction<InvoiceResetMutation, InvoiceResetMutationVariables>;

/**
 * __useInvoiceResetMutation__
 *
 * To run a mutation, you first call `useInvoiceResetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInvoiceResetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [invoiceResetMutation, { data, loading, error }] = useInvoiceResetMutation({
 *   variables: {
 *      brandHouseId: // value for 'brandHouseId'
 *      invoiceId: // value for 'invoiceId'
 *   },
 * });
 */
export function useInvoiceResetMutation(baseOptions?: Apollo.MutationHookOptions<InvoiceResetMutation, InvoiceResetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InvoiceResetMutation, InvoiceResetMutationVariables>(InvoiceResetDocument, options);
      }
export type InvoiceResetMutationHookResult = ReturnType<typeof useInvoiceResetMutation>;
export type InvoiceResetMutationResult = Apollo.MutationResult<InvoiceResetMutation>;
export type InvoiceResetMutationOptions = Apollo.BaseMutationOptions<InvoiceResetMutation, InvoiceResetMutationVariables>;
export const InvoiceLinesDocument = gql`
    query InvoiceLines($invoiceId: MongoID!, $lineType: EnumInvoiceLineLineType!) {
  InvoiceLines(
    filter: {invoiceId: $invoiceId, lineType: $lineType}
    sort: _ID_DESC
    limit: 1000
  ) {
    _id
    brandHouseId
    invoiceId
    cost
    currency
    lineType
    lineId
    lineDate
    createdAt
  }
}
    `;

/**
 * __useInvoiceLinesQuery__
 *
 * To run a query within a React component, call `useInvoiceLinesQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvoiceLinesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvoiceLinesQuery({
 *   variables: {
 *      invoiceId: // value for 'invoiceId'
 *      lineType: // value for 'lineType'
 *   },
 * });
 */
export function useInvoiceLinesQuery(baseOptions: Apollo.QueryHookOptions<InvoiceLinesQuery, InvoiceLinesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InvoiceLinesQuery, InvoiceLinesQueryVariables>(InvoiceLinesDocument, options);
      }
export function useInvoiceLinesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InvoiceLinesQuery, InvoiceLinesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InvoiceLinesQuery, InvoiceLinesQueryVariables>(InvoiceLinesDocument, options);
        }
export type InvoiceLinesQueryHookResult = ReturnType<typeof useInvoiceLinesQuery>;
export type InvoiceLinesLazyQueryHookResult = ReturnType<typeof useInvoiceLinesLazyQuery>;
export type InvoiceLinesQueryResult = Apollo.QueryResult<InvoiceLinesQuery, InvoiceLinesQueryVariables>;
export const InvoicePageUpdateDocument = gql`
    mutation InvoicePageUpdate($brandHouseId: MongoID!, $invoiceId: String!, $locked: Boolean, $paid: Boolean) {
  InvoiceUpdate(
    brandHouseId: $brandHouseId
    invoiceId: $invoiceId
    paid: $paid
    locked: $locked
  ) {
    _id
    paid
    locked
  }
}
    `;
export type InvoicePageUpdateMutationFn = Apollo.MutationFunction<InvoicePageUpdateMutation, InvoicePageUpdateMutationVariables>;

/**
 * __useInvoicePageUpdateMutation__
 *
 * To run a mutation, you first call `useInvoicePageUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInvoicePageUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [invoicePageUpdateMutation, { data, loading, error }] = useInvoicePageUpdateMutation({
 *   variables: {
 *      brandHouseId: // value for 'brandHouseId'
 *      invoiceId: // value for 'invoiceId'
 *      locked: // value for 'locked'
 *      paid: // value for 'paid'
 *   },
 * });
 */
export function useInvoicePageUpdateMutation(baseOptions?: Apollo.MutationHookOptions<InvoicePageUpdateMutation, InvoicePageUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InvoicePageUpdateMutation, InvoicePageUpdateMutationVariables>(InvoicePageUpdateDocument, options);
      }
export type InvoicePageUpdateMutationHookResult = ReturnType<typeof useInvoicePageUpdateMutation>;
export type InvoicePageUpdateMutationResult = Apollo.MutationResult<InvoicePageUpdateMutation>;
export type InvoicePageUpdateMutationOptions = Apollo.BaseMutationOptions<InvoicePageUpdateMutation, InvoicePageUpdateMutationVariables>;
export const InvoicePageDeleteDocument = gql`
    mutation InvoicePageDelete($brandHouseId: MongoID!, $invoiceId: String!) {
  InvoiceDelete(brandHouseId: $brandHouseId, invoiceId: $invoiceId)
}
    `;
export type InvoicePageDeleteMutationFn = Apollo.MutationFunction<InvoicePageDeleteMutation, InvoicePageDeleteMutationVariables>;

/**
 * __useInvoicePageDeleteMutation__
 *
 * To run a mutation, you first call `useInvoicePageDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInvoicePageDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [invoicePageDeleteMutation, { data, loading, error }] = useInvoicePageDeleteMutation({
 *   variables: {
 *      brandHouseId: // value for 'brandHouseId'
 *      invoiceId: // value for 'invoiceId'
 *   },
 * });
 */
export function useInvoicePageDeleteMutation(baseOptions?: Apollo.MutationHookOptions<InvoicePageDeleteMutation, InvoicePageDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InvoicePageDeleteMutation, InvoicePageDeleteMutationVariables>(InvoicePageDeleteDocument, options);
      }
export type InvoicePageDeleteMutationHookResult = ReturnType<typeof useInvoicePageDeleteMutation>;
export type InvoicePageDeleteMutationResult = Apollo.MutationResult<InvoicePageDeleteMutation>;
export type InvoicePageDeleteMutationOptions = Apollo.BaseMutationOptions<InvoicePageDeleteMutation, InvoicePageDeleteMutationVariables>;
export const InvoiceRebuildBrandDocument = gql`
    mutation InvoiceRebuildBrand($brandHouseId: MongoID!) {
  InvoiceRebuild(brandHouseId: $brandHouseId)
}
    `;
export type InvoiceRebuildBrandMutationFn = Apollo.MutationFunction<InvoiceRebuildBrandMutation, InvoiceRebuildBrandMutationVariables>;

/**
 * __useInvoiceRebuildBrandMutation__
 *
 * To run a mutation, you first call `useInvoiceRebuildBrandMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInvoiceRebuildBrandMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [invoiceRebuildBrandMutation, { data, loading, error }] = useInvoiceRebuildBrandMutation({
 *   variables: {
 *      brandHouseId: // value for 'brandHouseId'
 *   },
 * });
 */
export function useInvoiceRebuildBrandMutation(baseOptions?: Apollo.MutationHookOptions<InvoiceRebuildBrandMutation, InvoiceRebuildBrandMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InvoiceRebuildBrandMutation, InvoiceRebuildBrandMutationVariables>(InvoiceRebuildBrandDocument, options);
      }
export type InvoiceRebuildBrandMutationHookResult = ReturnType<typeof useInvoiceRebuildBrandMutation>;
export type InvoiceRebuildBrandMutationResult = Apollo.MutationResult<InvoiceRebuildBrandMutation>;
export type InvoiceRebuildBrandMutationOptions = Apollo.BaseMutationOptions<InvoiceRebuildBrandMutation, InvoiceRebuildBrandMutationVariables>;
export const InvoiceAdjustmentsDocument = gql`
    query InvoiceAdjustments($brandHouseId: MongoID!) {
  InvoiceAdjustments(filter: {brandHouseId: $brandHouseId}) {
    _id
    amount
    createdAt
    description
  }
}
    `;

/**
 * __useInvoiceAdjustmentsQuery__
 *
 * To run a query within a React component, call `useInvoiceAdjustmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvoiceAdjustmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvoiceAdjustmentsQuery({
 *   variables: {
 *      brandHouseId: // value for 'brandHouseId'
 *   },
 * });
 */
export function useInvoiceAdjustmentsQuery(baseOptions: Apollo.QueryHookOptions<InvoiceAdjustmentsQuery, InvoiceAdjustmentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InvoiceAdjustmentsQuery, InvoiceAdjustmentsQueryVariables>(InvoiceAdjustmentsDocument, options);
      }
export function useInvoiceAdjustmentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InvoiceAdjustmentsQuery, InvoiceAdjustmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InvoiceAdjustmentsQuery, InvoiceAdjustmentsQueryVariables>(InvoiceAdjustmentsDocument, options);
        }
export type InvoiceAdjustmentsQueryHookResult = ReturnType<typeof useInvoiceAdjustmentsQuery>;
export type InvoiceAdjustmentsLazyQueryHookResult = ReturnType<typeof useInvoiceAdjustmentsLazyQuery>;
export type InvoiceAdjustmentsQueryResult = Apollo.QueryResult<InvoiceAdjustmentsQuery, InvoiceAdjustmentsQueryVariables>;
export const InvoiceAdjustmentCreateDocument = gql`
    mutation InvoiceAdjustmentCreate($input: CreateOneInvoiceAdjustmentInput!) {
  InvoiceAdjustmentCreate(record: $input) {
    record {
      _id
      amount
      createdAt
      description
    }
  }
}
    `;
export type InvoiceAdjustmentCreateMutationFn = Apollo.MutationFunction<InvoiceAdjustmentCreateMutation, InvoiceAdjustmentCreateMutationVariables>;

/**
 * __useInvoiceAdjustmentCreateMutation__
 *
 * To run a mutation, you first call `useInvoiceAdjustmentCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInvoiceAdjustmentCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [invoiceAdjustmentCreateMutation, { data, loading, error }] = useInvoiceAdjustmentCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInvoiceAdjustmentCreateMutation(baseOptions?: Apollo.MutationHookOptions<InvoiceAdjustmentCreateMutation, InvoiceAdjustmentCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InvoiceAdjustmentCreateMutation, InvoiceAdjustmentCreateMutationVariables>(InvoiceAdjustmentCreateDocument, options);
      }
export type InvoiceAdjustmentCreateMutationHookResult = ReturnType<typeof useInvoiceAdjustmentCreateMutation>;
export type InvoiceAdjustmentCreateMutationResult = Apollo.MutationResult<InvoiceAdjustmentCreateMutation>;
export type InvoiceAdjustmentCreateMutationOptions = Apollo.BaseMutationOptions<InvoiceAdjustmentCreateMutation, InvoiceAdjustmentCreateMutationVariables>;
export const ObjectHistoryDocument = gql`
    query objectHistory($ref: MongoID!) {
  PatchPagination(sort: _ID_DESC, perPage: 100, page: 1, filter: {ref: $ref}) {
    count
    items {
      ...ObjectPatchFragment
    }
    pageInfo {
      hasNextPage
    }
  }
}
    ${ObjectPatchFragmentDoc}`;

/**
 * __useObjectHistoryQuery__
 *
 * To run a query within a React component, call `useObjectHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useObjectHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useObjectHistoryQuery({
 *   variables: {
 *      ref: // value for 'ref'
 *   },
 * });
 */
export function useObjectHistoryQuery(baseOptions: Apollo.QueryHookOptions<ObjectHistoryQuery, ObjectHistoryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ObjectHistoryQuery, ObjectHistoryQueryVariables>(ObjectHistoryDocument, options);
      }
export function useObjectHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ObjectHistoryQuery, ObjectHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ObjectHistoryQuery, ObjectHistoryQueryVariables>(ObjectHistoryDocument, options);
        }
export type ObjectHistoryQueryHookResult = ReturnType<typeof useObjectHistoryQuery>;
export type ObjectHistoryLazyQueryHookResult = ReturnType<typeof useObjectHistoryLazyQuery>;
export type ObjectHistoryQueryResult = Apollo.QueryResult<ObjectHistoryQuery, ObjectHistoryQueryVariables>;
export const ObjectHistoryUserDocument = gql`
    query objectHistoryUser($id: MongoID!) {
  User(_id: $id) {
    name
    email
  }
}
    `;

/**
 * __useObjectHistoryUserQuery__
 *
 * To run a query within a React component, call `useObjectHistoryUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useObjectHistoryUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useObjectHistoryUserQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useObjectHistoryUserQuery(baseOptions: Apollo.QueryHookOptions<ObjectHistoryUserQuery, ObjectHistoryUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ObjectHistoryUserQuery, ObjectHistoryUserQueryVariables>(ObjectHistoryUserDocument, options);
      }
export function useObjectHistoryUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ObjectHistoryUserQuery, ObjectHistoryUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ObjectHistoryUserQuery, ObjectHistoryUserQueryVariables>(ObjectHistoryUserDocument, options);
        }
export type ObjectHistoryUserQueryHookResult = ReturnType<typeof useObjectHistoryUserQuery>;
export type ObjectHistoryUserLazyQueryHookResult = ReturnType<typeof useObjectHistoryUserLazyQuery>;
export type ObjectHistoryUserQueryResult = Apollo.QueryResult<ObjectHistoryUserQuery, ObjectHistoryUserQueryVariables>;
export const ListsTradeInsListDocument = gql`
    query ListsTradeInsList($search: String, $filter: FilterFindManyTradeInInput, $sort: SortFindManyTradeInInput, $page: Int, $perPage: Int, $viewId: MongoID) {
  TradeInPagination(
    filter: $filter
    search: $search
    page: $page
    perPage: $perPage
    sort: $sort
    viewId: $viewId
  ) {
    count
    pageInfo {
      perPage
      currentPage
      hasNextPage
      hasPreviousPage
      itemCount
      pageCount
    }
    items {
      ...ListsTradeInFragment
    }
  }
}
    ${ListsTradeInFragmentDoc}`;

/**
 * __useListsTradeInsListQuery__
 *
 * To run a query within a React component, call `useListsTradeInsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useListsTradeInsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListsTradeInsListQuery({
 *   variables: {
 *      search: // value for 'search'
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *      viewId: // value for 'viewId'
 *   },
 * });
 */
export function useListsTradeInsListQuery(baseOptions?: Apollo.QueryHookOptions<ListsTradeInsListQuery, ListsTradeInsListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListsTradeInsListQuery, ListsTradeInsListQueryVariables>(ListsTradeInsListDocument, options);
      }
export function useListsTradeInsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListsTradeInsListQuery, ListsTradeInsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListsTradeInsListQuery, ListsTradeInsListQueryVariables>(ListsTradeInsListDocument, options);
        }
export type ListsTradeInsListQueryHookResult = ReturnType<typeof useListsTradeInsListQuery>;
export type ListsTradeInsListLazyQueryHookResult = ReturnType<typeof useListsTradeInsListLazyQuery>;
export type ListsTradeInsListQueryResult = Apollo.QueryResult<ListsTradeInsListQuery, ListsTradeInsListQueryVariables>;
export const ListTrackingViewDataDocument = gql`
    query ListTrackingViewData($filter: FilterFindManyTrackingInput!) {
  TrackingMany(filter: $filter, sort: _ID_DESC, limit: 200) {
    _id
    shopId
    ts
    objectId
    objectType
    objectPayload
    browser
    ip
  }
}
    `;

/**
 * __useListTrackingViewDataQuery__
 *
 * To run a query within a React component, call `useListTrackingViewDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useListTrackingViewDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListTrackingViewDataQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useListTrackingViewDataQuery(baseOptions: Apollo.QueryHookOptions<ListTrackingViewDataQuery, ListTrackingViewDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListTrackingViewDataQuery, ListTrackingViewDataQueryVariables>(ListTrackingViewDataDocument, options);
      }
export function useListTrackingViewDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListTrackingViewDataQuery, ListTrackingViewDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListTrackingViewDataQuery, ListTrackingViewDataQueryVariables>(ListTrackingViewDataDocument, options);
        }
export type ListTrackingViewDataQueryHookResult = ReturnType<typeof useListTrackingViewDataQuery>;
export type ListTrackingViewDataLazyQueryHookResult = ReturnType<typeof useListTrackingViewDataLazyQuery>;
export type ListTrackingViewDataQueryResult = Apollo.QueryResult<ListTrackingViewDataQuery, ListTrackingViewDataQueryVariables>;
export const ListTrackingDataDocument = gql`
    query ListTrackingData($filter: FilterFindManyTrackingInput!) {
  TrackingPagination(filter: $filter, sort: _ID_DESC, page: 1, perPage: 200) {
    items {
      _id
      shopId
      ts
      objectId
      objectType
      objectPayload
      browser
      ip
    }
    count
  }
}
    `;

/**
 * __useListTrackingDataQuery__
 *
 * To run a query within a React component, call `useListTrackingDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useListTrackingDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListTrackingDataQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useListTrackingDataQuery(baseOptions: Apollo.QueryHookOptions<ListTrackingDataQuery, ListTrackingDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListTrackingDataQuery, ListTrackingDataQueryVariables>(ListTrackingDataDocument, options);
      }
export function useListTrackingDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListTrackingDataQuery, ListTrackingDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListTrackingDataQuery, ListTrackingDataQueryVariables>(ListTrackingDataDocument, options);
        }
export type ListTrackingDataQueryHookResult = ReturnType<typeof useListTrackingDataQuery>;
export type ListTrackingDataLazyQueryHookResult = ReturnType<typeof useListTrackingDataLazyQuery>;
export type ListTrackingDataQueryResult = Apollo.QueryResult<ListTrackingDataQuery, ListTrackingDataQueryVariables>;
export const ListTrackingStockItemDocument = gql`
    query ListTrackingStockItem($stockItemId: MongoID!) {
  StockItemById(_id: $stockItemId) {
    _id
    title
    imageUrls
    isSold
    shopId
    shop {
      brandHouseId
    }
  }
}
    `;

/**
 * __useListTrackingStockItemQuery__
 *
 * To run a query within a React component, call `useListTrackingStockItemQuery` and pass it any options that fit your needs.
 * When your component renders, `useListTrackingStockItemQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListTrackingStockItemQuery({
 *   variables: {
 *      stockItemId: // value for 'stockItemId'
 *   },
 * });
 */
export function useListTrackingStockItemQuery(baseOptions: Apollo.QueryHookOptions<ListTrackingStockItemQuery, ListTrackingStockItemQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListTrackingStockItemQuery, ListTrackingStockItemQueryVariables>(ListTrackingStockItemDocument, options);
      }
export function useListTrackingStockItemLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListTrackingStockItemQuery, ListTrackingStockItemQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListTrackingStockItemQuery, ListTrackingStockItemQueryVariables>(ListTrackingStockItemDocument, options);
        }
export type ListTrackingStockItemQueryHookResult = ReturnType<typeof useListTrackingStockItemQuery>;
export type ListTrackingStockItemLazyQueryHookResult = ReturnType<typeof useListTrackingStockItemLazyQuery>;
export type ListTrackingStockItemQueryResult = Apollo.QueryResult<ListTrackingStockItemQuery, ListTrackingStockItemQueryVariables>;
export const ListTrackingBrandDocument = gql`
    query ListTrackingBrand($shopId: MongoID!) {
  ShopById(_id: $shopId) {
    _id
    name
    brandHouseId
  }
}
    `;

/**
 * __useListTrackingBrandQuery__
 *
 * To run a query within a React component, call `useListTrackingBrandQuery` and pass it any options that fit your needs.
 * When your component renders, `useListTrackingBrandQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListTrackingBrandQuery({
 *   variables: {
 *      shopId: // value for 'shopId'
 *   },
 * });
 */
export function useListTrackingBrandQuery(baseOptions: Apollo.QueryHookOptions<ListTrackingBrandQuery, ListTrackingBrandQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListTrackingBrandQuery, ListTrackingBrandQueryVariables>(ListTrackingBrandDocument, options);
      }
export function useListTrackingBrandLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListTrackingBrandQuery, ListTrackingBrandQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListTrackingBrandQuery, ListTrackingBrandQueryVariables>(ListTrackingBrandDocument, options);
        }
export type ListTrackingBrandQueryHookResult = ReturnType<typeof useListTrackingBrandQuery>;
export type ListTrackingBrandLazyQueryHookResult = ReturnType<typeof useListTrackingBrandLazyQuery>;
export type ListTrackingBrandQueryResult = Apollo.QueryResult<ListTrackingBrandQuery, ListTrackingBrandQueryVariables>;
export const ListTrackingVariantByIdDocument = gql`
    query ListTrackingVariantById($id: String!) {
  ProductVariant(id: $id) {
    _id
    productId
    product {
      name
    }
    shopId
    shop {
      brandHouseId
    }
    imageUrls
  }
}
    `;

/**
 * __useListTrackingVariantByIdQuery__
 *
 * To run a query within a React component, call `useListTrackingVariantByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useListTrackingVariantByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListTrackingVariantByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useListTrackingVariantByIdQuery(baseOptions: Apollo.QueryHookOptions<ListTrackingVariantByIdQuery, ListTrackingVariantByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListTrackingVariantByIdQuery, ListTrackingVariantByIdQueryVariables>(ListTrackingVariantByIdDocument, options);
      }
export function useListTrackingVariantByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListTrackingVariantByIdQuery, ListTrackingVariantByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListTrackingVariantByIdQuery, ListTrackingVariantByIdQueryVariables>(ListTrackingVariantByIdDocument, options);
        }
export type ListTrackingVariantByIdQueryHookResult = ReturnType<typeof useListTrackingVariantByIdQuery>;
export type ListTrackingVariantByIdLazyQueryHookResult = ReturnType<typeof useListTrackingVariantByIdLazyQuery>;
export type ListTrackingVariantByIdQueryResult = Apollo.QueryResult<ListTrackingVariantByIdQuery, ListTrackingVariantByIdQueryVariables>;
export const ExportTradeInsConsumerDocument = gql`
    query ExportTradeInsConsumer($consumerId: MongoID!, $dateTime: Date!, $now: Date!) {
  ConsumerById(_id: $consumerId) {
    statisticsBefore: statistics(date: $dateTime) {
      orders
      tradeIns
    }
    statisticsAfter: statistics(date: $now) {
      orders
      tradeIns
    }
  }
}
    `;

/**
 * __useExportTradeInsConsumerQuery__
 *
 * To run a query within a React component, call `useExportTradeInsConsumerQuery` and pass it any options that fit your needs.
 * When your component renders, `useExportTradeInsConsumerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExportTradeInsConsumerQuery({
 *   variables: {
 *      consumerId: // value for 'consumerId'
 *      dateTime: // value for 'dateTime'
 *      now: // value for 'now'
 *   },
 * });
 */
export function useExportTradeInsConsumerQuery(baseOptions: Apollo.QueryHookOptions<ExportTradeInsConsumerQuery, ExportTradeInsConsumerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExportTradeInsConsumerQuery, ExportTradeInsConsumerQueryVariables>(ExportTradeInsConsumerDocument, options);
      }
export function useExportTradeInsConsumerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExportTradeInsConsumerQuery, ExportTradeInsConsumerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExportTradeInsConsumerQuery, ExportTradeInsConsumerQueryVariables>(ExportTradeInsConsumerDocument, options);
        }
export type ExportTradeInsConsumerQueryHookResult = ReturnType<typeof useExportTradeInsConsumerQuery>;
export type ExportTradeInsConsumerLazyQueryHookResult = ReturnType<typeof useExportTradeInsConsumerLazyQuery>;
export type ExportTradeInsConsumerQueryResult = Apollo.QueryResult<ExportTradeInsConsumerQuery, ExportTradeInsConsumerQueryVariables>;
export const ExportTradeInsDocument = gql`
    query ExportTradeIns($tradeIns: [MongoID!], $currency: String!) {
  TradeIns(
    filter: {_operators: {_id: {in: $tradeIns}, deletedTs: {exists: false}}}
    limit: 99999
  ) {
    ...TradeInExport
  }
}
    ${TradeInExportFragmentDoc}`;

/**
 * __useExportTradeInsQuery__
 *
 * To run a query within a React component, call `useExportTradeInsQuery` and pass it any options that fit your needs.
 * When your component renders, `useExportTradeInsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExportTradeInsQuery({
 *   variables: {
 *      tradeIns: // value for 'tradeIns'
 *      currency: // value for 'currency'
 *   },
 * });
 */
export function useExportTradeInsQuery(baseOptions: Apollo.QueryHookOptions<ExportTradeInsQuery, ExportTradeInsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExportTradeInsQuery, ExportTradeInsQueryVariables>(ExportTradeInsDocument, options);
      }
export function useExportTradeInsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExportTradeInsQuery, ExportTradeInsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExportTradeInsQuery, ExportTradeInsQueryVariables>(ExportTradeInsDocument, options);
        }
export type ExportTradeInsQueryHookResult = ReturnType<typeof useExportTradeInsQuery>;
export type ExportTradeInsLazyQueryHookResult = ReturnType<typeof useExportTradeInsLazyQuery>;
export type ExportTradeInsQueryResult = Apollo.QueryResult<ExportTradeInsQuery, ExportTradeInsQueryVariables>;
export const ExportTradeInItemsDocument = gql`
    query ExportTradeInItems($tradeIns: [MongoID!]) {
  TradeIns(
    filter: {_operators: {_id: {in: $tradeIns}, deletedTs: {exists: false}}}
    limit: 99999
  ) {
    ...TradeInExportItems
  }
}
    ${TradeInExportItemsFragmentDoc}`;

/**
 * __useExportTradeInItemsQuery__
 *
 * To run a query within a React component, call `useExportTradeInItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useExportTradeInItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExportTradeInItemsQuery({
 *   variables: {
 *      tradeIns: // value for 'tradeIns'
 *   },
 * });
 */
export function useExportTradeInItemsQuery(baseOptions?: Apollo.QueryHookOptions<ExportTradeInItemsQuery, ExportTradeInItemsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExportTradeInItemsQuery, ExportTradeInItemsQueryVariables>(ExportTradeInItemsDocument, options);
      }
export function useExportTradeInItemsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExportTradeInItemsQuery, ExportTradeInItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExportTradeInItemsQuery, ExportTradeInItemsQueryVariables>(ExportTradeInItemsDocument, options);
        }
export type ExportTradeInItemsQueryHookResult = ReturnType<typeof useExportTradeInItemsQuery>;
export type ExportTradeInItemsLazyQueryHookResult = ReturnType<typeof useExportTradeInItemsLazyQuery>;
export type ExportTradeInItemsQueryResult = Apollo.QueryResult<ExportTradeInItemsQuery, ExportTradeInItemsQueryVariables>;
export const LogisticsBrandItemsPagePushDocument = gql`
    mutation LogisticsBrandItemsPagePush($brandItemId: MongoID!, $active: Boolean!) {
  BrandItemPush(brandItemId: $brandItemId, active: $active) {
    _id
    active
    shopId
  }
}
    `;
export type LogisticsBrandItemsPagePushMutationFn = Apollo.MutationFunction<LogisticsBrandItemsPagePushMutation, LogisticsBrandItemsPagePushMutationVariables>;

/**
 * __useLogisticsBrandItemsPagePushMutation__
 *
 * To run a mutation, you first call `useLogisticsBrandItemsPagePushMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLogisticsBrandItemsPagePushMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [logisticsBrandItemsPagePushMutation, { data, loading, error }] = useLogisticsBrandItemsPagePushMutation({
 *   variables: {
 *      brandItemId: // value for 'brandItemId'
 *      active: // value for 'active'
 *   },
 * });
 */
export function useLogisticsBrandItemsPagePushMutation(baseOptions?: Apollo.MutationHookOptions<LogisticsBrandItemsPagePushMutation, LogisticsBrandItemsPagePushMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LogisticsBrandItemsPagePushMutation, LogisticsBrandItemsPagePushMutationVariables>(LogisticsBrandItemsPagePushDocument, options);
      }
export type LogisticsBrandItemsPagePushMutationHookResult = ReturnType<typeof useLogisticsBrandItemsPagePushMutation>;
export type LogisticsBrandItemsPagePushMutationResult = Apollo.MutationResult<LogisticsBrandItemsPagePushMutation>;
export type LogisticsBrandItemsPagePushMutationOptions = Apollo.BaseMutationOptions<LogisticsBrandItemsPagePushMutation, LogisticsBrandItemsPagePushMutationVariables>;
export const LogisticsBrandItemRetouchDocument = gql`
    mutation LogisticsBrandItemRetouch($ids: [MongoID!]!) {
  BrandItemRetouch(brandItemIds: $ids) {
    _id
    imageUrls
    images {
      _id
      imageUrl
    }
  }
}
    `;
export type LogisticsBrandItemRetouchMutationFn = Apollo.MutationFunction<LogisticsBrandItemRetouchMutation, LogisticsBrandItemRetouchMutationVariables>;

/**
 * __useLogisticsBrandItemRetouchMutation__
 *
 * To run a mutation, you first call `useLogisticsBrandItemRetouchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLogisticsBrandItemRetouchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [logisticsBrandItemRetouchMutation, { data, loading, error }] = useLogisticsBrandItemRetouchMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useLogisticsBrandItemRetouchMutation(baseOptions?: Apollo.MutationHookOptions<LogisticsBrandItemRetouchMutation, LogisticsBrandItemRetouchMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LogisticsBrandItemRetouchMutation, LogisticsBrandItemRetouchMutationVariables>(LogisticsBrandItemRetouchDocument, options);
      }
export type LogisticsBrandItemRetouchMutationHookResult = ReturnType<typeof useLogisticsBrandItemRetouchMutation>;
export type LogisticsBrandItemRetouchMutationResult = Apollo.MutationResult<LogisticsBrandItemRetouchMutation>;
export type LogisticsBrandItemRetouchMutationOptions = Apollo.BaseMutationOptions<LogisticsBrandItemRetouchMutation, LogisticsBrandItemRetouchMutationVariables>;
export const LogisticsBrandItemInfoDocument = gql`
    query LogisticsBrandItemInfo($brandItemId: MongoID!) {
  BrandItem(_id: $brandItemId) {
    _id
    brandHouseId
  }
}
    `;

/**
 * __useLogisticsBrandItemInfoQuery__
 *
 * To run a query within a React component, call `useLogisticsBrandItemInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useLogisticsBrandItemInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLogisticsBrandItemInfoQuery({
 *   variables: {
 *      brandItemId: // value for 'brandItemId'
 *   },
 * });
 */
export function useLogisticsBrandItemInfoQuery(baseOptions: Apollo.QueryHookOptions<LogisticsBrandItemInfoQuery, LogisticsBrandItemInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LogisticsBrandItemInfoQuery, LogisticsBrandItemInfoQueryVariables>(LogisticsBrandItemInfoDocument, options);
      }
export function useLogisticsBrandItemInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LogisticsBrandItemInfoQuery, LogisticsBrandItemInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LogisticsBrandItemInfoQuery, LogisticsBrandItemInfoQueryVariables>(LogisticsBrandItemInfoDocument, options);
        }
export type LogisticsBrandItemInfoQueryHookResult = ReturnType<typeof useLogisticsBrandItemInfoQuery>;
export type LogisticsBrandItemInfoLazyQueryHookResult = ReturnType<typeof useLogisticsBrandItemInfoLazyQuery>;
export type LogisticsBrandItemInfoQueryResult = Apollo.QueryResult<LogisticsBrandItemInfoQuery, LogisticsBrandItemInfoQueryVariables>;
export const LogisticsPartnersPageDocument = gql`
    query LogisticsPartnersPage {
  LogisticsPartners {
    ...LogisticsPartnerListFields
  }
}
    ${LogisticsPartnerListFieldsFragmentDoc}`;

/**
 * __useLogisticsPartnersPageQuery__
 *
 * To run a query within a React component, call `useLogisticsPartnersPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useLogisticsPartnersPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLogisticsPartnersPageQuery({
 *   variables: {
 *   },
 * });
 */
export function useLogisticsPartnersPageQuery(baseOptions?: Apollo.QueryHookOptions<LogisticsPartnersPageQuery, LogisticsPartnersPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LogisticsPartnersPageQuery, LogisticsPartnersPageQueryVariables>(LogisticsPartnersPageDocument, options);
      }
export function useLogisticsPartnersPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LogisticsPartnersPageQuery, LogisticsPartnersPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LogisticsPartnersPageQuery, LogisticsPartnersPageQueryVariables>(LogisticsPartnersPageDocument, options);
        }
export type LogisticsPartnersPageQueryHookResult = ReturnType<typeof useLogisticsPartnersPageQuery>;
export type LogisticsPartnersPageLazyQueryHookResult = ReturnType<typeof useLogisticsPartnersPageLazyQuery>;
export type LogisticsPartnersPageQueryResult = Apollo.QueryResult<LogisticsPartnersPageQuery, LogisticsPartnersPageQueryVariables>;
export const LogisticsPartnerSettingsPageDocument = gql`
    query LogisticsPartnerSettingsPage($id: MongoID!) {
  LogisticsPartner(_id: $id) {
    ...LogisticsPartnerFields
  }
}
    ${LogisticsPartnerFieldsFragmentDoc}`;

/**
 * __useLogisticsPartnerSettingsPageQuery__
 *
 * To run a query within a React component, call `useLogisticsPartnerSettingsPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useLogisticsPartnerSettingsPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLogisticsPartnerSettingsPageQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useLogisticsPartnerSettingsPageQuery(baseOptions: Apollo.QueryHookOptions<LogisticsPartnerSettingsPageQuery, LogisticsPartnerSettingsPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LogisticsPartnerSettingsPageQuery, LogisticsPartnerSettingsPageQueryVariables>(LogisticsPartnerSettingsPageDocument, options);
      }
export function useLogisticsPartnerSettingsPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LogisticsPartnerSettingsPageQuery, LogisticsPartnerSettingsPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LogisticsPartnerSettingsPageQuery, LogisticsPartnerSettingsPageQueryVariables>(LogisticsPartnerSettingsPageDocument, options);
        }
export type LogisticsPartnerSettingsPageQueryHookResult = ReturnType<typeof useLogisticsPartnerSettingsPageQuery>;
export type LogisticsPartnerSettingsPageLazyQueryHookResult = ReturnType<typeof useLogisticsPartnerSettingsPageLazyQuery>;
export type LogisticsPartnerSettingsPageQueryResult = Apollo.QueryResult<LogisticsPartnerSettingsPageQuery, LogisticsPartnerSettingsPageQueryVariables>;
export const LogisticsPartnersPageCreateDocument = gql`
    mutation LogisticsPartnersPageCreate($name: String!, $attention: String, $address: String, $address2: String, $zipCode: String, $city: String, $country: String, $countryCode: String, $mail: String, $phone: String) {
  LogisticsPartnerCreate(
    name: $name
    attention: $attention
    address: $address
    address2: $address2
    zipCode: $zipCode
    city: $city
    country: $country
    countryCode: $countryCode
    mail: $mail
    phone: $phone
  ) {
    ...LogisticsPartnerFields
  }
}
    ${LogisticsPartnerFieldsFragmentDoc}`;
export type LogisticsPartnersPageCreateMutationFn = Apollo.MutationFunction<LogisticsPartnersPageCreateMutation, LogisticsPartnersPageCreateMutationVariables>;

/**
 * __useLogisticsPartnersPageCreateMutation__
 *
 * To run a mutation, you first call `useLogisticsPartnersPageCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLogisticsPartnersPageCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [logisticsPartnersPageCreateMutation, { data, loading, error }] = useLogisticsPartnersPageCreateMutation({
 *   variables: {
 *      name: // value for 'name'
 *      attention: // value for 'attention'
 *      address: // value for 'address'
 *      address2: // value for 'address2'
 *      zipCode: // value for 'zipCode'
 *      city: // value for 'city'
 *      country: // value for 'country'
 *      countryCode: // value for 'countryCode'
 *      mail: // value for 'mail'
 *      phone: // value for 'phone'
 *   },
 * });
 */
export function useLogisticsPartnersPageCreateMutation(baseOptions?: Apollo.MutationHookOptions<LogisticsPartnersPageCreateMutation, LogisticsPartnersPageCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LogisticsPartnersPageCreateMutation, LogisticsPartnersPageCreateMutationVariables>(LogisticsPartnersPageCreateDocument, options);
      }
export type LogisticsPartnersPageCreateMutationHookResult = ReturnType<typeof useLogisticsPartnersPageCreateMutation>;
export type LogisticsPartnersPageCreateMutationResult = Apollo.MutationResult<LogisticsPartnersPageCreateMutation>;
export type LogisticsPartnersPageCreateMutationOptions = Apollo.BaseMutationOptions<LogisticsPartnersPageCreateMutation, LogisticsPartnersPageCreateMutationVariables>;
export const LogisticsPartnerSettingsPageUpdateDocument = gql`
    mutation LogisticsPartnerSettingsPageUpdate($id: MongoID!, $input: UpdateByIdLogisticsPartnerInput!) {
  LogisticsPartnerUpdate(_id: $id, record: $input) {
    recordId
    record {
      ...LogisticsPartnerFields
    }
    error {
      message
    }
  }
}
    ${LogisticsPartnerFieldsFragmentDoc}`;
export type LogisticsPartnerSettingsPageUpdateMutationFn = Apollo.MutationFunction<LogisticsPartnerSettingsPageUpdateMutation, LogisticsPartnerSettingsPageUpdateMutationVariables>;

/**
 * __useLogisticsPartnerSettingsPageUpdateMutation__
 *
 * To run a mutation, you first call `useLogisticsPartnerSettingsPageUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLogisticsPartnerSettingsPageUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [logisticsPartnerSettingsPageUpdateMutation, { data, loading, error }] = useLogisticsPartnerSettingsPageUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLogisticsPartnerSettingsPageUpdateMutation(baseOptions?: Apollo.MutationHookOptions<LogisticsPartnerSettingsPageUpdateMutation, LogisticsPartnerSettingsPageUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LogisticsPartnerSettingsPageUpdateMutation, LogisticsPartnerSettingsPageUpdateMutationVariables>(LogisticsPartnerSettingsPageUpdateDocument, options);
      }
export type LogisticsPartnerSettingsPageUpdateMutationHookResult = ReturnType<typeof useLogisticsPartnerSettingsPageUpdateMutation>;
export type LogisticsPartnerSettingsPageUpdateMutationResult = Apollo.MutationResult<LogisticsPartnerSettingsPageUpdateMutation>;
export type LogisticsPartnerSettingsPageUpdateMutationOptions = Apollo.BaseMutationOptions<LogisticsPartnerSettingsPageUpdateMutation, LogisticsPartnerSettingsPageUpdateMutationVariables>;
export const LogisticsProductsPageBrandDocument = gql`
    query LogisticsProductsPageBrand($shopId: MongoID!) {
  ShopById(_id: $shopId) {
    _id
    brandHouseId
  }
}
    `;

/**
 * __useLogisticsProductsPageBrandQuery__
 *
 * To run a query within a React component, call `useLogisticsProductsPageBrandQuery` and pass it any options that fit your needs.
 * When your component renders, `useLogisticsProductsPageBrandQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLogisticsProductsPageBrandQuery({
 *   variables: {
 *      shopId: // value for 'shopId'
 *   },
 * });
 */
export function useLogisticsProductsPageBrandQuery(baseOptions: Apollo.QueryHookOptions<LogisticsProductsPageBrandQuery, LogisticsProductsPageBrandQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LogisticsProductsPageBrandQuery, LogisticsProductsPageBrandQueryVariables>(LogisticsProductsPageBrandDocument, options);
      }
export function useLogisticsProductsPageBrandLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LogisticsProductsPageBrandQuery, LogisticsProductsPageBrandQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LogisticsProductsPageBrandQuery, LogisticsProductsPageBrandQueryVariables>(LogisticsProductsPageBrandDocument, options);
        }
export type LogisticsProductsPageBrandQueryHookResult = ReturnType<typeof useLogisticsProductsPageBrandQuery>;
export type LogisticsProductsPageBrandLazyQueryHookResult = ReturnType<typeof useLogisticsProductsPageBrandLazyQuery>;
export type LogisticsProductsPageBrandQueryResult = Apollo.QueryResult<LogisticsProductsPageBrandQuery, LogisticsProductsPageBrandQueryVariables>;
export const InventoryItemStockItemDocument = gql`
    query InventoryItemStockItem($stockItemId: MongoID!) {
  StockItemById(_id: $stockItemId) {
    _id
    title
    color
    size
    condition
    sku
    imageUrls
    effectiveChecked
    shopId
    shop {
      name
      brandHouseId
    }
  }
}
    `;

/**
 * __useInventoryItemStockItemQuery__
 *
 * To run a query within a React component, call `useInventoryItemStockItemQuery` and pass it any options that fit your needs.
 * When your component renders, `useInventoryItemStockItemQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInventoryItemStockItemQuery({
 *   variables: {
 *      stockItemId: // value for 'stockItemId'
 *   },
 * });
 */
export function useInventoryItemStockItemQuery(baseOptions: Apollo.QueryHookOptions<InventoryItemStockItemQuery, InventoryItemStockItemQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InventoryItemStockItemQuery, InventoryItemStockItemQueryVariables>(InventoryItemStockItemDocument, options);
      }
export function useInventoryItemStockItemLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InventoryItemStockItemQuery, InventoryItemStockItemQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InventoryItemStockItemQuery, InventoryItemStockItemQueryVariables>(InventoryItemStockItemDocument, options);
        }
export type InventoryItemStockItemQueryHookResult = ReturnType<typeof useInventoryItemStockItemQuery>;
export type InventoryItemStockItemLazyQueryHookResult = ReturnType<typeof useInventoryItemStockItemLazyQuery>;
export type InventoryItemStockItemQueryResult = Apollo.QueryResult<InventoryItemStockItemQuery, InventoryItemStockItemQueryVariables>;
export const InventoryItemCheckDocument = gql`
    mutation InventoryItemCheck($stockItemId: String!, $checked: Boolean!) {
  StockItemChecked(stockItemId: $stockItemId, checked: $checked) {
    _id
    checked
  }
}
    `;
export type InventoryItemCheckMutationFn = Apollo.MutationFunction<InventoryItemCheckMutation, InventoryItemCheckMutationVariables>;

/**
 * __useInventoryItemCheckMutation__
 *
 * To run a mutation, you first call `useInventoryItemCheckMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInventoryItemCheckMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [inventoryItemCheckMutation, { data, loading, error }] = useInventoryItemCheckMutation({
 *   variables: {
 *      stockItemId: // value for 'stockItemId'
 *      checked: // value for 'checked'
 *   },
 * });
 */
export function useInventoryItemCheckMutation(baseOptions?: Apollo.MutationHookOptions<InventoryItemCheckMutation, InventoryItemCheckMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InventoryItemCheckMutation, InventoryItemCheckMutationVariables>(InventoryItemCheckDocument, options);
      }
export type InventoryItemCheckMutationHookResult = ReturnType<typeof useInventoryItemCheckMutation>;
export type InventoryItemCheckMutationResult = Apollo.MutationResult<InventoryItemCheckMutation>;
export type InventoryItemCheckMutationOptions = Apollo.BaseMutationOptions<InventoryItemCheckMutation, InventoryItemCheckMutationVariables>;
export const InventoryPageLocationsDocument = gql`
    query InventoryPageLocations {
  WarehouseLocations(logisticsPartnerId: "") {
    _id
    count
    checked
    items {
      _id
      effectiveChecked
    }
  }
}
    `;

/**
 * __useInventoryPageLocationsQuery__
 *
 * To run a query within a React component, call `useInventoryPageLocationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useInventoryPageLocationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInventoryPageLocationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useInventoryPageLocationsQuery(baseOptions?: Apollo.QueryHookOptions<InventoryPageLocationsQuery, InventoryPageLocationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InventoryPageLocationsQuery, InventoryPageLocationsQueryVariables>(InventoryPageLocationsDocument, options);
      }
export function useInventoryPageLocationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InventoryPageLocationsQuery, InventoryPageLocationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InventoryPageLocationsQuery, InventoryPageLocationsQueryVariables>(InventoryPageLocationsDocument, options);
        }
export type InventoryPageLocationsQueryHookResult = ReturnType<typeof useInventoryPageLocationsQuery>;
export type InventoryPageLocationsLazyQueryHookResult = ReturnType<typeof useInventoryPageLocationsLazyQuery>;
export type InventoryPageLocationsQueryResult = Apollo.QueryResult<InventoryPageLocationsQuery, InventoryPageLocationsQueryVariables>;
export const InventoryPageItemsUpdateDocument = gql`
    query InventoryPageItemsUpdate($query: FilterFindManyStockItemInput) {
  StockItems(filter: $query) {
    _id
    effectiveChecked
  }
}
    `;

/**
 * __useInventoryPageItemsUpdateQuery__
 *
 * To run a query within a React component, call `useInventoryPageItemsUpdateQuery` and pass it any options that fit your needs.
 * When your component renders, `useInventoryPageItemsUpdateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInventoryPageItemsUpdateQuery({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useInventoryPageItemsUpdateQuery(baseOptions?: Apollo.QueryHookOptions<InventoryPageItemsUpdateQuery, InventoryPageItemsUpdateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InventoryPageItemsUpdateQuery, InventoryPageItemsUpdateQueryVariables>(InventoryPageItemsUpdateDocument, options);
      }
export function useInventoryPageItemsUpdateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InventoryPageItemsUpdateQuery, InventoryPageItemsUpdateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InventoryPageItemsUpdateQuery, InventoryPageItemsUpdateQueryVariables>(InventoryPageItemsUpdateDocument, options);
        }
export type InventoryPageItemsUpdateQueryHookResult = ReturnType<typeof useInventoryPageItemsUpdateQuery>;
export type InventoryPageItemsUpdateLazyQueryHookResult = ReturnType<typeof useInventoryPageItemsUpdateLazyQuery>;
export type InventoryPageItemsUpdateQueryResult = Apollo.QueryResult<InventoryPageItemsUpdateQuery, InventoryPageItemsUpdateQueryVariables>;
export const InventoryPageResetDocument = gql`
    mutation InventoryPageReset($lpId: String!) {
  LogisticsStockItemsCheckedReset(logisticsPartnerId: $lpId)
}
    `;
export type InventoryPageResetMutationFn = Apollo.MutationFunction<InventoryPageResetMutation, InventoryPageResetMutationVariables>;

/**
 * __useInventoryPageResetMutation__
 *
 * To run a mutation, you first call `useInventoryPageResetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInventoryPageResetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [inventoryPageResetMutation, { data, loading, error }] = useInventoryPageResetMutation({
 *   variables: {
 *      lpId: // value for 'lpId'
 *   },
 * });
 */
export function useInventoryPageResetMutation(baseOptions?: Apollo.MutationHookOptions<InventoryPageResetMutation, InventoryPageResetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InventoryPageResetMutation, InventoryPageResetMutationVariables>(InventoryPageResetDocument, options);
      }
export type InventoryPageResetMutationHookResult = ReturnType<typeof useInventoryPageResetMutation>;
export type InventoryPageResetMutationResult = Apollo.MutationResult<InventoryPageResetMutation>;
export type InventoryPageResetMutationOptions = Apollo.BaseMutationOptions<InventoryPageResetMutation, InventoryPageResetMutationVariables>;
export const NfcTagsDocument = gql`
    query NFCTags {
  NFCMany(limit: 2000) {
    ...NFCFragment
  }
}
    ${NfcFragmentDoc}`;

/**
 * __useNfcTagsQuery__
 *
 * To run a query within a React component, call `useNfcTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useNfcTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNfcTagsQuery({
 *   variables: {
 *   },
 * });
 */
export function useNfcTagsQuery(baseOptions?: Apollo.QueryHookOptions<NfcTagsQuery, NfcTagsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NfcTagsQuery, NfcTagsQueryVariables>(NfcTagsDocument, options);
      }
export function useNfcTagsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NfcTagsQuery, NfcTagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NfcTagsQuery, NfcTagsQueryVariables>(NfcTagsDocument, options);
        }
export type NfcTagsQueryHookResult = ReturnType<typeof useNfcTagsQuery>;
export type NfcTagsLazyQueryHookResult = ReturnType<typeof useNfcTagsLazyQuery>;
export type NfcTagsQueryResult = Apollo.QueryResult<NfcTagsQuery, NfcTagsQueryVariables>;
export const BrandSettingsPageHouseDocument = gql`
    query BrandSettingsPageHouse($brandHouseId: MongoID!) {
  BrandHouse(id: $brandHouseId) {
    _id
    name
  }
}
    `;

/**
 * __useBrandSettingsPageHouseQuery__
 *
 * To run a query within a React component, call `useBrandSettingsPageHouseQuery` and pass it any options that fit your needs.
 * When your component renders, `useBrandSettingsPageHouseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBrandSettingsPageHouseQuery({
 *   variables: {
 *      brandHouseId: // value for 'brandHouseId'
 *   },
 * });
 */
export function useBrandSettingsPageHouseQuery(baseOptions: Apollo.QueryHookOptions<BrandSettingsPageHouseQuery, BrandSettingsPageHouseQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BrandSettingsPageHouseQuery, BrandSettingsPageHouseQueryVariables>(BrandSettingsPageHouseDocument, options);
      }
export function useBrandSettingsPageHouseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BrandSettingsPageHouseQuery, BrandSettingsPageHouseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BrandSettingsPageHouseQuery, BrandSettingsPageHouseQueryVariables>(BrandSettingsPageHouseDocument, options);
        }
export type BrandSettingsPageHouseQueryHookResult = ReturnType<typeof useBrandSettingsPageHouseQuery>;
export type BrandSettingsPageHouseLazyQueryHookResult = ReturnType<typeof useBrandSettingsPageHouseLazyQuery>;
export type BrandSettingsPageHouseQueryResult = Apollo.QueryResult<BrandSettingsPageHouseQuery, BrandSettingsPageHouseQueryVariables>;
export const ShopTabsShopsDocument = gql`
    query ShopTabsShops($brandHouseId: MongoID) {
  ShopMany(filter: {brandHouseId: $brandHouseId}) {
    _id
    name
  }
}
    `;

/**
 * __useShopTabsShopsQuery__
 *
 * To run a query within a React component, call `useShopTabsShopsQuery` and pass it any options that fit your needs.
 * When your component renders, `useShopTabsShopsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShopTabsShopsQuery({
 *   variables: {
 *      brandHouseId: // value for 'brandHouseId'
 *   },
 * });
 */
export function useShopTabsShopsQuery(baseOptions?: Apollo.QueryHookOptions<ShopTabsShopsQuery, ShopTabsShopsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ShopTabsShopsQuery, ShopTabsShopsQueryVariables>(ShopTabsShopsDocument, options);
      }
export function useShopTabsShopsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ShopTabsShopsQuery, ShopTabsShopsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ShopTabsShopsQuery, ShopTabsShopsQueryVariables>(ShopTabsShopsDocument, options);
        }
export type ShopTabsShopsQueryHookResult = ReturnType<typeof useShopTabsShopsQuery>;
export type ShopTabsShopsLazyQueryHookResult = ReturnType<typeof useShopTabsShopsLazyQuery>;
export type ShopTabsShopsQueryResult = Apollo.QueryResult<ShopTabsShopsQuery, ShopTabsShopsQueryVariables>;
export const HistorySettingsBrandDocument = gql`
    query historySettingsBrand($refId: MongoID!) {
  BrandSettings(refId: $refId) {
    _id
  }
}
    `;

/**
 * __useHistorySettingsBrandQuery__
 *
 * To run a query within a React component, call `useHistorySettingsBrandQuery` and pass it any options that fit your needs.
 * When your component renders, `useHistorySettingsBrandQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHistorySettingsBrandQuery({
 *   variables: {
 *      refId: // value for 'refId'
 *   },
 * });
 */
export function useHistorySettingsBrandQuery(baseOptions: Apollo.QueryHookOptions<HistorySettingsBrandQuery, HistorySettingsBrandQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HistorySettingsBrandQuery, HistorySettingsBrandQueryVariables>(HistorySettingsBrandDocument, options);
      }
export function useHistorySettingsBrandLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HistorySettingsBrandQuery, HistorySettingsBrandQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HistorySettingsBrandQuery, HistorySettingsBrandQueryVariables>(HistorySettingsBrandDocument, options);
        }
export type HistorySettingsBrandQueryHookResult = ReturnType<typeof useHistorySettingsBrandQuery>;
export type HistorySettingsBrandLazyQueryHookResult = ReturnType<typeof useHistorySettingsBrandLazyQuery>;
export type HistorySettingsBrandQueryResult = Apollo.QueryResult<HistorySettingsBrandQuery, HistorySettingsBrandQueryVariables>;
export const MasterDataSettingsDocument = gql`
    query MasterDataSettings($brandHouseId: MongoID!) {
  BrandSettings(brandHouseId: $brandHouseId) {
    ...MasterData
  }
  BrandProductGroups(filter: {brandHouseId: $brandHouseId}) {
    _id
    name
  }
}
    ${MasterDataFragmentDoc}`;

/**
 * __useMasterDataSettingsQuery__
 *
 * To run a query within a React component, call `useMasterDataSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMasterDataSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMasterDataSettingsQuery({
 *   variables: {
 *      brandHouseId: // value for 'brandHouseId'
 *   },
 * });
 */
export function useMasterDataSettingsQuery(baseOptions: Apollo.QueryHookOptions<MasterDataSettingsQuery, MasterDataSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MasterDataSettingsQuery, MasterDataSettingsQueryVariables>(MasterDataSettingsDocument, options);
      }
export function useMasterDataSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MasterDataSettingsQuery, MasterDataSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MasterDataSettingsQuery, MasterDataSettingsQueryVariables>(MasterDataSettingsDocument, options);
        }
export type MasterDataSettingsQueryHookResult = ReturnType<typeof useMasterDataSettingsQuery>;
export type MasterDataSettingsLazyQueryHookResult = ReturnType<typeof useMasterDataSettingsLazyQuery>;
export type MasterDataSettingsQueryResult = Apollo.QueryResult<MasterDataSettingsQuery, MasterDataSettingsQueryVariables>;
export const MasterDataSettingsSaveDocument = gql`
    mutation MasterDataSettingsSave($brandHouseId: MongoID!, $input: BrandSettingMasterDataConsolidateInput!, $useBrandItems: Boolean!, $removeBg: Boolean!, $removeBgVersion: Float!, $masterDataUseProductImages: Boolean!, $auditNoteId: MongoID) {
  BrandSettingsUpdate(
    brandHouseId: $brandHouseId
    auditNoteId: $auditNoteId
    api: {masterDataConsolidate: $input, useBrandItems: $useBrandItems, masterDataRemoveBg: $removeBg, masterDataRemoveBgVersion: $removeBgVersion, masterDataUseProductImages: $masterDataUseProductImages}
  ) {
    ...MasterData
  }
}
    ${MasterDataFragmentDoc}`;
export type MasterDataSettingsSaveMutationFn = Apollo.MutationFunction<MasterDataSettingsSaveMutation, MasterDataSettingsSaveMutationVariables>;

/**
 * __useMasterDataSettingsSaveMutation__
 *
 * To run a mutation, you first call `useMasterDataSettingsSaveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMasterDataSettingsSaveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [masterDataSettingsSaveMutation, { data, loading, error }] = useMasterDataSettingsSaveMutation({
 *   variables: {
 *      brandHouseId: // value for 'brandHouseId'
 *      input: // value for 'input'
 *      useBrandItems: // value for 'useBrandItems'
 *      removeBg: // value for 'removeBg'
 *      removeBgVersion: // value for 'removeBgVersion'
 *      masterDataUseProductImages: // value for 'masterDataUseProductImages'
 *      auditNoteId: // value for 'auditNoteId'
 *   },
 * });
 */
export function useMasterDataSettingsSaveMutation(baseOptions?: Apollo.MutationHookOptions<MasterDataSettingsSaveMutation, MasterDataSettingsSaveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MasterDataSettingsSaveMutation, MasterDataSettingsSaveMutationVariables>(MasterDataSettingsSaveDocument, options);
      }
export type MasterDataSettingsSaveMutationHookResult = ReturnType<typeof useMasterDataSettingsSaveMutation>;
export type MasterDataSettingsSaveMutationResult = Apollo.MutationResult<MasterDataSettingsSaveMutation>;
export type MasterDataSettingsSaveMutationOptions = Apollo.BaseMutationOptions<MasterDataSettingsSaveMutation, MasterDataSettingsSaveMutationVariables>;
export const MasterDataConsolidationStartDocument = gql`
    mutation MasterDataConsolidationStart($brandHouseId: MongoID!) {
  BrandProductImport(brandHouseId: $brandHouseId)
}
    `;
export type MasterDataConsolidationStartMutationFn = Apollo.MutationFunction<MasterDataConsolidationStartMutation, MasterDataConsolidationStartMutationVariables>;

/**
 * __useMasterDataConsolidationStartMutation__
 *
 * To run a mutation, you first call `useMasterDataConsolidationStartMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMasterDataConsolidationStartMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [masterDataConsolidationStartMutation, { data, loading, error }] = useMasterDataConsolidationStartMutation({
 *   variables: {
 *      brandHouseId: // value for 'brandHouseId'
 *   },
 * });
 */
export function useMasterDataConsolidationStartMutation(baseOptions?: Apollo.MutationHookOptions<MasterDataConsolidationStartMutation, MasterDataConsolidationStartMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MasterDataConsolidationStartMutation, MasterDataConsolidationStartMutationVariables>(MasterDataConsolidationStartDocument, options);
      }
export type MasterDataConsolidationStartMutationHookResult = ReturnType<typeof useMasterDataConsolidationStartMutation>;
export type MasterDataConsolidationStartMutationResult = Apollo.MutationResult<MasterDataConsolidationStartMutation>;
export type MasterDataConsolidationStartMutationOptions = Apollo.BaseMutationOptions<MasterDataConsolidationStartMutation, MasterDataConsolidationStartMutationVariables>;
export const MasterDataRequestProductsDocument = gql`
    mutation MasterDataRequestProducts($refId: MongoID!, $refType: EnumIntegrationConnectorRefType, $args: [JSON!]) {
  IntegrationMessageExecute(
    name: "sendMessageRequestBrandProducts"
    refId: $refId
    refType: $refType
    arguments: $args
  )
}
    `;
export type MasterDataRequestProductsMutationFn = Apollo.MutationFunction<MasterDataRequestProductsMutation, MasterDataRequestProductsMutationVariables>;

/**
 * __useMasterDataRequestProductsMutation__
 *
 * To run a mutation, you first call `useMasterDataRequestProductsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMasterDataRequestProductsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [masterDataRequestProductsMutation, { data, loading, error }] = useMasterDataRequestProductsMutation({
 *   variables: {
 *      refId: // value for 'refId'
 *      refType: // value for 'refType'
 *      args: // value for 'args'
 *   },
 * });
 */
export function useMasterDataRequestProductsMutation(baseOptions?: Apollo.MutationHookOptions<MasterDataRequestProductsMutation, MasterDataRequestProductsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MasterDataRequestProductsMutation, MasterDataRequestProductsMutationVariables>(MasterDataRequestProductsDocument, options);
      }
export type MasterDataRequestProductsMutationHookResult = ReturnType<typeof useMasterDataRequestProductsMutation>;
export type MasterDataRequestProductsMutationResult = Apollo.MutationResult<MasterDataRequestProductsMutation>;
export type MasterDataRequestProductsMutationOptions = Apollo.BaseMutationOptions<MasterDataRequestProductsMutation, MasterDataRequestProductsMutationVariables>;
export const GetOptionSetsDocument = gql`
    query GetOptionSets($refId: MongoID!) {
  Options(filter: {refId: $refId}) {
    ...OptionSetDataFragment
  }
}
    ${OptionSetDataFragmentDoc}`;

/**
 * __useGetOptionSetsQuery__
 *
 * To run a query within a React component, call `useGetOptionSetsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOptionSetsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOptionSetsQuery({
 *   variables: {
 *      refId: // value for 'refId'
 *   },
 * });
 */
export function useGetOptionSetsQuery(baseOptions: Apollo.QueryHookOptions<GetOptionSetsQuery, GetOptionSetsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOptionSetsQuery, GetOptionSetsQueryVariables>(GetOptionSetsDocument, options);
      }
export function useGetOptionSetsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOptionSetsQuery, GetOptionSetsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOptionSetsQuery, GetOptionSetsQueryVariables>(GetOptionSetsDocument, options);
        }
export type GetOptionSetsQueryHookResult = ReturnType<typeof useGetOptionSetsQuery>;
export type GetOptionSetsLazyQueryHookResult = ReturnType<typeof useGetOptionSetsLazyQuery>;
export type GetOptionSetsQueryResult = Apollo.QueryResult<GetOptionSetsQuery, GetOptionSetsQueryVariables>;
export const GetOptionSetDocument = gql`
    query GetOptionSet($id: MongoID!) {
  Option(_id: $id) {
    ...OptionSetDataFragment
  }
}
    ${OptionSetDataFragmentDoc}`;

/**
 * __useGetOptionSetQuery__
 *
 * To run a query within a React component, call `useGetOptionSetQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOptionSetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOptionSetQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetOptionSetQuery(baseOptions: Apollo.QueryHookOptions<GetOptionSetQuery, GetOptionSetQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOptionSetQuery, GetOptionSetQueryVariables>(GetOptionSetDocument, options);
      }
export function useGetOptionSetLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOptionSetQuery, GetOptionSetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOptionSetQuery, GetOptionSetQueryVariables>(GetOptionSetDocument, options);
        }
export type GetOptionSetQueryHookResult = ReturnType<typeof useGetOptionSetQuery>;
export type GetOptionSetLazyQueryHookResult = ReturnType<typeof useGetOptionSetLazyQuery>;
export type GetOptionSetQueryResult = Apollo.QueryResult<GetOptionSetQuery, GetOptionSetQueryVariables>;
export const OptionsSynchronizeDocument = gql`
    mutation optionsSynchronize($input: OptionSetInput!) {
  OptionSynchronize(input: $input) {
    ...OptionSetDataFragment
  }
}
    ${OptionSetDataFragmentDoc}`;
export type OptionsSynchronizeMutationFn = Apollo.MutationFunction<OptionsSynchronizeMutation, OptionsSynchronizeMutationVariables>;

/**
 * __useOptionsSynchronizeMutation__
 *
 * To run a mutation, you first call `useOptionsSynchronizeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOptionsSynchronizeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [optionsSynchronizeMutation, { data, loading, error }] = useOptionsSynchronizeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useOptionsSynchronizeMutation(baseOptions?: Apollo.MutationHookOptions<OptionsSynchronizeMutation, OptionsSynchronizeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OptionsSynchronizeMutation, OptionsSynchronizeMutationVariables>(OptionsSynchronizeDocument, options);
      }
export type OptionsSynchronizeMutationHookResult = ReturnType<typeof useOptionsSynchronizeMutation>;
export type OptionsSynchronizeMutationResult = Apollo.MutationResult<OptionsSynchronizeMutation>;
export type OptionsSynchronizeMutationOptions = Apollo.BaseMutationOptions<OptionsSynchronizeMutation, OptionsSynchronizeMutationVariables>;
export const ContactPersonSettingsDocument = gql`
    query ContactPersonSettings($brandHouseId: MongoID!) {
  BrandSettings(brandHouseId: $brandHouseId) {
    ...ContactPersonFragment
  }
}
    ${ContactPersonFragmentDoc}`;

/**
 * __useContactPersonSettingsQuery__
 *
 * To run a query within a React component, call `useContactPersonSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useContactPersonSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContactPersonSettingsQuery({
 *   variables: {
 *      brandHouseId: // value for 'brandHouseId'
 *   },
 * });
 */
export function useContactPersonSettingsQuery(baseOptions: Apollo.QueryHookOptions<ContactPersonSettingsQuery, ContactPersonSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ContactPersonSettingsQuery, ContactPersonSettingsQueryVariables>(ContactPersonSettingsDocument, options);
      }
export function useContactPersonSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContactPersonSettingsQuery, ContactPersonSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ContactPersonSettingsQuery, ContactPersonSettingsQueryVariables>(ContactPersonSettingsDocument, options);
        }
export type ContactPersonSettingsQueryHookResult = ReturnType<typeof useContactPersonSettingsQuery>;
export type ContactPersonSettingsLazyQueryHookResult = ReturnType<typeof useContactPersonSettingsLazyQuery>;
export type ContactPersonSettingsQueryResult = Apollo.QueryResult<ContactPersonSettingsQuery, ContactPersonSettingsQueryVariables>;
export const ContactPersonSettingsUpdateDocument = gql`
    mutation ContactPersonSettingsUpdate($brandHouseId: MongoID!, $input: BrandSettingInput!, $auditNoteId: MongoID) {
  BrandSettingsUpdate(
    brandHouseId: $brandHouseId
    auditNoteId: $auditNoteId
    api: $input
  ) {
    ...ContactPersonFragment
  }
}
    ${ContactPersonFragmentDoc}`;
export type ContactPersonSettingsUpdateMutationFn = Apollo.MutationFunction<ContactPersonSettingsUpdateMutation, ContactPersonSettingsUpdateMutationVariables>;

/**
 * __useContactPersonSettingsUpdateMutation__
 *
 * To run a mutation, you first call `useContactPersonSettingsUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useContactPersonSettingsUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [contactPersonSettingsUpdateMutation, { data, loading, error }] = useContactPersonSettingsUpdateMutation({
 *   variables: {
 *      brandHouseId: // value for 'brandHouseId'
 *      input: // value for 'input'
 *      auditNoteId: // value for 'auditNoteId'
 *   },
 * });
 */
export function useContactPersonSettingsUpdateMutation(baseOptions?: Apollo.MutationHookOptions<ContactPersonSettingsUpdateMutation, ContactPersonSettingsUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ContactPersonSettingsUpdateMutation, ContactPersonSettingsUpdateMutationVariables>(ContactPersonSettingsUpdateDocument, options);
      }
export type ContactPersonSettingsUpdateMutationHookResult = ReturnType<typeof useContactPersonSettingsUpdateMutation>;
export type ContactPersonSettingsUpdateMutationResult = Apollo.MutationResult<ContactPersonSettingsUpdateMutation>;
export type ContactPersonSettingsUpdateMutationOptions = Apollo.BaseMutationOptions<ContactPersonSettingsUpdateMutation, ContactPersonSettingsUpdateMutationVariables>;
export const UsersInviteSendDocument = gql`
    mutation UsersInviteSend($brandHouseId: MongoID, $email: String!) {
  UserInvite(brandHouseId: $brandHouseId, email: $email) {
    user {
      _id
      name
      email
      resetTokenTs
    }
    brandHouseId
    brandHouseName
    inviteTokenTs
  }
}
    `;
export type UsersInviteSendMutationFn = Apollo.MutationFunction<UsersInviteSendMutation, UsersInviteSendMutationVariables>;

/**
 * __useUsersInviteSendMutation__
 *
 * To run a mutation, you first call `useUsersInviteSendMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUsersInviteSendMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [usersInviteSendMutation, { data, loading, error }] = useUsersInviteSendMutation({
 *   variables: {
 *      brandHouseId: // value for 'brandHouseId'
 *      email: // value for 'email'
 *   },
 * });
 */
export function useUsersInviteSendMutation(baseOptions?: Apollo.MutationHookOptions<UsersInviteSendMutation, UsersInviteSendMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UsersInviteSendMutation, UsersInviteSendMutationVariables>(UsersInviteSendDocument, options);
      }
export type UsersInviteSendMutationHookResult = ReturnType<typeof useUsersInviteSendMutation>;
export type UsersInviteSendMutationResult = Apollo.MutationResult<UsersInviteSendMutation>;
export type UsersInviteSendMutationOptions = Apollo.BaseMutationOptions<UsersInviteSendMutation, UsersInviteSendMutationVariables>;
export const UserAccessesDocument = gql`
    query UserAccesses($brandHouseId: MongoID) {
  UserAccesses(brandHouseId: $brandHouseId) {
    _id
    user {
      _id
      name
      email
      lastLoginAt
      resetTokenTs
    }
    brandHouseId
    brandHouseName
    logisticsPartnerId
    logisticsPartnerName
    inviteTokenTs
    disabled
  }
}
    `;

/**
 * __useUserAccessesQuery__
 *
 * To run a query within a React component, call `useUserAccessesQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserAccessesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserAccessesQuery({
 *   variables: {
 *      brandHouseId: // value for 'brandHouseId'
 *   },
 * });
 */
export function useUserAccessesQuery(baseOptions?: Apollo.QueryHookOptions<UserAccessesQuery, UserAccessesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserAccessesQuery, UserAccessesQueryVariables>(UserAccessesDocument, options);
      }
export function useUserAccessesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserAccessesQuery, UserAccessesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserAccessesQuery, UserAccessesQueryVariables>(UserAccessesDocument, options);
        }
export type UserAccessesQueryHookResult = ReturnType<typeof useUserAccessesQuery>;
export type UserAccessesLazyQueryHookResult = ReturnType<typeof useUserAccessesLazyQuery>;
export type UserAccessesQueryResult = Apollo.QueryResult<UserAccessesQuery, UserAccessesQueryVariables>;
export const UserAccessToggleDocument = gql`
    mutation UserAccessToggle($id: MongoID!, $disabled: Boolean!) {
  UserAccessToggle(accessId: $id, disabled: $disabled) {
    _id
    disabled
  }
}
    `;
export type UserAccessToggleMutationFn = Apollo.MutationFunction<UserAccessToggleMutation, UserAccessToggleMutationVariables>;

/**
 * __useUserAccessToggleMutation__
 *
 * To run a mutation, you first call `useUserAccessToggleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserAccessToggleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userAccessToggleMutation, { data, loading, error }] = useUserAccessToggleMutation({
 *   variables: {
 *      id: // value for 'id'
 *      disabled: // value for 'disabled'
 *   },
 * });
 */
export function useUserAccessToggleMutation(baseOptions?: Apollo.MutationHookOptions<UserAccessToggleMutation, UserAccessToggleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UserAccessToggleMutation, UserAccessToggleMutationVariables>(UserAccessToggleDocument, options);
      }
export type UserAccessToggleMutationHookResult = ReturnType<typeof useUserAccessToggleMutation>;
export type UserAccessToggleMutationResult = Apollo.MutationResult<UserAccessToggleMutation>;
export type UserAccessToggleMutationOptions = Apollo.BaseMutationOptions<UserAccessToggleMutation, UserAccessToggleMutationVariables>;
export const ShopConnectorMenuDocument = gql`
    query ShopConnectorMenu {
  IntegrationConnectors {
    _id
    name
    type
    refTypes
    activeFor
    autoInstallFor
    messages
  }
}
    `;

/**
 * __useShopConnectorMenuQuery__
 *
 * To run a query within a React component, call `useShopConnectorMenuQuery` and pass it any options that fit your needs.
 * When your component renders, `useShopConnectorMenuQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShopConnectorMenuQuery({
 *   variables: {
 *   },
 * });
 */
export function useShopConnectorMenuQuery(baseOptions?: Apollo.QueryHookOptions<ShopConnectorMenuQuery, ShopConnectorMenuQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ShopConnectorMenuQuery, ShopConnectorMenuQueryVariables>(ShopConnectorMenuDocument, options);
      }
export function useShopConnectorMenuLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ShopConnectorMenuQuery, ShopConnectorMenuQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ShopConnectorMenuQuery, ShopConnectorMenuQueryVariables>(ShopConnectorMenuDocument, options);
        }
export type ShopConnectorMenuQueryHookResult = ReturnType<typeof useShopConnectorMenuQuery>;
export type ShopConnectorMenuLazyQueryHookResult = ReturnType<typeof useShopConnectorMenuLazyQuery>;
export type ShopConnectorMenuQueryResult = Apollo.QueryResult<ShopConnectorMenuQuery, ShopConnectorMenuQueryVariables>;
export const ConfigCompareDocument = gql`
    query ConfigCompare($shopIdA: MongoID, $brandHouseIdA: MongoID, $shopIdB: MongoID, $brandHouseIdB: MongoID, $models: [String!]) {
  ConfigCompare(
    shopIdA: $shopIdA
    brandHouseIdA: $brandHouseIdA
    shopIdB: $shopIdB
    brandHouseIdB: $brandHouseIdB
    models: $models
  ) {
    nameA
    nameB
    comparedAt
    summary {
      totalDifferences
      byModel {
        modelName
        count
      }
    }
    differences {
      path
      valueA
      valueB
      differenceType
      modelName
    }
  }
}
    `;

/**
 * __useConfigCompareQuery__
 *
 * To run a query within a React component, call `useConfigCompareQuery` and pass it any options that fit your needs.
 * When your component renders, `useConfigCompareQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConfigCompareQuery({
 *   variables: {
 *      shopIdA: // value for 'shopIdA'
 *      brandHouseIdA: // value for 'brandHouseIdA'
 *      shopIdB: // value for 'shopIdB'
 *      brandHouseIdB: // value for 'brandHouseIdB'
 *      models: // value for 'models'
 *   },
 * });
 */
export function useConfigCompareQuery(baseOptions?: Apollo.QueryHookOptions<ConfigCompareQuery, ConfigCompareQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ConfigCompareQuery, ConfigCompareQueryVariables>(ConfigCompareDocument, options);
      }
export function useConfigCompareLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ConfigCompareQuery, ConfigCompareQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ConfigCompareQuery, ConfigCompareQueryVariables>(ConfigCompareDocument, options);
        }
export type ConfigCompareQueryHookResult = ReturnType<typeof useConfigCompareQuery>;
export type ConfigCompareLazyQueryHookResult = ReturnType<typeof useConfigCompareLazyQuery>;
export type ConfigCompareQueryResult = Apollo.QueryResult<ConfigCompareQuery, ConfigCompareQueryVariables>;
export const DetailsPageBrandByIdDocument = gql`
    query DetailsPageBrandById($id: MongoID!) {
  BrandHouse(id: $id) {
    _id
    name
    license
    deactivated
    logisticsPartnerId
    shops {
      ...BrandHouseShop
    }
    address {
      name
      attention
      add1
      add2
      zipCode
      city
      countryCode
      phone
      mail
    }
  }
  LogisticsPartners {
    _id
    name
  }
}
    ${BrandHouseShopFragmentDoc}`;

/**
 * __useDetailsPageBrandByIdQuery__
 *
 * To run a query within a React component, call `useDetailsPageBrandByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useDetailsPageBrandByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDetailsPageBrandByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDetailsPageBrandByIdQuery(baseOptions: Apollo.QueryHookOptions<DetailsPageBrandByIdQuery, DetailsPageBrandByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DetailsPageBrandByIdQuery, DetailsPageBrandByIdQueryVariables>(DetailsPageBrandByIdDocument, options);
      }
export function useDetailsPageBrandByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DetailsPageBrandByIdQuery, DetailsPageBrandByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DetailsPageBrandByIdQuery, DetailsPageBrandByIdQueryVariables>(DetailsPageBrandByIdDocument, options);
        }
export type DetailsPageBrandByIdQueryHookResult = ReturnType<typeof useDetailsPageBrandByIdQuery>;
export type DetailsPageBrandByIdLazyQueryHookResult = ReturnType<typeof useDetailsPageBrandByIdLazyQuery>;
export type DetailsPageBrandByIdQueryResult = Apollo.QueryResult<DetailsPageBrandByIdQuery, DetailsPageBrandByIdQueryVariables>;
export const DetailsPageBrandUpdateDocument = gql`
    mutation DetailsPageBrandUpdate($id: MongoID!, $input: UpdateByIdBrandHouseInput!) {
  BrandHouseUpdate(_id: $id, record: $input) {
    record {
      _id
      name
      logisticsPartnerId
    }
  }
}
    `;
export type DetailsPageBrandUpdateMutationFn = Apollo.MutationFunction<DetailsPageBrandUpdateMutation, DetailsPageBrandUpdateMutationVariables>;

/**
 * __useDetailsPageBrandUpdateMutation__
 *
 * To run a mutation, you first call `useDetailsPageBrandUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDetailsPageBrandUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [detailsPageBrandUpdateMutation, { data, loading, error }] = useDetailsPageBrandUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDetailsPageBrandUpdateMutation(baseOptions?: Apollo.MutationHookOptions<DetailsPageBrandUpdateMutation, DetailsPageBrandUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DetailsPageBrandUpdateMutation, DetailsPageBrandUpdateMutationVariables>(DetailsPageBrandUpdateDocument, options);
      }
export type DetailsPageBrandUpdateMutationHookResult = ReturnType<typeof useDetailsPageBrandUpdateMutation>;
export type DetailsPageBrandUpdateMutationResult = Apollo.MutationResult<DetailsPageBrandUpdateMutation>;
export type DetailsPageBrandUpdateMutationOptions = Apollo.BaseMutationOptions<DetailsPageBrandUpdateMutation, DetailsPageBrandUpdateMutationVariables>;
export const RefIntegrationSettingsDocument = gql`
    query RefIntegrationSettings($instanceId: MongoID!) {
  IntegrationInstance(_id: $instanceId) {
    _id
    name
    connector {
      _id
      name
      fields {
        field
        description
        namespace
        type
        options {
          value
          label
        }
      }
      messages
    }
    settings {
      _id
      refId
      instanceId
      key
      value
    }
    configs {
      _id
      refId
      message
      enabled
    }
  }
}
    `;

/**
 * __useRefIntegrationSettingsQuery__
 *
 * To run a query within a React component, call `useRefIntegrationSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRefIntegrationSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRefIntegrationSettingsQuery({
 *   variables: {
 *      instanceId: // value for 'instanceId'
 *   },
 * });
 */
export function useRefIntegrationSettingsQuery(baseOptions: Apollo.QueryHookOptions<RefIntegrationSettingsQuery, RefIntegrationSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RefIntegrationSettingsQuery, RefIntegrationSettingsQueryVariables>(RefIntegrationSettingsDocument, options);
      }
export function useRefIntegrationSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RefIntegrationSettingsQuery, RefIntegrationSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RefIntegrationSettingsQuery, RefIntegrationSettingsQueryVariables>(RefIntegrationSettingsDocument, options);
        }
export type RefIntegrationSettingsQueryHookResult = ReturnType<typeof useRefIntegrationSettingsQuery>;
export type RefIntegrationSettingsLazyQueryHookResult = ReturnType<typeof useRefIntegrationSettingsLazyQuery>;
export type RefIntegrationSettingsQueryResult = Apollo.QueryResult<RefIntegrationSettingsQuery, RefIntegrationSettingsQueryVariables>;
export const RefIntegrationSettingUpdateDocument = gql`
    mutation RefIntegrationSettingUpdate($instanceId: MongoID!, $input: [IntegrationSettingInInput!]) {
  IntegrationSettingUpdate(instanceId: $instanceId, input: $input) {
    _id
    refId
    instanceId
    key
    value
  }
}
    `;
export type RefIntegrationSettingUpdateMutationFn = Apollo.MutationFunction<RefIntegrationSettingUpdateMutation, RefIntegrationSettingUpdateMutationVariables>;

/**
 * __useRefIntegrationSettingUpdateMutation__
 *
 * To run a mutation, you first call `useRefIntegrationSettingUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRefIntegrationSettingUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [refIntegrationSettingUpdateMutation, { data, loading, error }] = useRefIntegrationSettingUpdateMutation({
 *   variables: {
 *      instanceId: // value for 'instanceId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRefIntegrationSettingUpdateMutation(baseOptions?: Apollo.MutationHookOptions<RefIntegrationSettingUpdateMutation, RefIntegrationSettingUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RefIntegrationSettingUpdateMutation, RefIntegrationSettingUpdateMutationVariables>(RefIntegrationSettingUpdateDocument, options);
      }
export type RefIntegrationSettingUpdateMutationHookResult = ReturnType<typeof useRefIntegrationSettingUpdateMutation>;
export type RefIntegrationSettingUpdateMutationResult = Apollo.MutationResult<RefIntegrationSettingUpdateMutation>;
export type RefIntegrationSettingUpdateMutationOptions = Apollo.BaseMutationOptions<RefIntegrationSettingUpdateMutation, RefIntegrationSettingUpdateMutationVariables>;
export const RefIntegrationMessageUpdateDocument = gql`
    mutation RefIntegrationMessageUpdate($instanceId: MongoID!, $message: IntegrationMessageEnum, $enabled: Boolean!) {
  IntegrationConfigUpdate(
    instanceId: $instanceId
    message: $message
    enabled: $enabled
  ) {
    _id
    message
    instanceId
    refId
  }
}
    `;
export type RefIntegrationMessageUpdateMutationFn = Apollo.MutationFunction<RefIntegrationMessageUpdateMutation, RefIntegrationMessageUpdateMutationVariables>;

/**
 * __useRefIntegrationMessageUpdateMutation__
 *
 * To run a mutation, you first call `useRefIntegrationMessageUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRefIntegrationMessageUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [refIntegrationMessageUpdateMutation, { data, loading, error }] = useRefIntegrationMessageUpdateMutation({
 *   variables: {
 *      instanceId: // value for 'instanceId'
 *      message: // value for 'message'
 *      enabled: // value for 'enabled'
 *   },
 * });
 */
export function useRefIntegrationMessageUpdateMutation(baseOptions?: Apollo.MutationHookOptions<RefIntegrationMessageUpdateMutation, RefIntegrationMessageUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RefIntegrationMessageUpdateMutation, RefIntegrationMessageUpdateMutationVariables>(RefIntegrationMessageUpdateDocument, options);
      }
export type RefIntegrationMessageUpdateMutationHookResult = ReturnType<typeof useRefIntegrationMessageUpdateMutation>;
export type RefIntegrationMessageUpdateMutationResult = Apollo.MutationResult<RefIntegrationMessageUpdateMutation>;
export type RefIntegrationMessageUpdateMutationOptions = Apollo.BaseMutationOptions<RefIntegrationMessageUpdateMutation, RefIntegrationMessageUpdateMutationVariables>;
export const RefConsumerActivitySetupDocument = gql`
    mutation RefConsumerActivitySetup($instanceId: MongoID!, $email: String!) {
  ConsumerActivitySetup(instanceId: $instanceId, email: $email)
}
    `;
export type RefConsumerActivitySetupMutationFn = Apollo.MutationFunction<RefConsumerActivitySetupMutation, RefConsumerActivitySetupMutationVariables>;

/**
 * __useRefConsumerActivitySetupMutation__
 *
 * To run a mutation, you first call `useRefConsumerActivitySetupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRefConsumerActivitySetupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [refConsumerActivitySetupMutation, { data, loading, error }] = useRefConsumerActivitySetupMutation({
 *   variables: {
 *      instanceId: // value for 'instanceId'
 *      email: // value for 'email'
 *   },
 * });
 */
export function useRefConsumerActivitySetupMutation(baseOptions?: Apollo.MutationHookOptions<RefConsumerActivitySetupMutation, RefConsumerActivitySetupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RefConsumerActivitySetupMutation, RefConsumerActivitySetupMutationVariables>(RefConsumerActivitySetupDocument, options);
      }
export type RefConsumerActivitySetupMutationHookResult = ReturnType<typeof useRefConsumerActivitySetupMutation>;
export type RefConsumerActivitySetupMutationResult = Apollo.MutationResult<RefConsumerActivitySetupMutation>;
export type RefConsumerActivitySetupMutationOptions = Apollo.BaseMutationOptions<RefConsumerActivitySetupMutation, RefConsumerActivitySetupMutationVariables>;
export const RefIntegrationConfigDocument = gql`
    query RefIntegrationConfig($refId: MongoID!) {
  IntegrationConnectors(limit: 999) {
    _id
    name
    icon
    activeFor
    type
    messages
  }
  IntegrationInstances(filter: {refId: $refId}, limit: 999) {
    _id
    name
    connectorId
    enabled
    deleted
    mode
    configs {
      _id
      message
      enabled
    }
  }
}
    `;

/**
 * __useRefIntegrationConfigQuery__
 *
 * To run a query within a React component, call `useRefIntegrationConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useRefIntegrationConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRefIntegrationConfigQuery({
 *   variables: {
 *      refId: // value for 'refId'
 *   },
 * });
 */
export function useRefIntegrationConfigQuery(baseOptions: Apollo.QueryHookOptions<RefIntegrationConfigQuery, RefIntegrationConfigQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RefIntegrationConfigQuery, RefIntegrationConfigQueryVariables>(RefIntegrationConfigDocument, options);
      }
export function useRefIntegrationConfigLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RefIntegrationConfigQuery, RefIntegrationConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RefIntegrationConfigQuery, RefIntegrationConfigQueryVariables>(RefIntegrationConfigDocument, options);
        }
export type RefIntegrationConfigQueryHookResult = ReturnType<typeof useRefIntegrationConfigQuery>;
export type RefIntegrationConfigLazyQueryHookResult = ReturnType<typeof useRefIntegrationConfigLazyQuery>;
export type RefIntegrationConfigQueryResult = Apollo.QueryResult<RefIntegrationConfigQuery, RefIntegrationConfigQueryVariables>;
export const RefIntegrationInstallConnectorDocument = gql`
    mutation RefIntegrationInstallConnector($refId: MongoID!, $connectorId: MongoID!, $refType: EnumIntegrationConnectorRefType!) {
  IntegrationInstall(refId: $refId, refType: $refType, connectorId: $connectorId) {
    _id
    connectorId
    refId
    enabled
    deleted
  }
}
    `;
export type RefIntegrationInstallConnectorMutationFn = Apollo.MutationFunction<RefIntegrationInstallConnectorMutation, RefIntegrationInstallConnectorMutationVariables>;

/**
 * __useRefIntegrationInstallConnectorMutation__
 *
 * To run a mutation, you first call `useRefIntegrationInstallConnectorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRefIntegrationInstallConnectorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [refIntegrationInstallConnectorMutation, { data, loading, error }] = useRefIntegrationInstallConnectorMutation({
 *   variables: {
 *      refId: // value for 'refId'
 *      connectorId: // value for 'connectorId'
 *      refType: // value for 'refType'
 *   },
 * });
 */
export function useRefIntegrationInstallConnectorMutation(baseOptions?: Apollo.MutationHookOptions<RefIntegrationInstallConnectorMutation, RefIntegrationInstallConnectorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RefIntegrationInstallConnectorMutation, RefIntegrationInstallConnectorMutationVariables>(RefIntegrationInstallConnectorDocument, options);
      }
export type RefIntegrationInstallConnectorMutationHookResult = ReturnType<typeof useRefIntegrationInstallConnectorMutation>;
export type RefIntegrationInstallConnectorMutationResult = Apollo.MutationResult<RefIntegrationInstallConnectorMutation>;
export type RefIntegrationInstallConnectorMutationOptions = Apollo.BaseMutationOptions<RefIntegrationInstallConnectorMutation, RefIntegrationInstallConnectorMutationVariables>;
export const RefIntegrationUninstallDocument = gql`
    mutation RefIntegrationUninstall($refId: MongoID!, $refType: EnumIntegrationConnectorRefType!, $instanceId: MongoID!) {
  IntegrationUnInstall(refId: $refId, refType: $refType, instanceId: $instanceId) {
    _id
    name
    deleted
    enabled
  }
}
    `;
export type RefIntegrationUninstallMutationFn = Apollo.MutationFunction<RefIntegrationUninstallMutation, RefIntegrationUninstallMutationVariables>;

/**
 * __useRefIntegrationUninstallMutation__
 *
 * To run a mutation, you first call `useRefIntegrationUninstallMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRefIntegrationUninstallMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [refIntegrationUninstallMutation, { data, loading, error }] = useRefIntegrationUninstallMutation({
 *   variables: {
 *      refId: // value for 'refId'
 *      refType: // value for 'refType'
 *      instanceId: // value for 'instanceId'
 *   },
 * });
 */
export function useRefIntegrationUninstallMutation(baseOptions?: Apollo.MutationHookOptions<RefIntegrationUninstallMutation, RefIntegrationUninstallMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RefIntegrationUninstallMutation, RefIntegrationUninstallMutationVariables>(RefIntegrationUninstallDocument, options);
      }
export type RefIntegrationUninstallMutationHookResult = ReturnType<typeof useRefIntegrationUninstallMutation>;
export type RefIntegrationUninstallMutationResult = Apollo.MutationResult<RefIntegrationUninstallMutation>;
export type RefIntegrationUninstallMutationOptions = Apollo.BaseMutationOptions<RefIntegrationUninstallMutation, RefIntegrationUninstallMutationVariables>;
export const SalesforceEditGetDocument = gql`
    query SalesforceEditGet($brandHouseId: MongoID!) {
  BrandHouse(id: $brandHouseId) {
    _id
    license
  }
}
    `;

/**
 * __useSalesforceEditGetQuery__
 *
 * To run a query within a React component, call `useSalesforceEditGetQuery` and pass it any options that fit your needs.
 * When your component renders, `useSalesforceEditGetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSalesforceEditGetQuery({
 *   variables: {
 *      brandHouseId: // value for 'brandHouseId'
 *   },
 * });
 */
export function useSalesforceEditGetQuery(baseOptions: Apollo.QueryHookOptions<SalesforceEditGetQuery, SalesforceEditGetQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SalesforceEditGetQuery, SalesforceEditGetQueryVariables>(SalesforceEditGetDocument, options);
      }
export function useSalesforceEditGetLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SalesforceEditGetQuery, SalesforceEditGetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SalesforceEditGetQuery, SalesforceEditGetQueryVariables>(SalesforceEditGetDocument, options);
        }
export type SalesforceEditGetQueryHookResult = ReturnType<typeof useSalesforceEditGetQuery>;
export type SalesforceEditGetLazyQueryHookResult = ReturnType<typeof useSalesforceEditGetLazyQuery>;
export type SalesforceEditGetQueryResult = Apollo.QueryResult<SalesforceEditGetQuery, SalesforceEditGetQueryVariables>;
export const SalesforceEditShopDocument = gql`
    query SalesforceEditShop($shop: MongoID!) {
  ShopById(_id: $shop) {
    _id
    externalId
    name
    configuration
    logisticsPartnerId
  }
  LogisticsPartners {
    _id
    name
  }
}
    `;

/**
 * __useSalesforceEditShopQuery__
 *
 * To run a query within a React component, call `useSalesforceEditShopQuery` and pass it any options that fit your needs.
 * When your component renders, `useSalesforceEditShopQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSalesforceEditShopQuery({
 *   variables: {
 *      shop: // value for 'shop'
 *   },
 * });
 */
export function useSalesforceEditShopQuery(baseOptions: Apollo.QueryHookOptions<SalesforceEditShopQuery, SalesforceEditShopQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SalesforceEditShopQuery, SalesforceEditShopQueryVariables>(SalesforceEditShopDocument, options);
      }
export function useSalesforceEditShopLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SalesforceEditShopQuery, SalesforceEditShopQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SalesforceEditShopQuery, SalesforceEditShopQueryVariables>(SalesforceEditShopDocument, options);
        }
export type SalesforceEditShopQueryHookResult = ReturnType<typeof useSalesforceEditShopQuery>;
export type SalesforceEditShopLazyQueryHookResult = ReturnType<typeof useSalesforceEditShopLazyQuery>;
export type SalesforceEditShopQueryResult = Apollo.QueryResult<SalesforceEditShopQuery, SalesforceEditShopQueryVariables>;
export const SalesforceEditCreateDocument = gql`
    mutation SalesforceEditCreate($name: String!, $externId: String!, $license: String!, $config: JSON) {
  ShopCreate2(
    name: $name
    frontendType: salesforce
    externId: $externId
    license: $license
    configuration: $config
  ) {
    _id
  }
}
    `;
export type SalesforceEditCreateMutationFn = Apollo.MutationFunction<SalesforceEditCreateMutation, SalesforceEditCreateMutationVariables>;

/**
 * __useSalesforceEditCreateMutation__
 *
 * To run a mutation, you first call `useSalesforceEditCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSalesforceEditCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [salesforceEditCreateMutation, { data, loading, error }] = useSalesforceEditCreateMutation({
 *   variables: {
 *      name: // value for 'name'
 *      externId: // value for 'externId'
 *      license: // value for 'license'
 *      config: // value for 'config'
 *   },
 * });
 */
export function useSalesforceEditCreateMutation(baseOptions?: Apollo.MutationHookOptions<SalesforceEditCreateMutation, SalesforceEditCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SalesforceEditCreateMutation, SalesforceEditCreateMutationVariables>(SalesforceEditCreateDocument, options);
      }
export type SalesforceEditCreateMutationHookResult = ReturnType<typeof useSalesforceEditCreateMutation>;
export type SalesforceEditCreateMutationResult = Apollo.MutationResult<SalesforceEditCreateMutation>;
export type SalesforceEditCreateMutationOptions = Apollo.BaseMutationOptions<SalesforceEditCreateMutation, SalesforceEditCreateMutationVariables>;
export const SalesforceEditUpdateDocument = gql`
    mutation SalesforceEditUpdate($shopId: String!, $data: JSON!) {
  ShopUpdate(
    shopId: $shopId
    shop: {frontendType: salesforce, configuration: $data}
  ) {
    _id
    configuration
  }
}
    `;
export type SalesforceEditUpdateMutationFn = Apollo.MutationFunction<SalesforceEditUpdateMutation, SalesforceEditUpdateMutationVariables>;

/**
 * __useSalesforceEditUpdateMutation__
 *
 * To run a mutation, you first call `useSalesforceEditUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSalesforceEditUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [salesforceEditUpdateMutation, { data, loading, error }] = useSalesforceEditUpdateMutation({
 *   variables: {
 *      shopId: // value for 'shopId'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useSalesforceEditUpdateMutation(baseOptions?: Apollo.MutationHookOptions<SalesforceEditUpdateMutation, SalesforceEditUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SalesforceEditUpdateMutation, SalesforceEditUpdateMutationVariables>(SalesforceEditUpdateDocument, options);
      }
export type SalesforceEditUpdateMutationHookResult = ReturnType<typeof useSalesforceEditUpdateMutation>;
export type SalesforceEditUpdateMutationResult = Apollo.MutationResult<SalesforceEditUpdateMutation>;
export type SalesforceEditUpdateMutationOptions = Apollo.BaseMutationOptions<SalesforceEditUpdateMutation, SalesforceEditUpdateMutationVariables>;
export const ShopCreateGetDocument = gql`
    query ShopCreateGet($brandHouseId: MongoID!) {
  BrandHouse(id: $brandHouseId) {
    _id
    license
  }
}
    `;

/**
 * __useShopCreateGetQuery__
 *
 * To run a query within a React component, call `useShopCreateGetQuery` and pass it any options that fit your needs.
 * When your component renders, `useShopCreateGetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShopCreateGetQuery({
 *   variables: {
 *      brandHouseId: // value for 'brandHouseId'
 *   },
 * });
 */
export function useShopCreateGetQuery(baseOptions: Apollo.QueryHookOptions<ShopCreateGetQuery, ShopCreateGetQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ShopCreateGetQuery, ShopCreateGetQueryVariables>(ShopCreateGetDocument, options);
      }
export function useShopCreateGetLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ShopCreateGetQuery, ShopCreateGetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ShopCreateGetQuery, ShopCreateGetQueryVariables>(ShopCreateGetDocument, options);
        }
export type ShopCreateGetQueryHookResult = ReturnType<typeof useShopCreateGetQuery>;
export type ShopCreateGetLazyQueryHookResult = ReturnType<typeof useShopCreateGetLazyQuery>;
export type ShopCreateGetQueryResult = Apollo.QueryResult<ShopCreateGetQuery, ShopCreateGetQueryVariables>;
export const ShopCreateDocument = gql`
    mutation ShopCreate($name: String!, $currency: String!, $locale: String!, $license: String!, $frontendType: EnumShopFrontendType!, $mainCountryCode: String!, $shop: String!, $tradeInBaseUrl: String!) {
  ShopCreate(
    name: $name
    currency: $currency
    primaryLocale: $locale
    license: $license
    frontendType: $frontendType
    mainCountryCode: $mainCountryCode
    shop: $shop
    tradeInBaseUrl: $tradeInBaseUrl
  ) {
    _id
  }
}
    `;
export type ShopCreateMutationFn = Apollo.MutationFunction<ShopCreateMutation, ShopCreateMutationVariables>;

/**
 * __useShopCreateMutation__
 *
 * To run a mutation, you first call `useShopCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useShopCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [shopCreateMutation, { data, loading, error }] = useShopCreateMutation({
 *   variables: {
 *      name: // value for 'name'
 *      currency: // value for 'currency'
 *      locale: // value for 'locale'
 *      license: // value for 'license'
 *      frontendType: // value for 'frontendType'
 *      mainCountryCode: // value for 'mainCountryCode'
 *      shop: // value for 'shop'
 *      tradeInBaseUrl: // value for 'tradeInBaseUrl'
 *   },
 * });
 */
export function useShopCreateMutation(baseOptions?: Apollo.MutationHookOptions<ShopCreateMutation, ShopCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ShopCreateMutation, ShopCreateMutationVariables>(ShopCreateDocument, options);
      }
export type ShopCreateMutationHookResult = ReturnType<typeof useShopCreateMutation>;
export type ShopCreateMutationResult = Apollo.MutationResult<ShopCreateMutation>;
export type ShopCreateMutationOptions = Apollo.BaseMutationOptions<ShopCreateMutation, ShopCreateMutationVariables>;
export const ShopIntegrationConfigDocument = gql`
    query ShopIntegrationConfig($shopId: MongoID!) {
  BrandSettings(shopId: $shopId) {
    _id
    legacyIntegrationDisabled
    legacyIntegrationDisabledMessages
  }
}
    `;

/**
 * __useShopIntegrationConfigQuery__
 *
 * To run a query within a React component, call `useShopIntegrationConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useShopIntegrationConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShopIntegrationConfigQuery({
 *   variables: {
 *      shopId: // value for 'shopId'
 *   },
 * });
 */
export function useShopIntegrationConfigQuery(baseOptions: Apollo.QueryHookOptions<ShopIntegrationConfigQuery, ShopIntegrationConfigQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ShopIntegrationConfigQuery, ShopIntegrationConfigQueryVariables>(ShopIntegrationConfigDocument, options);
      }
export function useShopIntegrationConfigLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ShopIntegrationConfigQuery, ShopIntegrationConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ShopIntegrationConfigQuery, ShopIntegrationConfigQueryVariables>(ShopIntegrationConfigDocument, options);
        }
export type ShopIntegrationConfigQueryHookResult = ReturnType<typeof useShopIntegrationConfigQuery>;
export type ShopIntegrationConfigLazyQueryHookResult = ReturnType<typeof useShopIntegrationConfigLazyQuery>;
export type ShopIntegrationConfigQueryResult = Apollo.QueryResult<ShopIntegrationConfigQuery, ShopIntegrationConfigQueryVariables>;
export const ShopSettingsShopDocument = gql`
    query ShopSettingsShop($shopId: MongoID!) {
  ShopById(_id: $shopId) {
    _id
    name
    live
    liveDate
    closeDate
    tradeInBaseUrl
    shopCollectionUrl
    currency
    disableContactResetDate
    frontendType
    logisticsPartnerId
  }
  LogisticsPartners {
    _id
    name
  }
}
    `;

/**
 * __useShopSettingsShopQuery__
 *
 * To run a query within a React component, call `useShopSettingsShopQuery` and pass it any options that fit your needs.
 * When your component renders, `useShopSettingsShopQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShopSettingsShopQuery({
 *   variables: {
 *      shopId: // value for 'shopId'
 *   },
 * });
 */
export function useShopSettingsShopQuery(baseOptions: Apollo.QueryHookOptions<ShopSettingsShopQuery, ShopSettingsShopQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ShopSettingsShopQuery, ShopSettingsShopQueryVariables>(ShopSettingsShopDocument, options);
      }
export function useShopSettingsShopLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ShopSettingsShopQuery, ShopSettingsShopQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ShopSettingsShopQuery, ShopSettingsShopQueryVariables>(ShopSettingsShopDocument, options);
        }
export type ShopSettingsShopQueryHookResult = ReturnType<typeof useShopSettingsShopQuery>;
export type ShopSettingsShopLazyQueryHookResult = ReturnType<typeof useShopSettingsShopLazyQuery>;
export type ShopSettingsShopQueryResult = Apollo.QueryResult<ShopSettingsShopQuery, ShopSettingsShopQueryVariables>;
export const ShopSettingsShopUpdateDocument = gql`
    mutation ShopSettingsShopUpdate($shopId: String!, $shop: ShopUpdateInput!) {
  ShopUpdate(shopId: $shopId, shop: $shop) {
    _id
  }
}
    `;
export type ShopSettingsShopUpdateMutationFn = Apollo.MutationFunction<ShopSettingsShopUpdateMutation, ShopSettingsShopUpdateMutationVariables>;

/**
 * __useShopSettingsShopUpdateMutation__
 *
 * To run a mutation, you first call `useShopSettingsShopUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useShopSettingsShopUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [shopSettingsShopUpdateMutation, { data, loading, error }] = useShopSettingsShopUpdateMutation({
 *   variables: {
 *      shopId: // value for 'shopId'
 *      shop: // value for 'shop'
 *   },
 * });
 */
export function useShopSettingsShopUpdateMutation(baseOptions?: Apollo.MutationHookOptions<ShopSettingsShopUpdateMutation, ShopSettingsShopUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ShopSettingsShopUpdateMutation, ShopSettingsShopUpdateMutationVariables>(ShopSettingsShopUpdateDocument, options);
      }
export type ShopSettingsShopUpdateMutationHookResult = ReturnType<typeof useShopSettingsShopUpdateMutation>;
export type ShopSettingsShopUpdateMutationResult = Apollo.MutationResult<ShopSettingsShopUpdateMutation>;
export type ShopSettingsShopUpdateMutationOptions = Apollo.BaseMutationOptions<ShopSettingsShopUpdateMutation, ShopSettingsShopUpdateMutationVariables>;
export const ShopResetDocument = gql`
    mutation ShopReset($shopId: MongoID!) {
  ShopReset(shopId: $shopId) {
    _id
  }
}
    `;
export type ShopResetMutationFn = Apollo.MutationFunction<ShopResetMutation, ShopResetMutationVariables>;

/**
 * __useShopResetMutation__
 *
 * To run a mutation, you first call `useShopResetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useShopResetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [shopResetMutation, { data, loading, error }] = useShopResetMutation({
 *   variables: {
 *      shopId: // value for 'shopId'
 *   },
 * });
 */
export function useShopResetMutation(baseOptions?: Apollo.MutationHookOptions<ShopResetMutation, ShopResetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ShopResetMutation, ShopResetMutationVariables>(ShopResetDocument, options);
      }
export type ShopResetMutationHookResult = ReturnType<typeof useShopResetMutation>;
export type ShopResetMutationResult = Apollo.MutationResult<ShopResetMutation>;
export type ShopResetMutationOptions = Apollo.BaseMutationOptions<ShopResetMutation, ShopResetMutationVariables>;
export const ShopSettingsLogisticsPartnerUpdateDocument = gql`
    mutation ShopSettingsLogisticsPartnerUpdate($shopId: MongoID!, $logisticsPartnerId: MongoID!) {
  ShopUpdateOne(
    filter: {_id: $shopId}
    record: {logisticsPartnerId: $logisticsPartnerId}
  ) {
    recordId
    record {
      _id
      logisticsPartnerId
    }
  }
}
    `;
export type ShopSettingsLogisticsPartnerUpdateMutationFn = Apollo.MutationFunction<ShopSettingsLogisticsPartnerUpdateMutation, ShopSettingsLogisticsPartnerUpdateMutationVariables>;

/**
 * __useShopSettingsLogisticsPartnerUpdateMutation__
 *
 * To run a mutation, you first call `useShopSettingsLogisticsPartnerUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useShopSettingsLogisticsPartnerUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [shopSettingsLogisticsPartnerUpdateMutation, { data, loading, error }] = useShopSettingsLogisticsPartnerUpdateMutation({
 *   variables: {
 *      shopId: // value for 'shopId'
 *      logisticsPartnerId: // value for 'logisticsPartnerId'
 *   },
 * });
 */
export function useShopSettingsLogisticsPartnerUpdateMutation(baseOptions?: Apollo.MutationHookOptions<ShopSettingsLogisticsPartnerUpdateMutation, ShopSettingsLogisticsPartnerUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ShopSettingsLogisticsPartnerUpdateMutation, ShopSettingsLogisticsPartnerUpdateMutationVariables>(ShopSettingsLogisticsPartnerUpdateDocument, options);
      }
export type ShopSettingsLogisticsPartnerUpdateMutationHookResult = ReturnType<typeof useShopSettingsLogisticsPartnerUpdateMutation>;
export type ShopSettingsLogisticsPartnerUpdateMutationResult = Apollo.MutationResult<ShopSettingsLogisticsPartnerUpdateMutation>;
export type ShopSettingsLogisticsPartnerUpdateMutationOptions = Apollo.BaseMutationOptions<ShopSettingsLogisticsPartnerUpdateMutation, ShopSettingsLogisticsPartnerUpdateMutationVariables>;
export const AutoTagShopDocument = gql`
    query AutoTagShop($shopId: MongoID!) {
  ShopById(_id: $shopId) {
    _id
    productTags
  }
}
    `;

/**
 * __useAutoTagShopQuery__
 *
 * To run a query within a React component, call `useAutoTagShopQuery` and pass it any options that fit your needs.
 * When your component renders, `useAutoTagShopQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAutoTagShopQuery({
 *   variables: {
 *      shopId: // value for 'shopId'
 *   },
 * });
 */
export function useAutoTagShopQuery(baseOptions: Apollo.QueryHookOptions<AutoTagShopQuery, AutoTagShopQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AutoTagShopQuery, AutoTagShopQueryVariables>(AutoTagShopDocument, options);
      }
export function useAutoTagShopLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AutoTagShopQuery, AutoTagShopQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AutoTagShopQuery, AutoTagShopQueryVariables>(AutoTagShopDocument, options);
        }
export type AutoTagShopQueryHookResult = ReturnType<typeof useAutoTagShopQuery>;
export type AutoTagShopLazyQueryHookResult = ReturnType<typeof useAutoTagShopLazyQuery>;
export type AutoTagShopQueryResult = Apollo.QueryResult<AutoTagShopQuery, AutoTagShopQueryVariables>;
export const AutoTagBrandDocument = gql`
    query AutoTagBrand($brandHouseId: MongoID!) {
  BrandHouse(id: $brandHouseId) {
    _id
    productTags
  }
}
    `;

/**
 * __useAutoTagBrandQuery__
 *
 * To run a query within a React component, call `useAutoTagBrandQuery` and pass it any options that fit your needs.
 * When your component renders, `useAutoTagBrandQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAutoTagBrandQuery({
 *   variables: {
 *      brandHouseId: // value for 'brandHouseId'
 *   },
 * });
 */
export function useAutoTagBrandQuery(baseOptions: Apollo.QueryHookOptions<AutoTagBrandQuery, AutoTagBrandQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AutoTagBrandQuery, AutoTagBrandQueryVariables>(AutoTagBrandDocument, options);
      }
export function useAutoTagBrandLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AutoTagBrandQuery, AutoTagBrandQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AutoTagBrandQuery, AutoTagBrandQueryVariables>(AutoTagBrandDocument, options);
        }
export type AutoTagBrandQueryHookResult = ReturnType<typeof useAutoTagBrandQuery>;
export type AutoTagBrandLazyQueryHookResult = ReturnType<typeof useAutoTagBrandLazyQuery>;
export type AutoTagBrandQueryResult = Apollo.QueryResult<AutoTagBrandQuery, AutoTagBrandQueryVariables>;
export const AutoTagSettingsDocument = gql`
    query AutoTagSettings($shopId: MongoID, $brandHouseId: MongoID) {
  BrandSettings(shopId: $shopId, brandHouseId: $brandHouseId) {
    _id
    stockItemConfig {
      ...SettingsStockItemFragment
    }
  }
}
    ${SettingsStockItemFragmentDoc}`;

/**
 * __useAutoTagSettingsQuery__
 *
 * To run a query within a React component, call `useAutoTagSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAutoTagSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAutoTagSettingsQuery({
 *   variables: {
 *      shopId: // value for 'shopId'
 *      brandHouseId: // value for 'brandHouseId'
 *   },
 * });
 */
export function useAutoTagSettingsQuery(baseOptions?: Apollo.QueryHookOptions<AutoTagSettingsQuery, AutoTagSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AutoTagSettingsQuery, AutoTagSettingsQueryVariables>(AutoTagSettingsDocument, options);
      }
export function useAutoTagSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AutoTagSettingsQuery, AutoTagSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AutoTagSettingsQuery, AutoTagSettingsQueryVariables>(AutoTagSettingsDocument, options);
        }
export type AutoTagSettingsQueryHookResult = ReturnType<typeof useAutoTagSettingsQuery>;
export type AutoTagSettingsLazyQueryHookResult = ReturnType<typeof useAutoTagSettingsLazyQuery>;
export type AutoTagSettingsQueryResult = Apollo.QueryResult<AutoTagSettingsQuery, AutoTagSettingsQueryVariables>;
export const AutoTagSettingsUpdateDocument = gql`
    mutation AutoTagSettingsUpdate($shopId: MongoID, $brandHouseId: MongoID, $stockConfig: BrandSettingStockItemConfigInput, $auditNoteId: MongoID) {
  BrandSettingsUpdate(
    shopId: $shopId
    brandHouseId: $brandHouseId
    auditNoteId: $auditNoteId
    api: {stockItemConfig: $stockConfig}
  ) {
    _id
    stockItemConfig {
      ...SettingsStockItemFragment
    }
  }
}
    ${SettingsStockItemFragmentDoc}`;
export type AutoTagSettingsUpdateMutationFn = Apollo.MutationFunction<AutoTagSettingsUpdateMutation, AutoTagSettingsUpdateMutationVariables>;

/**
 * __useAutoTagSettingsUpdateMutation__
 *
 * To run a mutation, you first call `useAutoTagSettingsUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAutoTagSettingsUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [autoTagSettingsUpdateMutation, { data, loading, error }] = useAutoTagSettingsUpdateMutation({
 *   variables: {
 *      shopId: // value for 'shopId'
 *      brandHouseId: // value for 'brandHouseId'
 *      stockConfig: // value for 'stockConfig'
 *      auditNoteId: // value for 'auditNoteId'
 *   },
 * });
 */
export function useAutoTagSettingsUpdateMutation(baseOptions?: Apollo.MutationHookOptions<AutoTagSettingsUpdateMutation, AutoTagSettingsUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AutoTagSettingsUpdateMutation, AutoTagSettingsUpdateMutationVariables>(AutoTagSettingsUpdateDocument, options);
      }
export type AutoTagSettingsUpdateMutationHookResult = ReturnType<typeof useAutoTagSettingsUpdateMutation>;
export type AutoTagSettingsUpdateMutationResult = Apollo.MutationResult<AutoTagSettingsUpdateMutation>;
export type AutoTagSettingsUpdateMutationOptions = Apollo.BaseMutationOptions<AutoTagSettingsUpdateMutation, AutoTagSettingsUpdateMutationVariables>;
export const BasicSettingsShopDocument = gql`
    query BasicSettingsShop($shopId: MongoID!) {
  ShopById(_id: $shopId) {
    _id
    stockItemLocalePrimary
    stockItemLocales
  }
}
    `;

/**
 * __useBasicSettingsShopQuery__
 *
 * To run a query within a React component, call `useBasicSettingsShopQuery` and pass it any options that fit your needs.
 * When your component renders, `useBasicSettingsShopQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBasicSettingsShopQuery({
 *   variables: {
 *      shopId: // value for 'shopId'
 *   },
 * });
 */
export function useBasicSettingsShopQuery(baseOptions: Apollo.QueryHookOptions<BasicSettingsShopQuery, BasicSettingsShopQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BasicSettingsShopQuery, BasicSettingsShopQueryVariables>(BasicSettingsShopDocument, options);
      }
export function useBasicSettingsShopLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BasicSettingsShopQuery, BasicSettingsShopQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BasicSettingsShopQuery, BasicSettingsShopQueryVariables>(BasicSettingsShopDocument, options);
        }
export type BasicSettingsShopQueryHookResult = ReturnType<typeof useBasicSettingsShopQuery>;
export type BasicSettingsShopLazyQueryHookResult = ReturnType<typeof useBasicSettingsShopLazyQuery>;
export type BasicSettingsShopQueryResult = Apollo.QueryResult<BasicSettingsShopQuery, BasicSettingsShopQueryVariables>;
export const BasicSettingsStockDocument = gql`
    query BasicSettingsStock($shopId: MongoID, $brandHouseId: MongoID) {
  BrandSettings(shopId: $shopId, brandHouseId: $brandHouseId) {
    _id
    defaultCountryOfOrigin
    locales {
      activeItems
      locale
    }
    stockItemConfig {
      ...SettingsStockItemFragment
    }
  }
}
    ${SettingsStockItemFragmentDoc}`;

/**
 * __useBasicSettingsStockQuery__
 *
 * To run a query within a React component, call `useBasicSettingsStockQuery` and pass it any options that fit your needs.
 * When your component renders, `useBasicSettingsStockQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBasicSettingsStockQuery({
 *   variables: {
 *      shopId: // value for 'shopId'
 *      brandHouseId: // value for 'brandHouseId'
 *   },
 * });
 */
export function useBasicSettingsStockQuery(baseOptions?: Apollo.QueryHookOptions<BasicSettingsStockQuery, BasicSettingsStockQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BasicSettingsStockQuery, BasicSettingsStockQueryVariables>(BasicSettingsStockDocument, options);
      }
export function useBasicSettingsStockLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BasicSettingsStockQuery, BasicSettingsStockQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BasicSettingsStockQuery, BasicSettingsStockQueryVariables>(BasicSettingsStockDocument, options);
        }
export type BasicSettingsStockQueryHookResult = ReturnType<typeof useBasicSettingsStockQuery>;
export type BasicSettingsStockLazyQueryHookResult = ReturnType<typeof useBasicSettingsStockLazyQuery>;
export type BasicSettingsStockQueryResult = Apollo.QueryResult<BasicSettingsStockQuery, BasicSettingsStockQueryVariables>;
export const BasicSettingsStockUpdateDocument = gql`
    mutation BasicSettingsStockUpdate($shopId: MongoID, $brandHouseId: MongoID, $stockConfig: BrandSettingStockItemConfigInput, $defaultCountryOfOrigin: String, $auditNoteId: MongoID) {
  BrandSettingsUpdate(
    brandHouseId: $brandHouseId
    shopId: $shopId
    auditNoteId: $auditNoteId
    api: {stockItemConfig: $stockConfig, defaultCountryOfOrigin: $defaultCountryOfOrigin}
  ) {
    _id
    defaultCountryOfOrigin
    stockItemConfig {
      ...SettingsStockItemFragment
    }
  }
}
    ${SettingsStockItemFragmentDoc}`;
export type BasicSettingsStockUpdateMutationFn = Apollo.MutationFunction<BasicSettingsStockUpdateMutation, BasicSettingsStockUpdateMutationVariables>;

/**
 * __useBasicSettingsStockUpdateMutation__
 *
 * To run a mutation, you first call `useBasicSettingsStockUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBasicSettingsStockUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [basicSettingsStockUpdateMutation, { data, loading, error }] = useBasicSettingsStockUpdateMutation({
 *   variables: {
 *      shopId: // value for 'shopId'
 *      brandHouseId: // value for 'brandHouseId'
 *      stockConfig: // value for 'stockConfig'
 *      defaultCountryOfOrigin: // value for 'defaultCountryOfOrigin'
 *      auditNoteId: // value for 'auditNoteId'
 *   },
 * });
 */
export function useBasicSettingsStockUpdateMutation(baseOptions?: Apollo.MutationHookOptions<BasicSettingsStockUpdateMutation, BasicSettingsStockUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BasicSettingsStockUpdateMutation, BasicSettingsStockUpdateMutationVariables>(BasicSettingsStockUpdateDocument, options);
      }
export type BasicSettingsStockUpdateMutationHookResult = ReturnType<typeof useBasicSettingsStockUpdateMutation>;
export type BasicSettingsStockUpdateMutationResult = Apollo.MutationResult<BasicSettingsStockUpdateMutation>;
export type BasicSettingsStockUpdateMutationOptions = Apollo.BaseMutationOptions<BasicSettingsStockUpdateMutation, BasicSettingsStockUpdateMutationVariables>;
export const LocaleItemSettingsDocument = gql`
    query LocaleItemSettings($shopId: MongoID) {
  BrandSettings(shopId: $shopId) {
    _id
    stockItemConfig {
      ...SettingsStockItemFragment
    }
  }
}
    ${SettingsStockItemFragmentDoc}`;

/**
 * __useLocaleItemSettingsQuery__
 *
 * To run a query within a React component, call `useLocaleItemSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLocaleItemSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLocaleItemSettingsQuery({
 *   variables: {
 *      shopId: // value for 'shopId'
 *   },
 * });
 */
export function useLocaleItemSettingsQuery(baseOptions?: Apollo.QueryHookOptions<LocaleItemSettingsQuery, LocaleItemSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LocaleItemSettingsQuery, LocaleItemSettingsQueryVariables>(LocaleItemSettingsDocument, options);
      }
export function useLocaleItemSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LocaleItemSettingsQuery, LocaleItemSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LocaleItemSettingsQuery, LocaleItemSettingsQueryVariables>(LocaleItemSettingsDocument, options);
        }
export type LocaleItemSettingsQueryHookResult = ReturnType<typeof useLocaleItemSettingsQuery>;
export type LocaleItemSettingsLazyQueryHookResult = ReturnType<typeof useLocaleItemSettingsLazyQuery>;
export type LocaleItemSettingsQueryResult = Apollo.QueryResult<LocaleItemSettingsQuery, LocaleItemSettingsQueryVariables>;
export const LocaleItemSettingsUpdateDocument = gql`
    mutation LocaleItemSettingsUpdate($shopId: MongoID, $stockConfig: BrandSettingStockItemConfigInput, $auditNoteId: MongoID) {
  BrandSettingsUpdate(
    shopId: $shopId
    auditNoteId: $auditNoteId
    api: {stockItemConfig: $stockConfig}
  ) {
    _id
    stockItemConfig {
      ...SettingsStockItemFragment
    }
  }
}
    ${SettingsStockItemFragmentDoc}`;
export type LocaleItemSettingsUpdateMutationFn = Apollo.MutationFunction<LocaleItemSettingsUpdateMutation, LocaleItemSettingsUpdateMutationVariables>;

/**
 * __useLocaleItemSettingsUpdateMutation__
 *
 * To run a mutation, you first call `useLocaleItemSettingsUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLocaleItemSettingsUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [localeItemSettingsUpdateMutation, { data, loading, error }] = useLocaleItemSettingsUpdateMutation({
 *   variables: {
 *      shopId: // value for 'shopId'
 *      stockConfig: // value for 'stockConfig'
 *      auditNoteId: // value for 'auditNoteId'
 *   },
 * });
 */
export function useLocaleItemSettingsUpdateMutation(baseOptions?: Apollo.MutationHookOptions<LocaleItemSettingsUpdateMutation, LocaleItemSettingsUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LocaleItemSettingsUpdateMutation, LocaleItemSettingsUpdateMutationVariables>(LocaleItemSettingsUpdateDocument, options);
      }
export type LocaleItemSettingsUpdateMutationHookResult = ReturnType<typeof useLocaleItemSettingsUpdateMutation>;
export type LocaleItemSettingsUpdateMutationResult = Apollo.MutationResult<LocaleItemSettingsUpdateMutation>;
export type LocaleItemSettingsUpdateMutationOptions = Apollo.BaseMutationOptions<LocaleItemSettingsUpdateMutation, LocaleItemSettingsUpdateMutationVariables>;
export const LocaleItemBrandHouseSettingsDocument = gql`
    query LocaleItemBrandHouseSettings($brandHouseId: MongoID) {
  BrandSettings(brandHouseId: $brandHouseId) {
    _id
    stockItemConfig {
      ...SettingsStockItemFragment
    }
  }
}
    ${SettingsStockItemFragmentDoc}`;

/**
 * __useLocaleItemBrandHouseSettingsQuery__
 *
 * To run a query within a React component, call `useLocaleItemBrandHouseSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLocaleItemBrandHouseSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLocaleItemBrandHouseSettingsQuery({
 *   variables: {
 *      brandHouseId: // value for 'brandHouseId'
 *   },
 * });
 */
export function useLocaleItemBrandHouseSettingsQuery(baseOptions?: Apollo.QueryHookOptions<LocaleItemBrandHouseSettingsQuery, LocaleItemBrandHouseSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LocaleItemBrandHouseSettingsQuery, LocaleItemBrandHouseSettingsQueryVariables>(LocaleItemBrandHouseSettingsDocument, options);
      }
export function useLocaleItemBrandHouseSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LocaleItemBrandHouseSettingsQuery, LocaleItemBrandHouseSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LocaleItemBrandHouseSettingsQuery, LocaleItemBrandHouseSettingsQueryVariables>(LocaleItemBrandHouseSettingsDocument, options);
        }
export type LocaleItemBrandHouseSettingsQueryHookResult = ReturnType<typeof useLocaleItemBrandHouseSettingsQuery>;
export type LocaleItemBrandHouseSettingsLazyQueryHookResult = ReturnType<typeof useLocaleItemBrandHouseSettingsLazyQuery>;
export type LocaleItemBrandHouseSettingsQueryResult = Apollo.QueryResult<LocaleItemBrandHouseSettingsQuery, LocaleItemBrandHouseSettingsQueryVariables>;
export const LocaleItemBrandHouseSettingsUpdateDocument = gql`
    mutation LocaleItemBrandHouseSettingsUpdate($brandHouseId: MongoID, $stockConfig: BrandSettingStockItemConfigInput, $auditNoteId: MongoID) {
  BrandSettingsUpdate(
    brandHouseId: $brandHouseId
    auditNoteId: $auditNoteId
    api: {stockItemConfig: $stockConfig}
  ) {
    _id
    stockItemConfig {
      ...SettingsStockItemFragment
    }
  }
}
    ${SettingsStockItemFragmentDoc}`;
export type LocaleItemBrandHouseSettingsUpdateMutationFn = Apollo.MutationFunction<LocaleItemBrandHouseSettingsUpdateMutation, LocaleItemBrandHouseSettingsUpdateMutationVariables>;

/**
 * __useLocaleItemBrandHouseSettingsUpdateMutation__
 *
 * To run a mutation, you first call `useLocaleItemBrandHouseSettingsUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLocaleItemBrandHouseSettingsUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [localeItemBrandHouseSettingsUpdateMutation, { data, loading, error }] = useLocaleItemBrandHouseSettingsUpdateMutation({
 *   variables: {
 *      brandHouseId: // value for 'brandHouseId'
 *      stockConfig: // value for 'stockConfig'
 *      auditNoteId: // value for 'auditNoteId'
 *   },
 * });
 */
export function useLocaleItemBrandHouseSettingsUpdateMutation(baseOptions?: Apollo.MutationHookOptions<LocaleItemBrandHouseSettingsUpdateMutation, LocaleItemBrandHouseSettingsUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LocaleItemBrandHouseSettingsUpdateMutation, LocaleItemBrandHouseSettingsUpdateMutationVariables>(LocaleItemBrandHouseSettingsUpdateDocument, options);
      }
export type LocaleItemBrandHouseSettingsUpdateMutationHookResult = ReturnType<typeof useLocaleItemBrandHouseSettingsUpdateMutation>;
export type LocaleItemBrandHouseSettingsUpdateMutationResult = Apollo.MutationResult<LocaleItemBrandHouseSettingsUpdateMutation>;
export type LocaleItemBrandHouseSettingsUpdateMutationOptions = Apollo.BaseMutationOptions<LocaleItemBrandHouseSettingsUpdateMutation, LocaleItemBrandHouseSettingsUpdateMutationVariables>;
export const SellingPriceSettingsShopDocument = gql`
    query SellingPriceSettingsShop($shopId: MongoID!) {
  ShopById(_id: $shopId) {
    _id
    conditions {
      condition
      name
      description
    }
    productTags
    productTypes
  }
}
    `;

/**
 * __useSellingPriceSettingsShopQuery__
 *
 * To run a query within a React component, call `useSellingPriceSettingsShopQuery` and pass it any options that fit your needs.
 * When your component renders, `useSellingPriceSettingsShopQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSellingPriceSettingsShopQuery({
 *   variables: {
 *      shopId: // value for 'shopId'
 *   },
 * });
 */
export function useSellingPriceSettingsShopQuery(baseOptions: Apollo.QueryHookOptions<SellingPriceSettingsShopQuery, SellingPriceSettingsShopQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SellingPriceSettingsShopQuery, SellingPriceSettingsShopQueryVariables>(SellingPriceSettingsShopDocument, options);
      }
export function useSellingPriceSettingsShopLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SellingPriceSettingsShopQuery, SellingPriceSettingsShopQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SellingPriceSettingsShopQuery, SellingPriceSettingsShopQueryVariables>(SellingPriceSettingsShopDocument, options);
        }
export type SellingPriceSettingsShopQueryHookResult = ReturnType<typeof useSellingPriceSettingsShopQuery>;
export type SellingPriceSettingsShopLazyQueryHookResult = ReturnType<typeof useSellingPriceSettingsShopLazyQuery>;
export type SellingPriceSettingsShopQueryResult = Apollo.QueryResult<SellingPriceSettingsShopQuery, SellingPriceSettingsShopQueryVariables>;
export const SellingPriceSettingsBrandDocument = gql`
    query SellingPriceSettingsBrand($brandId: MongoID!) {
  BrandHouse(id: $brandId) {
    _id
    conditions {
      condition
      name
      description
    }
  }
}
    `;

/**
 * __useSellingPriceSettingsBrandQuery__
 *
 * To run a query within a React component, call `useSellingPriceSettingsBrandQuery` and pass it any options that fit your needs.
 * When your component renders, `useSellingPriceSettingsBrandQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSellingPriceSettingsBrandQuery({
 *   variables: {
 *      brandId: // value for 'brandId'
 *   },
 * });
 */
export function useSellingPriceSettingsBrandQuery(baseOptions: Apollo.QueryHookOptions<SellingPriceSettingsBrandQuery, SellingPriceSettingsBrandQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SellingPriceSettingsBrandQuery, SellingPriceSettingsBrandQueryVariables>(SellingPriceSettingsBrandDocument, options);
      }
export function useSellingPriceSettingsBrandLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SellingPriceSettingsBrandQuery, SellingPriceSettingsBrandQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SellingPriceSettingsBrandQuery, SellingPriceSettingsBrandQueryVariables>(SellingPriceSettingsBrandDocument, options);
        }
export type SellingPriceSettingsBrandQueryHookResult = ReturnType<typeof useSellingPriceSettingsBrandQuery>;
export type SellingPriceSettingsBrandLazyQueryHookResult = ReturnType<typeof useSellingPriceSettingsBrandLazyQuery>;
export type SellingPriceSettingsBrandQueryResult = Apollo.QueryResult<SellingPriceSettingsBrandQuery, SellingPriceSettingsBrandQueryVariables>;
export const SellingPriceSettingsDocument = gql`
    query SellingPriceSettings($shopId: MongoID, $brandHouseId: MongoID) {
  BrandSettings(shopId: $shopId, brandHouseId: $brandHouseId) {
    ...SellingPriceSettingsFragment
  }
}
    ${SellingPriceSettingsFragmentDoc}`;

/**
 * __useSellingPriceSettingsQuery__
 *
 * To run a query within a React component, call `useSellingPriceSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSellingPriceSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSellingPriceSettingsQuery({
 *   variables: {
 *      shopId: // value for 'shopId'
 *      brandHouseId: // value for 'brandHouseId'
 *   },
 * });
 */
export function useSellingPriceSettingsQuery(baseOptions?: Apollo.QueryHookOptions<SellingPriceSettingsQuery, SellingPriceSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SellingPriceSettingsQuery, SellingPriceSettingsQueryVariables>(SellingPriceSettingsDocument, options);
      }
export function useSellingPriceSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SellingPriceSettingsQuery, SellingPriceSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SellingPriceSettingsQuery, SellingPriceSettingsQueryVariables>(SellingPriceSettingsDocument, options);
        }
export type SellingPriceSettingsQueryHookResult = ReturnType<typeof useSellingPriceSettingsQuery>;
export type SellingPriceSettingsLazyQueryHookResult = ReturnType<typeof useSellingPriceSettingsLazyQuery>;
export type SellingPriceSettingsQueryResult = Apollo.QueryResult<SellingPriceSettingsQuery, SellingPriceSettingsQueryVariables>;
export const SellingPriceSettingsUpdateDocument = gql`
    mutation SellingPriceSettingsUpdate($shopId: MongoID, $brandHouseId: MongoID, $sellPrice: [BrandSettingSellPriceInput!], $advanced: [BrandSettingSellPriceAdvancedInput!], $disableRRPListPrice: Boolean!, $auditNoteId: MongoID) {
  BrandSettingsUpdate(
    shopId: $shopId
    brandHouseId: $brandHouseId
    auditNoteId: $auditNoteId
    api: {sellPrice: $sellPrice, sellPriceAdvanced: $advanced, disableRRPListPrice: $disableRRPListPrice}
  ) {
    ...SellingPriceSettingsFragment
  }
}
    ${SellingPriceSettingsFragmentDoc}`;
export type SellingPriceSettingsUpdateMutationFn = Apollo.MutationFunction<SellingPriceSettingsUpdateMutation, SellingPriceSettingsUpdateMutationVariables>;

/**
 * __useSellingPriceSettingsUpdateMutation__
 *
 * To run a mutation, you first call `useSellingPriceSettingsUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSellingPriceSettingsUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sellingPriceSettingsUpdateMutation, { data, loading, error }] = useSellingPriceSettingsUpdateMutation({
 *   variables: {
 *      shopId: // value for 'shopId'
 *      brandHouseId: // value for 'brandHouseId'
 *      sellPrice: // value for 'sellPrice'
 *      advanced: // value for 'advanced'
 *      disableRRPListPrice: // value for 'disableRRPListPrice'
 *      auditNoteId: // value for 'auditNoteId'
 *   },
 * });
 */
export function useSellingPriceSettingsUpdateMutation(baseOptions?: Apollo.MutationHookOptions<SellingPriceSettingsUpdateMutation, SellingPriceSettingsUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SellingPriceSettingsUpdateMutation, SellingPriceSettingsUpdateMutationVariables>(SellingPriceSettingsUpdateDocument, options);
      }
export type SellingPriceSettingsUpdateMutationHookResult = ReturnType<typeof useSellingPriceSettingsUpdateMutation>;
export type SellingPriceSettingsUpdateMutationResult = Apollo.MutationResult<SellingPriceSettingsUpdateMutation>;
export type SellingPriceSettingsUpdateMutationOptions = Apollo.BaseMutationOptions<SellingPriceSettingsUpdateMutation, SellingPriceSettingsUpdateMutationVariables>;
export const LanguageSettingsDocument = gql`
    query LanguageSettings($shopId: MongoID, $brandHouseId: MongoID) {
  BrandSettings(shopId: $shopId, brandHouseId: $brandHouseId) {
    ...LanguagesFragment
  }
}
    ${LanguagesFragmentDoc}`;

/**
 * __useLanguageSettingsQuery__
 *
 * To run a query within a React component, call `useLanguageSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLanguageSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLanguageSettingsQuery({
 *   variables: {
 *      shopId: // value for 'shopId'
 *      brandHouseId: // value for 'brandHouseId'
 *   },
 * });
 */
export function useLanguageSettingsQuery(baseOptions?: Apollo.QueryHookOptions<LanguageSettingsQuery, LanguageSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LanguageSettingsQuery, LanguageSettingsQueryVariables>(LanguageSettingsDocument, options);
      }
export function useLanguageSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LanguageSettingsQuery, LanguageSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LanguageSettingsQuery, LanguageSettingsQueryVariables>(LanguageSettingsDocument, options);
        }
export type LanguageSettingsQueryHookResult = ReturnType<typeof useLanguageSettingsQuery>;
export type LanguageSettingsLazyQueryHookResult = ReturnType<typeof useLanguageSettingsLazyQuery>;
export type LanguageSettingsQueryResult = Apollo.QueryResult<LanguageSettingsQuery, LanguageSettingsQueryVariables>;
export const LanguageSettingsUpdateDocument = gql`
    mutation LanguageSettingsUpdate($shopId: MongoID, $brandHouseId: MongoID, $masterDataLocale: String!, $fallbackLocale: String, $locales: [BrandLocaleInput!], $auditNoteId: MongoID) {
  BrandSettingsUpdate(
    shopId: $shopId
    brandHouseId: $brandHouseId
    auditNoteId: $auditNoteId
    api: {locales: $locales, masterDataLocale: $masterDataLocale, fallbackLocale: $fallbackLocale}
  ) {
    ...LanguagesFragment
  }
}
    ${LanguagesFragmentDoc}`;
export type LanguageSettingsUpdateMutationFn = Apollo.MutationFunction<LanguageSettingsUpdateMutation, LanguageSettingsUpdateMutationVariables>;

/**
 * __useLanguageSettingsUpdateMutation__
 *
 * To run a mutation, you first call `useLanguageSettingsUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLanguageSettingsUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [languageSettingsUpdateMutation, { data, loading, error }] = useLanguageSettingsUpdateMutation({
 *   variables: {
 *      shopId: // value for 'shopId'
 *      brandHouseId: // value for 'brandHouseId'
 *      masterDataLocale: // value for 'masterDataLocale'
 *      fallbackLocale: // value for 'fallbackLocale'
 *      locales: // value for 'locales'
 *      auditNoteId: // value for 'auditNoteId'
 *   },
 * });
 */
export function useLanguageSettingsUpdateMutation(baseOptions?: Apollo.MutationHookOptions<LanguageSettingsUpdateMutation, LanguageSettingsUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LanguageSettingsUpdateMutation, LanguageSettingsUpdateMutationVariables>(LanguageSettingsUpdateDocument, options);
      }
export type LanguageSettingsUpdateMutationHookResult = ReturnType<typeof useLanguageSettingsUpdateMutation>;
export type LanguageSettingsUpdateMutationResult = Apollo.MutationResult<LanguageSettingsUpdateMutation>;
export type LanguageSettingsUpdateMutationOptions = Apollo.BaseMutationOptions<LanguageSettingsUpdateMutation, LanguageSettingsUpdateMutationVariables>;
export const KlaviyoInstancesDocument = gql`
    query klaviyoInstances($refId: MongoID!) {
  IntegrationInstances(
    filter: {refId: $refId, connectorId: "67194eae1d87c9c014060303"}
  ) {
    ...klaviyo
  }
}
    ${KlaviyoFragmentDoc}`;

/**
 * __useKlaviyoInstancesQuery__
 *
 * To run a query within a React component, call `useKlaviyoInstancesQuery` and pass it any options that fit your needs.
 * When your component renders, `useKlaviyoInstancesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useKlaviyoInstancesQuery({
 *   variables: {
 *      refId: // value for 'refId'
 *   },
 * });
 */
export function useKlaviyoInstancesQuery(baseOptions: Apollo.QueryHookOptions<KlaviyoInstancesQuery, KlaviyoInstancesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<KlaviyoInstancesQuery, KlaviyoInstancesQueryVariables>(KlaviyoInstancesDocument, options);
      }
export function useKlaviyoInstancesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<KlaviyoInstancesQuery, KlaviyoInstancesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<KlaviyoInstancesQuery, KlaviyoInstancesQueryVariables>(KlaviyoInstancesDocument, options);
        }
export type KlaviyoInstancesQueryHookResult = ReturnType<typeof useKlaviyoInstancesQuery>;
export type KlaviyoInstancesLazyQueryHookResult = ReturnType<typeof useKlaviyoInstancesLazyQuery>;
export type KlaviyoInstancesQueryResult = Apollo.QueryResult<KlaviyoInstancesQuery, KlaviyoInstancesQueryVariables>;
export const KlaviyoInstallDocument = gql`
    mutation klaviyoInstall($refId: MongoID!, $refType: EnumIntegrationConnectorRefType!) {
  IntegrationInstall(
    connectorId: "67194eae1d87c9c014060303"
    mode: production
    refId: $refId
    refType: $refType
  ) {
    ...klaviyo
  }
}
    ${KlaviyoFragmentDoc}`;
export type KlaviyoInstallMutationFn = Apollo.MutationFunction<KlaviyoInstallMutation, KlaviyoInstallMutationVariables>;

/**
 * __useKlaviyoInstallMutation__
 *
 * To run a mutation, you first call `useKlaviyoInstallMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useKlaviyoInstallMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [klaviyoInstallMutation, { data, loading, error }] = useKlaviyoInstallMutation({
 *   variables: {
 *      refId: // value for 'refId'
 *      refType: // value for 'refType'
 *   },
 * });
 */
export function useKlaviyoInstallMutation(baseOptions?: Apollo.MutationHookOptions<KlaviyoInstallMutation, KlaviyoInstallMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<KlaviyoInstallMutation, KlaviyoInstallMutationVariables>(KlaviyoInstallDocument, options);
      }
export type KlaviyoInstallMutationHookResult = ReturnType<typeof useKlaviyoInstallMutation>;
export type KlaviyoInstallMutationResult = Apollo.MutationResult<KlaviyoInstallMutation>;
export type KlaviyoInstallMutationOptions = Apollo.BaseMutationOptions<KlaviyoInstallMutation, KlaviyoInstallMutationVariables>;
export const BrickMailGetDocument = gql`
    query BrickMailGet($shopId: MongoID!, $type: String!) {
  BrickMail(shopId: $shopId, mailType: $type) {
    _id
    type
    mails {
      ...BrickMailFragment
    }
  }
  BrickMailTypeByID(shopId: $shopId, mailType: $type) {
    title
    description
  }
  ShopById(_id: $shopId) {
    tradeInLocales
  }
}
    ${BrickMailFragmentDoc}`;

/**
 * __useBrickMailGetQuery__
 *
 * To run a query within a React component, call `useBrickMailGetQuery` and pass it any options that fit your needs.
 * When your component renders, `useBrickMailGetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBrickMailGetQuery({
 *   variables: {
 *      shopId: // value for 'shopId'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useBrickMailGetQuery(baseOptions: Apollo.QueryHookOptions<BrickMailGetQuery, BrickMailGetQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BrickMailGetQuery, BrickMailGetQueryVariables>(BrickMailGetDocument, options);
      }
export function useBrickMailGetLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BrickMailGetQuery, BrickMailGetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BrickMailGetQuery, BrickMailGetQueryVariables>(BrickMailGetDocument, options);
        }
export type BrickMailGetQueryHookResult = ReturnType<typeof useBrickMailGetQuery>;
export type BrickMailGetLazyQueryHookResult = ReturnType<typeof useBrickMailGetLazyQuery>;
export type BrickMailGetQueryResult = Apollo.QueryResult<BrickMailGetQuery, BrickMailGetQueryVariables>;
export const BrickMailUpdateDocument = gql`
    mutation BrickMailUpdate($shopId: MongoID!, $type: String!, $input: [BrickMailMailsInput!], $auditNoteId: MongoID) {
  BrickMailUpdate(
    shopId: $shopId
    mailType: $type
    input: $input
    auditNoteId: $auditNoteId
  ) {
    locale
    message
    result
  }
}
    `;
export type BrickMailUpdateMutationFn = Apollo.MutationFunction<BrickMailUpdateMutation, BrickMailUpdateMutationVariables>;

/**
 * __useBrickMailUpdateMutation__
 *
 * To run a mutation, you first call `useBrickMailUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBrickMailUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [brickMailUpdateMutation, { data, loading, error }] = useBrickMailUpdateMutation({
 *   variables: {
 *      shopId: // value for 'shopId'
 *      type: // value for 'type'
 *      input: // value for 'input'
 *      auditNoteId: // value for 'auditNoteId'
 *   },
 * });
 */
export function useBrickMailUpdateMutation(baseOptions?: Apollo.MutationHookOptions<BrickMailUpdateMutation, BrickMailUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BrickMailUpdateMutation, BrickMailUpdateMutationVariables>(BrickMailUpdateDocument, options);
      }
export type BrickMailUpdateMutationHookResult = ReturnType<typeof useBrickMailUpdateMutation>;
export type BrickMailUpdateMutationResult = Apollo.MutationResult<BrickMailUpdateMutation>;
export type BrickMailUpdateMutationOptions = Apollo.BaseMutationOptions<BrickMailUpdateMutation, BrickMailUpdateMutationVariables>;
export const BrickMailTestDocument = gql`
    mutation BrickMailTest($shopId: String!, $type: String!, $email: String!, $language: String!, $activations: Boolean!, $testMail: String) {
  BrickMailTest(
    shopId: $shopId
    mailType: $type
    email: $email
    language: $language
    activations: $activations
    consumerEmail: $testMail
  )
}
    `;
export type BrickMailTestMutationFn = Apollo.MutationFunction<BrickMailTestMutation, BrickMailTestMutationVariables>;

/**
 * __useBrickMailTestMutation__
 *
 * To run a mutation, you first call `useBrickMailTestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBrickMailTestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [brickMailTestMutation, { data, loading, error }] = useBrickMailTestMutation({
 *   variables: {
 *      shopId: // value for 'shopId'
 *      type: // value for 'type'
 *      email: // value for 'email'
 *      language: // value for 'language'
 *      activations: // value for 'activations'
 *      testMail: // value for 'testMail'
 *   },
 * });
 */
export function useBrickMailTestMutation(baseOptions?: Apollo.MutationHookOptions<BrickMailTestMutation, BrickMailTestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BrickMailTestMutation, BrickMailTestMutationVariables>(BrickMailTestDocument, options);
      }
export type BrickMailTestMutationHookResult = ReturnType<typeof useBrickMailTestMutation>;
export type BrickMailTestMutationResult = Apollo.MutationResult<BrickMailTestMutation>;
export type BrickMailTestMutationOptions = Apollo.BaseMutationOptions<BrickMailTestMutation, BrickMailTestMutationVariables>;
export const BrickMailGetTypesDocument = gql`
    query BrickMailGetTypes($shopId: String!) {
  BrickMailTypes(shopId: $shopId) {
    type
    title
    description
    active
  }
}
    `;

/**
 * __useBrickMailGetTypesQuery__
 *
 * To run a query within a React component, call `useBrickMailGetTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useBrickMailGetTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBrickMailGetTypesQuery({
 *   variables: {
 *      shopId: // value for 'shopId'
 *   },
 * });
 */
export function useBrickMailGetTypesQuery(baseOptions: Apollo.QueryHookOptions<BrickMailGetTypesQuery, BrickMailGetTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BrickMailGetTypesQuery, BrickMailGetTypesQueryVariables>(BrickMailGetTypesDocument, options);
      }
export function useBrickMailGetTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BrickMailGetTypesQuery, BrickMailGetTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BrickMailGetTypesQuery, BrickMailGetTypesQueryVariables>(BrickMailGetTypesDocument, options);
        }
export type BrickMailGetTypesQueryHookResult = ReturnType<typeof useBrickMailGetTypesQuery>;
export type BrickMailGetTypesLazyQueryHookResult = ReturnType<typeof useBrickMailGetTypesLazyQuery>;
export type BrickMailGetTypesQueryResult = Apollo.QueryResult<BrickMailGetTypesQuery, BrickMailGetTypesQueryVariables>;
export const BrickMailActivateDocument = gql`
    mutation BrickMailActivate($shopId: String!, $mailType: String!, $active: Boolean!, $auditNoteId: MongoID) {
  BrickMailActivate(
    shopId: $shopId
    mailType: $mailType
    active: $active
    auditNoteId: $auditNoteId
  ) {
    _id
    active
  }
}
    `;
export type BrickMailActivateMutationFn = Apollo.MutationFunction<BrickMailActivateMutation, BrickMailActivateMutationVariables>;

/**
 * __useBrickMailActivateMutation__
 *
 * To run a mutation, you first call `useBrickMailActivateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBrickMailActivateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [brickMailActivateMutation, { data, loading, error }] = useBrickMailActivateMutation({
 *   variables: {
 *      shopId: // value for 'shopId'
 *      mailType: // value for 'mailType'
 *      active: // value for 'active'
 *      auditNoteId: // value for 'auditNoteId'
 *   },
 * });
 */
export function useBrickMailActivateMutation(baseOptions?: Apollo.MutationHookOptions<BrickMailActivateMutation, BrickMailActivateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BrickMailActivateMutation, BrickMailActivateMutationVariables>(BrickMailActivateDocument, options);
      }
export type BrickMailActivateMutationHookResult = ReturnType<typeof useBrickMailActivateMutation>;
export type BrickMailActivateMutationResult = Apollo.MutationResult<BrickMailActivateMutation>;
export type BrickMailActivateMutationOptions = Apollo.BaseMutationOptions<BrickMailActivateMutation, BrickMailActivateMutationVariables>;
export const ReminderMailSettingsDocument = gql`
    query ReminderMailSettings($shopId: MongoID!) {
  BrandSettings(shopId: $shopId) {
    _id
    plannedMailsTradeIn {
      repeatCount
      repeatDelay
      startAfter
    }
    plannedMailsVoucher {
      repeatCount
      repeatDelay
      startAfter
    }
  }
}
    `;

/**
 * __useReminderMailSettingsQuery__
 *
 * To run a query within a React component, call `useReminderMailSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useReminderMailSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReminderMailSettingsQuery({
 *   variables: {
 *      shopId: // value for 'shopId'
 *   },
 * });
 */
export function useReminderMailSettingsQuery(baseOptions: Apollo.QueryHookOptions<ReminderMailSettingsQuery, ReminderMailSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReminderMailSettingsQuery, ReminderMailSettingsQueryVariables>(ReminderMailSettingsDocument, options);
      }
export function useReminderMailSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReminderMailSettingsQuery, ReminderMailSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReminderMailSettingsQuery, ReminderMailSettingsQueryVariables>(ReminderMailSettingsDocument, options);
        }
export type ReminderMailSettingsQueryHookResult = ReturnType<typeof useReminderMailSettingsQuery>;
export type ReminderMailSettingsLazyQueryHookResult = ReturnType<typeof useReminderMailSettingsLazyQuery>;
export type ReminderMailSettingsQueryResult = Apollo.QueryResult<ReminderMailSettingsQuery, ReminderMailSettingsQueryVariables>;
export const ReminderMailVoucherUpdateDocument = gql`
    mutation ReminderMailVoucherUpdate($shopId: MongoID!, $voucher: BrandSettingPlannedMailsVoucherInput!, $auditNoteId: MongoID) {
  BrandSettingsUpdate(
    shopId: $shopId
    auditNoteId: $auditNoteId
    api: {plannedMailsVoucher: $voucher}
  ) {
    _id
    plannedMailsVoucher {
      repeatCount
      repeatDelay
      startAfter
    }
  }
}
    `;
export type ReminderMailVoucherUpdateMutationFn = Apollo.MutationFunction<ReminderMailVoucherUpdateMutation, ReminderMailVoucherUpdateMutationVariables>;

/**
 * __useReminderMailVoucherUpdateMutation__
 *
 * To run a mutation, you first call `useReminderMailVoucherUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReminderMailVoucherUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reminderMailVoucherUpdateMutation, { data, loading, error }] = useReminderMailVoucherUpdateMutation({
 *   variables: {
 *      shopId: // value for 'shopId'
 *      voucher: // value for 'voucher'
 *      auditNoteId: // value for 'auditNoteId'
 *   },
 * });
 */
export function useReminderMailVoucherUpdateMutation(baseOptions?: Apollo.MutationHookOptions<ReminderMailVoucherUpdateMutation, ReminderMailVoucherUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReminderMailVoucherUpdateMutation, ReminderMailVoucherUpdateMutationVariables>(ReminderMailVoucherUpdateDocument, options);
      }
export type ReminderMailVoucherUpdateMutationHookResult = ReturnType<typeof useReminderMailVoucherUpdateMutation>;
export type ReminderMailVoucherUpdateMutationResult = Apollo.MutationResult<ReminderMailVoucherUpdateMutation>;
export type ReminderMailVoucherUpdateMutationOptions = Apollo.BaseMutationOptions<ReminderMailVoucherUpdateMutation, ReminderMailVoucherUpdateMutationVariables>;
export const ReminderMailTradeInUpdateDocument = gql`
    mutation ReminderMailTradeInUpdate($shopId: MongoID!, $voucher: BrandSettingPlannedMailsTradeInInput!, $auditNoteId: MongoID) {
  BrandSettingsUpdate(
    shopId: $shopId
    auditNoteId: $auditNoteId
    api: {plannedMailsTradeIn: $voucher}
  ) {
    _id
    plannedMailsTradeIn {
      repeatCount
      repeatDelay
      startAfter
    }
  }
}
    `;
export type ReminderMailTradeInUpdateMutationFn = Apollo.MutationFunction<ReminderMailTradeInUpdateMutation, ReminderMailTradeInUpdateMutationVariables>;

/**
 * __useReminderMailTradeInUpdateMutation__
 *
 * To run a mutation, you first call `useReminderMailTradeInUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReminderMailTradeInUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reminderMailTradeInUpdateMutation, { data, loading, error }] = useReminderMailTradeInUpdateMutation({
 *   variables: {
 *      shopId: // value for 'shopId'
 *      voucher: // value for 'voucher'
 *      auditNoteId: // value for 'auditNoteId'
 *   },
 * });
 */
export function useReminderMailTradeInUpdateMutation(baseOptions?: Apollo.MutationHookOptions<ReminderMailTradeInUpdateMutation, ReminderMailTradeInUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReminderMailTradeInUpdateMutation, ReminderMailTradeInUpdateMutationVariables>(ReminderMailTradeInUpdateDocument, options);
      }
export type ReminderMailTradeInUpdateMutationHookResult = ReturnType<typeof useReminderMailTradeInUpdateMutation>;
export type ReminderMailTradeInUpdateMutationResult = Apollo.MutationResult<ReminderMailTradeInUpdateMutation>;
export type ReminderMailTradeInUpdateMutationOptions = Apollo.BaseMutationOptions<ReminderMailTradeInUpdateMutation, ReminderMailTradeInUpdateMutationVariables>;
export const ExportMailsDocument = gql`
    query ExportMails($shopId: MongoID!) {
  BrickMails(shopId: $shopId) {
    ...MailFragment
  }
}
    ${MailFragmentDoc}`;

/**
 * __useExportMailsQuery__
 *
 * To run a query within a React component, call `useExportMailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useExportMailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExportMailsQuery({
 *   variables: {
 *      shopId: // value for 'shopId'
 *   },
 * });
 */
export function useExportMailsQuery(baseOptions: Apollo.QueryHookOptions<ExportMailsQuery, ExportMailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExportMailsQuery, ExportMailsQueryVariables>(ExportMailsDocument, options);
      }
export function useExportMailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExportMailsQuery, ExportMailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExportMailsQuery, ExportMailsQueryVariables>(ExportMailsDocument, options);
        }
export type ExportMailsQueryHookResult = ReturnType<typeof useExportMailsQuery>;
export type ExportMailsLazyQueryHookResult = ReturnType<typeof useExportMailsLazyQuery>;
export type ExportMailsQueryResult = Apollo.QueryResult<ExportMailsQuery, ExportMailsQueryVariables>;
export const OrderSettingsDocument = gql`
    query OrderSettings($shopId: MongoID, $brandHouseId: MongoID) {
  BrandSettings(shopId: $shopId, brandHouseId: $brandHouseId) {
    _id
    order {
      ...OrderSettingsFragment
    }
    stockItemConfig {
      currencies {
        currency
        active
      }
    }
  }
}
    ${OrderSettingsFragmentDoc}`;

/**
 * __useOrderSettingsQuery__
 *
 * To run a query within a React component, call `useOrderSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrderSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrderSettingsQuery({
 *   variables: {
 *      shopId: // value for 'shopId'
 *      brandHouseId: // value for 'brandHouseId'
 *   },
 * });
 */
export function useOrderSettingsQuery(baseOptions?: Apollo.QueryHookOptions<OrderSettingsQuery, OrderSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrderSettingsQuery, OrderSettingsQueryVariables>(OrderSettingsDocument, options);
      }
export function useOrderSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrderSettingsQuery, OrderSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrderSettingsQuery, OrderSettingsQueryVariables>(OrderSettingsDocument, options);
        }
export type OrderSettingsQueryHookResult = ReturnType<typeof useOrderSettingsQuery>;
export type OrderSettingsLazyQueryHookResult = ReturnType<typeof useOrderSettingsLazyQuery>;
export type OrderSettingsQueryResult = Apollo.QueryResult<OrderSettingsQuery, OrderSettingsQueryVariables>;
export const OrderSettingsUpdateDocument = gql`
    mutation OrderSettingsUpdate($shopId: MongoID, $brandHouseId: MongoID, $input: BrandSettingOrderInput!, $auditNoteId: MongoID) {
  BrandSettingsUpdate(
    shopId: $shopId
    brandHouseId: $brandHouseId
    auditNoteId: $auditNoteId
    api: {order: $input}
  ) {
    _id
    order {
      ...OrderSettingsFragment
    }
  }
}
    ${OrderSettingsFragmentDoc}`;
export type OrderSettingsUpdateMutationFn = Apollo.MutationFunction<OrderSettingsUpdateMutation, OrderSettingsUpdateMutationVariables>;

/**
 * __useOrderSettingsUpdateMutation__
 *
 * To run a mutation, you first call `useOrderSettingsUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOrderSettingsUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [orderSettingsUpdateMutation, { data, loading, error }] = useOrderSettingsUpdateMutation({
 *   variables: {
 *      shopId: // value for 'shopId'
 *      brandHouseId: // value for 'brandHouseId'
 *      input: // value for 'input'
 *      auditNoteId: // value for 'auditNoteId'
 *   },
 * });
 */
export function useOrderSettingsUpdateMutation(baseOptions?: Apollo.MutationHookOptions<OrderSettingsUpdateMutation, OrderSettingsUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OrderSettingsUpdateMutation, OrderSettingsUpdateMutationVariables>(OrderSettingsUpdateDocument, options);
      }
export type OrderSettingsUpdateMutationHookResult = ReturnType<typeof useOrderSettingsUpdateMutation>;
export type OrderSettingsUpdateMutationResult = Apollo.MutationResult<OrderSettingsUpdateMutation>;
export type OrderSettingsUpdateMutationOptions = Apollo.BaseMutationOptions<OrderSettingsUpdateMutation, OrderSettingsUpdateMutationVariables>;
export const CircularPageDocument = gql`
    query CircularPage($shopId: MongoID, $brandHouseId: MongoID) {
  BrandSettings(shopId: $shopId, brandHouseId: $brandHouseId) {
    ...CircularFragment
  }
  CircularPayoutMany {
    _id
    name
    payoutType
    defaultRatio
  }
}
    ${CircularFragmentDoc}`;

/**
 * __useCircularPageQuery__
 *
 * To run a query within a React component, call `useCircularPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useCircularPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCircularPageQuery({
 *   variables: {
 *      shopId: // value for 'shopId'
 *      brandHouseId: // value for 'brandHouseId'
 *   },
 * });
 */
export function useCircularPageQuery(baseOptions?: Apollo.QueryHookOptions<CircularPageQuery, CircularPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CircularPageQuery, CircularPageQueryVariables>(CircularPageDocument, options);
      }
export function useCircularPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CircularPageQuery, CircularPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CircularPageQuery, CircularPageQueryVariables>(CircularPageDocument, options);
        }
export type CircularPageQueryHookResult = ReturnType<typeof useCircularPageQuery>;
export type CircularPageLazyQueryHookResult = ReturnType<typeof useCircularPageLazyQuery>;
export type CircularPageQueryResult = Apollo.QueryResult<CircularPageQuery, CircularPageQueryVariables>;
export const CircularPageUpdateDocument = gql`
    mutation CircularPageUpdate($shopId: MongoID, $brandHouseId: MongoID, $input: CircularSettingsInput, $auditNoteId: MongoID) {
  BrandSettingsUpdate(
    shopId: $shopId
    brandHouseId: $brandHouseId
    auditNoteId: $auditNoteId
    api: {circular: $input}
  ) {
    ...CircularFragment
  }
}
    ${CircularFragmentDoc}`;
export type CircularPageUpdateMutationFn = Apollo.MutationFunction<CircularPageUpdateMutation, CircularPageUpdateMutationVariables>;

/**
 * __useCircularPageUpdateMutation__
 *
 * To run a mutation, you first call `useCircularPageUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCircularPageUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [circularPageUpdateMutation, { data, loading, error }] = useCircularPageUpdateMutation({
 *   variables: {
 *      shopId: // value for 'shopId'
 *      brandHouseId: // value for 'brandHouseId'
 *      input: // value for 'input'
 *      auditNoteId: // value for 'auditNoteId'
 *   },
 * });
 */
export function useCircularPageUpdateMutation(baseOptions?: Apollo.MutationHookOptions<CircularPageUpdateMutation, CircularPageUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CircularPageUpdateMutation, CircularPageUpdateMutationVariables>(CircularPageUpdateDocument, options);
      }
export type CircularPageUpdateMutationHookResult = ReturnType<typeof useCircularPageUpdateMutation>;
export type CircularPageUpdateMutationResult = Apollo.MutationResult<CircularPageUpdateMutation>;
export type CircularPageUpdateMutationOptions = Apollo.BaseMutationOptions<CircularPageUpdateMutation, CircularPageUpdateMutationVariables>;
export const VouchersPageDocument = gql`
    query VouchersPage($shopId: MongoID, $brandHouseId: MongoID) {
  BrandSettings(shopId: $shopId, brandHouseId: $brandHouseId) {
    ...VoucherSettingsFragment
  }
}
    ${VoucherSettingsFragmentDoc}`;

/**
 * __useVouchersPageQuery__
 *
 * To run a query within a React component, call `useVouchersPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useVouchersPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVouchersPageQuery({
 *   variables: {
 *      shopId: // value for 'shopId'
 *      brandHouseId: // value for 'brandHouseId'
 *   },
 * });
 */
export function useVouchersPageQuery(baseOptions?: Apollo.QueryHookOptions<VouchersPageQuery, VouchersPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<VouchersPageQuery, VouchersPageQueryVariables>(VouchersPageDocument, options);
      }
export function useVouchersPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VouchersPageQuery, VouchersPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<VouchersPageQuery, VouchersPageQueryVariables>(VouchersPageDocument, options);
        }
export type VouchersPageQueryHookResult = ReturnType<typeof useVouchersPageQuery>;
export type VouchersPageLazyQueryHookResult = ReturnType<typeof useVouchersPageLazyQuery>;
export type VouchersPageQueryResult = Apollo.QueryResult<VouchersPageQuery, VouchersPageQueryVariables>;
export const VouchersPageUpdateDocument = gql`
    mutation VouchersPageUpdate($shopId: MongoID, $brandHouseId: MongoID, $input: BrandSettingVoucherInput, $auditNoteId: MongoID) {
  BrandSettingsUpdate(
    shopId: $shopId
    brandHouseId: $brandHouseId
    auditNoteId: $auditNoteId
    api: {voucher: $input}
  ) {
    ...VoucherSettingsFragment
  }
}
    ${VoucherSettingsFragmentDoc}`;
export type VouchersPageUpdateMutationFn = Apollo.MutationFunction<VouchersPageUpdateMutation, VouchersPageUpdateMutationVariables>;

/**
 * __useVouchersPageUpdateMutation__
 *
 * To run a mutation, you first call `useVouchersPageUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVouchersPageUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [vouchersPageUpdateMutation, { data, loading, error }] = useVouchersPageUpdateMutation({
 *   variables: {
 *      shopId: // value for 'shopId'
 *      brandHouseId: // value for 'brandHouseId'
 *      input: // value for 'input'
 *      auditNoteId: // value for 'auditNoteId'
 *   },
 * });
 */
export function useVouchersPageUpdateMutation(baseOptions?: Apollo.MutationHookOptions<VouchersPageUpdateMutation, VouchersPageUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VouchersPageUpdateMutation, VouchersPageUpdateMutationVariables>(VouchersPageUpdateDocument, options);
      }
export type VouchersPageUpdateMutationHookResult = ReturnType<typeof useVouchersPageUpdateMutation>;
export type VouchersPageUpdateMutationResult = Apollo.MutationResult<VouchersPageUpdateMutation>;
export type VouchersPageUpdateMutationOptions = Apollo.BaseMutationOptions<VouchersPageUpdateMutation, VouchersPageUpdateMutationVariables>;
export const AnalyticsGetDocument = gql`
    query AnalyticsGet($shopId: MongoID, $brandHouseId: MongoID) {
  BrandSettings(shopId: $shopId, brandHouseId: $brandHouseId) {
    ...AnalyticsFragment
  }
}
    ${AnalyticsFragmentDoc}`;

/**
 * __useAnalyticsGetQuery__
 *
 * To run a query within a React component, call `useAnalyticsGetQuery` and pass it any options that fit your needs.
 * When your component renders, `useAnalyticsGetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAnalyticsGetQuery({
 *   variables: {
 *      shopId: // value for 'shopId'
 *      brandHouseId: // value for 'brandHouseId'
 *   },
 * });
 */
export function useAnalyticsGetQuery(baseOptions?: Apollo.QueryHookOptions<AnalyticsGetQuery, AnalyticsGetQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AnalyticsGetQuery, AnalyticsGetQueryVariables>(AnalyticsGetDocument, options);
      }
export function useAnalyticsGetLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AnalyticsGetQuery, AnalyticsGetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AnalyticsGetQuery, AnalyticsGetQueryVariables>(AnalyticsGetDocument, options);
        }
export type AnalyticsGetQueryHookResult = ReturnType<typeof useAnalyticsGetQuery>;
export type AnalyticsGetLazyQueryHookResult = ReturnType<typeof useAnalyticsGetLazyQuery>;
export type AnalyticsGetQueryResult = Apollo.QueryResult<AnalyticsGetQuery, AnalyticsGetQueryVariables>;
export const AnalyticsUpdateDocument = gql`
    mutation AnalyticsUpdate($shopId: MongoID, $brandHouseId: MongoID, $input: BrandSettingTradeIn2AnalyticsInput!, $auditNoteId: MongoID) {
  BrandSettingsUpdate(
    shopId: $shopId
    brandHouseId: $brandHouseId
    auditNoteId: $auditNoteId
    api: {tradeIn2Analytics: $input}
  ) {
    ...AnalyticsFragment
  }
}
    ${AnalyticsFragmentDoc}`;
export type AnalyticsUpdateMutationFn = Apollo.MutationFunction<AnalyticsUpdateMutation, AnalyticsUpdateMutationVariables>;

/**
 * __useAnalyticsUpdateMutation__
 *
 * To run a mutation, you first call `useAnalyticsUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAnalyticsUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [analyticsUpdateMutation, { data, loading, error }] = useAnalyticsUpdateMutation({
 *   variables: {
 *      shopId: // value for 'shopId'
 *      brandHouseId: // value for 'brandHouseId'
 *      input: // value for 'input'
 *      auditNoteId: // value for 'auditNoteId'
 *   },
 * });
 */
export function useAnalyticsUpdateMutation(baseOptions?: Apollo.MutationHookOptions<AnalyticsUpdateMutation, AnalyticsUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AnalyticsUpdateMutation, AnalyticsUpdateMutationVariables>(AnalyticsUpdateDocument, options);
      }
export type AnalyticsUpdateMutationHookResult = ReturnType<typeof useAnalyticsUpdateMutation>;
export type AnalyticsUpdateMutationResult = Apollo.MutationResult<AnalyticsUpdateMutation>;
export type AnalyticsUpdateMutationOptions = Apollo.BaseMutationOptions<AnalyticsUpdateMutation, AnalyticsUpdateMutationVariables>;
export const ShopAppLayoutDocument = gql`
    query ShopAppLayout($shopId: MongoID, $brandHouseId: MongoID) {
  BrandSettings(shopId: $shopId, brandHouseId: $brandHouseId) {
    _id
    tradeIn2 {
      ...TradeInLayout
    }
    defaultProductImage
  }
}
    ${TradeInLayoutFragmentDoc}`;

/**
 * __useShopAppLayoutQuery__
 *
 * To run a query within a React component, call `useShopAppLayoutQuery` and pass it any options that fit your needs.
 * When your component renders, `useShopAppLayoutQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShopAppLayoutQuery({
 *   variables: {
 *      shopId: // value for 'shopId'
 *      brandHouseId: // value for 'brandHouseId'
 *   },
 * });
 */
export function useShopAppLayoutQuery(baseOptions?: Apollo.QueryHookOptions<ShopAppLayoutQuery, ShopAppLayoutQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ShopAppLayoutQuery, ShopAppLayoutQueryVariables>(ShopAppLayoutDocument, options);
      }
export function useShopAppLayoutLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ShopAppLayoutQuery, ShopAppLayoutQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ShopAppLayoutQuery, ShopAppLayoutQueryVariables>(ShopAppLayoutDocument, options);
        }
export type ShopAppLayoutQueryHookResult = ReturnType<typeof useShopAppLayoutQuery>;
export type ShopAppLayoutLazyQueryHookResult = ReturnType<typeof useShopAppLayoutLazyQuery>;
export type ShopAppLayoutQueryResult = Apollo.QueryResult<ShopAppLayoutQuery, ShopAppLayoutQueryVariables>;
export const ShopAppLayoutUpdateDocument = gql`
    mutation ShopAppLayoutUpdate($shopId: MongoID, $brandHouseId: MongoID, $api: BrandSettingInput, $auditNoteId: MongoID) {
  BrandSettingsUpdate(
    shopId: $shopId
    brandHouseId: $brandHouseId
    auditNoteId: $auditNoteId
    api: $api
  ) {
    _id
  }
}
    `;
export type ShopAppLayoutUpdateMutationFn = Apollo.MutationFunction<ShopAppLayoutUpdateMutation, ShopAppLayoutUpdateMutationVariables>;

/**
 * __useShopAppLayoutUpdateMutation__
 *
 * To run a mutation, you first call `useShopAppLayoutUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useShopAppLayoutUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [shopAppLayoutUpdateMutation, { data, loading, error }] = useShopAppLayoutUpdateMutation({
 *   variables: {
 *      shopId: // value for 'shopId'
 *      brandHouseId: // value for 'brandHouseId'
 *      api: // value for 'api'
 *      auditNoteId: // value for 'auditNoteId'
 *   },
 * });
 */
export function useShopAppLayoutUpdateMutation(baseOptions?: Apollo.MutationHookOptions<ShopAppLayoutUpdateMutation, ShopAppLayoutUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ShopAppLayoutUpdateMutation, ShopAppLayoutUpdateMutationVariables>(ShopAppLayoutUpdateDocument, options);
      }
export type ShopAppLayoutUpdateMutationHookResult = ReturnType<typeof useShopAppLayoutUpdateMutation>;
export type ShopAppLayoutUpdateMutationResult = Apollo.MutationResult<ShopAppLayoutUpdateMutation>;
export type ShopAppLayoutUpdateMutationOptions = Apollo.BaseMutationOptions<ShopAppLayoutUpdateMutation, ShopAppLayoutUpdateMutationVariables>;
export const TradeInCountriesDocument = gql`
    query TradeInCountries($shopId: MongoID, $brandHouseId: MongoID) {
  BrandSettings(shopId: $shopId, brandHouseId: $brandHouseId) {
    ...TradeInCountriesFragment
  }
}
    ${TradeInCountriesFragmentDoc}`;

/**
 * __useTradeInCountriesQuery__
 *
 * To run a query within a React component, call `useTradeInCountriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useTradeInCountriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTradeInCountriesQuery({
 *   variables: {
 *      shopId: // value for 'shopId'
 *      brandHouseId: // value for 'brandHouseId'
 *   },
 * });
 */
export function useTradeInCountriesQuery(baseOptions?: Apollo.QueryHookOptions<TradeInCountriesQuery, TradeInCountriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TradeInCountriesQuery, TradeInCountriesQueryVariables>(TradeInCountriesDocument, options);
      }
export function useTradeInCountriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TradeInCountriesQuery, TradeInCountriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TradeInCountriesQuery, TradeInCountriesQueryVariables>(TradeInCountriesDocument, options);
        }
export type TradeInCountriesQueryHookResult = ReturnType<typeof useTradeInCountriesQuery>;
export type TradeInCountriesLazyQueryHookResult = ReturnType<typeof useTradeInCountriesLazyQuery>;
export type TradeInCountriesQueryResult = Apollo.QueryResult<TradeInCountriesQuery, TradeInCountriesQueryVariables>;
export const TradeInCountriesUpdateDocument = gql`
    mutation TradeInCountriesUpdate($shopId: MongoID, $brandHouseId: MongoID, $countries: BrandSettingCountriesInput!, $locales: [BrandLocaleInput!], $auditNoteId: MongoID) {
  BrandSettingsUpdate(
    shopId: $shopId
    brandHouseId: $brandHouseId
    auditNoteId: $auditNoteId
    api: {countries: $countries, locales: $locales}
  ) {
    ...TradeInCountriesFragment
  }
}
    ${TradeInCountriesFragmentDoc}`;
export type TradeInCountriesUpdateMutationFn = Apollo.MutationFunction<TradeInCountriesUpdateMutation, TradeInCountriesUpdateMutationVariables>;

/**
 * __useTradeInCountriesUpdateMutation__
 *
 * To run a mutation, you first call `useTradeInCountriesUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTradeInCountriesUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [tradeInCountriesUpdateMutation, { data, loading, error }] = useTradeInCountriesUpdateMutation({
 *   variables: {
 *      shopId: // value for 'shopId'
 *      brandHouseId: // value for 'brandHouseId'
 *      countries: // value for 'countries'
 *      locales: // value for 'locales'
 *      auditNoteId: // value for 'auditNoteId'
 *   },
 * });
 */
export function useTradeInCountriesUpdateMutation(baseOptions?: Apollo.MutationHookOptions<TradeInCountriesUpdateMutation, TradeInCountriesUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TradeInCountriesUpdateMutation, TradeInCountriesUpdateMutationVariables>(TradeInCountriesUpdateDocument, options);
      }
export type TradeInCountriesUpdateMutationHookResult = ReturnType<typeof useTradeInCountriesUpdateMutation>;
export type TradeInCountriesUpdateMutationResult = Apollo.MutationResult<TradeInCountriesUpdateMutation>;
export type TradeInCountriesUpdateMutationOptions = Apollo.BaseMutationOptions<TradeInCountriesUpdateMutation, TradeInCountriesUpdateMutationVariables>;
export const ShippingCarriersDocument = gql`
    query ShippingCarriers($brandHouseId: MongoID!) {
  ShippingCarriers(brandHouseId: $brandHouseId) {
    _id
    logo
    name
    description
  }
}
    `;

/**
 * __useShippingCarriersQuery__
 *
 * To run a query within a React component, call `useShippingCarriersQuery` and pass it any options that fit your needs.
 * When your component renders, `useShippingCarriersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShippingCarriersQuery({
 *   variables: {
 *      brandHouseId: // value for 'brandHouseId'
 *   },
 * });
 */
export function useShippingCarriersQuery(baseOptions: Apollo.QueryHookOptions<ShippingCarriersQuery, ShippingCarriersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ShippingCarriersQuery, ShippingCarriersQueryVariables>(ShippingCarriersDocument, options);
      }
export function useShippingCarriersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ShippingCarriersQuery, ShippingCarriersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ShippingCarriersQuery, ShippingCarriersQueryVariables>(ShippingCarriersDocument, options);
        }
export type ShippingCarriersQueryHookResult = ReturnType<typeof useShippingCarriersQuery>;
export type ShippingCarriersLazyQueryHookResult = ReturnType<typeof useShippingCarriersLazyQuery>;
export type ShippingCarriersQueryResult = Apollo.QueryResult<ShippingCarriersQuery, ShippingCarriersQueryVariables>;
export const ShippingCarrierDocument = gql`
    query ShippingCarrier($brandHouseId: MongoID!, $shippingCarrierId: MongoID!) {
  BrandCarrier(brandHouseId: $brandHouseId, shippingCarrierId: $shippingCarrierId) {
    _id
    active
  }
}
    `;

/**
 * __useShippingCarrierQuery__
 *
 * To run a query within a React component, call `useShippingCarrierQuery` and pass it any options that fit your needs.
 * When your component renders, `useShippingCarrierQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShippingCarrierQuery({
 *   variables: {
 *      brandHouseId: // value for 'brandHouseId'
 *      shippingCarrierId: // value for 'shippingCarrierId'
 *   },
 * });
 */
export function useShippingCarrierQuery(baseOptions: Apollo.QueryHookOptions<ShippingCarrierQuery, ShippingCarrierQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ShippingCarrierQuery, ShippingCarrierQueryVariables>(ShippingCarrierDocument, options);
      }
export function useShippingCarrierLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ShippingCarrierQuery, ShippingCarrierQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ShippingCarrierQuery, ShippingCarrierQueryVariables>(ShippingCarrierDocument, options);
        }
export type ShippingCarrierQueryHookResult = ReturnType<typeof useShippingCarrierQuery>;
export type ShippingCarrierLazyQueryHookResult = ReturnType<typeof useShippingCarrierLazyQuery>;
export type ShippingCarrierQueryResult = Apollo.QueryResult<ShippingCarrierQuery, ShippingCarrierQueryVariables>;
export const ShippingCarrierActivateDocument = gql`
    mutation ShippingCarrierActivate($brandHouseId: MongoID!, $shippingCarrierId: MongoID!, $active: Boolean!) {
  BrandCarrierActivate(
    brandHouseId: $brandHouseId
    shippingCarrierId: $shippingCarrierId
    active: $active
  ) {
    _id
    active
  }
}
    `;
export type ShippingCarrierActivateMutationFn = Apollo.MutationFunction<ShippingCarrierActivateMutation, ShippingCarrierActivateMutationVariables>;

/**
 * __useShippingCarrierActivateMutation__
 *
 * To run a mutation, you first call `useShippingCarrierActivateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useShippingCarrierActivateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [shippingCarrierActivateMutation, { data, loading, error }] = useShippingCarrierActivateMutation({
 *   variables: {
 *      brandHouseId: // value for 'brandHouseId'
 *      shippingCarrierId: // value for 'shippingCarrierId'
 *      active: // value for 'active'
 *   },
 * });
 */
export function useShippingCarrierActivateMutation(baseOptions?: Apollo.MutationHookOptions<ShippingCarrierActivateMutation, ShippingCarrierActivateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ShippingCarrierActivateMutation, ShippingCarrierActivateMutationVariables>(ShippingCarrierActivateDocument, options);
      }
export type ShippingCarrierActivateMutationHookResult = ReturnType<typeof useShippingCarrierActivateMutation>;
export type ShippingCarrierActivateMutationResult = Apollo.MutationResult<ShippingCarrierActivateMutation>;
export type ShippingCarrierActivateMutationOptions = Apollo.BaseMutationOptions<ShippingCarrierActivateMutation, ShippingCarrierActivateMutationVariables>;
export const BrandAppLocalizationsDocument = gql`
    query BrandAppLocalizations($id: MongoID!, $type: String!) {
  BrandLocalizations(brandHouseId: $id, type: $type) {
    language
    key
    value
    default
    inherited
  }
  BrandSettings(brandHouseId: $id) {
    locales {
      locale
      activeTradeIn
      activeItems
    }
  }
}
    `;

/**
 * __useBrandAppLocalizationsQuery__
 *
 * To run a query within a React component, call `useBrandAppLocalizationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBrandAppLocalizationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBrandAppLocalizationsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useBrandAppLocalizationsQuery(baseOptions: Apollo.QueryHookOptions<BrandAppLocalizationsQuery, BrandAppLocalizationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BrandAppLocalizationsQuery, BrandAppLocalizationsQueryVariables>(BrandAppLocalizationsDocument, options);
      }
export function useBrandAppLocalizationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BrandAppLocalizationsQuery, BrandAppLocalizationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BrandAppLocalizationsQuery, BrandAppLocalizationsQueryVariables>(BrandAppLocalizationsDocument, options);
        }
export type BrandAppLocalizationsQueryHookResult = ReturnType<typeof useBrandAppLocalizationsQuery>;
export type BrandAppLocalizationsLazyQueryHookResult = ReturnType<typeof useBrandAppLocalizationsLazyQuery>;
export type BrandAppLocalizationsQueryResult = Apollo.QueryResult<BrandAppLocalizationsQuery, BrandAppLocalizationsQueryVariables>;
export const ShopAppLocalizationsDocument = gql`
    query ShopAppLocalizations($id: MongoID!, $type: String!) {
  BrandLocalizations(shopId: $id, type: $type) {
    language
    key
    value
    default
    inherited
  }
  BrandSettings(shopId: $id) {
    locales {
      locale
      activeItems
      activeTradeIn
    }
  }
}
    `;

/**
 * __useShopAppLocalizationsQuery__
 *
 * To run a query within a React component, call `useShopAppLocalizationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useShopAppLocalizationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShopAppLocalizationsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useShopAppLocalizationsQuery(baseOptions: Apollo.QueryHookOptions<ShopAppLocalizationsQuery, ShopAppLocalizationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ShopAppLocalizationsQuery, ShopAppLocalizationsQueryVariables>(ShopAppLocalizationsDocument, options);
      }
export function useShopAppLocalizationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ShopAppLocalizationsQuery, ShopAppLocalizationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ShopAppLocalizationsQuery, ShopAppLocalizationsQueryVariables>(ShopAppLocalizationsDocument, options);
        }
export type ShopAppLocalizationsQueryHookResult = ReturnType<typeof useShopAppLocalizationsQuery>;
export type ShopAppLocalizationsLazyQueryHookResult = ReturnType<typeof useShopAppLocalizationsLazyQuery>;
export type ShopAppLocalizationsQueryResult = Apollo.QueryResult<ShopAppLocalizationsQuery, ShopAppLocalizationsQueryVariables>;
export const ShopAppLocalizationsUpdateDocument = gql`
    mutation ShopAppLocalizationsUpdate($id: MongoID!, $type: String!, $input: [LocalizationInput], $auditNoteId: MongoID) {
  BrandLocalizationsUpdate(
    shopId: $id
    type: $type
    localizations: $input
    auditNoteId: $auditNoteId
  ) {
    key
  }
}
    `;
export type ShopAppLocalizationsUpdateMutationFn = Apollo.MutationFunction<ShopAppLocalizationsUpdateMutation, ShopAppLocalizationsUpdateMutationVariables>;

/**
 * __useShopAppLocalizationsUpdateMutation__
 *
 * To run a mutation, you first call `useShopAppLocalizationsUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useShopAppLocalizationsUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [shopAppLocalizationsUpdateMutation, { data, loading, error }] = useShopAppLocalizationsUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      type: // value for 'type'
 *      input: // value for 'input'
 *      auditNoteId: // value for 'auditNoteId'
 *   },
 * });
 */
export function useShopAppLocalizationsUpdateMutation(baseOptions?: Apollo.MutationHookOptions<ShopAppLocalizationsUpdateMutation, ShopAppLocalizationsUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ShopAppLocalizationsUpdateMutation, ShopAppLocalizationsUpdateMutationVariables>(ShopAppLocalizationsUpdateDocument, options);
      }
export type ShopAppLocalizationsUpdateMutationHookResult = ReturnType<typeof useShopAppLocalizationsUpdateMutation>;
export type ShopAppLocalizationsUpdateMutationResult = Apollo.MutationResult<ShopAppLocalizationsUpdateMutation>;
export type ShopAppLocalizationsUpdateMutationOptions = Apollo.BaseMutationOptions<ShopAppLocalizationsUpdateMutation, ShopAppLocalizationsUpdateMutationVariables>;
export const BrandAppShopsDocument = gql`
    query BrandAppShops($id: MongoID!) {
  Shops(filter: {brandHouseId: $id}) {
    _id
    name
  }
}
    `;

/**
 * __useBrandAppShopsQuery__
 *
 * To run a query within a React component, call `useBrandAppShopsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBrandAppShopsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBrandAppShopsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useBrandAppShopsQuery(baseOptions: Apollo.QueryHookOptions<BrandAppShopsQuery, BrandAppShopsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BrandAppShopsQuery, BrandAppShopsQueryVariables>(BrandAppShopsDocument, options);
      }
export function useBrandAppShopsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BrandAppShopsQuery, BrandAppShopsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BrandAppShopsQuery, BrandAppShopsQueryVariables>(BrandAppShopsDocument, options);
        }
export type BrandAppShopsQueryHookResult = ReturnType<typeof useBrandAppShopsQuery>;
export type BrandAppShopsLazyQueryHookResult = ReturnType<typeof useBrandAppShopsLazyQuery>;
export type BrandAppShopsQueryResult = Apollo.QueryResult<BrandAppShopsQuery, BrandAppShopsQueryVariables>;
export const BrandAppLocalizationsUpdateDocument = gql`
    mutation BrandAppLocalizationsUpdate($id: MongoID!, $type: String!, $input: [LocalizationInput], $auditNoteId: MongoID) {
  BrandLocalizationsUpdate(
    brandHouseId: $id
    type: $type
    localizations: $input
    auditNoteId: $auditNoteId
  ) {
    key
  }
}
    `;
export type BrandAppLocalizationsUpdateMutationFn = Apollo.MutationFunction<BrandAppLocalizationsUpdateMutation, BrandAppLocalizationsUpdateMutationVariables>;

/**
 * __useBrandAppLocalizationsUpdateMutation__
 *
 * To run a mutation, you first call `useBrandAppLocalizationsUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBrandAppLocalizationsUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [brandAppLocalizationsUpdateMutation, { data, loading, error }] = useBrandAppLocalizationsUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      type: // value for 'type'
 *      input: // value for 'input'
 *      auditNoteId: // value for 'auditNoteId'
 *   },
 * });
 */
export function useBrandAppLocalizationsUpdateMutation(baseOptions?: Apollo.MutationHookOptions<BrandAppLocalizationsUpdateMutation, BrandAppLocalizationsUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BrandAppLocalizationsUpdateMutation, BrandAppLocalizationsUpdateMutationVariables>(BrandAppLocalizationsUpdateDocument, options);
      }
export type BrandAppLocalizationsUpdateMutationHookResult = ReturnType<typeof useBrandAppLocalizationsUpdateMutation>;
export type BrandAppLocalizationsUpdateMutationResult = Apollo.MutationResult<BrandAppLocalizationsUpdateMutation>;
export type BrandAppLocalizationsUpdateMutationOptions = Apollo.BaseMutationOptions<BrandAppLocalizationsUpdateMutation, BrandAppLocalizationsUpdateMutationVariables>;
export const BrandSearchIndexesDocument = gql`
    query BrandSearchIndexes($brandHouseId: MongoID!) {
  BrandProductGroups(filter: {brandHouseId: $brandHouseId}) {
    _id
    name
  }
}
    `;

/**
 * __useBrandSearchIndexesQuery__
 *
 * To run a query within a React component, call `useBrandSearchIndexesQuery` and pass it any options that fit your needs.
 * When your component renders, `useBrandSearchIndexesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBrandSearchIndexesQuery({
 *   variables: {
 *      brandHouseId: // value for 'brandHouseId'
 *   },
 * });
 */
export function useBrandSearchIndexesQuery(baseOptions: Apollo.QueryHookOptions<BrandSearchIndexesQuery, BrandSearchIndexesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BrandSearchIndexesQuery, BrandSearchIndexesQueryVariables>(BrandSearchIndexesDocument, options);
      }
export function useBrandSearchIndexesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BrandSearchIndexesQuery, BrandSearchIndexesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BrandSearchIndexesQuery, BrandSearchIndexesQueryVariables>(BrandSearchIndexesDocument, options);
        }
export type BrandSearchIndexesQueryHookResult = ReturnType<typeof useBrandSearchIndexesQuery>;
export type BrandSearchIndexesLazyQueryHookResult = ReturnType<typeof useBrandSearchIndexesLazyQuery>;
export type BrandSearchIndexesQueryResult = Apollo.QueryResult<BrandSearchIndexesQuery, BrandSearchIndexesQueryVariables>;
export const ConsumerSettingsDocument = gql`
    query ConsumerSettings($shopId: MongoID, $brandHouseId: MongoID) {
  BrandSettings(brandHouseId: $brandHouseId, shopId: $shopId) {
    ...BrandSettingsFragment
  }
}
    ${BrandSettingsFragmentDoc}`;

/**
 * __useConsumerSettingsQuery__
 *
 * To run a query within a React component, call `useConsumerSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useConsumerSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConsumerSettingsQuery({
 *   variables: {
 *      shopId: // value for 'shopId'
 *      brandHouseId: // value for 'brandHouseId'
 *   },
 * });
 */
export function useConsumerSettingsQuery(baseOptions?: Apollo.QueryHookOptions<ConsumerSettingsQuery, ConsumerSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ConsumerSettingsQuery, ConsumerSettingsQueryVariables>(ConsumerSettingsDocument, options);
      }
export function useConsumerSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ConsumerSettingsQuery, ConsumerSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ConsumerSettingsQuery, ConsumerSettingsQueryVariables>(ConsumerSettingsDocument, options);
        }
export type ConsumerSettingsQueryHookResult = ReturnType<typeof useConsumerSettingsQuery>;
export type ConsumerSettingsLazyQueryHookResult = ReturnType<typeof useConsumerSettingsLazyQuery>;
export type ConsumerSettingsQueryResult = Apollo.QueryResult<ConsumerSettingsQuery, ConsumerSettingsQueryVariables>;
export const ConsumerSettingsSaveDocument = gql`
    mutation ConsumerSettingsSave($shopId: MongoID, $brandHouseId: MongoID, $input: BrandSettingInput!, $auditNoteId: MongoID) {
  BrandSettingsUpdate(
    shopId: $shopId
    brandHouseId: $brandHouseId
    auditNoteId: $auditNoteId
    api: $input
  ) {
    ...BrandSettingsFragment
  }
}
    ${BrandSettingsFragmentDoc}`;
export type ConsumerSettingsSaveMutationFn = Apollo.MutationFunction<ConsumerSettingsSaveMutation, ConsumerSettingsSaveMutationVariables>;

/**
 * __useConsumerSettingsSaveMutation__
 *
 * To run a mutation, you first call `useConsumerSettingsSaveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConsumerSettingsSaveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [consumerSettingsSaveMutation, { data, loading, error }] = useConsumerSettingsSaveMutation({
 *   variables: {
 *      shopId: // value for 'shopId'
 *      brandHouseId: // value for 'brandHouseId'
 *      input: // value for 'input'
 *      auditNoteId: // value for 'auditNoteId'
 *   },
 * });
 */
export function useConsumerSettingsSaveMutation(baseOptions?: Apollo.MutationHookOptions<ConsumerSettingsSaveMutation, ConsumerSettingsSaveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConsumerSettingsSaveMutation, ConsumerSettingsSaveMutationVariables>(ConsumerSettingsSaveDocument, options);
      }
export type ConsumerSettingsSaveMutationHookResult = ReturnType<typeof useConsumerSettingsSaveMutation>;
export type ConsumerSettingsSaveMutationResult = Apollo.MutationResult<ConsumerSettingsSaveMutation>;
export type ConsumerSettingsSaveMutationOptions = Apollo.BaseMutationOptions<ConsumerSettingsSaveMutation, ConsumerSettingsSaveMutationVariables>;
export const ShippingCostsDocument = gql`
    query ShippingCosts($queries: [ShippingCostInput!]!, $currency: String!, $includeVat: Boolean) {
  ShippingCosts(queries: $queries, currency: $currency, includeVat: $includeVat) {
    carrier
    country
    weight
    cost
    currency
    direction
  }
}
    `;

/**
 * __useShippingCostsQuery__
 *
 * To run a query within a React component, call `useShippingCostsQuery` and pass it any options that fit your needs.
 * When your component renders, `useShippingCostsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShippingCostsQuery({
 *   variables: {
 *      queries: // value for 'queries'
 *      currency: // value for 'currency'
 *      includeVat: // value for 'includeVat'
 *   },
 * });
 */
export function useShippingCostsQuery(baseOptions: Apollo.QueryHookOptions<ShippingCostsQuery, ShippingCostsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ShippingCostsQuery, ShippingCostsQueryVariables>(ShippingCostsDocument, options);
      }
export function useShippingCostsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ShippingCostsQuery, ShippingCostsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ShippingCostsQuery, ShippingCostsQueryVariables>(ShippingCostsDocument, options);
        }
export type ShippingCostsQueryHookResult = ReturnType<typeof useShippingCostsQuery>;
export type ShippingCostsLazyQueryHookResult = ReturnType<typeof useShippingCostsLazyQuery>;
export type ShippingCostsQueryResult = Apollo.QueryResult<ShippingCostsQuery, ShippingCostsQueryVariables>;
export const CircularPointsPanelQueryDocument = gql`
    query CircularPointsPanelQuery($consumerId: MongoID!) {
  CircularAccountById(consumerId: $consumerId) {
    consumerId
    shopId
    total
    pending
    points {
      value
      sourceType
      activated
    }
  }
}
    `;

/**
 * __useCircularPointsPanelQuery__
 *
 * To run a query within a React component, call `useCircularPointsPanelQuery` and pass it any options that fit your needs.
 * When your component renders, `useCircularPointsPanelQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCircularPointsPanelQuery({
 *   variables: {
 *      consumerId: // value for 'consumerId'
 *   },
 * });
 */
export function useCircularPointsPanelQuery(baseOptions: Apollo.QueryHookOptions<CircularPointsPanelQuery, CircularPointsPanelQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CircularPointsPanelQuery, CircularPointsPanelQueryVariables>(CircularPointsPanelQueryDocument, options);
      }
export function useCircularPointsPanelQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CircularPointsPanelQuery, CircularPointsPanelQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CircularPointsPanelQuery, CircularPointsPanelQueryVariables>(CircularPointsPanelQueryDocument, options);
        }
export type CircularPointsPanelQueryHookResult = ReturnType<typeof useCircularPointsPanelQuery>;
export type CircularPointsPanelQueryLazyQueryHookResult = ReturnType<typeof useCircularPointsPanelQueryLazyQuery>;
export type CircularPointsPanelQueryQueryResult = Apollo.QueryResult<CircularPointsPanelQuery, CircularPointsPanelQueryVariables>;
export const PanelConsumerByIdDocument = gql`
    query PanelConsumerById($consumerId: MongoID!) {
  ConsumerById(_id: $consumerId) {
    _id
    firstName
    lastName
    add1
    add2
    zipCode
    city
    country
    locale
    mail
    phone
    acceptsMarketing
    accessToken
    lastLogin
    selfCreated
    createdAt
    shopId
    externalId
    externUrl
    shop {
      _id
      brandHouseId
      tradeInBaseUrl
      currency
    }
    tradeInAppUrl
  }
  TradeInMany(filter: {consumerId: $consumerId}) {
    _id
  }
}
    `;

/**
 * __usePanelConsumerByIdQuery__
 *
 * To run a query within a React component, call `usePanelConsumerByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `usePanelConsumerByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePanelConsumerByIdQuery({
 *   variables: {
 *      consumerId: // value for 'consumerId'
 *   },
 * });
 */
export function usePanelConsumerByIdQuery(baseOptions: Apollo.QueryHookOptions<PanelConsumerByIdQuery, PanelConsumerByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PanelConsumerByIdQuery, PanelConsumerByIdQueryVariables>(PanelConsumerByIdDocument, options);
      }
export function usePanelConsumerByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PanelConsumerByIdQuery, PanelConsumerByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PanelConsumerByIdQuery, PanelConsumerByIdQueryVariables>(PanelConsumerByIdDocument, options);
        }
export type PanelConsumerByIdQueryHookResult = ReturnType<typeof usePanelConsumerByIdQuery>;
export type PanelConsumerByIdLazyQueryHookResult = ReturnType<typeof usePanelConsumerByIdLazyQuery>;
export type PanelConsumerByIdQueryResult = Apollo.QueryResult<PanelConsumerByIdQuery, PanelConsumerByIdQueryVariables>;
export const PanelExternConsumerByIdDocument = gql`
    query PanelExternConsumerById($consumerId: String!) {
  ExternOrders2Many(filter: {customer: {externCustomerId: $consumerId}}) {
    _id
    lineItems {
      discountedPricePreTax
    }
  }
}
    `;

/**
 * __usePanelExternConsumerByIdQuery__
 *
 * To run a query within a React component, call `usePanelExternConsumerByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `usePanelExternConsumerByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePanelExternConsumerByIdQuery({
 *   variables: {
 *      consumerId: // value for 'consumerId'
 *   },
 * });
 */
export function usePanelExternConsumerByIdQuery(baseOptions: Apollo.QueryHookOptions<PanelExternConsumerByIdQuery, PanelExternConsumerByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PanelExternConsumerByIdQuery, PanelExternConsumerByIdQueryVariables>(PanelExternConsumerByIdDocument, options);
      }
export function usePanelExternConsumerByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PanelExternConsumerByIdQuery, PanelExternConsumerByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PanelExternConsumerByIdQuery, PanelExternConsumerByIdQueryVariables>(PanelExternConsumerByIdDocument, options);
        }
export type PanelExternConsumerByIdQueryHookResult = ReturnType<typeof usePanelExternConsumerByIdQuery>;
export type PanelExternConsumerByIdLazyQueryHookResult = ReturnType<typeof usePanelExternConsumerByIdLazyQuery>;
export type PanelExternConsumerByIdQueryResult = Apollo.QueryResult<PanelExternConsumerByIdQuery, PanelExternConsumerByIdQueryVariables>;
export const InvoicesListInvoicesDocument = gql`
    query InvoicesListInvoices($brandHouseId: MongoID, $limit: Int) {
  Invoices(brandHouseId: $brandHouseId, limit: $limit) {
    _id
    brandHouseId
    brandHouse {
      name
    }
    invoiceId
    invoiceDate
    locked
    paid
    total {
      total
      sections {
        total
        title
        lines {
          lineType
          title
          count
          sum
        }
      }
    }
    currency
  }
  InvoiceIds
}
    `;

/**
 * __useInvoicesListInvoicesQuery__
 *
 * To run a query within a React component, call `useInvoicesListInvoicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvoicesListInvoicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvoicesListInvoicesQuery({
 *   variables: {
 *      brandHouseId: // value for 'brandHouseId'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useInvoicesListInvoicesQuery(baseOptions?: Apollo.QueryHookOptions<InvoicesListInvoicesQuery, InvoicesListInvoicesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InvoicesListInvoicesQuery, InvoicesListInvoicesQueryVariables>(InvoicesListInvoicesDocument, options);
      }
export function useInvoicesListInvoicesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InvoicesListInvoicesQuery, InvoicesListInvoicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InvoicesListInvoicesQuery, InvoicesListInvoicesQueryVariables>(InvoicesListInvoicesDocument, options);
        }
export type InvoicesListInvoicesQueryHookResult = ReturnType<typeof useInvoicesListInvoicesQuery>;
export type InvoicesListInvoicesLazyQueryHookResult = ReturnType<typeof useInvoicesListInvoicesLazyQuery>;
export type InvoicesListInvoicesQueryResult = Apollo.QueryResult<InvoicesListInvoicesQuery, InvoicesListInvoicesQueryVariables>;
export const InvoicesListLinesDocument = gql`
    query InvoicesListLines($invoiceId: MongoID!, $lineType: EnumInvoiceLineLineType!) {
  InvoiceLines(
    filter: {invoiceId: $invoiceId, lineType: $lineType}
    sort: _ID_DESC
    limit: 1000
  ) {
    _id
    invoiceId
    cost
    currency
    lineType
    lineId
    createdAt
  }
}
    `;

/**
 * __useInvoicesListLinesQuery__
 *
 * To run a query within a React component, call `useInvoicesListLinesQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvoicesListLinesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvoicesListLinesQuery({
 *   variables: {
 *      invoiceId: // value for 'invoiceId'
 *      lineType: // value for 'lineType'
 *   },
 * });
 */
export function useInvoicesListLinesQuery(baseOptions: Apollo.QueryHookOptions<InvoicesListLinesQuery, InvoicesListLinesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InvoicesListLinesQuery, InvoicesListLinesQueryVariables>(InvoicesListLinesDocument, options);
      }
export function useInvoicesListLinesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InvoicesListLinesQuery, InvoicesListLinesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InvoicesListLinesQuery, InvoicesListLinesQueryVariables>(InvoicesListLinesDocument, options);
        }
export type InvoicesListLinesQueryHookResult = ReturnType<typeof useInvoicesListLinesQuery>;
export type InvoicesListLinesLazyQueryHookResult = ReturnType<typeof useInvoicesListLinesLazyQuery>;
export type InvoicesListLinesQueryResult = Apollo.QueryResult<InvoicesListLinesQuery, InvoicesListLinesQueryVariables>;
export const InvoicesListLineStockItemDocument = gql`
    query InvoicesListLineStockItem($stockItemId: MongoID!) {
  StockItemById(_id: $stockItemId) {
    _id
    itemNr
    title
    imageUrls
    shopId
    shop {
      _id
      brandHouse {
        _id
      }
    }
  }
}
    `;

/**
 * __useInvoicesListLineStockItemQuery__
 *
 * To run a query within a React component, call `useInvoicesListLineStockItemQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvoicesListLineStockItemQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvoicesListLineStockItemQuery({
 *   variables: {
 *      stockItemId: // value for 'stockItemId'
 *   },
 * });
 */
export function useInvoicesListLineStockItemQuery(baseOptions: Apollo.QueryHookOptions<InvoicesListLineStockItemQuery, InvoicesListLineStockItemQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InvoicesListLineStockItemQuery, InvoicesListLineStockItemQueryVariables>(InvoicesListLineStockItemDocument, options);
      }
export function useInvoicesListLineStockItemLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InvoicesListLineStockItemQuery, InvoicesListLineStockItemQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InvoicesListLineStockItemQuery, InvoicesListLineStockItemQueryVariables>(InvoicesListLineStockItemDocument, options);
        }
export type InvoicesListLineStockItemQueryHookResult = ReturnType<typeof useInvoicesListLineStockItemQuery>;
export type InvoicesListLineStockItemLazyQueryHookResult = ReturnType<typeof useInvoicesListLineStockItemLazyQuery>;
export type InvoicesListLineStockItemQueryResult = Apollo.QueryResult<InvoicesListLineStockItemQuery, InvoicesListLineStockItemQueryVariables>;
export const InvoicesListConversionDocument = gql`
    query InvoicesListConversion($inputCurrency: String!, $inputValue: Float!, $outputCurrency: String!) {
  ConvertCurrency(
    inputCurrency: $inputCurrency
    inputValue: $inputValue
    outputCurrency: $outputCurrency
  ) {
    value
    currency
  }
}
    `;

/**
 * __useInvoicesListConversionQuery__
 *
 * To run a query within a React component, call `useInvoicesListConversionQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvoicesListConversionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvoicesListConversionQuery({
 *   variables: {
 *      inputCurrency: // value for 'inputCurrency'
 *      inputValue: // value for 'inputValue'
 *      outputCurrency: // value for 'outputCurrency'
 *   },
 * });
 */
export function useInvoicesListConversionQuery(baseOptions: Apollo.QueryHookOptions<InvoicesListConversionQuery, InvoicesListConversionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InvoicesListConversionQuery, InvoicesListConversionQueryVariables>(InvoicesListConversionDocument, options);
      }
export function useInvoicesListConversionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InvoicesListConversionQuery, InvoicesListConversionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InvoicesListConversionQuery, InvoicesListConversionQueryVariables>(InvoicesListConversionDocument, options);
        }
export type InvoicesListConversionQueryHookResult = ReturnType<typeof useInvoicesListConversionQuery>;
export type InvoicesListConversionLazyQueryHookResult = ReturnType<typeof useInvoicesListConversionLazyQuery>;
export type InvoicesListConversionQueryResult = Apollo.QueryResult<InvoicesListConversionQuery, InvoicesListConversionQueryVariables>;
export const InvoicesListResetDocument = gql`
    mutation InvoicesListReset($invoiceId: String!) {
  InvoiceReset(invoiceId: $invoiceId) {
    _id
  }
}
    `;
export type InvoicesListResetMutationFn = Apollo.MutationFunction<InvoicesListResetMutation, InvoicesListResetMutationVariables>;

/**
 * __useInvoicesListResetMutation__
 *
 * To run a mutation, you first call `useInvoicesListResetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInvoicesListResetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [invoicesListResetMutation, { data, loading, error }] = useInvoicesListResetMutation({
 *   variables: {
 *      invoiceId: // value for 'invoiceId'
 *   },
 * });
 */
export function useInvoicesListResetMutation(baseOptions?: Apollo.MutationHookOptions<InvoicesListResetMutation, InvoicesListResetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InvoicesListResetMutation, InvoicesListResetMutationVariables>(InvoicesListResetDocument, options);
      }
export type InvoicesListResetMutationHookResult = ReturnType<typeof useInvoicesListResetMutation>;
export type InvoicesListResetMutationResult = Apollo.MutationResult<InvoicesListResetMutation>;
export type InvoicesListResetMutationOptions = Apollo.BaseMutationOptions<InvoicesListResetMutation, InvoicesListResetMutationVariables>;
export const ExportOrderLinesDocument = gql`
    query ExportOrderLines($orderIds: [MongoID!], $currency: String!) {
  OrderPagination(
    filter: {_operators: {_id: {in: $orderIds}, orderState: {ne: CANCELLED}}}
    perPage: 99999
  ) {
    items {
      ...OrderLinesExport
    }
  }
}
    ${OrderLinesExportFragmentDoc}`;

/**
 * __useExportOrderLinesQuery__
 *
 * To run a query within a React component, call `useExportOrderLinesQuery` and pass it any options that fit your needs.
 * When your component renders, `useExportOrderLinesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExportOrderLinesQuery({
 *   variables: {
 *      orderIds: // value for 'orderIds'
 *      currency: // value for 'currency'
 *   },
 * });
 */
export function useExportOrderLinesQuery(baseOptions: Apollo.QueryHookOptions<ExportOrderLinesQuery, ExportOrderLinesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExportOrderLinesQuery, ExportOrderLinesQueryVariables>(ExportOrderLinesDocument, options);
      }
export function useExportOrderLinesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExportOrderLinesQuery, ExportOrderLinesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExportOrderLinesQuery, ExportOrderLinesQueryVariables>(ExportOrderLinesDocument, options);
        }
export type ExportOrderLinesQueryHookResult = ReturnType<typeof useExportOrderLinesQuery>;
export type ExportOrderLinesLazyQueryHookResult = ReturnType<typeof useExportOrderLinesLazyQuery>;
export type ExportOrderLinesQueryResult = Apollo.QueryResult<ExportOrderLinesQuery, ExportOrderLinesQueryVariables>;
export const ExportOrderConsumerDocument = gql`
    query ExportOrderConsumer($shopId: MongoID!, $mail: String!, $dateTime: Date!, $now: Date!) {
  ConsumerByIdentifier(
    shopId: $shopId
    identifier: $mail
    identifierType: EMAIL
    selfCreated: false
  ) {
    statisticsBefore: statistics(date: $dateTime) {
      orders
      tradeIns
    }
    statisticsAfter: statistics(date: $now) {
      orders
      tradeIns
    }
  }
}
    `;

/**
 * __useExportOrderConsumerQuery__
 *
 * To run a query within a React component, call `useExportOrderConsumerQuery` and pass it any options that fit your needs.
 * When your component renders, `useExportOrderConsumerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExportOrderConsumerQuery({
 *   variables: {
 *      shopId: // value for 'shopId'
 *      mail: // value for 'mail'
 *      dateTime: // value for 'dateTime'
 *      now: // value for 'now'
 *   },
 * });
 */
export function useExportOrderConsumerQuery(baseOptions: Apollo.QueryHookOptions<ExportOrderConsumerQuery, ExportOrderConsumerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExportOrderConsumerQuery, ExportOrderConsumerQueryVariables>(ExportOrderConsumerDocument, options);
      }
export function useExportOrderConsumerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExportOrderConsumerQuery, ExportOrderConsumerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExportOrderConsumerQuery, ExportOrderConsumerQueryVariables>(ExportOrderConsumerDocument, options);
        }
export type ExportOrderConsumerQueryHookResult = ReturnType<typeof useExportOrderConsumerQuery>;
export type ExportOrderConsumerLazyQueryHookResult = ReturnType<typeof useExportOrderConsumerLazyQuery>;
export type ExportOrderConsumerQueryResult = Apollo.QueryResult<ExportOrderConsumerQuery, ExportOrderConsumerQueryVariables>;
export const ExportOrdersDocument = gql`
    query ExportOrders($orderIds: [MongoID!], $currency: String!) {
  OrderPagination(
    filter: {_operators: {_id: {in: $orderIds}, orderState: {ne: CANCELLED}}}
    perPage: 99999
  ) {
    items {
      ...OrderExport
    }
  }
}
    ${OrderExportFragmentDoc}`;

/**
 * __useExportOrdersQuery__
 *
 * To run a query within a React component, call `useExportOrdersQuery` and pass it any options that fit your needs.
 * When your component renders, `useExportOrdersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExportOrdersQuery({
 *   variables: {
 *      orderIds: // value for 'orderIds'
 *      currency: // value for 'currency'
 *   },
 * });
 */
export function useExportOrdersQuery(baseOptions: Apollo.QueryHookOptions<ExportOrdersQuery, ExportOrdersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExportOrdersQuery, ExportOrdersQueryVariables>(ExportOrdersDocument, options);
      }
export function useExportOrdersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExportOrdersQuery, ExportOrdersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExportOrdersQuery, ExportOrdersQueryVariables>(ExportOrdersDocument, options);
        }
export type ExportOrdersQueryHookResult = ReturnType<typeof useExportOrdersQuery>;
export type ExportOrdersLazyQueryHookResult = ReturnType<typeof useExportOrdersLazyQuery>;
export type ExportOrdersQueryResult = Apollo.QueryResult<ExportOrdersQuery, ExportOrdersQueryVariables>;
export const OrdersListDocument = gql`
    query OrdersList($search: String, $filter: FilterFindManyOrder2Input, $sort: SortFindManyOrder2Input, $page: Int, $perPage: Int, $viewId: MongoID) {
  OrderPagination(
    filter: $filter
    search: $search
    page: $page
    perPage: $perPage
    sort: $sort
    viewId: $viewId
  ) {
    count
    pageInfo {
      perPage
      currentPage
      hasNextPage
      hasPreviousPage
      itemCount
      pageCount
    }
    items {
      ...OrderFragment
    }
  }
}
    ${OrderFragmentDoc}`;

/**
 * __useOrdersListQuery__
 *
 * To run a query within a React component, call `useOrdersListQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrdersListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrdersListQuery({
 *   variables: {
 *      search: // value for 'search'
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *      viewId: // value for 'viewId'
 *   },
 * });
 */
export function useOrdersListQuery(baseOptions?: Apollo.QueryHookOptions<OrdersListQuery, OrdersListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrdersListQuery, OrdersListQueryVariables>(OrdersListDocument, options);
      }
export function useOrdersListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrdersListQuery, OrdersListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrdersListQuery, OrdersListQueryVariables>(OrdersListDocument, options);
        }
export type OrdersListQueryHookResult = ReturnType<typeof useOrdersListQuery>;
export type OrdersListLazyQueryHookResult = ReturnType<typeof useOrdersListLazyQuery>;
export type OrdersListQueryResult = Apollo.QueryResult<OrdersListQuery, OrdersListQueryVariables>;
export const OrdersSelectAllDocument = gql`
    query OrdersSelectAll($filter: FilterFindManyOrder2Input, $sort: SortFindManyOrder2Input, $viewId: MongoID) {
  OrderPagination(
    filter: $filter
    sort: $sort
    page: 1
    perPage: 10000
    viewId: $viewId
  ) {
    items {
      _id
    }
  }
}
    `;

/**
 * __useOrdersSelectAllQuery__
 *
 * To run a query within a React component, call `useOrdersSelectAllQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrdersSelectAllQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrdersSelectAllQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *      viewId: // value for 'viewId'
 *   },
 * });
 */
export function useOrdersSelectAllQuery(baseOptions?: Apollo.QueryHookOptions<OrdersSelectAllQuery, OrdersSelectAllQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrdersSelectAllQuery, OrdersSelectAllQueryVariables>(OrdersSelectAllDocument, options);
      }
export function useOrdersSelectAllLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrdersSelectAllQuery, OrdersSelectAllQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrdersSelectAllQuery, OrdersSelectAllQueryVariables>(OrdersSelectAllDocument, options);
        }
export type OrdersSelectAllQueryHookResult = ReturnType<typeof useOrdersSelectAllQuery>;
export type OrdersSelectAllLazyQueryHookResult = ReturnType<typeof useOrdersSelectAllLazyQuery>;
export type OrdersSelectAllQueryResult = Apollo.QueryResult<OrdersSelectAllQuery, OrdersSelectAllQueryVariables>;
export const PotentialsListPaginationDocument = gql`
    query PotentialsListPagination($search: String, $filter: FilterFindManyPotentialInput, $sort: SortFindManyPotentialInput, $page: Int, $perPage: Int) {
  PotentialsPagination(
    search: $search
    filter: $filter
    sort: $sort
    page: $page
    perPage: $perPage
  ) {
    count
    pageInfo {
      perPage
      currentPage
      hasNextPage
      hasPreviousPage
      itemCount
      pageCount
    }
    items {
      _id
      externUrl
      externDate
      name
      sku
      color
      size
      ean
      rrp
      sp
      cancelled
      offer {
        value
        currency
        notifyDate
        activation
      }
      consumerId
      consumer {
        _id
        firstName
        lastName
      }
      imageUrls
      wholeSale {
        categoryId
        name
        value
      }
      notified
      notifiedTs
      sourceType
    }
  }
}
    `;

/**
 * __usePotentialsListPaginationQuery__
 *
 * To run a query within a React component, call `usePotentialsListPaginationQuery` and pass it any options that fit your needs.
 * When your component renders, `usePotentialsListPaginationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePotentialsListPaginationQuery({
 *   variables: {
 *      search: // value for 'search'
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *   },
 * });
 */
export function usePotentialsListPaginationQuery(baseOptions?: Apollo.QueryHookOptions<PotentialsListPaginationQuery, PotentialsListPaginationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PotentialsListPaginationQuery, PotentialsListPaginationQueryVariables>(PotentialsListPaginationDocument, options);
      }
export function usePotentialsListPaginationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PotentialsListPaginationQuery, PotentialsListPaginationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PotentialsListPaginationQuery, PotentialsListPaginationQueryVariables>(PotentialsListPaginationDocument, options);
        }
export type PotentialsListPaginationQueryHookResult = ReturnType<typeof usePotentialsListPaginationQuery>;
export type PotentialsListPaginationLazyQueryHookResult = ReturnType<typeof usePotentialsListPaginationLazyQuery>;
export type PotentialsListPaginationQueryResult = Apollo.QueryResult<PotentialsListPaginationQuery, PotentialsListPaginationQueryVariables>;
export const ViewProductVariantsSizesDocument = gql`
    query ViewProductVariantsSizes($shopId: MongoID!) {
  ShopById(_id: $shopId) {
    _id
    sizes
    colors
    productBatches
  }
}
    `;

/**
 * __useViewProductVariantsSizesQuery__
 *
 * To run a query within a React component, call `useViewProductVariantsSizesQuery` and pass it any options that fit your needs.
 * When your component renders, `useViewProductVariantsSizesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useViewProductVariantsSizesQuery({
 *   variables: {
 *      shopId: // value for 'shopId'
 *   },
 * });
 */
export function useViewProductVariantsSizesQuery(baseOptions: Apollo.QueryHookOptions<ViewProductVariantsSizesQuery, ViewProductVariantsSizesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ViewProductVariantsSizesQuery, ViewProductVariantsSizesQueryVariables>(ViewProductVariantsSizesDocument, options);
      }
export function useViewProductVariantsSizesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ViewProductVariantsSizesQuery, ViewProductVariantsSizesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ViewProductVariantsSizesQuery, ViewProductVariantsSizesQueryVariables>(ViewProductVariantsSizesDocument, options);
        }
export type ViewProductVariantsSizesQueryHookResult = ReturnType<typeof useViewProductVariantsSizesQuery>;
export type ViewProductVariantsSizesLazyQueryHookResult = ReturnType<typeof useViewProductVariantsSizesLazyQuery>;
export type ViewProductVariantsSizesQueryResult = Apollo.QueryResult<ViewProductVariantsSizesQuery, ViewProductVariantsSizesQueryVariables>;
export const ViewProductVariantsManyDocument = gql`
    query ViewProductVariantsMany($search: String, $filter: FilterFindManyProductVariantInput, $sort: SortFindManyProductVariantInput, $page: Int, $perPage: Int) {
  ProductVariantsPagination(
    search: $search
    filter: $filter
    sort: $sort
    page: $page
    perPage: $perPage
  ) {
    count
    pageInfo {
      perPage
      currentPage
      hasNextPage
      hasPreviousPage
      itemCount
      pageCount
    }
    items {
      ...ViewProductVariantFragment
    }
  }
}
    ${ViewProductVariantFragmentDoc}`;

/**
 * __useViewProductVariantsManyQuery__
 *
 * To run a query within a React component, call `useViewProductVariantsManyQuery` and pass it any options that fit your needs.
 * When your component renders, `useViewProductVariantsManyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useViewProductVariantsManyQuery({
 *   variables: {
 *      search: // value for 'search'
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *   },
 * });
 */
export function useViewProductVariantsManyQuery(baseOptions?: Apollo.QueryHookOptions<ViewProductVariantsManyQuery, ViewProductVariantsManyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ViewProductVariantsManyQuery, ViewProductVariantsManyQueryVariables>(ViewProductVariantsManyDocument, options);
      }
export function useViewProductVariantsManyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ViewProductVariantsManyQuery, ViewProductVariantsManyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ViewProductVariantsManyQuery, ViewProductVariantsManyQueryVariables>(ViewProductVariantsManyDocument, options);
        }
export type ViewProductVariantsManyQueryHookResult = ReturnType<typeof useViewProductVariantsManyQuery>;
export type ViewProductVariantsManyLazyQueryHookResult = ReturnType<typeof useViewProductVariantsManyLazyQuery>;
export type ViewProductVariantsManyQueryResult = Apollo.QueryResult<ViewProductVariantsManyQuery, ViewProductVariantsManyQueryVariables>;
export const ProductListBatchesDocument = gql`
    query ProductListBatches($shopId: MongoID!) {
  ShopById(_id: $shopId) {
    _id
    sizes
    colors
    productBatches
  }
}
    `;

/**
 * __useProductListBatchesQuery__
 *
 * To run a query within a React component, call `useProductListBatchesQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductListBatchesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductListBatchesQuery({
 *   variables: {
 *      shopId: // value for 'shopId'
 *   },
 * });
 */
export function useProductListBatchesQuery(baseOptions: Apollo.QueryHookOptions<ProductListBatchesQuery, ProductListBatchesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductListBatchesQuery, ProductListBatchesQueryVariables>(ProductListBatchesDocument, options);
      }
export function useProductListBatchesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductListBatchesQuery, ProductListBatchesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductListBatchesQuery, ProductListBatchesQueryVariables>(ProductListBatchesDocument, options);
        }
export type ProductListBatchesQueryHookResult = ReturnType<typeof useProductListBatchesQuery>;
export type ProductListBatchesLazyQueryHookResult = ReturnType<typeof useProductListBatchesLazyQuery>;
export type ProductListBatchesQueryResult = Apollo.QueryResult<ProductListBatchesQuery, ProductListBatchesQueryVariables>;
export const ProductListPaginationDocument = gql`
    query ProductListPagination($search: String, $filter: FilterFindManyProductInput, $sort: SortFindManyProductInput, $page: Int, $perPage: Int) {
  ProductsPagination(
    search: $search
    filter: $filter
    sort: $sort
    page: $page
    perPage: $perPage
  ) {
    count
    pageInfo {
      perPage
      currentPage
      hasNextPage
      hasPreviousPage
      itemCount
      pageCount
    }
    items {
      ...ProductListProductFragment
    }
  }
}
    ${ProductListProductFragmentDoc}`;

/**
 * __useProductListPaginationQuery__
 *
 * To run a query within a React component, call `useProductListPaginationQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductListPaginationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductListPaginationQuery({
 *   variables: {
 *      search: // value for 'search'
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *   },
 * });
 */
export function useProductListPaginationQuery(baseOptions?: Apollo.QueryHookOptions<ProductListPaginationQuery, ProductListPaginationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductListPaginationQuery, ProductListPaginationQueryVariables>(ProductListPaginationDocument, options);
      }
export function useProductListPaginationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductListPaginationQuery, ProductListPaginationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductListPaginationQuery, ProductListPaginationQueryVariables>(ProductListPaginationDocument, options);
        }
export type ProductListPaginationQueryHookResult = ReturnType<typeof useProductListPaginationQuery>;
export type ProductListPaginationLazyQueryHookResult = ReturnType<typeof useProductListPaginationLazyQuery>;
export type ProductListPaginationQueryResult = Apollo.QueryResult<ProductListPaginationQuery, ProductListPaginationQueryVariables>;
export const StockItemsColumnsCurrencyDocument = gql`
    query StockItemsColumnsCurrency($shopId: MongoID!) {
  ShopById(_id: $shopId) {
    _id
    currency
  }
}
    `;

/**
 * __useStockItemsColumnsCurrencyQuery__
 *
 * To run a query within a React component, call `useStockItemsColumnsCurrencyQuery` and pass it any options that fit your needs.
 * When your component renders, `useStockItemsColumnsCurrencyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStockItemsColumnsCurrencyQuery({
 *   variables: {
 *      shopId: // value for 'shopId'
 *   },
 * });
 */
export function useStockItemsColumnsCurrencyQuery(baseOptions: Apollo.QueryHookOptions<StockItemsColumnsCurrencyQuery, StockItemsColumnsCurrencyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StockItemsColumnsCurrencyQuery, StockItemsColumnsCurrencyQueryVariables>(StockItemsColumnsCurrencyDocument, options);
      }
export function useStockItemsColumnsCurrencyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StockItemsColumnsCurrencyQuery, StockItemsColumnsCurrencyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StockItemsColumnsCurrencyQuery, StockItemsColumnsCurrencyQueryVariables>(StockItemsColumnsCurrencyDocument, options);
        }
export type StockItemsColumnsCurrencyQueryHookResult = ReturnType<typeof useStockItemsColumnsCurrencyQuery>;
export type StockItemsColumnsCurrencyLazyQueryHookResult = ReturnType<typeof useStockItemsColumnsCurrencyLazyQuery>;
export type StockItemsColumnsCurrencyQueryResult = Apollo.QueryResult<StockItemsColumnsCurrencyQuery, StockItemsColumnsCurrencyQueryVariables>;
export const StockItemListBrandsDocument = gql`
    query StockItemListBrands {
  ShopMany {
    _id
    externalName
  }
}
    `;

/**
 * __useStockItemListBrandsQuery__
 *
 * To run a query within a React component, call `useStockItemListBrandsQuery` and pass it any options that fit your needs.
 * When your component renders, `useStockItemListBrandsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStockItemListBrandsQuery({
 *   variables: {
 *   },
 * });
 */
export function useStockItemListBrandsQuery(baseOptions?: Apollo.QueryHookOptions<StockItemListBrandsQuery, StockItemListBrandsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StockItemListBrandsQuery, StockItemListBrandsQueryVariables>(StockItemListBrandsDocument, options);
      }
export function useStockItemListBrandsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StockItemListBrandsQuery, StockItemListBrandsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StockItemListBrandsQuery, StockItemListBrandsQueryVariables>(StockItemListBrandsDocument, options);
        }
export type StockItemListBrandsQueryHookResult = ReturnType<typeof useStockItemListBrandsQuery>;
export type StockItemListBrandsLazyQueryHookResult = ReturnType<typeof useStockItemListBrandsLazyQuery>;
export type StockItemListBrandsQueryResult = Apollo.QueryResult<StockItemListBrandsQuery, StockItemListBrandsQueryVariables>;
export const StockItemsListManyDocument = gql`
    query StockItemsListMany($search: String, $filter: FilterFindManyStockItemInput, $sort: SortFindManyStockItemInput, $page: Int, $perPage: Int) {
  StockItemPagination(
    search: $search
    filter: $filter
    sort: $sort
    page: $page
    perPage: $perPage
  ) {
    count
    pageInfo {
      perPage
      currentPage
      hasNextPage
      hasPreviousPage
      itemCount
      pageCount
    }
    items {
      _id
      resolved {
        ...FlexStockItem
      }
    }
  }
}
    ${FlexStockItemFragmentDoc}`;

/**
 * __useStockItemsListManyQuery__
 *
 * To run a query within a React component, call `useStockItemsListManyQuery` and pass it any options that fit your needs.
 * When your component renders, `useStockItemsListManyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStockItemsListManyQuery({
 *   variables: {
 *      search: // value for 'search'
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *   },
 * });
 */
export function useStockItemsListManyQuery(baseOptions?: Apollo.QueryHookOptions<StockItemsListManyQuery, StockItemsListManyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StockItemsListManyQuery, StockItemsListManyQueryVariables>(StockItemsListManyDocument, options);
      }
export function useStockItemsListManyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StockItemsListManyQuery, StockItemsListManyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StockItemsListManyQuery, StockItemsListManyQueryVariables>(StockItemsListManyDocument, options);
        }
export type StockItemsListManyQueryHookResult = ReturnType<typeof useStockItemsListManyQuery>;
export type StockItemsListManyLazyQueryHookResult = ReturnType<typeof useStockItemsListManyLazyQuery>;
export type StockItemsListManyQueryResult = Apollo.QueryResult<StockItemsListManyQuery, StockItemsListManyQueryVariables>;
export const TradeInListDocument = gql`
    query TradeInList($shopId: MongoID!, $registered: Boolean!, $limit: Int!) {
  TradeIns(
    filter: {shopId: $shopId, OR: [{registered: $registered}, {_operators: {registered: {ne: false}}}]}
    limit: $limit
    sort: _ID_DESC
  ) {
    _id
    tradeInNr
    shopId
    dateTime
    consumer {
      firstName
      lastName
    }
    shippingCarrier {
      carrierId
      name
    }
    registered
    registeredTs
    label {
      deliveryDate
      deliveryStatus
    }
    items {
      _id
      imageUrls
      wholeSale {
        _id
      }
      brandItem {
        _id
      }
      stockItem {
        _id
      }
      rejected
    }
  }
}
    `;

/**
 * __useTradeInListQuery__
 *
 * To run a query within a React component, call `useTradeInListQuery` and pass it any options that fit your needs.
 * When your component renders, `useTradeInListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTradeInListQuery({
 *   variables: {
 *      shopId: // value for 'shopId'
 *      registered: // value for 'registered'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useTradeInListQuery(baseOptions: Apollo.QueryHookOptions<TradeInListQuery, TradeInListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TradeInListQuery, TradeInListQueryVariables>(TradeInListDocument, options);
      }
export function useTradeInListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TradeInListQuery, TradeInListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TradeInListQuery, TradeInListQueryVariables>(TradeInListDocument, options);
        }
export type TradeInListQueryHookResult = ReturnType<typeof useTradeInListQuery>;
export type TradeInListLazyQueryHookResult = ReturnType<typeof useTradeInListLazyQuery>;
export type TradeInListQueryResult = Apollo.QueryResult<TradeInListQuery, TradeInListQueryVariables>;
export const DtcEditBrandByIdDocument = gql`
    query DTCEditBrandById($shopId: MongoID!) {
  ShopById(_id: $shopId) {
    ...DTCEditBrandFragment
  }
}
    ${DtcEditBrandFragmentDoc}`;

/**
 * __useDtcEditBrandByIdQuery__
 *
 * To run a query within a React component, call `useDtcEditBrandByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useDtcEditBrandByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDtcEditBrandByIdQuery({
 *   variables: {
 *      shopId: // value for 'shopId'
 *   },
 * });
 */
export function useDtcEditBrandByIdQuery(baseOptions: Apollo.QueryHookOptions<DtcEditBrandByIdQuery, DtcEditBrandByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DtcEditBrandByIdQuery, DtcEditBrandByIdQueryVariables>(DtcEditBrandByIdDocument, options);
      }
export function useDtcEditBrandByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DtcEditBrandByIdQuery, DtcEditBrandByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DtcEditBrandByIdQuery, DtcEditBrandByIdQueryVariables>(DtcEditBrandByIdDocument, options);
        }
export type DtcEditBrandByIdQueryHookResult = ReturnType<typeof useDtcEditBrandByIdQuery>;
export type DtcEditBrandByIdLazyQueryHookResult = ReturnType<typeof useDtcEditBrandByIdLazyQuery>;
export type DtcEditBrandByIdQueryResult = Apollo.QueryResult<DtcEditBrandByIdQuery, DtcEditBrandByIdQueryVariables>;
export const DtcEditBrandRuleDocument = gql`
    query DTCEditBrandRule($ruleId: MongoID!) {
  BrandRule(_id: $ruleId) {
    ...DTCEditBrandRuleFragment
  }
}
    ${DtcEditBrandRuleFragmentDoc}`;

/**
 * __useDtcEditBrandRuleQuery__
 *
 * To run a query within a React component, call `useDtcEditBrandRuleQuery` and pass it any options that fit your needs.
 * When your component renders, `useDtcEditBrandRuleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDtcEditBrandRuleQuery({
 *   variables: {
 *      ruleId: // value for 'ruleId'
 *   },
 * });
 */
export function useDtcEditBrandRuleQuery(baseOptions: Apollo.QueryHookOptions<DtcEditBrandRuleQuery, DtcEditBrandRuleQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DtcEditBrandRuleQuery, DtcEditBrandRuleQueryVariables>(DtcEditBrandRuleDocument, options);
      }
export function useDtcEditBrandRuleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DtcEditBrandRuleQuery, DtcEditBrandRuleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DtcEditBrandRuleQuery, DtcEditBrandRuleQueryVariables>(DtcEditBrandRuleDocument, options);
        }
export type DtcEditBrandRuleQueryHookResult = ReturnType<typeof useDtcEditBrandRuleQuery>;
export type DtcEditBrandRuleLazyQueryHookResult = ReturnType<typeof useDtcEditBrandRuleLazyQuery>;
export type DtcEditBrandRuleQueryResult = Apollo.QueryResult<DtcEditBrandRuleQuery, DtcEditBrandRuleQueryVariables>;
export const DtcEditBrandRuleUpdateDocument = gql`
    mutation DTCEditBrandRuleUpdate($rule: BrandRuleInput, $auditNoteId: MongoID) {
  BrandRuleUpdate(rule: $rule, auditNoteId: $auditNoteId) {
    _id
  }
}
    `;
export type DtcEditBrandRuleUpdateMutationFn = Apollo.MutationFunction<DtcEditBrandRuleUpdateMutation, DtcEditBrandRuleUpdateMutationVariables>;

/**
 * __useDtcEditBrandRuleUpdateMutation__
 *
 * To run a mutation, you first call `useDtcEditBrandRuleUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDtcEditBrandRuleUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [dtcEditBrandRuleUpdateMutation, { data, loading, error }] = useDtcEditBrandRuleUpdateMutation({
 *   variables: {
 *      rule: // value for 'rule'
 *      auditNoteId: // value for 'auditNoteId'
 *   },
 * });
 */
export function useDtcEditBrandRuleUpdateMutation(baseOptions?: Apollo.MutationHookOptions<DtcEditBrandRuleUpdateMutation, DtcEditBrandRuleUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DtcEditBrandRuleUpdateMutation, DtcEditBrandRuleUpdateMutationVariables>(DtcEditBrandRuleUpdateDocument, options);
      }
export type DtcEditBrandRuleUpdateMutationHookResult = ReturnType<typeof useDtcEditBrandRuleUpdateMutation>;
export type DtcEditBrandRuleUpdateMutationResult = Apollo.MutationResult<DtcEditBrandRuleUpdateMutation>;
export type DtcEditBrandRuleUpdateMutationOptions = Apollo.BaseMutationOptions<DtcEditBrandRuleUpdateMutation, DtcEditBrandRuleUpdateMutationVariables>;
export const VoucherEditorTagsDocument = gql`
    query VoucherEditorTags($shopId: MongoID!) {
  ShopById(_id: $shopId) {
    _id
    productTags
  }
}
    `;

/**
 * __useVoucherEditorTagsQuery__
 *
 * To run a query within a React component, call `useVoucherEditorTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useVoucherEditorTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVoucherEditorTagsQuery({
 *   variables: {
 *      shopId: // value for 'shopId'
 *   },
 * });
 */
export function useVoucherEditorTagsQuery(baseOptions: Apollo.QueryHookOptions<VoucherEditorTagsQuery, VoucherEditorTagsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<VoucherEditorTagsQuery, VoucherEditorTagsQueryVariables>(VoucherEditorTagsDocument, options);
      }
export function useVoucherEditorTagsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VoucherEditorTagsQuery, VoucherEditorTagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<VoucherEditorTagsQuery, VoucherEditorTagsQueryVariables>(VoucherEditorTagsDocument, options);
        }
export type VoucherEditorTagsQueryHookResult = ReturnType<typeof useVoucherEditorTagsQuery>;
export type VoucherEditorTagsLazyQueryHookResult = ReturnType<typeof useVoucherEditorTagsLazyQuery>;
export type VoucherEditorTagsQueryResult = Apollo.QueryResult<VoucherEditorTagsQuery, VoucherEditorTagsQueryVariables>;
export const ProductEditorBrandByIdDocument = gql`
    query ProductEditorBrandById($shopId: MongoID!) {
  ShopById(_id: $shopId) {
    _id
    name
    tradeInBaseUrl
    currency
    productTags
    productCollections
    productTypes
    productVendors
  }
}
    `;

/**
 * __useProductEditorBrandByIdQuery__
 *
 * To run a query within a React component, call `useProductEditorBrandByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductEditorBrandByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductEditorBrandByIdQuery({
 *   variables: {
 *      shopId: // value for 'shopId'
 *   },
 * });
 */
export function useProductEditorBrandByIdQuery(baseOptions: Apollo.QueryHookOptions<ProductEditorBrandByIdQuery, ProductEditorBrandByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductEditorBrandByIdQuery, ProductEditorBrandByIdQueryVariables>(ProductEditorBrandByIdDocument, options);
      }
export function useProductEditorBrandByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductEditorBrandByIdQuery, ProductEditorBrandByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductEditorBrandByIdQuery, ProductEditorBrandByIdQueryVariables>(ProductEditorBrandByIdDocument, options);
        }
export type ProductEditorBrandByIdQueryHookResult = ReturnType<typeof useProductEditorBrandByIdQuery>;
export type ProductEditorBrandByIdLazyQueryHookResult = ReturnType<typeof useProductEditorBrandByIdLazyQuery>;
export type ProductEditorBrandByIdQueryResult = Apollo.QueryResult<ProductEditorBrandByIdQuery, ProductEditorBrandByIdQueryVariables>;
export const DtcRedirectRulesDocument = gql`
    query DTCRedirectRules($shopId: MongoID!) {
  BrandRules(shopId: $shopId) {
    _id
    active
  }
}
    `;

/**
 * __useDtcRedirectRulesQuery__
 *
 * To run a query within a React component, call `useDtcRedirectRulesQuery` and pass it any options that fit your needs.
 * When your component renders, `useDtcRedirectRulesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDtcRedirectRulesQuery({
 *   variables: {
 *      shopId: // value for 'shopId'
 *   },
 * });
 */
export function useDtcRedirectRulesQuery(baseOptions: Apollo.QueryHookOptions<DtcRedirectRulesQuery, DtcRedirectRulesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DtcRedirectRulesQuery, DtcRedirectRulesQueryVariables>(DtcRedirectRulesDocument, options);
      }
export function useDtcRedirectRulesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DtcRedirectRulesQuery, DtcRedirectRulesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DtcRedirectRulesQuery, DtcRedirectRulesQueryVariables>(DtcRedirectRulesDocument, options);
        }
export type DtcRedirectRulesQueryHookResult = ReturnType<typeof useDtcRedirectRulesQuery>;
export type DtcRedirectRulesLazyQueryHookResult = ReturnType<typeof useDtcRedirectRulesLazyQuery>;
export type DtcRedirectRulesQueryResult = Apollo.QueryResult<DtcRedirectRulesQuery, DtcRedirectRulesQueryVariables>;
export const DtcBrandRulesDocument = gql`
    query DTCBrandRules($shopId: MongoID!) {
  BrandRules(shopId: $shopId) {
    _id
    active
    priority
  }
}
    `;

/**
 * __useDtcBrandRulesQuery__
 *
 * To run a query within a React component, call `useDtcBrandRulesQuery` and pass it any options that fit your needs.
 * When your component renders, `useDtcBrandRulesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDtcBrandRulesQuery({
 *   variables: {
 *      shopId: // value for 'shopId'
 *   },
 * });
 */
export function useDtcBrandRulesQuery(baseOptions: Apollo.QueryHookOptions<DtcBrandRulesQuery, DtcBrandRulesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DtcBrandRulesQuery, DtcBrandRulesQueryVariables>(DtcBrandRulesDocument, options);
      }
export function useDtcBrandRulesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DtcBrandRulesQuery, DtcBrandRulesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DtcBrandRulesQuery, DtcBrandRulesQueryVariables>(DtcBrandRulesDocument, options);
        }
export type DtcBrandRulesQueryHookResult = ReturnType<typeof useDtcBrandRulesQuery>;
export type DtcBrandRulesLazyQueryHookResult = ReturnType<typeof useDtcBrandRulesLazyQuery>;
export type DtcBrandRulesQueryResult = Apollo.QueryResult<DtcBrandRulesQuery, DtcBrandRulesQueryVariables>;
export const DtcBrandRuleDocument = gql`
    query DTCBrandRule($ruleId: MongoID!) {
  BrandRule(_id: $ruleId) {
    _id
    shopId
    active
    periodFrom
    periodTo
    priority
    products {
      ids
      tags
      collections
    }
    tradeInPricePct
    minimumPrice
    minimumAge
    maximumAge
    marketingDelay
    voucherStrategy
    voucherValue
    expressions {
      operation
      valueType
      value
    }
  }
}
    `;

/**
 * __useDtcBrandRuleQuery__
 *
 * To run a query within a React component, call `useDtcBrandRuleQuery` and pass it any options that fit your needs.
 * When your component renders, `useDtcBrandRuleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDtcBrandRuleQuery({
 *   variables: {
 *      ruleId: // value for 'ruleId'
 *   },
 * });
 */
export function useDtcBrandRuleQuery(baseOptions: Apollo.QueryHookOptions<DtcBrandRuleQuery, DtcBrandRuleQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DtcBrandRuleQuery, DtcBrandRuleQueryVariables>(DtcBrandRuleDocument, options);
      }
export function useDtcBrandRuleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DtcBrandRuleQuery, DtcBrandRuleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DtcBrandRuleQuery, DtcBrandRuleQueryVariables>(DtcBrandRuleDocument, options);
        }
export type DtcBrandRuleQueryHookResult = ReturnType<typeof useDtcBrandRuleQuery>;
export type DtcBrandRuleLazyQueryHookResult = ReturnType<typeof useDtcBrandRuleLazyQuery>;
export type DtcBrandRuleQueryResult = Apollo.QueryResult<DtcBrandRuleQuery, DtcBrandRuleQueryVariables>;
export const DtcViewBrandByIdDocument = gql`
    query DTCViewBrandById($shopId: MongoID!) {
  ShopById(_id: $shopId) {
    ...DTCShopFragment
  }
}
    ${DtcShopFragmentDoc}`;

/**
 * __useDtcViewBrandByIdQuery__
 *
 * To run a query within a React component, call `useDtcViewBrandByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useDtcViewBrandByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDtcViewBrandByIdQuery({
 *   variables: {
 *      shopId: // value for 'shopId'
 *   },
 * });
 */
export function useDtcViewBrandByIdQuery(baseOptions: Apollo.QueryHookOptions<DtcViewBrandByIdQuery, DtcViewBrandByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DtcViewBrandByIdQuery, DtcViewBrandByIdQueryVariables>(DtcViewBrandByIdDocument, options);
      }
export function useDtcViewBrandByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DtcViewBrandByIdQuery, DtcViewBrandByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DtcViewBrandByIdQuery, DtcViewBrandByIdQueryVariables>(DtcViewBrandByIdDocument, options);
        }
export type DtcViewBrandByIdQueryHookResult = ReturnType<typeof useDtcViewBrandByIdQuery>;
export type DtcViewBrandByIdLazyQueryHookResult = ReturnType<typeof useDtcViewBrandByIdLazyQuery>;
export type DtcViewBrandByIdQueryResult = Apollo.QueryResult<DtcViewBrandByIdQuery, DtcViewBrandByIdQueryVariables>;
export const BrandRuleActivationDocument = gql`
    mutation BrandRuleActivation($shopId: MongoID!, $ruleId: MongoID!, $active: Boolean!, $auditNoteId: MongoID) {
  BrandRuleActivation(
    shopId: $shopId
    ruleId: $ruleId
    active: $active
    auditNoteId: $auditNoteId
  ) {
    _id
    active
  }
}
    `;
export type BrandRuleActivationMutationFn = Apollo.MutationFunction<BrandRuleActivationMutation, BrandRuleActivationMutationVariables>;

/**
 * __useBrandRuleActivationMutation__
 *
 * To run a mutation, you first call `useBrandRuleActivationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBrandRuleActivationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [brandRuleActivationMutation, { data, loading, error }] = useBrandRuleActivationMutation({
 *   variables: {
 *      shopId: // value for 'shopId'
 *      ruleId: // value for 'ruleId'
 *      active: // value for 'active'
 *      auditNoteId: // value for 'auditNoteId'
 *   },
 * });
 */
export function useBrandRuleActivationMutation(baseOptions?: Apollo.MutationHookOptions<BrandRuleActivationMutation, BrandRuleActivationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BrandRuleActivationMutation, BrandRuleActivationMutationVariables>(BrandRuleActivationDocument, options);
      }
export type BrandRuleActivationMutationHookResult = ReturnType<typeof useBrandRuleActivationMutation>;
export type BrandRuleActivationMutationResult = Apollo.MutationResult<BrandRuleActivationMutation>;
export type BrandRuleActivationMutationOptions = Apollo.BaseMutationOptions<BrandRuleActivationMutation, BrandRuleActivationMutationVariables>;
export const BrandRuleCreateDocument = gql`
    mutation BrandRuleCreate($shopId: MongoID!, $auditNoteId: MongoID) {
  BrandRuleCreate(shopId: $shopId, auditNoteId: $auditNoteId) {
    ...BrandRuleFragmentCreate
  }
}
    ${BrandRuleFragmentCreateFragmentDoc}`;
export type BrandRuleCreateMutationFn = Apollo.MutationFunction<BrandRuleCreateMutation, BrandRuleCreateMutationVariables>;

/**
 * __useBrandRuleCreateMutation__
 *
 * To run a mutation, you first call `useBrandRuleCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBrandRuleCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [brandRuleCreateMutation, { data, loading, error }] = useBrandRuleCreateMutation({
 *   variables: {
 *      shopId: // value for 'shopId'
 *      auditNoteId: // value for 'auditNoteId'
 *   },
 * });
 */
export function useBrandRuleCreateMutation(baseOptions?: Apollo.MutationHookOptions<BrandRuleCreateMutation, BrandRuleCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BrandRuleCreateMutation, BrandRuleCreateMutationVariables>(BrandRuleCreateDocument, options);
      }
export type BrandRuleCreateMutationHookResult = ReturnType<typeof useBrandRuleCreateMutation>;
export type BrandRuleCreateMutationResult = Apollo.MutationResult<BrandRuleCreateMutation>;
export type BrandRuleCreateMutationOptions = Apollo.BaseMutationOptions<BrandRuleCreateMutation, BrandRuleCreateMutationVariables>;
export const BrandRuleStatisticsDocument = gql`
    query brandRuleStatistics($brandRuleId: MongoID!) {
  BrandRule(_id: $brandRuleId) {
    _id
    shopId
    statistics {
      items
      itemsTotal
      consumers
      consumersTotal
      sendingFuture
      sendingNow
      voucherSum
      voucherTotal
    }
  }
}
    `;

/**
 * __useBrandRuleStatisticsQuery__
 *
 * To run a query within a React component, call `useBrandRuleStatisticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBrandRuleStatisticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBrandRuleStatisticsQuery({
 *   variables: {
 *      brandRuleId: // value for 'brandRuleId'
 *   },
 * });
 */
export function useBrandRuleStatisticsQuery(baseOptions: Apollo.QueryHookOptions<BrandRuleStatisticsQuery, BrandRuleStatisticsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BrandRuleStatisticsQuery, BrandRuleStatisticsQueryVariables>(BrandRuleStatisticsDocument, options);
      }
export function useBrandRuleStatisticsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BrandRuleStatisticsQuery, BrandRuleStatisticsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BrandRuleStatisticsQuery, BrandRuleStatisticsQueryVariables>(BrandRuleStatisticsDocument, options);
        }
export type BrandRuleStatisticsQueryHookResult = ReturnType<typeof useBrandRuleStatisticsQuery>;
export type BrandRuleStatisticsLazyQueryHookResult = ReturnType<typeof useBrandRuleStatisticsLazyQuery>;
export type BrandRuleStatisticsQueryResult = Apollo.QueryResult<BrandRuleStatisticsQuery, BrandRuleStatisticsQueryVariables>;
export const DtcSendMailsDocument = gql`
    mutation DTCSendMails($shopId: MongoID!) {
  PotentialDistribute(shopId: $shopId)
}
    `;
export type DtcSendMailsMutationFn = Apollo.MutationFunction<DtcSendMailsMutation, DtcSendMailsMutationVariables>;

/**
 * __useDtcSendMailsMutation__
 *
 * To run a mutation, you first call `useDtcSendMailsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDtcSendMailsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [dtcSendMailsMutation, { data, loading, error }] = useDtcSendMailsMutation({
 *   variables: {
 *      shopId: // value for 'shopId'
 *   },
 * });
 */
export function useDtcSendMailsMutation(baseOptions?: Apollo.MutationHookOptions<DtcSendMailsMutation, DtcSendMailsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DtcSendMailsMutation, DtcSendMailsMutationVariables>(DtcSendMailsDocument, options);
      }
export type DtcSendMailsMutationHookResult = ReturnType<typeof useDtcSendMailsMutation>;
export type DtcSendMailsMutationResult = Apollo.MutationResult<DtcSendMailsMutation>;
export type DtcSendMailsMutationOptions = Apollo.BaseMutationOptions<DtcSendMailsMutation, DtcSendMailsMutationVariables>;
export const DtcRebuildStatisticsDocument = gql`
    mutation DTCRebuildStatistics($shopId: MongoID!) {
  BrandRuleUpdateStatistics(shopId: $shopId)
}
    `;
export type DtcRebuildStatisticsMutationFn = Apollo.MutationFunction<DtcRebuildStatisticsMutation, DtcRebuildStatisticsMutationVariables>;

/**
 * __useDtcRebuildStatisticsMutation__
 *
 * To run a mutation, you first call `useDtcRebuildStatisticsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDtcRebuildStatisticsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [dtcRebuildStatisticsMutation, { data, loading, error }] = useDtcRebuildStatisticsMutation({
 *   variables: {
 *      shopId: // value for 'shopId'
 *   },
 * });
 */
export function useDtcRebuildStatisticsMutation(baseOptions?: Apollo.MutationHookOptions<DtcRebuildStatisticsMutation, DtcRebuildStatisticsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DtcRebuildStatisticsMutation, DtcRebuildStatisticsMutationVariables>(DtcRebuildStatisticsDocument, options);
      }
export type DtcRebuildStatisticsMutationHookResult = ReturnType<typeof useDtcRebuildStatisticsMutation>;
export type DtcRebuildStatisticsMutationResult = Apollo.MutationResult<DtcRebuildStatisticsMutation>;
export type DtcRebuildStatisticsMutationOptions = Apollo.BaseMutationOptions<DtcRebuildStatisticsMutation, DtcRebuildStatisticsMutationVariables>;
export const DtcPotentialsListPaginationDocument = gql`
    query DTCPotentialsListPagination($search: String, $filter: FilterFindManyPotentialInput, $sort: SortFindManyPotentialInput, $page: Int, $perPage: Int, $brandRuleId: MongoID!) {
  PotentialsDTCPagination(
    search: $search
    filter: $filter
    sort: $sort
    page: $page
    perPage: $perPage
  ) {
    count
    pageInfo {
      perPage
      currentPage
      hasNextPage
      hasPreviousPage
      itemCount
      pageCount
    }
    items {
      ...DTCFragment
    }
  }
}
    ${DtcFragmentDoc}`;

/**
 * __useDtcPotentialsListPaginationQuery__
 *
 * To run a query within a React component, call `useDtcPotentialsListPaginationQuery` and pass it any options that fit your needs.
 * When your component renders, `useDtcPotentialsListPaginationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDtcPotentialsListPaginationQuery({
 *   variables: {
 *      search: // value for 'search'
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *      brandRuleId: // value for 'brandRuleId'
 *   },
 * });
 */
export function useDtcPotentialsListPaginationQuery(baseOptions: Apollo.QueryHookOptions<DtcPotentialsListPaginationQuery, DtcPotentialsListPaginationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DtcPotentialsListPaginationQuery, DtcPotentialsListPaginationQueryVariables>(DtcPotentialsListPaginationDocument, options);
      }
export function useDtcPotentialsListPaginationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DtcPotentialsListPaginationQuery, DtcPotentialsListPaginationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DtcPotentialsListPaginationQuery, DtcPotentialsListPaginationQueryVariables>(DtcPotentialsListPaginationDocument, options);
        }
export type DtcPotentialsListPaginationQueryHookResult = ReturnType<typeof useDtcPotentialsListPaginationQuery>;
export type DtcPotentialsListPaginationLazyQueryHookResult = ReturnType<typeof useDtcPotentialsListPaginationLazyQuery>;
export type DtcPotentialsListPaginationQueryResult = Apollo.QueryResult<DtcPotentialsListPaginationQuery, DtcPotentialsListPaginationQueryVariables>;
export const OrderPageSynchronzieOrderDocument = gql`
    mutation OrderPageSynchronzieOrder($shopId: String!, $service: String!, $externalId: String) {
  StartSynchronize(shopId: $shopId, service: $service, externalId: $externalId) {
    status
  }
}
    `;
export type OrderPageSynchronzieOrderMutationFn = Apollo.MutationFunction<OrderPageSynchronzieOrderMutation, OrderPageSynchronzieOrderMutationVariables>;

/**
 * __useOrderPageSynchronzieOrderMutation__
 *
 * To run a mutation, you first call `useOrderPageSynchronzieOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOrderPageSynchronzieOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [orderPageSynchronzieOrderMutation, { data, loading, error }] = useOrderPageSynchronzieOrderMutation({
 *   variables: {
 *      shopId: // value for 'shopId'
 *      service: // value for 'service'
 *      externalId: // value for 'externalId'
 *   },
 * });
 */
export function useOrderPageSynchronzieOrderMutation(baseOptions?: Apollo.MutationHookOptions<OrderPageSynchronzieOrderMutation, OrderPageSynchronzieOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OrderPageSynchronzieOrderMutation, OrderPageSynchronzieOrderMutationVariables>(OrderPageSynchronzieOrderDocument, options);
      }
export type OrderPageSynchronzieOrderMutationHookResult = ReturnType<typeof useOrderPageSynchronzieOrderMutation>;
export type OrderPageSynchronzieOrderMutationResult = Apollo.MutationResult<OrderPageSynchronzieOrderMutation>;
export type OrderPageSynchronzieOrderMutationOptions = Apollo.BaseMutationOptions<OrderPageSynchronzieOrderMutation, OrderPageSynchronzieOrderMutationVariables>;
export const OrderPageBrandDocument = gql`
    query OrderPageBrand($id: MongoID!) {
  ShopById(_id: $id) {
    _id
    currency
    brandHouseId
    logisticsPartnerId
  }
}
    `;

/**
 * __useOrderPageBrandQuery__
 *
 * To run a query within a React component, call `useOrderPageBrandQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrderPageBrandQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrderPageBrandQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useOrderPageBrandQuery(baseOptions: Apollo.QueryHookOptions<OrderPageBrandQuery, OrderPageBrandQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrderPageBrandQuery, OrderPageBrandQueryVariables>(OrderPageBrandDocument, options);
      }
export function useOrderPageBrandLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrderPageBrandQuery, OrderPageBrandQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrderPageBrandQuery, OrderPageBrandQueryVariables>(OrderPageBrandDocument, options);
        }
export type OrderPageBrandQueryHookResult = ReturnType<typeof useOrderPageBrandQuery>;
export type OrderPageBrandLazyQueryHookResult = ReturnType<typeof useOrderPageBrandLazyQuery>;
export type OrderPageBrandQueryResult = Apollo.QueryResult<OrderPageBrandQuery, OrderPageBrandQueryVariables>;
export const OrderPageOrderDocument = gql`
    query OrderPageOrder($id: String!) {
  Order(id: $id) {
    ...OrderPageFragment
  }
}
    ${OrderPageFragmentDoc}`;

/**
 * __useOrderPageOrderQuery__
 *
 * To run a query within a React component, call `useOrderPageOrderQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrderPageOrderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrderPageOrderQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useOrderPageOrderQuery(baseOptions: Apollo.QueryHookOptions<OrderPageOrderQuery, OrderPageOrderQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrderPageOrderQuery, OrderPageOrderQueryVariables>(OrderPageOrderDocument, options);
      }
export function useOrderPageOrderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrderPageOrderQuery, OrderPageOrderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrderPageOrderQuery, OrderPageOrderQueryVariables>(OrderPageOrderDocument, options);
        }
export type OrderPageOrderQueryHookResult = ReturnType<typeof useOrderPageOrderQuery>;
export type OrderPageOrderLazyQueryHookResult = ReturnType<typeof useOrderPageOrderLazyQuery>;
export type OrderPageOrderQueryResult = Apollo.QueryResult<OrderPageOrderQuery, OrderPageOrderQueryVariables>;
export const OrderPageOrderUpdateDocument = gql`
    mutation OrderPageOrderUpdate($shopId: String!, $order: OrderUpdateInput2!) {
  OrderUpdate(shopId: $shopId, order: $order) {
    ...OrderPageFragment
  }
}
    ${OrderPageFragmentDoc}`;
export type OrderPageOrderUpdateMutationFn = Apollo.MutationFunction<OrderPageOrderUpdateMutation, OrderPageOrderUpdateMutationVariables>;

/**
 * __useOrderPageOrderUpdateMutation__
 *
 * To run a mutation, you first call `useOrderPageOrderUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOrderPageOrderUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [orderPageOrderUpdateMutation, { data, loading, error }] = useOrderPageOrderUpdateMutation({
 *   variables: {
 *      shopId: // value for 'shopId'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useOrderPageOrderUpdateMutation(baseOptions?: Apollo.MutationHookOptions<OrderPageOrderUpdateMutation, OrderPageOrderUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OrderPageOrderUpdateMutation, OrderPageOrderUpdateMutationVariables>(OrderPageOrderUpdateDocument, options);
      }
export type OrderPageOrderUpdateMutationHookResult = ReturnType<typeof useOrderPageOrderUpdateMutation>;
export type OrderPageOrderUpdateMutationResult = Apollo.MutationResult<OrderPageOrderUpdateMutation>;
export type OrderPageOrderUpdateMutationOptions = Apollo.BaseMutationOptions<OrderPageOrderUpdateMutation, OrderPageOrderUpdateMutationVariables>;
export const OrderSynchronizeDocument = gql`
    mutation OrderSynchronize($input: OrderSynchronizeInput!) {
  OrderSynchronize(order: $input, mode: MERGE) {
    ...OrderPageFragment
  }
}
    ${OrderPageFragmentDoc}`;
export type OrderSynchronizeMutationFn = Apollo.MutationFunction<OrderSynchronizeMutation, OrderSynchronizeMutationVariables>;

/**
 * __useOrderSynchronizeMutation__
 *
 * To run a mutation, you first call `useOrderSynchronizeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOrderSynchronizeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [orderSynchronizeMutation, { data, loading, error }] = useOrderSynchronizeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useOrderSynchronizeMutation(baseOptions?: Apollo.MutationHookOptions<OrderSynchronizeMutation, OrderSynchronizeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OrderSynchronizeMutation, OrderSynchronizeMutationVariables>(OrderSynchronizeDocument, options);
      }
export type OrderSynchronizeMutationHookResult = ReturnType<typeof useOrderSynchronizeMutation>;
export type OrderSynchronizeMutationResult = Apollo.MutationResult<OrderSynchronizeMutation>;
export type OrderSynchronizeMutationOptions = Apollo.BaseMutationOptions<OrderSynchronizeMutation, OrderSynchronizeMutationVariables>;
export const PrintDeliveryNoteDocument = gql`
    mutation PrintDeliveryNote($orderId: MongoID!) {
  OrderPrintDeliveryNote(orderId: $orderId)
}
    `;
export type PrintDeliveryNoteMutationFn = Apollo.MutationFunction<PrintDeliveryNoteMutation, PrintDeliveryNoteMutationVariables>;

/**
 * __usePrintDeliveryNoteMutation__
 *
 * To run a mutation, you first call `usePrintDeliveryNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePrintDeliveryNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [printDeliveryNoteMutation, { data, loading, error }] = usePrintDeliveryNoteMutation({
 *   variables: {
 *      orderId: // value for 'orderId'
 *   },
 * });
 */
export function usePrintDeliveryNoteMutation(baseOptions?: Apollo.MutationHookOptions<PrintDeliveryNoteMutation, PrintDeliveryNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PrintDeliveryNoteMutation, PrintDeliveryNoteMutationVariables>(PrintDeliveryNoteDocument, options);
      }
export type PrintDeliveryNoteMutationHookResult = ReturnType<typeof usePrintDeliveryNoteMutation>;
export type PrintDeliveryNoteMutationResult = Apollo.MutationResult<PrintDeliveryNoteMutation>;
export type PrintDeliveryNoteMutationOptions = Apollo.BaseMutationOptions<PrintDeliveryNoteMutation, PrintDeliveryNoteMutationVariables>;
export const OrderPageIntegrationInstancesDocument = gql`
    query OrderPageIntegrationInstances($filter: FilterFindManyIntegrationInstanceInput) {
  IntegrationInstances(filter: $filter) {
    _id
    name
    refType
    connector {
      messages
    }
  }
}
    `;

/**
 * __useOrderPageIntegrationInstancesQuery__
 *
 * To run a query within a React component, call `useOrderPageIntegrationInstancesQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrderPageIntegrationInstancesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrderPageIntegrationInstancesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useOrderPageIntegrationInstancesQuery(baseOptions?: Apollo.QueryHookOptions<OrderPageIntegrationInstancesQuery, OrderPageIntegrationInstancesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrderPageIntegrationInstancesQuery, OrderPageIntegrationInstancesQueryVariables>(OrderPageIntegrationInstancesDocument, options);
      }
export function useOrderPageIntegrationInstancesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrderPageIntegrationInstancesQuery, OrderPageIntegrationInstancesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrderPageIntegrationInstancesQuery, OrderPageIntegrationInstancesQueryVariables>(OrderPageIntegrationInstancesDocument, options);
        }
export type OrderPageIntegrationInstancesQueryHookResult = ReturnType<typeof useOrderPageIntegrationInstancesQuery>;
export type OrderPageIntegrationInstancesLazyQueryHookResult = ReturnType<typeof useOrderPageIntegrationInstancesLazyQuery>;
export type OrderPageIntegrationInstancesQueryResult = Apollo.QueryResult<OrderPageIntegrationInstancesQuery, OrderPageIntegrationInstancesQueryVariables>;
export const OrderPageResendCreateDocument = gql`
    mutation OrderPageResendCreate($orderId: MongoID!, $instanceId: MongoID!) {
  OrderResendCreate(orderId: $orderId, instanceId: $instanceId)
}
    `;
export type OrderPageResendCreateMutationFn = Apollo.MutationFunction<OrderPageResendCreateMutation, OrderPageResendCreateMutationVariables>;

/**
 * __useOrderPageResendCreateMutation__
 *
 * To run a mutation, you first call `useOrderPageResendCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOrderPageResendCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [orderPageResendCreateMutation, { data, loading, error }] = useOrderPageResendCreateMutation({
 *   variables: {
 *      orderId: // value for 'orderId'
 *      instanceId: // value for 'instanceId'
 *   },
 * });
 */
export function useOrderPageResendCreateMutation(baseOptions?: Apollo.MutationHookOptions<OrderPageResendCreateMutation, OrderPageResendCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OrderPageResendCreateMutation, OrderPageResendCreateMutationVariables>(OrderPageResendCreateDocument, options);
      }
export type OrderPageResendCreateMutationHookResult = ReturnType<typeof useOrderPageResendCreateMutation>;
export type OrderPageResendCreateMutationResult = Apollo.MutationResult<OrderPageResendCreateMutation>;
export type OrderPageResendCreateMutationOptions = Apollo.BaseMutationOptions<OrderPageResendCreateMutation, OrderPageResendCreateMutationVariables>;
export const OrderPageIntegrationMessageStatusDocument = gql`
    query OrderPageIntegrationMessageStatus($tokens: [String!]!) {
  IntegrationMessage(tokens: $tokens) {
    resultTs
    messageFailed
    messageIgnored
  }
}
    `;

/**
 * __useOrderPageIntegrationMessageStatusQuery__
 *
 * To run a query within a React component, call `useOrderPageIntegrationMessageStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrderPageIntegrationMessageStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrderPageIntegrationMessageStatusQuery({
 *   variables: {
 *      tokens: // value for 'tokens'
 *   },
 * });
 */
export function useOrderPageIntegrationMessageStatusQuery(baseOptions: Apollo.QueryHookOptions<OrderPageIntegrationMessageStatusQuery, OrderPageIntegrationMessageStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrderPageIntegrationMessageStatusQuery, OrderPageIntegrationMessageStatusQueryVariables>(OrderPageIntegrationMessageStatusDocument, options);
      }
export function useOrderPageIntegrationMessageStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrderPageIntegrationMessageStatusQuery, OrderPageIntegrationMessageStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrderPageIntegrationMessageStatusQuery, OrderPageIntegrationMessageStatusQueryVariables>(OrderPageIntegrationMessageStatusDocument, options);
        }
export type OrderPageIntegrationMessageStatusQueryHookResult = ReturnType<typeof useOrderPageIntegrationMessageStatusQuery>;
export type OrderPageIntegrationMessageStatusLazyQueryHookResult = ReturnType<typeof useOrderPageIntegrationMessageStatusLazyQuery>;
export type OrderPageIntegrationMessageStatusQueryResult = Apollo.QueryResult<OrderPageIntegrationMessageStatusQuery, OrderPageIntegrationMessageStatusQueryVariables>;
export const OrderPageUpdateBrandItemDocument = gql`
    mutation OrderPageUpdateBrandItem($brandHouseId: MongoID!, $input: BrandItemInputInput!) {
  BrandItemUpdate(brandHouseId: $brandHouseId, input: $input) {
    _id
    unavailable
  }
}
    `;
export type OrderPageUpdateBrandItemMutationFn = Apollo.MutationFunction<OrderPageUpdateBrandItemMutation, OrderPageUpdateBrandItemMutationVariables>;

/**
 * __useOrderPageUpdateBrandItemMutation__
 *
 * To run a mutation, you first call `useOrderPageUpdateBrandItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOrderPageUpdateBrandItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [orderPageUpdateBrandItemMutation, { data, loading, error }] = useOrderPageUpdateBrandItemMutation({
 *   variables: {
 *      brandHouseId: // value for 'brandHouseId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useOrderPageUpdateBrandItemMutation(baseOptions?: Apollo.MutationHookOptions<OrderPageUpdateBrandItemMutation, OrderPageUpdateBrandItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OrderPageUpdateBrandItemMutation, OrderPageUpdateBrandItemMutationVariables>(OrderPageUpdateBrandItemDocument, options);
      }
export type OrderPageUpdateBrandItemMutationHookResult = ReturnType<typeof useOrderPageUpdateBrandItemMutation>;
export type OrderPageUpdateBrandItemMutationResult = Apollo.MutationResult<OrderPageUpdateBrandItemMutation>;
export type OrderPageUpdateBrandItemMutationOptions = Apollo.BaseMutationOptions<OrderPageUpdateBrandItemMutation, OrderPageUpdateBrandItemMutationVariables>;
export const OrderResetReturnDocument = gql`
    mutation OrderResetReturn($orderId: MongoID!) {
  OrderResetReturn(orderId: $orderId) {
    ...OrderPageFragment
  }
}
    ${OrderPageFragmentDoc}`;
export type OrderResetReturnMutationFn = Apollo.MutationFunction<OrderResetReturnMutation, OrderResetReturnMutationVariables>;

/**
 * __useOrderResetReturnMutation__
 *
 * To run a mutation, you first call `useOrderResetReturnMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOrderResetReturnMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [orderResetReturnMutation, { data, loading, error }] = useOrderResetReturnMutation({
 *   variables: {
 *      orderId: // value for 'orderId'
 *   },
 * });
 */
export function useOrderResetReturnMutation(baseOptions?: Apollo.MutationHookOptions<OrderResetReturnMutation, OrderResetReturnMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OrderResetReturnMutation, OrderResetReturnMutationVariables>(OrderResetReturnDocument, options);
      }
export type OrderResetReturnMutationHookResult = ReturnType<typeof useOrderResetReturnMutation>;
export type OrderResetReturnMutationResult = Apollo.MutationResult<OrderResetReturnMutation>;
export type OrderResetReturnMutationOptions = Apollo.BaseMutationOptions<OrderResetReturnMutation, OrderResetReturnMutationVariables>;
export const OrderUpdateReasonsDocument = gql`
    query orderUpdateReasons($brandHouseId: MongoID!, $target: EnumOptionSetTarget!) {
  Options(filter: {refId: $brandHouseId, refType: BRANDHOUSE, target: $target}) {
    ...ReasonOptionFragment
  }
}
    ${ReasonOptionFragmentDoc}`;

/**
 * __useOrderUpdateReasonsQuery__
 *
 * To run a query within a React component, call `useOrderUpdateReasonsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrderUpdateReasonsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrderUpdateReasonsQuery({
 *   variables: {
 *      brandHouseId: // value for 'brandHouseId'
 *      target: // value for 'target'
 *   },
 * });
 */
export function useOrderUpdateReasonsQuery(baseOptions: Apollo.QueryHookOptions<OrderUpdateReasonsQuery, OrderUpdateReasonsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrderUpdateReasonsQuery, OrderUpdateReasonsQueryVariables>(OrderUpdateReasonsDocument, options);
      }
export function useOrderUpdateReasonsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrderUpdateReasonsQuery, OrderUpdateReasonsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrderUpdateReasonsQuery, OrderUpdateReasonsQueryVariables>(OrderUpdateReasonsDocument, options);
        }
export type OrderUpdateReasonsQueryHookResult = ReturnType<typeof useOrderUpdateReasonsQuery>;
export type OrderUpdateReasonsLazyQueryHookResult = ReturnType<typeof useOrderUpdateReasonsLazyQuery>;
export type OrderUpdateReasonsQueryResult = Apollo.QueryResult<OrderUpdateReasonsQuery, OrderUpdateReasonsQueryVariables>;
export const ParcelsListDocument = gql`
    query ParcelsList($search: String, $filter: FilterFindManyParcelInput, $sort: SortFindManyParcelInput, $page: Int, $perPage: Int) {
  ParcelsPagination(
    search: $search
    filter: $filter
    sort: $sort
    page: $page
    perPage: $perPage
  ) {
    count
    pageInfo {
      perPage
      currentPage
      hasNextPage
      hasPreviousPage
      itemCount
      pageCount
    }
    items {
      ...ParcelFragment
    }
  }
}
    ${ParcelFragmentDoc}`;

/**
 * __useParcelsListQuery__
 *
 * To run a query within a React component, call `useParcelsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useParcelsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useParcelsListQuery({
 *   variables: {
 *      search: // value for 'search'
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *   },
 * });
 */
export function useParcelsListQuery(baseOptions?: Apollo.QueryHookOptions<ParcelsListQuery, ParcelsListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ParcelsListQuery, ParcelsListQueryVariables>(ParcelsListDocument, options);
      }
export function useParcelsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ParcelsListQuery, ParcelsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ParcelsListQuery, ParcelsListQueryVariables>(ParcelsListDocument, options);
        }
export type ParcelsListQueryHookResult = ReturnType<typeof useParcelsListQuery>;
export type ParcelsListLazyQueryHookResult = ReturnType<typeof useParcelsListLazyQuery>;
export type ParcelsListQueryResult = Apollo.QueryResult<ParcelsListQuery, ParcelsListQueryVariables>;
export const ParcelShopNameDocument = gql`
    query ParcelShopName($id: MongoID!) {
  ShopById(_id: $id) {
    _id
    name
  }
}
    `;

/**
 * __useParcelShopNameQuery__
 *
 * To run a query within a React component, call `useParcelShopNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useParcelShopNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useParcelShopNameQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useParcelShopNameQuery(baseOptions: Apollo.QueryHookOptions<ParcelShopNameQuery, ParcelShopNameQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ParcelShopNameQuery, ParcelShopNameQueryVariables>(ParcelShopNameDocument, options);
      }
export function useParcelShopNameLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ParcelShopNameQuery, ParcelShopNameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ParcelShopNameQuery, ParcelShopNameQueryVariables>(ParcelShopNameDocument, options);
        }
export type ParcelShopNameQueryHookResult = ReturnType<typeof useParcelShopNameQuery>;
export type ParcelShopNameLazyQueryHookResult = ReturnType<typeof useParcelShopNameLazyQuery>;
export type ParcelShopNameQueryResult = Apollo.QueryResult<ParcelShopNameQuery, ParcelShopNameQueryVariables>;
export const ParcelLogisticsPartnerNameDocument = gql`
    query ParcelLogisticsPartnerName($id: MongoID!) {
  LogisticsPartner(_id: $id) {
    _id
    name
  }
}
    `;

/**
 * __useParcelLogisticsPartnerNameQuery__
 *
 * To run a query within a React component, call `useParcelLogisticsPartnerNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useParcelLogisticsPartnerNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useParcelLogisticsPartnerNameQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useParcelLogisticsPartnerNameQuery(baseOptions: Apollo.QueryHookOptions<ParcelLogisticsPartnerNameQuery, ParcelLogisticsPartnerNameQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ParcelLogisticsPartnerNameQuery, ParcelLogisticsPartnerNameQueryVariables>(ParcelLogisticsPartnerNameDocument, options);
      }
export function useParcelLogisticsPartnerNameLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ParcelLogisticsPartnerNameQuery, ParcelLogisticsPartnerNameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ParcelLogisticsPartnerNameQuery, ParcelLogisticsPartnerNameQueryVariables>(ParcelLogisticsPartnerNameDocument, options);
        }
export type ParcelLogisticsPartnerNameQueryHookResult = ReturnType<typeof useParcelLogisticsPartnerNameQuery>;
export type ParcelLogisticsPartnerNameLazyQueryHookResult = ReturnType<typeof useParcelLogisticsPartnerNameLazyQuery>;
export type ParcelLogisticsPartnerNameQueryResult = Apollo.QueryResult<ParcelLogisticsPartnerNameQuery, ParcelLogisticsPartnerNameQueryVariables>;
export const ParcelsPageDocument = gql`
    query ParcelsPage($shopId: MongoID!) {
  Parcels(filter: {shopId: $shopId}) {
    ...ParcelFragment
  }
}
    ${ParcelFragmentDoc}`;

/**
 * __useParcelsPageQuery__
 *
 * To run a query within a React component, call `useParcelsPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useParcelsPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useParcelsPageQuery({
 *   variables: {
 *      shopId: // value for 'shopId'
 *   },
 * });
 */
export function useParcelsPageQuery(baseOptions: Apollo.QueryHookOptions<ParcelsPageQuery, ParcelsPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ParcelsPageQuery, ParcelsPageQueryVariables>(ParcelsPageDocument, options);
      }
export function useParcelsPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ParcelsPageQuery, ParcelsPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ParcelsPageQuery, ParcelsPageQueryVariables>(ParcelsPageDocument, options);
        }
export type ParcelsPageQueryHookResult = ReturnType<typeof useParcelsPageQuery>;
export type ParcelsPageLazyQueryHookResult = ReturnType<typeof useParcelsPageLazyQuery>;
export type ParcelsPageQueryResult = Apollo.QueryResult<ParcelsPageQuery, ParcelsPageQueryVariables>;
export const ParcelsPageCreateDocument = gql`
    mutation ParcelsPageCreate($input: CreateOneParcelInput!) {
  ParcelCreate(record: $input) {
    record {
      ...ParcelFragment
    }
    recordId
  }
}
    ${ParcelFragmentDoc}`;
export type ParcelsPageCreateMutationFn = Apollo.MutationFunction<ParcelsPageCreateMutation, ParcelsPageCreateMutationVariables>;

/**
 * __useParcelsPageCreateMutation__
 *
 * To run a mutation, you first call `useParcelsPageCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useParcelsPageCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [parcelsPageCreateMutation, { data, loading, error }] = useParcelsPageCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useParcelsPageCreateMutation(baseOptions?: Apollo.MutationHookOptions<ParcelsPageCreateMutation, ParcelsPageCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ParcelsPageCreateMutation, ParcelsPageCreateMutationVariables>(ParcelsPageCreateDocument, options);
      }
export type ParcelsPageCreateMutationHookResult = ReturnType<typeof useParcelsPageCreateMutation>;
export type ParcelsPageCreateMutationResult = Apollo.MutationResult<ParcelsPageCreateMutation>;
export type ParcelsPageCreateMutationOptions = Apollo.BaseMutationOptions<ParcelsPageCreateMutation, ParcelsPageCreateMutationVariables>;
export const ParcelsPageCarriersDocument = gql`
    query ParcelsPageCarriers($shopId: MongoID!, $receiver: ShippingCarriersForParcelReceiverInput) {
  ShippingCarriersForParcel(shopId: $shopId, receiver: $receiver) {
    _id
    name
    logo
  }
}
    `;

/**
 * __useParcelsPageCarriersQuery__
 *
 * To run a query within a React component, call `useParcelsPageCarriersQuery` and pass it any options that fit your needs.
 * When your component renders, `useParcelsPageCarriersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useParcelsPageCarriersQuery({
 *   variables: {
 *      shopId: // value for 'shopId'
 *      receiver: // value for 'receiver'
 *   },
 * });
 */
export function useParcelsPageCarriersQuery(baseOptions: Apollo.QueryHookOptions<ParcelsPageCarriersQuery, ParcelsPageCarriersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ParcelsPageCarriersQuery, ParcelsPageCarriersQueryVariables>(ParcelsPageCarriersDocument, options);
      }
export function useParcelsPageCarriersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ParcelsPageCarriersQuery, ParcelsPageCarriersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ParcelsPageCarriersQuery, ParcelsPageCarriersQueryVariables>(ParcelsPageCarriersDocument, options);
        }
export type ParcelsPageCarriersQueryHookResult = ReturnType<typeof useParcelsPageCarriersQuery>;
export type ParcelsPageCarriersLazyQueryHookResult = ReturnType<typeof useParcelsPageCarriersLazyQuery>;
export type ParcelsPageCarriersQueryResult = Apollo.QueryResult<ParcelsPageCarriersQuery, ParcelsPageCarriersQueryVariables>;
export const ParcelsPageShopsDocument = gql`
    query ParcelsPageShops($brandHouseId: MongoID!) {
  ShopMany(filter: {brandHouseId: $brandHouseId}) {
    _id
    name
    logisticsPartnerId
  }
}
    `;

/**
 * __useParcelsPageShopsQuery__
 *
 * To run a query within a React component, call `useParcelsPageShopsQuery` and pass it any options that fit your needs.
 * When your component renders, `useParcelsPageShopsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useParcelsPageShopsQuery({
 *   variables: {
 *      brandHouseId: // value for 'brandHouseId'
 *   },
 * });
 */
export function useParcelsPageShopsQuery(baseOptions: Apollo.QueryHookOptions<ParcelsPageShopsQuery, ParcelsPageShopsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ParcelsPageShopsQuery, ParcelsPageShopsQueryVariables>(ParcelsPageShopsDocument, options);
      }
export function useParcelsPageShopsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ParcelsPageShopsQuery, ParcelsPageShopsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ParcelsPageShopsQuery, ParcelsPageShopsQueryVariables>(ParcelsPageShopsDocument, options);
        }
export type ParcelsPageShopsQueryHookResult = ReturnType<typeof useParcelsPageShopsQuery>;
export type ParcelsPageShopsLazyQueryHookResult = ReturnType<typeof useParcelsPageShopsLazyQuery>;
export type ParcelsPageShopsQueryResult = Apollo.QueryResult<ParcelsPageShopsQuery, ParcelsPageShopsQueryVariables>;
export const ParcelsPageLogisticsPartnerDocument = gql`
    query ParcelsPageLogisticsPartner($id: MongoID!) {
  LogisticsPartner(_id: $id) {
    _id
    countryCode
  }
}
    `;

/**
 * __useParcelsPageLogisticsPartnerQuery__
 *
 * To run a query within a React component, call `useParcelsPageLogisticsPartnerQuery` and pass it any options that fit your needs.
 * When your component renders, `useParcelsPageLogisticsPartnerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useParcelsPageLogisticsPartnerQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useParcelsPageLogisticsPartnerQuery(baseOptions: Apollo.QueryHookOptions<ParcelsPageLogisticsPartnerQuery, ParcelsPageLogisticsPartnerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ParcelsPageLogisticsPartnerQuery, ParcelsPageLogisticsPartnerQueryVariables>(ParcelsPageLogisticsPartnerDocument, options);
      }
export function useParcelsPageLogisticsPartnerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ParcelsPageLogisticsPartnerQuery, ParcelsPageLogisticsPartnerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ParcelsPageLogisticsPartnerQuery, ParcelsPageLogisticsPartnerQueryVariables>(ParcelsPageLogisticsPartnerDocument, options);
        }
export type ParcelsPageLogisticsPartnerQueryHookResult = ReturnType<typeof useParcelsPageLogisticsPartnerQuery>;
export type ParcelsPageLogisticsPartnerLazyQueryHookResult = ReturnType<typeof useParcelsPageLogisticsPartnerLazyQuery>;
export type ParcelsPageLogisticsPartnerQueryResult = Apollo.QueryResult<ParcelsPageLogisticsPartnerQuery, ParcelsPageLogisticsPartnerQueryVariables>;
export const IntegrationBrandByIdDocument = gql`
    query IntegrationBrandById($shopId: MongoID!) {
  ShopById(_id: $shopId) {
    _id
    name
    externalId
    synchronizeActions
    synchronizeOrders
    synchronizeProducts
    synchronizeHooks
  }
}
    `;

/**
 * __useIntegrationBrandByIdQuery__
 *
 * To run a query within a React component, call `useIntegrationBrandByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useIntegrationBrandByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIntegrationBrandByIdQuery({
 *   variables: {
 *      shopId: // value for 'shopId'
 *   },
 * });
 */
export function useIntegrationBrandByIdQuery(baseOptions: Apollo.QueryHookOptions<IntegrationBrandByIdQuery, IntegrationBrandByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IntegrationBrandByIdQuery, IntegrationBrandByIdQueryVariables>(IntegrationBrandByIdDocument, options);
      }
export function useIntegrationBrandByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IntegrationBrandByIdQuery, IntegrationBrandByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IntegrationBrandByIdQuery, IntegrationBrandByIdQueryVariables>(IntegrationBrandByIdDocument, options);
        }
export type IntegrationBrandByIdQueryHookResult = ReturnType<typeof useIntegrationBrandByIdQuery>;
export type IntegrationBrandByIdLazyQueryHookResult = ReturnType<typeof useIntegrationBrandByIdLazyQuery>;
export type IntegrationBrandByIdQueryResult = Apollo.QueryResult<IntegrationBrandByIdQuery, IntegrationBrandByIdQueryVariables>;
export const ShopDataPageSynchronizeDocument = gql`
    mutation ShopDataPageSynchronize($shopId: String!, $service: String!) {
  StartSynchronize(shopId: $shopId, service: $service) {
    status
  }
}
    `;
export type ShopDataPageSynchronizeMutationFn = Apollo.MutationFunction<ShopDataPageSynchronizeMutation, ShopDataPageSynchronizeMutationVariables>;

/**
 * __useShopDataPageSynchronizeMutation__
 *
 * To run a mutation, you first call `useShopDataPageSynchronizeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useShopDataPageSynchronizeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [shopDataPageSynchronizeMutation, { data, loading, error }] = useShopDataPageSynchronizeMutation({
 *   variables: {
 *      shopId: // value for 'shopId'
 *      service: // value for 'service'
 *   },
 * });
 */
export function useShopDataPageSynchronizeMutation(baseOptions?: Apollo.MutationHookOptions<ShopDataPageSynchronizeMutation, ShopDataPageSynchronizeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ShopDataPageSynchronizeMutation, ShopDataPageSynchronizeMutationVariables>(ShopDataPageSynchronizeDocument, options);
      }
export type ShopDataPageSynchronizeMutationHookResult = ReturnType<typeof useShopDataPageSynchronizeMutation>;
export type ShopDataPageSynchronizeMutationResult = Apollo.MutationResult<ShopDataPageSynchronizeMutation>;
export type ShopDataPageSynchronizeMutationOptions = Apollo.BaseMutationOptions<ShopDataPageSynchronizeMutation, ShopDataPageSynchronizeMutationVariables>;
export const ConsumerPageFetchPotentialsDocument = gql`
    mutation ConsumerPageFetchPotentials($shopId: MongoID!, $consumerId: MongoID!) {
  ConsumerRequestPotentials(shopId: $shopId, consumerId: $consumerId)
}
    `;
export type ConsumerPageFetchPotentialsMutationFn = Apollo.MutationFunction<ConsumerPageFetchPotentialsMutation, ConsumerPageFetchPotentialsMutationVariables>;

/**
 * __useConsumerPageFetchPotentialsMutation__
 *
 * To run a mutation, you first call `useConsumerPageFetchPotentialsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConsumerPageFetchPotentialsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [consumerPageFetchPotentialsMutation, { data, loading, error }] = useConsumerPageFetchPotentialsMutation({
 *   variables: {
 *      shopId: // value for 'shopId'
 *      consumerId: // value for 'consumerId'
 *   },
 * });
 */
export function useConsumerPageFetchPotentialsMutation(baseOptions?: Apollo.MutationHookOptions<ConsumerPageFetchPotentialsMutation, ConsumerPageFetchPotentialsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConsumerPageFetchPotentialsMutation, ConsumerPageFetchPotentialsMutationVariables>(ConsumerPageFetchPotentialsDocument, options);
      }
export type ConsumerPageFetchPotentialsMutationHookResult = ReturnType<typeof useConsumerPageFetchPotentialsMutation>;
export type ConsumerPageFetchPotentialsMutationResult = Apollo.MutationResult<ConsumerPageFetchPotentialsMutation>;
export type ConsumerPageFetchPotentialsMutationOptions = Apollo.BaseMutationOptions<ConsumerPageFetchPotentialsMutation, ConsumerPageFetchPotentialsMutationVariables>;
export const ConsumerUpdateDocument = gql`
    mutation ConsumerUpdate($input: ConsumerInput!) {
  ConsumerUpdate(consumer: $input) {
    _id
  }
}
    `;
export type ConsumerUpdateMutationFn = Apollo.MutationFunction<ConsumerUpdateMutation, ConsumerUpdateMutationVariables>;

/**
 * __useConsumerUpdateMutation__
 *
 * To run a mutation, you first call `useConsumerUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConsumerUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [consumerUpdateMutation, { data, loading, error }] = useConsumerUpdateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useConsumerUpdateMutation(baseOptions?: Apollo.MutationHookOptions<ConsumerUpdateMutation, ConsumerUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConsumerUpdateMutation, ConsumerUpdateMutationVariables>(ConsumerUpdateDocument, options);
      }
export type ConsumerUpdateMutationHookResult = ReturnType<typeof useConsumerUpdateMutation>;
export type ConsumerUpdateMutationResult = Apollo.MutationResult<ConsumerUpdateMutation>;
export type ConsumerUpdateMutationOptions = Apollo.BaseMutationOptions<ConsumerUpdateMutation, ConsumerUpdateMutationVariables>;
export const ConsumersPageMergeDocument = gql`
    mutation ConsumersPageMerge($consumerIds: [MongoID!]!) {
  ConsumerMerge(consumerIds: $consumerIds) {
    id
  }
}
    `;
export type ConsumersPageMergeMutationFn = Apollo.MutationFunction<ConsumersPageMergeMutation, ConsumersPageMergeMutationVariables>;

/**
 * __useConsumersPageMergeMutation__
 *
 * To run a mutation, you first call `useConsumersPageMergeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConsumersPageMergeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [consumersPageMergeMutation, { data, loading, error }] = useConsumersPageMergeMutation({
 *   variables: {
 *      consumerIds: // value for 'consumerIds'
 *   },
 * });
 */
export function useConsumersPageMergeMutation(baseOptions?: Apollo.MutationHookOptions<ConsumersPageMergeMutation, ConsumersPageMergeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConsumersPageMergeMutation, ConsumersPageMergeMutationVariables>(ConsumersPageMergeDocument, options);
      }
export type ConsumersPageMergeMutationHookResult = ReturnType<typeof useConsumersPageMergeMutation>;
export type ConsumersPageMergeMutationResult = Apollo.MutationResult<ConsumersPageMergeMutation>;
export type ConsumersPageMergeMutationOptions = Apollo.BaseMutationOptions<ConsumersPageMergeMutation, ConsumersPageMergeMutationVariables>;
export const ConsumerRequestAccessDocument = gql`
    mutation ConsumerRequestAccess($shopId: MongoID!, $mail: String!) {
  ConsumerRequestAccessFlow(
    shopId: $shopId
    identifier: $mail
    identifierType: EMAIL
    sendMail: false
  )
}
    `;
export type ConsumerRequestAccessMutationFn = Apollo.MutationFunction<ConsumerRequestAccessMutation, ConsumerRequestAccessMutationVariables>;

/**
 * __useConsumerRequestAccessMutation__
 *
 * To run a mutation, you first call `useConsumerRequestAccessMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConsumerRequestAccessMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [consumerRequestAccessMutation, { data, loading, error }] = useConsumerRequestAccessMutation({
 *   variables: {
 *      shopId: // value for 'shopId'
 *      mail: // value for 'mail'
 *   },
 * });
 */
export function useConsumerRequestAccessMutation(baseOptions?: Apollo.MutationHookOptions<ConsumerRequestAccessMutation, ConsumerRequestAccessMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConsumerRequestAccessMutation, ConsumerRequestAccessMutationVariables>(ConsumerRequestAccessDocument, options);
      }
export type ConsumerRequestAccessMutationHookResult = ReturnType<typeof useConsumerRequestAccessMutation>;
export type ConsumerRequestAccessMutationResult = Apollo.MutationResult<ConsumerRequestAccessMutation>;
export type ConsumerRequestAccessMutationOptions = Apollo.BaseMutationOptions<ConsumerRequestAccessMutation, ConsumerRequestAccessMutationVariables>;
export const PotentialCreateDocument = gql`
    mutation PotentialCreate($consumerId: MongoID!, $masterVariantId: String!) {
  PotentialCreate(consumerId: $consumerId, masterVariantId: $masterVariantId) {
    _id
  }
}
    `;
export type PotentialCreateMutationFn = Apollo.MutationFunction<PotentialCreateMutation, PotentialCreateMutationVariables>;

/**
 * __usePotentialCreateMutation__
 *
 * To run a mutation, you first call `usePotentialCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePotentialCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [potentialCreateMutation, { data, loading, error }] = usePotentialCreateMutation({
 *   variables: {
 *      consumerId: // value for 'consumerId'
 *      masterVariantId: // value for 'masterVariantId'
 *   },
 * });
 */
export function usePotentialCreateMutation(baseOptions?: Apollo.MutationHookOptions<PotentialCreateMutation, PotentialCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PotentialCreateMutation, PotentialCreateMutationVariables>(PotentialCreateDocument, options);
      }
export type PotentialCreateMutationHookResult = ReturnType<typeof usePotentialCreateMutation>;
export type PotentialCreateMutationResult = Apollo.MutationResult<PotentialCreateMutation>;
export type PotentialCreateMutationOptions = Apollo.BaseMutationOptions<PotentialCreateMutation, PotentialCreateMutationVariables>;
export const ProductDetailVariantsDocument = gql`
    query ProductDetailVariants($productId: MongoID!) {
  ProductById(_id: $productId) {
    _id
    name
    description
    createdAt
    updatedAt
    disabled
    deleted
    isPotential
    isPreOwned
    style
    tags
    collections
    productVariants {
      _id
      externalId
      sku
      ean
      size
      color
      rrp {
        value
        currency
      }
      imageUrls
      countryOrigin
      commodityCode
    }
  }
}
    `;

/**
 * __useProductDetailVariantsQuery__
 *
 * To run a query within a React component, call `useProductDetailVariantsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductDetailVariantsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductDetailVariantsQuery({
 *   variables: {
 *      productId: // value for 'productId'
 *   },
 * });
 */
export function useProductDetailVariantsQuery(baseOptions: Apollo.QueryHookOptions<ProductDetailVariantsQuery, ProductDetailVariantsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductDetailVariantsQuery, ProductDetailVariantsQueryVariables>(ProductDetailVariantsDocument, options);
      }
export function useProductDetailVariantsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductDetailVariantsQuery, ProductDetailVariantsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductDetailVariantsQuery, ProductDetailVariantsQueryVariables>(ProductDetailVariantsDocument, options);
        }
export type ProductDetailVariantsQueryHookResult = ReturnType<typeof useProductDetailVariantsQuery>;
export type ProductDetailVariantsLazyQueryHookResult = ReturnType<typeof useProductDetailVariantsLazyQuery>;
export type ProductDetailVariantsQueryResult = Apollo.QueryResult<ProductDetailVariantsQuery, ProductDetailVariantsQueryVariables>;
export const ProductDetailDisableDocument = gql`
    mutation ProductDetailDisable($productId: MongoID!, $disable: Boolean!) {
  ProductDisable(id: $productId, disable: $disable) {
    _id
    disabled
  }
}
    `;
export type ProductDetailDisableMutationFn = Apollo.MutationFunction<ProductDetailDisableMutation, ProductDetailDisableMutationVariables>;

/**
 * __useProductDetailDisableMutation__
 *
 * To run a mutation, you first call `useProductDetailDisableMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProductDetailDisableMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [productDetailDisableMutation, { data, loading, error }] = useProductDetailDisableMutation({
 *   variables: {
 *      productId: // value for 'productId'
 *      disable: // value for 'disable'
 *   },
 * });
 */
export function useProductDetailDisableMutation(baseOptions?: Apollo.MutationHookOptions<ProductDetailDisableMutation, ProductDetailDisableMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProductDetailDisableMutation, ProductDetailDisableMutationVariables>(ProductDetailDisableDocument, options);
      }
export type ProductDetailDisableMutationHookResult = ReturnType<typeof useProductDetailDisableMutation>;
export type ProductDetailDisableMutationResult = Apollo.MutationResult<ProductDetailDisableMutation>;
export type ProductDetailDisableMutationOptions = Apollo.BaseMutationOptions<ProductDetailDisableMutation, ProductDetailDisableMutationVariables>;
export const BrandProductImportDocument = gql`
    mutation BrandProductImport($brandHouseID: MongoID!, $productID: MongoID!) {
  BrandProductImport(brandHouseId: $brandHouseID, productId: $productID)
}
    `;
export type BrandProductImportMutationFn = Apollo.MutationFunction<BrandProductImportMutation, BrandProductImportMutationVariables>;

/**
 * __useBrandProductImportMutation__
 *
 * To run a mutation, you first call `useBrandProductImportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBrandProductImportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [brandProductImportMutation, { data, loading, error }] = useBrandProductImportMutation({
 *   variables: {
 *      brandHouseID: // value for 'brandHouseID'
 *      productID: // value for 'productID'
 *   },
 * });
 */
export function useBrandProductImportMutation(baseOptions?: Apollo.MutationHookOptions<BrandProductImportMutation, BrandProductImportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BrandProductImportMutation, BrandProductImportMutationVariables>(BrandProductImportDocument, options);
      }
export type BrandProductImportMutationHookResult = ReturnType<typeof useBrandProductImportMutation>;
export type BrandProductImportMutationResult = Apollo.MutationResult<BrandProductImportMutation>;
export type BrandProductImportMutationOptions = Apollo.BaseMutationOptions<BrandProductImportMutation, BrandProductImportMutationVariables>;
export const ProductsPageStatisticsDocument = gql`
    query ProductsPageStatistics($shopId: String!) {
  ProductStatistics(shopId: $shopId) {
    variants
    variantsImages
    variantsNoImages
    variantsNoThumbnails
    variantsThumbnails
    productsNoImages
  }
}
    `;

/**
 * __useProductsPageStatisticsQuery__
 *
 * To run a query within a React component, call `useProductsPageStatisticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductsPageStatisticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductsPageStatisticsQuery({
 *   variables: {
 *      shopId: // value for 'shopId'
 *   },
 * });
 */
export function useProductsPageStatisticsQuery(baseOptions: Apollo.QueryHookOptions<ProductsPageStatisticsQuery, ProductsPageStatisticsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductsPageStatisticsQuery, ProductsPageStatisticsQueryVariables>(ProductsPageStatisticsDocument, options);
      }
export function useProductsPageStatisticsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductsPageStatisticsQuery, ProductsPageStatisticsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductsPageStatisticsQuery, ProductsPageStatisticsQueryVariables>(ProductsPageStatisticsDocument, options);
        }
export type ProductsPageStatisticsQueryHookResult = ReturnType<typeof useProductsPageStatisticsQuery>;
export type ProductsPageStatisticsLazyQueryHookResult = ReturnType<typeof useProductsPageStatisticsLazyQuery>;
export type ProductsPageStatisticsQueryResult = Apollo.QueryResult<ProductsPageStatisticsQuery, ProductsPageStatisticsQueryVariables>;
export const ImportDialogStockItemDocument = gql`
    query ImportDialogStockItem($stockItemId: MongoID!) {
  StockItem(_id: $stockItemId) {
    _id
    originalEan
    sku
  }
}
    `;

/**
 * __useImportDialogStockItemQuery__
 *
 * To run a query within a React component, call `useImportDialogStockItemQuery` and pass it any options that fit your needs.
 * When your component renders, `useImportDialogStockItemQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useImportDialogStockItemQuery({
 *   variables: {
 *      stockItemId: // value for 'stockItemId'
 *   },
 * });
 */
export function useImportDialogStockItemQuery(baseOptions: Apollo.QueryHookOptions<ImportDialogStockItemQuery, ImportDialogStockItemQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ImportDialogStockItemQuery, ImportDialogStockItemQueryVariables>(ImportDialogStockItemDocument, options);
      }
export function useImportDialogStockItemLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ImportDialogStockItemQuery, ImportDialogStockItemQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ImportDialogStockItemQuery, ImportDialogStockItemQueryVariables>(ImportDialogStockItemDocument, options);
        }
export type ImportDialogStockItemQueryHookResult = ReturnType<typeof useImportDialogStockItemQuery>;
export type ImportDialogStockItemLazyQueryHookResult = ReturnType<typeof useImportDialogStockItemLazyQuery>;
export type ImportDialogStockItemQueryResult = Apollo.QueryResult<ImportDialogStockItemQuery, ImportDialogStockItemQueryVariables>;
export const ImportDialogProductDocument = gql`
    query ImportDialogProduct($shopId: MongoID!, $sku: String, $ean: String) {
  ProductVariantMany(filter: {shopId: $shopId, OR: [{sku: $sku}, {ean: $ean}]}) {
    _id
    productId
    product {
      _id
      name
      style
    }
    sku
    ean
    size
    color
    imageUrls
  }
}
    `;

/**
 * __useImportDialogProductQuery__
 *
 * To run a query within a React component, call `useImportDialogProductQuery` and pass it any options that fit your needs.
 * When your component renders, `useImportDialogProductQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useImportDialogProductQuery({
 *   variables: {
 *      shopId: // value for 'shopId'
 *      sku: // value for 'sku'
 *      ean: // value for 'ean'
 *   },
 * });
 */
export function useImportDialogProductQuery(baseOptions: Apollo.QueryHookOptions<ImportDialogProductQuery, ImportDialogProductQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ImportDialogProductQuery, ImportDialogProductQueryVariables>(ImportDialogProductDocument, options);
      }
export function useImportDialogProductLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ImportDialogProductQuery, ImportDialogProductQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ImportDialogProductQuery, ImportDialogProductQueryVariables>(ImportDialogProductDocument, options);
        }
export type ImportDialogProductQueryHookResult = ReturnType<typeof useImportDialogProductQuery>;
export type ImportDialogProductLazyQueryHookResult = ReturnType<typeof useImportDialogProductLazyQuery>;
export type ImportDialogProductQueryResult = Apollo.QueryResult<ImportDialogProductQuery, ImportDialogProductQueryVariables>;
export const ImportDialogCreateImageDocument = gql`
    mutation ImportDialogCreateImage($shopId: String!, $stockItemId: String!, $imageUrl: String!) {
  StockItemImageCreate2(
    shopId: $shopId
    stockItemId: $stockItemId
    silent: false
    imageUrl: $imageUrl
    autoretouch: false
    publish: true
  ) {
    _id
  }
}
    `;
export type ImportDialogCreateImageMutationFn = Apollo.MutationFunction<ImportDialogCreateImageMutation, ImportDialogCreateImageMutationVariables>;

/**
 * __useImportDialogCreateImageMutation__
 *
 * To run a mutation, you first call `useImportDialogCreateImageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImportDialogCreateImageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [importDialogCreateImageMutation, { data, loading, error }] = useImportDialogCreateImageMutation({
 *   variables: {
 *      shopId: // value for 'shopId'
 *      stockItemId: // value for 'stockItemId'
 *      imageUrl: // value for 'imageUrl'
 *   },
 * });
 */
export function useImportDialogCreateImageMutation(baseOptions?: Apollo.MutationHookOptions<ImportDialogCreateImageMutation, ImportDialogCreateImageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ImportDialogCreateImageMutation, ImportDialogCreateImageMutationVariables>(ImportDialogCreateImageDocument, options);
      }
export type ImportDialogCreateImageMutationHookResult = ReturnType<typeof useImportDialogCreateImageMutation>;
export type ImportDialogCreateImageMutationResult = Apollo.MutationResult<ImportDialogCreateImageMutation>;
export type ImportDialogCreateImageMutationOptions = Apollo.BaseMutationOptions<ImportDialogCreateImageMutation, ImportDialogCreateImageMutationVariables>;
export const ExportStockItemsDocument = gql`
    query ExportStockItems($stockItemIds: [MongoID!]) {
  StockItems2(ids: $stockItemIds) {
    _id
    resolved {
      _id
      itemNr
      condition
      isSold
      stockLocation
      imageUrls
      effectiveTitle
      effectiveMissing
      effectiveChecked
      sellingPrice
      beforePrice
      ean
      effectiveColor
      size
      originalEan
      sku
      vendor
    }
  }
}
    `;

/**
 * __useExportStockItemsQuery__
 *
 * To run a query within a React component, call `useExportStockItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useExportStockItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExportStockItemsQuery({
 *   variables: {
 *      stockItemIds: // value for 'stockItemIds'
 *   },
 * });
 */
export function useExportStockItemsQuery(baseOptions?: Apollo.QueryHookOptions<ExportStockItemsQuery, ExportStockItemsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExportStockItemsQuery, ExportStockItemsQueryVariables>(ExportStockItemsDocument, options);
      }
export function useExportStockItemsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExportStockItemsQuery, ExportStockItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExportStockItemsQuery, ExportStockItemsQueryVariables>(ExportStockItemsDocument, options);
        }
export type ExportStockItemsQueryHookResult = ReturnType<typeof useExportStockItemsQuery>;
export type ExportStockItemsLazyQueryHookResult = ReturnType<typeof useExportStockItemsLazyQuery>;
export type ExportStockItemsQueryResult = Apollo.QueryResult<ExportStockItemsQuery, ExportStockItemsQueryVariables>;
export const StockItemImagesRotateDocument = gql`
    mutation StockItemImagesRotate($shopId: String!, $imageId: String!, $rotate: Float!) {
  StockItemImageRotate(shopId: $shopId, imageId: $imageId, rotate: $rotate) {
    _id
    sourceId
    sourceUrl
    imageId
    imageUrl
  }
}
    `;
export type StockItemImagesRotateMutationFn = Apollo.MutationFunction<StockItemImagesRotateMutation, StockItemImagesRotateMutationVariables>;

/**
 * __useStockItemImagesRotateMutation__
 *
 * To run a mutation, you first call `useStockItemImagesRotateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStockItemImagesRotateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [stockItemImagesRotateMutation, { data, loading, error }] = useStockItemImagesRotateMutation({
 *   variables: {
 *      shopId: // value for 'shopId'
 *      imageId: // value for 'imageId'
 *      rotate: // value for 'rotate'
 *   },
 * });
 */
export function useStockItemImagesRotateMutation(baseOptions?: Apollo.MutationHookOptions<StockItemImagesRotateMutation, StockItemImagesRotateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StockItemImagesRotateMutation, StockItemImagesRotateMutationVariables>(StockItemImagesRotateDocument, options);
      }
export type StockItemImagesRotateMutationHookResult = ReturnType<typeof useStockItemImagesRotateMutation>;
export type StockItemImagesRotateMutationResult = Apollo.MutationResult<StockItemImagesRotateMutation>;
export type StockItemImagesRotateMutationOptions = Apollo.BaseMutationOptions<StockItemImagesRotateMutation, StockItemImagesRotateMutationVariables>;
export const StockItemImageAltTextDocument = gql`
    query StockItemImageAltText($imageId: MongoID!) {
  StockItemImageById(_id: $imageId) {
    _id
    altText
  }
}
    `;

/**
 * __useStockItemImageAltTextQuery__
 *
 * To run a query within a React component, call `useStockItemImageAltTextQuery` and pass it any options that fit your needs.
 * When your component renders, `useStockItemImageAltTextQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStockItemImageAltTextQuery({
 *   variables: {
 *      imageId: // value for 'imageId'
 *   },
 * });
 */
export function useStockItemImageAltTextQuery(baseOptions: Apollo.QueryHookOptions<StockItemImageAltTextQuery, StockItemImageAltTextQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StockItemImageAltTextQuery, StockItemImageAltTextQueryVariables>(StockItemImageAltTextDocument, options);
      }
export function useStockItemImageAltTextLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StockItemImageAltTextQuery, StockItemImageAltTextQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StockItemImageAltTextQuery, StockItemImageAltTextQueryVariables>(StockItemImageAltTextDocument, options);
        }
export type StockItemImageAltTextQueryHookResult = ReturnType<typeof useStockItemImageAltTextQuery>;
export type StockItemImageAltTextLazyQueryHookResult = ReturnType<typeof useStockItemImageAltTextLazyQuery>;
export type StockItemImageAltTextQueryResult = Apollo.QueryResult<StockItemImageAltTextQuery, StockItemImageAltTextQueryVariables>;
export const StockItemImageAltTextSaveDocument = gql`
    mutation StockItemImageAltTextSave($imageId: MongoID!, $input: UpdateByIdStockItemImageInput!) {
  StockItemImageUpdateById(_id: $imageId, record: $input) {
    record {
      _id
    }
  }
}
    `;
export type StockItemImageAltTextSaveMutationFn = Apollo.MutationFunction<StockItemImageAltTextSaveMutation, StockItemImageAltTextSaveMutationVariables>;

/**
 * __useStockItemImageAltTextSaveMutation__
 *
 * To run a mutation, you first call `useStockItemImageAltTextSaveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStockItemImageAltTextSaveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [stockItemImageAltTextSaveMutation, { data, loading, error }] = useStockItemImageAltTextSaveMutation({
 *   variables: {
 *      imageId: // value for 'imageId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useStockItemImageAltTextSaveMutation(baseOptions?: Apollo.MutationHookOptions<StockItemImageAltTextSaveMutation, StockItemImageAltTextSaveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StockItemImageAltTextSaveMutation, StockItemImageAltTextSaveMutationVariables>(StockItemImageAltTextSaveDocument, options);
      }
export type StockItemImageAltTextSaveMutationHookResult = ReturnType<typeof useStockItemImageAltTextSaveMutation>;
export type StockItemImageAltTextSaveMutationResult = Apollo.MutationResult<StockItemImageAltTextSaveMutation>;
export type StockItemImageAltTextSaveMutationOptions = Apollo.BaseMutationOptions<StockItemImageAltTextSaveMutation, StockItemImageAltTextSaveMutationVariables>;
export const StockItemsPageBrandDocument = gql`
    query stockItemsPageBrand($shopId: MongoID!) {
  ShopById(_id: $shopId) {
    _id
    currency
    brandHouseId
    brandHouse {
      _id
      settings {
        useBrandItems
      }
    }
  }
}
    `;

/**
 * __useStockItemsPageBrandQuery__
 *
 * To run a query within a React component, call `useStockItemsPageBrandQuery` and pass it any options that fit your needs.
 * When your component renders, `useStockItemsPageBrandQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStockItemsPageBrandQuery({
 *   variables: {
 *      shopId: // value for 'shopId'
 *   },
 * });
 */
export function useStockItemsPageBrandQuery(baseOptions: Apollo.QueryHookOptions<StockItemsPageBrandQuery, StockItemsPageBrandQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StockItemsPageBrandQuery, StockItemsPageBrandQueryVariables>(StockItemsPageBrandDocument, options);
      }
export function useStockItemsPageBrandLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StockItemsPageBrandQuery, StockItemsPageBrandQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StockItemsPageBrandQuery, StockItemsPageBrandQueryVariables>(StockItemsPageBrandDocument, options);
        }
export type StockItemsPageBrandQueryHookResult = ReturnType<typeof useStockItemsPageBrandQuery>;
export type StockItemsPageBrandLazyQueryHookResult = ReturnType<typeof useStockItemsPageBrandLazyQuery>;
export type StockItemsPageBrandQueryResult = Apollo.QueryResult<StockItemsPageBrandQuery, StockItemsPageBrandQueryVariables>;
export const ReprocessAllImagesDocument = gql`
    mutation ReprocessAllImages($shopId: String!) {
  StockItemImageAutoRetouchAll(shopId: $shopId) {
    _id
  }
}
    `;
export type ReprocessAllImagesMutationFn = Apollo.MutationFunction<ReprocessAllImagesMutation, ReprocessAllImagesMutationVariables>;

/**
 * __useReprocessAllImagesMutation__
 *
 * To run a mutation, you first call `useReprocessAllImagesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReprocessAllImagesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reprocessAllImagesMutation, { data, loading, error }] = useReprocessAllImagesMutation({
 *   variables: {
 *      shopId: // value for 'shopId'
 *   },
 * });
 */
export function useReprocessAllImagesMutation(baseOptions?: Apollo.MutationHookOptions<ReprocessAllImagesMutation, ReprocessAllImagesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReprocessAllImagesMutation, ReprocessAllImagesMutationVariables>(ReprocessAllImagesDocument, options);
      }
export type ReprocessAllImagesMutationHookResult = ReturnType<typeof useReprocessAllImagesMutation>;
export type ReprocessAllImagesMutationResult = Apollo.MutationResult<ReprocessAllImagesMutation>;
export type ReprocessAllImagesMutationOptions = Apollo.BaseMutationOptions<ReprocessAllImagesMutation, ReprocessAllImagesMutationVariables>;
export const ReprocessStockItemImagesDocument = gql`
    mutation ReprocessStockItemImages($shopId: String!, $stockItemId: String!) {
  StockItemImageAutoRetouch2(
    shopId: $shopId
    stockItemId: $stockItemId
    process: true
  ) {
    _id
  }
}
    `;
export type ReprocessStockItemImagesMutationFn = Apollo.MutationFunction<ReprocessStockItemImagesMutation, ReprocessStockItemImagesMutationVariables>;

/**
 * __useReprocessStockItemImagesMutation__
 *
 * To run a mutation, you first call `useReprocessStockItemImagesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReprocessStockItemImagesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reprocessStockItemImagesMutation, { data, loading, error }] = useReprocessStockItemImagesMutation({
 *   variables: {
 *      shopId: // value for 'shopId'
 *      stockItemId: // value for 'stockItemId'
 *   },
 * });
 */
export function useReprocessStockItemImagesMutation(baseOptions?: Apollo.MutationHookOptions<ReprocessStockItemImagesMutation, ReprocessStockItemImagesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReprocessStockItemImagesMutation, ReprocessStockItemImagesMutationVariables>(ReprocessStockItemImagesDocument, options);
      }
export type ReprocessStockItemImagesMutationHookResult = ReturnType<typeof useReprocessStockItemImagesMutation>;
export type ReprocessStockItemImagesMutationResult = Apollo.MutationResult<ReprocessStockItemImagesMutation>;
export type ReprocessStockItemImagesMutationOptions = Apollo.BaseMutationOptions<ReprocessStockItemImagesMutation, ReprocessStockItemImagesMutationVariables>;
export const StockItemsRecalculatePricesDocument = gql`
    mutation StockItemsRecalculatePrices($shopId: String!) {
  StockItemsRecalculatePrices(shopId: $shopId) {
    _id
    sellingPrice
    beforePrice
  }
}
    `;
export type StockItemsRecalculatePricesMutationFn = Apollo.MutationFunction<StockItemsRecalculatePricesMutation, StockItemsRecalculatePricesMutationVariables>;

/**
 * __useStockItemsRecalculatePricesMutation__
 *
 * To run a mutation, you first call `useStockItemsRecalculatePricesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStockItemsRecalculatePricesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [stockItemsRecalculatePricesMutation, { data, loading, error }] = useStockItemsRecalculatePricesMutation({
 *   variables: {
 *      shopId: // value for 'shopId'
 *   },
 * });
 */
export function useStockItemsRecalculatePricesMutation(baseOptions?: Apollo.MutationHookOptions<StockItemsRecalculatePricesMutation, StockItemsRecalculatePricesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StockItemsRecalculatePricesMutation, StockItemsRecalculatePricesMutationVariables>(StockItemsRecalculatePricesDocument, options);
      }
export type StockItemsRecalculatePricesMutationHookResult = ReturnType<typeof useStockItemsRecalculatePricesMutation>;
export type StockItemsRecalculatePricesMutationResult = Apollo.MutationResult<StockItemsRecalculatePricesMutation>;
export type StockItemsRecalculatePricesMutationOptions = Apollo.BaseMutationOptions<StockItemsRecalculatePricesMutation, StockItemsRecalculatePricesMutationVariables>;
export const StockItemsPagePublishDocument = gql`
    mutation StockItemsPagePublish($shopId: String!, $stockItem: StockItemUpdateInput!) {
  StockItemUpdate(shopId: $shopId, stockItem: $stockItem) {
    _id
    published
    draft
    review
  }
}
    `;
export type StockItemsPagePublishMutationFn = Apollo.MutationFunction<StockItemsPagePublishMutation, StockItemsPagePublishMutationVariables>;

/**
 * __useStockItemsPagePublishMutation__
 *
 * To run a mutation, you first call `useStockItemsPagePublishMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStockItemsPagePublishMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [stockItemsPagePublishMutation, { data, loading, error }] = useStockItemsPagePublishMutation({
 *   variables: {
 *      shopId: // value for 'shopId'
 *      stockItem: // value for 'stockItem'
 *   },
 * });
 */
export function useStockItemsPagePublishMutation(baseOptions?: Apollo.MutationHookOptions<StockItemsPagePublishMutation, StockItemsPagePublishMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StockItemsPagePublishMutation, StockItemsPagePublishMutationVariables>(StockItemsPagePublishDocument, options);
      }
export type StockItemsPagePublishMutationHookResult = ReturnType<typeof useStockItemsPagePublishMutation>;
export type StockItemsPagePublishMutationResult = Apollo.MutationResult<StockItemsPagePublishMutation>;
export type StockItemsPagePublishMutationOptions = Apollo.BaseMutationOptions<StockItemsPagePublishMutation, StockItemsPagePublishMutationVariables>;
export const StockItemImageSynchronizeDocument = gql`
    mutation StockItemImageSynchronize($stockItem: MongoID!) {
  StockItemImageSynchronize(stockItemId: $stockItem) {
    _id
    images {
      _id
    }
  }
}
    `;
export type StockItemImageSynchronizeMutationFn = Apollo.MutationFunction<StockItemImageSynchronizeMutation, StockItemImageSynchronizeMutationVariables>;

/**
 * __useStockItemImageSynchronizeMutation__
 *
 * To run a mutation, you first call `useStockItemImageSynchronizeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStockItemImageSynchronizeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [stockItemImageSynchronizeMutation, { data, loading, error }] = useStockItemImageSynchronizeMutation({
 *   variables: {
 *      stockItem: // value for 'stockItem'
 *   },
 * });
 */
export function useStockItemImageSynchronizeMutation(baseOptions?: Apollo.MutationHookOptions<StockItemImageSynchronizeMutation, StockItemImageSynchronizeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StockItemImageSynchronizeMutation, StockItemImageSynchronizeMutationVariables>(StockItemImageSynchronizeDocument, options);
      }
export type StockItemImageSynchronizeMutationHookResult = ReturnType<typeof useStockItemImageSynchronizeMutation>;
export type StockItemImageSynchronizeMutationResult = Apollo.MutationResult<StockItemImageSynchronizeMutation>;
export type StockItemImageSynchronizeMutationOptions = Apollo.BaseMutationOptions<StockItemImageSynchronizeMutation, StockItemImageSynchronizeMutationVariables>;
export const StockItemProductInfoDocument = gql`
    query StockItemProductInfo($productId: MongoID!) {
  ProductById(_id: $productId) {
    _id
    description
  }
}
    `;

/**
 * __useStockItemProductInfoQuery__
 *
 * To run a query within a React component, call `useStockItemProductInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useStockItemProductInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStockItemProductInfoQuery({
 *   variables: {
 *      productId: // value for 'productId'
 *   },
 * });
 */
export function useStockItemProductInfoQuery(baseOptions: Apollo.QueryHookOptions<StockItemProductInfoQuery, StockItemProductInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StockItemProductInfoQuery, StockItemProductInfoQueryVariables>(StockItemProductInfoDocument, options);
      }
export function useStockItemProductInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StockItemProductInfoQuery, StockItemProductInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StockItemProductInfoQuery, StockItemProductInfoQueryVariables>(StockItemProductInfoDocument, options);
        }
export type StockItemProductInfoQueryHookResult = ReturnType<typeof useStockItemProductInfoQuery>;
export type StockItemProductInfoLazyQueryHookResult = ReturnType<typeof useStockItemProductInfoLazyQuery>;
export type StockItemProductInfoQueryResult = Apollo.QueryResult<StockItemProductInfoQuery, StockItemProductInfoQueryVariables>;
export const StockItemFormBrandSettingDocument = gql`
    query StockItemFormBrandSetting($shopId: MongoID!) {
  BrandSettings(shopId: $shopId) {
    _id
    shopId
    locales {
      locale
      activeItems
    }
    stockItemConfig {
      titlePrefix
      appendColor
      appendSize
      descriptionSuffix
    }
    sellPrice {
      condition
      pct
    }
    pricingTags
  }
}
    `;

/**
 * __useStockItemFormBrandSettingQuery__
 *
 * To run a query within a React component, call `useStockItemFormBrandSettingQuery` and pass it any options that fit your needs.
 * When your component renders, `useStockItemFormBrandSettingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStockItemFormBrandSettingQuery({
 *   variables: {
 *      shopId: // value for 'shopId'
 *   },
 * });
 */
export function useStockItemFormBrandSettingQuery(baseOptions: Apollo.QueryHookOptions<StockItemFormBrandSettingQuery, StockItemFormBrandSettingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StockItemFormBrandSettingQuery, StockItemFormBrandSettingQueryVariables>(StockItemFormBrandSettingDocument, options);
      }
export function useStockItemFormBrandSettingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StockItemFormBrandSettingQuery, StockItemFormBrandSettingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StockItemFormBrandSettingQuery, StockItemFormBrandSettingQueryVariables>(StockItemFormBrandSettingDocument, options);
        }
export type StockItemFormBrandSettingQueryHookResult = ReturnType<typeof useStockItemFormBrandSettingQuery>;
export type StockItemFormBrandSettingLazyQueryHookResult = ReturnType<typeof useStockItemFormBrandSettingLazyQuery>;
export type StockItemFormBrandSettingQueryResult = Apollo.QueryResult<StockItemFormBrandSettingQuery, StockItemFormBrandSettingQueryVariables>;
export const StockItemFormStockItemUpdateDocument = gql`
    mutation StockItemFormStockItemUpdate($shopId: String!, $stockItem: StockItemUpdateInput!) {
  StockItemUpdate(shopId: $shopId, stockItem: $stockItem) {
    ...StockItemFragment
  }
}
    ${StockItemFragmentDoc}`;
export type StockItemFormStockItemUpdateMutationFn = Apollo.MutationFunction<StockItemFormStockItemUpdateMutation, StockItemFormStockItemUpdateMutationVariables>;

/**
 * __useStockItemFormStockItemUpdateMutation__
 *
 * To run a mutation, you first call `useStockItemFormStockItemUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStockItemFormStockItemUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [stockItemFormStockItemUpdateMutation, { data, loading, error }] = useStockItemFormStockItemUpdateMutation({
 *   variables: {
 *      shopId: // value for 'shopId'
 *      stockItem: // value for 'stockItem'
 *   },
 * });
 */
export function useStockItemFormStockItemUpdateMutation(baseOptions?: Apollo.MutationHookOptions<StockItemFormStockItemUpdateMutation, StockItemFormStockItemUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StockItemFormStockItemUpdateMutation, StockItemFormStockItemUpdateMutationVariables>(StockItemFormStockItemUpdateDocument, options);
      }
export type StockItemFormStockItemUpdateMutationHookResult = ReturnType<typeof useStockItemFormStockItemUpdateMutation>;
export type StockItemFormStockItemUpdateMutationResult = Apollo.MutationResult<StockItemFormStockItemUpdateMutation>;
export type StockItemFormStockItemUpdateMutationOptions = Apollo.BaseMutationOptions<StockItemFormStockItemUpdateMutation, StockItemFormStockItemUpdateMutationVariables>;
export const StockItemFormRecalculatePriceDocument = gql`
    mutation StockItemFormRecalculatePrice($shopId: String!, $stockItem: StockItemUpdateInput) {
  StockItemsRecalculatePrice(shopId: $shopId, stockItem: $stockItem)
}
    `;
export type StockItemFormRecalculatePriceMutationFn = Apollo.MutationFunction<StockItemFormRecalculatePriceMutation, StockItemFormRecalculatePriceMutationVariables>;

/**
 * __useStockItemFormRecalculatePriceMutation__
 *
 * To run a mutation, you first call `useStockItemFormRecalculatePriceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStockItemFormRecalculatePriceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [stockItemFormRecalculatePriceMutation, { data, loading, error }] = useStockItemFormRecalculatePriceMutation({
 *   variables: {
 *      shopId: // value for 'shopId'
 *      stockItem: // value for 'stockItem'
 *   },
 * });
 */
export function useStockItemFormRecalculatePriceMutation(baseOptions?: Apollo.MutationHookOptions<StockItemFormRecalculatePriceMutation, StockItemFormRecalculatePriceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StockItemFormRecalculatePriceMutation, StockItemFormRecalculatePriceMutationVariables>(StockItemFormRecalculatePriceDocument, options);
      }
export type StockItemFormRecalculatePriceMutationHookResult = ReturnType<typeof useStockItemFormRecalculatePriceMutation>;
export type StockItemFormRecalculatePriceMutationResult = Apollo.MutationResult<StockItemFormRecalculatePriceMutation>;
export type StockItemFormRecalculatePriceMutationOptions = Apollo.BaseMutationOptions<StockItemFormRecalculatePriceMutation, StockItemFormRecalculatePriceMutationVariables>;
export const StockItemFormStockItemByIdDocument = gql`
    query StockItemFormStockItemById($stockItemId: MongoID!) {
  StockItemById(_id: $stockItemId) {
    ...StockItemFragment
  }
}
    ${StockItemFragmentDoc}`;

/**
 * __useStockItemFormStockItemByIdQuery__
 *
 * To run a query within a React component, call `useStockItemFormStockItemByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useStockItemFormStockItemByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStockItemFormStockItemByIdQuery({
 *   variables: {
 *      stockItemId: // value for 'stockItemId'
 *   },
 * });
 */
export function useStockItemFormStockItemByIdQuery(baseOptions: Apollo.QueryHookOptions<StockItemFormStockItemByIdQuery, StockItemFormStockItemByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StockItemFormStockItemByIdQuery, StockItemFormStockItemByIdQueryVariables>(StockItemFormStockItemByIdDocument, options);
      }
export function useStockItemFormStockItemByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StockItemFormStockItemByIdQuery, StockItemFormStockItemByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StockItemFormStockItemByIdQuery, StockItemFormStockItemByIdQueryVariables>(StockItemFormStockItemByIdDocument, options);
        }
export type StockItemFormStockItemByIdQueryHookResult = ReturnType<typeof useStockItemFormStockItemByIdQuery>;
export type StockItemFormStockItemByIdLazyQueryHookResult = ReturnType<typeof useStockItemFormStockItemByIdLazyQuery>;
export type StockItemFormStockItemByIdQueryResult = Apollo.QueryResult<StockItemFormStockItemByIdQuery, StockItemFormStockItemByIdQueryVariables>;
export const StockItemImagesDocument = gql`
    query StockItemImages($shopId: String!, $stockItemId: String!) {
  StockItemImages(shopId: $shopId, stockItemId: $stockItemId) {
    _id
    sourceId
    sourceUrl
    imageId
    imageUrl
    process
    failed
    sortOrder
    effectiveAltText
  }
}
    `;

/**
 * __useStockItemImagesQuery__
 *
 * To run a query within a React component, call `useStockItemImagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useStockItemImagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStockItemImagesQuery({
 *   variables: {
 *      shopId: // value for 'shopId'
 *      stockItemId: // value for 'stockItemId'
 *   },
 * });
 */
export function useStockItemImagesQuery(baseOptions: Apollo.QueryHookOptions<StockItemImagesQuery, StockItemImagesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StockItemImagesQuery, StockItemImagesQueryVariables>(StockItemImagesDocument, options);
      }
export function useStockItemImagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StockItemImagesQuery, StockItemImagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StockItemImagesQuery, StockItemImagesQueryVariables>(StockItemImagesDocument, options);
        }
export type StockItemImagesQueryHookResult = ReturnType<typeof useStockItemImagesQuery>;
export type StockItemImagesLazyQueryHookResult = ReturnType<typeof useStockItemImagesLazyQuery>;
export type StockItemImagesQueryResult = Apollo.QueryResult<StockItemImagesQuery, StockItemImagesQueryVariables>;
export const StockItemImageDocument = gql`
    query StockItemImage($shopId: String!, $stockItemImageId: String!) {
  StockItemImage(shopId: $shopId, stockItemImageId: $stockItemImageId) {
    _id
    sourceId
    sourceUrl
    imageId
    imageUrl
    process
    failed
    sortOrder
  }
}
    `;

/**
 * __useStockItemImageQuery__
 *
 * To run a query within a React component, call `useStockItemImageQuery` and pass it any options that fit your needs.
 * When your component renders, `useStockItemImageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStockItemImageQuery({
 *   variables: {
 *      shopId: // value for 'shopId'
 *      stockItemImageId: // value for 'stockItemImageId'
 *   },
 * });
 */
export function useStockItemImageQuery(baseOptions: Apollo.QueryHookOptions<StockItemImageQuery, StockItemImageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StockItemImageQuery, StockItemImageQueryVariables>(StockItemImageDocument, options);
      }
export function useStockItemImageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StockItemImageQuery, StockItemImageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StockItemImageQuery, StockItemImageQueryVariables>(StockItemImageDocument, options);
        }
export type StockItemImageQueryHookResult = ReturnType<typeof useStockItemImageQuery>;
export type StockItemImageLazyQueryHookResult = ReturnType<typeof useStockItemImageLazyQuery>;
export type StockItemImageQueryResult = Apollo.QueryResult<StockItemImageQuery, StockItemImageQueryVariables>;
export const StockItemImageCreateDocument = gql`
    mutation StockItemImageCreate($shopId: String!, $stockItemId: String!, $uploadId: String!) {
  StockItemImageCreate(
    shopId: $shopId
    stockItemId: $stockItemId
    uploadId: $uploadId
  ) {
    _id
    sourceId
    sourceUrl
    imageId
    imageUrl
    sortOrder
  }
}
    `;
export type StockItemImageCreateMutationFn = Apollo.MutationFunction<StockItemImageCreateMutation, StockItemImageCreateMutationVariables>;

/**
 * __useStockItemImageCreateMutation__
 *
 * To run a mutation, you first call `useStockItemImageCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStockItemImageCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [stockItemImageCreateMutation, { data, loading, error }] = useStockItemImageCreateMutation({
 *   variables: {
 *      shopId: // value for 'shopId'
 *      stockItemId: // value for 'stockItemId'
 *      uploadId: // value for 'uploadId'
 *   },
 * });
 */
export function useStockItemImageCreateMutation(baseOptions?: Apollo.MutationHookOptions<StockItemImageCreateMutation, StockItemImageCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StockItemImageCreateMutation, StockItemImageCreateMutationVariables>(StockItemImageCreateDocument, options);
      }
export type StockItemImageCreateMutationHookResult = ReturnType<typeof useStockItemImageCreateMutation>;
export type StockItemImageCreateMutationResult = Apollo.MutationResult<StockItemImageCreateMutation>;
export type StockItemImageCreateMutationOptions = Apollo.BaseMutationOptions<StockItemImageCreateMutation, StockItemImageCreateMutationVariables>;
export const StockItemImageDeleteDocument = gql`
    mutation StockItemImageDelete($shopId: String!, $stockItemImageId: String!) {
  StockItemImageDelete(shopId: $shopId, stockItemImageId: $stockItemImageId) {
    _id
  }
}
    `;
export type StockItemImageDeleteMutationFn = Apollo.MutationFunction<StockItemImageDeleteMutation, StockItemImageDeleteMutationVariables>;

/**
 * __useStockItemImageDeleteMutation__
 *
 * To run a mutation, you first call `useStockItemImageDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStockItemImageDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [stockItemImageDeleteMutation, { data, loading, error }] = useStockItemImageDeleteMutation({
 *   variables: {
 *      shopId: // value for 'shopId'
 *      stockItemImageId: // value for 'stockItemImageId'
 *   },
 * });
 */
export function useStockItemImageDeleteMutation(baseOptions?: Apollo.MutationHookOptions<StockItemImageDeleteMutation, StockItemImageDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StockItemImageDeleteMutation, StockItemImageDeleteMutationVariables>(StockItemImageDeleteDocument, options);
      }
export type StockItemImageDeleteMutationHookResult = ReturnType<typeof useStockItemImageDeleteMutation>;
export type StockItemImageDeleteMutationResult = Apollo.MutationResult<StockItemImageDeleteMutation>;
export type StockItemImageDeleteMutationOptions = Apollo.BaseMutationOptions<StockItemImageDeleteMutation, StockItemImageDeleteMutationVariables>;
export const StockItemImageAutoRetouchDocument = gql`
    mutation StockItemImageAutoRetouch($shopId: String!, $stockItemImageId: String!, $process: Boolean!) {
  StockItemImageAutoRetouch(
    shopId: $shopId
    stockItemImageId: $stockItemImageId
    process: $process
  ) {
    _id
    sourceId
    sourceUrl
    imageId
    imageUrl
    process
    sortOrder
  }
}
    `;
export type StockItemImageAutoRetouchMutationFn = Apollo.MutationFunction<StockItemImageAutoRetouchMutation, StockItemImageAutoRetouchMutationVariables>;

/**
 * __useStockItemImageAutoRetouchMutation__
 *
 * To run a mutation, you first call `useStockItemImageAutoRetouchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStockItemImageAutoRetouchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [stockItemImageAutoRetouchMutation, { data, loading, error }] = useStockItemImageAutoRetouchMutation({
 *   variables: {
 *      shopId: // value for 'shopId'
 *      stockItemImageId: // value for 'stockItemImageId'
 *      process: // value for 'process'
 *   },
 * });
 */
export function useStockItemImageAutoRetouchMutation(baseOptions?: Apollo.MutationHookOptions<StockItemImageAutoRetouchMutation, StockItemImageAutoRetouchMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StockItemImageAutoRetouchMutation, StockItemImageAutoRetouchMutationVariables>(StockItemImageAutoRetouchDocument, options);
      }
export type StockItemImageAutoRetouchMutationHookResult = ReturnType<typeof useStockItemImageAutoRetouchMutation>;
export type StockItemImageAutoRetouchMutationResult = Apollo.MutationResult<StockItemImageAutoRetouchMutation>;
export type StockItemImageAutoRetouchMutationOptions = Apollo.BaseMutationOptions<StockItemImageAutoRetouchMutation, StockItemImageAutoRetouchMutationVariables>;
export const StockItemImageUpdateDocument = gql`
    mutation StockItemImageUpdate($shopId: String!, $imageId: String!, $sortOrder: Float!) {
  StockItemImageUpdate(shopId: $shopId, imageId: $imageId, sortOrder: $sortOrder) {
    _id
    sortOrder
  }
}
    `;
export type StockItemImageUpdateMutationFn = Apollo.MutationFunction<StockItemImageUpdateMutation, StockItemImageUpdateMutationVariables>;

/**
 * __useStockItemImageUpdateMutation__
 *
 * To run a mutation, you first call `useStockItemImageUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStockItemImageUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [stockItemImageUpdateMutation, { data, loading, error }] = useStockItemImageUpdateMutation({
 *   variables: {
 *      shopId: // value for 'shopId'
 *      imageId: // value for 'imageId'
 *      sortOrder: // value for 'sortOrder'
 *   },
 * });
 */
export function useStockItemImageUpdateMutation(baseOptions?: Apollo.MutationHookOptions<StockItemImageUpdateMutation, StockItemImageUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StockItemImageUpdateMutation, StockItemImageUpdateMutationVariables>(StockItemImageUpdateDocument, options);
      }
export type StockItemImageUpdateMutationHookResult = ReturnType<typeof useStockItemImageUpdateMutation>;
export type StockItemImageUpdateMutationResult = Apollo.MutationResult<StockItemImageUpdateMutation>;
export type StockItemImageUpdateMutationOptions = Apollo.BaseMutationOptions<StockItemImageUpdateMutation, StockItemImageUpdateMutationVariables>;
export const StockItemImageSetOrderDocument = gql`
    mutation StockItemImageSetOrder($shopId: String!, $stockItemId: String!, $imageIds: [String!]) {
  StockItemImageSetOrder(
    shopId: $shopId
    stockItemId: $stockItemId
    imageIds: $imageIds
  ) {
    _id
    sortOrder
  }
}
    `;
export type StockItemImageSetOrderMutationFn = Apollo.MutationFunction<StockItemImageSetOrderMutation, StockItemImageSetOrderMutationVariables>;

/**
 * __useStockItemImageSetOrderMutation__
 *
 * To run a mutation, you first call `useStockItemImageSetOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStockItemImageSetOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [stockItemImageSetOrderMutation, { data, loading, error }] = useStockItemImageSetOrderMutation({
 *   variables: {
 *      shopId: // value for 'shopId'
 *      stockItemId: // value for 'stockItemId'
 *      imageIds: // value for 'imageIds'
 *   },
 * });
 */
export function useStockItemImageSetOrderMutation(baseOptions?: Apollo.MutationHookOptions<StockItemImageSetOrderMutation, StockItemImageSetOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StockItemImageSetOrderMutation, StockItemImageSetOrderMutationVariables>(StockItemImageSetOrderDocument, options);
      }
export type StockItemImageSetOrderMutationHookResult = ReturnType<typeof useStockItemImageSetOrderMutation>;
export type StockItemImageSetOrderMutationResult = Apollo.MutationResult<StockItemImageSetOrderMutation>;
export type StockItemImageSetOrderMutationOptions = Apollo.BaseMutationOptions<StockItemImageSetOrderMutation, StockItemImageSetOrderMutationVariables>;
export const StockItemMultiSettingsDocument = gql`
    query StockItemMultiSettings($shopId: MongoID!) {
  Shop(_id: $shopId) {
    _id
    currency
  }
  BrandSettings(shopId: $shopId) {
    _id
    locales {
      locale
      activeItems
    }
    stockItemConfig {
      currencies {
        currency
        active
      }
    }
  }
}
    `;

/**
 * __useStockItemMultiSettingsQuery__
 *
 * To run a query within a React component, call `useStockItemMultiSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useStockItemMultiSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStockItemMultiSettingsQuery({
 *   variables: {
 *      shopId: // value for 'shopId'
 *   },
 * });
 */
export function useStockItemMultiSettingsQuery(baseOptions: Apollo.QueryHookOptions<StockItemMultiSettingsQuery, StockItemMultiSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StockItemMultiSettingsQuery, StockItemMultiSettingsQueryVariables>(StockItemMultiSettingsDocument, options);
      }
export function useStockItemMultiSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StockItemMultiSettingsQuery, StockItemMultiSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StockItemMultiSettingsQuery, StockItemMultiSettingsQueryVariables>(StockItemMultiSettingsDocument, options);
        }
export type StockItemMultiSettingsQueryHookResult = ReturnType<typeof useStockItemMultiSettingsQuery>;
export type StockItemMultiSettingsLazyQueryHookResult = ReturnType<typeof useStockItemMultiSettingsLazyQuery>;
export type StockItemMultiSettingsQueryResult = Apollo.QueryResult<StockItemMultiSettingsQuery, StockItemMultiSettingsQueryVariables>;
export const StockItemMultiDocument = gql`
    query StockItemMulti($StockItemIds: [MongoID!]) {
  StockItems2(ids: $StockItemIds) {
    ...StockItemMultiFragment
  }
}
    ${StockItemMultiFragmentDoc}`;

/**
 * __useStockItemMultiQuery__
 *
 * To run a query within a React component, call `useStockItemMultiQuery` and pass it any options that fit your needs.
 * When your component renders, `useStockItemMultiQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStockItemMultiQuery({
 *   variables: {
 *      StockItemIds: // value for 'StockItemIds'
 *   },
 * });
 */
export function useStockItemMultiQuery(baseOptions?: Apollo.QueryHookOptions<StockItemMultiQuery, StockItemMultiQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StockItemMultiQuery, StockItemMultiQueryVariables>(StockItemMultiDocument, options);
      }
export function useStockItemMultiLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StockItemMultiQuery, StockItemMultiQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StockItemMultiQuery, StockItemMultiQueryVariables>(StockItemMultiDocument, options);
        }
export type StockItemMultiQueryHookResult = ReturnType<typeof useStockItemMultiQuery>;
export type StockItemMultiLazyQueryHookResult = ReturnType<typeof useStockItemMultiLazyQuery>;
export type StockItemMultiQueryResult = Apollo.QueryResult<StockItemMultiQuery, StockItemMultiQueryVariables>;
export const StockItemMultiUpdateDocument = gql`
    mutation StockItemMultiUpdate($shopId: String!, $input: StockItemUpdateInput) {
  StockItemUpdate(shopId: $shopId, stockItem: $input, silent: false) {
    ...StockItemMultiFragment
  }
}
    ${StockItemMultiFragmentDoc}`;
export type StockItemMultiUpdateMutationFn = Apollo.MutationFunction<StockItemMultiUpdateMutation, StockItemMultiUpdateMutationVariables>;

/**
 * __useStockItemMultiUpdateMutation__
 *
 * To run a mutation, you first call `useStockItemMultiUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStockItemMultiUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [stockItemMultiUpdateMutation, { data, loading, error }] = useStockItemMultiUpdateMutation({
 *   variables: {
 *      shopId: // value for 'shopId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useStockItemMultiUpdateMutation(baseOptions?: Apollo.MutationHookOptions<StockItemMultiUpdateMutation, StockItemMultiUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StockItemMultiUpdateMutation, StockItemMultiUpdateMutationVariables>(StockItemMultiUpdateDocument, options);
      }
export type StockItemMultiUpdateMutationHookResult = ReturnType<typeof useStockItemMultiUpdateMutation>;
export type StockItemMultiUpdateMutationResult = Apollo.MutationResult<StockItemMultiUpdateMutation>;
export type StockItemMultiUpdateMutationOptions = Apollo.BaseMutationOptions<StockItemMultiUpdateMutation, StockItemMultiUpdateMutationVariables>;
export const StockItemMultiRecalculatePriceDocument = gql`
    mutation StockItemMultiRecalculatePrice($shopId: String!, $stockItem: StockItemUpdateInput) {
  StockItemsRecalculatePrice(shopId: $shopId, stockItem: $stockItem)
}
    `;
export type StockItemMultiRecalculatePriceMutationFn = Apollo.MutationFunction<StockItemMultiRecalculatePriceMutation, StockItemMultiRecalculatePriceMutationVariables>;

/**
 * __useStockItemMultiRecalculatePriceMutation__
 *
 * To run a mutation, you first call `useStockItemMultiRecalculatePriceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStockItemMultiRecalculatePriceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [stockItemMultiRecalculatePriceMutation, { data, loading, error }] = useStockItemMultiRecalculatePriceMutation({
 *   variables: {
 *      shopId: // value for 'shopId'
 *      stockItem: // value for 'stockItem'
 *   },
 * });
 */
export function useStockItemMultiRecalculatePriceMutation(baseOptions?: Apollo.MutationHookOptions<StockItemMultiRecalculatePriceMutation, StockItemMultiRecalculatePriceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StockItemMultiRecalculatePriceMutation, StockItemMultiRecalculatePriceMutationVariables>(StockItemMultiRecalculatePriceDocument, options);
      }
export type StockItemMultiRecalculatePriceMutationHookResult = ReturnType<typeof useStockItemMultiRecalculatePriceMutation>;
export type StockItemMultiRecalculatePriceMutationResult = Apollo.MutationResult<StockItemMultiRecalculatePriceMutation>;
export type StockItemMultiRecalculatePriceMutationOptions = Apollo.BaseMutationOptions<StockItemMultiRecalculatePriceMutation, StockItemMultiRecalculatePriceMutationVariables>;
export const TrackingPageDocument = gql`
    query TrackingPage($shopId: MongoID!) {
  BrandSettings(shopId: $shopId) {
    _id
    tracking
  }
}
    `;

/**
 * __useTrackingPageQuery__
 *
 * To run a query within a React component, call `useTrackingPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useTrackingPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTrackingPageQuery({
 *   variables: {
 *      shopId: // value for 'shopId'
 *   },
 * });
 */
export function useTrackingPageQuery(baseOptions: Apollo.QueryHookOptions<TrackingPageQuery, TrackingPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TrackingPageQuery, TrackingPageQueryVariables>(TrackingPageDocument, options);
      }
export function useTrackingPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TrackingPageQuery, TrackingPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TrackingPageQuery, TrackingPageQueryVariables>(TrackingPageDocument, options);
        }
export type TrackingPageQueryHookResult = ReturnType<typeof useTrackingPageQuery>;
export type TrackingPageLazyQueryHookResult = ReturnType<typeof useTrackingPageLazyQuery>;
export type TrackingPageQueryResult = Apollo.QueryResult<TrackingPageQuery, TrackingPageQueryVariables>;
export const TrackingPageUpdateDocument = gql`
    mutation TrackingPageUpdate($shopId: MongoID!, $tracking: Boolean!, $auditNoteId: MongoID) {
  BrandSettingsUpdate(
    shopId: $shopId
    auditNoteId: $auditNoteId
    api: {tracking: $tracking}
  ) {
    _id
    tracking
  }
}
    `;
export type TrackingPageUpdateMutationFn = Apollo.MutationFunction<TrackingPageUpdateMutation, TrackingPageUpdateMutationVariables>;

/**
 * __useTrackingPageUpdateMutation__
 *
 * To run a mutation, you first call `useTrackingPageUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTrackingPageUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [trackingPageUpdateMutation, { data, loading, error }] = useTrackingPageUpdateMutation({
 *   variables: {
 *      shopId: // value for 'shopId'
 *      tracking: // value for 'tracking'
 *      auditNoteId: // value for 'auditNoteId'
 *   },
 * });
 */
export function useTrackingPageUpdateMutation(baseOptions?: Apollo.MutationHookOptions<TrackingPageUpdateMutation, TrackingPageUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TrackingPageUpdateMutation, TrackingPageUpdateMutationVariables>(TrackingPageUpdateDocument, options);
      }
export type TrackingPageUpdateMutationHookResult = ReturnType<typeof useTrackingPageUpdateMutation>;
export type TrackingPageUpdateMutationResult = Apollo.MutationResult<TrackingPageUpdateMutation>;
export type TrackingPageUpdateMutationOptions = Apollo.BaseMutationOptions<TrackingPageUpdateMutation, TrackingPageUpdateMutationVariables>;
export const ConsumerPlannedMailsDocument = gql`
    query ConsumerPlannedMails($search: String, $filter: FilterFindManyPlannedMailInput, $sort: SortFindManyPlannedMailInput, $page: Int, $perPage: Int) {
  PlannedMailsPagination(
    search: $search
    filter: $filter
    sort: $sort
    page: $page
    perPage: $perPage
  ) {
    count
    pageInfo {
      perPage
      currentPage
      hasNextPage
      hasPreviousPage
      itemCount
      pageCount
    }
    items {
      _id
      mailType
      objectId
      objectType
      sent
      sentStatus
      sendAt
    }
  }
}
    `;

/**
 * __useConsumerPlannedMailsQuery__
 *
 * To run a query within a React component, call `useConsumerPlannedMailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useConsumerPlannedMailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConsumerPlannedMailsQuery({
 *   variables: {
 *      search: // value for 'search'
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *   },
 * });
 */
export function useConsumerPlannedMailsQuery(baseOptions?: Apollo.QueryHookOptions<ConsumerPlannedMailsQuery, ConsumerPlannedMailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ConsumerPlannedMailsQuery, ConsumerPlannedMailsQueryVariables>(ConsumerPlannedMailsDocument, options);
      }
export function useConsumerPlannedMailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ConsumerPlannedMailsQuery, ConsumerPlannedMailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ConsumerPlannedMailsQuery, ConsumerPlannedMailsQueryVariables>(ConsumerPlannedMailsDocument, options);
        }
export type ConsumerPlannedMailsQueryHookResult = ReturnType<typeof useConsumerPlannedMailsQuery>;
export type ConsumerPlannedMailsLazyQueryHookResult = ReturnType<typeof useConsumerPlannedMailsLazyQuery>;
export type ConsumerPlannedMailsQueryResult = Apollo.QueryResult<ConsumerPlannedMailsQuery, ConsumerPlannedMailsQueryVariables>;
export const ConsumerEventsTradeInDocument = gql`
    query ConsumerEventsTradeIn($tradeInID: MongoID!) {
  TradeIn(_id: $tradeInID) {
    _id
    tradeInNr
    consumerId
    consumer {
      name
      mail
    }
  }
}
    `;

/**
 * __useConsumerEventsTradeInQuery__
 *
 * To run a query within a React component, call `useConsumerEventsTradeInQuery` and pass it any options that fit your needs.
 * When your component renders, `useConsumerEventsTradeInQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConsumerEventsTradeInQuery({
 *   variables: {
 *      tradeInID: // value for 'tradeInID'
 *   },
 * });
 */
export function useConsumerEventsTradeInQuery(baseOptions: Apollo.QueryHookOptions<ConsumerEventsTradeInQuery, ConsumerEventsTradeInQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ConsumerEventsTradeInQuery, ConsumerEventsTradeInQueryVariables>(ConsumerEventsTradeInDocument, options);
      }
export function useConsumerEventsTradeInLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ConsumerEventsTradeInQuery, ConsumerEventsTradeInQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ConsumerEventsTradeInQuery, ConsumerEventsTradeInQueryVariables>(ConsumerEventsTradeInDocument, options);
        }
export type ConsumerEventsTradeInQueryHookResult = ReturnType<typeof useConsumerEventsTradeInQuery>;
export type ConsumerEventsTradeInLazyQueryHookResult = ReturnType<typeof useConsumerEventsTradeInLazyQuery>;
export type ConsumerEventsTradeInQueryResult = Apollo.QueryResult<ConsumerEventsTradeInQuery, ConsumerEventsTradeInQueryVariables>;
export const ConsumerEventsVoucherDocument = gql`
    query ConsumerEventsVoucher($voucherID: MongoID!) {
  VoucherById(_id: $voucherID) {
    _id
    code
    used
    currentValue
    consumerId
    consumer {
      name
      mail
    }
  }
}
    `;

/**
 * __useConsumerEventsVoucherQuery__
 *
 * To run a query within a React component, call `useConsumerEventsVoucherQuery` and pass it any options that fit your needs.
 * When your component renders, `useConsumerEventsVoucherQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConsumerEventsVoucherQuery({
 *   variables: {
 *      voucherID: // value for 'voucherID'
 *   },
 * });
 */
export function useConsumerEventsVoucherQuery(baseOptions: Apollo.QueryHookOptions<ConsumerEventsVoucherQuery, ConsumerEventsVoucherQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ConsumerEventsVoucherQuery, ConsumerEventsVoucherQueryVariables>(ConsumerEventsVoucherDocument, options);
      }
export function useConsumerEventsVoucherLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ConsumerEventsVoucherQuery, ConsumerEventsVoucherQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ConsumerEventsVoucherQuery, ConsumerEventsVoucherQueryVariables>(ConsumerEventsVoucherDocument, options);
        }
export type ConsumerEventsVoucherQueryHookResult = ReturnType<typeof useConsumerEventsVoucherQuery>;
export type ConsumerEventsVoucherLazyQueryHookResult = ReturnType<typeof useConsumerEventsVoucherLazyQuery>;
export type ConsumerEventsVoucherQueryResult = Apollo.QueryResult<ConsumerEventsVoucherQuery, ConsumerEventsVoucherQueryVariables>;
export const ConsumerMailResendDocument = gql`
    mutation ConsumerMailResend($mailId: MongoID) {
  PlannedMailUpdate(
    filter: {_id: $mailId}
    record: {sent: null, sentStatus: null}
  ) {
    recordId
  }
}
    `;
export type ConsumerMailResendMutationFn = Apollo.MutationFunction<ConsumerMailResendMutation, ConsumerMailResendMutationVariables>;

/**
 * __useConsumerMailResendMutation__
 *
 * To run a mutation, you first call `useConsumerMailResendMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConsumerMailResendMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [consumerMailResendMutation, { data, loading, error }] = useConsumerMailResendMutation({
 *   variables: {
 *      mailId: // value for 'mailId'
 *   },
 * });
 */
export function useConsumerMailResendMutation(baseOptions?: Apollo.MutationHookOptions<ConsumerMailResendMutation, ConsumerMailResendMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConsumerMailResendMutation, ConsumerMailResendMutationVariables>(ConsumerMailResendDocument, options);
      }
export type ConsumerMailResendMutationHookResult = ReturnType<typeof useConsumerMailResendMutation>;
export type ConsumerMailResendMutationResult = Apollo.MutationResult<ConsumerMailResendMutation>;
export type ConsumerMailResendMutationOptions = Apollo.BaseMutationOptions<ConsumerMailResendMutation, ConsumerMailResendMutationVariables>;
export const ConsumerSendAllDocument = gql`
    mutation ConsumerSendAll($shopId: MongoID!) {
  VoucherSendReminder(shopId: $shopId)
}
    `;
export type ConsumerSendAllMutationFn = Apollo.MutationFunction<ConsumerSendAllMutation, ConsumerSendAllMutationVariables>;

/**
 * __useConsumerSendAllMutation__
 *
 * To run a mutation, you first call `useConsumerSendAllMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConsumerSendAllMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [consumerSendAllMutation, { data, loading, error }] = useConsumerSendAllMutation({
 *   variables: {
 *      shopId: // value for 'shopId'
 *   },
 * });
 */
export function useConsumerSendAllMutation(baseOptions?: Apollo.MutationHookOptions<ConsumerSendAllMutation, ConsumerSendAllMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConsumerSendAllMutation, ConsumerSendAllMutationVariables>(ConsumerSendAllDocument, options);
      }
export type ConsumerSendAllMutationHookResult = ReturnType<typeof useConsumerSendAllMutation>;
export type ConsumerSendAllMutationResult = Apollo.MutationResult<ConsumerSendAllMutation>;
export type ConsumerSendAllMutationOptions = Apollo.BaseMutationOptions<ConsumerSendAllMutation, ConsumerSendAllMutationVariables>;
export const TradeInPageShopDocument = gql`
    query TradeInPageShop($shopId: MongoID!) {
  ShopById(_id: $shopId) {
    _id
    tradeInBaseUrl
    currency
    conditions {
      condition
      name
      description
    }
    brandHouseId
    brandHouse {
      _id
      settings {
        useBrandItems
      }
    }
  }
}
    `;

/**
 * __useTradeInPageShopQuery__
 *
 * To run a query within a React component, call `useTradeInPageShopQuery` and pass it any options that fit your needs.
 * When your component renders, `useTradeInPageShopQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTradeInPageShopQuery({
 *   variables: {
 *      shopId: // value for 'shopId'
 *   },
 * });
 */
export function useTradeInPageShopQuery(baseOptions: Apollo.QueryHookOptions<TradeInPageShopQuery, TradeInPageShopQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TradeInPageShopQuery, TradeInPageShopQueryVariables>(TradeInPageShopDocument, options);
      }
export function useTradeInPageShopLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TradeInPageShopQuery, TradeInPageShopQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TradeInPageShopQuery, TradeInPageShopQueryVariables>(TradeInPageShopDocument, options);
        }
export type TradeInPageShopQueryHookResult = ReturnType<typeof useTradeInPageShopQuery>;
export type TradeInPageShopLazyQueryHookResult = ReturnType<typeof useTradeInPageShopLazyQuery>;
export type TradeInPageShopQueryResult = Apollo.QueryResult<TradeInPageShopQuery, TradeInPageShopQueryVariables>;
export const TradeInPageByIdDocument = gql`
    query tradeInPageById($tradeInId: MongoID!) {
  TradeInById(_id: $tradeInId) {
    _id
    dateTime
    registered
    registeredTs
    notified
    shippingType
    shippingCarrierId
    tradeInNr
    deliveryNoteUrl
    vouchers {
      _id
      value
      currency
      code
      voucherStrategy
      activated
    }
    circularPoints {
      _id
      value
      activated
    }
    label {
      deliveryDate
      deliveryStatus
      url
    }
    consumerId
    hasBonus
    items {
      _id
      name
      sku
      size
      color
      condition
      externUrl
      bonus
      productVariantId
      productVariant {
        _id
        product {
          _id
          name
        }
        color
        size
        sku
      }
      wholeSale {
        categoryId
        name
        value
      }
      imageUrls
      stockItem {
        _id
      }
      rejected
      potential {
        externUrl
        rrp
        sp
      }
    }
  }
}
    `;

/**
 * __useTradeInPageByIdQuery__
 *
 * To run a query within a React component, call `useTradeInPageByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useTradeInPageByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTradeInPageByIdQuery({
 *   variables: {
 *      tradeInId: // value for 'tradeInId'
 *   },
 * });
 */
export function useTradeInPageByIdQuery(baseOptions: Apollo.QueryHookOptions<TradeInPageByIdQuery, TradeInPageByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TradeInPageByIdQuery, TradeInPageByIdQueryVariables>(TradeInPageByIdDocument, options);
      }
export function useTradeInPageByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TradeInPageByIdQuery, TradeInPageByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TradeInPageByIdQuery, TradeInPageByIdQueryVariables>(TradeInPageByIdDocument, options);
        }
export type TradeInPageByIdQueryHookResult = ReturnType<typeof useTradeInPageByIdQuery>;
export type TradeInPageByIdLazyQueryHookResult = ReturnType<typeof useTradeInPageByIdLazyQuery>;
export type TradeInPageByIdQueryResult = Apollo.QueryResult<TradeInPageByIdQuery, TradeInPageByIdQueryVariables>;
export const ShopTradeInItemsRemoveDocument = gql`
    mutation shopTradeInItemsRemove($tradeInId: MongoID!, $tradeInItemsId: [MongoID!]!, $reject: TradeInItemRejectReasonEnum!) {
  TradeInItemsReject(
    tradeInId: $tradeInId
    tradeInItemIds: $tradeInItemsId
    rejected: $reject
  ) {
    _id
  }
}
    `;
export type ShopTradeInItemsRemoveMutationFn = Apollo.MutationFunction<ShopTradeInItemsRemoveMutation, ShopTradeInItemsRemoveMutationVariables>;

/**
 * __useShopTradeInItemsRemoveMutation__
 *
 * To run a mutation, you first call `useShopTradeInItemsRemoveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useShopTradeInItemsRemoveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [shopTradeInItemsRemoveMutation, { data, loading, error }] = useShopTradeInItemsRemoveMutation({
 *   variables: {
 *      tradeInId: // value for 'tradeInId'
 *      tradeInItemsId: // value for 'tradeInItemsId'
 *      reject: // value for 'reject'
 *   },
 * });
 */
export function useShopTradeInItemsRemoveMutation(baseOptions?: Apollo.MutationHookOptions<ShopTradeInItemsRemoveMutation, ShopTradeInItemsRemoveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ShopTradeInItemsRemoveMutation, ShopTradeInItemsRemoveMutationVariables>(ShopTradeInItemsRemoveDocument, options);
      }
export type ShopTradeInItemsRemoveMutationHookResult = ReturnType<typeof useShopTradeInItemsRemoveMutation>;
export type ShopTradeInItemsRemoveMutationResult = Apollo.MutationResult<ShopTradeInItemsRemoveMutation>;
export type ShopTradeInItemsRemoveMutationOptions = Apollo.BaseMutationOptions<ShopTradeInItemsRemoveMutation, ShopTradeInItemsRemoveMutationVariables>;
export const MainTradeInItemUpdateByIdDocument = gql`
    mutation MainTradeInItemUpdateById($id: MongoID!, $record: UpdateByIdTradeInItemInput!) {
  TradeInItemUpdateById(_id: $id, record: $record) {
    recordId
  }
}
    `;
export type MainTradeInItemUpdateByIdMutationFn = Apollo.MutationFunction<MainTradeInItemUpdateByIdMutation, MainTradeInItemUpdateByIdMutationVariables>;

/**
 * __useMainTradeInItemUpdateByIdMutation__
 *
 * To run a mutation, you first call `useMainTradeInItemUpdateByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMainTradeInItemUpdateByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [mainTradeInItemUpdateByIdMutation, { data, loading, error }] = useMainTradeInItemUpdateByIdMutation({
 *   variables: {
 *      id: // value for 'id'
 *      record: // value for 'record'
 *   },
 * });
 */
export function useMainTradeInItemUpdateByIdMutation(baseOptions?: Apollo.MutationHookOptions<MainTradeInItemUpdateByIdMutation, MainTradeInItemUpdateByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MainTradeInItemUpdateByIdMutation, MainTradeInItemUpdateByIdMutationVariables>(MainTradeInItemUpdateByIdDocument, options);
      }
export type MainTradeInItemUpdateByIdMutationHookResult = ReturnType<typeof useMainTradeInItemUpdateByIdMutation>;
export type MainTradeInItemUpdateByIdMutationResult = Apollo.MutationResult<MainTradeInItemUpdateByIdMutation>;
export type MainTradeInItemUpdateByIdMutationOptions = Apollo.BaseMutationOptions<MainTradeInItemUpdateByIdMutation, MainTradeInItemUpdateByIdMutationVariables>;
export const WholeSaleEditCategoryGetDocument = gql`
    query WholeSaleEditCategoryGet($categoryId: MongoID!) {
  WholeSaleCategory(_id: $categoryId) {
    ...WholeSaleCategoryFragment
  }
}
    ${WholeSaleCategoryFragmentDoc}`;

/**
 * __useWholeSaleEditCategoryGetQuery__
 *
 * To run a query within a React component, call `useWholeSaleEditCategoryGetQuery` and pass it any options that fit your needs.
 * When your component renders, `useWholeSaleEditCategoryGetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWholeSaleEditCategoryGetQuery({
 *   variables: {
 *      categoryId: // value for 'categoryId'
 *   },
 * });
 */
export function useWholeSaleEditCategoryGetQuery(baseOptions: Apollo.QueryHookOptions<WholeSaleEditCategoryGetQuery, WholeSaleEditCategoryGetQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WholeSaleEditCategoryGetQuery, WholeSaleEditCategoryGetQueryVariables>(WholeSaleEditCategoryGetDocument, options);
      }
export function useWholeSaleEditCategoryGetLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WholeSaleEditCategoryGetQuery, WholeSaleEditCategoryGetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WholeSaleEditCategoryGetQuery, WholeSaleEditCategoryGetQueryVariables>(WholeSaleEditCategoryGetDocument, options);
        }
export type WholeSaleEditCategoryGetQueryHookResult = ReturnType<typeof useWholeSaleEditCategoryGetQuery>;
export type WholeSaleEditCategoryGetLazyQueryHookResult = ReturnType<typeof useWholeSaleEditCategoryGetLazyQuery>;
export type WholeSaleEditCategoryGetQueryResult = Apollo.QueryResult<WholeSaleEditCategoryGetQuery, WholeSaleEditCategoryGetQueryVariables>;
export const WholeSaleEditCategoryUpdateDocument = gql`
    mutation WholeSaleEditCategoryUpdate($categoryId: MongoID!, $record: UpdateOneWholeSaleCategoryInput!) {
  WholeSaleCategoryUpdate(filter: {_id: $categoryId}, record: $record) {
    recordId
    record {
      ...WholeSaleCategoryFragment
    }
  }
}
    ${WholeSaleCategoryFragmentDoc}`;
export type WholeSaleEditCategoryUpdateMutationFn = Apollo.MutationFunction<WholeSaleEditCategoryUpdateMutation, WholeSaleEditCategoryUpdateMutationVariables>;

/**
 * __useWholeSaleEditCategoryUpdateMutation__
 *
 * To run a mutation, you first call `useWholeSaleEditCategoryUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWholeSaleEditCategoryUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [wholeSaleEditCategoryUpdateMutation, { data, loading, error }] = useWholeSaleEditCategoryUpdateMutation({
 *   variables: {
 *      categoryId: // value for 'categoryId'
 *      record: // value for 'record'
 *   },
 * });
 */
export function useWholeSaleEditCategoryUpdateMutation(baseOptions?: Apollo.MutationHookOptions<WholeSaleEditCategoryUpdateMutation, WholeSaleEditCategoryUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<WholeSaleEditCategoryUpdateMutation, WholeSaleEditCategoryUpdateMutationVariables>(WholeSaleEditCategoryUpdateDocument, options);
      }
export type WholeSaleEditCategoryUpdateMutationHookResult = ReturnType<typeof useWholeSaleEditCategoryUpdateMutation>;
export type WholeSaleEditCategoryUpdateMutationResult = Apollo.MutationResult<WholeSaleEditCategoryUpdateMutation>;
export type WholeSaleEditCategoryUpdateMutationOptions = Apollo.BaseMutationOptions<WholeSaleEditCategoryUpdateMutation, WholeSaleEditCategoryUpdateMutationVariables>;
export const WholeSaleEditCategoryDeleteDocument = gql`
    mutation WholeSaleEditCategoryDelete($shopId: String!, $categoryId: String!) {
  WholeSaleCategoryDelete(shopId: $shopId, categoryId: $categoryId) {
    _id
  }
}
    `;
export type WholeSaleEditCategoryDeleteMutationFn = Apollo.MutationFunction<WholeSaleEditCategoryDeleteMutation, WholeSaleEditCategoryDeleteMutationVariables>;

/**
 * __useWholeSaleEditCategoryDeleteMutation__
 *
 * To run a mutation, you first call `useWholeSaleEditCategoryDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWholeSaleEditCategoryDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [wholeSaleEditCategoryDeleteMutation, { data, loading, error }] = useWholeSaleEditCategoryDeleteMutation({
 *   variables: {
 *      shopId: // value for 'shopId'
 *      categoryId: // value for 'categoryId'
 *   },
 * });
 */
export function useWholeSaleEditCategoryDeleteMutation(baseOptions?: Apollo.MutationHookOptions<WholeSaleEditCategoryDeleteMutation, WholeSaleEditCategoryDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<WholeSaleEditCategoryDeleteMutation, WholeSaleEditCategoryDeleteMutationVariables>(WholeSaleEditCategoryDeleteDocument, options);
      }
export type WholeSaleEditCategoryDeleteMutationHookResult = ReturnType<typeof useWholeSaleEditCategoryDeleteMutation>;
export type WholeSaleEditCategoryDeleteMutationResult = Apollo.MutationResult<WholeSaleEditCategoryDeleteMutation>;
export type WholeSaleEditCategoryDeleteMutationOptions = Apollo.BaseMutationOptions<WholeSaleEditCategoryDeleteMutation, WholeSaleEditCategoryDeleteMutationVariables>;
export const WholeSaleCategoryCreateDocument = gql`
    mutation WholeSaleCategoryCreate($record: CreateOneWholeSaleCategoryInput!) {
  WholeSaleCategoryCreate(record: $record) {
    recordId
  }
}
    `;
export type WholeSaleCategoryCreateMutationFn = Apollo.MutationFunction<WholeSaleCategoryCreateMutation, WholeSaleCategoryCreateMutationVariables>;

/**
 * __useWholeSaleCategoryCreateMutation__
 *
 * To run a mutation, you first call `useWholeSaleCategoryCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWholeSaleCategoryCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [wholeSaleCategoryCreateMutation, { data, loading, error }] = useWholeSaleCategoryCreateMutation({
 *   variables: {
 *      record: // value for 'record'
 *   },
 * });
 */
export function useWholeSaleCategoryCreateMutation(baseOptions?: Apollo.MutationHookOptions<WholeSaleCategoryCreateMutation, WholeSaleCategoryCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<WholeSaleCategoryCreateMutation, WholeSaleCategoryCreateMutationVariables>(WholeSaleCategoryCreateDocument, options);
      }
export type WholeSaleCategoryCreateMutationHookResult = ReturnType<typeof useWholeSaleCategoryCreateMutation>;
export type WholeSaleCategoryCreateMutationResult = Apollo.MutationResult<WholeSaleCategoryCreateMutation>;
export type WholeSaleCategoryCreateMutationOptions = Apollo.BaseMutationOptions<WholeSaleCategoryCreateMutation, WholeSaleCategoryCreateMutationVariables>;
export const WholeSaleCategoryEditBrandDocument = gql`
    query WholeSaleCategoryEditBrand($shopId: MongoID!) {
  ShopById(_id: $shopId) {
    _id
    productTags
    productCollections
  }
}
    `;

/**
 * __useWholeSaleCategoryEditBrandQuery__
 *
 * To run a query within a React component, call `useWholeSaleCategoryEditBrandQuery` and pass it any options that fit your needs.
 * When your component renders, `useWholeSaleCategoryEditBrandQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWholeSaleCategoryEditBrandQuery({
 *   variables: {
 *      shopId: // value for 'shopId'
 *   },
 * });
 */
export function useWholeSaleCategoryEditBrandQuery(baseOptions: Apollo.QueryHookOptions<WholeSaleCategoryEditBrandQuery, WholeSaleCategoryEditBrandQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WholeSaleCategoryEditBrandQuery, WholeSaleCategoryEditBrandQueryVariables>(WholeSaleCategoryEditBrandDocument, options);
      }
export function useWholeSaleCategoryEditBrandLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WholeSaleCategoryEditBrandQuery, WholeSaleCategoryEditBrandQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WholeSaleCategoryEditBrandQuery, WholeSaleCategoryEditBrandQueryVariables>(WholeSaleCategoryEditBrandDocument, options);
        }
export type WholeSaleCategoryEditBrandQueryHookResult = ReturnType<typeof useWholeSaleCategoryEditBrandQuery>;
export type WholeSaleCategoryEditBrandLazyQueryHookResult = ReturnType<typeof useWholeSaleCategoryEditBrandLazyQuery>;
export type WholeSaleCategoryEditBrandQueryResult = Apollo.QueryResult<WholeSaleCategoryEditBrandQuery, WholeSaleCategoryEditBrandQueryVariables>;
export const WholeSaleStatisticsDocument = gql`
    query WholeSaleStatistics($shopId: String!, $rule: WholeSaleCategoryRulesInput!) {
  WholeSaleRuleStatistics(shopId: $shopId, rule: $rule) {
    count
    sample {
      ...WholeSaleProductFragment
    }
  }
}
    ${WholeSaleProductFragmentDoc}`;

/**
 * __useWholeSaleStatisticsQuery__
 *
 * To run a query within a React component, call `useWholeSaleStatisticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useWholeSaleStatisticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWholeSaleStatisticsQuery({
 *   variables: {
 *      shopId: // value for 'shopId'
 *      rule: // value for 'rule'
 *   },
 * });
 */
export function useWholeSaleStatisticsQuery(baseOptions: Apollo.QueryHookOptions<WholeSaleStatisticsQuery, WholeSaleStatisticsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WholeSaleStatisticsQuery, WholeSaleStatisticsQueryVariables>(WholeSaleStatisticsDocument, options);
      }
export function useWholeSaleStatisticsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WholeSaleStatisticsQuery, WholeSaleStatisticsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WholeSaleStatisticsQuery, WholeSaleStatisticsQueryVariables>(WholeSaleStatisticsDocument, options);
        }
export type WholeSaleStatisticsQueryHookResult = ReturnType<typeof useWholeSaleStatisticsQuery>;
export type WholeSaleStatisticsLazyQueryHookResult = ReturnType<typeof useWholeSaleStatisticsLazyQuery>;
export type WholeSaleStatisticsQueryResult = Apollo.QueryResult<WholeSaleStatisticsQuery, WholeSaleStatisticsQueryVariables>;
export const WholeSaleLocalesDocument = gql`
    query WholeSaleLocales($shopId: MongoID!) {
  ShopById(_id: $shopId) {
    _id
    tradeInLocalePrimary
    tradeInLocales
  }
}
    `;

/**
 * __useWholeSaleLocalesQuery__
 *
 * To run a query within a React component, call `useWholeSaleLocalesQuery` and pass it any options that fit your needs.
 * When your component renders, `useWholeSaleLocalesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWholeSaleLocalesQuery({
 *   variables: {
 *      shopId: // value for 'shopId'
 *   },
 * });
 */
export function useWholeSaleLocalesQuery(baseOptions: Apollo.QueryHookOptions<WholeSaleLocalesQuery, WholeSaleLocalesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WholeSaleLocalesQuery, WholeSaleLocalesQueryVariables>(WholeSaleLocalesDocument, options);
      }
export function useWholeSaleLocalesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WholeSaleLocalesQuery, WholeSaleLocalesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WholeSaleLocalesQuery, WholeSaleLocalesQueryVariables>(WholeSaleLocalesDocument, options);
        }
export type WholeSaleLocalesQueryHookResult = ReturnType<typeof useWholeSaleLocalesQuery>;
export type WholeSaleLocalesLazyQueryHookResult = ReturnType<typeof useWholeSaleLocalesLazyQuery>;
export type WholeSaleLocalesQueryResult = Apollo.QueryResult<WholeSaleLocalesQuery, WholeSaleLocalesQueryVariables>;
export const WholeSaleActiveDocument = gql`
    query WholeSaleActive($shopId: MongoID!) {
  ShopById(_id: $shopId) {
    _id
    wholeSaleActive
  }
}
    `;

/**
 * __useWholeSaleActiveQuery__
 *
 * To run a query within a React component, call `useWholeSaleActiveQuery` and pass it any options that fit your needs.
 * When your component renders, `useWholeSaleActiveQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWholeSaleActiveQuery({
 *   variables: {
 *      shopId: // value for 'shopId'
 *   },
 * });
 */
export function useWholeSaleActiveQuery(baseOptions: Apollo.QueryHookOptions<WholeSaleActiveQuery, WholeSaleActiveQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WholeSaleActiveQuery, WholeSaleActiveQueryVariables>(WholeSaleActiveDocument, options);
      }
export function useWholeSaleActiveLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WholeSaleActiveQuery, WholeSaleActiveQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WholeSaleActiveQuery, WholeSaleActiveQueryVariables>(WholeSaleActiveDocument, options);
        }
export type WholeSaleActiveQueryHookResult = ReturnType<typeof useWholeSaleActiveQuery>;
export type WholeSaleActiveLazyQueryHookResult = ReturnType<typeof useWholeSaleActiveLazyQuery>;
export type WholeSaleActiveQueryResult = Apollo.QueryResult<WholeSaleActiveQuery, WholeSaleActiveQueryVariables>;
export const WholeSaleActivateDocument = gql`
    mutation WholeSaleActivate($shopId: MongoID!, $active: Boolean!) {
  ShopUpdateOne(filter: {_id: $shopId}, record: {wholeSaleActive: $active}) {
    recordId
  }
}
    `;
export type WholeSaleActivateMutationFn = Apollo.MutationFunction<WholeSaleActivateMutation, WholeSaleActivateMutationVariables>;

/**
 * __useWholeSaleActivateMutation__
 *
 * To run a mutation, you first call `useWholeSaleActivateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWholeSaleActivateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [wholeSaleActivateMutation, { data, loading, error }] = useWholeSaleActivateMutation({
 *   variables: {
 *      shopId: // value for 'shopId'
 *      active: // value for 'active'
 *   },
 * });
 */
export function useWholeSaleActivateMutation(baseOptions?: Apollo.MutationHookOptions<WholeSaleActivateMutation, WholeSaleActivateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<WholeSaleActivateMutation, WholeSaleActivateMutationVariables>(WholeSaleActivateDocument, options);
      }
export type WholeSaleActivateMutationHookResult = ReturnType<typeof useWholeSaleActivateMutation>;
export type WholeSaleActivateMutationResult = Apollo.MutationResult<WholeSaleActivateMutation>;
export type WholeSaleActivateMutationOptions = Apollo.BaseMutationOptions<WholeSaleActivateMutation, WholeSaleActivateMutationVariables>;
export const WholeSaleCategoriesDocument = gql`
    query WholeSaleCategories($shopId: MongoID!) {
  WholeSaleCategories(filter: {shopId: $shopId}) {
    _id
    iconId
    name
    section
    value
    voucherStrategy
  }
}
    `;

/**
 * __useWholeSaleCategoriesQuery__
 *
 * To run a query within a React component, call `useWholeSaleCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useWholeSaleCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWholeSaleCategoriesQuery({
 *   variables: {
 *      shopId: // value for 'shopId'
 *   },
 * });
 */
export function useWholeSaleCategoriesQuery(baseOptions: Apollo.QueryHookOptions<WholeSaleCategoriesQuery, WholeSaleCategoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WholeSaleCategoriesQuery, WholeSaleCategoriesQueryVariables>(WholeSaleCategoriesDocument, options);
      }
export function useWholeSaleCategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WholeSaleCategoriesQuery, WholeSaleCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WholeSaleCategoriesQuery, WholeSaleCategoriesQueryVariables>(WholeSaleCategoriesDocument, options);
        }
export type WholeSaleCategoriesQueryHookResult = ReturnType<typeof useWholeSaleCategoriesQuery>;
export type WholeSaleCategoriesLazyQueryHookResult = ReturnType<typeof useWholeSaleCategoriesLazyQuery>;
export type WholeSaleCategoriesQueryResult = Apollo.QueryResult<WholeSaleCategoriesQuery, WholeSaleCategoriesQueryVariables>;